[
  {
    "object": "page",
    "id": "3e05d164-78d8-805d-99f3-e0798d28f673",
    "created_time": "2026-09-19T16:09:00.000Z",
    "last_edited_time": "2026-09-25T07:28:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "9745d164-78d8-8278-8d18-01137183392f"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2026-09-19T16:09:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FI",
          "number": 51
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "492225b3-52b5-4c16-87b6-1e23085bedbc",
          "name": "3-For Fun",
          "color": "blue"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2026-09-25T07:28:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "sgq|",
          "name": "⚔️:1",
          "color": "red"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Chi cái chi chi",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Chi cái chi chi",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Chi-c-i-chi-chi-3e05d16478d8805d99f3e0798d28f673",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "39e5d164-78d8-80c6-9235-e6d0fd667caa",
      "name": "Other",
      "slug": "other",
      "icon": "👾",
      "order": 6,
      "created_time": "2026-07-15T00:59:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Tài chính",
          "slug": "tai-chinh",
          "order": 1
        },
        {
          "id": "5b23efe9-2fa7-4d0d-9ad4-8c25a146e2c5",
          "name": "Design",
          "slug": "design",
          "order": 2
        },
        {
          "id": "492225b3-52b5-4c16-87b6-1e23085bedbc",
          "name": "For Fun",
          "slug": "for-fun",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "492225b3-52b5-4c16-87b6-1e23085bedbc",
      "name": "For Fun",
      "slug": "for-fun",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "3e05d164-78d8-8009-a0cd-f2f9fd703a01",
        "parent": {
          "type": "page_id",
          "page_id": "3e05d164-78d8-805d-99f3-e0798d28f673"
        },
        "created_time": "2026-09-19T16:20:00.000Z",
        "last_edited_time": "2026-09-19T16:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1789834855/uxcomic-imgs/3e05d164-78d8-8009-a0cd-f2f9fd703a01.png",
            "expiry_time": "2026-10-04T09:09:23.086Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/3e05d164-78d8-8009-a0cd-f2f9fd703a01"
      },
      {
        "object": "block",
        "id": "3e65d164-78d8-80f8-aeb2-f02fb3cc1374",
        "parent": {
          "type": "page_id",
          "page_id": "3e05d164-78d8-805d-99f3-e0798d28f673"
        },
        "created_time": "2026-09-25T07:28:00.000Z",
        "last_edited_time": "2026-09-25T07:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "embed",
        "embed": {
          "caption": [],
          "url": "https://res.cloudinary.com/dpzknshvi/raw/upload/v1790321328/uxcomic-html/3e65d164-78d8-80f8-aeb2-f02fb3cc1374.html"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "3de5d164-78d8-80c6-a6a3-ce8e982afbe4",
    "created_time": "2026-09-17T13:53:00.000Z",
    "last_edited_time": "2026-09-21T10:55:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "9745d164-78d8-8278-8d18-01137183392f"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2026-09-17T13:53:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FI",
          "number": 50
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "492225b3-52b5-4c16-87b6-1e23085bedbc",
          "name": "3-For Fun",
          "color": "blue"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2026-09-21T10:55:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "sgq|",
          "name": "⚔️:1",
          "color": "red"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Thể dục thể thao",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Thể dục thể thao",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Th-d-c-th-thao-3de5d16478d880c6a6a3ce8e982afbe4",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "39e5d164-78d8-80c6-9235-e6d0fd667caa",
      "name": "Other",
      "slug": "other",
      "icon": "👾",
      "order": 6,
      "created_time": "2026-07-15T00:59:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Tài chính",
          "slug": "tai-chinh",
          "order": 1
        },
        {
          "id": "5b23efe9-2fa7-4d0d-9ad4-8c25a146e2c5",
          "name": "Design",
          "slug": "design",
          "order": 2
        },
        {
          "id": "492225b3-52b5-4c16-87b6-1e23085bedbc",
          "name": "For Fun",
          "slug": "for-fun",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "492225b3-52b5-4c16-87b6-1e23085bedbc",
      "name": "For Fun",
      "slug": "for-fun",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "3e05d164-78d8-80f7-9374-e89c2de7539e",
        "parent": {
          "type": "page_id",
          "page_id": "3de5d164-78d8-80c6-a6a3-ce8e982afbe4"
        },
        "created_time": "2026-09-19T16:19:00.000Z",
        "last_edited_time": "2026-09-21T10:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1789834860/uxcomic-imgs/3e05d164-78d8-80f7-9374-e89c2de7539e.png",
            "expiry_time": "2026-10-04T09:09:24.907Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/3e05d164-78d8-80f7-9374-e89c2de7539e"
      },
      {
        "object": "block",
        "id": "3e25d164-78d8-8028-9335-debeb1f615c3",
        "parent": {
          "type": "page_id",
          "page_id": "3de5d164-78d8-80c6-a6a3-ce8e982afbe4"
        },
        "created_time": "2026-09-21T10:55:00.000Z",
        "last_edited_time": "2026-09-21T10:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "embed",
        "embed": {
          "caption": [],
          "url": "https://res.cloudinary.com/dpzknshvi/raw/upload/v1789988178/uxcomic-html/3e25d164-78d8-8028-9335-debeb1f615c3.html"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "3b45d164-78d8-80d0-b108-c646433df03b",
    "created_time": "2026-08-06T10:56:00.000Z",
    "last_edited_time": "2026-09-21T12:23:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "9745d164-78d8-8278-8d18-01137183392f"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2026-08-06T10:56:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FI",
          "number": 48
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "492225b3-52b5-4c16-87b6-1e23085bedbc",
          "name": "3-For Fun",
          "color": "blue"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2026-09-21T12:23:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "sgq|",
          "name": "⚔️:1",
          "color": "red"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Time Portfolio",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Time Portfolio",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Time-Portfolio-3b45d16478d880d0b108c646433df03b",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "39e5d164-78d8-80c6-9235-e6d0fd667caa",
      "name": "Other",
      "slug": "other",
      "icon": "👾",
      "order": 6,
      "created_time": "2026-07-15T00:59:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Tài chính",
          "slug": "tai-chinh",
          "order": 1
        },
        {
          "id": "5b23efe9-2fa7-4d0d-9ad4-8c25a146e2c5",
          "name": "Design",
          "slug": "design",
          "order": 2
        },
        {
          "id": "492225b3-52b5-4c16-87b6-1e23085bedbc",
          "name": "For Fun",
          "slug": "for-fun",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "492225b3-52b5-4c16-87b6-1e23085bedbc",
      "name": "For Fun",
      "slug": "for-fun",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "3e05d164-78d8-80eb-a302-efc39b8c5191",
        "parent": {
          "type": "page_id",
          "page_id": "3b45d164-78d8-80d0-b108-c646433df03b"
        },
        "created_time": "2026-09-19T16:15:00.000Z",
        "last_edited_time": "2026-09-19T16:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1789834862/uxcomic-imgs/3e05d164-78d8-80eb-a302-efc39b8c5191.png",
            "expiry_time": "2026-10-04T09:09:25.927Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/3e05d164-78d8-80eb-a302-efc39b8c5191"
      },
      {
        "object": "block",
        "id": "3e25d164-78d8-80ee-938f-d29c501bc54d",
        "parent": {
          "type": "page_id",
          "page_id": "3b45d164-78d8-80d0-b108-c646433df03b"
        },
        "created_time": "2026-09-21T12:23:00.000Z",
        "last_edited_time": "2026-09-21T12:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "embed",
        "embed": {
          "caption": [],
          "url": "https://res.cloudinary.com/dpzknshvi/raw/upload/v1789993449/uxcomic-html/3e25d164-78d8-80ee-938f-d29c501bc54d.html"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "3a75d164-78d8-801f-a209-e73394fa760a",
    "created_time": "2026-07-24T04:39:00.000Z",
    "last_edited_time": "2026-07-25T04:30:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "9745d164-78d8-8278-8d18-01137183392f"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2026-07-24T04:39:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FI",
          "number": 47
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "5b23efe9-2fa7-4d0d-9ad4-8c25a146e2c5",
          "name": "2-Design",
          "color": "orange"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2026-07-25T04:30:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "tMsg",
          "name": "⚓:1",
          "color": "default"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Activities",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Activities",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Activities-3a75d16478d8801fa209e73394fa760a",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "39e5d164-78d8-80c6-9235-e6d0fd667caa",
      "name": "Other",
      "slug": "other",
      "icon": "👾",
      "order": 6,
      "created_time": "2026-07-15T00:59:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Tài chính",
          "slug": "tai-chinh",
          "order": 1
        },
        {
          "id": "5b23efe9-2fa7-4d0d-9ad4-8c25a146e2c5",
          "name": "Design",
          "slug": "design",
          "order": 2
        },
        {
          "id": "492225b3-52b5-4c16-87b6-1e23085bedbc",
          "name": "For Fun",
          "slug": "for-fun",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "5b23efe9-2fa7-4d0d-9ad4-8c25a146e2c5",
      "name": "Design",
      "slug": "design",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "3a85d164-78d8-80b3-9f16-dc5ed3c1e436",
        "parent": {
          "type": "page_id",
          "page_id": "3a75d164-78d8-801f-a209-e73394fa760a"
        },
        "created_time": "2026-07-25T04:16:00.000Z",
        "last_edited_time": "2026-07-25T04:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1784953063/uxcomic-imgs/3a85d164-78d8-80b3-9f16-dc5ed3c1e436.png",
            "expiry_time": "2026-10-04T09:09:27.073Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/3a85d164-78d8-80b3-9f16-dc5ed3c1e436"
      },
      {
        "object": "block",
        "id": "3a85d164-78d8-80a3-b441-f915c4cd224d",
        "parent": {
          "type": "page_id",
          "page_id": "3a75d164-78d8-801f-a209-e73394fa760a"
        },
        "created_time": "2026-07-25T04:30:00.000Z",
        "last_edited_time": "2026-07-25T04:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "embed",
        "embed": {
          "caption": [],
          "url": "https://res.cloudinary.com/dpzknshvi/raw/upload/v1784953875/uxcomic-html/3a85d164-78d8-80a3-b441-f915c4cd224d.html"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "3a45d164-78d8-8023-9bb7-ca5d63428d67",
    "created_time": "2026-07-21T01:05:00.000Z",
    "last_edited_time": "2026-07-21T01:42:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "9745d164-78d8-8278-8d18-01137183392f"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2026-07-21T01:05:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FI",
          "number": 46
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "1-Tài chính",
          "color": "default"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2026-07-21T01:42:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "sgq|",
          "name": "⚔️:1",
          "color": "red"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Correlation in Finance",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Correlation in Finance",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Correlation-in-Finance-3a45d16478d880239bb7ca5d63428d67",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "39e5d164-78d8-80c6-9235-e6d0fd667caa",
      "name": "Other",
      "slug": "other",
      "icon": "👾",
      "order": 6,
      "created_time": "2026-07-15T00:59:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Tài chính",
          "slug": "tai-chinh",
          "order": 1
        },
        {
          "id": "5b23efe9-2fa7-4d0d-9ad4-8c25a146e2c5",
          "name": "Design",
          "slug": "design",
          "order": 2
        },
        {
          "id": "492225b3-52b5-4c16-87b6-1e23085bedbc",
          "name": "For Fun",
          "slug": "for-fun",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Tài chính",
      "slug": "tai-chinh",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "3a45d164-78d8-8052-af9e-eeca3300c0fd",
        "parent": {
          "type": "page_id",
          "page_id": "3a45d164-78d8-8023-9bb7-ca5d63428d67"
        },
        "created_time": "2026-07-21T01:30:00.000Z",
        "last_edited_time": "2026-07-21T01:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1784599884/uxcomic-imgs/3a45d164-78d8-8052-af9e-eeca3300c0fd.png",
            "expiry_time": "2026-10-04T09:09:28.207Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/3a45d164-78d8-8052-af9e-eeca3300c0fd"
      },
      {
        "object": "block",
        "id": "3a45d164-78d8-808c-acaa-e757880ef478",
        "parent": {
          "type": "page_id",
          "page_id": "3a45d164-78d8-8023-9bb7-ca5d63428d67"
        },
        "created_time": "2026-07-21T01:42:00.000Z",
        "last_edited_time": "2026-07-21T01:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "embed",
        "embed": {
          "caption": [],
          "url": "https://res.cloudinary.com/dpzknshvi/raw/upload/v1784599886/uxcomic-html/3a45d164-78d8-808c-acaa-e757880ef478.html"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "3a05d164-78d8-8098-8de8-ebbfc81faaa2",
    "created_time": "2026-07-17T10:48:00.000Z",
    "last_edited_time": "2026-07-18T13:47:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "9745d164-78d8-8278-8d18-01137183392f"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2026-07-17T10:48:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FI",
          "number": 43
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "1-Tài chính",
          "color": "default"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2026-07-18T13:47:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "sgq|",
          "name": "⚔️:1",
          "color": "red"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Cashflow",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Cashflow",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Cashflow-3a05d16478d880988de8ebbfc81faaa2",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "39e5d164-78d8-80c6-9235-e6d0fd667caa",
      "name": "Other",
      "slug": "other",
      "icon": "👾",
      "order": 6,
      "created_time": "2026-07-15T00:59:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Tài chính",
          "slug": "tai-chinh",
          "order": 1
        },
        {
          "id": "5b23efe9-2fa7-4d0d-9ad4-8c25a146e2c5",
          "name": "Design",
          "slug": "design",
          "order": 2
        },
        {
          "id": "492225b3-52b5-4c16-87b6-1e23085bedbc",
          "name": "For Fun",
          "slug": "for-fun",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Tài chính",
      "slug": "tai-chinh",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "3a05d164-78d8-809d-a3d3-f2a2c5baf3d1",
        "parent": {
          "type": "page_id",
          "page_id": "3a05d164-78d8-8098-8de8-ebbfc81faaa2"
        },
        "created_time": "2026-07-17T10:53:00.000Z",
        "last_edited_time": "2026-07-17T10:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1784349795/uxcomic-imgs/3a05d164-78d8-809d-a3d3-f2a2c5baf3d1.png",
            "expiry_time": "2026-10-04T09:09:29.016Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/3a05d164-78d8-809d-a3d3-f2a2c5baf3d1"
      },
      {
        "object": "block",
        "id": "3a15d164-78d8-80f9-a8ae-f3e3fc92aa36",
        "parent": {
          "type": "page_id",
          "page_id": "3a05d164-78d8-8098-8de8-ebbfc81faaa2"
        },
        "created_time": "2026-07-18T13:47:00.000Z",
        "last_edited_time": "2026-07-18T13:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "embed",
        "embed": {
          "caption": [],
          "url": "https://res.cloudinary.com/dpzknshvi/raw/upload/v1784391606/uxcomic-html/3a15d164-78d8-80f9-a8ae-f3e3fc92aa36.html"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "39f5d164-78d8-8089-8689-f442dc275e75",
    "created_time": "2026-07-16T09:00:00.000Z",
    "last_edited_time": "2026-07-21T01:22:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "9745d164-78d8-8278-8d18-01137183392f"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2026-07-16T09:00:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FI",
          "number": 42
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "1-Tài chính",
          "color": "default"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2026-07-21T01:22:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "prxX",
          "name": "⚔️:2",
          "color": "yellow"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "So kèo",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "So kèo",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/So-k-o-39f5d16478d880898689f442dc275e75",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "39e5d164-78d8-80c6-9235-e6d0fd667caa",
      "name": "Other",
      "slug": "other",
      "icon": "👾",
      "order": 6,
      "created_time": "2026-07-15T00:59:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Tài chính",
          "slug": "tai-chinh",
          "order": 1
        },
        {
          "id": "5b23efe9-2fa7-4d0d-9ad4-8c25a146e2c5",
          "name": "Design",
          "slug": "design",
          "order": 2
        },
        {
          "id": "492225b3-52b5-4c16-87b6-1e23085bedbc",
          "name": "For Fun",
          "slug": "for-fun",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Tài chính",
      "slug": "tai-chinh",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "39f5d164-78d8-801e-abe7-fb643609236b",
        "parent": {
          "type": "page_id",
          "page_id": "39f5d164-78d8-8089-8689-f442dc275e75"
        },
        "created_time": "2026-07-16T09:00:00.000Z",
        "last_edited_time": "2026-07-16T09:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1784198085/uxcomic-imgs/39f5d164-78d8-801e-abe7-fb643609236b.png",
            "expiry_time": "2026-10-04T09:09:29.832Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/39f5d164-78d8-801e-abe7-fb643609236b"
      },
      {
        "object": "block",
        "id": "3a45d164-78d8-802e-8bb0-f2c4bd21c946",
        "parent": {
          "type": "page_id",
          "page_id": "39f5d164-78d8-8089-8689-f442dc275e75"
        },
        "created_time": "2026-07-21T01:22:00.000Z",
        "last_edited_time": "2026-07-21T01:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "embed",
        "embed": {
          "caption": [],
          "url": "https://res.cloudinary.com/dpzknshvi/raw/upload/v1784599888/uxcomic-html/3a45d164-78d8-802e-8bb0-f2c4bd21c946.html"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "39e5d164-78d8-80f4-a91c-ca85cb9e3cb4",
    "created_time": "2026-07-15T02:20:00.000Z",
    "last_edited_time": "2026-07-18T04:21:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "9745d164-78d8-8278-8d18-01137183392f"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2026-07-15T02:20:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FI",
          "number": 40
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "1-Tài chính",
          "color": "default"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2026-07-18T04:21:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "sgq|",
          "name": "⚔️:1",
          "color": "red"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Sản phẩm tài chính",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Sản phẩm tài chính",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/S-n-ph-m-t-i-ch-nh-39e5d16478d880f4a91cca85cb9e3cb4",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "39e5d164-78d8-80c6-9235-e6d0fd667caa",
      "name": "Other",
      "slug": "other",
      "icon": "👾",
      "order": 6,
      "created_time": "2026-07-15T00:59:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Tài chính",
          "slug": "tai-chinh",
          "order": 1
        },
        {
          "id": "5b23efe9-2fa7-4d0d-9ad4-8c25a146e2c5",
          "name": "Design",
          "slug": "design",
          "order": 2
        },
        {
          "id": "492225b3-52b5-4c16-87b6-1e23085bedbc",
          "name": "For Fun",
          "slug": "for-fun",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Tài chính",
      "slug": "tai-chinh",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "3a15d164-78d8-8039-bf98-e35bef90fd26",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80f4-a91c-ca85cb9e3cb4"
        },
        "created_time": "2026-07-18T04:21:00.000Z",
        "last_edited_time": "2026-07-18T04:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1784349799/uxcomic-imgs/3a15d164-78d8-8039-bf98-e35bef90fd26.png",
            "expiry_time": "2026-10-04T09:09:30.694Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/3a15d164-78d8-8039-bf98-e35bef90fd26"
      },
      {
        "object": "block",
        "id": "3a05d164-78d8-8085-8ac9-fea8a40e5f9a",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80f4-a91c-ca85cb9e3cb4"
        },
        "created_time": "2026-07-17T10:47:00.000Z",
        "last_edited_time": "2026-07-17T10:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "embed",
        "embed": {
          "caption": [],
          "url": "https://res.cloudinary.com/dpzknshvi/raw/upload/v1784349801/uxcomic-html/3a05d164-78d8-8085-8ac9-fea8a40e5f9a.html"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "39e5d164-78d8-800a-b1c8-ebb0a0d60fc8",
    "created_time": "2026-07-15T01:05:00.000Z",
    "last_edited_time": "2026-07-21T01:24:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "9745d164-78d8-8278-8d18-01137183392f"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2026-07-15T01:05:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FI",
          "number": 38
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "1-Tài chính",
          "color": "default"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2026-07-21T01:24:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "qO=g",
          "name": "♟️:1",
          "color": "pink"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Giai đoạn tài chính",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Giai đoạn tài chính",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Giai-o-n-t-i-ch-nh-39e5d16478d8800ab1c8ebb0a0d60fc8",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "39e5d164-78d8-80c6-9235-e6d0fd667caa",
      "name": "Other",
      "slug": "other",
      "icon": "👾",
      "order": 6,
      "created_time": "2026-07-15T00:59:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Tài chính",
          "slug": "tai-chinh",
          "order": 1
        },
        {
          "id": "5b23efe9-2fa7-4d0d-9ad4-8c25a146e2c5",
          "name": "Design",
          "slug": "design",
          "order": 2
        },
        {
          "id": "492225b3-52b5-4c16-87b6-1e23085bedbc",
          "name": "For Fun",
          "slug": "for-fun",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Tài chính",
      "slug": "tai-chinh",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "39e5d164-78d8-805f-b317-f2b48a4d6503",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-800a-b1c8-ebb0a0d60fc8"
        },
        "created_time": "2026-07-15T12:59:00.000Z",
        "last_edited_time": "2026-07-15T12:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1784120494/uxcomic-imgs/39e5d164-78d8-805f-b317-f2b48a4d6503.png",
            "expiry_time": "2026-10-04T09:09:31.852Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/39e5d164-78d8-805f-b317-f2b48a4d6503"
      },
      {
        "object": "block",
        "id": "3a45d164-78d8-809f-b5ab-cb8de1b71aa5",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-800a-b1c8-ebb0a0d60fc8"
        },
        "created_time": "2026-07-21T01:24:00.000Z",
        "last_edited_time": "2026-07-21T01:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "embed",
        "embed": {
          "caption": [],
          "url": "https://res.cloudinary.com/dpzknshvi/raw/upload/v1784599891/uxcomic-html/3a45d164-78d8-809f-b5ab-cb8de1b71aa5.html"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20",
    "created_time": "2026-07-15T01:02:00.000Z",
    "last_edited_time": "2026-07-16T11:05:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "9745d164-78d8-8278-8d18-01137183392f"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2026-07-15T01:02:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FI",
          "number": 37
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "1-Tài chính",
          "color": "default"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2026-07-16T11:05:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "sgq|",
          "name": "⚔️:1",
          "color": "red"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Popular Traps",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Popular Traps",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Popular-Traps-39e5d16478d880fab3e9c7e5e9500e20",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "39e5d164-78d8-80c6-9235-e6d0fd667caa",
      "name": "Other",
      "slug": "other",
      "icon": "👾",
      "order": 6,
      "created_time": "2026-07-15T00:59:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Tài chính",
          "slug": "tai-chinh",
          "order": 1
        },
        {
          "id": "5b23efe9-2fa7-4d0d-9ad4-8c25a146e2c5",
          "name": "Design",
          "slug": "design",
          "order": 2
        },
        {
          "id": "492225b3-52b5-4c16-87b6-1e23085bedbc",
          "name": "For Fun",
          "slug": "for-fun",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Tài chính",
      "slug": "tai-chinh",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "39e5d164-78d8-8079-bf78-de6deb2248e3",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T13:00:00.000Z",
        "last_edited_time": "2026-07-15T13:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1784120497/uxcomic-imgs/39e5d164-78d8-8079-bf78-de6deb2248e3.png",
            "expiry_time": "2026-10-04T09:09:32.727Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/39e5d164-78d8-8079-bf78-de6deb2248e3"
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-8030-ad63-c735be00124a",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:02:00.000Z",
        "last_edited_time": "2026-07-15T01:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các trap phổ biến trong tài chính, aware càng sớm càng tốt",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các trap phổ biến trong tài chính, aware càng sớm càng tốt",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39f5d164-78d8-8065-9cde-e0780943d48c",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-16T11:04:00.000Z",
        "last_edited_time": "2026-07-16T11:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1784200062/uxcomic-imgs/39f5d164-78d8-8065-9cde-e0780943d48c.png",
            "expiry_time": "2026-10-04T09:09:32.727Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/39f5d164-78d8-8065-9cde-e0780943d48c"
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-807c-a226-db927344964a",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Poverty Trap (Bẫy nghèo đói)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Poverty Trap (Bẫy nghèo đói)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80fb-abf5-fb194c6a1a7e",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bẫy nghèo đói là một cơ chế kinh tế tự củng cố khiến các cá nhân, gia đình hoặc toàn bộ quốc gia bị mắc kẹt trong sự nghèo khổ qua nhiều thế hệ. Ở đây, ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bẫy nghèo đói là một cơ chế kinh tế tự củng cố khiến các cá nhân, gia đình hoặc toàn bộ quốc gia bị mắc kẹt trong sự nghèo khổ qua nhiều thế hệ. Ở đây, ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "nghèo chính là nguyên nhân gây ra nghèo tiếp",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "nghèo chính là nguyên nhân gây ra nghèo tiếp",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80cc-90fc-e93eae98a62c",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cơ chế sinh tồn:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cơ chế sinh tồn:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Khi thu nhập chỉ vừa đủ để ăn qua ngày, tỷ lệ tiết kiệm bằng không. Không có tiết kiệm đồng nghĩa với không có vốn để đầu tư vào tài sản sinh lời hay giáo dục chất lượng cao để tăng năng suất.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Khi thu nhập chỉ vừa đủ để ăn qua ngày, tỷ lệ tiết kiệm bằng không. Không có tiết kiệm đồng nghĩa với không có vốn để đầu tư vào tài sản sinh lời hay giáo dục chất lượng cao để tăng năng suất.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80b2-8449-f58b9b97c826",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chi phí của cái nghèo (The Cost of Being Poor):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chi phí của cái nghèo (The Cost of Being Poor):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Người nghèo thường phải trả nhiều tiền hơn cho cùng một dịch vụ/hàng hóa. Ví dụ: Không có tiền mua số lượng lớn nên phải mua lẻ với giá đắt hơn; không có tài sản thế chấp nên phải vay tín dụng đen với lãi suất cắt cổ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Người nghèo thường phải trả nhiều tiền hơn cho cùng một dịch vụ/hàng hóa. Ví dụ: Không có tiền mua số lượng lớn nên phải mua lẻ với giá đắt hơn; không có tài sản thế chấp nên phải vay tín dụng đen với lãi suất cắt cổ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-8075-bcd5-d879f292348e",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lối thoát:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lối thoát:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Cần đòn bẩy hoặc sự hỗ trợ mạnh mẽ từ bên ngoài (chính sách, giáo dục miễn phí, mạng lưới an sinh xã hội, vốn vi mô).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Cần đòn bẩy hoặc sự hỗ trợ mạnh mẽ từ bên ngoài (chính sách, giáo dục miễn phí, mạng lưới an sinh xã hội, vốn vi mô).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39f5d164-78d8-8083-a479-d7c06adc0226",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-16T10:29:00.000Z",
        "last_edited_time": "2026-07-16T10:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "39f5d164-78d8-808d-bb4f-d3f3577fb808",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-16T11:04:00.000Z",
        "last_edited_time": "2026-07-16T11:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1784200064/uxcomic-imgs/39f5d164-78d8-808d-bb4f-d3f3577fb808.png",
            "expiry_time": "2026-10-04T09:09:32.727Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/39f5d164-78d8-808d-bb4f-d3f3577fb808"
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-801f-a7cb-eba3c6bb5c12",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Rat Race (Cuộc đua chuột)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Rat Race (Cuộc đua chuột)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-800e-96df-dff48fe724c1",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Rat Race mô tả lối sống của tầng lớp trung lưu hoặc lao động có thu nhập khá, nơi họ bị cuốn vào một cuộc đua tài chính vô tận: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Rat Race mô tả lối sống của tầng lớp trung lưu hoặc lao động có thu nhập khá, nơi họ bị cuốn vào một cuộc đua tài chính vô tận: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Làm việc chăm chỉ → Kiếm tiền → Trả hóa đơn/Mua sắm → Hết tiền → Tiếp tục làm việc chăm chỉ hơn.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Làm việc chăm chỉ → Kiếm tiền → Trả hóa đơn/Mua sắm → Hết tiền → Tiếp tục làm việc chăm chỉ hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80aa-b73b-d91d0e5a4392",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lạm phát lối sống (Lifestyle Inflation):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lạm phát lối sống (Lifestyle Inflation):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Khi thu nhập tăng lên, các chi phí \"nhu cầu\" tự động biến thành \"yêu cầu\" (đổi xe tốt hơn, mua nhà to hơn, dùng đồ hiệu). Mức chi tiêu luôn tịnh tiến bằng hoặc vượt mức lương mới.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Khi thu nhập tăng lên, các chi phí \"nhu cầu\" tự động biến thành \"yêu cầu\" (đổi xe tốt hơn, mua nhà to hơn, dùng đồ hiệu). Mức chi tiêu luôn tịnh tiến bằng hoặc vượt mức lương mới.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80e2-a377-f9b57ff0eb33",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hiệu ứng Hedonic Treadmill (Vòng xoáy thích nghi):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hiệu ứng Hedonic Treadmill (Vòng xoáy thích nghi):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Con người nhanh chóng thích nghi với mức độ hạnh phúc do vật chất mang lại. Chiếc túi hiệu hay chiếc xe mới chỉ làm họ vui trong vài tuần, sau đó họ cần một thứ đắt hơn để tìm lại cảm giác đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Con người nhanh chóng thích nghi với mức độ hạnh phúc do vật chất mang lại. Chiếc túi hiệu hay chiếc xe mới chỉ làm họ vui trong vài tuần, sau đó họ cần một thứ đắt hơn để tìm lại cảm giác đó.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-8029-8cbd-d87ef6b6985c",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lối thoát:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lối thoát:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Cần thay đổi tư duy tài chính bên trong (kỷ luật cá nhân, kiểm soát ham muốn, ưu tiên tích lũy tài sản sinh dòng tiền thay vì tiêu sản).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Cần thay đổi tư duy tài chính bên trong (kỷ luật cá nhân, kiểm soát ham muốn, ưu tiên tích lũy tài sản sinh dòng tiền thay vì tiêu sản).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39f5d164-78d8-8020-b485-fa5069a5233a",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-16T10:29:00.000Z",
        "last_edited_time": "2026-07-16T10:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "39f5d164-78d8-80c1-a707-f30dd2cee019",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-16T11:04:00.000Z",
        "last_edited_time": "2026-07-16T11:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1784200066/uxcomic-imgs/39f5d164-78d8-80c1-a707-f30dd2cee019.png",
            "expiry_time": "2026-10-04T09:09:32.727Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/39f5d164-78d8-80c1-a707-f30dd2cee019"
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-8026-9c0d-f13231f7b365",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Middle-Class Trap (Bẫy tầng lớp trung lưu)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Middle-Class Trap (Bẫy tầng lớp trung lưu)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-8018-a968-d5b526d3e81f",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bản chất:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bản chất:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Đây là một biến thể nguy hiểm của ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Đây là một biến thể nguy hiểm của ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Rat Race",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": true,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Rat Race",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ". Nó xảy ra khi một cá nhân có thu nhập rất tốt, nhưng ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". Nó xảy ra khi một cá nhân có thu nhập rất tốt, nhưng ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "tất cả dòng tiền của họ đều bị khóa chặt vào các cam kết dài hạn",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "tất cả dòng tiền của họ đều bị khóa chặt vào các cam kết dài hạn",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (vay mua nhà 20 năm, vay mua ô tô trả góp, học phí trường quốc tế cho con).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (vay mua nhà 20 năm, vay mua ô tô trả góp, học phí trường quốc tế cho con).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80e5-8307-ee75ae9da01c",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hệ quả:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hệ quả:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Bạn bị biến thành một \"nô lệ cao cấp\" của công việc. Bạn không thể nghỉ việc, không thể khởi nghiệp, không thể mạo hiểm vì ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Bạn bị biến thành một \"nô lệ cao cấp\" của công việc. Bạn không thể nghỉ việc, không thể khởi nghiệp, không thể mạo hiểm vì ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "\"chi phí cố định\" hàng tháng quá cao",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "\"chi phí cố định\" hàng tháng quá cao",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ". Bạn không nghèo, nhưng bạn hoàn toàn mất đi tự do lựa chọn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". Bạn không nghèo, nhưng bạn hoàn toàn mất đi tự do lựa chọn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39f5d164-78d8-808a-9703-c54986e2ccb7",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-16T10:30:00.000Z",
        "last_edited_time": "2026-07-16T10:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "39f5d164-78d8-807f-af7b-ddfb15599fe9",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-16T11:04:00.000Z",
        "last_edited_time": "2026-07-16T11:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1784200068/uxcomic-imgs/39f5d164-78d8-807f-af7b-ddfb15599fe9.png",
            "expiry_time": "2026-10-04T09:09:32.727Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/39f5d164-78d8-807f-af7b-ddfb15599fe9"
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80ae-ac2a-e1b340801e33",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Middle-Income Trap (Bẫy thu nhập trung bình)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Middle-Income Trap (Bẫy thu nhập trung bình)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80a4-80ce-d1b7f4315a45",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bản chất:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bản chất:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Ở cấp độ vĩ mô (quốc gia), hiện tượng này mô tả một đất nước từ nghèo phát triển lên mức thu nhập trung bình nhờ nhân công giá rẻ, nhưng bị mắc kẹt ở đó và không thể bứt phá thành quốc gia giàu có.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Ở cấp độ vĩ mô (quốc gia), hiện tượng này mô tả một đất nước từ nghèo phát triển lên mức thu nhập trung bình nhờ nhân công giá rẻ, nhưng bị mắc kẹt ở đó và không thể bứt phá thành quốc gia giàu có.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-8018-9fb0-cdf47b821b6e",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hệ quả đối với công dân:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hệ quả đối với công dân:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Khi quốc gia bị kẹt trong bẫy này, tầng lớp lao động sẽ đối mặt với tình trạng \"lương tăng chậm nhưng chi phí sinh hoạt (nhà cửa, y tế, giáo dục) tăng phi mã\".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Khi quốc gia bị kẹt trong bẫy này, tầng lớp lao động sẽ đối mặt với tình trạng \"lương tăng chậm nhưng chi phí sinh hoạt (nhà cửa, y tế, giáo dục) tăng phi mã\".",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39f5d164-78d8-802e-b47f-db9a0a261717",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-16T10:30:00.000Z",
        "last_edited_time": "2026-07-16T10:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "39f5d164-78d8-8053-a29f-e7cbaf8fca8b",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-16T11:05:00.000Z",
        "last_edited_time": "2026-07-16T11:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1784200069/uxcomic-imgs/39f5d164-78d8-8053-a29f-e7cbaf8fca8b.png",
            "expiry_time": "2026-10-04T09:09:32.809Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/39f5d164-78d8-8053-a29f-e7cbaf8fca8b"
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-8012-9aa8-c90842933100",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Liquidity Trap (Bẫy thanh khoản cá nhân - \"Giàu trên giấy\")",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Liquidity Trap (Bẫy thanh khoản cá nhân - \"Giàu trên giấy\")",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-8007-aa7e-d85e298a4bd6",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bản chất:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bản chất:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Hiện tượng một người sở hữu khối tài sản ròng (Net Worth) rất lớn nhưng lúc nào cũng túng quẫn, áp lực và không có tiền chi tiêu hàng ngày.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Hiện tượng một người sở hữu khối tài sản ròng (Net Worth) rất lớn nhưng lúc nào cũng túng quẫn, áp lực và không có tiền chi tiêu hàng ngày.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80ce-8bf6-c494e38d5f66",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Bạn có 2 mảnh đất trị giá nhiều tỷ đồng nhưng dồn hết tiền vào đó. Khi gia đình có việc khẩn cấp cần 200 triệu tiền mặt, bạn không thể bẻ một góc mảnh đất ra để thanh toán. Nếu thị trường đóng băng, bạn buộc phải bán tháo \"cắt lỗ\" hoặc đi vay lãi cao dù mình đang có tài sản lớn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Bạn có 2 mảnh đất trị giá nhiều tỷ đồng nhưng dồn hết tiền vào đó. Khi gia đình có việc khẩn cấp cần 200 triệu tiền mặt, bạn không thể bẻ một góc mảnh đất ra để thanh toán. Nếu thị trường đóng băng, bạn buộc phải bán tháo \"cắt lỗ\" hoặc đi vay lãi cao dù mình đang có tài sản lớn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39f5d164-78d8-8017-94a6-d8d93037b05f",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-16T10:30:00.000Z",
        "last_edited_time": "2026-07-16T10:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "39f5d164-78d8-80bf-841f-cf20a535fba6",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-16T11:05:00.000Z",
        "last_edited_time": "2026-07-16T11:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1784200070/uxcomic-imgs/39f5d164-78d8-80bf-841f-cf20a535fba6.png",
            "expiry_time": "2026-10-04T09:09:32.809Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/39f5d164-78d8-80bf-841f-cf20a535fba6"
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-8053-ba0f-ca380679419e",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Credit Card Debt Trap (Bẫy thanh toán tối thiểu thẻ tín dụng)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Credit Card Debt Trap (Bẫy thanh toán tối thiểu thẻ tín dụng)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80e6-81e3-d9965bc386c3",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thẻ tín dụng là công cụ tuyệt vời nếu trả hết 100% sao kê đúng hạn. Nhưng các ngân hàng kiếm được nhiều tiền nhất chính là nhờ cái bẫy mang tên: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thẻ tín dụng là công cụ tuyệt vời nếu trả hết 100% sao kê đúng hạn. Nhưng các ngân hàng kiếm được nhiều tiền nhất chính là nhờ cái bẫy mang tên: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "\"Số tiền thanh toán tối thiểu\" (Minimum Payment Required)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "\"Số tiền thanh toán tối thiểu\" (Minimum Payment Required)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " — thường chỉ bằng 2-5% tổng dư nợ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " — thường chỉ bằng 2-5% tổng dư nợ.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80ba-8237-eef3fb045c33",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cơ chế luẩn quẩn:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cơ chế luẩn quẩn:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Bạn quẹt thẻ tiêu 50 triệu. Đến kỳ sao kê, ngân hàng báo bạn chỉ cần thanh toán tối thiểu 2 triệu là không bị phạt quá hạn. Bạn hí hửng trả 2 triệu và nghĩ mình vẫn ổn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Bạn quẹt thẻ tiêu 50 triệu. Đến kỳ sao kê, ngân hàng báo bạn chỉ cần thanh toán tối thiểu 2 triệu là không bị phạt quá hạn. Bạn hí hửng trả 2 triệu và nghĩ mình vẫn ổn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80c6-ba77-f4b48d6a66d2",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thực tế tàn nhẫn:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thực tế tàn nhẫn:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " 48 triệu còn lại sẽ bị tính lãi suất cực cao (thường từ 20-35%/năm) và ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " 48 triệu còn lại sẽ bị tính lãi suất cực cao (thường từ 20-35%/năm) và ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "tính lãi theo ngày",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "tính lãi theo ngày",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ". Tháng sau, tiền lãi cộng dồn vào gốc. Nếu bạn tiếp tục chỉ trả số tối thiểu, số tiền đó thậm chí không đủ bù tiền lãi phát sinh hàng tháng. Bạn sẽ mất nhiều năm, thậm chí cả đời chỉ để trả nợ cho một món đồ đã hỏng từ lâu.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". Tháng sau, tiền lãi cộng dồn vào gốc. Nếu bạn tiếp tục chỉ trả số tối thiểu, số tiền đó thậm chí không đủ bù tiền lãi phát sinh hàng tháng. Bạn sẽ mất nhiều năm, thậm chí cả đời chỉ để trả nợ cho một món đồ đã hỏng từ lâu.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39f5d164-78d8-804b-afed-ed9a1c3845ec",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-16T10:31:00.000Z",
        "last_edited_time": "2026-07-16T10:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "39f5d164-78d8-8073-bcde-dce69f1b5027",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-16T11:05:00.000Z",
        "last_edited_time": "2026-07-16T11:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1784200072/uxcomic-imgs/39f5d164-78d8-8073-bcde-dce69f1b5027.png",
            "expiry_time": "2026-10-04T09:09:32.809Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/39f5d164-78d8-8073-bcde-dce69f1b5027"
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-8046-822d-f2acf55e372c",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Subscription Trap (Bẫy đăng ký dịch vụ ẩn)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Subscription Trap (Bẫy đăng ký dịch vụ ẩn)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-8038-8af2-eb1552a31fc6",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong nền kinh tế hiện đại, các doanh nghiệp chuyển dịch từ bán đứt sang mô hình \"Subscription\" (trả phí định kỳ hàng tháng/hàng năm) như Netflix, Spotify, iCloud, phần mềm, thẻ tập gym, các gói cước...",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong nền kinh tế hiện đại, các doanh nghiệp chuyển dịch từ bán đứt sang mô hình \"Subscription\" (trả phí định kỳ hàng tháng/hàng năm) như Netflix, Spotify, iCloud, phần mềm, thẻ tập gym, các gói cước...",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80cf-b38b-c90969333746",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cơ chế luẩn quẩn:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cơ chế luẩn quẩn:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Mỗi dịch vụ chỉ có giá \"bằng một ly cà phê\" (vài chục đến vài trăm nghìn/tháng), khiến não bộ của bạn có cảm giác nó rất rẻ. Họ thường cho bạn dùng thử miễn phí 1 tháng (Free Trial) và yêu cầu nhập thẻ visa.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Mỗi dịch vụ chỉ có giá \"bằng một ly cà phê\" (vài chục đến vài trăm nghìn/tháng), khiến não bộ của bạn có cảm giác nó rất rẻ. Họ thường cho bạn dùng thử miễn phí 1 tháng (Free Trial) và yêu cầu nhập thẻ visa.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80bf-81ca-d9890c8dacea",
        "parent": {
          "type": "page_id",
          "page_id": "39e5d164-78d8-80fa-b3e9-c7e5e9500e20"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thực tế tàn nhẫn:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thực tế tàn nhẫn:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Bạn dùng thử xong rồi quên bẵng đi. Thuật toán sẽ tự động gia hạn và âm thầm trừ tiền trong tài khoản của bạn hàng tháng. Khi bạn cộng dồn 10-15 dịch vụ nhỏ như vậy lại, chúng biến thành một khoản \"rò rỉ tài chính\" khổng lồ (vài triệu đồng/tháng) mà bạn không hề hay biết, bào mòn dòng tiền dương của bạn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Bạn dùng thử xong rồi quên bẵng đi. Thuật toán sẽ tự động gia hạn và âm thầm trừ tiền trong tài khoản của bạn hàng tháng. Khi bạn cộng dồn 10-15 dịch vụ nhỏ như vậy lại, chúng biến thành một khoản \"rò rỉ tài chính\" khổng lồ (vài triệu đồng/tháng) mà bạn không hề hay biết, bào mòn dòng tiền dương của bạn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "0595d164-78d8-8245-8a88-812eef0e51fc",
    "created_time": "2026-07-15T00:59:00.000Z",
    "last_edited_time": "2026-08-07T02:41:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "9745d164-78d8-8278-8d18-01137183392f"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2026-07-15T00:59:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FI",
          "number": 34
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "1-Tài chính",
          "color": "default"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2026-08-07T02:41:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "tMsg",
          "name": "⚓:1",
          "color": "default"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Tài chính 101",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Tài chính 101",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/T-i-ch-nh-101-0595d16478d882458a88812eef0e51fc",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "39e5d164-78d8-80c6-9235-e6d0fd667caa",
      "name": "Other",
      "slug": "other",
      "icon": "👾",
      "order": 6,
      "created_time": "2026-07-15T00:59:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Tài chính",
          "slug": "tai-chinh",
          "order": 1
        },
        {
          "id": "5b23efe9-2fa7-4d0d-9ad4-8c25a146e2c5",
          "name": "Design",
          "slug": "design",
          "order": 2
        },
        {
          "id": "492225b3-52b5-4c16-87b6-1e23085bedbc",
          "name": "For Fun",
          "slug": "for-fun",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Tài chính",
      "slug": "tai-chinh",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "39e5d164-78d8-80df-bbbd-f123b549876b",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T13:00:00.000Z",
        "last_edited_time": "2026-07-15T13:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1784120499/uxcomic-imgs/39e5d164-78d8-80df-bbbd-f123b549876b.png",
            "expiry_time": "2026-10-04T09:09:35.112Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/39e5d164-78d8-80df-bbbd-f123b549876b"
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-806a-80b6-c76c48f914a8",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_1",
        "heading_1": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Định nghĩa",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Định nghĩa",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-8055-aa99-d218cf3660ab",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nói một cách đơn giản nhất, ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nói một cách đơn giản nhất, ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Tài chính (Finance)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tài chính (Finance)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là khoa học và nghệ thuật quản lý tiền bạc. Nếu \"tiền\" là vật ngang giá chung, thì \"tài chính\" là ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là khoa học và nghệ thuật quản lý tiền bạc. Nếu \"tiền\" là vật ngang giá chung, thì \"tài chính\" là ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cách tiền vận chuyển qua thời gian và rủi ro",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cách tiền vận chuyển qua thời gian và rủi ro",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-806c-9add-e2ddeebdeb9c",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đối với một người trưởng thành, tài chính xoay quanh 3 câu hỏi cốt lõi:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đối với một người trưởng thành, tài chính xoay quanh 3 câu hỏi cốt lõi:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-802f-a87d-dc27d89baa30",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bạn kiếm tiền bằng cách nào? (Thu nhập)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bạn kiếm tiền bằng cách nào? (Thu nhập)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80d2-b731-e598248d2f3b",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T13:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bạn giữ lại và tối ưu hóa số tiền đó ra sao? (Tiết kiệm & Đầu tư)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bạn giữ lại và tối ưu hóa số tiền đó ra sao? (Tiết kiệm & Đầu tư)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80ea-a117-eed07f32a021",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bạn bảo vệ số tiền đó trước các biến cố như thế nào? (Quản trị rủi ro)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bạn bảo vệ số tiền đó trước các biến cố như thế nào? (Quản trị rủi ro)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-804e-b3a6-cc035ca72dbf",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:04:00.000Z",
        "last_edited_time": "2026-07-15T01:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-8053-a020-c6dcd334bcab",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_1",
        "heading_1": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Principle",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Principle",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-8069-9d8e-efd284e81c1f",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các nguyên lý bất di bất dịch trong tài chính mà bất kỳ quyết định nào của bạn cũng phải dựa vào:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các nguyên lý bất di bất dịch trong tài chính mà bất kỳ quyết định nào của bạn cũng phải dựa vào:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-801a-90fd-d6303f9baf87",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giá trị thời gian của tiền (Time Value of Money - TVM):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giá trị thời gian của tiền (Time Value of Money - TVM):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Một đồng hôm nay luôn có giá trị hơn một đồng ngày mai. Lý do là vì đồng tiền hôm nay có cơ hội được đem đi đầu tư để sinh lời (lãi kép). Và lạm phát luôn xảy ra, tùy quốc gia mà nó nhanh hay chậm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Một đồng hôm nay luôn có giá trị hơn một đồng ngày mai. Lý do là vì đồng tiền hôm nay có cơ hội được đem đi đầu tư để sinh lời (lãi kép). Và lạm phát luôn xảy ra, tùy quốc gia mà nó nhanh hay chậm.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-8041-9c35-db8778ab93cc",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bán thời gian thì không thể tự do tài chính, ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bán thời gian thì không thể tự do tài chính, ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "vì thứ mình đang tạo ra không phải là tài sản, tài sản là thứ tự nó sản sinh ra thêm tiền.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "vì thứ mình đang tạo ra không phải là tài sản, tài sản là thứ tự nó sản sinh ra thêm tiền.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80a7-a84c-c136d3a8fff5",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tính thị trường & giá trị:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tính thị trường & giá trị:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " cùng 1 món hàng, cùng 1 service, cùng 1 khả năng, nhưng khi nó được đón nhận ở 2 thị trường khác nhau, cách đón nhận giá trị khác nhau.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " cùng 1 món hàng, cùng 1 service, cùng 1 khả năng, nhưng khi nó được đón nhận ở 2 thị trường khác nhau, cách đón nhận giá trị khác nhau.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80cf-8c8c-d94c24ef8f85",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mối quan hệ giữa Rủi ro và Lợi nhuận (Risk-Return Trade-off):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mối quan hệ giữa Rủi ro và Lợi nhuận (Risk-Return Trade-off):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Không có bữa ăn nào miễn phí. Lợi nhuận càng cao thì rủi ro mất tiền càng lớn. Nếu ai đó chào mời một cơ hội \"lợi nhuận khủng nhưng không rủi ro\", đó chắc chắn là lừa đảo.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Không có bữa ăn nào miễn phí. Lợi nhuận càng cao thì rủi ro mất tiền càng lớn. Nếu ai đó chào mời một cơ hội \"lợi nhuận khủng nhưng không rủi ro\", đó chắc chắn là lừa đảo.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80a8-beb4-d6c1cbcab492",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tính thanh khoản (Liquidity):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tính thanh khoản (Liquidity):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Khả năng chuyển đổi một tài sản thành tiền mặt nhanh chóng mà không bị mất giá. Tiền mặt có thanh khoản cao nhất, trong khi bất động sản có thanh khoản thấp hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Khả năng chuyển đổi một tài sản thành tiền mặt nhanh chóng mà không bị mất giá. Tiền mặt có thanh khoản cao nhất, trong khi bất động sản có thanh khoản thấp hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80e6-bb44-e0ebc1f8ace3",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Opportunity cost: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Opportunity cost: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "là số tiền bạn tiêu, mà là giá trị của những gì bạn phải từ bỏ khi đưa ra một lựa chọn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "là số tiền bạn tiêu, mà là giá trị của những gì bạn phải từ bỏ khi đưa ra một lựa chọn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-8072-8ed5-d8364db15ed6",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "The Leverage Principle:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "The Leverage Principle:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Đòn bẩy = Kính lúp, nó chỉ nhân nhanh khả năng thành công / thất bại.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Đòn bẩy = Kính lúp, nó chỉ nhân nhanh khả năng thành công / thất bại.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80aa-b80a-f6a9ec6a3b01",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Market Efficiency & Asymmetric Information (Tính hiệu quả của thị trường & Thông tin bất đối xứng):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Market Efficiency & Asymmetric Information (Tính hiệu quả của thị trường & Thông tin bất đối xứng):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Trong giới tài chính, thông tin = tiền. Thông tin lái hành vi (hãy cẩn trọng với nguồn thông tin mà bạn có).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Trong giới tài chính, thông tin = tiền. Thông tin lái hành vi (hãy cẩn trọng với nguồn thông tin mà bạn có).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-8000-b8ee-cab77685867e",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Margin of Safety (Biên độ an toàn):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Margin of Safety (Biên độ an toàn):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Biên độ an toàn là khoảng cách giữa giá trị thực tế của một tài sản và giá bạn trả để mua nó. (vd: giá cổ phiếu bạn định giá là 10tr thì nên mua lúc nó biến động 7-8tr, lúc bạn vay mua gì đó thì không bao giờ vay mua với số tiền trả góp hàng tháng chiếm quá 40% thu nhập).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Biên độ an toàn là khoảng cách giữa giá trị thực tế của một tài sản và giá bạn trả để mua nó. (vd: giá cổ phiếu bạn định giá là 10tr thì nên mua lúc nó biến động 7-8tr, lúc bạn vay mua gì đó thì không bao giờ vay mua với số tiền trả góp hàng tháng chiếm quá 40% thu nhập).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-804e-b100-eafb5e1911d6",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Asymmetric Risk/Reward (Rủi ro bất đối xứng): ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Asymmetric Risk/Reward (Rủi ro bất đối xứng): ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Đây là trạng thái của một quyết định mà ở đó khoản lỗ tối đa bạn phải chịu rất nhỏ (hoặc giới hạn), nhưng khoản lợi nhuận tiềm năng nhận lại thì vô hạn (hoặc cực kỳ lớn). Ví dụ: việc bạn dành thời gian cuối tuần để tự xây dựng một sản phẩm nhỏ (indie hacking), viết blog chia sẻ kiến thức, hoặc gửi CV ứng tuyển vào một vị trí cao hơn. Cái mất là thời gian nhưng tiềm năng cơ hội thì rất lớn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đây là trạng thái của một quyết định mà ở đó khoản lỗ tối đa bạn phải chịu rất nhỏ (hoặc giới hạn), nhưng khoản lợi nhuận tiềm năng nhận lại thì vô hạn (hoặc cực kỳ lớn). Ví dụ: việc bạn dành thời gian cuối tuần để tự xây dựng một sản phẩm nhỏ (indie hacking), viết blog chia sẻ kiến thức, hoặc gửi CV ứng tuyển vào một vị trí cao hơn. Cái mất là thời gian nhưng tiềm năng cơ hội thì rất lớn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80a9-9826-f74bb0b031b3",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:04:00.000Z",
        "last_edited_time": "2026-07-15T01:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80ab-b8cc-dde156c430f1",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_1",
        "heading_1": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Fundamentals ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Fundamentals ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-8088-a87c-f7911d4dcc5a",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tài chính cá nhân",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tài chính cá nhân",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80e9-a659-d5ca5e6d92a5",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tư duy về Tài sản & Tiêu sản",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tư duy về Tài sản & Tiêu sản",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80b0-aa35-c70f072f0e4a",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quản trị Rủi ro & Tín dụng",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quản trị Rủi ro & Tín dụng",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-8034-8bf9-db29ee628dfa",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhập môn Đầu tư dựa trên Dữ liệu (Data-driven Investing)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhập môn Đầu tư dựa trên Dữ liệu (Data-driven Investing)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-806d-8363-fee074c80326",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Poverty trap & Rat race",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Poverty trap & Rat race",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 3
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-802d-9d13-fc74891965dc",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kinh tế vi mô",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kinh tế vi mô",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-806f-8ea4-e1aa585abd3c",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bản chất của Cung - Cầu & Điểm cân bằng",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bản chất của Cung - Cầu & Điểm cân bằng",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-808d-965e-c81e923616d6",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Động lực và Cấu trúc thị trường",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Động lực và Cấu trúc thị trường",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-8076-8f77-eefe928c56fc",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kinh tế vĩ mô",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kinh tế vĩ mô",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80c2-8d1e-d860f7d27a68",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ba trụ cột của Vĩ mô: GDP, Lạm phát & Thất nghiệp",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ba trụ cột của Vĩ mô: GDP, Lạm phát & Thất nghiệp",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-801c-a7ae-c717255ab672",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ngân hàng Trung ương & \"Van điều tiết\" Lãi suất",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ngân hàng Trung ương & \"Van điều tiết\" Lãi suất",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-8036-b648-e029dec30f90",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:01:00.000Z",
        "last_edited_time": "2026-07-15T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chu kỳ kinh tế toàn cầu & Bản đồ dòng tiền",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chu kỳ kinh tế toàn cầu & Bản đồ dòng tiền",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80df-9cb2-cec753066e91",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:05:00.000Z",
        "last_edited_time": "2026-07-15T01:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-8013-83db-ceb213756f3b",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:05:00.000Z",
        "last_edited_time": "2026-07-15T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_1",
        "heading_1": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Approach",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Approach",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-803d-9014-d7c8bfe8c52b",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:05:00.000Z",
        "last_edited_time": "2026-07-15T01:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Làm công nhưng lương thực cao, lấy thặng dư đi đầu tư",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Làm công nhưng lương thực cao, lấy thặng dư đi đầu tư",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-807e-803d-fe2b74038b13",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:05:00.000Z",
        "last_edited_time": "2026-07-15T01:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Làm lèo tèo, làm side project để có nguồn thu nhập thụ động",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Làm lèo tèo, làm side project để có nguồn thu nhập thụ động",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80fd-8efb-dc1698dbc72f",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:05:00.000Z",
        "last_edited_time": "2026-07-15T01:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cả 2 đều đòi hỏi năng lực, đều có bài toàn cạnh tranh khác nhau. Cá nhân nên khéo léo xem cái nào phù hợp với mình, cái nào mình thấy sẽ dễ có room hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cả 2 đều đòi hỏi năng lực, đều có bài toàn cạnh tranh khác nhau. Cá nhân nên khéo léo xem cái nào phù hợp với mình, cái nào mình thấy sẽ dễ có room hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-80ae-8548-f3e733ad9f94",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:05:00.000Z",
        "last_edited_time": "2026-07-15T01:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "99% bỏ việc ra làm riêng đều tạch, cần làm as side project & bền 1 thời gian đã. Đừng nghĩ làm gì đó để giàu, nó rất bề mặt, chỉ nên làm được gì đó để “gãi đúng chỗ ngứa”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "99% bỏ việc ra làm riêng đều tạch, cần làm as side project & bền 1 thời gian đã. Đừng nghĩ làm gì đó để giàu, nó rất bề mặt, chỉ nên làm được gì đó để “gãi đúng chỗ ngứa”.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39e5d164-78d8-8095-86e1-fdcb4597a483",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-15T01:05:00.000Z",
        "last_edited_time": "2026-07-15T01:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "1 tỉ đầu tiên đem tiết kiệm / đầu tư thì mới giảm nhẹ được khoảng chi phí hàng tháng, từ đó làm đà tâm lý để mình thiết lập những tài sản khác.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "1 tỉ đầu tiên đem tiết kiệm / đầu tư thì mới giảm nhẹ được khoảng chi phí hàng tháng, từ đó làm đà tâm lý để mình thiết lập những tài sản khác.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39d5d164-78d8-8039-ba00-c4ed4acfc8e9",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-14T12:19:00.000Z",
        "last_edited_time": "2026-07-15T01:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "39d5d164-78d8-8051-bd54-eddd9ddf742b",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-14T14:01:00.000Z",
        "last_edited_time": "2026-07-15T01:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Remarkable video",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Remarkable video",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39d5d164-78d8-809d-b790-f190212f0018",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-14T14:01:00.000Z",
        "last_edited_time": "2026-07-15T01:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thuê vs Mua nhà",
                "link": {
                  "url": "https://www.youtube.com/watch?v=VuhqRw_YwBM&list=PL1bLXQ3Ow2lZ_R2MdEjOln67i9zfnVxuu"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thuê vs Mua nhà",
              "href": "https://www.youtube.com/watch?v=VuhqRw_YwBM&list=PL1bLXQ3Ow2lZ_R2MdEjOln67i9zfnVxuu"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39d5d164-78d8-8063-a364-ec27ef7bc61c",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-14T14:01:00.000Z",
        "last_edited_time": "2026-07-15T01:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lạm phát",
                "link": {
                  "url": "https://www.youtube.com/watch?v=DHdEAtes8H8&list=PL1bLXQ3Ow2lZ_R2MdEjOln67i9zfnVxuu&index=5"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lạm phát",
              "href": "https://www.youtube.com/watch?v=DHdEAtes8H8&list=PL1bLXQ3Ow2lZ_R2MdEjOln67i9zfnVxuu&index=5"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39d5d164-78d8-8014-b5db-fcd41a0ed4fb",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-14T16:02:00.000Z",
        "last_edited_time": "2026-08-07T02:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Làm công ăn lương & Tự do tài chính (p1)",
                "link": {
                  "url": "https://www.youtube.com/watch?v=cri-olhOOrM&list=PL1bLXQ3Ow2lZ_R2MdEjOln67i9zfnVxuu&index=14"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Làm công ăn lương & Tự do tài chính (p1)",
              "href": "https://www.youtube.com/watch?v=cri-olhOOrM&list=PL1bLXQ3Ow2lZ_R2MdEjOln67i9zfnVxuu&index=14"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39d5d164-78d8-80e9-8f19-c90f3356563e",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-14T16:02:00.000Z",
        "last_edited_time": "2026-07-15T01:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Làm công ăn lương & Tự do tài chính (p2)",
                "link": {
                  "url": "https://www.youtube.com/watch?v=6Snew5np1tE&list=PL1bLXQ3Ow2lZ_R2MdEjOln67i9zfnVxuu&index=14"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Làm công ăn lương & Tự do tài chính (p2)",
              "href": "https://www.youtube.com/watch?v=6Snew5np1tE&list=PL1bLXQ3Ow2lZ_R2MdEjOln67i9zfnVxuu&index=14"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39d5d164-78d8-804d-8c86-f93991ff3912",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-14T14:00:00.000Z",
        "last_edited_time": "2026-07-15T01:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "39c5d164-78d8-8085-9a02-ca408734e894",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-13T17:28:00.000Z",
        "last_edited_time": "2026-07-15T01:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Helpful Link",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Helpful Link",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39c5d164-78d8-80fc-bd75-e1a4b6cf54d7",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-13T17:28:00.000Z",
        "last_edited_time": "2026-07-15T01:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://cafef.vn/du-lieu.chn",
                "link": {
                  "url": "https://cafef.vn/du-lieu.chn"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://cafef.vn/du-lieu.chn",
              "href": "https://cafef.vn/du-lieu.chn"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39c5d164-78d8-8097-aea4-d898e4bf4110",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-13T17:28:00.000Z",
        "last_edited_time": "2026-07-15T01:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://24hmoney.vn/",
                "link": {
                  "url": "https://24hmoney.vn/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://24hmoney.vn/",
              "href": "https://24hmoney.vn/"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39d5d164-78d8-8041-bf79-f023884e3192",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-14T12:32:00.000Z",
        "last_edited_time": "2026-07-15T01:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.youtube.com/@ThanhCongTC",
                "link": {
                  "url": "https://www.youtube.com/@ThanhCongTC"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.youtube.com/@ThanhCongTC",
              "href": "https://www.youtube.com/@ThanhCongTC"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39d5d164-78d8-8031-b7db-db2c8ae9ea06",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-14T12:32:00.000Z",
        "last_edited_time": "2026-07-15T01:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.youtube.com/c/HieuNN",
                "link": {
                  "url": "https://www.youtube.com/c/HieuNN"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.youtube.com/c/HieuNN",
              "href": "https://www.youtube.com/c/HieuNN"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "39d5d164-78d8-804a-8071-de722e9cb9c1",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-14T13:00:00.000Z",
        "last_edited_time": "2026-07-15T01:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.youtube.com/@lcghuy",
                "link": {
                  "url": "https://www.youtube.com/@lcghuy"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.youtube.com/@lcghuy",
              "href": "https://www.youtube.com/@lcghuy"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3a15d164-78d8-800f-b200-edeab0f593a8",
        "parent": {
          "type": "page_id",
          "page_id": "0595d164-78d8-8245-8a88-812eef0e51fc"
        },
        "created_time": "2026-07-18T03:26:00.000Z",
        "last_edited_time": "2026-07-18T03:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.visualcapitalist.com/",
                "link": {
                  "url": "https://www.visualcapitalist.com/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.visualcapitalist.com/",
              "href": "https://www.visualcapitalist.com/"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "4aa5d164-78d8-8376-989c-810059218b11",
    "created_time": "2026-07-15T00:59:00.000Z",
    "last_edited_time": "2026-08-12T01:30:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "9745d164-78d8-8278-8d18-01137183392f"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2026-07-15T00:59:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FI",
          "number": 30
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "1-Tài chính",
          "color": "default"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2026-08-12T01:30:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "sgq|",
          "name": "⚔️:1",
          "color": "red"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Caculator",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Caculator",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Caculator-4aa5d16478d88376989c810059218b11",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "39e5d164-78d8-80c6-9235-e6d0fd667caa",
      "name": "Other",
      "slug": "other",
      "icon": "👾",
      "order": 6,
      "created_time": "2026-07-15T00:59:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Tài chính",
          "slug": "tai-chinh",
          "order": 1
        },
        {
          "id": "5b23efe9-2fa7-4d0d-9ad4-8c25a146e2c5",
          "name": "Design",
          "slug": "design",
          "order": 2
        },
        {
          "id": "492225b3-52b5-4c16-87b6-1e23085bedbc",
          "name": "For Fun",
          "slug": "for-fun",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Tài chính",
      "slug": "tai-chinh",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "39e5d164-78d8-8060-bddb-d236ac1fd014",
        "parent": {
          "type": "page_id",
          "page_id": "4aa5d164-78d8-8376-989c-810059218b11"
        },
        "created_time": "2026-07-15T13:00:00.000Z",
        "last_edited_time": "2026-07-15T13:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1784120502/uxcomic-imgs/39e5d164-78d8-8060-bddb-d236ac1fd014.png",
            "expiry_time": "2026-10-04T09:09:35.542Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/39e5d164-78d8-8060-bddb-d236ac1fd014"
      },
      {
        "object": "block",
        "id": "3ba5d164-78d8-802b-8588-ea9852209f9a",
        "parent": {
          "type": "page_id",
          "page_id": "4aa5d164-78d8-8376-989c-810059218b11"
        },
        "created_time": "2026-08-12T01:30:00.000Z",
        "last_edited_time": "2026-08-12T01:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "embed",
        "embed": {
          "caption": [],
          "url": "https://res.cloudinary.com/dpzknshvi/raw/upload/v1786498299/uxcomic-html/3ba5d164-78d8-802b-8588-ea9852209f9a.html"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3ba5d164-78d8-8037-9b5a-d16cffc6f464",
        "parent": {
          "type": "page_id",
          "page_id": "4aa5d164-78d8-8376-989c-810059218b11"
        },
        "created_time": "2026-08-12T01:30:00.000Z",
        "last_edited_time": "2026-08-12T01:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "10f5d164-78d8-804f-b8ea-e2a265424273",
    "created_time": "2024-09-28T03:59:00.000Z",
    "last_edited_time": "2025-08-15T10:43:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "page_id",
      "page_id": "a58596ad-902a-49e3-9a81-fdb9b84b92d9"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "title": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "UX comic - Introduction",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "UX comic - Introduction",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/UX-comic-Introduction-10f5d16478d8804fb8eae2a265424273",
    "public_url": null,
    "archived": false,
    "request_id": "2dc9bb92-665b-4413-a341-b3f4dd8fd971",
    "content": [
      {
        "object": "block",
        "id": "1145d164-78d8-8054-b6ed-ee06674bf4ed",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-03T14:54:00.000Z",
        "last_edited_time": "2024-10-03T14:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081079/uxcomic-imgs/1145d164-78d8-8054-b6ed-ee06674bf4ed.png",
            "expiry_time": "2026-10-04T09:09:36.474Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1145d164-78d8-8054-b6ed-ee06674bf4ed"
      },
      {
        "object": "block",
        "id": "1175d164-78d8-8062-b2b6-e5d5c1f1d3b4",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-06T13:42:00.000Z",
        "last_edited_time": "2024-10-06T13:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tụi mình ở đây để chia sẻ các kiến thức, góc nhìn cá nhân về hành trình làm nghề UX/UI.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tụi mình ở đây để chia sẻ các kiến thức, góc nhìn cá nhân về hành trình làm nghề UX/UI.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "👋"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-80f5-ba2a-dc7da74d909e",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-09-28T04:03:00.000Z",
        "last_edited_time": "2025-01-14T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình xin giới thiệu chút, mình có background công việc trong graphic design, illustrator, sau đó mình chuyển sang lĩnh vực UX/UI, và chắc cũng như đa phần mọi người đó là học vài khoá, tự mày mò đọc blog để học hỏi thêm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình xin giới thiệu chút, mình có background công việc trong graphic design, illustrator, sau đó mình chuyển sang lĩnh vực UX/UI, và chắc cũng như đa phần mọi người đó là học vài khoá, tự mày mò đọc blog để học hỏi thêm.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-8022-90a4-e47dd0056496",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-14T02:05:00.000Z",
        "last_edited_time": "2025-01-14T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80b8-ba44-f0b7bbe1c82c",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-22T16:01:00.000Z",
        "last_edited_time": "2024-12-25T02:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuy nhiên trong quá trình tự học, mình hay gặp phải các vấn đề sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuy nhiên trong quá trình tự học, mình hay gặp phải các vấn đề sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-80c7-9e98-d40601cb5d76",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-09-28T04:11:00.000Z",
        "last_edited_time": "2024-12-25T02:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "😵 Theo thời gian, kiến thức gia tăng, mọi thứ dần trở nên rối ren, chi chít như màn nhện,  nó như cái cảnh mình vào khu rừng mà không có map, cứ xoay vòng vòng, vòng vòng, vòng vòng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "😵 Theo thời gian, kiến thức gia tăng, mọi thứ dần trở nên rối ren, chi chít như màn nhện,  nó như cái cảnh mình vào khu rừng mà không có map, cứ xoay vòng vòng, vòng vòng, vòng vòng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-8055-ba1e-cdeabdc6e536",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-09-28T04:11:00.000Z",
        "last_edited_time": "2024-12-25T02:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "🫣 Mặc dù đã cất công collect, tự học các thứ nhưng đến lúc làm thực tế thì lại quên bén đi, xong tự chửi bản thân: “học chi cho lắm không áp dụng được gì”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "🫣 Mặc dù đã cất công collect, tự học các thứ nhưng đến lúc làm thực tế thì lại quên bén đi, xong tự chửi bản thân: “học chi cho lắm không áp dụng được gì”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80e9-a617-fed34699865b",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T02:40:00.000Z",
        "last_edited_time": "2024-12-25T02:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "😫 Đến lúc nhớ để áp dụng rồi thì lại có khi không phù hợp, kết quả không như  khuôn mẫu sách vở.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "😫 Đến lúc nhớ để áp dụng rồi thì lại có khi không phù hợp, kết quả không như  khuôn mẫu sách vở.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80bd-821c-d1385c95355a",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-22T14:48:00.000Z",
        "last_edited_time": "2024-12-23T03:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081080/uxcomic-imgs/1645d164-78d8-80bd-821c-d1385c95355a.jpg",
            "expiry_time": "2026-10-04T09:09:36.475Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1645d164-78d8-80bd-821c-d1385c95355a"
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-80c2-a417-ca89e359e251",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-27T04:48:00.000Z",
        "last_edited_time": "2024-12-22T16:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1175d164-78d8-802e-b0b2-e9f603db4448",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-06T07:32:00.000Z",
        "last_edited_time": "2025-01-14T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Rồi tình cờ, mình có nghe đến kĩ thuật Feyman trong việc học - đại ý là học làm sao để bạn có thể dạy lại được cho người khác. Sau đó mình bắt đầu áp dụng, tập thói quen nghiền ngẫm, tập hệ thống hoá, để “ôn bài”, để biết thêm những thứ mà mình tưởng là mình đã biết >> 💡 project được sinh ra",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Rồi tình cờ, mình có nghe đến kĩ thuật Feyman trong việc học - đại ý là học làm sao để bạn có thể dạy lại được cho người khác. Sau đó mình bắt đầu áp dụng, tập thói quen nghiền ngẫm, tập hệ thống hoá, để “ôn bài”, để biết thêm những thứ mà mình tưởng là mình đã biết >> 💡 project được sinh ra",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-801d-bbfe-cbe5f489c720",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-10T02:05:00.000Z",
        "last_edited_time": "2025-01-12T14:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Share your knowledge and teach others — it benefits both of you!",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Share your knowledge and teach others — it benefits both of you!",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13f5d164-78d8-801a-871e-c9d89a1c3ec0",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-11-15T02:12:00.000Z",
        "last_edited_time": "2024-11-15T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-80ac-ba44-fb1e73088960",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-14T02:37:00.000Z",
        "last_edited_time": "2025-08-14T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "✏️ Other tiny things",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "✏️ Other tiny things",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-8041-b4ef-f5c09e17be85",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T02:57:00.000Z",
        "last_edited_time": "2025-01-14T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lê thê vậy đủ rồi. Nếu bạn có thêm chút thời gian, hãy xem thêm các chú thích ở dưới nhé, vì nó liên quan đến giá trị “hệ thống hoá” mà mình đang muốn offer khi làm blog này.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lê thê vậy đủ rồi. Nếu bạn có thêm chút thời gian, hãy xem thêm các chú thích ở dưới nhé, vì nó liên quan đến giá trị “hệ thống hoá” mà mình đang muốn offer khi làm blog này.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8033-b108-debe1f729659",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:55:00.000Z",
        "last_edited_time": "2025-08-14T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755136730/uxcomic-imgs/24f5d164-78d8-8033-b108-debe1f729659.png",
            "expiry_time": "2026-10-04T09:09:36.475Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/24f5d164-78d8-8033-b108-debe1f729659"
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80cf-9e31-eba6bd4663a0",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:02:00.000Z",
        "last_edited_time": "2025-08-14T01:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1175d164-78d8-807a-bc07-ce1b50fe378a",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-06T13:38:00.000Z",
        "last_edited_time": "2025-08-14T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "📢 ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "📢 ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Disclaimer",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Disclaimer",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8071-af14-c321c266389f",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:47:00.000Z",
        "last_edited_time": "2025-08-15T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "các bài viết này là tổng hợp của những kiến thức lượm lặt trên mạng + chatGPT + góc độ, quan sát cá nhân >> mình vẫn có thể sai >> nên đừng vội chấp nhận hoặc tin hết những gì mình viết (mặc dù mình đều cố gắng tìm hiểu các nguồn đáng tin cậy và kèm link reference cho từng bài viết nếu có).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "các bài viết này là tổng hợp của những kiến thức lượm lặt trên mạng + chatGPT + góc độ, quan sát cá nhân >> mình vẫn có thể sai >> nên đừng vội chấp nhận hoặc tin hết những gì mình viết (mặc dù mình đều cố gắng tìm hiểu các nguồn đáng tin cậy và kèm link reference cho từng bài viết nếu có).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8070-a7db-d7a5898e615d",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:47:00.000Z",
        "last_edited_time": "2025-08-15T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hãy xem mình như một người bạn, một đồng nghiệp như đang trò chuyện với bạn trong một buổi ăn trưa, một buổi hẹn cafe, chúng mình ở đây để chia sẻ và học hỏi nhau trên con đường mày mò & cải thiện quá trình làm nghề UX/UI.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hãy xem mình như một người bạn, một đồng nghiệp như đang trò chuyện với bạn trong một buổi ăn trưa, một buổi hẹn cafe, chúng mình ở đây để chia sẻ và học hỏi nhau trên con đường mày mò & cải thiện quá trình làm nghề UX/UI.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80be-bd5b-fde96187a589",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:48:00.000Z",
        "last_edited_time": "2025-08-15T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Again luôn recheck các thông tin, luận điểm của mình nhé. Cảm ơn mọi người nhiều 😜.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Again luôn recheck các thông tin, luận điểm của mình nhé. Cảm ơn mọi người nhiều 😜.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80b0-a0cf-c3d3ac509af9",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:03:00.000Z",
        "last_edited_time": "2025-01-14T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1815d164-78d8-8043-8c86-f3f060cfaa2c",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-20T03:25:00.000Z",
        "last_edited_time": "2025-01-20T03:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Contact",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Contact",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80e8-8428-f6dcc343a5ec",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T02:45:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình rất vui lòng nếu nhận được những góc nhìn khác từ các bạn, nếu bạn muốn liên hệ hay chia sẻ gì với mình thêm, hay muốn mình share topic gì khác, hãy để lại lời nhắn qua:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình rất vui lòng nếu nhận được những góc nhìn khác từ các bạn, nếu bạn muốn liên hệ hay chia sẻ gì với mình thêm, hay muốn mình share topic gì khác, hãy để lại lời nhắn qua:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1c15d164-78d8-80dc-bc47-ff02b571cf37",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-03-25T05:59:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1815d164-78d8-8006-8bb0-f9639445d848",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-20T03:23:00.000Z",
        "last_edited_time": "2025-01-20T03:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thread",
                "link": {
                  "url": "https://www.threads.net/@ux_share_choi?hl=vi"
                }
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thread",
              "href": "https://www.threads.net/@ux_share_choi?hl=vi"
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "💬"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1815d164-78d8-801b-b02c-f6a970beae36",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-20T03:23:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Linkedin",
                "link": {
                  "url": "https://www.linkedin.com/in/minhhuynh95/"
                }
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Linkedin",
              "href": "https://www.linkedin.com/in/minhhuynh95/"
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "💼"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1c15d164-78d8-80aa-b4ae-d81e4bdbad4e",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-03-25T05:59:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-8081-8eb4-f9373214ab36",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:10:00.000Z",
        "last_edited_time": "2024-12-25T03:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081083/uxcomic-imgs/1675d164-78d8-8081-8eb4-f9373214ab36.png",
            "expiry_time": "2026-10-04T09:09:36.513Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1675d164-78d8-8081-8eb4-f9373214ab36"
      },
      {
        "object": "block",
        "id": "1675d164-78d8-802d-a902-c546642f72dc",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:03:00.000Z",
        "last_edited_time": "2024-12-28T03:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mong các bài viết này có chút hữu ích cho bạn 🥰. Dự án được built with ❤️‍🔥 bởi ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mong các bài viết này có chút hữu ích cho bạn 🥰. Dự án được built with ❤️‍🔥 bởi ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Minh",
                "link": {
                  "url": "https://www.linkedin.com/in/minhhuynh95/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Minh",
              "href": "https://www.linkedin.com/in/minhhuynh95/"
            },
            {
              "type": "text",
              "text": {
                "content": " & ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " & ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Hùng",
                "link": {
                  "url": "https://www.linkedin.com/in/vhung71/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hùng",
              "href": "https://www.linkedin.com/in/vhung71/"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "26aaa722-7e34-4293-bf96-4eaa09a6a24d",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-11-23T07:53:00.000Z",
        "last_edited_time": "2024-11-23T07:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-80ef-a681-d83a4e28308a",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-27T04:50:00.000Z",
        "last_edited_time": "2024-10-27T04:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "16e5d164-78d8-80bc-911c-e46d1955dd98",
    "created_time": "2025-01-01T04:19:00.000Z",
    "last_edited_time": "2026-07-18T04:37:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "11a5d164-78d8-8116-a337-fd3af01f0a79"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2025-01-01T04:19:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "YsTj",
        "type": "unique_id",
        "unique_id": {
          "prefix": "TN",
          "number": 7
        }
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "1-UI relevant",
          "color": "default"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2026-07-18T04:37:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "sgq|",
          "name": "⚔️:1",
          "color": "red"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Figma UI term vs CSS term",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Figma UI term vs CSS term",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Figma-UI-term-vs-CSS-term-16e5d16478d880bc911ce46d1955dd98",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "11a5d164-78d8-80c5-95ab-ebc19da12022",
      "name": "Technical",
      "slug": "technical",
      "icon": "🕹️",
      "order": 5,
      "created_time": "2024-10-09T02:56:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "UI relevant",
          "slug": "ui-relevant",
          "order": 1
        },
        {
          "id": "d416873d-bbef-4675-8e5f-6dadaca6b689",
          "name": "Functionality",
          "slug": "functionality",
          "order": 2
        },
        {
          "id": "9171cfc1-4b53-4d18-b58f-72e33c73ea78",
          "name": "Data",
          "slug": "data",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "UI relevant",
      "slug": "ui-relevant",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "16e5d164-78d8-80b7-a94e-e63658e10bb8",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:20:00.000Z",
        "last_edited_time": "2025-01-01T12:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081059/uxcomic-imgs/16e5d164-78d8-80b7-a94e-e63658e10bb8.png",
            "expiry_time": "2026-10-04T09:09:38.071Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/16e5d164-78d8-80b7-a94e-e63658e10bb8"
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8026-9908-cf50f3c1d365",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:20:00.000Z",
        "last_edited_time": "2025-01-01T12:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhiều khi các setting trên Figma không phải ngôn ngữ mà Dev hay dùng >> dẫn đến dễ gặp khó khăn khi bạn muốn nói sao cho dev hiểu, vì có khoảng gap giữa term phía designer (Figma) vs term phía dev (CSS).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhiều khi các setting trên Figma không phải ngôn ngữ mà Dev hay dùng >> dẫn đến dễ gặp khó khăn khi bạn muốn nói sao cho dev hiểu, vì có khoảng gap giữa term phía designer (Figma) vs term phía dev (CSS).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80d1-8d7d-ec027d1f86c2",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-04T12:13:00.000Z",
        "last_edited_time": "2025-01-12T12:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081061/uxcomic-imgs/1715d164-78d8-80d1-8d7d-ec027d1f86c2.webp",
            "expiry_time": "2026-10-04T09:09:38.071Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1715d164-78d8-80d1-8d7d-ec027d1f86c2"
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8078-a7b0-d2b90ecdef9c",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:21:00.000Z",
        "last_edited_time": "2025-01-01T04:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nên bài này để mình liệt kê ra từ điển mapping term giữa Figma và CSS.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nên bài này để mình liệt kê ra từ điển mapping term giữa Figma và CSS.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80f5-b860-f13301a48992",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:58:00.000Z",
        "last_edited_time": "2025-01-01T04:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tham khảo thêm các loại ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tham khảo thêm các loại ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "CSS tại trang này.",
                "link": {
                  "url": "https://www.w3schools.com/cssref/index.php"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "CSS tại trang này.",
              "href": "https://www.w3schools.com/cssref/index.php"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-808b-9b0d-fb1f0c7a003c",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:29:00.000Z",
        "last_edited_time": "2025-01-01T07:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tip: Nếu bạn muốn thử áp dụng thực tế thì mình nghĩ có thể ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tip: Nếu bạn muốn thử áp dụng thực tế thì mình nghĩ có thể ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "webflow ",
                "link": {
                  "url": "https://webflow.com/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "webflow ",
              "href": "https://webflow.com/"
            },
            {
              "type": "text",
              "text": {
                "content": "nhé. Dùng ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "nhé. Dùng ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Codepen",
                "link": {
                  "url": "https://codepen.io/pen/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Codepen",
              "href": "https://codepen.io/pen/"
            },
            {
              "type": "text",
              "text": {
                "content": " để thử preview code.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " để thử preview code.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-805f-9997-ee45c859ce4b",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:22:00.000Z",
        "last_edited_time": "2025-01-01T04:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-800c-865e-ce233ea21e4d",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:41:00.000Z",
        "last_edited_time": "2025-01-01T08:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Fundamental",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Fundamental",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80cc-a104-f59da2cbc4ed",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T12:59:00.000Z",
        "last_edited_time": "2025-01-04T02:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước hết ta phải hiểu về Box model, đơn giản có thể hiểu khác với design, ta đặt để layout các element một cách freedom được NHƯNG phía dev thì không, họ sẽ build UI dựa trên các block đặt để lên nhau, khi họ xây dựng UI đó phải có logic hơn rất nhiều, và mình cần hiểu điều đó thông qua khái niệm box model.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước hết ta phải hiểu về Box model, đơn giản có thể hiểu khác với design, ta đặt để layout các element một cách freedom được NHƯNG phía dev thì không, họ sẽ build UI dựa trên các block đặt để lên nhau, khi họ xây dựng UI đó phải có logic hơn rất nhiều, và mình cần hiểu điều đó thông qua khái niệm box model.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80a9-892e-f7ab7f8cd185",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:41:00.000Z",
        "last_edited_time": "2025-01-04T02:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "UI Layout as Box model",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UI Layout as Box model",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8074-9007-df744cb01fe8",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T05:03:00.000Z",
        "last_edited_time": "2025-01-04T02:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081063/uxcomic-imgs/16e5d164-78d8-8074-9007-df744cb01fe8.png",
            "expiry_time": "2026-10-04T09:09:38.071Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/16e5d164-78d8-8074-9007-df744cb01fe8"
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80f7-a0ae-c040df8e9c15",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T05:28:00.000Z",
        "last_edited_time": "2025-01-04T02:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081064/uxcomic-imgs/16e5d164-78d8-80f7-a0ae-c040df8e9c15.png",
            "expiry_time": "2026-10-04T09:09:38.072Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/16e5d164-78d8-80f7-a0ae-c040df8e9c15"
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-800e-91a6-d9b9d336743c",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T13:08:00.000Z",
        "last_edited_time": "2025-01-04T02:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tips: hãy áp dụng auto layout nhiều nhất có thể. Hoặc tốt hơn nữa hãy dùng Webflow để tự build portfolio cho bạn",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tips: hãy áp dụng auto layout nhiều nhất có thể. Hoặc tốt hơn nữa hãy dùng Webflow để tự build portfolio cho bạn",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (vì webflow hiện là web builder có giao diện trực quan nhất nằm giữa điểm cần bằng design & dev).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (vì webflow hiện là web builder có giao diện trực quan nhất nằm giữa điểm cần bằng design & dev).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8095-b4a6-c0848d9c88cc",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T13:09:00.000Z",
        "last_edited_time": "2025-01-01T13:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80bb-88b6-fff27a379d2a",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T05:01:00.000Z",
        "last_edited_time": "2025-01-01T13:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Spacing",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Spacing",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8007-a22c-c8610b9cc88c",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-04T02:09:00.000Z",
        "last_edited_time": "2025-01-04T02:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tiếp sau box model, là cách bạn hiểu về spacing cần khác với cách designer hay làm, mình cần làm quen với các khái niệm sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tiếp sau box model, là cách bạn hiểu về spacing cần khác với cách designer hay làm, mình cần làm quen với các khái niệm sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8024-8dcc-d8d348c2b7f4",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:42:00.000Z",
        "last_edited_time": "2025-01-01T13:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081065/uxcomic-imgs/16e5d164-78d8-8024-8dcc-d8d348c2b7f4.png",
            "expiry_time": "2026-10-04T09:09:38.072Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/16e5d164-78d8-8024-8dcc-d8d348c2b7f4"
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8076-81e0-cd4806b10076",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:52:00.000Z",
        "last_edited_time": "2025-01-01T05:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081067/uxcomic-imgs/16e5d164-78d8-8076-81e0-cd4806b10076.png",
            "expiry_time": "2026-10-04T09:09:38.072Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/16e5d164-78d8-8076-81e0-cd4806b10076"
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8022-80bb-df1dacb43034",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:46:00.000Z",
        "last_edited_time": "2026-07-18T04:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081068/uxcomic-imgs/16e5d164-78d8-8022-80bb-df1dacb43034.png",
            "expiry_time": "2026-10-04T09:09:38.072Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/16e5d164-78d8-8022-80bb-df1dacb43034"
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80ee-82ef-cdb87d462447",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:47:00.000Z",
        "last_edited_time": "2025-01-04T02:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Stack, Inline spacing (gap in Figma) = margin",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Stack, Inline spacing (gap in Figma) = margin",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80f6-9bc1-cd2fab1385d0",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:52:00.000Z",
        "last_edited_time": "2025-01-01T05:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Inset spacing = padding",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Inset spacing = padding",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8088-9872-d42e5648f6ee",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T13:10:00.000Z",
        "last_edited_time": "2025-01-01T13:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80e3-989f-c0fb1058723d",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:32:00.000Z",
        "last_edited_time": "2025-01-01T13:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Layout",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Layout",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-804b-bc9d-e2e735820eeb",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-04T02:11:00.000Z",
        "last_edited_time": "2025-01-04T02:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Again hãy cố gắng dùng auto layout nhiều nhất có thể để gần với cách dev hay xài.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Again hãy cố gắng dùng auto layout nhiều nhất có thể để gần với cách dev hay xài.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80b7-a201-ec1931210eda",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:26:00.000Z",
        "last_edited_time": "2025-01-01T05:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Auto layout = Flexbox",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Auto layout = Flexbox",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8054-a2e6-edb06e9cf743",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:32:00.000Z",
        "last_edited_time": "2025-01-12T12:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [
            {
              "type": "text",
              "text": {
                "content": "https://dillionmegida.com/p/css-flex-property/",
                "link": {
                  "url": "https://dillionmegida.com/p/css-flex-property/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://dillionmegida.com/p/css-flex-property/",
              "href": "https://dillionmegida.com/p/css-flex-property/"
            }
          ],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081069/uxcomic-imgs/16e5d164-78d8-8054-a2e6-edb06e9cf743.png",
            "expiry_time": "2026-10-04T09:09:38.217Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/16e5d164-78d8-8054-a2e6-edb06e9cf743"
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80f7-89b9-df02bf553b6a",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T13:10:00.000Z",
        "last_edited_time": "2025-01-01T13:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: tiếc là Figma chưa có dạng layout grid như trên CSS.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: tiếc là Figma chưa có dạng layout grid như trên CSS.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8033-9268-fda5cc6bda9e",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T05:18:00.000Z",
        "last_edited_time": "2025-01-01T05:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Clip content = Overflow",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Clip content = Overflow",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-808c-9ef6-ce4664d1b9b7",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:25:00.000Z",
        "last_edited_time": "2025-01-01T04:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081071/uxcomic-imgs/16e5d164-78d8-808c-9ef6-ce4664d1b9b7.png",
            "expiry_time": "2026-10-04T09:09:38.217Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/16e5d164-78d8-808c-9ef6-ce4664d1b9b7"
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8082-a8a7-eba5965812a5",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T08:16:00.000Z",
        "last_edited_time": "2025-01-01T08:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80f9-898c-c6dd298ce2c9",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T05:31:00.000Z",
        "last_edited_time": "2025-01-01T13:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Position",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Position",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80f7-b1aa-db1fe6ae4d31",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T13:06:00.000Z",
        "last_edited_time": "2025-01-01T13:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để hiểu đúng về position, bạn phải bắt tay build prototype & hình dung UI sẽ behave ra sao >> lúc này có element scroll theo, có element thì fix cứng, có cái thì swipe ngang… tất cả những thứ này đều liên quan đến position trong css.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để hiểu đúng về position, bạn phải bắt tay build prototype & hình dung UI sẽ behave ra sao >> lúc này có element scroll theo, có element thì fix cứng, có cái thì swipe ngang… tất cả những thứ này đều liên quan đến position trong css.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8083-b087-f733f94cfe8e",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T06:55:00.000Z",
        "last_edited_time": "2025-01-12T12:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [
            {
              "type": "text",
              "text": {
                "content": "https://dillionmegida.com/p/static-relative-absolute-fixed-sticky-positions/",
                "link": {
                  "url": "https://dillionmegida.com/p/static-relative-absolute-fixed-sticky-positions/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://dillionmegida.com/p/static-relative-absolute-fixed-sticky-positions/",
              "href": "https://dillionmegida.com/p/static-relative-absolute-fixed-sticky-positions/"
            }
          ],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081073/uxcomic-imgs/16e5d164-78d8-8083-b087-f733f94cfe8e.png",
            "expiry_time": "2026-10-04T09:09:38.218Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/16e5d164-78d8-8083-b087-f733f94cfe8e"
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80f6-b95e-dabd7ccd2d21",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T08:32:00.000Z",
        "last_edited_time": "2025-01-01T08:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8082-9673-eb68105a3875",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T05:51:00.000Z",
        "last_edited_time": "2025-01-01T07:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Statis Positioning (by default)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Statis Positioning (by default)",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8089-9dd9-c761f5909480",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T06:32:00.000Z",
        "last_edited_time": "2025-01-01T08:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu không set bất kỳ giá position nào, thì mặc định sẽ là static, các phần tử được sắp xếp theo luồng block by block (như lúc mình set auto layout trên Figma, các thành phần luôn theo order).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu không set bất kỳ giá position nào, thì mặc định sẽ là static, các phần tử được sắp xếp theo luồng block by block (như lúc mình set auto layout trên Figma, các thành phần luôn theo order).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8096-a068-e1c22fe36256",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T05:13:00.000Z",
        "last_edited_time": "2025-01-01T08:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Scroll with parent = Static positioning (Default)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Scroll with parent = Static positioning (Default)",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "16e5d164-78d8-806b-98c2-dafb8db86ec8",
            "parent": {
              "type": "block_id",
              "block_id": "16e5d164-78d8-8096-a068-e1c22fe36256"
            },
            "created_time": "2025-01-01T08:14:00.000Z",
            "last_edited_time": "2025-01-01T08:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Phần tử tuân theo luồng tự nhiên (không bị ảnh hưởng bởi top, left, right, bottom).",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Phần tử tuân theo luồng tự nhiên (không bị ảnh hưởng bởi top, left, right, bottom).",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "16e5d164-78d8-8061-a7d0-cb9275d9cb99",
            "parent": {
              "type": "block_id",
              "block_id": "16e5d164-78d8-8096-a068-e1c22fe36256"
            },
            "created_time": "2025-01-01T07:06:00.000Z",
            "last_edited_time": "2025-01-01T07:06:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Ví dụ: các list item",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Ví dụ: các list item",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-801e-a025-c001285dbf8b",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T06:58:00.000Z",
        "last_edited_time": "2025-01-01T06:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-806c-b3f0-eab0a46ca96e",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T06:31:00.000Z",
        "last_edited_time": "2025-01-01T06:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relative Positioning",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relative Positioning",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8013-b81b-e85cf8839c72",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T06:35:00.000Z",
        "last_edited_time": "2025-01-01T07:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Loại định vị cho phép bạn di chuyển phần tử dựa trên vị trí ban đầu của nó trong luồng block.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Loại định vị cho phép bạn di chuyển phần tử dựa trên vị trí ban đầu của nó trong luồng block.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8008-a213-f60fd6169523",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T05:45:00.000Z",
        "last_edited_time": "2025-01-01T08:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relative position",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relative position",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "16e5d164-78d8-8051-8ba6-cefe8d87ab19",
            "parent": {
              "type": "block_id",
              "block_id": "16e5d164-78d8-8008-a213-f60fd6169523"
            },
            "created_time": "2025-01-01T08:14:00.000Z",
            "last_edited_time": "2025-01-01T08:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Giữ chỗ trong luồng nhưng có thể di chuyển dựa trên vị trí ban đầu bằng top, left, v.v.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Giữ chỗ trong luồng nhưng có thể di chuyển dựa trên vị trí ban đầu bằng top, left, v.v.",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "16e5d164-78d8-80a7-9a1c-fb9e00b47cb9",
            "parent": {
              "type": "block_id",
              "block_id": "16e5d164-78d8-8008-a213-f60fd6169523"
            },
            "created_time": "2025-01-01T06:58:00.000Z",
            "last_edited_time": "2025-01-01T13:12:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Case có thể áp dụng: badge, highlight một đoạn text, mở card, hover…",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Case có thể áp dụng: badge, highlight một đoạn text, mở card, hover…",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-803e-ac64-dd232af798be",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T07:18:00.000Z",
        "last_edited_time": "2025-01-01T07:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Layer front, back = z index",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Layer front, back = z index",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8047-bb0b-f9c339beb15d",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T06:58:00.000Z",
        "last_edited_time": "2025-01-01T06:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80f4-86da-d13fee0ccb83",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T05:51:00.000Z",
        "last_edited_time": "2025-01-01T05:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Free Positioning",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Free Positioning",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8064-9f47-f673665381ec",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T06:38:00.000Z",
        "last_edited_time": "2025-01-01T07:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Loại \"định vị tự do\", không theo luồng block.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Loại \"định vị tự do\", không theo luồng block.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-806c-a730-d85923e015a1",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T05:45:00.000Z",
        "last_edited_time": "2025-01-01T08:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Fixed - stay in place (trên prototype Figma)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Fixed - stay in place (trên prototype Figma)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " = ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " = ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Fixed position",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Fixed position",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "16e5d164-78d8-8083-9b44-c3639e8aaa8d",
            "parent": {
              "type": "block_id",
              "block_id": "16e5d164-78d8-806c-a730-d85923e015a1"
            },
            "created_time": "2025-01-01T08:14:00.000Z",
            "last_edited_time": "2025-01-01T08:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Cố định so với cửa sổ trình duyệt (viewport).",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Cố định so với cửa sổ trình duyệt (viewport).",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "16e5d164-78d8-80ac-9752-f3c675dc6326",
            "parent": {
              "type": "block_id",
              "block_id": "16e5d164-78d8-806c-a730-d85923e015a1"
            },
            "created_time": "2025-01-01T06:46:00.000Z",
            "last_edited_time": "2025-01-01T07:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Ví dụ: thanh menu, pop up, FAB, toast message/ snackbar…",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Ví dụ: thanh menu, pop up, FAB, toast message/ snackbar…",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80c0-b72c-ec947468fe2d",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T05:47:00.000Z",
        "last_edited_time": "2025-01-01T08:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Absolute position (trên Figma) = Absolute position",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Absolute position (trên Figma) = Absolute position",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "16e5d164-78d8-805f-9cc5-e3f8d0e8c31e",
            "parent": {
              "type": "block_id",
              "block_id": "16e5d164-78d8-80c0-b72c-ec947468fe2d"
            },
            "created_time": "2025-01-01T08:14:00.000Z",
            "last_edited_time": "2025-01-01T08:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Fixed position nhưng nằm trong 1 container.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Fixed position nhưng nằm trong 1 container.",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "16e5d164-78d8-8020-a7fc-ec5b8997bded",
            "parent": {
              "type": "block_id",
              "block_id": "16e5d164-78d8-80c0-b72c-ec947468fe2d"
            },
            "created_time": "2025-01-01T07:38:00.000Z",
            "last_edited_time": "2025-01-01T07:40:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "*Default nó sẽ giống theo viewport, nếu muốn giống theo container A thì cần set container A có giá trị relative position (thay vì default là static).",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "*Default nó sẽ giống theo viewport, nếu muốn giống theo container A thì cần set container A có giá trị relative position (thay vì default là static).",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "16e5d164-78d8-8020-8e2e-e515552aec9e",
            "parent": {
              "type": "block_id",
              "block_id": "16e5d164-78d8-80c0-b72c-ec947468fe2d"
            },
            "created_time": "2025-01-01T06:45:00.000Z",
            "last_edited_time": "2025-01-01T07:29:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Ví dụ: tooltip, red dot",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Ví dụ: tooltip, red dot",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8089-b2a0-eec44742ddcb",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T06:43:00.000Z",
        "last_edited_time": "2025-01-01T08:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sticky - stop at top edge (trên prototype Figma) = Sticky position",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sticky - stop at top edge (trên prototype Figma) = Sticky position",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "16e5d164-78d8-805a-9cf3-c927e41ed433",
            "parent": {
              "type": "block_id",
              "block_id": "16e5d164-78d8-8089-b2a0-eec44742ddcb"
            },
            "created_time": "2025-01-01T08:14:00.000Z",
            "last_edited_time": "2025-01-01T08:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Lai giữa relative positioning và fixed positioning. Phần tử với ",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Lai giữa relative positioning và fixed positioning. Phần tử với ",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": "position: sticky",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "position: sticky",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": " sẽ hoạt động như relative khi ở trong giới hạn (container) của nó và sẽ chuyển sang fixed khi người dùng cuộn trang đến một điểm nhất định.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": " sẽ hoạt động như relative khi ở trong giới hạn (container) của nó và sẽ chuyển sang fixed khi người dùng cuộn trang đến một điểm nhất định.",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "16e5d164-78d8-80d0-ab7d-cee0180a1e37",
            "parent": {
              "type": "block_id",
              "block_id": "16e5d164-78d8-8089-b2a0-eec44742ddcb"
            },
            "created_time": "2025-01-01T06:46:00.000Z",
            "last_edited_time": "2025-01-01T07:29:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Ví dụ: header, tiêu đề bảng (table header), các mục lục (TOC) trong một bài viết…",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Ví dụ: header, tiêu đề bảng (table header), các mục lục (TOC) trong một bài viết…",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-800b-9644-e5c5868b22b2",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T07:18:00.000Z",
        "last_edited_time": "2025-01-01T13:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để dễ hình dung hơn, bạn xem cách build trên webflow nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để dễ hình dung hơn, bạn xem cách build trên webflow nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-807e-bfbc-d71b9794f149",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T07:17:00.000Z",
        "last_edited_time": "2025-01-01T07:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "video",
        "video": {
          "caption": [],
          "type": "external",
          "external": {
            "url": "https://www.youtube.com/watch?v=GPadt8wmGXM&t=55s"
          }
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-804c-853d-d2bf13fa54d1",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T06:10:00.000Z",
        "last_edited_time": "2025-01-01T06:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-801e-bc8a-d6cae74d88a0",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:35:00.000Z",
        "last_edited_time": "2025-01-01T08:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Resize",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Resize",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80f2-807c-e46c17dd1343",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:33:00.000Z",
        "last_edited_time": "2025-01-01T08:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Fixed size = gán value bằng",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Fixed size = gán value bằng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " px",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " px",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " hoặc",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " hoặc",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " % ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " % ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cho width, height",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cho width, height",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-803a-87d8-f666c5996b01",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T05:05:00.000Z",
        "last_edited_time": "2025-01-01T08:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Fill container (tuỳ theo object đó đang được đặt trong layout dạng nào)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Fill container (tuỳ theo object đó đang được đặt trong layout dạng nào)",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "16e5d164-78d8-8070-913a-e3cd0809418e",
            "parent": {
              "type": "block_id",
              "block_id": "16e5d164-78d8-803a-87d8-f666c5996b01"
            },
            "created_time": "2025-01-01T05:22:00.000Z",
            "last_edited_time": "2025-01-01T06:21:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Nếu layout object đó trong container >> ",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Nếu layout object đó trong container >> ",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": "width: 100%; ",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "width: 100%; ",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": "and/or",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "and/or",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": " height: 100%;",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": " height: 100%;",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": " ",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": " ",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "16e5d164-78d8-8090-8457-f770bb51fd57",
            "parent": {
              "type": "block_id",
              "block_id": "16e5d164-78d8-803a-87d8-f666c5996b01"
            },
            "created_time": "2025-01-01T05:22:00.000Z",
            "last_edited_time": "2025-01-01T06:21:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Nếu layout theo flexbox >> ",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Nếu layout theo flexbox >> ",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": "flex-grow: 1;",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "flex-grow: 1;",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "16e5d164-78d8-80a5-a3b8-ec0fa0277b02",
            "parent": {
              "type": "block_id",
              "block_id": "16e5d164-78d8-803a-87d8-f666c5996b01"
            },
            "created_time": "2025-01-01T05:22:00.000Z",
            "last_edited_time": "2025-01-01T06:21:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Nếu layout trong dạng grid >> ",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Nếu layout trong dạng grid >> ",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": "grid ",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "grid ",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": "fractional units (",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "fractional units (",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": "1fr)",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "1fr)",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "16e5d164-78d8-8003-a005-fd3578d016af",
            "parent": {
              "type": "block_id",
              "block_id": "16e5d164-78d8-803a-87d8-f666c5996b01"
            },
            "created_time": "2025-01-01T05:22:00.000Z",
            "last_edited_time": "2025-01-01T08:31:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Nếu element đó tràn lên trên parent (ví dụ: pop up) >> ",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Nếu element đó tràn lên trên parent (ví dụ: pop up) >> ",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": "position: absolute",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "position: absolute",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": " ",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": " ",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80d6-ac42-d20b55875e54",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:36:00.000Z",
        "last_edited_time": "2025-01-01T08:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Stretch (left & right, top & bottom) = align-self: stretch (flexbox)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Stretch (left & right, top & bottom) = align-self: stretch (flexbox)",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80b3-a7f7-eb532413424e",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:29:00.000Z",
        "last_edited_time": "2025-01-01T08:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hug content = Auto",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hug content = Auto",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8013-b4b4-cf18700a1109",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T08:17:00.000Z",
        "last_edited_time": "2025-01-01T08:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-805f-bec8-f10e7ff973ff",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:37:00.000Z",
        "last_edited_time": "2025-01-01T05:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Text",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Text",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80a1-9012-c9c9ab168346",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:26:00.000Z",
        "last_edited_time": "2025-01-01T05:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Text case (UPPERCASE, lowercase, Title Case) = text-transform",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Text case (UPPERCASE, lowercase, Title Case) = text-transform",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8069-967a-f8c0b83384a0",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T05:09:00.000Z",
        "last_edited_time": "2025-01-01T05:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "font size scale by device size = em,rem",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "font size scale by device size = em,rem",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-809d-adac-e8a76240cd88",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-12T12:58:00.000Z",
        "last_edited_time": "2025-01-12T12:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-809e-a79f-e1f32cffe331",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:37:00.000Z",
        "last_edited_time": "2025-01-01T05:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Blend mode (mutiply, screen, overlay,…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Blend mode (mutiply, screen, overlay,…)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8057-8c20-c11916a1db43",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:37:00.000Z",
        "last_edited_time": "2025-01-01T05:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Blend Mode = mix-blend-mode",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Blend Mode = mix-blend-mode",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-8038-a804-c5fc10d985ac",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-12T12:58:00.000Z",
        "last_edited_time": "2025-01-12T12:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80e0-895e-c2a99605ca25",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T05:09:00.000Z",
        "last_edited_time": "2025-01-01T06:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Other",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Other",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80ca-9fea-ef1e85d64307",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T07:47:00.000Z",
        "last_edited_time": "2025-01-01T07:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hide (giống như set layer opacity = 0% trên Figma) = display: hidden\nDelete (giống như xoá layer trên Figma) = display: none",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hide (giống như set layer opacity = 0% trên Figma) = display: hidden\nDelete (giống như xoá layer trên Figma) = display: none",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8039-a097-e1e1a7ae0013",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T05:43:00.000Z",
        "last_edited_time": "2025-01-01T06:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Inside an object: left side = Leading; right side = Trailing; middle = Middle",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Inside an object: left side = Leading; right side = Trailing; middle = Middle",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80d3-be65-f06913f5aa40",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T04:29:00.000Z",
        "last_edited_time": "2025-01-01T06:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Scale tool (ctrl + K in Figma) = transform: scale(2)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Scale tool (ctrl + K in Figma) = transform: scale(2)",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80a1-9f15-d721ec4dfd8f",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T13:13:00.000Z",
        "last_edited_time": "2025-01-01T13:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80ac-a049-db70ce113c53",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T08:02:00.000Z",
        "last_edited_time": "2025-01-01T13:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Image",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Image",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80e0-b60f-cd45832246b1",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T08:04:00.000Z",
        "last_edited_time": "2025-01-01T08:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Image (Fill) = object-fit: cover",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Image (Fill) = object-fit: cover",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-800f-926b-fcaecc71ad93",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T08:06:00.000Z",
        "last_edited_time": "2025-01-01T08:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Image (Fit) = object-fit: contain",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Image (Fit) = object-fit: contain",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-805e-a10d-d67a28e0f01f",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T05:09:00.000Z",
        "last_edited_time": "2025-01-01T08:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hình stretch theo width nhưng giữ đúng ratio của hình = width: 100%, height: auto",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hình stretch theo width nhưng giữ đúng ratio của hình = width: 100%, height: auto",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-805a-b2a9-dcacc6e7594c",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T07:48:00.000Z",
        "last_edited_time": "2025-01-01T07:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "4:3, 1:1, 16:9,… = aspect-ratio",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "4:3, 1:1, 16:9,… = aspect-ratio",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80a8-8484-da8a42b668ea",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T08:08:00.000Z",
        "last_edited_time": "2025-01-01T08:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Other object-fit: none, scale down, fill",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Other object-fit: none, scale down, fill",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8030-b3a6-d24bfb039900",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T05:08:00.000Z",
        "last_edited_time": "2025-01-01T05:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80e7-b17e-e1c144287460",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T05:20:00.000Z",
        "last_edited_time": "2025-01-01T08:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Design system",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Design system",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80cf-b5ba-d9ecb40c58e9",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T08:17:00.000Z",
        "last_edited_time": "2025-01-01T08:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Này căng ah, chưa rõ..",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Này căng ah, chưa rõ..",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80ab-b30f-f8dc4d5cd94e",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T07:54:00.000Z",
        "last_edited_time": "2025-01-01T07:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Style = Selector",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Style = Selector",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8080-86ea-db2d191adf58",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T05:20:00.000Z",
        "last_edited_time": "2025-01-01T05:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Component = Reusable Components / Classes / Functions",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Component = Reusable Components / Classes / Functions",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8031-bd1f-c7d53a56d7e2",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T05:38:00.000Z",
        "last_edited_time": "2025-01-01T05:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Variant = Props / Modifiers / Variations",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Variant = Props / Modifiers / Variations",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-804f-83d9-ddd7ca3253e8",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T05:39:00.000Z",
        "last_edited_time": "2025-01-01T05:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Variants with States (Hover, Active, Focus) = Pseudo-classes",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Variants with States (Hover, Active, Focus) = Pseudo-classes",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80b1-95c2-e93100e03eaf",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T08:22:00.000Z",
        "last_edited_time": "2025-01-01T08:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Variants with Element (Selection, Placeholder, Red dot) = Pseudo-element",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Variants with Element (Selection, Placeholder, Red dot) = Pseudo-element",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80d7-9af7-d9a415226046",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T05:40:00.000Z",
        "last_edited_time": "2025-01-01T05:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nested Variants (Complex States) = Dynamic Props or Logic",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nested Variants (Complex States) = Dynamic Props or Logic",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "❇️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-800a-8a14-f9f14e150bd3",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T13:14:00.000Z",
        "last_edited_time": "2025-01-01T13:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80da-8b2b-f11bdc4f291d",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T13:14:00.000Z",
        "last_edited_time": "2025-01-01T13:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tóm lại",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tóm lại",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8003-8675-f892e46ed29f",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T13:14:00.000Z",
        "last_edited_time": "2025-01-01T13:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chắc là nhiều & rối não lắm, nhưng nếu bạn quan tâm đến trải nghiệm của dev, không muốn họ đoán già đoán non khi muốn xem design của bạn, cũng như bạn muốn design pixel perfect, đúng với design expectation",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chắc là nhiều & rối não lắm, nhưng nếu bạn quan tâm đến trải nghiệm của dev, không muốn họ đoán già đoán non khi muốn xem design của bạn, cũng như bạn muốn design pixel perfect, đúng với design expectation",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80a0-8cf8-c212ffe3c4b2",
        "parent": {
          "type": "page_id",
          "page_id": "16e5d164-78d8-80bc-911c-e46d1955dd98"
        },
        "created_time": "2025-01-01T13:25:00.000Z",
        "last_edited_time": "2025-01-01T13:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> thì mình nghĩ cách hiệu quả nhất là bạn phải hiểu ngôn ngữ của họ. So, this’s matter.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> thì mình nghĩ cách hiệu quả nhất là bạn phải hiểu ngôn ngữ của họ. So, this’s matter.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "10f5d164-78d8-804f-b8ea-e2a265424273",
    "created_time": "2024-09-28T03:59:00.000Z",
    "last_edited_time": "2025-08-15T10:43:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "page_id",
      "page_id": "a58596ad-902a-49e3-9a81-fdb9b84b92d9"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "title": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "UX comic - Introduction",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "UX comic - Introduction",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/UX-comic-Introduction-10f5d16478d8804fb8eae2a265424273",
    "public_url": null,
    "archived": false,
    "request_id": "0987f638-2d9f-4937-b02e-6ef8edfdaf5a",
    "content": [
      {
        "object": "block",
        "id": "1145d164-78d8-8054-b6ed-ee06674bf4ed",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-03T14:54:00.000Z",
        "last_edited_time": "2024-10-03T14:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081079/uxcomic-imgs/1145d164-78d8-8054-b6ed-ee06674bf4ed.png",
            "expiry_time": "2026-10-04T09:09:41.887Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1145d164-78d8-8054-b6ed-ee06674bf4ed"
      },
      {
        "object": "block",
        "id": "1175d164-78d8-8062-b2b6-e5d5c1f1d3b4",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-06T13:42:00.000Z",
        "last_edited_time": "2024-10-06T13:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tụi mình ở đây để chia sẻ các kiến thức, góc nhìn cá nhân về hành trình làm nghề UX/UI.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tụi mình ở đây để chia sẻ các kiến thức, góc nhìn cá nhân về hành trình làm nghề UX/UI.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "👋"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-80f5-ba2a-dc7da74d909e",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-09-28T04:03:00.000Z",
        "last_edited_time": "2025-01-14T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình xin giới thiệu chút, mình có background công việc trong graphic design, illustrator, sau đó mình chuyển sang lĩnh vực UX/UI, và chắc cũng như đa phần mọi người đó là học vài khoá, tự mày mò đọc blog để học hỏi thêm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình xin giới thiệu chút, mình có background công việc trong graphic design, illustrator, sau đó mình chuyển sang lĩnh vực UX/UI, và chắc cũng như đa phần mọi người đó là học vài khoá, tự mày mò đọc blog để học hỏi thêm.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-8022-90a4-e47dd0056496",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-14T02:05:00.000Z",
        "last_edited_time": "2025-01-14T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80b8-ba44-f0b7bbe1c82c",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-22T16:01:00.000Z",
        "last_edited_time": "2024-12-25T02:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuy nhiên trong quá trình tự học, mình hay gặp phải các vấn đề sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuy nhiên trong quá trình tự học, mình hay gặp phải các vấn đề sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-80c7-9e98-d40601cb5d76",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-09-28T04:11:00.000Z",
        "last_edited_time": "2024-12-25T02:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "😵 Theo thời gian, kiến thức gia tăng, mọi thứ dần trở nên rối ren, chi chít như màn nhện,  nó như cái cảnh mình vào khu rừng mà không có map, cứ xoay vòng vòng, vòng vòng, vòng vòng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "😵 Theo thời gian, kiến thức gia tăng, mọi thứ dần trở nên rối ren, chi chít như màn nhện,  nó như cái cảnh mình vào khu rừng mà không có map, cứ xoay vòng vòng, vòng vòng, vòng vòng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-8055-ba1e-cdeabdc6e536",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-09-28T04:11:00.000Z",
        "last_edited_time": "2024-12-25T02:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "🫣 Mặc dù đã cất công collect, tự học các thứ nhưng đến lúc làm thực tế thì lại quên bén đi, xong tự chửi bản thân: “học chi cho lắm không áp dụng được gì”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "🫣 Mặc dù đã cất công collect, tự học các thứ nhưng đến lúc làm thực tế thì lại quên bén đi, xong tự chửi bản thân: “học chi cho lắm không áp dụng được gì”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80e9-a617-fed34699865b",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T02:40:00.000Z",
        "last_edited_time": "2024-12-25T02:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "😫 Đến lúc nhớ để áp dụng rồi thì lại có khi không phù hợp, kết quả không như  khuôn mẫu sách vở.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "😫 Đến lúc nhớ để áp dụng rồi thì lại có khi không phù hợp, kết quả không như  khuôn mẫu sách vở.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80bd-821c-d1385c95355a",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-22T14:48:00.000Z",
        "last_edited_time": "2024-12-23T03:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081080/uxcomic-imgs/1645d164-78d8-80bd-821c-d1385c95355a.jpg",
            "expiry_time": "2026-10-04T09:09:41.888Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1645d164-78d8-80bd-821c-d1385c95355a"
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-80c2-a417-ca89e359e251",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-27T04:48:00.000Z",
        "last_edited_time": "2024-12-22T16:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1175d164-78d8-802e-b0b2-e9f603db4448",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-06T07:32:00.000Z",
        "last_edited_time": "2025-01-14T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Rồi tình cờ, mình có nghe đến kĩ thuật Feyman trong việc học - đại ý là học làm sao để bạn có thể dạy lại được cho người khác. Sau đó mình bắt đầu áp dụng, tập thói quen nghiền ngẫm, tập hệ thống hoá, để “ôn bài”, để biết thêm những thứ mà mình tưởng là mình đã biết >> 💡 project được sinh ra",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Rồi tình cờ, mình có nghe đến kĩ thuật Feyman trong việc học - đại ý là học làm sao để bạn có thể dạy lại được cho người khác. Sau đó mình bắt đầu áp dụng, tập thói quen nghiền ngẫm, tập hệ thống hoá, để “ôn bài”, để biết thêm những thứ mà mình tưởng là mình đã biết >> 💡 project được sinh ra",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-801d-bbfe-cbe5f489c720",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-10T02:05:00.000Z",
        "last_edited_time": "2025-01-12T14:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Share your knowledge and teach others — it benefits both of you!",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Share your knowledge and teach others — it benefits both of you!",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13f5d164-78d8-801a-871e-c9d89a1c3ec0",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-11-15T02:12:00.000Z",
        "last_edited_time": "2024-11-15T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-80ac-ba44-fb1e73088960",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-14T02:37:00.000Z",
        "last_edited_time": "2025-08-14T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "✏️ Other tiny things",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "✏️ Other tiny things",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-8041-b4ef-f5c09e17be85",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T02:57:00.000Z",
        "last_edited_time": "2025-01-14T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lê thê vậy đủ rồi. Nếu bạn có thêm chút thời gian, hãy xem thêm các chú thích ở dưới nhé, vì nó liên quan đến giá trị “hệ thống hoá” mà mình đang muốn offer khi làm blog này.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lê thê vậy đủ rồi. Nếu bạn có thêm chút thời gian, hãy xem thêm các chú thích ở dưới nhé, vì nó liên quan đến giá trị “hệ thống hoá” mà mình đang muốn offer khi làm blog này.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8033-b108-debe1f729659",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:55:00.000Z",
        "last_edited_time": "2025-08-14T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755136730/uxcomic-imgs/24f5d164-78d8-8033-b108-debe1f729659.png",
            "expiry_time": "2026-10-04T09:09:41.888Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/24f5d164-78d8-8033-b108-debe1f729659"
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80cf-9e31-eba6bd4663a0",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:02:00.000Z",
        "last_edited_time": "2025-08-14T01:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1175d164-78d8-807a-bc07-ce1b50fe378a",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-06T13:38:00.000Z",
        "last_edited_time": "2025-08-14T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "📢 ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "📢 ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Disclaimer",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Disclaimer",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8071-af14-c321c266389f",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:47:00.000Z",
        "last_edited_time": "2025-08-15T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "các bài viết này là tổng hợp của những kiến thức lượm lặt trên mạng + chatGPT + góc độ, quan sát cá nhân >> mình vẫn có thể sai >> nên đừng vội chấp nhận hoặc tin hết những gì mình viết (mặc dù mình đều cố gắng tìm hiểu các nguồn đáng tin cậy và kèm link reference cho từng bài viết nếu có).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "các bài viết này là tổng hợp của những kiến thức lượm lặt trên mạng + chatGPT + góc độ, quan sát cá nhân >> mình vẫn có thể sai >> nên đừng vội chấp nhận hoặc tin hết những gì mình viết (mặc dù mình đều cố gắng tìm hiểu các nguồn đáng tin cậy và kèm link reference cho từng bài viết nếu có).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8070-a7db-d7a5898e615d",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:47:00.000Z",
        "last_edited_time": "2025-08-15T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hãy xem mình như một người bạn, một đồng nghiệp như đang trò chuyện với bạn trong một buổi ăn trưa, một buổi hẹn cafe, chúng mình ở đây để chia sẻ và học hỏi nhau trên con đường mày mò & cải thiện quá trình làm nghề UX/UI.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hãy xem mình như một người bạn, một đồng nghiệp như đang trò chuyện với bạn trong một buổi ăn trưa, một buổi hẹn cafe, chúng mình ở đây để chia sẻ và học hỏi nhau trên con đường mày mò & cải thiện quá trình làm nghề UX/UI.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80be-bd5b-fde96187a589",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:48:00.000Z",
        "last_edited_time": "2025-08-15T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Again luôn recheck các thông tin, luận điểm của mình nhé. Cảm ơn mọi người nhiều 😜.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Again luôn recheck các thông tin, luận điểm của mình nhé. Cảm ơn mọi người nhiều 😜.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80b0-a0cf-c3d3ac509af9",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:03:00.000Z",
        "last_edited_time": "2025-01-14T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1815d164-78d8-8043-8c86-f3f060cfaa2c",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-20T03:25:00.000Z",
        "last_edited_time": "2025-01-20T03:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Contact",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Contact",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80e8-8428-f6dcc343a5ec",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T02:45:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình rất vui lòng nếu nhận được những góc nhìn khác từ các bạn, nếu bạn muốn liên hệ hay chia sẻ gì với mình thêm, hay muốn mình share topic gì khác, hãy để lại lời nhắn qua:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình rất vui lòng nếu nhận được những góc nhìn khác từ các bạn, nếu bạn muốn liên hệ hay chia sẻ gì với mình thêm, hay muốn mình share topic gì khác, hãy để lại lời nhắn qua:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1c15d164-78d8-80dc-bc47-ff02b571cf37",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-03-25T05:59:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1815d164-78d8-8006-8bb0-f9639445d848",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-20T03:23:00.000Z",
        "last_edited_time": "2025-01-20T03:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thread",
                "link": {
                  "url": "https://www.threads.net/@ux_share_choi?hl=vi"
                }
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thread",
              "href": "https://www.threads.net/@ux_share_choi?hl=vi"
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "💬"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1815d164-78d8-801b-b02c-f6a970beae36",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-20T03:23:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Linkedin",
                "link": {
                  "url": "https://www.linkedin.com/in/minhhuynh95/"
                }
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Linkedin",
              "href": "https://www.linkedin.com/in/minhhuynh95/"
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "💼"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1c15d164-78d8-80aa-b4ae-d81e4bdbad4e",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-03-25T05:59:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-8081-8eb4-f9373214ab36",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:10:00.000Z",
        "last_edited_time": "2024-12-25T03:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081083/uxcomic-imgs/1675d164-78d8-8081-8eb4-f9373214ab36.png",
            "expiry_time": "2026-10-04T09:09:41.935Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1675d164-78d8-8081-8eb4-f9373214ab36"
      },
      {
        "object": "block",
        "id": "1675d164-78d8-802d-a902-c546642f72dc",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:03:00.000Z",
        "last_edited_time": "2024-12-28T03:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mong các bài viết này có chút hữu ích cho bạn 🥰. Dự án được built with ❤️‍🔥 bởi ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mong các bài viết này có chút hữu ích cho bạn 🥰. Dự án được built with ❤️‍🔥 bởi ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Minh",
                "link": {
                  "url": "https://www.linkedin.com/in/minhhuynh95/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Minh",
              "href": "https://www.linkedin.com/in/minhhuynh95/"
            },
            {
              "type": "text",
              "text": {
                "content": " & ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " & ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Hùng",
                "link": {
                  "url": "https://www.linkedin.com/in/vhung71/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hùng",
              "href": "https://www.linkedin.com/in/vhung71/"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "26aaa722-7e34-4293-bf96-4eaa09a6a24d",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-11-23T07:53:00.000Z",
        "last_edited_time": "2024-11-23T07:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-80ef-a681-d83a4e28308a",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-27T04:50:00.000Z",
        "last_edited_time": "2024-10-27T04:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "2825d164-78d8-8022-b278-c095fef80560",
    "created_time": "2025-10-04T11:39:00.000Z",
    "last_edited_time": "2025-10-09T05:15:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2025-10-04T11:39:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 51
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "3-Other",
          "color": "purple"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-10-09T05:15:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "prxX",
          "name": "⚔️:2",
          "color": "yellow"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Meeting checklist",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Meeting checklist",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Meeting-checklist-2825d16478d88022b278c095fef80560",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
      "name": "Other",
      "slug": "other",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "2825d164-78d8-8054-af0b-dccb83f9a1a2",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-04T11:45:00.000Z",
        "last_edited_time": "2025-10-04T11:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1759892216/uxcomic-imgs/2825d164-78d8-8054-af0b-dccb83f9a1a2.png",
            "expiry_time": "2026-10-04T09:09:43.717Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2825d164-78d8-8054-af0b-dccb83f9a1a2"
      },
      {
        "object": "block",
        "id": "2825d164-78d8-8062-93a9-e6e993b431c4",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-04T11:45:00.000Z",
        "last_edited_time": "2025-10-04T11:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dành cho bản thân bị cái tật hay lan man trong các cuộc meeting, please check these item :))",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dành cho bản thân bị cái tật hay lan man trong các cuộc meeting, please check these item :))",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2865d164-78d8-8047-b433-cc766905134e",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-08T01:59:00.000Z",
        "last_edited_time": "2025-10-08T02:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Intention of meeting ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Intention of meeting ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2825d164-78d8-804f-9bb2-f02d09bbc003",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-04T11:40:00.000Z",
        "last_edited_time": "2025-10-08T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "What is the expected outcome? (decision we will make, things we need to clarify, any ambiguity need to share out,…). Tips: identify before and after meeting differences (lí do cần đến buổi meeting này là gì, sự thay đổi nào có thể xảy ra sau khi tham gia cuộc họp giữa mình và họ)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "What is the expected outcome? (decision we will make, things we need to clarify, any ambiguity need to share out,…). Tips: identify before and after meeting differences (lí do cần đến buổi meeting này là gì, sự thay đổi nào có thể xảy ra sau khi tham gia cuộc họp giữa mình và họ)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2825d164-78d8-8015-9e79-e59f4801d67a",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-04T11:40:00.000Z",
        "last_edited_time": "2025-10-04T11:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Who is the attendance, who is the stakeholders, what they care?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Who is the attendance, who is the stakeholders, what they care?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2865d164-78d8-8005-bdfa-c9bbbc996d0f",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-08T02:06:00.000Z",
        "last_edited_time": "2025-10-09T05:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Xác định buổi meeting theo chiều hướng “mở hay đóng”, khúc nào cần open to discuss, khúc nào cần đóng vấn đề / đóng sự lựa chọn (",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Xác định buổi meeting theo chiều hướng “mở hay đóng”, khúc nào cần open to discuss, khúc nào cần đóng vấn đề / đóng sự lựa chọn (",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "problem framing",
                "link": {
                  "url": "/1265d16478d8804587d2e2532aae0b64"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "problem framing",
              "href": "/1265d16478d8804587d2e2532aae0b64"
            },
            {
              "type": "text",
              "text": {
                "content": ", ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "decision making",
                "link": {
                  "url": "/1495d16478d880128e3cc8b2e4d92bda"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "decision making",
              "href": "/1495d16478d880128e3cc8b2e4d92bda"
            },
            {
              "type": "text",
              "text": {
                "content": ")",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ")",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2865d164-78d8-804e-a040-d191dc46279e",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-08T02:13:00.000Z",
        "last_edited_time": "2025-10-08T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Identify the context (why, when, where, who, which…), the key point, the alignment.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Identify the context (why, when, where, who, which…), the key point, the alignment.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2865d164-78d8-8076-bc42-f33c36ae6c14",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-08T02:27:00.000Z",
        "last_edited_time": "2025-10-08T02:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mindset: we're here to discuss, empathize each other POV, and make alignment, not to defend, not to show up “that I know it all”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mindset: we're here to discuss, empathize each other POV, and make alignment, not to defend, not to show up “that I know it all”",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2865d164-78d8-801e-96ef-efccfb6189d8",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-08T02:00:00.000Z",
        "last_edited_time": "2025-10-08T02:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Meeting content",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Meeting content",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2825d164-78d8-80df-8eec-d1b732d5c989",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-04T11:40:00.000Z",
        "last_edited_time": "2025-10-08T02:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "How should agenda look like?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "How should agenda look like?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2825d164-78d8-8076-9d4b-d83e5e7af3fe",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-04T11:42:00.000Z",
        "last_edited_time": "2025-10-08T02:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "How you will structure the narrative, cognitive load flow, information flow, storytelling?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "How you will structure the narrative, cognitive load flow, information flow, storytelling?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2825d164-78d8-80e1-83ad-c02d66697ac0",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-04T11:57:00.000Z",
        "last_edited_time": "2025-10-08T02:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Did you chunk it down? Be aware audience can remember all, especially long meeting.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Did you chunk it down? Be aware audience can remember all, especially long meeting.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2825d164-78d8-8024-ae2f-d4b67976a906",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-04T11:55:00.000Z",
        "last_edited_time": "2025-10-08T02:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "If thing is complex, make sure you have example, visual, diagram, it helps.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "If thing is complex, make sure you have example, visual, diagram, it helps.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2825d164-78d8-8032-bfad-fbc4d8f0d9c6",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-04T11:55:00.000Z",
        "last_edited_time": "2025-10-08T02:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Could follow this structure for each point: 1 main idea, 1 support idea, 1 example.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Could follow this structure for each point: 1 main idea, 1 support idea, 1 example.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2865d164-78d8-807f-8eef-db0c14dddc9e",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-08T02:19:00.000Z",
        "last_edited_time": "2025-10-08T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Progress of idea decision: Problem - Framing - Approach - Directions evaluation - Options evaluation - Preference & Trade off alignment - Decision log",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Progress of idea decision: Problem - Framing - Approach - Directions evaluation - Options evaluation - Preference & Trade off alignment - Decision log",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2825d164-78d8-8025-9f1a-d0a4e7fe2ea3",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-04T11:47:00.000Z",
        "last_edited_time": "2025-10-09T05:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Anticipate reaction & prepare back-up response",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Anticipate reaction & prepare back-up response",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2825d164-78d8-804c-9349-e1648c8d331a",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-04T11:41:00.000Z",
        "last_edited_time": "2025-10-04T11:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "If need to make decision, so how we will make that decision?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "If need to make decision, so how we will make that decision?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2825d164-78d8-8039-874b-c9a0192bfc22",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-04T11:42:00.000Z",
        "last_edited_time": "2025-10-08T02:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Any back-up data point we should prepare? (data / user research / user testing…), if not what is the assumption, risk of that assumption?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Any back-up data point we should prepare? (data / user research / user testing…), if not what is the assumption, risk of that assumption?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2865d164-78d8-8035-ba1d-db42225027ae",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-08T02:00:00.000Z",
        "last_edited_time": "2025-10-08T02:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Practice in every meeting",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Practice in every meeting",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2865d164-78d8-80d3-a2fc-e78d75cd4a0a",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-08T02:12:00.000Z",
        "last_edited_time": "2025-10-08T02:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Clarify “why I did what I did” then talk about how I did, and keep align back to the what, the why.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Clarify “why I did what I did” then talk about how I did, and keep align back to the what, the why.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2865d164-78d8-8054-b73a-c568168de4cd",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-08T02:14:00.000Z",
        "last_edited_time": "2025-10-08T02:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Active Listening, repeat and repharse, clarify “subjective” into “objective” (tips: transform “what I like” to “what works”, transform “adj” to “noun/ verb”)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Active Listening, repeat and repharse, clarify “subjective” into “objective” (tips: transform “what I like” to “what works”, transform “adj” to “noun/ verb”)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2825d164-78d8-80f3-a18c-feb05f4fd04f",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-04T11:48:00.000Z",
        "last_edited_time": "2025-10-08T02:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Keep in mind the purpose of the meeting — remove distractions and steer the discussion back to the main topic (",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Keep in mind the purpose of the meeting — remove distractions and steer the discussion back to the main topic (",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Facilitate skill",
                "link": {
                  "url": "/ff81ff8ab21e4952a5f78e1b1714f022"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Facilitate skill",
              "href": "/ff81ff8ab21e4952a5f78e1b1714f022"
            },
            {
              "type": "text",
              "text": {
                "content": ").",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ").",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2865d164-78d8-807d-87c8-f4f9cdd33af8",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-08T02:23:00.000Z",
        "last_edited_time": "2025-10-08T02:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Let's them talk, and keep them discuss on the right direction ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Let's them talk, and keep them discuss on the right direction ",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2825d164-78d8-80d9-ac83-f88336b9f028",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-04T11:49:00.000Z",
        "last_edited_time": "2025-10-08T02:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Did you take the note?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Did you take the note?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2825d164-78d8-8041-ab0f-d7a632612847",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-04T11:43:00.000Z",
        "last_edited_time": "2025-10-08T02:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Do you wrap up all discussions? (who comment what, what we agree on, decision log, forward-looking: what should be on the next meeting session?…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Do you wrap up all discussions? (who comment what, what we agree on, decision log, forward-looking: what should be on the next meeting session?…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2865d164-78d8-805a-92b6-c5527a7e8a4a",
        "parent": {
          "type": "page_id",
          "page_id": "2825d164-78d8-8022-b278-c095fef80560"
        },
        "created_time": "2025-10-08T02:25:00.000Z",
        "last_edited_time": "2025-10-08T02:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Again, please chunk it down, keep things simple, the longer meeting have the more chunking need",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Again, please chunk it down, keep things simple, the longer meeting have the more chunking need",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "2605d164-78d8-800a-87d2-ca72aa76dbb9",
    "created_time": "2025-08-31T05:01:00.000Z",
    "last_edited_time": "2025-08-31T14:27:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2025-08-31T05:01:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 49
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "1-Design",
          "color": "default"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-31T14:27:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "sgq|",
          "name": "⚔️:1",
          "color": "red"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "UI checklist ",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "UI checklist ",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/UI-checklist-2605d16478d8800a87d2ca72aa76dbb9",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Design",
      "slug": "design",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "2605d164-78d8-80d0-8509-eb9b47b8fbc6",
        "parent": {
          "type": "page_id",
          "page_id": "2605d164-78d8-800a-87d2-ca72aa76dbb9"
        },
        "created_time": "2025-08-31T06:47:00.000Z",
        "last_edited_time": "2025-08-31T14:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756622957/uxcomic-imgs/2605d164-78d8-80d0-8509-eb9b47b8fbc6.png",
            "expiry_time": "2026-10-04T09:09:44.190Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2605d164-78d8-80d0-8509-eb9b47b8fbc6"
      },
      {
        "object": "block",
        "id": "2605d164-78d8-807b-9d65-dc96a1689ac6",
        "parent": {
          "type": "page_id",
          "page_id": "2605d164-78d8-800a-87d2-ca72aa76dbb9"
        },
        "created_time": "2025-08-31T05:01:00.000Z",
        "last_edited_time": "2025-08-31T05:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đầu tiên phải nhớ UI là tầng surface, nó là nơi “giao tiếp” giữa system và user, giữa brand và target audience, nó chịu trách nhiệm cho việc “translator”  / “ambassador”, sau khi đã làm rõ được chủ đích, nội dung mới tính đến chuyện UI trông ra sao.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đầu tiên phải nhớ UI là tầng surface, nó là nơi “giao tiếp” giữa system và user, giữa brand và target audience, nó chịu trách nhiệm cho việc “translator”  / “ambassador”, sau khi đã làm rõ được chủ đích, nội dung mới tính đến chuyện UI trông ra sao.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2605d164-78d8-802b-8210-f4dd5b15a93c",
        "parent": {
          "type": "page_id",
          "page_id": "2605d164-78d8-800a-87d2-ca72aa76dbb9"
        },
        "created_time": "2025-08-31T05:06:00.000Z",
        "last_edited_time": "2025-08-31T06:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ok checklist này nhầm nhắc nhở bản thân chỉ tập trung cho việc làm sao để UI truyền tải đúng thông điệp, đúng “chuẩn” & làm sao để trông đẹp hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ok checklist này nhầm nhắc nhở bản thân chỉ tập trung cho việc làm sao để UI truyền tải đúng thông điệp, đúng “chuẩn” & làm sao để trông đẹp hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2605d164-78d8-807e-97e8-d5d779caa94a",
        "parent": {
          "type": "page_id",
          "page_id": "2605d164-78d8-800a-87d2-ca72aa76dbb9"
        },
        "created_time": "2025-08-31T06:34:00.000Z",
        "last_edited_time": "2025-08-31T06:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "list",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "list",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "2605d164-78d8-80d3-bf70-f5f0dec79d0c",
            "parent": {
              "type": "block_id",
              "block_id": "2605d164-78d8-807e-97e8-d5d779caa94a"
            },
            "created_time": "2025-08-31T06:34:00.000Z",
            "last_edited_time": "2025-08-31T06:34:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756622958/uxcomic-imgs/2605d164-78d8-80d3-bf70-f5f0dec79d0c.png",
                "expiry_time": "2026-10-04T09:09:44.682Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2605d164-78d8-80d3-bf70-f5f0dec79d0c"
          },
          {
            "object": "block",
            "id": "2605d164-78d8-8095-b92e-c92a3cfaf7c4",
            "parent": {
              "type": "block_id",
              "block_id": "2605d164-78d8-807e-97e8-d5d779caa94a"
            },
            "created_time": "2025-08-31T06:34:00.000Z",
            "last_edited_time": "2025-08-31T06:34:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756622959/uxcomic-imgs/2605d164-78d8-8095-b92e-c92a3cfaf7c4.png",
                "expiry_time": "2026-10-04T09:09:44.683Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2605d164-78d8-8095-b92e-c92a3cfaf7c4"
          },
          {
            "object": "block",
            "id": "2605d164-78d8-8047-b18c-c5cf01b18da6",
            "parent": {
              "type": "block_id",
              "block_id": "2605d164-78d8-807e-97e8-d5d779caa94a"
            },
            "created_time": "2025-08-31T06:34:00.000Z",
            "last_edited_time": "2025-08-31T06:34:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756622960/uxcomic-imgs/2605d164-78d8-8047-b18c-c5cf01b18da6.png",
                "expiry_time": "2026-10-04T09:09:44.683Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2605d164-78d8-8047-b18c-c5cf01b18da6"
          },
          {
            "object": "block",
            "id": "2605d164-78d8-8092-8c4d-c32ba4d2ecfb",
            "parent": {
              "type": "block_id",
              "block_id": "2605d164-78d8-807e-97e8-d5d779caa94a"
            },
            "created_time": "2025-08-31T06:34:00.000Z",
            "last_edited_time": "2025-08-31T06:34:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756622961/uxcomic-imgs/2605d164-78d8-8092-8c4d-c32ba4d2ecfb.png",
                "expiry_time": "2026-10-04T09:09:44.683Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2605d164-78d8-8092-8c4d-c32ba4d2ecfb"
          }
        ]
      },
      {
        "object": "block",
        "id": "2605d164-78d8-809c-9607-ff031e3a38da",
        "parent": {
          "type": "page_id",
          "page_id": "2605d164-78d8-800a-87d2-ca72aa76dbb9"
        },
        "created_time": "2025-08-31T06:48:00.000Z",
        "last_edited_time": "2025-08-31T06:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2605d164-78d8-803e-878f-f5e7f6caa077",
        "parent": {
          "type": "page_id",
          "page_id": "2605d164-78d8-800a-87d2-ca72aa76dbb9"
        },
        "created_time": "2025-08-31T06:34:00.000Z",
        "last_edited_time": "2025-08-31T06:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2605d164-78d8-80c8-8968-e4259f1d5382",
        "parent": {
          "type": "page_id",
          "page_id": "2605d164-78d8-800a-87d2-ca72aa76dbb9"
        },
        "created_time": "2025-08-31T06:48:00.000Z",
        "last_edited_time": "2025-08-31T06:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Items",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Items",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2605d164-78d8-8095-83b1-cdd7dfba302a",
        "parent": {
          "type": "page_id",
          "page_id": "2605d164-78d8-800a-87d2-ca72aa76dbb9"
        },
        "created_time": "2025-08-31T06:48:00.000Z",
        "last_edited_time": "2025-08-31T06:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "bb2954d0-2081-4702-a748-8c22aee6689b"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Graphic Fundamental",
              "href": "https://app.notion.com/p/bb2954d020814702a7488c22aee6689b"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2605d164-78d8-80b2-b034-d6b0a9e9ba60",
        "parent": {
          "type": "page_id",
          "page_id": "2605d164-78d8-800a-87d2-ca72aa76dbb9"
        },
        "created_time": "2025-08-31T06:48:00.000Z",
        "last_edited_time": "2025-08-31T06:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1195d164-78d8-80db-a620-d79bfde9595c"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Information, Message, Content",
              "href": "https://app.notion.com/p/1195d16478d880dba620d79bfde9595c"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2605d164-78d8-805c-95d0-f443bd936c79",
        "parent": {
          "type": "page_id",
          "page_id": "2605d164-78d8-800a-87d2-ca72aa76dbb9"
        },
        "created_time": "2025-08-31T06:48:00.000Z",
        "last_edited_time": "2025-08-31T06:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "25d5d164-78d8-80c3-a53b-ee6957d3700c",
    "created_time": "2025-08-28T13:37:00.000Z",
    "last_edited_time": "2025-08-28T14:25:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2025-08-28T13:37:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 47
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "2-Think",
          "color": "green"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-28T14:25:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "cZzk",
          "name": "⚔️:3",
          "color": "orange"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Idea… Wait, Rethink",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Idea… Wait, Rethink",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Idea-Wait-Rethink-25d5d16478d880c3a53bee6957d3700c",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
      "name": "Think",
      "slug": "think",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "25d5d164-78d8-8071-8c21-fc572d6d04b6",
        "parent": {
          "type": "page_id",
          "page_id": "25d5d164-78d8-80c3-a53b-ee6957d3700c"
        },
        "created_time": "2025-08-28T13:57:00.000Z",
        "last_edited_time": "2025-08-28T14:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756391139/uxcomic-imgs/25d5d164-78d8-8071-8c21-fc572d6d04b6.png",
            "expiry_time": "2026-10-04T09:09:45.837Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/25d5d164-78d8-8071-8c21-fc572d6d04b6"
      },
      {
        "object": "block",
        "id": "25d5d164-78d8-805d-8dda-ef077eb2be83",
        "parent": {
          "type": "page_id",
          "page_id": "25d5d164-78d8-80c3-a53b-ee6957d3700c"
        },
        "created_time": "2025-08-28T13:38:00.000Z",
        "last_edited_time": "2025-08-28T13:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dành cho những lúc mình điên cuồng nghĩ về idea… ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dành cho những lúc mình điên cuồng nghĩ về idea… ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25d5d164-78d8-80e5-b929-d0240a6e9473",
        "parent": {
          "type": "page_id",
          "page_id": "25d5d164-78d8-80c3-a53b-ee6957d3700c"
        },
        "created_time": "2025-08-28T13:39:00.000Z",
        "last_edited_time": "2025-08-28T14:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "list",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "list",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "25d5d164-78d8-8009-967f-d96639fd33b6",
            "parent": {
              "type": "block_id",
              "block_id": "25d5d164-78d8-80e5-b929-d0240a6e9473"
            },
            "created_time": "2025-08-28T14:24:00.000Z",
            "last_edited_time": "2025-08-28T14:25:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756391141/uxcomic-imgs/25d5d164-78d8-8009-967f-d96639fd33b6.png",
                "expiry_time": "2026-10-04T09:09:46.267Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25d5d164-78d8-8009-967f-d96639fd33b6"
          },
          {
            "object": "block",
            "id": "25d5d164-78d8-8026-9e7c-d43e586a913f",
            "parent": {
              "type": "block_id",
              "block_id": "25d5d164-78d8-80e5-b929-d0240a6e9473"
            },
            "created_time": "2025-08-28T14:24:00.000Z",
            "last_edited_time": "2025-08-28T14:25:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756391142/uxcomic-imgs/25d5d164-78d8-8026-9e7c-d43e586a913f.png",
                "expiry_time": "2026-10-04T09:09:46.267Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25d5d164-78d8-8026-9e7c-d43e586a913f"
          },
          {
            "object": "block",
            "id": "25d5d164-78d8-8044-9fc0-c4d5b02824dd",
            "parent": {
              "type": "block_id",
              "block_id": "25d5d164-78d8-80e5-b929-d0240a6e9473"
            },
            "created_time": "2025-08-28T14:24:00.000Z",
            "last_edited_time": "2025-08-28T14:25:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756391143/uxcomic-imgs/25d5d164-78d8-8044-9fc0-c4d5b02824dd.png",
                "expiry_time": "2026-10-04T09:09:46.267Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25d5d164-78d8-8044-9fc0-c4d5b02824dd"
          },
          {
            "object": "block",
            "id": "25d5d164-78d8-806c-bc35-e4bf8297e6b7",
            "parent": {
              "type": "block_id",
              "block_id": "25d5d164-78d8-80e5-b929-d0240a6e9473"
            },
            "created_time": "2025-08-28T14:24:00.000Z",
            "last_edited_time": "2025-08-28T14:25:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756391144/uxcomic-imgs/25d5d164-78d8-806c-bc35-e4bf8297e6b7.png",
                "expiry_time": "2026-10-04T09:09:46.267Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25d5d164-78d8-806c-bc35-e4bf8297e6b7"
          },
          {
            "object": "block",
            "id": "25d5d164-78d8-8050-a13c-fea06d88a85a",
            "parent": {
              "type": "block_id",
              "block_id": "25d5d164-78d8-80e5-b929-d0240a6e9473"
            },
            "created_time": "2025-08-28T14:24:00.000Z",
            "last_edited_time": "2025-08-28T14:25:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756391145/uxcomic-imgs/25d5d164-78d8-8050-a13c-fea06d88a85a.png",
                "expiry_time": "2026-10-04T09:09:46.267Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25d5d164-78d8-8050-a13c-fea06d88a85a"
          },
          {
            "object": "block",
            "id": "25d5d164-78d8-80e1-a9e4-d5abaff88b85",
            "parent": {
              "type": "block_id",
              "block_id": "25d5d164-78d8-80e5-b929-d0240a6e9473"
            },
            "created_time": "2025-08-28T14:24:00.000Z",
            "last_edited_time": "2025-08-28T14:25:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756391146/uxcomic-imgs/25d5d164-78d8-80e1-a9e4-d5abaff88b85.png",
                "expiry_time": "2026-10-04T09:09:46.267Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25d5d164-78d8-80e1-a9e4-d5abaff88b85"
          }
        ]
      },
      {
        "object": "block",
        "id": "25d5d164-78d8-8053-b871-cc8b9d291146",
        "parent": {
          "type": "page_id",
          "page_id": "25d5d164-78d8-80c3-a53b-ee6957d3700c"
        },
        "created_time": "2025-08-28T13:57:00.000Z",
        "last_edited_time": "2025-08-28T14:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "25a5d164-78d8-8022-885c-cf74b030e53d",
    "created_time": "2025-08-25T04:58:00.000Z",
    "last_edited_time": "2025-10-23T07:54:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2025-08-25T04:58:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 46
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "1-Design",
          "color": "default"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-10-23T07:54:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "prxX",
          "name": "⚔️:2",
          "color": "yellow"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Measuring checklist",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Measuring checklist",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Measuring-checklist-25a5d16478d88022885ccf74b030e53d",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Design",
      "slug": "design",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "25a5d164-78d8-8037-965b-db5e0dcb1e90",
        "parent": {
          "type": "page_id",
          "page_id": "25a5d164-78d8-8022-885c-cf74b030e53d"
        },
        "created_time": "2025-08-25T05:00:00.000Z",
        "last_edited_time": "2025-08-25T06:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756098143/uxcomic-imgs/25a5d164-78d8-8037-965b-db5e0dcb1e90.png",
            "expiry_time": "2026-10-04T09:09:47.945Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/25a5d164-78d8-8037-965b-db5e0dcb1e90"
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-804d-95c6-f9cdf2a56e40",
        "parent": {
          "type": "page_id",
          "page_id": "25a5d164-78d8-8022-885c-cf74b030e53d"
        },
        "created_time": "2025-08-25T04:59:00.000Z",
        "last_edited_time": "2025-08-25T10:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ship được một flow, một feature chỉ mới hoàn thành 1 nửa chặng đường, có thể nói là ta mới dừng lại ở việc deliver ra output, artifact gì đó và cho nó ra thế giới.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ship được một flow, một feature chỉ mới hoàn thành 1 nửa chặng đường, có thể nói là ta mới dừng lại ở việc deliver ra output, artifact gì đó và cho nó ra thế giới.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8022-8ae0-f85c55dfc197",
        "parent": {
          "type": "page_id",
          "page_id": "25a5d164-78d8-8022-885c-cf74b030e53d"
        },
        "created_time": "2025-08-25T06:07:00.000Z",
        "last_edited_time": "2025-08-25T06:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thử hình dung artifact đó là một hợp chất A, ta release để nó tiếp xúc với world - hợp chất B, và ta cần xem chúng nó phản ứng ra sao, liệu sự phản ứng đó có phải thứ mà ta đang kì vọng. Sự phản ứng này chính là outcome của project/product, nếu mình không đo đạc chúng thì sẽ thiếu dữ kiện, thiếu định hướng, chơi bài may rủi, và tệ hơn là không learn được gì cả.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thử hình dung artifact đó là một hợp chất A, ta release để nó tiếp xúc với world - hợp chất B, và ta cần xem chúng nó phản ứng ra sao, liệu sự phản ứng đó có phải thứ mà ta đang kì vọng. Sự phản ứng này chính là outcome của project/product, nếu mình không đo đạc chúng thì sẽ thiếu dữ kiện, thiếu định hướng, chơi bài may rủi, và tệ hơn là không learn được gì cả.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8041-ab63-c2293b677626",
        "parent": {
          "type": "page_id",
          "page_id": "25a5d164-78d8-8022-885c-cf74b030e53d"
        },
        "created_time": "2025-08-25T06:09:00.000Z",
        "last_edited_time": "2025-08-25T06:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đây là mindset nhìn nhận mình như là một nhà hoá học, mang tâm thế của một người thử nghiệm, các bạn có thể xem thêm bài này về ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đây là mindset nhìn nhận mình như là một nhà hoá học, mang tâm thế của một người thử nghiệm, các bạn có thể xem thêm bài này về ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "experimental mindset",
                "link": {
                  "url": "/fba9a75a71ae4302ac761431b742e33d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "experimental mindset",
              "href": "/fba9a75a71ae4302ac761431b742e33d"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8018-87d0-c95d8b73b5eb",
        "parent": {
          "type": "page_id",
          "page_id": "25a5d164-78d8-8022-885c-cf74b030e53d"
        },
        "created_time": "2025-08-25T06:05:00.000Z",
        "last_edited_time": "2025-08-25T06:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-807b-a7cb-f324999f7564",
        "parent": {
          "type": "page_id",
          "page_id": "25a5d164-78d8-8022-885c-cf74b030e53d"
        },
        "created_time": "2025-08-25T06:05:00.000Z",
        "last_edited_time": "2025-08-25T06:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tạm list ra vài metrics phổ biến để tiện xem lại… Còn bài detail hơn về",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tạm list ra vài metrics phổ biến để tiện xem lại… Còn bài detail hơn về",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " các loại metrics có thể xem thêm ở bài này",
                "link": {
                  "url": "/1ca5d16478d8802ebb3bfaa465a1d6dc"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " các loại metrics có thể xem thêm ở bài này",
              "href": "/1ca5d16478d8802ebb3bfaa465a1d6dc"
            },
            {
              "type": "text",
              "text": {
                "content": " nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8064-a432-c77daeffefc9",
        "parent": {
          "type": "page_id",
          "page_id": "25a5d164-78d8-8022-885c-cf74b030e53d"
        },
        "created_time": "2025-08-25T05:00:00.000Z",
        "last_edited_time": "2025-08-29T10:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "list",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "list",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "25e5d164-78d8-800d-855e-de2e2e29b626",
            "parent": {
              "type": "block_id",
              "block_id": "25a5d164-78d8-8064-a432-c77daeffefc9"
            },
            "created_time": "2025-08-29T10:04:00.000Z",
            "last_edited_time": "2025-10-11T03:18:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756462182/uxcomic-imgs/25e5d164-78d8-800d-855e-de2e2e29b626.png",
                "expiry_time": "2026-10-04T09:09:48.581Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-800d-855e-de2e2e29b626"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-80af-accc-c39d8042b061",
            "parent": {
              "type": "block_id",
              "block_id": "25a5d164-78d8-8064-a432-c77daeffefc9"
            },
            "created_time": "2025-08-29T10:04:00.000Z",
            "last_edited_time": "2025-10-11T03:18:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756462183/uxcomic-imgs/25e5d164-78d8-80af-accc-c39d8042b061.png",
                "expiry_time": "2026-10-04T09:09:48.581Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-80af-accc-c39d8042b061"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-8048-a961-cffb30c69c30",
            "parent": {
              "type": "block_id",
              "block_id": "25a5d164-78d8-8064-a432-c77daeffefc9"
            },
            "created_time": "2025-08-29T10:04:00.000Z",
            "last_edited_time": "2025-10-11T03:18:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756462184/uxcomic-imgs/25e5d164-78d8-8048-a961-cffb30c69c30.png",
                "expiry_time": "2026-10-04T09:09:48.581Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-8048-a961-cffb30c69c30"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-8086-ab49-cc39aae4b9fb",
            "parent": {
              "type": "block_id",
              "block_id": "25a5d164-78d8-8064-a432-c77daeffefc9"
            },
            "created_time": "2025-08-29T10:04:00.000Z",
            "last_edited_time": "2025-10-11T03:18:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756462185/uxcomic-imgs/25e5d164-78d8-8086-ab49-cc39aae4b9fb.png",
                "expiry_time": "2026-10-04T09:09:48.581Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-8086-ab49-cc39aae4b9fb"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-800d-9192-c4437d2a7504",
            "parent": {
              "type": "block_id",
              "block_id": "25a5d164-78d8-8064-a432-c77daeffefc9"
            },
            "created_time": "2025-08-29T10:04:00.000Z",
            "last_edited_time": "2025-10-11T03:18:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756462186/uxcomic-imgs/25e5d164-78d8-800d-9192-c4437d2a7504.png",
                "expiry_time": "2026-10-04T09:09:48.581Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-800d-9192-c4437d2a7504"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-8088-83d0-e40b2351cb88",
            "parent": {
              "type": "block_id",
              "block_id": "25a5d164-78d8-8064-a432-c77daeffefc9"
            },
            "created_time": "2025-08-29T10:04:00.000Z",
            "last_edited_time": "2025-10-11T03:18:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756462187/uxcomic-imgs/25e5d164-78d8-8088-83d0-e40b2351cb88.png",
                "expiry_time": "2026-10-04T09:09:48.581Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-8088-83d0-e40b2351cb88"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-8050-9aea-fa887602ca68",
            "parent": {
              "type": "block_id",
              "block_id": "25a5d164-78d8-8064-a432-c77daeffefc9"
            },
            "created_time": "2025-08-29T10:04:00.000Z",
            "last_edited_time": "2025-10-11T03:18:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756462188/uxcomic-imgs/25e5d164-78d8-8050-9aea-fa887602ca68.png",
                "expiry_time": "2026-10-04T09:09:48.581Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-8050-9aea-fa887602ca68"
          }
        ]
      },
      {
        "object": "block",
        "id": "25e5d164-78d8-8069-98b6-cb518332efb0",
        "parent": {
          "type": "page_id",
          "page_id": "25a5d164-78d8-8022-885c-cf74b030e53d"
        },
        "created_time": "2025-08-29T10:04:00.000Z",
        "last_edited_time": "2025-08-29T10:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-80df-9d8b-cca5deab4c07",
        "parent": {
          "type": "page_id",
          "page_id": "25a5d164-78d8-8022-885c-cf74b030e53d"
        },
        "created_time": "2025-08-25T05:00:00.000Z",
        "last_edited_time": "2025-08-27T11:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8095-8650-d5b200d743ba",
        "parent": {
          "type": "page_id",
          "page_id": "25a5d164-78d8-8022-885c-cf74b030e53d"
        },
        "created_time": "2025-08-25T05:00:00.000Z",
        "last_edited_time": "2025-09-09T09:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ngoài ra còn có các tactics liên quan đến việc validate hypothesis, test product idea trước khi build hoặc sau khi build (nó nhằm mục đích kiểm chứng nhu cầu, đo lường độ hứng thú, đo lường mức độ hiệu quả, quản lý rủi ro…). Một cuốn sách không thể thiếu cho ai muốn kiểm chứng các product idea trước khi build nó là “The mom test” của ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ngoài ra còn có các tactics liên quan đến việc validate hypothesis, test product idea trước khi build hoặc sau khi build (nó nhằm mục đích kiểm chứng nhu cầu, đo lường độ hứng thú, đo lường mức độ hiệu quả, quản lý rủi ro…). Một cuốn sách không thể thiếu cho ai muốn kiểm chứng các product idea trước khi build nó là “The mom test” của ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Rob Fitzpatrick",
                "link": {
                  "url": "https://www.google.com/search?sca_esv=f6511093bb828960&rlz=1C5CHFA_enVN1091VN1091&sxsrf=AE3TifPAY7bLcGIc-aKgf8S4E3VVpYO_rA%3A1757410419622&q=the%20mom%20test%3A%20how%20to%20talk%20to%20customers%20%26%20learn%20if%20your%20business%20is%20a%20good%20idea%20when%20everyone%20is%20lying%20to%20you%20rob%20fitzpatrick&si=AMgyJEs9DArPE9xmb5yVYVjpG4jqWDEKSIpCRSjmm88XZWnGNb7IDEto_3CuFYZE8o7JQAQMq976_QVvQ3pzpFx2Hd33l_AltwjQVeUOKvMIZonVHSXrF4tNMTRvLgew9ZAZWY2H3I9DOYRztGtlpmoPIUMA_xDRpXW3hpJ-3S6LvpXYi0vYN7yxxr53A0Er40l9OJTfu3hTv3LAxJWgZJyjFh1WHZ28zhH2EJEmOPbZqvmIh5N6xA1cGv--pm0aGZS0hoXLN4WU6n841rx5aUAocNplZoKKHY60ZFQCHflwS02QQF7F5aUuRMlE8cFpJrtApXGVBYrGnGMeenvERH4vqmeI82yXpeX5B5oW5zJ3h8AQpkgFDW4%3D&sa=X&ved=2ahUKEwiD66T-r8uPAxWJ1DgGHf_6JhAQmxN6BAgsEAI"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Rob Fitzpatrick",
              "href": "https://www.google.com/search?sca_esv=f6511093bb828960&rlz=1C5CHFA_enVN1091VN1091&sxsrf=AE3TifPAY7bLcGIc-aKgf8S4E3VVpYO_rA%3A1757410419622&q=the%20mom%20test%3A%20how%20to%20talk%20to%20customers%20%26%20learn%20if%20your%20business%20is%20a%20good%20idea%20when%20everyone%20is%20lying%20to%20you%20rob%20fitzpatrick&si=AMgyJEs9DArPE9xmb5yVYVjpG4jqWDEKSIpCRSjmm88XZWnGNb7IDEto_3CuFYZE8o7JQAQMq976_QVvQ3pzpFx2Hd33l_AltwjQVeUOKvMIZonVHSXrF4tNMTRvLgew9ZAZWY2H3I9DOYRztGtlpmoPIUMA_xDRpXW3hpJ-3S6LvpXYi0vYN7yxxr53A0Er40l9OJTfu3hTv3LAxJWgZJyjFh1WHZ28zhH2EJEmOPbZqvmIh5N6xA1cGv--pm0aGZS0hoXLN4WU6n841rx5aUAocNplZoKKHY60ZFQCHflwS02QQF7F5aUuRMlE8cFpJrtApXGVBYrGnGMeenvERH4vqmeI82yXpeX5B5oW5zJ3h8AQpkgFDW4%3D&sa=X&ved=2ahUKEwiD66T-r8uPAxWJ1DgGHf_6JhAQmxN6BAgsEAI"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25c5d164-78d8-80fb-b7a3-e9eafb4114ba",
        "parent": {
          "type": "page_id",
          "page_id": "25a5d164-78d8-8022-885c-cf74b030e53d"
        },
        "created_time": "2025-08-27T11:06:00.000Z",
        "last_edited_time": "2025-08-27T11:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [
            {
              "type": "text",
              "text": {
                "content": "Itamar Gilad’s Testing Product Ideas Handbook",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Itamar Gilad’s Testing Product Ideas Handbook",
              "href": null
            }
          ],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756293401/uxcomic-imgs/25c5d164-78d8-80fb-b7a3-e9eafb4114ba.jpg",
            "expiry_time": "2026-10-04T09:09:47.945Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/25c5d164-78d8-80fb-b7a3-e9eafb4114ba"
      },
      {
        "object": "block",
        "id": "25c5d164-78d8-8012-8113-d47843238409",
        "parent": {
          "type": "page_id",
          "page_id": "25a5d164-78d8-8022-885c-cf74b030e53d"
        },
        "created_time": "2025-08-27T10:56:00.000Z",
        "last_edited_time": "2025-08-29T10:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "list2",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "list2",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "25e5d164-78d8-808c-a965-eba8135243e2",
            "parent": {
              "type": "block_id",
              "block_id": "25c5d164-78d8-8012-8113-d47843238409"
            },
            "created_time": "2025-08-29T10:06:00.000Z",
            "last_edited_time": "2025-08-31T05:25:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756462189/uxcomic-imgs/25e5d164-78d8-808c-a965-eba8135243e2.png",
                "expiry_time": "2026-10-04T09:09:50.613Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-808c-a965-eba8135243e2"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-804f-bbe4-f2fbeed0e57c",
            "parent": {
              "type": "block_id",
              "block_id": "25c5d164-78d8-8012-8113-d47843238409"
            },
            "created_time": "2025-08-29T10:06:00.000Z",
            "last_edited_time": "2025-08-31T05:25:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756462190/uxcomic-imgs/25e5d164-78d8-804f-bbe4-f2fbeed0e57c.png",
                "expiry_time": "2026-10-04T09:09:50.613Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-804f-bbe4-f2fbeed0e57c"
          }
        ]
      },
      {
        "object": "block",
        "id": "25c5d164-78d8-80dc-9d7a-d56485e5c2ea",
        "parent": {
          "type": "page_id",
          "page_id": "25a5d164-78d8-8022-885c-cf74b030e53d"
        },
        "created_time": "2025-08-27T11:02:00.000Z",
        "last_edited_time": "2025-08-28T13:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-80b9-9b9f-dc40c089748e",
        "parent": {
          "type": "page_id",
          "page_id": "25a5d164-78d8-8022-885c-cf74b030e53d"
        },
        "created_time": "2025-08-25T05:00:00.000Z",
        "last_edited_time": "2025-08-25T05:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2955d164-78d8-8002-9e7e-e8d1c4add400",
        "parent": {
          "type": "page_id",
          "page_id": "25a5d164-78d8-8022-885c-cf74b030e53d"
        },
        "created_time": "2025-10-23T07:42:00.000Z",
        "last_edited_time": "2025-10-23T07:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2955d164-78d8-80b2-ae13-c51e8686679b",
        "parent": {
          "type": "page_id",
          "page_id": "25a5d164-78d8-8022-885c-cf74b030e53d"
        },
        "created_time": "2025-10-23T07:42:00.000Z",
        "last_edited_time": "2025-10-23T07:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://amplitude.com/blog/map-your-metrics",
                "link": {
                  "url": "https://amplitude.com/blog/map-your-metrics"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://amplitude.com/blog/map-your-metrics",
              "href": "https://amplitude.com/blog/map-your-metrics"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2955d164-78d8-8044-9ad1-d06b4481410d",
        "parent": {
          "type": "page_id",
          "page_id": "25a5d164-78d8-8022-885c-cf74b030e53d"
        },
        "created_time": "2025-10-23T07:42:00.000Z",
        "last_edited_time": "2025-10-23T07:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-80cf-a056-cf852bb465bf",
        "parent": {
          "type": "page_id",
          "page_id": "25a5d164-78d8-8022-885c-cf74b030e53d"
        },
        "created_time": "2025-08-25T05:00:00.000Z",
        "last_edited_time": "2025-08-25T05:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Related Items",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Related Items",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8005-ac08-e57ff39f86bd",
        "parent": {
          "type": "page_id",
          "page_id": "25a5d164-78d8-8022-885c-cf74b030e53d"
        },
        "created_time": "2025-08-25T05:01:00.000Z",
        "last_edited_time": "2025-08-25T05:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Data-Metrics in UX",
              "href": "https://app.notion.com/p/1ca5d16478d8802ebb3bfaa465a1d6dc"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8022-859b-ed8153790a6e",
        "parent": {
          "type": "page_id",
          "page_id": "25a5d164-78d8-8022-885c-cf74b030e53d"
        },
        "created_time": "2025-08-25T05:01:00.000Z",
        "last_edited_time": "2025-08-25T05:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Just an experiment",
              "href": "https://app.notion.com/p/fba9a75a71ae4302ac761431b742e33d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "2575d164-78d8-80c3-bb1e-dfb915676d98",
    "created_time": "2025-08-22T02:50:00.000Z",
    "last_edited_time": "2026-10-04T08:08:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2025-08-22T02:50:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 52
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "1-Design",
          "color": "default"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2026-10-04T08:08:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "sgq|",
          "name": "⚔️:1",
          "color": "red"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "UX Challenge cards",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "UX Challenge cards",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/UX-Challenge-cards-2575d16478d880c3bb1edfb915676d98",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Design",
      "slug": "design",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "2925d164-78d8-8059-bfd2-fe55696f1a71",
        "parent": {
          "type": "page_id",
          "page_id": "2575d164-78d8-80c3-bb1e-dfb915676d98"
        },
        "created_time": "2025-10-20T01:40:00.000Z",
        "last_edited_time": "2025-10-20T01:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1760924973/uxcomic-imgs/2925d164-78d8-8059-bfd2-fe55696f1a71.png",
            "expiry_time": "2026-10-04T09:09:51.270Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2925d164-78d8-8059-bfd2-fe55696f1a71"
      },
      {
        "object": "block",
        "id": "2575d164-78d8-8019-8bc0-e6b13921cd0c",
        "parent": {
          "type": "page_id",
          "page_id": "2575d164-78d8-80c3-bb1e-dfb915676d98"
        },
        "created_time": "2025-08-22T02:50:00.000Z",
        "last_edited_time": "2026-10-04T08:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dành cho những lúc cần tự vấn bản thân…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dành cho những lúc cần tự vấn bản thân…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2675d164-78d8-80d8-8da9-f0677de2e006",
        "parent": {
          "type": "page_id",
          "page_id": "2575d164-78d8-80c3-bb1e-dfb915676d98"
        },
        "created_time": "2025-09-07T10:24:00.000Z",
        "last_edited_time": "2025-09-07T10:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2675d164-78d8-8009-9f6a-f53d4ee02295",
        "parent": {
          "type": "page_id",
          "page_id": "2575d164-78d8-80c3-bb1e-dfb915676d98"
        },
        "created_time": "2025-09-07T10:25:00.000Z",
        "last_edited_time": "2025-09-07T10:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2675d164-78d8-809f-9962-fdc8b0456f81",
        "parent": {
          "type": "page_id",
          "page_id": "2575d164-78d8-80c3-bb1e-dfb915676d98"
        },
        "created_time": "2025-09-07T10:24:00.000Z",
        "last_edited_time": "2025-09-08T01:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Pre-design",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Pre-design",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "2685d164-78d8-80fe-9e10-da9e5a4d37cb",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809f-9962-fdc8b0456f81"
            },
            "created_time": "2025-09-08T01:14:00.000Z",
            "last_edited_time": "2025-09-08T01:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757294131/uxcomic-imgs/2685d164-78d8-80fe-9e10-da9e5a4d37cb.png",
                "expiry_time": "2026-10-04T09:09:51.761Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2685d164-78d8-80fe-9e10-da9e5a4d37cb"
          },
          {
            "object": "block",
            "id": "2685d164-78d8-805d-a3e6-e7bc6992e36b",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809f-9962-fdc8b0456f81"
            },
            "created_time": "2025-09-08T01:14:00.000Z",
            "last_edited_time": "2025-09-08T01:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757294133/uxcomic-imgs/2685d164-78d8-805d-a3e6-e7bc6992e36b.png",
                "expiry_time": "2026-10-04T09:09:51.761Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2685d164-78d8-805d-a3e6-e7bc6992e36b"
          },
          {
            "object": "block",
            "id": "2685d164-78d8-807e-a0fe-e9ac03efaab1",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809f-9962-fdc8b0456f81"
            },
            "created_time": "2025-09-08T01:14:00.000Z",
            "last_edited_time": "2025-09-08T01:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757294134/uxcomic-imgs/2685d164-78d8-807e-a0fe-e9ac03efaab1.png",
                "expiry_time": "2026-10-04T09:09:51.761Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2685d164-78d8-807e-a0fe-e9ac03efaab1"
          },
          {
            "object": "block",
            "id": "2685d164-78d8-80db-ba2e-c90399bfb6e9",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809f-9962-fdc8b0456f81"
            },
            "created_time": "2025-09-08T01:14:00.000Z",
            "last_edited_time": "2025-09-08T01:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757294135/uxcomic-imgs/2685d164-78d8-80db-ba2e-c90399bfb6e9.png",
                "expiry_time": "2026-10-04T09:09:51.761Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2685d164-78d8-80db-ba2e-c90399bfb6e9"
          },
          {
            "object": "block",
            "id": "2685d164-78d8-8086-bb3f-c25ef717b11c",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809f-9962-fdc8b0456f81"
            },
            "created_time": "2025-09-08T01:14:00.000Z",
            "last_edited_time": "2025-09-08T01:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757294136/uxcomic-imgs/2685d164-78d8-8086-bb3f-c25ef717b11c.png",
                "expiry_time": "2026-10-04T09:09:51.761Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2685d164-78d8-8086-bb3f-c25ef717b11c"
          },
          {
            "object": "block",
            "id": "2685d164-78d8-80f6-a4f8-c4e067820f81",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809f-9962-fdc8b0456f81"
            },
            "created_time": "2025-09-08T01:14:00.000Z",
            "last_edited_time": "2025-09-08T01:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757294137/uxcomic-imgs/2685d164-78d8-80f6-a4f8-c4e067820f81.png",
                "expiry_time": "2026-10-04T09:09:51.761Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2685d164-78d8-80f6-a4f8-c4e067820f81"
          },
          {
            "object": "block",
            "id": "2685d164-78d8-806c-8dbb-e7606eb46ea4",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809f-9962-fdc8b0456f81"
            },
            "created_time": "2025-09-08T01:14:00.000Z",
            "last_edited_time": "2025-09-08T01:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757294138/uxcomic-imgs/2685d164-78d8-806c-8dbb-e7606eb46ea4.png",
                "expiry_time": "2026-10-04T09:09:51.761Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2685d164-78d8-806c-8dbb-e7606eb46ea4"
          },
          {
            "object": "block",
            "id": "2685d164-78d8-809f-bc27-f46ff4ebfc65",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809f-9962-fdc8b0456f81"
            },
            "created_time": "2025-09-08T01:14:00.000Z",
            "last_edited_time": "2025-09-08T01:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757294139/uxcomic-imgs/2685d164-78d8-809f-bc27-f46ff4ebfc65.png",
                "expiry_time": "2026-10-04T09:09:51.761Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2685d164-78d8-809f-bc27-f46ff4ebfc65"
          },
          {
            "object": "block",
            "id": "2685d164-78d8-80c4-aca9-e86be89276ad",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809f-9962-fdc8b0456f81"
            },
            "created_time": "2025-09-08T01:14:00.000Z",
            "last_edited_time": "2025-09-08T01:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757294140/uxcomic-imgs/2685d164-78d8-80c4-aca9-e86be89276ad.png",
                "expiry_time": "2026-10-04T09:09:51.761Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2685d164-78d8-80c4-aca9-e86be89276ad"
          },
          {
            "object": "block",
            "id": "2685d164-78d8-8028-a15e-c92938423160",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809f-9962-fdc8b0456f81"
            },
            "created_time": "2025-09-08T01:14:00.000Z",
            "last_edited_time": "2025-09-08T01:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757294142/uxcomic-imgs/2685d164-78d8-8028-a15e-c92938423160.png",
                "expiry_time": "2026-10-04T09:09:51.761Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2685d164-78d8-8028-a15e-c92938423160"
          },
          {
            "object": "block",
            "id": "2685d164-78d8-80d5-8ea7-f4888350239e",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809f-9962-fdc8b0456f81"
            },
            "created_time": "2025-09-08T01:14:00.000Z",
            "last_edited_time": "2025-09-08T01:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757294143/uxcomic-imgs/2685d164-78d8-80d5-8ea7-f4888350239e.png",
                "expiry_time": "2026-10-04T09:09:51.762Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2685d164-78d8-80d5-8ea7-f4888350239e"
          },
          {
            "object": "block",
            "id": "2685d164-78d8-8005-8716-c923314bdff9",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809f-9962-fdc8b0456f81"
            },
            "created_time": "2025-09-08T01:14:00.000Z",
            "last_edited_time": "2025-09-08T01:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757294144/uxcomic-imgs/2685d164-78d8-8005-8716-c923314bdff9.png",
                "expiry_time": "2026-10-04T09:09:51.762Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2685d164-78d8-8005-8716-c923314bdff9"
          },
          {
            "object": "block",
            "id": "2685d164-78d8-80cc-9699-f48ceee4c22e",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809f-9962-fdc8b0456f81"
            },
            "created_time": "2025-09-08T01:14:00.000Z",
            "last_edited_time": "2025-09-08T01:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757294145/uxcomic-imgs/2685d164-78d8-80cc-9699-f48ceee4c22e.png",
                "expiry_time": "2026-10-04T09:09:51.762Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2685d164-78d8-80cc-9699-f48ceee4c22e"
          },
          {
            "object": "block",
            "id": "2685d164-78d8-80bd-95bf-ce41a9fe0a5c",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809f-9962-fdc8b0456f81"
            },
            "created_time": "2025-09-08T01:14:00.000Z",
            "last_edited_time": "2025-09-08T01:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757294146/uxcomic-imgs/2685d164-78d8-80bd-95bf-ce41a9fe0a5c.png",
                "expiry_time": "2026-10-04T09:09:51.762Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2685d164-78d8-80bd-95bf-ce41a9fe0a5c"
          },
          {
            "object": "block",
            "id": "2685d164-78d8-8072-9bdd-eabd6bf1a7cd",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809f-9962-fdc8b0456f81"
            },
            "created_time": "2025-09-08T01:14:00.000Z",
            "last_edited_time": "2025-09-08T01:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757294147/uxcomic-imgs/2685d164-78d8-8072-9bdd-eabd6bf1a7cd.png",
                "expiry_time": "2026-10-04T09:09:51.762Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2685d164-78d8-8072-9bdd-eabd6bf1a7cd"
          },
          {
            "object": "block",
            "id": "2685d164-78d8-800b-b2fa-c573909c7aa3",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809f-9962-fdc8b0456f81"
            },
            "created_time": "2025-09-08T01:14:00.000Z",
            "last_edited_time": "2025-09-08T01:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757294148/uxcomic-imgs/2685d164-78d8-800b-b2fa-c573909c7aa3.png",
                "expiry_time": "2026-10-04T09:09:51.762Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2685d164-78d8-800b-b2fa-c573909c7aa3"
          },
          {
            "object": "block",
            "id": "2685d164-78d8-8050-b364-c457a49b6b69",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809f-9962-fdc8b0456f81"
            },
            "created_time": "2025-09-08T01:14:00.000Z",
            "last_edited_time": "2025-09-08T01:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757294149/uxcomic-imgs/2685d164-78d8-8050-b364-c457a49b6b69.png",
                "expiry_time": "2026-10-04T09:09:51.762Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2685d164-78d8-8050-b364-c457a49b6b69"
          },
          {
            "object": "block",
            "id": "2685d164-78d8-80fe-9007-da1c8698d21f",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809f-9962-fdc8b0456f81"
            },
            "created_time": "2025-09-08T01:14:00.000Z",
            "last_edited_time": "2025-09-08T01:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757294150/uxcomic-imgs/2685d164-78d8-80fe-9007-da1c8698d21f.png",
                "expiry_time": "2026-10-04T09:09:51.762Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2685d164-78d8-80fe-9007-da1c8698d21f"
          },
          {
            "object": "block",
            "id": "2685d164-78d8-8054-b59f-f05ca67ad4dc",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809f-9962-fdc8b0456f81"
            },
            "created_time": "2025-09-08T01:14:00.000Z",
            "last_edited_time": "2025-09-08T01:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757294151/uxcomic-imgs/2685d164-78d8-8054-b59f-f05ca67ad4dc.png",
                "expiry_time": "2026-10-04T09:09:51.762Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2685d164-78d8-8054-b59f-f05ca67ad4dc"
          },
          {
            "object": "block",
            "id": "2685d164-78d8-808f-a123-cca3dfb7c400",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809f-9962-fdc8b0456f81"
            },
            "created_time": "2025-09-08T01:14:00.000Z",
            "last_edited_time": "2025-09-08T01:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757294152/uxcomic-imgs/2685d164-78d8-808f-a123-cca3dfb7c400.png",
                "expiry_time": "2026-10-04T09:09:51.762Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2685d164-78d8-808f-a123-cca3dfb7c400"
          }
        ]
      },
      {
        "object": "block",
        "id": "2675d164-78d8-800c-bfab-ea904b8af8a9",
        "parent": {
          "type": "page_id",
          "page_id": "2575d164-78d8-80c3-bb1e-dfb915676d98"
        },
        "created_time": "2025-09-07T10:25:00.000Z",
        "last_edited_time": "2025-09-07T10:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2675d164-78d8-8044-985e-f2edb8892ee0",
        "parent": {
          "type": "page_id",
          "page_id": "2575d164-78d8-80c3-bb1e-dfb915676d98"
        },
        "created_time": "2025-09-07T10:25:00.000Z",
        "last_edited_time": "2025-09-07T10:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2675d164-78d8-808b-960e-dd66e338f34e",
        "parent": {
          "type": "page_id",
          "page_id": "2575d164-78d8-80c3-bb1e-dfb915676d98"
        },
        "created_time": "2025-09-07T10:25:00.000Z",
        "last_edited_time": "2025-09-07T10:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "In-design",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "In-design",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "2675d164-78d8-800c-b882-fc41c887edd3",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-808b-960e-dd66e338f34e"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757240978/uxcomic-imgs/2675d164-78d8-800c-b882-fc41c887edd3.png",
                "expiry_time": "2026-10-04T09:09:56.259Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-800c-b882-fc41c887edd3"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8037-8fea-e3f5029d0ded",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-808b-960e-dd66e338f34e"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757240979/uxcomic-imgs/2675d164-78d8-8037-8fea-e3f5029d0ded.png",
                "expiry_time": "2026-10-04T09:09:56.259Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8037-8fea-e3f5029d0ded"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-806a-8b87-f7456a04d93a",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-808b-960e-dd66e338f34e"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757240980/uxcomic-imgs/2675d164-78d8-806a-8b87-f7456a04d93a.png",
                "expiry_time": "2026-10-04T09:09:56.259Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-806a-8b87-f7456a04d93a"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-80a0-8d23-e17924d65fa7",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-808b-960e-dd66e338f34e"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757240981/uxcomic-imgs/2675d164-78d8-80a0-8d23-e17924d65fa7.png",
                "expiry_time": "2026-10-04T09:09:56.259Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-80a0-8d23-e17924d65fa7"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-809b-9d70-ed9999daa6de",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-808b-960e-dd66e338f34e"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757240982/uxcomic-imgs/2675d164-78d8-809b-9d70-ed9999daa6de.png",
                "expiry_time": "2026-10-04T09:09:56.259Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-809b-9d70-ed9999daa6de"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8023-a85c-fa4710e313ac",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-808b-960e-dd66e338f34e"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757240983/uxcomic-imgs/2675d164-78d8-8023-a85c-fa4710e313ac.png",
                "expiry_time": "2026-10-04T09:09:56.259Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8023-a85c-fa4710e313ac"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-80cf-a7a5-cf4647e9c903",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-808b-960e-dd66e338f34e"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757240984/uxcomic-imgs/2675d164-78d8-80cf-a7a5-cf4647e9c903.png",
                "expiry_time": "2026-10-04T09:09:56.259Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-80cf-a7a5-cf4647e9c903"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8065-87e9-f71482d68cae",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-808b-960e-dd66e338f34e"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757240985/uxcomic-imgs/2675d164-78d8-8065-87e9-f71482d68cae.png",
                "expiry_time": "2026-10-04T09:09:56.260Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8065-87e9-f71482d68cae"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8002-aca2-e49e457f5439",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-808b-960e-dd66e338f34e"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757240986/uxcomic-imgs/2675d164-78d8-8002-aca2-e49e457f5439.png",
                "expiry_time": "2026-10-04T09:09:56.260Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8002-aca2-e49e457f5439"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-80ae-be5d-c38cda5cdc0f",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-808b-960e-dd66e338f34e"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757240987/uxcomic-imgs/2675d164-78d8-80ae-be5d-c38cda5cdc0f.png",
                "expiry_time": "2026-10-04T09:09:56.260Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-80ae-be5d-c38cda5cdc0f"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8054-b71c-cdbef77a2c57",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-808b-960e-dd66e338f34e"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757240988/uxcomic-imgs/2675d164-78d8-8054-b71c-cdbef77a2c57.png",
                "expiry_time": "2026-10-04T09:09:56.260Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8054-b71c-cdbef77a2c57"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-80ac-b3e7-fec1a05fc8c3",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-808b-960e-dd66e338f34e"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757240989/uxcomic-imgs/2675d164-78d8-80ac-b3e7-fec1a05fc8c3.png",
                "expiry_time": "2026-10-04T09:09:56.260Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-80ac-b3e7-fec1a05fc8c3"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8002-abb3-d8106d323737",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-808b-960e-dd66e338f34e"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757240990/uxcomic-imgs/2675d164-78d8-8002-abb3-d8106d323737.png",
                "expiry_time": "2026-10-04T09:09:56.260Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8002-abb3-d8106d323737"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8063-8a2a-d9b5278e3a96",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-808b-960e-dd66e338f34e"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757240991/uxcomic-imgs/2675d164-78d8-8063-8a2a-d9b5278e3a96.png",
                "expiry_time": "2026-10-04T09:09:56.260Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8063-8a2a-d9b5278e3a96"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-802a-96e9-c50abbf58999",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-808b-960e-dd66e338f34e"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757240992/uxcomic-imgs/2675d164-78d8-802a-96e9-c50abbf58999.png",
                "expiry_time": "2026-10-04T09:09:56.260Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-802a-96e9-c50abbf58999"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-808a-a927-e14863533c63",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-808b-960e-dd66e338f34e"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757240993/uxcomic-imgs/2675d164-78d8-808a-a927-e14863533c63.png",
                "expiry_time": "2026-10-04T09:09:56.260Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-808a-a927-e14863533c63"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8026-9051-fbe7535e4664",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-808b-960e-dd66e338f34e"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757240994/uxcomic-imgs/2675d164-78d8-8026-9051-fbe7535e4664.png",
                "expiry_time": "2026-10-04T09:09:56.260Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8026-9051-fbe7535e4664"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8013-9717-dd098d83c906",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-808b-960e-dd66e338f34e"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757240995/uxcomic-imgs/2675d164-78d8-8013-9717-dd098d83c906.png",
                "expiry_time": "2026-10-04T09:09:56.260Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8013-9717-dd098d83c906"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8076-a4e4-f1f7e5f2c8d5",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-808b-960e-dd66e338f34e"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757240996/uxcomic-imgs/2675d164-78d8-8076-a4e4-f1f7e5f2c8d5.png",
                "expiry_time": "2026-10-04T09:09:56.260Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8076-a4e4-f1f7e5f2c8d5"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-800f-bdde-d0547bf2b803",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-808b-960e-dd66e338f34e"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757240997/uxcomic-imgs/2675d164-78d8-800f-bdde-d0547bf2b803.png",
                "expiry_time": "2026-10-04T09:09:56.260Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-800f-bdde-d0547bf2b803"
          }
        ]
      },
      {
        "object": "block",
        "id": "2675d164-78d8-808b-aab0-c83ee0cf531f",
        "parent": {
          "type": "page_id",
          "page_id": "2575d164-78d8-80c3-bb1e-dfb915676d98"
        },
        "created_time": "2025-09-07T10:25:00.000Z",
        "last_edited_time": "2025-09-07T10:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2675d164-78d8-8061-918d-d5a871b441ce",
        "parent": {
          "type": "page_id",
          "page_id": "2575d164-78d8-80c3-bb1e-dfb915676d98"
        },
        "created_time": "2025-09-07T10:25:00.000Z",
        "last_edited_time": "2025-09-07T10:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2675d164-78d8-8015-887e-c4d36fee90a6",
        "parent": {
          "type": "page_id",
          "page_id": "2575d164-78d8-80c3-bb1e-dfb915676d98"
        },
        "created_time": "2025-09-07T10:25:00.000Z",
        "last_edited_time": "2025-09-07T10:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Post-design",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Post-design",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "2675d164-78d8-80ce-8d2f-edffb7a961f6",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8015-887e-c4d36fee90a6"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757240999/uxcomic-imgs/2675d164-78d8-80ce-8d2f-edffb7a961f6.png",
                "expiry_time": "2026-10-04T09:10:01.108Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-80ce-8d2f-edffb7a961f6"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8029-b331-f76d0fd0e339",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8015-887e-c4d36fee90a6"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241000/uxcomic-imgs/2675d164-78d8-8029-b331-f76d0fd0e339.png",
                "expiry_time": "2026-10-04T09:10:01.108Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8029-b331-f76d0fd0e339"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8041-8ded-fa478ccb55f2",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8015-887e-c4d36fee90a6"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241001/uxcomic-imgs/2675d164-78d8-8041-8ded-fa478ccb55f2.png",
                "expiry_time": "2026-10-04T09:10:01.108Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8041-8ded-fa478ccb55f2"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-804f-b5eb-e5332d49c9ff",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8015-887e-c4d36fee90a6"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241002/uxcomic-imgs/2675d164-78d8-804f-b5eb-e5332d49c9ff.png",
                "expiry_time": "2026-10-04T09:10:01.108Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-804f-b5eb-e5332d49c9ff"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8027-ac87-f0512111064c",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8015-887e-c4d36fee90a6"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241002/uxcomic-imgs/2675d164-78d8-8027-ac87-f0512111064c.png",
                "expiry_time": "2026-10-04T09:10:01.108Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8027-ac87-f0512111064c"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8052-a314-dbddfb6466ac",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8015-887e-c4d36fee90a6"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241004/uxcomic-imgs/2675d164-78d8-8052-a314-dbddfb6466ac.png",
                "expiry_time": "2026-10-04T09:10:01.108Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8052-a314-dbddfb6466ac"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-80f2-b3c3-e42147f6716d",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8015-887e-c4d36fee90a6"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241005/uxcomic-imgs/2675d164-78d8-80f2-b3c3-e42147f6716d.png",
                "expiry_time": "2026-10-04T09:10:01.108Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-80f2-b3c3-e42147f6716d"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8097-bb4d-ea78feef3491",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8015-887e-c4d36fee90a6"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241006/uxcomic-imgs/2675d164-78d8-8097-bb4d-ea78feef3491.png",
                "expiry_time": "2026-10-04T09:10:01.108Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8097-bb4d-ea78feef3491"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8075-a96e-ccefdaadd971",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8015-887e-c4d36fee90a6"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241007/uxcomic-imgs/2675d164-78d8-8075-a96e-ccefdaadd971.png",
                "expiry_time": "2026-10-04T09:10:01.109Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8075-a96e-ccefdaadd971"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-80b2-a21a-fdcfe6919019",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8015-887e-c4d36fee90a6"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241008/uxcomic-imgs/2675d164-78d8-80b2-a21a-fdcfe6919019.png",
                "expiry_time": "2026-10-04T09:10:01.109Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-80b2-a21a-fdcfe6919019"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8013-b928-d02ab5a533d0",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8015-887e-c4d36fee90a6"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241009/uxcomic-imgs/2675d164-78d8-8013-b928-d02ab5a533d0.png",
                "expiry_time": "2026-10-04T09:10:01.109Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8013-b928-d02ab5a533d0"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8003-8ddf-ecbe6247eda8",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8015-887e-c4d36fee90a6"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241010/uxcomic-imgs/2675d164-78d8-8003-8ddf-ecbe6247eda8.png",
                "expiry_time": "2026-10-04T09:10:01.109Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8003-8ddf-ecbe6247eda8"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-807d-bcd9-dcd00857492a",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8015-887e-c4d36fee90a6"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241011/uxcomic-imgs/2675d164-78d8-807d-bcd9-dcd00857492a.png",
                "expiry_time": "2026-10-04T09:10:01.109Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-807d-bcd9-dcd00857492a"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-80e0-9962-d9605b16292d",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8015-887e-c4d36fee90a6"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241012/uxcomic-imgs/2675d164-78d8-80e0-9962-d9605b16292d.png",
                "expiry_time": "2026-10-04T09:10:01.109Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-80e0-9962-d9605b16292d"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8098-94a2-fb6ffadf47d1",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8015-887e-c4d36fee90a6"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241013/uxcomic-imgs/2675d164-78d8-8098-94a2-fb6ffadf47d1.png",
                "expiry_time": "2026-10-04T09:10:01.109Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8098-94a2-fb6ffadf47d1"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-80bc-8706-fec06a56f1c7",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8015-887e-c4d36fee90a6"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241014/uxcomic-imgs/2675d164-78d8-80bc-8706-fec06a56f1c7.png",
                "expiry_time": "2026-10-04T09:10:01.109Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-80bc-8706-fec06a56f1c7"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8088-a670-eebb7ffd185c",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8015-887e-c4d36fee90a6"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241015/uxcomic-imgs/2675d164-78d8-8088-a670-eebb7ffd185c.png",
                "expiry_time": "2026-10-04T09:10:01.109Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8088-a670-eebb7ffd185c"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8012-8cb6-c49174b8b663",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8015-887e-c4d36fee90a6"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241016/uxcomic-imgs/2675d164-78d8-8012-8cb6-c49174b8b663.png",
                "expiry_time": "2026-10-04T09:10:01.109Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8012-8cb6-c49174b8b663"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8066-a053-e81742f1bad4",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8015-887e-c4d36fee90a6"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241017/uxcomic-imgs/2675d164-78d8-8066-a053-e81742f1bad4.png",
                "expiry_time": "2026-10-04T09:10:01.109Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8066-a053-e81742f1bad4"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-808a-ad75-d9a6cd92768d",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8015-887e-c4d36fee90a6"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241018/uxcomic-imgs/2675d164-78d8-808a-ad75-d9a6cd92768d.png",
                "expiry_time": "2026-10-04T09:10:01.109Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-808a-ad75-d9a6cd92768d"
          }
        ]
      },
      {
        "object": "block",
        "id": "2675d164-78d8-80e5-9591-e9e4c2bf9eb1",
        "parent": {
          "type": "page_id",
          "page_id": "2575d164-78d8-80c3-bb1e-dfb915676d98"
        },
        "created_time": "2025-09-07T10:25:00.000Z",
        "last_edited_time": "2025-09-07T10:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2675d164-78d8-8047-a02e-f0df9ed68331",
        "parent": {
          "type": "page_id",
          "page_id": "2575d164-78d8-80c3-bb1e-dfb915676d98"
        },
        "created_time": "2025-09-07T10:25:00.000Z",
        "last_edited_time": "2025-09-07T10:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2675d164-78d8-809b-99fa-dd074a8da7a7",
        "parent": {
          "type": "page_id",
          "page_id": "2575d164-78d8-80c3-bb1e-dfb915676d98"
        },
        "created_time": "2025-09-07T10:25:00.000Z",
        "last_edited_time": "2025-09-07T10:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Collab",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Collab",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "2675d164-78d8-80d8-86bf-cc1e5c70f744",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809b-99fa-dd074a8da7a7"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241019/uxcomic-imgs/2675d164-78d8-80d8-86bf-cc1e5c70f744.png",
                "expiry_time": "2026-10-04T09:10:05.568Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-80d8-86bf-cc1e5c70f744"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8056-9cf4-d0720577bb7b",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809b-99fa-dd074a8da7a7"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241020/uxcomic-imgs/2675d164-78d8-8056-9cf4-d0720577bb7b.png",
                "expiry_time": "2026-10-04T09:10:05.568Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8056-9cf4-d0720577bb7b"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8072-8d57-e1d649a3ef94",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809b-99fa-dd074a8da7a7"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241021/uxcomic-imgs/2675d164-78d8-8072-8d57-e1d649a3ef94.png",
                "expiry_time": "2026-10-04T09:10:05.568Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8072-8d57-e1d649a3ef94"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-80ea-aa29-cf32c2b3cc36",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809b-99fa-dd074a8da7a7"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241022/uxcomic-imgs/2675d164-78d8-80ea-aa29-cf32c2b3cc36.png",
                "expiry_time": "2026-10-04T09:10:05.568Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-80ea-aa29-cf32c2b3cc36"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-805f-ba49-f45b3035951e",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809b-99fa-dd074a8da7a7"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241023/uxcomic-imgs/2675d164-78d8-805f-ba49-f45b3035951e.png",
                "expiry_time": "2026-10-04T09:10:05.569Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-805f-ba49-f45b3035951e"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8073-bf14-c2f0c6830947",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809b-99fa-dd074a8da7a7"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241024/uxcomic-imgs/2675d164-78d8-8073-bf14-c2f0c6830947.png",
                "expiry_time": "2026-10-04T09:10:05.569Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8073-bf14-c2f0c6830947"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8033-830a-c3617b36adc6",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809b-99fa-dd074a8da7a7"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241025/uxcomic-imgs/2675d164-78d8-8033-830a-c3617b36adc6.png",
                "expiry_time": "2026-10-04T09:10:05.569Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8033-830a-c3617b36adc6"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-80ab-bc0a-df677259d14e",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809b-99fa-dd074a8da7a7"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241026/uxcomic-imgs/2675d164-78d8-80ab-bc0a-df677259d14e.png",
                "expiry_time": "2026-10-04T09:10:05.569Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-80ab-bc0a-df677259d14e"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-804d-baa4-f0fc3f99412d",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809b-99fa-dd074a8da7a7"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241028/uxcomic-imgs/2675d164-78d8-804d-baa4-f0fc3f99412d.png",
                "expiry_time": "2026-10-04T09:10:05.569Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-804d-baa4-f0fc3f99412d"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-80db-b57b-c38c3479c53b",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809b-99fa-dd074a8da7a7"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241029/uxcomic-imgs/2675d164-78d8-80db-b57b-c38c3479c53b.png",
                "expiry_time": "2026-10-04T09:10:05.569Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-80db-b57b-c38c3479c53b"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8061-8872-d08b4a2d3a40",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809b-99fa-dd074a8da7a7"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241030/uxcomic-imgs/2675d164-78d8-8061-8872-d08b4a2d3a40.png",
                "expiry_time": "2026-10-04T09:10:05.569Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8061-8872-d08b4a2d3a40"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8036-8713-ffe12d524be1",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809b-99fa-dd074a8da7a7"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241031/uxcomic-imgs/2675d164-78d8-8036-8713-ffe12d524be1.png",
                "expiry_time": "2026-10-04T09:10:05.569Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8036-8713-ffe12d524be1"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8027-8a13-fe8eecfea331",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809b-99fa-dd074a8da7a7"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241032/uxcomic-imgs/2675d164-78d8-8027-8a13-fe8eecfea331.png",
                "expiry_time": "2026-10-04T09:10:05.569Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8027-8a13-fe8eecfea331"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-80e9-b172-da963c6e075c",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809b-99fa-dd074a8da7a7"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241033/uxcomic-imgs/2675d164-78d8-80e9-b172-da963c6e075c.png",
                "expiry_time": "2026-10-04T09:10:05.569Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-80e9-b172-da963c6e075c"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8083-857f-e3d085134b08",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809b-99fa-dd074a8da7a7"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241034/uxcomic-imgs/2675d164-78d8-8083-857f-e3d085134b08.png",
                "expiry_time": "2026-10-04T09:10:05.569Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8083-857f-e3d085134b08"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-80bd-9583-f052e9a59c53",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809b-99fa-dd074a8da7a7"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241035/uxcomic-imgs/2675d164-78d8-80bd-9583-f052e9a59c53.png",
                "expiry_time": "2026-10-04T09:10:05.569Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-80bd-9583-f052e9a59c53"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8063-8675-fcf19a62bc0d",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809b-99fa-dd074a8da7a7"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241036/uxcomic-imgs/2675d164-78d8-8063-8675-fcf19a62bc0d.png",
                "expiry_time": "2026-10-04T09:10:05.569Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8063-8675-fcf19a62bc0d"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-80c4-9b73-e92d230275b5",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809b-99fa-dd074a8da7a7"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241037/uxcomic-imgs/2675d164-78d8-80c4-9b73-e92d230275b5.png",
                "expiry_time": "2026-10-04T09:10:05.569Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-80c4-9b73-e92d230275b5"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-80d4-aecb-f6b9f92ee7a5",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809b-99fa-dd074a8da7a7"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241038/uxcomic-imgs/2675d164-78d8-80d4-aecb-f6b9f92ee7a5.png",
                "expiry_time": "2026-10-04T09:10:05.569Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-80d4-aecb-f6b9f92ee7a5"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8002-9381-dad808e85ce4",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-809b-99fa-dd074a8da7a7"
            },
            "created_time": "2025-09-07T10:26:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241039/uxcomic-imgs/2675d164-78d8-8002-9381-dad808e85ce4.png",
                "expiry_time": "2026-10-04T09:10:05.569Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8002-9381-dad808e85ce4"
          }
        ]
      },
      {
        "object": "block",
        "id": "2675d164-78d8-809b-b8e3-e8c76a4d78f8",
        "parent": {
          "type": "page_id",
          "page_id": "2575d164-78d8-80c3-bb1e-dfb915676d98"
        },
        "created_time": "2025-09-07T10:25:00.000Z",
        "last_edited_time": "2025-09-07T10:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2675d164-78d8-80f1-b960-df0d49939d62",
        "parent": {
          "type": "page_id",
          "page_id": "2575d164-78d8-80c3-bb1e-dfb915676d98"
        },
        "created_time": "2025-09-07T10:25:00.000Z",
        "last_edited_time": "2025-09-07T10:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2675d164-78d8-8000-90ff-dd76375ea847",
        "parent": {
          "type": "page_id",
          "page_id": "2575d164-78d8-80c3-bb1e-dfb915676d98"
        },
        "created_time": "2025-09-07T10:25:00.000Z",
        "last_edited_time": "2025-09-07T10:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ops",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ops",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "2675d164-78d8-808b-bfe8-c3c37939b4ef",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8000-90ff-dd76375ea847"
            },
            "created_time": "2025-09-07T10:27:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241041/uxcomic-imgs/2675d164-78d8-808b-bfe8-c3c37939b4ef.png",
                "expiry_time": "2026-10-04T09:10:09.788Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-808b-bfe8-c3c37939b4ef"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-80be-ade3-c75c7f2d2df4",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8000-90ff-dd76375ea847"
            },
            "created_time": "2025-09-07T10:27:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241042/uxcomic-imgs/2675d164-78d8-80be-ade3-c75c7f2d2df4.png",
                "expiry_time": "2026-10-04T09:10:09.788Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-80be-ade3-c75c7f2d2df4"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8061-876a-c8ea373835e4",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8000-90ff-dd76375ea847"
            },
            "created_time": "2025-09-07T10:27:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241043/uxcomic-imgs/2675d164-78d8-8061-876a-c8ea373835e4.png",
                "expiry_time": "2026-10-04T09:10:09.788Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8061-876a-c8ea373835e4"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-80fc-a98c-c0c740494c9d",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8000-90ff-dd76375ea847"
            },
            "created_time": "2025-09-07T10:27:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241044/uxcomic-imgs/2675d164-78d8-80fc-a98c-c0c740494c9d.png",
                "expiry_time": "2026-10-04T09:10:09.788Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-80fc-a98c-c0c740494c9d"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-80a5-80a7-f2994c97ec12",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8000-90ff-dd76375ea847"
            },
            "created_time": "2025-09-07T10:27:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241045/uxcomic-imgs/2675d164-78d8-80a5-80a7-f2994c97ec12.png",
                "expiry_time": "2026-10-04T09:10:09.788Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-80a5-80a7-f2994c97ec12"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8022-ad58-c6232a23a801",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8000-90ff-dd76375ea847"
            },
            "created_time": "2025-09-07T10:27:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241046/uxcomic-imgs/2675d164-78d8-8022-ad58-c6232a23a801.png",
                "expiry_time": "2026-10-04T09:10:09.788Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8022-ad58-c6232a23a801"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-80ac-83b6-ffece0cd544a",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8000-90ff-dd76375ea847"
            },
            "created_time": "2025-09-07T10:27:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241047/uxcomic-imgs/2675d164-78d8-80ac-83b6-ffece0cd544a.png",
                "expiry_time": "2026-10-04T09:10:09.788Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-80ac-83b6-ffece0cd544a"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8097-b2f6-e21ff83686c3",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8000-90ff-dd76375ea847"
            },
            "created_time": "2025-09-07T10:27:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241048/uxcomic-imgs/2675d164-78d8-8097-b2f6-e21ff83686c3.png",
                "expiry_time": "2026-10-04T09:10:09.788Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8097-b2f6-e21ff83686c3"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8083-be91-df8489d96ab2",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8000-90ff-dd76375ea847"
            },
            "created_time": "2025-09-07T10:27:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241049/uxcomic-imgs/2675d164-78d8-8083-be91-df8489d96ab2.png",
                "expiry_time": "2026-10-04T09:10:09.788Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8083-be91-df8489d96ab2"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8042-ba1b-e5f76123e1e8",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8000-90ff-dd76375ea847"
            },
            "created_time": "2025-09-07T10:27:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241050/uxcomic-imgs/2675d164-78d8-8042-ba1b-e5f76123e1e8.png",
                "expiry_time": "2026-10-04T09:10:09.788Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8042-ba1b-e5f76123e1e8"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8004-b81e-cd6c8d384ecb",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8000-90ff-dd76375ea847"
            },
            "created_time": "2025-09-07T10:27:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241051/uxcomic-imgs/2675d164-78d8-8004-b81e-cd6c8d384ecb.png",
                "expiry_time": "2026-10-04T09:10:09.788Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8004-b81e-cd6c8d384ecb"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-80ab-a827-ffda98b8d02c",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8000-90ff-dd76375ea847"
            },
            "created_time": "2025-09-07T10:27:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241053/uxcomic-imgs/2675d164-78d8-80ab-a827-ffda98b8d02c.png",
                "expiry_time": "2026-10-04T09:10:09.788Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-80ab-a827-ffda98b8d02c"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-805b-bc0d-ca6014661e16",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8000-90ff-dd76375ea847"
            },
            "created_time": "2025-09-07T10:27:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241054/uxcomic-imgs/2675d164-78d8-805b-bc0d-ca6014661e16.png",
                "expiry_time": "2026-10-04T09:10:09.788Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-805b-bc0d-ca6014661e16"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8002-87b0-ca5a91511075",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8000-90ff-dd76375ea847"
            },
            "created_time": "2025-09-07T10:27:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241055/uxcomic-imgs/2675d164-78d8-8002-87b0-ca5a91511075.png",
                "expiry_time": "2026-10-04T09:10:09.789Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8002-87b0-ca5a91511075"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8080-8c69-dbb5ebb2f75d",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8000-90ff-dd76375ea847"
            },
            "created_time": "2025-09-07T10:27:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241056/uxcomic-imgs/2675d164-78d8-8080-8c69-dbb5ebb2f75d.png",
                "expiry_time": "2026-10-04T09:10:09.789Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8080-8c69-dbb5ebb2f75d"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8073-8811-fa8345e4efb7",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8000-90ff-dd76375ea847"
            },
            "created_time": "2025-09-07T10:27:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241057/uxcomic-imgs/2675d164-78d8-8073-8811-fa8345e4efb7.png",
                "expiry_time": "2026-10-04T09:10:09.789Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8073-8811-fa8345e4efb7"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-800b-b772-f2797481805d",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8000-90ff-dd76375ea847"
            },
            "created_time": "2025-09-07T10:27:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241058/uxcomic-imgs/2675d164-78d8-800b-b772-f2797481805d.png",
                "expiry_time": "2026-10-04T09:10:09.789Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-800b-b772-f2797481805d"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-8091-95d1-ef072247854e",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8000-90ff-dd76375ea847"
            },
            "created_time": "2025-09-07T10:27:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241059/uxcomic-imgs/2675d164-78d8-8091-95d1-ef072247854e.png",
                "expiry_time": "2026-10-04T09:10:09.789Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-8091-95d1-ef072247854e"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-800d-98dc-dd1649e6ba75",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8000-90ff-dd76375ea847"
            },
            "created_time": "2025-09-07T10:27:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241060/uxcomic-imgs/2675d164-78d8-800d-98dc-dd1649e6ba75.png",
                "expiry_time": "2026-10-04T09:10:09.789Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-800d-98dc-dd1649e6ba75"
          },
          {
            "object": "block",
            "id": "2675d164-78d8-804b-9166-d31b85456b85",
            "parent": {
              "type": "block_id",
              "block_id": "2675d164-78d8-8000-90ff-dd76375ea847"
            },
            "created_time": "2025-09-07T10:27:00.000Z",
            "last_edited_time": "2025-09-07T10:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1757241061/uxcomic-imgs/2675d164-78d8-804b-9166-d31b85456b85.png",
                "expiry_time": "2026-10-04T09:10:09.789Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2675d164-78d8-804b-9166-d31b85456b85"
          }
        ]
      },
      {
        "object": "block",
        "id": "2675d164-78d8-80c5-9559-dbfdcff26f1a",
        "parent": {
          "type": "page_id",
          "page_id": "2575d164-78d8-80c3-bb1e-dfb915676d98"
        },
        "created_time": "2025-09-07T10:27:00.000Z",
        "last_edited_time": "2025-09-07T10:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "2565d164-78d8-809c-93b9-c083cb7ce87d",
    "created_time": "2025-08-21T01:07:00.000Z",
    "last_edited_time": "2025-08-22T01:31:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2025-08-21T01:07:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 44
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "3-Other",
          "color": "purple"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-22T01:31:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "cZzk",
          "name": "⚔️:3",
          "color": "orange"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Terms “hơi thở” của PO-PM, UX Designer, Dev",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Terms “hơi thở” của PO-PM, UX Designer, Dev",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Terms-h-i-th-c-a-PO-PM-UX-Designer-Dev-2565d16478d8809c93b9c083cb7ce87d",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
      "name": "Other",
      "slug": "other",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "2565d164-78d8-8070-86df-c497c4e13093",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-21T04:53:00.000Z",
        "last_edited_time": "2025-08-21T04:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755752122/uxcomic-imgs/2565d164-78d8-8070-86df-c497c4e13093.png",
            "expiry_time": "2026-10-04T09:10:14.852Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2565d164-78d8-8070-86df-c497c4e13093"
      },
      {
        "object": "block",
        "id": "2565d164-78d8-8090-83f7-dd59e16d1b22",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-21T01:08:00.000Z",
        "last_edited_time": "2025-08-21T10:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Term - thuật ngữ là các từ chuyên môn, mình hay nghe bảo là tránh dùng nhiều khi trao đổi, vì nó khiến câu chuyện trở nên phức tạp, nhưng mình không đồng ý hoàn toàn, ngược lại thì mình thấy trong công việc lại sử dụng nó với tần suất cao, vì sao? Vì trong mỗi term hàm chứa trong nó một lượng thông tin phong phú hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Term - thuật ngữ là các từ chuyên môn, mình hay nghe bảo là tránh dùng nhiều khi trao đổi, vì nó khiến câu chuyện trở nên phức tạp, nhưng mình không đồng ý hoàn toàn, ngược lại thì mình thấy trong công việc lại sử dụng nó với tần suất cao, vì sao? Vì trong mỗi term hàm chứa trong nó một lượng thông tin phong phú hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2565d164-78d8-80e8-87d5-d104b653acdc",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-21T01:17:00.000Z",
        "last_edited_time": "2025-08-21T01:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2565d164-78d8-806b-b05c-ff6bc91f53c8",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-21T01:10:00.000Z",
        "last_edited_time": "2025-08-21T10:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau khi xem phim Demon Slayer, trong đầu mình chợt loé lên những “hơi thở” chiêu thức của các trụ cột PO, Designer, Dev 🤣. Nên bài này mình list ra sơ các term mà trụ cột hay xài, mong là bài này vui vui nhưng cũng giúp cho mọi người có được vài hint để tìm hiểu thêm một chút về scope & responsibility, cũng như các mối bận tâm của họ trong công việc product development → Am hiểu các term này một phần sẽ giúp quá trình collaboration, trao đổi mượt mà hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau khi xem phim Demon Slayer, trong đầu mình chợt loé lên những “hơi thở” chiêu thức của các trụ cột PO, Designer, Dev 🤣. Nên bài này mình list ra sơ các term mà trụ cột hay xài, mong là bài này vui vui nhưng cũng giúp cho mọi người có được vài hint để tìm hiểu thêm một chút về scope & responsibility, cũng như các mối bận tâm của họ trong công việc product development → Am hiểu các term này một phần sẽ giúp quá trình collaboration, trao đổi mượt mà hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2565d164-78d8-8096-aad5-e874424b1672",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-21T01:13:00.000Z",
        "last_edited_time": "2025-08-21T10:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nào xem qua các “hơi thở” của các trụ cột PO/PM, Designer, Dev nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nào xem qua các “hơi thở” của các trụ cột PO/PM, Designer, Dev nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2565d164-78d8-80e5-8052-e36fbe26edc3",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-21T01:14:00.000Z",
        "last_edited_time": "2025-08-21T01:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2565d164-78d8-807c-8209-de7390d812d6",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-21T01:14:00.000Z",
        "last_edited_time": "2025-08-21T03:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hơi thở🌪️ 🌊⛰️",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hơi thở🌪️ 🌊⛰️",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2565d164-78d8-8076-b26d-dc91a4dffa8d",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-21T01:56:00.000Z",
        "last_edited_time": "2025-08-21T10:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "List",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "List",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "2565d164-78d8-801c-8c11-dd3285788081",
            "parent": {
              "type": "block_id",
              "block_id": "2565d164-78d8-8076-b26d-dc91a4dffa8d"
            },
            "created_time": "2025-08-21T10:29:00.000Z",
            "last_edited_time": "2025-08-21T10:30:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755772300/uxcomic-imgs/2565d164-78d8-801c-8c11-dd3285788081.png",
                "expiry_time": "2026-10-04T09:10:15.798Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2565d164-78d8-801c-8c11-dd3285788081"
          },
          {
            "object": "block",
            "id": "2565d164-78d8-8088-9510-cb1c8eead540",
            "parent": {
              "type": "block_id",
              "block_id": "2565d164-78d8-8076-b26d-dc91a4dffa8d"
            },
            "created_time": "2025-08-21T10:29:00.000Z",
            "last_edited_time": "2025-08-21T10:30:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755772301/uxcomic-imgs/2565d164-78d8-8088-9510-cb1c8eead540.png",
                "expiry_time": "2026-10-04T09:10:15.798Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2565d164-78d8-8088-9510-cb1c8eead540"
          },
          {
            "object": "block",
            "id": "2565d164-78d8-8074-becb-ce4ddbe7a0a8",
            "parent": {
              "type": "block_id",
              "block_id": "2565d164-78d8-8076-b26d-dc91a4dffa8d"
            },
            "created_time": "2025-08-21T10:29:00.000Z",
            "last_edited_time": "2025-08-21T10:30:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755772302/uxcomic-imgs/2565d164-78d8-8074-becb-ce4ddbe7a0a8.png",
                "expiry_time": "2026-10-04T09:10:15.798Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2565d164-78d8-8074-becb-ce4ddbe7a0a8"
          },
          {
            "object": "block",
            "id": "2565d164-78d8-806c-a09f-d335ddd9f8b3",
            "parent": {
              "type": "block_id",
              "block_id": "2565d164-78d8-8076-b26d-dc91a4dffa8d"
            },
            "created_time": "2025-08-21T10:29:00.000Z",
            "last_edited_time": "2025-08-21T10:30:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755772304/uxcomic-imgs/2565d164-78d8-806c-a09f-d335ddd9f8b3.png",
                "expiry_time": "2026-10-04T09:10:15.798Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2565d164-78d8-806c-a09f-d335ddd9f8b3"
          },
          {
            "object": "block",
            "id": "2565d164-78d8-801a-9a49-f2e8788aa82d",
            "parent": {
              "type": "block_id",
              "block_id": "2565d164-78d8-8076-b26d-dc91a4dffa8d"
            },
            "created_time": "2025-08-21T10:29:00.000Z",
            "last_edited_time": "2025-08-21T10:30:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755772304/uxcomic-imgs/2565d164-78d8-801a-9a49-f2e8788aa82d.png",
                "expiry_time": "2026-10-04T09:10:15.798Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2565d164-78d8-801a-9a49-f2e8788aa82d"
          },
          {
            "object": "block",
            "id": "2565d164-78d8-8021-ae8c-d72cf6b60ab0",
            "parent": {
              "type": "block_id",
              "block_id": "2565d164-78d8-8076-b26d-dc91a4dffa8d"
            },
            "created_time": "2025-08-21T10:29:00.000Z",
            "last_edited_time": "2025-08-21T10:30:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755772306/uxcomic-imgs/2565d164-78d8-8021-ae8c-d72cf6b60ab0.png",
                "expiry_time": "2026-10-04T09:10:15.798Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2565d164-78d8-8021-ae8c-d72cf6b60ab0"
          },
          {
            "object": "block",
            "id": "2565d164-78d8-8014-bc1b-ff708ad76cab",
            "parent": {
              "type": "block_id",
              "block_id": "2565d164-78d8-8076-b26d-dc91a4dffa8d"
            },
            "created_time": "2025-08-21T10:29:00.000Z",
            "last_edited_time": "2025-08-21T10:30:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755772307/uxcomic-imgs/2565d164-78d8-8014-bc1b-ff708ad76cab.png",
                "expiry_time": "2026-10-04T09:10:15.798Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2565d164-78d8-8014-bc1b-ff708ad76cab"
          },
          {
            "object": "block",
            "id": "2565d164-78d8-80a2-92a6-c6705f64d23b",
            "parent": {
              "type": "block_id",
              "block_id": "2565d164-78d8-8076-b26d-dc91a4dffa8d"
            },
            "created_time": "2025-08-21T10:29:00.000Z",
            "last_edited_time": "2025-08-21T10:30:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755772309/uxcomic-imgs/2565d164-78d8-80a2-92a6-c6705f64d23b.png",
                "expiry_time": "2026-10-04T09:10:15.798Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2565d164-78d8-80a2-92a6-c6705f64d23b"
          }
        ]
      },
      {
        "object": "block",
        "id": "2565d164-78d8-803d-97fa-fa843b1e9456",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-21T01:56:00.000Z",
        "last_edited_time": "2025-08-21T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2565d164-78d8-80b7-9714-cfcde6c2c553",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-21T01:56:00.000Z",
        "last_edited_time": "2025-08-21T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Disclaimer",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Disclaimer",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2565d164-78d8-8090-9db3-e5fa45a8a0b8",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-21T01:56:00.000Z",
        "last_edited_time": "2025-08-22T01:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình dựa theo quan sát cá nhân cũng như có hỏi GPT để lên danh sách các từ này, nên chắc chắn là không đầy đủ, again đây cũng ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình dựa theo quan sát cá nhân cũng như có hỏi GPT để lên danh sách các từ này, nên chắc chắn là không đầy đủ, again đây cũng ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cho vui là chính",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cho vui là chính",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", có gì mọi người thông cảm nhe :))",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", có gì mọi người thông cảm nhe :))",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2565d164-78d8-8070-baa2-e44998bb716c",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-21T02:59:00.000Z",
        "last_edited_time": "2025-08-21T10:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "P/s: hình gen bằng AI - ChatGPT",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "P/s: hình gen bằng AI - ChatGPT",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2565d164-78d8-803e-92c7-f452e4ff6a24",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-21T10:30:00.000Z",
        "last_edited_time": "2025-08-21T10:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755772294/uxcomic-imgs/2565d164-78d8-803e-92c7-f452e4ff6a24.png",
            "expiry_time": "2026-10-04T09:10:14.853Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2565d164-78d8-803e-92c7-f452e4ff6a24"
      },
      {
        "object": "block",
        "id": "2565d164-78d8-80be-ae94-d55eb67a050c",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-21T10:30:00.000Z",
        "last_edited_time": "2025-08-21T10:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thấy hài hài có thể share chơi cho các stakeholders nhé",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thấy hài hài có thể share chơi cho các stakeholders nhé",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "🫣"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2565d164-78d8-8000-a125-fdd623e75273",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-21T01:58:00.000Z",
        "last_edited_time": "2025-08-21T03:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2575d164-78d8-8002-a7d0-c8366d473193",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-22T01:26:00.000Z",
        "last_edited_time": "2025-08-22T01:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2575d164-78d8-803a-8b9a-f47fda0fea3c",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-22T01:26:00.000Z",
        "last_edited_time": "2025-08-22T01:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cuốn sách này cũng khá hay nếu bạn muốn nắm thêm các activities của stakeholder nè.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cuốn sách này cũng khá hay nếu bạn muốn nắm thêm các activities của stakeholder nè.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2575d164-78d8-8012-af41-d9e2162cbae8",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-22T01:31:00.000Z",
        "last_edited_time": "2025-08-22T01:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755826371/uxcomic-imgs/2575d164-78d8-8012-af41-d9e2162cbae8.jpg",
            "expiry_time": "2026-10-04T09:10:14.853Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2575d164-78d8-8012-af41-d9e2162cbae8"
      },
      {
        "object": "block",
        "id": "2575d164-78d8-8050-b771-ef0881bd55cb",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-22T01:26:00.000Z",
        "last_edited_time": "2025-08-22T01:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2565d164-78d8-80a6-9eee-d6cfca4922e3",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-21T03:15:00.000Z",
        "last_edited_time": "2025-08-21T03:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2565d164-78d8-803f-844b-fe05b876a595",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-21T03:15:00.000Z",
        "last_edited_time": "2025-08-21T03:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1445d164-78d8-805b-b388-e24b5f13cccb"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product development process (overall)",
              "href": "https://app.notion.com/p/1445d16478d8805bb388e24b5f13cccb"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2565d164-78d8-80cb-874e-cfb3b72ff4c7",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-21T03:15:00.000Z",
        "last_edited_time": "2025-08-21T03:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1025d164-78d8-80c5-891f-debd0fc09547"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product development process (detail)",
              "href": "https://app.notion.com/p/1025d16478d880c5891fdebd0fc09547"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2575d164-78d8-8040-ad7b-f65a448cfd2c",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-22T01:31:00.000Z",
        "last_edited_time": "2025-08-22T01:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX as a Cupid",
              "href": "https://app.notion.com/p/10f5d16478d8808484a5d6eff66f3eec"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2565d164-78d8-8093-b985-c28dc1f42b77",
        "parent": {
          "type": "page_id",
          "page_id": "2565d164-78d8-809c-93b9-c083cb7ce87d"
        },
        "created_time": "2025-08-21T03:15:00.000Z",
        "last_edited_time": "2025-08-21T03:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Design value",
              "href": "https://app.notion.com/p/ed40fd40a3184fd6a63f0067b4e54861"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "24c5d164-78d8-807b-a2d4-e8e4318bbe1e",
    "created_time": "2025-08-11T11:39:00.000Z",
    "last_edited_time": "2025-08-15T16:30:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2025-08-11T11:39:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 42
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "1-Design",
          "color": "default"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-15T16:30:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "qO=g",
          "name": "♟️:1",
          "color": "pink"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "UX-UI Mindmap",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "UX-UI Mindmap",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/UX-UI-Mindmap-24c5d16478d8807ba2d4e8e4318bbe1e",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Design",
      "slug": "design",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "2505d164-78d8-807b-9b54-d94c33c6ed12",
        "parent": {
          "type": "page_id",
          "page_id": "24c5d164-78d8-807b-a2d4-e8e4318bbe1e"
        },
        "created_time": "2025-08-15T11:05:00.000Z",
        "last_edited_time": "2025-08-15T11:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755257036/uxcomic-imgs/2505d164-78d8-807b-9b54-d94c33c6ed12.png",
            "expiry_time": "2026-10-04T09:10:17.759Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2505d164-78d8-807b-9b54-d94c33c6ed12"
      },
      {
        "object": "block",
        "id": "2505d164-78d8-8070-bd61-e004e126de5b",
        "parent": {
          "type": "page_id",
          "page_id": "24c5d164-78d8-807b-a2d4-e8e4318bbe1e"
        },
        "created_time": "2025-08-15T11:05:00.000Z",
        "last_edited_time": "2025-08-15T11:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình nghĩ cũng như mọi người, khi vừa bước chân vào nghề, câu hỏi mọi người hay hỏi nhất là: “Không biết bắt đầu từ đâu?”. Thật ra tới thời điểm hiện tại, đôi khi mình cũng rối rối với lượng keyword, lượng term quá nhiều trong quá trình mài dũa nghề. Nên sẵn tiện tổng hợp thành dạng mindmap này, mình nghĩ sẽ một phần giúp được cho các newbie.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình nghĩ cũng như mọi người, khi vừa bước chân vào nghề, câu hỏi mọi người hay hỏi nhất là: “Không biết bắt đầu từ đâu?”. Thật ra tới thời điểm hiện tại, đôi khi mình cũng rối rối với lượng keyword, lượng term quá nhiều trong quá trình mài dũa nghề. Nên sẵn tiện tổng hợp thành dạng mindmap này, mình nghĩ sẽ một phần giúp được cho các newbie.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2505d164-78d8-8099-b241-da1e76c17fed",
        "parent": {
          "type": "page_id",
          "page_id": "24c5d164-78d8-807b-a2d4-e8e4318bbe1e"
        },
        "created_time": "2025-08-15T11:11:00.000Z",
        "last_edited_time": "2025-08-15T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2505d164-78d8-8073-85d5-d151a213f292",
        "parent": {
          "type": "page_id",
          "page_id": "24c5d164-78d8-807b-a2d4-e8e4318bbe1e"
        },
        "created_time": "2025-08-15T11:10:00.000Z",
        "last_edited_time": "2025-08-15T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "UX/UI Mindmap",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX/UI Mindmap",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2505d164-78d8-80c3-8559-fda84939121d",
        "parent": {
          "type": "page_id",
          "page_id": "24c5d164-78d8-807b-a2d4-e8e4318bbe1e"
        },
        "created_time": "2025-08-15T11:05:00.000Z",
        "last_edited_time": "2025-08-15T11:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Xem trên desktop nhé mọi người do map khá to.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Xem trên desktop nhé mọi người do map khá to.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2505d164-78d8-8005-8387-cdd9eeb376bc",
        "parent": {
          "type": "page_id",
          "page_id": "24c5d164-78d8-807b-a2d4-e8e4318bbe1e"
        },
        "created_time": "2025-08-15T11:12:00.000Z",
        "last_edited_time": "2025-08-15T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.figma.com/board/MsLgJuVJCpzy8plzIeB2SH/UX-UI-design-mindmap?node-id=0-1&t=JnVmPx2z5tqIDuLf-1",
                "link": {
                  "url": "https://www.figma.com/board/MsLgJuVJCpzy8plzIeB2SH/UX-UI-design-mindmap?node-id=0-1&t=JnVmPx2z5tqIDuLf-1"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.figma.com/board/MsLgJuVJCpzy8plzIeB2SH/UX-UI-design-mindmap?node-id=0-1&t=JnVmPx2z5tqIDuLf-1",
              "href": "https://www.figma.com/board/MsLgJuVJCpzy8plzIeB2SH/UX-UI-design-mindmap?node-id=0-1&t=JnVmPx2z5tqIDuLf-1"
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "🗾"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2505d164-78d8-80fc-876b-ff92958fd98a",
        "parent": {
          "type": "page_id",
          "page_id": "24c5d164-78d8-807b-a2d4-e8e4318bbe1e"
        },
        "created_time": "2025-08-15T11:14:00.000Z",
        "last_edited_time": "2025-08-15T11:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755257038/uxcomic-imgs/2505d164-78d8-80fc-876b-ff92958fd98a.png",
            "expiry_time": "2026-10-04T09:10:17.759Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2505d164-78d8-80fc-876b-ff92958fd98a"
      },
      {
        "object": "block",
        "id": "2505d164-78d8-8090-a4fa-ee6fb3ab2df7",
        "parent": {
          "type": "page_id",
          "page_id": "24c5d164-78d8-807b-a2d4-e8e4318bbe1e"
        },
        "created_time": "2025-08-15T11:12:00.000Z",
        "last_edited_time": "2025-08-15T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2505d164-78d8-80c9-98dc-df1b73ea58e9",
        "parent": {
          "type": "page_id",
          "page_id": "24c5d164-78d8-807b-a2d4-e8e4318bbe1e"
        },
        "created_time": "2025-08-15T11:12:00.000Z",
        "last_edited_time": "2025-08-15T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2505d164-78d8-8014-9b03-d0522b030783",
        "parent": {
          "type": "page_id",
          "page_id": "24c5d164-78d8-807b-a2d4-e8e4318bbe1e"
        },
        "created_time": "2025-08-15T11:12:00.000Z",
        "last_edited_time": "2025-08-15T11:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình thấy quá trình tìm hiểu nó giống như một mạng lưới neuron vậy, khi tìm hiểu chủ đề A này, nó sẽ đẻ ra chủ đề B,C,D… và rồi tìm hiểu chủ đề B thì ra X,Y,Z, dần dần khối lượng này lớn dần lên, nên nếu có map, có mạch của chuỗi tìm hiểu ấy thì sẽ giúp mình dễ nắm được tổng quan hơn. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình thấy quá trình tìm hiểu nó giống như một mạng lưới neuron vậy, khi tìm hiểu chủ đề A này, nó sẽ đẻ ra chủ đề B,C,D… và rồi tìm hiểu chủ đề B thì ra X,Y,Z, dần dần khối lượng này lớn dần lên, nên nếu có map, có mạch của chuỗi tìm hiểu ấy thì sẽ giúp mình dễ nắm được tổng quan hơn. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2505d164-78d8-80f3-bb0f-c259f3308835",
        "parent": {
          "type": "page_id",
          "page_id": "24c5d164-78d8-807b-a2d4-e8e4318bbe1e"
        },
        "created_time": "2025-08-15T11:15:00.000Z",
        "last_edited_time": "2025-08-15T16:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755257039/uxcomic-imgs/2505d164-78d8-80f3-bb0f-c259f3308835.jpg",
            "expiry_time": "2026-10-04T09:10:17.759Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2505d164-78d8-80f3-bb0f-c259f3308835"
      },
      {
        "object": "block",
        "id": "2505d164-78d8-803f-b7fc-dac68645bb52",
        "parent": {
          "type": "page_id",
          "page_id": "24c5d164-78d8-807b-a2d4-e8e4318bbe1e"
        },
        "created_time": "2025-08-15T11:22:00.000Z",
        "last_edited_time": "2025-08-15T11:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kiên nhẫn, từ tốn tìm hiểu 1 by 1 thôi nhé 😀",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kiên nhẫn, từ tốn tìm hiểu 1 by 1 thôi nhé 😀",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "🗾"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2505d164-78d8-8074-8bba-e6f44a70a82f",
        "parent": {
          "type": "page_id",
          "page_id": "24c5d164-78d8-807b-a2d4-e8e4318bbe1e"
        },
        "created_time": "2025-08-15T11:05:00.000Z",
        "last_edited_time": "2025-08-15T11:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2505d164-78d8-804b-9a08-c49846a2c734",
        "parent": {
          "type": "page_id",
          "page_id": "24c5d164-78d8-807b-a2d4-e8e4318bbe1e"
        },
        "created_time": "2025-08-15T11:05:00.000Z",
        "last_edited_time": "2025-08-15T11:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2505d164-78d8-8014-b6b0-d1fed751b576",
        "parent": {
          "type": "page_id",
          "page_id": "24c5d164-78d8-807b-a2d4-e8e4318bbe1e"
        },
        "created_time": "2025-08-15T11:05:00.000Z",
        "last_edited_time": "2025-08-15T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Interaction",
              "href": "https://app.notion.com/p/10f5d16478d880509b0ce73068127ed4"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2505d164-78d8-8050-8758-c221d757082a",
        "parent": {
          "type": "page_id",
          "page_id": "24c5d164-78d8-807b-a2d4-e8e4318bbe1e"
        },
        "created_time": "2025-08-15T11:11:00.000Z",
        "last_edited_time": "2025-08-15T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Understand, Empathize user?",
              "href": "https://app.notion.com/p/32cbe568c34b4255a408f2a2e6227bb2"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2505d164-78d8-802a-b942-c57d187b6825",
        "parent": {
          "type": "page_id",
          "page_id": "24c5d164-78d8-807b-a2d4-e8e4318bbe1e"
        },
        "created_time": "2025-08-15T11:11:00.000Z",
        "last_edited_time": "2025-08-15T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User Journey map, User scenario, Task flow, User flow",
              "href": "https://app.notion.com/p/1155d16478d880a883a6ec9db47fe4dc"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2505d164-78d8-8077-9d22-f202a67c542d",
        "parent": {
          "type": "page_id",
          "page_id": "24c5d164-78d8-807b-a2d4-e8e4318bbe1e"
        },
        "created_time": "2025-08-15T11:05:00.000Z",
        "last_edited_time": "2025-08-15T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1445d164-78d8-805b-b388-e24b5f13cccb"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product development process (overall)",
              "href": "https://app.notion.com/p/1445d16478d8805bb388e24b5f13cccb"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2505d164-78d8-8024-9a12-eedbc02c5c4d",
        "parent": {
          "type": "page_id",
          "page_id": "24c5d164-78d8-807b-a2d4-e8e4318bbe1e"
        },
        "created_time": "2025-08-15T11:11:00.000Z",
        "last_edited_time": "2025-08-15T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1025d164-78d8-80c5-891f-debd0fc09547"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product development process (detail)",
              "href": "https://app.notion.com/p/1025d16478d880c5891fdebd0fc09547"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "2475d164-78d8-8075-8c4d-f915f369beb7",
    "created_time": "2025-08-06T02:14:00.000Z",
    "last_edited_time": "2025-08-23T01:57:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2025-08-06T02:14:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 41
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "1-Design",
          "color": "default"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-23T01:57:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "prxX",
          "name": "⚔️:2",
          "color": "yellow"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Cognitive load checklist",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Cognitive load checklist",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Cognitive-load-checklist-2475d16478d880758c4df915f369beb7",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Design",
      "slug": "design",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "2475d164-78d8-8073-92e8-dc121d828e65",
        "parent": {
          "type": "page_id",
          "page_id": "2475d164-78d8-8075-8c4d-f915f369beb7"
        },
        "created_time": "2025-08-06T02:14:00.000Z",
        "last_edited_time": "2025-08-07T01:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754529292/uxcomic-imgs/2475d164-78d8-8073-92e8-dc121d828e65.png",
            "expiry_time": "2026-10-04T09:10:18.649Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2475d164-78d8-8073-92e8-dc121d828e65"
      },
      {
        "object": "block",
        "id": "2475d164-78d8-80d7-86c8-feead1612f9b",
        "parent": {
          "type": "page_id",
          "page_id": "2475d164-78d8-8075-8c4d-f915f369beb7"
        },
        "created_time": "2025-08-06T02:14:00.000Z",
        "last_edited_time": "2025-08-07T01:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cognitive load là khái niệm nói về tổng mental effort để con người suy nghĩ (xử lý thông tin), là lượng thông tin cần phải xử lý để hiểu, để học, để nhớ, để làm gì đó tại một thời điểm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cognitive load là khái niệm nói về tổng mental effort để con người suy nghĩ (xử lý thông tin), là lượng thông tin cần phải xử lý để hiểu, để học, để nhớ, để làm gì đó tại một thời điểm.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2485d164-78d8-8095-a662-d23a3203b6ef",
        "parent": {
          "type": "page_id",
          "page_id": "2475d164-78d8-8075-8c4d-f915f369beb7"
        },
        "created_time": "2025-08-07T01:13:00.000Z",
        "last_edited_time": "2025-08-23T01:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "list",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "list",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "2485d164-78d8-80b4-8c62-c7f5f116b740",
            "parent": {
              "type": "block_id",
              "block_id": "2485d164-78d8-8095-a662-d23a3203b6ef"
            },
            "created_time": "2025-08-07T01:13:00.000Z",
            "last_edited_time": "2025-08-07T01:50:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754529294/uxcomic-imgs/2485d164-78d8-80b4-8c62-c7f5f116b740.png",
                "expiry_time": "2026-10-04T09:10:19.139Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2485d164-78d8-80b4-8c62-c7f5f116b740"
          },
          {
            "object": "block",
            "id": "2485d164-78d8-808a-8dde-c88654d9608f",
            "parent": {
              "type": "block_id",
              "block_id": "2485d164-78d8-8095-a662-d23a3203b6ef"
            },
            "created_time": "2025-08-07T01:13:00.000Z",
            "last_edited_time": "2025-08-07T01:50:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754529295/uxcomic-imgs/2485d164-78d8-808a-8dde-c88654d9608f.png",
                "expiry_time": "2026-10-04T09:10:19.139Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2485d164-78d8-808a-8dde-c88654d9608f"
          },
          {
            "object": "block",
            "id": "2485d164-78d8-80a1-b81c-de847dbe09fd",
            "parent": {
              "type": "block_id",
              "block_id": "2485d164-78d8-8095-a662-d23a3203b6ef"
            },
            "created_time": "2025-08-07T02:47:00.000Z",
            "last_edited_time": "2025-08-21T01:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754534884/uxcomic-imgs/2485d164-78d8-80a1-b81c-de847dbe09fd.png",
                "expiry_time": "2026-10-04T09:10:19.139Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2485d164-78d8-80a1-b81c-de847dbe09fd"
          },
          {
            "object": "block",
            "id": "2485d164-78d8-8069-9641-c905cafac511",
            "parent": {
              "type": "block_id",
              "block_id": "2485d164-78d8-8095-a662-d23a3203b6ef"
            },
            "created_time": "2025-08-07T01:13:00.000Z",
            "last_edited_time": "2025-08-07T01:50:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754529297/uxcomic-imgs/2485d164-78d8-8069-9641-c905cafac511.png",
                "expiry_time": "2026-10-04T09:10:19.139Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2485d164-78d8-8069-9641-c905cafac511"
          },
          {
            "object": "block",
            "id": "2485d164-78d8-80a2-a49f-ef2f16935b75",
            "parent": {
              "type": "block_id",
              "block_id": "2485d164-78d8-8095-a662-d23a3203b6ef"
            },
            "created_time": "2025-08-07T01:13:00.000Z",
            "last_edited_time": "2025-08-07T01:50:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754529298/uxcomic-imgs/2485d164-78d8-80a2-a49f-ef2f16935b75.png",
                "expiry_time": "2026-10-04T09:10:19.140Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2485d164-78d8-80a2-a49f-ef2f16935b75"
          }
        ]
      },
      {
        "object": "block",
        "id": "2585d164-78d8-80d3-9a5c-daac14ca26a5",
        "parent": {
          "type": "page_id",
          "page_id": "2475d164-78d8-8075-8c4d-f915f369beb7"
        },
        "created_time": "2025-08-23T01:57:00.000Z",
        "last_edited_time": "2025-08-23T01:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2585d164-78d8-801d-9264-e15085f54d1d",
        "parent": {
          "type": "page_id",
          "page_id": "2475d164-78d8-8075-8c4d-f915f369beb7"
        },
        "created_time": "2025-08-23T01:57:00.000Z",
        "last_edited_time": "2025-08-23T01:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2475d164-78d8-80de-911f-e9c95c85421e",
        "parent": {
          "type": "page_id",
          "page_id": "2475d164-78d8-8075-8c4d-f915f369beb7"
        },
        "created_time": "2025-08-06T02:14:00.000Z",
        "last_edited_time": "2025-08-06T02:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2475d164-78d8-8085-b09d-e6ead78f722b",
        "parent": {
          "type": "page_id",
          "page_id": "2475d164-78d8-8075-8c4d-f915f369beb7"
        },
        "created_time": "2025-08-06T02:14:00.000Z",
        "last_edited_time": "2025-08-06T02:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2475d164-78d8-8041-b1d5-f188a69d7a7a",
        "parent": {
          "type": "page_id",
          "page_id": "2475d164-78d8-8075-8c4d-f915f369beb7"
        },
        "created_time": "2025-08-06T02:14:00.000Z",
        "last_edited_time": "2025-08-06T02:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cognitive Load",
              "href": "https://app.notion.com/p/2465d16478d880b5a79bed3aafd415ae"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2475d164-78d8-80bf-8247-dac380a4da2a",
        "parent": {
          "type": "page_id",
          "page_id": "2475d164-78d8-8075-8c4d-f915f369beb7"
        },
        "created_time": "2025-08-06T02:14:00.000Z",
        "last_edited_time": "2025-08-06T02:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mental model?",
              "href": "https://app.notion.com/p/73bdf5d9ca494b2789a22dde16b2af7d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2585d164-78d8-800f-95b3-f71b91409635",
        "parent": {
          "type": "page_id",
          "page_id": "2475d164-78d8-8075-8c4d-f915f369beb7"
        },
        "created_time": "2025-08-23T01:57:00.000Z",
        "last_edited_time": "2025-08-23T01:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "23d5d164-78d8-8077-b873-e7bb2220b6e7",
    "created_time": "2025-07-27T05:55:00.000Z",
    "last_edited_time": "2025-08-19T06:25:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2025-07-27T05:55:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 37
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "1-Design",
          "color": "default"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-19T06:25:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "cZzk",
          "name": "⚔️:3",
          "color": "orange"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "User Behavior",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "User Behavior",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/User-Behavior-23d5d16478d88077b873e7bb2220b6e7",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Design",
      "slug": "design",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "23d5d164-78d8-80d8-a465-e814c30bf67b",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8077-b873-e7bb2220b6e7"
        },
        "created_time": "2025-07-27T05:55:00.000Z",
        "last_edited_time": "2025-07-28T05:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753599466/uxcomic-imgs/23d5d164-78d8-80d8-a465-e814c30bf67b.png",
            "expiry_time": "2026-10-04T09:10:20.298Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/23d5d164-78d8-80d8-a465-e814c30bf67b"
      },
      {
        "object": "block",
        "id": "23d5d164-78d8-8058-9b01-f9f52cacc84d",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8077-b873-e7bb2220b6e7"
        },
        "created_time": "2025-07-27T05:55:00.000Z",
        "last_edited_time": "2025-07-27T06:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "From IxDF (Interaction Design Foundation)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "From IxDF (Interaction Design Foundation)",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23d5d164-78d8-8042-b8b8-c9e34c04445c",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8077-b873-e7bb2220b6e7"
        },
        "created_time": "2025-07-27T05:58:00.000Z",
        "last_edited_time": "2025-07-27T05:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "User behavior refers to users’ actions, decisions and interactions while they use a product or service. It encompasses the way users navigate through interfaces and choices they make. It includes the underlying motivations and needs that drive their behavior too. Designers must understand user behavior and get insights into user preferences, pain points and opportunities for improvement. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User behavior refers to users’ actions, decisions and interactions while they use a product or service. It encompasses the way users navigate through interfaces and choices they make. It includes the underlying motivations and needs that drive their behavior too. Designers must understand user behavior and get insights into user preferences, pain points and opportunities for improvement. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23d5d164-78d8-80ce-8636-ea5b3b722251",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8077-b873-e7bb2220b6e7"
        },
        "created_time": "2025-07-27T07:25:00.000Z",
        "last_edited_time": "2025-07-27T07:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "list",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "list",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "23d5d164-78d8-807a-91d5-f57b202c9e13",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80ce-8636-ea5b3b722251"
            },
            "created_time": "2025-07-27T07:25:00.000Z",
            "last_edited_time": "2025-07-28T05:54:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753601202/uxcomic-imgs/23d5d164-78d8-807a-91d5-f57b202c9e13.png",
                "expiry_time": "2026-10-04T09:10:20.697Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-807a-91d5-f57b202c9e13"
          },
          {
            "object": "block",
            "id": "23d5d164-78d8-80a5-87a8-ccadceebe809",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80ce-8636-ea5b3b722251"
            },
            "created_time": "2025-07-27T07:25:00.000Z",
            "last_edited_time": "2025-07-28T05:54:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753601203/uxcomic-imgs/23d5d164-78d8-80a5-87a8-ccadceebe809.png",
                "expiry_time": "2026-10-04T09:10:20.697Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-80a5-87a8-ccadceebe809"
          },
          {
            "object": "block",
            "id": "23d5d164-78d8-80ba-9a27-fe83a5cb6706",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80ce-8636-ea5b3b722251"
            },
            "created_time": "2025-07-27T07:25:00.000Z",
            "last_edited_time": "2025-07-28T05:54:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753601204/uxcomic-imgs/23d5d164-78d8-80ba-9a27-fe83a5cb6706.png",
                "expiry_time": "2026-10-04T09:10:20.697Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-80ba-9a27-fe83a5cb6706"
          },
          {
            "object": "block",
            "id": "23d5d164-78d8-80f2-b5cb-c69f43f35307",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80ce-8636-ea5b3b722251"
            },
            "created_time": "2025-07-27T07:25:00.000Z",
            "last_edited_time": "2025-07-28T05:54:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753601205/uxcomic-imgs/23d5d164-78d8-80f2-b5cb-c69f43f35307.png",
                "expiry_time": "2026-10-04T09:10:20.697Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-80f2-b5cb-c69f43f35307"
          },
          {
            "object": "block",
            "id": "23d5d164-78d8-800a-95fa-eebeb4014f84",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80ce-8636-ea5b3b722251"
            },
            "created_time": "2025-07-27T07:25:00.000Z",
            "last_edited_time": "2025-07-28T05:54:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753601206/uxcomic-imgs/23d5d164-78d8-800a-95fa-eebeb4014f84.png",
                "expiry_time": "2026-10-04T09:10:20.697Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-800a-95fa-eebeb4014f84"
          },
          {
            "object": "block",
            "id": "23d5d164-78d8-8088-806d-f4245a48b42a",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80ce-8636-ea5b3b722251"
            },
            "created_time": "2025-07-27T07:25:00.000Z",
            "last_edited_time": "2025-07-28T05:54:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753601207/uxcomic-imgs/23d5d164-78d8-8088-806d-f4245a48b42a.png",
                "expiry_time": "2026-10-04T09:10:20.697Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-8088-806d-f4245a48b42a"
          },
          {
            "object": "block",
            "id": "23d5d164-78d8-8092-9440-e590adab748e",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80ce-8636-ea5b3b722251"
            },
            "created_time": "2025-07-27T07:25:00.000Z",
            "last_edited_time": "2025-07-28T05:54:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753601208/uxcomic-imgs/23d5d164-78d8-8092-9440-e590adab748e.png",
                "expiry_time": "2026-10-04T09:10:20.697Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-8092-9440-e590adab748e"
          },
          {
            "object": "block",
            "id": "23d5d164-78d8-80f6-a13e-cd27b08a1c87",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80ce-8636-ea5b3b722251"
            },
            "created_time": "2025-07-27T07:25:00.000Z",
            "last_edited_time": "2025-07-28T05:54:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753601209/uxcomic-imgs/23d5d164-78d8-80f6-a13e-cd27b08a1c87.png",
                "expiry_time": "2026-10-04T09:10:20.697Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-80f6-a13e-cd27b08a1c87"
          },
          {
            "object": "block",
            "id": "23d5d164-78d8-8076-a905-d0a2d5aabfcc",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80ce-8636-ea5b3b722251"
            },
            "created_time": "2025-07-27T07:25:00.000Z",
            "last_edited_time": "2025-07-28T05:54:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753601210/uxcomic-imgs/23d5d164-78d8-8076-a905-d0a2d5aabfcc.png",
                "expiry_time": "2026-10-04T09:10:20.697Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-8076-a905-d0a2d5aabfcc"
          },
          {
            "object": "block",
            "id": "23d5d164-78d8-80ff-a307-ec71bd88c2fa",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80ce-8636-ea5b3b722251"
            },
            "created_time": "2025-07-27T07:25:00.000Z",
            "last_edited_time": "2025-07-28T05:54:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753601211/uxcomic-imgs/23d5d164-78d8-80ff-a307-ec71bd88c2fa.png",
                "expiry_time": "2026-10-04T09:10:20.697Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-80ff-a307-ec71bd88c2fa"
          }
        ]
      },
      {
        "object": "block",
        "id": "23d5d164-78d8-8052-a64b-eb70f631b180",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8077-b873-e7bb2220b6e7"
        },
        "created_time": "2025-07-27T05:55:00.000Z",
        "last_edited_time": "2025-07-27T05:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "23d5d164-78d8-8071-b83e-e833da934c50",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8077-b873-e7bb2220b6e7"
        },
        "created_time": "2025-07-27T05:55:00.000Z",
        "last_edited_time": "2025-07-27T05:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23d5d164-78d8-80c2-945a-d63c3a6c29a3",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8077-b873-e7bb2220b6e7"
        },
        "created_time": "2025-07-27T05:56:00.000Z",
        "last_edited_time": "2025-08-19T06:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.interaction-design.org/literature/topics/user-behavior",
                "link": {
                  "url": "https://www.interaction-design.org/literature/topics/user-behavior"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.interaction-design.org/literature/topics/user-behavior",
              "href": "https://www.interaction-design.org/literature/topics/user-behavior"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8052-8652-da821ec7f96b",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8077-b873-e7bb2220b6e7"
        },
        "created_time": "2025-08-19T06:25:00.000Z",
        "last_edited_time": "2025-08-19T06:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.makeit.tools/",
                "link": {
                  "url": "https://www.makeit.tools/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.makeit.tools/",
              "href": "https://www.makeit.tools/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23d5d164-78d8-80c0-938e-e682fffbf558",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8077-b873-e7bb2220b6e7"
        },
        "created_time": "2025-07-27T05:56:00.000Z",
        "last_edited_time": "2025-07-27T05:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "23d5d164-78d8-8044-93b2-ebfa1d7bf1dd",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8077-b873-e7bb2220b6e7"
        },
        "created_time": "2025-07-27T05:56:00.000Z",
        "last_edited_time": "2025-07-27T05:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-8086-ad2a-d1cc21318dd3",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8077-b873-e7bb2220b6e7"
        },
        "created_time": "2025-07-28T06:59:00.000Z",
        "last_edited_time": "2025-07-28T06:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Understand, Empathize user?",
              "href": "https://app.notion.com/p/32cbe568c34b4255a408f2a2e6227bb2"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-808c-b656-cfa4315f07b0",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8077-b873-e7bb2220b6e7"
        },
        "created_time": "2025-07-28T06:59:00.000Z",
        "last_edited_time": "2025-07-28T06:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User Multiverse",
              "href": "https://app.notion.com/p/22a3b4bb88d34f84a70f83e7c12ac91d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "22e5d164-78d8-80a5-add3-ed7cd93f001b",
    "created_time": "2025-07-12T10:18:00.000Z",
    "last_edited_time": "2025-08-14T02:37:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2025-07-12T10:18:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 29
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "3-Other",
          "color": "purple"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-14T02:37:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "cZzk",
          "name": "⚔️:3",
          "color": "orange"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Các “meta terms” để học",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Các “meta terms” để học",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/C-c-meta-terms-h-c-22e5d16478d880a5add3ed7cd93f001b",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
      "name": "Other",
      "slug": "other",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "22e5d164-78d8-8086-956f-fef78799fa47",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T10:18:00.000Z",
        "last_edited_time": "2025-07-14T02:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081089/uxcomic-imgs/22e5d164-78d8-8086-956f-fef78799fa47.png",
            "expiry_time": "2026-10-04T09:10:23.010Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/22e5d164-78d8-8086-956f-fef78799fa47"
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-80b0-844a-deb0e432f864",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T10:37:00.000Z",
        "last_edited_time": "2025-07-12T10:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Definition",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Definition",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8061-b6c3-d1ca5e8eb027",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T10:18:00.000Z",
        "last_edited_time": "2025-07-12T10:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Từ “meta terms” không biết có ai dùng hok, mình chế chế ra thôi vì không tìm được từ nào hay hơn. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Từ “meta terms” không biết có ai dùng hok, mình chế chế ra thôi vì không tìm được từ nào hay hơn. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-80d8-bcd0-c0deb7f3b49d",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T10:27:00.000Z",
        "last_edited_time": "2025-07-12T10:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Meta mang nghĩa “vượt ra ngoài” hoặc “toàn diện hơn”. Terms là những một từ hoặc cụm từ dùng để gọi tên hoặc định nghĩa một hiện tượng, đối tượng hoặc khái niệm trong một lĩnh vực chuyên môn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Meta mang nghĩa “vượt ra ngoài” hoặc “toàn diện hơn”. Terms là những một từ hoặc cụm từ dùng để gọi tên hoặc định nghĩa một hiện tượng, đối tượng hoặc khái niệm trong một lĩnh vực chuyên môn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8019-8a85-c46bf6eba50c",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T10:18:00.000Z",
        "last_edited_time": "2025-07-12T10:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Meta terms có nghĩa là những “keywords” giúp mình nghiên cứu về 1 topic gì đó trở nên dễ dàng và có đường hướng hơn. Giống như thay vì biết cách đặt câu hỏi, thì “meta terms” là những từ mình có thể đính kèm nó với bất kì một lĩnh vực nào.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Meta terms có nghĩa là những “keywords” giúp mình nghiên cứu về 1 topic gì đó trở nên dễ dàng và có đường hướng hơn. Giống như thay vì biết cách đặt câu hỏi, thì “meta terms” là những từ mình có thể đính kèm nó với bất kì một lĩnh vực nào.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-8023-a501-e27b90cbd954",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-13T01:37:00.000Z",
        "last_edited_time": "2025-07-13T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-8077-ac7b-eab5d2c02d14",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-13T01:37:00.000Z",
        "last_edited_time": "2025-07-22T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Some meta terms",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Some meta terms",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2385d164-78d8-8071-bc81-e7e02f455614",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-22T05:34:00.000Z",
        "last_edited_time": "2025-07-22T05:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau đây là vài keyword để giúp mình tìm hiểu, thực hành cũng như reflect lại trong suốt quá trình tự học gì đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau đây là vài keyword để giúp mình tìm hiểu, thực hành cũng như reflect lại trong suốt quá trình tự học gì đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23d5d164-78d8-809e-9750-dd7e9eb8dd76",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-27T01:52:00.000Z",
        "last_edited_time": "2025-07-27T06:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "list",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "list",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "23d5d164-78d8-8047-b703-c5b490615a4f",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-809e-9750-dd7e9eb8dd76"
            },
            "created_time": "2025-07-27T01:52:00.000Z",
            "last_edited_time": "2025-07-27T01:52:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753581410/uxcomic-imgs/23d5d164-78d8-8047-b703-c5b490615a4f.png",
                "expiry_time": "2026-10-04T09:10:23.824Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-8047-b703-c5b490615a4f"
          },
          {
            "object": "block",
            "id": "23d5d164-78d8-80ab-9283-c8583ed230b5",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-809e-9750-dd7e9eb8dd76"
            },
            "created_time": "2025-07-27T01:52:00.000Z",
            "last_edited_time": "2025-07-27T01:52:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753581411/uxcomic-imgs/23d5d164-78d8-80ab-9283-c8583ed230b5.png",
                "expiry_time": "2026-10-04T09:10:23.824Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-80ab-9283-c8583ed230b5"
          },
          {
            "object": "block",
            "id": "23d5d164-78d8-80c5-a8ba-f4cf245316b4",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-809e-9750-dd7e9eb8dd76"
            },
            "created_time": "2025-07-27T01:52:00.000Z",
            "last_edited_time": "2025-07-27T01:52:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753581412/uxcomic-imgs/23d5d164-78d8-80c5-a8ba-f4cf245316b4.png",
                "expiry_time": "2026-10-04T09:10:23.824Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-80c5-a8ba-f4cf245316b4"
          }
        ]
      },
      {
        "object": "block",
        "id": "23d5d164-78d8-80d9-9e1a-c8a5f9a394e0",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-27T01:52:00.000Z",
        "last_edited_time": "2025-07-27T01:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8015-8c2f-e6c52175c032",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T10:30:00.000Z",
        "last_edited_time": "2025-07-12T10:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thử gắn vào xem sao nhé:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thử gắn vào xem sao nhé:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8087-9eab-eb45aa1148fd",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T10:31:00.000Z",
        "last_edited_time": "2025-07-12T10:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Design {principle}",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Design {principle}",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-8015-8a03-cde86bbe1bd2",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-13T01:02:00.000Z",
        "last_edited_time": "2025-07-13T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "UI {theory}",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UI {theory}",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8066-985d-c6f234cc701c",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T10:31:00.000Z",
        "last_edited_time": "2025-07-12T10:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "UX {pattern}",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX {pattern}",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-80d2-8808-c50d283d82f3",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T10:31:00.000Z",
        "last_edited_time": "2025-07-12T10:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Product {framework}",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product {framework}",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-80fb-9a39-cbe2f5f53415",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T10:31:00.000Z",
        "last_edited_time": "2025-07-12T10:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Interaction {phisolophy}",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Interaction {phisolophy}",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8087-b149-cf8edc358b5f",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T10:32:00.000Z",
        "last_edited_time": "2025-07-12T10:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đấy, với một bộ {lĩnh vực} + {meta terms}, mình xem tìm hiểu được một khối thông tin trong lĩnh vực ấy.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đấy, với một bộ {lĩnh vực} + {meta terms}, mình xem tìm hiểu được một khối thông tin trong lĩnh vực ấy.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8073-adff-e98884798561",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T10:33:00.000Z",
        "last_edited_time": "2025-07-12T10:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-800f-b4a1-cb1859154d27",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T10:18:00.000Z",
        "last_edited_time": "2025-07-27T01:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách mình hay áp dụng",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách mình hay áp dụng",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-8015-80ef-fcc879e38229",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-13T01:45:00.000Z",
        "last_edited_time": "2025-07-13T01:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đi từ lý thuyết đến thực hành, phải đủ hiểu, đủ biết thì hành mới chuẩn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đi từ lý thuyết đến thực hành, phải đủ hiểu, đủ biết thì hành mới chuẩn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2305d164-78d8-80ca-b568-e70d5f1b8a52",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-14T02:07:00.000Z",
        "last_edited_time": "2025-07-14T02:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Flow phổ biến cho mạch tìm hiểu:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Flow phổ biến cho mạch tìm hiểu:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2305d164-78d8-80a5-8075-e091c02b5e12",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-14T02:07:00.000Z",
        "last_edited_time": "2025-07-14T02:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Definition → Principles → History → Fundamentals → Factors → Applications → Tactics.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Definition → Principles → History → Fundamentals → Factors → Applications → Tactics.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-80ca-87e1-c975c482e240",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T11:23:00.000Z",
        "last_edited_time": "2025-07-12T12:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Definition ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Definition ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-801d-981c-f4300a1af7d5",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T11:56:00.000Z",
        "last_edited_time": "2025-07-12T12:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hiểu rõ nghĩa của cái tên đã giúp mình hiểu thêm được khá nhiều thứ đấy. Vì cái tên đó đã bao gồm được rất nhiều cái ý.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hiểu rõ nghĩa của cái tên đã giúp mình hiểu thêm được khá nhiều thứ đấy. Vì cái tên đó đã bao gồm được rất nhiều cái ý.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-801b-84e8-e2a4057cd455",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T11:59:00.000Z",
        "last_edited_time": "2025-07-12T12:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: “tương tác là gì”, “thiết kế là gì”, “thông tin là gì”. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: “tương tác là gì”, “thiết kế là gì”, “thông tin là gì”. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8090-9176-fe50edd7d739",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T12:20:00.000Z",
        "last_edited_time": "2025-07-12T12:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Tương tác” là quá trình có sự tác động giữa hai hoặc nhiều bên. Từ cái basic này, nhìn chuyên môn hơn chút chữ “interaction” trong Interaction design (trước đó là HCI - human computer interaction) là quá trình tác động qua lại giữa người và máy, quá trình này diễn ra khi con người tiếp nhận gì đó từ máy (vd: thấy cái gì) rồi tác động vô máy (vd: click chuột vào một folder) thì máy phản hồi lại (mở folder) >> đây là một tương tác.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Tương tác” là quá trình có sự tác động giữa hai hoặc nhiều bên. Từ cái basic này, nhìn chuyên môn hơn chút chữ “interaction” trong Interaction design (trước đó là HCI - human computer interaction) là quá trình tác động qua lại giữa người và máy, quá trình này diễn ra khi con người tiếp nhận gì đó từ máy (vd: thấy cái gì) rồi tác động vô máy (vd: click chuột vào một folder) thì máy phản hồi lại (mở folder) >> đây là một tương tác.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-805b-a11b-f4896bb2a5f6",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T11:59:00.000Z",
        "last_edited_time": "2025-07-12T12:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "History ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "History ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-80a0-bb58-fc3f3b6b28b8",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T10:18:00.000Z",
        "last_edited_time": "2025-07-12T11:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bất kì “term” nào trên xã hội loài người mà mình nghe được, chúng đều sinh ra với một lí do ban đầu gì đó, khi nghiên cứu về lịch sử, ta sẽ hiểu về bối cảnh & tại sao nó lại được sinh ra, nhiệm vụ cốt lõi của nó là gì.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bất kì “term” nào trên xã hội loài người mà mình nghe được, chúng đều sinh ra với một lí do ban đầu gì đó, khi nghiên cứu về lịch sử, ta sẽ hiểu về bối cảnh & tại sao nó lại được sinh ra, nhiệm vụ cốt lõi của nó là gì.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-80ad-8ebf-c1f9feb1af65",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-13T03:13:00.000Z",
        "last_edited_time": "2025-07-13T03:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: lúc mình nghiên cứu nó còn thấy được sự thú vị của việc “tên ngành” biến đổi như thế nào qua các thời kì, vì ngành phát triển và mang trong nó những scope & trách nhiệm khác nên tên cũng phải khác. Web design vs HCI vs Interaction design vs UI/UX design vs Product design,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: lúc mình nghiên cứu nó còn thấy được sự thú vị của việc “tên ngành” biến đổi như thế nào qua các thời kì, vì ngành phát triển và mang trong nó những scope & trách nhiệm khác nên tên cũng phải khác. Web design vs HCI vs Interaction design vs UI/UX design vs Product design,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8023-bb1f-d937a40f0fcf",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T11:23:00.000Z",
        "last_edited_time": "2025-07-13T03:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vd: lịch sử tiền, lịch sử interaction design, lịch sử UX design…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vd: lịch sử tiền, lịch sử interaction design, lịch sử UX design…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8010-a711-c487fc5d3c23",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T12:26:00.000Z",
        "last_edited_time": "2025-07-12T12:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Principle",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Principle",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-807a-8ec0-cf55c05f2ba4",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T12:26:00.000Z",
        "last_edited_time": "2025-07-12T12:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là những gì bất biến, là những “luật ngầm” chi phối cách hoạt động và ra quyết định trong lĩnh vực đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là những gì bất biến, là những “luật ngầm” chi phối cách hoạt động và ra quyết định trong lĩnh vực đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-802b-98ab-d0635a15d96c",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T12:29:00.000Z",
        "last_edited_time": "2025-07-12T12:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-805f-b9af-d0a7e6cd5faf",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T12:30:00.000Z",
        "last_edited_time": "2025-07-12T12:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Consistency giúp user dễ học & dễ dùng hơn",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Consistency giúp user dễ học & dễ dùng hơn",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-805f-8643-f8acd82cf291",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T12:30:00.000Z",
        "last_edited_time": "2025-07-12T12:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Feedback: luôn cho user biết chuyện gì đang xảy ra, từ đó user mới thấy an tâm và có tính control hơn (mô phỏng tình huống thực tế đi, bạn sẽ rất bực bội khi mà nói gì đó với đối phương và chỉ thấy họ im thinh thích).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Feedback: luôn cho user biết chuyện gì đang xảy ra, từ đó user mới thấy an tâm và có tính control hơn (mô phỏng tình huống thực tế đi, bạn sẽ rất bực bội khi mà nói gì đó với đối phương và chỉ thấy họ im thinh thích).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-809a-a96a-c55710c4b04d",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T12:33:00.000Z",
        "last_edited_time": "2025-07-12T12:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Làm đủ & đúng trước, sau đó mới tính đến chuyện đẹp xấu.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Làm đủ & đúng trước, sau đó mới tính đến chuyện đẹp xấu.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8052-89f4-ffad8e8cbb77",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T12:29:00.000Z",
        "last_edited_time": "2025-07-12T12:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phisolophy ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phisolophy ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8098-b649-ea47abb52e4f",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T12:29:00.000Z",
        "last_edited_time": "2025-07-12T12:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là những triết lý, tinh thần, niềm tin cốt lõi cho lĩnh vực nào đó. Niềm tin này điều hướng cách chúng ta suy nghĩ và có bộ lọc quyết định.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là những triết lý, tinh thần, niềm tin cốt lõi cho lĩnh vực nào đó. Niềm tin này điều hướng cách chúng ta suy nghĩ và có bộ lọc quyết định.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-80be-a26a-c7c33396909e",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T12:29:00.000Z",
        "last_edited_time": "2025-07-12T12:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ cho vài design phisolophy",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ cho vài design phisolophy",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8049-a702-d3529d356c2d",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T12:29:00.000Z",
        "last_edited_time": "2025-07-12T12:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Human center design = Mọi quyết định xuất phát từ ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Human center design = Mọi quyết định xuất phát từ ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "nhu cầu và bối cảnh người dùng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "nhu cầu và bối cảnh người dùng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-802e-a9eb-ddba620ce676",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T12:29:00.000Z",
        "last_edited_time": "2025-07-12T12:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Minimalism = less but better = Giản lược và tối ưu cho những gì quan trọng nhất.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Minimalism = less but better = Giản lược và tối ưu cho những gì quan trọng nhất.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-80e6-9118-d0ca2ed96b85",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T12:33:00.000Z",
        "last_edited_time": "2025-07-12T12:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Fundamental",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Fundamental",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8005-b1c7-ce400ff27878",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T12:34:00.000Z",
        "last_edited_time": "2025-07-12T12:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là các yếu tố gốc rễ, bất biến, đóng vai trò như “nền móng” mà mọi nguyên lý, quy trình, pattern đều xây dựng trên đó.\nVí dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là các yếu tố gốc rễ, bất biến, đóng vai trò như “nền móng” mà mọi nguyên lý, quy trình, pattern đều xây dựng trên đó.\nVí dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-80c9-b15b-d083214cf348",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T12:35:00.000Z",
        "last_edited_time": "2025-07-12T12:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "UX honey comb = Usefulness, Usability, Desirability, Findability, Accessibility, Credibility, Value. Đảm bảo được những thứ này UX mới tốt.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX honey comb = Usefulness, Usability, Desirability, Findability, Accessibility, Credibility, Value. Đảm bảo được những thứ này UX mới tốt.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-805a-9c09-ee2584cbf9ed",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T12:36:00.000Z",
        "last_edited_time": "2025-07-12T12:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Usability heuristic bao gồm bộ 10 tiêu chí để giúp thiết kế trở nên dùng được và dễ dùng hoặc hiệu quả hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Usability heuristic bao gồm bộ 10 tiêu chí để giúp thiết kế trở nên dùng được và dễ dùng hoặc hiệu quả hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2315d164-78d8-8081-947a-ffc6a1f8eb9e",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-15T12:49:00.000Z",
        "last_edited_time": "2025-07-15T12:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Harsh / Uncomfortable truth ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Harsh / Uncomfortable truth ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2315d164-78d8-80d0-a765-d84a2cd46f64",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-15T12:49:00.000Z",
        "last_edited_time": "2025-07-15T12:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đây là term mình thấy thích nhất, vì nó vạch ra được những điểm mù, có khi cũng mention đến cốt lõi vấn đề, nó cho một cái nhìn thực tế & phũ phãng hơn, sâu & bao quát hơn… anyway bạn thử search thử “UX harsh truth”, đảm bảo thú dị.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đây là term mình thấy thích nhất, vì nó vạch ra được những điểm mù, có khi cũng mention đến cốt lõi vấn đề, nó cho một cái nhìn thực tế & phũ phãng hơn, sâu & bao quát hơn… anyway bạn thử search thử “UX harsh truth”, đảm bảo thú dị.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-80f3-af8d-fd64937adc69",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T12:37:00.000Z",
        "last_edited_time": "2025-07-13T01:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Process / Framework / Patten / Best practices / Tactics / Factors…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Process / Framework / Patten / Best practices / Tactics / Factors…",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-806a-85c7-fdd9d1182095",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T12:38:00.000Z",
        "last_edited_time": "2025-07-12T12:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau khi bạn mày mò được những term trên kia (definition, principle,…) xong, nó sẽ cho bạn cái hiểu trước, qua các term này (process, framework …) sẽ cho bạn biết cách ứng dụng và luyện tập.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau khi bạn mày mò được những term trên kia (definition, principle,…) xong, nó sẽ cho bạn cái hiểu trước, qua các term này (process, framework …) sẽ cho bạn biết cách ứng dụng và luyện tập.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8038-b790-e596fb16925b",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-08-14T02:35:00.000Z",
        "last_edited_time": "2025-08-14T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-800f-83e6-c647a6eedf45",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-08-14T02:37:00.000Z",
        "last_edited_time": "2025-08-14T02:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80d9-8b7b-c82a5373dec5",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-08-14T02:35:00.000Z",
        "last_edited_time": "2025-08-14T02:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755139115/uxcomic-imgs/24f5d164-78d8-80d9-8b7b-c82a5373dec5.png",
            "expiry_time": "2026-10-04T09:10:23.151Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/24f5d164-78d8-80d9-8b7b-c82a5373dec5"
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-808c-a8ff-f8389529383f",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T10:37:00.000Z",
        "last_edited_time": "2025-07-12T10:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-80be-8989-dede3e3329e2",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T10:18:00.000Z",
        "last_edited_time": "2025-07-12T12:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kết",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kết",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8062-b45a-fcdd538125ed",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T10:18:00.000Z",
        "last_edited_time": "2025-07-13T01:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mong bài này sẽ giúp ích được cho mọi người trong quá trình phát triển nghề, đặc biệt là với những ai tự học, mình tin những terms đó khi gắn với tên của bất kì topic nào đều là cần thiết để có thể am hiểu một cách sâu sắc.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mong bài này sẽ giúp ích được cho mọi người trong quá trình phát triển nghề, đặc biệt là với những ai tự học, mình tin những terms đó khi gắn với tên của bất kì topic nào đều là cần thiết để có thể am hiểu một cách sâu sắc.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-800d-bf01-d1fc3906f764",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T12:44:00.000Z",
        "last_edited_time": "2025-07-12T12:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu các bạn có trên con đường học ui/ux thì mình nghĩ 1 nguồn duy nhất mà bạn đã đọc hết và theo đúng cấu trúc của nó thì đã lên trình rất nhiều rồi đó là ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu các bạn có trên con đường học ui/ux thì mình nghĩ 1 nguồn duy nhất mà bạn đã đọc hết và theo đúng cấu trúc của nó thì đã lên trình rất nhiều rồi đó là ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "https://www.nngroup.com/articles/",
                "link": {
                  "url": "https://www.nngroup.com/articles/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.nngroup.com/articles/",
              "href": "https://www.nngroup.com/articles/"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-80b6-a4ae-f5d44d7efb71",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T12:46:00.000Z",
        "last_edited_time": "2025-07-12T12:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ngay cả những người nhiều năm kinh nghiệm còn liên tục tiêu thụ và grow bản thân từ đây nữa mà, ngon lành lắm đó 🤓",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ngay cả những người nhiều năm kinh nghiệm còn liên tục tiêu thụ và grow bản thân từ đây nữa mà, ngon lành lắm đó 🤓",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80f2-bea9-d015e4aa4cce",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-08-14T02:35:00.000Z",
        "last_edited_time": "2025-08-14T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80ba-aa09-efc26fd3da5d",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-08-14T02:35:00.000Z",
        "last_edited_time": "2025-08-14T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80b4-a01f-fe150955a7e0",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-08-14T02:36:00.000Z",
        "last_edited_time": "2025-08-14T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.arlo.co/blog/overview-of-the-learning-pyramid-for-training-providers",
                "link": {
                  "url": "https://www.arlo.co/blog/overview-of-the-learning-pyramid-for-training-providers"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.arlo.co/blog/overview-of-the-learning-pyramid-for-training-providers",
              "href": "https://www.arlo.co/blog/overview-of-the-learning-pyramid-for-training-providers"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-808a-999c-cdb8a597c51f",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T10:18:00.000Z",
        "last_edited_time": "2025-07-12T10:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-80b8-bda4-cdf11d122081",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T10:18:00.000Z",
        "last_edited_time": "2025-07-12T10:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-80e1-b9dc-eb39b43b9721",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T10:18:00.000Z",
        "last_edited_time": "2025-07-12T12:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi có “quá nhiều” thứ cần…",
              "href": "https://app.notion.com/p/1ff5d16478d88089ab9ede9665e30a1f"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8095-a26c-ff3b876380ca",
        "parent": {
          "type": "page_id",
          "page_id": "22e5d164-78d8-80a5-add3-ed7cd93f001b"
        },
        "created_time": "2025-07-12T10:18:00.000Z",
        "last_edited_time": "2025-07-12T12:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relation (systematic thinking)",
              "href": "https://app.notion.com/p/1225d16478d880db8d9be6cc64d11314"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "20a5d164-78d8-80ed-bf5d-cf2ba1d343e0",
    "created_time": "2025-06-06T13:37:00.000Z",
    "last_edited_time": "2025-08-08T07:53:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2025-06-06T13:37:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 27
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "3-Other",
          "color": "purple"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-08T07:53:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "QMEI",
          "name": "♟️:3",
          "color": "green"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "My map",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "My map",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/My-map-20a5d16478d880edbf5dcf2ba1d343e0",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
      "name": "Other",
      "slug": "other",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "20a5d164-78d8-8095-82c5-fa47758d8ae7",
        "parent": {
          "type": "page_id",
          "page_id": "20a5d164-78d8-80ed-bf5d-cf2ba1d343e0"
        },
        "created_time": "2025-06-06T13:57:00.000Z",
        "last_edited_time": "2025-08-08T07:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081091/uxcomic-imgs/20a5d164-78d8-8095-82c5-fa47758d8ae7.png",
            "expiry_time": "2026-10-04T09:10:24.704Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/20a5d164-78d8-8095-82c5-fa47758d8ae7"
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-8050-9af3-e96074c70397",
        "parent": {
          "type": "page_id",
          "page_id": "20a5d164-78d8-80ed-bf5d-cf2ba1d343e0"
        },
        "created_time": "2025-06-06T13:54:00.000Z",
        "last_edited_time": "2025-06-06T13:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Base",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Base",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-8020-a04f-ec03c6cb8589",
        "parent": {
          "type": "page_id",
          "page_id": "20a5d164-78d8-80ed-bf5d-cf2ba1d343e0"
        },
        "created_time": "2025-06-06T13:37:00.000Z",
        "last_edited_time": "2025-06-06T13:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081093/uxcomic-imgs/20a5d164-78d8-8020-a04f-ec03c6cb8589.png",
            "expiry_time": "2026-10-04T09:10:24.704Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/20a5d164-78d8-8020-a04f-ec03c6cb8589"
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-80b8-8471-e24f5fa773a4",
        "parent": {
          "type": "page_id",
          "page_id": "20a5d164-78d8-80ed-bf5d-cf2ba1d343e0"
        },
        "created_time": "2025-06-06T13:54:00.000Z",
        "last_edited_time": "2025-06-06T13:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "2light",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2light",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20b5d164-78d8-8084-ac64-f0a5bb27b378",
        "parent": {
          "type": "page_id",
          "page_id": "20a5d164-78d8-80ed-bf5d-cf2ba1d343e0"
        },
        "created_time": "2025-06-07T02:17:00.000Z",
        "last_edited_time": "2025-06-07T02:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081094/uxcomic-imgs/20b5d164-78d8-8084-ac64-f0a5bb27b378.png",
            "expiry_time": "2026-10-04T09:10:24.704Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/20b5d164-78d8-8084-ac64-f0a5bb27b378"
      },
      {
        "object": "block",
        "id": "2495d164-78d8-80e9-9981-f6a8ad0e4f8d",
        "parent": {
          "type": "page_id",
          "page_id": "20a5d164-78d8-80ed-bf5d-cf2ba1d343e0"
        },
        "created_time": "2025-08-08T07:53:00.000Z",
        "last_edited_time": "2025-08-08T07:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2495d164-78d8-8023-b436-ed0da164e3fb",
        "parent": {
          "type": "page_id",
          "page_id": "20a5d164-78d8-80ed-bf5d-cf2ba1d343e0"
        },
        "created_time": "2025-08-08T07:53:00.000Z",
        "last_edited_time": "2025-08-08T07:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-8005-bcf7-f3a6b75f034a",
        "parent": {
          "type": "page_id",
          "page_id": "20a5d164-78d8-80ed-bf5d-cf2ba1d343e0"
        },
        "created_time": "2025-06-06T13:37:00.000Z",
        "last_edited_time": "2025-08-08T07:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ask myself",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ask myself",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2495d164-78d8-8049-94c3-d27726ef2e81",
        "parent": {
          "type": "page_id",
          "page_id": "20a5d164-78d8-80ed-bf5d-cf2ba1d343e0"
        },
        "created_time": "2025-08-08T07:26:00.000Z",
        "last_edited_time": "2025-08-08T07:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "2495d164-78d8-809e-a8ca-c00c1d55e156",
            "parent": {
              "type": "block_id",
              "block_id": "2495d164-78d8-8049-94c3-d27726ef2e81"
            },
            "created_time": "2025-08-08T07:26:00.000Z",
            "last_edited_time": "2025-08-08T07:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754638084/uxcomic-imgs/2495d164-78d8-809e-a8ca-c00c1d55e156.png",
                "expiry_time": "2026-10-04T09:10:25.536Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2495d164-78d8-809e-a8ca-c00c1d55e156"
          },
          {
            "object": "block",
            "id": "2495d164-78d8-80e9-a037-ca007bbe2221",
            "parent": {
              "type": "block_id",
              "block_id": "2495d164-78d8-8049-94c3-d27726ef2e81"
            },
            "created_time": "2025-08-08T07:26:00.000Z",
            "last_edited_time": "2025-08-08T07:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754638085/uxcomic-imgs/2495d164-78d8-80e9-a037-ca007bbe2221.png",
                "expiry_time": "2026-10-04T09:10:25.536Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2495d164-78d8-80e9-a037-ca007bbe2221"
          },
          {
            "object": "block",
            "id": "2495d164-78d8-802b-87c7-d8c906d3c2d8",
            "parent": {
              "type": "block_id",
              "block_id": "2495d164-78d8-8049-94c3-d27726ef2e81"
            },
            "created_time": "2025-08-08T07:26:00.000Z",
            "last_edited_time": "2025-08-08T07:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754638086/uxcomic-imgs/2495d164-78d8-802b-87c7-d8c906d3c2d8.png",
                "expiry_time": "2026-10-04T09:10:25.536Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2495d164-78d8-802b-87c7-d8c906d3c2d8"
          },
          {
            "object": "block",
            "id": "2495d164-78d8-80eb-86c5-da642ff09140",
            "parent": {
              "type": "block_id",
              "block_id": "2495d164-78d8-8049-94c3-d27726ef2e81"
            },
            "created_time": "2025-08-08T07:26:00.000Z",
            "last_edited_time": "2025-08-08T07:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754638087/uxcomic-imgs/2495d164-78d8-80eb-86c5-da642ff09140.png",
                "expiry_time": "2026-10-04T09:10:25.536Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2495d164-78d8-80eb-86c5-da642ff09140"
          }
        ]
      }
    ]
  },
  {
    "object": "page",
    "id": "2075d164-78d8-8065-9601-e74bce1c1919",
    "created_time": "2025-06-03T02:58:00.000Z",
    "last_edited_time": "2025-09-01T15:52:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2025-06-03T02:58:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 25
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "2-Think",
          "color": "green"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-09-01T15:52:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "QMEI",
          "name": "♟️:3",
          "color": "green"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "To think?",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "To think?",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/To-think-2075d16478d880659601e74bce1c1919",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
      "name": "Think",
      "slug": "think",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "23d5d164-78d8-8010-b957-cde5b4dfa4cc",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-07-27T06:50:00.000Z",
        "last_edited_time": "2025-08-26T11:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753599481/uxcomic-imgs/23d5d164-78d8-8010-b957-cde5b4dfa4cc.png",
            "expiry_time": "2026-10-04T09:10:26.637Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/23d5d164-78d8-8010-b957-cde5b4dfa4cc"
      },
      {
        "object": "block",
        "id": "2075d164-78d8-80ac-8120-d1b326b60ea4",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-06-03T02:58:00.000Z",
        "last_edited_time": "2025-09-01T05:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi tìm hiểu về việc hỏi, mình hay bắt gặp những keyword như “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi tìm hiểu về việc hỏi, mình hay bắt gặp những keyword như “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Critical thinking",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Critical thinking",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "” & “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” & “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Socratic method",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Socratic method",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "”. Rồi hỏi AI các kiểu, đọc blog,… thì thấy nó như một vũ trụ mới vậy. Cơ mà topic này mình cảm nhận chúng rất hữu ích và cần thiết cho mọi thứ trong cuộc sống >> bài này mình chỉ tổng hợp lại thôi và có thêm vài hint để có thể làm cảm hứng đi đào sâu thêm. Mình cũng đang ngâm cứu =))",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "”. Rồi hỏi AI các kiểu, đọc blog,… thì thấy nó như một vũ trụ mới vậy. Cơ mà topic này mình cảm nhận chúng rất hữu ích và cần thiết cho mọi thứ trong cuộc sống >> bài này mình chỉ tổng hợp lại thôi và có thêm vài hint để có thể làm cảm hứng đi đào sâu thêm. Mình cũng đang ngâm cứu =))",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2075d164-78d8-80b4-8274-d111c1c31ed6",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-06-03T03:17:00.000Z",
        "last_edited_time": "2025-06-03T03:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thinking is Driven by Questions",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thinking is Driven by Questions",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2075d164-78d8-80fd-ab86-ed405afe6070",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-06-03T03:03:00.000Z",
        "last_edited_time": "2025-06-03T03:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2075d164-78d8-80ca-850d-e5dc1b1b1951",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-06-03T03:03:00.000Z",
        "last_edited_time": "2025-07-27T06:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Critical thinking & Socratic method… the flow?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Critical thinking & Socratic method… the flow?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23d5d164-78d8-8037-8054-e761c823b329",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-07-27T06:56:00.000Z",
        "last_edited_time": "2025-07-27T06:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753599482/uxcomic-imgs/23d5d164-78d8-8037-8054-e761c823b329.png",
            "expiry_time": "2026-10-04T09:10:26.637Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/23d5d164-78d8-8037-8054-e761c823b329"
      },
      {
        "object": "block",
        "id": "23d5d164-78d8-80ea-a8cb-ec5e4896d834",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-07-27T06:55:00.000Z",
        "last_edited_time": "2025-09-01T05:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753599483/uxcomic-imgs/23d5d164-78d8-80ea-a8cb-ec5e4896d834.jpg",
            "expiry_time": "2026-10-04T09:10:26.637Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/23d5d164-78d8-80ea-a8cb-ec5e4896d834"
      },
      {
        "object": "block",
        "id": "2075d164-78d8-80d0-a5d3-d68dcfe2974f",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-06-03T03:09:00.000Z",
        "last_edited_time": "2025-06-03T03:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2075d164-78d8-807c-a822-d7d592b4ee20",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-06-03T03:07:00.000Z",
        "last_edited_time": "2025-07-27T06:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quality of thinking?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quality of thinking?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2075d164-78d8-8038-98f4-ffaf573c6ce2",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-06-03T03:08:00.000Z",
        "last_edited_time": "2025-06-03T03:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "To assess the quality of thinking, the Paul-Elder framework includes nine intellectual standards, which guide how we apply the elements:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "To assess the quality of thinking, the Paul-Elder framework includes nine intellectual standards, which guide how we apply the elements:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-80ac-9792-e1d9e1e2da79",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-09-01T06:11:00.000Z",
        "last_edited_time": "2025-09-01T15:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "list",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "list",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "2615d164-78d8-800d-90ce-c478e9155294",
            "parent": {
              "type": "block_id",
              "block_id": "2615d164-78d8-80ac-9792-e1d9e1e2da79"
            },
            "created_time": "2025-09-01T15:51:00.000Z",
            "last_edited_time": "2025-09-01T15:51:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756742026/uxcomic-imgs/2615d164-78d8-800d-90ce-c478e9155294.png",
                "expiry_time": "2026-10-04T09:10:27.680Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2615d164-78d8-800d-90ce-c478e9155294"
          },
          {
            "object": "block",
            "id": "2615d164-78d8-8057-8615-f5945b2a1c7b",
            "parent": {
              "type": "block_id",
              "block_id": "2615d164-78d8-80ac-9792-e1d9e1e2da79"
            },
            "created_time": "2025-09-01T15:51:00.000Z",
            "last_edited_time": "2025-09-01T15:51:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756742026/uxcomic-imgs/2615d164-78d8-8057-8615-f5945b2a1c7b.png",
                "expiry_time": "2026-10-04T09:10:27.680Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2615d164-78d8-8057-8615-f5945b2a1c7b"
          },
          {
            "object": "block",
            "id": "2615d164-78d8-80fd-9715-eb3b29572a2f",
            "parent": {
              "type": "block_id",
              "block_id": "2615d164-78d8-80ac-9792-e1d9e1e2da79"
            },
            "created_time": "2025-09-01T15:51:00.000Z",
            "last_edited_time": "2025-09-01T15:51:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756742027/uxcomic-imgs/2615d164-78d8-80fd-9715-eb3b29572a2f.png",
                "expiry_time": "2026-10-04T09:10:27.680Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2615d164-78d8-80fd-9715-eb3b29572a2f"
          },
          {
            "object": "block",
            "id": "2615d164-78d8-80d8-8928-c3455f305270",
            "parent": {
              "type": "block_id",
              "block_id": "2615d164-78d8-80ac-9792-e1d9e1e2da79"
            },
            "created_time": "2025-09-01T15:51:00.000Z",
            "last_edited_time": "2025-09-01T15:51:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756742028/uxcomic-imgs/2615d164-78d8-80d8-8928-c3455f305270.png",
                "expiry_time": "2026-10-04T09:10:27.680Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2615d164-78d8-80d8-8928-c3455f305270"
          },
          {
            "object": "block",
            "id": "2615d164-78d8-8042-ae03-fc7e48979bb4",
            "parent": {
              "type": "block_id",
              "block_id": "2615d164-78d8-80ac-9792-e1d9e1e2da79"
            },
            "created_time": "2025-09-01T15:51:00.000Z",
            "last_edited_time": "2025-09-01T15:51:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756742029/uxcomic-imgs/2615d164-78d8-8042-ae03-fc7e48979bb4.png",
                "expiry_time": "2026-10-04T09:10:27.680Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2615d164-78d8-8042-ae03-fc7e48979bb4"
          },
          {
            "object": "block",
            "id": "2615d164-78d8-805d-b016-fc242964c680",
            "parent": {
              "type": "block_id",
              "block_id": "2615d164-78d8-80ac-9792-e1d9e1e2da79"
            },
            "created_time": "2025-09-01T15:51:00.000Z",
            "last_edited_time": "2025-09-01T15:51:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756742031/uxcomic-imgs/2615d164-78d8-805d-b016-fc242964c680.png",
                "expiry_time": "2026-10-04T09:10:27.680Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2615d164-78d8-805d-b016-fc242964c680"
          },
          {
            "object": "block",
            "id": "2615d164-78d8-8028-b8a9-cb2a85cb3963",
            "parent": {
              "type": "block_id",
              "block_id": "2615d164-78d8-80ac-9792-e1d9e1e2da79"
            },
            "created_time": "2025-09-01T15:51:00.000Z",
            "last_edited_time": "2025-09-01T15:51:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756742032/uxcomic-imgs/2615d164-78d8-8028-b8a9-cb2a85cb3963.png",
                "expiry_time": "2026-10-04T09:10:27.680Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2615d164-78d8-8028-b8a9-cb2a85cb3963"
          },
          {
            "object": "block",
            "id": "2615d164-78d8-8001-a266-d534c615dda5",
            "parent": {
              "type": "block_id",
              "block_id": "2615d164-78d8-80ac-9792-e1d9e1e2da79"
            },
            "created_time": "2025-09-01T15:51:00.000Z",
            "last_edited_time": "2025-09-01T15:51:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756742033/uxcomic-imgs/2615d164-78d8-8001-a266-d534c615dda5.png",
                "expiry_time": "2026-10-04T09:10:27.680Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2615d164-78d8-8001-a266-d534c615dda5"
          },
          {
            "object": "block",
            "id": "2615d164-78d8-80d2-9376-e1aea639fada",
            "parent": {
              "type": "block_id",
              "block_id": "2615d164-78d8-80ac-9792-e1d9e1e2da79"
            },
            "created_time": "2025-09-01T15:51:00.000Z",
            "last_edited_time": "2025-09-01T15:51:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756742034/uxcomic-imgs/2615d164-78d8-80d2-9376-e1aea639fada.png",
                "expiry_time": "2026-10-04T09:10:27.680Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2615d164-78d8-80d2-9376-e1aea639fada"
          }
        ]
      },
      {
        "object": "block",
        "id": "2615d164-78d8-8010-a72c-e400a7ac441c",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-09-01T15:50:00.000Z",
        "last_edited_time": "2025-09-01T15:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2075d164-78d8-8069-b133-f4a959d0241c",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-06-03T02:58:00.000Z",
        "last_edited_time": "2025-06-03T02:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2075d164-78d8-803d-b080-c9eed7038495",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-06-03T02:58:00.000Z",
        "last_edited_time": "2025-06-03T02:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25b5d164-78d8-80a8-9dd3-d7f0b71cc873",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-08-26T11:50:00.000Z",
        "last_edited_time": "2025-08-26T11:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "video",
        "video": {
          "caption": [],
          "type": "external",
          "external": {
            "url": "https://youtu.be/-sfiReUu3o0?si=H8fK9IgzrgPpyCXY"
          }
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25b5d164-78d8-801b-880b-f9184cf8bf5b",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-08-26T11:50:00.000Z",
        "last_edited_time": "2025-08-26T11:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2075d164-78d8-8093-9cc1-c16737bf7ec9",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-06-03T03:07:00.000Z",
        "last_edited_time": "2025-06-03T03:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://louisville.edu/ideastoaction/about/criticalthinking/framework",
                "link": {
                  "url": "https://louisville.edu/ideastoaction/about/criticalthinking/framework"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://louisville.edu/ideastoaction/about/criticalthinking/framework",
              "href": "https://louisville.edu/ideastoaction/about/criticalthinking/framework"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2075d164-78d8-80ee-9abb-f4c733581936",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-06-03T03:11:00.000Z",
        "last_edited_time": "2025-06-03T03:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://asana.com/resources/critical-thinking-skills",
                "link": {
                  "url": "https://asana.com/resources/critical-thinking-skills"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://asana.com/resources/critical-thinking-skills",
              "href": "https://asana.com/resources/critical-thinking-skills"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2075d164-78d8-80d9-8bb1-c2f882893289",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-06-03T03:11:00.000Z",
        "last_edited_time": "2025-06-03T03:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://positivepsychology.com/socratic-questioning/",
                "link": {
                  "url": "https://positivepsychology.com/socratic-questioning/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://positivepsychology.com/socratic-questioning/",
              "href": "https://positivepsychology.com/socratic-questioning/"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2075d164-78d8-8094-9643-c3fb029db220",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-06-03T03:12:00.000Z",
        "last_edited_time": "2025-06-03T03:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.criticalthinking.org/pages/the-role-of-socratic-questioning-in-thinking-teac/522",
                "link": {
                  "url": "https://www.criticalthinking.org/pages/the-role-of-socratic-questioning-in-thinking-teac/522"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.criticalthinking.org/pages/the-role-of-socratic-questioning-in-thinking-teac/522",
              "href": "https://www.criticalthinking.org/pages/the-role-of-socratic-questioning-in-thinking-teac/522"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2075d164-78d8-809b-a932-d597a52769d8",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-06-03T02:58:00.000Z",
        "last_edited_time": "2025-06-03T02:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2075d164-78d8-80ad-a118-f3f9464a2935",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-06-03T02:58:00.000Z",
        "last_edited_time": "2025-06-03T02:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2075d164-78d8-800f-b2a9-d68c2725665f",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-06-03T02:58:00.000Z",
        "last_edited_time": "2025-06-03T02:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Questioning (P2)",
              "href": "https://app.notion.com/p/1435d16478d88004930ce9f3fede9fe4"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2075d164-78d8-8087-8de3-c99731dbd2a2",
        "parent": {
          "type": "page_id",
          "page_id": "2075d164-78d8-8065-9601-e74bce1c1919"
        },
        "created_time": "2025-06-03T02:58:00.000Z",
        "last_edited_time": "2025-06-03T02:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sense making",
              "href": "https://app.notion.com/p/1195d16478d880cda21ff9d0e90ae7b8"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f",
    "created_time": "2025-05-26T02:12:00.000Z",
    "last_edited_time": "2025-06-28T05:27:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2025-05-26T02:12:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 24
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "3-Other",
          "color": "purple"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-06-28T05:27:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "QMEI",
          "name": "♟️:3",
          "color": "green"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Khi có “quá nhiều” thứ cần…",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Khi có “quá nhiều” thứ cần…",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Khi-c-qu-nhi-u-th-c-n-1ff5d16478d88089ab9ede9665e30a1f",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
      "name": "Other",
      "slug": "other",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "1ff5d164-78d8-80a2-acc4-f83b95aa72a2",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T03:59:00.000Z",
        "last_edited_time": "2025-05-26T14:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081098/uxcomic-imgs/1ff5d164-78d8-80a2-acc4-f83b95aa72a2.png",
            "expiry_time": "2026-10-04T09:10:29.913Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1ff5d164-78d8-80a2-acc4-f83b95aa72a2"
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80d6-8fee-fc4c91e7da72",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:12:00.000Z",
        "last_edited_time": "2025-05-26T02:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hiện mình đang trong giai đoạn thấy có quá nhiều thứ cần phải take action gì đó, còn không nó sẽ rơi vào hỗn độn, phần nữa là cũng nghe bác Naval khuyên nên set up một model riêng cho bản thân, để dùng nó 1 cái tool giúp đẩy nhanh hiệu suất suy nghĩ hay ra quyết định…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hiện mình đang trong giai đoạn thấy có quá nhiều thứ cần phải take action gì đó, còn không nó sẽ rơi vào hỗn độn, phần nữa là cũng nghe bác Naval khuyên nên set up một model riêng cho bản thân, để dùng nó 1 cái tool giúp đẩy nhanh hiệu suất suy nghĩ hay ra quyết định…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80a8-8914-d3730ad76b1b",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:21:00.000Z",
        "last_edited_time": "2025-05-26T02:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nên solution của mình đang hướng đến là:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nên solution của mình đang hướng đến là:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-8099-8277-cb62c12c3808",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:21:00.000Z",
        "last_edited_time": "2025-05-26T02:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quy hoạch 1 model để có thể nhìn vào mà áp dụng cho cuộc đời LINH HOẠT nhất cho mọi tình huống, ngữ cảnh.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quy hoạch 1 model để có thể nhìn vào mà áp dụng cho cuộc đời LINH HOẠT nhất cho mọi tình huống, ngữ cảnh.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-8052-b172-f5933834a121",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:22:00.000Z",
        "last_edited_time": "2025-05-26T03:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lên chiến lược để take action một cách khôn ngoan & hiệu quả > tư duy ĐÒN BẨY > làm 1 ăn 10, không những vậy nó còn cần đến COMPOUND effect để mỗi bước mình làm đều có giá trị về sau.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lên chiến lược để take action một cách khôn ngoan & hiệu quả > tư duy ĐÒN BẨY > làm 1 ăn 10, không những vậy nó còn cần đến COMPOUND effect để mỗi bước mình làm đều có giá trị về sau.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-803e-ae53-c8a7aff6c2fd",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:18:00.000Z",
        "last_edited_time": "2025-05-26T02:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80b2-9d0d-ecb2d350b41e",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:18:00.000Z",
        "last_edited_time": "2025-05-27T01:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_1",
        "heading_1": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Define",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Define",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80e3-ac5d-db0f2277671a",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:18:00.000Z",
        "last_edited_time": "2025-05-26T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hiện mình đang cảm thấy, thử define vấn đề 1 cách rõ ràng xem sao?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hiện mình đang cảm thấy, thử define vấn đề 1 cách rõ ràng xem sao?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-8051-955d-c3500e938474",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:19:00.000Z",
        "last_edited_time": "2025-05-26T02:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình đang thấy có “quá nhiều”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình đang thấy có “quá nhiều”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80bb-a82e-fcce0729c76b",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:20:00.000Z",
        "last_edited_time": "2025-05-26T02:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thứ cần học, cần biết",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thứ cần học, cần biết",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-805d-8d00-def94da9524e",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:20:00.000Z",
        "last_edited_time": "2025-05-26T02:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thứ cần hiểu và áp dụng",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thứ cần hiểu và áp dụng",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-8087-81db-d3b59d966409",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:20:00.000Z",
        "last_edited_time": "2025-05-26T03:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quyết định cần được cần nhắc",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quyết định cần được cần nhắc",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-808d-935d-d00914315f3b",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:21:00.000Z",
        "last_edited_time": "2025-05-26T02:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thứ cần phải chiêm nghiệm và rút tỉa",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thứ cần phải chiêm nghiệm và rút tỉa",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80f5-a705-c5ac71a9e4a2",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:32:00.000Z",
        "last_edited_time": "2025-05-26T02:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80de-a766-c161da807d20",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:32:00.000Z",
        "last_edited_time": "2025-05-27T01:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_1",
        "heading_1": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Approach",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Approach",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-8070-a459-e50c1e3f0177",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:24:00.000Z",
        "last_edited_time": "2025-05-26T02:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vấn đề ở đây đang là “quá nhiều”, vậy giải quyết cho quá nhiều như thế nào?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vấn đề ở đây đang là “quá nhiều”, vậy giải quyết cho quá nhiều như thế nào?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-806c-bb41-d605ee00aea8",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:25:00.000Z",
        "last_edited_time": "2025-05-26T02:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "1. Tăng khả năng để không còn cảm thấy “quá nhiều”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "1. Tăng khả năng để không còn cảm thấy “quá nhiều”",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-804b-8d7d-f6e108642b4e",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:26:00.000Z",
        "last_edited_time": "2025-05-26T03:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tăng khả năng xử lý",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tăng khả năng xử lý",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": này đòi hỏi làm riết quen tay > áp dụng và hành tối đa những gì mình đã biết > khiến nó trở thành thói quen & phản xạ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": này đòi hỏi làm riết quen tay > áp dụng và hành tối đa những gì mình đã biết > khiến nó trở thành thói quen & phản xạ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80f2-af12-df4dfb0d1695",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T03:19:00.000Z",
        "last_edited_time": "2025-05-26T03:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chunk up",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chunk up",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": cố gắng tổng quát hoá, đơn giản hoá để hiểu đúng bản chất & cốt lõi",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": cố gắng tổng quát hoá, đơn giản hoá để hiểu đúng bản chất & cốt lõi",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-8046-9066-c71c67595b73",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:27:00.000Z",
        "last_edited_time": "2025-05-26T02:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "2. Giảm bớt",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2. Giảm bớt",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-8071-8301-d0e545c48349",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:28:00.000Z",
        "last_edited_time": "2025-05-26T03:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cắt bỏ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cắt bỏ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": đánh giá xem cái nào chưa cần, không cần cho thời điểm hiện tại thì tạm gác qua 1 bên.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": đánh giá xem cái nào chưa cần, không cần cho thời điểm hiện tại thì tạm gác qua 1 bên.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80d8-ad32-efc15ec78c09",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:28:00.000Z",
        "last_edited_time": "2025-05-26T03:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ưu tiên",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ưu tiên",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " - Cắt không được thì câu chuyện tiếp đến là ưu tiên > biết cái nào là quan trọng, có khả năng leverage cao nhất (nguyên tắc 80/20)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " - Cắt không được thì câu chuyện tiếp đến là ưu tiên > biết cái nào là quan trọng, có khả năng leverage cao nhất (nguyên tắc 80/20)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-8005-bfa2-f366619271f4",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:30:00.000Z",
        "last_edited_time": "2025-05-26T03:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chunk down ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chunk down ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "- Ưu tiên không được nữa thì băm nhỏ ra làm dần > cảm giác không bị overwhelm > Keep things in 3 bullet point.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "- Ưu tiên không được nữa thì băm nhỏ ra làm dần > cảm giác không bị overwhelm > Keep things in 3 bullet point.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80cf-9649-c31bfc4cbdc3",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:31:00.000Z",
        "last_edited_time": "2025-05-26T02:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "OK vậy đây sẽ là hướng giải quyết chung chung cho tình trạng “quá nhiều”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "OK vậy đây sẽ là hướng giải quyết chung chung cho tình trạng “quá nhiều”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-809f-b51f-f96b9c3b74c8",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:31:00.000Z",
        "last_edited_time": "2025-05-26T02:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giờ sang từ mục xem sẽ cụ thể giải quyết như thế nào.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giờ sang từ mục xem sẽ cụ thể giải quyết như thế nào.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-8048-beb5-f9b755e6e7d1",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:32:00.000Z",
        "last_edited_time": "2025-05-26T02:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-8080-920d-fe91843c6190",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T02:32:00.000Z",
        "last_edited_time": "2025-06-28T05:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_1",
        "heading_1": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Actions",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Actions",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-8025-ae40-e60fe2189f75",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T03:20:00.000Z",
        "last_edited_time": "2025-05-26T03:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quá nhiều thứ cần học, cần biết",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quá nhiều thứ cần học, cần biết",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-8066-8c98-d8b5326e4fed",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T03:21:00.000Z",
        "last_edited_time": "2025-06-03T02:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Học cốt lõi",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Học cốt lõi",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " - ráng tìm ra được cái gì học được rồi sẽ giúp học 10 cái khác nhanh hơn. Tips: hãy hình dung thứ đang chuẩn bị học, chunk up > nó thuộc về topic gì > học topic to đó. Ví dụ: mình đang muốn học cách present design solution > lớn hơn việc đó là design reasoning > lớn hơn nữa là khả năng present > lớn hơn nữa là communication > lớn hơn nữa là sense making.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " - ráng tìm ra được cái gì học được rồi sẽ giúp học 10 cái khác nhanh hơn. Tips: hãy hình dung thứ đang chuẩn bị học, chunk up > nó thuộc về topic gì > học topic to đó. Ví dụ: mình đang muốn học cách present design solution > lớn hơn việc đó là design reasoning > lớn hơn nữa là khả năng present > lớn hơn nữa là communication > lớn hơn nữa là sense making.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-8036-bbe6-dfbad0ffb0ea",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T03:23:00.000Z",
        "last_edited_time": "2025-05-26T03:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Học cái gì có giá trị cho",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Học cái gì có giá trị cho",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " thời điểm hiện tại,",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " thời điểm hiện tại,",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " đừng ôm đồm ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " đừng ôm đồm ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-8078-af14-d61d1df67b81",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:09:00.000Z",
        "last_edited_time": "2025-05-26T04:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Set up 🗺️ ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Set up 🗺️ ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Growth Map",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Growth Map",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " cho bản thân.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " cho bản thân.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "💡"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-8043-af22-ec365068e8dc",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:24:00.000Z",
        "last_edited_time": "2025-05-26T04:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081100/uxcomic-imgs/1ff5d164-78d8-8043-af22-ec365068e8dc.webp",
            "expiry_time": "2026-10-04T09:10:29.970Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1ff5d164-78d8-8043-af22-ec365068e8dc"
      },
      {
        "object": "block",
        "id": "2015d164-78d8-806e-a46d-cccfebdc41b0",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-28T02:16:00.000Z",
        "last_edited_time": "2025-05-28T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80d4-ae40-c6c3b0732ee7",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T03:25:00.000Z",
        "last_edited_time": "2025-05-26T03:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quá nhiều kiến thức cần được nhớ, được hiểu & được áp dụng",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quá nhiều kiến thức cần được nhớ, được hiểu & được áp dụng",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-8004-91e0-e849c205b490",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T03:24:00.000Z",
        "last_edited_time": "2025-06-03T02:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sẽ có hàng ngàn framework để giúp mình theo lối tư duy và hiểu được gì đó NHƯNG làm sao mà mình nhớ được. Chunk up thì ta có gì >> Phương pháp luận >> Câu hỏi khơi mở tư duy.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sẽ có hàng ngàn framework để giúp mình theo lối tư duy và hiểu được gì đó NHƯNG làm sao mà mình nhớ được. Chunk up thì ta có gì >> Phương pháp luận >> Câu hỏi khơi mở tư duy.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2075d164-78d8-80b7-9113-f68738ddcf02",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-06-03T02:12:00.000Z",
        "last_edited_time": "2025-06-03T02:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy để hiểu thì ta cần nhấn 1 nút nguồn để bắt đầu tư duy: mọi thứ bắt đầu bằng câu hỏi >> ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy để hiểu thì ta cần nhấn 1 nút nguồn để bắt đầu tư duy: mọi thứ bắt đầu bằng câu hỏi >> ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Học cách HỎI.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Học cách HỎI.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2075d164-78d8-80f1-9474-f0d504584ebe",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-06-03T02:13:00.000Z",
        "last_edited_time": "2025-06-03T02:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hiểu là quá trình suy luận, ta hệ thống hoá, make sense, tìm mối liên hệ và cách các thông tin tương tác với nhau >> ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hiểu là quá trình suy luận, ta hệ thống hoá, make sense, tìm mối liên hệ và cách các thông tin tương tác với nhau >> ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Học cách LUẬN ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Học cách LUẬN ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "(critical, strategic, inversion, creative, mental model…). Tip: hãy ẩn dụ hoá, kết nối với những thứ đã biết, một cách thần kì nào đó metaphor cho thấy có vài thứ có bản chất giống nhau. Ví dụ: bản chất con người là lười nên các sản phẩm giúp tiết kiệm công sức luôn ok.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "(critical, strategic, inversion, creative, mental model…). Tip: hãy ẩn dụ hoá, kết nối với những thứ đã biết, một cách thần kì nào đó metaphor cho thấy có vài thứ có bản chất giống nhau. Ví dụ: bản chất con người là lười nên các sản phẩm giúp tiết kiệm công sức luôn ok.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-809b-bcac-c3c7c9be0a30",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:09:00.000Z",
        "last_edited_time": "2025-05-26T04:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hỏi & Luận",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hỏi & Luận",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "💡"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80a1-9169-d164f1da7bb5",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:24:00.000Z",
        "last_edited_time": "2025-05-26T04:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081102/uxcomic-imgs/1ff5d164-78d8-80a1-9169-d164f1da7bb5.webp",
            "expiry_time": "2026-10-04T09:10:29.971Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1ff5d164-78d8-80a1-9169-d164f1da7bb5"
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80b1-891d-eb9202172dac",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T03:33:00.000Z",
        "last_edited_time": "2025-06-03T02:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Còn về việc áp dụng cũng quan trọng không kém gì? Học cho lắm mà không hiểu, hiểu mà không hành thì cũng chưa chắc gì là hiểu & cũng sẽ là vô ích nếu không áp dụng đúng cách. Vậy làm sao ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Còn về việc áp dụng cũng quan trọng không kém gì? Học cho lắm mà không hiểu, hiểu mà không hành thì cũng chưa chắc gì là hiểu & cũng sẽ là vô ích nếu không áp dụng đúng cách. Vậy làm sao ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "để nhớ mà hành.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "để nhớ mà hành.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2075d164-78d8-80f4-860b-c528f022372b",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-06-03T02:12:00.000Z",
        "last_edited_time": "2025-06-03T02:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Second brain - để nhớ: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Second brain - để nhớ: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "note ra đâu đó & dùng nó thường xuyên, bộ não ta nhanh quên thì hãy dùng tool để bổ trợ cho việc đó: tập, cheat sheet, mind map, notion.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "note ra đâu đó & dùng nó thường xuyên, bộ não ta nhanh quên thì hãy dùng tool để bổ trợ cho việc đó: tập, cheat sheet, mind map, notion.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2075d164-78d8-806c-bb6d-e8cd05378762",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-06-03T02:12:00.000Z",
        "last_edited_time": "2025-06-03T02:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Pause - để hành : ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Pause - để hành : ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "trong các tình huống, hãy dừng vài giây, luyện cho mình thói quen này để tránh phản ứng theo bản năng, rồi nghĩ xem có mớ kiến thức nào mình có thể áp dụng không, hãy kiếm cơ hội để hành nó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "trong các tình huống, hãy dừng vài giây, luyện cho mình thói quen này để tránh phản ứng theo bản năng, rồi nghĩ xem có mớ kiến thức nào mình có thể áp dụng không, hãy kiếm cơ hội để hành nó.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80f2-aa01-e6d482f7c24a",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:09:00.000Z",
        "last_edited_time": "2025-05-26T04:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhớ & Hành",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhớ & Hành",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "💡"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-8073-97b8-c3f0eaecf8de",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:27:00.000Z",
        "last_edited_time": "2025-05-26T04:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081104/uxcomic-imgs/1ff5d164-78d8-8073-97b8-c3f0eaecf8de.webp",
            "expiry_time": "2026-10-04T09:10:29.971Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1ff5d164-78d8-8073-97b8-c3f0eaecf8de"
      },
      {
        "object": "block",
        "id": "2015d164-78d8-80b0-b4fc-fd1cbfa3a2ca",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-28T02:16:00.000Z",
        "last_edited_time": "2025-05-28T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80ac-95f0-c291d2878b04",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:00:00.000Z",
        "last_edited_time": "2025-05-26T04:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quá nhiều quyết định cần được cân nhắc",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quá nhiều quyết định cần được cân nhắc",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-805f-af36-e12b489d0075",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:01:00.000Z",
        "last_edited_time": "2025-05-26T04:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vâng một ngày, có rất nhiều quyết định cần được đưa ra, từ mặc quần áo gì, đi đường nào, ăn cái gì,… cho đến chọn option nào, nên hỏi thêm gì, nên trình bày ra sao,… đều là những quyết định cần được đưa ra, chưa kể đến những quyết định lớn hơn như sự nghiệp, quan hệ, hướng đi, giá trị quan,… cũng cần có câu trả lời.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vâng một ngày, có rất nhiều quyết định cần được đưa ra, từ mặc quần áo gì, đi đường nào, ăn cái gì,… cho đến chọn option nào, nên hỏi thêm gì, nên trình bày ra sao,… đều là những quyết định cần được đưa ra, chưa kể đến những quyết định lớn hơn như sự nghiệp, quan hệ, hướng đi, giá trị quan,… cũng cần có câu trả lời.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80f9-bc31-d10b95ff878a",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:03:00.000Z",
        "last_edited_time": "2025-05-26T04:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy thì làm sao để có thể quyết định một cách khôn ngoan? Liệu có cách nào để chúng ta luôn bám theo mà quyết định được mọi thứ cho cuộc đời này?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy thì làm sao để có thể quyết định một cách khôn ngoan? Liệu có cách nào để chúng ta luôn bám theo mà quyết định được mọi thứ cho cuộc đời này?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80f5-bdf7-de9e27400a9c",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:10:00.000Z",
        "last_edited_time": "2025-05-26T04:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Biết cái nào cần quyết, cái nào không (như cách steve job chỉ mặc một bộ đồ để đỡ phải nghĩ mình cần mặc gì > concept ở đây là biến “những quyết định” không quan trọng thành auto pilot > tiết kiệm sức lực)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Biết cái nào cần quyết, cái nào không (như cách steve job chỉ mặc một bộ đồ để đỡ phải nghĩ mình cần mặc gì > concept ở đây là biến “những quyết định” không quan trọng thành auto pilot > tiết kiệm sức lực)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-8043-a5e7-f611f899353b",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:04:00.000Z",
        "last_edited_time": "2025-05-26T04:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Questions: là những câu hỏi dùng được cho mọi tình huống khi cần ra quyết định (ví dụ: một quyết định tối ưu chỉ khi ta có & đánh giá, cân nhắc được rất nhiều idea khác nhau > câu hỏi là mình đang có bao nhiêu direction, bao nhiêu option,…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Questions: là những câu hỏi dùng được cho mọi tình huống khi cần ra quyết định (ví dụ: một quyết định tối ưu chỉ khi ta có & đánh giá, cân nhắc được rất nhiều idea khác nhau > câu hỏi là mình đang có bao nhiêu direction, bao nhiêu option,…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-8056-b603-ef4cb447703c",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:05:00.000Z",
        "last_edited_time": "2025-05-26T04:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Học về decision making (criteria, benchmark, opportunity cost, secondary order thinking…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Học về decision making (criteria, benchmark, opportunity cost, secondary order thinking…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80b0-bfb7-ed7ba690db97",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:04:00.000Z",
        "last_edited_time": "2025-05-26T04:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Template hoá”, “Quy trình hoá” những cách ra quyết định tốt mà bản thân đã trải nghiệm qua.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Template hoá”, “Quy trình hoá” những cách ra quyết định tốt mà bản thân đã trải nghiệm qua.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-8041-8744-c9def251527b",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:13:00.000Z",
        "last_edited_time": "2025-05-26T04:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Questions & Frameworks",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Questions & Frameworks",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "💡"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80e6-ab74-c4a686eded0a",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:31:00.000Z",
        "last_edited_time": "2025-05-26T04:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081105/uxcomic-imgs/1ff5d164-78d8-80e6-ab74-c4a686eded0a.webp",
            "expiry_time": "2026-10-04T09:10:30.040Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1ff5d164-78d8-80e6-ab74-c4a686eded0a"
      },
      {
        "object": "block",
        "id": "2015d164-78d8-8003-8df8-cb4ec690d767",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-28T02:16:00.000Z",
        "last_edited_time": "2025-05-28T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-8047-82a0-c89a0210968c",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:13:00.000Z",
        "last_edited_time": "2025-05-26T04:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quá nhiều thứ cần được chiêm nghiệm",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quá nhiều thứ cần được chiêm nghiệm",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-8042-85d1-e2d04f4d3792",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:13:00.000Z",
        "last_edited_time": "2025-05-26T04:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mọi thứ trở nên vô bổ, rỗng tuế nếu mình chỉ nhớ & làm mà không đánh giá lại kết quả mình đạt được có tốt hay không, liệu mớ kiến thức, quyết định kia có thay đổi cuộc đời mình hay không, hay như áp dụng nó như 1 con vẹt.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mọi thứ trở nên vô bổ, rỗng tuế nếu mình chỉ nhớ & làm mà không đánh giá lại kết quả mình đạt được có tốt hay không, liệu mớ kiến thức, quyết định kia có thay đổi cuộc đời mình hay không, hay như áp dụng nó như 1 con vẹt.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80dc-948b-d44639c22200",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:15:00.000Z",
        "last_edited_time": "2025-05-26T04:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy tại sao chiêm nghiệm lại rất quan trọng?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy tại sao chiêm nghiệm lại rất quan trọng?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80e7-84f4-c6d58c19acaf",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:15:00.000Z",
        "last_edited_time": "2025-05-26T04:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vì bối cảnh mà người kia sản sinh ra kiến thức hay framework đó là từ kinh nghiệm & bối cảnh >> cách của họ, chưa chắc nó sẽ đúng cho mình mà cũng chưa chắc mình hành nó đúng cách >> luôn cần đánh giá lại những “feedback & signal” mà ngoài thế giới gửi lại cho mình >> từ đó mà tinh chỉnh, rút kết ra được cái gì đó rất riêng cho bản thân >> cái rút tỉa này đúng cho bối cảnh bản thân nên nó hiệu quả hơn nhiều.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vì bối cảnh mà người kia sản sinh ra kiến thức hay framework đó là từ kinh nghiệm & bối cảnh >> cách của họ, chưa chắc nó sẽ đúng cho mình mà cũng chưa chắc mình hành nó đúng cách >> luôn cần đánh giá lại những “feedback & signal” mà ngoài thế giới gửi lại cho mình >> từ đó mà tinh chỉnh, rút kết ra được cái gì đó rất riêng cho bản thân >> cái rút tỉa này đúng cho bối cảnh bản thân nên nó hiệu quả hơn nhiều.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80fb-a225-e9e232867936",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:17:00.000Z",
        "last_edited_time": "2025-05-26T04:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy thì câu chuyện tiếp theo là nhiều thứ quá thì hãy tập dần thôi, đừng để nó nhiều nữa. Như kiểu 1 nhà hoá học thử chất A (output bản thân) và chất B (phản ứng của xã hội & thế giới) > xem nó phản ứng với nhau như thế nào >>  bạn quan sát và note lại thành case study, note “quá trình & kết quả” >> đây là ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy thì câu chuyện tiếp theo là nhiều thứ quá thì hãy tập dần thôi, đừng để nó nhiều nữa. Như kiểu 1 nhà hoá học thử chất A (output bản thân) và chất B (phản ứng của xã hội & thế giới) > xem nó phản ứng với nhau như thế nào >>  bạn quan sát và note lại thành case study, note “quá trình & kết quả” >> đây là ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "kho báu",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "kho báu",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " của bản thân, cái mà ta gọi là kinh nghiệm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " của bản thân, cái mà ta gọi là kinh nghiệm.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80c6-a57b-d84669bf84b5",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:21:00.000Z",
        "last_edited_time": "2025-05-26T04:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy thói quen cần tập là",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy thói quen cần tập là",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80f5-83b6-f0de4630a901",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:21:00.000Z",
        "last_edited_time": "2025-05-26T04:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Journal theo project, theo case",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Journal theo project, theo case",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-802c-a3d3-c001133c2bc0",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:21:00.000Z",
        "last_edited_time": "2025-05-26T04:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Retro hàng quý, hàng năm",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Retro hàng quý, hàng năm",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80a9-bf70-ddf4666c5312",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:21:00.000Z",
        "last_edited_time": "2025-05-26T04:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kinh nghiệm = Chiêm nghiệm x Hành động",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kinh nghiệm = Chiêm nghiệm x Hành động",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "💡"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ff5d164-78d8-80ba-bcc6-f6f29b89da29",
        "parent": {
          "type": "page_id",
          "page_id": "1ff5d164-78d8-8089-ab9e-de9665e30a1f"
        },
        "created_time": "2025-05-26T04:38:00.000Z",
        "last_edited_time": "2025-05-26T04:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081107/uxcomic-imgs/1ff5d164-78d8-80ba-bcc6-f6f29b89da29.webp",
            "expiry_time": "2026-10-04T09:10:30.041Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1ff5d164-78d8-80ba-bcc6-f6f29b89da29"
      }
    ]
  },
  {
    "object": "page",
    "id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec",
    "created_time": "2025-05-23T05:08:00.000Z",
    "last_edited_time": "2025-08-28T13:37:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2025-05-23T05:08:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 22
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "2-Think",
          "color": "green"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-28T13:37:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "prxX",
          "name": "⚔️:2",
          "color": "yellow"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Observation",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Observation",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Observation-1fc5d16478d880caa762d0d1658b5eec",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
      "name": "Think",
      "slug": "think",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "1fd5d164-78d8-8015-bfa9-f9a1b758074d",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-24T08:44:00.000Z",
        "last_edited_time": "2025-06-08T06:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081110/uxcomic-imgs/1fd5d164-78d8-8015-bfa9-f9a1b758074d.png",
            "expiry_time": "2026-10-04T09:10:31.755Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1fd5d164-78d8-8015-bfa9-f9a1b758074d"
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-80fb-822b-e1640aea85e6",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T05:08:00.000Z",
        "last_edited_time": "2025-06-08T06:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sống trên đời này, ta liên tục phải “quan sát”, nó giúp ta tiếp thu thông tin, giúp ta tò mò & dùng những thông tin ấy cho việc hiểu ra gì đó, biết thêm gì đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sống trên đời này, ta liên tục phải “quan sát”, nó giúp ta tiếp thu thông tin, giúp ta tò mò & dùng những thông tin ấy cho việc hiểu ra gì đó, biết thêm gì đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-807c-b358-f8155291f866",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T05:12:00.000Z",
        "last_edited_time": "2025-06-08T06:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Biết là vậy, nhưng gần đây, mình thấy mình bị overwhelm bởi có quá nhiều thứ cần quan sát, mình thấy còn quá nhiều thứ cần phải biết, phải hiểu, nên cũng đang nghĩ cách để có thể quan sát mọi thứ một cách có chủ đích & có sự kiểm soát hơn, xong mình nghĩ ra được matrix này thấy cũng khá thú vị >> qua nó mình biết được mình đang biết & không biết cái gì >> rồi mới cân nhắc xem cách tiếp cận nào là phù hợp cho từng loại “quan sát”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Biết là vậy, nhưng gần đây, mình thấy mình bị overwhelm bởi có quá nhiều thứ cần quan sát, mình thấy còn quá nhiều thứ cần phải biết, phải hiểu, nên cũng đang nghĩ cách để có thể quan sát mọi thứ một cách có chủ đích & có sự kiểm soát hơn, xong mình nghĩ ra được matrix này thấy cũng khá thú vị >> qua nó mình biết được mình đang biết & không biết cái gì >> rồi mới cân nhắc xem cách tiếp cận nào là phù hợp cho từng loại “quan sát”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-8065-8be9-c9efe4b782a7",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T05:13:00.000Z",
        "last_edited_time": "2025-05-23T05:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-80c8-8917-f0cfa4811139",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T05:13:00.000Z",
        "last_edited_time": "2025-08-28T13:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình cần “quan sát” cái gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình cần “quan sát” cái gì?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-8023-8206-d49d2f4178d9",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T05:25:00.000Z",
        "last_edited_time": "2025-05-23T05:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu có thể phân loại các vùng thông tin để giúp ta hiểu được gì đó, thì mình nghĩ sẽ có ma trận như sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu có thể phân loại các vùng thông tin để giúp ta hiểu được gì đó, thì mình nghĩ sẽ có ma trận như sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-80e1-b887-cbf3f8be94cc",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T05:46:00.000Z",
        "last_edited_time": "2025-05-23T05:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081112/uxcomic-imgs/1fc5d164-78d8-80e1-b887-cbf3f8be94cc.png",
            "expiry_time": "2026-10-04T09:10:31.755Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1fc5d164-78d8-80e1-b887-cbf3f8be94cc"
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-80a2-a677-c19afdc756af",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T05:45:00.000Z",
        "last_edited_time": "2025-05-23T05:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-808b-bbde-ecb8683a2fce",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T05:41:00.000Z",
        "last_edited_time": "2025-06-09T01:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mục tiêu: Ta cần chuyển mọi thông tin sang “Ý thức + Đã biết” nhiều nhất có thể, vì nó là kiến thức, là thông tin ta có để ta nắm quyền kiểm soát hơn, từ đó có cái hiểu sáng suốt hơn và nhiều sự cân nhắc hơn khi đưa ra được quyết định .",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mục tiêu: Ta cần chuyển mọi thông tin sang “Ý thức + Đã biết” nhiều nhất có thể, vì nó là kiến thức, là thông tin ta có để ta nắm quyền kiểm soát hơn, từ đó có cái hiểu sáng suốt hơn và nhiều sự cân nhắc hơn khi đưa ra được quyết định .",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20d5d164-78d8-803e-823d-ca3958ee64a9",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-06-09T01:34:00.000Z",
        "last_edited_time": "2025-06-09T01:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-80cd-bf99-ea4ef91d18ab",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T05:47:00.000Z",
        "last_edited_time": "2025-05-23T05:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vô thức + Chưa biết",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vô thức + Chưa biết",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-80d9-854b-ed7c8ebc1339",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T05:50:00.000Z",
        "last_edited_time": "2025-05-23T05:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là những thứ bản năng, xu hướng hành động của chúng ta mà chính mình còn không nhận ra cho đến khi ai đó nói cho bạn biết hoặc tình cờ nhà khoa học nào đó khám phá ra và cho loài người biết.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là những thứ bản năng, xu hướng hành động của chúng ta mà chính mình còn không nhận ra cho đến khi ai đó nói cho bạn biết hoặc tình cờ nhà khoa học nào đó khám phá ra và cho loài người biết.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-80ff-801a-f20ed6c2bd7e",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T05:49:00.000Z",
        "last_edited_time": "2025-05-23T05:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-80a6-a9c4-ccdf467c9f5f",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T05:56:00.000Z",
        "last_edited_time": "2025-05-23T05:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Màu đỏ khiến tim ta đập nhanh & chú ý hơn vì liên quan đến máu, màu xanh dương khiến ta thấy tự do hơn vì nó là màu của bầu trời, của nước, từ xưa con người luôn tìm đến vùng nào có nước uống được để tụ tập sinh sống vì nó là một nguồn giúp duy trì sự sống & giúp tưới tiêu trồng trọt >> thấy nó là ta sẽ an lòng hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Màu đỏ khiến tim ta đập nhanh & chú ý hơn vì liên quan đến máu, màu xanh dương khiến ta thấy tự do hơn vì nó là màu của bầu trời, của nước, từ xưa con người luôn tìm đến vùng nào có nước uống được để tụ tập sinh sống vì nó là một nguồn giúp duy trì sự sống & giúp tưới tiêu trồng trọt >> thấy nó là ta sẽ an lòng hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-80cd-8ee2-d10dd83f4b85",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T05:56:00.000Z",
        "last_edited_time": "2025-05-23T05:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Những câu nói mình hay lặp đi lặp lại mà bạn bè nói mình mới biết.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Những câu nói mình hay lặp đi lặp lại mà bạn bè nói mình mới biết.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-8030-9968-f72beea3ac81",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T05:50:00.000Z",
        "last_edited_time": "2025-05-23T05:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vô thức + Đã biết ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vô thức + Đã biết ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-8071-afe2-e003e7399b57",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T05:53:00.000Z",
        "last_edited_time": "2025-05-23T05:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là những thứ bạn biết được rồi, nhưng sẽ khó lòng mà kiểm soát nó hoạt động theo vô thức. Nên việc mình biết chỉ giúp ích cho việc mình nên set up môi trường xung quanh ra sao cho phù hợp hoặc tăng sự nhận thức thôi.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là những thứ bạn biết được rồi, nhưng sẽ khó lòng mà kiểm soát nó hoạt động theo vô thức. Nên việc mình biết chỉ giúp ích cho việc mình nên set up môi trường xung quanh ra sao cho phù hợp hoặc tăng sự nhận thức thôi.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-808e-b5e0-c2fbc3cfee9a",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T06:17:00.000Z",
        "last_edited_time": "2025-05-23T06:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để chuyển từ vô thức - chưa biết sang đã biết, có một bài tập mà chắc bạn cũng nghe đến: thiền & trí thông minh cảm xúc, feedback 360 độ, tự phản tư…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để chuyển từ vô thức - chưa biết sang đã biết, có một bài tập mà chắc bạn cũng nghe đến: thiền & trí thông minh cảm xúc, feedback 360 độ, tự phản tư…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-80b9-8c3b-c36f97a3d6ee",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T05:53:00.000Z",
        "last_edited_time": "2025-05-23T05:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lấy ví dụ: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lấy ví dụ: ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-8077-86bd-ce7c98f56a53",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T05:58:00.000Z",
        "last_edited_time": "2025-05-23T06:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lúc nóng giận hay buồn bã, ta thường ra quyết định thiếu tính sáng suốt vì lúc đó ta chỉ tập trung vào những thông tin tiêu cực >> bạn rút kinh nghiệm, để bình tĩnh rồi mới hẳn cân nhắc việc quyết định.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lúc nóng giận hay buồn bã, ta thường ra quyết định thiếu tính sáng suốt vì lúc đó ta chỉ tập trung vào những thông tin tiêu cực >> bạn rút kinh nghiệm, để bình tĩnh rồi mới hẳn cân nhắc việc quyết định.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-80d4-91f9-ff9d33c48078",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T05:58:00.000Z",
        "last_edited_time": "2025-05-23T06:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Màu đỏ liên quan đến thức ăn nhiều hơn nên các brand fast food phần lớn chọn màu này để gây sự chú ý & tạo cảm giác thèm ăn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Màu đỏ liên quan đến thức ăn nhiều hơn nên các brand fast food phần lớn chọn màu này để gây sự chú ý & tạo cảm giác thèm ăn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-80fc-a19d-eba29069c4a9",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T06:07:00.000Z",
        "last_edited_time": "2025-05-23T06:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đôi khi trong vùng này ta còn có tự gọi là “trực giác”, ta không lí giải được nhưng nó ngầm báo hiệu ta gì đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đôi khi trong vùng này ta còn có tự gọi là “trực giác”, ta không lí giải được nhưng nó ngầm báo hiệu ta gì đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-80c8-80fb-ddea85651dfd",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T05:55:00.000Z",
        "last_edited_time": "2025-05-23T06:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ý thức + Chưa biết",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ý thức + Chưa biết",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-8028-926e-dea258b3c8f6",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T06:00:00.000Z",
        "last_edited_time": "2025-05-23T06:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Câu nói này sẽ giúp bạn hiểu được term này hơn nè: “biết những thứ ta chưa biết đôi khi quan trọng hơn những thứ ta đã biết”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Câu nói này sẽ giúp bạn hiểu được term này hơn nè: “biết những thứ ta chưa biết đôi khi quan trọng hơn những thứ ta đã biết”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-806a-914e-db4e75dba451",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T06:01:00.000Z",
        "last_edited_time": "2025-05-23T06:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-80f0-abe4-fb137cdde785",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T06:25:00.000Z",
        "last_edited_time": "2025-05-23T06:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chắc mình đã nghe qua từ “lạm phát”, nhưng ta chỉ biết hậu quả của nó là làm đồng tiền mất giá, còn tại sao lại như thế, điều gì tác động lên lạm phát thì ta gần như mù mờ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chắc mình đã nghe qua từ “lạm phát”, nhưng ta chỉ biết hậu quả của nó là làm đồng tiền mất giá, còn tại sao lại như thế, điều gì tác động lên lạm phát thì ta gần như mù mờ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-8035-9e8e-d0fcf922e0e9",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T06:25:00.000Z",
        "last_edited_time": "2025-05-23T06:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giả sử mình đã biết đến chữ leader rồi, nhưng scope & responsibility và skills cần có thì mình không hề biết, vị trí đó có những bài toán, những khó khăn nào mình cũng không biết.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giả sử mình đã biết đến chữ leader rồi, nhưng scope & responsibility và skills cần có thì mình không hề biết, vị trí đó có những bài toán, những khó khăn nào mình cũng không biết.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-80b9-aea6-e330722b31d6",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T06:20:00.000Z",
        "last_edited_time": "2025-05-23T06:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Việc quan trọng nhất với những thông tin vùng này là biết chọn cái gì để ta nghiền ngẫm thêm. Nếu biết chọn một cách có chiến lược, nó sẽ là nền móng rất tốt để mở rộng nhân sinh quan của chúng ta.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Việc quan trọng nhất với những thông tin vùng này là biết chọn cái gì để ta nghiền ngẫm thêm. Nếu biết chọn một cách có chiến lược, nó sẽ là nền móng rất tốt để mở rộng nhân sinh quan của chúng ta.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-80be-9f70-f3ba2b9118c4",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T06:26:00.000Z",
        "last_edited_time": "2025-05-23T06:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ngược lại, nếu thấy không ý thức được ít thứ ta chưa biết quá có thể là mình thiếu sự quan sát, ù lì hoặc quá tự cao >> thế giới quan ta quá nhỏ hoặc ta tự giới hạn nó lại.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ngược lại, nếu thấy không ý thức được ít thứ ta chưa biết quá có thể là mình thiếu sự quan sát, ù lì hoặc quá tự cao >> thế giới quan ta quá nhỏ hoặc ta tự giới hạn nó lại.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-807d-b51a-daed30f80c23",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T06:01:00.000Z",
        "last_edited_time": "2025-05-23T06:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ý thức + Đã biết",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ý thức + Đã biết",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-8016-8c2a-efd41124b89a",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T05:54:00.000Z",
        "last_edited_time": "2025-05-23T06:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Này thì dễ hiểu rồi, chắc không cần giải thích thêm. Cái quan trọng nhất ở vùng này là cần nhận thức được:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Này thì dễ hiểu rồi, chắc không cần giải thích thêm. Cái quan trọng nhất ở vùng này là cần nhận thức được:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-80d6-a661-fad3768a1627",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T06:28:00.000Z",
        "last_edited_time": "2025-06-11T06:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình biết nó đến mức độ nào. Mình có cái nhìn hệ thống về nó không (nó được tạo thành như thế nào, nó có mấy loại, giữa nó và những thứ khác tác động thế nào…, nguyên lý hoạt động, bản chất nó là gì). Tip luyện tập ý thức thêm những thứ đã biết một cách sâu sắc hơn là research về “phương pháp luận”, “framework”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình biết nó đến mức độ nào. Mình có cái nhìn hệ thống về nó không (nó được tạo thành như thế nào, nó có mấy loại, giữa nó và những thứ khác tác động thế nào…, nguyên lý hoạt động, bản chất nó là gì). Tip luyện tập ý thức thêm những thứ đã biết một cách sâu sắc hơn là research về “phương pháp luận”, “framework”.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-8054-933e-ffac67433803",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T06:29:00.000Z",
        "last_edited_time": "2025-06-11T06:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đừng tưởng mình biết hết, sẽ luôn có gì đó bạn chưa biết trong cái thứ bạn biết >> ta gọi đây là những điểm mù. Người thông minh sẽ biết cách để hạn chế điểm mù này, ví dụ như hỏi thêm ý kiến người khác, tự phản biện, nhìn ở nhiều angle, tiếp nhận góc nhìn trái chiều, nhìn sâu thêm hoặc rộng thêm 1 level nữa thì nó là gì…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đừng tưởng mình biết hết, sẽ luôn có gì đó bạn chưa biết trong cái thứ bạn biết >> ta gọi đây là những điểm mù. Người thông minh sẽ biết cách để hạn chế điểm mù này, ví dụ như hỏi thêm ý kiến người khác, tự phản biện, nhìn ở nhiều angle, tiếp nhận góc nhìn trái chiều, nhìn sâu thêm hoặc rộng thêm 1 level nữa thì nó là gì…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20f5d164-78d8-801f-8b63-d3f081a3c68b",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-06-11T06:36:00.000Z",
        "last_edited_time": "2025-06-11T06:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đây có thể là vùng mà mình sẽ muốn tốn nhiều effort nhất để nghĩ về nó, vì ta đã có sẵn những dự kiện, nó như một viên ngọc thô chờ được mài giũa, tại sao không tận dụng nó phải không? Có hàng tá thứ mình đã already biết nhưng chưa hề sâu. Ví dụ: “tiền là gì?”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đây có thể là vùng mà mình sẽ muốn tốn nhiều effort nhất để nghĩ về nó, vì ta đã có sẵn những dự kiện, nó như một viên ngọc thô chờ được mài giũa, tại sao không tận dụng nó phải không? Có hàng tá thứ mình đã already biết nhưng chưa hề sâu. Ví dụ: “tiền là gì?”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-80b1-8ad8-cb7ba20b74a6",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T06:34:00.000Z",
        "last_edited_time": "2025-05-23T06:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-8076-ad2d-fb572925fe7e",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T06:34:00.000Z",
        "last_edited_time": "2025-05-23T06:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Items",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Items",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-8036-97fe-eaa48121c11e",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T06:34:00.000Z",
        "last_edited_time": "2025-05-23T06:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "95727332-bdb3-4f63-a0cd-f9023732995d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Questioning (P1)",
              "href": "https://app.notion.com/p/95727332bdb34f63a0cdf9023732995d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-808b-ae97-e53aefc9b767",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T06:34:00.000Z",
        "last_edited_time": "2025-05-23T06:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1fb5d164-78d8-80a0-b63e-e8f5c8dbdc6f"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Deal with unknown",
              "href": "https://app.notion.com/p/1fb5d16478d880a0b63ee8f5c8dbdc6f"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-80e3-a954-cde7cb7577cd",
        "parent": {
          "type": "page_id",
          "page_id": "1fc5d164-78d8-80ca-a762-d0d1658b5eec"
        },
        "created_time": "2025-05-23T06:34:00.000Z",
        "last_edited_time": "2025-05-23T06:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sense making",
              "href": "https://app.notion.com/p/1195d16478d880cda21ff9d0e90ae7b8"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1",
    "created_time": "2024-12-31T00:15:00.000Z",
    "last_edited_time": "2025-08-19T08:27:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-12-31T00:15:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 18
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "1-Design",
          "color": "default"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-19T08:27:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "sgq|",
          "name": "⚔️:1",
          "color": "red"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Your design suck if…",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Your design suck if…",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Your-design-suck-if-16d5d16478d8801faa40c2aeb6b36bc1",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Design",
      "slug": "design",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "16d5d164-78d8-81aa-a676-d50b937dbf26",
        "parent": {
          "type": "page_id",
          "page_id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1"
        },
        "created_time": "2024-12-31T00:15:00.000Z",
        "last_edited_time": "2024-12-31T02:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081144/uxcomic-imgs/16d5d164-78d8-81aa-a676-d50b937dbf26.png",
            "expiry_time": "2026-10-04T09:10:32.512Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/16d5d164-78d8-81aa-a676-d50b937dbf26"
      },
      {
        "object": "block",
        "id": "16d5d164-78d8-801d-9925-f76d4d1298ca",
        "parent": {
          "type": "page_id",
          "page_id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1"
        },
        "created_time": "2024-12-31T00:38:00.000Z",
        "last_edited_time": "2024-12-31T00:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reminder cho bản thân mỗi khi design 1 project gì đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reminder cho bản thân mỗi khi design 1 project gì đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23d5d164-78d8-80b1-a612-f22ca14255f4",
        "parent": {
          "type": "page_id",
          "page_id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1"
        },
        "created_time": "2025-07-27T01:16:00.000Z",
        "last_edited_time": "2025-07-27T01:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Talked too much about the solution/artifact, not enough about the problem or context.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Talked too much about the solution/artifact, not enough about the problem or context.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "💩"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23d5d164-78d8-8018-8cbb-e2cb3987905b",
        "parent": {
          "type": "page_id",
          "page_id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1"
        },
        "created_time": "2025-07-27T01:15:00.000Z",
        "last_edited_time": "2025-07-27T01:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "No initial definition of success metrics, hypotheses, or assumptions",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "No initial definition of success metrics, hypotheses, or assumptions",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "💩"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16d5d164-78d8-80c3-8fd1-db76edf57f8d",
        "parent": {
          "type": "page_id",
          "page_id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1"
        },
        "created_time": "2024-12-31T00:21:00.000Z",
        "last_edited_time": "2025-07-27T01:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "No hierarchy (not only in screen, but whole flow, whole app experience)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "No hierarchy (not only in screen, but whole flow, whole app experience)",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "💥"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16d5d164-78d8-81e9-936c-c5edd5845dd9",
        "parent": {
          "type": "page_id",
          "page_id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1"
        },
        "created_time": "2024-12-31T00:15:00.000Z",
        "last_edited_time": "2024-12-31T00:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Happy path only — no attention to edge cases or what-if scenarios",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Happy path only — no attention to edge cases or what-if scenarios",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "🥲"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16d5d164-78d8-80f7-be16-d3fac1b908c6",
        "parent": {
          "type": "page_id",
          "page_id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1"
        },
        "created_time": "2024-12-31T00:29:00.000Z",
        "last_edited_time": "2024-12-31T00:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Inconsistent UI / Interaction pattern",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Inconsistent UI / Interaction pattern",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "😵‍💫"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8008-9c31-c0840a576b4e",
        "parent": {
          "type": "page_id",
          "page_id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1"
        },
        "created_time": "2025-08-19T08:26:00.000Z",
        "last_edited_time": "2025-08-19T08:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Not aware UX Friction Loop",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Not aware UX Friction Loop",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "😵‍💫"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16d5d164-78d8-800d-bfa6-e4b4b2945056",
        "parent": {
          "type": "page_id",
          "page_id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1"
        },
        "created_time": "2024-12-31T00:16:00.000Z",
        "last_edited_time": "2024-12-31T00:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Just stop at ensuring usability, not experience",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Just stop at ensuring usability, not experience",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "🤓"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23d5d164-78d8-8035-a3f4-c060a4f0f8b4",
        "parent": {
          "type": "page_id",
          "page_id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1"
        },
        "created_time": "2025-07-27T01:12:00.000Z",
        "last_edited_time": "2025-07-27T01:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Too many intention in one screen",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Too many intention in one screen",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "🕳️"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16d5d164-78d8-80ac-96f1-f92800b717e8",
        "parent": {
          "type": "page_id",
          "page_id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1"
        },
        "created_time": "2024-12-31T00:23:00.000Z",
        "last_edited_time": "2025-07-27T01:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "You forgot UX writing. Words shape thoughts, and thoughts shape actions",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "You forgot UX writing. Words shape thoughts, and thoughts shape actions",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "🙊"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16d5d164-78d8-8064-85fd-e3d2bafca8bf",
        "parent": {
          "type": "page_id",
          "page_id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1"
        },
        "created_time": "2024-12-31T00:20:00.000Z",
        "last_edited_time": "2025-07-27T01:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Not seeking any feedback for user, from stakeholders",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Not seeking any feedback for user, from stakeholders",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "🙉"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16d5d164-78d8-8072-b4f8-e0a423d2a89c",
        "parent": {
          "type": "page_id",
          "page_id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1"
        },
        "created_time": "2024-12-31T00:40:00.000Z",
        "last_edited_time": "2025-07-27T01:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Just have one option to consider",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Just have one option to consider",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "🤡"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16d5d164-78d8-81d3-bd5a-f7c6202871eb",
        "parent": {
          "type": "page_id",
          "page_id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1"
        },
        "created_time": "2024-12-31T00:15:00.000Z",
        "last_edited_time": "2024-12-31T00:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-808f-af54-f6895fc039e7",
        "parent": {
          "type": "page_id",
          "page_id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1"
        },
        "created_time": "2025-08-19T08:26:00.000Z",
        "last_edited_time": "2025-08-19T08:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8082-9820-c105b1f601af",
        "parent": {
          "type": "page_id",
          "page_id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1"
        },
        "created_time": "2025-08-19T08:26:00.000Z",
        "last_edited_time": "2025-08-19T08:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://medium.com/design-bootcamp/ux-loop-friction-identifying-hidden-breaks-in-repetitive-user-journeys-164044d052dd",
                "link": {
                  "url": "https://medium.com/design-bootcamp/ux-loop-friction-identifying-hidden-breaks-in-repetitive-user-journeys-164044d052dd"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://medium.com/design-bootcamp/ux-loop-friction-identifying-hidden-breaks-in-repetitive-user-journeys-164044d052dd",
              "href": "https://medium.com/design-bootcamp/ux-loop-friction-identifying-hidden-breaks-in-repetitive-user-journeys-164044d052dd"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8057-9be2-c209b6d03603",
        "parent": {
          "type": "page_id",
          "page_id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1"
        },
        "created_time": "2025-08-19T08:26:00.000Z",
        "last_edited_time": "2025-08-19T08:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "16d5d164-78d8-81e0-9102-cc6a412e2633",
        "parent": {
          "type": "page_id",
          "page_id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1"
        },
        "created_time": "2024-12-31T00:15:00.000Z",
        "last_edited_time": "2024-12-31T00:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16d5d164-78d8-8041-b8ca-e974c69c651e",
        "parent": {
          "type": "page_id",
          "page_id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1"
        },
        "created_time": "2024-12-31T00:36:00.000Z",
        "last_edited_time": "2024-12-31T00:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1605d164-78d8-80ad-9130-fe44c6663146"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Value vs Benefit",
              "href": "https://app.notion.com/p/1605d16478d880ad9130fe44c6663146"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16d5d164-78d8-8012-959b-f4867ddc31ff",
        "parent": {
          "type": "page_id",
          "page_id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1"
        },
        "created_time": "2024-12-31T00:36:00.000Z",
        "last_edited_time": "2024-12-31T00:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Design value",
              "href": "https://app.notion.com/p/ed40fd40a3184fd6a63f0067b4e54861"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16d5d164-78d8-804c-8df0-dec46874c201",
        "parent": {
          "type": "page_id",
          "page_id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1"
        },
        "created_time": "2024-12-31T00:36:00.000Z",
        "last_edited_time": "2024-12-31T00:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User Journey map, User scenario, Task flow, User flow",
              "href": "https://app.notion.com/p/1155d16478d880a883a6ec9db47fe4dc"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16d5d164-78d8-8070-836f-dfebd2719634",
        "parent": {
          "type": "page_id",
          "page_id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1"
        },
        "created_time": "2024-12-31T00:42:00.000Z",
        "last_edited_time": "2024-12-31T00:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Figjam before Figma”",
              "href": "https://app.notion.com/p/b3551d4fd6db48b293bd21c9a7ea792e"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16d5d164-78d8-809a-a4b8-ea1aa43cb04e",
        "parent": {
          "type": "page_id",
          "page_id": "16d5d164-78d8-801f-aa40-c2aeb6b36bc1"
        },
        "created_time": "2024-12-31T00:42:00.000Z",
        "last_edited_time": "2024-12-31T00:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ideate (P2)",
              "href": "https://app.notion.com/p/15e5d16478d880c8ac9eff1a29784a09"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1605d164-78d8-80c3-b322-f577530e7916",
    "created_time": "2024-12-18T02:02:00.000Z",
    "last_edited_time": "2025-08-29T15:41:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-12-18T02:02:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 17
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "2-Think",
          "color": "green"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-29T15:41:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "prxX",
          "name": "⚔️:2",
          "color": "yellow"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Questionnaire toolkit",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Questionnaire toolkit",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Questionnaire-toolkit-1605d16478d880c3b322f577530e7916",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
      "name": "Think",
      "slug": "think",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "1605d164-78d8-8118-8f8f-d5362ffbb4ae",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80c3-b322-f577530e7916"
        },
        "created_time": "2024-12-18T02:02:00.000Z",
        "last_edited_time": "2024-12-30T12:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081146/uxcomic-imgs/1605d164-78d8-8118-8f8f-d5362ffbb4ae.png",
            "expiry_time": "2026-10-04T09:10:33.009Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1605d164-78d8-8118-8f8f-d5362ffbb4ae"
      },
      {
        "object": "block",
        "id": "1605d164-78d8-809e-948b-fe9975f6d2b9",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80c3-b322-f577530e7916"
        },
        "created_time": "2024-12-18T04:22:00.000Z",
        "last_edited_time": "2024-12-24T06:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giống như mô hình diamond thinking, ta có divergent (mở rộng) & convergent (thu hẹp) thinking. Thì câu hỏi cũng có thể chia làm 2 category chính: open-end & closed-end questions.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giống như mô hình diamond thinking, ta có divergent (mở rộng) & convergent (thu hẹp) thinking. Thì câu hỏi cũng có thể chia làm 2 category chính: open-end & closed-end questions.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80ae-88c7-d6b46b69efd2",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80c3-b322-f577530e7916"
        },
        "created_time": "2024-12-18T03:55:00.000Z",
        "last_edited_time": "2025-07-18T07:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081148/uxcomic-imgs/1605d164-78d8-80ae-88c7-d6b46b69efd2.png",
            "expiry_time": "2026-10-04T09:10:33.009Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1605d164-78d8-80ae-88c7-d6b46b69efd2"
      },
      {
        "object": "block",
        "id": "2345d164-78d8-80e1-965e-cc52e58763e5",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80c3-b322-f577530e7916"
        },
        "created_time": "2025-07-18T07:05:00.000Z",
        "last_edited_time": "2025-08-29T15:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Test",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Test",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "25e5d164-78d8-80fa-aebe-f3bd437116f0",
            "parent": {
              "type": "block_id",
              "block_id": "2345d164-78d8-80e1-965e-cc52e58763e5"
            },
            "created_time": "2025-08-29T15:39:00.000Z",
            "last_edited_time": "2025-08-29T15:39:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756482504/uxcomic-imgs/25e5d164-78d8-80fa-aebe-f3bd437116f0.png",
                "expiry_time": "2026-10-04T09:10:33.570Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-80fa-aebe-f3bd437116f0"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-805d-9929-e22b0f1abfc0",
            "parent": {
              "type": "block_id",
              "block_id": "2345d164-78d8-80e1-965e-cc52e58763e5"
            },
            "created_time": "2025-08-29T15:39:00.000Z",
            "last_edited_time": "2025-08-29T15:39:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756482505/uxcomic-imgs/25e5d164-78d8-805d-9929-e22b0f1abfc0.png",
                "expiry_time": "2026-10-04T09:10:33.571Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-805d-9929-e22b0f1abfc0"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-8018-8c6f-c59c21f1d080",
            "parent": {
              "type": "block_id",
              "block_id": "2345d164-78d8-80e1-965e-cc52e58763e5"
            },
            "created_time": "2025-08-29T15:39:00.000Z",
            "last_edited_time": "2025-08-29T15:39:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756482506/uxcomic-imgs/25e5d164-78d8-8018-8c6f-c59c21f1d080.png",
                "expiry_time": "2026-10-04T09:10:33.571Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-8018-8c6f-c59c21f1d080"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-806b-8942-eb75cdbb37a1",
            "parent": {
              "type": "block_id",
              "block_id": "2345d164-78d8-80e1-965e-cc52e58763e5"
            },
            "created_time": "2025-08-29T15:39:00.000Z",
            "last_edited_time": "2025-08-29T15:39:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756482508/uxcomic-imgs/25e5d164-78d8-806b-8942-eb75cdbb37a1.png",
                "expiry_time": "2026-10-04T09:10:33.571Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-806b-8942-eb75cdbb37a1"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-8078-be49-f56ee7378b5c",
            "parent": {
              "type": "block_id",
              "block_id": "2345d164-78d8-80e1-965e-cc52e58763e5"
            },
            "created_time": "2025-08-29T15:39:00.000Z",
            "last_edited_time": "2025-08-29T15:39:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756482509/uxcomic-imgs/25e5d164-78d8-8078-be49-f56ee7378b5c.png",
                "expiry_time": "2026-10-04T09:10:33.571Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-8078-be49-f56ee7378b5c"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-801a-8944-f97a8dc6f1eb",
            "parent": {
              "type": "block_id",
              "block_id": "2345d164-78d8-80e1-965e-cc52e58763e5"
            },
            "created_time": "2025-08-29T15:39:00.000Z",
            "last_edited_time": "2025-08-29T15:39:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756482510/uxcomic-imgs/25e5d164-78d8-801a-8944-f97a8dc6f1eb.png",
                "expiry_time": "2026-10-04T09:10:33.571Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-801a-8944-f97a8dc6f1eb"
          }
        ]
      },
      {
        "object": "block",
        "id": "25e5d164-78d8-8048-8c00-e1a5ec1d84d1",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80c3-b322-f577530e7916"
        },
        "created_time": "2025-08-29T15:37:00.000Z",
        "last_edited_time": "2025-08-29T15:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-81d3-a6be-c4b0a12335de",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80c3-b322-f577530e7916"
        },
        "created_time": "2024-12-18T02:02:00.000Z",
        "last_edited_time": "2024-12-18T02:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8157-9b07-c13eb8e9c859",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80c3-b322-f577530e7916"
        },
        "created_time": "2024-12-18T02:02:00.000Z",
        "last_edited_time": "2024-12-18T02:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-81da-9cd0-d499d12c451a",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80c3-b322-f577530e7916"
        },
        "created_time": "2024-12-18T02:02:00.000Z",
        "last_edited_time": "2024-12-18T03:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.nngroup.com/articles/open-ended-questions/",
                "link": {
                  "url": "https://www.nngroup.com/articles/open-ended-questions/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.nngroup.com/articles/open-ended-questions/",
              "href": "https://www.nngroup.com/articles/open-ended-questions/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80c5-a8d0-e092db56940e",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80c3-b322-f577530e7916"
        },
        "created_time": "2024-12-18T04:39:00.000Z",
        "last_edited_time": "2024-12-18T04:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.fearlessculture.design/blog-posts/the-power-of-clarifying-questions-and-how-to-improve-team-conversations",
                "link": {
                  "url": "https://www.fearlessculture.design/blog-posts/the-power-of-clarifying-questions-and-how-to-improve-team-conversations"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.fearlessculture.design/blog-posts/the-power-of-clarifying-questions-and-how-to-improve-team-conversations",
              "href": "https://www.fearlessculture.design/blog-posts/the-power-of-clarifying-questions-and-how-to-improve-team-conversations"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8197-b507-d147d3038a80",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80c3-b322-f577530e7916"
        },
        "created_time": "2024-12-18T02:02:00.000Z",
        "last_edited_time": "2024-12-18T02:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8137-8e27-e36391ad201e",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80c3-b322-f577530e7916"
        },
        "created_time": "2024-12-18T02:02:00.000Z",
        "last_edited_time": "2024-12-18T02:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-814c-80f5-d30098e4c8f1",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80c3-b322-f577530e7916"
        },
        "created_time": "2024-12-18T02:02:00.000Z",
        "last_edited_time": "2024-12-18T04:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Questioning (P2)",
              "href": "https://app.notion.com/p/1435d16478d88004930ce9f3fede9fe4"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-81f5-b78b-e69db2d87762",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80c3-b322-f577530e7916"
        },
        "created_time": "2024-12-18T02:02:00.000Z",
        "last_edited_time": "2024-12-18T04:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sense making",
              "href": "https://app.notion.com/p/1195d16478d880cda21ff9d0e90ae7b8"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1595d164-78d8-80b4-a0bc-c10c9eb29a87",
    "created_time": "2024-12-11T10:57:00.000Z",
    "last_edited_time": "2025-08-29T16:16:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-12-11T10:57:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 15
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "2-Think",
          "color": "green"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-29T16:16:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "prxX",
          "name": "⚔️:2",
          "color": "yellow"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Judging",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Judging",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Judging-1595d16478d880b4a0bcc10c9eb29a87",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
      "name": "Think",
      "slug": "think",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "25e5d164-78d8-807e-9e12-d81a78d2bbd8",
        "parent": {
          "type": "page_id",
          "page_id": "1595d164-78d8-80b4-a0bc-c10c9eb29a87"
        },
        "created_time": "2025-08-29T15:31:00.000Z",
        "last_edited_time": "2025-08-29T15:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756482511/uxcomic-imgs/25e5d164-78d8-807e-9e12-d81a78d2bbd8.png",
            "expiry_time": "2026-10-04T09:10:36.544Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/25e5d164-78d8-807e-9e12-d81a78d2bbd8"
      },
      {
        "object": "block",
        "id": "23d5d164-78d8-802f-80f0-d9f3c27911e0",
        "parent": {
          "type": "page_id",
          "page_id": "1595d164-78d8-80b4-a0bc-c10c9eb29a87"
        },
        "created_time": "2025-07-27T01:28:00.000Z",
        "last_edited_time": "2025-07-27T01:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi judge sự việc, judge con người, judge idea, judge message…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi judge sự việc, judge con người, judge idea, judge message…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23d5d164-78d8-8025-9825-e32eeddb00cb",
        "parent": {
          "type": "page_id",
          "page_id": "1595d164-78d8-80b4-a0bc-c10c9eb29a87"
        },
        "created_time": "2025-07-27T01:28:00.000Z",
        "last_edited_time": "2025-08-29T16:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "list",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "list",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "25e5d164-78d8-80d0-9d62-f13534bc6f6f",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-8025-9825-e32eeddb00cb"
            },
            "created_time": "2025-08-29T15:19:00.000Z",
            "last_edited_time": "2025-08-29T15:20:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756482515/uxcomic-imgs/25e5d164-78d8-80d0-9d62-f13534bc6f6f.png",
                "expiry_time": "2026-10-04T09:10:37.210Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-80d0-9d62-f13534bc6f6f"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-80ec-8c89-f7c3b5ab1103",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-8025-9825-e32eeddb00cb"
            },
            "created_time": "2025-08-29T16:16:00.000Z",
            "last_edited_time": "2025-08-29T16:16:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756484254/uxcomic-imgs/25e5d164-78d8-80ec-8c89-f7c3b5ab1103.png",
                "expiry_time": "2026-10-04T09:10:37.210Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-80ec-8c89-f7c3b5ab1103"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-800d-8f11-edfb48e171f8",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-8025-9825-e32eeddb00cb"
            },
            "created_time": "2025-08-29T15:19:00.000Z",
            "last_edited_time": "2025-08-29T15:20:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756482517/uxcomic-imgs/25e5d164-78d8-800d-8f11-edfb48e171f8.png",
                "expiry_time": "2026-10-04T09:10:37.210Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-800d-8f11-edfb48e171f8"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-80d3-a331-e6ad29b50419",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-8025-9825-e32eeddb00cb"
            },
            "created_time": "2025-08-29T15:19:00.000Z",
            "last_edited_time": "2025-08-29T15:20:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756482518/uxcomic-imgs/25e5d164-78d8-80d3-a331-e6ad29b50419.png",
                "expiry_time": "2026-10-04T09:10:37.210Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-80d3-a331-e6ad29b50419"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-8001-9210-dec7a636b7ee",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-8025-9825-e32eeddb00cb"
            },
            "created_time": "2025-08-29T15:19:00.000Z",
            "last_edited_time": "2025-08-29T15:20:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756482519/uxcomic-imgs/25e5d164-78d8-8001-9210-dec7a636b7ee.png",
                "expiry_time": "2026-10-04T09:10:37.210Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-8001-9210-dec7a636b7ee"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-80b6-a599-c840d15a1057",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-8025-9825-e32eeddb00cb"
            },
            "created_time": "2025-08-29T15:19:00.000Z",
            "last_edited_time": "2025-08-29T15:19:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756482520/uxcomic-imgs/25e5d164-78d8-80b6-a599-c840d15a1057.png",
                "expiry_time": "2026-10-04T09:10:37.210Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-80b6-a599-c840d15a1057"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-808e-872f-c4647c85c173",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-8025-9825-e32eeddb00cb"
            },
            "created_time": "2025-08-29T15:19:00.000Z",
            "last_edited_time": "2025-08-29T15:20:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756482521/uxcomic-imgs/25e5d164-78d8-808e-872f-c4647c85c173.png",
                "expiry_time": "2026-10-04T09:10:37.210Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-808e-872f-c4647c85c173"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-80c5-99a5-d00e142aba47",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-8025-9825-e32eeddb00cb"
            },
            "created_time": "2025-08-29T15:19:00.000Z",
            "last_edited_time": "2025-08-29T15:20:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756482522/uxcomic-imgs/25e5d164-78d8-80c5-99a5-d00e142aba47.png",
                "expiry_time": "2026-10-04T09:10:37.210Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-80c5-99a5-d00e142aba47"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-8078-8274-f1ffb4884409",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-8025-9825-e32eeddb00cb"
            },
            "created_time": "2025-08-29T15:19:00.000Z",
            "last_edited_time": "2025-08-29T15:20:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756482523/uxcomic-imgs/25e5d164-78d8-8078-8274-f1ffb4884409.png",
                "expiry_time": "2026-10-04T09:10:37.211Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-8078-8274-f1ffb4884409"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-80d0-b7c2-f03e2e5f770f",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-8025-9825-e32eeddb00cb"
            },
            "created_time": "2025-08-29T15:19:00.000Z",
            "last_edited_time": "2025-08-29T15:20:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756482524/uxcomic-imgs/25e5d164-78d8-80d0-b7c2-f03e2e5f770f.png",
                "expiry_time": "2026-10-04T09:10:37.211Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-80d0-b7c2-f03e2e5f770f"
          }
        ]
      },
      {
        "object": "block",
        "id": "2495d164-78d8-80f8-8bde-d037e28a74d0",
        "parent": {
          "type": "page_id",
          "page_id": "1595d164-78d8-80b4-a0bc-c10c9eb29a87"
        },
        "created_time": "2025-08-08T06:37:00.000Z",
        "last_edited_time": "2025-08-08T06:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2495d164-78d8-807e-903e-de5ce1ba3647",
        "parent": {
          "type": "page_id",
          "page_id": "1595d164-78d8-80b4-a0bc-c10c9eb29a87"
        },
        "created_time": "2025-08-08T06:35:00.000Z",
        "last_edited_time": "2025-08-08T06:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2495d164-78d8-8051-8922-dcffaa2826a7",
        "parent": {
          "type": "page_id",
          "page_id": "1595d164-78d8-80b4-a0bc-c10c9eb29a87"
        },
        "created_time": "2025-08-08T06:37:00.000Z",
        "last_edited_time": "2025-08-08T06:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Specific cho case judge ideas",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Specific cho case judge ideas",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2495d164-78d8-800b-aeab-c91df189c6de",
        "parent": {
          "type": "page_id",
          "page_id": "1595d164-78d8-80b4-a0bc-c10c9eb29a87"
        },
        "created_time": "2025-08-08T06:38:00.000Z",
        "last_edited_time": "2025-08-08T06:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754638103/uxcomic-imgs/2495d164-78d8-800b-aeab-c91df189c6de.jpg",
            "expiry_time": "2026-10-04T09:10:36.544Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2495d164-78d8-800b-aeab-c91df189c6de"
      },
      {
        "object": "block",
        "id": "2495d164-78d8-80cc-b7d1-e069d6c78bb4",
        "parent": {
          "type": "page_id",
          "page_id": "1595d164-78d8-80b4-a0bc-c10c9eb29a87"
        },
        "created_time": "2025-08-08T06:35:00.000Z",
        "last_edited_time": "2025-08-08T06:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2495d164-78d8-807a-ba6f-cd5e27ec3975",
        "parent": {
          "type": "page_id",
          "page_id": "1595d164-78d8-80b4-a0bc-c10c9eb29a87"
        },
        "created_time": "2025-08-08T06:35:00.000Z",
        "last_edited_time": "2025-08-08T06:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2495d164-78d8-802d-b6bd-cd2f34d51a78",
        "parent": {
          "type": "page_id",
          "page_id": "1595d164-78d8-80b4-a0bc-c10c9eb29a87"
        },
        "created_time": "2025-08-08T06:41:00.000Z",
        "last_edited_time": "2025-08-08T06:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://medium.com/@warren.tomlin/strategy-reimagined-moving-from-swot-to-so-what-analysis-80bb6bd0de5c",
                "link": {
                  "url": "https://medium.com/@warren.tomlin/strategy-reimagined-moving-from-swot-to-so-what-analysis-80bb6bd0de5c"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://medium.com/@warren.tomlin/strategy-reimagined-moving-from-swot-to-so-what-analysis-80bb6bd0de5c",
              "href": "https://medium.com/@warren.tomlin/strategy-reimagined-moving-from-swot-to-so-what-analysis-80bb6bd0de5c"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2495d164-78d8-80da-93fb-d3e31a5edd25",
        "parent": {
          "type": "page_id",
          "page_id": "1595d164-78d8-80b4-a0bc-c10c9eb29a87"
        },
        "created_time": "2025-08-08T06:41:00.000Z",
        "last_edited_time": "2025-08-08T06:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2495d164-78d8-80c2-b047-c4419669b83b",
        "parent": {
          "type": "page_id",
          "page_id": "1595d164-78d8-80b4-a0bc-c10c9eb29a87"
        },
        "created_time": "2025-08-08T06:41:00.000Z",
        "last_edited_time": "2025-08-08T06:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2495d164-78d8-802b-b832-f0d2efa771a6",
        "parent": {
          "type": "page_id",
          "page_id": "1595d164-78d8-80b4-a0bc-c10c9eb29a87"
        },
        "created_time": "2025-08-08T06:42:00.000Z",
        "last_edited_time": "2025-08-08T06:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Decision making (P1)",
              "href": "https://app.notion.com/p/b2deb93698dc4fafaadc9cfcb4a6c302"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2495d164-78d8-8086-9b82-d070275a0bee",
        "parent": {
          "type": "page_id",
          "page_id": "1595d164-78d8-80b4-a0bc-c10c9eb29a87"
        },
        "created_time": "2025-08-08T06:42:00.000Z",
        "last_edited_time": "2025-08-08T06:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Smarter question for decision making",
              "href": "https://app.notion.com/p/1495d16478d880128e3cc8b2e4d92bda"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1505d164-78d8-80f8-9aad-e59e03c067dc",
    "created_time": "2024-12-02T12:53:00.000Z",
    "last_edited_time": "2025-07-27T01:06:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-12-02T12:53:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 12
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "2-Think",
          "color": "green"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-07-27T01:06:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "sgq|",
          "name": "⚔️:1",
          "color": "red"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Brainstorm toolkit",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Brainstorm toolkit",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Brainstorm-toolkit-1505d16478d880f89aade59e03c067dc",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
      "name": "Think",
      "slug": "think",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "1505d164-78d8-81ac-80fa-d9cc041ed029",
        "parent": {
          "type": "page_id",
          "page_id": "1505d164-78d8-80f8-9aad-e59e03c067dc"
        },
        "created_time": "2024-12-02T12:54:00.000Z",
        "last_edited_time": "2024-12-04T02:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081163/uxcomic-imgs/1505d164-78d8-81ac-80fa-d9cc041ed029.png",
            "expiry_time": "2026-10-04T09:10:39.658Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1505d164-78d8-81ac-80fa-d9cc041ed029"
      },
      {
        "object": "block",
        "id": "1505d164-78d8-8019-9e45-cc7ec68d1d04",
        "parent": {
          "type": "page_id",
          "page_id": "1505d164-78d8-80f8-9aad-e59e03c067dc"
        },
        "created_time": "2024-12-02T13:46:00.000Z",
        "last_edited_time": "2025-07-27T01:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Rule: defer judment, seek quantity, mix & match.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Rule: defer judment, seek quantity, mix & match.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23d5d164-78d8-80de-902a-c7c755ae1a9d",
        "parent": {
          "type": "page_id",
          "page_id": "1505d164-78d8-80f8-9aad-e59e03c067dc"
        },
        "created_time": "2025-07-27T01:04:00.000Z",
        "last_edited_time": "2025-07-27T01:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "List",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "List",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "1505d164-78d8-805f-9b1c-ece42e5b60c9",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80de-902a-c7c755ae1a9d"
            },
            "created_time": "2024-12-02T14:15:00.000Z",
            "last_edited_time": "2025-07-27T01:04:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081165/uxcomic-imgs/1505d164-78d8-805f-9b1c-ece42e5b60c9.png",
                "expiry_time": "2026-10-04T09:10:40.048Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/1505d164-78d8-805f-9b1c-ece42e5b60c9"
          },
          {
            "object": "block",
            "id": "1505d164-78d8-808a-8f7b-cab80aebec62",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80de-902a-c7c755ae1a9d"
            },
            "created_time": "2024-12-02T14:02:00.000Z",
            "last_edited_time": "2025-07-27T01:04:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081166/uxcomic-imgs/1505d164-78d8-808a-8f7b-cab80aebec62.png",
                "expiry_time": "2026-10-04T09:10:40.049Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/1505d164-78d8-808a-8f7b-cab80aebec62"
          },
          {
            "object": "block",
            "id": "1505d164-78d8-80d0-be83-dbfecec94589",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80de-902a-c7c755ae1a9d"
            },
            "created_time": "2024-12-02T14:02:00.000Z",
            "last_edited_time": "2025-07-27T01:04:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081167/uxcomic-imgs/1505d164-78d8-80d0-be83-dbfecec94589.png",
                "expiry_time": "2026-10-04T09:10:40.049Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/1505d164-78d8-80d0-be83-dbfecec94589"
          },
          {
            "object": "block",
            "id": "1505d164-78d8-802a-b330-dd6aba2b50c2",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80de-902a-c7c755ae1a9d"
            },
            "created_time": "2024-12-02T14:02:00.000Z",
            "last_edited_time": "2025-07-27T01:04:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081168/uxcomic-imgs/1505d164-78d8-802a-b330-dd6aba2b50c2.png",
                "expiry_time": "2026-10-04T09:10:40.049Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/1505d164-78d8-802a-b330-dd6aba2b50c2"
          },
          {
            "object": "block",
            "id": "1505d164-78d8-80f7-b06e-c550dd1c9c88",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80de-902a-c7c755ae1a9d"
            },
            "created_time": "2024-12-02T14:02:00.000Z",
            "last_edited_time": "2025-07-27T01:04:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081169/uxcomic-imgs/1505d164-78d8-80f7-b06e-c550dd1c9c88.png",
                "expiry_time": "2026-10-04T09:10:40.049Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/1505d164-78d8-80f7-b06e-c550dd1c9c88"
          },
          {
            "object": "block",
            "id": "1505d164-78d8-80f8-a9d5-dc3b772e7873",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80de-902a-c7c755ae1a9d"
            },
            "created_time": "2024-12-02T14:02:00.000Z",
            "last_edited_time": "2025-07-27T01:04:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081171/uxcomic-imgs/1505d164-78d8-80f8-a9d5-dc3b772e7873.png",
                "expiry_time": "2026-10-04T09:10:40.050Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/1505d164-78d8-80f8-a9d5-dc3b772e7873"
          },
          {
            "object": "block",
            "id": "1505d164-78d8-80db-9d68-c50c29930be4",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80de-902a-c7c755ae1a9d"
            },
            "created_time": "2024-12-02T14:02:00.000Z",
            "last_edited_time": "2025-07-27T01:04:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081172/uxcomic-imgs/1505d164-78d8-80db-9d68-c50c29930be4.png",
                "expiry_time": "2026-10-04T09:10:40.050Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/1505d164-78d8-80db-9d68-c50c29930be4"
          },
          {
            "object": "block",
            "id": "1505d164-78d8-8022-833b-fde10bb64e51",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80de-902a-c7c755ae1a9d"
            },
            "created_time": "2024-12-02T14:02:00.000Z",
            "last_edited_time": "2025-07-27T01:04:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081173/uxcomic-imgs/1505d164-78d8-8022-833b-fde10bb64e51.png",
                "expiry_time": "2026-10-04T09:10:40.050Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/1505d164-78d8-8022-833b-fde10bb64e51"
          },
          {
            "object": "block",
            "id": "1505d164-78d8-8071-8b36-e8146c94aea3",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80de-902a-c7c755ae1a9d"
            },
            "created_time": "2024-12-02T14:02:00.000Z",
            "last_edited_time": "2025-07-27T01:04:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081175/uxcomic-imgs/1505d164-78d8-8071-8b36-e8146c94aea3.png",
                "expiry_time": "2026-10-04T09:10:40.050Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/1505d164-78d8-8071-8b36-e8146c94aea3"
          },
          {
            "object": "block",
            "id": "1505d164-78d8-80e0-be1e-f313b1d66791",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80de-902a-c7c755ae1a9d"
            },
            "created_time": "2024-12-02T14:02:00.000Z",
            "last_edited_time": "2025-07-27T01:04:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081176/uxcomic-imgs/1505d164-78d8-80e0-be1e-f313b1d66791.png",
                "expiry_time": "2026-10-04T09:10:40.051Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/1505d164-78d8-80e0-be1e-f313b1d66791"
          },
          {
            "object": "block",
            "id": "1515d164-78d8-80d5-a3d0-d8f183ff9e4b",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80de-902a-c7c755ae1a9d"
            },
            "created_time": "2024-12-03T05:58:00.000Z",
            "last_edited_time": "2025-07-27T01:04:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081177/uxcomic-imgs/1515d164-78d8-80d5-a3d0-d8f183ff9e4b.png",
                "expiry_time": "2026-10-04T09:10:40.051Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/1515d164-78d8-80d5-a3d0-d8f183ff9e4b"
          }
        ]
      },
      {
        "object": "block",
        "id": "1505d164-78d8-8164-bdff-f056d51c20e9",
        "parent": {
          "type": "page_id",
          "page_id": "1505d164-78d8-80f8-9aad-e59e03c067dc"
        },
        "created_time": "2024-12-02T12:54:00.000Z",
        "last_edited_time": "2024-12-02T12:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-81c8-98f7-ef0f33a4b6d1",
        "parent": {
          "type": "page_id",
          "page_id": "1505d164-78d8-80f8-9aad-e59e03c067dc"
        },
        "created_time": "2024-12-02T12:54:00.000Z",
        "last_edited_time": "2024-12-02T12:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-8159-8c72-c34c2060fe39",
        "parent": {
          "type": "page_id",
          "page_id": "1505d164-78d8-80f8-9aad-e59e03c067dc"
        },
        "created_time": "2024-12-02T12:54:00.000Z",
        "last_edited_time": "2024-12-02T13:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://productmindset.substack.com/p/1436-understanding-solution-space",
                "link": {
                  "url": "https://productmindset.substack.com/p/1436-understanding-solution-space"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://productmindset.substack.com/p/1436-understanding-solution-space",
              "href": "https://productmindset.substack.com/p/1436-understanding-solution-space"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-81ae-b60b-de2d18e7ec4f",
        "parent": {
          "type": "page_id",
          "page_id": "1505d164-78d8-80f8-9aad-e59e03c067dc"
        },
        "created_time": "2024-12-02T12:54:00.000Z",
        "last_edited_time": "2024-12-02T12:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-8130-aea6-f29ebf556934",
        "parent": {
          "type": "page_id",
          "page_id": "1505d164-78d8-80f8-9aad-e59e03c067dc"
        },
        "created_time": "2024-12-02T12:54:00.000Z",
        "last_edited_time": "2024-12-02T12:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-81f1-967a-c5fc737bb536",
        "parent": {
          "type": "page_id",
          "page_id": "1505d164-78d8-80f8-9aad-e59e03c067dc"
        },
        "created_time": "2024-12-02T12:54:00.000Z",
        "last_edited_time": "2024-12-16T09:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1585d164-78d8-80c3-b602-e97f38fd7948"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ideate (P1)",
              "href": "https://app.notion.com/p/1585d16478d880c3b602e97f38fd7948"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-81f9-9db0-d8cbd3e32ea4",
        "parent": {
          "type": "page_id",
          "page_id": "1505d164-78d8-80f8-9aad-e59e03c067dc"
        },
        "created_time": "2024-12-02T12:54:00.000Z",
        "last_edited_time": "2024-12-16T09:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ideate (P2)",
              "href": "https://app.notion.com/p/15e5d16478d880c8ac9eff1a29784a09"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15e5d164-78d8-8048-8d3c-f1859153cede",
        "parent": {
          "type": "page_id",
          "page_id": "1505d164-78d8-80f8-9aad-e59e03c067dc"
        },
        "created_time": "2024-12-16T09:48:00.000Z",
        "last_edited_time": "2024-12-16T09:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "14f5d164-78d8-807a-9ce7-ed335a243652",
    "created_time": "2024-12-01T04:15:00.000Z",
    "last_edited_time": "2025-08-29T15:46:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-12-01T04:15:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 10
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "2-Think",
          "color": "green"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-29T15:46:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "sgq|",
          "name": "⚔️:1",
          "color": "red"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "6 Thinking Hats ",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "6 Thinking Hats ",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/6-Thinking-Hats-14f5d16478d8807a9ce7ed335a243652",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
      "name": "Think",
      "slug": "think",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "1505d164-78d8-8193-a832-dae2150bbbbc",
        "parent": {
          "type": "page_id",
          "page_id": "14f5d164-78d8-807a-9ce7-ed335a243652"
        },
        "created_time": "2024-12-02T03:46:00.000Z",
        "last_edited_time": "2024-12-30T12:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081179/uxcomic-imgs/1505d164-78d8-8193-a832-dae2150bbbbc.png",
            "expiry_time": "2026-10-04T09:10:42.594Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1505d164-78d8-8193-a832-dae2150bbbbc"
      },
      {
        "object": "block",
        "id": "1505d164-78d8-81ce-b6f4-ffff353137f1",
        "parent": {
          "type": "page_id",
          "page_id": "14f5d164-78d8-807a-9ce7-ed335a243652"
        },
        "created_time": "2024-12-02T03:46:00.000Z",
        "last_edited_time": "2024-12-30T12:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Six thinking hats là framework được phát triển bởi Edward de Bono để giúp giải quyết vấn đề & bổ trợ việc ra quyết định.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Six thinking hats là framework được phát triển bởi Edward de Bono để giúp giải quyết vấn đề & bổ trợ việc ra quyết định.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8041-b52c-ec7871d0c115",
        "parent": {
          "type": "page_id",
          "page_id": "14f5d164-78d8-807a-9ce7-ed335a243652"
        },
        "created_time": "2024-12-30T12:47:00.000Z",
        "last_edited_time": "2024-12-30T12:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sơ lược thì ta sẽ có 6 chiếc mũ, mỗi chiếc mũ đại diện cho một POV, và khi ta đội chiếc mũ đó vào sẽ giống như được bật công tắc vậy, ta chỉ tập trung suy nghĩ theo POV tương ứng với chiếc mũ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sơ lược thì ta sẽ có 6 chiếc mũ, mỗi chiếc mũ đại diện cho một POV, và khi ta đội chiếc mũ đó vào sẽ giống như được bật công tắc vậy, ta chỉ tập trung suy nghĩ theo POV tương ứng với chiếc mũ.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8060-ae22-d6dc2da36145",
        "parent": {
          "type": "page_id",
          "page_id": "14f5d164-78d8-807a-9ce7-ed335a243652"
        },
        "created_time": "2024-12-30T12:47:00.000Z",
        "last_edited_time": "2024-12-30T12:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Điều này giúp chúng ta có góc nhìn đa chiều hơn khi đánh giá một vấn đề hay giải pháp nào đó, tránh bị quá tiêu cực, hay quá lạc quan hoặc bị các định kiến che mờ lí trí,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Điều này giúp chúng ta có góc nhìn đa chiều hơn khi đánh giá một vấn đề hay giải pháp nào đó, tránh bị quá tiêu cực, hay quá lạc quan hoặc bị các định kiến che mờ lí trí,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23d5d164-78d8-80e2-aef9-c457b30e4c8f",
        "parent": {
          "type": "page_id",
          "page_id": "14f5d164-78d8-807a-9ce7-ed335a243652"
        },
        "created_time": "2025-07-27T01:03:00.000Z",
        "last_edited_time": "2025-08-29T15:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "List",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "List",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "25e5d164-78d8-80cf-825f-ef58757b2b4d",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80e2-aef9-c457b30e4c8f"
            },
            "created_time": "2025-08-29T15:46:00.000Z",
            "last_edited_time": "2025-08-29T15:46:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756482547/uxcomic-imgs/25e5d164-78d8-80cf-825f-ef58757b2b4d.png",
                "expiry_time": "2026-10-04T09:10:43.351Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-80cf-825f-ef58757b2b4d"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-8036-b240-c22d52fc29d7",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80e2-aef9-c457b30e4c8f"
            },
            "created_time": "2025-08-29T15:46:00.000Z",
            "last_edited_time": "2025-08-29T15:46:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756482548/uxcomic-imgs/25e5d164-78d8-8036-b240-c22d52fc29d7.png",
                "expiry_time": "2026-10-04T09:10:43.351Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-8036-b240-c22d52fc29d7"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-809a-9eba-c7c2f88bb166",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80e2-aef9-c457b30e4c8f"
            },
            "created_time": "2025-08-29T15:46:00.000Z",
            "last_edited_time": "2025-08-29T15:46:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756482549/uxcomic-imgs/25e5d164-78d8-809a-9eba-c7c2f88bb166.png",
                "expiry_time": "2026-10-04T09:10:43.351Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-809a-9eba-c7c2f88bb166"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-80cd-9c82-c24743c9e21d",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80e2-aef9-c457b30e4c8f"
            },
            "created_time": "2025-08-29T15:46:00.000Z",
            "last_edited_time": "2025-08-29T15:46:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756482550/uxcomic-imgs/25e5d164-78d8-80cd-9c82-c24743c9e21d.png",
                "expiry_time": "2026-10-04T09:10:43.351Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-80cd-9c82-c24743c9e21d"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-80a7-9ffa-c64ef7dea48e",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80e2-aef9-c457b30e4c8f"
            },
            "created_time": "2025-08-29T15:46:00.000Z",
            "last_edited_time": "2025-08-29T15:46:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756482551/uxcomic-imgs/25e5d164-78d8-80a7-9ffa-c64ef7dea48e.png",
                "expiry_time": "2026-10-04T09:10:43.351Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-80a7-9ffa-c64ef7dea48e"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-80e0-9461-f86cceaaf41b",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-80e2-aef9-c457b30e4c8f"
            },
            "created_time": "2025-08-29T15:46:00.000Z",
            "last_edited_time": "2025-08-29T15:46:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756482552/uxcomic-imgs/25e5d164-78d8-80e0-9461-f86cceaaf41b.png",
                "expiry_time": "2026-10-04T09:10:43.351Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-80e0-9461-f86cceaaf41b"
          }
        ]
      },
      {
        "object": "block",
        "id": "25e5d164-78d8-803b-981f-db62894ddb0d",
        "parent": {
          "type": "page_id",
          "page_id": "14f5d164-78d8-807a-9ce7-ed335a243652"
        },
        "created_time": "2025-08-29T15:46:00.000Z",
        "last_edited_time": "2025-08-29T15:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8076-8053-d21baabede09",
        "parent": {
          "type": "page_id",
          "page_id": "14f5d164-78d8-807a-9ce7-ed335a243652"
        },
        "created_time": "2024-12-24T06:05:00.000Z",
        "last_edited_time": "2024-12-24T06:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-81dd-b8e6-d81ad7d5204c",
        "parent": {
          "type": "page_id",
          "page_id": "14f5d164-78d8-807a-9ce7-ed335a243652"
        },
        "created_time": "2024-12-02T03:46:00.000Z",
        "last_edited_time": "2024-12-02T03:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách ứng dụng",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách ứng dụng",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-8118-af94-dc04959c1328",
        "parent": {
          "type": "page_id",
          "page_id": "14f5d164-78d8-807a-9ce7-ed335a243652"
        },
        "created_time": "2024-12-02T03:46:00.000Z",
        "last_edited_time": "2024-12-02T10:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình có thể áp dụng nó từ phạm vi cá nhân đến nhóm khi nhìn nhận vấn đề. Nếu ở cá nhân, bạn có thể thay phiên đội những chiếc mũ để đánh giá vấn đề, nếu ở nhóm bạn có thể assign cho team member đội chiếc mũ phù hợp, vd: designer đội mũ xanh để ra ý tưởng, researcher đội mũ trắng để cung cấp các thông tin research được, dev đội mũ đen để đánh giá độ khả thi & các rủi ro có thể xảy ra,…Hoặc team member có thể thay phiên đội các mũ các nhau, hoặc ta có thể đề ra luật ta sẽ có bao nhiêu phút để mọi người cùng đội một chiếc mũ & thảo luận dưới POV đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình có thể áp dụng nó từ phạm vi cá nhân đến nhóm khi nhìn nhận vấn đề. Nếu ở cá nhân, bạn có thể thay phiên đội những chiếc mũ để đánh giá vấn đề, nếu ở nhóm bạn có thể assign cho team member đội chiếc mũ phù hợp, vd: designer đội mũ xanh để ra ý tưởng, researcher đội mũ trắng để cung cấp các thông tin research được, dev đội mũ đen để đánh giá độ khả thi & các rủi ro có thể xảy ra,…Hoặc team member có thể thay phiên đội các mũ các nhau, hoặc ta có thể đề ra luật ta sẽ có bao nhiêu phút để mọi người cùng đội một chiếc mũ & thảo luận dưới POV đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-80ea-93be-c3bd16678cc9",
        "parent": {
          "type": "page_id",
          "page_id": "14f5d164-78d8-807a-9ce7-ed335a243652"
        },
        "created_time": "2024-12-02T03:58:00.000Z",
        "last_edited_time": "2024-12-30T12:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: có khi trong buổi họp bạn không cần đề cập đến việc apply framework này, chủ yếu mình có thể đánh giá xem cuộc thảo luận đã đi qua hết các chiếc mũ này chưa & cân nhắc xem cần đặt câu hỏi thế nào để giúp mọi người đào sâu thêm các góc nhìn khác. Mình cũng không nên quá gập khuông mà hãy linh hoạt áp dụng chúng, có thể bạn gán một ngữ nghĩa khác cho một chiếc nón ví dụ thay vì red-emotion thì giờ red-branding chẳng hạn, hay tuỳ buổi thảo luận mà ta có thể gạt bỏ hoặc thêm chiếc mũ nào đó, ví dụ: problem framing chưa cần đến chiếc mũ sáng tạo.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: có khi trong buổi họp bạn không cần đề cập đến việc apply framework này, chủ yếu mình có thể đánh giá xem cuộc thảo luận đã đi qua hết các chiếc mũ này chưa & cân nhắc xem cần đặt câu hỏi thế nào để giúp mọi người đào sâu thêm các góc nhìn khác. Mình cũng không nên quá gập khuông mà hãy linh hoạt áp dụng chúng, có thể bạn gán một ngữ nghĩa khác cho một chiếc nón ví dụ thay vì red-emotion thì giờ red-branding chẳng hạn, hay tuỳ buổi thảo luận mà ta có thể gạt bỏ hoặc thêm chiếc mũ nào đó, ví dụ: problem framing chưa cần đến chiếc mũ sáng tạo.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-8063-a5f9-d8354e953bd5",
        "parent": {
          "type": "page_id",
          "page_id": "14f5d164-78d8-807a-9ce7-ed335a243652"
        },
        "created_time": "2024-12-02T04:05:00.000Z",
        "last_edited_time": "2024-12-02T04:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Điều quan trọng nhất của framework này là ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Điều quan trọng nhất của framework này là ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "góc nhìn đa chiều",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "góc nhìn đa chiều",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-8038-bcd9-c22f7669ea72",
        "parent": {
          "type": "page_id",
          "page_id": "14f5d164-78d8-807a-9ce7-ed335a243652"
        },
        "created_time": "2024-12-02T09:52:00.000Z",
        "last_edited_time": "2024-12-30T12:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081188/uxcomic-imgs/1505d164-78d8-8038-bcd9-c22f7669ea72.png",
            "expiry_time": "2026-10-04T09:10:42.595Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1505d164-78d8-8038-bcd9-c22f7669ea72"
      },
      {
        "object": "block",
        "id": "1505d164-78d8-819b-b28e-daabb438c41e",
        "parent": {
          "type": "page_id",
          "page_id": "14f5d164-78d8-807a-9ce7-ed335a243652"
        },
        "created_time": "2024-12-02T03:46:00.000Z",
        "last_edited_time": "2024-12-02T03:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-81e0-ae3b-e1938cf48ac4",
        "parent": {
          "type": "page_id",
          "page_id": "14f5d164-78d8-807a-9ce7-ed335a243652"
        },
        "created_time": "2024-12-02T03:46:00.000Z",
        "last_edited_time": "2024-12-02T03:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-81bd-957d-def49c6b1673",
        "parent": {
          "type": "page_id",
          "page_id": "14f5d164-78d8-807a-9ce7-ed335a243652"
        },
        "created_time": "2024-12-02T03:46:00.000Z",
        "last_edited_time": "2024-12-02T03:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.linkedin.com/pulse/six-thinking-hats-method-powerful-tool-product-teams-4jdhc",
                "link": {
                  "url": "https://www.linkedin.com/pulse/six-thinking-hats-method-powerful-tool-product-teams-4jdhc?utm_source=share&utm_medium=member_ios&utm_campaign=share_via"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.linkedin.com/pulse/six-thinking-hats-method-powerful-tool-product-teams-4jdhc",
              "href": "https://www.linkedin.com/pulse/six-thinking-hats-method-powerful-tool-product-teams-4jdhc?utm_source=share&utm_medium=member_ios&utm_campaign=share_via"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-819f-9bef-f7671abdeb5c",
        "parent": {
          "type": "page_id",
          "page_id": "14f5d164-78d8-807a-9ce7-ed335a243652"
        },
        "created_time": "2024-12-02T03:46:00.000Z",
        "last_edited_time": "2024-12-02T09:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.debonogroup.com/services/core-programs/six-thinking-hats/",
                "link": {
                  "url": "https://www.debonogroup.com/services/core-programs/six-thinking-hats/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.debonogroup.com/services/core-programs/six-thinking-hats/",
              "href": "https://www.debonogroup.com/services/core-programs/six-thinking-hats/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-81a5-8cda-d3a40441e0a7",
        "parent": {
          "type": "page_id",
          "page_id": "14f5d164-78d8-807a-9ce7-ed335a243652"
        },
        "created_time": "2024-12-02T03:46:00.000Z",
        "last_edited_time": "2024-12-02T10:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.designorate.com/the-six-hats-of-critical-thinking-and-how-to-use-them/",
                "link": {
                  "url": "https://www.designorate.com/the-six-hats-of-critical-thinking-and-how-to-use-them/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.designorate.com/the-six-hats-of-critical-thinking-and-how-to-use-them/",
              "href": "https://www.designorate.com/the-six-hats-of-critical-thinking-and-how-to-use-them/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-8138-bd28-d51c02807336",
        "parent": {
          "type": "page_id",
          "page_id": "14f5d164-78d8-807a-9ce7-ed335a243652"
        },
        "created_time": "2024-12-02T03:46:00.000Z",
        "last_edited_time": "2024-12-02T03:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-8118-967b-ced6feff8a8a",
        "parent": {
          "type": "page_id",
          "page_id": "14f5d164-78d8-807a-9ce7-ed335a243652"
        },
        "created_time": "2024-12-02T03:46:00.000Z",
        "last_edited_time": "2024-12-02T03:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-8153-9b4c-d25d6972d488",
        "parent": {
          "type": "page_id",
          "page_id": "14f5d164-78d8-807a-9ce7-ed335a243652"
        },
        "created_time": "2024-12-02T03:46:00.000Z",
        "last_edited_time": "2024-12-02T09:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sense making",
              "href": "https://app.notion.com/p/1195d16478d880cda21ff9d0e90ae7b8"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-81b7-a5a1-d14052b08bb9",
        "parent": {
          "type": "page_id",
          "page_id": "14f5d164-78d8-807a-9ce7-ed335a243652"
        },
        "created_time": "2024-12-02T03:46:00.000Z",
        "last_edited_time": "2024-12-02T09:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda",
    "created_time": "2024-11-25T05:43:00.000Z",
    "last_edited_time": "2025-05-20T01:33:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-11-25T05:43:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 9
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "2-Think",
          "color": "green"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-05-20T01:33:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "cZzk",
          "name": "⚔️:3",
          "color": "orange"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Smarter question for decision making",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Smarter question for decision making",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Smarter-question-for-decision-making-1495d16478d880128e3cc8b2e4d92bda",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
      "name": "Think",
      "slug": "think",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "1505d164-78d8-806d-b67e-cdd6b14bd6ff",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-12-02T14:25:00.000Z",
        "last_edited_time": "2024-12-24T06:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081190/uxcomic-imgs/1505d164-78d8-806d-b67e-cdd6b14bd6ff.png",
            "expiry_time": "2026-10-04T09:10:45.218Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1505d164-78d8-806d-b67e-cdd6b14bd6ff"
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8064-a5d8-d2b5474fb9d5",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:14:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "The question we gonna ask to boost strategic decision-making. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "The question we gonna ask to boost strategic decision-making. ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1495d164-78d8-8066-ae49-c182589ad322",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-25T05:42:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "With organizations facing increased urgency and unpredictability, being able to ask smart questions has become a key leadership skill—especially when setting strategy. Here are five types of questions to ask that can boost strategic decision-making. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "With organizations facing increased urgency and unpredictability, being able to ask smart questions has become a key leadership skill—especially when setting strategy. Here are five types of questions to ask that can boost strategic decision-making. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-80c2-b632-d334251b15d9",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "INVESTIGATIVE ➟ Clarify your purpose",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "INVESTIGATIVE ➟ Clarify your purpose",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8014-92da-c01bed66526e",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "What’s known?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "What’s known?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8013-af57-ca440514af6d",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "What do we want to achieve?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "What do we want to achieve?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-809f-89ca-d5f648185a83",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "What do we need to learn to do so?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "What do we need to learn to do so?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1435d164-78d8-804a-b2a2-c432c177b7d0",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-19T02:22:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "How feasible and desirable is each option?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "How feasible and desirable is each option?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1435d164-78d8-80a0-81d4-e8fe17f9b717",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-19T02:22:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "What evidence supports our proposed plan?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "What evidence supports our proposed plan?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8076-acca-f36625e90985",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ask why and how",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ask why and how",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-80bf-8e0f-e75e76370c40",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "SPECULATIVE ➟ Consider the problem more broadly",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "SPECULATIVE ➟ Consider the problem more broadly",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-807a-8b85-fbce509948c8",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "What if?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "What if?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8026-b277-ca2e0df7715a",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "What else?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "What else?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-806f-bb89-e4965bfbf2e0",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:27:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": " How might we?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " How might we?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-80d4-9a2c-d868aed48fe4",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "PRODUCTIVE ➟ Assess the availability of resources",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "PRODUCTIVE ➟ Assess the availability of resources",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-803e-ad55-c5de0dfb9d40",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Now what?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Now what?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-80ff-9be3-d072742e7639",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "How can we get it done?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "How can we get it done?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1435d164-78d8-80ea-b9d6-f52bb4382715",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-19T02:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "What do we need to achieve before taking it?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "What do we need to achieve before taking it?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1435d164-78d8-8081-a775-db449f107b25",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-19T02:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Do we have the resources to move ahead?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Do we have the resources to move ahead?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-802b-93fa-ca878d5fe6ce",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "How will we synchronize our actions?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "How will we synchronize our actions?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8090-92e4-c62643242dff",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "How will we measure progress?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "How will we measure progress?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8087-8026-fcac04d519d9",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "INTERPRETIVE ➟ Make sense and synthesize",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "INTERPRETIVE ➟ Make sense and synthesize",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-809a-8637-e51b2f6ff6eb",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "So, what?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "So, what?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-803a-ad18-f34fddd0127f",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "So, what is this problem really about?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "So, what is this problem really about?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-803d-b38f-e4dd1e383835",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "So, what happens if this trend continues?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "So, what happens if this trend continues?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8090-a034-dd45cef60e2b",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "So, what opportunities does that idea open up?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "So, what opportunities does that idea open up?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-80d1-9b5a-e4e7b434e119",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "So, what does that imply for scaling up or sequencing?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "So, what does that imply for scaling up or sequencing?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-80be-812e-e5399ca93ed8",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "So, what did we learn from this?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "So, what did we learn from this?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-805f-8ad4-c209c2954f3c",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "So, why are we doing things?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "So, why are we doing things?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8017-8219-c4c8932fd211",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "So, why does it matter?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "So, why does it matter?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8096-87ee-e9346c7fab00",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:21:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Subjective ➟ Consider the emotional part of the decision",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Subjective ➟ Consider the emotional part of the decision",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8080-89ae-d61fa2052623",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:29:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Are there differences between what was said, what was heard, and what was meant?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Are there differences between what was said, what was heard, and what was meant?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-803a-ad1b-fdd4826b2726",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:28:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "How will people feel about this decision?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "How will people feel about this decision?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-80ed-b601-ec25d52e4c7d",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:28:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "What are your concerns?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "What are your concerns?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8077-8233-fa753895a404",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:29:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Have we consulted the right people?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Have we consulted the right people?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8081-9ec3-edc1567f4216",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-18T15:29:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Are all stakeholders genuinely aligned?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Are all stakeholders genuinely aligned?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-8097-805c-e78fad7eb588",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-23T07:48:00.000Z",
        "last_edited_time": "2024-11-25T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1495d164-78d8-807c-9613-dfd9a2edd245",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-25T05:44:00.000Z",
        "last_edited_time": "2024-11-25T05:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1495d164-78d8-8084-8e7e-e4bdefe3562a",
        "parent": {
          "type": "page_id",
          "page_id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
        },
        "created_time": "2024-11-25T05:44:00.000Z",
        "last_edited_time": "2024-11-25T05:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.linkedin.com/pulse/art-asking-smarter-questions-sanjeevi-kumar-awpkc/",
                "link": {
                  "url": "https://www.linkedin.com/pulse/art-asking-smarter-questions-sanjeevi-kumar-awpkc/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.linkedin.com/pulse/art-asking-smarter-questions-sanjeevi-kumar-awpkc/",
              "href": "https://www.linkedin.com/pulse/art-asking-smarter-questions-sanjeevi-kumar-awpkc/"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1195d164-78d8-80a5-8e49-dccadd944107",
    "created_time": "2024-10-08T10:14:00.000Z",
    "last_edited_time": "2025-07-28T05:56:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-10-08T10:14:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 5
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "1-Design",
          "color": "default"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-07-28T05:56:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "cZzk",
          "name": "⚔️:3",
          "color": "orange"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Product design checklist",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Product design checklist",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Product-design-checklist-1195d16478d880a58e49dccadd944107",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Design",
      "slug": "design",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "1195d164-78d8-8095-afd8-dec32d46466c",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80a5-8e49-dccadd944107"
        },
        "created_time": "2024-10-08T14:59:00.000Z",
        "last_edited_time": "2024-10-08T15:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081192/uxcomic-imgs/1195d164-78d8-8095-afd8-dec32d46466c.png",
            "expiry_time": "2026-10-04T09:10:45.673Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1195d164-78d8-8095-afd8-dec32d46466c"
      },
      {
        "object": "block",
        "id": "79c48843-def8-49d9-a727-b145ddca3da7",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80a5-8e49-dccadd944107"
        },
        "created_time": "2024-10-08T14:59:00.000Z",
        "last_edited_time": "2025-07-27T01:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Product design sẽ tiếp cận vấn đề ở góc nhìn khái quát hơn, quan tâm nhiều hơn đến impact của design và ensure solution implement.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product design sẽ tiếp cận vấn đề ở góc nhìn khái quát hơn, quan tâm nhiều hơn đến impact của design và ensure solution implement.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23d5d164-78d8-809a-8ec8-d751829a3a93",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80a5-8e49-dccadd944107"
        },
        "created_time": "2025-07-27T01:40:00.000Z",
        "last_edited_time": "2025-07-27T01:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "List",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "List",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "23d5d164-78d8-80cf-a57e-cc8d423da269",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-809a-8ec8-d751829a3a93"
            },
            "created_time": "2025-07-27T01:47:00.000Z",
            "last_edited_time": "2025-07-27T01:47:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753581444/uxcomic-imgs/23d5d164-78d8-80cf-a57e-cc8d423da269.png",
                "expiry_time": "2026-10-04T09:10:46.067Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-80cf-a57e-cc8d423da269"
          },
          {
            "object": "block",
            "id": "23d5d164-78d8-80da-b6e9-fe4f04ff8233",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-809a-8ec8-d751829a3a93"
            },
            "created_time": "2025-07-27T01:47:00.000Z",
            "last_edited_time": "2025-07-27T01:47:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753581445/uxcomic-imgs/23d5d164-78d8-80da-b6e9-fe4f04ff8233.png",
                "expiry_time": "2026-10-04T09:10:46.067Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-80da-b6e9-fe4f04ff8233"
          },
          {
            "object": "block",
            "id": "23d5d164-78d8-80dc-94e1-fc27ef5fffb8",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-809a-8ec8-d751829a3a93"
            },
            "created_time": "2025-07-27T01:47:00.000Z",
            "last_edited_time": "2025-07-27T01:47:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753581446/uxcomic-imgs/23d5d164-78d8-80dc-94e1-fc27ef5fffb8.png",
                "expiry_time": "2026-10-04T09:10:46.067Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-80dc-94e1-fc27ef5fffb8"
          },
          {
            "object": "block",
            "id": "23d5d164-78d8-8013-a9e9-f187b8907ccf",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-809a-8ec8-d751829a3a93"
            },
            "created_time": "2025-07-27T01:47:00.000Z",
            "last_edited_time": "2025-07-27T01:47:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753581447/uxcomic-imgs/23d5d164-78d8-8013-a9e9-f187b8907ccf.png",
                "expiry_time": "2026-10-04T09:10:46.067Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-8013-a9e9-f187b8907ccf"
          },
          {
            "object": "block",
            "id": "23d5d164-78d8-8060-ad1d-f1967a621006",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-809a-8ec8-d751829a3a93"
            },
            "created_time": "2025-07-27T01:47:00.000Z",
            "last_edited_time": "2025-07-27T01:47:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753581448/uxcomic-imgs/23d5d164-78d8-8060-ad1d-f1967a621006.png",
                "expiry_time": "2026-10-04T09:10:46.067Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-8060-ad1d-f1967a621006"
          },
          {
            "object": "block",
            "id": "23d5d164-78d8-807a-aa85-e5e59a057417",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-809a-8ec8-d751829a3a93"
            },
            "created_time": "2025-07-27T01:47:00.000Z",
            "last_edited_time": "2025-07-27T01:47:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753581449/uxcomic-imgs/23d5d164-78d8-807a-aa85-e5e59a057417.png",
                "expiry_time": "2026-10-04T09:10:46.067Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-807a-aa85-e5e59a057417"
          },
          {
            "object": "block",
            "id": "23d5d164-78d8-8063-af13-f7159f9c89dd",
            "parent": {
              "type": "block_id",
              "block_id": "23d5d164-78d8-809a-8ec8-d751829a3a93"
            },
            "created_time": "2025-07-27T01:47:00.000Z",
            "last_edited_time": "2025-07-27T01:47:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753581450/uxcomic-imgs/23d5d164-78d8-8063-af13-f7159f9c89dd.png",
                "expiry_time": "2026-10-04T09:10:46.067Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-8063-af13-f7159f9c89dd"
          }
        ]
      },
      {
        "object": "block",
        "id": "11a5d164-78d8-80f9-9d1a-f30fef19d21c",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80a5-8e49-dccadd944107"
        },
        "created_time": "2024-10-09T11:15:00.000Z",
        "last_edited_time": "2024-10-09T11:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "11a5d164-78d8-80a1-bf90-edb3341be5b6",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80a5-8e49-dccadd944107"
        },
        "created_time": "2024-10-09T11:17:00.000Z",
        "last_edited_time": "2025-07-28T05:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11a5d164-78d8-8078-bc43-f48cee7f4975",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80a5-8e49-dccadd944107"
        },
        "created_time": "2024-10-09T11:17:00.000Z",
        "last_edited_time": "2024-10-09T11:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.growthdesign.coach/growth-design-la-gi",
                "link": {
                  "url": "https://www.growthdesign.coach/growth-design-la-gi"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.growthdesign.coach/growth-design-la-gi",
              "href": "https://www.growthdesign.coach/growth-design-la-gi"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80e6-9d32-d6a78a205b0d",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80a5-8e49-dccadd944107"
        },
        "created_time": "2025-07-28T05:55:00.000Z",
        "last_edited_time": "2025-07-28T05:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-809b-bcf5-eb7f61be79b4",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80a5-8e49-dccadd944107"
        },
        "created_time": "2025-07-28T05:55:00.000Z",
        "last_edited_time": "2025-07-28T05:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Items",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Items",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-803f-85de-dd12879e3488",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80a5-8e49-dccadd944107"
        },
        "created_time": "2025-07-28T05:55:00.000Z",
        "last_edited_time": "2025-07-28T05:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1445d164-78d8-805b-b388-e24b5f13cccb"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product development process (overall)",
              "href": "https://app.notion.com/p/1445d16478d8805bb388e24b5f13cccb"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-802e-a782-c792fa1d5e44",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80a5-8e49-dccadd944107"
        },
        "created_time": "2025-07-28T05:55:00.000Z",
        "last_edited_time": "2025-07-28T05:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product là gì?",
              "href": "https://app.notion.com/p/22f4879b78c641f4ac922219ca7879f2"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-8079-be5c-e7e7ec83308a",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80a5-8e49-dccadd944107"
        },
        "created_time": "2025-07-28T05:55:00.000Z",
        "last_edited_time": "2025-07-28T05:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1195d164-78d8-800e-93cc-d89ca8ed01bc",
    "created_time": "2024-10-08T10:13:00.000Z",
    "last_edited_time": "2025-07-31T01:39:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-10-08T10:13:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 4
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "1-Design",
          "color": "default"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-07-31T01:39:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "prxX",
          "name": "⚔️:2",
          "color": "yellow"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "UX checklist",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "UX checklist",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/UX-checklist-1195d16478d8800e93ccd89ca8ed01bc",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Design",
      "slug": "design",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "1195d164-78d8-8072-a0e5-f14a823acbfd",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-800e-93cc-d89ca8ed01bc"
        },
        "created_time": "2024-10-08T15:03:00.000Z",
        "last_edited_time": "2024-10-08T15:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081197/uxcomic-imgs/1195d164-78d8-8072-a0e5-f14a823acbfd.png",
            "expiry_time": "2026-10-04T09:10:47.794Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1195d164-78d8-8072-a0e5-f14a823acbfd"
      },
      {
        "object": "block",
        "id": "13e5d164-78d8-804e-8ff3-c6740cd7a365",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-800e-93cc-d89ca8ed01bc"
        },
        "created_time": "2024-11-14T14:53:00.000Z",
        "last_edited_time": "2025-07-26T05:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "UX hướng nhiều hơn về việc user nên “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX hướng nhiều hơn về việc user nên “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cảm thấy",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cảm thấy",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "” như thế nào trong & sau khi sử dụng sản phẩm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” như thế nào trong & sau khi sử dụng sản phẩm.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23c5d164-78d8-8014-9be6-ff7eac6fa584",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-800e-93cc-d89ca8ed01bc"
        },
        "created_time": "2025-07-26T09:13:00.000Z",
        "last_edited_time": "2025-07-27T06:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tạm giả sử điều kiện lý tưởng 1 product đã reliable, đã useful, đã có value, thì làm thế nào để giúp UX trở nên tốt hơn?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tạm giả sử điều kiện lý tưởng 1 product đã reliable, đã useful, đã có value, thì làm thế nào để giúp UX trở nên tốt hơn?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2395d164-78d8-8003-af8e-d8dc21c30235",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-800e-93cc-d89ca8ed01bc"
        },
        "created_time": "2025-07-23T10:01:00.000Z",
        "last_edited_time": "2025-07-26T09:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "UX checklist",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX checklist",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "23c5d164-78d8-808a-afe9-edced83abfae",
            "parent": {
              "type": "block_id",
              "block_id": "2395d164-78d8-8003-af8e-d8dc21c30235"
            },
            "created_time": "2025-07-26T09:16:00.000Z",
            "last_edited_time": "2025-07-31T01:38:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753547710/uxcomic-imgs/23c5d164-78d8-808a-afe9-edced83abfae.png",
                "expiry_time": "2026-10-04T09:10:48.198Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23c5d164-78d8-808a-afe9-edced83abfae"
          },
          {
            "object": "block",
            "id": "23c5d164-78d8-80e1-af95-d8943840eda5",
            "parent": {
              "type": "block_id",
              "block_id": "2395d164-78d8-8003-af8e-d8dc21c30235"
            },
            "created_time": "2025-07-26T09:16:00.000Z",
            "last_edited_time": "2025-07-31T01:38:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753547711/uxcomic-imgs/23c5d164-78d8-80e1-af95-d8943840eda5.png",
                "expiry_time": "2026-10-04T09:10:48.198Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23c5d164-78d8-80e1-af95-d8943840eda5"
          },
          {
            "object": "block",
            "id": "23c5d164-78d8-807a-a6e3-ede7e346c6b4",
            "parent": {
              "type": "block_id",
              "block_id": "2395d164-78d8-8003-af8e-d8dc21c30235"
            },
            "created_time": "2025-07-26T09:16:00.000Z",
            "last_edited_time": "2025-07-31T01:38:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753547712/uxcomic-imgs/23c5d164-78d8-807a-a6e3-ede7e346c6b4.png",
                "expiry_time": "2026-10-04T09:10:48.198Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23c5d164-78d8-807a-a6e3-ede7e346c6b4"
          },
          {
            "object": "block",
            "id": "23c5d164-78d8-802b-823e-f09728134f50",
            "parent": {
              "type": "block_id",
              "block_id": "2395d164-78d8-8003-af8e-d8dc21c30235"
            },
            "created_time": "2025-07-26T09:16:00.000Z",
            "last_edited_time": "2025-07-31T01:38:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753547713/uxcomic-imgs/23c5d164-78d8-802b-823e-f09728134f50.png",
                "expiry_time": "2026-10-04T09:10:48.198Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23c5d164-78d8-802b-823e-f09728134f50"
          },
          {
            "object": "block",
            "id": "23c5d164-78d8-805c-89b5-c173fb54ffc4",
            "parent": {
              "type": "block_id",
              "block_id": "2395d164-78d8-8003-af8e-d8dc21c30235"
            },
            "created_time": "2025-07-26T09:16:00.000Z",
            "last_edited_time": "2025-07-31T01:38:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753547714/uxcomic-imgs/23c5d164-78d8-805c-89b5-c173fb54ffc4.png",
                "expiry_time": "2026-10-04T09:10:48.198Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23c5d164-78d8-805c-89b5-c173fb54ffc4"
          },
          {
            "object": "block",
            "id": "23c5d164-78d8-8024-8bbb-e92dc7914aa7",
            "parent": {
              "type": "block_id",
              "block_id": "2395d164-78d8-8003-af8e-d8dc21c30235"
            },
            "created_time": "2025-07-26T09:16:00.000Z",
            "last_edited_time": "2025-07-31T01:38:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753547715/uxcomic-imgs/23c5d164-78d8-8024-8bbb-e92dc7914aa7.png",
                "expiry_time": "2026-10-04T09:10:48.198Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23c5d164-78d8-8024-8bbb-e92dc7914aa7"
          },
          {
            "object": "block",
            "id": "23c5d164-78d8-801b-b5fe-c898c13fd880",
            "parent": {
              "type": "block_id",
              "block_id": "2395d164-78d8-8003-af8e-d8dc21c30235"
            },
            "created_time": "2025-07-26T09:16:00.000Z",
            "last_edited_time": "2025-07-31T01:38:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753547716/uxcomic-imgs/23c5d164-78d8-801b-b5fe-c898c13fd880.png",
                "expiry_time": "2026-10-04T09:10:48.198Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23c5d164-78d8-801b-b5fe-c898c13fd880"
          }
        ]
      },
      {
        "object": "block",
        "id": "11a5d164-78d8-80cb-84ca-e80faef723fe",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-800e-93cc-d89ca8ed01bc"
        },
        "created_time": "2024-10-09T11:08:00.000Z",
        "last_edited_time": "2024-10-09T11:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "11a5d164-78d8-80d8-aaad-cab75179ee12",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-800e-93cc-d89ca8ed01bc"
        },
        "created_time": "2024-10-09T11:10:00.000Z",
        "last_edited_time": "2025-07-26T09:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Items",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Items",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80f0-bc57-e9500419e5a9",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-800e-93cc-d89ca8ed01bc"
        },
        "created_time": "2025-07-28T06:32:00.000Z",
        "last_edited_time": "2025-07-28T06:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "22d5d164-78d8-805e-91ed-ebff577e5186"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX pattern",
              "href": "https://app.notion.com/p/22d5d16478d8805e91edebff577e5186"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-8044-b4ab-c7ca003c6e4c",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-800e-93cc-d89ca8ed01bc"
        },
        "created_time": "2025-07-28T05:54:00.000Z",
        "last_edited_time": "2025-07-28T06:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mental model?",
              "href": "https://app.notion.com/p/73bdf5d9ca494b2789a22dde16b2af7d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1195d164-78d8-80db-a620-d79bfde9595c",
    "created_time": "2024-10-08T10:13:00.000Z",
    "last_edited_time": "2025-07-27T06:08:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-10-08T10:13:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 3
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "1-Design",
          "color": "default"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-07-27T06:08:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "sgq|",
          "name": "⚔️:1",
          "color": "red"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Information, Message, Content",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Information, Message, Content",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Information-Message-Content-1195d16478d880dba620d79bfde9595c",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Design",
      "slug": "design",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "1195d164-78d8-806a-8f41-f8e09656c8b5",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80db-a620-d79bfde9595c"
        },
        "created_time": "2024-10-08T15:55:00.000Z",
        "last_edited_time": "2024-10-08T15:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081203/uxcomic-imgs/1195d164-78d8-806a-8f41-f8e09656c8b5.png",
            "expiry_time": "2026-10-04T09:10:49.919Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1195d164-78d8-806a-8f41-f8e09656c8b5"
      },
      {
        "object": "block",
        "id": "23c5d164-78d8-8038-a459-c4e1e84bf76f",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80db-a620-d79bfde9595c"
        },
        "created_time": "2025-07-26T16:24:00.000Z",
        "last_edited_time": "2025-07-27T00:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lấy cảm hứng từ “form follow function”, phân biệt cái này cũng thú vị, nó giúp mình phân tách rõ các phần để ideate cho từng chủ đích riêng biệt khi phải làm việc với content. Content ở đây mang nghĩa nội dung, nên nó có thể là chữ viết, là hình ảnh, là hành vi, nó có thể tồn tại nhiều dạng form thái khác nhau.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lấy cảm hứng từ “form follow function”, phân biệt cái này cũng thú vị, nó giúp mình phân tách rõ các phần để ideate cho từng chủ đích riêng biệt khi phải làm việc với content. Content ở đây mang nghĩa nội dung, nên nó có thể là chữ viết, là hình ảnh, là hành vi, nó có thể tồn tại nhiều dạng form thái khác nhau.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23c5d164-78d8-80af-977e-e454c7f39369",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80db-a620-d79bfde9595c"
        },
        "created_time": "2025-07-26T16:22:00.000Z",
        "last_edited_time": "2025-07-27T06:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "list",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "list",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "23d5d164-78d8-80f4-ba78-faacfaad0cd9",
            "parent": {
              "type": "block_id",
              "block_id": "23c5d164-78d8-80af-977e-e454c7f39369"
            },
            "created_time": "2025-07-27T00:44:00.000Z",
            "last_edited_time": "2025-07-27T00:44:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753581453/uxcomic-imgs/23d5d164-78d8-80f4-ba78-faacfaad0cd9.png",
                "expiry_time": "2026-10-04T09:10:50.323Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-80f4-ba78-faacfaad0cd9"
          },
          {
            "object": "block",
            "id": "23d5d164-78d8-8035-a46a-e4cb25292e80",
            "parent": {
              "type": "block_id",
              "block_id": "23c5d164-78d8-80af-977e-e454c7f39369"
            },
            "created_time": "2025-07-27T00:44:00.000Z",
            "last_edited_time": "2025-07-27T00:44:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753581454/uxcomic-imgs/23d5d164-78d8-8035-a46a-e4cb25292e80.png",
                "expiry_time": "2026-10-04T09:10:50.323Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-8035-a46a-e4cb25292e80"
          },
          {
            "object": "block",
            "id": "23d5d164-78d8-8046-8cbb-e43f75e3543f",
            "parent": {
              "type": "block_id",
              "block_id": "23c5d164-78d8-80af-977e-e454c7f39369"
            },
            "created_time": "2025-07-27T00:44:00.000Z",
            "last_edited_time": "2025-07-27T00:44:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753581455/uxcomic-imgs/23d5d164-78d8-8046-8cbb-e43f75e3543f.png",
                "expiry_time": "2026-10-04T09:10:50.323Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-8046-8cbb-e43f75e3543f"
          }
        ]
      },
      {
        "object": "block",
        "id": "1195d164-78d8-80b6-abfd-fa0cb1419d92",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80db-a620-d79bfde9595c"
        },
        "created_time": "2024-10-08T15:56:00.000Z",
        "last_edited_time": "2024-10-08T15:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1195d164-78d8-8130-8d61-fe6e1619967b",
    "created_time": "2024-10-08T09:58:00.000Z",
    "last_edited_time": "2025-07-28T06:58:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-10-08T09:58:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 1
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "1-Design",
          "color": "default"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-07-28T06:58:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "sgq|",
          "name": "⚔️:1",
          "color": "red"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "IxD checklist",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "IxD checklist",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/IxD-checklist-1195d16478d881308d61fe6e1619967b",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Design",
      "slug": "design",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "11a5d164-78d8-80d1-963a-f2e1858288e7",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-8130-8d61-fe6e1619967b"
        },
        "created_time": "2024-10-09T10:56:00.000Z",
        "last_edited_time": "2024-12-06T05:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081209/uxcomic-imgs/11a5d164-78d8-80d1-963a-f2e1858288e7.png",
            "expiry_time": "2026-10-04T09:10:51.382Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/11a5d164-78d8-80d1-963a-f2e1858288e7"
      },
      {
        "object": "block",
        "id": "4b92e2ab-2d4b-4700-9d33-f0ec46546221",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-8130-8d61-fe6e1619967b"
        },
        "created_time": "2024-12-30T11:29:00.000Z",
        "last_edited_time": "2025-07-27T00:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Interaction quan tâm đến sự tương tác giữa người & máy, chịu sự tác động qua lại giữa 2 bên.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Interaction quan tâm đến sự tương tác giữa người & máy, chịu sự tác động qua lại giữa 2 bên.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1735d164-78d8-802a-baf4-fbe6065b3552",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-8130-8d61-fe6e1619967b"
        },
        "created_time": "2025-01-06T16:27:00.000Z",
        "last_edited_time": "2025-07-27T00:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cheat sheet",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cheat sheet",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "23d5d164-78d8-801f-ae27-e909fb50a987",
            "parent": {
              "type": "block_id",
              "block_id": "1735d164-78d8-802a-baf4-fbe6065b3552"
            },
            "created_time": "2025-07-27T00:39:00.000Z",
            "last_edited_time": "2025-07-28T05:56:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753581457/uxcomic-imgs/23d5d164-78d8-801f-ae27-e909fb50a987.png",
                "expiry_time": "2026-10-04T09:10:51.747Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-801f-ae27-e909fb50a987"
          },
          {
            "object": "block",
            "id": "23c5d164-78d8-80d7-b6ec-e2391dd2f7b9",
            "parent": {
              "type": "block_id",
              "block_id": "1735d164-78d8-802a-baf4-fbe6065b3552"
            },
            "created_time": "2025-07-26T16:13:00.000Z",
            "last_edited_time": "2025-07-26T16:47:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753547724/uxcomic-imgs/23c5d164-78d8-80d7-b6ec-e2391dd2f7b9.png",
                "expiry_time": "2026-10-04T09:10:51.748Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23c5d164-78d8-80d7-b6ec-e2391dd2f7b9"
          },
          {
            "object": "block",
            "id": "23c5d164-78d8-8095-8bac-e49c8ea96bf8",
            "parent": {
              "type": "block_id",
              "block_id": "1735d164-78d8-802a-baf4-fbe6065b3552"
            },
            "created_time": "2025-07-26T16:13:00.000Z",
            "last_edited_time": "2025-07-26T16:47:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753547725/uxcomic-imgs/23c5d164-78d8-8095-8bac-e49c8ea96bf8.png",
                "expiry_time": "2026-10-04T09:10:51.748Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23c5d164-78d8-8095-8bac-e49c8ea96bf8"
          },
          {
            "object": "block",
            "id": "23c5d164-78d8-80cc-a971-ee5eb3229847",
            "parent": {
              "type": "block_id",
              "block_id": "1735d164-78d8-802a-baf4-fbe6065b3552"
            },
            "created_time": "2025-07-26T16:13:00.000Z",
            "last_edited_time": "2025-07-26T16:47:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753547726/uxcomic-imgs/23c5d164-78d8-80cc-a971-ee5eb3229847.png",
                "expiry_time": "2026-10-04T09:10:51.748Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23c5d164-78d8-80cc-a971-ee5eb3229847"
          },
          {
            "object": "block",
            "id": "23c5d164-78d8-806f-8a35-e83fbf01e97c",
            "parent": {
              "type": "block_id",
              "block_id": "1735d164-78d8-802a-baf4-fbe6065b3552"
            },
            "created_time": "2025-07-26T16:13:00.000Z",
            "last_edited_time": "2025-07-26T16:47:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753547727/uxcomic-imgs/23c5d164-78d8-806f-8a35-e83fbf01e97c.png",
                "expiry_time": "2026-10-04T09:10:51.748Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23c5d164-78d8-806f-8a35-e83fbf01e97c"
          },
          {
            "object": "block",
            "id": "23d5d164-78d8-80f0-91d5-c7539ab8c2f7",
            "parent": {
              "type": "block_id",
              "block_id": "1735d164-78d8-802a-baf4-fbe6065b3552"
            },
            "created_time": "2025-07-27T00:41:00.000Z",
            "last_edited_time": "2025-07-28T05:56:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753581459/uxcomic-imgs/23d5d164-78d8-80f0-91d5-c7539ab8c2f7.png",
                "expiry_time": "2026-10-04T09:10:51.748Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23d5d164-78d8-80f0-91d5-c7539ab8c2f7"
          },
          {
            "object": "block",
            "id": "23c5d164-78d8-808a-b481-e70a49d6ac38",
            "parent": {
              "type": "block_id",
              "block_id": "1735d164-78d8-802a-baf4-fbe6065b3552"
            },
            "created_time": "2025-07-26T16:13:00.000Z",
            "last_edited_time": "2025-07-28T05:56:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753547730/uxcomic-imgs/23c5d164-78d8-808a-b481-e70a49d6ac38.png",
                "expiry_time": "2026-10-04T09:10:51.748Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23c5d164-78d8-808a-b481-e70a49d6ac38"
          },
          {
            "object": "block",
            "id": "23c5d164-78d8-8054-8e9c-cd5a0fdc996d",
            "parent": {
              "type": "block_id",
              "block_id": "1735d164-78d8-802a-baf4-fbe6065b3552"
            },
            "created_time": "2025-07-26T16:13:00.000Z",
            "last_edited_time": "2025-07-27T00:58:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753547731/uxcomic-imgs/23c5d164-78d8-8054-8e9c-cd5a0fdc996d.png",
                "expiry_time": "2026-10-04T09:10:51.748Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23c5d164-78d8-8054-8e9c-cd5a0fdc996d"
          }
        ]
      },
      {
        "object": "block",
        "id": "1545d164-78d8-8024-bf4c-c627ff51b665",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-8130-8d61-fe6e1619967b"
        },
        "created_time": "2024-12-06T02:47:00.000Z",
        "last_edited_time": "2024-12-06T02:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1545d164-78d8-80c6-a6f5-f480d9368972",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-8130-8d61-fe6e1619967b"
        },
        "created_time": "2024-12-06T02:47:00.000Z",
        "last_edited_time": "2024-12-06T02:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80ad-87f8-cb34930c8518",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-8130-8d61-fe6e1619967b"
        },
        "created_time": "2025-07-28T06:32:00.000Z",
        "last_edited_time": "2025-07-28T06:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Interaction Pattern",
              "href": "https://app.notion.com/p/56798be37f484cfea30e49cc2dedd33d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-8067-8fcc-ce3a78822e6a",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-8130-8d61-fe6e1619967b"
        },
        "created_time": "2025-07-28T05:57:00.000Z",
        "last_edited_time": "2025-07-28T05:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "2345d164-78d8-8068-929a-ed7272e1260b"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Interaction cost",
              "href": "https://app.notion.com/p/2345d16478d88068929aed7272e1260b"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1745d164-78d8-802d-80f5-c21e2686c8cf",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-8130-8d61-fe6e1619967b"
        },
        "created_time": "2025-01-07T02:27:00.000Z",
        "last_edited_time": "2025-07-26T09:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1195d164-78d8-81ac-9a30-d03724b3531b"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Usability Heuristics",
              "href": "https://app.notion.com/p/1195d16478d881ac9a30d03724b3531b"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1195d164-78d8-81ac-9a30-d03724b3531b",
    "created_time": "2024-10-08T09:58:00.000Z",
    "last_edited_time": "2025-07-27T01:00:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1195d164-78d8-8133-84aa-e48f31eb9cac"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-10-08T09:58:00.000Z"
      },
      "ID": {
        "id": "PpAE",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CS",
          "number": 2
        }
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "1-Design",
          "color": "default"
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-07-27T01:00:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "prxX",
          "name": "⚔️:2",
          "color": "yellow"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Usability Heuristics",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Usability Heuristics",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Usability-Heuristics-1195d16478d881ac9a30d03724b3531b",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1195d164-78d8-8065-a1df-f4f8e3c089fd",
      "name": "Cheat sheet",
      "slug": "cheat-sheet",
      "icon": "🧩",
      "order": 1,
      "created_time": "2024-10-08T09:58:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Design",
          "slug": "design",
          "order": 1
        },
        {
          "id": "e01c5a08-4b91-45db-8aca-0720767c6574",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "34ab4e5c-eb99-46c6-af9c-27ca71f10955",
          "name": "Other",
          "slug": "other",
          "order": 3
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Design",
      "slug": "design",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "1195d164-78d8-80ed-84a0-f8bd2c207bd0",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-81ac-9a30-d03724b3531b"
        },
        "created_time": "2024-10-08T15:31:00.000Z",
        "last_edited_time": "2024-10-08T15:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081215/uxcomic-imgs/1195d164-78d8-80ed-84a0-f8bd2c207bd0.png",
            "expiry_time": "2026-10-04T09:10:53.792Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1195d164-78d8-80ed-84a0-f8bd2c207bd0"
      },
      {
        "object": "block",
        "id": "19b61827-21bb-4e84-858f-08b88120c0f3",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-81ac-9a30-d03724b3531b"
        },
        "created_time": "2024-10-08T15:31:00.000Z",
        "last_edited_time": "2025-07-26T09:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phương pháp này giúp bạn audit lại usability cho UI, để make sure nó user-friendly và tăng tính hiệu quả sử dụng. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phương pháp này giúp bạn audit lại usability cho UI, để make sure nó user-friendly và tăng tính hiệu quả sử dụng. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2395d164-78d8-803e-9877-cfc20906fd4c",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-81ac-9a30-d03724b3531b"
        },
        "created_time": "2025-07-23T10:00:00.000Z",
        "last_edited_time": "2025-07-26T09:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Usability heuristic",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Usability heuristic",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "23c5d164-78d8-80d5-94e7-fe659185a638",
            "parent": {
              "type": "block_id",
              "block_id": "2395d164-78d8-803e-9877-cfc20906fd4c"
            },
            "created_time": "2025-07-26T09:34:00.000Z",
            "last_edited_time": "2025-07-27T00:59:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753547733/uxcomic-imgs/23c5d164-78d8-80d5-94e7-fe659185a638.png",
                "expiry_time": "2026-10-04T09:10:54.213Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23c5d164-78d8-80d5-94e7-fe659185a638"
          },
          {
            "object": "block",
            "id": "23c5d164-78d8-80a8-86da-d4a33b287aec",
            "parent": {
              "type": "block_id",
              "block_id": "2395d164-78d8-803e-9877-cfc20906fd4c"
            },
            "created_time": "2025-07-26T09:34:00.000Z",
            "last_edited_time": "2025-07-26T09:34:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753547734/uxcomic-imgs/23c5d164-78d8-80a8-86da-d4a33b287aec.png",
                "expiry_time": "2026-10-04T09:10:54.213Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23c5d164-78d8-80a8-86da-d4a33b287aec"
          },
          {
            "object": "block",
            "id": "23c5d164-78d8-80c2-86d4-e5e8e4894112",
            "parent": {
              "type": "block_id",
              "block_id": "2395d164-78d8-803e-9877-cfc20906fd4c"
            },
            "created_time": "2025-07-26T09:34:00.000Z",
            "last_edited_time": "2025-07-26T09:34:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753547735/uxcomic-imgs/23c5d164-78d8-80c2-86d4-e5e8e4894112.png",
                "expiry_time": "2026-10-04T09:10:54.213Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23c5d164-78d8-80c2-86d4-e5e8e4894112"
          },
          {
            "object": "block",
            "id": "23c5d164-78d8-8038-9612-ff0ae0df68b2",
            "parent": {
              "type": "block_id",
              "block_id": "2395d164-78d8-803e-9877-cfc20906fd4c"
            },
            "created_time": "2025-07-26T09:34:00.000Z",
            "last_edited_time": "2025-07-27T01:00:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753547736/uxcomic-imgs/23c5d164-78d8-8038-9612-ff0ae0df68b2.png",
                "expiry_time": "2026-10-04T09:10:54.213Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23c5d164-78d8-8038-9612-ff0ae0df68b2"
          },
          {
            "object": "block",
            "id": "23c5d164-78d8-80ff-87ab-d92b99ce4c9f",
            "parent": {
              "type": "block_id",
              "block_id": "2395d164-78d8-803e-9877-cfc20906fd4c"
            },
            "created_time": "2025-07-26T09:34:00.000Z",
            "last_edited_time": "2025-07-26T09:34:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753547737/uxcomic-imgs/23c5d164-78d8-80ff-87ab-d92b99ce4c9f.png",
                "expiry_time": "2026-10-04T09:10:54.213Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23c5d164-78d8-80ff-87ab-d92b99ce4c9f"
          },
          {
            "object": "block",
            "id": "23c5d164-78d8-80f6-9c17-cdd8c2f5b45c",
            "parent": {
              "type": "block_id",
              "block_id": "2395d164-78d8-803e-9877-cfc20906fd4c"
            },
            "created_time": "2025-07-26T09:34:00.000Z",
            "last_edited_time": "2025-07-26T09:34:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753547738/uxcomic-imgs/23c5d164-78d8-80f6-9c17-cdd8c2f5b45c.png",
                "expiry_time": "2026-10-04T09:10:54.213Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23c5d164-78d8-80f6-9c17-cdd8c2f5b45c"
          },
          {
            "object": "block",
            "id": "23c5d164-78d8-8077-82fd-d9a6452e48be",
            "parent": {
              "type": "block_id",
              "block_id": "2395d164-78d8-803e-9877-cfc20906fd4c"
            },
            "created_time": "2025-07-26T09:34:00.000Z",
            "last_edited_time": "2025-07-26T09:34:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753547739/uxcomic-imgs/23c5d164-78d8-8077-82fd-d9a6452e48be.png",
                "expiry_time": "2026-10-04T09:10:54.213Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23c5d164-78d8-8077-82fd-d9a6452e48be"
          },
          {
            "object": "block",
            "id": "23c5d164-78d8-80d6-947d-c7b69d2760e7",
            "parent": {
              "type": "block_id",
              "block_id": "2395d164-78d8-803e-9877-cfc20906fd4c"
            },
            "created_time": "2025-07-26T09:34:00.000Z",
            "last_edited_time": "2025-07-26T09:34:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753547740/uxcomic-imgs/23c5d164-78d8-80d6-947d-c7b69d2760e7.png",
                "expiry_time": "2026-10-04T09:10:54.213Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23c5d164-78d8-80d6-947d-c7b69d2760e7"
          },
          {
            "object": "block",
            "id": "23c5d164-78d8-8077-b8a4-ed17669e6b08",
            "parent": {
              "type": "block_id",
              "block_id": "2395d164-78d8-803e-9877-cfc20906fd4c"
            },
            "created_time": "2025-07-26T09:34:00.000Z",
            "last_edited_time": "2025-07-26T09:34:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753547741/uxcomic-imgs/23c5d164-78d8-8077-b8a4-ed17669e6b08.png",
                "expiry_time": "2026-10-04T09:10:54.213Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23c5d164-78d8-8077-b8a4-ed17669e6b08"
          },
          {
            "object": "block",
            "id": "23c5d164-78d8-80a3-8082-c28286d8e2d9",
            "parent": {
              "type": "block_id",
              "block_id": "2395d164-78d8-803e-9877-cfc20906fd4c"
            },
            "created_time": "2025-07-26T09:34:00.000Z",
            "last_edited_time": "2025-07-27T01:00:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753547742/uxcomic-imgs/23c5d164-78d8-80a3-8082-c28286d8e2d9.png",
                "expiry_time": "2026-10-04T09:10:54.213Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/23c5d164-78d8-80a3-8082-c28286d8e2d9"
          }
        ]
      }
    ]
  },
  {
    "object": "page",
    "id": "10f5d164-78d8-804f-b8ea-e2a265424273",
    "created_time": "2024-09-28T03:59:00.000Z",
    "last_edited_time": "2025-08-15T10:43:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "page_id",
      "page_id": "a58596ad-902a-49e3-9a81-fdb9b84b92d9"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "title": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "UX comic - Introduction",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "UX comic - Introduction",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/UX-comic-Introduction-10f5d16478d8804fb8eae2a265424273",
    "public_url": null,
    "archived": false,
    "request_id": "65bb59fa-7cf1-44b5-ba5a-e5a3f8e861ba",
    "content": [
      {
        "object": "block",
        "id": "1145d164-78d8-8054-b6ed-ee06674bf4ed",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-03T14:54:00.000Z",
        "last_edited_time": "2024-10-03T14:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081079/uxcomic-imgs/1145d164-78d8-8054-b6ed-ee06674bf4ed.png",
            "expiry_time": "2026-10-04T09:10:56.464Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1145d164-78d8-8054-b6ed-ee06674bf4ed"
      },
      {
        "object": "block",
        "id": "1175d164-78d8-8062-b2b6-e5d5c1f1d3b4",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-06T13:42:00.000Z",
        "last_edited_time": "2024-10-06T13:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tụi mình ở đây để chia sẻ các kiến thức, góc nhìn cá nhân về hành trình làm nghề UX/UI.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tụi mình ở đây để chia sẻ các kiến thức, góc nhìn cá nhân về hành trình làm nghề UX/UI.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "👋"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-80f5-ba2a-dc7da74d909e",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-09-28T04:03:00.000Z",
        "last_edited_time": "2025-01-14T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình xin giới thiệu chút, mình có background công việc trong graphic design, illustrator, sau đó mình chuyển sang lĩnh vực UX/UI, và chắc cũng như đa phần mọi người đó là học vài khoá, tự mày mò đọc blog để học hỏi thêm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình xin giới thiệu chút, mình có background công việc trong graphic design, illustrator, sau đó mình chuyển sang lĩnh vực UX/UI, và chắc cũng như đa phần mọi người đó là học vài khoá, tự mày mò đọc blog để học hỏi thêm.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-8022-90a4-e47dd0056496",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-14T02:05:00.000Z",
        "last_edited_time": "2025-01-14T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80b8-ba44-f0b7bbe1c82c",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-22T16:01:00.000Z",
        "last_edited_time": "2024-12-25T02:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuy nhiên trong quá trình tự học, mình hay gặp phải các vấn đề sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuy nhiên trong quá trình tự học, mình hay gặp phải các vấn đề sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-80c7-9e98-d40601cb5d76",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-09-28T04:11:00.000Z",
        "last_edited_time": "2024-12-25T02:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "😵 Theo thời gian, kiến thức gia tăng, mọi thứ dần trở nên rối ren, chi chít như màn nhện,  nó như cái cảnh mình vào khu rừng mà không có map, cứ xoay vòng vòng, vòng vòng, vòng vòng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "😵 Theo thời gian, kiến thức gia tăng, mọi thứ dần trở nên rối ren, chi chít như màn nhện,  nó như cái cảnh mình vào khu rừng mà không có map, cứ xoay vòng vòng, vòng vòng, vòng vòng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-8055-ba1e-cdeabdc6e536",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-09-28T04:11:00.000Z",
        "last_edited_time": "2024-12-25T02:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "🫣 Mặc dù đã cất công collect, tự học các thứ nhưng đến lúc làm thực tế thì lại quên bén đi, xong tự chửi bản thân: “học chi cho lắm không áp dụng được gì”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "🫣 Mặc dù đã cất công collect, tự học các thứ nhưng đến lúc làm thực tế thì lại quên bén đi, xong tự chửi bản thân: “học chi cho lắm không áp dụng được gì”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80e9-a617-fed34699865b",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T02:40:00.000Z",
        "last_edited_time": "2024-12-25T02:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "😫 Đến lúc nhớ để áp dụng rồi thì lại có khi không phù hợp, kết quả không như  khuôn mẫu sách vở.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "😫 Đến lúc nhớ để áp dụng rồi thì lại có khi không phù hợp, kết quả không như  khuôn mẫu sách vở.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80bd-821c-d1385c95355a",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-22T14:48:00.000Z",
        "last_edited_time": "2024-12-23T03:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081080/uxcomic-imgs/1645d164-78d8-80bd-821c-d1385c95355a.jpg",
            "expiry_time": "2026-10-04T09:10:56.465Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1645d164-78d8-80bd-821c-d1385c95355a"
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-80c2-a417-ca89e359e251",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-27T04:48:00.000Z",
        "last_edited_time": "2024-12-22T16:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1175d164-78d8-802e-b0b2-e9f603db4448",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-06T07:32:00.000Z",
        "last_edited_time": "2025-01-14T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Rồi tình cờ, mình có nghe đến kĩ thuật Feyman trong việc học - đại ý là học làm sao để bạn có thể dạy lại được cho người khác. Sau đó mình bắt đầu áp dụng, tập thói quen nghiền ngẫm, tập hệ thống hoá, để “ôn bài”, để biết thêm những thứ mà mình tưởng là mình đã biết >> 💡 project được sinh ra",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Rồi tình cờ, mình có nghe đến kĩ thuật Feyman trong việc học - đại ý là học làm sao để bạn có thể dạy lại được cho người khác. Sau đó mình bắt đầu áp dụng, tập thói quen nghiền ngẫm, tập hệ thống hoá, để “ôn bài”, để biết thêm những thứ mà mình tưởng là mình đã biết >> 💡 project được sinh ra",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-801d-bbfe-cbe5f489c720",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-10T02:05:00.000Z",
        "last_edited_time": "2025-01-12T14:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Share your knowledge and teach others — it benefits both of you!",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Share your knowledge and teach others — it benefits both of you!",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13f5d164-78d8-801a-871e-c9d89a1c3ec0",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-11-15T02:12:00.000Z",
        "last_edited_time": "2024-11-15T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-80ac-ba44-fb1e73088960",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-14T02:37:00.000Z",
        "last_edited_time": "2025-08-14T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "✏️ Other tiny things",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "✏️ Other tiny things",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-8041-b4ef-f5c09e17be85",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T02:57:00.000Z",
        "last_edited_time": "2025-01-14T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lê thê vậy đủ rồi. Nếu bạn có thêm chút thời gian, hãy xem thêm các chú thích ở dưới nhé, vì nó liên quan đến giá trị “hệ thống hoá” mà mình đang muốn offer khi làm blog này.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lê thê vậy đủ rồi. Nếu bạn có thêm chút thời gian, hãy xem thêm các chú thích ở dưới nhé, vì nó liên quan đến giá trị “hệ thống hoá” mà mình đang muốn offer khi làm blog này.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8033-b108-debe1f729659",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:55:00.000Z",
        "last_edited_time": "2025-08-14T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755136730/uxcomic-imgs/24f5d164-78d8-8033-b108-debe1f729659.png",
            "expiry_time": "2026-10-04T09:10:56.465Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/24f5d164-78d8-8033-b108-debe1f729659"
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80cf-9e31-eba6bd4663a0",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:02:00.000Z",
        "last_edited_time": "2025-08-14T01:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1175d164-78d8-807a-bc07-ce1b50fe378a",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-06T13:38:00.000Z",
        "last_edited_time": "2025-08-14T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "📢 ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "📢 ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Disclaimer",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Disclaimer",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8071-af14-c321c266389f",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:47:00.000Z",
        "last_edited_time": "2025-08-15T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "các bài viết này là tổng hợp của những kiến thức lượm lặt trên mạng + chatGPT + góc độ, quan sát cá nhân >> mình vẫn có thể sai >> nên đừng vội chấp nhận hoặc tin hết những gì mình viết (mặc dù mình đều cố gắng tìm hiểu các nguồn đáng tin cậy và kèm link reference cho từng bài viết nếu có).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "các bài viết này là tổng hợp của những kiến thức lượm lặt trên mạng + chatGPT + góc độ, quan sát cá nhân >> mình vẫn có thể sai >> nên đừng vội chấp nhận hoặc tin hết những gì mình viết (mặc dù mình đều cố gắng tìm hiểu các nguồn đáng tin cậy và kèm link reference cho từng bài viết nếu có).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8070-a7db-d7a5898e615d",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:47:00.000Z",
        "last_edited_time": "2025-08-15T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hãy xem mình như một người bạn, một đồng nghiệp như đang trò chuyện với bạn trong một buổi ăn trưa, một buổi hẹn cafe, chúng mình ở đây để chia sẻ và học hỏi nhau trên con đường mày mò & cải thiện quá trình làm nghề UX/UI.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hãy xem mình như một người bạn, một đồng nghiệp như đang trò chuyện với bạn trong một buổi ăn trưa, một buổi hẹn cafe, chúng mình ở đây để chia sẻ và học hỏi nhau trên con đường mày mò & cải thiện quá trình làm nghề UX/UI.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80be-bd5b-fde96187a589",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:48:00.000Z",
        "last_edited_time": "2025-08-15T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Again luôn recheck các thông tin, luận điểm của mình nhé. Cảm ơn mọi người nhiều 😜.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Again luôn recheck các thông tin, luận điểm của mình nhé. Cảm ơn mọi người nhiều 😜.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80b0-a0cf-c3d3ac509af9",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:03:00.000Z",
        "last_edited_time": "2025-01-14T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1815d164-78d8-8043-8c86-f3f060cfaa2c",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-20T03:25:00.000Z",
        "last_edited_time": "2025-01-20T03:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Contact",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Contact",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80e8-8428-f6dcc343a5ec",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T02:45:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình rất vui lòng nếu nhận được những góc nhìn khác từ các bạn, nếu bạn muốn liên hệ hay chia sẻ gì với mình thêm, hay muốn mình share topic gì khác, hãy để lại lời nhắn qua:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình rất vui lòng nếu nhận được những góc nhìn khác từ các bạn, nếu bạn muốn liên hệ hay chia sẻ gì với mình thêm, hay muốn mình share topic gì khác, hãy để lại lời nhắn qua:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1c15d164-78d8-80dc-bc47-ff02b571cf37",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-03-25T05:59:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1815d164-78d8-8006-8bb0-f9639445d848",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-20T03:23:00.000Z",
        "last_edited_time": "2025-01-20T03:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thread",
                "link": {
                  "url": "https://www.threads.net/@ux_share_choi?hl=vi"
                }
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thread",
              "href": "https://www.threads.net/@ux_share_choi?hl=vi"
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "💬"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1815d164-78d8-801b-b02c-f6a970beae36",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-20T03:23:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Linkedin",
                "link": {
                  "url": "https://www.linkedin.com/in/minhhuynh95/"
                }
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Linkedin",
              "href": "https://www.linkedin.com/in/minhhuynh95/"
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "💼"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1c15d164-78d8-80aa-b4ae-d81e4bdbad4e",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-03-25T05:59:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-8081-8eb4-f9373214ab36",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:10:00.000Z",
        "last_edited_time": "2024-12-25T03:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081083/uxcomic-imgs/1675d164-78d8-8081-8eb4-f9373214ab36.png",
            "expiry_time": "2026-10-04T09:10:56.516Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1675d164-78d8-8081-8eb4-f9373214ab36"
      },
      {
        "object": "block",
        "id": "1675d164-78d8-802d-a902-c546642f72dc",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:03:00.000Z",
        "last_edited_time": "2024-12-28T03:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mong các bài viết này có chút hữu ích cho bạn 🥰. Dự án được built with ❤️‍🔥 bởi ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mong các bài viết này có chút hữu ích cho bạn 🥰. Dự án được built with ❤️‍🔥 bởi ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Minh",
                "link": {
                  "url": "https://www.linkedin.com/in/minhhuynh95/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Minh",
              "href": "https://www.linkedin.com/in/minhhuynh95/"
            },
            {
              "type": "text",
              "text": {
                "content": " & ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " & ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Hùng",
                "link": {
                  "url": "https://www.linkedin.com/in/vhung71/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hùng",
              "href": "https://www.linkedin.com/in/vhung71/"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "26aaa722-7e34-4293-bf96-4eaa09a6a24d",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-11-23T07:53:00.000Z",
        "last_edited_time": "2024-11-23T07:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-80ef-a681-d83a4e28308a",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-27T04:50:00.000Z",
        "last_edited_time": "2024-10-27T04:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791",
    "created_time": "2025-10-14T01:33:00.000Z",
    "last_edited_time": "2025-10-15T02:01:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2025-10-14T01:33:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "3-Workflow",
          "color": "default"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 81
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-10-15T02:01:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "CDA\\",
          "name": "⚓:2",
          "color": "brown"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Meeting (P2)",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Meeting (P2)",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Meeting-P2-28c5d16478d88096a9cfcecf8ddd4791",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
      "name": "Workflow",
      "slug": "workflow",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "28c5d164-78d8-8077-9342-d187b9e198db",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T01:34:00.000Z",
        "last_edited_time": "2025-10-14T01:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1760493266/uxcomic-imgs/28c5d164-78d8-8077-9342-d187b9e198db.png",
            "expiry_time": "2026-10-04T09:10:58.233Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/28c5d164-78d8-8077-9342-d187b9e198db"
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-80fe-a94e-e8a1d5ba7183",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T01:34:00.000Z",
        "last_edited_time": "2025-10-14T01:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mặc dù xem trên mạng có thể thấy được rất nhiều kĩ thật có thể apply cho meeting, nhưng mình đang muốn tổng hợp lại những tip hay ho nhất trong bài viết này.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mặc dù xem trên mạng có thể thấy được rất nhiều kĩ thật có thể apply cho meeting, nhưng mình đang muốn tổng hợp lại những tip hay ho nhất trong bài viết này.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8069-a215-fbfd4740adff",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T01:35:00.000Z",
        "last_edited_time": "2025-10-14T01:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu được chia làm 3 vòng tròn, vòng tròn trong cùng sẽ là thứ cốt lõi nhất thì có thể chia như sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu được chia làm 3 vòng tròn, vòng tròn trong cùng sẽ là thứ cốt lõi nhất thì có thể chia như sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28d5d164-78d8-8028-90d3-f70deda07562",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-15T01:52:00.000Z",
        "last_edited_time": "2025-10-15T01:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1760493267/uxcomic-imgs/28d5d164-78d8-8028-90d3-f70deda07562.png",
            "expiry_time": "2026-10-04T09:10:58.234Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/28d5d164-78d8-8028-90d3-f70deda07562"
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8018-9029-fd2bc123f7d6",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T01:37:00.000Z",
        "last_edited_time": "2025-10-14T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8048-8527-ce32cb82d255",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T01:37:00.000Z",
        "last_edited_time": "2025-10-14T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Năng lượng & Mindset",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Năng lượng & Mindset",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-80fa-af8c-e9c53014b603",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T01:37:00.000Z",
        "last_edited_time": "2025-10-14T01:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đây là thứ vô thức tác động mạnh mẽ nhất đến mọi thứ ta sẽ truyền đạt và phía đối phương phản hồi ra sao.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đây là thứ vô thức tác động mạnh mẽ nhất đến mọi thứ ta sẽ truyền đạt và phía đối phương phản hồi ra sao.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-800b-b981-fb8b5dc802f0",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T01:38:00.000Z",
        "last_edited_time": "2025-10-14T01:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lấy ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lấy ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-809b-85f1-d283863ecce5",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T01:38:00.000Z",
        "last_edited_time": "2025-10-14T01:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu bạn thiếu tự tin, thì nội dung bạn truyền tải mặc dù là đúng đi nữa, họ vẫn sẽ hoài nghi (mà chưa kể nhiều thứ không có đúng sai thì khả năng hoài nghi càng cao).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu bạn thiếu tự tin, thì nội dung bạn truyền tải mặc dù là đúng đi nữa, họ vẫn sẽ hoài nghi (mà chưa kể nhiều thứ không có đúng sai thì khả năng hoài nghi càng cao).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-80b2-b12f-f94f4e2c4bfb",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T01:39:00.000Z",
        "last_edited_time": "2025-10-14T01:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu bạn cao ngạo, thì họ cũng sẽ có xu hướng phản bác bạn lại thay vì là thật sự lắng nghe ý bạn trình bày.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu bạn cao ngạo, thì họ cũng sẽ có xu hướng phản bác bạn lại thay vì là thật sự lắng nghe ý bạn trình bày.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-80f9-a356-ecd0a55da485",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T01:40:00.000Z",
        "last_edited_time": "2025-10-14T01:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu bạn máy móc, thì sẽ rất dễ khiến họ nghe nội dung đó một cách nửa vời.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu bạn máy móc, thì sẽ rất dễ khiến họ nghe nội dung đó một cách nửa vời.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8075-adb6-ea16216c08ca",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T01:41:00.000Z",
        "last_edited_time": "2025-10-14T01:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "v.v",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "v.v",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8021-ad85-f8284a4b8764",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T01:41:00.000Z",
        "last_edited_time": "2025-10-14T01:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy ta nên set mindset và năng lượng ra sao?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy ta nên set mindset và năng lượng ra sao?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-80b9-bece-d5ffd26a7b8d",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T01:41:00.000Z",
        "last_edited_time": "2025-10-14T01:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước mắt, hãy nghĩ theo hướng win-win, chúng ta ngồi đây vì cùng đang muốn hướng đến một điều gì đó, bạn ở đây là để làm cộng tác, làm người đồng hành để giúp đỡ nhau đến đích. Từ góc nhìn này, ta bỏ đi cái lớp “phải chứng minh” sang việc “cùng thảo luận và cùng nhau ra quyết định”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước mắt, hãy nghĩ theo hướng win-win, chúng ta ngồi đây vì cùng đang muốn hướng đến một điều gì đó, bạn ở đây là để làm cộng tác, làm người đồng hành để giúp đỡ nhau đến đích. Từ góc nhìn này, ta bỏ đi cái lớp “phải chứng minh” sang việc “cùng thảo luận và cùng nhau ra quyết định”.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8070-ac9c-e4baeda7030f",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T01:43:00.000Z",
        "last_edited_time": "2025-10-14T01:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đặt mình như vai một người “hướng dẫn viên du lịch (tour guide)”, lúc này mình sẽ dẫn dắt họ khám phá mọi ngóc ngách, cho họ tham quan các góc cạnh khác nhau của vấn đề & giải pháp, kể câu chuyện để lôi cuốn người nghe, ta liên tục đọc vị họ (read the room) và có nhóm thì thích xem chùa, có nhóm thì thích shopping…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đặt mình như vai một người “hướng dẫn viên du lịch (tour guide)”, lúc này mình sẽ dẫn dắt họ khám phá mọi ngóc ngách, cho họ tham quan các góc cạnh khác nhau của vấn đề & giải pháp, kể câu chuyện để lôi cuốn người nghe, ta liên tục đọc vị họ (read the room) và có nhóm thì thích xem chùa, có nhóm thì thích shopping…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8021-97d7-d252646583f1",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T01:50:00.000Z",
        "last_edited_time": "2025-10-14T01:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tour guide phải đảm bảo mọi người theo đoàn (mạch chuyện chính), không để họ lan man & lạc đi đâu đó (nếu họ muốn, ta sẽ dẫn họ đến sau, tour guide có thể xếp lại lịch trình).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tour guide phải đảm bảo mọi người theo đoàn (mạch chuyện chính), không để họ lan man & lạc đi đâu đó (nếu họ muốn, ta sẽ dẫn họ đến sau, tour guide có thể xếp lại lịch trình).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-803e-9ca6-ccbd890abd13",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T01:48:00.000Z",
        "last_edited_time": "2025-10-15T01:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu đã là tour guide, hẳn bạn cũng biết những người này rất friendly & giàu năng lượng, nó tạo thiện cảm tốt cho người nghe. Khi mà chính mình còn không thoải mái, không tự tin, không open thì làm sao expect đối phương cũng có tần số ấy.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu đã là tour guide, hẳn bạn cũng biết những người này rất friendly & giàu năng lượng, nó tạo thiện cảm tốt cho người nghe. Khi mà chính mình còn không thoải mái, không tự tin, không open thì làm sao expect đối phương cũng có tần số ấy.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8016-8ec3-f26313bf95a9",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T01:51:00.000Z",
        "last_edited_time": "2025-10-14T01:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chốt lại thì mình nên là người tự tin, tâm lý thoải mái và xem mọi người cùng chung con thuyền với mình.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chốt lại thì mình nên là người tự tin, tâm lý thoải mái và xem mọi người cùng chung con thuyền với mình.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8015-b7ce-c249e0e303e2",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T05:34:00.000Z",
        "last_edited_time": "2025-10-14T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Add on thêm 1 chút về first impression ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Add on thêm 1 chút về first impression ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8020-8ede-fce9689987ba",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T05:34:00.000Z",
        "last_edited_time": "2025-10-14T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đây sẽ là kiểu “trông mặt mà bắt hình dông”, họ có 1 thiện cảm nhất định khi biết về bạn, ngay cả khi bạn chưa nói gì.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đây sẽ là kiểu “trông mặt mà bắt hình dông”, họ có 1 thiện cảm nhất định khi biết về bạn, ngay cả khi bạn chưa nói gì.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-80bf-8567-dc4e618f81ed",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T05:34:00.000Z",
        "last_edited_time": "2025-10-14T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bởi vậy mới có việc nên chỉnh tề, gọn gàng, bằng cấp, role title, giải thưởng và build được good relationship,… tất cả những thứ này đã vô thức tác động đến cách họ tiếp nhận thông tin.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bởi vậy mới có việc nên chỉnh tề, gọn gàng, bằng cấp, role title, giải thưởng và build được good relationship,… tất cả những thứ này đã vô thức tác động đến cách họ tiếp nhận thông tin.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8016-ac71-c3a709152f61",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T05:34:00.000Z",
        "last_edited_time": "2025-10-14T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thử ngẫm lại xem, chính bạn có bị nó tác động hay không? Mình tin chắc là có.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thử ngẫm lại xem, chính bạn có bị nó tác động hay không? Mình tin chắc là có.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8001-8531-cf2f965bd102",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T05:34:00.000Z",
        "last_edited_time": "2025-10-14T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một ví dụ bạn thường gặp nữa là cho một buổi talkshow, trên poster và MC luôn giới thiệu về background khách mời, vì sao? Vì nó tác động ngay đến thái độ của bạn trước khi tiếp nhận thông tin.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một ví dụ bạn thường gặp nữa là cho một buổi talkshow, trên poster và MC luôn giới thiệu về background khách mời, vì sao? Vì nó tác động ngay đến thái độ của bạn trước khi tiếp nhận thông tin.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-807b-a3d0-cec965f1013c",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T05:35:00.000Z",
        "last_edited_time": "2025-10-14T05:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8081-bd97-d2aa34e2bdb8",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T05:34:00.000Z",
        "last_edited_time": "2025-10-14T05:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy chốt lại, mình mention đến thông tin này để làm gì, là để mình cũng phải biết “yếu tố tâm lý” này để tận dụng nó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy chốt lại, mình mention đến thông tin này để làm gì, là để mình cũng phải biết “yếu tố tâm lý” này để tận dụng nó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8027-89a2-e5c3eb5fe13f",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T05:35:00.000Z",
        "last_edited_time": "2025-10-14T05:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một chút gọn gàng khiến người ta muốn nghe hơn, một vài show off thành quả lại khiến họ chú tâm hơn, so why not. → Mình làm thế không phải để khoe mẽ gì, mình làm thế để họ xem trọng những gì mình nói hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một chút gọn gàng khiến người ta muốn nghe hơn, một vài show off thành quả lại khiến họ chú tâm hơn, so why not. → Mình làm thế không phải để khoe mẽ gì, mình làm thế để họ xem trọng những gì mình nói hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-80d7-850d-dd21228c7f9c",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T05:34:00.000Z",
        "last_edited_time": "2025-10-14T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-80f8-94ff-ea81ab22fe56",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T01:52:00.000Z",
        "last_edited_time": "2025-10-14T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cấu trúc thông tin (kịch bản)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cấu trúc thông tin (kịch bản)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8078-bf72-f23ea8a4ee45",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T01:53:00.000Z",
        "last_edited_time": "2025-10-14T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một buổi present hay là một câu chuyện được thiết kế có chủ đích.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một buổi present hay là một câu chuyện được thiết kế có chủ đích.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8058-9ef7-d8521551762e",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T01:53:00.000Z",
        "last_edited_time": "2025-10-14T05:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một cấu trúc hợp lý là khởi đầu cho mọi buổi meeting, vì nó ảnh hưởng trực tiếp đến cách audience nắm & hiểu nội dung, đó là lí do agenda được sinh ra.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một cấu trúc hợp lý là khởi đầu cho mọi buổi meeting, vì nó ảnh hưởng trực tiếp đến cách audience nắm & hiểu nội dung, đó là lí do agenda được sinh ra.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8032-9146-c21bfc8f4092",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T01:54:00.000Z",
        "last_edited_time": "2025-10-14T05:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Và hãy nhớ kịch bản này thay đổi tuỳ thuộc vào người nghe là ai, như có mention ở trên, tour guide phải biết có nhóm thích đi chùa, có nhóm thì shopping.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Và hãy nhớ kịch bản này thay đổi tuỳ thuộc vào người nghe là ai, như có mention ở trên, tour guide phải biết có nhóm thích đi chùa, có nhóm thì shopping.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8078-8c58-fc4623ea8096",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T01:55:00.000Z",
        "last_edited_time": "2025-10-14T05:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Về mặt cấu trúc ra sao, sẽ có rất nhiều dạng, nào là problem - solution - value, PEEL, Context - Conflict - Resolution, 3C,…cái này tuỳ vào chủ đích của buổi họp ấy, tuy nhiên để cho nó thú vị ta có thể apply vài tips sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Về mặt cấu trúc ra sao, sẽ có rất nhiều dạng, nào là problem - solution - value, PEEL, Context - Conflict - Resolution, 3C,…cái này tuỳ vào chủ đích của buổi họp ấy, tuy nhiên để cho nó thú vị ta có thể apply vài tips sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8055-81d3-cfe199e23cad",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T01:56:00.000Z",
        "last_edited_time": "2025-10-14T05:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chunk it down",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chunk it down",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": phải chia nội dung cuộc họp thành những khúc nhỏ, và chủ đích nhấn nhá cho từng khúc. Vì sao? Vì con người rất dễ quên, thông thường họ chỉ nhớ được điểm đầu, điểm cuối và bỏ quên nội dung ở giữa.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": phải chia nội dung cuộc họp thành những khúc nhỏ, và chủ đích nhấn nhá cho từng khúc. Vì sao? Vì con người rất dễ quên, thông thường họ chỉ nhớ được điểm đầu, điểm cuối và bỏ quên nội dung ở giữa.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-80e0-b7eb-ca21added761",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T02:00:00.000Z",
        "last_edited_time": "2025-10-14T02:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1760493269/uxcomic-imgs/28c5d164-78d8-80e0-b7eb-ca21added761.jpg",
            "expiry_time": "2026-10-04T09:10:58.330Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/28c5d164-78d8-80e0-b7eb-ca21added761"
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-80de-9a3d-e626704accee",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T02:14:00.000Z",
        "last_edited_time": "2025-10-14T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "3 hũ truth",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3 hũ truth",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (trong sách Show, don’t tell), mỗi con người chúng ta sẽ có 3 dạng sự thật: sự thật dạng fact, sự thật dạng logic, sự thật dạng niềm tin. Mình phải biết buổi hôm nay ta sẽ cần tác động đến việc lay động sự thật nào để chọn nội dung cho phù hợp (lấy vd: dân engineer sẽ cần logic nhiều, dân biz sẽ cần nhiều hơn về vision, niềm tin, và có căn cứ dựa trên fact, thuyết phục khách hàng lại cần chú trọng nhiều hơn về việc thay đổi niềm tin…).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (trong sách Show, don’t tell), mỗi con người chúng ta sẽ có 3 dạng sự thật: sự thật dạng fact, sự thật dạng logic, sự thật dạng niềm tin. Mình phải biết buổi hôm nay ta sẽ cần tác động đến việc lay động sự thật nào để chọn nội dung cho phù hợp (lấy vd: dân engineer sẽ cần logic nhiều, dân biz sẽ cần nhiều hơn về vision, niềm tin, và có căn cứ dựa trên fact, thuyết phục khách hàng lại cần chú trọng nhiều hơn về việc thay đổi niềm tin…).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-80fa-8de6-efbf6706d26b",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T02:00:00.000Z",
        "last_edited_time": "2025-10-14T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hook / Wow moment",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hook / Wow moment",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": đây là những ý khiến họ tò mò & ghi nhớ. Những ý này cực kì quan trọng để họ make sense được everything we said. Và mình phải là người khiến họ để tâm cho việc đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": đây là những ý khiến họ tò mò & ghi nhớ. Những ý này cực kì quan trọng để họ make sense được everything we said. Và mình phải là người khiến họ để tâm cho việc đó.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-80b1-a583-fe12f8c5ea81",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T02:02:00.000Z",
        "last_edited_time": "2025-10-14T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sense making & systemactic thinking:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sense making & systemactic thinking:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " mình đưa ra rất nhiều point, và đừng quên làm rõ mối tương quan giữa chúng, nếu mình làm rõ được logic flow này, họ sẽ đỡ phải tốn neuron cho việc đó, từ đó còn thêm năng lượng để nghe ta.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " mình đưa ra rất nhiều point, và đừng quên làm rõ mối tương quan giữa chúng, nếu mình làm rõ được logic flow này, họ sẽ đỡ phải tốn neuron cho việc đó, từ đó còn thêm năng lượng để nghe ta.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8035-98ad-d2df3a7b1052",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T02:04:00.000Z",
        "last_edited_time": "2025-10-14T05:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Line of emotion:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Line of emotion:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " này cũng quan trọng nè, ta phải phỏng đoán được nội dung nào thì cần có yếu tố cảm xúc nào, và cả journey buổi meeting đó nên diễn ra như thế nào. Ví dụ: đầu buổi meeting ta cho thấy đang gặp vấn đề (vẽ ra một bức tranh tối mịt) sau đó sáng dần vì ta định nghĩa được vấn đề và có hướng giải quyết nó; hay bạn đoán được ở giữa buổi meeting, khả năng mọi người bắt đầu lỡ đãng, bạn sẽ có một câu hỏi mở tương tác hay một ví dụ vui để mọi người tiếp tục engage với nội dung meeting.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " này cũng quan trọng nè, ta phải phỏng đoán được nội dung nào thì cần có yếu tố cảm xúc nào, và cả journey buổi meeting đó nên diễn ra như thế nào. Ví dụ: đầu buổi meeting ta cho thấy đang gặp vấn đề (vẽ ra một bức tranh tối mịt) sau đó sáng dần vì ta định nghĩa được vấn đề và có hướng giải quyết nó; hay bạn đoán được ở giữa buổi meeting, khả năng mọi người bắt đầu lỡ đãng, bạn sẽ có một câu hỏi mở tương tác hay một ví dụ vui để mọi người tiếp tục engage với nội dung meeting.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-80e1-8244-d5981590d2ea",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T05:44:00.000Z",
        "last_edited_time": "2025-10-14T05:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8058-bc40-f38ee2a86ebf",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T02:23:00.000Z",
        "last_edited_time": "2025-10-14T05:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khả năng deliver message (trình bày)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khả năng deliver message (trình bày)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8092-b24b-ca6435b9e72e",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T02:23:00.000Z",
        "last_edited_time": "2025-10-14T05:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lớp này sẽ là ngoài cùng và có tính linh hoạt, ứng biến nhiều. Và cũng là lớp mình dễ thấy nhất.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lớp này sẽ là ngoài cùng và có tính linh hoạt, ứng biến nhiều. Và cũng là lớp mình dễ thấy nhất.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-807a-bfa3-f3848b4ec19e",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T02:24:00.000Z",
        "last_edited_time": "2025-10-14T02:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đây là lớp bạn bộc lộ ra ngoài, nó sẽ là:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đây là lớp bạn bộc lộ ra ngoài, nó sẽ là:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8053-95e9-f9a199613b88",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T02:24:00.000Z",
        "last_edited_time": "2025-10-14T02:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tone giọng, nhịp truyện",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tone giọng, nhịp truyện",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8002-9066-e5f9edc6c505",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T02:24:00.000Z",
        "last_edited_time": "2025-10-14T02:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách trình bày slide (nên show ít chữ để audience tập trung vào những gì bạn nói thay vì là đọc slide).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách trình bày slide (nên show ít chữ để audience tập trung vào những gì bạn nói thay vì là đọc slide).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-808c-82fe-ec0f0802fcc1",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T02:25:00.000Z",
        "last_edited_time": "2025-10-14T02:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là những mô phỏng, ví dụ, hình vẽ diagram… để minh hoạ cho ý bạn nói ra.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là những mô phỏng, ví dụ, hình vẽ diagram… để minh hoạ cho ý bạn nói ra.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-80bb-934b-c577713f6fe4",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T02:26:00.000Z",
        "last_edited_time": "2025-10-14T02:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là ngôn ngữ cơ thể / visual là để bổ trợ cho việc dẫn truyện của bạn (vd: bạn xoay bàn tay để minh hoạ cho việc đổi góc nhìn, bạn nắm bàn tay thành từng cục để mô phòng đây là những yếu tố tách biệt, ánh mắt nhìn vào audience …)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là ngôn ngữ cơ thể / visual là để bổ trợ cho việc dẫn truyện của bạn (vd: bạn xoay bàn tay để minh hoạ cho việc đổi góc nhìn, bạn nắm bàn tay thành từng cục để mô phòng đây là những yếu tố tách biệt, ánh mắt nhìn vào audience …)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8021-a028-df755a70357d",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T02:26:00.000Z",
        "last_edited_time": "2025-10-14T02:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Biến những thứ thô kệch thành ý dễ hình dung, vd: “Nếu 10 người ở đây là user, thì 4 người đã rời đi chỉ sau 1 phút.” → Dễ hiểu hơn “tỉ lệ churn 40%”.  “Hãy tưởng tượng Linh – 26 tuổi, mở app lúc 7h sáng, đang vội đi làm…” Người ta kết nối với con người, không với con số.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Biến những thứ thô kệch thành ý dễ hình dung, vd: “Nếu 10 người ở đây là user, thì 4 người đã rời đi chỉ sau 1 phút.” → Dễ hiểu hơn “tỉ lệ churn 40%”.  “Hãy tưởng tượng Linh – 26 tuổi, mở app lúc 7h sáng, đang vội đi làm…” Người ta kết nối với con người, không với con số.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28d5d164-78d8-8052-8160-f7b32e5c09ff",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-15T01:30:00.000Z",
        "last_edited_time": "2025-10-15T01:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Và cuối cùng là giảm “distraction”, phần này ít khi để ý nè, nó có nghĩa là ta phải tinh gọn lại nội dung, lọc hoặc đơn giản hoá các thông tin không có giá trị nhiều. Tip: hãy thử hình dung nếu cắt bỏ 50% nội dung thì sẽ còn lại gì.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Và cuối cùng là giảm “distraction”, phần này ít khi để ý nè, nó có nghĩa là ta phải tinh gọn lại nội dung, lọc hoặc đơn giản hoá các thông tin không có giá trị nhiều. Tip: hãy thử hình dung nếu cắt bỏ 50% nội dung thì sẽ còn lại gì.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8018-b924-fc81b4cd64ac",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T02:28:00.000Z",
        "last_edited_time": "2025-10-14T02:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8029-a274-f500f6b434c9",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T02:30:00.000Z",
        "last_edited_time": "2025-10-14T02:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kết ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kết ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28c5d164-78d8-8000-91df-eb29933e108a",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-14T02:30:00.000Z",
        "last_edited_time": "2025-10-15T01:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hãy nhớ đi từ vòng tròn bên trong sang bên ngoài. Càng ở vòng tròn sâu bên trong, nó còn hơn cả việc rèn luyện riêng cho một buổi meeting, nó là sự rèn luyện về mặt con người, tính cách và bản lĩnh. Trở thành người dễ mến, ngay thẳng, có chiều sâu, rõ ràng, open…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hãy nhớ đi từ vòng tròn bên trong sang bên ngoài. Càng ở vòng tròn sâu bên trong, nó còn hơn cả việc rèn luyện riêng cho một buổi meeting, nó là sự rèn luyện về mặt con người, tính cách và bản lĩnh. Trở thành người dễ mến, ngay thẳng, có chiều sâu, rõ ràng, open…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28d5d164-78d8-8058-91ba-c70cbb2acaf5",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-15T01:35:00.000Z",
        "last_edited_time": "2025-10-15T02:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "28d5d164-78d8-80f0-b2b9-de4edd4a8a70",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-15T02:01:00.000Z",
        "last_edited_time": "2025-10-15T02:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Items",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Items",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28d5d164-78d8-80dd-8d9c-c13f78e7f39b",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-15T02:01:00.000Z",
        "last_edited_time": "2025-10-15T02:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1585d164-78d8-803a-9506-fed5673c611f"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Meeting (P1)",
              "href": "https://app.notion.com/p/1585d16478d8803a9506fed5673c611f"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28d5d164-78d8-80a9-b70e-e7bab9964121",
        "parent": {
          "type": "page_id",
          "page_id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
        },
        "created_time": "2025-10-15T02:01:00.000Z",
        "last_edited_time": "2025-10-15T02:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "2825d164-78d8-8022-b278-c095fef80560"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Meeting checklist",
              "href": "https://app.notion.com/p/2825d16478d88022b278c095fef80560"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "2635d164-78d8-8031-9704-e771db619205",
    "created_time": "2025-09-03T10:58:00.000Z",
    "last_edited_time": "2025-09-04T10:56:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2025-09-03T10:58:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "1-Understanding",
          "color": "orange"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 80
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-09-04T10:56:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "tMsg",
          "name": "⚓:1",
          "color": "default"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Bias in work",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Bias in work",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Bias-in-work-2635d16478d880319704e771db619205",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
      "name": "Understanding",
      "slug": "understanding",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "2635d164-78d8-8061-92b9-e6004d76df7e",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T15:00:00.000Z",
        "last_edited_time": "2025-09-04T01:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756912257/uxcomic-imgs/2635d164-78d8-8061-92b9-e6004d76df7e.png",
            "expiry_time": "2026-10-04T09:10:59.259Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2635d164-78d8-8061-92b9-e6004d76df7e"
      },
      {
        "object": "block",
        "id": "2635d164-78d8-8002-8066-e2e40f7f7cca",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T10:58:00.000Z",
        "last_edited_time": "2025-09-03T14:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bạn có từng thấy bực bộ khi làm việc với stakeholder mà thấy họ bị bias không? Mình thì gặp nhiều, và sự bực dộc đó thành nguồn cảm hứng để mình tìm hiểu chút về chủ đề này.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bạn có từng thấy bực bộ khi làm việc với stakeholder mà thấy họ bị bias không? Mình thì gặp nhiều, và sự bực dộc đó thành nguồn cảm hứng để mình tìm hiểu chút về chủ đề này.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-8009-ab46-cf6f3c6e1f56",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T14:10:00.000Z",
        "last_edited_time": "2025-09-03T14:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Và chớ vội tưởng mình không bị nhé, ai cũng có hết đấy, “họ bias & ta cũng thế”, so… bài này sẽ rà qua những bias phổ biến trong công việc.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Và chớ vội tưởng mình không bị nhé, ai cũng có hết đấy, “họ bias & ta cũng thế”, so… bài này sẽ rà qua những bias phổ biến trong công việc.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-803c-a63a-f866457c7c5a",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T11:27:00.000Z",
        "last_edited_time": "2025-09-04T00:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "list",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "list",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "2635d164-78d8-80dc-be27-ef74e4a5613a",
            "parent": {
              "type": "block_id",
              "block_id": "2635d164-78d8-803c-a63a-f866457c7c5a"
            },
            "created_time": "2025-09-03T14:56:00.000Z",
            "last_edited_time": "2025-09-04T01:16:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756912260/uxcomic-imgs/2635d164-78d8-80dc-be27-ef74e4a5613a.png",
                "expiry_time": "2026-10-04T09:10:59.865Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2635d164-78d8-80dc-be27-ef74e4a5613a"
          },
          {
            "object": "block",
            "id": "2635d164-78d8-805a-a28a-e5b7eeb41537",
            "parent": {
              "type": "block_id",
              "block_id": "2635d164-78d8-803c-a63a-f866457c7c5a"
            },
            "created_time": "2025-09-03T14:56:00.000Z",
            "last_edited_time": "2025-09-04T01:16:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756912261/uxcomic-imgs/2635d164-78d8-805a-a28a-e5b7eeb41537.png",
                "expiry_time": "2026-10-04T09:10:59.866Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2635d164-78d8-805a-a28a-e5b7eeb41537"
          },
          {
            "object": "block",
            "id": "2635d164-78d8-8062-a1d4-ca3525a420ae",
            "parent": {
              "type": "block_id",
              "block_id": "2635d164-78d8-803c-a63a-f866457c7c5a"
            },
            "created_time": "2025-09-03T14:56:00.000Z",
            "last_edited_time": "2025-09-04T01:16:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756912262/uxcomic-imgs/2635d164-78d8-8062-a1d4-ca3525a420ae.png",
                "expiry_time": "2026-10-04T09:10:59.866Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2635d164-78d8-8062-a1d4-ca3525a420ae"
          },
          {
            "object": "block",
            "id": "2635d164-78d8-8091-ad4a-e8e7ed8b8fdf",
            "parent": {
              "type": "block_id",
              "block_id": "2635d164-78d8-803c-a63a-f866457c7c5a"
            },
            "created_time": "2025-09-03T14:56:00.000Z",
            "last_edited_time": "2025-09-04T01:16:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756912263/uxcomic-imgs/2635d164-78d8-8091-ad4a-e8e7ed8b8fdf.png",
                "expiry_time": "2026-10-04T09:10:59.866Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2635d164-78d8-8091-ad4a-e8e7ed8b8fdf"
          },
          {
            "object": "block",
            "id": "2635d164-78d8-80cd-8283-fb34e05f76e0",
            "parent": {
              "type": "block_id",
              "block_id": "2635d164-78d8-803c-a63a-f866457c7c5a"
            },
            "created_time": "2025-09-03T14:56:00.000Z",
            "last_edited_time": "2025-09-04T01:16:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756912265/uxcomic-imgs/2635d164-78d8-80cd-8283-fb34e05f76e0.png",
                "expiry_time": "2026-10-04T09:10:59.866Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2635d164-78d8-80cd-8283-fb34e05f76e0"
          },
          {
            "object": "block",
            "id": "2635d164-78d8-803c-a863-f7a699c7773f",
            "parent": {
              "type": "block_id",
              "block_id": "2635d164-78d8-803c-a63a-f866457c7c5a"
            },
            "created_time": "2025-09-03T14:56:00.000Z",
            "last_edited_time": "2025-09-04T01:16:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756912266/uxcomic-imgs/2635d164-78d8-803c-a863-f7a699c7773f.png",
                "expiry_time": "2026-10-04T09:10:59.866Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2635d164-78d8-803c-a863-f7a699c7773f"
          },
          {
            "object": "block",
            "id": "2635d164-78d8-80c0-9891-cfabdfca56ce",
            "parent": {
              "type": "block_id",
              "block_id": "2635d164-78d8-803c-a63a-f866457c7c5a"
            },
            "created_time": "2025-09-03T14:56:00.000Z",
            "last_edited_time": "2025-09-04T01:16:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756912267/uxcomic-imgs/2635d164-78d8-80c0-9891-cfabdfca56ce.png",
                "expiry_time": "2026-10-04T09:10:59.866Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2635d164-78d8-80c0-9891-cfabdfca56ce"
          },
          {
            "object": "block",
            "id": "2635d164-78d8-8029-bfb1-cedfc6ecc0dc",
            "parent": {
              "type": "block_id",
              "block_id": "2635d164-78d8-803c-a63a-f866457c7c5a"
            },
            "created_time": "2025-09-03T14:56:00.000Z",
            "last_edited_time": "2025-09-04T01:16:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756912268/uxcomic-imgs/2635d164-78d8-8029-bfb1-cedfc6ecc0dc.png",
                "expiry_time": "2026-10-04T09:10:59.866Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2635d164-78d8-8029-bfb1-cedfc6ecc0dc"
          },
          {
            "object": "block",
            "id": "2635d164-78d8-80cd-a179-c7d8d06c3178",
            "parent": {
              "type": "block_id",
              "block_id": "2635d164-78d8-803c-a63a-f866457c7c5a"
            },
            "created_time": "2025-09-03T14:56:00.000Z",
            "last_edited_time": "2025-09-04T01:16:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756912269/uxcomic-imgs/2635d164-78d8-80cd-a179-c7d8d06c3178.png",
                "expiry_time": "2026-10-04T09:10:59.866Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2635d164-78d8-80cd-a179-c7d8d06c3178"
          },
          {
            "object": "block",
            "id": "2635d164-78d8-8028-8069-f573d3dfca23",
            "parent": {
              "type": "block_id",
              "block_id": "2635d164-78d8-803c-a63a-f866457c7c5a"
            },
            "created_time": "2025-09-03T14:56:00.000Z",
            "last_edited_time": "2025-09-04T01:16:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756912271/uxcomic-imgs/2635d164-78d8-8028-8069-f573d3dfca23.png",
                "expiry_time": "2026-10-04T09:10:59.866Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2635d164-78d8-8028-8069-f573d3dfca23"
          },
          {
            "object": "block",
            "id": "2635d164-78d8-8070-8b85-cb7db9a3ef79",
            "parent": {
              "type": "block_id",
              "block_id": "2635d164-78d8-803c-a63a-f866457c7c5a"
            },
            "created_time": "2025-09-03T14:56:00.000Z",
            "last_edited_time": "2025-09-04T01:16:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756912272/uxcomic-imgs/2635d164-78d8-8070-8b85-cb7db9a3ef79.png",
                "expiry_time": "2026-10-04T09:10:59.866Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2635d164-78d8-8070-8b85-cb7db9a3ef79"
          },
          {
            "object": "block",
            "id": "2635d164-78d8-80bc-b4a1-da6952670f47",
            "parent": {
              "type": "block_id",
              "block_id": "2635d164-78d8-803c-a63a-f866457c7c5a"
            },
            "created_time": "2025-09-03T14:56:00.000Z",
            "last_edited_time": "2025-09-04T01:16:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756912274/uxcomic-imgs/2635d164-78d8-80bc-b4a1-da6952670f47.png",
                "expiry_time": "2026-10-04T09:10:59.866Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2635d164-78d8-80bc-b4a1-da6952670f47"
          },
          {
            "object": "block",
            "id": "2635d164-78d8-8013-b197-f5f62a86f43b",
            "parent": {
              "type": "block_id",
              "block_id": "2635d164-78d8-803c-a63a-f866457c7c5a"
            },
            "created_time": "2025-09-03T14:56:00.000Z",
            "last_edited_time": "2025-09-04T01:16:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756912275/uxcomic-imgs/2635d164-78d8-8013-b197-f5f62a86f43b.png",
                "expiry_time": "2026-10-04T09:10:59.866Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2635d164-78d8-8013-b197-f5f62a86f43b"
          },
          {
            "object": "block",
            "id": "2635d164-78d8-80a5-95b3-d6abc3ffd45e",
            "parent": {
              "type": "block_id",
              "block_id": "2635d164-78d8-803c-a63a-f866457c7c5a"
            },
            "created_time": "2025-09-03T14:56:00.000Z",
            "last_edited_time": "2025-09-04T01:16:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756912276/uxcomic-imgs/2635d164-78d8-80a5-95b3-d6abc3ffd45e.png",
                "expiry_time": "2026-10-04T09:10:59.866Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2635d164-78d8-80a5-95b3-d6abc3ffd45e"
          },
          {
            "object": "block",
            "id": "2635d164-78d8-8008-bce7-dc8c2fa36e52",
            "parent": {
              "type": "block_id",
              "block_id": "2635d164-78d8-803c-a63a-f866457c7c5a"
            },
            "created_time": "2025-09-03T14:56:00.000Z",
            "last_edited_time": "2025-09-04T01:16:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756912278/uxcomic-imgs/2635d164-78d8-8008-bce7-dc8c2fa36e52.png",
                "expiry_time": "2026-10-04T09:10:59.866Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2635d164-78d8-8008-bce7-dc8c2fa36e52"
          },
          {
            "object": "block",
            "id": "2635d164-78d8-8018-a770-ffaef7ed9ee7",
            "parent": {
              "type": "block_id",
              "block_id": "2635d164-78d8-803c-a63a-f866457c7c5a"
            },
            "created_time": "2025-09-03T14:56:00.000Z",
            "last_edited_time": "2025-09-04T01:16:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756912279/uxcomic-imgs/2635d164-78d8-8018-a770-ffaef7ed9ee7.png",
                "expiry_time": "2026-10-04T09:10:59.866Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2635d164-78d8-8018-a770-ffaef7ed9ee7"
          },
          {
            "object": "block",
            "id": "2635d164-78d8-801e-a405-db2155b58e49",
            "parent": {
              "type": "block_id",
              "block_id": "2635d164-78d8-803c-a63a-f866457c7c5a"
            },
            "created_time": "2025-09-03T14:56:00.000Z",
            "last_edited_time": "2025-09-04T01:16:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756912280/uxcomic-imgs/2635d164-78d8-801e-a405-db2155b58e49.png",
                "expiry_time": "2026-10-04T09:10:59.866Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2635d164-78d8-801e-a405-db2155b58e49"
          },
          {
            "object": "block",
            "id": "2635d164-78d8-80b9-9ad4-c35f699a58e2",
            "parent": {
              "type": "block_id",
              "block_id": "2635d164-78d8-803c-a63a-f866457c7c5a"
            },
            "created_time": "2025-09-03T14:56:00.000Z",
            "last_edited_time": "2025-09-04T01:16:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756912281/uxcomic-imgs/2635d164-78d8-80b9-9ad4-c35f699a58e2.png",
                "expiry_time": "2026-10-04T09:10:59.866Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2635d164-78d8-80b9-9ad4-c35f699a58e2"
          }
        ]
      },
      {
        "object": "block",
        "id": "2635d164-78d8-80c3-ab2a-e45fca07e016",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T11:06:00.000Z",
        "last_edited_time": "2025-09-03T11:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-8078-b89b-c3b62eb4f607",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T11:06:00.000Z",
        "last_edited_time": "2025-09-04T00:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bias là gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bias là gì?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-80dc-95f5-fe9dab895083",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T11:06:00.000Z",
        "last_edited_time": "2025-09-03T11:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bias là sự sai lệch mang tính hệ thống trong tư duy, dẫn đến việc hiểu vấn đề sai sót, ảnh hưởng đến việc phán đoán và quyết định không chính xác, nói nôm na nó là lỗi trong việc xử lý thông tin.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bias là sự sai lệch mang tính hệ thống trong tư duy, dẫn đến việc hiểu vấn đề sai sót, ảnh hưởng đến việc phán đoán và quyết định không chính xác, nói nôm na nó là lỗi trong việc xử lý thông tin.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-80f9-8712-c27998ed47a3",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T14:01:00.000Z",
        "last_edited_time": "2025-09-03T14:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Tend to do sth…”",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Tend to do sth…”",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là cụm từ bạn sẽ thường thấy khi nghiên cứu về chủ đề này qua các article khác, lí do là vì cách hiểu tác động lên hành động. Mà bias tác động lên cách hiểu.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là cụm từ bạn sẽ thường thấy khi nghiên cứu về chủ đề này qua các article khác, lí do là vì cách hiểu tác động lên hành động. Mà bias tác động lên cách hiểu.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-806b-8403-fee69d020497",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T11:08:00.000Z",
        "last_edited_time": "2025-09-04T10:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: bias và ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: bias và ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "mental model",
                "link": {
                  "url": "/73bdf5d9ca494b2789a22dde16b2af7d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "mental model",
              "href": "/73bdf5d9ca494b2789a22dde16b2af7d"
            },
            {
              "type": "text",
              "text": {
                "content": " có điểm giống nhau ở chỗ nó đều là short cut trong tư duy nhầm mục đích tiết giảm effort cho não bộ và tăng tốc độ cho việc nhận định & ra quyết định. Nhưng bias mention nhiều hơn về việc ta nhìn nhận vấn đề thiếu khách quan, thiếu chính xác, sai lệch trong khi đó mental model chung chung hơn, nó nói về việc ta suy nghĩ, giải nghĩa ra sao.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " có điểm giống nhau ở chỗ nó đều là short cut trong tư duy nhầm mục đích tiết giảm effort cho não bộ và tăng tốc độ cho việc nhận định & ra quyết định. Nhưng bias mention nhiều hơn về việc ta nhìn nhận vấn đề thiếu khách quan, thiếu chính xác, sai lệch trong khi đó mental model chung chung hơn, nó nói về việc ta suy nghĩ, giải nghĩa ra sao.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-8087-9002-e08cbac8e34a",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T14:13:00.000Z",
        "last_edited_time": "2025-09-03T14:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-8075-b50a-c16cf8a258bf",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T13:45:00.000Z",
        "last_edited_time": "2025-09-03T13:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Không liên quan đến bài viết này, nhưng trong UX cũng tận dụng các cognitive bias này để nhầm thay đổi hoặc thuyết phục người dùng. Các bạn có thể xem thêm các ứng dụng đó ở ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Không liên quan đến bài viết này, nhưng trong UX cũng tận dụng các cognitive bias này để nhầm thay đổi hoặc thuyết phục người dùng. Các bạn có thể xem thêm các ứng dụng đó ở ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "trang này",
                "link": {
                  "url": "https://growth.design/psychology"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "trang này",
              "href": "https://growth.design/psychology"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-80b8-a442-e83ba6f9455c",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T11:10:00.000Z",
        "last_edited_time": "2025-09-03T11:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-8077-8aeb-f6bd052c1db0",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T11:10:00.000Z",
        "last_edited_time": "2025-09-03T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vì sao nó được hình thành?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vì sao nó được hình thành?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-80fe-81e0-fb02b3993694",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T11:13:00.000Z",
        "last_edited_time": "2025-09-04T10:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Não chúng ta bị giới hạn nhận thức, một lúc không thể suy nghĩ quá nhiều thông tin → nó cần một cách nhanh gọn hơn → bias được sinh ra nhầm đáp ứng cho nhu cầu đó của bộ não. Ví dụ: Availability bias, Recency bias.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Não chúng ta bị giới hạn nhận thức, một lúc không thể suy nghĩ quá nhiều thông tin → nó cần một cách nhanh gọn hơn → bias được sinh ra nhầm đáp ứng cho nhu cầu đó của bộ não. Ví dụ: Availability bias, Recency bias.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-80f5-9331-edf08630b14b",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T11:19:00.000Z",
        "last_edited_time": "2025-09-04T10:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong lịch sử thời hái lượm, nguyên thủy, còn sống trong rừng rú, nguy hiểm luôn vây quanh, nên theo tiến hoá, ta phải có những cách tư duy nhanh nhạy để quyết định nhanh nhầm ưu tiên khả năng sống sót. Ví dụ: Negativity bias, Availability heuristic, Status quo bias.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong lịch sử thời hái lượm, nguyên thủy, còn sống trong rừng rú, nguy hiểm luôn vây quanh, nên theo tiến hoá, ta phải có những cách tư duy nhanh nhạy để quyết định nhanh nhầm ưu tiên khả năng sống sót. Ví dụ: Negativity bias, Availability heuristic, Status quo bias.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-80d3-af33-e11112a08f70",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T11:20:00.000Z",
        "last_edited_time": "2025-09-04T10:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ảnh hưởng của văn hoá & tâm lý đám đông, một cách vô thức chúng ta có nhu cầu thuộc về một nhóm người nào đó → ta phải có những niềm tin, quyết định để chạy theo mong muốn đó. Ví dụ: Groupthink, Bandwagon effect.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ảnh hưởng của văn hoá & tâm lý đám đông, một cách vô thức chúng ta có nhu cầu thuộc về một nhóm người nào đó → ta phải có những niềm tin, quyết định để chạy theo mong muốn đó. Ví dụ: Groupthink, Bandwagon effect.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-80f5-b188-c8a2a4503fee",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T11:21:00.000Z",
        "last_edited_time": "2025-09-04T10:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ảnh hưởng bởi cảm xúc & tâm lý trong bối cảnh đó cũng tác động đến việc không thể hoàn toàn logic. Ví dụ: khi bực hay buồn hay gấp, ta sẽ có cách suy nghĩ khác lúc ta bình tĩnh, hoặc Halo effect.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ảnh hưởng bởi cảm xúc & tâm lý trong bối cảnh đó cũng tác động đến việc không thể hoàn toàn logic. Ví dụ: khi bực hay buồn hay gấp, ta sẽ có cách suy nghĩ khác lúc ta bình tĩnh, hoặc Halo effect.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-8083-a61e-d2e83382bcb8",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T11:23:00.000Z",
        "last_edited_time": "2025-09-03T11:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ảnh hưởng bởi ký ức, kinh nghiệm, mental model → dùng chúng để diễn giải sự vật hiện tượng mới → bias. Ví dụ: Recency bias.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ảnh hưởng bởi ký ức, kinh nghiệm, mental model → dùng chúng để diễn giải sự vật hiện tượng mới → bias. Ví dụ: Recency bias.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-8064-9389-e6fed4a7515e",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T13:21:00.000Z",
        "last_edited_time": "2025-09-03T13:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-8066-973f-dbc7653a20c8",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T13:21:00.000Z",
        "last_edited_time": "2025-09-03T13:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy làm sao để đỡ bias?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy làm sao để đỡ bias?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-80bf-b208-c98763e64afc",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T13:22:00.000Z",
        "last_edited_time": "2025-09-03T13:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình nghĩ có thể bám theo lí do nó được sinh ra để tìm ra phương án tiết giảm nó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình nghĩ có thể bám theo lí do nó được sinh ra để tìm ra phương án tiết giảm nó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-80e1-94e0-dec1b67fdb90",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T13:22:00.000Z",
        "last_edited_time": "2025-09-03T13:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bias được sinh ra vì nó muốn nhanh → nếu muốn hạn chế thì phải chậm lại, rethink.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bias được sinh ra vì nó muốn nhanh → nếu muốn hạn chế thì phải chậm lại, rethink.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-801f-93ab-e805ade01fd1",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T13:23:00.000Z",
        "last_edited_time": "2025-09-03T13:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vì bias một phần được hình thành dựa theo kí ức, trải nghiệm → nếu ta mở rộng thế giới quan, quan sát được nhiều câu chuyện nguyên nhân kết quả khác nhau trong cùng 1 tình huống thì sẽ learn được “mindset lái hành động” hay nói cách khác bias ảnh hưởng lên hành động ra sao.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vì bias một phần được hình thành dựa theo kí ức, trải nghiệm → nếu ta mở rộng thế giới quan, quan sát được nhiều câu chuyện nguyên nhân kết quả khác nhau trong cùng 1 tình huống thì sẽ learn được “mindset lái hành động” hay nói cách khác bias ảnh hưởng lên hành động ra sao.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-803e-a0a1-defb6fadd34f",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T13:26:00.000Z",
        "last_edited_time": "2025-09-03T13:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tâm lý, cảm xúc, bầy đàn, đám đông, văn hoá… khiến ta có bias → Context & Self awareness quan trọng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tâm lý, cảm xúc, bầy đàn, đám đông, văn hoá… khiến ta có bias → Context & Self awareness quan trọng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-8073-9156-d0780e69239e",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T13:49:00.000Z",
        "last_edited_time": "2025-09-04T10:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bộ 3 mình cho là quan trọng nhất: critical & systematic thinking + experimental mindset. Vì sao? Vì bộ 3 này tập trung vào việc có nhiều góc nhìn & tăng độ kiểm chứng, cái mà “các bạn bias” không hề thích - vì nó không hề nhẹ đầu :)).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bộ 3 mình cho là quan trọng nhất: critical & systematic thinking + experimental mindset. Vì sao? Vì bộ 3 này tập trung vào việc có nhiều góc nhìn & tăng độ kiểm chứng, cái mà “các bạn bias” không hề thích - vì nó không hề nhẹ đầu :)).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-80b3-b07f-d5b069e9c6e6",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T13:51:00.000Z",
        "last_edited_time": "2025-09-03T13:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756912258/uxcomic-imgs/2635d164-78d8-80b3-b07f-d5b069e9c6e6.gif",
            "expiry_time": "2026-10-04T09:10:59.326Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2635d164-78d8-80b3-b07f-d5b069e9c6e6"
      },
      {
        "object": "block",
        "id": "2635d164-78d8-808f-a78c-c7d8d9f02fdd",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T11:11:00.000Z",
        "last_edited_time": "2025-09-03T11:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-8084-83d3-fa77372730ba",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T11:13:00.000Z",
        "last_edited_time": "2025-09-03T11:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-809b-be86-f1bbc1d241d2",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T13:59:00.000Z",
        "last_edited_time": "2025-09-03T13:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://plan.io/blog/unconscious-bias-examples/",
                "link": {
                  "url": "https://plan.io/blog/unconscious-bias-examples/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://plan.io/blog/unconscious-bias-examples/",
              "href": "https://plan.io/blog/unconscious-bias-examples/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-80d4-bfd4-d04f243ed11d",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T14:03:00.000Z",
        "last_edited_time": "2025-09-03T14:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.nngroup.com/articles/confirmation-bias-ux/",
                "link": {
                  "url": "https://www.nngroup.com/articles/confirmation-bias-ux/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.nngroup.com/articles/confirmation-bias-ux/",
              "href": "https://www.nngroup.com/articles/confirmation-bias-ux/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-8075-b7db-d6176546c800",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T11:13:00.000Z",
        "last_edited_time": "2025-09-03T11:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.simplypsychology.org/cognitive-bias.html",
                "link": {
                  "url": "https://www.simplypsychology.org/cognitive-bias.html"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.simplypsychology.org/cognitive-bias.html",
              "href": "https://www.simplypsychology.org/cognitive-bias.html"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-80c3-8365-fb7a612895f7",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T11:13:00.000Z",
        "last_edited_time": "2025-09-03T11:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://en.wikipedia.org/wiki/Cognitive_bias",
                "link": {
                  "url": "https://en.wikipedia.org/wiki/Cognitive_bias"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://en.wikipedia.org/wiki/Cognitive_bias",
              "href": "https://en.wikipedia.org/wiki/Cognitive_bias"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-8052-8ca5-d92b1ae8b689",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T11:13:00.000Z",
        "last_edited_time": "2025-09-03T11:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.frontiersin.org/journals/psychology/articles/10.3389/fpsyg.2022.892829/full",
                "link": {
                  "url": "https://www.frontiersin.org/journals/psychology/articles/10.3389/fpsyg.2022.892829/full"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.frontiersin.org/journals/psychology/articles/10.3389/fpsyg.2022.892829/full",
              "href": "https://www.frontiersin.org/journals/psychology/articles/10.3389/fpsyg.2022.892829/full"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-80e2-b110-eff36d36b773",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T13:27:00.000Z",
        "last_edited_time": "2025-09-03T13:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-809f-aec0-e0a7975b39ed",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T13:27:00.000Z",
        "last_edited_time": "2025-09-03T13:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Items",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Items",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-80ab-b5d2-c5eab2b349dc",
        "parent": {
          "type": "page_id",
          "page_id": "2635d164-78d8-8031-9704-e771db619205"
        },
        "created_time": "2025-09-03T13:27:00.000Z",
        "last_edited_time": "2025-09-03T13:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mental model?",
              "href": "https://app.notion.com/p/73bdf5d9ca494b2789a22dde16b2af7d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "2455d164-78d8-80ad-8474-d1ae89d02f58",
    "created_time": "2025-08-04T07:45:00.000Z",
    "last_edited_time": "2025-08-27T01:46:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2025-08-04T07:45:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "2-Communication",
          "color": "default"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 75
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-27T01:46:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "prxX",
          "name": "⚔️:2",
          "color": "yellow"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Response",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Response",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Response-2455d16478d880ad8474d1ae89d02f58",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Communication",
      "slug": "communication",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "24f5d164-78d8-80f0-83c3-c814c92f71ac",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:57:00.000Z",
        "last_edited_time": "2025-08-27T01:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755136816/uxcomic-imgs/24f5d164-78d8-80f0-83c3-c814c92f71ac.png",
            "expiry_time": "2026-10-04T09:11:03.827Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/24f5d164-78d8-80f0-83c3-c814c92f71ac"
      },
      {
        "object": "block",
        "id": "2455d164-78d8-802e-993f-cc3ce1b3f9c9",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:23:00.000Z",
        "last_edited_time": "2025-08-04T11:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình đánh giá mình là một người rất dở trong giao tiếp, lí do mình thấy vậy vì mình rất chậm trong việc phản hồi và khả năng xử lý tình huống rất hay bị đơ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình đánh giá mình là một người rất dở trong giao tiếp, lí do mình thấy vậy vì mình rất chậm trong việc phản hồi và khả năng xử lý tình huống rất hay bị đơ.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-80ff-8951-cfc5ff37dd5a",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:24:00.000Z",
        "last_edited_time": "2025-08-14T01:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bài này reflect vài tình huống va chạm phải trong công việc & tìm hiểu hướng xử lý - “soạn bài” trước, mong là mình sẽ bớt bị đơ hơn =)))",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bài này reflect vài tình huống va chạm phải trong công việc & tìm hiểu hướng xử lý - “soạn bài” trước, mong là mình sẽ bớt bị đơ hơn =)))",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24b5d164-78d8-80b0-ab67-e08facff5bfe",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-10T10:34:00.000Z",
        "last_edited_time": "2025-08-10T10:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-8077-86bf-d470695b597e",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:23:00.000Z",
        "last_edited_time": "2025-08-14T01:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước mắt, những factor nào ảnh hưởng đến cách mình phản hồi?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước mắt, những factor nào ảnh hưởng đến cách mình phản hồi?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-8045-b13a-ee54ba7f84d1",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:23:00.000Z",
        "last_edited_time": "2025-08-04T11:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mục tiêu của cuộc hội thoại này?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mục tiêu của cuộc hội thoại này?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "2455d164-78d8-808a-bec5-f121525c6d6d",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:31:00.000Z",
        "last_edited_time": "2025-08-10T10:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cái từ & cái ý của họ là gì? Nếu mình chưa rõ cái ý thì cần đặt câu hỏi để clarify lại hoặc mình frame lại câu từ của họ và trình bày lại xem liệu có đúng là cái ý họ đang muốn nói không?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cái từ & cái ý của họ là gì? Nếu mình chưa rõ cái ý thì cần đặt câu hỏi để clarify lại hoặc mình frame lại câu từ của họ và trình bày lại xem liệu có đúng là cái ý họ đang muốn nói không?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "2455d164-78d8-8036-bd44-ff655bb62fc0",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:32:00.000Z",
        "last_edited_time": "2025-08-10T10:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cái ý vs cái ẩn ý? Liệu cái ẩn ý, mục tiêu đằng sau nó là gì? Bạn có đoán ra nó được hay không?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cái ý vs cái ẩn ý? Liệu cái ẩn ý, mục tiêu đằng sau nó là gì? Bạn có đoán ra nó được hay không?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "2455d164-78d8-8093-a721-c886120be4ce",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:33:00.000Z",
        "last_edited_time": "2025-08-04T11:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mối quan hệ & vị thế? Phần này cũng ảnh hưởng nhiều đến nội dung & cách mình sẽ phải phản hồi.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mối quan hệ & vị thế? Phần này cũng ảnh hưởng nhiều đến nội dung & cách mình sẽ phải phản hồi.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 3
      },
      {
        "object": "block",
        "id": "2455d164-78d8-8078-ab56-e89bdb85d6bc",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:34:00.000Z",
        "last_edited_time": "2025-08-04T11:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phía mình - đang có chủ đích gì trước khi mở miệng trả lời hay không? Nó là gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phía mình - đang có chủ đích gì trước khi mở miệng trả lời hay không? Nó là gì?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 4
      },
      {
        "object": "block",
        "id": "2455d164-78d8-80eb-9508-fd74265a61fe",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:41:00.000Z",
        "last_edited_time": "2025-08-14T01:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bối cảnh & tâm thế của mình? Mình có đang hồi hộp, có đang hấp tấp, áp lực, có đang gồng…?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bối cảnh & tâm thế của mình? Mình có đang hồi hộp, có đang hấp tấp, áp lực, có đang gồng…?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 5
      },
      {
        "object": "block",
        "id": "24b5d164-78d8-800b-aea7-c26e19fb87d8",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-10T10:34:00.000Z",
        "last_edited_time": "2025-08-10T10:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-806a-8f20-dd34cadaa1cc",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T12:10:00.000Z",
        "last_edited_time": "2025-08-10T10:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau tất thẩy những data point đó, mình sẽ cần:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau tất thẩy những data point đó, mình sẽ cần:",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-80ef-b3db-e58323678b76",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T12:11:00.000Z",
        "last_edited_time": "2025-08-14T01:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Pause & chọn “tâm thế”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Pause & chọn “tâm thế”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80b6-aaf2-ed29bd8f3f18",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:20:00.000Z",
        "last_edited_time": "2025-08-14T01:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhận diện context",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhận diện context",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8098-b944-e46b9a76fd8c",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:20:00.000Z",
        "last_edited_time": "2025-08-14T01:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Clarify (question before statement)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Clarify (question before statement)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "2455d164-78d8-8058-af3f-f76b7b3810cc",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T12:10:00.000Z",
        "last_edited_time": "2025-08-04T12:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lên dàn ý những phần mình sẽ trả lời",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lên dàn ý những phần mình sẽ trả lời",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 3
      },
      {
        "object": "block",
        "id": "2455d164-78d8-80d2-9b62-dc1b43d878fb",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T12:11:00.000Z",
        "last_edited_time": "2025-08-04T12:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chọn “cách truyền đạt”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chọn “cách truyền đạt”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 4
      },
      {
        "object": "block",
        "id": "2455d164-78d8-8085-9512-de1831234eb2",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T12:11:00.000Z",
        "last_edited_time": "2025-08-14T01:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phát “nội dung” (Chọn “ngôn từ” cho phù hợp)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phát “nội dung” (Chọn “ngôn từ” cho phù hợp)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 5
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8001-9bac-d7adf7577e82",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:22:00.000Z",
        "last_edited_time": "2025-08-14T01:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80f9-b188-d05a57977ae2",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:22:00.000Z",
        "last_edited_time": "2025-08-14T01:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Rủi ro nếu xử lý kém",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Rủi ro nếu xử lý kém",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80e2-b7c9-e1780021c2a8",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:22:00.000Z",
        "last_edited_time": "2025-08-14T01:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mất nhịp tự tin → ảnh hưởng toàn bộ phần trình bày còn lại.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mất nhịp tự tin → ảnh hưởng toàn bộ phần trình bày còn lại.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-804a-ba7d-ee85cd7cf7c3",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:22:00.000Z",
        "last_edited_time": "2025-08-14T01:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tạo cảm giác bị “thua thế” trước khán giả.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tạo cảm giác bị “thua thế” trước khán giả.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-806b-bdb5-fb9dbf4a095f",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:22:00.000Z",
        "last_edited_time": "2025-08-14T01:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phản ứng cảm xúc (phản bác gắt hoặc lúng túng) → giảm uy tín.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phản ứng cảm xúc (phản bác gắt hoặc lúng túng) → giảm uy tín.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24b5d164-78d8-8059-b0d8-e1b8bfbf7ad2",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-10T10:34:00.000Z",
        "last_edited_time": "2025-08-10T10:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-80ad-8e86-df80e8e2798d",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:23:00.000Z",
        "last_edited_time": "2025-08-14T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vài tình huống khiến mình hay căng thẳng như:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vài tình huống khiến mình hay căng thẳng như:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-80c5-b91e-ca39d3eeb01c",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:23:00.000Z",
        "last_edited_time": "2025-08-10T10:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi không có câu trả lời hoặc bí",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi không có câu trả lời hoặc bí",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-803c-91f2-f0f02adc2ea9",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:43:00.000Z",
        "last_edited_time": "2025-08-04T11:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước mắt, hãy bình tĩnh, thở.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước mắt, hãy bình tĩnh, thở.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-80e0-8200-dcee76f7c93b",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:47:00.000Z",
        "last_edited_time": "2025-08-04T11:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau đó hãy xoáy sâu vào câu chữ của câu hỏi? Định nghĩa chúng. >> Tìm ra cái ý cốt lỗi, nếu không chắc hay hỏi lại.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau đó hãy xoáy sâu vào câu chữ của câu hỏi? Định nghĩa chúng. >> Tìm ra cái ý cốt lỗi, nếu không chắc hay hỏi lại.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25c5d164-78d8-80e4-a36b-c2ccd5f7c7e6",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-27T01:29:00.000Z",
        "last_edited_time": "2025-08-27T01:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu sau tất thẩy mà vẫn không biết nữa, thì cứ nói không biết, không ai muốn nghe một người chém gió cả. Tuy nhiên nếu bạn có phương án để xử lý cái không biết đó thì có thể share out, ví dụ: mình biết nghiên cứu nó thông qua đâu, mình biết data nào cần được query để làm rõ, mình biết source nào để xem các practical method…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu sau tất thẩy mà vẫn không biết nữa, thì cứ nói không biết, không ai muốn nghe một người chém gió cả. Tuy nhiên nếu bạn có phương án để xử lý cái không biết đó thì có thể share out, ví dụ: mình biết nghiên cứu nó thông qua đâu, mình biết data nào cần được query để làm rõ, mình biết source nào để xem các practical method…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-8069-b4dc-dcd2412805dc",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:59:00.000Z",
        "last_edited_time": "2025-08-04T11:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-80dd-a39b-c2400b4feecc",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:49:00.000Z",
        "last_edited_time": "2025-08-14T01:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thử reframe lại câu hỏi sang vùng thông tin lận cận mà mình biết (bridge technique), lấy ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thử reframe lại câu hỏi sang vùng thông tin lận cận mà mình biết (bridge technique), lấy ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-8092-abd1-c5446fd4b98d",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:49:00.000Z",
        "last_edited_time": "2025-08-04T11:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Họ: “em có thể cho anh biết em đã chuẩn hoá design system như thế nào?”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Họ: “em có thể cho anh biết em đã chuẩn hoá design system như thế nào?”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-8075-944e-d72d9e8f3ea8",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:50:00.000Z",
        "last_edited_time": "2025-08-27T01:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình (ban đầu) nghĩ “chuẩn hoá là sao nhỉ?” mình chỉ biết làm nó thôi? Cái chuẩn và cái không chuẩn khác nhau thế nào? Mình không hoàn toàn biết & nắm rõ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình (ban đầu) nghĩ “chuẩn hoá là sao nhỉ?” mình chỉ biết làm nó thôi? Cái chuẩn và cái không chuẩn khác nhau thế nào? Mình không hoàn toàn biết & nắm rõ.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-8053-8ad6-c66fd03bca82",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:51:00.000Z",
        "last_edited_time": "2025-08-27T01:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình (lúc sau): “em có thể trả lời câu hỏi này bằng chia sẻ việc đã vận dụng những nguyên tắc nào khi làm design system & những mục tiêu cần thoả khi làm chúng. Anh/chị nghĩ thông tin này có giúp anh/chị có được thông tin cần có không?”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình (lúc sau): “em có thể trả lời câu hỏi này bằng chia sẻ việc đã vận dụng những nguyên tắc nào khi làm design system & những mục tiêu cần thoả khi làm chúng. Anh/chị nghĩ thông tin này có giúp anh/chị có được thông tin cần có không?”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-801c-84df-ffb15d9758ac",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T12:03:00.000Z",
        "last_edited_time": "2025-08-04T12:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-80ee-bd9d-d2b63117155c",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T12:03:00.000Z",
        "last_edited_time": "2025-08-10T10:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu không reframe được. Hiện em không có câu trả lời cho vấn đề này, liệu anh có câu hỏi khác hoặc em sẽ trả lời sau.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu không reframe được. Hiện em không có câu trả lời cho vấn đề này, liệu anh có câu hỏi khác hoặc em sẽ trả lời sau.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24b5d164-78d8-802a-83ea-c68fa2f03b05",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-10T10:37:00.000Z",
        "last_edited_time": "2025-08-10T10:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-8008-a81b-fb2dfa44f61a",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:59:00.000Z",
        "last_edited_time": "2025-08-04T12:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-80bd-b9fb-fadd3c4f364c",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T12:12:00.000Z",
        "last_edited_time": "2025-08-27T01:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong cái ý mình trình bày cố gắng cover ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong cái ý mình trình bày cố gắng cover ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "{what the heck what I’m saying} + {so what/ why I said that}.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "{what the heck what I’m saying} + {so what/ why I said that}.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-8081-b3c5-c1558359e941",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:46:00.000Z",
        "last_edited_time": "2025-08-27T01:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lưu ý “tính từ”, vì mỗi người định nghĩa nó khác nhau, hãy frame chúng kĩ hơn và align trước khi trả lời. Tip là quy adj sang verb. Ví dụ: “muốn nó đơn giản hơn” >> “giảm cognitive load”; “giảm step”; “tận dụng mental model”;…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lưu ý “tính từ”, vì mỗi người định nghĩa nó khác nhau, hãy frame chúng kĩ hơn và align trước khi trả lời. Tip là quy adj sang verb. Ví dụ: “muốn nó đơn giản hơn” >> “giảm cognitive load”; “giảm step”; “tận dụng mental model”;…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-8019-a73a-eba31dfc416f",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T12:13:00.000Z",
        "last_edited_time": "2025-08-04T12:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lưu ý các câu hỏi “close question” vì rất dễ bị trap (bị anchor effect), với các câu hỏi dạng đó hãy hỏi lại why hoặc how do you understand it? Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lưu ý các câu hỏi “close question” vì rất dễ bị trap (bị anchor effect), với các câu hỏi dạng đó hãy hỏi lại why hoặc how do you understand it? Ví dụ:",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "2455d164-78d8-802e-ac2d-ccea6f1a4009",
            "parent": {
              "type": "block_id",
              "block_id": "2455d164-78d8-8019-a73a-eba31dfc416f"
            },
            "created_time": "2025-08-04T12:14:00.000Z",
            "last_edited_time": "2025-08-27T01:35:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "“Em có nghĩ mình nên theo phương án A này không, chúng giúp xyz…” → Tại sao lại cần xyz??",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "“Em có nghĩ mình nên theo phương án A này không, chúng giúp xyz…” → Tại sao lại cần xyz??",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "2455d164-78d8-8056-abf6-e0c4edeff497",
            "parent": {
              "type": "block_id",
              "block_id": "2455d164-78d8-8019-a73a-eba31dfc416f"
            },
            "created_time": "2025-08-04T12:16:00.000Z",
            "last_edited_time": "2025-08-27T01:36:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "“Hãy cho anh biết cách để khiến flow này ít step hơn?” → tại sao lại cần ít step? anh nghĩ ít step sẽ tốt hơn ra sao? liệu có dẫn cứ gì cho việc giảm step là tốt?",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "“Hãy cho anh biết cách để khiến flow này ít step hơn?” → tại sao lại cần ít step? anh nghĩ ít step sẽ tốt hơn ra sao? liệu có dẫn cứ gì cho việc giảm step là tốt?",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "2455d164-78d8-804b-a132-d48c48c514fd",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T12:20:00.000Z",
        "last_edited_time": "2025-08-04T12:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tránh xin lỗi, bạn không phải lúc nào cũng có lỗi khi bị dồn vô thế bí, bạn mà xin lỗi vô tội vạ là vô thế yếu ngay.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tránh xin lỗi, bạn không phải lúc nào cũng có lỗi khi bị dồn vô thế bí, bạn mà xin lỗi vô tội vạ là vô thế yếu ngay.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24b5d164-78d8-809d-80a9-d4f27fedcc37",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-10T10:33:00.000Z",
        "last_edited_time": "2025-08-10T10:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-80b5-8290-de31b38d54f2",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:46:00.000Z",
        "last_edited_time": "2025-08-14T01:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi bị hỏi xoáy , hỏi gài",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi bị hỏi xoáy , hỏi gài",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-8004-9484-dfb762bd5f59",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:23:00.000Z",
        "last_edited_time": "2025-08-04T12:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các lí do khi họ làm vậy ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các lí do khi họ làm vậy ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-801b-ac41-de594ff28f07",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:14:00.000Z",
        "last_edited_time": "2025-08-27T01:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mục đích kiểm tra năng lực, muốn biết bạn thực sự hiểu sâu hay chỉ nói lý thuyết suông.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mục đích kiểm tra năng lực, muốn biết bạn thực sự hiểu sâu hay chỉ nói lý thuyết suông.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-80bc-b2f3-d6806c5bd47e",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T12:20:00.000Z",
        "last_edited_time": "2025-08-27T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Họ có thể hỏi gài bạn để tìm lỗ hổng trong câu trả lời của bạn (ví dụ: đưa một hint sai lệch / một giải pháp random sai hướng hoặc bất chợt), chủ yếu họ muốn xem khả năng critical thinking, khả năng reframe, đặt câu hỏi & làm rõ vấn đề.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Họ có thể hỏi gài bạn để tìm lỗ hổng trong câu trả lời của bạn (ví dụ: đưa một hint sai lệch / một giải pháp random sai hướng hoặc bất chợt), chủ yếu họ muốn xem khả năng critical thinking, khả năng reframe, đặt câu hỏi & làm rõ vấn đề.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-809d-8a50-c73215b77f05",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T12:20:00.000Z",
        "last_edited_time": "2025-08-04T12:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Họ muốn bạn lòi ra điểm yếu hoặc mâu thuẫn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Họ muốn bạn lòi ra điểm yếu hoặc mâu thuẫn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-8097-a2ce-fbe4232d7473",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T12:20:00.000Z",
        "last_edited_time": "2025-08-04T12:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hoặc đôi khi họ chỉ thử độ chắc của thông tin.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hoặc đôi khi họ chỉ thử độ chắc của thông tin.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-80b3-869f-ff4434157cc3",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T12:20:00.000Z",
        "last_edited_time": "2025-08-04T12:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một số người thì làm vậy để thể hiện quyền lực hoặc thử thách bạn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một số người thì làm vậy để thể hiện quyền lực hoặc thử thách bạn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-806e-9b3a-ea8ca8375739",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:16:00.000Z",
        "last_edited_time": "2025-08-14T01:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-80e7-9853-da1b539cacdd",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T12:20:00.000Z",
        "last_edited_time": "2025-08-14T01:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hướng xử lý",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hướng xử lý",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-8021-937e-d5ad238c1986",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T12:21:00.000Z",
        "last_edited_time": "2025-08-10T10:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hỏi lại họ để xem ý định họ là gì? Recheck xem cái ý định họ có liên quan gì đến dự án, đến mình, đến chúng ta?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hỏi lại họ để xem ý định họ là gì? Recheck xem cái ý định họ có liên quan gì đến dự án, đến mình, đến chúng ta?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-80a2-953b-e731ef2c28fe",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T12:25:00.000Z",
        "last_edited_time": "2025-08-04T12:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Be aware cái ý họ cần mình trả lời có mang lại bất lợi gì cho mình không?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Be aware cái ý họ cần mình trả lời có mang lại bất lợi gì cho mình không?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80b6-aa49-ccb91b118d3c",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:16:00.000Z",
        "last_edited_time": "2025-08-27T01:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quay về những tiêu chuẩn, những nguyên tắc, direction để cân nhắc luận điểm đó, suy xét luận cứ của họ (lí do họ j nghĩ vậy). Những thứ như rationale, cách áp dụng theory, principle vào trong công việc bản chất là phải chuẩn bị ngay trong giai đoạn làm dự án, thì khi bị hỏi xoáy, bạn mới đủ vững để phản biện lại. → Mình đang cố gắng viết ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quay về những tiêu chuẩn, những nguyên tắc, direction để cân nhắc luận điểm đó, suy xét luận cứ của họ (lí do họ j nghĩ vậy). Những thứ như rationale, cách áp dụng theory, principle vào trong công việc bản chất là phải chuẩn bị ngay trong giai đoạn làm dự án, thì khi bị hỏi xoáy, bạn mới đủ vững để phản biện lại. → Mình đang cố gắng viết ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "work journal ",
                "link": {
                  "url": "/11b5d16478d8801e8d22d0e5bdfd337c"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "work journal ",
              "href": "/11b5d16478d8801e8d22d0e5bdfd337c"
            },
            {
              "type": "text",
              "text": {
                "content": "cho từng project mình làm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cho từng project mình làm.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-800b-9cbd-c98366d125ad",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:25:00.000Z",
        "last_edited_time": "2025-08-14T01:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80bd-876c-d0123711bedf",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:25:00.000Z",
        "last_edited_time": "2025-08-14T01:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi lời nói mình kém trọng lượng",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi lời nói mình kém trọng lượng",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-803c-8e35-c5f2b433d46d",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:25:00.000Z",
        "last_edited_time": "2025-08-27T01:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Điều này hoàn toàn tự nhiên. Mình từng đọc qua khái niệm “thuyết phục” của triết gia Aristotle (bạn có thể đọc thêm qua bài ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Điều này hoàn toàn tự nhiên. Mình từng đọc qua khái niệm “thuyết phục” của triết gia Aristotle (bạn có thể đọc thêm qua bài ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Persuade",
                "link": {
                  "url": "/1215d16478d8809d89b0e84bbf170b05"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Persuade",
              "href": "/1215d16478d8809d89b0e84bbf170b05"
            },
            {
              "type": "text",
              "text": {
                "content": " này). Ông nhắc đến 3 factor trong việc lời nói bạn có đủ thuyết phục: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " này). Ông nhắc đến 3 factor trong việc lời nói bạn có đủ thuyết phục: ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25c5d164-78d8-80d0-8b38-ddc7bcdeabc2",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-27T01:43:00.000Z",
        "last_edited_time": "2025-08-27T01:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Logic (logos)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Logic (logos)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25c5d164-78d8-80a3-b0d8-c0b54c8d92c4",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-27T01:43:00.000Z",
        "last_edited_time": "2025-08-27T01:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lời nói “lọt lỗ tai” (pathos)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lời nói “lọt lỗ tai” (pathos)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25c5d164-78d8-803f-8910-c26c92ddf510",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-27T01:43:00.000Z",
        "last_edited_time": "2025-08-27T01:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vị thế (ethos)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vị thế (ethos)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25c5d164-78d8-809b-b5ee-c5f54b4018f7",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-27T01:43:00.000Z",
        "last_edited_time": "2025-08-27T01:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ethos nhắc đến vị thế, uy quyền nó ảnh hưởng lên trọng lượng lời nói của mình.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ethos nhắc đến vị thế, uy quyền nó ảnh hưởng lên trọng lượng lời nói của mình.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8031-b8a8-c9a3870d770e",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:29:00.000Z",
        "last_edited_time": "2025-08-27T01:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "→ Nếu mình ở một vị thế thấp hơn, sẽ rất dễ bị xem nhẹ. Như vậy thì sẽ dễ bị phớt lờ hoặc lời nói có uy tín không cao → điều này dẫn đến nỗ lực truyền tải cao hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "→ Nếu mình ở một vị thế thấp hơn, sẽ rất dễ bị xem nhẹ. Như vậy thì sẽ dễ bị phớt lờ hoặc lời nói có uy tín không cao → điều này dẫn đến nỗ lực truyền tải cao hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80ff-a13b-e474ccd417db",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:30:00.000Z",
        "last_edited_time": "2025-08-27T01:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy có cách nào để nâng sức nặng lời nói lên hay không?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy có cách nào để nâng sức nặng lời nói lên hay không?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80a7-9b0a-df65241313c6",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:36:00.000Z",
        "last_edited_time": "2025-08-14T01:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80ad-993d-f4bf11a4b2be",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:31:00.000Z",
        "last_edited_time": "2025-08-14T01:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hướng xử lý:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hướng xử lý:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80f9-8160-fa794f87dd2e",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:30:00.000Z",
        "last_edited_time": "2025-08-27T01:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "LUẬN CỨ là thứ mình phải chuẩn bị & truyền đạt cho họ. Nó giống như việc dựa trên vai “người khổng lổ”, “người khổng lồ” này là gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "LUẬN CỨ là thứ mình phải chuẩn bị & truyền đạt cho họ. Nó giống như việc dựa trên vai “người khổng lổ”, “người khổng lồ” này là gì?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80fd-accd-f7d6b438704d",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:32:00.000Z",
        "last_edited_time": "2025-08-14T01:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nó có thể là:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nó có thể là:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8072-9be8-fb7f0b47761c",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:32:00.000Z",
        "last_edited_time": "2025-08-14T01:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Fact (user testing, research)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Fact (user testing, research)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8010-b51f-db0058fe3499",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:32:00.000Z",
        "last_edited_time": "2025-08-14T01:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Data",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Data",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80c3-af7d-fe21f2a499a0",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:32:00.000Z",
        "last_edited_time": "2025-08-14T01:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Principle, foundation, best practice",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Principle, foundation, best practice",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80f3-8bf0-f37ebcb0a6f0",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:34:00.000Z",
        "last_edited_time": "2025-08-14T01:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Past exprience, past reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Past exprience, past reference",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8005-834b-fae01367a4c7",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:33:00.000Z",
        "last_edited_time": "2025-08-27T01:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Những data point này không phải luận điểm của bạn, mà nó là những thứ khó chối cãi, vì nó là reality, là công trình nghiên cứu của ngành,… Nó sẽ giúp củng cố lòng tin của họ không phải dựa vào lời bạn nói, mà chúng dựa vào những thứ khách quan, những thứ “lớn hơn bạn”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Những data point này không phải luận điểm của bạn, mà nó là những thứ khó chối cãi, vì nó là reality, là công trình nghiên cứu của ngành,… Nó sẽ giúp củng cố lòng tin của họ không phải dựa vào lời bạn nói, mà chúng dựa vào những thứ khách quan, những thứ “lớn hơn bạn”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8016-8c0d-f5bea15722c1",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:37:00.000Z",
        "last_edited_time": "2025-08-14T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80f6-8b03-c8b4f110053f",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:37:00.000Z",
        "last_edited_time": "2025-08-14T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tạm kết",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tạm kết",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8040-8e4f-cb0637e64806",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:37:00.000Z",
        "last_edited_time": "2025-08-27T01:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đây là bài mình sẽ liên tục cập nhật các lesson learnt từ tình huống thực tế mình va đập qua, so wait for it",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đây là bài mình sẽ liên tục cập nhật các lesson learnt từ tình huống thực tế mình va đập qua, so wait for it",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8090-9ab1-f5fb2e617642",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:38:00.000Z",
        "last_edited_time": "2025-08-14T01:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "To be continue…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "To be continue…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-80d3-aba3-d77286844812",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:23:00.000Z",
        "last_edited_time": "2025-08-04T11:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-8099-b475-d6b30b853dbe",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:23:00.000Z",
        "last_edited_time": "2025-08-04T11:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80c5-9578-e46d71fb3743",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-14T01:18:00.000Z",
        "last_edited_time": "2025-08-14T01:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lập luận vs Tranh luận",
              "href": "https://app.notion.com/p/2095d16478d880538f74c9eb6baeca79"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-80b5-bba3-e2a217258153",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:23:00.000Z",
        "last_edited_time": "2025-08-10T10:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Take design feedback (P1)",
              "href": "https://app.notion.com/p/22c5d16478d880908563e4ee428f9a9a"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-8010-b012-ee36061a74aa",
        "parent": {
          "type": "page_id",
          "page_id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
        },
        "created_time": "2025-08-04T11:23:00.000Z",
        "last_edited_time": "2025-08-10T10:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "14477ad8-7b47-470c-9af5-9bab88236d43"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Take design feedback (P2)",
              "href": "https://app.notion.com/p/14477ad87b47470c9af59bab88236d43"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "23d5d164-78d8-8059-9489-f11799cee284",
    "created_time": "2025-07-27T15:45:00.000Z",
    "last_edited_time": "2025-09-04T02:00:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2025-07-27T15:45:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "1-Understanding",
          "color": "orange"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 73
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-09-04T02:00:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "CDA\\",
          "name": "⚓:2",
          "color": "brown"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "UX as consultant & Expectation",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "UX as consultant & Expectation",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/UX-as-consultant-Expectation-23d5d16478d880599489f11799cee284",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
      "name": "Understanding",
      "slug": "understanding",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "2545d164-78d8-80c4-9b4f-eb10fb994cbc",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T02:24:00.000Z",
        "last_edited_time": "2025-08-21T05:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755570434/uxcomic-imgs/2545d164-78d8-80c4-9b4f-eb10fb994cbc.png",
            "expiry_time": "2026-10-04T09:11:06.304Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2545d164-78d8-80c4-9b4f-eb10fb994cbc"
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80a5-875f-c2376daabec4",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-08-21T05:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Những năm gần đây, mình được làm trong cấu trúc tổ chức định hình team UX như một team consultant service, nó có hơi khác với công việc quá khứ của mình (UX trong product team - do mình cũng làm môi trường start-up nữa nên size khá nhỏ, vì thế được invovle luôn từ giai đoạn đầu), vì thế mình cũng tò mò “thật ra nó sẽ khác biệt ra sao giữa việc xem UX là consultant vs UX thuộc core product team?”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Những năm gần đây, mình được làm trong cấu trúc tổ chức định hình team UX như một team consultant service, nó có hơi khác với công việc quá khứ của mình (UX trong product team - do mình cũng làm môi trường start-up nữa nên size khá nhỏ, vì thế được invovle luôn từ giai đoạn đầu), vì thế mình cũng tò mò “thật ra nó sẽ khác biệt ra sao giữa việc xem UX là consultant vs UX thuộc core product team?”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2565d164-78d8-80bd-9275-c01526597e54",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-21T05:30:00.000Z",
        "last_edited_time": "2025-08-21T05:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cùng mình tìm hiểu qua nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cùng mình tìm hiểu qua nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8058-8e57-e20902a051b3",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:43:00.000Z",
        "last_edited_time": "2025-08-19T01:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80ac-bf3f-d74142463956",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-08-19T01:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Định nghĩa",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Định nghĩa",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8064-a9a9-eac8d0ecf7b8",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-08-19T01:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Consult: tham vấn, xin ý kiến, bàn bạc trước khi ra quyết định.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Consult: tham vấn, xin ý kiến, bàn bạc trước khi ra quyết định.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8097-b8bf-ebfa2f852390",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-08-19T01:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Consultant: chuyên gia tư vấn, đưa kiến thức và góc nhìn chuyên môn giúp người khác giải quyết vấn đề.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Consultant: chuyên gia tư vấn, đưa kiến thức và góc nhìn chuyên môn giúp người khác giải quyết vấn đề.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8069-bcc5-c81309951140",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-08-21T05:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong bản chất, consult không phải là làm thay, mà là giúp người khác ra quyết định tốt hơn bằng tri thức, kinh nghiệm và phân tích mà mình bổ sung thêm cho họ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong bản chất, consult không phải là làm thay, mà là giúp người khác ra quyết định tốt hơn bằng tri thức, kinh nghiệm và phân tích mà mình bổ sung thêm cho họ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80a8-80a4-cf76b8c145e8",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:34:00.000Z",
        "last_edited_time": "2025-08-19T01:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8026-9e9f-c14d61d52f4b",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-09-04T01:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong ngữ cảnh UX team as a consulting service",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong ngữ cảnh UX team as a consulting service",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-802d-aeef-ee19cb217c96",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-08-19T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tính chất",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tính chất",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8046-8747-e2446bcd025e",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-09-04T02:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong bối cảnh này, UX team không phải người đóng góp nhiều vào các quyết định mang tính đưa ra concept hay solution (thường PM, business owner mới là decision maker). UX team được xem như một người đồng hành chuyên môn, giúp các team khác (PM, Dev, Business, Marketing…), ta chịu trách đề xuất các giải pháp UX phù hợp. UX team giống như bác sĩ: chẩn đoán bệnh (phân tích problem mà PO đưa ra), kênh đơn thuốc- đưa giải pháp (UX solution), nhưng sau cùng bệnh nhân (business/stakeholder) mới là người chọn có theo hay không.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong bối cảnh này, UX team không phải người đóng góp nhiều vào các quyết định mang tính đưa ra concept hay solution (thường PM, business owner mới là decision maker). UX team được xem như một người đồng hành chuyên môn, giúp các team khác (PM, Dev, Business, Marketing…), ta chịu trách đề xuất các giải pháp UX phù hợp. UX team giống như bác sĩ: chẩn đoán bệnh (phân tích problem mà PO đưa ra), kênh đơn thuốc- đưa giải pháp (UX solution), nhưng sau cùng bệnh nhân (business/stakeholder) mới là người chọn có theo hay không.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80b0-8de9-f958fbb6fe8f",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:37:00.000Z",
        "last_edited_time": "2025-08-19T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Workflow",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Workflow",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80d4-b6a2-c88172ef43a7",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:48:00.000Z",
        "last_edited_time": "2025-09-04T01:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Team UX thường được chia thành 1 department độc lập, team tiếp nhận request từ các bên, có thể hình dung như một agency in house.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Team UX thường được chia thành 1 department độc lập, team tiếp nhận request từ các bên, có thể hình dung như một agency in house.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8073-a5c1-cb0bf2c5af8a",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:37:00.000Z",
        "last_edited_time": "2025-08-21T05:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Stage được involve vào = Sau khi problem hoặc thậm chí solution đã được định nghĩa, định hình → Mình đồng hành với PO/PM trong giai đoạn lên design concept là chính, sau đó chủ yếu follow up để support cho dev, và xem metrics report sau khi release.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Stage được involve vào = Sau khi problem hoặc thậm chí solution đã được định nghĩa, định hình → Mình đồng hành với PO/PM trong giai đoạn lên design concept là chính, sau đó chủ yếu follow up để support cho dev, và xem metrics report sau khi release.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8067-b15a-cc94484b199a",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:39:00.000Z",
        "last_edited_time": "2025-08-19T01:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có tính khách quan hơn vì bạn chỉ đóng vai trò input góc nhìn của UX, không bị chịu nhiều áp lực KPI phía business hoặc feature outcome.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có tính khách quan hơn vì bạn chỉ đóng vai trò input góc nhìn của UX, không bị chịu nhiều áp lực KPI phía business hoặc feature outcome.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80d8-ad2e-fbaaab296736",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:44:00.000Z",
        "last_edited_time": "2025-08-19T01:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ưu và nhược",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ưu và nhược",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80f3-96ab-d935891a8e86",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:45:00.000Z",
        "last_edited_time": "2025-08-19T01:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "✅ Tính độc lập: dễ giữ được quan điểm khách quan, unbiased.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "✅ Tính độc lập: dễ giữ được quan điểm khách quan, unbiased.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-804f-9804-e8e1b2a0df13",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:45:00.000Z",
        "last_edited_time": "2025-09-04T01:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "✅ Tính linh hoạt cao vì có thể phục vụ nhiều team cùng lúc.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "✅ Tính linh hoạt cao vì có thể phục vụ nhiều team cùng lúc.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2645d164-78d8-80ee-ab70-eb6a9ad83525",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-09-04T01:33:00.000Z",
        "last_edited_time": "2025-09-04T01:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "✅ Có cơ hội học hỏi chéo lẫn nhau (học từ các peer - designer).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "✅ Có cơ hội học hỏi chéo lẫn nhau (học từ các peer - designer).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8087-a7c1-cc64fdceafc9",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:45:00.000Z",
        "last_edited_time": "2025-08-21T05:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "❌ Khó tạo impact sâu, vì không có quyền ra quyết định. Dễ bị xem như “service team” (order taker).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "❌ Khó tạo impact sâu, vì không có quyền ra quyết định. Dễ bị xem như “service team” (order taker).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8025-b62a-db3150752003",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:34:00.000Z",
        "last_edited_time": "2025-08-19T01:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8008-86fa-d986152645c8",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:34:00.000Z",
        "last_edited_time": "2025-09-04T01:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khác với ngữ cảnh ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khác với ngữ cảnh ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "UX as a Core Product teammate",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX as a Core Product teammate",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80b8-b779-c3db39e22089",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:36:00.000Z",
        "last_edited_time": "2025-08-19T01:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tính chất",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tính chất",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80a6-9fc1-cfc857118b53",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:35:00.000Z",
        "last_edited_time": "2025-09-04T01:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "UX cùng ngồi chung team cross-functional (PM, Dev, BA, QA), team này tự chủ 1 feature area cụ thể và cùng nhau ownership trực tiếp với outcome gì đó (KPIs, OKRs của product), nên lúc này UX có tiếng nói ngang hàng trong quyết định sản phẩm, có thể hình dung như một mini start up trong công ty.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX cùng ngồi chung team cross-functional (PM, Dev, BA, QA), team này tự chủ 1 feature area cụ thể và cùng nhau ownership trực tiếp với outcome gì đó (KPIs, OKRs của product), nên lúc này UX có tiếng nói ngang hàng trong quyết định sản phẩm, có thể hình dung như một mini start up trong công ty.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8099-97ad-e6384af6f3bd",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:36:00.000Z",
        "last_edited_time": "2025-08-19T01:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Workflow",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Workflow",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8084-9cdb-d0838a1e12b2",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:48:00.000Z",
        "last_edited_time": "2025-09-04T01:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "UX thuộc và chuyên trách cho 1 product area (hoặc 1 squad, ví dụ bạn chỉ thuộc squad growth & engagement, module payment & subscription, hoặc chuyên trách các tính năng cho gói Business account chẳng hạn).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX thuộc và chuyên trách cho 1 product area (hoặc 1 squad, ví dụ bạn chỉ thuộc squad growth & engagement, module payment & subscription, hoặc chuyên trách các tính năng cho gói Business account chẳng hạn).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80d4-9cc1-d6c780fc17cf",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:36:00.000Z",
        "last_edited_time": "2025-09-04T01:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Stage được involve vào = Tham gia từ rất sớm (discovery, định nghĩa vấn đề, ưu tiên backlog). Đồng hành xuyên suốt: từ research → design → test → launch → iterate. End-to-end process.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Stage được involve vào = Tham gia từ rất sớm (discovery, định nghĩa vấn đề, ưu tiên backlog). Đồng hành xuyên suốt: từ research → design → test → launch → iterate. End-to-end process.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80f7-b900-e4750b2b533f",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:36:00.000Z",
        "last_edited_time": "2025-08-19T01:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đề xuất có tính ràng buộc hơn, không chỉ “tư vấn” mà còn đồng chịu trách nhiệm với product.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đề xuất có tính ràng buộc hơn, không chỉ “tư vấn” mà còn đồng chịu trách nhiệm với product.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8048-a630-cd352547015a",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:46:00.000Z",
        "last_edited_time": "2025-08-19T01:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ưu và nhược",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ưu và nhược",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8004-8188-ffa18da77062",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:46:00.000Z",
        "last_edited_time": "2025-08-19T01:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "✅ Impact lớn: UX có thể ảnh hưởng trực tiếp tới roadmap & outcome.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "✅ Impact lớn: UX có thể ảnh hưởng trực tiếp tới roadmap & outcome.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80f2-9591-dec1284087cc",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:46:00.000Z",
        "last_edited_time": "2025-08-19T01:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "✅ Gắn kết chặt chẽ với business & tech, hiểu sâu domain.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "✅ Gắn kết chặt chẽ với business & tech, hiểu sâu domain.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-803b-ab73-ed6032ee2655",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:46:00.000Z",
        "last_edited_time": "2025-08-19T01:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "❌ Dễ bị cuốn vào “business pressure”, mất đi tính khách quan vì có khi bạn làm theo hướng KPI-centered thay vì user-centered.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "❌ Dễ bị cuốn vào “business pressure”, mất đi tính khách quan vì có khi bạn làm theo hướng KPI-centered thay vì user-centered.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2645d164-78d8-80f0-934f-cca7bc8db187",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-09-04T01:38:00.000Z",
        "last_edited_time": "2025-09-04T01:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2645d164-78d8-8079-8afe-dfa570b38c33",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-09-04T01:41:00.000Z",
        "last_edited_time": "2025-09-04T01:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hybrid",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hybrid",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2645d164-78d8-80a5-b9e7-cb7faedd07ed",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-09-04T01:38:00.000Z",
        "last_edited_time": "2025-09-04T01:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ngoài còn có một dạng giữa giữa, bạn có thể vừa trực thuộc chính cho một squad để đảm đương các task trong squad đó, nhưng song song vẫn thuộc chapter UX (phòng ban UX), nơi mà có Head of design sẽ quyết định career development & đảm bảo chất lượng design.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ngoài còn có một dạng giữa giữa, bạn có thể vừa trực thuộc chính cho một squad để đảm đương các task trong squad đó, nhưng song song vẫn thuộc chapter UX (phòng ban UX), nơi mà có Head of design sẽ quyết định career development & đảm bảo chất lượng design.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80da-aa2c-d65b8806e4d4",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:32:00.000Z",
        "last_edited_time": "2025-08-19T01:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2645d164-78d8-80a4-a404-dd9b24ee789d",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-09-04T01:36:00.000Z",
        "last_edited_time": "2025-09-04T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bối cảnh của mình…",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bối cảnh của mình…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2645d164-78d8-801b-a2b7-fbc22cd71d93",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-09-04T01:31:00.000Z",
        "last_edited_time": "2025-09-04T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ở công ty hiện tại của mình tồn tại cả 2 mô hình trên, nhưng mình thuộc team xu hướng dạng service, nên bài này muốn nghiên cứu xem “nếu mình trong tổ chức dạng đó thì nên xử trí thế nào?”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ở công ty hiện tại của mình tồn tại cả 2 mô hình trên, nhưng mình thuộc team xu hướng dạng service, nên bài này muốn nghiên cứu xem “nếu mình trong tổ chức dạng đó thì nên xử trí thế nào?”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2645d164-78d8-808e-9018-da6726641e97",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-09-04T01:36:00.000Z",
        "last_edited_time": "2025-09-04T01:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80b9-9d67-dc2572db138b",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:32:00.000Z",
        "last_edited_time": "2025-09-04T01:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy làm thế nào để consult tốt?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy làm thế nào để consult tốt?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8063-a443-f844381509a0",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-08-19T01:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nguyên tắc cốt lõi",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nguyên tắc cốt lõi",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8080-8307-e229448d061b",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-08-19T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Listen first, then advise",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Listen first, then advise",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": lắng nghe bối cảnh, constraint, mục tiêu trước khi đưa lời khuyên.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": lắng nghe bối cảnh, constraint, mục tiêu trước khi đưa lời khuyên.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "2545d164-78d8-800d-9725-cc37c96b96de",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-08-19T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Evidence-based",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Evidence-based",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": tư vấn dựa trên data, research, best practice UX — tránh chỉ nói theo cảm tính.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": tư vấn dựa trên data, research, best practice UX — tránh chỉ nói theo cảm tính.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80e2-9563-f422a4486637",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-08-19T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Frame choices, not orders",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Frame choices, not orders",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": thay vì “phải làm thế này”, hãy đưa 2–3 option kèm trade-off để họ chọn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": thay vì “phải làm thế này”, hãy đưa 2–3 option kèm trade-off để họ chọn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8078-8c44-dfda179e4f4d",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-08-21T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bridge mindset",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bridge mindset",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": hiểu ngôn ngữ business, tech, và user để “thông dịch” & giao tiếp.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": hiểu ngôn ngữ business, tech, và user để “thông dịch” & giao tiếp.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 3
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80e4-843c-fa398da6f54b",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-09-04T01:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kỹ năng cần",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kỹ năng cần",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8044-86d5-c5593d2a4f52",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-09-04T01:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khai thác vấn đề",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khai thác vấn đề",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": biết đặt câu hỏi để hiểu real problem / root cause, không chỉ giải quyết symptom.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": biết đặt câu hỏi để hiểu real problem / root cause, không chỉ giải quyết symptom.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8011-858e-cf22549ceee4",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-09-04T01:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Storytelling",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Storytelling",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": trình bày insight và đề xuất theo cách dễ hiểu, dễ hành động.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": trình bày insight và đề xuất theo cách dễ hiểu, dễ hành động.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80ed-b65d-ecad1a561c32",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-09-04T01:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Negotiation",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Negotiation",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": tuỳ tình huống biết khi nào cần nhượng bộ, khi nào cần biết push back.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": tuỳ tình huống biết khi nào cần nhượng bộ, khi nào cần biết push back.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-803e-9f13-c7ddc2a3f58c",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-09-04T01:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Expectation management",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Expectation management",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": luôn rõ ràng rằng UX không “cứu cả thế giới”, mà hỗ trợ trong phạm vi nhất định.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": luôn rõ ràng rằng UX không “cứu cả thế giới”, mà hỗ trợ trong phạm vi nhất định.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80ee-aab9-e98156d7d9f4",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T02:09:00.000Z",
        "last_edited_time": "2025-08-19T02:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kinh nghiệm xương máu",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kinh nghiệm xương máu",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80c5-92a5-e474474fe032",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T02:09:00.000Z",
        "last_edited_time": "2025-08-19T02:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hãy document mọi thứ, từ problem statement, solution proposal cho đến meeting note & decision log. Chúng là những source of truth rằng bạn đã consult ra sao, vì again decision maker không thuộc về mình, mình chỉ chuẩn đoán & tư vấn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hãy document mọi thứ, từ problem statement, solution proposal cho đến meeting note & decision log. Chúng là những source of truth rằng bạn đã consult ra sao, vì again decision maker không thuộc về mình, mình chỉ chuẩn đoán & tư vấn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-800a-9855-dc72fc2dcba4",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:53:00.000Z",
        "last_edited_time": "2025-08-19T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80d0-a786-dcac81f69399",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-09-04T01:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "What UX consult will do:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "What UX consult will do:",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80a2-a283-c3b0f3fd28f8",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:33:00.000Z",
        "last_edited_time": "2025-08-19T01:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hiểu người dùng, bối cảnh sử dụng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hiểu người dùng, bối cảnh sử dụng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8067-a683-c1bca3d5b9b2",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:33:00.000Z",
        "last_edited_time": "2025-08-19T01:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cung cấp insight và best practice.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cung cấp insight và best practice.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8089-a7af-fcffcd14eb0a",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:33:00.000Z",
        "last_edited_time": "2025-08-19T01:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đưa khuyến nghị với trade-off rõ ràng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đưa khuyến nghị với trade-off rõ ràng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8075-9fb2-fd9f166e7cf2",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:33:00.000Z",
        "last_edited_time": "2025-08-19T01:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hỗ trợ thiết kế để test idea nhanh.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hỗ trợ thiết kế để test idea nhanh.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80f5-8b0e-d7f5263d0628",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-08-19T01:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80f9-aeab-daeddb8d1b3b",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-08-19T01:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "What UX consult won’t do:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "What UX consult won’t do:",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8055-888f-f723b5c6e03d",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:33:00.000Z",
        "last_edited_time": "2025-08-21T05:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Không tự quyết business strategy.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Không tự quyết business strategy.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-802a-ab36-c28c2fe682c0",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:33:00.000Z",
        "last_edited_time": "2025-09-04T01:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Không cam kết outcome nếu stakeholder không theo UX solution.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Không cam kết outcome nếu stakeholder không theo UX solution.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8039-b468-d34218e4e304",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:33:00.000Z",
        "last_edited_time": "2025-09-04T01:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Không làm “order taker” - chỉ để vẽ màn hình mà không tham gia vào problem framing.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Không làm “order taker” - chỉ để vẽ màn hình mà không tham gia vào problem framing.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80a8-9ce2-c356b2f70a4b",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-08-19T01:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-801b-a285-dee8b60ebc45",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-09-04T01:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tóm gọn",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tóm gọn",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80b5-8ef1-d161155982f7",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:30:00.000Z",
        "last_edited_time": "2025-09-04T01:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tâm thế cần set trong đầu:\n“UX team sẽ giúp đưa ra góc nhìn người dùng, stand for “user voice”, tư vấn giải pháp dựa trên evidence, và dùng thiết kế để kiểm chứng. Nhưng quyết định cuối cùng nằm ở PM/business.”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tâm thế cần set trong đầu:\n“UX team sẽ giúp đưa ra góc nhìn người dùng, stand for “user voice”, tư vấn giải pháp dựa trên evidence, và dùng thiết kế để kiểm chứng. Nhưng quyết định cuối cùng nằm ở PM/business.”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8046-98b4-dd4d7bc9b417",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T02:11:00.000Z",
        "last_edited_time": "2025-08-19T02:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Làm consult tốt = (Lắng nghe + Phân tích bằng evidence + Truyền đạt rõ ràng trade-off) x Quản lý kỳ vọng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Làm consult tốt = (Lắng nghe + Phân tích bằng evidence + Truyền đạt rõ ràng trade-off) x Quản lý kỳ vọng.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80d3-9a6b-da7cd2f583e2",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:55:00.000Z",
        "last_edited_time": "2025-08-19T02:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8001-9515-ce44f2092b09",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:55:00.000Z",
        "last_edited_time": "2025-08-19T02:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vài chia sẻ cá nhân",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vài chia sẻ cá nhân",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-809c-b845-f0720bd13c7b",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T02:00:00.000Z",
        "last_edited_time": "2025-09-04T01:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "— Bài này mình có tham khảo nhiều từ chatGPT, tuy nhiên đọc và ngẫm, đối chiếu với công việc và kinh nghiệm quá khứ thì thấy rất đúng. Đồng thời có thêm vài nhận định cá nhân, nên nếu mọi người có góc nhìn khác, mình rất mong được biết thêm. Nếu bạn muốn nghiên cứu thêm, có thể xem thêm các nguồn bên dưới.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "— Bài này mình có tham khảo nhiều từ chatGPT, tuy nhiên đọc và ngẫm, đối chiếu với công việc và kinh nghiệm quá khứ thì thấy rất đúng. Đồng thời có thêm vài nhận định cá nhân, nên nếu mọi người có góc nhìn khác, mình rất mong được biết thêm. Nếu bạn muốn nghiên cứu thêm, có thể xem thêm các nguồn bên dưới.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-805f-a130-febc988daaea",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T02:14:00.000Z",
        "last_edited_time": "2025-08-19T02:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80d8-b401-c76c78c9b319",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:56:00.000Z",
        "last_edited_time": "2025-09-04T01:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ban đầu mình cũng muốn được nhìn nhận UX như một core product team, nhưng ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ban đầu mình cũng muốn được nhìn nhận UX như một core product team, nhưng ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "việc nhìn nhận sai này khiến mình set expectation sai",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "việc nhìn nhận sai này khiến mình set expectation sai",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " → dẫn đến mâu thuẫn nội tâm, nên nếu nhìn nhận đúng hơn thì expectation sẽ được đặt về đúng chỗ (nó như kiểu bơi xuôi dòng thay vì ngược dòng) → Dễ thở hơn và tập trung cho phần việc mình tốt hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " → dẫn đến mâu thuẫn nội tâm, nên nếu nhìn nhận đúng hơn thì expectation sẽ được đặt về đúng chỗ (nó như kiểu bơi xuôi dòng thay vì ngược dòng) → Dễ thở hơn và tập trung cho phần việc mình tốt hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80dc-8c67-d0abe8354a48",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T02:11:00.000Z",
        "last_edited_time": "2025-08-19T02:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-806b-8bc5-fba59c345852",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T02:07:00.000Z",
        "last_edited_time": "2025-09-04T01:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Không có cách nhìn nhận team UX như thế nào là tốt hoàn toàn, nó tuỳ thuộc vào cấu trúc tổ chức, resource team, product phase cũng như độ UX maturity.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Không có cách nhìn nhận team UX như thế nào là tốt hoàn toàn, nó tuỳ thuộc vào cấu trúc tổ chức, resource team, product phase cũng như độ UX maturity.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8035-985b-c41dde2aa78a",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:58:00.000Z",
        "last_edited_time": "2025-08-19T01:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2645d164-78d8-8073-9683-d514c26c0f42",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-09-04T01:47:00.000Z",
        "last_edited_time": "2025-09-04T01:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2645d164-78d8-805f-9632-f42f5fae4a6b",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-09-04T01:47:00.000Z",
        "last_edited_time": "2025-09-04T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.nngroup.com/articles/ux-team-models/",
                "link": {
                  "url": "https://www.nngroup.com/articles/ux-team-models/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.nngroup.com/articles/ux-team-models/",
              "href": "https://www.nngroup.com/articles/ux-team-models/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2645d164-78d8-8039-b022-f77489e1033c",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-09-04T01:48:00.000Z",
        "last_edited_time": "2025-09-04T01:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://maze.co/collections/ux-management/team-structure/",
                "link": {
                  "url": "https://maze.co/collections/ux-management/team-structure/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://maze.co/collections/ux-management/team-structure/",
              "href": "https://maze.co/collections/ux-management/team-structure/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2645d164-78d8-8006-b0ff-d759cce16203",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-09-04T01:47:00.000Z",
        "last_edited_time": "2025-09-04T01:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80ad-a49b-d82b1269f25f",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:58:00.000Z",
        "last_edited_time": "2025-08-19T01:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8069-9466-f04d9a1cc5eb",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:58:00.000Z",
        "last_edited_time": "2025-08-19T01:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1445d164-78d8-805b-b388-e24b5f13cccb"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product development process (overall)",
              "href": "https://app.notion.com/p/1445d16478d8805bb388e24b5f13cccb"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-80fd-9667-c2f3b6681877",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:58:00.000Z",
        "last_edited_time": "2025-08-19T01:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1185d164-78d8-8014-bdf1-e631b28f601e"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "RACI (Role & Responsibility)",
              "href": "https://app.notion.com/p/1185d16478d88014bdf1e631b28f601e"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-802f-a08d-d7321b7d7bf6",
        "parent": {
          "type": "page_id",
          "page_id": "23d5d164-78d8-8059-9489-f11799cee284"
        },
        "created_time": "2025-08-19T01:58:00.000Z",
        "last_edited_time": "2025-08-19T01:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1265d164-78d8-8045-87d2-e2532aae0b64"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Brief (Hiểu đề)",
              "href": "https://app.notion.com/p/1265d16478d8804587d2e2532aae0b64"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "22c5d164-78d8-8090-8563-e4ee428f9a9a",
    "created_time": "2025-07-10T06:48:00.000Z",
    "last_edited_time": "2026-07-26T02:05:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2025-07-10T06:48:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "3-Workflow",
          "color": "default"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 70
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2026-07-26T02:05:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "tMsg",
          "name": "⚓:1",
          "color": "default"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Take design feedback (P1)",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Take design feedback (P1)",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Take-design-feedback-P1-22c5d16478d880908563e4ee428f9a9a",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
      "name": "Workflow",
      "slug": "workflow",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "2305d164-78d8-8011-8d8e-e2ffb36a6e84",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-14T02:27:00.000Z",
        "last_edited_time": "2025-07-14T02:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754877988/uxcomic-imgs/2305d164-78d8-8011-8d8e-e2ffb36a6e84.png",
            "expiry_time": "2026-10-04T09:11:08.359Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2305d164-78d8-8011-8d8e-e2ffb36a6e84"
      },
      {
        "object": "block",
        "id": "3a95d164-78d8-80e3-839f-c922ee9fb40e",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2026-07-26T01:05:00.000Z",
        "last_edited_time": "2026-07-26T01:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chủ đề đón nhận & tackle feedback chắc là một trong các topic mình thấy khó nhằn nhất.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chủ đề đón nhận & tackle feedback chắc là một trong các topic mình thấy khó nhằn nhất.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3a95d164-78d8-80d2-81f9-cd37e6cd41d1",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2026-07-26T01:06:00.000Z",
        "last_edited_time": "2026-07-26T01:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Xưa giờ mình là người không giỏi giao tiếp, nên việc đứng ra nhận feedback & defend lại nhiều lúc khiến mình như đơ luôn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Xưa giờ mình là người không giỏi giao tiếp, nên việc đứng ra nhận feedback & defend lại nhiều lúc khiến mình như đơ luôn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3a95d164-78d8-802c-8af6-edcf095a0756",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2026-07-26T01:07:00.000Z",
        "last_edited_time": "2026-07-26T01:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phải rèn luyện rất nhiều mình mới dạn miệng hơn chút, đầu quay số nhanh hơn chút. Và bài này mình sẽ mình sẽ reflect lại quá trình take design feedback.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phải rèn luyện rất nhiều mình mới dạn miệng hơn chút, đầu quay số nhanh hơn chút. Và bài này mình sẽ mình sẽ reflect lại quá trình take design feedback.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2325d164-78d8-809b-8ea4-f4d6a250d90e",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-16T05:11:00.000Z",
        "last_edited_time": "2025-07-16T05:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2325d164-78d8-807d-8fab-f2143a3f3c41",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-16T05:08:00.000Z",
        "last_edited_time": "2025-07-16T05:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Intro",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Intro",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2325d164-78d8-803e-98e3-d278e6b94042",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-16T05:08:00.000Z",
        "last_edited_time": "2025-10-13T10:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phần intro này viết về “take design feedback” mình thấy hay quá nên xin trích dẫn hoàn toàn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phần intro này viết về “take design feedback” mình thấy hay quá nên xin trích dẫn hoàn toàn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2325d164-78d8-8050-a4af-e0c6cdafd6d1",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-16T05:08:00.000Z",
        "last_edited_time": "2025-07-16T05:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“The reason why you feel that knot in your stomach whenever you are about to receive feedback is that your ego views it as an attack, provoking a fight, flight, or freeze response. Your ego thinks you're about to be killed—it's no wonder you feel nervous!",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“The reason why you feel that knot in your stomach whenever you are about to receive feedback is that your ego views it as an attack, provoking a fight, flight, or freeze response. Your ego thinks you're about to be killed—it's no wonder you feel nervous!",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2325d164-78d8-8076-8a7c-d5a9c5d08968",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-16T05:08:00.000Z",
        "last_edited_time": "2025-07-16T05:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "The key is to learn to evaluate ideas objectively and view feedback as a gift. Now this is easier said than done, and will require constant effort and practice. We definitely recommend reading the two books mentioned above, but here's a little shortcut.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "The key is to learn to evaluate ideas objectively and view feedback as a gift. Now this is easier said than done, and will require constant effort and practice. We definitely recommend reading the two books mentioned above, but here's a little shortcut.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2325d164-78d8-8079-acee-c3ba581ca3b2",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-16T05:08:00.000Z",
        "last_edited_time": "2025-07-16T05:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "When people are giving you critical feedback, as soon as they're finished, repeat back to them what you heard. Say “What I'm hearing is XYZ. Is that right?” It is important that the person giving feedback knows that you're hearing and listening to them. Not only will this mechanism do that, but it will also ensure that you have some breathing time to think. Keep asking, “Is that all?” and repeating back until you're sure you've squeezed every last ounce of feedback out of them.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "When people are giving you critical feedback, as soon as they're finished, repeat back to them what you heard. Say “What I'm hearing is XYZ. Is that right?” It is important that the person giving feedback knows that you're hearing and listening to them. Not only will this mechanism do that, but it will also ensure that you have some breathing time to think. Keep asking, “Is that all?” and repeating back until you're sure you've squeezed every last ounce of feedback out of them.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2325d164-78d8-801f-9459-dd5dc96490ef",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-16T05:08:00.000Z",
        "last_edited_time": "2025-07-16T05:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Now, take that piece of feedback and take a second to think about it objectively. Be curious, run through the possibilities. Even if you don't agree with all of it, or with the format in which it was delivered, are there aspects of it that you can take to improve yourself? If you accept the feedback, suggest an action to resolve it. Thank them—giving feedback isn't easy, and by doing so, they've shown they care about you. You don’t have to accept all the feedback you’re given, but at least give a good explanation why not (and be curious to how the opposite might be true).”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Now, take that piece of feedback and take a second to think about it objectively. Be curious, run through the possibilities. Even if you don't agree with all of it, or with the format in which it was delivered, are there aspects of it that you can take to improve yourself? If you accept the feedback, suggest an action to resolve it. Thank them—giving feedback isn't easy, and by doing so, they've shown they care about you. You don’t have to accept all the feedback you’re given, but at least give a good explanation why not (and be curious to how the opposite might be true).”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2325d164-78d8-8045-9ae5-d96807f6f1e5",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-16T05:08:00.000Z",
        "last_edited_time": "2025-07-16T05:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trích từ ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trích từ ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "https://themanagershandbook.com/coaching-and-feedback/feedback#receiving-feedback",
                "link": {
                  "url": "https://themanagershandbook.com/coaching-and-feedback/feedback#receiving-feedback"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://themanagershandbook.com/coaching-and-feedback/feedback#receiving-feedback",
              "href": "https://themanagershandbook.com/coaching-and-feedback/feedback#receiving-feedback"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2325d164-78d8-8048-a0c6-f63664d7bc5e",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-16T05:05:00.000Z",
        "last_edited_time": "2025-07-16T05:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "22c5d164-78d8-806d-9734-c35834294947",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-10T06:48:00.000Z",
        "last_edited_time": "2025-07-10T06:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vài cái hiểu có để tâm thế đúng",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vài cái hiểu có để tâm thế đúng",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22c5d164-78d8-8033-b7fe-c6ad45008c2b",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-10T06:48:00.000Z",
        "last_edited_time": "2025-10-13T10:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Feedback nằm trong process design. Design không thể tách rời khỏi việc chỉnh sửa & cải tiến, và feedback sẽ giúp ta có được nhiều cơ hội để đánh giá lại và iterate khi cần. Cố gắng bình thường hoá nó sẽ khiến mình dễ thở hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Feedback nằm trong process design. Design không thể tách rời khỏi việc chỉnh sửa & cải tiến, và feedback sẽ giúp ta có được nhiều cơ hội để đánh giá lại và iterate khi cần. Cố gắng bình thường hoá nó sẽ khiến mình dễ thở hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22c5d164-78d8-8056-adb6-d1d8852b41b3",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-10T07:18:00.000Z",
        "last_edited_time": "2026-07-26T01:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Feedback chỉ là words, quan trọng là hiểu meaning đằng sau nó, hãy cố gắng hiểu và làm rõ ý đối phương, làm rõ cả những động lực, chủ đích cũng như nỗi sợ, concern của đối phương khi họ đưa ra feedback ấy (vd: PO/PM có thể sẽ xoáy sâu lo về outcome, risk, trade-off, Dev sẽ lo về performance, độ khả thi, khả năng tích hợp, operation sẽ lo về workflow vận hành đằng sau idea đó,…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Feedback chỉ là words, quan trọng là hiểu meaning đằng sau nó, hãy cố gắng hiểu và làm rõ ý đối phương, làm rõ cả những động lực, chủ đích cũng như nỗi sợ, concern của đối phương khi họ đưa ra feedback ấy (vd: PO/PM có thể sẽ xoáy sâu lo về outcome, risk, trade-off, Dev sẽ lo về performance, độ khả thi, khả năng tích hợp, operation sẽ lo về workflow vận hành đằng sau idea đó,…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22c5d164-78d8-80c0-80a7-efba62a2ff5b",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-10T07:17:00.000Z",
        "last_edited_time": "2026-07-26T01:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Feedback & câu chuyện “thầy bói xem voi”: hãy cố gắng tách mình ra, không xem đó là cuộc đối đầu lẫn nhau, nhìn nhận vấn đề như một thứ chung mà 2 bên đều đang muốn thảo luận để tìm ra một phương án tối ưu nhất. Thầy bói xem voi chỉ ra rằng chúng ta đều có những điểm mù, và chúng ta cần lắng nghe ở phía đối phương để có thể nhìn bao quát hơn >> tâm thế này giúp chúng ta cởi mở đón nhận nó hơn, vì càng nhiều góc nhìn ta mới có thể thấy được “con voi” (bức tranh toàn diện).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Feedback & câu chuyện “thầy bói xem voi”: hãy cố gắng tách mình ra, không xem đó là cuộc đối đầu lẫn nhau, nhìn nhận vấn đề như một thứ chung mà 2 bên đều đang muốn thảo luận để tìm ra một phương án tối ưu nhất. Thầy bói xem voi chỉ ra rằng chúng ta đều có những điểm mù, và chúng ta cần lắng nghe ở phía đối phương để có thể nhìn bao quát hơn >> tâm thế này giúp chúng ta cởi mở đón nhận nó hơn, vì càng nhiều góc nhìn ta mới có thể thấy được “con voi” (bức tranh toàn diện).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3a95d164-78d8-807a-ab3d-c274673f0302",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2026-07-26T01:25:00.000Z",
        "last_edited_time": "2026-07-26T01:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Theo kinh nghiệm của mình, để có thể defend được, thì ngay trong quá trình làm design, tốt nhất mình đã suy nghĩ về vấn đề, mình đã cân nhắc 7749 thứ, thì khi feedback đến, ta sẽ hạn chế được việc bị đơ, vì mình đã tư duy qua vấn đề đó, còn nếu chưa tư duy đến thì lúc đó phụ thuộc vào khả năng xử lý thông tin tại thời điểm đó, có người nhảy số nhanh, có người nhảy số chậm, và mình là người chậm nên kinh nghiệm của mình cho những lúc ấy là xin thêm time để suy nghĩ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Theo kinh nghiệm của mình, để có thể defend được, thì ngay trong quá trình làm design, tốt nhất mình đã suy nghĩ về vấn đề, mình đã cân nhắc 7749 thứ, thì khi feedback đến, ta sẽ hạn chế được việc bị đơ, vì mình đã tư duy qua vấn đề đó, còn nếu chưa tư duy đến thì lúc đó phụ thuộc vào khả năng xử lý thông tin tại thời điểm đó, có người nhảy số nhanh, có người nhảy số chậm, và mình là người chậm nên kinh nghiệm của mình cho những lúc ấy là xin thêm time để suy nghĩ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22c5d164-78d8-802b-bff9-fc7c830ad061",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-10T06:48:00.000Z",
        "last_edited_time": "2025-07-10T06:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách tiếp nhận",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách tiếp nhận",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3845d164-78d8-807e-afa0-f6649cfcab1f",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2026-06-19T02:44:00.000Z",
        "last_edited_time": "2026-07-26T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [
            {
              "type": "text",
              "text": {
                "content": "https://www.linkedin.com/posts/protogeridis_as-you-start-working-with-more-and-more-stakeholders-share-7473278228049092609-utsM/?utm_source=share&utm_medium=member_desktop&rcm=ACoAACTxzsYBO4mptTzgsbAc8dNNiYnc142O2IA",
                "link": {
                  "url": "https://www.linkedin.com/posts/protogeridis_as-you-start-working-with-more-and-more-stakeholders-share-7473278228049092609-utsM/?utm_source=share&utm_medium=member_desktop&rcm=ACoAACTxzsYBO4mptTzgsbAc8dNNiYnc142O2IA"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.linkedin.com/posts/protogeridis_as-you-start-working-with-more-and-more-stakeholders-share-7473278228049092609-utsM/?utm_source=share&utm_medium=member_desktop&rcm=ACoAACTxzsYBO4mptTzgsbAc8dNNiYnc142O2IA",
              "href": "https://www.linkedin.com/posts/protogeridis_as-you-start-working-with-more-and-more-stakeholders-share-7473278228049092609-utsM/?utm_source=share&utm_medium=member_desktop&rcm=ACoAACTxzsYBO4mptTzgsbAc8dNNiYnc142O2IA"
            }
          ],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1781837302/uxcomic-imgs/3845d164-78d8-807e-afa0-f6649cfcab1f.png",
            "expiry_time": "2026-10-04T09:11:08.359Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/3845d164-78d8-807e-afa0-f6649cfcab1f"
      },
      {
        "object": "block",
        "id": "22c5d164-78d8-80bb-885c-dd63ab709858",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-10T06:48:00.000Z",
        "last_edited_time": "2026-07-26T01:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước tiên, lắng lại và nghe trước, hiểu và làm rõ hết ý của đối phương. Đây là cơ hội để bạn có thể có thêm góc nhìn mới, đừng block nó (đừng cứng đầu). Lưu ý hãy làm cho rõ ý, nếu không hiểu hoặc thấy mơ hồ thì hãy clarify lại.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước tiên, lắng lại và nghe trước, hiểu và làm rõ hết ý của đối phương. Đây là cơ hội để bạn có thể có thêm góc nhìn mới, đừng block nó (đừng cứng đầu). Lưu ý hãy làm cho rõ ý, nếu không hiểu hoặc thấy mơ hồ thì hãy clarify lại.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "3a95d164-78d8-8066-8c27-f2fc5f976366",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2026-07-26T01:19:00.000Z",
        "last_edited_time": "2026-07-26T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bạn sẽ muốn những dẫn cứ đằng sau lời feedback ấy, liệu nó đang là trên những cảm nhận khách quan hay chủ quan, liệu nhận định đó đến từ cách đánh giá như thế nào, trên data, research, trên kinh nghiệm, lý thuyết hay trên assumption, nếu là assumption thì đã có cách nào validate nó hay chưa.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bạn sẽ muốn những dẫn cứ đằng sau lời feedback ấy, liệu nó đang là trên những cảm nhận khách quan hay chủ quan, liệu nhận định đó đến từ cách đánh giá như thế nào, trên data, research, trên kinh nghiệm, lý thuyết hay trên assumption, nếu là assumption thì đã có cách nào validate nó hay chưa.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "2305d164-78d8-803d-8203-c56023999f26",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-14T02:27:00.000Z",
        "last_edited_time": "2026-07-26T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau đó mới đánh giá tác động của feedback đó, nó ảnh hưởng đến phần việc mình ra sao, đến dự án chung ra sao, mức độ tác động như thế nào (từ chi tiết đến tổng thể).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau đó mới đánh giá tác động của feedback đó, nó ảnh hưởng đến phần việc mình ra sao, đến dự án chung ra sao, mức độ tác động như thế nào (từ chi tiết đến tổng thể).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "2305d164-78d8-80a1-8e2e-dc7a30b21405",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-14T02:27:00.000Z",
        "last_edited_time": "2026-07-26T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau khi đánh giá rõ ràng nó, mình mới xem nên skip nó, nên thay đổi hay không, thay đổi đến mức độ nào để đảm bảo lợi ích 2 bên hoặc buộc phải lựa chọn 1 trong 2, trade off là gì, mọi người đã nắm rõ hết chưa.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau khi đánh giá rõ ràng nó, mình mới xem nên skip nó, nên thay đổi hay không, thay đổi đến mức độ nào để đảm bảo lợi ích 2 bên hoặc buộc phải lựa chọn 1 trong 2, trade off là gì, mọi người đã nắm rõ hết chưa.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 3
      },
      {
        "object": "block",
        "id": "22c5d164-78d8-80cd-8267-d9f4694540b9",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-10T11:31:00.000Z",
        "last_edited_time": "2025-07-10T11:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "3 keywords take aways",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3 keywords take aways",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22c5d164-78d8-80ae-863a-e8ffe40722d1",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-10T11:37:00.000Z",
        "last_edited_time": "2025-07-16T05:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Clarity - Evidence - Impact & Level of that impact",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Clarity - Evidence - Impact & Level of that impact",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2325d164-78d8-80ea-9d89-ec69c22dcf96",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-16T05:05:00.000Z",
        "last_edited_time": "2025-07-16T05:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Về các dạng feedback phổ biến hay gặp và hướng xử lý, mình sẽ mention ở phần 2 nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Về các dạng feedback phổ biến hay gặp và hướng xử lý, mình sẽ mention ở phần 2 nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22c5d164-78d8-8043-abaa-dc7010ebd857",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-10T06:48:00.000Z",
        "last_edited_time": "2025-07-10T06:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "22c5d164-78d8-80c0-81f6-ddd1f957bfde",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-10T06:48:00.000Z",
        "last_edited_time": "2025-07-10T06:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22c5d164-78d8-807f-bf87-deaaedbf3c05",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-07-10T06:48:00.000Z",
        "last_edited_time": "2025-07-14T02:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "14477ad8-7b47-470c-9af5-9bab88236d43"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Take design feedback (P2)",
              "href": "https://app.notion.com/p/14477ad87b47470c9af59bab88236d43"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80f0-ab68-c3c09f859c76",
        "parent": {
          "type": "page_id",
          "page_id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
        },
        "created_time": "2025-08-14T01:39:00.000Z",
        "last_edited_time": "2025-08-14T01:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "2455d164-78d8-80ad-8474-d1ae89d02f58"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Response",
              "href": "https://app.notion.com/p/2455d16478d880ad8474d1ae89d02f58"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "2025d164-78d8-8039-9ecf-e076ef82ba85",
    "created_time": "2025-05-29T01:26:00.000Z",
    "last_edited_time": "2025-08-28T02:37:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2025-05-29T01:26:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "1-Understanding",
          "color": "orange"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 60
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-28T02:37:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "CDA\\",
          "name": "⚓:2",
          "color": "brown"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Tính cách (P2)",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Tính cách (P2)",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/T-nh-c-ch-P2-2025d16478d880399ecfe076ef82ba85",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
      "name": "Understanding",
      "slug": "understanding",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "25d5d164-78d8-80f1-b462-e4743a8454d0",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-08-28T02:35:00.000Z",
        "last_edited_time": "2025-08-28T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756349899/uxcomic-imgs/25d5d164-78d8-80f1-b462-e4743a8454d0.png",
            "expiry_time": "2026-10-04T09:11:09.000Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/25d5d164-78d8-80f1-b462-e4743a8454d0"
      },
      {
        "object": "block",
        "id": "2025d164-78d8-8001-82ed-c25f68d664ef",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:26:00.000Z",
        "last_edited_time": "2025-08-28T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi ai đó nói “bạn này có tiềm năng” hay như các bô lão thường nói “thằng này lớn lên sẽ ok”… mình tò mò sau câu nói mơ hồ ấy, họ đánh giá những gì để có thể đưa ra nhận định đó. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi ai đó nói “bạn này có tiềm năng” hay như các bô lão thường nói “thằng này lớn lên sẽ ok”… mình tò mò sau câu nói mơ hồ ấy, họ đánh giá những gì để có thể đưa ra nhận định đó. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25d5d164-78d8-8022-876f-ced0a1afc269",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-08-28T02:35:00.000Z",
        "last_edited_time": "2025-08-28T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lí do mình rất thích thú xem cách người già nhìn nhận vấn đề, vì họ có vẻ ít đánh giá bề mặt - những cái dễ thấy trước mắt (có thể là kết quả công việc, những “tạo tác” mà người khác phô ra), cái họ quan sát là những thứ rất “con người”, là quá trình, là hành vi, thái độ, là tính cách.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lí do mình rất thích thú xem cách người già nhìn nhận vấn đề, vì họ có vẻ ít đánh giá bề mặt - những cái dễ thấy trước mắt (có thể là kết quả công việc, những “tạo tác” mà người khác phô ra), cái họ quan sát là những thứ rất “con người”, là quá trình, là hành vi, thái độ, là tính cách.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-8038-8273-f1be3d7e241b",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:30:00.000Z",
        "last_edited_time": "2025-05-29T01:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy thì tính cách nào sẽ được đánh giá cao?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy thì tính cách nào sẽ được đánh giá cao?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-80a1-b73b-e221329e51c3",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:30:00.000Z",
        "last_edited_time": "2025-05-29T01:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-80e4-aa3b-f8446d546b93",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:30:00.000Z",
        "last_edited_time": "2025-05-29T01:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Growth vs Fixed mindset",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Growth vs Fixed mindset",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-8034-8629-d882ed8e49b9",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:31:00.000Z",
        "last_edited_time": "2025-05-29T01:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chúng ta đều bị giới hạn bởi những thứ ta đang biết, nếu tưởng tượng ta là chiếc máy tính, thì input là những data ta đang biết và thuật toán là quá trình ta xử lý thông tin. Cả data & thuật toán đều có thể được nâng cấp lên một phiên bản tốt hơn nếu như ta chịu học hỏi, mày mò thêm data, tìm bug & cải thiện thuật toán.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chúng ta đều bị giới hạn bởi những thứ ta đang biết, nếu tưởng tượng ta là chiếc máy tính, thì input là những data ta đang biết và thuật toán là quá trình ta xử lý thông tin. Cả data & thuật toán đều có thể được nâng cấp lên một phiên bản tốt hơn nếu như ta chịu học hỏi, mày mò thêm data, tìm bug & cải thiện thuật toán.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-80d5-b48e-c2936526c101",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:34:00.000Z",
        "last_edited_time": "2025-05-29T01:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nên người có growth mindset sẽ chủ động cho việc đó, còn fixed mindset sẽ đóng cánh cửa đó lại và như một cổ máy luôn ở version 1, không nâng cấp gì thêm. Như câu nói “ếch ngồi đáy giếng”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nên người có growth mindset sẽ chủ động cho việc đó, còn fixed mindset sẽ đóng cánh cửa đó lại và như một cổ máy luôn ở version 1, không nâng cấp gì thêm. Như câu nói “ếch ngồi đáy giếng”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-80e1-b5d1-eafbc08d3d08",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:36:00.000Z",
        "last_edited_time": "2025-05-29T01:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> việc một con người chịu tò mò, học hỏi là tính cách sáng giá đầu tiên để được xem là “có tiềm năng”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> việc một con người chịu tò mò, học hỏi là tính cách sáng giá đầu tiên để được xem là “có tiềm năng”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-8017-b0cb-e2507f49a99d",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:37:00.000Z",
        "last_edited_time": "2025-08-28T02:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chúng ta đều sẽ có thứ mình chưa biết, quan trọng là ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chúng ta đều sẽ có thứ mình chưa biết, quan trọng là ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cách ta phản ứng với cái chưa biết như thế nào.",
                "link": {
                  "url": "/1fb5d16478d880a0b63ee8f5c8dbdc6f"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cách ta phản ứng với cái chưa biết như thế nào.",
              "href": "/1fb5d16478d880a0b63ee8f5c8dbdc6f"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-8099-8067-e32c057dc03e",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:38:00.000Z",
        "last_edited_time": "2025-05-29T01:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-807c-b55f-e2f2492728b6",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:36:00.000Z",
        "last_edited_time": "2025-05-29T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dám nghĩ, dám làm",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dám nghĩ, dám làm",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-80ed-ae9c-d982da6d5907",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:37:00.000Z",
        "last_edited_time": "2025-05-29T01:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tiếp đến là câu nói chắc hẳn ai cũng nghe qua “học & hành”. Vì chỉ khi “hành” mình mới gây ra một tác động gì đó với thế giới ngoài kia, các phản ứng/ phản hồi mới được trả về, từ đó cái gọi là kinh nghiệm, insight, thực tiễn mới được phát sinh.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tiếp đến là câu nói chắc hẳn ai cũng nghe qua “học & hành”. Vì chỉ khi “hành” mình mới gây ra một tác động gì đó với thế giới ngoài kia, các phản ứng/ phản hồi mới được trả về, từ đó cái gọi là kinh nghiệm, insight, thực tiễn mới được phát sinh.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-80e2-aedf-e59b29d008c7",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:40:00.000Z",
        "last_edited_time": "2025-05-29T02:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> Từ đó kiến thức mới được củng cố, mới thấm vào trong người & bản lĩnh mới được hình thành. Nên bạn thấy người già hay thích mấy đứa trẻ hiếu động, ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> Từ đó kiến thức mới được củng cố, mới thấm vào trong người & bản lĩnh mới được hình thành. Nên bạn thấy người già hay thích mấy đứa trẻ hiếu động, ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "gan lì",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "gan lì",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là vậy, vì tính cách này sẽ giúp bé đó có được nhiều bài học thực tế nhất.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là vậy, vì tính cách này sẽ giúp bé đó có được nhiều bài học thực tế nhất.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-808b-ba43-ebf38516fd11",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:42:00.000Z",
        "last_edited_time": "2025-05-29T01:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-802a-b053-f5c5c3a8564e",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:42:00.000Z",
        "last_edited_time": "2025-05-29T01:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Biết suy nghĩ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Biết suy nghĩ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-8046-b0c4-ec3d59991514",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:43:00.000Z",
        "last_edited_time": "2025-05-29T01:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu bạn có nghe qua khái niệm tư duy nhanh & chậm, thì “biết suy nghĩ” đại diện cho việc suy nghĩ chậm, đó là lúc ta biết ngồi phân tích, ngồi phản tư và suy nghĩ lớp lan cho một vấn đề. Còn ngược lại tư duy nhanh là các phản ứng, hành động theo bản năng & điều này thường không dưới quyền kiểm soát của ta.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu bạn có nghe qua khái niệm tư duy nhanh & chậm, thì “biết suy nghĩ” đại diện cho việc suy nghĩ chậm, đó là lúc ta biết ngồi phân tích, ngồi phản tư và suy nghĩ lớp lan cho một vấn đề. Còn ngược lại tư duy nhanh là các phản ứng, hành động theo bản năng & điều này thường không dưới quyền kiểm soát của ta.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-8061-a8ad-d7eaaf3442f2",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:45:00.000Z",
        "last_edited_time": "2025-08-28T02:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Người biết chậm lại một nhịp trước khi trả lời, trước khi hành động là người biết tính toán, biết suy xét, nó sẽ cho ra được những quyết định khôn ngoan, tối ưu hơn, và nó đòi hỏi ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Người biết chậm lại một nhịp trước khi trả lời, trước khi hành động là người biết tính toán, biết suy xét, nó sẽ cho ra được những quyết định khôn ngoan, tối ưu hơn, và nó đòi hỏi ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cái nhìn hệ thống",
                "link": {
                  "url": "/1225d16478d880db8d9be6cc64d11314"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cái nhìn hệ thống",
              "href": "/1225d16478d880db8d9be6cc64d11314"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-8004-91ef-c91a9ba830c4",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:46:00.000Z",
        "last_edited_time": "2025-08-28T02:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> Đây là tín hiệu của một người sẽ ngày càng khôn ngoan & sáng suốt, họ có suy nghĩ để ra được các quyết định tốt hơn cho cuộc đời mình.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> Đây là tín hiệu của một người sẽ ngày càng khôn ngoan & sáng suốt, họ có suy nghĩ để ra được các quyết định tốt hơn cho cuộc đời mình.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-80dd-81af-e53cd0825f77",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:48:00.000Z",
        "last_edited_time": "2025-05-29T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-8099-a19e-c7aaa83fa0fe",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:47:00.000Z",
        "last_edited_time": "2025-05-29T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dám nghĩ lớn",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dám nghĩ lớn",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-8013-b352-ebe6d8520202",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:49:00.000Z",
        "last_edited_time": "2025-08-28T02:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "OK, các nết tính cách trên kia đã cho thấy ta có khả năng học, dám làm & suy nghĩ sâu, nó là những năng lực nội tại ta cần có nhưng cũng không thể bỏ qua yếu tố hệ sinh thái xoay quanh ta, đó là “môi trường”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "OK, các nết tính cách trên kia đã cho thấy ta có khả năng học, dám làm & suy nghĩ sâu, nó là những năng lực nội tại ta cần có nhưng cũng không thể bỏ qua yếu tố hệ sinh thái xoay quanh ta, đó là “môi trường”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-8015-afa2-c1f4635cc128",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:51:00.000Z",
        "last_edited_time": "2025-08-28T02:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Môi trường tạo cho ta cơ hội được “thấy”, được “thử nghiệm” để phát triển giới hạn bản thân >> người dám nghĩ lớn sẽ cho mình cơ hội để mở rộng môi trường ấy, từ đó thúc đẩy bản thân vươn lên tầng “cái giếng” trong cuộc đời này. Và người dám nghĩ lớn, khả năng cao là cũng đã mang luôn trong mình tính chủ động, gan dạ thay vì ù lì, an toàn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Môi trường tạo cho ta cơ hội được “thấy”, được “thử nghiệm” để phát triển giới hạn bản thân >> người dám nghĩ lớn sẽ cho mình cơ hội để mở rộng môi trường ấy, từ đó thúc đẩy bản thân vươn lên tầng “cái giếng” trong cuộc đời này. Và người dám nghĩ lớn, khả năng cao là cũng đã mang luôn trong mình tính chủ động, gan dạ thay vì ù lì, an toàn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-80e9-a917-f94a8b16e7f6",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:55:00.000Z",
        "last_edited_time": "2025-05-29T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-8026-8607-c678a1b79922",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:55:00.000Z",
        "last_edited_time": "2025-05-29T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Biết gây ảnh hưởng",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Biết gây ảnh hưởng",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-802c-a4ce-d3445f0dd604",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:55:00.000Z",
        "last_edited_time": "2025-08-28T02:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chúng ta là giống loài bầy đàn, chúng ta tồn tại thì luôn cần đến những mối quan hệ xung quanh, ai đó cần kĩ năng của bạn, bạn cần lại kĩ năng của ai đó, cuộc trao đổi diễn ra… không thể tách rời.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chúng ta là giống loài bầy đàn, chúng ta tồn tại thì luôn cần đến những mối quan hệ xung quanh, ai đó cần kĩ năng của bạn, bạn cần lại kĩ năng của ai đó, cuộc trao đổi diễn ra… không thể tách rời.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-803e-9380-ecd126fbdc4e",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:56:00.000Z",
        "last_edited_time": "2025-05-29T02:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> Nên việc hiểu được sự liên hệ này khiến bạn dễ sống hơn, đó là lí do các kĩ năng như communication, influence, personal branding, leadership, cung cầu, thuyết trò chơi… luôn có chỗ đứng của nó dù trải qua bao nhiêu thập kỉ đi nữa.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> Nên việc hiểu được sự liên hệ này khiến bạn dễ sống hơn, đó là lí do các kĩ năng như communication, influence, personal branding, leadership, cung cầu, thuyết trò chơi… luôn có chỗ đứng của nó dù trải qua bao nhiêu thập kỉ đi nữa.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-80e1-b12b-dc40281cf6dd",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:59:00.000Z",
        "last_edited_time": "2025-05-29T01:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-8089-a063-dc9c35e0514b",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:59:00.000Z",
        "last_edited_time": "2025-05-29T01:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_1",
        "heading_1": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kết",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kết",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-800b-a26b-cc87fae2bef7",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T01:59:00.000Z",
        "last_edited_time": "2025-08-28T02:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Việc đánh giá ai đó “tiềm năng” hay không không chỉ nhìn vào kết quả họ tạo ra, mà còn nhìn vào năng lực nội tại, cốt cách của họ, nó cần đến cái nhìn sâu và dài hơi hơn, ta nhìn nhận nó như “giống mầm”, “đất trồng”… thay vì chỉ xét về “trái”, cái nhìn đó giúp ta thấy được “cái nhân” trong họ để phán đoán rằng họ có khả năng làm được việc ở tương lai hay không. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Việc đánh giá ai đó “tiềm năng” hay không không chỉ nhìn vào kết quả họ tạo ra, mà còn nhìn vào năng lực nội tại, cốt cách của họ, nó cần đến cái nhìn sâu và dài hơi hơn, ta nhìn nhận nó như “giống mầm”, “đất trồng”… thay vì chỉ xét về “trái”, cái nhìn đó giúp ta thấy được “cái nhân” trong họ để phán đoán rằng họ có khả năng làm được việc ở tương lai hay không. ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Người “già” không những nhìn việc mà còn nhìn người.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Người “già” không những nhìn việc mà còn nhìn người.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-8080-8937-eef35bb112cf",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T02:04:00.000Z",
        "last_edited_time": "2025-05-29T02:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Người khôn ngoan sẽ đánh giá quá trình họ đang đi liệu có đúng hướng hay không.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Người khôn ngoan sẽ đánh giá quá trình họ đang đi liệu có đúng hướng hay không.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-8076-8bc0-e1712ed9ad97",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T02:07:00.000Z",
        "last_edited_time": "2025-05-29T02:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Họ té mà họ biết đứng lên và học",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Họ té mà họ biết đứng lên và học",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-800f-8ea7-dde93e7d2b3a",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T02:07:00.000Z",
        "last_edited_time": "2025-05-29T02:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Họ có những niềm tin, bản lĩnh cốt lõi",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Họ có những niềm tin, bản lĩnh cốt lõi",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-8052-b47d-f73703ab10ee",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T02:07:00.000Z",
        "last_edited_time": "2025-05-29T02:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Họ có 1 thái độ đúng đắn",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Họ có 1 thái độ đúng đắn",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-806a-b224-d6b5ace4a2b5",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T02:07:00.000Z",
        "last_edited_time": "2025-05-29T02:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Họ có nhiệt huyết và chủ động",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Họ có nhiệt huyết và chủ động",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-80da-bec4-cd213dc0e9dc",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T02:08:00.000Z",
        "last_edited_time": "2025-05-29T02:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "vv",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "vv",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-80b3-9e70-eef14212738e",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T02:08:00.000Z",
        "last_edited_time": "2025-05-29T02:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đây mới là những thứ “sáng giá” ẩn chìm mà ta cần xem xét.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đây mới là những thứ “sáng giá” ẩn chìm mà ta cần xem xét.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-8055-a592-fab2cf4b265d",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T02:09:00.000Z",
        "last_edited_time": "2025-05-29T02:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-806c-95bc-d2aa643c6afd",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T02:09:00.000Z",
        "last_edited_time": "2025-05-29T02:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Items",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Items",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25d5d164-78d8-80e4-8322-c649f01329c3",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-08-28T02:34:00.000Z",
        "last_edited_time": "2025-08-28T02:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1575d164-78d8-8024-860e-d419e25be8bc"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tính cách (P1)",
              "href": "https://app.notion.com/p/1575d16478d88024860ed419e25be8bc"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-803e-8fab-e366dde41f91",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T02:09:00.000Z",
        "last_edited_time": "2025-05-29T02:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mindset vs Tâm thế",
              "href": "https://app.notion.com/p/a8c82bf15c5b4f4db945cbdb31c819b7"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-8062-87e0-d505f249757a",
        "parent": {
          "type": "page_id",
          "page_id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
        },
        "created_time": "2025-05-29T02:09:00.000Z",
        "last_edited_time": "2025-05-29T02:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1d75d164-78d8-80b5-aeb3-fc8dd08cf12a"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thái độ?",
              "href": "https://app.notion.com/p/1d75d16478d880b5aeb3fc8dd08cf12a"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1fa5d164-78d8-80ea-9589-e1218df460a6",
    "created_time": "2025-05-21T06:30:00.000Z",
    "last_edited_time": "2025-05-21T11:42:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2025-05-21T06:30:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "1-Understanding",
          "color": "orange"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 58
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-05-21T11:42:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "cZzk",
          "name": "⚔️:3",
          "color": "orange"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Questioning (P4)",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Questioning (P4)",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Questioning-P4-1fa5d16478d880ea9589e1218df460a6",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
      "name": "Understanding",
      "slug": "understanding",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "adc10378-6ac4-42a9-9a30-bb6805276ced",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:30:00.000Z",
        "last_edited_time": "2025-05-21T06:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081236/uxcomic-imgs/adc10378-6ac4-42a9-9a30-bb6805276ced.png",
            "expiry_time": "2026-10-04T09:11:09.444Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/adc10378-6ac4-42a9-9a30-bb6805276ced"
      },
      {
        "object": "block",
        "id": "480425ea-0e0e-4a5c-8bb8-1d7b8c101c30",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:30:00.000Z",
        "last_edited_time": "2025-05-21T11:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_1",
        "heading_1": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ở chiều ngược lại…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ở chiều ngược lại…",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "e1895e78-4139-4c5d-a683-e21901f7488e",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:30:00.000Z",
        "last_edited_time": "2025-05-21T11:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các nội dung đều đang được nói với góc nhìn mình là người đi hỏi, mình biết việc hỏi là để họ tìm kiếm hoặc làm rõ thêm thông tin, để hiểu một cái gì đó và quan trọng hơn hết là câu hỏi có khả năng định hướng, dẫn dắt tư duy. Sẽ không có gì xảy ra nếu như cách họ hỏi là cho mục đích tốt hay hiệu quả, còn không thì bạn cần phải cần nhận diện được chúng, không phải câu hỏi nào bạn cũng cần phải trả lời.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các nội dung đều đang được nói với góc nhìn mình là người đi hỏi, mình biết việc hỏi là để họ tìm kiếm hoặc làm rõ thêm thông tin, để hiểu một cái gì đó và quan trọng hơn hết là câu hỏi có khả năng định hướng, dẫn dắt tư duy. Sẽ không có gì xảy ra nếu như cách họ hỏi là cho mục đích tốt hay hiệu quả, còn không thì bạn cần phải cần nhận diện được chúng, không phải câu hỏi nào bạn cũng cần phải trả lời.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-80d7-bfd7-e4e3a4f84f8a",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T11:04:00.000Z",
        "last_edited_time": "2025-05-21T11:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nên nếu mình là người được hỏi thì việc hiểu thêm chủ đề “Questioning” này sẽ giúp ích gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nên nếu mình là người được hỏi thì việc hiểu thêm chủ đề “Questioning” này sẽ giúp ích gì?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "95495bb1-5563-4504-80ad-079cbc027419",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:30:00.000Z",
        "last_edited_time": "2025-05-21T06:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình sẽ đoán biết được ý định của đối phương thông qua câu hỏi họ đặt ra",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình sẽ đoán biết được ý định của đối phương thông qua câu hỏi họ đặt ra",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "7bb1e6cd-3c75-4125-89fd-0772224f2e6b",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:30:00.000Z",
        "last_edited_time": "2025-05-21T06:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình có thể đánh giá lại câu hỏi của họ đặt ra có hiệu quả hay không.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình có thể đánh giá lại câu hỏi của họ đặt ra có hiệu quả hay không.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "167194d7-e19c-47a8-9472-bc255d38f2d8",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:30:00.000Z",
        "last_edited_time": "2025-05-21T06:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kiểm soát & phát triển cuộc trò chuyện, tránh để đối phương dẫn dắt hoàn toàn bằng việc biết hỏi lại.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kiểm soát & phát triển cuộc trò chuyện, tránh để đối phương dẫn dắt hoàn toàn bằng việc biết hỏi lại.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8053-89e6-fa7e65dc8783",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:32:00.000Z",
        "last_edited_time": "2025-05-21T06:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-802a-b530-cfa14cd3f633",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_1",
        "heading_1": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dark Questions là gì?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dark Questions là gì?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8070-ac39-d69b8de27c87",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là những câu hỏi ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là những câu hỏi ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "có vẻ vô hại",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "có vẻ vô hại",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", nhưng ẩn bên trong là một ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", nhưng ẩn bên trong là một ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "bẫy giả định",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "bẫy giả định",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", một ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", một ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "thế giới quan méo mó",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "thế giới quan méo mó",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", hoặc một ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", hoặc một ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "tư duy đã bị định hướng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "tư duy đã bị định hướng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " sẵn. Nếu trả lời theo khuôn khổ của câu hỏi đó, bạn ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " sẵn. Nếu trả lời theo khuôn khổ của câu hỏi đó, bạn ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "mặc nhiên thừa nhận điều sai hoặc sai lệch",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "mặc nhiên thừa nhận điều sai hoặc sai lệch",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " mà người hỏi ngụ ý.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " mà người hỏi ngụ ý.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8000-a466-f6e75adc730d",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8062-866c-e5aa6d3d395d",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các dạng “Dark Questions” phổ biến",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các dạng “Dark Questions” phổ biến",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-801e-b989-c548adabc870",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T11:08:00.000Z",
        "last_edited_time": "2025-05-21T11:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "table",
        "table": {
          "table_width": 4,
          "has_column_header": false,
          "has_row_header": false
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "1fa5d164-78d8-8054-8953-e25c79ebd827",
            "parent": {
              "type": "block_id",
              "block_id": "1fa5d164-78d8-801e-b989-c548adabc870"
            },
            "created_time": "2025-05-21T11:08:00.000Z",
            "last_edited_time": "2025-05-21T11:08:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "table_row",
            "table_row": {
              "cells": [
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "Loại câu hỏi",
                      "link": null
                    },
                    "annotations": {
                      "bold": true,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "Loại câu hỏi",
                    "href": null
                  }
                ],
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "Mô tả",
                      "link": null
                    },
                    "annotations": {
                      "bold": true,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "Mô tả",
                    "href": null
                  }
                ],
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "Ví dụ",
                      "link": null
                    },
                    "annotations": {
                      "bold": true,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "Ví dụ",
                    "href": null
                  }
                ],
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "Bẫy ẩn",
                      "link": null
                    },
                    "annotations": {
                      "bold": true,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "Bẫy ẩn",
                    "href": null
                  }
                ]
              ]
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1fa5d164-78d8-8069-aec2-ea7a821a0ace",
            "parent": {
              "type": "block_id",
              "block_id": "1fa5d164-78d8-801e-b989-c548adabc870"
            },
            "created_time": "2025-05-21T11:08:00.000Z",
            "last_edited_time": "2025-05-21T11:08:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "table_row",
            "table_row": {
              "cells": [
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "Câu hỏi nhị phân ép buộc",
                      "link": null
                    },
                    "annotations": {
                      "bold": false,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "Câu hỏi nhị phân ép buộc",
                    "href": null
                  }
                ],
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "Bắt bạn chọn giữa 2 thứ không đầy đủ",
                      "link": null
                    },
                    "annotations": {
                      "bold": false,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "Bắt bạn chọn giữa 2 thứ không đầy đủ",
                    "href": null
                  }
                ],
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "“Bạn chọn trung thành hay hiệu quả?”",
                      "link": null
                    },
                    "annotations": {
                      "bold": false,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "“Bạn chọn trung thành hay hiệu quả?”",
                    "href": null
                  }
                ],
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "Giả định là không thể vừa trung thành vừa hiệu quả",
                      "link": null
                    },
                    "annotations": {
                      "bold": false,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "Giả định là không thể vừa trung thành vừa hiệu quả",
                    "href": null
                  }
                ]
              ]
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1fa5d164-78d8-800b-bfc7-d733424466b8",
            "parent": {
              "type": "block_id",
              "block_id": "1fa5d164-78d8-801e-b989-c548adabc870"
            },
            "created_time": "2025-05-21T11:08:00.000Z",
            "last_edited_time": "2025-05-21T11:08:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "table_row",
            "table_row": {
              "cells": [
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "Câu hỏi chứa định kiến",
                      "link": null
                    },
                    "annotations": {
                      "bold": false,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "Câu hỏi chứa định kiến",
                    "href": null
                  }
                ],
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "Giả định sẵn một điều tiêu cực",
                      "link": null
                    },
                    "annotations": {
                      "bold": false,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "Giả định sẵn một điều tiêu cực",
                    "href": null
                  }
                ],
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "“Sao nhóm bạn lần nào cũng làm chậm?”",
                      "link": null
                    },
                    "annotations": {
                      "bold": false,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "“Sao nhóm bạn lần nào cũng làm chậm?”",
                    "href": null
                  }
                ],
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "Ngụ ý nhóm luôn chậm, không còn chỗ để biện minh",
                      "link": null
                    },
                    "annotations": {
                      "bold": false,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "Ngụ ý nhóm luôn chậm, không còn chỗ để biện minh",
                    "href": null
                  }
                ]
              ]
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1fa5d164-78d8-80c3-9bff-ceda430d6afa",
            "parent": {
              "type": "block_id",
              "block_id": "1fa5d164-78d8-801e-b989-c548adabc870"
            },
            "created_time": "2025-05-21T11:08:00.000Z",
            "last_edited_time": "2025-05-21T11:08:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "table_row",
            "table_row": {
              "cells": [
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "Câu hỏi chụp mũ",
                      "link": null
                    },
                    "annotations": {
                      "bold": false,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "Câu hỏi chụp mũ",
                    "href": null
                  }
                ],
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "Gắn nhãn bạn theo cách xấu",
                      "link": null
                    },
                    "annotations": {
                      "bold": false,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "Gắn nhãn bạn theo cách xấu",
                    "href": null
                  }
                ],
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "“Tại sao bạn luôn phản ứng tiêu cực với góp ý?”",
                      "link": null
                    },
                    "annotations": {
                      "bold": false,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "“Tại sao bạn luôn phản ứng tiêu cực với góp ý?”",
                    "href": null
                  }
                ],
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "Ngụ ý bạn luôn tiêu cực, dù có thể không phải vậy",
                      "link": null
                    },
                    "annotations": {
                      "bold": false,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "Ngụ ý bạn luôn tiêu cực, dù có thể không phải vậy",
                    "href": null
                  }
                ]
              ]
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1fa5d164-78d8-803d-9f96-f56533e9037b",
            "parent": {
              "type": "block_id",
              "block_id": "1fa5d164-78d8-801e-b989-c548adabc870"
            },
            "created_time": "2025-05-21T11:08:00.000Z",
            "last_edited_time": "2025-05-21T11:08:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "table_row",
            "table_row": {
              "cells": [
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "Câu hỏi lật vai",
                      "link": null
                    },
                    "annotations": {
                      "bold": false,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "Câu hỏi lật vai",
                    "href": null
                  }
                ],
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "Biến bạn thành người có lỗi dù không sai",
                      "link": null
                    },
                    "annotations": {
                      "bold": false,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "Biến bạn thành người có lỗi dù không sai",
                    "href": null
                  }
                ],
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "“Bạn nghĩ mình đủ tư cách nói ra điều đó không?”",
                      "link": null
                    },
                    "annotations": {
                      "bold": false,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "“Bạn nghĩ mình đủ tư cách nói ra điều đó không?”",
                    "href": null
                  }
                ],
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "Chuyển trọng tâm từ vấn đề sang cá nhân",
                      "link": null
                    },
                    "annotations": {
                      "bold": false,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "Chuyển trọng tâm từ vấn đề sang cá nhân",
                    "href": null
                  }
                ]
              ]
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1fa5d164-78d8-80df-8201-df3fd039307b",
            "parent": {
              "type": "block_id",
              "block_id": "1fa5d164-78d8-801e-b989-c548adabc870"
            },
            "created_time": "2025-05-21T11:08:00.000Z",
            "last_edited_time": "2025-05-21T11:08:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "table_row",
            "table_row": {
              "cells": [
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "Câu hỏi thao túng cảm xúc",
                      "link": null
                    },
                    "annotations": {
                      "bold": false,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "Câu hỏi thao túng cảm xúc",
                    "href": null
                  }
                ],
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "Kích hoạt mặc cảm, sợ hãi, hoặc tội lỗi",
                      "link": null
                    },
                    "annotations": {
                      "bold": false,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "Kích hoạt mặc cảm, sợ hãi, hoặc tội lỗi",
                    "href": null
                  }
                ],
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "“Làm vậy bạn không thấy có lỗi với team à?”",
                      "link": null
                    },
                    "annotations": {
                      "bold": false,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "“Làm vậy bạn không thấy có lỗi với team à?”",
                    "href": null
                  }
                ],
                [
                  {
                    "type": "text",
                    "text": {
                      "content": "Buộc bạn hành động vì cảm xúc, không dựa lý trí",
                      "link": null
                    },
                    "annotations": {
                      "bold": false,
                      "italic": false,
                      "strikethrough": false,
                      "underline": false,
                      "code": false,
                      "color": "default"
                    },
                    "plain_text": "Buộc bạn hành động vì cảm xúc, không dựa lý trí",
                    "href": null
                  }
                ]
              ]
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8064-9171-c09866a9253a",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8038-934d-e24b708a8ba7",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách Nhận Diện Dark Questions",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách Nhận Diện Dark Questions",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8094-86d8-e4e32edbd145",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T11:39:00.000Z",
        "last_edited_time": "2025-05-21T11:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cảnh giác với áp lực thời gian: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cảnh giác với áp lực thời gian: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Những người hay hỏi gấp gáp, yêu cầu trả lời ngay, thường là đang muốn ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Những người hay hỏi gấp gáp, yêu cầu trả lời ngay, thường là đang muốn ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "lấy phản xạ thay vì lập luận. ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "lấy phản xạ thay vì lập luận. ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Họ không cho bạn thời gian để nghĩ – vì khi bạn không nghĩ, họ kiểm soát bạn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Họ không cho bạn thời gian để nghĩ – vì khi bạn không nghĩ, họ kiểm soát bạn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8024-9b2e-f58f14d35646",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cảm giác bị “kẹt” khi nghe xong → Không biết trả lời thế nào cho đúng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cảm giác bị “kẹt” khi nghe xong → Không biết trả lời thế nào cho đúng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-80e2-8c00-eaaebee87275",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Câu hỏi khiến bạn phải phòng thủ, thay vì suy nghĩ mở.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Câu hỏi khiến bạn phải phòng thủ, thay vì suy nghĩ mở.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-80e7-aafa-d74263e319fd",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Câu hỏi đưa ra giả định như thể đó là sự thật hiển nhiên.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Câu hỏi đưa ra giả định như thể đó là sự thật hiển nhiên.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8099-98ca-e12bd189a49e",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Câu hỏi khiến bạn cảm thấy sai… dù bạn chưa sai.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Câu hỏi khiến bạn cảm thấy sai… dù bạn chưa sai.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8078-aead-f93f9c920c58",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giới hạn lựa chọn của bạn vào khuôn mà họ đặt ra.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giới hạn lựa chọn của bạn vào khuôn mà họ đặt ra.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8015-95f1-f22c66face65",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-80d2-a3be-c606f063dc5a",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phản đòn: Các kỹ thuật phòng thủ và lật ngược thế cờ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phản đòn: Các kỹ thuật phòng thủ và lật ngược thế cờ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-802f-baf0-f194c5df9a5a",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "1. Gỡ Giả Định (Expose the Frame)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "1. Gỡ Giả Định (Expose the Frame)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-80a6-9787-d67aa8578b1b",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chiêu",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chiêu",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": “Câu hỏi của bạn đang giả định rằng… Tôi không chắc điều đó đúng.”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": “Câu hỏi của bạn đang giả định rằng… Tôi không chắc điều đó đúng.”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-80e3-83bb-c4442ea54279",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-803f-b34d-d0610f51af6c",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Họ: “Sao bạn luôn phản đối ý tưởng của team vậy?”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Họ: “Sao bạn luôn phản đối ý tưởng của team vậy?”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8040-ba83-f54e4d8f5226",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bạn: “Bạn đang giả định là tôi luôn phản đối. Tôi có thể chia sẻ logic đằng sau góc nhìn của mình không?”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bạn: “Bạn đang giả định là tôi luôn phản đối. Tôi có thể chia sẻ logic đằng sau góc nhìn của mình không?”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-803a-a42a-f849d960fbc8",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-80ce-84df-f72ebc1349f7",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "2. Mở Khung Lựa Chọn (Reframe the Choices)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2. Mở Khung Lựa Chọn (Reframe the Choices)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-80f9-be73-f21ca42724d2",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chiêu",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chiêu",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": “Tôi không nghĩ đó là hai lựa chọn duy nhất.”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": “Tôi không nghĩ đó là hai lựa chọn duy nhất.”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-80bd-9ce2-e99d038002d5",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8098-b1a7-f8bfcdd23359",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Họ: “Bạn chọn trung thành hay hiệu quả?”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Họ: “Bạn chọn trung thành hay hiệu quả?”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-80ad-8d39-f5ee21936336",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bạn: “Tôi nghĩ mình có thể trung thành với tổ chức bằng cách làm việc hiệu quả. Hai điều đó không loại trừ nhau.”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bạn: “Tôi nghĩ mình có thể trung thành với tổ chức bằng cách làm việc hiệu quả. Hai điều đó không loại trừ nhau.”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-80aa-b72d-fbe165354d8d",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-80aa-aeb7-c894e2e0483c",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "3. Đưa Câu Hỏi Ngược (Counter-question)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3. Đưa Câu Hỏi Ngược (Counter-question)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8050-bf03-e696c00bc27d",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chiêu",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chiêu",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": “Bạn hỏi vậy là vì điều gì?”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": “Bạn hỏi vậy là vì điều gì?”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-800a-b2e8-e27365b2c5bd",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-800a-949b-c8c1da016136",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Họ: “Bạn nghĩ bạn đủ kinh nghiệm để đảm nhận dự án này không?”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Họ: “Bạn nghĩ bạn đủ kinh nghiệm để đảm nhận dự án này không?”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-80dd-90db-fbd3ecf23310",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bạn: “Bạn đang quan ngại điều gì cụ thể nhất trong dự án?”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bạn: “Bạn đang quan ngại điều gì cụ thể nhất trong dự án?”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-808b-a9e6-e89d04988b56",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8025-ba0b-d863e7c31aa8",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "4. Xác định Lệch Tâm (Bring back to the point)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "4. Xác định Lệch Tâm (Bring back to the point)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-80dc-b00e-cd743e509f11",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chiêu",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chiêu",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": “Tôi thấy trọng tâm không nằm ở điều bạn hỏi.”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": “Tôi thấy trọng tâm không nằm ở điều bạn hỏi.”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-809f-8349-ecb7b6a05f47",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-80e9-b612-d79cc9428630",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Họ: “Bạn làm vậy không thấy có lỗi à?”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Họ: “Bạn làm vậy không thấy có lỗi à?”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8006-9807-d5e5054ba558",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bạn: “Tôi tin rằng quyết định này cần được đánh giá bằng tác động và lý do, không chỉ bằng cảm xúc.”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bạn: “Tôi tin rằng quyết định này cần được đánh giá bằng tác động và lý do, không chỉ bằng cảm xúc.”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8084-be2d-f11dd5550679",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8096-8b18-c654173382ae",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "5. Chặn Đứng Chụp Mũ (Label and Disarm)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "5. Chặn Đứng Chụp Mũ (Label and Disarm)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-802f-a1d1-ed39a1c76a12",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chiêu",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chiêu",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": “Tôi thấy câu hỏi này hơi quy chụp. Có thể chúng ta đang nhìn khác góc độ.”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": “Tôi thấy câu hỏi này hơi quy chụp. Có thể chúng ta đang nhìn khác góc độ.”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-80a7-8f46-db71ef88dfb1",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8013-b4bf-f2197b9e80e9",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Họ: “Bạn không quan tâm đến tiến độ của team à?”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Họ: “Bạn không quan tâm đến tiến độ của team à?”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-80a6-99a2-d53604d92d6c",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bạn: “Tôi nghĩ mình đang góp phần bằng cách nhìn vào những thứ cần cải thiện, không phải vì tôi không quan tâm.”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bạn: “Tôi nghĩ mình đang góp phần bằng cách nhìn vào những thứ cần cải thiện, không phải vì tôi không quan tâm.”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-800b-a046-f4919d178873",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-80d4-aa26-f78f0637f1ee",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Rèn luyện khả năng phát hiện và phản đòn",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Rèn luyện khả năng phát hiện và phản đòn",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-80ba-89db-db7dc348e48c",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tự hỏi lại: “Họ là ai? Tại sao họ lại hỏi mình? Câu này có giả định gì ngầm không?”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tự hỏi lại: “Họ là ai? Tại sao họ lại hỏi mình? Câu này có giả định gì ngầm không?”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-809f-b934-d56bcf8beffe",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phân tích cảm xúc của mình khi nghe – nếu thấy “mắc kẹt”, có thể là bẫy.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phân tích cảm xúc của mình khi nghe – nếu thấy “mắc kẹt”, có thể là bẫy.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8042-9ec4-c45f60427e4f",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Học cách dừng lại 2–3 giây trước khi trả lời.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Học cách dừng lại 2–3 giây trước khi trả lời.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8029-a6ec-cecc5a69e650",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Viết lại những câu hỏi bạn từng bị “đánh úp” và luyện phản đòn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Viết lại những câu hỏi bạn từng bị “đánh úp” và luyện phản đòn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-805c-a81d-d577019344c6",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Xem các buổi tranh luận logic hoặc đọc sách về lập luận/phản biện.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Xem các buổi tranh luận logic hoặc đọc sách về lập luận/phản biện.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-808d-bc1b-e92bd992c845",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-80c7-9199-fae42aa54508",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kết",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kết",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-805e-89d7-c7983b16dd6c",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:36:00.000Z",
        "last_edited_time": "2025-05-21T11:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Người khôn không những là người biết hỏi, mà còn là người nhận ra những câu hỏi khiến bạn mất đi tư duy.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Người khôn không những là người biết hỏi, mà còn là người nhận ra những câu hỏi khiến bạn mất đi tư duy.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "c887b5fd-406a-4d0e-ad9e-1e2124fc75c0",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:30:00.000Z",
        "last_edited_time": "2025-05-21T06:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "6379a18f-06df-4eaa-bbd1-873041d31c0e",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:30:00.000Z",
        "last_edited_time": "2025-05-21T06:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "151abe66-4b4c-4935-9908-d4ce1aa56927",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:30:00.000Z",
        "last_edited_time": "2025-05-21T06:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "95727332-bdb3-4f63-a0cd-f9023732995d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Questioning (P1)",
              "href": "https://app.notion.com/p/95727332bdb34f63a0cdf9023732995d"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "96bec2e2-ace9-4a83-8d81-61daf734c92e",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:30:00.000Z",
        "last_edited_time": "2025-05-21T06:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Questioning (P2)",
              "href": "https://app.notion.com/p/1435d16478d88004930ce9f3fede9fe4"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8014-b1b6-eb20dcbdc258",
        "parent": {
          "type": "page_id",
          "page_id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
        },
        "created_time": "2025-05-21T06:30:00.000Z",
        "last_edited_time": "2025-05-21T06:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1425d164-78d8-80f2-9f44-e27115c54d8b"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Questioning (P3)",
              "href": "https://app.notion.com/p/1425d16478d880f29f44e27115c54d8b"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1f15d164-78d8-807b-a23b-c00515a22f7c",
    "created_time": "2025-05-12T16:21:00.000Z",
    "last_edited_time": "2025-08-08T07:53:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2025-05-12T16:21:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "3-Workflow",
          "color": "default"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 54
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-08T07:53:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "QMEI",
          "name": "♟️:3",
          "color": "green"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Decision making (P2)",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Decision making (P2)",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Decision-making-P2-1f15d16478d8807ba23bc00515a22f7c",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
      "name": "Workflow",
      "slug": "workflow",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "31422d65-9725-4cd3-8c60-5d092e27d709",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-12T16:21:00.000Z",
        "last_edited_time": "2025-05-12T16:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081239/uxcomic-imgs/31422d65-9725-4cd3-8c60-5d092e27d709.png",
            "expiry_time": "2026-10-04T09:11:10.409Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/31422d65-9725-4cd3-8c60-5d092e27d709"
      },
      {
        "object": "block",
        "id": "e75a48e1-1e69-4476-a41a-10f590c4bce1",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-12T16:21:00.000Z",
        "last_edited_time": "2025-08-08T07:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ta không phải thánh, quyết định đâu là trúng đó, tuy nhiên quyết định đúng vẫn luôn là mong đợi của hầu hết chúng ta, vì rõ là bạn muốn kết quả ấy thì mới triển khai, đúng không nào. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ta không phải thánh, quyết định đâu là trúng đó, tuy nhiên quyết định đúng vẫn luôn là mong đợi của hầu hết chúng ta, vì rõ là bạn muốn kết quả ấy thì mới triển khai, đúng không nào. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2495d164-78d8-8027-8a08-e03d8c520e89",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-08-08T07:40:00.000Z",
        "last_edited_time": "2025-08-08T07:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhưng có khi nhiều tình huống trong cuộc sống rơi vào trường hợp KHÔNG ĐỦ/ THIẾU thông tin hoặc rất nhiều khi mình sẽ tưởng rằng đã ĐỦ / đã KHÔN NGOAN, vậy thì làm thế nào đây???",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhưng có khi nhiều tình huống trong cuộc sống rơi vào trường hợp KHÔNG ĐỦ/ THIẾU thông tin hoặc rất nhiều khi mình sẽ tưởng rằng đã ĐỦ / đã KHÔN NGOAN, vậy thì làm thế nào đây???",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f15d164-78d8-80a7-92af-f5c61b30ce1b",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-12T16:25:00.000Z",
        "last_edited_time": "2025-05-12T16:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1f15d164-78d8-80cc-9afc-cce3a9bff6a1",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-12T16:25:00.000Z",
        "last_edited_time": "2025-08-08T07:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Điều đầu tiên: cố mà gom thêm data",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Điều đầu tiên: cố mà gom thêm data",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f15d164-78d8-80d8-995a-fa7689b8e3d4",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-12T16:27:00.000Z",
        "last_edited_time": "2025-08-08T07:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: garbage in, garbage out.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: garbage in, garbage out.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f15d164-78d8-807b-9194-dcbf089b2207",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-12T16:28:00.000Z",
        "last_edited_time": "2025-08-08T07:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Câu hỏi quan trọng ở đây là mình cần thông tin GÌ & từ NGUỒN nào.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Câu hỏi quan trọng ở đây là mình cần thông tin GÌ & từ NGUỒN nào.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f15d164-78d8-8076-a6d7-ff7da1c868f6",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-12T16:31:00.000Z",
        "last_edited_time": "2025-05-12T16:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "GÓC NHÌN của là một dạng thông tin mình cần thu thập.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "GÓC NHÌN của là một dạng thông tin mình cần thu thập.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f15d164-78d8-80f9-a781-c98e006c6ce0",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-12T16:31:00.000Z",
        "last_edited_time": "2025-08-08T07:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": " Điều thứ 2: giảm thiểu rủi ro",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Điều thứ 2: giảm thiểu rủi ro",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f15d164-78d8-80ba-98c6-ec848dd287e2",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-12T16:33:00.000Z",
        "last_edited_time": "2025-05-12T16:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Từ phía bản thân: nhận diện rõ xem mình có đang mắc phải thiên kiến nhận định nào không, hãy rà lại cách nghĩ của chúng ta, tự đánh giá xem nó có LOGIC không ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Từ phía bản thân: nhận diện rõ xem mình có đang mắc phải thiên kiến nhận định nào không, hãy rà lại cách nghĩ của chúng ta, tự đánh giá xem nó có LOGIC không ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f15d164-78d8-8037-9835-dfd80977fe78",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-12T16:34:00.000Z",
        "last_edited_time": "2025-05-13T06:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hình dung nếu ta SAI thì sao (pre-mortem, tư duy ngược ), có cho mình plan B, C…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hình dung nếu ta SAI thì sao (pre-mortem, tư duy ngược ), có cho mình plan B, C…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f15d164-78d8-8005-8e84-cbe527c251ca",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-12T16:39:00.000Z",
        "last_edited_time": "2025-05-12T16:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu bạn đã có cho mình “nước đi” đó, hãy cố xem cho “vết xe đỗ” nào trước đó mà bạn có thể học từ họ không ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu bạn đã có cho mình “nước đi” đó, hãy cố xem cho “vết xe đỗ” nào trước đó mà bạn có thể học từ họ không ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f15d164-78d8-801b-ad5c-edde993c216f",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-12T16:32:00.000Z",
        "last_edited_time": "2025-08-08T07:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Điều thứ 3: phép “thử”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Điều thứ 3: phép “thử”",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f15d164-78d8-8030-9a0d-f60982ddb4aa",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-12T16:37:00.000Z",
        "last_edited_time": "2025-05-13T01:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Thử” nhỏ & đo lường, mình sẽ không muốn chơi tất tay, cược hết vào một nơi chốn mơ hồ, vd: mặc dù phỏng vấn nhân sự kĩ cỡ nào thì cũng phải có probation để kiểm chứng trước khi đồng ý chi một khoản cho nhân sự đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Thử” nhỏ & đo lường, mình sẽ không muốn chơi tất tay, cược hết vào một nơi chốn mơ hồ, vd: mặc dù phỏng vấn nhân sự kĩ cỡ nào thì cũng phải có probation để kiểm chứng trước khi đồng ý chi một khoản cho nhân sự đó.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f15d164-78d8-806c-a2c6-c75bfbb1125f",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-12T16:43:00.000Z",
        "last_edited_time": "2025-05-12T16:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phép thử này, hãy tự sáng tạo ra nhé, nguyên lý là làm sao để tối ưu effort nhưng outcome ta muốn vẫn ở mức chấp nhận được (proof of concept)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phép thử này, hãy tự sáng tạo ra nhé, nguyên lý là làm sao để tối ưu effort nhưng outcome ta muốn vẫn ở mức chấp nhận được (proof of concept)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-80a3-9a49-c6fe14839aa9",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-13T01:36:00.000Z",
        "last_edited_time": "2025-05-13T01:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-802c-a272-f2be50f995c4",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-13T01:36:00.000Z",
        "last_edited_time": "2025-08-08T07:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi đã có option",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi đã có option",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-8072-8735-c4ee46218cc7",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-13T01:37:00.000Z",
        "last_edited_time": "2025-08-08T07:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081241/uxcomic-imgs/1f25d164-78d8-8072-8735-c4ee46218cc7.png",
            "expiry_time": "2026-10-04T09:11:10.410Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1f25d164-78d8-8072-8735-c4ee46218cc7"
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-80d2-9ae0-f5f4e8e6ad26",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-13T01:37:00.000Z",
        "last_edited_time": "2025-05-13T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "3 công cụ giúp đánh giá các sự lựa chọn",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3 công cụ giúp đánh giá các sự lựa chọn",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-80d2-87e9-ddc587108d6f",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-13T01:37:00.000Z",
        "last_edited_time": "2025-05-13T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi nhắc đến quyết định có nghĩa là ta phải lựa chọn, vậy giữa các lựa chọn ấy, làm sao để ta đánh giá chúng một cách hiệu quả mà không rơi vào kiểu cảm tính.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi nhắc đến quyết định có nghĩa là ta phải lựa chọn, vậy giữa các lựa chọn ấy, làm sao để ta đánh giá chúng một cách hiệu quả mà không rơi vào kiểu cảm tính.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-80e1-9fde-da8b3305b2be",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-13T01:37:00.000Z",
        "last_edited_time": "2025-05-13T01:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "1. Tiêu chuẩn (benchmark)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "1. Tiêu chuẩn (benchmark)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-80bd-9616-cbb2d4347ed7",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-13T01:37:00.000Z",
        "last_edited_time": "2025-05-13T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là mức đòi hỏi tối thiểu nhất cho các lựa chọn, nếu các lựa chọn không đạt được yếu tố này xem như loại khỏi vòng gửi xe. Ví dụ: scan CV của ứng viên, mình đang đặt điều kiện đầu vào  >2 năm kinh nghiệm, nếu dưới thì ứng viên bị loại. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là mức đòi hỏi tối thiểu nhất cho các lựa chọn, nếu các lựa chọn không đạt được yếu tố này xem như loại khỏi vòng gửi xe. Ví dụ: scan CV của ứng viên, mình đang đặt điều kiện đầu vào  >2 năm kinh nghiệm, nếu dưới thì ứng viên bị loại. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-80fe-9807-e46cb5d2d3c8",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-13T01:37:00.000Z",
        "last_edited_time": "2025-05-13T01:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "2. Bộ tiêu chí (criteria)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2. Bộ tiêu chí (criteria)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-801c-a3c5-e313d864ff08",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-13T01:37:00.000Z",
        "last_edited_time": "2025-05-13T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình quyết định được là vì mình thấy lựa chọn này tốt hơn lựa chọn kia dựa trên một hay nhiều khía cạnh nào đó. Sự so sánh này tồn tại được do ta đặt các lựa chọn trên một hệ tiêu chí nhất định (các tiêu chí này càng khách quan, càng cụ thể thì càng tốt). Lưu ý: các option nên được đặt trên một điều kiện so sánh cơ bản nhất định (mình cũng không biết nên gọi nó là gì, tạm gọi là base).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình quyết định được là vì mình thấy lựa chọn này tốt hơn lựa chọn kia dựa trên một hay nhiều khía cạnh nào đó. Sự so sánh này tồn tại được do ta đặt các lựa chọn trên một hệ tiêu chí nhất định (các tiêu chí này càng khách quan, càng cụ thể thì càng tốt). Lưu ý: các option nên được đặt trên một điều kiện so sánh cơ bản nhất định (mình cũng không biết nên gọi nó là gì, tạm gọi là base).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-804b-9eaf-ed95ac9ca102",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-13T01:37:00.000Z",
        "last_edited_time": "2025-05-13T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lấy ví dụ: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lấy ví dụ: ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-804b-82e9-e4d0de17e58a",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-13T01:37:00.000Z",
        "last_edited_time": "2025-05-13T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "So sánh giữa bạn A và B ai cao hơn, thì cả 2 đều cần đứng trên cùng một mặt phẳng (base) và xem đầu ai cao hơn (tiêu chí). ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "So sánh giữa bạn A và B ai cao hơn, thì cả 2 đều cần đứng trên cùng một mặt phẳng (base) và xem đầu ai cao hơn (tiêu chí). ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-8018-8adb-fc1a1a65d7d7",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-13T01:37:00.000Z",
        "last_edited_time": "2025-05-13T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chấm điểm thi môn toán, mọi người đều có 45 phút để làm, đều có chừng đó câu hỏi (base) và tiêu chí được điểm đơn giản là giải đúng đáp án. (tất nhiên nhiều khi không thể hoàn toàn công bằng, vì có thể có bạn được học thêm, có bạn thì có ít thời gian hơn vì phải phụ giúp gia đình,…ta chỉ có thể set up vài base nhất định)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chấm điểm thi môn toán, mọi người đều có 45 phút để làm, đều có chừng đó câu hỏi (base) và tiêu chí được điểm đơn giản là giải đúng đáp án. (tất nhiên nhiều khi không thể hoàn toàn công bằng, vì có thể có bạn được học thêm, có bạn thì có ít thời gian hơn vì phải phụ giúp gia đình,…ta chỉ có thể set up vài base nhất định)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-80ee-9e61-f6b9857f6b26",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-13T01:37:00.000Z",
        "last_edited_time": "2025-05-13T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các framework phức tạp hơn như RICE, Opportunity score, Weight score model…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các framework phức tạp hơn như RICE, Opportunity score, Weight score model…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f45d164-78d8-80b9-9ee0-f5b21fcc4cf4",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-15T16:17:00.000Z",
        "last_edited_time": "2025-05-15T16:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: còn một khái niệm mang tên ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: còn một khái niệm mang tên ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "kill criteria",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "kill criteria",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " -  một tập hợp tiêu chí xác định trước nhằm quyết định khi nào nên dừng một dự án, sáng kiến hoặc giải pháp, thay vì tiếp tục đầu tư thêm thời gian, tiền bạc, và nguồn lực vào một thứ không còn khả năng tạo ra giá trị (một phần của go/no-go check ở các điểm review).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " -  một tập hợp tiêu chí xác định trước nhằm quyết định khi nào nên dừng một dự án, sáng kiến hoặc giải pháp, thay vì tiếp tục đầu tư thêm thời gian, tiền bạc, và nguồn lực vào một thứ không còn khả năng tạo ra giá trị (một phần của go/no-go check ở các điểm review).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-803a-a578-db00af6d53af",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-13T01:37:00.000Z",
        "last_edited_time": "2025-05-13T01:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "3. Sự đánh đổi (trade-off)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3. Sự đánh đổi (trade-off)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-8065-b4a6-c7edf6ec8630",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-13T01:37:00.000Z",
        "last_edited_time": "2025-08-08T07:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi không thể tối ưu hóa tất cả tiêu chí cùng lúc, lúc này trade-off xuất hiện. Thông thường thực tế không có lựa chọn nào là hoàn hảo cả, buộc mình phải dựa trên mục tiêu, trên bối cảnh hiện tại để đánh giá độ ưu tiên các tiêu chí, để xem đâu là sự đánh đổi ta chấp nhận được ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi không thể tối ưu hóa tất cả tiêu chí cùng lúc, lúc này trade-off xuất hiện. Thông thường thực tế không có lựa chọn nào là hoàn hảo cả, buộc mình phải dựa trên mục tiêu, trên bối cảnh hiện tại để đánh giá độ ưu tiên các tiêu chí, để xem đâu là sự đánh đổi ta chấp nhận được ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "(cái “giá” phải trả)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "(cái “giá” phải trả)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ". Câu hỏi mình hay đặt ra: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". Câu hỏi mình hay đặt ra: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "luyện điều tệ nhất có thể xảy ra là gì? Vậy nó đáng để thử không? Opportunity cost có thể là gì? ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "luyện điều tệ nhất có thể xảy ra là gì? Vậy nó đáng để thử không? Opportunity cost có thể là gì? ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2495d164-78d8-8095-ad1b-f1ba60edf79e",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-08-08T07:42:00.000Z",
        "last_edited_time": "2025-08-08T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ cho trade-off: mình không thể có cái gì - [ngon, bổ, rẻ]; [nhanh, rẻ, chất lượng]…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ cho trade-off: mình không thể có cái gì - [ngon, bổ, rẻ]; [nhanh, rẻ, chất lượng]…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-805f-8f12-ca08b26b5669",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-13T01:37:00.000Z",
        "last_edited_time": "2025-05-13T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081242/uxcomic-imgs/1f25d164-78d8-805f-8f12-ca08b26b5669.png",
            "expiry_time": "2026-10-04T09:11:10.668Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1f25d164-78d8-805f-8f12-ca08b26b5669"
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-804a-892b-f16f3fd826f3",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-13T01:37:00.000Z",
        "last_edited_time": "2025-05-13T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-80ae-a39f-e4c17f1d7ef5",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-13T01:55:00.000Z",
        "last_edited_time": "2025-05-13T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Items",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Items",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-8004-a235-d7ecb7a2c237",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-13T01:55:00.000Z",
        "last_edited_time": "2025-05-13T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Decision making (P1)",
              "href": "https://app.notion.com/p/b2deb93698dc4fafaadc9cfcb4a6c302"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-8031-a027-d044130daf88",
        "parent": {
          "type": "page_id",
          "page_id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
        },
        "created_time": "2025-05-13T01:55:00.000Z",
        "last_edited_time": "2025-08-08T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1595d164-78d8-80b4-a0bc-c10c9eb29a87"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Judging",
              "href": "https://app.notion.com/p/1595d16478d880b4a0bcc10c9eb29a87"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7",
    "created_time": "2024-12-23T08:06:00.000Z",
    "last_edited_time": "2025-06-15T05:13:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-12-23T08:06:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "1-Understanding",
          "color": "orange"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 32
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-06-15T05:13:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "bx`f",
          "name": "⚓:3",
          "color": "purple"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Mindset vs Tâm thế",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Mindset vs Tâm thế",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Mindset-vs-T-m-th-a8c82bf15c5b4f4db945cbdb31c819b7",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
      "name": "Understanding",
      "slug": "understanding",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "304b7111-2f90-45b6-b200-1ce4502e62bd",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T08:06:00.000Z",
        "last_edited_time": "2024-12-23T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081247/uxcomic-imgs/304b7111-2f90-45b6-b200-1ce4502e62bd.png",
            "expiry_time": "2026-10-04T09:11:11.785Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/304b7111-2f90-45b6-b200-1ce4502e62bd"
      },
      {
        "object": "block",
        "id": "48940ab1-c955-4db3-84a7-3ba832c6608c",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T08:06:00.000Z",
        "last_edited_time": "2024-12-26T01:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chắc hẳn đâu đó bạn đã nghe qua “bạn này có mindset tốt”, “thái độ quan trọng hơn trình độ”, mình thì có nghe qua chữ “tâm thế” nữa nhưng ít người nói hơn, vậy chúng nó là gì & liệu có tác động gì vào cuộc sống?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chắc hẳn đâu đó bạn đã nghe qua “bạn này có mindset tốt”, “thái độ quan trọng hơn trình độ”, mình thì có nghe qua chữ “tâm thế” nữa nhưng ít người nói hơn, vậy chúng nó là gì & liệu có tác động gì vào cuộc sống?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8006-ad2a-c3ead14e67b9",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T08:10:00.000Z",
        "last_edited_time": "2024-12-23T08:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "a848846d-9152-4119-930b-6df906ea118a",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T08:06:00.000Z",
        "last_edited_time": "2024-12-23T08:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Định nghĩa",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Định nghĩa",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80bd-b9fe-e9a5743e30bd",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T08:10:00.000Z",
        "last_edited_time": "2024-12-26T10:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước mắt một điểm chung về mindset, tâm thế đó là tất cả những thứ này nằm trong đầu chúng ta, thuộc về nội tại & không dễ quan sát (ngay cả với chính chúng ta chứ chưa kể đến người khác), chúng một cách vô tình hay cố ý chúng ảnh hưởng đến hành vi & thái độ của ta. Mà hành vi, thái độ là cách bạn tương tác với cuộc sống, thông qua tương tác này, ta sẽ nhận được phản hồi gì đó từ phía cuộc sống.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước mắt một điểm chung về mindset, tâm thế đó là tất cả những thứ này nằm trong đầu chúng ta, thuộc về nội tại & không dễ quan sát (ngay cả với chính chúng ta chứ chưa kể đến người khác), chúng một cách vô tình hay cố ý chúng ảnh hưởng đến hành vi & thái độ của ta. Mà hành vi, thái độ là cách bạn tương tác với cuộc sống, thông qua tương tác này, ta sẽ nhận được phản hồi gì đó từ phía cuộc sống.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-806b-9d1a-e59463dbaef1",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-26T01:39:00.000Z",
        "last_edited_time": "2024-12-26T01:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thử lấy vài ví dụ nhé:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thử lấy vài ví dụ nhé:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-8082-adb4-eaa0966d37e1",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-26T01:40:00.000Z",
        "last_edited_time": "2024-12-26T10:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi gặp cùng 1 tình huống về thất bại , ta có thể “Tập trung vào sự phát triển, xem nó là cơ hội để học” (Growth mindset) hoặc “Tin vào sự cố định của năng lực, xem nó là bằng chứng cho giới hạn bản thân” (Fixed mindset). 2 niềm tin như 2 direction riêng biệt lèo lái mọi hành vi & thái độ của ta, người có growth mindset sẽ vui mừng vì học thêm được gì đó, người có fixed mindset sẽ buồn & tự trách bản thân.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi gặp cùng 1 tình huống về thất bại , ta có thể “Tập trung vào sự phát triển, xem nó là cơ hội để học” (Growth mindset) hoặc “Tin vào sự cố định của năng lực, xem nó là bằng chứng cho giới hạn bản thân” (Fixed mindset). 2 niềm tin như 2 direction riêng biệt lèo lái mọi hành vi & thái độ của ta, người có growth mindset sẽ vui mừng vì học thêm được gì đó, người có fixed mindset sẽ buồn & tự trách bản thân.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-8081-8dca-e397bfa7efdc",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-26T01:51:00.000Z",
        "last_edited_time": "2024-12-26T10:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tâm thế thì có chút khác biệt, nó mang tính nhất thời hơn thay vì mindset là một quá trình tập luyện, và niềm tin được củng cố qua năm tháng. Tâm thế là trạng thái chuẩn bị tinh thần khi đối mặt với một tình huống cụ thể, nếu không aware tốt nó sẽ bị cảm xúc & bản năng chi phối. Ví dụ: khi bạn chuẩn bị có một buổi họp để đề xuất idea, nếu tâm thế bạn là chỉ tin idea mình là đúng đắn & chỉ muốn thuyết phục mọi người thì trong buổi họp, khi bạn được tiếp nhận các feedback, xu hướng bạn sẽ phớt lờ & push back cái feedback đó để bảo vệ idea của mình là chính, còn nếu tâm thế của bạn là muốn collect thêm những góc nhìn khác & kiểm chứng xem idea của mình có hợp lý, có sai sót gì không thì xu hướng lại là lắng nghe & cố gắng tìm cách khơi mở, đào sâu góc nhìn của mọi người. 2 hành vi & thái độ này rất khác biệt.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tâm thế thì có chút khác biệt, nó mang tính nhất thời hơn thay vì mindset là một quá trình tập luyện, và niềm tin được củng cố qua năm tháng. Tâm thế là trạng thái chuẩn bị tinh thần khi đối mặt với một tình huống cụ thể, nếu không aware tốt nó sẽ bị cảm xúc & bản năng chi phối. Ví dụ: khi bạn chuẩn bị có một buổi họp để đề xuất idea, nếu tâm thế bạn là chỉ tin idea mình là đúng đắn & chỉ muốn thuyết phục mọi người thì trong buổi họp, khi bạn được tiếp nhận các feedback, xu hướng bạn sẽ phớt lờ & push back cái feedback đó để bảo vệ idea của mình là chính, còn nếu tâm thế của bạn là muốn collect thêm những góc nhìn khác & kiểm chứng xem idea của mình có hợp lý, có sai sót gì không thì xu hướng lại là lắng nghe & cố gắng tìm cách khơi mở, đào sâu góc nhìn của mọi người. 2 hành vi & thái độ này rất khác biệt.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-8060-9a1e-f5f52c6e48e1",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-26T01:59:00.000Z",
        "last_edited_time": "2024-12-26T10:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy mình có thể định nghĩa như sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy mình có thể định nghĩa như sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80b1-b47c-ff29ca1c092f",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T08:13:00.000Z",
        "last_edited_time": "2024-12-26T10:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mindset: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mindset: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "là cách tư duy, quan niệm và niềm tin của một người, ảnh hưởng đến cách mình nhìn nhận thế giới xung quanh và xử lý thông tin.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "là cách tư duy, quan niệm và niềm tin của một người, ảnh hưởng đến cách mình nhìn nhận thế giới xung quanh và xử lý thông tin.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8023-93a6-c714a9c085b3",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T08:15:00.000Z",
        "last_edited_time": "2024-12-26T01:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tâm thế:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tâm thế:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là trạng thái chuẩn bị tinh thần khi đối mặt với một tình huống cụ thể.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là trạng thái chuẩn bị tinh thần khi đối mặt với một tình huống cụ thể.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-8060-9444-d1b35e2d30ae",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-26T01:37:00.000Z",
        "last_edited_time": "2024-12-26T01:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thái độ:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thái độ:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là cảm xúc, là cách bạn cảm nhận và phản ứng với một sự việc.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là cảm xúc, là cách bạn cảm nhận và phản ứng với một sự việc.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-807d-9afd-d2d547d3a8cd",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-26T01:38:00.000Z",
        "last_edited_time": "2024-12-26T10:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hành vi",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hành vi",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": là những hành động, lời nói khi bạn tương tác với cuộc sống.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": là những hành động, lời nói khi bạn tương tác với cuộc sống.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80f4-890d-d3688cc4645d",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T08:28:00.000Z",
        "last_edited_time": "2024-12-23T08:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8089-8a1e-f1c286920c9d",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T08:28:00.000Z",
        "last_edited_time": "2024-12-23T08:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mối liên hệ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mối liên hệ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80db-b44e-d429e6939174",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T08:23:00.000Z",
        "last_edited_time": "2024-12-26T02:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mindset là bầu trời bao quát ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mindset là bầu trời bao quát ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "- là bức tranh lớn, nền tảng bao trùm mọi suy nghĩ, niềm tin và cách bạn nhìn nhận thế giới. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "- là bức tranh lớn, nền tảng bao trùm mọi suy nghĩ, niềm tin và cách bạn nhìn nhận thế giới. ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Tâm thế sẽ là ánh sáng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tâm thế sẽ là ánh sáng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " - là trạng thái tâm lý chiếu vào các tình huống cụ thể. Và ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " - là trạng thái tâm lý chiếu vào các tình huống cụ thể. Và ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "thái độ, hành vi chính là cái bóng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "thái độ, hành vi chính là cái bóng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " - là biểu hiện ra bên ngoài, là thứ theo sau, chúng chịu ảnh hưởng trực tiếp từ ánh sáng (tâm thế) và bầu trời (mindset).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " - là biểu hiện ra bên ngoài, là thứ theo sau, chúng chịu ảnh hưởng trực tiếp từ ánh sáng (tâm thế) và bầu trời (mindset).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8053-9ccf-cdec25f03ad8",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T08:27:00.000Z",
        "last_edited_time": "2024-12-23T08:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081249/uxcomic-imgs/1655d164-78d8-8053-9ccf-cdec25f03ad8.png",
            "expiry_time": "2026-10-04T09:11:11.785Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1655d164-78d8-8053-9ccf-cdec25f03ad8"
      },
      {
        "object": "block",
        "id": "a244a523-be33-4d7d-9553-cf030864497e",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T08:06:00.000Z",
        "last_edited_time": "2024-12-23T08:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80f7-8b18-f9c15868dbda",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T08:29:00.000Z",
        "last_edited_time": "2024-12-23T08:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "So what",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "So what",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80b9-8fef-e69fb299484f",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T08:29:00.000Z",
        "last_edited_time": "2024-12-23T08:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "OK biết mấy thứ này để làm gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "OK biết mấy thứ này để làm gì?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-805c-8da6-edd149fc218b",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T08:29:00.000Z",
        "last_edited_time": "2024-12-27T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nghe hơi giáo điều, nhưng đây chính là gốc rễ vấn đề cho mọi kết quả ta đạt được trong cuộc sống này. Nó theo luật nhân quả, mindset & tâm thế cái tạo nên nhân, thái độ & hành vi là biểu hiện của nhân, thông qua biểu hiện đó mình sẽ nhận phản hồi từ cuộc sống là quả (nghe hơi lag lag 🤣). Anyway thì nhận diện được mindset & tâm thế sẽ giúp bạn hiểu mình hiểu người thêm, từ đó có những kế sách để ứng phó phù hợp hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nghe hơi giáo điều, nhưng đây chính là gốc rễ vấn đề cho mọi kết quả ta đạt được trong cuộc sống này. Nó theo luật nhân quả, mindset & tâm thế cái tạo nên nhân, thái độ & hành vi là biểu hiện của nhân, thông qua biểu hiện đó mình sẽ nhận phản hồi từ cuộc sống là quả (nghe hơi lag lag 🤣). Anyway thì nhận diện được mindset & tâm thế sẽ giúp bạn hiểu mình hiểu người thêm, từ đó có những kế sách để ứng phó phù hợp hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-809a-b2f3-cd58f722f29e",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-26T10:40:00.000Z",
        "last_edited_time": "2024-12-26T10:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8093-aed8-d6e47097a6f2",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T10:11:00.000Z",
        "last_edited_time": "2024-12-26T02:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ah, nếu liên hệ một chút đến công việc design & build product thì cũng phần nào hữu ích:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ah, nếu liên hệ một chút đến công việc design & build product thì cũng phần nào hữu ích:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80fd-a0ab-ca18849ed2d8",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T10:14:00.000Z",
        "last_edited_time": "2024-12-26T10:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi ta nói thiết kế sao cho có tính user-centric, đồng nghĩa với việc mình phải thấu hiểu user, phải đứng được trên perception của họ. Như thế nào? Ngoài việc quan sát những hành vi & thái độ của họ, bạn còn phải thăm dò xem lớp ẩn ở dưới là gì, họ có tâm thế ra sao, mindset ra sao. Mindset đó bị tác động, định hình bởi cái gì? (để hiểu thêm việc được định hình bởi cái gì, bạn có thể xem thêm khái niệm Tam quan qua",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi ta nói thiết kế sao cho có tính user-centric, đồng nghĩa với việc mình phải thấu hiểu user, phải đứng được trên perception của họ. Như thế nào? Ngoài việc quan sát những hành vi & thái độ của họ, bạn còn phải thăm dò xem lớp ẩn ở dưới là gì, họ có tâm thế ra sao, mindset ra sao. Mindset đó bị tác động, định hình bởi cái gì? (để hiểu thêm việc được định hình bởi cái gì, bạn có thể xem thêm khái niệm Tam quan qua",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " bài viết này",
                "link": {
                  "url": "/32cbe568c34b4255a408f2a2e6227bb2"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " bài viết này",
              "href": "/32cbe568c34b4255a408f2a2e6227bb2"
            },
            {
              "type": "text",
              "text": {
                "content": ").",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ").",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80d6-9f4f-edb36c790dd5",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T10:14:00.000Z",
        "last_edited_time": "2024-12-26T10:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ngược lại, nếu product mình muốn thuyết phục hay thay đổi hành vi user thì ta phải làm sao tác động được vào quan niệm và niềm tin của họ, vì chúng định hình hành vi & thái độ của user khi tiếp cận product của bạn. (thuyết phục được user là nỗ lực của cả doanh nghiệp, từ business định hình value sẽ offer cho user, đến marketing, đến trải nghiệm của họ khi tương tác với product, từng câu từng chữ trên UI…).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ngược lại, nếu product mình muốn thuyết phục hay thay đổi hành vi user thì ta phải làm sao tác động được vào quan niệm và niềm tin của họ, vì chúng định hình hành vi & thái độ của user khi tiếp cận product của bạn. (thuyết phục được user là nỗ lực của cả doanh nghiệp, từ business định hình value sẽ offer cho user, đến marketing, đến trải nghiệm của họ khi tương tác với product, từng câu từng chữ trên UI…).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-800d-94a4-fc08850084d5",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-26T10:35:00.000Z",
        "last_edited_time": "2025-06-15T05:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [
            {
              "type": "text",
              "text": {
                "content": "Intention of Use.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Intention of Use.",
              "href": null
            }
          ],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081251/uxcomic-imgs/1685d164-78d8-800d-94a4-fc08850084d5.png",
            "expiry_time": "2026-10-04T09:11:11.838Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1685d164-78d8-800d-94a4-fc08850084d5"
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8000-8fcf-d17b24adca4d",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T10:15:00.000Z",
        "last_edited_time": "2024-12-23T10:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80c3-b2c4-eef5007dccb9",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T10:15:00.000Z",
        "last_edited_time": "2024-12-23T13:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bonus",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bonus",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-803d-b4db-c9aaa8a86cc9",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T10:16:00.000Z",
        "last_edited_time": "2024-12-26T02:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Không xa lạ đâu, mấy sách self-help nói nhiều lắm, mà clip này mình thấy hay hay nên share lại cho mọi người xem.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Không xa lạ đâu, mấy sách self-help nói nhiều lắm, mà clip này mình thấy hay hay nên share lại cho mọi người xem.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8071-a36e-fe563f60d8ec",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T12:58:00.000Z",
        "last_edited_time": "2024-12-23T12:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Growth vs Fixed mindset",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Growth vs Fixed mindset",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80dc-ad9d-f3870af8f0a8",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T08:35:00.000Z",
        "last_edited_time": "2024-12-23T08:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "video",
        "video": {
          "caption": [],
          "type": "external",
          "external": {
            "url": "https://www.youtube.com/watch?v=IioB6fC23fM"
          }
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8057-8aa4-da4898e9c749",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T12:59:00.000Z",
        "last_edited_time": "2024-12-23T12:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Strategic mindset",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Strategic mindset",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8042-b41e-c75af0c6491a",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-23T12:53:00.000Z",
        "last_edited_time": "2024-12-23T12:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "video",
        "video": {
          "caption": [],
          "type": "external",
          "external": {
            "url": "https://youtu.be/kL2QkfhGhcc?si=iy7TfXDzGqyKb36w"
          }
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-80e2-b022-c1eea9ddab7b",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-26T02:14:00.000Z",
        "last_edited_time": "2024-12-26T02:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-80ee-8b67-fce843b89012",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-26T02:14:00.000Z",
        "last_edited_time": "2024-12-26T02:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1d75d164-78d8-808b-afc5-c6696cfb167f",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2025-04-16T02:23:00.000Z",
        "last_edited_time": "2025-04-16T02:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1d75d164-78d8-80eb-bb89-f63dbc0a2775"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách nhìn người ",
              "href": "https://app.notion.com/p/1d75d16478d880ebbb89f63dbc0a2775"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-807d-ac13-c4e7a7d1a3e7",
        "parent": {
          "type": "page_id",
          "page_id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
        },
        "created_time": "2024-12-26T02:21:00.000Z",
        "last_edited_time": "2024-12-26T02:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1405d164-78d8-801a-b019-e709965fbf48"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Listening",
              "href": "https://app.notion.com/p/1405d16478d8801ab019e709965fbf48"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef",
    "created_time": "2024-12-22T00:42:00.000Z",
    "last_edited_time": "2025-06-26T02:35:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-12-22T00:42:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "3-Workflow",
          "color": "default"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 31
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-06-26T02:35:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "CDA\\",
          "name": "⚓:2",
          "color": "brown"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Workflow?",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Workflow?",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Workflow-1645d16478d880ffbfccc5ed623af4ef",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
      "name": "Workflow",
      "slug": "workflow",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "1645d164-78d8-813f-a7ad-d96eca8d6caf",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T00:43:00.000Z",
        "last_edited_time": "2024-12-30T05:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081254/uxcomic-imgs/1645d164-78d8-813f-a7ad-d96eca8d6caf.png",
            "expiry_time": "2026-10-04T09:11:12.633Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1645d164-78d8-813f-a7ad-d96eca8d6caf"
      },
      {
        "object": "block",
        "id": "1645d164-78d8-81cb-8706-f2a8cf3bea9e",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T00:43:00.000Z",
        "last_edited_time": "2025-06-24T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhớ lại những năm đầu làm nghề, mình rất hay bối rối giữa những quy trình học được qua khoá học, qua các blog khác với quy trình thực tế trong công việc. Gần đây khi trải nghiệm qua đủ nhiều cũng như có được lượng kiến thức nhiều hơn mình mới bắt đầu phân biệt được process & workflow >> lí giải được tại sao quy trình thực tế có khi lại khác với những gì mình biết, mình học.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhớ lại những năm đầu làm nghề, mình rất hay bối rối giữa những quy trình học được qua khoá học, qua các blog khác với quy trình thực tế trong công việc. Gần đây khi trải nghiệm qua đủ nhiều cũng như có được lượng kiến thức nhiều hơn mình mới bắt đầu phân biệt được process & workflow >> lí giải được tại sao quy trình thực tế có khi lại khác với những gì mình biết, mình học.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80f4-bbfe-c0a314fa7f88",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T01:54:00.000Z",
        "last_edited_time": "2024-12-22T01:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-806a-8982-e9d3974e5fcf",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T01:54:00.000Z",
        "last_edited_time": "2024-12-22T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Workflow vs Process",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Workflow vs Process",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-804f-873b-feee6845f5f5",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T01:54:00.000Z",
        "last_edited_time": "2024-12-30T06:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Process",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Process",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": hãy bắt đầu với process trước, vì đây là thứ quen thuộc nhất với chúng ta, ví dụ design thinking process, double diamond process. Process được sinh ra để tập hợp tất cả các hoạt động cần có để đạt được một mục tiêu cụ thể, nó bao gồm những quy tắc, guideline để đảm bảo hiệu quả công việc, thường thì nó có tính lặp lại & ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": hãy bắt đầu với process trước, vì đây là thứ quen thuộc nhất với chúng ta, ví dụ design thinking process, double diamond process. Process được sinh ra để tập hợp tất cả các hoạt động cần có để đạt được một mục tiêu cụ thể, nó bao gồm những quy tắc, guideline để đảm bảo hiệu quả công việc, thường thì nó có tính lặp lại & ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "bao quát.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "bao quát.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-80fe-9935-f3655edd9288",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2025-01-14T11:13:00.000Z",
        "last_edited_time": "2025-01-14T11:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8041-95b8-d4aa6f22f273",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T02:00:00.000Z",
        "last_edited_time": "2024-12-30T06:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Workflow",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Workflow",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": cũng hao hao như process (nên mới dẫn đến việc thấy rối rối), cũng bao gồm các bước cần mình follow, nhưng điểm khác việc lớn ở đây là ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": cũng hao hao như process (nên mới dẫn đến việc thấy rối rối), cũng bao gồm các bước cần mình follow, nhưng điểm khác việc lớn ở đây là ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "nó được mô tả dưới các công việc nhỏ & cụ thể, phải mô tả trách nhiệm và sự tham gia của các bên tham gia",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "nó được mô tả dưới các công việc nhỏ & cụ thể, phải mô tả trách nhiệm và sự tham gia của các bên tham gia",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " trong quá trình thực hiện. Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " trong quá trình thực hiện. Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80ca-91b2-ef92153bf089",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T02:04:00.000Z",
        "last_edited_time": "2024-12-22T02:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Workflow phê duyệt thiết kế:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Workflow phê duyệt thiết kế:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8054-855a-e85b1156d0aa",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T02:05:00.000Z",
        "last_edited_time": "2024-12-22T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Designer tạo mẫu thiết kế",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Designer tạo mẫu thiết kế",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8053-8d63-e07b258f4efb",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T02:05:00.000Z",
        "last_edited_time": "2024-12-22T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Gửi mẫu cho leader để review",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Gửi mẫu cho leader để review",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80fb-aa02-dab3c9f1e633",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T02:05:00.000Z",
        "last_edited_time": "2024-12-22T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Leader duyệt hoặc yêu cầu chỉnh sửa",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Leader duyệt hoặc yêu cầu chỉnh sửa",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "21c5d164-78d8-80d9-be54-e1f88a5424eb",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2025-06-24T01:46:00.000Z",
        "last_edited_time": "2025-06-24T01:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Designer catch up với các stakeholder khác như PO, Dev,… để có sự đồng thuận",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Designer catch up với các stakeholder khác như PO, Dev,… để có sự đồng thuận",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 3
      },
      {
        "object": "block",
        "id": "1645d164-78d8-800d-9a96-fda476088f5f",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T02:05:00.000Z",
        "last_edited_time": "2025-06-24T01:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu đã chốt được, mẫu sẽ được chuyển cho developer",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu đã chốt được, mẫu sẽ được chuyển cho developer",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 4
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-80d9-a722-fe359068d867",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2025-01-14T11:13:00.000Z",
        "last_edited_time": "2025-01-14T11:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8029-b429-de90b2cfabb2",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T02:06:00.000Z",
        "last_edited_time": "2025-01-14T11:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mối liên hệ giữa process & workflow",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mối liên hệ giữa process & workflow",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8044-8a7d-f691779cce14",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T02:06:00.000Z",
        "last_edited_time": "2025-06-24T01:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Process là lý thuyết, là bức tranh lớn, là chuỗi mục tiêu cần có & workflow là các chi tiết cụ thể trong từng bước của process, nó tập trung vào cách hiện thực hoá mục tiêu của từng bước có trong process. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Process là lý thuyết, là bức tranh lớn, là chuỗi mục tiêu cần có & workflow là các chi tiết cụ thể trong từng bước của process, nó tập trung vào cách hiện thực hoá mục tiêu của từng bước có trong process. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "21c5d164-78d8-804f-9738-ff689c0ddad3",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2025-06-24T01:58:00.000Z",
        "last_edited_time": "2025-06-24T02:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ design thinking process bao gồm các bước: empathize > define > ideate > prototype > test. Tuy nhiên từng giai đoạn đó có nhiều bên involve vào, không nhất thiết designer phải làm hết, ví dụ: empathize sẽ cần team UXR handle chính, define sẽ gồm UXR, PO/PM, UXD cùng thảo luận và frame vấn đề, ideate sẽ do UXD & PO cùng brainstorm,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ design thinking process bao gồm các bước: empathize > define > ideate > prototype > test. Tuy nhiên từng giai đoạn đó có nhiều bên involve vào, không nhất thiết designer phải làm hết, ví dụ: empathize sẽ cần team UXR handle chính, define sẽ gồm UXR, PO/PM, UXD cùng thảo luận và frame vấn đề, ideate sẽ do UXD & PO cùng brainstorm,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-808b-990a-f5f4995fcb59",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T02:21:00.000Z",
        "last_edited_time": "2025-06-24T02:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cụ thể hơn workflow cho mục đích empathize thì ta cần những activities như interview, collect user feedback, data analysis, chiến lược của công ty… ai sẽ làm hoạt động nào, cần trình bày và document đó ở đâu,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cụ thể hơn workflow cho mục đích empathize thì ta cần những activities như interview, collect user feedback, data analysis, chiến lược của công ty… ai sẽ làm hoạt động nào, cần trình bày và document đó ở đâu,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "21c5d164-78d8-804f-8ee1-d5cdfbebf7fd",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2025-06-24T02:16:00.000Z",
        "last_edited_time": "2025-06-24T02:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Workflow có tính linh hoạt cao hơn, nó là cách tổ chức/ phòng ban định hình cách làm việc với nhau, workflow của một công ty 100 người sẽ khác hẳn với công ty start-up 10 người.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Workflow có tính linh hoạt cao hơn, nó là cách tổ chức/ phòng ban định hình cách làm việc với nhau, workflow của một công ty 100 người sẽ khác hẳn với công ty start-up 10 người.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8072-88ca-c80414220cca",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T02:59:00.000Z",
        "last_edited_time": "2024-12-22T02:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8075-8fa8-f41d2d00a608",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-30T06:05:00.000Z",
        "last_edited_time": "2024-12-30T06:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các yếu tố định hình process & workflow",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các yếu tố định hình process & workflow",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80f3-8aa2-d8c4ef929819",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-30T06:06:00.000Z",
        "last_edited_time": "2024-12-30T06:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "1/ UX maturity",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "1/ UX maturity",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-803a-8a1c-dcb5a13cf684",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-30T06:06:00.000Z",
        "last_edited_time": "2025-06-24T02:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cả mặt process, workflow nếu nhìn tổng quan đều được định hình bởi scope & trách nhiệm công việc của các nhân sự. Những đầu công việc này bị ảnh hưởng rất lớn bởi UX maturity (nói cách khác là mức độ quan tâm & đề cao giá trị UX trong doanh nghiệp đó), mức độ quan tâm càng lớn thì đầu việc càng nhiều & càng có impact.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cả mặt process, workflow nếu nhìn tổng quan đều được định hình bởi scope & trách nhiệm công việc của các nhân sự. Những đầu công việc này bị ảnh hưởng rất lớn bởi UX maturity (nói cách khác là mức độ quan tâm & đề cao giá trị UX trong doanh nghiệp đó), mức độ quan tâm càng lớn thì đầu việc càng nhiều & càng có impact.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8009-b4a8-e62fd1eba665",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-30T06:06:00.000Z",
        "last_edited_time": "2024-12-30T06:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081255/uxcomic-imgs/16c5d164-78d8-8009-b4a8-e62fd1eba665.jpg",
            "expiry_time": "2026-10-04T09:11:12.634Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/16c5d164-78d8-8009-b4a8-e62fd1eba665"
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80fb-9b27-dc667771f852",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-30T06:06:00.000Z",
        "last_edited_time": "2025-06-24T02:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nên nếu bạn thấy những gì mình đọc, mình học, nó đang khác xa với process thực tế trong công ty bạn, nó có thể đến từng việc công ty đang hiểu và quan tâm đến UX ở level nào, nếu công ty càng đầu tư, thì process mới gần với các thứ mình được học.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nên nếu bạn thấy những gì mình đọc, mình học, nó đang khác xa với process thực tế trong công ty bạn, nó có thể đến từng việc công ty đang hiểu và quan tâm đến UX ở level nào, nếu công ty càng đầu tư, thì process mới gần với các thứ mình được học.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8008-97b4-f7b9487bcab6",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-30T06:06:00.000Z",
        "last_edited_time": "2024-12-30T06:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-817b-a68e-e05be73a7c92",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T00:43:00.000Z",
        "last_edited_time": "2024-12-30T06:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "2/ Team structure",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2/ Team structure",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-81a8-b01c-c96859eecad6",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T00:43:00.000Z",
        "last_edited_time": "2024-12-30T06:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách công ty tổ chức phòng ban, thiết kế đội ngũ sẽ tác động đến workflow của bạn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách công ty tổ chức phòng ban, thiết kế đội ngũ sẽ tác động đến workflow của bạn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "21c5d164-78d8-8024-895b-e250d97d4c25",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2025-06-24T02:19:00.000Z",
        "last_edited_time": "2025-06-24T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80ab-82c3-c7e7104b2152",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T02:59:00.000Z",
        "last_edited_time": "2025-06-24T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081257/uxcomic-imgs/1645d164-78d8-80ab-82c3-c7e7104b2152.jpg",
            "expiry_time": "2026-10-04T09:11:12.716Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1645d164-78d8-80ab-82c3-c7e7104b2152"
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80e3-b466-d8a5774794c5",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T02:27:00.000Z",
        "last_edited_time": "2025-06-26T02:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Công ty A chia team theo dạng cụm ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Công ty A chia team theo dạng cụm ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "phòng ban:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "phòng ban:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " PO riêng, designer riêng, dev riêng. PO sẽ chịu trách nhiệm hoạch định chiến lược  sau đó lên kế hoạch, soạn brief cho team designer, dev để thực thi solution ấy. Có thể thấy cách chia này nhầm để các bên phối hợp với nhau theo dạng ghép nối các công việc chuyên môn theo từng project. Mảnh ghép ở đây là những phần việc chuyên môn của từng phòng ban.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " PO riêng, designer riêng, dev riêng. PO sẽ chịu trách nhiệm hoạch định chiến lược  sau đó lên kế hoạch, soạn brief cho team designer, dev để thực thi solution ấy. Có thể thấy cách chia này nhầm để các bên phối hợp với nhau theo dạng ghép nối các công việc chuyên môn theo từng project. Mảnh ghép ở đây là những phần việc chuyên môn của từng phòng ban.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8030-9491-fedc013d683d",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T02:59:00.000Z",
        "last_edited_time": "2024-12-23T09:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081259/uxcomic-imgs/1645d164-78d8-8030-9491-fedc013d683d.png",
            "expiry_time": "2026-10-04T09:11:12.716Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1645d164-78d8-8030-9491-fedc013d683d"
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-80c0-8e7e-ea776425affd",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2025-01-14T11:14:00.000Z",
        "last_edited_time": "2025-01-14T11:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8068-8060-fc93e990df26",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T02:29:00.000Z",
        "last_edited_time": "2025-06-24T02:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Công ty B chia team theo dạng theo ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Công ty B chia team theo dạng theo ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "module, product / outcome-oriented",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "module, product / outcome-oriented",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", mảnh ghép ở đây là các module của một product.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", mảnh ghép ở đây là các module của một product.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "21c5d164-78d8-8058-b20b-cfb20832879d",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2025-06-24T02:20:00.000Z",
        "last_edited_time": "2025-06-26T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: mỗi squad gồm PO, designer, dev, QC. Squad X lo về khía cạnh loyalty ; Squad Y lo về module “thanh toán”; Squad Z lo về “gamification”... Cách chia này khiến từng module, từng feature theme, và squad hoạt động như một công ty nhỏ, nên từng thành viên sẽ có cơ hội tham gia được các hoạt động trong process nhiều hơn >> tính ownership các thành viên rất cao, họ được hoạt động độc lập, họ sống & làm để tối ưu cho một mục tiêu cụ thể. Điều này giúp họ chuyên hoá cho một outcome nhất định. (Bạn có thể tìm hiểu thêm qua keyword: squad, Spotify model).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: mỗi squad gồm PO, designer, dev, QC. Squad X lo về khía cạnh loyalty ; Squad Y lo về module “thanh toán”; Squad Z lo về “gamification”... Cách chia này khiến từng module, từng feature theme, và squad hoạt động như một công ty nhỏ, nên từng thành viên sẽ có cơ hội tham gia được các hoạt động trong process nhiều hơn >> tính ownership các thành viên rất cao, họ được hoạt động độc lập, họ sống & làm để tối ưu cho một mục tiêu cụ thể. Điều này giúp họ chuyên hoá cho một outcome nhất định. (Bạn có thể tìm hiểu thêm qua keyword: squad, Spotify model).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-8054-9368-fcbd0eac5ed6",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2025-01-14T11:14:00.000Z",
        "last_edited_time": "2025-01-14T11:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8078-946f-f6b4c061b389",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T02:45:00.000Z",
        "last_edited_time": "2024-12-23T02:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tất nhiên mỗi cách đều có ưu nhược riêng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tất nhiên mỗi cách đều có ưu nhược riêng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80da-890a-f7a045f16608",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-23T02:22:00.000Z",
        "last_edited_time": "2024-12-23T02:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chia theo phòng ban giúp dễ quản lý hơn nhưng dễ bị hiệu ứng xa cách (silo effect).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chia theo phòng ban giúp dễ quản lý hơn nhưng dễ bị hiệu ứng xa cách (silo effect).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80a5-8fb0-c15523614f4e",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-23T02:23:00.000Z",
        "last_edited_time": "2025-06-26T02:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chia theo squad thì hợp tác chặt chẽ, thích ứng nhanh nhưng quá tải quản lý & cần lượng nhân sự nhiều hơn (vì thử nghĩ xem thay vì một designer thiết kế cho 3 module khác nhau, giờ lại cần đến 3 designer khác nhau phân bổ cho từng module).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chia theo squad thì hợp tác chặt chẽ, thích ứng nhanh nhưng quá tải quản lý & cần lượng nhân sự nhiều hơn (vì thử nghĩ xem thay vì một designer thiết kế cho 3 module khác nhau, giờ lại cần đến 3 designer khác nhau phân bổ cho từng module).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80a6-b502-dd24134d754d",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T03:25:00.000Z",
        "last_edited_time": "2024-12-23T02:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8033-8c45-e54b1dd4b436",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T03:07:00.000Z",
        "last_edited_time": "2024-12-23T02:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "So what",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "So what",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-808f-85d5-d9e1976f8e41",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T02:49:00.000Z",
        "last_edited_time": "2024-12-30T05:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy nó tác động đến mình như thế nào? ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy nó tác động đến mình như thế nào? ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-805a-a8c1-d8af74c780da",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-30T05:54:00.000Z",
        "last_edited_time": "2024-12-30T06:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Xem workflow nào hợp gu bạn hơn hoặc phục vụ cho hướng phát triển của bạn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Xem workflow nào hợp gu bạn hơn hoặc phục vụ cho hướng phát triển của bạn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-802e-9be3-c19930cf0f60",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-30T06:00:00.000Z",
        "last_edited_time": "2025-06-24T02:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "UX maturity sẽ ảnh hưởng đến scope công việc của bạn, nên hãy aware với scope đó có phải đúng thứ mình muốn grow hay không. (ví dụ nếu bạn muốn chuyên sâu, theo hướng crafting skill thì công ty có UX maturity lv3 là hợp, nếu muốn bắt đầu đóng góp nhiều vào solution, vào strategy hãy lựa chọn công ty có UX maturity ở lv4 & 5).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX maturity sẽ ảnh hưởng đến scope công việc của bạn, nên hãy aware với scope đó có phải đúng thứ mình muốn grow hay không. (ví dụ nếu bạn muốn chuyên sâu, theo hướng crafting skill thì công ty có UX maturity lv3 là hợp, nếu muốn bắt đầu đóng góp nhiều vào solution, vào strategy hãy lựa chọn công ty có UX maturity ở lv4 & 5).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80d1-b7ee-ca58a358b79a",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-30T05:59:00.000Z",
        "last_edited_time": "2025-06-24T02:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Team structure: nếu bạn ưu tiên tính chuyên môn cao & muốn làm được nhiều project thì chọn công ty chia theo department là phù hợp, còn bạn muốn được đóng góp solution nhiều hơn, sống với những gì mình tạo ra thì chọn công ty chia theo squad là phù hợp.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Team structure: nếu bạn ưu tiên tính chuyên môn cao & muốn làm được nhiều project thì chọn công ty chia theo department là phù hợp, còn bạn muốn được đóng góp solution nhiều hơn, sống với những gì mình tạo ra thì chọn công ty chia theo squad là phù hợp.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "16c5d164-78d8-8007-b748-c3a10bafb471",
            "parent": {
              "type": "block_id",
              "block_id": "16c5d164-78d8-80d1-b7ee-ca58a358b79a"
            },
            "created_time": "2024-12-30T06:00:00.000Z",
            "last_edited_time": "2025-06-24T02:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Theo mô hình department, có thể thấy ngồi theo department khả năng cao team sẽ có level rõ ràng (junior → manager) >> do đó khả năng học hỏi chuyên môn sẽ nhiều hơn, lộ trình thăng tiến cũng rõ ràng hơn. Phù hợp cho việc chuyên sâu hoặc phát triển theo hướng quản lý team.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Theo mô hình department, có thể thấy ngồi theo department khả năng cao team sẽ có level rõ ràng (junior → manager) >> do đó khả năng học hỏi chuyên môn sẽ nhiều hơn, lộ trình thăng tiến cũng rõ ràng hơn. Phù hợp cho việc chuyên sâu hoặc phát triển theo hướng quản lý team.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "16c5d164-78d8-80ee-8f72-e93556dc0c9e",
            "parent": {
              "type": "block_id",
              "block_id": "16c5d164-78d8-80d1-b7ee-ca58a358b79a"
            },
            "created_time": "2024-12-30T06:00:00.000Z",
            "last_edited_time": "2025-06-24T02:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Ngược lại thì khi theo mô hình squad cho phép bạn được quan sát, trải nghiệm một sản phẩm build từ đầu đến cuối ra sao, bạn được làm việc sát sao hơn với cross-functional team >> do đó bạn được phát triển kĩ năng rộng, đa dạng hơn, tăng cường tư duy sản phẩm (product sense), phần nào đó giúp rèn luyện khả năng collaboration (vì bạn đang chịu trách nhiệm cho chuyên môn của mình & phối hợp với các bên khác hàng ngày). Phù hợp cho hướng phát triển bền ngang.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Ngược lại thì khi theo mô hình squad cho phép bạn được quan sát, trải nghiệm một sản phẩm build từ đầu đến cuối ra sao, bạn được làm việc sát sao hơn với cross-functional team >> do đó bạn được phát triển kĩ năng rộng, đa dạng hơn, tăng cường tư duy sản phẩm (product sense), phần nào đó giúp rèn luyện khả năng collaboration (vì bạn đang chịu trách nhiệm cho chuyên môn của mình & phối hợp với các bên khác hàng ngày). Phù hợp cho hướng phát triển bền ngang.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "1645d164-78d8-819b-8db7-da00b63e90d9",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T00:43:00.000Z",
        "last_edited_time": "2024-12-22T00:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8115-a235-ef890507f6cc",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T00:43:00.000Z",
        "last_edited_time": "2024-12-22T00:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8135-9706-de9898a79d0e",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T00:43:00.000Z",
        "last_edited_time": "2024-12-22T00:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.linkedin.com/pulse/quy-trình-làm-việc-của-cty-tôi-chán-lắm-sếp-chẳng-nghe-phat-vo-ji9wc?",
                "link": {
                  "url": "https://www.linkedin.com/pulse/quy-tr%C3%ACnh-l%C3%A0m-vi%E1%BB%87c-c%E1%BB%A7a-cty-t%C3%B4i-ch%C3%A1n-l%E1%BA%AFm-s%E1%BA%BFp-ch%E1%BA%B3ng-nghe-phat-vo-ji9wc?utm_source=share&utm_medium=member_ios&utm_campaign=share_via"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.linkedin.com/pulse/quy-trình-làm-việc-của-cty-tôi-chán-lắm-sếp-chẳng-nghe-phat-vo-ji9wc?",
              "href": "https://www.linkedin.com/pulse/quy-tr%C3%ACnh-l%C3%A0m-vi%E1%BB%87c-c%E1%BB%A7a-cty-t%C3%B4i-ch%C3%A1n-l%E1%BA%AFm-s%E1%BA%BFp-ch%E1%BA%B3ng-nghe-phat-vo-ji9wc?utm_source=share&utm_medium=member_ios&utm_campaign=share_via"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-81c2-8a2c-d19eedfdbd3e",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T00:43:00.000Z",
        "last_edited_time": "2024-12-22T00:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.linkedin.com/pulse/project-management-triangle-phat-vo-gvuvc?",
                "link": {
                  "url": "https://www.linkedin.com/pulse/project-management-triangle-phat-vo-gvuvc?utm_source=share&utm_medium=member_ios&utm_campaign=share_via"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.linkedin.com/pulse/project-management-triangle-phat-vo-gvuvc?",
              "href": "https://www.linkedin.com/pulse/project-management-triangle-phat-vo-gvuvc?utm_source=share&utm_medium=member_ios&utm_campaign=share_via"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1745d164-78d8-8026-b963-d9187bdd8a59",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2025-01-07T07:12:00.000Z",
        "last_edited_time": "2025-01-07T07:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.linkedin.com/posts/tam-pham-1010-sammy_productmanagement-activity-7281859526713090048-nVu1?",
                "link": {
                  "url": "https://www.linkedin.com/posts/tam-pham-1010-sammy_productmanagement-activity-7281859526713090048-nVu1?utm_source=share&utm_medium=member_ios"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.linkedin.com/posts/tam-pham-1010-sammy_productmanagement-activity-7281859526713090048-nVu1?",
              "href": "https://www.linkedin.com/posts/tam-pham-1010-sammy_productmanagement-activity-7281859526713090048-nVu1?utm_source=share&utm_medium=member_ios"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-81fe-9dff-d94626bf4836",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T00:43:00.000Z",
        "last_edited_time": "2024-12-22T00:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-81bc-b8d8-ecd7fdf9c4da",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T00:43:00.000Z",
        "last_edited_time": "2024-12-22T00:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-81a4-8400-f69b7c6d0a28",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T00:43:00.000Z",
        "last_edited_time": "2024-12-22T03:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1445d164-78d8-805b-b388-e24b5f13cccb"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product development process (overall)",
              "href": "https://app.notion.com/p/1445d16478d8805bb388e24b5f13cccb"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-818b-9472-f97689d466a3",
        "parent": {
          "type": "page_id",
          "page_id": "1645d164-78d8-80ff-bfcc-c5ed623af4ef"
        },
        "created_time": "2024-12-22T00:43:00.000Z",
        "last_edited_time": "2024-12-22T03:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1185d164-78d8-8014-bdf1-e631b28f601e"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "RACI (Role & Responsibility)",
              "href": "https://app.notion.com/p/1185d16478d88014bdf1e631b28f601e"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096",
    "created_time": "2024-12-14T13:58:00.000Z",
    "last_edited_time": "2025-08-29T05:21:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-12-14T13:58:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "2-Communication",
          "color": "default"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 29
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-29T05:21:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "prxX",
          "name": "⚔️:2",
          "color": "yellow"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Presenting (P2)",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Presenting (P2)",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Presenting-P2-15c5d16478d8807d8bc1ff2ebee6b096",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Communication",
      "slug": "communication",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "db8bac78-baef-44b9-a0c6-eec4d5455307",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T13:58:00.000Z",
        "last_edited_time": "2024-12-14T13:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081263/uxcomic-imgs/db8bac78-baef-44b9-a0c6-eec4d5455307.png",
            "expiry_time": "2026-10-04T09:11:13.877Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/db8bac78-baef-44b9-a0c6-eec4d5455307"
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8091-a7c1-f74598dd7778",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T14:02:00.000Z",
        "last_edited_time": "2024-12-14T14:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phần 1",
                "link": {
                  "url": "/15a5d16478d88058b2d5d1d08ced0f2d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phần 1",
              "href": "/15a5d16478d88058b2d5d1d08ced0f2d"
            },
            {
              "type": "text",
              "text": {
                "content": " mình đã có nói sơ qua lí do cần nói có hệ thống, bài này sẽ bàn về how.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " mình đã có nói sơ qua lí do cần nói có hệ thống, bài này sẽ bàn về how.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8068-b143-fece26bb8fdc",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T14:03:00.000Z",
        "last_edited_time": "2024-12-14T14:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sơ lược thì mình thấy 3 thứ cần làm như sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sơ lược thì mình thấy 3 thứ cần làm như sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8090-8bb0-d62bd503a73b",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T13:59:00.000Z",
        "last_edited_time": "2024-12-14T13:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hiểu những gì mình nói",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hiểu những gì mình nói",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-804a-a396-f36a42afda21",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T13:59:00.000Z",
        "last_edited_time": "2024-12-22T00:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thiết kế luồng thông tin, hay nói dễ hiểu hơn là thiết kế câu chuyện, lên kịch bản",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thiết kế luồng thông tin, hay nói dễ hiểu hơn là thiết kế câu chuyện, lên kịch bản",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-80f2-989d-f3ba239c6c10",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T14:00:00.000Z",
        "last_edited_time": "2024-12-14T14:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khiến những gì bạn nói dễ liên tưởng hơn",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khiến những gì bạn nói dễ liên tưởng hơn",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8015-a89c-f240d17122fa",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T13:59:00.000Z",
        "last_edited_time": "2024-12-14T14:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-80a0-b72b-f0c3c9a50503",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T09:34:00.000Z",
        "last_edited_time": "2024-12-14T15:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "I. Hệ thống thông tin",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "I. Hệ thống thông tin",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-80b6-adc8-ef3f3da313e5",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T15:47:00.000Z",
        "last_edited_time": "2024-12-14T15:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình nghĩ là các activities dưới đây là thứ cần phải làm để nắm hoặc tìm những thông tin mình cần để nói về một vấn đề gì. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình nghĩ là các activities dưới đây là thứ cần phải làm để nắm hoặc tìm những thông tin mình cần để nói về một vấn đề gì. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8084-b76c-e34e7be97a6e",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T15:50:00.000Z",
        "last_edited_time": "2024-12-14T15:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "(disclaimer: đây chỉ là cách mình đang áp dụng, k sure nó đúng hoàn toàn nhé :D)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "(disclaimer: đây chỉ là cách mình đang áp dụng, k sure nó đúng hoàn toàn nhé :D)",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8044-807c-d0746a6b758c",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T09:35:00.000Z",
        "last_edited_time": "2024-12-14T15:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "1. Bày ra thông tin bằng nguyên tắc MECE (tách biệt & toàn diện)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "1. Bày ra thông tin bằng nguyên tắc MECE (tách biệt & toàn diện)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-804d-ae94-c180ff2095a5",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T13:56:00.000Z",
        "last_edited_time": "2024-12-14T13:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081265/uxcomic-imgs/15c5d164-78d8-804d-ae94-c180ff2095a5.png",
            "expiry_time": "2026-10-04T09:11:13.878Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/15c5d164-78d8-804d-ae94-c180ff2095a5"
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8049-be1b-e736781f3d18",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T09:48:00.000Z",
        "last_edited_time": "2024-12-14T14:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đây là một phương pháp được McKinsey giới thiệu rộng rãi, nó giúp chúng ta tư duy logic, phân tích thông tin dưới mức độ cả chi tiết & tổng quát, tìm ra mối liên quan giữa chúng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đây là một phương pháp được McKinsey giới thiệu rộng rãi, nó giúp chúng ta tư duy logic, phân tích thông tin dưới mức độ cả chi tiết & tổng quát, tìm ra mối liên quan giữa chúng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-803e-9633-c4034d358aeb",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T09:54:00.000Z",
        "last_edited_time": "2024-12-14T14:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "ME (không trùng lấp)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "ME (không trùng lấp)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": mỗi vấn đề được chia ra thành những mục nhỏ hơn & hoàn toàn độc lập. >> việc này giúp mình nhận diện được độ chi tiết & tìm ra hướng hành động trên từng chi tiết đó. Ví dụ: chi phí nhân công khác hoàn toàn chi phí vật liệu .",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": mỗi vấn đề được chia ra thành những mục nhỏ hơn & hoàn toàn độc lập. >> việc này giúp mình nhận diện được độ chi tiết & tìm ra hướng hành động trên từng chi tiết đó. Ví dụ: chi phí nhân công khác hoàn toàn chi phí vật liệu .",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8031-8f37-eaa8b278cc59",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T09:54:00.000Z",
        "last_edited_time": "2024-12-14T14:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "CE (không bỏ sót)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "CE (không bỏ sót)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": tất cả các phần được kết hợp lại được mà không có bất kỳ bỏ sót nào. Ví dụ: liệt kê tất cả các touchpoint mà customer tương tác với sản phẩm dịch vụ tạo ra một hành trình khách hàng - customer journey map",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": tất cả các phần được kết hợp lại được mà không có bất kỳ bỏ sót nào. Ví dụ: liệt kê tất cả các touchpoint mà customer tương tác với sản phẩm dịch vụ tạo ra một hành trình khách hàng - customer journey map",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8020-a989-eabc789c8cc2",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T14:25:00.000Z",
        "last_edited_time": "2024-12-14T14:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một cách minh hoạ để dễ hiểu hơn, đó là ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một cách minh hoạ để dễ hiểu hơn, đó là ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "trò chơi puzzle",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "trò chơi puzzle",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ". Các mảng miếng hoàn toàn khác nhau, độc lập nhưng khi ghép lại sẽ cho ra một bức tranh có ý nghĩa.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". Các mảng miếng hoàn toàn khác nhau, độc lập nhưng khi ghép lại sẽ cho ra một bức tranh có ý nghĩa.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-80df-be46-c4618a557eac",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T14:32:00.000Z",
        "last_edited_time": "2024-12-15T01:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081267/uxcomic-imgs/15c5d164-78d8-80df-be46-c4618a557eac.png",
            "expiry_time": "2026-10-04T09:11:13.878Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/15c5d164-78d8-80df-be46-c4618a557eac"
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8030-bbee-f0f157a894bf",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T13:47:00.000Z",
        "last_edited_time": "2024-12-14T14:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lưu ý:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lưu ý:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " để áp dụng được MECE cần mình phải có một cái hiểu đủ nhiều, có khả năng để hình dung được như thế nào là một bức tranh lớn, có cái sense biết khi nào là đủ hay khi nào là thiếu,… và việc này cần mình phải có một mức độ nghiên cứu, kiến thức & kinh nghiệm nhất định. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " để áp dụng được MECE cần mình phải có một cái hiểu đủ nhiều, có khả năng để hình dung được như thế nào là một bức tranh lớn, có cái sense biết khi nào là đủ hay khi nào là thiếu,… và việc này cần mình phải có một mức độ nghiên cứu, kiến thức & kinh nghiệm nhất định. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-80c2-b652-d1fa4ee8c968",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T14:33:00.000Z",
        "last_edited_time": "2024-12-14T14:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuy nhiên nếu tập dần cách áp dụng nguyên tắc này, chắc chắn sẽ boost cách chúng ta hiểu về vấn đề tốt hơn, cho cái nhìn từ khái quát cho đến chi tiết.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuy nhiên nếu tập dần cách áp dụng nguyên tắc này, chắc chắn sẽ boost cách chúng ta hiểu về vấn đề tốt hơn, cho cái nhìn từ khái quát cho đến chi tiết.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8038-852e-c3687b31b6ef",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T15:49:00.000Z",
        "last_edited_time": "2024-12-14T15:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-80af-a0cb-d6129fb195f0",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T09:35:00.000Z",
        "last_edited_time": "2024-12-14T16:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "2. Làm rõ mối liên hệ thông tin bằng việc trả lời câu hỏi:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2. Làm rõ mối liên hệ thông tin bằng việc trả lời câu hỏi:",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8043-81f4-d65342b32dc4",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T09:45:00.000Z",
        "last_edited_time": "2024-12-14T16:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Why?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Why?",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": để hiểu mối liên hệ nhân quả giữa các thông tin",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": để hiểu mối liên hệ nhân quả giữa các thông tin",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-800d-9f26-e1bf36f911e7",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T09:45:00.000Z",
        "last_edited_time": "2024-12-14T16:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "How?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "How?",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": để mô tả cách tác động qua lại giữa các thông tin",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": để mô tả cách tác động qua lại giữa các thông tin",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8049-9349-fd951a5eaf0a",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T09:45:00.000Z",
        "last_edited_time": "2024-12-14T16:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "So what?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "So what?",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": để gôm thông tin đến một kết luận, suggestion gì đó",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": để gôm thông tin đến một kết luận, suggestion gì đó",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-806c-82a7-c34fd91f03d3",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T16:18:00.000Z",
        "last_edited_time": "2024-12-14T16:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8042-858a-ed41540af077",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T09:35:00.000Z",
        "last_edited_time": "2024-12-14T16:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "3. Phản biện/ Kiểm chứng bằng Pyramid principle",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3. Phản biện/ Kiểm chứng bằng Pyramid principle",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-80a6-8f91-d63d2e275b69",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T09:35:00.000Z",
        "last_edited_time": "2024-12-14T16:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đưa ra kết luận & cung cấp các luận điểm, dữ liệu, chứng cứ để bổ sung cho kết luận đó. Mô hình này cực kì hữu ích khi buổi trình bày theo thiên hướng nhầm chốt một vấn đề gì đó hay đưa ra một đề xuất, một kết luận.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đưa ra kết luận & cung cấp các luận điểm, dữ liệu, chứng cứ để bổ sung cho kết luận đó. Mô hình này cực kì hữu ích khi buổi trình bày theo thiên hướng nhầm chốt một vấn đề gì đó hay đưa ra một đề xuất, một kết luận.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8067-82d0-df8ad582607b",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T15:09:00.000Z",
        "last_edited_time": "2024-12-14T16:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Điểm đặc biệt nhất của principle này là mình thấy nó cực kì đúng với sense making, khi suy nghĩ dưới mô hình này chắc chắn giúp bản thân mình tự phản biện cho một kết luận hay ý nghĩ gì đó, chắc chắn bạn sẽ tự hỏi bản thân: “dựa trên lập luận gì mà bạn nghĩ vậy?; dựa trên chứng cứ, data nào mà bạn có thể nói vậy?”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Điểm đặc biệt nhất của principle này là mình thấy nó cực kì đúng với sense making, khi suy nghĩ dưới mô hình này chắc chắn giúp bản thân mình tự phản biện cho một kết luận hay ý nghĩ gì đó, chắc chắn bạn sẽ tự hỏi bản thân: “dựa trên lập luận gì mà bạn nghĩ vậy?; dựa trên chứng cứ, data nào mà bạn có thể nói vậy?”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-80d8-aac9-e24ae264e67e",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T14:39:00.000Z",
        "last_edited_time": "2024-12-14T16:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081268/uxcomic-imgs/15c5d164-78d8-80d8-aac9-e24ae264e67e.png",
            "expiry_time": "2026-10-04T09:11:13.951Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/15c5d164-78d8-80d8-aac9-e24ae264e67e"
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-800c-b6a0-d7d58563b43f",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T16:18:00.000Z",
        "last_edited_time": "2024-12-14T16:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8037-a290-dbf37b006087",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T09:40:00.000Z",
        "last_edited_time": "2024-12-14T15:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "II. Set up luồng thông tin (câu chuyện)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "II. Set up luồng thông tin (câu chuyện)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-8008-a84d-f2382701bf1d",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-15T01:27:00.000Z",
        "last_edited_time": "2024-12-23T13:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Câu chuyện biến những thứ ta nói nghe tự nhiên & gần gũi hơn, nó giống như cách mà não bộ chúng ta thông thường hay xử lý nên tăng khả năng hiểu vấn đề. Tip: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Câu chuyện biến những thứ ta nói nghe tự nhiên & gần gũi hơn, nó giống như cách mà não bộ chúng ta thông thường hay xử lý nên tăng khả năng hiểu vấn đề. Tip: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "story telling",
                "link": {
                  "url": "/1655d16478d880e0afe1f2341799250c"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "story telling",
              "href": "/1655d16478d880e0afe1f2341799250c"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-80f1-94e7-edb189085fed",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T15:33:00.000Z",
        "last_edited_time": "2024-12-15T13:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách gì? - Dàn ý.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách gì? - Dàn ý.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-8047-99fb-cf92572a8ea4",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2025-01-12T02:43:00.000Z",
        "last_edited_time": "2025-01-12T02:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081270/uxcomic-imgs/1795d164-78d8-8047-99fb-cf92572a8ea4.jpg",
            "expiry_time": "2026-10-04T09:11:13.951Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1795d164-78d8-8047-99fb-cf92572a8ea4"
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-80d8-acc4-f9c90f0fcf4d",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T16:14:00.000Z",
        "last_edited_time": "2024-12-15T01:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình nhớ xưa học văn có khái niệm diễn dịch, quy nạp, song hành… ngắn gọn như sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình nhớ xưa học văn có khái niệm diễn dịch, quy nạp, song hành… ngắn gọn như sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8039-b22b-f21ad5dc4e5b",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T16:28:00.000Z",
        "last_edited_time": "2024-12-14T16:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quy nạp: đưa ra luận điểm A,B,C để suy ra D.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quy nạp: đưa ra luận điểm A,B,C để suy ra D.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8033-8cd3-ef29ae431e63",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T16:27:00.000Z",
        "last_edited_time": "2024-12-14T16:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Diễn dịch: đưa ra kết luận D, các ý A,B,C tiếp theo để bổ trợ cho D.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Diễn dịch: đưa ra kết luận D, các ý A,B,C tiếp theo để bổ trợ cho D.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-802e-a448-f7a22e90e7a0",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-15T01:20:00.000Z",
        "last_edited_time": "2024-12-15T01:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Song hành: các câu A,B,C mang tính chất liệt kê, đóng vai trò bình đẳng để bổ trợ, làm rõ khái niệm cho D.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Song hành: các câu A,B,C mang tính chất liệt kê, đóng vai trò bình đẳng để bổ trợ, làm rõ khái niệm cho D.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-8008-a075-d6d354376441",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-15T01:23:00.000Z",
        "last_edited_time": "2024-12-15T01:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tổng - Phân - Hợp: là cách kết hợp cả diễn dịch & quy nạp, mở vấn đề, phân tích và đưa ra một kết luận.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tổng - Phân - Hợp: là cách kết hợp cả diễn dịch & quy nạp, mở vấn đề, phân tích và đưa ra một kết luận.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8070-b701-e194ddca8bbb",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-24T05:51:00.000Z",
        "last_edited_time": "2024-12-24T05:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "video",
        "video": {
          "caption": [],
          "type": "external",
          "external": {
            "url": "https://youtu.be/HAnw168huqA?si=QNQqOwy-Ez9vwlLW&t=2028"
          }
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8019-822f-cdf59aeb9932",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T16:34:00.000Z",
        "last_edited_time": "2024-12-20T06:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các kịch bản",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các kịch bản",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (tuỳ mục tiêu & trường hợp):",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (tuỳ mục tiêu & trường hợp):",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8013-a69d-d02bc110be4a",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T16:22:00.000Z",
        "last_edited_time": "2024-12-15T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Problem - Solution - Benefit",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Problem - Solution - Benefit",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8015-a1cb-eab755b569ce",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T16:23:00.000Z",
        "last_edited_time": "2024-12-14T16:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "What - So what - Now what",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "What - So what - Now what",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8064-8044-c5b3bc3e3512",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T16:37:00.000Z",
        "last_edited_time": "2024-12-14T16:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Why - How - What",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Why - How - What",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8047-bef9-db88dab52931",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T16:36:00.000Z",
        "last_edited_time": "2024-12-14T16:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Benefit - Solution - Evidence",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Benefit - Solution - Evidence",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8017-b0ab-c7eab38e2140",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T16:24:00.000Z",
        "last_edited_time": "2024-12-20T06:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "PEEL: Point - Evidence - Explaination - Link",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "PEEL: Point - Evidence - Explaination - Link",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8097-a741-d6891e4f7cda",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T16:38:00.000Z",
        "last_edited_time": "2024-12-20T06:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Four C’s: Context - Challenge - Choices - Conclusion",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Four C’s: Context - Challenge - Choices - Conclusion",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-80ff-89ca-fdac8f7ff82f",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T16:35:00.000Z",
        "last_edited_time": "2024-12-14T16:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "SCQA: Situation - Complication - Question - Answer",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "SCQA: Situation - Complication - Question - Answer",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-80d0-9b4d-c3ae2ca0c818",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T16:22:00.000Z",
        "last_edited_time": "2024-12-14T16:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "STAR: Situation - Task - Action - Result",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "STAR: Situation - Task - Action - Result",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-80ca-bc76-db9285f15f99",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T16:40:00.000Z",
        "last_edited_time": "2024-12-14T16:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "etc.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "etc.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1625d164-78d8-8067-91b7-cc4890cdb6dc",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-20T06:00:00.000Z",
        "last_edited_time": "2024-12-20T06:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bonus",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bonus",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": để gia tăng hứng thú nghe của đối phương, hãy học cách báo chí “giật tít” đặt tên cho tiêu đề, ví dụ: tạo sự tò mò (",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": để gia tăng hứng thú nghe của đối phương, hãy học cách báo chí “giật tít” đặt tên cho tiêu đề, ví dụ: tạo sự tò mò (",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "curiosity gap",
                "link": {
                  "url": "https://www.linkedin.com/pulse/why-you-need-curiosity-gap-your-marketing-david-bark-ys8rc?utm_source=share&utm_medium=member_ios&utm_campaign=share_via"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "curiosity gap",
              "href": "https://www.linkedin.com/pulse/why-you-need-curiosity-gap-your-marketing-david-bark-ys8rc?utm_source=share&utm_medium=member_ios&utm_campaign=share_via"
            },
            {
              "type": "text",
              "text": {
                "content": "), sử dụng con số (3 góc nhìn thay đổi cách nhìn của bạn về thiết kế), từ có cảm xúc mạnh, nhấn mạnh lợi ích, drama, mâu thuẫn,… nhiều lắm, nếu muốn hãy hỏi chatGPT thêm nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "), sử dụng con số (3 góc nhìn thay đổi cách nhìn của bạn về thiết kế), từ có cảm xúc mạnh, nhấn mạnh lợi ích, drama, mâu thuẫn,… nhiều lắm, nếu muốn hãy hỏi chatGPT thêm nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-80ae-a830-e5d860575bd0",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T09:41:00.000Z",
        "last_edited_time": "2024-12-14T15:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "15b5d164-78d8-80be-aa5e-e83f34f46979",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-13T05:58:00.000Z",
        "last_edited_time": "2024-12-14T17:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "III. Khiến mọi thứ dễ liên tưởng hơn",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "III. Khiến mọi thứ dễ liên tưởng hơn",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-807d-9f55-f350cb4dbc08",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T09:39:00.000Z",
        "last_edited_time": "2024-12-14T13:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Show! Don't tell",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Show! Don't tell",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-8035-b659-d0492bd4b43d",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-15T01:32:00.000Z",
        "last_edited_time": "2024-12-15T01:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi mình đã có hệ thống thông tin rõ ràng, luồng thông tin mượt mà, có khi vẫn chưa đủ nếu chủ đề đó phức tạp hoặc quá trừu tượng. Ta cần thêm sự support của các tactics để làm rõ thứ ta đang nói hơn, có vài cách sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi mình đã có hệ thống thông tin rõ ràng, luồng thông tin mượt mà, có khi vẫn chưa đủ nếu chủ đề đó phức tạp hoặc quá trừu tượng. Ta cần thêm sự support của các tactics để làm rõ thứ ta đang nói hơn, có vài cách sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-806f-ac82-c61995d85082",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T09:39:00.000Z",
        "last_edited_time": "2024-12-15T02:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đưa ví dụ/ phép ẩn dụ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đưa ví dụ/ phép ẩn dụ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": càng dính, càng relevant đến background người nghe càng tốt. Vì nó giúp ta tạo kết nối thông tin mới với những thông tin đã biết (nếu cần bạn có thêm xem thêm khái niệm",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": càng dính, càng relevant đến background người nghe càng tốt. Vì nó giúp ta tạo kết nối thông tin mới với những thông tin đã biết (nếu cần bạn có thêm xem thêm khái niệm",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": {
                  "url": "/15c5d16478d8807d8bc1ff2ebee6b096"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": "/15c5d16478d8807d8bc1ff2ebee6b096"
            },
            {
              "type": "text",
              "text": {
                "content": "top down processing",
                "link": {
                  "url": "/73bdf5d9ca494b2789a22dde16b2af7d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "top down processing",
              "href": "/73bdf5d9ca494b2789a22dde16b2af7d"
            },
            {
              "type": "text",
              "text": {
                "content": "). Ví dụ: tăng lead về website mà không cải thiện conversion chẳng khác gì cố bom nước vào một cái thùng đầy lỗ, dù có bơm bao nhiêu nước cũng không đầy.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "). Ví dụ: tăng lead về website mà không cải thiện conversion chẳng khác gì cố bom nước vào một cái thùng đầy lỗ, dù có bơm bao nhiêu nước cũng không đầy.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8055-858e-da3ea9e397a3",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T09:39:00.000Z",
        "last_edited_time": "2024-12-15T01:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tận dụng hình ảnh/ ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tận dụng hình ảnh/ ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "diagram:",
                "link": {
                  "url": "/1235d16478d8809490a1e82eea06a15b"
                }
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "diagram:",
              "href": "/1235d16478d8809490a1e82eea06a15b"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "vì não bộ chúng ta xử lý hình ảnh tốt hơn, nó khiến mọi thứ sống động hơn dễ ghi nhớ hơn. Ví dụ: cách đội nhóm phối hợp với nhau như một ban nhạc vậy, nếu mọi người không phối hợp nhịp điệu tốt với nhau thì bản nhạc sẽ rất khó nghe; Tháp nhu cầu Maslow cho ta thấy rõ các mức độ nhu cầu của một con người từ cơ bản đến sự thoả mãn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "vì não bộ chúng ta xử lý hình ảnh tốt hơn, nó khiến mọi thứ sống động hơn dễ ghi nhớ hơn. Ví dụ: cách đội nhóm phối hợp với nhau như một ban nhạc vậy, nếu mọi người không phối hợp nhịp điệu tốt với nhau thì bản nhạc sẽ rất khó nghe; Tháp nhu cầu Maslow cho ta thấy rõ các mức độ nhu cầu của một con người từ cơ bản đến sự thoả mãn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-8014-a723-eb498293c283",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-15T01:59:00.000Z",
        "last_edited_time": "2024-12-15T02:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tương tác & trải nghiệm minh họa",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tương tác & trải nghiệm minh họa",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": cách này cũng giúp đối phương chuyển từ việc ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": cách này cũng giúp đối phương chuyển từ việc ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "nghe thụ động",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "nghe thụ động",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " sang ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " sang ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "hiểu chủ động ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "hiểu chủ động ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "vì",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "vì",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "bạn để người nghe quan sát và tự rút ra kết luận. Ví dụ thay vì bạn nói “web của mình đang chạy chậm quá” thì bạn mở demo web đó lên cho họ tự xem, họ sẽ hiểu nó chậm như thế nào và tự cảm nhận sự khó chịu trong việc chờ đợi nó load.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "bạn để người nghe quan sát và tự rút ra kết luận. Ví dụ thay vì bạn nói “web của mình đang chạy chậm quá” thì bạn mở demo web đó lên cho họ tự xem, họ sẽ hiểu nó chậm như thế nào và tự cảm nhận sự khó chịu trong việc chờ đợi nó load.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8021-bd79-f9a2179ade6c",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T16:50:00.000Z",
        "last_edited_time": "2024-12-20T11:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đặt câu hỏi cho đối phương",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đặt câu hỏi cho đối phương",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": là lúc bạn cho người nghe có cơ hội liên kết với những dữ liệu quá khứ của họ, do đó khiến việc liên tưởng đến chủ đề tốt hơn. Ví dụ: theo bạn một người có chuyên môn 8 điểm mà khả năng trình bày chỉ có 4 điểm thì người khác sẽ đánh giá khả năng bạn ở mấy điểm? (lúc này họ sẽ liên tưởng xem bản thân mình như thế nào hoặc nghĩ xem liệu có bạn bè, người quen nào rất giỏi nhưng trình bày kém thì kết quả ra sao để đưa ra câu trả lời).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": là lúc bạn cho người nghe có cơ hội liên kết với những dữ liệu quá khứ của họ, do đó khiến việc liên tưởng đến chủ đề tốt hơn. Ví dụ: theo bạn một người có chuyên môn 8 điểm mà khả năng trình bày chỉ có 4 điểm thì người khác sẽ đánh giá khả năng bạn ở mấy điểm? (lúc này họ sẽ liên tưởng xem bản thân mình như thế nào hoặc nghĩ xem liệu có bạn bè, người quen nào rất giỏi nhưng trình bày kém thì kết quả ra sao để đưa ra câu trả lời).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80d4-bc40-cbeb931f8efe",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-11-17T05:03:00.000Z",
        "last_edited_time": "2024-12-15T02:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-8007-b298-ce988d898a65",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-15T02:04:00.000Z",
        "last_edited_time": "2024-12-15T02:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tóm lại",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tóm lại",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80da-bdba-d13d690527c0",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-11-17T05:13:00.000Z",
        "last_edited_time": "2024-12-15T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để khiến nội dung bạn trình bày giúp người nghe dễ hiểu hơn (tốn ít effort cho decoding message) thì hãy đạt được 3 nhiệm vụ sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để khiến nội dung bạn trình bày giúp người nghe dễ hiểu hơn (tốn ít effort cho decoding message) thì hãy đạt được 3 nhiệm vụ sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-80d5-a5b4-dd23628eed3e",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-15T02:05:00.000Z",
        "last_edited_time": "2024-12-15T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hiểu những gì mình nói",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hiểu những gì mình nói",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-8035-b470-e2086928715f",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-15T02:05:00.000Z",
        "last_edited_time": "2024-12-15T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thiết kế luồng thông tin, hay nói dễ hiểu hơn là thiết kế câu chuyện, lên kịch bản những gì bạn sẽ nói",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thiết kế luồng thông tin, hay nói dễ hiểu hơn là thiết kế câu chuyện, lên kịch bản những gì bạn sẽ nói",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-8070-bf7f-cfddc6b72d0b",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-15T02:05:00.000Z",
        "last_edited_time": "2024-12-15T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khiến những gì bạn nói dễ liên tưởng hơn",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khiến những gì bạn nói dễ liên tưởng hơn",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-802d-98b8-ebc6c4d8519a",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-15T02:05:00.000Z",
        "last_edited_time": "2024-12-15T02:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bài viết này khá dài nhưng mong nó đem lại nhiều sự thú vị, lợi ích cho bạn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bài viết này khá dài nhưng mong nó đem lại nhiều sự thú vị, lợi ích cho bạn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-8037-b1fc-d87484c85ade",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-15T08:03:00.000Z",
        "last_edited_time": "2024-12-15T08:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-80e3-960e-ca0ead26577e",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-15T08:03:00.000Z",
        "last_edited_time": "2024-12-15T08:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bonus: sau cùng thì người nghe rút ra được gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bonus: sau cùng thì người nghe rút ra được gì?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-806a-a142-c52fbf76a50a",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-15T08:04:00.000Z",
        "last_edited_time": "2024-12-22T01:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "OK, thông tin mình gửi đi hữu ích đó, trình bày dễ hiểu đó, nhưng não người có giới hạn cho việc ghi nhớ (đường cong quên lãng), vậy nên hãy cố gắng:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "OK, thông tin mình gửi đi hữu ích đó, trình bày dễ hiểu đó, nhưng não người có giới hạn cho việc ghi nhớ (đường cong quên lãng), vậy nên hãy cố gắng:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-8015-b083-d60e4bb6414a",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-15T08:49:00.000Z",
        "last_edited_time": "2024-12-22T01:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giản lược số ý có thể take away, tốt nhất là dưới 3 (có thể là 3 ý tóm gọn hoặc 3 kết luận hữu ích cho việc take next action…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giản lược số ý có thể take away, tốt nhất là dưới 3 (có thể là 3 ý tóm gọn hoặc 3 kết luận hữu ích cho việc take next action…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1635d164-78d8-8085-8cd7-da0ccd10f2e0",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-21T02:30:00.000Z",
        "last_edited_time": "2024-12-22T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mặc dù sau cùng họ nhớ không nhiều, nhưng trong khi trình bày mình phải nói đủ để họ hiểu (cái này thì thường nó không ngắn, từ khái niệm, bản chất, nguyên lí hoạt động & ví dụ thực tiễn...)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mặc dù sau cùng họ nhớ không nhiều, nhưng trong khi trình bày mình phải nói đủ để họ hiểu (cái này thì thường nó không ngắn, từ khái niệm, bản chất, nguyên lí hoạt động & ví dụ thực tiễn...)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-804e-9518-cd755e7ba734",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-15T08:50:00.000Z",
        "last_edited_time": "2024-12-22T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Gửi lại slide hoặc note summary ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Gửi lại slide hoặc note summary ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-80f6-afeb-d18538a5314e",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-24T05:42:00.000Z",
        "last_edited_time": "2024-12-24T05:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "video",
        "video": {
          "caption": [],
          "type": "external",
          "external": {
            "url": "https://www.youtube.com/watch?v=Fsr4yrSAIAQ"
          }
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-81b7-9267-c7fd855ec8e0",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-12T06:30:00.000Z",
        "last_edited_time": "2024-12-14T13:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-812a-8d37-d04ab1173927",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-12T06:30:00.000Z",
        "last_edited_time": "2024-12-14T13:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-811b-b6c3-eb72431eb29a",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-12T06:30:00.000Z",
        "last_edited_time": "2024-12-14T14:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://slideworks.io/resources/mece-mutually-exclusive-collectively-exhaustive",
                "link": {
                  "url": "https://slideworks.io/resources/mece-mutually-exclusive-collectively-exhaustive"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://slideworks.io/resources/mece-mutually-exclusive-collectively-exhaustive",
              "href": "https://slideworks.io/resources/mece-mutually-exclusive-collectively-exhaustive"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-816d-bd9e-df61049fdfb7",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-12T06:30:00.000Z",
        "last_edited_time": "2024-12-14T13:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://productmindset.substack.com/p/mckinseys-pyramid-principle",
                "link": {
                  "url": "https://productmindset.substack.com/p/mckinseys-pyramid-principle"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://productmindset.substack.com/p/mckinseys-pyramid-principle",
              "href": "https://productmindset.substack.com/p/mckinseys-pyramid-principle"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-81d1-86e5-c469f9f95805",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-12T06:30:00.000Z",
        "last_edited_time": "2024-12-14T14:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://plan.io/blog/pyramid-principle-pitching/",
                "link": {
                  "url": "https://plan.io/blog/pyramid-principle-pitching/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://plan.io/blog/pyramid-principle-pitching/",
              "href": "https://plan.io/blog/pyramid-principle-pitching/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25e5d164-78d8-80b9-8c71-c2945c5b8427",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2025-08-29T05:21:00.000Z",
        "last_edited_time": "2025-08-29T05:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.linkedin.com/posts/vincent-angelo-coach_a-complete-guide-to-writing-your-conference-ugcPost-7366831848905179136-SbVH?",
                "link": {
                  "url": "https://www.linkedin.com/posts/vincent-angelo-coach_a-complete-guide-to-writing-your-conference-ugcPost-7366831848905179136-SbVH?utm_medium=ios_app&rcm=ACoAACTxzsYBO4mptTzgsbAc8dNNiYnc142O2IA&utm_source=social_share_send&utm_campaign=copy_link"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.linkedin.com/posts/vincent-angelo-coach_a-complete-guide-to-writing-your-conference-ugcPost-7366831848905179136-SbVH?",
              "href": "https://www.linkedin.com/posts/vincent-angelo-coach_a-complete-guide-to-writing-your-conference-ugcPost-7366831848905179136-SbVH?utm_medium=ios_app&rcm=ACoAACTxzsYBO4mptTzgsbAc8dNNiYnc142O2IA&utm_source=social_share_send&utm_campaign=copy_link"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "778b948e-a107-4bdf-b303-56fb7f42b35e",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T13:58:00.000Z",
        "last_edited_time": "2024-12-14T13:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "9cd18041-db0e-4d32-9aa5-a36c25a06d93",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T13:58:00.000Z",
        "last_edited_time": "2024-12-14T13:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "585a8f11-0c49-4e4b-bd1f-3eddab91fe53",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T13:58:00.000Z",
        "last_edited_time": "2024-12-15T02:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Presenting (P1)",
              "href": "https://app.notion.com/p/15a5d16478d88058b2d5d1d08ced0f2d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3a49a509-c927-4b42-885f-c8cadafacf15",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-14T13:58:00.000Z",
        "last_edited_time": "2024-12-15T02:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mental model?",
              "href": "https://app.notion.com/p/73bdf5d9ca494b2789a22dde16b2af7d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-80e4-9c49-ddfb5ab94e27",
        "parent": {
          "type": "page_id",
          "page_id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
        },
        "created_time": "2024-12-15T02:06:00.000Z",
        "last_edited_time": "2024-12-15T02:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1235d164-78d8-8094-90a1-e82eea06a15b"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Diagram & Canvas",
              "href": "https://app.notion.com/p/1235d16478d8809490a1e82eea06a15b"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d",
    "created_time": "2024-12-12T05:42:00.000Z",
    "last_edited_time": "2024-12-31T05:13:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-12-12T05:42:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "2-Communication",
          "color": "default"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 28
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2024-12-31T05:13:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "prxX",
          "name": "⚔️:2",
          "color": "yellow"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Presenting (P1)",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Presenting (P1)",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Presenting-P1-15a5d16478d88058b2d5d1d08ced0f2d",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Communication",
      "slug": "communication",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "15a5d164-78d8-814b-849b-d018bc019ef0",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-12T06:30:00.000Z",
        "last_edited_time": "2024-12-14T09:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081272/uxcomic-imgs/15a5d164-78d8-814b-849b-d018bc019ef0.png",
            "expiry_time": "2026-10-04T09:11:15.870Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/15a5d164-78d8-814b-849b-d018bc019ef0"
      },
      {
        "object": "block",
        "id": "15b5d164-78d8-80dd-8126-ef630baf2d3b",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-13T05:21:00.000Z",
        "last_edited_time": "2024-12-13T05:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thông qua bài ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thông qua bài ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "principle of communication",
                "link": {
                  "url": "/1405d16478d8801faad4f558038c6ba3"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "principle of communication",
              "href": "/1405d16478d8801faad4f558038c6ba3"
            },
            {
              "type": "text",
              "text": {
                "content": ", ta hiểu được thông điệp bạn chuyền đi, đối phương hiểu nó đến mức độ nào còn tuỳ vào khả năng diễn giải của họ cũng như chịu tác động từ “noise”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", ta hiểu được thông điệp bạn chuyền đi, đối phương hiểu nó đến mức độ nào còn tuỳ vào khả năng diễn giải của họ cũng như chịu tác động từ “noise”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15b5d164-78d8-80d0-ac8e-dbd4b9ab0eac",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-13T05:24:00.000Z",
        "last_edited_time": "2024-12-22T00:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Diễn đạt tốt có thể được định nghĩa lại là quá trình encoding message của mình càng sát với cách người nghe decoding message thì càng tốt, vậy thì cách nào để chúng ta làm chuyện đó?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Diễn đạt tốt có thể được định nghĩa lại là quá trình encoding message của mình càng sát với cách người nghe decoding message thì càng tốt, vậy thì cách nào để chúng ta làm chuyện đó?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15b5d164-78d8-8080-b59e-c7c814a84949",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-13T05:47:00.000Z",
        "last_edited_time": "2024-12-14T04:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "15b5d164-78d8-80c3-b240-eecabb4582e3",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-13T05:47:00.000Z",
        "last_edited_time": "2024-12-13T05:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "1. Rà đúng đài, đúng tần số",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "1. Rà đúng đài, đúng tần số",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-81bf-aa24-fcec23427417",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-12T06:30:00.000Z",
        "last_edited_time": "2024-12-14T14:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Lựa lời mà nói cho vừa lòng nhau” ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Lựa lời mà nói cho vừa lòng nhau” ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "😉",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "😉",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15b5d164-78d8-80b3-b7e3-c49b97b845bc",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-13T05:47:00.000Z",
        "last_edited_time": "2024-12-13T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nói theo ngôn ngữ của họ:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nói theo ngôn ngữ của họ:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " hãy dùng các từ quen thuộc với background của họ. Vì khi bạn đã lựa chọn ngôn ngữ quen thuộc họ, việc họ giải nghĩa thông điệp của bạn sẽ nhanh hơn cũng như giúp đánh vào độ quan tâm của họ. Ví dụ: nhóm người công việc có thể họ thích nghe những từ ngữ chuyên môn, trung lập & ít cảm xúc; nhóm bạn bè thì thích nghe từ ngữ thẳng thắn, dân dã, giàu cảm xúc hơn; nhóm business thích nghe đến như con số, conversion, revenue các thứ hơn…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " hãy dùng các từ quen thuộc với background của họ. Vì khi bạn đã lựa chọn ngôn ngữ quen thuộc họ, việc họ giải nghĩa thông điệp của bạn sẽ nhanh hơn cũng như giúp đánh vào độ quan tâm của họ. Ví dụ: nhóm người công việc có thể họ thích nghe những từ ngữ chuyên môn, trung lập & ít cảm xúc; nhóm bạn bè thì thích nghe từ ngữ thẳng thắn, dân dã, giàu cảm xúc hơn; nhóm business thích nghe đến như con số, conversion, revenue các thứ hơn…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8095-b55c-e4583e24e6de",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-14T04:39:00.000Z",
        "last_edited_time": "2024-12-14T09:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081274/uxcomic-imgs/15c5d164-78d8-8095-b55c-e4583e24e6de.png",
            "expiry_time": "2026-10-04T09:11:15.870Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/15c5d164-78d8-8095-b55c-e4583e24e6de"
      },
      {
        "object": "block",
        "id": "15b5d164-78d8-801a-b690-c30401539691",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-13T05:49:00.000Z",
        "last_edited_time": "2024-12-13T11:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hiểu mối quan tâm của họ là gì: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hiểu mối quan tâm của họ là gì: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "chúng ta không phải ai cũng có kiên nhẫn ngồi lắng nghe hết tất cả các ý trong buổi trò chuyện, vô thức hay cố ý thì chúng ta đều đã có sẵn một bộ lọc thông tin trong đầu, bộ lọc này có thể chia làm 2, đó là thông tin đó kích thích sự ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "chúng ta không phải ai cũng có kiên nhẫn ngồi lắng nghe hết tất cả các ý trong buổi trò chuyện, vô thức hay cố ý thì chúng ta đều đã có sẵn một bộ lọc thông tin trong đầu, bộ lọc này có thể chia làm 2, đó là thông tin đó kích thích sự ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "ham muốn",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "ham muốn",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " gì đó hoặc cảnh báo cho ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " gì đó hoặc cảnh báo cho ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "mối nguy hại ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "mối nguy hại ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "gì đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "gì đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-80c1-87ef-d31fe321609a",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-14T15:29:00.000Z",
        "last_edited_time": "2024-12-14T15:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Key ở đây là có ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Key ở đây là có ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "“liên quan” ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“liên quan” ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "gì tới tôi k?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "gì tới tôi k?",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "😑",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "😑",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15b5d164-78d8-805f-8b53-fd3bed7fb172",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-13T05:53:00.000Z",
        "last_edited_time": "2024-12-13T11:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: trong cuộc họp có khi dev không quan tâm lắm đến cách design hình thành solution thế nào, họ chỉ cần nắm solution này có function nào, các edge case là gì, liệu nó có ảnh hưởng lên các vị trí khác hay tác động gì đến sever, performance hay không. Hoặc khi ai đó không có nhu cầu lắng nghe về idea từ đầu, thì đối với họ idea bạn sắp nói chỉ mang tính chất tham khảo, cân nhắc thêm thì bạn phải trình bày & nhấn mạnh về benefit trước tiên để thuyết phục tốt hơn thay vì bắt đầu buổi trò chuyện bằng việc phân tích problem.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: trong cuộc họp có khi dev không quan tâm lắm đến cách design hình thành solution thế nào, họ chỉ cần nắm solution này có function nào, các edge case là gì, liệu nó có ảnh hưởng lên các vị trí khác hay tác động gì đến sever, performance hay không. Hoặc khi ai đó không có nhu cầu lắng nghe về idea từ đầu, thì đối với họ idea bạn sắp nói chỉ mang tính chất tham khảo, cân nhắc thêm thì bạn phải trình bày & nhấn mạnh về benefit trước tiên để thuyết phục tốt hơn thay vì bắt đầu buổi trò chuyện bằng việc phân tích problem.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15b5d164-78d8-800f-8f52-f19d97c69017",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-13T05:57:00.000Z",
        "last_edited_time": "2024-12-14T09:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "15b5d164-78d8-80b3-b9d9-f096ee2e4a66",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-13T05:57:00.000Z",
        "last_edited_time": "2024-12-14T14:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "2. Nói có hệ thống",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2. Nói có hệ thống",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-804a-b4cb-c37a73601b04",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-14T04:41:00.000Z",
        "last_edited_time": "2024-12-14T04:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nghe có lý không, nghe có mệt không? 🤪",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nghe có lý không, nghe có mệt không? 🤪",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15b5d164-78d8-80c9-82a5-c60651a7c550",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-13T11:22:00.000Z",
        "last_edited_time": "2024-12-22T01:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vì người nghe sẽ cần phải giải nghĩa (decoding) thông điệp bạn nói, nó liên quan đến quá trình ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vì người nghe sẽ cần phải giải nghĩa (decoding) thông điệp bạn nói, nó liên quan đến quá trình ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "sense making",
                "link": {
                  "url": "/1195d16478d880cda21ff9d0e90ae7b8"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "sense making",
              "href": "/1195d16478d880cda21ff9d0e90ae7b8"
            },
            {
              "type": "text",
              "text": {
                "content": ", nếu tưởng tượng việc make sense thông tin như một phương trình toán học: (A+B)xC=D thì người nghe cần có thông tin A,B,C và sự lập luận, diễn giải mối liên hệ giữa chúng (+,x) để làm sao tạo ra được D. Khi bạn nói mà không có structure đồng nghĩa người nghe phải bỏ sức ra để tập trung & sắp xếp các thông tin bạn đưa ra, họ phải tự hình dung các phép tính (+,x) >> họ tốn effort khi nghe bạn trình bày, đồng thời khả năng họ sẽ hiểu sai vấn đề.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", nếu tưởng tượng việc make sense thông tin như một phương trình toán học: (A+B)xC=D thì người nghe cần có thông tin A,B,C và sự lập luận, diễn giải mối liên hệ giữa chúng (+,x) để làm sao tạo ra được D. Khi bạn nói mà không có structure đồng nghĩa người nghe phải bỏ sức ra để tập trung & sắp xếp các thông tin bạn đưa ra, họ phải tự hình dung các phép tính (+,x) >> họ tốn effort khi nghe bạn trình bày, đồng thời khả năng họ sẽ hiểu sai vấn đề.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8059-b2ed-d04c20b3be81",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-14T04:46:00.000Z",
        "last_edited_time": "2024-12-22T01:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nên một nội dung có hệ thống sẽ giúp người nghe dễ định vị xem các ý nằm đâu trong câu chuyện tồng thể, giảm tải effort sense making, đồng thời cũng giúp dễ ghi nhớ hơn, phần nào đó nó cũng khiến họ tò mò hơn (kiểu như khi mình xem phim, có những lúc mới đang ở giữa câu chuyện mà mình luôn thắc mắc xem nhân vật này có thực sự tốt hay không, liệu cái kết nó ra sao, bla bla).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nên một nội dung có hệ thống sẽ giúp người nghe dễ định vị xem các ý nằm đâu trong câu chuyện tồng thể, giảm tải effort sense making, đồng thời cũng giúp dễ ghi nhớ hơn, phần nào đó nó cũng khiến họ tò mò hơn (kiểu như khi mình xem phim, có những lúc mới đang ở giữa câu chuyện mà mình luôn thắc mắc xem nhân vật này có thực sự tốt hay không, liệu cái kết nó ra sao, bla bla).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15b5d164-78d8-8070-ad0e-c1d076b8cb74",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-13T11:24:00.000Z",
        "last_edited_time": "2024-12-22T01:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để minh họa thêm, có thể xem việc truyền đạt như cách ta offer các món ăn vậy, nếu bạn cho quá ít thì sẽ không no, quá nhiều thì sẽ dẫn đến ngán ăn, việc xào nấu cũng rất quan trọng (nếu bạn mix nguyên liệu bún với kem thì sẽ rất ghê phải không), khẩu vị của mọi người cũng khác nhau, và nếu mình trình bày nó lởm thì ăn cũng kém ngon.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để minh họa thêm, có thể xem việc truyền đạt như cách ta offer các món ăn vậy, nếu bạn cho quá ít thì sẽ không no, quá nhiều thì sẽ dẫn đến ngán ăn, việc xào nấu cũng rất quan trọng (nếu bạn mix nguyên liệu bún với kem thì sẽ rất ghê phải không), khẩu vị của mọi người cũng khác nhau, và nếu mình trình bày nó lởm thì ăn cũng kém ngon.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-80f6-ac8a-f3ebc4a86fc7",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-14T04:38:00.000Z",
        "last_edited_time": "2024-12-14T04:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081276/uxcomic-imgs/15c5d164-78d8-80f6-ac8a-f3ebc4a86fc7.png",
            "expiry_time": "2026-10-04T09:11:15.871Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/15c5d164-78d8-80f6-ac8a-f3ebc4a86fc7"
      },
      {
        "object": "block",
        "id": "15b5d164-78d8-80b4-ac48-e61c7d61276f",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-13T11:29:00.000Z",
        "last_edited_time": "2024-12-14T09:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tương tự hệ thống thông tin để gửi đi cũng work như vậy:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tương tự hệ thống thông tin để gửi đi cũng work như vậy:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8028-9514-eae1c01687dd",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-14T09:31:00.000Z",
        "last_edited_time": "2024-12-22T01:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu bạn nói quá nhanh hay quá nhiều thông tin một lúc cũng giống như ép họ ăn nhanh, ăn nhiều một lúc vậy. Ngon thì ăn cũng mệt, mà dở thì chắc bỏ chạy luôn :)).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu bạn nói quá nhanh hay quá nhiều thông tin một lúc cũng giống như ép họ ăn nhanh, ăn nhiều một lúc vậy. Ngon thì ăn cũng mệt, mà dở thì chắc bỏ chạy luôn :)).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-800a-9a03-c107ffb5d7be",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-14T09:32:00.000Z",
        "last_edited_time": "2024-12-22T01:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách bạn mix nguyên liệu cũng như cách bạn lý luận trình bày, mọi thứ nên có tính liên quan & bổ trợ nhau.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách bạn mix nguyên liệu cũng như cách bạn lý luận trình bày, mọi thứ nên có tính liên quan & bổ trợ nhau.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-8002-a136-d5d4fcd0a97d",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-14T09:32:00.000Z",
        "last_edited_time": "2024-12-14T09:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách trình bày dĩa thức ăn như hình thức bạn diễn đạt nó, là tone giọng, là nhấn nhá, là slide gọn gàng, là những cảm xúc trong từng câu chữ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách trình bày dĩa thức ăn như hình thức bạn diễn đạt nó, là tone giọng, là nhấn nhá, là slide gọn gàng, là những cảm xúc trong từng câu chữ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-801b-84f7-c1da4cf86eb3",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-14T14:01:00.000Z",
        "last_edited_time": "2024-12-14T14:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Do bài viết cũng hơi dài rồi, nên cụ thể HOW - cách nào để nói có hệ thống, thì mình dành qua ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Do bài viết cũng hơi dài rồi, nên cụ thể HOW - cách nào để nói có hệ thống, thì mình dành qua ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "phần 2 ",
                "link": {
                  "url": "/15c5d16478d8807d8bc1ff2ebee6b096"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "phần 2 ",
              "href": "/15c5d16478d8807d8bc1ff2ebee6b096"
            },
            {
              "type": "text",
              "text": {
                "content": "nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-8128-ba15-f22ddf295bab",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-12T06:30:00.000Z",
        "last_edited_time": "2024-12-12T06:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-81b6-8fe0-da11bc430a94",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-12T06:30:00.000Z",
        "last_edited_time": "2024-12-12T06:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-8113-b850-cec38c0b8ae2",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-12T06:30:00.000Z",
        "last_edited_time": "2024-12-14T14:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "15c5d164-78d8-807d-8bc1-ff2ebee6b096"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Presenting (P2)",
              "href": "https://app.notion.com/p/15c5d16478d8807d8bc1ff2ebee6b096"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-803a-947a-da061b165623",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-14T14:01:00.000Z",
        "last_edited_time": "2024-12-14T14:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sense making",
              "href": "https://app.notion.com/p/1195d16478d880cda21ff9d0e90ae7b8"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-8104-8717-cf1ae99f38a3",
        "parent": {
          "type": "page_id",
          "page_id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
        },
        "created_time": "2024-12-12T06:30:00.000Z",
        "last_edited_time": "2024-12-14T14:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1405d164-78d8-801f-aad4-f558038c6ba3"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Principle of Communication",
              "href": "https://app.notion.com/p/1405d16478d8801faad4f558038c6ba3"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1585d164-78d8-803a-9506-fed5673c611f",
    "created_time": "2024-12-10T12:46:00.000Z",
    "last_edited_time": "2025-10-15T02:02:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-12-10T12:46:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "3-Workflow",
          "color": "default"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 27
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-10-15T02:02:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "prxX",
          "name": "⚔️:2",
          "color": "yellow"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Meeting (P1)",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Meeting (P1)",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Meeting-P1-1585d16478d8803a9506fed5673c611f",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
      "name": "Workflow",
      "slug": "workflow",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "1585d164-78d8-812b-b2a0-ffc4346dcdad",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T12:46:00.000Z",
        "last_edited_time": "2024-12-14T09:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081279/uxcomic-imgs/1585d164-78d8-812b-b2a0-ffc4346dcdad.png",
            "expiry_time": "2026-10-04T09:11:16.665Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1585d164-78d8-812b-b2a0-ffc4346dcdad"
      },
      {
        "object": "block",
        "id": "1585d164-78d8-814b-9706-d051041d70c4",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T12:46:00.000Z",
        "last_edited_time": "2024-12-23T11:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Những năm gần đây, mình được vào làm việc ở một môi trường có các buổi meeting nhiều hơn, cũng như các stakeholder cũng gấp 3,4 lần so với trước đó. Nỗi đau bắt đầu xuất hiện, mình bắt đầu thấy dễ nhức nhức cái đầu hơn =)) vì có quá nhiều thông tin cần phải xử lý, phải loay hoay tìm cách truyền đạt tốt hơn cho những lúc trình bày hoặc propose solutions, sau buổi họp thì dễ quên này quên kia…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Những năm gần đây, mình được vào làm việc ở một môi trường có các buổi meeting nhiều hơn, cũng như các stakeholder cũng gấp 3,4 lần so với trước đó. Nỗi đau bắt đầu xuất hiện, mình bắt đầu thấy dễ nhức nhức cái đầu hơn =)) vì có quá nhiều thông tin cần phải xử lý, phải loay hoay tìm cách truyền đạt tốt hơn cho những lúc trình bày hoặc propose solutions, sau buổi họp thì dễ quên này quên kia…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-805f-b37d-fedf88d22032",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T16:02:00.000Z",
        "last_edited_time": "2024-12-23T11:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Câu hỏi mình đặt ra là: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Câu hỏi mình đặt ra là: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "“Như thế nào là một buổi họp tốt, liệu có những phương pháp nào để mình linh hoạt ứng dụng được cho các buổi meeting?”",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Như thế nào là một buổi họp tốt, liệu có những phương pháp nào để mình linh hoạt ứng dụng được cho các buổi meeting?”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "21c5d164-78d8-8072-9f76-eaf62e3eeb80",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2025-06-24T06:22:00.000Z",
        "last_edited_time": "2025-06-24T06:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: có nhiều loại meeting lém, nhưng trong bài viết này chắc mình chỉ nói về các buổi decision / catchup meeting.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: có nhiều loại meeting lém, nhưng trong bài viết này chắc mình chỉ nói về các buổi decision / catchup meeting.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1595d164-78d8-807c-aa7e-c179b429ece7",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-11T01:39:00.000Z",
        "last_edited_time": "2024-12-11T01:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1595d164-78d8-8088-a597-e2c5ffaba433",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-11T01:39:00.000Z",
        "last_edited_time": "2025-06-24T06:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_1",
        "heading_1": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hiểu - Trước hết tại sao ta họp?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hiểu - Trước hết tại sao ta họp?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15f5d164-78d8-809c-8bb1-e56ff94534df",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-17T05:30:00.000Z",
        "last_edited_time": "2024-12-23T11:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Họp giúp chúng ta tăng tính tương tác, thảo luận để dễ đi đến sự đồng thuận & ra quyết định, nói cách khác nó là quá trình ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Họp giúp chúng ta tăng tính tương tác, thảo luận để dễ đi đến sự đồng thuận & ra quyết định, nói cách khác nó là quá trình ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "sense making",
                "link": {
                  "url": "/1195d16478d880cda21ff9d0e90ae7b8"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "sense making",
              "href": "/1195d16478d880cda21ff9d0e90ae7b8"
            },
            {
              "type": "text",
              "text": {
                "content": " ở phạm vi nhóm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ở phạm vi nhóm.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-8103-b738-f423f919058f",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T12:46:00.000Z",
        "last_edited_time": "2024-12-17T05:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nghĩ lại thì mình thấy có vài tình huống sau cần họp:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nghĩ lại thì mình thấy có vài tình huống sau cần họp:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-801e-8f2f-ccf25fc9a5e3",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T15:00:00.000Z",
        "last_edited_time": "2024-12-17T05:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi cần có sự tham gia của nhiều người.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi cần có sự tham gia của nhiều người.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1585d164-78d8-8085-8419-d68f282140ab",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T15:00:00.000Z",
        "last_edited_time": "2024-12-23T11:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi cần trao đổi nhiều, có thể là vì có quá nhiều topic, hoặc topic đang quá mơ hồ >> cần thêm nhiều thông tin & input của mọi người.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi cần trao đổi nhiều, có thể là vì có quá nhiều topic, hoặc topic đang quá mơ hồ >> cần thêm nhiều thông tin & input của mọi người.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "15f5d164-78d8-806a-94f8-c15cfaf2dd06",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-17T05:20:00.000Z",
        "last_edited_time": "2024-12-17T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi cần nhiều sự tương tác hơn, ví dụ cần cả đội nhóm tích cực thảo luận để đánh giá & đóng góp ý kiến…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi cần nhiều sự tương tác hơn, ví dụ cần cả đội nhóm tích cực thảo luận để đánh giá & đóng góp ý kiến…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "1585d164-78d8-8009-8f39-eedefe6184b9",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T15:01:00.000Z",
        "last_edited_time": "2024-12-17T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi topic đó quan trọng & chúng ta không muốn có bất kỳ sự hiểu lầm nào hoặc chúng ta cần để ý nhiều hơn đến tâm lý đối phương.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi topic đó quan trọng & chúng ta không muốn có bất kỳ sự hiểu lầm nào hoặc chúng ta cần để ý nhiều hơn đến tâm lý đối phương.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 3
      },
      {
        "object": "block",
        "id": "15c5d164-78d8-80cf-8c93-f9a4e2bca9b8",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-14T03:36:00.000Z",
        "last_edited_time": "2024-12-23T11:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [
            {
              "type": "text",
              "text": {
                "content": "Hình không liên quan gì mà mình thấy vui vui :))",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hình không liên quan gì mà mình thấy vui vui :))",
              "href": null
            }
          ],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081280/uxcomic-imgs/15c5d164-78d8-80cf-8c93-f9a4e2bca9b8.jpg",
            "expiry_time": "2026-10-04T09:11:16.665Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/15c5d164-78d8-80cf-8c93-f9a4e2bca9b8"
      },
      {
        "object": "block",
        "id": "1585d164-78d8-802d-80a9-d8455507512b",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T15:02:00.000Z",
        "last_edited_time": "2025-06-24T06:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một buổi meeting có gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một buổi meeting có gì?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-8059-9e35-e2e10f70d15e",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T15:04:00.000Z",
        "last_edited_time": "2024-12-10T15:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Người nói, người nghe",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Người nói, người nghe",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1585d164-78d8-80be-8e0f-d603dc43766a",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T15:04:00.000Z",
        "last_edited_time": "2024-12-23T11:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chủ đề -",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chủ đề -",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " một buổi meeting sẽ có tính chủ đích rõ ràng hơn một buổi giao tiếp thông thường. Ta cần có agenda, những gì cần thảo luận & những gì cần rút ra hoặc chốt sau buổi họp. Đây là cốt lõi của việc meeting.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " một buổi meeting sẽ có tính chủ đích rõ ràng hơn một buổi giao tiếp thông thường. Ta cần có agenda, những gì cần thảo luận & những gì cần rút ra hoặc chốt sau buổi họp. Đây là cốt lõi của việc meeting.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1585d164-78d8-801c-9d9d-cff9e683cb61",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T15:10:00.000Z",
        "last_edited_time": "2024-12-23T11:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Không khí buổi họp / tình huống 😃 🥱",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Không khí buổi họp / tình huống 😃 🥱",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "21c5d164-78d8-808b-be33-fd98a84e8de5",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2025-06-24T06:28:00.000Z",
        "last_edited_time": "2025-06-24T06:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-806a-8c2b-fc428560c801",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T15:16:00.000Z",
        "last_edited_time": "2025-06-24T06:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy như thế nào là một buổi họp tốt, đừng tệ là được?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy như thế nào là một buổi họp tốt, đừng tệ là được?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-805b-99f2-f6a454e3276a",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T15:16:00.000Z",
        "last_edited_time": "2025-06-24T06:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mất thời gian:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mất thời gian:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " sau buổi meeting, mọi người lan man, hoang mang không rút tỉa được gì cũng như không hiểu next action ra sao > buổi meeting không có giá trị rõ ràng. Thậm chí có những nội dung đôi khi vài người còn không cần thiết phải có mặt trong buổi họp. Nếu nhìn thời gian là tiền bạc thì ta cần hạn chế sự lãng phí này, chỉ mời ai liên quan, chỉ thảo luận những nội dung liên quan, và cân nhắc luôn nếu thấy không cần thiết phải họp thì hãy cắt giảm nó, thay vào đó sử dụng một hình thức giao tiếp khác, ví dụ như chat, document, record…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " sau buổi meeting, mọi người lan man, hoang mang không rút tỉa được gì cũng như không hiểu next action ra sao > buổi meeting không có giá trị rõ ràng. Thậm chí có những nội dung đôi khi vài người còn không cần thiết phải có mặt trong buổi họp. Nếu nhìn thời gian là tiền bạc thì ta cần hạn chế sự lãng phí này, chỉ mời ai liên quan, chỉ thảo luận những nội dung liên quan, và cân nhắc luôn nếu thấy không cần thiết phải họp thì hãy cắt giảm nó, thay vào đó sử dụng một hình thức giao tiếp khác, ví dụ như chat, document, record…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-80a9-83e3-e04343081eb9",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T15:17:00.000Z",
        "last_edited_time": "2024-12-23T11:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dài dòng mà không cần thiết, ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dài dòng mà không cần thiết, ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "ví dụ: thảo luận các chi tiết nhỏ, lạc đề, dông dài lê thê. Có những thứ bạn chỉ cần gửi kèm tài liệu hay link để tìm hiểu sau.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "ví dụ: thảo luận các chi tiết nhỏ, lạc đề, dông dài lê thê. Có những thứ bạn chỉ cần gửi kèm tài liệu hay link để tìm hiểu sau.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-80d6-b31e-ed9a69f564ea",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T15:24:00.000Z",
        "last_edited_time": "2024-12-17T05:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thảo luận kém",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thảo luận kém",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", đặc biệt là topic cần đến sự thảo luận, có thể do buổi meeting ở cuối ngày nên mọi người đã mệt hết năng lượng, hoặc các thành viên ngại đóng góp, hoặc ngược lại quá đông người dẫn đến quá nhiều ý kiến mà không thể đồng thuận, hoặc có khi chỉ đơn giản là các thành viên không thích họp,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", đặc biệt là topic cần đến sự thảo luận, có thể do buổi meeting ở cuối ngày nên mọi người đã mệt hết năng lượng, hoặc các thành viên ngại đóng góp, hoặc ngược lại quá đông người dẫn đến quá nhiều ý kiến mà không thể đồng thuận, hoặc có khi chỉ đơn giản là các thành viên không thích họp,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-805c-84f7-cc8ebe34e554",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T15:11:00.000Z",
        "last_edited_time": "2024-12-10T15:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-81ec-9c27-d5e1d751b28e",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T12:46:00.000Z",
        "last_edited_time": "2025-06-24T06:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_1",
        "heading_1": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách (How)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách (How)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-81bf-bf0a-c738f805fb67",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T12:46:00.000Z",
        "last_edited_time": "2024-12-17T05:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Về căn bản meeting vẫn là giao tiếp, mà giao tiếp thì có người nói người nghe, có thông điệp, có trao đổi, có phản hồi,… chỉ khác meeting sẽ luôn có những chủ đề rõ ràng từ đầu & những mục tiêu cụ thể cần chốt/ nắm sau buổi họp. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Về căn bản meeting vẫn là giao tiếp, mà giao tiếp thì có người nói người nghe, có thông điệp, có trao đổi, có phản hồi,… chỉ khác meeting sẽ luôn có những chủ đề rõ ràng từ đầu & những mục tiêu cụ thể cần chốt/ nắm sau buổi họp. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15f5d164-78d8-8065-ba45-de0165317321",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-17T05:29:00.000Z",
        "last_edited_time": "2024-12-23T11:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ah còn một cái mình thấy khác nữa là độ thông tin, áp lực trong buổi meeting có thể nhiều hơn một buổi trò chuyện thông thường.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ah còn một cái mình thấy khác nữa là độ thông tin, áp lực trong buổi meeting có thể nhiều hơn một buổi trò chuyện thông thường.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-8098-83a8-ccf722ca24c3",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T15:42:00.000Z",
        "last_edited_time": "2024-12-17T05:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy theo mình có 3 thứ chính cần handle trong meeting là: Mục tiêu; Thông điệp & Tình huống",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy theo mình có 3 thứ chính cần handle trong meeting là: Mục tiêu; Thông điệp & Tình huống",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-800c-a6e4-da3edc1656fe",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T15:53:00.000Z",
        "last_edited_time": "2024-12-11T05:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "1/ Mục tiêu: buổi họp này để làm gì?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "1/ Mục tiêu: buổi họp này để làm gì?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-80a3-bf92-f3baf71086c5",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T15:54:00.000Z",
        "last_edited_time": "2024-12-23T11:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nắm mục tiêu là bước đầu tiên luôn cần làm cho một buổi meeting. Mục tiêu cho bạn biết cần phải ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nắm mục tiêu là bước đầu tiên luôn cần làm cho một buổi meeting. Mục tiêu cho bạn biết cần phải ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "mời ai vào họp,",
                "link": {
                  "url": "/1185d16478d88014bdf1e631b28f601e"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "mời ai vào họp,",
              "href": "/1185d16478d88014bdf1e631b28f601e"
            },
            {
              "type": "text",
              "text": {
                "content": " cần phải bàn những chủ đề nào, cần truyền đạt nó ra sao (vui vẻ, khơi mở hay nghiêm túc), & đánh giá xem liệu với mục tiêu đó có nhất thiết phải họp hay không?… ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " cần phải bàn những chủ đề nào, cần truyền đạt nó ra sao (vui vẻ, khơi mở hay nghiêm túc), & đánh giá xem liệu với mục tiêu đó có nhất thiết phải họp hay không?… ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-80b9-9be9-c7b03d1b9929",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T16:27:00.000Z",
        "last_edited_time": "2024-12-11T01:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vài mục tiêu phổ biến như: kick-off, catchup, discuss, brainstorming, decision making, retrospective…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vài mục tiêu phổ biến như: kick-off, catchup, discuss, brainstorming, decision making, retrospective…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2545d164-78d8-8036-90f2-c67600ff48f4",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2025-08-19T02:47:00.000Z",
        "last_edited_time": "2025-08-19T02:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tip: mình hay hình dung trạng thái “before” & “after” của buổi họp để nghĩ về mục tiêu của buổi meeting.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tip: mình hay hình dung trạng thái “before” & “after” của buổi họp để nghĩ về mục tiêu của buổi meeting.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-80c3-b26b-ebdabe3425ec",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-12T02:33:00.000Z",
        "last_edited_time": "2024-12-12T03:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081281/uxcomic-imgs/15a5d164-78d8-80c3-b26b-ebdabe3425ec.png",
            "expiry_time": "2026-10-04T09:11:16.742Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/15a5d164-78d8-80c3-b26b-ebdabe3425ec"
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-8072-a806-f177fe4969ea",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-12T02:45:00.000Z",
        "last_edited_time": "2024-12-12T02:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-8092-b75b-ea9e2da2b1b8",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T16:04:00.000Z",
        "last_edited_time": "2024-12-11T05:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "2/ Thông điệp: nó là gì & nên thảo luận nó ra sao?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2/ Thông điệp: nó là gì & nên thảo luận nó ra sao?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-80a0-ae7d-fc6de5a59214",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-12T02:30:00.000Z",
        "last_edited_time": "2024-12-12T03:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081283/uxcomic-imgs/15a5d164-78d8-80a0-ae7d-fc6de5a59214.png",
            "expiry_time": "2026-10-04T09:11:16.743Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/15a5d164-78d8-80a0-ae7d-fc6de5a59214"
      },
      {
        "object": "block",
        "id": "1585d164-78d8-80ad-ae19-fed28a75f1c0",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T16:05:00.000Z",
        "last_edited_time": "2024-12-12T02:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lại lôi ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lại lôi ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "sense making",
                "link": {
                  "url": "/1195d16478d880cda21ff9d0e90ae7b8"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "sense making",
              "href": "/1195d16478d880cda21ff9d0e90ae7b8"
            },
            {
              "type": "text",
              "text": {
                "content": " ra nói =)). Cái hiểu được hình thành từ việc ta gắn ngữ nghĩa cho thông tin và liên kết chúng lại để tạo thành một câu chuyện có tính structure.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ra nói =)). Cái hiểu được hình thành từ việc ta gắn ngữ nghĩa cho thông tin và liên kết chúng lại để tạo thành một câu chuyện có tính structure.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-80be-9a09-eddecdea8070",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T16:09:00.000Z",
        "last_edited_time": "2024-12-12T02:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nên 3 thứ cần quan tâm khi thiết kế buổi họp",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nên 3 thứ cần quan tâm khi thiết kế buổi họp",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-80c6-921c-c642e54acc41",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T16:11:00.000Z",
        "last_edited_time": "2024-12-14T03:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lượng thông tin",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lượng thông tin",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (nếu nhiều thì chia nhỏ ra để dễ nắm, dễ tập trung để xử lý thông tin)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (nếu nhiều thì chia nhỏ ra để dễ nắm, dễ tập trung để xử lý thông tin)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-8008-aaaf-f8889058b8fb",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T16:11:00.000Z",
        "last_edited_time": "2024-12-14T03:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Độ uy tín của thông tin",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Độ uy tín của thông tin",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (nó được base trên dẫn chứng nào, trên nghiên cứu nào)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (nó được base trên dẫn chứng nào, trên nghiên cứu nào)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-8034-ac49-f011fdc716f0",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T16:12:00.000Z",
        "last_edited_time": "2024-12-23T11:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dẫn dắt",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dẫn dắt",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " - là khả năng mốc nối các thông tin, nhìn nó dưới sự liên hệ (bạn có thể tham khảo",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " - là khả năng mốc nối các thông tin, nhìn nó dưới sự liên hệ (bạn có thể tham khảo",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " bài viết này",
                "link": {
                  "url": "/1225d16478d880db8d9be6cc64d11314"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " bài viết này",
              "href": "/1225d16478d880db8d9be6cc64d11314"
            },
            {
              "type": "text",
              "text": {
                "content": "). Làm sao để giữa các điểm thông tin đó ta lập luận được một câu chuyện make sense & mọi người có thể get được thông điệp đó. Mình có nghe qua một ẩn dụ khá hay: khi bạn là người lead buổi họp, bạn giống như là một tour guide vậy, việc cần làm là không để các khách du lịch lạc tour, khuyến khích, truyền cảm hứng & quan tâm họ để có một chuyến đi thú vị. Vậy ta phải ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "). Làm sao để giữa các điểm thông tin đó ta lập luận được một câu chuyện make sense & mọi người có thể get được thông điệp đó. Mình có nghe qua một ẩn dụ khá hay: khi bạn là người lead buổi họp, bạn giống như là một tour guide vậy, việc cần làm là không để các khách du lịch lạc tour, khuyến khích, truyền cảm hứng & quan tâm họ để có một chuyến đi thú vị. Vậy ta phải ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "làm thế nào",
                "link": {
                  "url": "/15a5d16478d88058b2d5d1d08ced0f2d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "làm thế nào",
              "href": "/15a5d16478d88058b2d5d1d08ced0f2d"
            },
            {
              "type": "text",
              "text": {
                "content": "?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "1585d164-78d8-80ef-a517-c910eb8a6e61",
            "parent": {
              "type": "block_id",
              "block_id": "1585d164-78d8-8034-ac49-f011fdc716f0"
            },
            "created_time": "2024-12-10T16:18:00.000Z",
            "last_edited_time": "2024-12-12T02:49:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Truyền đạt nó theo một ",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Truyền đạt nó theo một ",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": "cấu trúc",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "cấu trúc",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": " rõ ràng, cấu trúc này cũng nên linh hoạt tuỳ theo mục tiêu & mối quan tâm của người nghe. Ví dụ: [what, so what, now what]; [problem; solution; benefit], [objective, options, evaluation, decision]…Điều này rất rất quan trọng, vì khi không có structure khả năng hiểu cả mình & người nghe đều không tốt, khi có structure giúp ta tránh lan man cũng như dễ ghi nhớ các ý cần phải nói hơn, nó đóng vai như một tấm bản đồ để bạn là một tour guide dẫn mọi người đi hết điểm này sang điểm khác.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": " rõ ràng, cấu trúc này cũng nên linh hoạt tuỳ theo mục tiêu & mối quan tâm của người nghe. Ví dụ: [what, so what, now what]; [problem; solution; benefit], [objective, options, evaluation, decision]…Điều này rất rất quan trọng, vì khi không có structure khả năng hiểu cả mình & người nghe đều không tốt, khi có structure giúp ta tránh lan man cũng như dễ ghi nhớ các ý cần phải nói hơn, nó đóng vai như một tấm bản đồ để bạn là một tour guide dẫn mọi người đi hết điểm này sang điểm khác.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1585d164-78d8-8067-9c62-c8622aa65dc9",
            "parent": {
              "type": "block_id",
              "block_id": "1585d164-78d8-8034-ac49-f011fdc716f0"
            },
            "created_time": "2024-12-10T16:18:00.000Z",
            "last_edited_time": "2024-12-14T03:41:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Cung cấp ví dụ",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Cung cấp ví dụ",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": " để họ dễ hình dung, bổ trợ cho việc giải nghĩa, giúp họ hiểu tốt ý bạn đang truyền đạt.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": " để họ dễ hình dung, bổ trợ cho việc giải nghĩa, giúp họ hiểu tốt ý bạn đang truyền đạt.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1585d164-78d8-805b-a788-e6e1e10fa33b",
            "parent": {
              "type": "block_id",
              "block_id": "1585d164-78d8-8034-ac49-f011fdc716f0"
            },
            "created_time": "2024-12-10T16:19:00.000Z",
            "last_edited_time": "2024-12-14T03:42:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Cần có vài tactics để họ ",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Cần có vài tactics để họ ",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": "engage",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "engage",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": " vào buổi meeting tốt hơn. Ví dụ: khơi dậy sự tò mò, game, joke, bất ngờ, story telling,… Một điểm cũng rất quan trọng đó chính là không khí của buổi họp, nghĩa vụ của mình (nếu bạn chair the meeting) là để ý energy của các thành viên, thúc đẩy sự thảo luận, khiến thành viên tích cực lắng nghe, trao đổi & bám sát vào mục tiêu đề ra, có thể coi đây liên quan đến",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": " vào buổi meeting tốt hơn. Ví dụ: khơi dậy sự tò mò, game, joke, bất ngờ, story telling,… Một điểm cũng rất quan trọng đó chính là không khí của buổi họp, nghĩa vụ của mình (nếu bạn chair the meeting) là để ý energy của các thành viên, thúc đẩy sự thảo luận, khiến thành viên tích cực lắng nghe, trao đổi & bám sát vào mục tiêu đề ra, có thể coi đây liên quan đến",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": " kĩ năng facilitate",
                    "link": {
                      "url": "/ff81ff8ab21e4952a5f78e1b1714f022"
                    }
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": " kĩ năng facilitate",
                  "href": "/ff81ff8ab21e4952a5f78e1b1714f022"
                },
                {
                  "type": "text",
                  "text": {
                    "content": ".",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": ".",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "1595d164-78d8-8042-af46-efa65e3219a9",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-11T02:00:00.000Z",
        "last_edited_time": "2024-12-11T02:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1595d164-78d8-8098-b615-f9fe2780a713",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-11T02:00:00.000Z",
        "last_edited_time": "2024-12-11T05:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "3/ Tình huống: nhận diện & ứng phó",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3/ Tình huống: nhận diện & ứng phó",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1595d164-78d8-806c-8ef0-f090441f7e3d",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-11T02:00:00.000Z",
        "last_edited_time": "2024-12-23T11:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong buổi meeting, theo mình thấy nó hiệu quả khi các thành viên có sự trao đổi nhiều, nhiều ý kiến được xem xét, nhiều góc nhìn, nhiều sự cân nhắc trước khi đi đến một sự đồng thuận, một decision nào đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong buổi meeting, theo mình thấy nó hiệu quả khi các thành viên có sự trao đổi nhiều, nhiều ý kiến được xem xét, nhiều góc nhìn, nhiều sự cân nhắc trước khi đi đến một sự đồng thuận, một decision nào đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15f5d164-78d8-805d-9671-e97f9b959f0b",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-17T05:41:00.000Z",
        "last_edited_time": "2024-12-17T05:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mà thông thường để đạt được độ hiệu quả trên thì tính biến động trong buổi họp chắc chắn sẽ rất cao, ví dụ có thể cuộc họp kéo dài cho thảo luận quá nhiều, quá nhiều thông tin dẫn đến sự hoang mang, tranh cãi nhiều khiến chúng ta khó đưa ra quyết định,… ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mà thông thường để đạt được độ hiệu quả trên thì tính biến động trong buổi họp chắc chắn sẽ rất cao, ví dụ có thể cuộc họp kéo dài cho thảo luận quá nhiều, quá nhiều thông tin dẫn đến sự hoang mang, tranh cãi nhiều khiến chúng ta khó đưa ra quyết định,… ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1595d164-78d8-8012-b26c-f69372f3709b",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-11T02:05:00.000Z",
        "last_edited_time": "2024-12-23T11:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Với tính biến động cao trong buổi họp, một là bạn đã có khả năng để ứng phó tốt (có thể do tài năng hay kinh nghiệm của bạn), thì hai là bạn phải có sự chuẩn bị, lường trước các tình huống có thể xảy ra & soạn sẵn các phương án để ứng phó. Mình tự đánh giá là người thiếu sự linh hoạt, mình thuộc nhóm 2 nên dưới đây là các sự chuẩn bị trước.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Với tính biến động cao trong buổi họp, một là bạn đã có khả năng để ứng phó tốt (có thể do tài năng hay kinh nghiệm của bạn), thì hai là bạn phải có sự chuẩn bị, lường trước các tình huống có thể xảy ra & soạn sẵn các phương án để ứng phó. Mình tự đánh giá là người thiếu sự linh hoạt, mình thuộc nhóm 2 nên dưới đây là các sự chuẩn bị trước.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1595d164-78d8-8057-9079-d36b826b995c",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-11T02:06:00.000Z",
        "last_edited_time": "2024-12-12T02:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu dựa trên mức độ sôi nổi buổi họp thì có thể chia ra các tình huống sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu dựa trên mức độ sôi nổi buổi họp thì có thể chia ra các tình huống sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1595d164-78d8-8035-a617-ef3e812afac7",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-11T02:08:00.000Z",
        "last_edited_time": "2025-06-24T06:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quá im ắng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quá im ắng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": các thành viên đa phần chỉ nghe mà không thảo luận nhiều hoặc phần nội dung trình bày quá nghèo nàn. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": các thành viên đa phần chỉ nghe mà không thảo luận nhiều hoặc phần nội dung trình bày quá nghèo nàn. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "21c5d164-78d8-80b5-baa7-e95f96e67922",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2025-06-24T06:02:00.000Z",
        "last_edited_time": "2025-06-24T06:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Việc cần làm là hãy chuẩn bị agenda & gửi cho mọi người trước buổi họp để họ set up sẵn các nội dung cần bàn luận. Thậm chí họ cũng có thể add on vào agenda những mục khác.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Việc cần làm là hãy chuẩn bị agenda & gửi cho mọi người trước buổi họp để họ set up sẵn các nội dung cần bàn luận. Thậm chí họ cũng có thể add on vào agenda những mục khác.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "21c5d164-78d8-8010-8668-fcce4ea4b625",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2025-06-24T06:02:00.000Z",
        "last_edited_time": "2025-06-24T06:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khuyến khích hoặc dùng các tactic (round robin, game, Q&A,…) để tăng cơ hội các thành viên tham gia vào buổi thảo luận.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khuyến khích hoặc dùng các tactic (round robin, game, Q&A,…) để tăng cơ hội các thành viên tham gia vào buổi thảo luận.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1595d164-78d8-808b-961c-f0ce563cab05",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-11T02:13:00.000Z",
        "last_edited_time": "2025-06-24T06:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có người tham gia vào thảo luận nhưng không may ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có người tham gia vào thảo luận nhưng không may ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "người này chiếm diễn đàn",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "người này chiếm diễn đàn",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", họ nói quá nhiều và áp đảo buổi meeting, khiến các thành viên khác không có cơ hội đóng góp quan điểm. Việc cần làm là hãy tôn trọng ý kiến của họ, nhẹ nhàng xin ngắt lời để chuyền cơ hội cho người khác (”mình rất hiểu những thứ bạn A đang nói & nó rất hữu ích, tuy nhiên mình xin phép dừng lại chút để lắng nghe thêm ý kiến của bạn B, bạn C nhé”), có vài tactics để tránh việc này, ví dụ như: set thời gian mọi người được trình bày, round robin, ẩn danh…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", họ nói quá nhiều và áp đảo buổi meeting, khiến các thành viên khác không có cơ hội đóng góp quan điểm. Việc cần làm là hãy tôn trọng ý kiến của họ, nhẹ nhàng xin ngắt lời để chuyền cơ hội cho người khác (”mình rất hiểu những thứ bạn A đang nói & nó rất hữu ích, tuy nhiên mình xin phép dừng lại chút để lắng nghe thêm ý kiến của bạn B, bạn C nhé”), có vài tactics để tránh việc này, ví dụ như: set thời gian mọi người được trình bày, round robin, ẩn danh…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1595d164-78d8-807a-8aac-ca288a3057ec",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-11T02:11:00.000Z",
        "last_edited_time": "2025-06-24T06:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có thảo luận nhưng bắt đầu ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có thảo luận nhưng bắt đầu ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "dông dài, lan man, lạc đề",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "dông dài, lan man, lạc đề",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ". Tuỳ theo mức độ quan trọng của nội dung đó & thời gian còn lại trong cuộc họp, hãy cân nhắc kéo mọi người quay lại chủ đề chính, nếu cần thì hẹn buổi sau bàn luận tiếp (chỉ mời ai liên quan), hoặc trao đổi sau qua chat nếu thấy cần.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". Tuỳ theo mức độ quan trọng của nội dung đó & thời gian còn lại trong cuộc họp, hãy cân nhắc kéo mọi người quay lại chủ đề chính, nếu cần thì hẹn buổi sau bàn luận tiếp (chỉ mời ai liên quan), hoặc trao đổi sau qua chat nếu thấy cần.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1595d164-78d8-80f5-b486-cab46cac61cf",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-11T02:12:00.000Z",
        "last_edited_time": "2025-06-24T06:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Việc thảo luận nhiều sẽ dẫn đến ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Việc thảo luận nhiều sẽ dẫn đến ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "quá nhiều thông tin",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "quá nhiều thông tin",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " cần phải xử lý. Khi đó mọi thứ bắt đầu vượt ngoài kiểm soát, vậy nên hãy note lại, nếu được thì có thể sắp xếp thông tin & wrap up nó ngay trong buổi họp, có một summary note gửi lại cho mọi người. Không thì ta dễ bị rớt não lắm đó, họp xong không nhớ gì hoặc bị miss/ nhầm thông tin dẫn đến về sau gặp trục trặc trong việc align.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " cần phải xử lý. Khi đó mọi thứ bắt đầu vượt ngoài kiểm soát, vậy nên hãy note lại, nếu được thì có thể sắp xếp thông tin & wrap up nó ngay trong buổi họp, có một summary note gửi lại cho mọi người. Không thì ta dễ bị rớt não lắm đó, họp xong không nhớ gì hoặc bị miss/ nhầm thông tin dẫn đến về sau gặp trục trặc trong việc align.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1595d164-78d8-8037-b89c-f2fc4184d0ec",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-11T02:13:00.000Z",
        "last_edited_time": "2025-06-24T06:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tranh cãi nhiều",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tranh cãi nhiều",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", khi tranh cãi xảy ra hãy đánh giá xem ta có cùng một hệ quy chiếu để nhìn nhận vấn đề không, objective chung ở đây là gì, hệ quy chiếu để đánh giá nó như thế nào, chúng ta có đồng ý thứ tự ưu tiên của các tiêu chí hay không…, nếu đã chung “thước đo” rồi, mà vẫn tranh cãi thì phải dựa trên ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", khi tranh cãi xảy ra hãy đánh giá xem ta có cùng một hệ quy chiếu để nhìn nhận vấn đề không, objective chung ở đây là gì, hệ quy chiếu để đánh giá nó như thế nào, chúng ta có đồng ý thứ tự ưu tiên của các tiêu chí hay không…, nếu đã chung “thước đo” rồi, mà vẫn tranh cãi thì phải dựa trên ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "RACI",
                "link": {
                  "url": "/1185d16478d88014bdf1e631b28f601e"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "RACI",
              "href": "/1185d16478d88014bdf1e631b28f601e"
            },
            {
              "type": "text",
              "text": {
                "content": " để chốt vấn đề (xem thêm ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " để chốt vấn đề (xem thêm ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "bài conflict",
                "link": {
                  "url": "/7c105f498bff404bb1e1dcd82a632887"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "bài conflict",
              "href": "/7c105f498bff404bb1e1dcd82a632887"
            },
            {
              "type": "text",
              "text": {
                "content": ").",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ").",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-806b-bfa5-c6e06f404e0a",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-12T02:22:00.000Z",
        "last_edited_time": "2024-12-12T02:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-807c-9663-f2ec8006ef13",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-12T02:22:00.000Z",
        "last_edited_time": "2025-06-24T06:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_1",
        "heading_1": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tóm lại",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tóm lại",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-807d-ae72-e4135bf2d0a5",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-12T02:22:00.000Z",
        "last_edited_time": "2024-12-17T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Họp nhiều chắc chắn sẽ mất thời gian & năng lượng nhưng không thể chối bỏ tính cần thiết của nó, nó giúp chúng ta có góc nhìn đa chiều hơn, đồng thuận tốt hơn & đôi khi tranh cãi sẽ kích thích sự sáng tạo & tối ưu hơn cho giải pháp vấn đề.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Họp nhiều chắc chắn sẽ mất thời gian & năng lượng nhưng không thể chối bỏ tính cần thiết của nó, nó giúp chúng ta có góc nhìn đa chiều hơn, đồng thuận tốt hơn & đôi khi tranh cãi sẽ kích thích sự sáng tạo & tối ưu hơn cho giải pháp vấn đề.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-800d-8197-f99e3adc76db",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-12T02:25:00.000Z",
        "last_edited_time": "2024-12-23T11:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhưng chỉ khi buổi meeting đó được diễn ra đúng cách.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhưng chỉ khi buổi meeting đó được diễn ra đúng cách.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1e85d164-78d8-8009-ad57-edda32edcb26",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2025-05-03T04:15:00.000Z",
        "last_edited_time": "2025-05-03T04:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lời khuyên chung để dẫn dắt bất kỳ kiểu thảo luận nào:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lời khuyên chung để dẫn dắt bất kỳ kiểu thảo luận nào:",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1e85d164-78d8-80d3-ade8-ffaef5722bb4",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2025-05-03T04:15:00.000Z",
        "last_edited_time": "2025-05-03T04:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đặt mục tiêu & agenda rõ ràng trước meeting.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đặt mục tiêu & agenda rõ ràng trước meeting.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1e85d164-78d8-8011-83ed-e28a986bb3e7",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2025-05-03T04:15:00.000Z",
        "last_edited_time": "2025-05-03T04:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Timebox từng phần (update, thảo luận, quyết định).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Timebox từng phần (update, thảo luận, quyết định).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1e85d164-78d8-8077-ab20-e4423503bad0",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2025-05-03T04:15:00.000Z",
        "last_edited_time": "2025-05-29T09:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Document & follow-up: Ghi minutes và action items, phân công rõ ràng. (không những hạn chế não cá vàng, mà còn là source of truth để các bên align với nhau).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Document & follow-up: Ghi minutes và action items, phân công rõ ràng. (không những hạn chế não cá vàng, mà còn là source of truth để các bên align với nhau).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "1e85d164-78d8-804f-a9e9-e6ba7cbd604d",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2025-05-03T04:15:00.000Z",
        "last_edited_time": "2025-05-03T04:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đánh giá sau meeting: Có đạt mục tiêu không? Có cần cải tiến format?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đánh giá sau meeting: Có đạt mục tiêu không? Có cần cải tiến format?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 3
      },
      {
        "object": "block",
        "id": "1585d164-78d8-8109-a6b9-f8bf6198c429",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T12:46:00.000Z",
        "last_edited_time": "2024-12-10T12:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-8146-91d8-fca9d5b413d5",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T12:46:00.000Z",
        "last_edited_time": "2024-12-10T12:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-81f9-a8fb-c86d4cd7fc49",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T12:46:00.000Z",
        "last_edited_time": "2024-12-10T15:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://vietcetera.com/vn/vi-sao-ta-hop-xong-ta-lai-hay-quen-noi-dung-cuoc-hop",
                "link": {
                  "url": "https://vietcetera.com/vn/vi-sao-ta-hop-xong-ta-lai-hay-quen-noi-dung-cuoc-hop"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://vietcetera.com/vn/vi-sao-ta-hop-xong-ta-lai-hay-quen-noi-dung-cuoc-hop",
              "href": "https://vietcetera.com/vn/vi-sao-ta-hop-xong-ta-lai-hay-quen-noi-dung-cuoc-hop"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-8105-90da-fb2aba57a459",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T12:46:00.000Z",
        "last_edited_time": "2024-12-10T15:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.wired.com/2010/08/the-itch-of-curiosity/",
                "link": {
                  "url": "https://www.wired.com/2010/08/the-itch-of-curiosity/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.wired.com/2010/08/the-itch-of-curiosity/",
              "href": "https://www.wired.com/2010/08/the-itch-of-curiosity/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-8071-a587-c20d40bfff96",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-12T02:30:00.000Z",
        "last_edited_time": "2024-12-12T02:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://plan.io/blog/meeting-notes/",
                "link": {
                  "url": "https://plan.io/blog/meeting-notes/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://plan.io/blog/meeting-notes/",
              "href": "https://plan.io/blog/meeting-notes/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-81f6-a741-e616b3628f97",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T12:46:00.000Z",
        "last_edited_time": "2024-12-10T12:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-8139-a4ca-d08236033d09",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T12:46:00.000Z",
        "last_edited_time": "2024-12-10T12:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28d5d164-78d8-8013-8327-d8038261c085",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2025-10-15T02:01:00.000Z",
        "last_edited_time": "2025-10-15T02:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "28c5d164-78d8-8096-a9cf-cecf8ddd4791"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Meeting (P2)",
              "href": "https://app.notion.com/p/28c5d16478d88096a9cfcecf8ddd4791"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2825d164-78d8-80bd-a2db-eff238da39e2",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2025-10-04T11:45:00.000Z",
        "last_edited_time": "2025-10-04T11:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "2825d164-78d8-8022-b278-c095fef80560"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Meeting checklist",
              "href": "https://app.notion.com/p/2825d16478d88022b278c095fef80560"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-813e-885f-e0d6f8e11e98",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-10T12:46:00.000Z",
        "last_edited_time": "2024-12-12T02:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1405d164-78d8-801f-aad4-f558038c6ba3"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Principle of Communication",
              "href": "https://app.notion.com/p/1405d16478d8801faad4f558038c6ba3"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-80d2-9b7b-c16c9c5ccdc8",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-12T02:31:00.000Z",
        "last_edited_time": "2024-12-12T02:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1185d164-78d8-8014-bdf1-e631b28f601e"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "RACI (Role & Responsibility)",
              "href": "https://app.notion.com/p/1185d16478d88014bdf1e631b28f601e"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-80a1-80c4-c62334d1deca",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-803a-9506-fed5673c611f"
        },
        "created_time": "2024-12-12T02:31:00.000Z",
        "last_edited_time": "2024-12-12T02:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Facilitate",
              "href": "https://app.notion.com/p/ff81ff8ab21e4952a5f78e1b1714f022"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1575d164-78d8-8024-860e-d419e25be8bc",
    "created_time": "2024-12-09T10:18:00.000Z",
    "last_edited_time": "2025-08-28T02:34:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-12-09T10:18:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "1-Understanding",
          "color": "orange"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 26
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-28T02:34:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "qO=g",
          "name": "♟️:1",
          "color": "pink"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Tính cách (P1)",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Tính cách (P1)",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/T-nh-c-ch-P1-1575d16478d88024860ed419e25be8bc",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
      "name": "Understanding",
      "slug": "understanding",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "1575d164-78d8-8141-b7c5-d79ea7c0635b",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-09T10:23:00.000Z",
        "last_edited_time": "2025-01-07T10:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081285/uxcomic-imgs/1575d164-78d8-8141-b7c5-d79ea7c0635b.png",
            "expiry_time": "2026-10-04T09:11:18.413Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1575d164-78d8-8141-b7c5-d79ea7c0635b"
      },
      {
        "object": "block",
        "id": "1575d164-78d8-80b0-999e-d900650ed5ec",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-09T10:23:00.000Z",
        "last_edited_time": "2024-12-30T01:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Làm việc với đồng nghiệp, ngoài việc hiểu role & responsibility của nhau, chúng ta còn phải nhắc tới một khía cạnh rất con người, đó là tính cách.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Làm việc với đồng nghiệp, ngoài việc hiểu role & responsibility của nhau, chúng ta còn phải nhắc tới một khía cạnh rất con người, đó là tính cách.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80ce-bfcc-ef931b4dbb4c",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T01:31:00.000Z",
        "last_edited_time": "2024-12-30T01:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tính cách được hình thành do gen di truyền, bản năng & môi trường sống.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tính cách được hình thành do gen di truyền, bản năng & môi trường sống.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8035-8727-cb1eda17b0f0",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T01:40:00.000Z",
        "last_edited_time": "2024-12-30T15:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Môi trường sống? ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Môi trường sống? ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80e4-a600-de5048961b56",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T15:44:00.000Z",
        "last_edited_time": "2024-12-30T15:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tính chất công việc của họ, ví dụ: kế toán thì cần kĩ, designer thì sáng tạo, dev thì thích học thuật, chuyên sâu,…, ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tính chất công việc của họ, ví dụ: kế toán thì cần kĩ, designer thì sáng tạo, dev thì thích học thuật, chuyên sâu,…, ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-802f-840e-f8b0b417a954",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T15:44:00.000Z",
        "last_edited_time": "2024-12-30T15:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tam quan của họ ra sao- thế giới quan, giá trị quan, nhân sinh quan",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tam quan của họ ra sao- thế giới quan, giá trị quan, nhân sinh quan",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8055-a604-fef6bd28871a",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T15:44:00.000Z",
        "last_edited_time": "2024-12-30T15:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tính cách còn có thể thay đổi tuỳ theo các giai đoạn trong cuộc đời (độc thân, có gia đình, khủng hoảng,…), rồi lại có khi theo từng thế hệ cũng có các nét đặc trưng riệng (ví dụ: gen Z vị kỷ, cá tính, gen Y cởi mở, độc lập, gen X kỉ luật…). ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tính cách còn có thể thay đổi tuỳ theo các giai đoạn trong cuộc đời (độc thân, có gia đình, khủng hoảng,…), rồi lại có khi theo từng thế hệ cũng có các nét đặc trưng riệng (ví dụ: gen Z vị kỷ, cá tính, gen Y cởi mở, độc lập, gen X kỉ luật…). ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8022-9986-fec0ccabed7b",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T15:43:00.000Z",
        "last_edited_time": "2024-12-30T15:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-800a-bb4a-f7343f210c8b",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T01:36:00.000Z",
        "last_edited_time": "2024-12-30T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giới khoa học cũng có cho ra vài nghiên cứu như DISC, MBTI để giúp phân loại các nhóm tính cách, rồi vui vui thì có cung hoàng đạo, mạng, nhân số học,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giới khoa học cũng có cho ra vài nghiên cứu như DISC, MBTI để giúp phân loại các nhóm tính cách, rồi vui vui thì có cung hoàng đạo, mạng, nhân số học,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80bc-9717-d2025fb10987",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T15:45:00.000Z",
        "last_edited_time": "2024-12-30T15:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-803c-aa11-ed983209bd9b",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T01:46:00.000Z",
        "last_edited_time": "2024-12-30T01:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "TUY NHIÊN đây là những mẫu số chung, đều dựa trên xác suất thống kê, phần nào đó nó gán nhãn có thể sai & sẽ bị định kiến nếu ta tin vào nó hoàn toàn. Nên tất cả chỉ nên mang tính tham khảo, để hiểu tính của ai đó, không gì OK bằng việc làm việc cùng, quan sát & lắng nghe họ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "TUY NHIÊN đây là những mẫu số chung, đều dựa trên xác suất thống kê, phần nào đó nó gán nhãn có thể sai & sẽ bị định kiến nếu ta tin vào nó hoàn toàn. Nên tất cả chỉ nên mang tính tham khảo, để hiểu tính của ai đó, không gì OK bằng việc làm việc cùng, quan sát & lắng nghe họ.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-802b-b7cd-d0ed28b7c0d7",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T01:48:00.000Z",
        "last_edited_time": "2024-12-30T01:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nên thôi thì mình tự quan sát & tổng hợp theo cách riêng của mình. (đâu đó vẫn có những cái mình tham khảo ở các nghiên cứu như DISC, MBTI nhé).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nên thôi thì mình tự quan sát & tổng hợp theo cách riêng của mình. (đâu đó vẫn có những cái mình tham khảo ở các nghiên cứu như DISC, MBTI nhé).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8072-af3b-e5696881011b",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T01:49:00.000Z",
        "last_edited_time": "2024-12-30T01:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8022-b8a8-f5a9d8a05e09",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T01:49:00.000Z",
        "last_edited_time": "2024-12-30T01:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các loại tính cách đặc trưng",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các loại tính cách đặc trưng",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80a6-83d1-f7184f490313",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T01:50:00.000Z",
        "last_edited_time": "2024-12-30T02:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hướng nội vs Hướng ngoại",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hướng nội vs Hướng ngoại",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-806c-9d40-e1ea3cccf061",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T01:51:00.000Z",
        "last_edited_time": "2024-12-30T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Người hướng nội thường tập trung vào thế giới nội tâm, thích sự yên tĩnh và có xu hướng suy nghĩ sâu sắc trước khi hành động. Họ thường cảm thấy thoải mái khi ở một mình hoặc trong các nhóm nhỏ thân thiết, và dễ bị cạn năng lượng khi giao tiếp xã hội quá nhiều.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Người hướng nội thường tập trung vào thế giới nội tâm, thích sự yên tĩnh và có xu hướng suy nghĩ sâu sắc trước khi hành động. Họ thường cảm thấy thoải mái khi ở một mình hoặc trong các nhóm nhỏ thân thiết, và dễ bị cạn năng lượng khi giao tiếp xã hội quá nhiều.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80ad-ac85-e1de24f4a9e8",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T01:53:00.000Z",
        "last_edited_time": "2024-12-30T05:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> Tôn trọng không gian và thời gian của họ, đừng ép buộc họ tham gia vào các cuộc thảo luận đông người. Hãy tạo môi trường để họ có thể chia sẻ ý kiến một cách thoải mái, ví dụ qua chat hoặc cuộc họp nhỏ. Lắng nghe kỹ lưỡng và đừng ngắt lời, vì họ thường cần thời gian để diễn đạt suy nghĩ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> Tôn trọng không gian và thời gian của họ, đừng ép buộc họ tham gia vào các cuộc thảo luận đông người. Hãy tạo môi trường để họ có thể chia sẻ ý kiến một cách thoải mái, ví dụ qua chat hoặc cuộc họp nhỏ. Lắng nghe kỹ lưỡng và đừng ngắt lời, vì họ thường cần thời gian để diễn đạt suy nghĩ.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80bf-9f80-fb494793df86",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T01:59:00.000Z",
        "last_edited_time": "2024-12-30T01:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-803f-be4f-d84d495cc9c2",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T01:52:00.000Z",
        "last_edited_time": "2024-12-30T01:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ngược lại, người hướng ngoại lại lấy năng lượng từ việc tương tác với người khác, yêu thích môi trường sôi động và thường cởi mở, dễ dàng thể hiện cảm xúc. Họ thích khám phá thế giới bên ngoài, chủ động kết nối và thường xử lý vấn đề thông qua hành động thay vì suy tư lâu dài.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ngược lại, người hướng ngoại lại lấy năng lượng từ việc tương tác với người khác, yêu thích môi trường sôi động và thường cởi mở, dễ dàng thể hiện cảm xúc. Họ thích khám phá thế giới bên ngoài, chủ động kết nối và thường xử lý vấn đề thông qua hành động thay vì suy tư lâu dài.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-806c-b900-f86bc2f88bc8",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T01:54:00.000Z",
        "last_edited_time": "2024-12-30T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> Tạo cơ hội để họ bày tỏ ý kiến và tham gia vào các hoạt động nhóm. Họ thường thích các cuộc thảo luận sôi nổi và phản hồi ngay lập tức, vì vậy hãy khuyến khích sự tương tác. Tuy nhiên, cũng cần hướng họ đến việc lắng nghe người khác và không chiếm quá nhiều thời gian trong các cuộc họp.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> Tạo cơ hội để họ bày tỏ ý kiến và tham gia vào các hoạt động nhóm. Họ thường thích các cuộc thảo luận sôi nổi và phản hồi ngay lập tức, vì vậy hãy khuyến khích sự tương tác. Tuy nhiên, cũng cần hướng họ đến việc lắng nghe người khác và không chiếm quá nhiều thời gian trong các cuộc họp.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-806e-a738-c50c5e6c30c4",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T01:59:00.000Z",
        "last_edited_time": "2024-12-30T01:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8028-a252-c0304080fd82",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T01:55:00.000Z",
        "last_edited_time": "2024-12-30T01:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mạnh dạn vs Thụ động",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mạnh dạn vs Thụ động",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80ad-a905-f7fc55a29aa2",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T01:57:00.000Z",
        "last_edited_time": "2024-12-30T02:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Người mạnh dạn thường chủ động, quyết đoán và không ngại thử thách. Họ dám đưa ra ý kiến, chịu trách nhiệm và nhanh chóng hành động để giải quyết vấn đề. (Đâu đó bạn sẽ thấy đa phần người hướng ngoại sẽ mạnh dạn hơn người hướng nội).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Người mạnh dạn thường chủ động, quyết đoán và không ngại thử thách. Họ dám đưa ra ý kiến, chịu trách nhiệm và nhanh chóng hành động để giải quyết vấn đề. (Đâu đó bạn sẽ thấy đa phần người hướng ngoại sẽ mạnh dạn hơn người hướng nội).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80e3-b165-d7da3319ff25",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T01:58:00.000Z",
        "last_edited_time": "2024-12-30T05:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> Mạnh dạn rất tốt trong việc dám bày tỏ ý kiến của họ, nhưng sẽ tệ đi nếu họ không biết lắng nghe, dẫn đến có đôi khi cứng nhắc, nên khi làm việc với nhóm này ta cần cho họ thấy được nhiều góc nhìn hơn, tốt hơn hết là thông qua câu hỏi thay vì bác bỏ ý kiến của họ. Nhóm này sẽ thích cuộc trò chuyện thẳng thắn, hợp lý như kiểu “người Hải Phòng không lòng vòng”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> Mạnh dạn rất tốt trong việc dám bày tỏ ý kiến của họ, nhưng sẽ tệ đi nếu họ không biết lắng nghe, dẫn đến có đôi khi cứng nhắc, nên khi làm việc với nhóm này ta cần cho họ thấy được nhiều góc nhìn hơn, tốt hơn hết là thông qua câu hỏi thay vì bác bỏ ý kiến của họ. Nhóm này sẽ thích cuộc trò chuyện thẳng thắn, hợp lý như kiểu “người Hải Phòng không lòng vòng”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8063-917f-e8f247b744c5",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T02:11:00.000Z",
        "last_edited_time": "2024-12-30T02:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-800c-9b14-dd2c36ab91b2",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T01:58:00.000Z",
        "last_edited_time": "2024-12-30T01:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Người thụ động thường né tránh xung đột, chờ chỉ đạo, và dễ chấp nhận tình huống hơn là thay đổi. Họ thường thiếu sự tự tin để thể hiện ý kiến hoặc đối mặt với rủi ro trong công việc.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Người thụ động thường né tránh xung đột, chờ chỉ đạo, và dễ chấp nhận tình huống hơn là thay đổi. Họ thường thiếu sự tự tin để thể hiện ý kiến hoặc đối mặt với rủi ro trong công việc.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80e8-a0a6-f5d6be352571",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T01:52:00.000Z",
        "last_edited_time": "2024-12-30T05:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> Vì tính nhạy cảm nên nhóm này cần chúng ta động viên, tạo môi trường an toàn để họ chia sẻ, và hỗ trợ họ trong việc ra quyết định. Nhóm này rất dễ chấp nhận nên có khi sẽ thiếu chính kiến, nên phải make sure là khi nhóm này ra quyết định, họ đã trải qua đủ sự cân nhắc & đủ thông tin. Nhóm này cũng ưa chuộng phương án an toàn hơn vì xu hướng nét tránh xung đột, nên cũng nên khuyến khích sự sáng tạo trong họ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> Vì tính nhạy cảm nên nhóm này cần chúng ta động viên, tạo môi trường an toàn để họ chia sẻ, và hỗ trợ họ trong việc ra quyết định. Nhóm này rất dễ chấp nhận nên có khi sẽ thiếu chính kiến, nên phải make sure là khi nhóm này ra quyết định, họ đã trải qua đủ sự cân nhắc & đủ thông tin. Nhóm này cũng ưa chuộng phương án an toàn hơn vì xu hướng nét tránh xung đột, nên cũng nên khuyến khích sự sáng tạo trong họ.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8052-a3fc-dd1222f10329",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T02:08:00.000Z",
        "last_edited_time": "2024-12-30T02:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80b0-9acb-c4a476b59a5c",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T02:12:00.000Z",
        "last_edited_time": "2024-12-30T02:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tham vọng vs An phận",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tham vọng vs An phận",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80ea-aedc-eaba7e29a718",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T01:51:00.000Z",
        "last_edited_time": "2024-12-30T02:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Người tham vọng thường chủ động, cầu tiến và luôn hướng đến những mục tiêu lớn. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Người tham vọng thường chủ động, cầu tiến và luôn hướng đến những mục tiêu lớn. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80f8-b513-f0ccc1495b11",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T02:23:00.000Z",
        "last_edited_time": "2025-01-07T10:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> Họ phù hợp với các dự án thách thức và cần cơ hội phát triển, nhưng cũng dễ bị quá tải hoặc gây áp lực cho người khác, nên cần nhắc nhở về cân bằng và tinh thần hợp tác.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> Họ phù hợp với các dự án thách thức và cần cơ hội phát triển, nhưng cũng dễ bị quá tải hoặc gây áp lực cho người khác, nên cần nhắc nhở về cân bằng và tinh thần hợp tác.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8049-a77a-e3e2e73631cd",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T02:23:00.000Z",
        "last_edited_time": "2025-01-07T10:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-804f-8314-cbcf3f635c41",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T02:15:00.000Z",
        "last_edited_time": "2024-12-30T02:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ngược lại, người an phận thường ổn định, đáng tin cậy và ít tạo xung đột, nhưng lại thiếu chủ động và ngại thay đổi. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ngược lại, người an phận thường ổn định, đáng tin cậy và ít tạo xung đột, nhưng lại thiếu chủ động và ngại thay đổi. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-806c-997f-fb82c7fc9284",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T02:23:00.000Z",
        "last_edited_time": "2025-01-07T10:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> Họ cần được động viên thử thách bản thân và giao việc phù hợp để phát huy năng lực.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> Họ cần được động viên thử thách bản thân và giao việc phù hợp để phát huy năng lực.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-806a-99a3-e86f711345cb",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T02:17:00.000Z",
        "last_edited_time": "2024-12-30T02:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-808f-86f1-d917612ea677",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T02:21:00.000Z",
        "last_edited_time": "2024-12-30T02:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cứng nhắc vs Linh hoạt",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cứng nhắc vs Linh hoạt",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80a9-be11-f291ed564173",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T02:21:00.000Z",
        "last_edited_time": "2024-12-30T05:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Người cứng nhắc thường tuân thủ quy tắc, kỷ luật và làm việc có hệ thống. Họ mạnh ở sự ổn định và nhất quán nhưng dễ thiếu sáng tạo và khó thích nghi với thay đổi.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Người cứng nhắc thường tuân thủ quy tắc, kỷ luật và làm việc có hệ thống. Họ mạnh ở sự ổn định và nhất quán nhưng dễ thiếu sáng tạo và khó thích nghi với thay đổi.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8065-bd19-f6e3eb24e701",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T02:22:00.000Z",
        "last_edited_time": "2024-12-30T02:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> Họ phù hợp với các nhiệm vụ cần sự chính xác và quy trình rõ ràng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> Họ phù hợp với các nhiệm vụ cần sự chính xác và quy trình rõ ràng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8009-8ad2-f68d8b0e3dc6",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T02:23:00.000Z",
        "last_edited_time": "2024-12-30T02:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8089-9364-ec5e0655e226",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T02:22:00.000Z",
        "last_edited_time": "2024-12-30T02:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ngược lại, người linh hoạt thích ứng nhanh, sáng tạo và dễ giải quyết vấn đề trong các tình huống mới, nhưng đôi khi thiếu kế hoạch cụ thể hoặc thiếu tập trung. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ngược lại, người linh hoạt thích ứng nhanh, sáng tạo và dễ giải quyết vấn đề trong các tình huống mới, nhưng đôi khi thiếu kế hoạch cụ thể hoặc thiếu tập trung. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80ad-b46d-fdcd7a6adcf9",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T02:22:00.000Z",
        "last_edited_time": "2024-12-30T02:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> Họ phù hơp để đảm nhận những công việc đòi hỏi sự đổi mới hoặc ứng biến.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> Họ phù hơp để đảm nhận những công việc đòi hỏi sự đổi mới hoặc ứng biến.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-802f-bc11-ef6854f66e73",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T02:35:00.000Z",
        "last_edited_time": "2024-12-30T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80c2-af15-df482de76092",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T02:35:00.000Z",
        "last_edited_time": "2024-12-30T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tóm lại",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tóm lại",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8016-9d94-e9463067627c",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T05:16:00.000Z",
        "last_edited_time": "2024-12-30T05:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Như bạn thấy đó, tính cách nào cũng có strength & weakness, đôi khi ta nên tận dụng điểm mạnh của họ & tìm cách cover các điểm yếu. Có thể từ việc set up team cho đến lựa chọn các framework để làm việc, thảo luận cùng nhau…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Như bạn thấy đó, tính cách nào cũng có strength & weakness, đôi khi ta nên tận dụng điểm mạnh của họ & tìm cách cover các điểm yếu. Có thể từ việc set up team cho đến lựa chọn các framework để làm việc, thảo luận cùng nhau…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80d8-a996-f30d812a3978",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T05:18:00.000Z",
        "last_edited_time": "2024-12-30T05:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lấy ví dụ: trong buổi brainstorming, có khi người mạnh dạn sẽ trình bày quá nhiều, còn người thụ động sẽ không dám bày tỏ >> có thể áp dụng Silent brainstorming (mọi người viết idea ra note thay vì nói).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lấy ví dụ: trong buổi brainstorming, có khi người mạnh dạn sẽ trình bày quá nhiều, còn người thụ động sẽ không dám bày tỏ >> có thể áp dụng Silent brainstorming (mọi người viết idea ra note thay vì nói).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80f0-8e18-cfe3ea67192c",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T05:21:00.000Z",
        "last_edited_time": "2024-12-30T05:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dù là tính cách nào đi nữa thì trong môi trường công việc luôn ưu ái những tính cách như: trung thực, rõ ràng, dám chịu trách nhiệm, dám trình bày, thân thiện & tinh thần đội nhóm,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dù là tính cách nào đi nữa thì trong môi trường công việc luôn ưu ái những tính cách như: trung thực, rõ ràng, dám chịu trách nhiệm, dám trình bày, thân thiện & tinh thần đội nhóm,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80b8-9210-e7ddb3bc820a",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T05:24:00.000Z",
        "last_edited_time": "2025-01-07T10:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Anyway, hiểu độ đa dạng tính cách ở trên nhưng mình nghĩ đây là 3 việc chính cần làm khi hợp tác với mọi người:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Anyway, hiểu độ đa dạng tính cách ở trên nhưng mình nghĩ đây là 3 việc chính cần làm khi hợp tác với mọi người:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80f0-8283-c332f2492b9f",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T02:35:00.000Z",
        "last_edited_time": "2024-12-30T05:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thấu tình đạt lý",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thấu tình đạt lý",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là key trong hợp tác làm việc.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là key trong hợp tác làm việc.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8007-8394-ec1abddda382",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T02:35:00.000Z",
        "last_edited_time": "2024-12-30T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuỳ (Mục tiêu + Tình huống + Tính cách) mà lựa chọn phương án ứng xử.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuỳ (Mục tiêu + Tình huống + Tính cách) mà lựa chọn phương án ứng xử.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-800d-98ab-c735e4f25e77",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T05:08:00.000Z",
        "last_edited_time": "2024-12-30T05:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Gán nhãn ai đó dĩ nhiên là điều không nên, nhưng gọi tên được tính cách giúp bạn tìm phương hướng ứng xử tốt hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Gán nhãn ai đó dĩ nhiên là điều không nên, nhưng gọi tên được tính cách giúp bạn tìm phương hướng ứng xử tốt hơn.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "✋"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1575d164-78d8-8136-9fc3-d99d433bdb23",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-09T10:23:00.000Z",
        "last_edited_time": "2024-12-09T10:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1575d164-78d8-8128-9aea-e41d8fa29a75",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-09T10:23:00.000Z",
        "last_edited_time": "2024-12-09T10:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8044-beca-e0db84417415",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-30T05:33:00.000Z",
        "last_edited_time": "2024-12-30T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bài ở dưới hay lắm, mọi người có time đọc qua nhé, nó nói về các tính cách trong cuộc họp.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bài ở dưới hay lắm, mọi người có time đọc qua nhé, nó nói về các tính cách trong cuộc họp.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1575d164-78d8-819c-b4ae-fc8f346608b2",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-09T10:23:00.000Z",
        "last_edited_time": "2024-12-30T05:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://vietcetera.com/onboardy/ban-la-ai-trong-phong-hop-4-kieu-tinh-cach-pho-bien",
                "link": {
                  "url": "https://vietcetera.com/onboardy/ban-la-ai-trong-phong-hop-4-kieu-tinh-cach-pho-bien"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://vietcetera.com/onboardy/ban-la-ai-trong-phong-hop-4-kieu-tinh-cach-pho-bien",
              "href": "https://vietcetera.com/onboardy/ban-la-ai-trong-phong-hop-4-kieu-tinh-cach-pho-bien"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1575d164-78d8-814b-aad5-fd01d97025d9",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-09T10:23:00.000Z",
        "last_edited_time": "2024-12-09T10:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1575d164-78d8-81d5-938e-ccb5c7832aea",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-09T10:23:00.000Z",
        "last_edited_time": "2024-12-09T10:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25d5d164-78d8-805e-b81e-d3b51a9280be",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2025-08-28T02:34:00.000Z",
        "last_edited_time": "2025-08-28T02:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "2025d164-78d8-8039-9ecf-e076ef82ba85"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tính cách (P2)",
              "href": "https://app.notion.com/p/2025d16478d880399ecfe076ef82ba85"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1575d164-78d8-8144-b53c-eb5d0084b144",
        "parent": {
          "type": "page_id",
          "page_id": "1575d164-78d8-8024-860e-d419e25be8bc"
        },
        "created_time": "2024-12-09T10:23:00.000Z",
        "last_edited_time": "2024-12-30T05:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1185d164-78d8-8014-bdf1-e631b28f601e"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "RACI (Role & Responsibility)",
              "href": "https://app.notion.com/p/1185d16478d88014bdf1e631b28f601e"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1435d164-78d8-8004-930c-e9f3fede9fe4",
    "created_time": "2024-11-19T01:48:00.000Z",
    "last_edited_time": "2025-08-19T00:48:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-11-19T01:48:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "1-Understanding",
          "color": "orange"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 25
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-19T00:48:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "cZzk",
          "name": "⚔️:3",
          "color": "orange"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Questioning (P2)",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Questioning (P2)",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Questioning-P2-1435d16478d88004930ce9f3fede9fe4",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
      "name": "Understanding",
      "slug": "understanding",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "d66ae4e8-1c8b-4a34-a71e-e1a2fd1686ab",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-11-19T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081287/uxcomic-imgs/d66ae4e8-1c8b-4a34-a71e-e1a2fd1686ab.png",
            "expiry_time": "2026-10-04T09:11:18.926Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/d66ae4e8-1c8b-4a34-a71e-e1a2fd1686ab"
      },
      {
        "object": "block",
        "id": "1945d741-8e08-4794-bfda-65275478b8b0",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-11-19T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Học cách hỏi",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Học cách hỏi",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "247fd3f7-cb45-4e18-8d42-9b11ea32f5ec",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-11-19T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081290/uxcomic-imgs/247fd3f7-cb45-4e18-8d42-9b11ea32f5ec.png",
            "expiry_time": "2026-10-04T09:11:18.926Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/247fd3f7-cb45-4e18-8d42-9b11ea32f5ec"
      },
      {
        "object": "block",
        "id": "3e3f0eed-9a2a-4abf-9817-1ab423cf27d8",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2025-05-09T01:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu hình dung việc chúng ta questioning như bộ môn câu cá thì mục tiêu chúng ta ở đây là biết mình muốn câu được những con cá nào hoặc đơn giản chỉ là cứ bắt được thật nhiều cá.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu hình dung việc chúng ta questioning như bộ môn câu cá thì mục tiêu chúng ta ở đây là biết mình muốn câu được những con cá nào hoặc đơn giản chỉ là cứ bắt được thật nhiều cá.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1485d164-78d8-803f-b60b-fd5301237fbd",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-24T01:34:00.000Z",
        "last_edited_time": "2025-05-09T01:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Con cá",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Con cá",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " ở đây chính là thông tin, là một cái hiểu hay một cái biết gì đó. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ở đây chính là thông tin, là một cái hiểu hay một cái biết gì đó. ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1485d164-78d8-8071-b94d-d0cf1034e9ad",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-24T01:34:00.000Z",
        "last_edited_time": "2025-05-09T01:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vùng nước",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vùng nước",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là kênh mà mình có thể tìm kiếm các thông tin đó, ví dụ như: bạn hỏi ai, từ sách, từ podcast, từ sự kiện, từ nhóm cộng đồng nào đó…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là kênh mà mình có thể tìm kiếm các thông tin đó, ví dụ như: bạn hỏi ai, từ sách, từ podcast, từ sự kiện, từ nhóm cộng đồng nào đó…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1485d164-78d8-8060-aae0-d88d9eb77ddb",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-24T01:38:00.000Z",
        "last_edited_time": "2025-05-09T01:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có thể hình dung",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có thể hình dung",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " sợi dây",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " sợi dây",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là một chuỗi câu hỏi, mạch năng lượng… là một mối liên hệ gì đó để liên kết giữa con cá và bạn - cái cách để trích xuất được thông tin.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là một chuỗi câu hỏi, mạch năng lượng… là một mối liên hệ gì đó để liên kết giữa con cá và bạn - cái cách để trích xuất được thông tin.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1485d164-78d8-8052-8043-d5399ee8678b",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-24T01:34:00.000Z",
        "last_edited_time": "2025-05-09T01:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một chút yếu tố ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một chút yếu tố ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "thời tiết",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "thời tiết",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " mang tính thời điểm, ngữ cảnh như: tâm trạng, bối cảnh, nhận thức ở thời điểm đó chẳng hạn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " mang tính thời điểm, ngữ cảnh như: tâm trạng, bối cảnh, nhận thức ở thời điểm đó chẳng hạn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1435d164-78d8-80ed-999f-c63b8ab9db5a",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T11:35:00.000Z",
        "last_edited_time": "2025-08-19T00:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Việc câu cá đòi hỏi sự kiên nhẫn cũng như kĩ năng, tính chủ đích trong việc chọn mồi câu, cần câu hay lựa vùng nước, thời tiết phù hợp, việc mình đọc tín hiệu cũng giống như nắm tâm lý đối phương, và việc mình kiểm soát sự kéo thả dây cũng giống như khả năng ứng biến trong cuộc trao đổi, tất cả đều tác động đến kết quả mình trích xuất thông tin.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Việc câu cá đòi hỏi sự kiên nhẫn cũng như kĩ năng, tính chủ đích trong việc chọn mồi câu, cần câu hay lựa vùng nước, thời tiết phù hợp, việc mình đọc tín hiệu cũng giống như nắm tâm lý đối phương, và việc mình kiểm soát sự kéo thả dây cũng giống như khả năng ứng biến trong cuộc trao đổi, tất cả đều tác động đến kết quả mình trích xuất thông tin.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1435d164-78d8-8070-9063-e5052c0fef49",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T11:39:00.000Z",
        "last_edited_time": "2025-08-19T00:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình sẽ không biết “con cá” sắp cắn câu trông ra sao cho đến khi nó ra được khỏi mặt nước, và cũng không biết “con cá” đó đáng giá thế nào cho đến khi mình cho ra “thị trường” (dựa theo độ hiếm, độ cần) hoặc có “ngon” hay không (hợp khẩu vị mình hay không).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình sẽ không biết “con cá” sắp cắn câu trông ra sao cho đến khi nó ra được khỏi mặt nước, và cũng không biết “con cá” đó đáng giá thế nào cho đến khi mình cho ra “thị trường” (dựa theo độ hiếm, độ cần) hoặc có “ngon” hay không (hợp khẩu vị mình hay không).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1435d164-78d8-8086-86a7-d8c2cbf6de67",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:56:00.000Z",
        "last_edited_time": "2024-11-19T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "4c455227-e1d3-4f70-8eca-8382b73db417",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-11-19T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "1. Các mục tiêu việc hỏi (con cá 🐠)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "1. Các mục tiêu việc hỏi (con cá 🐠)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d1d7010-295e-498b-ad69-ebea0d6c1a9a",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-11-19T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hỏi để hiểu",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hỏi để hiểu",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " — Khi mình cần tìm hiểu vấn đề hoặc tiếp thu kiến thức mới.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " — Khi mình cần tìm hiểu vấn đề hoặc tiếp thu kiến thức mới.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "e96a5993-b87f-413a-83dd-0c6a0ff7276a",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-11-19T02:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hỏi để thăm do & kiểm chứng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hỏi để thăm do & kiểm chứng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " — Khi mình cần sự xác nhận hoặc thăm dò, làm rõ những phán đoán, nhận định.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " — Khi mình cần sự xác nhận hoặc thăm dò, làm rõ những phán đoán, nhận định.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2bc4586a-3de7-4b94-991b-26211dc51a8f",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2025-08-19T00:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hỏi để dẫn dắt lối suy nghĩ ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hỏi để dẫn dắt lối suy nghĩ ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "— Khi mình là người khơi mở chủ đề và các câu hỏi có nghĩa vụ dẫn dắt từ thông tin A đến thông tin B,C,D gì đó. Sau quá trình suy luận này nó sẽ form lên được một kết luận gì đó. Ví dụ: ta có thể dùng câu hỏi để gợi mở đối phương suy nghĩ logic về một vấn đề gì đó, từ việc chính họ tự tìm ra câu trả lời sẽ giúp họ tự hình thành một quan điểm hay một kết luận gì đó (cái này nếu chủ đích tích cực thì ta gọi coaching, còn nếu chủ đích là tiêu cực thì gọi là manipulate nè, kaka).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "— Khi mình là người khơi mở chủ đề và các câu hỏi có nghĩa vụ dẫn dắt từ thông tin A đến thông tin B,C,D gì đó. Sau quá trình suy luận này nó sẽ form lên được một kết luận gì đó. Ví dụ: ta có thể dùng câu hỏi để gợi mở đối phương suy nghĩ logic về một vấn đề gì đó, từ việc chính họ tự tìm ra câu trả lời sẽ giúp họ tự hình thành một quan điểm hay một kết luận gì đó (cái này nếu chủ đích tích cực thì ta gọi coaching, còn nếu chủ đích là tiêu cực thì gọi là manipulate nè, kaka).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1435d164-78d8-8087-bd41-cdc8b157d952",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T02:02:00.000Z",
        "last_edited_time": "2024-11-19T05:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hỏi để phát hiện điểm mù ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hỏi để phát hiện điểm mù ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "— Khi đặt câu hỏi đủ nhiều và các câu hỏi mang tính thách thức, ta sẽ bắt đầu góc nhìn đa chiều & sâu sắc hơn về vấn đề, từ đó phát hiện ra các điểm mù trong cách tư duy hiện tại. Ví dụ: “Thử nghĩ xem nếu chúng ta không có những rào cản hiện tại, thì solution hoàn hảo nhất sẽ trông như thế nào?”, “Tại sao, tại sao, tại sao,…”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "— Khi đặt câu hỏi đủ nhiều và các câu hỏi mang tính thách thức, ta sẽ bắt đầu góc nhìn đa chiều & sâu sắc hơn về vấn đề, từ đó phát hiện ra các điểm mù trong cách tư duy hiện tại. Ví dụ: “Thử nghĩ xem nếu chúng ta không có những rào cản hiện tại, thì solution hoàn hảo nhất sẽ trông như thế nào?”, “Tại sao, tại sao, tại sao,…”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "9eff0e86-2578-45b4-9e38-bd123beb66db",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-11-19T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "de7a4e52-ac1f-4022-8f43-b6e5788b649e",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-11-19T02:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "2. Loại câu hỏi (mồi câu🪝 & sợi dây)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2. Loại câu hỏi (mồi câu🪝 & sợi dây)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "dd19f72a-e8e7-43c8-8651-d583b449aa39",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-11-19T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Câu hỏi mở (Open-ended questions):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Câu hỏi mở (Open-ended questions):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là bất kỳ câu hỏi nào kích thích tư duy & mời người khác chia sẻ ý kiến và cảm nhận của họ. Tip: nên dùng câu hỏi “What” & “How” thay vì “Why”, vì why có thể nghe hơi phán xét hoặc buộc tội.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là bất kỳ câu hỏi nào kích thích tư duy & mời người khác chia sẻ ý kiến và cảm nhận của họ. Tip: nên dùng câu hỏi “What” & “How” thay vì “Why”, vì why có thể nghe hơi phán xét hoặc buộc tội.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "0a95bf22-9d9b-4308-be72-e99377e49f48",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-11-19T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Câu hỏi đóng (Closed-ended questions): ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Câu hỏi đóng (Closed-ended questions): ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "như cái tên của nó, nó dùng để đóng lại vấn đề, để xác định thông tin cụ thể hoặc đưa ra quyết định nhanh. Thường là câu hỏi dạng yes/no.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "như cái tên của nó, nó dùng để đóng lại vấn đề, để xác định thông tin cụ thể hoặc đưa ra quyết định nhanh. Thường là câu hỏi dạng yes/no.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3b72f3a8-b94c-424a-8ae8-852384c8425e",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-11-19T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Câu hỏi thăm dò (Probing questions): ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Câu hỏi thăm dò (Probing questions): ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "dùng để",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "dùng để",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "tìm hiểu sâu hơn về một chủ đề và khám phá những lý do hoặc động cơ cơ bản. Thường là câu hỏi “why”, “how”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "tìm hiểu sâu hơn về một chủ đề và khám phá những lý do hoặc động cơ cơ bản. Thường là câu hỏi “why”, “how”.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "136a6da1-1e7b-4c43-8d81-d8e81f5f154d",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-11-19T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Câu hỏi dẫn dắt/ giả định (Leading questions): ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Câu hỏi dẫn dắt/ giả định (Leading questions): ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "là loại câu hỏi mà trong đó người hỏi cố ý hoặc vô tình gợi ý câu trả lời qua cách diễn đạt. Chúng thường chứa đựng một giả định hoặc ý kiến, khiến người trả lời bị ảnh hưởng và có xu hướng trả lời theo hướng mà người hỏi mong muốn. Ví dụ: “Bạn thích chức năng A hay B hơn?” (giả định rằng user đã thích và chỉ quan tâm đến hai chức năng này).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "là loại câu hỏi mà trong đó người hỏi cố ý hoặc vô tình gợi ý câu trả lời qua cách diễn đạt. Chúng thường chứa đựng một giả định hoặc ý kiến, khiến người trả lời bị ảnh hưởng và có xu hướng trả lời theo hướng mà người hỏi mong muốn. Ví dụ: “Bạn thích chức năng A hay B hơn?” (giả định rằng user đã thích và chỉ quan tâm đến hai chức năng này).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2fb885dc-a968-462e-bf15-01d7497c3490",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-12-18T04:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Câu hỏi giả thuyết (Hypothetical questions):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Câu hỏi giả thuyết (Hypothetical questions):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là một loại câu hỏi được đặt ra dựa trên một tình huống, hoàn cảnh hoặc kịch bản giả định nhầm kích thích tư duy sáng tạo, hiểu cách đối phương suy nghĩ, đánh giá & giải quyết vấn đề. Thường là câu hỏi “what if”, “what happen if”. Ví dụ: \"Nếu bạn phải dẫn dắt một dự án lớn với thời gian rất ngắn, bạn sẽ bắt đầu từ đâu?”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là một loại câu hỏi được đặt ra dựa trên một tình huống, hoàn cảnh hoặc kịch bản giả định nhầm kích thích tư duy sáng tạo, hiểu cách đối phương suy nghĩ, đánh giá & giải quyết vấn đề. Thường là câu hỏi “what if”, “what happen if”. Ví dụ: \"Nếu bạn phải dẫn dắt một dự án lớn với thời gian rất ngắn, bạn sẽ bắt đầu từ đâu?”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "84444169-b1a0-476b-8794-5ff79c81a3bd",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-11-19T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Câu hỏi phản ánh (Reflective questions)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Câu hỏi phản ánh (Reflective questions)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": kích thích tự đánh giá hoặc suy ngẫm lại hành động và quan điểm của bản thân. Ví dụ: “Thời điểm nào trong năm qua khiến bạn cảm thấy mình ở trạng thái tốt nhất?”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": kích thích tự đánh giá hoặc suy ngẫm lại hành động và quan điểm của bản thân. Ví dụ: “Thời điểm nào trong năm qua khiến bạn cảm thấy mình ở trạng thái tốt nhất?”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "c83f7666-5711-4080-ac90-9f5b8108b5c5",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-11-19T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "058305cf-2ca7-4f52-b086-65bca284e553",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-11-19T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "3. Hỏi cho khéo (đọc tín hiệu, thả câu & thu dây 🎣)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3. Hỏi cho khéo (đọc tín hiệu, thả câu & thu dây 🎣)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "8f6b44c8-3c7a-4c50-adb7-f9118266ef2c",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-11-19T15:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nghĩa là mình biết cách giữ mạch câu chuyện, tạo tâm lý thoải mái cho đối phương, đặt được những câu hỏi để hiểu được cách đối phương hiểu vấn đề, đào sâu được cách họ suy luận, hiểu cái gì quan trọng với họ và tại sao. Một cái hay của hỏi khéo nữa là khả năng bạn có thể làm mỏng bức tường giữa mình & đối phương, điều này giúp thông tin họ sẵn sàng trao cho bạn nhiều & chân thật hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nghĩa là mình biết cách giữ mạch câu chuyện, tạo tâm lý thoải mái cho đối phương, đặt được những câu hỏi để hiểu được cách đối phương hiểu vấn đề, đào sâu được cách họ suy luận, hiểu cái gì quan trọng với họ và tại sao. Một cái hay của hỏi khéo nữa là khả năng bạn có thể làm mỏng bức tường giữa mình & đối phương, điều này giúp thông tin họ sẵn sàng trao cho bạn nhiều & chân thật hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1435d164-78d8-8006-a806-fc2f26859867",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T15:08:00.000Z",
        "last_edited_time": "2024-11-19T15:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau đây là 3 cách mình nghĩ nên làm và quan trọng nhất.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau đây là 3 cách mình nghĩ nên làm và quan trọng nhất.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3635074f-41de-47f2-8192-d5936df3934d",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2025-08-19T00:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lắng nghe đối phương (active listening): ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lắng nghe đối phương (active listening): ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "lắng nghe với một sự tập trung, với một tâm thế muốn thấu hiểu, tò mò, điều này sẽ khiến đối phương cảm thấy được tôn trọng & có thiện cảm. >> là cơ hội để họ sẽ gạc bớt vài lớp băng để có tâm lý trả lời tốt hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "lắng nghe với một sự tập trung, với một tâm thế muốn thấu hiểu, tò mò, điều này sẽ khiến đối phương cảm thấy được tôn trọng & có thiện cảm. >> là cơ hội để họ sẽ gạc bớt vài lớp băng để có tâm lý trả lời tốt hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "a1045ff3-d872-4239-b6fe-1555e9c00583",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2025-08-19T00:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Biết cách phát triển câu hỏi từ câu trả lời của đối phương (follow-up question)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Biết cách phát triển câu hỏi từ câu trả lời của đối phương (follow-up question)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ". Nó sẽ giúp mình khai phá được thêm nhiều thông tin hơn và có chiều sâu hơn, đồng thời để kiểm chứng tính xác thực của thông tin hoặc đánh giá xem câu trả lời đang được dựa trên luận điểm nào.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". Nó sẽ giúp mình khai phá được thêm nhiều thông tin hơn và có chiều sâu hơn, đồng thời để kiểm chứng tính xác thực của thông tin hoặc đánh giá xem câu trả lời đang được dựa trên luận điểm nào.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3ea00fb6-96d8-4d6c-af7d-4faf52e00477",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2025-08-19T00:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khả năng linh hoạt & ứng biến điều chỉnh câu hỏi ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khả năng linh hoạt & ứng biến điều chỉnh câu hỏi ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "dựa theo tâm lý đối phương. Điều này đòi hỏi mình chú tâm “nghe” ở những điều đối phương không nói ra (phi ngôn ngữ: thông qua ánh mắt, tone giọng, tốc độ, hành vi tay chân),… Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "dựa theo tâm lý đối phương. Điều này đòi hỏi mình chú tâm “nghe” ở những điều đối phương không nói ra (phi ngôn ngữ: thông qua ánh mắt, tone giọng, tốc độ, hành vi tay chân),… Ví dụ:",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "aac0068d-0375-40f0-9bca-837a26a4a892",
            "parent": {
              "type": "block_id",
              "block_id": "3ea00fb6-96d8-4d6c-af7d-4faf52e00477"
            },
            "created_time": "2024-11-19T01:48:00.000Z",
            "last_edited_time": "2024-11-19T01:48:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Đối phương trả lời dài dòng hoặc chung chung? → Đặt câu hỏi cụ thể hơn.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Đối phương trả lời dài dòng hoặc chung chung? → Đặt câu hỏi cụ thể hơn.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "c43c83d2-25d4-435c-9cc8-c1e3ab22479a",
            "parent": {
              "type": "block_id",
              "block_id": "3ea00fb6-96d8-4d6c-af7d-4faf52e00477"
            },
            "created_time": "2024-11-19T01:48:00.000Z",
            "last_edited_time": "2024-11-19T01:48:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Đối phương né tránh? → Hỏi lại từ một góc độ nhẹ nhàng hơn.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Đối phương né tránh? → Hỏi lại từ một góc độ nhẹ nhàng hơn.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "441543d2-dd54-4396-8473-73129af44e3b",
            "parent": {
              "type": "block_id",
              "block_id": "3ea00fb6-96d8-4d6c-af7d-4faf52e00477"
            },
            "created_time": "2024-11-19T01:48:00.000Z",
            "last_edited_time": "2024-11-19T01:48:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Đối phương trầm tư? → Chờ đợi hoặc khuyến khích thêm.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Đối phương trầm tư? → Chờ đợi hoặc khuyến khích thêm.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "bd075601-832d-40c8-9c3f-0ae65162f75e",
            "parent": {
              "type": "block_id",
              "block_id": "3ea00fb6-96d8-4d6c-af7d-4faf52e00477"
            },
            "created_time": "2024-11-19T01:48:00.000Z",
            "last_edited_time": "2024-11-19T01:48:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Đối phương hào hứng → Hỏi thêm chi tiết để duy trì năng lượng",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Đối phương hào hứng → Hỏi thêm chi tiết để duy trì năng lượng",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "f8f655b0-c24c-4af7-8d50-15a175af862b",
            "parent": {
              "type": "block_id",
              "block_id": "3ea00fb6-96d8-4d6c-af7d-4faf52e00477"
            },
            "created_time": "2024-11-19T01:48:00.000Z",
            "last_edited_time": "2025-08-19T00:48:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Nếu mình hỏi \"Tại sao bạn làm vậy?\" mà đối phương phòng thủ, hãy đổi sang \"Bạn có thể chia sẻ thêm về điều gì đã dẫn bạn tới quyết định này không?\"",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Nếu mình hỏi \"Tại sao bạn làm vậy?\" mà đối phương phòng thủ, hãy đổi sang \"Bạn có thể chia sẻ thêm về điều gì đã dẫn bạn tới quyết định này không?\"",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "7c945762-b755-4c40-807c-c4e8cdb1254b",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-11-19T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1435d164-78d8-8002-80a1-eabb806315a5",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T11:29:00.000Z",
        "last_edited_time": "2024-11-19T11:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tóm lại",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tóm lại",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "8f0dd062-3365-48f7-a139-0a3b20148a62",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-11-19T11:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để học cách hỏi, hãy tự trả lời các câu hỏi sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để học cách hỏi, hãy tự trả lời các câu hỏi sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "82d6cbb4-dcc6-4e78-891f-047100b9b1f6",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2025-05-23T16:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "5165801c-2967-4fcd-80db-2995a4891f28",
            "parent": {
              "type": "block_id",
              "block_id": "82d6cbb4-dcc6-4e78-891f-047100b9b1f6"
            },
            "created_time": "2024-11-19T01:48:00.000Z",
            "last_edited_time": "2024-11-19T01:48:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Mục tiêu của việc hỏi ở đây là gì?",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Mục tiêu của việc hỏi ở đây là gì?",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 0
          },
          {
            "object": "block",
            "id": "1435d164-78d8-80a6-91ef-c905e59e8f8e",
            "parent": {
              "type": "block_id",
              "block_id": "82d6cbb4-dcc6-4e78-891f-047100b9b1f6"
            },
            "created_time": "2024-11-19T01:56:00.000Z",
            "last_edited_time": "2024-12-30T12:15:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Mình sẽ hỏi gì? Kịch bản?",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Mình sẽ hỏi gì? Kịch bản?",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 1
          },
          {
            "object": "block",
            "id": "cd420a94-e9c9-4d36-ab5f-55a1c8d540ee",
            "parent": {
              "type": "block_id",
              "block_id": "82d6cbb4-dcc6-4e78-891f-047100b9b1f6"
            },
            "created_time": "2024-11-19T01:48:00.000Z",
            "last_edited_time": "2024-11-19T01:48:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Mình có đang hỏi đúng người, đúng thời điểm, đúng trọng tâm không?",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Mình có đang hỏi đúng người, đúng thời điểm, đúng trọng tâm không?",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 2
          },
          {
            "object": "block",
            "id": "3181b196-784e-4f60-a9ab-daf822644c29",
            "parent": {
              "type": "block_id",
              "block_id": "82d6cbb4-dcc6-4e78-891f-047100b9b1f6"
            },
            "created_time": "2024-11-19T01:48:00.000Z",
            "last_edited_time": "2024-11-19T11:30:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Mình nên hỏi sao cho “khéo”?",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Mình nên hỏi sao cho “khéo”?",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 3
          }
        ]
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-80eb-834e-cb8c416a6a80",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2025-05-23T16:24:00.000Z",
        "last_edited_time": "2025-05-23T16:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-80c8-9f47-fc27f302f6b1",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2025-05-23T16:24:00.000Z",
        "last_edited_time": "2025-05-23T16:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-8000-9ad1-c91c4e587220",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2025-05-23T16:24:00.000Z",
        "last_edited_time": "2025-05-23T16:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "video",
        "video": {
          "caption": [],
          "type": "external",
          "external": {
            "url": "https://youtu.be/i9NRHLRKi6k?si=rmKWg2PqlJ3DZ4d1"
          }
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "987ac90f-352d-4720-a3e5-01bd67cd6a25",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-11-19T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "ef6948a7-10f5-42b7-b41b-fa52aa7ffd50",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-11-19T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1435d164-78d8-80c1-b117-e61646b6f969",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T02:16:00.000Z",
        "last_edited_time": "2024-11-19T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "95727332-bdb3-4f63-a0cd-f9023732995d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Questioning (P1)",
              "href": "https://app.notion.com/p/95727332bdb34f63a0cdf9023732995d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "a3ce2e44-b801-44e8-a0ca-d86877898d6f",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-11-19T11:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1425d164-78d8-80f2-9f44-e27115c54d8b"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Questioning (P3)",
              "href": "https://app.notion.com/p/1425d16478d880f29f44e27115c54d8b"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "0b16b617-5943-41d8-a2dd-990006c2691f",
        "parent": {
          "type": "page_id",
          "page_id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-11-19T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1405d164-78d8-801f-aad4-f558038c6ba3"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Principle of Communication",
              "href": "https://app.notion.com/p/1405d16478d8801faad4f558038c6ba3"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1425d164-78d8-80f2-9f44-e27115c54d8b",
    "created_time": "2024-11-18T10:37:00.000Z",
    "last_edited_time": "2025-05-23T16:24:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-11-18T10:37:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "1-Understanding",
          "color": "orange"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 24
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-05-23T16:24:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "cZzk",
          "name": "⚔️:3",
          "color": "orange"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Questioning (P3)",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Questioning (P3)",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Questioning-P3-1425d16478d880f29f44e27115c54d8b",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
      "name": "Understanding",
      "slug": "understanding",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "a21082e0-d1c3-49d7-8e55-abb4c64638be",
        "parent": {
          "type": "page_id",
          "page_id": "1425d164-78d8-80f2-9f44-e27115c54d8b"
        },
        "created_time": "2024-11-18T10:37:00.000Z",
        "last_edited_time": "2024-11-18T10:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081302/uxcomic-imgs/a21082e0-d1c3-49d7-8e55-abb4c64638be.png",
            "expiry_time": "2026-10-04T09:11:20.067Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/a21082e0-d1c3-49d7-8e55-abb4c64638be"
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8026-8a17-e7a9b12c9733",
        "parent": {
          "type": "page_id",
          "page_id": "1425d164-78d8-80f2-9f44-e27115c54d8b"
        },
        "created_time": "2024-11-17T16:41:00.000Z",
        "last_edited_time": "2024-11-19T02:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hỏi có chiến lược",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hỏi có chiến lược",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-809f-8e41-fb7c4cf665e7",
        "parent": {
          "type": "page_id",
          "page_id": "1425d164-78d8-80f2-9f44-e27115c54d8b"
        },
        "created_time": "2024-11-18T15:01:00.000Z",
        "last_edited_time": "2024-11-19T02:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Liệt kê ra các ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Liệt kê ra các ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "mục tiêu của việc hỏi ở đây là gì, ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "mục tiêu của việc hỏi ở đây là gì, ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "hình dung",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "hình dung",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "các thứ mình cần biết, và “dịch” nó thành các câu hỏi, rồi sắp xếp & ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "các thứ mình cần biết, và “dịch” nó thành các câu hỏi, rồi sắp xếp & ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "ưu tiên",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "ưu tiên",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " chúng. (Method Tree Structure Questioning: giống mindmap vậy, nó giúp bạn phân tách chủ đề và phát triển sâu chuỗi câu hỏi cho từng topic.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " chúng. (Method Tree Structure Questioning: giống mindmap vậy, nó giúp bạn phân tách chủ đề và phát triển sâu chuỗi câu hỏi cho từng topic.",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Kỹ thuật này giúp mình vừa bám sát mục tiêu vừa khai thác sâu khi cần).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kỹ thuật này giúp mình vừa bám sát mục tiêu vừa khai thác sâu khi cần).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8009-965f-d26ae323a895",
        "parent": {
          "type": "page_id",
          "page_id": "1425d164-78d8-80f2-9f44-e27115c54d8b"
        },
        "created_time": "2024-11-18T14:51:00.000Z",
        "last_edited_time": "2024-12-30T12:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Fine tune: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Fine tune: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "tinh chỉnh câu hỏi, nắm các do & don’t trong việc hình thành câu hỏi. Và thử nghĩ xem liệu có “một phiên bản” tốt hơn của câu hỏi đó hay không.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "tinh chỉnh câu hỏi, nắm các do & don’t trong việc hình thành câu hỏi. Và thử nghĩ xem liệu có “một phiên bản” tốt hơn của câu hỏi đó hay không.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8053-a250-db9eee0291a9",
        "parent": {
          "type": "page_id",
          "page_id": "1425d164-78d8-80f2-9f44-e27115c54d8b"
        },
        "created_time": "2024-11-17T18:04:00.000Z",
        "last_edited_time": "2024-12-30T12:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dàn ý: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dàn ý: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cũng như lúc mình học văn thôi, mình có mở bài, thân bài, kết bài. Dàn ý này sẽ dẫn dắt lối suy nghĩ để có một cái nhìn đủ rộng & sâu, từ đó rút ra được một kết luận.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cũng như lúc mình học văn thôi, mình có mở bài, thân bài, kết bài. Dàn ý này sẽ dẫn dắt lối suy nghĩ để có một cái nhìn đủ rộng & sâu, từ đó rút ra được một kết luận.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2,
        "children": [
          {
            "object": "block",
            "id": "1415d164-78d8-8009-8f9e-faa903d6e919",
            "parent": {
              "type": "block_id",
              "block_id": "1415d164-78d8-8053-a250-db9eee0291a9"
            },
            "created_time": "2024-11-17T18:05:00.000Z",
            "last_edited_time": "2024-11-18T15:01:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Mở đầu (Exploration): khám phá vấn đề rộng, về bối cảnh, về background.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Mở đầu (Exploration): khám phá vấn đề rộng, về bối cảnh, về background.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 0
          },
          {
            "object": "block",
            "id": "1415d164-78d8-8092-9dda-e71043b35d44",
            "parent": {
              "type": "block_id",
              "block_id": "1415d164-78d8-8053-a250-db9eee0291a9"
            },
            "created_time": "2024-11-17T18:06:00.000Z",
            "last_edited_time": "2024-11-17T18:09:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Đào sâu (Digging Deeper): làm rõ chi tiết hoặc khám phá ý nghĩa sâu xa.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Đào sâu (Digging Deeper): làm rõ chi tiết hoặc khám phá ý nghĩa sâu xa.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 1
          },
          {
            "object": "block",
            "id": "1415d164-78d8-80e1-b9f1-d9a9349e3101",
            "parent": {
              "type": "block_id",
              "block_id": "1415d164-78d8-8053-a250-db9eee0291a9"
            },
            "created_time": "2024-11-17T18:07:00.000Z",
            "last_edited_time": "2024-11-18T14:54:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Định hướng (Guidance): hướng câu trả lời tới giải pháp hoặc kết luận.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Định hướng (Guidance): hướng câu trả lời tới giải pháp hoặc kết luận.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 2
          }
        ]
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80c1-92b7-f1bad74ddb5a",
        "parent": {
          "type": "page_id",
          "page_id": "1425d164-78d8-80f2-9f44-e27115c54d8b"
        },
        "created_time": "2024-11-17T18:14:00.000Z",
        "last_edited_time": "2024-11-18T14:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tình huống & câu hỏi đối ứng: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tình huống & câu hỏi đối ứng: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "trong quá trình trao đổi, chắc chắn sẽ có những trường hợp khác nhau xảy ra khiến ta không thu được thông tin mong muốn, ví dụ: đối phương không rõ hoặc không có đủ thông tin để trả lời, hoặc họ không muốn trả lời, cố tình né tránh,… Vậy sự chuẩn bị trước các kịch bản hỏi (plan B) sẽ giúp tăng tính linh hoạt trong cuộc hội thoại.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "trong quá trình trao đổi, chắc chắn sẽ có những trường hợp khác nhau xảy ra khiến ta không thu được thông tin mong muốn, ví dụ: đối phương không rõ hoặc không có đủ thông tin để trả lời, hoặc họ không muốn trả lời, cố tình né tránh,… Vậy sự chuẩn bị trước các kịch bản hỏi (plan B) sẽ giúp tăng tính linh hoạt trong cuộc hội thoại.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 3
      },
      {
        "object": "block",
        "id": "1425d164-78d8-80ed-b891-d5b43a000488",
        "parent": {
          "type": "page_id",
          "page_id": "1425d164-78d8-80f2-9f44-e27115c54d8b"
        },
        "created_time": "2024-11-18T00:44:00.000Z",
        "last_edited_time": "2024-11-18T15:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [
            {
              "type": "text",
              "text": {
                "content": "https://productcoalition.com/how-to-define-customer-problems-part-2-of-5-the-issue-tree-e0c64a6c814d",
                "link": {
                  "url": "https://productcoalition.com/how-to-define-customer-problems-part-2-of-5-the-issue-tree-e0c64a6c814d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://productcoalition.com/how-to-define-customer-problems-part-2-of-5-the-issue-tree-e0c64a6c814d",
              "href": "https://productcoalition.com/how-to-define-customer-problems-part-2-of-5-the-issue-tree-e0c64a6c814d"
            }
          ],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081304/uxcomic-imgs/1425d164-78d8-80ed-b891-d5b43a000488.png",
            "expiry_time": "2026-10-04T09:11:20.068Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1425d164-78d8-80ed-b891-d5b43a000488"
      },
      {
        "object": "block",
        "id": "1425d164-78d8-805c-a7e8-c6b3bd2b900b",
        "parent": {
          "type": "page_id",
          "page_id": "1425d164-78d8-80f2-9f44-e27115c54d8b"
        },
        "created_time": "2024-11-18T00:44:00.000Z",
        "last_edited_time": "2024-11-18T10:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-80c2-9c57-fdb79c527ff8",
        "parent": {
          "type": "page_id",
          "page_id": "1425d164-78d8-80f2-9f44-e27115c54d8b"
        },
        "created_time": "2024-11-18T05:55:00.000Z",
        "last_edited_time": "2024-11-18T10:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vài sai lầm trong việc hỏi",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vài sai lầm trong việc hỏi",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-80fe-8872-e58455de47bb",
        "parent": {
          "type": "page_id",
          "page_id": "1425d164-78d8-80f2-9f44-e27115c54d8b"
        },
        "created_time": "2024-11-18T08:20:00.000Z",
        "last_edited_time": "2024-12-30T12:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Câu hỏi mơ hồ, chung chung ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Câu hỏi mơ hồ, chung chung ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "(không lấy được thông tin cụ thể).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "(không lấy được thông tin cụ thể).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-80e1-8af8-fbd16917843d",
        "parent": {
          "type": "page_id",
          "page_id": "1425d164-78d8-80f2-9f44-e27115c54d8b"
        },
        "created_time": "2024-11-18T08:17:00.000Z",
        "last_edited_time": "2024-12-30T12:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hỏi sai thời điểm ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hỏi sai thời điểm ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "(họ đang bận hay cảm xúc không ổn định).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "(họ đang bận hay cảm xúc không ổn định).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8017-81e2-cb6c2824703a",
        "parent": {
          "type": "page_id",
          "page_id": "1425d164-78d8-80f2-9f44-e27115c54d8b"
        },
        "created_time": "2024-11-18T08:17:00.000Z",
        "last_edited_time": "2024-12-30T12:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tránh các câu hỏi dẫn dắt ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tránh các câu hỏi dẫn dắt ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "(Leading Questions). Nếu bạn có chủ đích là khai thác thêm thông tin thì hãy tránh tối đa sử dụng dạng này. Vì khả năng cao đối phương muốn tránh xung đột hoặc muốn làm bạn hài lòng, họ sẽ đưa ra câu trả lời không giống như cái họ đang nghĩ, dẫn đến thông tin thu về thiếu chính xác, bị bóp méo. Ví dụ: bạn hỏi “Mẹ ơi, màn hình này đẹp không?”, mẹ: “đẹp”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "(Leading Questions). Nếu bạn có chủ đích là khai thác thêm thông tin thì hãy tránh tối đa sử dụng dạng này. Vì khả năng cao đối phương muốn tránh xung đột hoặc muốn làm bạn hài lòng, họ sẽ đưa ra câu trả lời không giống như cái họ đang nghĩ, dẫn đến thông tin thu về thiếu chính xác, bị bóp méo. Ví dụ: bạn hỏi “Mẹ ơi, màn hình này đẹp không?”, mẹ: “đẹp”.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8097-aa20-dedc555ff36e",
        "parent": {
          "type": "page_id",
          "page_id": "1425d164-78d8-80f2-9f44-e27115c54d8b"
        },
        "created_time": "2024-11-18T06:03:00.000Z",
        "last_edited_time": "2024-11-18T10:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bỏ qua câu hỏi follow-up",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bỏ qua câu hỏi follow-up",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ". Khiến bạn bỏ lỡ các thông tin giá trị để giúp hiểu rõ vấn đề hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". Khiến bạn bỏ lỡ các thông tin giá trị để giúp hiểu rõ vấn đề hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-806e-a7c7-e75be3a027ec",
        "parent": {
          "type": "page_id",
          "page_id": "1425d164-78d8-80f2-9f44-e27115c54d8b"
        },
        "created_time": "2024-11-18T08:26:00.000Z",
        "last_edited_time": "2025-05-21T06:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Liên tục đặt câu hỏi. ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Liên tục đặt câu hỏi. ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Cách hỏi này",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách hỏi này",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "kiểu như đang bị điều tra hay làm khó vậy, khiến cho họ cảm thấy áp lực và dễ bị khó chịu. Việc này rơi vào bản năng & việc rèn luyện hơn, làm sao vẫn giữ mạch hỏi tốt mà không làm đối phương khó chịu.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "kiểu như đang bị điều tra hay làm khó vậy, khiến cho họ cảm thấy áp lực và dễ bị khó chịu. Việc này rơi vào bản năng & việc rèn luyện hơn, làm sao vẫn giữ mạch hỏi tốt mà không làm đối phương khó chịu.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fc5d164-78d8-8015-9780-de006b8545fa",
        "parent": {
          "type": "page_id",
          "page_id": "1425d164-78d8-80f2-9f44-e27115c54d8b"
        },
        "created_time": "2025-05-23T16:23:00.000Z",
        "last_edited_time": "2025-05-23T16:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "0957821e-08b7-4797-a0a3-b770efdb2748",
        "parent": {
          "type": "page_id",
          "page_id": "1425d164-78d8-80f2-9f44-e27115c54d8b"
        },
        "created_time": "2024-11-18T10:37:00.000Z",
        "last_edited_time": "2024-11-18T10:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "d62f3eb7-1d56-45e9-be37-10290f6e247d",
        "parent": {
          "type": "page_id",
          "page_id": "1425d164-78d8-80f2-9f44-e27115c54d8b"
        },
        "created_time": "2024-11-18T10:37:00.000Z",
        "last_edited_time": "2024-11-19T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "95727332-bdb3-4f63-a0cd-f9023732995d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Questioning (P1)",
              "href": "https://app.notion.com/p/95727332bdb34f63a0cdf9023732995d"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1435d164-78d8-80e9-bbd6-c360fce38b2a",
        "parent": {
          "type": "page_id",
          "page_id": "1425d164-78d8-80f2-9f44-e27115c54d8b"
        },
        "created_time": "2024-11-19T02:19:00.000Z",
        "last_edited_time": "2025-05-21T06:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Questioning (P2)",
              "href": "https://app.notion.com/p/1435d16478d88004930ce9f3fede9fe4"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-80f7-ab80-c3b628c7e128",
        "parent": {
          "type": "page_id",
          "page_id": "1425d164-78d8-80f2-9f44-e27115c54d8b"
        },
        "created_time": "2025-05-21T06:31:00.000Z",
        "last_edited_time": "2025-05-21T06:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1fa5d164-78d8-80ea-9589-e1218df460a6"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Questioning (P4)",
              "href": "https://app.notion.com/p/1fa5d16478d880ea9589e1218df460a6"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1405d164-78d8-801f-aad4-f558038c6ba3",
    "created_time": "2024-11-16T09:05:00.000Z",
    "last_edited_time": "2025-08-27T02:14:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-11-16T09:05:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "2-Communication",
          "color": "default"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 23
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-27T02:14:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "tMsg",
          "name": "⚓:1",
          "color": "default"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Principle of Communication",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Principle of Communication",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Principle-of-Communication-1405d16478d8801faad4f558038c6ba3",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Communication",
      "slug": "communication",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "1405d164-78d8-8166-80d3-c86b7584bcf9",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-16T09:05:00.000Z",
        "last_edited_time": "2024-11-16T09:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081306/uxcomic-imgs/1405d164-78d8-8166-80d3-c86b7584bcf9.png",
            "expiry_time": "2026-10-04T09:11:20.758Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1405d164-78d8-8166-80d3-c86b7584bcf9"
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80ea-aa37-dacd137780b3",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T01:14:00.000Z",
        "last_edited_time": "2024-12-12T10:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giao tiếp là một quá trình ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giao tiếp là một quá trình ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "chuyển giao ý nghĩ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "chuyển giao ý nghĩ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " giữa các cá nhân hoặc nhóm, thông qua việc trao đổi thông điệp, ý tưởng, cảm xúc.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " giữa các cá nhân hoặc nhóm, thông qua việc trao đổi thông điệp, ý tưởng, cảm xúc.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8000-a9ce-cf3706d6a43c",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T01:26:00.000Z",
        "last_edited_time": "2024-11-17T01:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8064-84a9-c0d66c2e4688",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-16T09:19:00.000Z",
        "last_edited_time": "2024-12-12T10:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Communication model",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Communication model",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8005-8fd0-cf5892578b71",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-16T09:15:00.000Z",
        "last_edited_time": "2024-12-12T10:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081308/uxcomic-imgs/1405d164-78d8-8005-8fd0-cf5892578b71.png",
            "expiry_time": "2026-10-04T09:11:20.758Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1405d164-78d8-8005-8fd0-cf5892578b71"
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-8072-898d-e4e2cd428ba3",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-12-12T10:41:00.000Z",
        "last_edited_time": "2024-12-12T10:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hình vẽ này theo mình mô tả đầy đủ nhất về tính chất của giao tiếp,  nó bao gồm những thành tố sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hình vẽ này theo mình mô tả đầy đủ nhất về tính chất của giao tiếp,  nó bao gồm những thành tố sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8049-9fb5-ca1ade472a8b",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T01:15:00.000Z",
        "last_edited_time": "2024-12-12T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Actor",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Actor",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": người nói, người nghe. Mỗi nhân vật có background, niềm tin, động lực & nỗi sợ riêng. Điều này tác động lên quá trình encoding & decoding.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": người nói, người nghe. Mỗi nhân vật có background, niềm tin, động lực & nỗi sợ riêng. Điều này tác động lên quá trình encoding & decoding.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80ee-9b5c-fcdd1a0bf35e",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T01:18:00.000Z",
        "last_edited_time": "2024-12-12T10:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Encoding",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Encoding",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": là quá trình chuyển ý nghĩ, cảm xúc thành thông điệp",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": là quá trình chuyển ý nghĩ, cảm xúc thành thông điệp",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8003-96be-de105c4d114c",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T01:18:00.000Z",
        "last_edited_time": "2024-12-12T10:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Message",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Message",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": thông điệp, cái ý, dưới tầng cả nghĩa đen & nghĩa bóng",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": thông điệp, cái ý, dưới tầng cả nghĩa đen & nghĩa bóng",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80ed-b72c-d3ec8f318b0e",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T01:21:00.000Z",
        "last_edited_time": "2024-12-12T10:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Decoding",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Decoding",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": là quá trình giải nghĩa từ thông điệp tiếp nhận",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": là quá trình giải nghĩa từ thông điệp tiếp nhận",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8099-b9bf-f08b2b45ec6a",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T01:24:00.000Z",
        "last_edited_time": "2024-12-12T10:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Feedback",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Feedback",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": phản hồi của người nhận sau khi nhận thông điệp. Có thể không nhất thiết thành lời, đó có thể là những cử chi, cảm xúc sau khi tiếp nhận.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": phản hồi của người nhận sau khi nhận thông điệp. Có thể không nhất thiết thành lời, đó có thể là những cử chi, cảm xúc sau khi tiếp nhận.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-801b-9a8e-e211862d6208",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T01:21:00.000Z",
        "last_edited_time": "2024-12-12T11:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Channel",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Channel",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": là kênh, là hình thức thể hiện thông điệp, ví dụ: lời nói, tin nhắn, ngôn ngữ cơ thể, hình ảnh,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": là kênh, là hình thức thể hiện thông điệp, ví dụ: lời nói, tin nhắn, ngôn ngữ cơ thể, hình ảnh,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80b6-9409-cc01098d4bbb",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T01:24:00.000Z",
        "last_edited_time": "2024-12-25T03:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Noise",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Noise",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": tất cả các yếu tố làm cản trở hoặc nhiễu thông điệp. Cái này chúng ta rất hay không để tâm đến, mặc dù nó có cũng ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": tất cả các yếu tố làm cản trở hoặc nhiễu thông điệp. Cái này chúng ta rất hay không để tâm đến, mặc dù nó có cũng ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "tính tác động rất mạnh",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "tính tác động rất mạnh",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", nó là rào cản cho cuộc trao đổi. Ví dụ cho các dạng noise:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", nó là rào cản cho cuộc trao đổi. Ví dụ cho các dạng noise:",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "15a5d164-78d8-8087-93da-cfc6d1d595f7",
            "parent": {
              "type": "block_id",
              "block_id": "1415d164-78d8-80b6-9409-cc01098d4bbb"
            },
            "created_time": "2024-12-12T10:49:00.000Z",
            "last_edited_time": "2024-12-25T03:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Tâm lý",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Tâm lý",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": ": thành kiến, lo lắng hoặc mất tập trung. Ví dụ: người kia đang bực hay có thành kiến với bạn thì nói gì lúc đó thì chắc cũng không ăn thua.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": ": thành kiến, lo lắng hoặc mất tập trung. Ví dụ: người kia đang bực hay có thành kiến với bạn thì nói gì lúc đó thì chắc cũng không ăn thua.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "15a5d164-78d8-80c6-aa74-d4ed8a0dabf7",
            "parent": {
              "type": "block_id",
              "block_id": "1415d164-78d8-80b6-9409-cc01098d4bbb"
            },
            "created_time": "2024-12-12T10:48:00.000Z",
            "last_edited_time": "2024-12-17T05:59:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Môi trường vật lý",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Môi trường vật lý",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": ": ồn ào, đông đúc, có người gián đoạn… làm mất đi sự tập trung.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": ": ồn ào, đông đúc, có người gián đoạn… làm mất đi sự tập trung.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "15a5d164-78d8-80ba-9ef7-f5407ff20cb8",
            "parent": {
              "type": "block_id",
              "block_id": "1415d164-78d8-80b6-9409-cc01098d4bbb"
            },
            "created_time": "2024-12-12T10:50:00.000Z",
            "last_edited_time": "2024-12-17T05:57:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Sinh lý:",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Sinh lý:",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": " bệnh, mệt mỏi, buồn ngủ :))",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": " bệnh, mệt mỏi, buồn ngủ :))",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "15a5d164-78d8-80ab-a813-fdce2d13e2fc",
            "parent": {
              "type": "block_id",
              "block_id": "1415d164-78d8-80b6-9409-cc01098d4bbb"
            },
            "created_time": "2024-12-12T10:51:00.000Z",
            "last_edited_time": "2024-12-17T05:59:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Văn hoá",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Văn hoá",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": ": cách diễn đạt, cử chi không phù hợp, ví dụ nói chuyện với người lớn tuổi khác với đồng trang lứa hay khác biệt vùng miền chẳng hạn.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": ": cách diễn đạt, cử chi không phù hợp, ví dụ nói chuyện với người lớn tuổi khác với đồng trang lứa hay khác biệt vùng miền chẳng hạn.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8027-a0bf-e6c8b98f660e",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T01:25:00.000Z",
        "last_edited_time": "2024-12-12T10:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Context",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Context",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": yếu tố này không được nhắc đến nhưng mình thấy nó cũng khá quan trọng. Ví dụ: vị thế của các bên trong buổi giao tiếp, mục tiêu của buổi trò chuyện, mức độ quan tâm của người nghe…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": yếu tố này không được nhắc đến nhưng mình thấy nó cũng khá quan trọng. Ví dụ: vị thế của các bên trong buổi giao tiếp, mục tiêu của buổi trò chuyện, mức độ quan tâm của người nghe…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80a8-baab-e43264269904",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T01:14:00.000Z",
        "last_edited_time": "2024-11-17T01:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-817e-a51c-f6c235e73a03",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-16T09:05:00.000Z",
        "last_edited_time": "2024-11-16T09:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Communication diễn ra như thế nào",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Communication diễn ra như thế nào",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8008-8dc1-f00e34a1a5bb",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-16T09:18:00.000Z",
        "last_edited_time": "2024-11-16T09:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081310/uxcomic-imgs/1405d164-78d8-8008-8dc1-f00e34a1a5bb.png",
            "expiry_time": "2026-10-04T09:11:20.759Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1405d164-78d8-8008-8dc1-f00e34a1a5bb"
      },
      {
        "object": "block",
        "id": "1415d164-78d8-800c-999f-fae24e406b6d",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T01:32:00.000Z",
        "last_edited_time": "2024-11-17T01:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Người gửi",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Người gửi",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Họ có một suy nghĩ, cảm xúc, hoặc ý tưởng. Họ cần \"mã hóa\" nó – chuyển từ suy nghĩ trong đầu thành từ ngữ, hình ảnh, hoặc hành động.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Họ có một suy nghĩ, cảm xúc, hoặc ý tưởng. Họ cần \"mã hóa\" nó – chuyển từ suy nghĩ trong đầu thành từ ngữ, hình ảnh, hoặc hành động.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8023-9c4a-cf09953f21cf",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T01:32:00.000Z",
        "last_edited_time": "2024-12-12T10:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thông điệp",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thông điệp",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Đây chính là hình thức của thông điệp của người gửi đi – một câu nói, một email, hoặc thậm chí một cái nhướn mày. Thông điệp này tồn tại trên một \"kênh\" nào đó – một cuộc gặp mặt trò chuyện, một bài đăng trên mạng xã hội, voice call, video call...",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Đây chính là hình thức của thông điệp của người gửi đi – một câu nói, một email, hoặc thậm chí một cái nhướn mày. Thông điệp này tồn tại trên một \"kênh\" nào đó – một cuộc gặp mặt trò chuyện, một bài đăng trên mạng xã hội, voice call, video call...",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8097-987a-fd53f27efa19",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T01:32:00.000Z",
        "last_edited_time": "2024-12-12T10:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Người nhận",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Người nhận",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Họ giải mã thông điệp. Ý nghĩa của thông điệp sẽ được chuyển hóa theo cách họ diễn giải dựa trên kinh nghiệm, cảm xúc, và bối cảnh để dẫn đến một cái hiểu. Khi người nhận hiểu, họ sẽ phản hồi lại, và vòng tuần hoàn này cứ thế tiếp tục.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Họ giải mã thông điệp. Ý nghĩa của thông điệp sẽ được chuyển hóa theo cách họ diễn giải dựa trên kinh nghiệm, cảm xúc, và bối cảnh để dẫn đến một cái hiểu. Khi người nhận hiểu, họ sẽ phản hồi lại, và vòng tuần hoàn này cứ thế tiếp tục.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-8065-b4eb-d81abe2a1d2c",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-12-12T11:01:00.000Z",
        "last_edited_time": "2025-08-27T01:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong quá trình này, sẽ có ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong quá trình này, sẽ có ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "noise tác động",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "noise tác động",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " lên thông điệp khiến nó có thể gặp vài cản trở hoặc nhiễu ý nghĩa. Điểm cần quan tâm nhất đến noise đó là hãy cố gắng tạo được thiện cảm, trước mắt bạn cần là một người đáng tin cậy, có sự thấu hiểu, biết lắng nghe >> lúc này thông điệp bạn gửi đi mới ít bị cản trở. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " lên thông điệp khiến nó có thể gặp vài cản trở hoặc nhiễu ý nghĩa. Điểm cần quan tâm nhất đến noise đó là hãy cố gắng tạo được thiện cảm, trước mắt bạn cần là một người đáng tin cậy, có sự thấu hiểu, biết lắng nghe >> lúc này thông điệp bạn gửi đi mới ít bị cản trở. ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Tip: hãy cố gắng đặt mình ở vị thế người khác, rà tần số của họ - hình dung ngôn ngữ của họ, hiểu động lực, nỗi sợ của họ là gì.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tip: hãy cố gắng đặt mình ở vị thế người khác, rà tần số của họ - hình dung ngôn ngữ của họ, hiểu động lực, nỗi sợ của họ là gì.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1575d164-78d8-804c-a563-c9a0be0d9835",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-12-09T12:38:00.000Z",
        "last_edited_time": "2024-12-25T03:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Right message (relevant), right time, right channel.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Right message (relevant), right time, right channel.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80bd-aa91-d72a8b427d43",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T01:34:00.000Z",
        "last_edited_time": "2025-08-27T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Như vậy một giao tiếp tốt có nghĩa là quá trình mình truyền đạt ý nghĩ phải tốt, cái ý phía người nói càng giống với cái ý mà ở phía người nhận giải nghĩa ra càng tốt = thông suốt.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Như vậy một giao tiếp tốt có nghĩa là quá trình mình truyền đạt ý nghĩ phải tốt, cái ý phía người nói càng giống với cái ý mà ở phía người nhận giải nghĩa ra càng tốt = thông suốt.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25c5d164-78d8-80e6-af5d-d84327b5c40f",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2025-08-27T01:53:00.000Z",
        "last_edited_time": "2025-08-27T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8041-b5ec-cd9a92ce040a",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T05:25:00.000Z",
        "last_edited_time": "2025-08-27T01:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "À mà đôi khi việc đối phương không hoàn toàn hiểu ý mình cũng có một tác động thú vị khác, ví dụ khi một nhạc sĩ tạo ra một bài hát, người nghe thấy đồng cảm và hiểu theo góc nhìn của họ, khơi gợi những cảm xúc & liên hệ đến chính trải nghiệm của họ >> có tính cá nhân hơn, từ đó mà tác động vào cảm xúc người nghe tốt hơn. Tuy nhiên trong công việc thì hiếm khi nào như thế là tốt, nếu mỗi người hiểu mỗi kiểu.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "À mà đôi khi việc đối phương không hoàn toàn hiểu ý mình cũng có một tác động thú vị khác, ví dụ khi một nhạc sĩ tạo ra một bài hát, người nghe thấy đồng cảm và hiểu theo góc nhìn của họ, khơi gợi những cảm xúc & liên hệ đến chính trải nghiệm của họ >> có tính cá nhân hơn, từ đó mà tác động vào cảm xúc người nghe tốt hơn. Tuy nhiên trong công việc thì hiếm khi nào như thế là tốt, nếu mỗi người hiểu mỗi kiểu.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8070-a582-c53941f4b7de",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T08:56:00.000Z",
        "last_edited_time": "2024-11-17T08:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8041-958a-fcf030a8aa23",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T08:56:00.000Z",
        "last_edited_time": "2024-11-17T09:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tỉ lệ của các hình thái trong giao tiếp",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tỉ lệ của các hình thái trong giao tiếp",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-804f-922b-f20e0f5199e7",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T05:25:00.000Z",
        "last_edited_time": "2024-12-25T03:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081312/uxcomic-imgs/1415d164-78d8-804f-922b-f20e0f5199e7.png",
            "expiry_time": "2026-10-04T09:11:20.861Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1415d164-78d8-804f-922b-f20e0f5199e7"
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8085-b798-dd252feb1a2d",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T08:58:00.000Z",
        "last_edited_time": "2024-12-12T11:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nội dung (Content) – 7%: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nội dung (Content) – 7%: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Đây là những gì bạn ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đây là những gì bạn ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "nói",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "nói",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", là thông tin và ý nghĩa cụ thể mà bạn muốn truyền đạt.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", là thông tin và ý nghĩa cụ thể mà bạn muốn truyền đạt.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8091-aaa7-cef56015686a",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T08:58:00.000Z",
        "last_edited_time": "2024-12-12T11:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tông giọng (Tone of Voice, Speed) – 38%: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tông giọng (Tone of Voice, Speed) – 38%: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cách bạn truyền đạt cảm xúc và thái độ khi giao tiếp. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cách bạn truyền đạt cảm xúc và thái độ khi giao tiếp. ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8084-8f72-d3307a8ed9d9",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T08:58:00.000Z",
        "last_edited_time": "2024-12-12T11:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ngôn ngữ cơ thể (Body Language) – 55%:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ngôn ngữ cơ thể (Body Language) – 55%:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "  phản ánh cảm xúc và thái độ mà bạn không nói ra qua những cử chỉ, ánh mắt, biểu cảm khuôn mặt, và tư thế, tất cả đều truyền đạt thông điệp ngầm mạnh mẽ, ví dụ: khi nói xạo mắt bạn hay đảo liên tục, khi thiếu tự tin có thể cơ thể bạn sẽ có xu hướng khúm núm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "  phản ánh cảm xúc và thái độ mà bạn không nói ra qua những cử chỉ, ánh mắt, biểu cảm khuôn mặt, và tư thế, tất cả đều truyền đạt thông điệp ngầm mạnh mẽ, ví dụ: khi nói xạo mắt bạn hay đảo liên tục, khi thiếu tự tin có thể cơ thể bạn sẽ có xu hướng khúm núm.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8043-b422-d26c0cab0a86",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T08:54:00.000Z",
        "last_edited_time": "2024-12-12T11:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tỉ lệ này ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tỉ lệ này ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "có thể thay đổi tùy theo ngữ cảnh giao tiếp",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "có thể thay đổi tùy theo ngữ cảnh giao tiếp",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", nhưng theo nghiên cứu của Mehrabian, ngôn ngữ cơ thể và tông giọng chiếm phần lớn trong cách người nghe tiếp nhận thông điệp của bạn. Nên khi truyền đạt thông tin, đừng chỉ chú trọng vào nội dung mà hãy đảm bảo rằng ngôn ngữ cơ thể và tông giọng của bạn cũng phản ánh đúng cảm xúc và thái độ bạn muốn truyền tải.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", nhưng theo nghiên cứu của Mehrabian, ngôn ngữ cơ thể và tông giọng chiếm phần lớn trong cách người nghe tiếp nhận thông điệp của bạn. Nên khi truyền đạt thông tin, đừng chỉ chú trọng vào nội dung mà hãy đảm bảo rằng ngôn ngữ cơ thể và tông giọng của bạn cũng phản ánh đúng cảm xúc và thái độ bạn muốn truyền tải.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80de-9b45-d2ed0d14e873",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T09:04:00.000Z",
        "last_edited_time": "2024-12-12T11:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đây cũng lí giải tại sao khi các cuộc gặp mặt trực tiếp sẽ giúp hiểu nhau hơn là nhắn tin hay gọi điện, vì chúng ta không quan sát được các ngôn ngữ cơ thể. Từng cái cử chỉ nhỏ, ánh mắt đều cho một lượng lớn thông tin về thái độ, hành vi, tâm lý của đối phương.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đây cũng lí giải tại sao khi các cuộc gặp mặt trực tiếp sẽ giúp hiểu nhau hơn là nhắn tin hay gọi điện, vì chúng ta không quan sát được các ngôn ngữ cơ thể. Từng cái cử chỉ nhỏ, ánh mắt đều cho một lượng lớn thông tin về thái độ, hành vi, tâm lý của đối phương.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80db-9517-e714bda8e277",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T01:40:00.000Z",
        "last_edited_time": "2024-11-17T01:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8194-9aca-ddb3eb0f9863",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-16T09:05:00.000Z",
        "last_edited_time": "2024-12-12T06:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bonus",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bonus",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80bf-a911-daf4d643e024",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T01:48:00.000Z",
        "last_edited_time": "2024-12-25T03:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thông điệp & Channel: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thông điệp & Channel: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "mỗi hình thức truyền tải thông điệp của bạn có những mặt lợi hại khác nhau. Tuỳ theo mục tiêu của thông điệp và tình huống hãy lựa chọn phù hợp. Ví dụ: nếu cần nhanh và sự rõ ràng nên ưu tiên gặp mặt trực tiếp trao đổi; nếu cần chi tiết, phức tạp thì hãy dùng email, tài liệu viết; nếu bạn muốn khích lệ sự tò mò của đối phương hãy thử đặt tình huống.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "mỗi hình thức truyền tải thông điệp của bạn có những mặt lợi hại khác nhau. Tuỳ theo mục tiêu của thông điệp và tình huống hãy lựa chọn phù hợp. Ví dụ: nếu cần nhanh và sự rõ ràng nên ưu tiên gặp mặt trực tiếp trao đổi; nếu cần chi tiết, phức tạp thì hãy dùng email, tài liệu viết; nếu bạn muốn khích lệ sự tò mò của đối phương hãy thử đặt tình huống.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-8061-83c8-f7524520ffe2",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-12-25T03:29:00.000Z",
        "last_edited_time": "2024-12-25T03:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vài nhìn nhận mình thấy thú vị về channel:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vài nhìn nhận mình thấy thú vị về channel:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80f2-a9d6-d6235cb9bdf3",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T02:11:00.000Z",
        "last_edited_time": "2025-08-27T01:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sách: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sách: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "có lúc mình nghĩ đến việc đọc sách sao có một sự thú vị riêng, thì aha! Tại vì đọc sách là quá trình bạn lắng nghe tuyệt đối, tác giả không ngồi kế bạn để bạn có thể tranh luận, tất cả sự tập trung của bạn được dành cho việc cố hiểu xem những gì tác giả viết, cố gắng giải nghĩa chúng → khi đọc sách, luôn có một tiếng nói chảy trong đầu, nó giống như lúc bạn suy nghĩ, việc này khiến việc đọc giống như đang mô phỏng lại quá trình tác giả suy nghĩ vậy. Nó làm mình liên tưởng đến professor X trong Xmen.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "có lúc mình nghĩ đến việc đọc sách sao có một sự thú vị riêng, thì aha! Tại vì đọc sách là quá trình bạn lắng nghe tuyệt đối, tác giả không ngồi kế bạn để bạn có thể tranh luận, tất cả sự tập trung của bạn được dành cho việc cố hiểu xem những gì tác giả viết, cố gắng giải nghĩa chúng → khi đọc sách, luôn có một tiếng nói chảy trong đầu, nó giống như lúc bạn suy nghĩ, việc này khiến việc đọc giống như đang mô phỏng lại quá trình tác giả suy nghĩ vậy. Nó làm mình liên tưởng đến professor X trong Xmen.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80ed-a82e-ec3c6e9320c6",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T02:11:00.000Z",
        "last_edited_time": "2025-08-27T02:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Còn dùng ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Còn dùng ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "chatGPT ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "chatGPT ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "sao mà cuốn thế!  Là vì nó được tương tác như một cuộc trao đổi giữa người với người, điều này trước đó công nghệ khó làm được, nó khiến việc bạn dùng công nghệ cực kì trực quan, khác hẳn với cách mình tiêu thụ thông tin thông thường trước đó - thường bị hạn chế bởi cách product define cách phản hồi (vd: like, comment, share…) nhưng qua chat với AI, thì bạn bày tỏ mọi thứ được thông qua việc giao tiếp lại (có thể bạn hỏi 1 câu khác follow-up, phản biện với nó, kiu nó thử đưa ra 3 pov khác,…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "sao mà cuốn thế!  Là vì nó được tương tác như một cuộc trao đổi giữa người với người, điều này trước đó công nghệ khó làm được, nó khiến việc bạn dùng công nghệ cực kì trực quan, khác hẳn với cách mình tiêu thụ thông tin thông thường trước đó - thường bị hạn chế bởi cách product define cách phản hồi (vd: like, comment, share…) nhưng qua chat với AI, thì bạn bày tỏ mọi thứ được thông qua việc giao tiếp lại (có thể bạn hỏi 1 câu khác follow-up, phản biện với nó, kiu nó thử đưa ra 3 pov khác,…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8058-94ce-d7d14467a955",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T02:11:00.000Z",
        "last_edited_time": "2025-08-27T02:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Âm nhạc, điện ảnh",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Âm nhạc, điện ảnh",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " sao mà cảm xúc lôi cuốn theo một cách rất kì diệu. Vì ngoài ngôn từ, “phi ngôn từ” trong phim ảnh, âm nhạc rất đa dạng và được dùng rất nhiều, từng âm thanh, nốt nhạc, góc quay đến màu sắc đều là những ngôn ngữ để bạn “cảm” nhanh hơn, do nó tác động đến phần unconscious (vô thức)- phần mà không cần tốn nhiều effort cho quá trình decoding (giải nghĩa), nó rất trực tiếp & tự nhiên. Ví dụ: nếu bạn nhìn một tường màu xanh bạn sẽ dễ thấy thoải mái hơn là một màu đỏ chói, vì sao? Vì màu xanh mình bắt gặp nhiều ở bầu trời, biển cả, hồ nước, nó mang lại sự thoải mái do con người thấy trời quan mây tạnh, có nước = an toàn cho sinh tồn,…, còn màu đỏ bạn thấy ở đâu, phần nhiều là máu, là lửa nên cảm xúc nó mạng lại có phần nguy hiểm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " sao mà cảm xúc lôi cuốn theo một cách rất kì diệu. Vì ngoài ngôn từ, “phi ngôn từ” trong phim ảnh, âm nhạc rất đa dạng và được dùng rất nhiều, từng âm thanh, nốt nhạc, góc quay đến màu sắc đều là những ngôn ngữ để bạn “cảm” nhanh hơn, do nó tác động đến phần unconscious (vô thức)- phần mà không cần tốn nhiều effort cho quá trình decoding (giải nghĩa), nó rất trực tiếp & tự nhiên. Ví dụ: nếu bạn nhìn một tường màu xanh bạn sẽ dễ thấy thoải mái hơn là một màu đỏ chói, vì sao? Vì màu xanh mình bắt gặp nhiều ở bầu trời, biển cả, hồ nước, nó mang lại sự thoải mái do con người thấy trời quan mây tạnh, có nước = an toàn cho sinh tồn,…, còn màu đỏ bạn thấy ở đâu, phần nhiều là máu, là lửa nên cảm xúc nó mạng lại có phần nguy hiểm.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-80ea-b4db-c6709d00bf7d",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-12-12T11:11:00.000Z",
        "last_edited_time": "2024-12-12T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80cf-901a-c52cab0aca1a",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T02:08:00.000Z",
        "last_edited_time": "2024-12-12T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khoảng lặng:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khoảng lặng:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " không chỉ là sự \"ngắt quãng\" trong giao tiếp mà là một ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " không chỉ là sự \"ngắt quãng\" trong giao tiếp mà là một ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "phần tử quan trọng giúp lời nói có chiều sâu",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "phần tử quan trọng giúp lời nói có chiều sâu",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ". ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-805b-812c-dd633250c28f",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-12-12T11:11:00.000Z",
        "last_edited_time": "2024-12-12T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ở phía người nói: khoảng lặng cho phép bạn suy nghĩ kỹ trước khi nói, giúp lời nói trở nên thấu đáo và có trọng lượng hơn. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ở phía người nói: khoảng lặng cho phép bạn suy nghĩ kỹ trước khi nói, giúp lời nói trở nên thấu đáo và có trọng lượng hơn. ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-80f5-9945-e4dea5bf8da7",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-12-12T11:11:00.000Z",
        "last_edited_time": "2024-12-12T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ở phía người nghe: khoảng lặng cho phép họ thời gian để xử lý và hiểu thông tin, đặc biệt trong những cuộc trao đổi ý nghĩa hoặc phức tạp.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ở phía người nghe: khoảng lặng cho phép họ thời gian để xử lý và hiểu thông tin, đặc biệt trong những cuộc trao đổi ý nghĩa hoặc phức tạp.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-8080-9d9a-e8fe30e0d07a",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-12-12T11:11:00.000Z",
        "last_edited_time": "2024-12-12T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khoảng lặng và tính đa dạng ngữ nghĩa của nó: đôi lúc nó chứng tỏ bạn đang thật sự lắng nghe, đồng cảm; đôi lúc nó cho thấy sự thờ ơ, phớt lờ; đôi lúc nó lại là một chiến thuật để thể hiện sự tự tin trong đàm phán, tranh luận; đôi lúc nó lại là một cách để bạn thăm dò tâm lý đối phương…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khoảng lặng và tính đa dạng ngữ nghĩa của nó: đôi lúc nó chứng tỏ bạn đang thật sự lắng nghe, đồng cảm; đôi lúc nó cho thấy sự thờ ơ, phớt lờ; đôi lúc nó lại là một chiến thuật để thể hiện sự tự tin trong đàm phán, tranh luận; đôi lúc nó lại là một cách để bạn thăm dò tâm lý đối phương…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25c5d164-78d8-8021-81ab-db09805511ef",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2025-08-27T02:04:00.000Z",
        "last_edited_time": "2025-08-27T02:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "25c5d164-78d8-80e5-9c5c-ce2507370ca0",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2025-08-27T02:04:00.000Z",
        "last_edited_time": "2025-08-27T02:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tóm lại",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tóm lại",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25c5d164-78d8-80ec-9314-f94ff096f4a5",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2025-08-27T02:13:00.000Z",
        "last_edited_time": "2025-08-27T02:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756261115/uxcomic-imgs/25c5d164-78d8-80ec-9314-f94ff096f4a5.gif",
            "expiry_time": "2026-10-04T09:11:20.861Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/25c5d164-78d8-80ec-9314-f94ff096f4a5"
      },
      {
        "object": "block",
        "id": "25c5d164-78d8-805f-a814-e0ba331bfe85",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2025-08-27T02:04:00.000Z",
        "last_edited_time": "2025-08-27T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chết rồi, nói dông nói dài quá, sợ chẳng rút ra được gì. Nếu tóm lại 3 ý mình thấy quan trọng nhất sau bài này thì chúng sẽ là:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chết rồi, nói dông nói dài quá, sợ chẳng rút ra được gì. Nếu tóm lại 3 ý mình thấy quan trọng nhất sau bài này thì chúng sẽ là:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25c5d164-78d8-801d-a671-e220f9ce4989",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2025-08-27T02:05:00.000Z",
        "last_edited_time": "2025-08-27T02:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nói phải “trúng” - có nghĩa là “trúng” tần số người nghe, “trúng” thứ họ đang quan tâm. Keep it relevant.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nói phải “trúng” - có nghĩa là “trúng” tần số người nghe, “trúng” thứ họ đang quan tâm. Keep it relevant.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25c5d164-78d8-8017-b3d2-cfce40dc6b06",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2025-08-27T02:06:00.000Z",
        "last_edited_time": "2025-08-27T02:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Noise, channel, context, vị thế là những factor tác động đến quá trình truyền đạt & quá trình tiếp nhận → aware chúng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Noise, channel, context, vị thế là những factor tác động đến quá trình truyền đạt & quá trình tiếp nhận → aware chúng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25c5d164-78d8-801b-af7b-c7acbad0a817",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2025-08-27T02:07:00.000Z",
        "last_edited_time": "2025-08-27T02:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để ý quá trình encoding & decoding message, mình muốn chúng align với nhau. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để ý quá trình encoding & decoding message, mình muốn chúng align với nhau. ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "25c5d164-78d8-80c3-ad74-c88ac00e6564",
            "parent": {
              "type": "block_id",
              "block_id": "25c5d164-78d8-801b-af7b-c7acbad0a817"
            },
            "created_time": "2025-08-27T02:09:00.000Z",
            "last_edited_time": "2025-08-27T02:09:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Nếu mình là người nói thì hãy cố gắng làm rõ ý đó (tips: dùng ngôn từ của họ, đưa ra ví dụ, vẽ diagram…).",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Nếu mình là người nói thì hãy cố gắng làm rõ ý đó (tips: dùng ngôn từ của họ, đưa ra ví dụ, vẽ diagram…).",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "25c5d164-78d8-805c-93f1-f89487a7ccc3",
            "parent": {
              "type": "block_id",
              "block_id": "25c5d164-78d8-801b-af7b-c7acbad0a817"
            },
            "created_time": "2025-08-27T02:09:00.000Z",
            "last_edited_time": "2025-08-27T02:10:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Nếu mình là người nghe, hãy chốt lại vấn đề hoặc trình bày lại cái bạn hiểu được, để xem nó có giống với cái ý của người nói không, hoặc nếu chưa clear, hãy nhờ họ giải nghĩa thêm.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Nếu mình là người nghe, hãy chốt lại vấn đề hoặc trình bày lại cái bạn hiểu được, để xem nó có giống với cái ý của người nói không, hoặc nếu chưa clear, hãy nhờ họ giải nghĩa thêm.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "1405d164-78d8-811c-af34-f4a4b5ebaaff",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-16T09:05:00.000Z",
        "last_edited_time": "2024-11-16T09:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1575d164-78d8-801a-8ecc-f6bb0b8bd682",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-12-09T12:04:00.000Z",
        "last_edited_time": "2024-12-09T12:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15e5d164-78d8-8011-bb8e-f07d73e5cc33",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-12-16T05:45:00.000Z",
        "last_edited_time": "2024-12-16T05:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://professional.dce.harvard.edu/blog/mastering-the-basics-of-communication/",
                "link": {
                  "url": "https://professional.dce.harvard.edu/blog/mastering-the-basics-of-communication/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://professional.dce.harvard.edu/blog/mastering-the-basics-of-communication/",
              "href": "https://professional.dce.harvard.edu/blog/mastering-the-basics-of-communication/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1575d164-78d8-80f2-ac2b-e7ed81d67a32",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-12-09T12:04:00.000Z",
        "last_edited_time": "2024-12-09T12:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://youtu.be/x6TsR3y5Qfg?si=5RQKjLTO6ToBS37-",
                "link": {
                  "url": "https://youtu.be/x6TsR3y5Qfg?si=5RQKjLTO6ToBS37-"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://youtu.be/x6TsR3y5Qfg?si=5RQKjLTO6ToBS37-",
              "href": "https://youtu.be/x6TsR3y5Qfg?si=5RQKjLTO6ToBS37-"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1575d164-78d8-8099-88de-c740515e7d0a",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-12-09T13:53:00.000Z",
        "last_edited_time": "2024-12-09T13:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.linkedin.com/pulse/right-message-time-through-channel-oscar-vazquez?",
                "link": {
                  "url": "https://www.linkedin.com/pulse/right-message-time-through-channel-oscar-vazquez?utm_source=share&utm_medium=member_ios&utm_campaign=share_via"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.linkedin.com/pulse/right-message-time-through-channel-oscar-vazquez?",
              "href": "https://www.linkedin.com/pulse/right-message-time-through-channel-oscar-vazquez?utm_source=share&utm_medium=member_ios&utm_campaign=share_via"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2005d164-78d8-80b7-ac8f-e1e96b914315",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2025-05-27T01:55:00.000Z",
        "last_edited_time": "2025-05-27T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://medium.com/dancing-elephants-press/mastering-the-art-of-thinking-before-you-speak-for-more-effective-communication-ead5d4352c4e",
                "link": {
                  "url": "https://medium.com/dancing-elephants-press/mastering-the-art-of-thinking-before-you-speak-for-more-effective-communication-ead5d4352c4e"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://medium.com/dancing-elephants-press/mastering-the-art-of-thinking-before-you-speak-for-more-effective-communication-ead5d4352c4e",
              "href": "https://medium.com/dancing-elephants-press/mastering-the-art-of-thinking-before-you-speak-for-more-effective-communication-ead5d4352c4e"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1575d164-78d8-80ad-b4d5-f40888cab3d5",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-12-09T12:04:00.000Z",
        "last_edited_time": "2024-12-09T12:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-81f6-9b52-c959ceecdd67",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-16T09:05:00.000Z",
        "last_edited_time": "2024-11-16T09:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-80dd-a77f-f4f7fb6849eb",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-12-12T06:32:00.000Z",
        "last_edited_time": "2024-12-12T06:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "15a5d164-78d8-8058-b2d5-d1d08ced0f2d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Presenting (P1)",
              "href": "https://app.notion.com/p/15a5d16478d88058b2d5d1d08ced0f2d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-801e-899f-cafd3cafb517",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-12-12T06:32:00.000Z",
        "last_edited_time": "2024-12-12T06:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1405d164-78d8-801a-b019-e709965fbf48"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Listening",
              "href": "https://app.notion.com/p/1405d16478d8801ab019e709965fbf48"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-81ff-8dfc-cdebb8ea9e5e",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-16T09:05:00.000Z",
        "last_edited_time": "2024-11-17T03:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sense making",
              "href": "https://app.notion.com/p/1195d16478d880cda21ff9d0e90ae7b8"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8055-9818-df76a6b8e2a7",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-11-17T03:27:00.000Z",
        "last_edited_time": "2024-11-18T09:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "95727332-bdb3-4f63-a0cd-f9023732995d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Questioning (P1)",
              "href": "https://app.notion.com/p/95727332bdb34f63a0cdf9023732995d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-80e2-9fc9-d8abad3f1804",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801f-aad4-f558038c6ba3"
        },
        "created_time": "2024-12-12T06:32:00.000Z",
        "last_edited_time": "2024-12-12T06:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1405d164-78d8-801a-b019-e709965fbf48",
    "created_time": "2024-11-16T07:47:00.000Z",
    "last_edited_time": "2025-05-21T01:59:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-11-16T07:47:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "2-Communication",
          "color": "default"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 22
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-05-21T01:59:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "sgq|",
          "name": "⚔️:1",
          "color": "red"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Listening",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Listening",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Listening-1405d16478d8801ab019e709965fbf48",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Communication",
      "slug": "communication",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "1405d164-78d8-81ff-8a35-fe86c8f947e4",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-11-16T08:54:00.000Z",
        "last_edited_time": "2024-12-22T03:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081315/uxcomic-imgs/1405d164-78d8-81ff-8a35-fe86c8f947e4.png",
            "expiry_time": "2026-10-04T09:11:22.860Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1405d164-78d8-81ff-8a35-fe86c8f947e4"
      },
      {
        "object": "block",
        "id": "1405d164-78d8-81b0-897f-c1caf7f819dd",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-11-16T08:54:00.000Z",
        "last_edited_time": "2024-12-31T01:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nghe thôi mà có gì mà phải học, ohm mình cũng nghĩ thế cho đến khi gặp các người không thực sự lắng nghe mình, lúc đó mới thấy khó chịu. Vậy tại sao có người khiến bạn thấy dễ chịu khi trò chuyện, có người thì chỉ nói 1,2 câu là đã muốn thôi skip. OK, cùng mình tìm hiểu nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nghe thôi mà có gì mà phải học, ohm mình cũng nghĩ thế cho đến khi gặp các người không thực sự lắng nghe mình, lúc đó mới thấy khó chịu. Vậy tại sao có người khiến bạn thấy dễ chịu khi trò chuyện, có người thì chỉ nói 1,2 câu là đã muốn thôi skip. OK, cùng mình tìm hiểu nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8085-adbb-c3c4329677f2",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T04:54:00.000Z",
        "last_edited_time": "2024-12-24T04:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8148-b284-d76c253d70e9",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-11-16T08:54:00.000Z",
        "last_edited_time": "2024-12-26T05:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Level of listening",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Level of listening",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-81ae-9820-d24b1e5c18f5",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-11-16T08:54:00.000Z",
        "last_edited_time": "2024-12-26T05:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước hết cho mình xin 5s để hỏi: bạn nghĩ giữa “nghe” & “lắng nghe” khác nhau như thế nào?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước hết cho mình xin 5s để hỏi: bạn nghĩ giữa “nghe” & “lắng nghe” khác nhau như thế nào?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-8074-b550-e04146477db6",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-26T05:51:00.000Z",
        "last_edited_time": "2024-12-26T05:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khoan đọc tiếp nhé, thử suy nghĩ chút đi mà… 5,4,3,2,1. OK tìm hiểu tiếp nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khoan đọc tiếp nhé, thử suy nghĩ chút đi mà… 5,4,3,2,1. OK tìm hiểu tiếp nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8012-8c80-dbd0765fb0cf",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T04:55:00.000Z",
        "last_edited_time": "2025-05-21T01:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Lắng” được định nghĩa là “trở lại trạng thái tĩnh, không còn những biểu hiện sôi nổi mạnh mẽ lúc đầu”. Trong bối cảnh “lắng nghe”, thì có thể hiểu đó là lúc bạn tạm gác tất cả các luồng suy nghĩ, tạm bỏ qua việc cố gắng nghĩ xem nên phản hồi thế nào, mà ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Lắng” được định nghĩa là “trở lại trạng thái tĩnh, không còn những biểu hiện sôi nổi mạnh mẽ lúc đầu”. Trong bối cảnh “lắng nghe”, thì có thể hiểu đó là lúc bạn tạm gác tất cả các luồng suy nghĩ, tạm bỏ qua việc cố gắng nghĩ xem nên phản hồi thế nào, mà ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "TẬP TRUNG",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "TẬP TRUNG",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " hoàn toàn vào người nói. Nó giống như việc xem tâm trí mình là một hồ nước, khiến nó trở nên tĩnh lặng mà không có cơn gợn sóng nào. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " hoàn toàn vào người nói. Nó giống như việc xem tâm trí mình là một hồ nước, khiến nó trở nên tĩnh lặng mà không có cơn gợn sóng nào. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8070-a27f-da5c097c00d4",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T04:59:00.000Z",
        "last_edited_time": "2024-12-26T05:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081317/uxcomic-imgs/1665d164-78d8-8070-a27f-da5c097c00d4.jpg",
            "expiry_time": "2026-10-04T09:11:22.860Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1665d164-78d8-8070-a27f-da5c097c00d4"
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8039-b3d7-f55aeaacc1ad",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T06:39:00.000Z",
        "last_edited_time": "2024-12-26T05:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hoặc nói một cách khác, bạn phải vắt khô “miếng rửa chén” (ý nghĩ / định kiến) để thấm được thật nhiều “nước” (thông điệp của người nói).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hoặc nói một cách khác, bạn phải vắt khô “miếng rửa chén” (ý nghĩ / định kiến) để thấm được thật nhiều “nước” (thông điệp của người nói).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-8039-8def-fe8b6276210c",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-26T05:54:00.000Z",
        "last_edited_time": "2024-12-26T05:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-81cf-b6a4-c08a4509009c",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-11-16T08:54:00.000Z",
        "last_edited_time": "2024-12-27T02:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cụ thể hơn ta có các level nghe như sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cụ thể hơn ta có các level nghe như sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8018-ad26-dee1bcbec318",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T05:03:00.000Z",
        "last_edited_time": "2024-12-27T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phớt lờ (Ignoring):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phớt lờ (Ignoring):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Chúng ta hoàn toàn phớt lờ lời nói của họ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Chúng ta hoàn toàn phớt lờ lời nói của họ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8041-b2df-d637e86552e1",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T05:03:00.000Z",
        "last_edited_time": "2024-12-24T05:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giả vờ lắng nghe (Pretend listening):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giả vờ lắng nghe (Pretend listening):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Chúng ta sử dụng ngôn ngữ cơ thể và giao tiếp bằng mắt để thể hiện rằng mình đang lắng nghe, nhưng thực tế là không.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Chúng ta sử dụng ngôn ngữ cơ thể và giao tiếp bằng mắt để thể hiện rằng mình đang lắng nghe, nhưng thực tế là không.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8018-a7e4-e0170817fab6",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T05:03:00.000Z",
        "last_edited_time": "2024-12-24T05:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nghe có chọn lọc (Selective listening):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nghe có chọn lọc (Selective listening):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Chúng ta chỉ lắng nghe những phần mình thấy hứng thú và bỏ qua những phần không quan tâm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Chúng ta chỉ lắng nghe những phần mình thấy hứng thú và bỏ qua những phần không quan tâm.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8067-b47e-db37ae55abc5",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T05:03:00.000Z",
        "last_edited_time": "2024-12-27T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nghe chú tâm (Attentive listening):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nghe chú tâm (Attentive listening):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Chúng ta chú ý và thật sự tiếp thu những gì họ nói.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Chúng ta chú ý và thật sự tiếp thu những gì họ nói.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 3
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8029-bd03-fe7426817dce",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T05:03:00.000Z",
        "last_edited_time": "2024-12-27T02:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nghe thấu cảm (Empathetically listening):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nghe thấu cảm (Empathetically listening):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Chúng ta tập trung và lắng nghe để hiểu rõ ý định đằng sau thông điệp. Đây mới là đỉnh cao của việc nghe, nghe “những gì họ không nói ra”, là lúc bạn quan sát thêm các ngôn ngữ cơ thể của họ, đoán biết tâm lý của họ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Chúng ta tập trung và lắng nghe để hiểu rõ ý định đằng sau thông điệp. Đây mới là đỉnh cao của việc nghe, nghe “những gì họ không nói ra”, là lúc bạn quan sát thêm các ngôn ngữ cơ thể của họ, đoán biết tâm lý của họ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 4
      },
      {
        "object": "block",
        "id": "1465d164-78d8-8026-a5dc-f305460b0458",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-11-22T02:27:00.000Z",
        "last_edited_time": "2024-12-24T05:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tất nhiên không phải lúc nào cũng cần nghe ở level cao như vậy, nhưng nếu thật sự bạn muốn tôn trọng & hiểu đối phương thì hãy nhận diện xem mình đang nghe ở level nào & điều chỉnh cho phù hợp.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tất nhiên không phải lúc nào cũng cần nghe ở level cao như vậy, nhưng nếu thật sự bạn muốn tôn trọng & hiểu đối phương thì hãy nhận diện xem mình đang nghe ở level nào & điều chỉnh cho phù hợp.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8081-8de4-ef0b4229be56",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T06:27:00.000Z",
        "last_edited_time": "2024-12-24T06:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8058-874f-f8bf493eed0d",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T06:26:00.000Z",
        "last_edited_time": "2024-12-26T05:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ah có sự quan sát này, mình nghĩ cũng hơi liên quan, mình thấy khi viết hoặc đọc là lúc bạn đang thật sự tập trung lắng nghe, vì não bạn không thể song song vừa đọc vừa nghĩ, nếu bạn để ý, ta chỉ thực sự dừng đọc rồi mới nghĩ >> hạn chế phớt lờ thông tin. Khi nhỏ mình có từng ước qua sẽ thật tuyệt nếu có thể đọc suy nghĩ của ai đó (trước khi xem X-men luôn, ghê không 🤣), đến lúc lớn lên đọc sách mới thấy à thì ra đây có vẻ cũng là một cách, khi đọc sách, mình sẽ có một giọng nói chảy trong đầu y như lúc mình nghĩ ngợi vậy, nhưng nội dung đang chảy không phải của bạn mà là của tác giả, điều này khiến mình như được hoá thân thành tác giả vậy.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ah có sự quan sát này, mình nghĩ cũng hơi liên quan, mình thấy khi viết hoặc đọc là lúc bạn đang thật sự tập trung lắng nghe, vì não bạn không thể song song vừa đọc vừa nghĩ, nếu bạn để ý, ta chỉ thực sự dừng đọc rồi mới nghĩ >> hạn chế phớt lờ thông tin. Khi nhỏ mình có từng ước qua sẽ thật tuyệt nếu có thể đọc suy nghĩ của ai đó (trước khi xem X-men luôn, ghê không 🤣), đến lúc lớn lên đọc sách mới thấy à thì ra đây có vẻ cũng là một cách, khi đọc sách, mình sẽ có một giọng nói chảy trong đầu y như lúc mình nghĩ ngợi vậy, nhưng nội dung đang chảy không phải của bạn mà là của tác giả, điều này khiến mình như được hoá thân thành tác giả vậy.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-802b-8898-ff5ad6330554",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-26T05:58:00.000Z",
        "last_edited_time": "2024-12-27T02:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> bạn cũng có thể thử apply vào tình huống lắng nghe ai đó, tập trung hoàn toàn vào họ, xem cách họ kể chuyện, hình dung cách lập luận, cách diễn giải của họ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> bạn cũng có thể thử apply vào tình huống lắng nghe ai đó, tập trung hoàn toàn vào họ, xem cách họ kể chuyện, hình dung cách lập luận, cách diễn giải của họ.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8057-b45c-c888b95b795c",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T05:10:00.000Z",
        "last_edited_time": "2024-12-24T05:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1465d164-78d8-80b0-91ee-f09ed4d28785",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-11-22T02:27:00.000Z",
        "last_edited_time": "2024-12-24T05:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "How - làm sao để nghe tốt hơn?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "How - làm sao để nghe tốt hơn?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-80c0-b62f-d252c36afb7f",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T05:10:00.000Z",
        "last_edited_time": "2024-12-24T05:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tập các skill liên quan đến",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tập các skill liên quan đến",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " active listening.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " active listening.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8089-96a3-f3de203cc24a",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T05:15:00.000Z",
        "last_edited_time": "2024-12-26T06:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cụ thể như thế nào thì bạn hãy xem thêm ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cụ thể như thế nào thì bạn hãy xem thêm ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "bài viết này",
                "link": {
                  "url": "https://www.ccl.org/articles/leading-effectively-articles/coaching-others-use-active-listening-skills/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "bài viết này",
              "href": "https://www.ccl.org/articles/leading-effectively-articles/coaching-others-use-active-listening-skills/"
            },
            {
              "type": "text",
              "text": {
                "content": " nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8044-a571-d5fb172507c1",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T05:11:00.000Z",
        "last_edited_time": "2024-12-26T06:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [
            {
              "type": "text",
              "text": {
                "content": "https://www.ccl.org/articles/leading-effectively-articles/coaching-others-use-active-listening-skills/",
                "link": {
                  "url": "https://www.ccl.org/articles/leading-effectively-articles/coaching-others-use-active-listening-skills/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.ccl.org/articles/leading-effectively-articles/coaching-others-use-active-listening-skills/",
              "href": "https://www.ccl.org/articles/leading-effectively-articles/coaching-others-use-active-listening-skills/"
            }
          ],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081318/uxcomic-imgs/1665d164-78d8-8044-a571-d5fb172507c1.png",
            "expiry_time": "2026-10-04T09:11:22.861Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1665d164-78d8-8044-a571-d5fb172507c1"
      },
      {
        "object": "block",
        "id": "1685d164-78d8-804f-bbd2-e726131b90a2",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-26T06:02:00.000Z",
        "last_edited_time": "2024-12-26T06:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhưng tóm lại sẽ có 4 ý sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhưng tóm lại sẽ có 4 ý sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8020-8fa6-e0bada8ac2fd",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T05:12:00.000Z",
        "last_edited_time": "2024-12-27T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước hết là “lắng” lại, tập trung & tạm gác các suy nghĩ, judgement. Nghe & hiểu cho hết các ý họ nói đã, rồi hãy nghĩ cách phản hồi.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước hết là “lắng” lại, tập trung & tạm gác các suy nghĩ, judgement. Nghe & hiểu cho hết các ý họ nói đã, rồi hãy nghĩ cách phản hồi.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1665d164-78d8-80fa-9e67-f720df0a21ff",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T05:13:00.000Z",
        "last_edited_time": "2024-12-24T05:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Làm cho rõ nếu bạn chưa hiểu được thông điệp của đối phương.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Làm cho rõ nếu bạn chưa hiểu được thông điệp của đối phương.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1665d164-78d8-80bf-84ef-f5259999bf51",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T05:14:00.000Z",
        "last_edited_time": "2024-12-27T02:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu bạn cảm thấy đã hiểu, cũng nên paraphrase lại (trình bày lại cách bạn hiểu thông điệp của đối phương như thế nào), hoặc hỏi để thăm dò thêm, đừng assume mình hiểu hết ý của đối phương.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu bạn cảm thấy đã hiểu, cũng nên paraphrase lại (trình bày lại cách bạn hiểu thông điệp của đối phương như thế nào), hoặc hỏi để thăm dò thêm, đừng assume mình hiểu hết ý của đối phương.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8095-9e83-d211560f3983",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T05:31:00.000Z",
        "last_edited_time": "2024-12-27T02:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong giao tiếp, bạn không phải nghe như nghe podcast, hay đọc sách mà nó còn là sự đối thoại giữa đôi bên >> nếu thực sự bạn muốn nghe nhiều hơn, hãy biết cách ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong giao tiếp, bạn không phải nghe như nghe podcast, hay đọc sách mà nó còn là sự đối thoại giữa đôi bên >> nếu thực sự bạn muốn nghe nhiều hơn, hãy biết cách ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "đặt câu hỏi,",
                "link": {
                  "url": "/95727332bdb34f63a0cdf9023732995d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "đặt câu hỏi,",
              "href": "/95727332bdb34f63a0cdf9023732995d"
            },
            {
              "type": "text",
              "text": {
                "content": " share góc nhìn, câu chuyện của bạn… >> để tạo đối phương có cơ hội bày tỏ nhiều hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " share góc nhìn, câu chuyện của bạn… >> để tạo đối phương có cơ hội bày tỏ nhiều hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 3
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8058-aa51-f9668145f747",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-11-18T10:48:00.000Z",
        "last_edited_time": "2024-11-18T10:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8039-9b14-c8534c9426fc",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-11-18T10:48:00.000Z",
        "last_edited_time": "2024-12-24T05:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "So what",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "So what",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8089-a60d-f3dc41c6245c",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T05:16:00.000Z",
        "last_edited_time": "2024-12-24T05:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Việc nghe tốt giúp gì cho bạn?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Việc nghe tốt giúp gì cho bạn?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8035-a4e5-c0e8035683d5",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T05:16:00.000Z",
        "last_edited_time": "2024-12-26T06:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu không muốn bị cho là thiếu lịch sự, thì tập nghe đi, chẳng ai muốn nói chuyện với một người bất lịch sự cả >> tác động là họ cũng sẽ chẳng thèm lắng nghe bạn. Lắng nghe tốt là cách để bạn tạo được",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu không muốn bị cho là thiếu lịch sự, thì tập nghe đi, chẳng ai muốn nói chuyện với một người bất lịch sự cả >> tác động là họ cũng sẽ chẳng thèm lắng nghe bạn. Lắng nghe tốt là cách để bạn tạo được",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " thiện cảm.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " thiện cảm.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8053-b426-d36feae23414",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T05:22:00.000Z",
        "last_edited_time": "2024-12-27T02:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tăng khả năng",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tăng khả năng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " hiểu vấn đề",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " hiểu vấn đề",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", hãy cố gắng apply active listening, không những trong công việc mà cả cuộc sống >> nó giúp chúng ta phối hợp, trao đổi với nhau tốt hơn, tránh hiểu lầm & tăng sự đồng thuận.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", hãy cố gắng apply active listening, không những trong công việc mà cả cuộc sống >> nó giúp chúng ta phối hợp, trao đổi với nhau tốt hơn, tránh hiểu lầm & tăng sự đồng thuận.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-80bd-98d4-edbd9e583336",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T05:24:00.000Z",
        "last_edited_time": "2024-12-26T06:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Việc chú tâm lắng nghe giúp bạn ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Việc chú tâm lắng nghe giúp bạn ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "học thêm điều gì đó mới,",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "học thêm điều gì đó mới,",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " đừng nghĩ rằng mình biết tất cả, chúng ta luôn có các điểm mù, và họ thì luôn có gì đó hay ho để chúng ta có thể catch lấy, nếu đó là những gì đó xấu thì ta biết mà tránh, nếu đó là những gì đó tốt thì ta học hỏi, nếu đó là một hướng tiếp cận, góc nhìn khác thì có khi đó lại là một cơ hội gì đó mà bạn chưa từng nghĩ qua.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " đừng nghĩ rằng mình biết tất cả, chúng ta luôn có các điểm mù, và họ thì luôn có gì đó hay ho để chúng ta có thể catch lấy, nếu đó là những gì đó xấu thì ta biết mà tránh, nếu đó là những gì đó tốt thì ta học hỏi, nếu đó là một hướng tiếp cận, góc nhìn khác thì có khi đó lại là một cơ hội gì đó mà bạn chưa từng nghĩ qua.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-81c4-a273-d5c50bf29737",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-11-16T08:54:00.000Z",
        "last_edited_time": "2024-11-16T08:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8176-8552-c71d9d99f502",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-11-16T08:54:00.000Z",
        "last_edited_time": "2024-11-16T08:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-80e6-b8a2-c430af853522",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T05:48:00.000Z",
        "last_edited_time": "2024-12-26T06:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "video",
        "video": {
          "caption": [],
          "type": "external",
          "external": {
            "url": "https://youtu.be/HAnw168huqA?si=QNQqOwy-Ez9vwlLW&t=2027"
          }
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-81fe-8346-cab120427135",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-11-16T08:54:00.000Z",
        "last_edited_time": "2024-12-24T05:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.revolutionlearning.co.uk/article/the-5-levels-of-listening/",
                "link": {
                  "url": "https://www.revolutionlearning.co.uk/article/the-5-levels-of-listening/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.revolutionlearning.co.uk/article/the-5-levels-of-listening/",
              "href": "https://www.revolutionlearning.co.uk/article/the-5-levels-of-listening/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8116-be30-f6861fd83f82",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-11-16T08:54:00.000Z",
        "last_edited_time": "2024-12-24T05:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.ccl.org/articles/leading-effectively-articles/coaching-others-use-active-listening-skills/",
                "link": {
                  "url": "https://www.ccl.org/articles/leading-effectively-articles/coaching-others-use-active-listening-skills/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.ccl.org/articles/leading-effectively-articles/coaching-others-use-active-listening-skills/",
              "href": "https://www.ccl.org/articles/leading-effectively-articles/coaching-others-use-active-listening-skills/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8137-862c-c571bb1c9492",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-11-16T08:54:00.000Z",
        "last_edited_time": "2024-11-16T08:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-81ff-bc61-f2e85169f17a",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-11-16T08:54:00.000Z",
        "last_edited_time": "2024-11-16T08:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-810a-bd4c-c3ec2fe5d1aa",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-11-16T08:54:00.000Z",
        "last_edited_time": "2024-12-24T05:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1405d164-78d8-801f-aad4-f558038c6ba3"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Principle of Communication",
              "href": "https://app.notion.com/p/1405d16478d8801faad4f558038c6ba3"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8069-bd33-d401ae84a304",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T05:33:00.000Z",
        "last_edited_time": "2024-12-24T05:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "95727332-bdb3-4f63-a0cd-f9023732995d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Questioning (P1)",
              "href": "https://app.notion.com/p/95727332bdb34f63a0cdf9023732995d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8090-a927-f88f7ed25dc8",
        "parent": {
          "type": "page_id",
          "page_id": "1405d164-78d8-801a-b019-e709965fbf48"
        },
        "created_time": "2024-12-24T05:21:00.000Z",
        "last_edited_time": "2024-12-24T05:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Understand, Empathize user?",
              "href": "https://app.notion.com/p/32cbe568c34b4255a408f2a2e6227bb2"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "7c105f49-8bff-404b-b1e1-dcd82a632887",
    "created_time": "2024-11-12T15:34:00.000Z",
    "last_edited_time": "2025-06-27T05:54:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-11-12T15:34:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "2-Communication",
          "color": "default"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 21
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-06-27T05:54:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "prxX",
          "name": "⚔️:2",
          "color": "yellow"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Conflict ",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Conflict ",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Conflict-7c105f498bff404bb1e1dcd82a632887",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Communication",
      "slug": "communication",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "13c5d164-78d8-8135-8358-dec52a23e4ff",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-11-12T15:34:00.000Z",
        "last_edited_time": "2024-11-16T12:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081321/uxcomic-imgs/13c5d164-78d8-8135-8358-dec52a23e4ff.png",
            "expiry_time": "2026-10-04T09:11:23.804Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/13c5d164-78d8-8135-8358-dec52a23e4ff"
      },
      {
        "object": "block",
        "id": "e626982c-7677-48f7-8d0e-91ee0100a938",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-11-12T15:35:00.000Z",
        "last_edited_time": "2024-11-16T03:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Conflict xảy ra khi cả 2 đang có sự xung đột về mục tiêu, lợi ích, quan điểm, không tìm thấy sự đồng thuận.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Conflict xảy ra khi cả 2 đang có sự xung đột về mục tiêu, lợi ích, quan điểm, không tìm thấy sự đồng thuận.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13f5d164-78d8-80fb-ae33-e6131d3ac05b",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-11-15T01:16:00.000Z",
        "last_edited_time": "2024-11-15T01:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "13f5d164-78d8-8056-814c-c00672de1ab8",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-11-15T01:16:00.000Z",
        "last_edited_time": "2024-11-15T01:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các nguyên nhân & hướng xử lý",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các nguyên nhân & hướng xử lý",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "08eaa140-f872-426a-8997-abc6852a31f6",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-11-13T05:31:00.000Z",
        "last_edited_time": "2024-11-15T01:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu điều kiện lý tưởng là không có hiềm khích cá nhân nhé :D, thì sự conflict xảy ra do:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu điều kiện lý tưởng là không có hiềm khích cá nhân nhé :D, thì sự conflict xảy ra do:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "6d28d87e-a8c2-45cb-b625-b5dc73eecc0a",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-11-12T15:35:00.000Z",
        "last_edited_time": "2025-01-06T05:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đã hiểu ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đã hiểu ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "đúng ý",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "đúng ý",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " nhau chưa? Có khi nào đang trong trường hợp “ông nói gà, bà nói vịt”-mỗi người nói một ý. Tip: để make sure mình có rõ ràng ý của nhau hay không, hãy để cả 2 bên cùng miêu tả, định nghĩa một vấn đề và đưa ví dụ cụ thể để mô tả ý vừa nói.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " nhau chưa? Có khi nào đang trong trường hợp “ông nói gà, bà nói vịt”-mỗi người nói một ý. Tip: để make sure mình có rõ ràng ý của nhau hay không, hãy để cả 2 bên cùng miêu tả, định nghĩa một vấn đề và đưa ví dụ cụ thể để mô tả ý vừa nói.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "d91cc435-97ba-44ec-9f00-c65e23f27a4b",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-11-12T15:35:00.000Z",
        "last_edited_time": "2024-11-17T09:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau khi đã get được ý của nhau, ta có đồng tình luận điểm của nhau không? Mình có đánh giá vấn đề trên cùng ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau khi đã get được ý của nhau, ta có đồng tình luận điểm của nhau không? Mình có đánh giá vấn đề trên cùng ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "một hệ quy chiếu (cùng tiêu chí) ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "một hệ quy chiếu (cùng tiêu chí) ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "nào không? Đặc biệt với các vấn đề càng trừu tượng thì càng nên làm rõ hệ quy chiếu xem thước đo ở đây là gì. Điều này giúp tránh việc chúng ta tranh luận theo cảm tính & chủ quan.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "nào không? Đặc biệt với các vấn đề càng trừu tượng thì càng nên làm rõ hệ quy chiếu xem thước đo ở đây là gì. Điều này giúp tránh việc chúng ta tranh luận theo cảm tính & chủ quan.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "6cad4f5c-791e-450b-a6c7-8a395656f834",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-11-12T15:35:00.000Z",
        "last_edited_time": "2024-11-14T02:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Và khi luận điểm nào cũng có cái lý của nó, thì hãy tiếp tục đánh giá nó trên 1 ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Và khi luận điểm nào cũng có cái lý của nó, thì hãy tiếp tục đánh giá nó trên 1 ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "lớp quy chiếu thứ 2,",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "lớp quy chiếu thứ 2,",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " chẳng hạn xét xem luận điểm nào phù hợp hơn với tình huống hiện tại hơn. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " chẳng hạn xét xem luận điểm nào phù hợp hơn với tình huống hiện tại hơn. ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "09c7d257-a4a2-493a-a48e-8a3698386aee",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-11-12T15:35:00.000Z",
        "last_edited_time": "2024-11-16T03:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau tất cả, nếu chúng ta đều không tin, không sure về phương án của nhau thì mình cần “anh cả” vào việc, ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau tất cả, nếu chúng ta đều không tin, không sure về phương án của nhau thì mình cần “anh cả” vào việc, ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "“anh cả” ở đây là fact-sự thật",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“anh cả” ở đây là fact-sự thật",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", để tìm được anh này cần có vài phương pháp như: a/b test, interview user, usability test, research, measure,… Ví dụ: team đang thảo luận về phương án thiết kế, hiện đang có 2 option, tuy nhiên option A lại tốt cho ngữ cảnh này, option B lại tốt cho ngữ cảnh kia, nhưng hiện lại không có bất kì dữ liệu nào để chứng minh ngữ cảnh nào có tần suất xảy ra cao hơn >> đành phải chọn một option để release trước và measure thêm, hoặc nếu khả thi thì thực hiện luôn a/b testing.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", để tìm được anh này cần có vài phương pháp như: a/b test, interview user, usability test, research, measure,… Ví dụ: team đang thảo luận về phương án thiết kế, hiện đang có 2 option, tuy nhiên option A lại tốt cho ngữ cảnh này, option B lại tốt cho ngữ cảnh kia, nhưng hiện lại không có bất kì dữ liệu nào để chứng minh ngữ cảnh nào có tần suất xảy ra cao hơn >> đành phải chọn một option để release trước và measure thêm, hoặc nếu khả thi thì thực hiện luôn a/b testing.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 3
      },
      {
        "object": "block",
        "id": "1735d164-78d8-8017-9bf0-eebc23de8382",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2025-01-06T05:33:00.000Z",
        "last_edited_time": "2025-01-06T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081322/uxcomic-imgs/1735d164-78d8-8017-9bf0-eebc23de8382.gif",
            "expiry_time": "2026-10-04T09:11:23.804Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1735d164-78d8-8017-9bf0-eebc23de8382"
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8026-8fd7-e391b3778120",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-11-16T12:11:00.000Z",
        "last_edited_time": "2024-11-16T12:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thấu tình đạt lý",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thấu tình đạt lý",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là tinh thần chung của việc giải quyết conflict.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là tinh thần chung của việc giải quyết conflict.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13f5d164-78d8-8003-9359-f81aa6a6ca82",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-11-15T01:18:00.000Z",
        "last_edited_time": "2024-11-15T01:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "8251984a-6f61-46ab-8624-d4fadb533464",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-11-14T02:29:00.000Z",
        "last_edited_time": "2024-11-15T01:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tips ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tips ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "61f0a6d4-a147-48bf-a969-8c703de4871a",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-11-14T02:30:00.000Z",
        "last_edited_time": "2025-01-06T05:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hãy cố gắng giữ ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hãy cố gắng giữ ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "góc nhìn trung lập khách quan",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "góc nhìn trung lập khách quan",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", thảo luận dựa trên một cái đích chung, dựa trên nghiên cứu, principle, data…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", thảo luận dựa trên một cái đích chung, dựa trên nghiên cứu, principle, data…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "90bb4508-62a7-4356-82cc-f62ef981b91e",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-11-14T02:30:00.000Z",
        "last_edited_time": "2024-11-16T08:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hãy cố gắng ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hãy cố gắng ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "collaborate từ sớm",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "collaborate từ sớm",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", để cả 2 thảo luận, lên idea, cùng form lên solution, điều này sẽ giúp tăng việc hiểu các concern lẫn nhau, giúp quá trình buy-in và đồng thuận diễn ra dễ dàng hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", để cả 2 thảo luận, lên idea, cùng form lên solution, điều này sẽ giúp tăng việc hiểu các concern lẫn nhau, giúp quá trình buy-in và đồng thuận diễn ra dễ dàng hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "91236bf5-2dbb-45f4-8998-7c482311666e",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-11-14T02:33:00.000Z",
        "last_edited_time": "2025-01-06T05:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Danh xưng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Danh xưng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": thay vì dùng từ “bạn” trong các câu bạn nói ra, hãy dùng từ “mình” hoặc “tôi”, điều này tác động đến tâm lý - các câu bạn nói ra sẽ không mang hướng chỉ trích hay phán xét. Ví dụ: thay vì nói “bạn không lắng nghe ý kiến của tôi” thì chỉnh lại thành “tôi thấy ý kiến của tôi chưa được lắng nghe” hoặc “mình cùng ngồi phân tích thêm về ý kiến này”, nghe nó dễ thương liền phải không =)).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": thay vì dùng từ “bạn” trong các câu bạn nói ra, hãy dùng từ “mình” hoặc “tôi”, điều này tác động đến tâm lý - các câu bạn nói ra sẽ không mang hướng chỉ trích hay phán xét. Ví dụ: thay vì nói “bạn không lắng nghe ý kiến của tôi” thì chỉnh lại thành “tôi thấy ý kiến của tôi chưa được lắng nghe” hoặc “mình cùng ngồi phân tích thêm về ý kiến này”, nghe nó dễ thương liền phải không =)).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1735d164-78d8-80ff-b679-fb3728d35e0c",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2025-01-06T05:48:00.000Z",
        "last_edited_time": "2025-01-06T05:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thay vì hỏi WHY? hãy hỏi HOW & WHAT nhiều hơn",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thay vì hỏi WHY? hãy hỏi HOW & WHAT nhiều hơn",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", vì khi hỏi why đâu đó nó sẽ có tính tra hỏi, dò xét hơn. Ví dụ: “Tại sao bạn nghĩ idea này thích hợp?” >> “Điều gì khiến bạn tự tin về idea này?” hoặc “Như thế nào thì mình biết được idea này là phù hợp?”. Như bạn thấy đó, feeling mang lại rất khác, hỏi How & What khiến mọi thứ trông khách quan hơn mà lại thu thập được thông tin cụ thể.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", vì khi hỏi why đâu đó nó sẽ có tính tra hỏi, dò xét hơn. Ví dụ: “Tại sao bạn nghĩ idea này thích hợp?” >> “Điều gì khiến bạn tự tin về idea này?” hoặc “Như thế nào thì mình biết được idea này là phù hợp?”. Như bạn thấy đó, feeling mang lại rất khác, hỏi How & What khiến mọi thứ trông khách quan hơn mà lại thu thập được thông tin cụ thể.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "ccec8f81-c009-46d6-8c9f-4e2abfaf4980",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-11-14T02:35:00.000Z",
        "last_edited_time": "2025-01-06T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Active listening",
                "link": {
                  "url": "/1405d16478d8801ab019e709965fbf48"
                }
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Active listening",
              "href": "/1405d16478d8801ab019e709965fbf48"
            },
            {
              "type": "text",
              "text": {
                "content": ": khi nghe ai đó trình bày, thay vì mình nhảy số ngay trong đầu các phán xét, sự đánh giá, hay nghĩ đến một đề xuất khác, hãy tạm tập trung vào việc lắng nghe, thấu hiểu nhau trước. Điều này cho đối phương thấy mình có sự tôn trọng với các ý kiến của họ, nó sẽ giúp cuộc tranh luận được êm ả hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": khi nghe ai đó trình bày, thay vì mình nhảy số ngay trong đầu các phán xét, sự đánh giá, hay nghĩ đến một đề xuất khác, hãy tạm tập trung vào việc lắng nghe, thấu hiểu nhau trước. Điều này cho đối phương thấy mình có sự tôn trọng với các ý kiến của họ, nó sẽ giúp cuộc tranh luận được êm ả hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1735d164-78d8-802d-b2f4-c64cd444e010",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2025-01-06T05:54:00.000Z",
        "last_edited_time": "2025-01-06T05:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1735d164-78d8-807a-b90b-fa07cc67f64b",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2025-01-06T05:54:00.000Z",
        "last_edited_time": "2025-01-06T05:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuy nhiên",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuy nhiên",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "b42857fb-7bfe-458d-8492-c65c802b3d9b",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-11-12T15:35:00.000Z",
        "last_edited_time": "2025-01-06T05:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuy nhiên trong thực tế vẫn có khi mâu thuẫn không được giải quyết, các bên chẳng thể align & make decision được :)), mỗi người đều nhất quyết bảo vệ cho luận điểm của mình, vậy thì làm sao đây. Đó là lúc “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuy nhiên trong thực tế vẫn có khi mâu thuẫn không được giải quyết, các bên chẳng thể align & make decision được :)), mỗi người đều nhất quyết bảo vệ cho luận điểm của mình, vậy thì làm sao đây. Đó là lúc “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "role & responsibility",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "role & responsibility",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "” vào cuộc, lúc này mình rõ ràng với nhau ai chịu trách nhiệm cho việc gì hoặc xem ai phải chịu trách nhiệm cao hơn thì sẽ quyết theo người ấy. (Bạn có thể tham khảo thêm ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” vào cuộc, lúc này mình rõ ràng với nhau ai chịu trách nhiệm cho việc gì hoặc xem ai phải chịu trách nhiệm cao hơn thì sẽ quyết theo người ấy. (Bạn có thể tham khảo thêm ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "RACI framework",
                "link": {
                  "url": "/1185d16478d88014bdf1e631b28f601e"
                }
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "RACI framework",
              "href": "/1185d16478d88014bdf1e631b28f601e"
            },
            {
              "type": "text",
              "text": {
                "content": " để rõ hơn). Nhưng rạch ròi quá như RACI lại đôi lúc tạo ra hiệu ứng silo (xa cách) nên hãy áp dụng một cách khéo léo nhé, dù gì đây cũng là mối quan hệ người với người.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " để rõ hơn). Nhưng rạch ròi quá như RACI lại đôi lúc tạo ra hiệu ứng silo (xa cách) nên hãy áp dụng một cách khéo léo nhé, dù gì đây cũng là mối quan hệ người với người.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1735d164-78d8-805b-bb6c-e789677b3f3b",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2025-01-06T05:47:00.000Z",
        "last_edited_time": "2025-01-06T05:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081325/uxcomic-imgs/1735d164-78d8-805b-bb6c-e789677b3f3b.gif",
            "expiry_time": "2026-10-04T09:11:23.805Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1735d164-78d8-805b-bb6c-e789677b3f3b"
      },
      {
        "object": "block",
        "id": "1735d164-78d8-8059-9f49-dbeb47652835",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2025-01-06T05:38:00.000Z",
        "last_edited_time": "2025-01-06T05:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thậm chí đôi lúc cần nhờ đến sự can thiệp của cấp trên, tất nhiên mình nên hạn chế việc gì cũng phải đụng đến cấp trên nhé (họ thuê bạn vào không phải để giải quyết mớ hỗn độn của bạn).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thậm chí đôi lúc cần nhờ đến sự can thiệp của cấp trên, tất nhiên mình nên hạn chế việc gì cũng phải đụng đến cấp trên nhé (họ thuê bạn vào không phải để giải quyết mớ hỗn độn của bạn).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1735d164-78d8-8049-ae60-d85549ed0388",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2025-01-06T05:33:00.000Z",
        "last_edited_time": "2025-01-06T05:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1735d164-78d8-80be-b2e5-ed5966f160ed",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2025-01-06T05:20:00.000Z",
        "last_edited_time": "2025-01-06T05:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081326/uxcomic-imgs/1735d164-78d8-80be-b2e5-ed5966f160ed.gif",
            "expiry_time": "2026-10-04T09:11:23.805Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1735d164-78d8-80be-b2e5-ed5966f160ed"
      },
      {
        "object": "block",
        "id": "a95252d9-1bc6-4333-9915-339845143260",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-11-12T15:35:00.000Z",
        "last_edited_time": "2025-01-06T05:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note mạnh: conflict xảy ra rất dễ kéo theo sự giận dữ. ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note mạnh: conflict xảy ra rất dễ kéo theo sự giận dữ. ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Bất kỳ khi nào mình ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bất kỳ khi nào mình ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "giận dữ",
                "link": {
                  "url": "/16d5d16478d880c3abd7e6ca980b9ab0"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "giận dữ",
              "href": "/16d5d16478d880c3abd7e6ca980b9ab0"
            },
            {
              "type": "text",
              "text": {
                "content": " thì sẽ như một bình nước đang sôi sùng sục vậy, tiếng kêu điếng tai, lúc này điều mình cần làm nhất là để nó lặng lại một chút rồi mới tranh cãi hoặc thảo luận tiếp, vì lúc này tâm trí bạn không ổn, mặt nước không phẳng lặng để nhìn rõ, âm thanh duy nhất bạn đang nghe chỉ là tiếng gào thét của bản thân trong cơn giận đó. >> Nên hãy cố gắng xin thêm thời gian để có thể bình tĩnh và bàn luận sau, còn cách nào để bình tĩnh lại thì mỗi người sẽ mỗi khác, ví dụ: mình thì hay tạm tránh để chơi game, đi dạo, xem phim.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " thì sẽ như một bình nước đang sôi sùng sục vậy, tiếng kêu điếng tai, lúc này điều mình cần làm nhất là để nó lặng lại một chút rồi mới tranh cãi hoặc thảo luận tiếp, vì lúc này tâm trí bạn không ổn, mặt nước không phẳng lặng để nhìn rõ, âm thanh duy nhất bạn đang nghe chỉ là tiếng gào thét của bản thân trong cơn giận đó. >> Nên hãy cố gắng xin thêm thời gian để có thể bình tĩnh và bàn luận sau, còn cách nào để bình tĩnh lại thì mỗi người sẽ mỗi khác, ví dụ: mình thì hay tạm tránh để chơi game, đi dạo, xem phim.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13c5d164-78d8-8177-a413-e0e258b976d3",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-11-12T15:34:00.000Z",
        "last_edited_time": "2024-11-12T15:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-8029-a8ff-fc4a8f8bfb34",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-12-12T05:24:00.000Z",
        "last_edited_time": "2024-12-12T05:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-802f-9c78-d3cdd5f4cb9c",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-12-12T05:24:00.000Z",
        "last_edited_time": "2024-12-12T05:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://vuxhr.wordpress.com/2021/11/12/lam-sao-de-dua-ra-y-kien-trai-chieu-voi-sep/",
                "link": {
                  "url": "https://vuxhr.wordpress.com/2021/11/12/lam-sao-de-dua-ra-y-kien-trai-chieu-voi-sep/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://vuxhr.wordpress.com/2021/11/12/lam-sao-de-dua-ra-y-kien-trai-chieu-voi-sep/",
              "href": "https://vuxhr.wordpress.com/2021/11/12/lam-sao-de-dua-ra-y-kien-trai-chieu-voi-sep/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "21f5d164-78d8-8035-81f2-e0a10668ed8e",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2025-06-27T05:54:00.000Z",
        "last_edited_time": "2025-06-27T05:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.linkedin.com/posts/daneoleary_growth-vs-ethics-when-growth-goals-compromise-ugcPost-7343890797727023107-nwok?",
                "link": {
                  "url": "https://www.linkedin.com/posts/daneoleary_growth-vs-ethics-when-growth-goals-compromise-ugcPost-7343890797727023107-nwok?utm_medium=ios_app&rcm=ACoAACTxzsYBO4mptTzgsbAc8dNNiYnc142O2IA&utm_source=social_share_send&utm_campaign=copy_link"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.linkedin.com/posts/daneoleary_growth-vs-ethics-when-growth-goals-compromise-ugcPost-7343890797727023107-nwok?",
              "href": "https://www.linkedin.com/posts/daneoleary_growth-vs-ethics-when-growth-goals-compromise-ugcPost-7343890797727023107-nwok?utm_medium=ios_app&rcm=ACoAACTxzsYBO4mptTzgsbAc8dNNiYnc142O2IA&utm_source=social_share_send&utm_campaign=copy_link"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-8033-92dc-f71e39be28c1",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-12-12T05:25:00.000Z",
        "last_edited_time": "2024-12-12T05:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "13c5d164-78d8-8139-bb85-eb4b5496a334",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-11-12T15:34:00.000Z",
        "last_edited_time": "2024-11-12T15:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13c5d164-78d8-8110-944a-c437a1d67804",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-11-12T15:34:00.000Z",
        "last_edited_time": "2024-11-15T00:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1215d164-78d8-809d-89b0-e84bbf170b05"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Persuade",
              "href": "https://app.notion.com/p/1215d16478d8809d89b0e84bbf170b05"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13c5d164-78d8-819f-80d9-f3082ff1f7ee",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-11-12T15:34:00.000Z",
        "last_edited_time": "2024-11-15T01:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "5cd8a019-315b-418f-af5b-2fc62c943855"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Negotiation",
              "href": "https://app.notion.com/p/5cd8a019315b418faf5b2fc62c943855"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13f5d164-78d8-8070-88cb-d40a5295a292",
        "parent": {
          "type": "page_id",
          "page_id": "7c105f49-8bff-404b-b1e1-dcd82a632887"
        },
        "created_time": "2024-11-15T01:21:00.000Z",
        "last_edited_time": "2024-11-15T01:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1185d164-78d8-8014-bdf1-e631b28f601e"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "RACI (Role & Responsibility)",
              "href": "https://app.notion.com/p/1185d16478d88014bdf1e631b28f601e"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022",
    "created_time": "2024-11-06T01:47:00.000Z",
    "last_edited_time": "2025-01-03T01:50:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-11-06T01:47:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "2-Communication",
          "color": "default"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 20
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-01-03T01:50:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "cZzk",
          "name": "⚔️:3",
          "color": "orange"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Facilitate",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Facilitate",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Facilitate-ff81ff8ab21e4952a5f78e1b1714f022",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Communication",
      "slug": "communication",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "14b5d164-78d8-81e1-9303-f4cb198aef37",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-11-27T03:38:00.000Z",
        "last_edited_time": "2024-12-01T10:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081330/uxcomic-imgs/14b5d164-78d8-81e1-9303-f4cb198aef37.png",
            "expiry_time": "2026-10-04T09:11:25.242Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/14b5d164-78d8-81e1-9303-f4cb198aef37"
      },
      {
        "object": "block",
        "id": "14b5d164-78d8-8196-b9cd-e5f0c030d108",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-11-27T03:38:00.000Z",
        "last_edited_time": "2024-12-02T03:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu trong các cuộc họp bạn đã từng ngưỡng mộ ai đó làm chủ  được cuộc thảo luận, dẫn dắt điều hướng câu chuyện, hay bạn từng gặp khó khăn, bỡ ngỡ, luống cuống trong whiteboard challenge ở các buổi interview thì facilitate chính là skill bạn cần quan tâm đến.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu trong các cuộc họp bạn đã từng ngưỡng mộ ai đó làm chủ  được cuộc thảo luận, dẫn dắt điều hướng câu chuyện, hay bạn từng gặp khó khăn, bỡ ngỡ, luống cuống trong whiteboard challenge ở các buổi interview thì facilitate chính là skill bạn cần quan tâm đến.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-8075-be45-c93bebec9fe7",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T05:17:00.000Z",
        "last_edited_time": "2024-12-01T05:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-8056-b9d5-d5a9b7e9a2b5",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T03:24:00.000Z",
        "last_edited_time": "2024-12-01T05:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy nó là gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy nó là gì?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-8065-ae47-d1ec7c82b84d",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T04:22:00.000Z",
        "last_edited_time": "2024-12-01T04:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Facilitation is the key to unlocking the cross-functional power of shared understanding and diversity.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Facilitation is the key to unlocking the cross-functional power of shared understanding and diversity.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-8024-9ebe-fb4b74d88f51",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T03:03:00.000Z",
        "last_edited_time": "2024-12-01T10:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Facilitator được xem như là một điều phối viên để giúp các thành viên trong nhóm thảo luận về vấn đề gì đó để đạt được một sự đồng thuận và cho ra một kết luận cho vấn đề gì đó. Ví dụ các buổi họp cần facilitator: problem framing, brainstorm, design sprint, retrospective,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Facilitator được xem như là một điều phối viên để giúp các thành viên trong nhóm thảo luận về vấn đề gì đó để đạt được một sự đồng thuận và cho ra một kết luận cho vấn đề gì đó. Ví dụ các buổi họp cần facilitator: problem framing, brainstorm, design sprint, retrospective,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-8051-ae53-c9cb66cd9076",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T03:19:00.000Z",
        "last_edited_time": "2024-12-01T05:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: khác với presenter, bạn không phải là người trình bày, bạn chỉ đóng vai trò thúc đẩy các thành viên giao tiếp, thảo luận với nhau.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: khác với presenter, bạn không phải là người trình bày, bạn chỉ đóng vai trò thúc đẩy các thành viên giao tiếp, thảo luận với nhau.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-8043-ac33-e44cc1bf51cd",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T03:14:00.000Z",
        "last_edited_time": "2024-12-01T10:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Minh hoạ vui: facilitator giống như ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Minh hoạ vui: facilitator giống như ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "một huấn luyện viên",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "một huấn luyện viên",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " trên sân bóng vậy, bạn sẽ biết trận đấu (meeting) này cần có những cầu thủ nào (stakeholders), điểm mạnh điểm yếu & trách nhiệm của họ ra sao, khó khăn tình huống hiện tại là gì (topic) & tìm cách thúc đẩy họ phối hợp trong trận đấu một cách tốt nhất có thể (chiến thuật) để đem lại bàn thắng (outcome).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " trên sân bóng vậy, bạn sẽ biết trận đấu (meeting) này cần có những cầu thủ nào (stakeholders), điểm mạnh điểm yếu & trách nhiệm của họ ra sao, khó khăn tình huống hiện tại là gì (topic) & tìm cách thúc đẩy họ phối hợp trong trận đấu một cách tốt nhất có thể (chiến thuật) để đem lại bàn thắng (outcome).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-80a6-81c0-f3855048a26a",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T10:25:00.000Z",
        "last_edited_time": "2024-12-02T03:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: 1 buổi thảo luận sẽ work well khi tầm 3-5 người/nhóm, nếu nhiều hơn như 10-15 người hãy chia nhóm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: 1 buổi thảo luận sẽ work well khi tầm 3-5 người/nhóm, nếu nhiều hơn như 10-15 người hãy chia nhóm.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-80ee-aa0e-e5876d5b2ef1",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T05:17:00.000Z",
        "last_edited_time": "2024-12-01T05:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-803d-9d97-c577088f3923",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T03:24:00.000Z",
        "last_edited_time": "2024-12-01T03:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tại sao tôi nên biết skill này?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tại sao tôi nên biết skill này?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-8052-bfa5-c02043bdf5b5",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T03:23:00.000Z",
        "last_edited_time": "2024-12-06T11:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vì bạn sẽ luôn có điểm mù & bạn không biết hết tất cả, nên bạn cần sự giúp sức của các bên khác để cho thấy nhiều góc nhìn hơn, cho bạn ghép nối các công việc khác để ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vì bạn sẽ luôn có điểm mù & bạn không biết hết tất cả, nên bạn cần sự giúp sức của các bên khác để cho thấy nhiều góc nhìn hơn, cho bạn ghép nối các công việc khác để ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "giải quyết những vấn đề phức tạp",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "giải quyết những vấn đề phức tạp",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", cụ thể ở role ux/ product design thường là những buổi giải quyết vấn đề, đề xuất giải pháp hay đánh giá ý tưởng. Việc nắm được kĩ năng facilitate giúp bạn điều phối cuộc họp để thu thập được nhiều thông tin hơn cho giải pháp design.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", cụ thể ở role ux/ product design thường là những buổi giải quyết vấn đề, đề xuất giải pháp hay đánh giá ý tưởng. Việc nắm được kĩ năng facilitate giúp bạn điều phối cuộc họp để thu thập được nhiều thông tin hơn cho giải pháp design.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-80a3-8246-dd634194ec7b",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T04:17:00.000Z",
        "last_edited_time": "2024-12-01T10:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [
            {
              "type": "text",
              "text": {
                "content": "Jeff Patton & Associates",
                "link": {
                  "url": "https://www.slideshare.net/AgileNYC/agile-day-2015-jeff-patton-how-doing-the-little-things-well-make-the-big-things-possible"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Jeff Patton & Associates",
              "href": "https://www.slideshare.net/AgileNYC/agile-day-2015-jeff-patton-how-doing-the-little-things-well-make-the-big-things-possible"
            }
          ],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081331/uxcomic-imgs/14f5d164-78d8-80a3-8246-dd634194ec7b.png",
            "expiry_time": "2026-10-04T09:11:25.242Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/14f5d164-78d8-80a3-8246-dd634194ec7b"
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-801f-86b6-f4d52365850a",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T10:09:00.000Z",
        "last_edited_time": "2024-12-01T10:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kĩ năng này cũng là thứ đóng góp cực kì nhiều trong white board challenge khi đi phỏng vấn UX/Product design, người phỏng vấn bạn không những muốn xem bạn suy nghĩ ra sao, giải quyết vấn đề thế nào, mà còn muốn đánh giá xem cách bạn dẫn dắt, tương tác, involve họ thế nào trong lúc giải quyết đề bài đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kĩ năng này cũng là thứ đóng góp cực kì nhiều trong white board challenge khi đi phỏng vấn UX/Product design, người phỏng vấn bạn không những muốn xem bạn suy nghĩ ra sao, giải quyết vấn đề thế nào, mà còn muốn đánh giá xem cách bạn dẫn dắt, tương tác, involve họ thế nào trong lúc giải quyết đề bài đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1545d164-78d8-8054-9603-cb23655da851",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-06T11:17:00.000Z",
        "last_edited_time": "2024-12-06T11:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-804c-a945-ec28c049784f",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T03:23:00.000Z",
        "last_edited_time": "2024-12-02T03:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Từ việc bạn đóng tốt vai trò một facilitator, bạn sẽ dần trở thành người đáng tin cậy, dần có tiếng nói hơn vì bạn thể hiện được khả năng dẫn dắt cuộc họp để giúp đội nhóm thảo luận hiệu quả & ra quyết định nhanh chóng. Điều này đặc biệt quan trọng khi bạn ở level middle trở lên.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Từ việc bạn đóng tốt vai trò một facilitator, bạn sẽ dần trở thành người đáng tin cậy, dần có tiếng nói hơn vì bạn thể hiện được khả năng dẫn dắt cuộc họp để giúp đội nhóm thảo luận hiệu quả & ra quyết định nhanh chóng. Điều này đặc biệt quan trọng khi bạn ở level middle trở lên.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1545d164-78d8-80b3-b5ac-d6b77dff680b",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-06T11:18:00.000Z",
        "last_edited_time": "2024-12-06T11:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-8012-8554-fab72ed7561a",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T04:32:00.000Z",
        "last_edited_time": "2024-12-02T03:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Còn trong tổ chức thì như thế nào? Thông qua việc tạo điều kiện để các bên ngồi xuống thảo luận & đóng góp ý kiến cho nhau, điều này giúp mọi người đồng thuận với nhau, tránh xung đột, tăng khả năng hợp tác, giúp các member cảm thấy có thêm động lực vì được lắng nghe (chứ không như waterfall, designer chỉ cần thực thi requirement từ PO/PM, dev chỉ cần làm theo design). Cũng nhờ có nhiều góc nhìn hơn, nó khuyến khích được sự sáng tạo & phát hiện được các điểm mù sớm hơn, tránh việc bên trên plan xong thì bên dưới bảo không được.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Còn trong tổ chức thì như thế nào? Thông qua việc tạo điều kiện để các bên ngồi xuống thảo luận & đóng góp ý kiến cho nhau, điều này giúp mọi người đồng thuận với nhau, tránh xung đột, tăng khả năng hợp tác, giúp các member cảm thấy có thêm động lực vì được lắng nghe (chứ không như waterfall, designer chỉ cần thực thi requirement từ PO/PM, dev chỉ cần làm theo design). Cũng nhờ có nhiều góc nhìn hơn, nó khuyến khích được sự sáng tạo & phát hiện được các điểm mù sớm hơn, tránh việc bên trên plan xong thì bên dưới bảo không được.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-8030-8f9f-faf0e5d5fcdf",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T06:09:00.000Z",
        "last_edited_time": "2024-12-01T06:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081333/uxcomic-imgs/14f5d164-78d8-8030-8f9f-faf0e5d5fcdf.png",
            "expiry_time": "2026-10-04T09:11:25.242Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/14f5d164-78d8-8030-8f9f-faf0e5d5fcdf"
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-805a-8ec4-d2e6c59577cf",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T05:17:00.000Z",
        "last_edited_time": "2024-12-01T05:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "14b5d164-78d8-81b7-ac03-d2f44730c706",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-11-27T03:38:00.000Z",
        "last_edited_time": "2024-12-02T03:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "How",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "How",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14b5d164-78d8-811c-8bd7-c5584954fc50",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-11-27T03:38:00.000Z",
        "last_edited_time": "2024-12-01T04:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhiệm vụ của facilitator là:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhiệm vụ của facilitator là:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-80d4-8264-ea9372655b5a",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T03:34:00.000Z",
        "last_edited_time": "2024-12-01T04:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Người tổ chức cuộc họp:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Người tổ chức cuộc họp:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " bạn là người lên lịch, invite các stakeholders, set up agenda, quản lý thời gian & giữ nhịp độ thảo luận.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " bạn là người lên lịch, invite các stakeholders, set up agenda, quản lý thời gian & giữ nhịp độ thảo luận.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-80af-9dce-e246d16f5258",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T03:35:00.000Z",
        "last_edited_time": "2024-12-02T03:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Người điều hướng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Người điều hướng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": từ agenda bạn sẽ phải đảm bảo cuộc họp đi đúng hướng, tránh lan man và khuyến khích, kêu gọi mọi người cùng đóng góp chia sẻ, thảo luận.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": từ agenda bạn sẽ phải đảm bảo cuộc họp đi đúng hướng, tránh lan man và khuyến khích, kêu gọi mọi người cùng đóng góp chia sẻ, thảo luận.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-8002-9a43-e9dc6897ec06",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T03:37:00.000Z",
        "last_edited_time": "2024-12-01T04:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Người trung lập",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Người trung lập",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": luôn nhớ mình chỉ đóng vai trò là người điều phối, không áp đặt ý kiến cá nhân, đảm bảo mọi ý kiến đều được xem xét công bằng. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": luôn nhớ mình chỉ đóng vai trò là người điều phối, không áp đặt ý kiến cá nhân, đảm bảo mọi ý kiến đều được xem xét công bằng. ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-804f-8f09-ec5a12b97832",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T03:40:00.000Z",
        "last_edited_time": "2024-12-01T04:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy công việc của facilitator là gì?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy công việc của facilitator là gì?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-8056-bb65-f6c26281d22c",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T03:41:00.000Z",
        "last_edited_time": "2024-12-02T03:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Xác định mục tiêu",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Xác định mục tiêu",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " buổi họp, agenda của buổi họp gồm bao nhiêu topic, thứ cần chốt sau buổi họp là gì.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " buổi họp, agenda của buổi họp gồm bao nhiêu topic, thứ cần chốt sau buổi họp là gì.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-8022-84d8-ff31431629db",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T03:42:00.000Z",
        "last_edited_time": "2024-12-01T05:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chọn đúng người",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chọn đúng người",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " tham gia vào buổi họp. Để biết chọn ai, bạn có thể tham khảo thêm ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " tham gia vào buổi họp. Để biết chọn ai, bạn có thể tham khảo thêm ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "RACI",
                "link": {
                  "url": "/1185d16478d88014bdf1e631b28f601e"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "RACI",
              "href": "/1185d16478d88014bdf1e631b28f601e"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-8086-b74b-e0332fca4272",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T03:44:00.000Z",
        "last_edited_time": "2024-12-02T03:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thiết kế workshop",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thiết kế workshop",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": với mục tiêu đề ra, bạn sẽ thiết kế xem cách thảo luận nào là phù hợp, bao lâu là đủ, lựa chọn framework/ tool nào cho phù hợp để các member đều contribute vào cuộc thảo luận,... Ví dụ: affinity mapping, dot voting, 5whys, crazy 8s, round robin discussions (tham khảo ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": với mục tiêu đề ra, bạn sẽ thiết kế xem cách thảo luận nào là phù hợp, bao lâu là đủ, lựa chọn framework/ tool nào cho phù hợp để các member đều contribute vào cuộc thảo luận,... Ví dụ: affinity mapping, dot voting, 5whys, crazy 8s, round robin discussions (tham khảo ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "trang này thêm ",
                "link": {
                  "url": "https://untools.co/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "trang này thêm ",
              "href": "https://untools.co/"
            },
            {
              "type": "text",
              "text": {
                "content": "nhe, nhiều framework lắm)…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "nhe, nhiều framework lắm)…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-806d-84a1-ef7cb214d9e4",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T03:48:00.000Z",
        "last_edited_time": "2024-12-01T05:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dẫn dắt buổi họp",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dẫn dắt buổi họp",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": thiết lập không khí buổi họp, biết cách ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": thiết lập không khí buổi họp, biết cách ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "lắng nghe",
                "link": {
                  "url": "/1405d16478d8801ab019e709965fbf48"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "lắng nghe",
              "href": "/1405d16478d8801ab019e709965fbf48"
            },
            {
              "type": "text",
              "text": {
                "content": ", ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "đặt câu hỏi",
                "link": {
                  "url": "/1435d16478d88004930ce9f3fede9fe4"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "đặt câu hỏi",
              "href": "/1435d16478d88004930ce9f3fede9fe4"
            },
            {
              "type": "text",
              "text": {
                "content": ", ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "khơi gợi khuyến khích sự đóng góp",
                "link": {
                  "url": "/40bca176e75c44e588052995bc234d8f"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "khơi gợi khuyến khích sự đóng góp",
              "href": "/40bca176e75c44e588052995bc234d8f"
            },
            {
              "type": "text",
              "text": {
                "content": ", quản lý thời gian buổi họp. Một cái quan trọng trong việc thảo luận đó là bạn muốn collect được càng nhiều thông tin càng tốt vì nó sẽ giúp đi đến được một kết luận đủ chất hơn (từ lượng sang chất). Nên đừng bỏ qua khái niệm ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", quản lý thời gian buổi họp. Một cái quan trọng trong việc thảo luận đó là bạn muốn collect được càng nhiều thông tin càng tốt vì nó sẽ giúp đi đến được một kết luận đủ chất hơn (từ lượng sang chất). Nên đừng bỏ qua khái niệm ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "6 Thinking Hats",
                "link": {
                  "url": "/14f5d16478d8807a9ce7ed335a243652"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "6 Thinking Hats",
              "href": "/14f5d16478d8807a9ce7ed335a243652"
            },
            {
              "type": "text",
              "text": {
                "content": " để giúp mình đảm bảo việc này. Ah đừng quên timeline trong buổi họp, có những lúc thảo luận sôi nổi nhưng phải remind việc ra quyết định để move on sang next topic (đôi khi việc hoàn thành quan trọng hơn sự hoàn hảo, ta luôn có thể cải thiện nó ở tương lai nếu muốn).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " để giúp mình đảm bảo việc này. Ah đừng quên timeline trong buổi họp, có những lúc thảo luận sôi nổi nhưng phải remind việc ra quyết định để move on sang next topic (đôi khi việc hoàn thành quan trọng hơn sự hoàn hảo, ta luôn có thể cải thiện nó ở tương lai nếu muốn).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-80ae-927e-f23c4b1b4b76",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T03:49:00.000Z",
        "last_edited_time": "2024-12-01T04:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Biết cách tổng hợp lại chủ đề thảo luận, tóm tắt kết quả, xác định next step. Ai làm việc gì? Timeline thế nào… Note: trong buổi họp tuỳ tình huống ta sẽ có nhiều decision maker, ví dụ tuỳ theo chủ để đang thảo luận, ai có chuyên môn cao sẽ là người quyết, hoặc ai là người chịu trách nhiệm cao nhất cho dự án sẽ là người quyết.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Biết cách tổng hợp lại chủ đề thảo luận, tóm tắt kết quả, xác định next step. Ai làm việc gì? Timeline thế nào… Note: trong buổi họp tuỳ tình huống ta sẽ có nhiều decision maker, ví dụ tuỳ theo chủ để đang thảo luận, ai có chuyên môn cao sẽ là người quyết, hoặc ai là người chịu trách nhiệm cao nhất cho dự án sẽ là người quyết.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-8078-ba71-cdb1120f72be",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2025-01-03T01:50:00.000Z",
        "last_edited_time": "2025-01-03T01:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081336/uxcomic-imgs/1705d164-78d8-8078-ba71-cdb1120f72be.gif",
            "expiry_time": "2026-10-04T09:11:25.320Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1705d164-78d8-8078-ba71-cdb1120f72be"
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-80bd-8590-e23288d5e627",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T03:52:00.000Z",
        "last_edited_time": "2024-12-01T04:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Từ tính chất nhiệm vụ & công việc của facilitator, sau đây là 4 principle phải keep in mind:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Từ tính chất nhiệm vụ & công việc của facilitator, sau đây là 4 principle phải keep in mind:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-80e9-aa51-e95ddaa21c22",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T03:52:00.000Z",
        "last_edited_time": "2024-12-01T04:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tính trung lập: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tính trung lập: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "ý kiến của bạn chỉ là một trong số các ý kiến, tránh bị bias, mang tính áp đặt, mọi ý kiến nên được đánh giá khách quan & xem xét công bằng. Một trong những cách để tránh bias đó là hãy đem data, principle, nghiên cứu, best practics ra thảo luận, cố gắng nhìn với góc độ đa chiều & có ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "ý kiến của bạn chỉ là một trong số các ý kiến, tránh bị bias, mang tính áp đặt, mọi ý kiến nên được đánh giá khách quan & xem xét công bằng. Một trong những cách để tránh bias đó là hãy đem data, principle, nghiên cứu, best practics ra thảo luận, cố gắng nhìn với góc độ đa chiều & có ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "hệ tiêu chí ",
                "link": {
                  "url": "/b2deb93698dc4fafaadc9cfcb4a6c302"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "hệ tiêu chí ",
              "href": "/b2deb93698dc4fafaadc9cfcb4a6c302"
            },
            {
              "type": "text",
              "text": {
                "content": "đánh giá rõ ràng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "đánh giá rõ ràng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-80e6-a583-cff7220d5d18",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T03:53:00.000Z",
        "last_edited_time": "2024-12-02T03:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Inclusivity",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Inclusivity",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": có nghĩa khuyến khích tất cả mọi người đều tham gia đóng góp, đặc biệt với những ai ngại chia sẻ. Ví dụ trong buổi brainstorm, bạn nói trước là không có ý tưởng nào ngu ngốc cả, không có sự đúng sai ở bước này, hãy để mọi người được im lặng note hết những idea trong đầu ra giấy trong vài phút & dán chúng lên bảng (tránh sự thảo luận khiến vài người không dám đóng góp hoặc bị ảnh hưởng ý kiến của nhau). Hoặc lúc dot voting thì nên làm dưới chế độ ẩn danh để mọi người thoải mái bình chọn & công tâm nhất.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": có nghĩa khuyến khích tất cả mọi người đều tham gia đóng góp, đặc biệt với những ai ngại chia sẻ. Ví dụ trong buổi brainstorm, bạn nói trước là không có ý tưởng nào ngu ngốc cả, không có sự đúng sai ở bước này, hãy để mọi người được im lặng note hết những idea trong đầu ra giấy trong vài phút & dán chúng lên bảng (tránh sự thảo luận khiến vài người không dám đóng góp hoặc bị ảnh hưởng ý kiến của nhau). Hoặc lúc dot voting thì nên làm dưới chế độ ẩn danh để mọi người thoải mái bình chọn & công tâm nhất.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-800a-8c3a-cac4ce70fe5f",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T03:54:00.000Z",
        "last_edited_time": "2024-12-01T04:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sự rõ ràng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sự rõ ràng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": cuộc thảo luận nên càng clear càng tốt, tận dụng các framework để mọi người dễ hình dung bức tranh chung, cố gắng visualize các suy nghĩ của mọi người (show, don’t tell), sắp xếp & tổ chức chúng, nó được xem là ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": cuộc thảo luận nên càng clear càng tốt, tận dụng các framework để mọi người dễ hình dung bức tranh chung, cố gắng visualize các suy nghĩ của mọi người (show, don’t tell), sắp xếp & tổ chức chúng, nó được xem là ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "sense making ",
                "link": {
                  "url": "/1195d16478d880cda21ff9d0e90ae7b8"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "sense making ",
              "href": "/1195d16478d880cda21ff9d0e90ae7b8"
            },
            {
              "type": "text",
              "text": {
                "content": "ở phạm vi nhóm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "ở phạm vi nhóm.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-80eb-90ce-ca8cb53c3105",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T03:56:00.000Z",
        "last_edited_time": "2024-12-01T04:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Outcome-oriented",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Outcome-oriented",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": đảm bảo cuộc họp đạt đúng được mục tiêu đề ra, tránh lan man & kết quả sau buổi họp là một sự mông lung, mơ hồ, mất thời gian đôi bên.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": đảm bảo cuộc họp đạt đúng được mục tiêu đề ra, tránh lan man & kết quả sau buổi họp là một sự mông lung, mơ hồ, mất thời gian đôi bên.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 3
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-8066-93bc-d2516105db28",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T05:26:00.000Z",
        "last_edited_time": "2024-12-01T05:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-8068-b719-f2b731c7b619",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T05:26:00.000Z",
        "last_edited_time": "2024-12-01T05:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tóm lại",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tóm lại",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-8010-bd2e-eb8f0de1e373",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T05:26:00.000Z",
        "last_edited_time": "2024-12-01T05:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Facilitating is more about ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Facilitating is more about ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "listening to the conversation",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "listening to the conversation",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "... than actively participating in it... as a facilitator, it’s important to let the participants generate the content on their own. It also means ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "... than actively participating in it... as a facilitator, it’s important to let the participants generate the content on their own. It also means ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "guiding or directing",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "guiding or directing",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " conversations and activities, rather than leading them.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " conversations and activities, rather than leading them.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14b5d164-78d8-815b-a314-c352f9e89e2b",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-11-27T03:38:00.000Z",
        "last_edited_time": "2024-11-27T03:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "14b5d164-78d8-81ee-91a9-ea65b390806c",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-11-27T03:38:00.000Z",
        "last_edited_time": "2024-11-27T03:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14b5d164-78d8-8177-b689-c0d7e0ab2eed",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-11-27T03:38:00.000Z",
        "last_edited_time": "2024-12-01T04:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://jeremybird276.medium.com/design-facilitation-the-secret-sauce-of-great-designers-880de684d14f",
                "link": {
                  "url": "https://jeremybird276.medium.com/design-facilitation-the-secret-sauce-of-great-designers-880de684d14f"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://jeremybird276.medium.com/design-facilitation-the-secret-sauce-of-great-designers-880de684d14f",
              "href": "https://jeremybird276.medium.com/design-facilitation-the-secret-sauce-of-great-designers-880de684d14f"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-80e0-b702-f4afdd12ca5b",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-02T13:45:00.000Z",
        "last_edited_time": "2024-12-02T13:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.thefountaininstitute.com/blog/how-to-build-facilitation-skills",
                "link": {
                  "url": "https://www.thefountaininstitute.com/blog/how-to-build-facilitation-skills"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.thefountaininstitute.com/blog/how-to-build-facilitation-skills",
              "href": "https://www.thefountaininstitute.com/blog/how-to-build-facilitation-skills"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-80ee-adff-c3e497848912",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T05:26:00.000Z",
        "last_edited_time": "2024-12-01T05:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://rangle.io/blog/facilitating-design-getting-to-the-why-on-your-projects",
                "link": {
                  "url": "https://rangle.io/blog/facilitating-design-getting-to-the-why-on-your-projects"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://rangle.io/blog/facilitating-design-getting-to-the-why-on-your-projects",
              "href": "https://rangle.io/blog/facilitating-design-getting-to-the-why-on-your-projects"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-80ba-ada4-ef141437751d",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T06:06:00.000Z",
        "last_edited_time": "2024-12-01T06:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.slideshare.net/slideshow/agile-day-2015-jeff-patton-how-doing-the-little-things-well-make-the-big-things-possible/55558390",
                "link": {
                  "url": "https://www.slideshare.net/slideshow/agile-day-2015-jeff-patton-how-doing-the-little-things-well-make-the-big-things-possible/55558390"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.slideshare.net/slideshow/agile-day-2015-jeff-patton-how-doing-the-little-things-well-make-the-big-things-possible/55558390",
              "href": "https://www.slideshare.net/slideshow/agile-day-2015-jeff-patton-how-doing-the-little-things-well-make-the-big-things-possible/55558390"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14b5d164-78d8-8169-bfa8-ff2a5628cd98",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-11-27T03:38:00.000Z",
        "last_edited_time": "2024-12-01T05:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://untools.co/",
                "link": {
                  "url": "https://untools.co/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://untools.co/",
              "href": "https://untools.co/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14b5d164-78d8-81c0-adc0-cad315e6dc0b",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-11-27T03:38:00.000Z",
        "last_edited_time": "2024-11-27T03:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "14b5d164-78d8-819f-8545-e4a894e14c2f",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-11-27T03:38:00.000Z",
        "last_edited_time": "2024-11-27T03:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14b5d164-78d8-81ef-8a7b-dd659d8da9e1",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-11-27T03:38:00.000Z",
        "last_edited_time": "2024-12-01T05:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "95727332-bdb3-4f63-a0cd-f9023732995d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Questioning (P1)",
              "href": "https://app.notion.com/p/95727332bdb34f63a0cdf9023732995d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14b5d164-78d8-816d-b482-ebf338c47a72",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-11-27T03:38:00.000Z",
        "last_edited_time": "2024-12-01T05:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sense making",
              "href": "https://app.notion.com/p/1195d16478d880cda21ff9d0e90ae7b8"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-802e-a602-c6256a33380f",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T10:22:00.000Z",
        "last_edited_time": "2025-01-03T01:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "14477ad8-7b47-470c-9af5-9bab88236d43"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Take design feedback (P2)",
              "href": "https://app.notion.com/p/14477ad87b47470c9af59bab88236d43"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14f5d164-78d8-8014-b95b-c33d59b29257",
        "parent": {
          "type": "page_id",
          "page_id": "ff81ff8a-b21e-4952-a5f7-8e1b1714f022"
        },
        "created_time": "2024-12-01T05:23:00.000Z",
        "last_edited_time": "2024-12-01T05:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1265d164-78d8-8045-87d2-e2532aae0b64"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Brief (Hiểu đề)",
              "href": "https://app.notion.com/p/1265d16478d8804587d2e2532aae0b64"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8",
    "created_time": "2024-10-27T07:26:00.000Z",
    "last_edited_time": "2025-05-19T01:58:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-10-27T07:26:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "1-Understanding",
          "color": "orange"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 17
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-05-19T01:58:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "CDA\\",
          "name": "⚓:2",
          "color": "brown"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Non-design work",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Non-design work",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Non-design-work-12c5d16478d880b582fbdc48f1f4d4f8",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
      "name": "Understanding",
      "slug": "understanding",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "12c5d164-78d8-81f1-8174-c70cd80cf2cc",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-10-27T07:26:00.000Z",
        "last_edited_time": "2024-12-24T04:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081339/uxcomic-imgs/12c5d164-78d8-81f1-8174-c70cd80cf2cc.png",
            "expiry_time": "2026-10-04T09:11:27.603Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/12c5d164-78d8-81f1-8174-c70cd80cf2cc"
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-806b-bb9c-dc746bc6dde1",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-10-27T07:30:00.000Z",
        "last_edited_time": "2024-11-27T10:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình đã có vài năm kinh nghiệm trong công việc UX/UI, sau khi đã dần thuần thục các process, framework để có thể deliver 1 design trơn tru hơn, mình bắt đầu thấy tầm quan trọng của những non-design work như collaboration, build trust, influence…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình đã có vài năm kinh nghiệm trong công việc UX/UI, sau khi đã dần thuần thục các process, framework để có thể deliver 1 design trơn tru hơn, mình bắt đầu thấy tầm quan trọng của những non-design work như collaboration, build trust, influence…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8091-8db7-f3dca26b210a",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T10:39:00.000Z",
        "last_edited_time": "2024-12-18T10:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80f1-bafd-ee0b2cb52416",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T10:37:00.000Z",
        "last_edited_time": "2024-12-19T01:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để hình dung về non-design work, mình sẽ hệ thống bài viết này theo concept sau, hãy hình dung bạn đang đứng ở giữa 2 trục ngang & dọc.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để hình dung về non-design work, mình sẽ hệ thống bài viết này theo concept sau, hãy hình dung bạn đang đứng ở giữa 2 trục ngang & dọc.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-803f-b95f-da49b1acf6b1",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T10:40:00.000Z",
        "last_edited_time": "2024-12-19T01:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đối với trục dọc sẽ liên quan đến nghề của mình:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đối với trục dọc sẽ liên quan đến nghề của mình:",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "1605d164-78d8-809d-b4d7-f59aaf0df445",
            "parent": {
              "type": "block_id",
              "block_id": "1605d164-78d8-803f-b95f-da49b1acf6b1"
            },
            "created_time": "2024-12-18T10:40:00.000Z",
            "last_edited_time": "2024-12-19T01:42:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Khi nhìn lên, mình sẽ thấy những công việc mà level senior, leader sẽ phải handle thêm.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Khi nhìn lên, mình sẽ thấy những công việc mà level senior, leader sẽ phải handle thêm.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1605d164-78d8-80dd-ada4-ffaf3e094cf7",
            "parent": {
              "type": "block_id",
              "block_id": "1605d164-78d8-803f-b95f-da49b1acf6b1"
            },
            "created_time": "2024-12-18T10:40:00.000Z",
            "last_edited_time": "2024-12-19T01:42:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Khi nhìn xuống, mình sẽ thấy những công việc liên quan đến soft skill, đến khả năng quản lý & tối ưu công việc bản thân.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Khi nhìn xuống, mình sẽ thấy những công việc liên quan đến soft skill, đến khả năng quản lý & tối ưu công việc bản thân.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8059-92e5-d2a207a1d4b5",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T10:41:00.000Z",
        "last_edited_time": "2024-12-19T01:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đối với trục ngang sẽ liên quan đến nghề của các stakeholder ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đối với trục ngang sẽ liên quan đến nghề của các stakeholder ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "1605d164-78d8-80c9-ac1f-c5b0e1e0ea87",
            "parent": {
              "type": "block_id",
              "block_id": "1605d164-78d8-8059-92e5-d2a207a1d4b5"
            },
            "created_time": "2024-12-18T10:41:00.000Z",
            "last_edited_time": "2024-12-18T10:45:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Khi nhìn sang trái đó là các stakeholder định hình công việc của designer, có thể kể đến là business, R&D, PO, PM…",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Khi nhìn sang trái đó là các stakeholder định hình công việc của designer, có thể kể đến là business, R&D, PO, PM…",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1605d164-78d8-80be-bdfd-c22e6d48b248",
            "parent": {
              "type": "block_id",
              "block_id": "1605d164-78d8-8059-92e5-d2a207a1d4b5"
            },
            "created_time": "2024-12-18T10:43:00.000Z",
            "last_edited_time": "2024-12-18T10:45:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Khi nhìn sang phải đó là các stakeholder sẽ lĩnh hội output công việc của bạn, có thể kể đến là Dev, QC, operation team…",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Khi nhìn sang phải đó là các stakeholder sẽ lĩnh hội output công việc của bạn, có thể kể đến là Dev, QC, operation team…",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1605d164-78d8-80ce-b668-ec74ce1897c2",
            "parent": {
              "type": "block_id",
              "block_id": "1605d164-78d8-8059-92e5-d2a207a1d4b5"
            },
            "created_time": "2024-12-18T10:47:00.000Z",
            "last_edited_time": "2024-12-18T10:47:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [],
              "icon": null,
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8014-b878-e51ca3993cd9",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T10:47:00.000Z",
        "last_edited_time": "2025-05-14T11:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Disclaimer",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Disclaimer",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": để khách quan hơn, thì mình đang ở level middle khi viết bài này, đây là hoàn toàn là những quan sát cá nhân & tham khảo từ các nguồn khác nhau, nếu có sai sót mong quý dị bỏ qua & cho mình biết thêm nhé (please! 🥹).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": để khách quan hơn, thì mình đang ở level middle khi viết bài này, đây là hoàn toàn là những quan sát cá nhân & tham khảo từ các nguồn khác nhau, nếu có sai sót mong quý dị bỏ qua & cho mình biết thêm nhé (please! 🥹).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8088-9608-d0b1340f8f55",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T10:45:00.000Z",
        "last_edited_time": "2024-12-18T10:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-803b-a2d7-e03bc591e8ab",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T10:45:00.000Z",
        "last_edited_time": "2025-05-14T11:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_1",
        "heading_1": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "↕️ Trục dọc",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "↕️ Trục dọc",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8051-9c38-c5ab21e3ce8d",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T10:46:00.000Z",
        "last_edited_time": "2024-12-18T10:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "1. Nhìn xuống",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "1. Nhìn xuống",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8065-be20-e6785e068f57",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T10:46:00.000Z",
        "last_edited_time": "2024-12-24T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là những skill ngoài chuyên môn, nhưng tác động đến các nhân rất mạnh.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là những skill ngoài chuyên môn, nhưng tác động đến các nhân rất mạnh.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-80d4-80d6-f017e056dcc7",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-24T01:57:00.000Z",
        "last_edited_time": "2024-12-24T01:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mindset, thái độ, tâm thế.",
                "link": {
                  "url": "/a8c82bf15c5b4f4db945cbdb31c819b7"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mindset, thái độ, tâm thế.",
              "href": "/a8c82bf15c5b4f4db945cbdb31c819b7"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80a9-8ba3-f9f726b15435",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T10:48:00.000Z",
        "last_edited_time": "2024-12-24T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Soft skill",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Soft skill",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là những kĩ năng bổ trợ bạn trong quá trình collaborate với các stakeholders, ví dụ: stakeholder management, communication, listening, meeting skill, negotiation…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là những kĩ năng bổ trợ bạn trong quá trình collaborate với các stakeholders, ví dụ: stakeholder management, communication, listening, meeting skill, negotiation…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8055-ae18-ec6acdd39430",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T10:49:00.000Z",
        "last_edited_time": "2024-12-19T01:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các skill xoay quanh việc tối ưu cho hard skill, ví dụ mình sẽ phải có phương án để tối ưu hoá hiệu suất làm việc, có thể liên quan đến scoping, timeline estimation, time management, file management, documentation…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các skill xoay quanh việc tối ưu cho hard skill, ví dụ mình sẽ phải có phương án để tối ưu hoá hiệu suất làm việc, có thể liên quan đến scoping, timeline estimation, time management, file management, documentation…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8077-9fcc-f39ccfb9805d",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-24T01:51:00.000Z",
        "last_edited_time": "2025-05-14T11:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Meta skill",
                "link": {
                  "url": "/1665d16478d880bfbd1ff14b2e9cdd0a"
                }
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Meta skill",
              "href": "/1665d16478d880bfbd1ff14b2e9cdd0a"
            },
            {
              "type": "text",
              "text": {
                "content": ". OMG! Bữa mình nghe được khái niệm này mới thấy nó huge thật sự, đây là những skill tính ảnh hưởng lên mọi thứ bạn hiểu, bạn làm hiện tại. Ví dụ: học về cách học, học về cách hiểu, học về cách ra quyết định,… Các skill này chắc chắn boost bạn lên một version khác, kiểu như Tony Stark được trang bị thêm lớp giáp Iron man vậy.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". OMG! Bữa mình nghe được khái niệm này mới thấy nó huge thật sự, đây là những skill tính ảnh hưởng lên mọi thứ bạn hiểu, bạn làm hiện tại. Ví dụ: học về cách học, học về cách hiểu, học về cách ra quyết định,… Các skill này chắc chắn boost bạn lên một version khác, kiểu như Tony Stark được trang bị thêm lớp giáp Iron man vậy.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8006-8d24-fdf0cc7d00b2",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T10:51:00.000Z",
        "last_edited_time": "2024-12-18T10:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8010-9785-d9e1928f0fdf",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T10:51:00.000Z",
        "last_edited_time": "2024-12-18T10:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "2. Nhìn lên",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2. Nhìn lên",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-8062-9f4b-ed5d37495b86",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T03:39:00.000Z",
        "last_edited_time": "2024-12-19T01:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước khi đi vào chi tiết, mình muốn kể lại một câu chuyện minh hoạ cho việc đặt mục tiêu: Khi ta nhắm & bắn cung đến mục tiêu, nó không hoạt động theo kiểu đường thẳng (đặc biệt là khi mục tiêu càng xa), có nghĩa mặc dù bạn nhắm đúng điểm và bắn nhưng chắc chắn mũi tên sẽ chệch xuống vì ảnh hưởng của ma sát, sức gió và gia tốc bị giảm dần… >> khi đặt mục tiêu cũng vậy, bạn luôn phải làm hơn mức cần thiết, ví dụ: nếu bạn đang ở level của junior và muốn lên middle thì kiến thức, kĩ năng cần trau dồi phải ở mức senior, khi middle muốn lên senior thì phải am hiểu công việc mức leader. Thực tế công sức bạn bỏ ra 100% nhưng chỉ 50-70% là có khả năng convert sang thành tựu, không có chuyện tươi đẹp đánh đâu thắng đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước khi đi vào chi tiết, mình muốn kể lại một câu chuyện minh hoạ cho việc đặt mục tiêu: Khi ta nhắm & bắn cung đến mục tiêu, nó không hoạt động theo kiểu đường thẳng (đặc biệt là khi mục tiêu càng xa), có nghĩa mặc dù bạn nhắm đúng điểm và bắn nhưng chắc chắn mũi tên sẽ chệch xuống vì ảnh hưởng của ma sát, sức gió và gia tốc bị giảm dần… >> khi đặt mục tiêu cũng vậy, bạn luôn phải làm hơn mức cần thiết, ví dụ: nếu bạn đang ở level của junior và muốn lên middle thì kiến thức, kĩ năng cần trau dồi phải ở mức senior, khi middle muốn lên senior thì phải am hiểu công việc mức leader. Thực tế công sức bạn bỏ ra 100% nhưng chỉ 50-70% là có khả năng convert sang thành tựu, không có chuyện tươi đẹp đánh đâu thắng đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8031-8e6c-d0fb5ce9fa8a",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T10:52:00.000Z",
        "last_edited_time": "2024-12-18T10:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "OK, chắc qua câu chuyện trên bạn đã hình dung được mức độ quan trọng của việc nhìn lên, vậy chúng mình bắt đầu nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "OK, chắc qua câu chuyện trên bạn đã hình dung được mức độ quan trọng của việc nhìn lên, vậy chúng mình bắt đầu nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80c8-91f6-f3f29032be48",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T10:57:00.000Z",
        "last_edited_time": "2024-12-18T10:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình có một minh hoạ đơn giản cho các level trong tổ chức, hãy hình dung ta có 3 circle: cá nhân, team, tổ chức (phòng ban), thì sau đây là scope của các level:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình có một minh hoạ đơn giản cho các level trong tổ chức, hãy hình dung ta có 3 circle: cá nhân, team, tổ chức (phòng ban), thì sau đây là scope của các level:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8000-8b75-f65ebe644359",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T13:24:00.000Z",
        "last_edited_time": "2024-12-19T01:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081341/uxcomic-imgs/1605d164-78d8-8000-8b75-f65ebe644359.png",
            "expiry_time": "2026-10-04T09:11:27.603Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1605d164-78d8-8000-8b75-f65ebe644359"
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8086-8e84-dc19b677b9b2",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T10:57:00.000Z",
        "last_edited_time": "2024-12-18T13:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Junior, Middle",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Junior, Middle",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": bạn đứng trong circle cá nhân, nhiệm vụ chính của bạn là hoàn thành tốt các công việc được giao, quản lý bản thân tốt.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": bạn đứng trong circle cá nhân, nhiệm vụ chính của bạn là hoàn thành tốt các công việc được giao, quản lý bản thân tốt.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80b2-9e49-e2f931dc87b1",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T11:00:00.000Z",
        "last_edited_time": "2024-12-23T10:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Senior",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Senior",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": bạn có một chân đứng trong circle cá nhân, một chân đứng trong circle team. Điều này có nghĩa bạn phải hoàn thành tốt việc của mình đồng thời phải ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": bạn có một chân đứng trong circle cá nhân, một chân đứng trong circle team. Điều này có nghĩa bạn phải hoàn thành tốt việc của mình đồng thời phải ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "đóng góp giá trị cho team",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "đóng góp giá trị cho team",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", ví dụ: bạn đóng góp vào các internal project như design system, ux debt, guideline…, một sự đóng góp rõ ràng nhất ở level này là bạn phải có khả năng mentor ít nhất 1 bạn, việc này giúp đào tạo team member, để có resource kế thừa.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", ví dụ: bạn đóng góp vào các internal project như design system, ux debt, guideline…, một sự đóng góp rõ ràng nhất ở level này là bạn phải có khả năng mentor ít nhất 1 bạn, việc này giúp đào tạo team member, để có resource kế thừa.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80a1-8902-f86fe55f717c",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T11:06:00.000Z",
        "last_edited_time": "2024-12-23T10:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Leader+",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Leader+",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": bạn có một chân đứng trong team & một chân đứng ngoài tổ chức. Điều này có nghĩa, những công việc bạn làm phải có tính tác động đến",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": bạn có một chân đứng trong team & một chân đứng ngoài tổ chức. Điều này có nghĩa, những công việc bạn làm phải có tính tác động đến",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " cục diện của team ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " cục diện của team ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cũng như bắt đầu ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cũng như bắt đầu ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "tạo sức ảnh hưởng lên tổ chức - chứng minh được giá trị của phòng ban team design",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "tạo sức ảnh hưởng lên tổ chức - chứng minh được giá trị của phòng ban team design",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ". Ví dụ: bạn build process, set up thang chuẩn đánh giá output, thảo luận với các department khác để set up workflow, làm các buổi sharing để các bên khác hiểu thêm về giá trị của design (một cách khéo léo nhé), hoặc thậm chí cao hơn là contribute được vào strategy, propose các idea tác động đến business metrics.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". Ví dụ: bạn build process, set up thang chuẩn đánh giá output, thảo luận với các department khác để set up workflow, làm các buổi sharing để các bên khác hiểu thêm về giá trị của design (một cách khéo léo nhé), hoặc thậm chí cao hơn là contribute được vào strategy, propose các idea tác động đến business metrics.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80cd-9696-ebfe3d29cb3d",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T15:16:00.000Z",
        "last_edited_time": "2024-12-19T01:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [
            {
              "type": "text",
              "text": {
                "content": "https://www.intelligentpeople.co.uk/user-experience-lead/",
                "link": {
                  "url": "https://www.intelligentpeople.co.uk/user-experience-lead/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.intelligentpeople.co.uk/user-experience-lead/",
              "href": "https://www.intelligentpeople.co.uk/user-experience-lead/"
            }
          ],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081343/uxcomic-imgs/1605d164-78d8-80cd-9696-ebfe3d29cb3d.png",
            "expiry_time": "2026-10-04T09:11:27.603Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1605d164-78d8-80cd-9696-ebfe3d29cb3d"
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-80c6-805c-d3fc22bbb881",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2025-01-16T12:35:00.000Z",
        "last_edited_time": "2025-01-16T12:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "f450a658-4204-4d23-8bac-a92f7d57457c",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-10-27T07:48:00.000Z",
        "last_edited_time": "2025-01-16T12:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu xét về non-design work, thì level leader sẽ handle nhiều hơn. Nên hãy thử tìm hiểu xem leader sẽ làm gì nhé.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu xét về non-design work, thì level leader sẽ handle nhiều hơn. Nên hãy thử tìm hiểu xem leader sẽ làm gì nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-80e7-9063-e9537c66f746",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2025-01-16T12:35:00.000Z",
        "last_edited_time": "2025-01-16T12:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-80af-bc54-f8d3061bd2ba",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T02:20:00.000Z",
        "last_edited_time": "2024-12-18T15:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "1. Team management",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "1. Team management",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "cfc7a3bd-94b9-4d57-a323-86fba7bbaa59",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-10-27T07:48:00.000Z",
        "last_edited_time": "2024-12-23T10:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hãy hình dung công việc của ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hãy hình dung công việc của ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "một executor (IC) cần làm là tạo ra thứ A",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "một executor (IC) cần làm là tạo ra thứ A",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (một output gì đó mà nghề này đòi hỏi bạn cung cấp). ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (một output gì đó mà nghề này đòi hỏi bạn cung cấp). ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Leader là người sẽ có khả năng scale A",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Leader là người sẽ có khả năng scale A",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "đảm bảo dây chuyền sản xuất được trơn tru, giữ & nâng cao chất lượng A",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "đảm bảo dây chuyền sản xuất được trơn tru, giữ & nâng cao chất lượng A",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ". Ngoài ra, leader giờ còn là cầu nối với các phòng ban khác, các bên đó cũng có nghĩa vụ cho ra output B, C, D… Lúc này các leader collaborate với nhau ở mức độ đảm bảo một “dây chuyền sản xuất” lớn hơn, xoay quanh việc cross-functional collaborate có ổn không, workload đang như thế nào, sắp tới có cần sắp xếp nhân lực ra sao không,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". Ngoài ra, leader giờ còn là cầu nối với các phòng ban khác, các bên đó cũng có nghĩa vụ cho ra output B, C, D… Lúc này các leader collaborate với nhau ở mức độ đảm bảo một “dây chuyền sản xuất” lớn hơn, xoay quanh việc cross-functional collaborate có ổn không, workload đang như thế nào, sắp tới có cần sắp xếp nhân lực ra sao không,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-8015-8842-fda770279873",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T02:21:00.000Z",
        "last_edited_time": "2024-12-19T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhìn chung thì sẽ có 2 khía cạnh cần nhắc đến đó là việc & người.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhìn chung thì sẽ có 2 khía cạnh cần nhắc đến đó là việc & người.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14b5d164-78d8-80a1-a542-c24d9368bb90",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-27T08:20:00.000Z",
        "last_edited_time": "2024-12-19T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Biết “dùng người”",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Biết “dùng người”",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "1️⃣"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-8008-a001-ec9b3cac54b8",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T02:22:00.000Z",
        "last_edited_time": "2024-12-23T10:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Xét theo Employee life cycle: từ tuyển dụng > onboarding > phát triển > giữ chân > promote hoặc cắt giảm, leader đều có tác động một phần vào các giai đoạn này, nếu liên tưởng employee life cycle này là một customer journey map, thì leader đều có những đóng góp lớn vào các touchpoint trong việc hình thành nên trải nghiệm của một nhân sự.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Xét theo Employee life cycle: từ tuyển dụng > onboarding > phát triển > giữ chân > promote hoặc cắt giảm, leader đều có tác động một phần vào các giai đoạn này, nếu liên tưởng employee life cycle này là một customer journey map, thì leader đều có những đóng góp lớn vào các touchpoint trong việc hình thành nên trải nghiệm của một nhân sự.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-80f6-84c8-ef2d12618c19",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T02:23:00.000Z",
        "last_edited_time": "2024-12-19T01:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Level này sẽ cần bạn",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Level này sẽ cần bạn",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " coach, guide & inpire các team member",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " coach, guide & inpire các team member",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ". Mình sẽ phải hiểu điểm mạnh, điểm yếu của từng thành viên, xu hướng tâm lý, động lực và trở ngại của họ là gì, làm sao mình có thể giúp họ phát triển, hỗ trợ họ những lúc khó khăn, làm sao để truyền động lực & khiến họ muốn gắn kết với team nói riêng & với công ty nói chung.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". Mình sẽ phải hiểu điểm mạnh, điểm yếu của từng thành viên, xu hướng tâm lý, động lực và trở ngại của họ là gì, làm sao mình có thể giúp họ phát triển, hỗ trợ họ những lúc khó khăn, làm sao để truyền động lực & khiến họ muốn gắn kết với team nói riêng & với công ty nói chung.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-80f6-a4ba-c5929f47dc74",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T02:35:00.000Z",
        "last_edited_time": "2024-12-23T10:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi nhắc đến yếu tố con người, không thể tách rời khỏi ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi nhắc đến yếu tố con người, không thể tách rời khỏi ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "văn hoá",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "văn hoá",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (team culture là một tập hợp các giá trị, quan niệm, thái độ, hành vi và phương pháp làm việc chung của một nhóm người trong quá trình hợp tác để đạt được mục tiêu chung). Mình sẽ là người phải đóng góp rất lớn đến văn hoá team, mình vừa là tấm gương vừa là người truyền giáo, mình muốn team sẽ chuyên nghiệp ra sao, kết nối như thế nào thì cần bạn phải set up các activities để khuyến khích, inspire mọi người cùng xây dựng văn hoá này. Ví dụ: nếu muốn team có văn hoá tự trau dồi & chia sẻ thì có thể set up có sharing session vào mỗi tuần, hay muốn các team member kết nối với nhau nhiều hơn thì hàng quý nên có 1 buổi team building gì đó…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (team culture là một tập hợp các giá trị, quan niệm, thái độ, hành vi và phương pháp làm việc chung của một nhóm người trong quá trình hợp tác để đạt được mục tiêu chung). Mình sẽ là người phải đóng góp rất lớn đến văn hoá team, mình vừa là tấm gương vừa là người truyền giáo, mình muốn team sẽ chuyên nghiệp ra sao, kết nối như thế nào thì cần bạn phải set up các activities để khuyến khích, inspire mọi người cùng xây dựng văn hoá này. Ví dụ: nếu muốn team có văn hoá tự trau dồi & chia sẻ thì có thể set up có sharing session vào mỗi tuần, hay muốn các team member kết nối với nhau nhiều hơn thì hàng quý nên có 1 buổi team building gì đó…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1575d164-78d8-8054-8ccd-f9107d30dbef",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-09T15:21:00.000Z",
        "last_edited_time": "2024-12-19T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Biết xếp việc",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Biết xếp việc",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "2️⃣"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-8033-9af3-ff8843acd82f",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T02:33:00.000Z",
        "last_edited_time": "2024-12-19T02:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi ở vị trí này, leader được xem là người sẽ đại diện cho team đi nhận các requirement từ các phòng ban khác, nghĩa vụ của mình là phải biết quản lý & đảm bảo chất lượng công việc. Các công việc như:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi ở vị trí này, leader được xem là người sẽ đại diện cho team đi nhận các requirement từ các phòng ban khác, nghĩa vụ của mình là phải biết quản lý & đảm bảo chất lượng công việc. Các công việc như:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-80ab-bbe5-f2cf9799604e",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T02:46:00.000Z",
        "last_edited_time": "2024-12-19T02:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lập kế hoạch & Quản lý ưu tiên:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lập kế hoạch & Quản lý ưu tiên:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Xác định mục tiêu, chia nhỏ nhiệm vụ, lập timeline rõ ràng. Cân nhắc yêu cầu project và phân bổ nguồn lực một cách hợp lý.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Xác định mục tiêu, chia nhỏ nhiệm vụ, lập timeline rõ ràng. Cân nhắc yêu cầu project và phân bổ nguồn lực một cách hợp lý.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-8074-96d3-fcf317a23768",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T02:46:00.000Z",
        "last_edited_time": "2024-12-24T13:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Theo dõi tiến độ:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Theo dõi tiến độ:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Đảm bảo nhóm đi đúng hướng, điều chỉnh khi cần thiết. (tiến độ ra sao, có bị block gì không).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Đảm bảo nhóm đi đúng hướng, điều chỉnh khi cần thiết. (tiến độ ra sao, có bị block gì không).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-800a-be84-f8b573fa72e0",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T02:46:00.000Z",
        "last_edited_time": "2024-12-19T02:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đảm bảo chất lượng công việc:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đảm bảo chất lượng công việc:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " bằng việc build process rõ ràng, có thang đánh giá chất lượng, review process…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " bằng việc build process rõ ràng, có thang đánh giá chất lượng, review process…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-804e-a2c9-c41eadd5dc37",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T02:47:00.000Z",
        "last_edited_time": "2024-12-19T02:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lưu ý: hãy ghi nhớ khi mình là một leader, mình không nên làm thay việc của các team member, bạn chỉ nên là người hoạch định, guide cho họ, mình muốn team member có khả năng grow lên từng ngày thông qua các project. Don’t be micro management nó không tốt cho cả 2.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lưu ý: hãy ghi nhớ khi mình là một leader, mình không nên làm thay việc của các team member, bạn chỉ nên là người hoạch định, guide cho họ, mình muốn team member có khả năng grow lên từng ngày thông qua các project. Don’t be micro management nó không tốt cho cả 2.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-80fb-b725-d663bf1db3e7",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2025-01-16T12:35:00.000Z",
        "last_edited_time": "2025-01-16T12:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-80ae-9789-d65b1efdd6e3",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T03:16:00.000Z",
        "last_edited_time": "2024-12-18T14:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "2. Impact enhancement",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2. Impact enhancement",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-80a8-9f46-d7bcfdc1e18b",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T03:16:00.000Z",
        "last_edited_time": "2024-12-24T04:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vì mình không còn là một IC nữa, công việc liên quan đến design cho từng project riêng lẻ cũng ít đi. Tính chất công việc giờ phải mang lại impact có ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vì mình không còn là một IC nữa, công việc liên quan đến design cho từng project riêng lẻ cũng ít đi. Tính chất công việc giờ phải mang lại impact có ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "tính cục diện hơn, tạo impact lên toàn team & đóng góp nhiều hơn vào product & tổ chức.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "tính cục diện hơn, tạo impact lên toàn team & đóng góp nhiều hơn vào product & tổ chức.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-80fa-8a7a-f11bb2287b52",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T03:34:00.000Z",
        "last_edited_time": "2024-12-18T14:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Programs not Projects",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Programs not Projects",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80f2-b081-d0e487180a7a",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T14:07:00.000Z",
        "last_edited_time": "2024-12-24T04:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Programs (hiểu nôm na là các output có tính strategic & mang tính system hơn) có thể chia làm 2 dạng: chất & lượng. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Programs (hiểu nôm na là các output có tính strategic & mang tính system hơn) có thể chia làm 2 dạng: chất & lượng. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8001-a0a3-eb8b859add56",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T14:58:00.000Z",
        "last_edited_time": "2024-12-23T11:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lượng - tác động nhiều:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lượng - tác động nhiều:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " thông qua team management đã là một phần output của bạn, bạn chịu trách nhiệm việc đảm bảo, nâng cao hiệu suất & chất lượng công việc của các team member. Nhưng bạn vẫn có làm design, chỉ khác là project của bạn phải có tính tác động đến product ở góc độ toàn diện hơn,… ví dụ: set up design system, design language cho toàn bộ app, quy hoạch IA, guideline quy chuẩn UX,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " thông qua team management đã là một phần output của bạn, bạn chịu trách nhiệm việc đảm bảo, nâng cao hiệu suất & chất lượng công việc của các team member. Nhưng bạn vẫn có làm design, chỉ khác là project của bạn phải có tính tác động đến product ở góc độ toàn diện hơn,… ví dụ: set up design system, design language cho toàn bộ app, quy hoạch IA, guideline quy chuẩn UX,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80c2-ba2d-c7adbe628828",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T14:58:00.000Z",
        "last_edited_time": "2024-12-23T11:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chất - tác động sâu:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chất - tác động sâu:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " cũng là những task design nhưng ở một level cao hơn, để hình dung cao hơn là như thế nào, thì design solution bạn đưa ra sẽ phải trả lời cho những câu hỏi mơ hồ hơn như: “làm sao để tăng conversion từ 10 > 15%?”, “làm sao để UX tốt hơn?”, “hướng để cải thiện feature adoption trong toàn app”,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " cũng là những task design nhưng ở một level cao hơn, để hình dung cao hơn là như thế nào, thì design solution bạn đưa ra sẽ phải trả lời cho những câu hỏi mơ hồ hơn như: “làm sao để tăng conversion từ 10 > 15%?”, “làm sao để UX tốt hơn?”, “hướng để cải thiện feature adoption trong toàn app”,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80e4-bd6f-d1153b0a2d80",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T15:44:00.000Z",
        "last_edited_time": "2024-12-23T11:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8050-bdd4-f2dcdfdbc319",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T15:31:00.000Z",
        "last_edited_time": "2024-12-23T11:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "So what?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "So what?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-809c-bc4c-cf2dcb1c2219",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T02:27:00.000Z",
        "last_edited_time": "2024-12-18T15:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhức nhức cái đầu rồi đó, vậy mình as an IC thì giờ có thể chuẩn bị những gì?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhức nhức cái đầu rồi đó, vậy mình as an IC thì giờ có thể chuẩn bị những gì?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-8006-bd66-ca6a8bcf895d",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T02:27:00.000Z",
        "last_edited_time": "2024-12-19T02:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước tiên hãy vững nghề, mình sẽ phải có khả năng am hiểu hết các kiến thức, skill của công việc hiện tại, kiểm soát và xử lý tốt được các tình huống trong công việc. Hãy cố gắng ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước tiên hãy vững nghề, mình sẽ phải có khả năng am hiểu hết các kiến thức, skill của công việc hiện tại, kiểm soát và xử lý tốt được các tình huống trong công việc. Hãy cố gắng ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "“template hoá”, “quy trình hoá”",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“template hoá”, “quy trình hoá”",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " các đầu việc, các phương án xử lý tình huống trong công việc. Bài tập này sẽ là cơ sở để bạn có tài liệu, hành trang cho việc đào tạo các team member.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " các đầu việc, các phương án xử lý tình huống trong công việc. Bài tập này sẽ là cơ sở để bạn có tài liệu, hành trang cho việc đào tạo các team member.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-8002-bf49-c4708cc4f5d6",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T02:31:00.000Z",
        "last_edited_time": "2024-12-23T11:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình cần ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình cần ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "quản lý bản thân",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "quản lý bản thân",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " tốt hơn, ý mình là nó liên quan đến khả năng quản lý thời gian, quản lý công việc, quản lý cảm xúc. Trước khi quản lý được, mình cần phải nhận diện chúng, một trong những cách mình hay làm là work journal, routine retrospective. Vì sao? Vì bạn chính là tấm gương cho các member, member phải nể phải phục bạn thì nói mới dễ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " tốt hơn, ý mình là nó liên quan đến khả năng quản lý thời gian, quản lý công việc, quản lý cảm xúc. Trước khi quản lý được, mình cần phải nhận diện chúng, một trong những cách mình hay làm là work journal, routine retrospective. Vì sao? Vì bạn chính là tấm gương cho các member, member phải nể phải phục bạn thì nói mới dễ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-80b2-b59e-e99bc9c77aae",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T03:10:00.000Z",
        "last_edited_time": "2024-12-23T11:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tập quan sát & đóng góp cho những ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tập quan sát & đóng góp cho những ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "“việc vô hình”",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“việc vô hình”",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", đó là các công việc không hẳn thuộc về trách nhiệm của ai, chỉ là bạn thấy nó cần cho team của bạn, cần cho tổ chức để mọi thứ được vận hành trơn tru hơn. Ví dụ: làm thế nào để onboarding một new team member tốt hơn, làm sao quản lý file tốt hơn, làm sao để tăng sự đồng nhất trong design giữa các team member (không phải mỗi người làm mỗi kiểu), làm sao để các team member có thể hiểu công việc & học hỏi lẫn nhau tốt hơn… Dù là gì đi nữa, hãy chú ý đến những việc này, vì nó rất matter khi bạn lên level lead, các việc vô hình này có tác dụng như là “keo dán”, giúp bạn set up “dây chuyền sản xuất” được trơn tru hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", đó là các công việc không hẳn thuộc về trách nhiệm của ai, chỉ là bạn thấy nó cần cho team của bạn, cần cho tổ chức để mọi thứ được vận hành trơn tru hơn. Ví dụ: làm thế nào để onboarding một new team member tốt hơn, làm sao quản lý file tốt hơn, làm sao để tăng sự đồng nhất trong design giữa các team member (không phải mỗi người làm mỗi kiểu), làm sao để các team member có thể hiểu công việc & học hỏi lẫn nhau tốt hơn… Dù là gì đi nữa, hãy chú ý đến những việc này, vì nó rất matter khi bạn lên level lead, các việc vô hình này có tác dụng như là “keo dán”, giúp bạn set up “dây chuyền sản xuất” được trơn tru hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-80df-a7f4-f45a0429b091",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T03:51:00.000Z",
        "last_edited_time": "2024-11-28T03:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-8019-8ef5-e849e50f3e40",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T07:56:00.000Z",
        "last_edited_time": "2025-05-14T11:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_1",
        "heading_1": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "↔️ Trục ngang",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "↔️ Trục ngang",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-8051-8127-e5a4ead8dd8d",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T07:56:00.000Z",
        "last_edited_time": "2024-12-19T02:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tiếp theo của non-design work, mình sẽ bàn đến việc mình cần để tâm đến các công việc của các stakeholder, là PO/PM, là Dev, QC, Sale, Marketing, Operation team…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tiếp theo của non-design work, mình sẽ bàn đến việc mình cần để tâm đến các công việc của các stakeholder, là PO/PM, là Dev, QC, Sale, Marketing, Operation team…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-8098-a9dd-e0e7c1944d15",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T09:35:00.000Z",
        "last_edited_time": "2024-12-23T11:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Không nhất thiết bạn phải am hiểu sâu, nhưng nên ở mức đủ để giao tiếp hiệu quả hơn, đủ để bạn có thể hình dung họ cần gì ở phía design của mình, đủ để hiểu trách nhiệm công việc của họ, thành công đối với họ là như thế nào, họ quan tâm & lo ngại gì nhất… Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Không nhất thiết bạn phải am hiểu sâu, nhưng nên ở mức đủ để giao tiếp hiệu quả hơn, đủ để bạn có thể hình dung họ cần gì ở phía design của mình, đủ để hiểu trách nhiệm công việc của họ, thành công đối với họ là như thế nào, họ quan tâm & lo ngại gì nhất… Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-8048-b2ff-f1247de7c964",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T09:37:00.000Z",
        "last_edited_time": "2025-01-16T12:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "PO/PM:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "PO/PM:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " họ quan tâm đến số: feature adoption, retention, conversion, revenue; đến tiến độ dự án; đến cách đo lường, cách kiểm chứng các hypothesis, stakeholder management,  collaboration…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " họ quan tâm đến số: feature adoption, retention, conversion, revenue; đến tiến độ dự án; đến cách đo lường, cách kiểm chứng các hypothesis, stakeholder management,  collaboration…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-801d-9e3e-c57467b3eae4",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T10:05:00.000Z",
        "last_edited_time": "2025-01-16T12:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dev: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dev: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "họ quan tâm đến độ khả thi, khả năng của công nghệ đang dùng, mức độ phức tạp của function, để ý đến các edge case, cơ chế hoạt động, performance, độ tải sever, độ tương thích, testable - maintainable - scalable…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "họ quan tâm đến độ khả thi, khả năng của công nghệ đang dùng, mức độ phức tạp của function, để ý đến các edge case, cơ chế hoạt động, performance, độ tải sever, độ tương thích, testable - maintainable - scalable…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-8060-bef6-e7896b02244f",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T10:06:00.000Z",
        "last_edited_time": "2025-01-16T12:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sale & Marketing: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sale & Marketing: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "họ quan tâm đến những benefit có thể mang lại cho user là gì, use case như thế nào, để có thể promote hoặc collaborate với đối tác,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "họ quan tâm đến những benefit có thể mang lại cho user là gì, use case như thế nào, để có thể promote hoặc collaborate với đối tác,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-801b-a066-c1cb0e44e4c7",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T14:50:00.000Z",
        "last_edited_time": "2025-01-16T12:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Operation team ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Operation team ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "thì khả năng họ sẽ muốn không có tác động tiêu cực gì đến họ, ví dụ: feature sinh thêm lỗi, tăng thêm việc cho họ, ảnh hưởng đến quy trình bên họ…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "thì khả năng họ sẽ muốn không có tác động tiêu cực gì đến họ, ví dụ: feature sinh thêm lỗi, tăng thêm việc cho họ, ảnh hưởng đến quy trình bên họ…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-80fb-bcfb-cd54468cf459",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T10:07:00.000Z",
        "last_edited_time": "2024-12-18T14:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Việc hiểu công việc các bên chắc chắn sẽ không dễ dàng gì, không những bạn tự tìm tòi nghiên cứu mà còn nên gặp mặt trò chuyện, quan sát họ thường ngày, điều này giúp bạn hợp tác hiệu quả hơn cũng như khiến design của bạn làm ra có những dự tính, mục đích & sự cân nhắc ở góc độ bao quát hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Việc hiểu công việc các bên chắc chắn sẽ không dễ dàng gì, không những bạn tự tìm tòi nghiên cứu mà còn nên gặp mặt trò chuyện, quan sát họ thường ngày, điều này giúp bạn hợp tác hiệu quả hơn cũng như khiến design của bạn làm ra có những dự tính, mục đích & sự cân nhắc ở góc độ bao quát hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8077-a907-eee98f5a2aae",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-24T13:13:00.000Z",
        "last_edited_time": "2024-12-24T13:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "video",
        "video": {
          "caption": [],
          "type": "external",
          "external": {
            "url": "https://youtu.be/VNC1U-oxB4s?si=zoIc6JQTSo0oUHcp"
          }
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-80c7-accc-d78e9ea3c239",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T10:19:00.000Z",
        "last_edited_time": "2024-12-19T02:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chẳng hạn mình có thể bắt đầu tìm hiểu thêm về: HTML/CSS, API, Data query, business model, project management, user stories, roll-out program...",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chẳng hạn mình có thể bắt đầu tìm hiểu thêm về: HTML/CSS, API, Data query, business model, project management, user stories, roll-out program...",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1625d164-78d8-807c-aff9-c916b1a25d66",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-20T10:44:00.000Z",
        "last_edited_time": "2024-12-20T10:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1625d164-78d8-804e-a29a-d829354b321a",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-20T10:44:00.000Z",
        "last_edited_time": "2024-12-20T10:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bonus",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bonus",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1625d164-78d8-8025-8092-c3a62db8af48",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-20T10:44:00.000Z",
        "last_edited_time": "2024-12-20T10:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ý này mình thấy không thể gắn vô trục được (vì sẽ hơi loạn concept) nhưng lại rất quan trọng, đó là văn hoá doanh nghiệp.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ý này mình thấy không thể gắn vô trục được (vì sẽ hơi loạn concept) nhưng lại rất quan trọng, đó là văn hoá doanh nghiệp.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-8051-9897-d09b9424b225",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2025-01-16T12:35:00.000Z",
        "last_edited_time": "2025-01-16T12:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1625d164-78d8-80f0-9d2e-cb842bae049b",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-20T10:46:00.000Z",
        "last_edited_time": "2025-01-01T00:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tưởng tượng xem, thế hệ sau đang nỗ lực phấn đấu & tiếp cận với những kiến thức mới mỗi ngày, chắc chắn kiến thức đó sẽ up to date hơn & hay hơn, các khóa học cũng sát với thực tế hơn, chưa kể đến tích luỹ kinh nghiệm cũng có nhiều đường tắt hơn với thời đại thông tin như hiện nay…>> thế hệ sau “tiến hoá” nhanh hơn mình là điều chắc chắn xảy ra & nó là tốt, có vậy ngành nghề này mới phát triển được.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tưởng tượng xem, thế hệ sau đang nỗ lực phấn đấu & tiếp cận với những kiến thức mới mỗi ngày, chắc chắn kiến thức đó sẽ up to date hơn & hay hơn, các khóa học cũng sát với thực tế hơn, chưa kể đến tích luỹ kinh nghiệm cũng có nhiều đường tắt hơn với thời đại thông tin như hiện nay…>> thế hệ sau “tiến hoá” nhanh hơn mình là điều chắc chắn xảy ra & nó là tốt, có vậy ngành nghề này mới phát triển được.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1625d164-78d8-8079-8f0b-fde6b811f980",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-20T10:51:00.000Z",
        "last_edited_time": "2025-01-01T00:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy câu hỏi đặt ra là liệu đâu là giá trị cao nhất cho một người có thâm niên lâu ở một công ty trong khi thế hệ sau có sức trẻ, nhiệt huyết, có kiến thức & skill, thậm chí tư duy tốt hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy câu hỏi đặt ra là liệu đâu là giá trị cao nhất cho một người có thâm niên lâu ở một công ty trong khi thế hệ sau có sức trẻ, nhiệt huyết, có kiến thức & skill, thậm chí tư duy tốt hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-80dc-a14c-c54b07d217ad",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2025-01-16T12:35:00.000Z",
        "last_edited_time": "2025-01-16T12:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8062-8559-e890316d7b9a",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2025-01-01T00:52:00.000Z",
        "last_edited_time": "2025-05-19T01:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Suy nghĩ một hồi về tình huống này, mình nghĩ đến khả năng am hiểu văn hoá công ty, sự khôn ngoan trong việc biết nên áp dụng kiến thức, skill nào phù hợp trong tổ chức, cách đối nhân xử thế với các stakeholder như thế nào là hợp tình hợp lý, điểm này chắc chắn bạn sẽ không học được cho đến khi phải nhúng mình vào trong môi trường đó đủ lâu, nó là câu chuyện “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Suy nghĩ một hồi về tình huống này, mình nghĩ đến khả năng am hiểu văn hoá công ty, sự khôn ngoan trong việc biết nên áp dụng kiến thức, skill nào phù hợp trong tổ chức, cách đối nhân xử thế với các stakeholder như thế nào là hợp tình hợp lý, điểm này chắc chắn bạn sẽ không học được cho đến khi phải nhúng mình vào trong môi trường đó đủ lâu, nó là câu chuyện “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "nhập gia tuỳ tục”.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "nhập gia tuỳ tục”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-8036-9a14-f2483f40d3ae",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T10:20:00.000Z",
        "last_edited_time": "2024-11-28T10:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-809f-9f0c-ffd79f19af27",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T10:20:00.000Z",
        "last_edited_time": "2024-11-28T10:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tóm lại",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tóm lại",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8095-a09f-ff5967ed439b",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-24T04:47:00.000Z",
        "last_edited_time": "2025-01-01T00:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081344/uxcomic-imgs/1665d164-78d8-8095-a09f-ff5967ed439b.png",
            "expiry_time": "2026-10-04T09:11:27.774Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1665d164-78d8-8095-a09f-ff5967ed439b"
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80a8-a83b-f521d8bd371d",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-18T14:53:00.000Z",
        "last_edited_time": "2024-12-19T02:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Non-design work chắc chắn khiến mình grow, giúp mình tạo ra nhiều impact & có value hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Non-design work chắc chắn khiến mình grow, giúp mình tạo ra nhiều impact & có value hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-8087-a12b-ddb59c1bab79",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T10:21:00.000Z",
        "last_edited_time": "2025-01-01T00:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để tìm hiểu các non-design work không hề khó. Nhìn lên, nhìn xuống, nhìn trái, nhìn phải, chú tâm quan sát, tò mò, hỏi han mình sẽ nhận ra, không bao giờ thiếu, nó là cái đáy vô tận & chân trời bao la.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để tìm hiểu các non-design work không hề khó. Nhìn lên, nhìn xuống, nhìn trái, nhìn phải, chú tâm quan sát, tò mò, hỏi han mình sẽ nhận ra, không bao giờ thiếu, nó là cái đáy vô tận & chân trời bao la.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1625d164-78d8-80a5-80a3-f66dcc9aee1b",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-20T10:59:00.000Z",
        "last_edited_time": "2025-01-01T00:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Và đừng quên câu chuyện “nhập gia tuỳ tục” cũng rất matter.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Và đừng quên câu chuyện “nhập gia tuỳ tục” cũng rất matter.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-804a-804a-e07ba100b7a9",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-10-27T08:26:00.000Z",
        "last_edited_time": "2024-10-27T08:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-815b-8f97-dd7338177ea3",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-10-27T07:26:00.000Z",
        "last_edited_time": "2024-10-27T07:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-8112-bae5-e8906d2f4bea",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-10-27T07:26:00.000Z",
        "last_edited_time": "2024-10-27T07:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://medium.com/design-bridges/hands-off-design-leadership-e1608240e169",
                "link": {
                  "url": "https://medium.com/design-bridges/hands-off-design-leadership-e1608240e169"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://medium.com/design-bridges/hands-off-design-leadership-e1608240e169",
              "href": "https://medium.com/design-bridges/hands-off-design-leadership-e1608240e169"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-8185-8a29-ced51b44498a",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-10-27T07:26:00.000Z",
        "last_edited_time": "2024-10-27T08:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.youtube.com/watch?v=0N7NBLvhhHw&t=12s",
                "link": {
                  "url": "https://www.youtube.com/watch?v=0N7NBLvhhHw&t=12s"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.youtube.com/watch?v=0N7NBLvhhHw&t=12s",
              "href": "https://www.youtube.com/watch?v=0N7NBLvhhHw&t=12s"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-804b-a117-d096bb283826",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-10-27T10:53:00.000Z",
        "last_edited_time": "2024-10-27T10:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.tannerchristensen.com/notes/the-bridge-to-head-of-design",
                "link": {
                  "url": "https://www.tannerchristensen.com/notes/the-bridge-to-head-of-design"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.tannerchristensen.com/notes/the-bridge-to-head-of-design",
              "href": "https://www.tannerchristensen.com/notes/the-bridge-to-head-of-design"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-8025-9fe1-d22886f2c09f",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-11-28T05:55:00.000Z",
        "last_edited_time": "2024-11-28T05:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.tannerchristensen.com/notes/how-to-create-a-culture-of-open-design",
                "link": {
                  "url": "https://www.tannerchristensen.com/notes/how-to-create-a-culture-of-open-design"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.tannerchristensen.com/notes/how-to-create-a-culture-of-open-design",
              "href": "https://www.tannerchristensen.com/notes/how-to-create-a-culture-of-open-design"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-80c1-840d-d225db0955fc",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-24T04:28:00.000Z",
        "last_edited_time": "2024-12-24T04:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://docs.google.com/spreadsheets/d/1m-Cso3848CgEz0eng5spL0lDppnwOgt726jJ01pVwO8/edit?gid=288553197#gid=288553197",
                "link": {
                  "url": "https://docs.google.com/spreadsheets/d/1m-Cso3848CgEz0eng5spL0lDppnwOgt726jJ01pVwO8/edit?gid=288553197#gid=288553197"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://docs.google.com/spreadsheets/d/1m-Cso3848CgEz0eng5spL0lDppnwOgt726jJ01pVwO8/edit?gid=288553197#gid=288553197",
              "href": "https://docs.google.com/spreadsheets/d/1m-Cso3848CgEz0eng5spL0lDppnwOgt726jJ01pVwO8/edit?gid=288553197#gid=288553197"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1615d164-78d8-8023-9ca4-f06f66fa3f6c",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-19T02:21:00.000Z",
        "last_edited_time": "2024-12-19T02:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1615d164-78d8-8017-a5ba-d2a402adad7c",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-19T02:21:00.000Z",
        "last_edited_time": "2024-12-19T02:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8098-bd17-d3ad7519c147",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2025-01-04T06:50:00.000Z",
        "last_edited_time": "2025-01-04T06:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1705d164-78d8-8075-923f-fbb228f43ae9"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Design Ops",
              "href": "https://app.notion.com/p/1705d16478d88075923ffbb228f43ae9"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1615d164-78d8-8099-9a8c-e2e54b55f14f",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-19T02:21:00.000Z",
        "last_edited_time": "2024-12-19T02:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1445d164-78d8-805b-b388-e24b5f13cccb"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product development process (overall)",
              "href": "https://app.notion.com/p/1445d16478d8805bb388e24b5f13cccb"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1615d164-78d8-8018-9bf0-d3823bfed73a",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2024-12-19T02:21:00.000Z",
        "last_edited_time": "2024-12-19T02:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1185d164-78d8-8014-bdf1-e631b28f601e"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "RACI (Role & Responsibility)",
              "href": "https://app.notion.com/p/1185d16478d88014bdf1e631b28f601e"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80fb-9c95-e3b6e94e49a3",
        "parent": {
          "type": "page_id",
          "page_id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
        },
        "created_time": "2025-01-04T06:50:00.000Z",
        "last_edited_time": "2025-01-04T06:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "5cd8a019-315b-418f-af5b-2fc62c943855",
    "created_time": "2024-10-25T02:18:00.000Z",
    "last_edited_time": "2024-12-11T01:32:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-10-25T02:18:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "2-Communication",
          "color": "default"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 16
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2024-12-11T01:32:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "prxX",
          "name": "⚔️:2",
          "color": "yellow"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Negotiation",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Negotiation",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Negotiation-5cd8a019315b418faf5b2fc62c943855",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Communication",
      "slug": "communication",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "12f5d164-78d8-818b-acc8-ea464f312b60",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-10-30T05:54:00.000Z",
        "last_edited_time": "2024-11-16T06:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081349/uxcomic-imgs/12f5d164-78d8-818b-acc8-ea464f312b60.png",
            "expiry_time": "2026-10-04T09:11:29.209Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/12f5d164-78d8-818b-acc8-ea464f312b60"
      },
      {
        "object": "block",
        "id": "12f5d164-78d8-8178-9014-f5de66757cac",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-10-30T05:54:00.000Z",
        "last_edited_time": "2024-11-16T08:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đàm phán là quá trình trao đổi và thỏa thuận để đạt được một giải pháp hoặc quyết định chung mà cả hai bên đều chấp nhận. Đàm phán thường diễn ra khi có lợi ích hoặc quan điểm khác biệt, và mục tiêu là ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đàm phán là quá trình trao đổi và thỏa thuận để đạt được một giải pháp hoặc quyết định chung mà cả hai bên đều chấp nhận. Đàm phán thường diễn ra khi có lợi ích hoặc quan điểm khác biệt, và mục tiêu là ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "tìm ra một thỏa hiệp hoặc sự đồng thuận giữa các bên. ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "tìm ra một thỏa hiệp hoặc sự đồng thuận giữa các bên. ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Tinh thần đúng đắn trong đàm phán là làm sao để bên kia vẫn có quyền lợi họ muốn như không phạm đến quyền lợi của mình. Tinh thần win-win.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tinh thần đúng đắn trong đàm phán là làm sao để bên kia vẫn có quyền lợi họ muốn như không phạm đến quyền lợi của mình. Tinh thần win-win.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12f5d164-78d8-81e1-b6d3-c39de9448b21",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-10-30T05:54:00.000Z",
        "last_edited_time": "2024-11-13T01:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "d85b5997-71cf-40bc-b729-3dcb33aaa6da",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-10-30T05:55:00.000Z",
        "last_edited_time": "2024-11-16T04:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hiểu về câu chuyện đàm phán",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hiểu về câu chuyện đàm phán",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80c4-91a9-fcd64f55074b",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T04:28:00.000Z",
        "last_edited_time": "2024-11-16T04:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081350/uxcomic-imgs/1405d164-78d8-80c4-91a9-fcd64f55074b.png",
            "expiry_time": "2026-10-04T09:11:29.209Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1405d164-78d8-80c4-91a9-fcd64f55074b"
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80c1-88b8-e6f238da8a22",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T04:30:00.000Z",
        "last_edited_time": "2024-11-16T06:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước hết hãy đi qua các component có trong cuộc đàm phán",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước hết hãy đi qua các component có trong cuộc đàm phán",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-801c-8872-f01e3f299231",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:15:00.000Z",
        "last_edited_time": "2024-11-16T08:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trading object(s):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trading object(s):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " 2 bên cần đàm phán với nhau chắc chắn là vì muốn trao đổi lợi ích gì đó, mình phải hiểu thứ “hàng hoá” trong cuộc trao đổi này là gì, hiểu được mục tiêu của đối phương là gì, và tại sao họ lại cần đến cuộc đàm phán này. Việc hiểu được target đối phương rất quan trọng, nó giúp bạn biết cách \"nói đúng trọng tâm\", “gãi đúng chỗ ngữa”, để set up được những chiến lược win-win phù hợp, từ đó dễ dàng thuyết phục, giải thích tại sao đề xuất của bạn mang lại lợi ích cho họ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " 2 bên cần đàm phán với nhau chắc chắn là vì muốn trao đổi lợi ích gì đó, mình phải hiểu thứ “hàng hoá” trong cuộc trao đổi này là gì, hiểu được mục tiêu của đối phương là gì, và tại sao họ lại cần đến cuộc đàm phán này. Việc hiểu được target đối phương rất quan trọng, nó giúp bạn biết cách \"nói đúng trọng tâm\", “gãi đúng chỗ ngữa”, để set up được những chiến lược win-win phù hợp, từ đó dễ dàng thuyết phục, giải thích tại sao đề xuất của bạn mang lại lợi ích cho họ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8051-9a4e-e7e9bcefa1b9",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T04:27:00.000Z",
        "last_edited_time": "2024-11-16T08:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vùng của 2 bên (range)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vùng của 2 bên (range)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": mỗi bên đều sẽ có sẵn trong đầu về mức độ lợi ích mong muốn cũng như mức cost có thể bỏ ra, 2 yếu tố được mất này sẽ hình thành nên một range. Và chắc chắn cả 2 đều sẽ muốn mình có lợi nhiều hơn mà ít cost hơn, cả 2 phía đều tồn tại một kì vọng tối thiểu (",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": mỗi bên đều sẽ có sẵn trong đầu về mức độ lợi ích mong muốn cũng như mức cost có thể bỏ ra, 2 yếu tố được mất này sẽ hình thành nên một range. Và chắc chắn cả 2 đều sẽ muốn mình có lợi nhiều hơn mà ít cost hơn, cả 2 phía đều tồn tại một kì vọng tối thiểu (",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Walk-Away Point)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Walk-Away Point)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", nếu vượt ngoài sự kì vọng này thì khả năng 1 trong 2 sẽ bỏ đi không cần đàm phán gì nữa.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", nếu vượt ngoài sự kì vọng này thì khả năng 1 trong 2 sẽ bỏ đi không cần đàm phán gì nữa.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "1405d164-78d8-80a8-a2a1-f9b6cf507ce3",
            "parent": {
              "type": "block_id",
              "block_id": "1405d164-78d8-8051-9a4e-e7e9bcefa1b9"
            },
            "created_time": "2024-11-16T06:02:00.000Z",
            "last_edited_time": "2024-11-16T06:25:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Ví dụ: khi client đề xuất một freelance job với mức phí 5-7 triệu, nhưng đó giờ bạn chỉ nhận job này với mức phí 8-10 triệu, bạn thấy bên kia có thể trả maximum cũng chỉ là 7 triệu, nó không đúng kì vọng tối thiểu của bạn nên bạn thấy không cần thương lượng gì nữa. ",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Ví dụ: khi client đề xuất một freelance job với mức phí 5-7 triệu, nhưng đó giờ bạn chỉ nhận job này với mức phí 8-10 triệu, bạn thấy bên kia có thể trả maximum cũng chỉ là 7 triệu, nó không đúng kì vọng tối thiểu của bạn nên bạn thấy không cần thương lượng gì nữa. ",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1405d164-78d8-80c0-8790-d8b2769d39d1",
            "parent": {
              "type": "block_id",
              "block_id": "1405d164-78d8-8051-9a4e-e7e9bcefa1b9"
            },
            "created_time": "2024-11-16T06:02:00.000Z",
            "last_edited_time": "2024-11-16T08:25:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Tuy nhiên range này sẽ có thể thay đổi trong quá trình đàm phán, nó liên quan đến câu chuyện 2 bên ",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Tuy nhiên range này sẽ có thể thay đổi trong quá trình đàm phán, nó liên quan đến câu chuyện 2 bên ",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": "thuyết phục như thế nào",
                    "link": {
                      "url": "/5cd8a019315b418faf5b2fc62c943855"
                    }
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "thuyết phục như thế nào",
                  "href": "/5cd8a019315b418faf5b2fc62c943855"
                },
                {
                  "type": "text",
                  "text": {
                    "content": ", ví dụ: nếu bạn có thể chứng minh cho đối phương thấy bạn có nhiều giá trị hơn và đáng giá hơn, thì đối phương có khả năng cân nhắc lại mức range ban đầu, họ có thể nới rộng khoảng cost phải bỏ ra để get được giá trị đó từ bạn.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": ", ví dụ: nếu bạn có thể chứng minh cho đối phương thấy bạn có nhiều giá trị hơn và đáng giá hơn, thì đối phương có khả năng cân nhắc lại mức range ban đầu, họ có thể nới rộng khoảng cost phải bỏ ra để get được giá trị đó từ bạn.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80b7-95cd-c14c315db259",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T04:29:00.000Z",
        "last_edited_time": "2024-11-16T08:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "BATNA",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "BATNA",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là viết tắt của Best Alternative to a Negotiated Agreemen",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là viết tắt của Best Alternative to a Negotiated Agreemen",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "t",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "t",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (Lựa chọn tốt nhất nếu không đạt được thỏa thuận). BATNA đóng vai trò như \"",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (Lựa chọn tốt nhất nếu không đạt được thỏa thuận). BATNA đóng vai trò như \"",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "kế hoạch B",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "kế hoạch B",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "\", giúp bạn có một lối thoát rõ ràng nếu thỏa thuận không thành công. Ai có trong mình nhiều “phương án dự phòng” tốt hơn thì sẽ có lợi thế hơn trong cuộc đàm phán. Ví dụ: khi bạn apply vào công ty Google, vị trí này có rất nhiều người tranh giành >> Google có nhiều quyền lựa chọn hơn bạn >> họ có BANTA mạnh hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "\", giúp bạn có một lối thoát rõ ràng nếu thỏa thuận không thành công. Ai có trong mình nhiều “phương án dự phòng” tốt hơn thì sẽ có lợi thế hơn trong cuộc đàm phán. Ví dụ: khi bạn apply vào công ty Google, vị trí này có rất nhiều người tranh giành >> Google có nhiều quyền lựa chọn hơn bạn >> họ có BANTA mạnh hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8014-b49e-c3a66d46b629",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T08:27:00.000Z",
        "last_edited_time": "2024-11-16T08:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " các component trên chính là những thông tin quan trọng mà các bên cần nắm ở phía đối phương, nhiều khi nó không rõ ràng từ ban đầu, phải cần đến một quá trình thăm dò lẫn nhau, bên nào có nhiều thông tin hơn từ đối phương sẽ nắm được lợi thế hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " các component trên chính là những thông tin quan trọng mà các bên cần nắm ở phía đối phương, nhiều khi nó không rõ ràng từ ban đầu, phải cần đến một quá trình thăm dò lẫn nhau, bên nào có nhiều thông tin hơn từ đối phương sẽ nắm được lợi thế hơn.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80de-bee5-d4dd71c9651c",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T04:24:00.000Z",
        "last_edited_time": "2024-11-16T08:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Và câu chuyện đàm phán diễn ra khi cả 2 bên đang đi tìm vùng giao thoa (ZOPA). ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Và câu chuyện đàm phán diễn ra khi cả 2 bên đang đi tìm vùng giao thoa (ZOPA). ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Vùng giao thoa là khoảng không gian mà trong đó hai bên tham gia đàm phán có thể đạt được thỏa thuận mà cả hai đều chấp nhận được, đều thấy “đáng” với cost mình để đổi lấy được giá trị từ phía đối phương. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vùng giao thoa là khoảng không gian mà trong đó hai bên tham gia đàm phán có thể đạt được thỏa thuận mà cả hai đều chấp nhận được, đều thấy “đáng” với cost mình để đổi lấy được giá trị từ phía đối phương. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "6e7f798b-2f48-49e5-a6ad-28c0e7cab4b8",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-14T05:54:00.000Z",
        "last_edited_time": "2024-11-14T06:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "8e18332b-d3fc-4b81-8a9e-745065b17546",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-14T06:09:00.000Z",
        "last_edited_time": "2024-11-14T06:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Thế” trong đàm phán",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Thế” trong đàm phán",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1485d164-78d8-80f4-900c-c51152024324",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-24T07:36:00.000Z",
        "last_edited_time": "2024-12-06T01:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "external",
          "external": {
            "url": "https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExenhwc2NoZ25ucXd6eWZrcm50OHkyNjdveDhyMWFwZm5rOXVpMHJkdiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/3orieRgQkQ6BYn5MOs/giphy.gif"
          }
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "65850601-514c-4f6b-932b-e612d95132c3",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-14T05:54:00.000Z",
        "last_edited_time": "2024-11-16T04:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong cuộc đàm phán sẽ có tồn tại “thế trên, thế dưới”. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong cuộc đàm phán sẽ có tồn tại “thế trên, thế dưới”. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13f5d164-78d8-8005-b0de-dbdd17f6116a",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-15T01:37:00.000Z",
        "last_edited_time": "2024-11-15T01:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thế trên",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thế trên",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Là khi một bên có lợi thế vượt trội so với bên kia. Điều này có thể bao gồm các nguồn lực, thông tin, quyền hạn, hoặc khả năng gây ảnh hưởng. Ví dụ, một bên có thể có \"thế\" tốt hơn nếu họ nắm được thông tin quan trọng mà bên kia không có, hoặc nếu họ có nhiều quyền lựa chọn hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Là khi một bên có lợi thế vượt trội so với bên kia. Điều này có thể bao gồm các nguồn lực, thông tin, quyền hạn, hoặc khả năng gây ảnh hưởng. Ví dụ, một bên có thể có \"thế\" tốt hơn nếu họ nắm được thông tin quan trọng mà bên kia không có, hoặc nếu họ có nhiều quyền lựa chọn hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13f5d164-78d8-8034-9569-dfb35cb3118a",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-15T01:37:00.000Z",
        "last_edited_time": "2024-11-15T01:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thế dưới",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thế dưới",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Là khi một bên gặp bất lợi hoặc có ít lựa chọn hơn trong đàm phán. Một bên có \"thế yếu\" nếu họ có ít thông tin, ít khả năng ảnh hưởng, hoặc phụ thuộc vào kết quả hơn bên còn lại.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Là khi một bên gặp bất lợi hoặc có ít lựa chọn hơn trong đàm phán. Một bên có \"thế yếu\" nếu họ có ít thông tin, ít khả năng ảnh hưởng, hoặc phụ thuộc vào kết quả hơn bên còn lại.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13f5d164-78d8-8080-8362-f657910be259",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-15T01:37:00.000Z",
        "last_edited_time": "2024-11-17T09:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tạo \"thế\" (Positioning)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tạo \"thế\" (Positioning)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Là kỹ năng tạo dựng tình huống thuận lợi cho bản thân trước khi bước vào đàm phán. Điều này có thể bao gồm việc chuẩn bị tốt hơn, xác định rõ mục tiêu, dự đoán các chiến lược của bên đối phương, và tìm cách phát huy các lợi thế riêng. Một ví dụ thực tế là trước các cuộc phỏng vấn tại sao luôn có phone interview, vì ở bước này phía công ty sẽ có thêm nhiều thông tin ở phía bạn, giúp ích rất nhiều cho quá trình đàm phán sau đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Là kỹ năng tạo dựng tình huống thuận lợi cho bản thân trước khi bước vào đàm phán. Điều này có thể bao gồm việc chuẩn bị tốt hơn, xác định rõ mục tiêu, dự đoán các chiến lược của bên đối phương, và tìm cách phát huy các lợi thế riêng. Một ví dụ thực tế là trước các cuộc phỏng vấn tại sao luôn có phone interview, vì ở bước này phía công ty sẽ có thêm nhiều thông tin ở phía bạn, giúp ích rất nhiều cho quá trình đàm phán sau đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13f5d164-78d8-80a4-ab8a-dc6c2751e09c",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-15T01:37:00.000Z",
        "last_edited_time": "2024-11-16T04:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Điều chỉnh thế",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Điều chỉnh thế",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Khi đàm phán tiến triển, các yếu tố \"thế\" có thể thay đổi dựa trên cách các bên phản ứng, điều chỉnh thông tin, hoặc thay đổi chiến lược. Người đàm phán giỏi là người biết cách linh hoạt điều chỉnh thế của mình, đôi khi bằng cách giảm kỳ vọng của đối phương hoặc làm nổi bật các lợi ích chung.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Khi đàm phán tiến triển, các yếu tố \"thế\" có thể thay đổi dựa trên cách các bên phản ứng, điều chỉnh thông tin, hoặc thay đổi chiến lược. Người đàm phán giỏi là người biết cách linh hoạt điều chỉnh thế của mình, đôi khi bằng cách giảm kỳ vọng của đối phương hoặc làm nổi bật các lợi ích chung.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8085-a154-f6f55965a548",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T08:34:00.000Z",
        "last_edited_time": "2024-11-17T09:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Biết người biết ta, trăm trận không nguy;\nKhông biết người mà chỉ biết ta, một trận thắng một trận thua;\nKhông biết người, không biết ta, mọi trận đều bại”\n",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Biết người biết ta, trăm trận không nguy;\nKhông biết người mà chỉ biết ta, một trận thắng một trận thua;\nKhông biết người, không biết ta, mọi trận đều bại”\n",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Tôn Tử",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tôn Tử",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80ec-b489-f99f2666d792",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:43:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80e4-a9d5-ec61d0fd0266",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T04:45:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ thực tế",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ thực tế",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8032-8609-f764a31ac3b6",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T05:50:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong ngữ cảnh, một hôm PO yêu cầu designer cần làm một tính năng ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong ngữ cảnh, một hôm PO yêu cầu designer cần làm một tính năng ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cuốn hút như ví dụ A",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cuốn hút như ví dụ A",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " và phải hoàn thành trong ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " và phải hoàn thành trong ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "1 tuần. ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "1 tuần. ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Tuy nhiên",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuy nhiên",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " d",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " d",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "esigner phản hồi là tính năng này cần ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "esigner phản hồi là tính năng này cần ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "3 tuần",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3 tuần",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " để đảm bảo chất lượng và đáp ứng tính thẩm mỹ như yêu cầu.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " để đảm bảo chất lượng và đáp ứng tính thẩm mỹ như yêu cầu.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80df-bb1e-c36152ad9533",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:45:00.000Z",
        "last_edited_time": "2024-11-16T07:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-801b-9c1e-f2a51fc89480",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T05:50:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "1. Xác định các yếu tố trong đàm phán",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "1. Xác định các yếu tố trong đàm phán",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8087-9725-e243c1b1b87a",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T05:50:00.000Z",
        "last_edited_time": "2024-12-06T14:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phạm vi (Range)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phạm vi (Range)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ":",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ":",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1545d164-78d8-8076-9e28-f9cac0f9dfbd",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-12-06T14:47:00.000Z",
        "last_edited_time": "2024-12-06T14:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "PO",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "PO",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ":",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ":",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "1405d164-78d8-8011-9da6-c22b7bf7807b",
            "parent": {
              "type": "block_id",
              "block_id": "1545d164-78d8-8076-9e28-f9cac0f9dfbd"
            },
            "created_time": "2024-11-16T05:50:00.000Z",
            "last_edited_time": "2024-12-06T14:47:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Mục tiêu: Tính năng được hoàn thành sớm nhất để kịp lộ trình phát hành sản phẩm.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Mục tiêu: Tính năng được hoàn thành sớm nhất để kịp lộ trình phát hành sản phẩm.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1405d164-78d8-80e9-91b3-cf93cae16ef3",
            "parent": {
              "type": "block_id",
              "block_id": "1545d164-78d8-8076-9e28-f9cac0f9dfbd"
            },
            "created_time": "2024-11-16T05:50:00.000Z",
            "last_edited_time": "2024-12-06T14:47:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Yêu cầu chất lượng: Đủ thu hút để đáp ứng mong đợi của người dùng.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Yêu cầu chất lượng: Đủ thu hút để đáp ứng mong đợi của người dùng.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1405d164-78d8-8026-87d3-c15c291c9bb8",
            "parent": {
              "type": "block_id",
              "block_id": "1545d164-78d8-8076-9e28-f9cac0f9dfbd"
            },
            "created_time": "2024-11-16T05:50:00.000Z",
            "last_edited_time": "2024-12-06T14:47:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Ưu tiên: Thời gian ngắn, nhưng vẫn đảm bảo tính năng có sức hút.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Ưu tiên: Thời gian ngắn, nhưng vẫn đảm bảo tính năng có sức hút.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1405d164-78d8-803a-b16a-fc0c414583a3",
            "parent": {
              "type": "block_id",
              "block_id": "1545d164-78d8-8076-9e28-f9cac0f9dfbd"
            },
            "created_time": "2024-11-16T05:50:00.000Z",
            "last_edited_time": "2024-12-06T14:47:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": true,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Designer",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Designer",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": ":",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": ":",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8063-9140-f91c24cf1301",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T05:50:00.000Z",
        "last_edited_time": "2024-12-06T14:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Walk-away point",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Walk-away point",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (Điểm không chấp nhận được):",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (Điểm không chấp nhận được):",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1545d164-78d8-80a3-aac2-d2c3c8911893",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-12-06T14:47:00.000Z",
        "last_edited_time": "2024-12-06T14:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "PO",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "PO",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Nếu mất hơn 2 tuần, tính năng có thể không còn kịp thời để đưa vào lộ trình hiện tại.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Nếu mất hơn 2 tuần, tính năng có thể không còn kịp thời để đưa vào lộ trình hiện tại.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1545d164-78d8-8063-89e6-ee7bb085033d",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-12-06T14:47:00.000Z",
        "last_edited_time": "2024-12-06T14:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Designer",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Designer",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Nếu chỉ có 1 tuần, tính năng sẽ không đạt yêu cầu chất lượng và có thể làm ảnh hưởng đến uy tín sản phẩm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Nếu chỉ có 1 tuần, tính năng sẽ không đạt yêu cầu chất lượng và có thể làm ảnh hưởng đến uy tín sản phẩm.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8085-a6ad-e3dffccea4d0",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T05:50:00.000Z",
        "last_edited_time": "2024-12-06T14:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "BATNA (Best Alternative to a Negotiated Agreement)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "BATNA (Best Alternative to a Negotiated Agreement)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ":",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ":",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1545d164-78d8-8072-99ef-dddbbb38ef2b",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-12-06T14:47:00.000Z",
        "last_edited_time": "2024-12-06T14:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "PO",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "PO",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Đơn giản hóa yêu cầu, ví dụ chỉ cần làm phần cơ bản của tính năng (MVP).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Đơn giản hóa yêu cầu, ví dụ chỉ cần làm phần cơ bản của tính năng (MVP).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1545d164-78d8-807d-b87f-c621e80a9f17",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-12-06T14:48:00.000Z",
        "last_edited_time": "2024-12-06T14:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Designer",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Designer",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Yêu cầu thêm thời gian hoặc giảm phạm vi công việc, ưu tiên các yếu tố tối cần thiết trước.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Yêu cầu thêm thời gian hoặc giảm phạm vi công việc, ưu tiên các yếu tố tối cần thiết trước.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-809a-b1c6-c04fa9689883",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T05:50:00.000Z",
        "last_edited_time": "2024-12-06T14:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "ZOPA (Zone of Possible Agreement)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "ZOPA (Zone of Possible Agreement)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": ZOPA nằm ở khoảng thời gian giữa ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": ZOPA nằm ở khoảng thời gian giữa ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "1 tuần",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "1 tuần",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " và ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " và ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "3 tuần",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3 tuần",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", với sự thỏa hiệp giữa chất lượng và thời gian.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", với sự thỏa hiệp giữa chất lượng và thời gian.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80af-9b86-e0c0c5281e83",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:45:00.000Z",
        "last_edited_time": "2024-11-16T07:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8098-ac9d-d9b198b12876",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T05:50:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "2. Tiến trình đàm phán",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2. Tiến trình đàm phán",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80ef-b895-c074cd39496d",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T05:50:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bước 1: Lắng nghe và làm rõ yêu cầu",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bước 1: Lắng nghe và làm rõ yêu cầu",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80ca-a46c-e13b9cb9fe7f",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:22:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Designer hỏi PO:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Designer hỏi PO:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80af-801b-f67700ac93c3",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:22:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "\"Ví dụ A mà anh/chị nhắc đến, điều gì là quan trọng nhất? Là tính năng chính, yếu tố cuốn hút hay tốc độ phát hành?\"",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "\"Ví dụ A mà anh/chị nhắc đến, điều gì là quan trọng nhất? Là tính năng chính, yếu tố cuốn hút hay tốc độ phát hành?\"",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80e0-9893-c70401b9a299",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:22:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "\"Nếu không kịp làm trong 1 tuần, điều gì sẽ xảy ra?\"",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "\"Nếu không kịp làm trong 1 tuần, điều gì sẽ xảy ra?\"",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-800e-9be4-f8dc6c43009c",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:22:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mục tiêu",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mục tiêu",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ":",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ":",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8033-8225-c61de5746b00",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:22:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hiểu rõ ưu tiên thực sự của PO (chẳng hạn, liệu yếu tố thẩm mỹ có thực sự quan trọng hơn thời gian không?).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hiểu rõ ưu tiên thực sự của PO (chẳng hạn, liệu yếu tố thẩm mỹ có thực sự quan trọng hơn thời gian không?).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8099-860d-d3582d3ed204",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:22:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Làm rõ phạm vi công việc (liệu có thể đơn giản hóa không?).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Làm rõ phạm vi công việc (liệu có thể đơn giản hóa không?).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-807c-9e5f-f20472658895",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:23:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80e3-944c-d50c036d702b",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T05:50:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bước 2: Đề xuất giải pháp với phạm vi linh hoạt",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bước 2: Đề xuất giải pháp với phạm vi linh hoạt",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80ab-8442-d3414c188565",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:21:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Designer trình bày: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Designer trình bày: ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80db-90e8-c5cdbdf2b8db",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:23:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "\"Để đạt chất lượng như Ví dụ A, chúng ta cần 3 tuần. Tuy nhiên, nếu tập trung vào phần quan trọng nhất (MVP), tôi có thể hoàn thành trong 2 tuần với một số chi tiết được tối giản.\"",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "\"Để đạt chất lượng như Ví dụ A, chúng ta cần 3 tuần. Tuy nhiên, nếu tập trung vào phần quan trọng nhất (MVP), tôi có thể hoàn thành trong 2 tuần với một số chi tiết được tối giản.\"",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8062-bb62-e834ea80fb7a",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T05:50:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "PO đáp lại: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "PO đáp lại: ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-802a-bea0-fc8805462b93",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:23:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "\"Chúng tôi chỉ có 1 tuần. Có cách nào làm xong cơ bản trong 1 tuần, sau đó tinh chỉnh thêm không?\"",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "\"Chúng tôi chỉ có 1 tuần. Có cách nào làm xong cơ bản trong 1 tuần, sau đó tinh chỉnh thêm không?\"",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80c4-af8b-f05eef180239",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:23:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80c5-8bb6-c4aa62b521ba",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T05:50:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bước 3: Đàm phán ZOPA",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bước 3: Đàm phán ZOPA",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-808c-a365-d189fae9f7e3",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:21:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hai bên cùng xem xét",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hai bên cùng xem xét",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80cb-9b0a-cc1f5dccf26e",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:24:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "PO: \"Nếu chúng ta có một bản demo đủ dùng trong 1 tuần, tôi có thể cho thêm 1 tuần nữa để cải thiện.\"",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "PO: \"Nếu chúng ta có một bản demo đủ dùng trong 1 tuần, tôi có thể cho thêm 1 tuần nữa để cải thiện.\"",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80cf-9bde-c2f4274e0722",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T05:50:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Designer: \"Tôi sẽ cố gắng hoàn thiện phiên bản demo trong 1 tuần, nhưng cần thêm 1-2 tuần để tối ưu hóa.\"",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Designer: \"Tôi sẽ cố gắng hoàn thiện phiên bản demo trong 1 tuần, nhưng cần thêm 1-2 tuần để tối ưu hóa.\"",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80ec-9486-f233ba5c5817",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:24:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-803e-8095-fb11465574ce",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T05:50:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bước 4: Thỏa thuận cuối cùng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bước 4: Thỏa thuận cuối cùng",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80d7-bb5f-f01c78fd6095",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:25:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuần 1: Hoàn thành bản MVP (giao diện cơ bản và chức năng chính).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuần 1: Hoàn thành bản MVP (giao diện cơ bản và chức năng chính).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8052-ad31-e14e5f711916",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:25:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuần 2: Cải thiện tính thẩm mỹ và tinh chỉnh.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuần 2: Cải thiện tính thẩm mỹ và tinh chỉnh.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8000-946f-ed91715d9b3f",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:25:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuần 3 (nếu cần): Tối ưu và kiểm tra toàn diện.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuần 3 (nếu cần): Tối ưu và kiểm tra toàn diện.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80e6-9a8a-e6aa5c7de009",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:45:00.000Z",
        "last_edited_time": "2024-11-16T07:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8086-b06c-d83b5cc1b891",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:43:00.000Z",
        "last_edited_time": "2024-11-16T07:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "3. Kết quả của cuộc đàm phán",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3. Kết quả của cuộc đàm phán",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80d1-acb5-e515730747d8",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T05:50:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "ZOPA đạt được",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "ZOPA đạt được",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": 2 tuần (MVP trong tuần 1, cải thiện trong tuần 2).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": 2 tuần (MVP trong tuần 1, cải thiện trong tuần 2).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80fc-92b1-ff881dad27a5",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T05:50:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "BATNA của PO và Designer",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "BATNA của PO và Designer",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Không cần dùng vì hai bên tìm được vùng giao thoa.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Không cần dùng vì hai bên tìm được vùng giao thoa.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80d8-a210-f603622b85f5",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T05:50:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bài học",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bài học",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Đàm phán thành công khi cả hai bên hiểu rõ ưu tiên của nhau và sẵn sàng linh hoạt để đạt được mục tiêu chung.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Đàm phán thành công khi cả hai bên hiểu rõ ưu tiên của nhau và sẵn sàng linh hoạt để đạt được mục tiêu chung.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80a6-aaf1-c45b4ce64394",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:43:00.000Z",
        "last_edited_time": "2024-11-16T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "06c4fc3a-4a60-4ce7-a885-79d73a1fe9e3",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-13T01:40:00.000Z",
        "last_edited_time": "2024-11-13T06:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "9968088e-17a9-4351-a17c-74abddd035e9",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-13T01:40:00.000Z",
        "last_edited_time": "2024-11-16T07:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vài chiến thuật trong đàm phán",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vài chiến thuật trong đàm phán",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80f2-918f-e987d3f70e64",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-17T09:29:00.000Z",
        "last_edited_time": "2024-11-17T09:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Càng nhiều thông tin càng có lợi thế",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Càng nhiều thông tin càng có lợi thế",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "9d0c9a24-559f-4ba0-ac8a-ec98c5c6afb6",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-13T05:46:00.000Z",
        "last_edited_time": "2024-12-11T01:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đặt ra đề nghị đầu tiên (First offer)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đặt ra đề nghị đầu tiên (First offer)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " thường giúp tạo ra một “neo” trong suy nghĩ của đối phương, từ đó tác động đến những đề xuất tiếp theo. Đây là một chiến lược đàm phán mạnh mẽ vì điểm neo ban đầu có thể ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " thường giúp tạo ra một “neo” trong suy nghĩ của đối phương, từ đó tác động đến những đề xuất tiếp theo. Đây là một chiến lược đàm phán mạnh mẽ vì điểm neo ban đầu có thể ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "định hình kỳ vọng và giới hạn của các bên.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "định hình kỳ vọng và giới hạn của các bên.",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Khi bạn là người đưa ra đề nghị đầu tiên, bạn có thể định hướng tâm lý cho đối phương, làm cho họ dễ dàng chấp nhận các giới hạn hoặc điều kiện của bạn hơn. Lấy ví dụ ở trên, bạn thấy PO đề xuất trước “1 tuần”, thì cuộc thảo luận sẽ xoay quanh con số đó trước. \nLưu ý: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Khi bạn là người đưa ra đề nghị đầu tiên, bạn có thể định hướng tâm lý cho đối phương, làm cho họ dễ dàng chấp nhận các giới hạn hoặc điều kiện của bạn hơn. Lấy ví dụ ở trên, bạn thấy PO đề xuất trước “1 tuần”, thì cuộc thảo luận sẽ xoay quanh con số đó trước. \nLưu ý: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "offer nên là con số cụ thể thay vì là range",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "offer nên là con số cụ thể thay vì là range",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", vì vô tình nếu bạn đưa ra range họ sẽ chọn mức phù hợp với họ, có khi lại không có lợi cho bạn. Ví dụ: nếu khi đàm phán lương nếu đưa ra range $500-800, thì tại sao đối phương lại không start với $500 phải không nào. Và first offer có thể ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", vì vô tình nếu bạn đưa ra range họ sẽ chọn mức phù hợp với họ, có khi lại không có lợi cho bạn. Ví dụ: nếu khi đàm phán lương nếu đưa ra range $500-800, thì tại sao đối phương lại không start với $500 phải không nào. Và first offer có thể ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "phản tác dụng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "phản tác dụng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " nếu bạn nắm được đủ thông tin nên hãy cực kỳ cân nhắc khi bạn chưa sure về context (vd: giá trị thị trường, kỳ vọng của đối phương, và lợi thế của bạn), ví dụ nếu trong phỏng vấn tìm việc, việc bạn bày tỏ mức lương quá thấp hoặc quá cao sẽ đem lại bất lợi cho bạn. (",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " nếu bạn nắm được đủ thông tin nên hãy cực kỳ cân nhắc khi bạn chưa sure về context (vd: giá trị thị trường, kỳ vọng của đối phương, và lợi thế của bạn), ví dụ nếu trong phỏng vấn tìm việc, việc bạn bày tỏ mức lương quá thấp hoặc quá cao sẽ đem lại bất lợi cho bạn. (",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "https://www.instagram.com/reel/DDYKVrLylKN/?igsh=MWM2bDU1dXRldnJkag==",
                "link": {
                  "url": "https://www.instagram.com/reel/DDYKVrLylKN/?igsh=MWM2bDU1dXRldnJkag%3D%3D"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.instagram.com/reel/DDYKVrLylKN/?igsh=MWM2bDU1dXRldnJkag==",
              "href": "https://www.instagram.com/reel/DDYKVrLylKN/?igsh=MWM2bDU1dXRldnJkag%3D%3D"
            },
            {
              "type": "text",
              "text": {
                "content": ")",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ")",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "d91f2253-7506-44e5-bac2-81a225ce01e8",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-14T05:51:00.000Z",
        "last_edited_time": "2024-11-15T01:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Make counter-offers",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Make counter-offers",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ". Hãy đưa ra các đề nghị đối ứng. Các bên sẽ cảm thấy hài lòng hơn nếu có một chút trao đổi qua lại trong quá trình thương lượng (đây là hiệu ứng tâm lý Endowment Effect). Ví dụ: nếu bạn chấp nhận đề nghị mở đầu của họ, chẳng hạn, họ có thể bắt đầu nghi ngờ hoặc cảm thấy rằng lẽ ra họ nên đưa ra đề nghị cao hơn. Nên ngay cả khi bạn hài lòng với một đề nghị sớm, đừng ngại đưa ra đề nghị đối ứng để giao dịch có cảm giác như một cuộc thương lượng thành công.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". Hãy đưa ra các đề nghị đối ứng. Các bên sẽ cảm thấy hài lòng hơn nếu có một chút trao đổi qua lại trong quá trình thương lượng (đây là hiệu ứng tâm lý Endowment Effect). Ví dụ: nếu bạn chấp nhận đề nghị mở đầu của họ, chẳng hạn, họ có thể bắt đầu nghi ngờ hoặc cảm thấy rằng lẽ ra họ nên đưa ra đề nghị cao hơn. Nên ngay cả khi bạn hài lòng với một đề nghị sớm, đừng ngại đưa ra đề nghị đối ứng để giao dịch có cảm giác như một cuộc thương lượng thành công.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "a55d9d27-a7d2-4f42-9b40-afcbb390bb3a",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-13T05:44:00.000Z",
        "last_edited_time": "2024-11-16T07:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lắng nghe chủ động (",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lắng nghe chủ động (",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Active Listening",
                "link": {
                  "url": "/1405d16478d8801ab019e709965fbf48"
                }
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Active Listening",
              "href": "/1405d16478d8801ab019e709965fbf48"
            },
            {
              "type": "text",
              "text": {
                "content": ")",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ")",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Kỹ năng lắng nghe là chìa khóa để hiểu rõ quan điểm và nhu cầu của đối phương. Ngoài việc lắng nghe thuần tuý, mình còn kết hợp với quan sát ngôn ngữ cơ thể và giọng điệu, điều này giúp bạn nắm bắt những thông tin ẩn ý, tâm lý đối phương để có thể phản hồi hiệu quả.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Kỹ năng lắng nghe là chìa khóa để hiểu rõ quan điểm và nhu cầu của đối phương. Ngoài việc lắng nghe thuần tuý, mình còn kết hợp với quan sát ngôn ngữ cơ thể và giọng điệu, điều này giúp bạn nắm bắt những thông tin ẩn ý, tâm lý đối phương để có thể phản hồi hiệu quả.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 3
      },
      {
        "object": "block",
        "id": "4dbae941-b46f-4352-b62a-b6a6d8de81d8",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-13T05:44:00.000Z",
        "last_edited_time": "2024-12-11T01:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đặt câu hỏi thông minh (",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đặt câu hỏi thông minh (",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Strategic Questioning",
                "link": {
                  "url": "/95727332bdb34f63a0cdf9023732995d"
                }
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Strategic Questioning",
              "href": "/95727332bdb34f63a0cdf9023732995d"
            },
            {
              "type": "text",
              "text": {
                "content": ")",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ")",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": vài giá trị trong việc đặt câu hỏi",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": vài giá trị trong việc đặt câu hỏi",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 4,
        "children": [
          {
            "object": "block",
            "id": "1405d164-78d8-8058-8a39-d683c99956be",
            "parent": {
              "type": "block_id",
              "block_id": "4dbae941-b46f-4352-b62a-b6a6d8de81d8"
            },
            "created_time": "2024-11-16T07:38:00.000Z",
            "last_edited_time": "2024-11-16T08:08:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Giúp bạn khai thác được thông tin quan trọng, thăm dò đối phương tốt hơn, chẳng hạn như hiểu thêm về mục tiêu của họ, cách họ đánh giá sự ưu tiên và range cân nhắc của họ là gì. ",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Giúp bạn khai thác được thông tin quan trọng, thăm dò đối phương tốt hơn, chẳng hạn như hiểu thêm về mục tiêu của họ, cách họ đánh giá sự ưu tiên và range cân nhắc của họ là gì. ",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1405d164-78d8-8013-92e9-ec5e3440066c",
            "parent": {
              "type": "block_id",
              "block_id": "4dbae941-b46f-4352-b62a-b6a6d8de81d8"
            },
            "created_time": "2024-11-16T07:38:00.000Z",
            "last_edited_time": "2024-11-16T07:39:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Đóng vai trò ",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Đóng vai trò ",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": "định hướng ",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "định hướng ",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": "cuộc đàm phán, hãy dùng \"calibrated questions\" (dạng câu hỏi định hướng như \"what\" và \"how\") để khiến đối phương suy nghĩ kỹ và dễ đi vào giải pháp thay vì tranh cãi. Điều này giúp duy trì sự kiểm soát mà vẫn tôn trọng ý kiến của người đối diện.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "cuộc đàm phán, hãy dùng \"calibrated questions\" (dạng câu hỏi định hướng như \"what\" và \"how\") để khiến đối phương suy nghĩ kỹ và dễ đi vào giải pháp thay vì tranh cãi. Điều này giúp duy trì sự kiểm soát mà vẫn tôn trọng ý kiến của người đối diện.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1405d164-78d8-80ea-94bb-eab73f2971f8",
            "parent": {
              "type": "block_id",
              "block_id": "4dbae941-b46f-4352-b62a-b6a6d8de81d8"
            },
            "created_time": "2024-11-16T07:38:00.000Z",
            "last_edited_time": "2024-11-16T07:40:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Giúp cuộc thảo luận được chậm lại, vì khi đặt câu hỏi, sẽ có thêm thời gian để cả 2 phải suy nghĩ để đưa ra câu trả lời.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Giúp cuộc thảo luận được chậm lại, vì khi đặt câu hỏi, sẽ có thêm thời gian để cả 2 phải suy nghĩ để đưa ra câu trả lời.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1595d164-78d8-80d7-aab5-f26521fbc293",
            "parent": {
              "type": "block_id",
              "block_id": "4dbae941-b46f-4352-b62a-b6a6d8de81d8"
            },
            "created_time": "2024-12-11T01:31:00.000Z",
            "last_edited_time": "2024-12-11T01:32:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Đặt câu hỏi cũng là cách giúp ta sáng tạo ra điểm giao thoa, tìm ra một phương án mà tốt cho cả 2 bên.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Đặt câu hỏi cũng là cách giúp ta sáng tạo ra điểm giao thoa, tìm ra một phương án mà tốt cho cả 2 bên.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "c61f28d6-2ccd-436e-9e2d-8c3f8ca62087",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-13T05:44:00.000Z",
        "last_edited_time": "2024-11-16T09:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khoảng lặng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khoảng lặng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": khoảng lặng trong mọi cuộc hội thoại đều rất quan trọng và cần thiết, nó giúp đôi bên có thêm thời gian để sắp xếp lại các thông tin và suy nghĩ về cách phản hồi phù hợp. Riêng trong đàm phán khoảng lặng rất giá trị, việc bạn không gấp gáp trình bày hay phản hồi phần nào đó khiến đối phương thấy được sự tự tin & quyết đoán của bạn, vô tình tạo nên một áp lực tâm lý tích cực.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": khoảng lặng trong mọi cuộc hội thoại đều rất quan trọng và cần thiết, nó giúp đôi bên có thêm thời gian để sắp xếp lại các thông tin và suy nghĩ về cách phản hồi phù hợp. Riêng trong đàm phán khoảng lặng rất giá trị, việc bạn không gấp gáp trình bày hay phản hồi phần nào đó khiến đối phương thấy được sự tự tin & quyết đoán của bạn, vô tình tạo nên một áp lực tâm lý tích cực.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 5
      },
      {
        "object": "block",
        "id": "1485d164-78d8-80f0-85b0-d8d888a3cf0c",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-24T07:41:00.000Z",
        "last_edited_time": "2024-11-24T07:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thời gian:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thời gian:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Càng ít thời gian để đàm phán, các bên càng có xu hướng đưa ra quyết định vội vàng, dẫn đến kết quả kém tối ưu. Bên nào ít bị áp lực thời gian hơn sẽ có lợi thế lớn hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Càng ít thời gian để đàm phán, các bên càng có xu hướng đưa ra quyết định vội vàng, dẫn đến kết quả kém tối ưu. Bên nào ít bị áp lực thời gian hơn sẽ có lợi thế lớn hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 6
      },
      {
        "object": "block",
        "id": "12f5d164-78d8-8176-b0c2-ec98b8d62ff1",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-10-30T05:54:00.000Z",
        "last_edited_time": "2024-10-30T05:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "12f5d164-78d8-81a3-b19d-d05b77785e47",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-10-30T05:54:00.000Z",
        "last_edited_time": "2024-10-30T05:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12f5d164-78d8-81a1-adf3-c71fca932b14",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-10-30T05:54:00.000Z",
        "last_edited_time": "2024-11-14T05:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.masterclass.com/articles/negotiating-tips-from-former-fbi-hostage-negotiator-chris-voss",
                "link": {
                  "url": "https://www.masterclass.com/articles/negotiating-tips-from-former-fbi-hostage-negotiator-chris-voss"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.masterclass.com/articles/negotiating-tips-from-former-fbi-hostage-negotiator-chris-voss",
              "href": "https://www.masterclass.com/articles/negotiating-tips-from-former-fbi-hostage-negotiator-chris-voss"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "a57af8bd-d162-4a0b-a2ab-b976f5f2c204",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-14T05:57:00.000Z",
        "last_edited_time": "2024-11-14T05:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.masterclass.com/articles/tips-for-negotiating-better",
                "link": {
                  "url": "https://www.masterclass.com/articles/tips-for-negotiating-better"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.masterclass.com/articles/tips-for-negotiating-better",
              "href": "https://www.masterclass.com/articles/tips-for-negotiating-better"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-805c-80a8-f9cc42f03938",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T06:07:00.000Z",
        "last_edited_time": "2024-11-16T06:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://hbr.org/2024/03/negotiate-like-a-pro",
                "link": {
                  "url": "https://hbr.org/2024/03/negotiate-like-a-pro"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://hbr.org/2024/03/negotiate-like-a-pro",
              "href": "https://hbr.org/2024/03/negotiate-like-a-pro"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12f5d164-78d8-8161-9844-efb1e39f5551",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-10-30T05:54:00.000Z",
        "last_edited_time": "2024-10-30T05:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "12f5d164-78d8-8112-b720-d922ab918366",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-10-30T05:54:00.000Z",
        "last_edited_time": "2024-10-30T05:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12f5d164-78d8-8135-a2fe-cd023a9085e2",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-10-30T05:54:00.000Z",
        "last_edited_time": "2024-11-14T16:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "95727332-bdb3-4f63-a0cd-f9023732995d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Questioning (P1)",
              "href": "https://app.notion.com/p/95727332bdb34f63a0cdf9023732995d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80ae-bab5-d37c55d52c0d",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-11-16T07:50:00.000Z",
        "last_edited_time": "2024-11-16T07:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1405d164-78d8-801a-b019-e709965fbf48"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Listening",
              "href": "https://app.notion.com/p/1405d16478d8801ab019e709965fbf48"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12f5d164-78d8-8139-a671-fed9acd35394",
        "parent": {
          "type": "page_id",
          "page_id": "5cd8a019-315b-418f-af5b-2fc62c943855"
        },
        "created_time": "2024-10-30T05:54:00.000Z",
        "last_edited_time": "2024-11-14T16:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1215d164-78d8-809d-89b0-e84bbf170b05"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Persuade",
              "href": "https://app.notion.com/p/1215d16478d8809d89b0e84bbf170b05"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1215d164-78d8-809d-89b0-e84bbf170b05",
    "created_time": "2024-10-16T03:13:00.000Z",
    "last_edited_time": "2025-07-10T05:50:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-10-16T03:13:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "2-Communication",
          "color": "default"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 14
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-07-10T05:50:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "prxX",
          "name": "⚔️:2",
          "color": "yellow"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Persuade",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Persuade",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Persuade-1215d16478d8809d89b0e84bbf170b05",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
      "name": "Communication",
      "slug": "communication",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "1215d164-78d8-81c6-9936-f4c900482aa3",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-10-16T03:13:00.000Z",
        "last_edited_time": "2024-11-16T06:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081355/uxcomic-imgs/1215d164-78d8-81c6-9936-f4c900482aa3.png",
            "expiry_time": "2026-10-04T09:11:30.475Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1215d164-78d8-81c6-9936-f4c900482aa3"
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80c0-8382-fcbc6fdd0b41",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-12-22T08:45:00.000Z",
        "last_edited_time": "2024-12-23T00:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đã bao giờ bạn thấy bí bí trong lúc cố gắng thuyết phục ai đó về idea của bạn, hoặc ngược lại có khi ai đó thuyết phục bạn có khi mình đồng ý ngay, có khi lại chẳng thèm nghe. Vậy thuyết phục hoạt động ra sao?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đã bao giờ bạn thấy bí bí trong lúc cố gắng thuyết phục ai đó về idea của bạn, hoặc ngược lại có khi ai đó thuyết phục bạn có khi mình đồng ý ngay, có khi lại chẳng thèm nghe. Vậy thuyết phục hoạt động ra sao?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8054-b97b-db584226f8c1",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-12-22T08:45:00.000Z",
        "last_edited_time": "2024-12-22T08:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80a3-80ba-e4e566fcba8d",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-12-22T08:40:00.000Z",
        "last_edited_time": "2024-12-22T08:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Định nghĩa",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Định nghĩa",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "ed7a5f20-cc7e-4f79-83d0-88cf212e6e06",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-11-12T16:01:00.000Z",
        "last_edited_time": "2025-01-16T05:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thuyết phục là quá trình trình bày lập luận để người khác thay đổi suy nghĩ, quan điểm, hoặc hành động theo ý muốn của mình. Thuyết phục thường không yêu cầu sự thỏa hiệp mà thay vào đó ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thuyết phục là quá trình trình bày lập luận để người khác thay đổi suy nghĩ, quan điểm, hoặc hành động theo ý muốn của mình. Thuyết phục thường không yêu cầu sự thỏa hiệp mà thay vào đó ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "tập trung vào việc tạo ảnh hưởng, khiến đối phương đồng ý với quan điểm của mình.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "tập trung vào việc tạo ảnh hưởng, khiến đối phương đồng ý với quan điểm của mình.",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (thuyết + phục)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (thuyết + phục)",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1c95d164-78d8-804c-a6c5-d0af513f5894",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2025-04-02T06:33:00.000Z",
        "last_edited_time": "2025-04-02T06:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-800d-9406-d5469d5c2ca4",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2025-01-16T06:00:00.000Z",
        "last_edited_time": "2025-04-02T06:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "3 level tác động (từ sách Show & Tell)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3 level tác động (từ sách Show & Tell)",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1c95d164-78d8-806d-8d19-cb18df980a00",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2025-04-02T06:32:00.000Z",
        "last_edited_time": "2025-04-02T06:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Data (thông tin)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Data (thông tin)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1c95d164-78d8-808e-88b1-cccb7ace0341",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2025-04-02T06:33:00.000Z",
        "last_edited_time": "2025-04-02T06:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Suy nghĩ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Suy nghĩ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1c95d164-78d8-80aa-99a7-e45eb93a9456",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2025-04-02T06:33:00.000Z",
        "last_edited_time": "2025-04-02T06:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Niềm tin",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Niềm tin",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "1c95d164-78d8-80e9-9b01-e8ad1fe17065",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2025-04-02T06:33:00.000Z",
        "last_edited_time": "2025-04-02T06:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Càng lên cao càng khó ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Càng lên cao càng khó ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1c95d164-78d8-805a-840c-f10c92f34031",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2025-04-02T06:33:00.000Z",
        "last_edited_time": "2025-04-02T06:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1c95d164-78d8-8023-8f33-c7907f7e156e",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2025-04-02T06:33:00.000Z",
        "last_edited_time": "2025-04-02T06:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "3 yếu tố hình thành nên việc nghe có “thuyết phục “ hay không",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3 yếu tố hình thành nên việc nghe có “thuyết phục “ hay không",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-80fc-9cf0-f25e1d180a66",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2025-01-16T05:59:00.000Z",
        "last_edited_time": "2025-01-16T06:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Qua “Cuốn sách sai không sót câu nào”, mình tìm hiểu được cách triết gia Aristotle định hình 3 yếu tố cần có khi muốn thuyết phục ai đó. Mình xin phép trích dẫn từ sách về cách định nghĩa 3 yếu tố đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Qua “Cuốn sách sai không sót câu nào”, mình tìm hiểu được cách triết gia Aristotle định hình 3 yếu tố cần có khi muốn thuyết phục ai đó. Mình xin phép trích dẫn từ sách về cách định nghĩa 3 yếu tố đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-80a8-aece-ddd41cd62c0e",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2025-01-16T06:01:00.000Z",
        "last_edited_time": "2025-01-16T06:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Logos",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Logos",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " chính là từ nguyên của \"logic\".\nNó được hiểu là tính hợp lý, tính khoa học của một tác phẩm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " chính là từ nguyên của \"logic\".\nNó được hiểu là tính hợp lý, tính khoa học của một tác phẩm.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-8094-af56-c1e339658b9f",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2025-01-16T06:01:00.000Z",
        "last_edited_time": "2025-01-16T06:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Pathos",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Pathos",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là từ nguyên của các chữ\n\"empathy\" (đồng cảm) hay sympathy (thông cảm) trong tiếng Anh. Nó được hiểu là việc tác phẩm đó có tạo ra được sự tương thông cảm xúc với người nhận hay không.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là từ nguyên của các chữ\n\"empathy\" (đồng cảm) hay sympathy (thông cảm) trong tiếng Anh. Nó được hiểu là việc tác phẩm đó có tạo ra được sự tương thông cảm xúc với người nhận hay không.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-801f-affd-d43a177c20f1",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2025-01-16T06:01:00.000Z",
        "last_edited_time": "2025-01-16T06:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ethos",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ethos",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là tính uy quyền, hay là thẩm quyền của tác phẩm. Nó quyết định việc người tiếp nhận có theo dõi tác phẩm với sự tôn trọng hay không.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là tính uy quyền, hay là thẩm quyền của tác phẩm. Nó quyết định việc người tiếp nhận có theo dõi tác phẩm với sự tôn trọng hay không.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-8077-941f-c72bf873cccf",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2025-01-16T05:58:00.000Z",
        "last_edited_time": "2025-01-16T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-80b1-a452-e5d24e20b4de",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2025-01-16T05:59:00.000Z",
        "last_edited_time": "2025-01-16T06:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Make sense (logos & pathos)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Make sense (logos & pathos)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "a485c611-43b2-4019-867c-b348a37b8690",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-11-12T16:27:00.000Z",
        "last_edited_time": "2024-12-22T08:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Về căn bản, thuyết phục cũng là một loại hình trong ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Về căn bản, thuyết phục cũng là một loại hình trong ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "giao tiếp,",
                "link": {
                  "url": "/1405d16478d8801faad4f558038c6ba3"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "giao tiếp,",
              "href": "/1405d16478d8801faad4f558038c6ba3"
            },
            {
              "type": "text",
              "text": {
                "content": " nên cũng cần follow các nguyên lý cơ bản như: hiểu đối phương, thông điệp rõ ràng, trình bày mạch lạc…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " nên cũng cần follow các nguyên lý cơ bản như: hiểu đối phương, thông điệp rõ ràng, trình bày mạch lạc…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-809a-969c-f8f0392ec9ee",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2025-01-16T06:11:00.000Z",
        "last_edited_time": "2025-01-16T06:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-80fd-adc1-e44173e68227",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-12-02T12:45:00.000Z",
        "last_edited_time": "2024-12-23T02:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuy nhiên trong thuyết phục, rất quan trọng việc dùng “ngôn ngữ” của đối phương,",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuy nhiên trong thuyết phục, rất quan trọng việc dùng “ngôn ngữ” của đối phương,",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " có nghĩa là mình phải đặt mình ở vị thế của họ, hiểu lối suy nghĩ, mối quan tâm của họ là gì, cách họ sẽ diễn giải vấn đề như thế nào >> để lựa chọn hướng truyền đạt cho phù hợp, càng “gãi đúng chỗ ngứa” càng tốt.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " có nghĩa là mình phải đặt mình ở vị thế của họ, hiểu lối suy nghĩ, mối quan tâm của họ là gì, cách họ sẽ diễn giải vấn đề như thế nào >> để lựa chọn hướng truyền đạt cho phù hợp, càng “gãi đúng chỗ ngứa” càng tốt.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8007-a699-c0f715d7fd8e",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-12-23T02:45:00.000Z",
        "last_edited_time": "2024-12-23T02:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [
            {
              "type": "text",
              "text": {
                "content": "https://www.rvysionstudio.com/",
                "link": {
                  "url": "https://www.rvysionstudio.com/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.rvysionstudio.com/",
              "href": "https://www.rvysionstudio.com/"
            }
          ],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081356/uxcomic-imgs/1655d164-78d8-8007-a699-c0f715d7fd8e.png",
            "expiry_time": "2026-10-04T09:11:30.475Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1655d164-78d8-8007-a699-c0f715d7fd8e"
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8022-8d78-c63236d5e891",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-12-23T02:45:00.000Z",
        "last_edited_time": "2024-12-23T02:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: trang landipage của một design studio, họ xoáy sâu vào cái pain point của target customer, thông điệp cực kì relevant đến đối tượng >> chưa cần nói studio cụ thể làm được gì nhưng giải quyết được mớ pain point này đã thấy hấp dẫn rồi đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: trang landipage của một design studio, họ xoáy sâu vào cái pain point của target customer, thông điệp cực kì relevant đến đối tượng >> chưa cần nói studio cụ thể làm được gì nhưng giải quyết được mớ pain point này đã thấy hấp dẫn rồi đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-8041-b058-ed61ac194384",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2025-01-16T06:10:00.000Z",
        "last_edited_time": "2025-01-16T06:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "05059620-8e4f-49c8-b38e-cd67dc6b91d5",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-11-12T16:26:00.000Z",
        "last_edited_time": "2025-01-16T06:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Lực cân nhắc”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Lực cân nhắc”",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "6863502e-16ea-436c-baf8-dd6b240db730",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-11-14T05:21:00.000Z",
        "last_edited_time": "2024-12-23T01:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi đối phương đã nắm & hình dung được ý mình đang nói, cái tiếp theo sẽ làm là cân nhắc luận điểm đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi đối phương đã nắm & hình dung được ý mình đang nói, cái tiếp theo sẽ làm là cân nhắc luận điểm đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17a5d164-78d8-80a6-9399-c66ec7b6ba99",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2025-01-13T02:25:00.000Z",
        "last_edited_time": "2025-01-13T02:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081358/uxcomic-imgs/17a5d164-78d8-80a6-9399-c66ec7b6ba99.png",
            "expiry_time": "2026-10-04T09:11:30.535Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/17a5d164-78d8-80a6-9399-c66ec7b6ba99"
      },
      {
        "object": "block",
        "id": "08ea2faa-257a-4e9b-85a3-50bf56c1804e",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-11-12T16:01:00.000Z",
        "last_edited_time": "2024-12-23T01:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước mọi quyết định, sẽ luôn có 2 chiều diễn ra trong đầu lúc ta cân nhắc gì đó:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước mọi quyết định, sẽ luôn có 2 chiều diễn ra trong đầu lúc ta cân nhắc gì đó:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "b055aa0a-36e3-4b26-b589-eeb5da6018a4",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-11-12T16:02:00.000Z",
        "last_edited_time": "2024-12-23T01:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lực đẩy (được gì)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lực đẩy (được gì)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": là những ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": là những ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "benefit, value",
                "link": {
                  "url": "/1605d16478d880ad9130fe44c6663146"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "benefit, value",
              "href": "/1605d16478d880ad9130fe44c6663146"
            },
            {
              "type": "text",
              "text": {
                "content": " trên góc nhìn của họ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " trên góc nhìn của họ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "71725dc9-7085-4ef0-916d-61fff690ab94",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-11-12T16:01:00.000Z",
        "last_edited_time": "2024-12-23T01:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lực kéo (mất gì)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lực kéo (mất gì)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": những trở ngại khiến chúng ta ngại thay đổi hoặc những rủi ro có thể xảy ra.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": những trở ngại khiến chúng ta ngại thay đổi hoặc những rủi ro có thể xảy ra.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "19aab20f-a45b-45ca-a322-6e1d8b0a35d6",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-11-12T16:04:00.000Z",
        "last_edited_time": "2024-12-23T01:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhiệm vụ của thuyết phục ở đây là thay đổi quan điểm đối phương, điều này đồng nghĩa với việc làm giảm “lực kéo-cái mất” và tăng “lực đẩy-cái được”.  Và như bạn thấy đó, cả 2 lực này đều dưới góc nhìn của đối phương, nên việc tiên quyết là phải nói theo “ngôn ngữ của họ” là vậy.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhiệm vụ của thuyết phục ở đây là thay đổi quan điểm đối phương, điều này đồng nghĩa với việc làm giảm “lực kéo-cái mất” và tăng “lực đẩy-cái được”.  Và như bạn thấy đó, cả 2 lực này đều dưới góc nhìn của đối phương, nên việc tiên quyết là phải nói theo “ngôn ngữ của họ” là vậy.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15f5d164-78d8-80e8-aa6b-edf02f237a8f",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-12-17T10:31:00.000Z",
        "last_edited_time": "2024-12-23T01:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: có hôm mình ngồi cafe với bạn, nghe nó kể rằng chủ nhà đang muốn lên tiền nhà, còn nó thì budget chỉ có nhiêu đó thôi, không muốn tăng thêm. Nhưng nó thuyết phục lại chủ nhà bằng cách rất hay, bạn nói tôi không thể trả hơn, nhưng như ông thấy đó tôi là người rất vệ sinh & cẩn thận, nhà của ông không hề có hỏng hóc gì, chưa kể nếu ông cần tìm người thuê mới, ông có thể sẽ mất thêm một chút thời gian & phải trả phí cho bên agent kiếm giúp (bạn mình ở bên nước ngoài nên phần lớn chủ nhà cho thuê cần thông qua agent) >> điều này làm chủ nhà suy nghĩ về cái được (vệ sinh, cẩn thận) & cái mất (mất thời gian, mất thêm tiền, tính ra giá tăng đó 6 tháng lại bù cho phí agent) >> chủ nhà đồng ý không giá cho bạn tôi.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: có hôm mình ngồi cafe với bạn, nghe nó kể rằng chủ nhà đang muốn lên tiền nhà, còn nó thì budget chỉ có nhiêu đó thôi, không muốn tăng thêm. Nhưng nó thuyết phục lại chủ nhà bằng cách rất hay, bạn nói tôi không thể trả hơn, nhưng như ông thấy đó tôi là người rất vệ sinh & cẩn thận, nhà của ông không hề có hỏng hóc gì, chưa kể nếu ông cần tìm người thuê mới, ông có thể sẽ mất thêm một chút thời gian & phải trả phí cho bên agent kiếm giúp (bạn mình ở bên nước ngoài nên phần lớn chủ nhà cho thuê cần thông qua agent) >> điều này làm chủ nhà suy nghĩ về cái được (vệ sinh, cẩn thận) & cái mất (mất thời gian, mất thêm tiền, tính ra giá tăng đó 6 tháng lại bù cho phí agent) >> chủ nhà đồng ý không giá cho bạn tôi.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-8012-a629-fa5d43f86a1e",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2025-01-16T06:04:00.000Z",
        "last_edited_time": "2025-01-16T06:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "6b8d07e9-0078-4ea3-87e3-d019ab57c399",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-11-13T02:23:00.000Z",
        "last_edited_time": "2025-01-16T06:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tiền tệ “lợi ích”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tiền tệ “lợi ích”",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "b764523b-15f0-41d4-97bb-0837839da3b5",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-11-13T02:20:00.000Z",
        "last_edited_time": "2024-12-22T08:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tiền tệ “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tiền tệ “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "lợi ích",
                "link": {
                  "url": "/1605d16478d880ad9130fe44c6663146"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "lợi ích",
              "href": "/1605d16478d880ad9130fe44c6663146"
            },
            {
              "type": "text",
              "text": {
                "content": "” ở đây có thể là tiền, là thời gian, là sức khoẻ, là mối quan hệ, công sức, chi phí cơ hội… là bất kì gì mà đối phương cho là giá trị. Và ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” ở đây có thể là tiền, là thời gian, là sức khoẻ, là mối quan hệ, công sức, chi phí cơ hội… là bất kì gì mà đối phương cho là giá trị. Và ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "mức độ giá trị ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "mức độ giá trị ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "giữa các tiền tệ này sẽ tuỳ thuộc vào cách nhìn nhận của đối phương, có người đánh giá tiền cao hơn, có người đánh giá thời gian cao hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "giữa các tiền tệ này sẽ tuỳ thuộc vào cách nhìn nhận của đối phương, có người đánh giá tiền cao hơn, có người đánh giá thời gian cao hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-80b5-94cd-f6f603aece78",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2025-01-16T06:04:00.000Z",
        "last_edited_time": "2025-01-16T06:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "fb1abe4f-0de9-4b92-8e42-fe870b0f6395",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-11-12T16:06:00.000Z",
        "last_edited_time": "2024-12-22T08:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Việc thuyết phục cần bạn quan tâm đến đối phương đang hình dung và đề cao những loại tiền tệ nào. Có khi bạn phải cung cấp thêm thông tin để họ có thể thay đổi quan điểm, một là giúp họ hình dung thêm loại tiền tệ khác, hai là mong họ thay đổi cách nhìn nhận về mức độ giá trị của loại tiền tệ đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Việc thuyết phục cần bạn quan tâm đến đối phương đang hình dung và đề cao những loại tiền tệ nào. Có khi bạn phải cung cấp thêm thông tin để họ có thể thay đổi quan điểm, một là giúp họ hình dung thêm loại tiền tệ khác, hai là mong họ thay đổi cách nhìn nhận về mức độ giá trị của loại tiền tệ đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15f5d164-78d8-80bb-b6cc-f4c27d0aa5bb",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-12-17T09:11:00.000Z",
        "last_edited_time": "2024-12-22T08:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu tưởng tượng nó dưới dạng một phương trình toán học, thì sẽ trông như thế này:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu tưởng tượng nó dưới dạng một phương trình toán học, thì sẽ trông như thế này:",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "15f5d164-78d8-800c-837f-fab7359a38db",
            "parent": {
              "type": "block_id",
              "block_id": "15f5d164-78d8-80bb-b6cc-f4c27d0aa5bb"
            },
            "created_time": "2024-12-17T09:12:00.000Z",
            "last_edited_time": "2024-12-17T09:13:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "A+B+c > D+f+g ",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "A+B+c > D+f+g ",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "15f5d164-78d8-80ae-ac00-dfadb2392a90",
            "parent": {
              "type": "block_id",
              "block_id": "15f5d164-78d8-80bb-b6cc-f4c27d0aa5bb"
            },
            "created_time": "2024-12-17T09:12:00.000Z",
            "last_edited_time": "2024-12-17T09:12:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "A+B+c = lực kéo",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "A+B+c = lực kéo",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "15f5d164-78d8-80f5-88c8-f38fcd05d848",
            "parent": {
              "type": "block_id",
              "block_id": "15f5d164-78d8-80bb-b6cc-f4c27d0aa5bb"
            },
            "created_time": "2024-12-17T09:12:00.000Z",
            "last_edited_time": "2024-12-17T09:12:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "D+f+g = lực đẩy",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "D+f+g = lực đẩy",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "15f5d164-78d8-80b2-8cde-f10c5619b64f",
            "parent": {
              "type": "block_id",
              "block_id": "15f5d164-78d8-80bb-b6cc-f4c27d0aa5bb"
            },
            "created_time": "2024-12-17T09:12:00.000Z",
            "last_edited_time": "2024-12-17T09:12:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Vậy cách nào để khiến lực kéo nhỏ hơn lực đẩy đây?",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Vậy cách nào để khiến lực kéo nhỏ hơn lực đẩy đây?",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "15f5d164-78d8-80a2-8b6c-ea8bf4331381",
            "parent": {
              "type": "block_id",
              "block_id": "15f5d164-78d8-80bb-b6cc-f4c27d0aa5bb"
            },
            "created_time": "2024-12-17T09:12:00.000Z",
            "last_edited_time": "2024-12-18T01:40:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Thêm x,y,z vào lực đẩy hoặc tăng giá trị cho f,g.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Thêm x,y,z vào lực đẩy hoặc tăng giá trị cho f,g.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "15f5d164-78d8-8002-a611-e4b1c08d5516",
            "parent": {
              "type": "block_id",
              "block_id": "15f5d164-78d8-80bb-b6cc-f4c27d0aa5bb"
            },
            "created_time": "2024-12-17T09:12:00.000Z",
            "last_edited_time": "2024-12-18T01:40:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Bỏ bớt hoặc giảm nhẹ A,B,c. ",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Bỏ bớt hoặc giảm nhẹ A,B,c. ",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "15f5d164-78d8-800d-90a2-c359d5179560",
            "parent": {
              "type": "block_id",
              "block_id": "15f5d164-78d8-80bb-b6cc-f4c27d0aa5bb"
            },
            "created_time": "2024-12-17T09:12:00.000Z",
            "last_edited_time": "2024-12-17T09:13:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Sau quá trình bạn thuyết phục thì kết quả có thể là: ",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Sau quá trình bạn thuyết phục thì kết quả có thể là: ",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "15f5d164-78d8-8094-98d1-c6cbe79894e8",
            "parent": {
              "type": "block_id",
              "block_id": "15f5d164-78d8-80bb-b6cc-f4c27d0aa5bb"
            },
            "created_time": "2024-12-17T09:13:00.000Z",
            "last_edited_time": "2024-12-18T01:41:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "b+c < D+F+g+x+y+z",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "b+c < D+F+g+x+y+z",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "7bee8b9f-7d23-46d9-96ea-107222f2ad11",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-11-13T02:17:00.000Z",
        "last_edited_time": "2024-11-13T02:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "38534dfe-2c5b-4dd5-ab7b-f740719caacd",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-11-13T02:11:00.000Z",
        "last_edited_time": "2025-01-16T05:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sự tác động (ethos)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sự tác động (ethos)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "c4461701-b7f0-4200-8936-095949f52250",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-11-12T16:19:00.000Z",
        "last_edited_time": "2024-12-23T01:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ngoài ra cũng còn nhiều thứ khác ảnh hưởng đến khả năng thuyết phục của bạn, đó là ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ngoài ra cũng còn nhiều thứ khác ảnh hưởng đến khả năng thuyết phục của bạn, đó là ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "uy tín, thiện cảm, sức ảnh hưởng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "uy tín, thiện cảm, sức ảnh hưởng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ",… Lấy ví dụ: KOL quảng cáo cho sản phẩm của nhãn hàng A khiến nó trở nên uy tín & dễ thuyết phục khách hàng mua hàng hơn. Hoặc khi bạn có tiếng trong giới, lời nói của bạn cũng có sức nặng hơn là một junior, tất nhiên nghe không đúng đắn lắm nhưng sự thật là như vậy, con người không phải lúc nào cũng lí trí hay có thời gian ngồi suy nghĩ cặn kẽ, chúng ta luôn có thiên kiến, một khi họ đang tin vào bạn rồi, thì quá trình thuyết phục sẽ êm dịu hơn vì những gì bạn nói, nó “lọt lỗ tai” hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ",… Lấy ví dụ: KOL quảng cáo cho sản phẩm của nhãn hàng A khiến nó trở nên uy tín & dễ thuyết phục khách hàng mua hàng hơn. Hoặc khi bạn có tiếng trong giới, lời nói của bạn cũng có sức nặng hơn là một junior, tất nhiên nghe không đúng đắn lắm nhưng sự thật là như vậy, con người không phải lúc nào cũng lí trí hay có thời gian ngồi suy nghĩ cặn kẽ, chúng ta luôn có thiên kiến, một khi họ đang tin vào bạn rồi, thì quá trình thuyết phục sẽ êm dịu hơn vì những gì bạn nói, nó “lọt lỗ tai” hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-8011-a5b0-dc63fc656f02",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2025-01-16T06:20:00.000Z",
        "last_edited_time": "2025-01-16T06:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8093-a94d-c447ae3e57e4",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-11-17T16:08:00.000Z",
        "last_edited_time": "2024-12-22T08:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tip: Đôi khi một lời thuyết phục sắc bén xuất phát từ câu hỏi?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tip: Đôi khi một lời thuyết phục sắc bén xuất phát từ câu hỏi?",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Các câu hỏi hay đúng thời điểm, khơi mở được sự khẳng định từ chính câu trả lời do chính miệng đối phương nói ra. Ví dụ: bạn nghĩ điều gì ở đây là quan trọng, thời gian hay tiền bạc? >> Vì có khi bạn nói họ sẽ không tin, nhưng chính họ nói thì…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Các câu hỏi hay đúng thời điểm, khơi mở được sự khẳng định từ chính câu trả lời do chính miệng đối phương nói ra. Ví dụ: bạn nghĩ điều gì ở đây là quan trọng, thời gian hay tiền bạc? >> Vì có khi bạn nói họ sẽ không tin, nhưng chính họ nói thì…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-80eb-b9e9-c255cd866c68",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2025-01-16T06:20:00.000Z",
        "last_edited_time": "2025-01-16T06:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80de-8af7-e5bcca4f7093",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-12-23T16:55:00.000Z",
        "last_edited_time": "2024-12-23T16:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bàn thêm chút về độ uy tín:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bàn thêm chút về độ uy tín:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " chắc chắn sẽ có tình huống bạn ở vị thế dưới hoặc lòng tin của đối phương với mình không cao, cách để tăng độ uy tín này là show the data, show the fact. Ví dụ: có thể team không tin những user pain point mà bạn share >> mời họ tham gia chung với mình hoặc share video,… trong lúc user testing, interview,…bằng việc tự chứng kiến họ sẽ tin hơn (show, don’t tell).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " chắc chắn sẽ có tình huống bạn ở vị thế dưới hoặc lòng tin của đối phương với mình không cao, cách để tăng độ uy tín này là show the data, show the fact. Ví dụ: có thể team không tin những user pain point mà bạn share >> mời họ tham gia chung với mình hoặc share video,… trong lúc user testing, interview,…bằng việc tự chứng kiến họ sẽ tin hơn (show, don’t tell).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-809a-b995-c06116c61ac3",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-12-23T10:19:00.000Z",
        "last_edited_time": "2024-12-23T10:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80b4-81e3-e31167d1aac3",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-12-23T10:19:00.000Z",
        "last_edited_time": "2024-12-23T10:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bonus",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bonus",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17a5d164-78d8-80d4-8cc1-d09b562d67b3",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2025-01-13T02:31:00.000Z",
        "last_edited_time": "2025-01-13T02:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nghĩ một chút về chữ “động lực”, động là khiến gì đó chuyển động, lực là lực :)) là sức. Chúng ta cần động lực để làm gì đó vì ta có một sức ì, theo vật lý thì lực để khiến một vật gì đó chuyển động thời gian đầu phải mạnh hơn lực ì đó, khi nó đã chuyển động, thì sẽ có quán tính, lực tác động có thể nhẹ đi nhưng vẫn cần vì nó sẽ mòn dần do ma sát. >> áp dụng cho việc thuyết phục cũng tương tự, phải làm sao truyền được một lực đủ lớn để thay đổi sức ì của đối phương.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nghĩ một chút về chữ “động lực”, động là khiến gì đó chuyển động, lực là lực :)) là sức. Chúng ta cần động lực để làm gì đó vì ta có một sức ì, theo vật lý thì lực để khiến một vật gì đó chuyển động thời gian đầu phải mạnh hơn lực ì đó, khi nó đã chuyển động, thì sẽ có quán tính, lực tác động có thể nhẹ đi nhưng vẫn cần vì nó sẽ mòn dần do ma sát. >> áp dụng cho việc thuyết phục cũng tương tự, phải làm sao truyền được một lực đủ lớn để thay đổi sức ì của đối phương.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8010-87de-c9472dc24c1e",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-12-23T10:19:00.000Z",
        "last_edited_time": "2024-12-23T10:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phần này phụ thôi, nhưng khi nói về việc product hay design của bạn có thuyết phục / lôi cuốn user hay không, thì đâu đó topic Persuade này cũng liên quan đó, mọi người thử ngậm nghĩ xem.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phần này phụ thôi, nhưng khi nói về việc product hay design của bạn có thuyết phục / lôi cuốn user hay không, thì đâu đó topic Persuade này cũng liên quan đó, mọi người thử ngậm nghĩ xem.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80a3-b74d-fe4bff9cefdd",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-12-23T10:19:00.000Z",
        "last_edited_time": "2024-12-23T10:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081360/uxcomic-imgs/1655d164-78d8-80a3-b74d-fe4bff9cefdd.png",
            "expiry_time": "2026-10-04T09:11:30.573Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1655d164-78d8-80a3-b74d-fe4bff9cefdd"
      },
      {
        "object": "block",
        "id": "1215d164-78d8-815c-9b00-ed9fb0046b64",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-10-16T03:13:00.000Z",
        "last_edited_time": "2024-10-16T03:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1215d164-78d8-81be-9059-ce9b578e6078",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-10-16T03:13:00.000Z",
        "last_edited_time": "2024-10-16T03:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1215d164-78d8-8199-9a67-db32ed7670d2",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-10-16T03:13:00.000Z",
        "last_edited_time": "2024-10-16T03:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.tannerchristensen.com/notes/three-ways-to-more-effectively-present-your-designs",
                "link": {
                  "url": "https://www.tannerchristensen.com/notes/three-ways-to-more-effectively-present-your-designs"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.tannerchristensen.com/notes/three-ways-to-more-effectively-present-your-designs",
              "href": "https://www.tannerchristensen.com/notes/three-ways-to-more-effectively-present-your-designs"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1215d164-78d8-81c9-b1cb-cb01d10489ab",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-10-16T03:13:00.000Z",
        "last_edited_time": "2025-07-10T05:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://open.substack.com/pub/productmindset/p/mckinseys-pyramid-principle?",
                "link": {
                  "url": "https://open.substack.com/pub/productmindset/p/mckinseys-pyramid-principle?utm_campaign=post&utm_medium=web"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://open.substack.com/pub/productmindset/p/mckinseys-pyramid-principle?",
              "href": "https://open.substack.com/pub/productmindset/p/mckinseys-pyramid-principle?utm_campaign=post&utm_medium=web"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22c5d164-78d8-803a-8c5d-e2e16251a0eb",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2025-07-10T05:50:00.000Z",
        "last_edited_time": "2025-07-10T05:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.linkedin.com/posts/mattprzegietka_15-rules-of-engagement-with-stakeholders-ugcPost-7322659685537390592-UvcX?",
                "link": {
                  "url": "https://www.linkedin.com/posts/mattprzegietka_15-rules-of-engagement-with-stakeholders-ugcPost-7322659685537390592-UvcX?utm_source=share&utm_medium=member_desktop&rcm=ACoAACTxzsYBO4mptTzgsbAc8dNNiYnc142O2IA"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.linkedin.com/posts/mattprzegietka_15-rules-of-engagement-with-stakeholders-ugcPost-7322659685537390592-UvcX?",
              "href": "https://www.linkedin.com/posts/mattprzegietka_15-rules-of-engagement-with-stakeholders-ugcPost-7322659685537390592-UvcX?utm_source=share&utm_medium=member_desktop&rcm=ACoAACTxzsYBO4mptTzgsbAc8dNNiYnc142O2IA"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1215d164-78d8-8185-8fd4-f2d90809375f",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-10-16T03:13:00.000Z",
        "last_edited_time": "2024-10-16T03:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1215d164-78d8-8180-9835-c3cfd3b6bc15",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-10-16T03:13:00.000Z",
        "last_edited_time": "2024-10-16T03:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1215d164-78d8-81df-aaea-f1cc119de1b7",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-10-16T03:13:00.000Z",
        "last_edited_time": "2024-12-18T05:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1405d164-78d8-801f-aad4-f558038c6ba3"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Principle of Communication",
              "href": "https://app.notion.com/p/1405d16478d8801faad4f558038c6ba3"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80c5-ab23-e34d4206c025",
        "parent": {
          "type": "page_id",
          "page_id": "1215d164-78d8-809d-89b0-e84bbf170b05"
        },
        "created_time": "2024-12-18T05:11:00.000Z",
        "last_edited_time": "2024-12-18T05:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1605d164-78d8-80ad-9130-fe44c6663146"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Value vs Benefit",
              "href": "https://app.notion.com/p/1605d16478d880ad9130fe44c6663146"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1185d164-78d8-8014-bdf1-e631b28f601e",
    "created_time": "2024-10-07T07:23:00.000Z",
    "last_edited_time": "2024-12-21T23:32:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-10-07T07:23:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "1-Understanding",
          "color": "orange"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 10
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2024-12-21T23:32:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "El~V",
          "name": "♟️:2",
          "color": "blue"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "RACI (Role & Responsibility)",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "RACI (Role & Responsibility)",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/RACI-Role-Responsibility-1185d16478d88014bdf1e631b28f601e",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
      "name": "Understanding",
      "slug": "understanding",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "13d5d164-78d8-81bd-b2ee-ebe2e6d8a72e",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-11-13T05:49:00.000Z",
        "last_edited_time": "2024-12-10T01:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081364/uxcomic-imgs/13d5d164-78d8-81bd-b2ee-ebe2e6d8a72e.png",
            "expiry_time": "2026-10-04T09:11:31.929Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/13d5d164-78d8-81bd-b2ee-ebe2e6d8a72e"
      },
      {
        "object": "block",
        "id": "13d5d164-78d8-8139-aedc-fd7f9d5842dd",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-11-13T05:49:00.000Z",
        "last_edited_time": "2024-12-13T01:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Công việc nào trong công ty cũng cần đến teamwork, và đặc biệt nếu bạn đang làm ở big corp thì stakeholders lại càng nhiều & đa dạng. (Stakeholder là tất cả những ai liên quan đến quá trình phát triển giải pháp). ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Công việc nào trong công ty cũng cần đến teamwork, và đặc biệt nếu bạn đang làm ở big corp thì stakeholders lại càng nhiều & đa dạng. (Stakeholder là tất cả những ai liên quan đến quá trình phát triển giải pháp). ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1545d164-78d8-80d1-a217-cb6064f0157f",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-06T11:26:00.000Z",
        "last_edited_time": "2024-12-06T11:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu bạn đã trải qua trong các tình huống sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu bạn đã trải qua trong các tình huống sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1545d164-78d8-8016-82cf-e89358f313dc",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-06T11:27:00.000Z",
        "last_edited_time": "2024-12-06T11:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Team thảo luận rất nhiều idea & ai cũng muốn idea của mình nên được triển khai.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Team thảo luận rất nhiều idea & ai cũng muốn idea của mình nên được triển khai.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1545d164-78d8-80a4-bb63-c199b7e40e73",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-06T11:28:00.000Z",
        "last_edited_time": "2024-12-06T11:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Xảy ra tình trạng overlap công việc giữa các thành viên làm uổng phí thời gian của dự án.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Xảy ra tình trạng overlap công việc giữa các thành viên làm uổng phí thời gian của dự án.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1545d164-78d8-80d5-bb2e-d9966ad2e87a",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-06T11:29:00.000Z",
        "last_edited_time": "2024-12-06T11:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bạn bị quá tải công việc khi phải handle quá nhiều thứ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bạn bị quá tải công việc khi phải handle quá nhiều thứ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1545d164-78d8-808d-bdfe-ee088b0c482e",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-06T11:30:00.000Z",
        "last_edited_time": "2024-12-10T01:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bạn bị xoay như chong chóng khi phải chỉnh sửa theo nhiều luồng feedback từ các stakeholder.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bạn bị xoay như chong chóng khi phải chỉnh sửa theo nhiều luồng feedback từ các stakeholder.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1545d164-78d8-803e-9339-f6128405aa75",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-06T11:41:00.000Z",
        "last_edited_time": "2024-12-06T11:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi xảy ra issue gì đó, các thành viên đổ lỗi cho nhau.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi xảy ra issue gì đó, các thành viên đổ lỗi cho nhau.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1545d164-78d8-801b-ae52-c6758d401823",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-06T11:39:00.000Z",
        "last_edited_time": "2024-12-06T11:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bạn tò mò về công việc của các bên khác tác động như thế nào đến mình.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bạn tò mò về công việc của các bên khác tác động như thế nào đến mình.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1545d164-78d8-80a0-a6a7-d605155ff7fe",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-06T11:42:00.000Z",
        "last_edited_time": "2024-12-13T01:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bạn không biết nên assign task như thế nào cho các thành viên (trường hợp bạn là một team leader cho dự án).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bạn không biết nên assign task như thế nào cho các thành viên (trường hợp bạn là một team leader cho dự án).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1545d164-78d8-803d-8cc3-dd88099a372c",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-06T11:26:00.000Z",
        "last_edited_time": "2024-12-13T01:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tất cả các tình huống trên xảy ra do ban đầu chúng ta không làm rõ các đầu mục & trách nhiệm công việc, dẫn đến các team member không nắm rõ quyền hạn, kì vọng của nhau >> dễ xảy ra nhầm lẫn, dễ dậm chân lên nhau, mâu thuẫn tranh cãi khi làm việc chung. Đây chính là lí do người ta hay mention đến kĩ năng stakeholder management, vậy làm sao để mình bắt đầu luyện về skill này đây.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tất cả các tình huống trên xảy ra do ban đầu chúng ta không làm rõ các đầu mục & trách nhiệm công việc, dẫn đến các team member không nắm rõ quyền hạn, kì vọng của nhau >> dễ xảy ra nhầm lẫn, dễ dậm chân lên nhau, mâu thuẫn tranh cãi khi làm việc chung. Đây chính là lí do người ta hay mention đến kĩ năng stakeholder management, vậy làm sao để mình bắt đầu luyện về skill này đây.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15b5d164-78d8-8055-8848-ca6ab4f841fe",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-13T01:32:00.000Z",
        "last_edited_time": "2024-12-13T01:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vâng chào mừng đến với framework RACI, một framework giúp chúng ta xác định vai trò & trách nhiệm của các bên trước khi bắt tay vào dự án.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vâng chào mừng đến với framework RACI, một framework giúp chúng ta xác định vai trò & trách nhiệm của các bên trước khi bắt tay vào dự án.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1545d164-78d8-8094-bef2-deb1d4008d04",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-06T11:39:00.000Z",
        "last_edited_time": "2024-12-06T11:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Who does what?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Who does what?",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1575d164-78d8-8096-b4e9-d174211ddcee",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-09T10:00:00.000Z",
        "last_edited_time": "2024-12-09T10:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "03578043-75b9-4755-bfd0-29fca44a1685",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-11-13T05:49:00.000Z",
        "last_edited_time": "2024-12-13T01:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "RACI là gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "RACI là gì?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1575d164-78d8-800d-853d-f643c315dd1b",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-09T09:58:00.000Z",
        "last_edited_time": "2024-12-13T01:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "R - Responsible (Người thực hiện):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "R - Responsible (Người thực hiện):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "\nĐây là người chịu trách nhiệm chính để hoàn thành công việc. Họ thực thi các nhiệm vụ cụ thể để đảm bảo rằng đầu ra được giao đúng hạn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "\nĐây là người chịu trách nhiệm chính để hoàn thành công việc. Họ thực thi các nhiệm vụ cụ thể để đảm bảo rằng đầu ra được giao đúng hạn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1575d164-78d8-80b5-a432-f59069b27b83",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-09T09:59:00.000Z",
        "last_edited_time": "2024-12-09T09:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "A - Accountable (Người chịu trách nhiệm cuối cùng):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "A - Accountable (Người chịu trách nhiệm cuối cùng):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "\nĐây là người chịu trách nhiệm cuối cùng về kết quả công việc. Họ có quyền đưa ra quyết định và đảm bảo rằng nhiệm vụ được thực hiện đúng cách. Mỗi nhiệm vụ chỉ nên có một người “Accountable”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "\nĐây là người chịu trách nhiệm cuối cùng về kết quả công việc. Họ có quyền đưa ra quyết định và đảm bảo rằng nhiệm vụ được thực hiện đúng cách. Mỗi nhiệm vụ chỉ nên có một người “Accountable”.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1575d164-78d8-807a-9365-e34727f8daaf",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-09T09:59:00.000Z",
        "last_edited_time": "2024-12-13T01:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "C - Consulted (Người được tham vấn)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "C - Consulted (Người được tham vấn)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ":\nĐây là những người được tham vấn để cung cấp thông tin, ý kiến chuyên môn hoặc đầu vào để hỗ trợ thực hiện nhiệm vụ. Ví dụ: team marketing, subject matter expert (chuyên gia trong lĩnh vực)… Họ không phải chịu trách nhiệm trực tiếp.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ":\nĐây là những người được tham vấn để cung cấp thông tin, ý kiến chuyên môn hoặc đầu vào để hỗ trợ thực hiện nhiệm vụ. Ví dụ: team marketing, subject matter expert (chuyên gia trong lĩnh vực)… Họ không phải chịu trách nhiệm trực tiếp.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1575d164-78d8-80ab-bc62-da46761112f7",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-09T09:58:00.000Z",
        "last_edited_time": "2024-12-09T09:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "I - Informed (Người được thông báo)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "I - Informed (Người được thông báo)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ":\nĐây là những người cần được cập nhật thông tin về tiến độ hoặc kết quả công việc nhưng không tham gia trực tiếp vào quá trình thực hiện.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ":\nĐây là những người cần được cập nhật thông tin về tiến độ hoặc kết quả công việc nhưng không tham gia trực tiếp vào quá trình thực hiện.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1575d164-78d8-80ac-abf4-e388d8cf6118",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-09T10:13:00.000Z",
        "last_edited_time": "2024-12-09T10:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "13d5d164-78d8-81c6-9967-cb179785a589",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-11-13T05:49:00.000Z",
        "last_edited_time": "2024-12-09T10:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ứng dụng khi nào?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ứng dụng khi nào?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1575d164-78d8-80af-ad00-f0759397b07d",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-09T10:09:00.000Z",
        "last_edited_time": "2024-12-10T01:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi bước chân vào công ty hoặc tham gia vào lĩnh vực ngành nào đó, mình phải hiểu rõ “luật chơi” các thành viên của nơi mình thuộc về.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi bước chân vào công ty hoặc tham gia vào lĩnh vực ngành nào đó, mình phải hiểu rõ “luật chơi” các thành viên của nơi mình thuộc về.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1575d164-78d8-809f-add9-e00a6f8fdef4",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-09T10:11:00.000Z",
        "last_edited_time": "2024-12-10T01:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi start dự án, vì có khi mỗi dự án mình sẽ có những stakeholder khác nhau, scope công việc cũng có thể khác, nên cần define và align với nhau rõ ràng trước khi bắt đầu.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi start dự án, vì có khi mỗi dự án mình sẽ có những stakeholder khác nhau, scope công việc cũng có thể khác, nên cần define và align với nhau rõ ràng trước khi bắt đầu.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1575d164-78d8-8061-a44c-d3b044febab5",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-09T10:11:00.000Z",
        "last_edited_time": "2024-12-09T15:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi tham gia các buổi retrospective, mọi người cùng ngồi lại đánh giá vấn đề, và feedback cho nhau hướng cải thiện.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi tham gia các buổi retrospective, mọi người cùng ngồi lại đánh giá vấn đề, và feedback cho nhau hướng cải thiện.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "1575d164-78d8-8002-8210-cc5ce2ec3f9e",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-09T10:06:00.000Z",
        "last_edited_time": "2024-12-09T12:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081365/uxcomic-imgs/1575d164-78d8-8002-8210-cc5ce2ec3f9e.jpg",
            "expiry_time": "2026-10-04T09:11:31.929Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1575d164-78d8-8002-8210-cc5ce2ec3f9e"
      },
      {
        "object": "block",
        "id": "1575d164-78d8-8083-b9fa-eefc335fb1e2",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-09T10:07:00.000Z",
        "last_edited_time": "2024-12-09T12:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081367/uxcomic-imgs/1575d164-78d8-8083-b9fa-eefc335fb1e2.jpg",
            "expiry_time": "2026-10-04T09:11:32.013Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1575d164-78d8-8083-b9fa-eefc335fb1e2"
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-808d-8ff9-c44ba8c24cc6",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-12T05:16:00.000Z",
        "last_edited_time": "2024-12-12T05:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-80e4-97d2-d229b1424d36",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-12T05:14:00.000Z",
        "last_edited_time": "2024-12-13T05:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bonus: cách quản lý mong đợi, nhu cầu & sự tham gia các stakeholder ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bonus: cách quản lý mong đợi, nhu cầu & sự tham gia các stakeholder ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-8017-81b2-db9e9a4b19c6",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-12T05:14:00.000Z",
        "last_edited_time": "2024-12-12T05:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuỳ theo độ power & interest, ta có ma trận sau, ma trận này giúp bạn biết nên làm gì với các stakeholder.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuỳ theo độ power & interest, ta có ma trận sau, ma trận này giúp bạn biết nên làm gì với các stakeholder.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-80e9-8ab4-ca7319a2fb17",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-12T05:16:00.000Z",
        "last_edited_time": "2024-12-12T05:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081368/uxcomic-imgs/15a5d164-78d8-80e9-8ab4-ca7319a2fb17.png",
            "expiry_time": "2026-10-04T09:11:32.014Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/15a5d164-78d8-80e9-8ab4-ca7319a2fb17"
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-80d5-baf8-d9e31a023480",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-12T05:14:00.000Z",
        "last_edited_time": "2024-12-12T05:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "13d5d164-78d8-816f-97cd-f85e14a63b8c",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-11-13T05:49:00.000Z",
        "last_edited_time": "2024-11-13T05:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13d5d164-78d8-8160-a980-c321cfc067a0",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-11-13T05:49:00.000Z",
        "last_edited_time": "2024-12-06T11:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.nngroup.com/articles/ux-roles-responsibilities/",
                "link": {
                  "url": "https://www.nngroup.com/articles/ux-roles-responsibilities/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.nngroup.com/articles/ux-roles-responsibilities/",
              "href": "https://www.nngroup.com/articles/ux-roles-responsibilities/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-80e7-b308-f767b501c373",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-12T05:19:00.000Z",
        "last_edited_time": "2024-12-12T05:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://vuxhr.wordpress.com/2021/10/10/mendelows-matrix/",
                "link": {
                  "url": "https://vuxhr.wordpress.com/2021/10/10/mendelows-matrix/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://vuxhr.wordpress.com/2021/10/10/mendelows-matrix/",
              "href": "https://vuxhr.wordpress.com/2021/10/10/mendelows-matrix/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1635d164-78d8-808e-bcd8-ef4a845abbfb",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-12-21T23:32:00.000Z",
        "last_edited_time": "2024-12-21T23:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://docs.google.com/presentation/d/1VJ7Me2aIxV-UtMlzs8kuzvnLI6-EBrXcIGZVkndVALk/mobilepresent?slide=id.g10cc2a0f730_0_157",
                "link": {
                  "url": "https://docs.google.com/presentation/d/1VJ7Me2aIxV-UtMlzs8kuzvnLI6-EBrXcIGZVkndVALk/mobilepresent?slide=id.g10cc2a0f730_0_157"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://docs.google.com/presentation/d/1VJ7Me2aIxV-UtMlzs8kuzvnLI6-EBrXcIGZVkndVALk/mobilepresent?slide=id.g10cc2a0f730_0_157",
              "href": "https://docs.google.com/presentation/d/1VJ7Me2aIxV-UtMlzs8kuzvnLI6-EBrXcIGZVkndVALk/mobilepresent?slide=id.g10cc2a0f730_0_157"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13d5d164-78d8-81a9-9482-cd2263d3aeed",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-11-13T05:49:00.000Z",
        "last_edited_time": "2024-11-13T05:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "13d5d164-78d8-81c0-979d-eedd5bf7e3eb",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-11-13T05:49:00.000Z",
        "last_edited_time": "2024-11-13T05:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13d5d164-78d8-8169-9027-fd80a39d0f9f",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-11-13T05:49:00.000Z",
        "last_edited_time": "2024-12-09T10:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1445d164-78d8-805b-b388-e24b5f13cccb"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product development process (overall)",
              "href": "https://app.notion.com/p/1445d16478d8805bb388e24b5f13cccb"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13d5d164-78d8-8196-a436-c3acd7d1f22f",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-11-13T05:49:00.000Z",
        "last_edited_time": "2024-12-09T10:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1025d164-78d8-80c5-891f-debd0fc09547"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product development process (detail)",
              "href": "https://app.notion.com/p/1025d16478d880c5891fdebd0fc09547"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2a88844b-2af7-4a6a-a513-df4f42cc6de0",
        "parent": {
          "type": "page_id",
          "page_id": "1185d164-78d8-8014-bdf1-e631b28f601e"
        },
        "created_time": "2024-11-13T05:49:00.000Z",
        "last_edited_time": "2024-11-13T05:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302",
    "created_time": "2024-10-01T10:49:00.000Z",
    "last_edited_time": "2025-08-08T07:44:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-10-01T10:49:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "3-Workflow",
          "color": "default"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 4
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-08T07:44:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "bx`f",
          "name": "⚓:3",
          "color": "purple"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Decision making (P1)",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Decision making (P1)",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Decision-making-P1-b2deb93698dc4fafaadc9cfcb4a6c302",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
      "name": "Workflow",
      "slug": "workflow",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "12b5d164-78d8-81ca-b38f-d23c4e08e621",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-10-26T04:12:00.000Z",
        "last_edited_time": "2024-11-28T02:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081371/uxcomic-imgs/12b5d164-78d8-81ca-b38f-d23c4e08e621.png",
            "expiry_time": "2026-10-04T09:11:33.120Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/12b5d164-78d8-81ca-b38f-d23c4e08e621"
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80e5-b04e-eea9746b7ace",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-12-22T04:55:00.000Z",
        "last_edited_time": "2024-12-22T05:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Làm trong nghề design này, chắc chắn chúng ta làm việc với idea rất nhiều, mọi người cùng thảo luận và đưa ra quyết định là chuyện cơm bữa, vậy làm sao để ta đánh giá & lựa chọn idea mà tất cả thành viên đều hài lòng & thấy nó make sense >> lí do thúc đẩy mình tìm hiểu chủ đề này.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Làm trong nghề design này, chắc chắn chúng ta làm việc với idea rất nhiều, mọi người cùng thảo luận và đưa ra quyết định là chuyện cơm bữa, vậy làm sao để ta đánh giá & lựa chọn idea mà tất cả thành viên đều hài lòng & thấy nó make sense >> lí do thúc đẩy mình tìm hiểu chủ đề này.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8060-b249-d7ab6028bc36",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-12-22T04:55:00.000Z",
        "last_edited_time": "2024-12-22T04:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-806e-802d-d72c7a813989",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-11-18T09:10:00.000Z",
        "last_edited_time": "2025-08-08T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tại sao chúng ta cần quyết định?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tại sao chúng ta cần quyết định?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80a6-8a77-f58f08d2fdab",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-11-23T08:57:00.000Z",
        "last_edited_time": "2024-11-24T07:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là vì ta có nhiều hơn một sự lựa chọn, mà ta không thể có hết tất cả.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là vì ta có nhiều hơn một sự lựa chọn, mà ta không thể có hết tất cả.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1675d164-78d8-8027-8129-f0343d65d033",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-12-25T04:45:00.000Z",
        "last_edited_time": "2025-03-03T01:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081373/uxcomic-imgs/1675d164-78d8-8027-8129-f0343d65d033.webp",
            "expiry_time": "2026-10-04T09:11:33.120Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1675d164-78d8-8027-8129-f0343d65d033"
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80c6-a2cc-f0ae73eeded2",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-11-23T08:57:00.000Z",
        "last_edited_time": "2024-12-25T04:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là vì yếu tố nhân quả, khi mọi hành động hiện tại đều có một hệ quả cho tương lai, mà ta thì không thể phân thân để đưa ra đồng thời 2 hành động",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là vì yếu tố nhân quả, khi mọi hành động hiện tại đều có một hệ quả cho tương lai, mà ta thì không thể phân thân để đưa ra đồng thời 2 hành động",
              "href": null
            }
          ],
          "color": "default",
          "list_start_index": 2
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80a1-a036-fb154bf02240",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-12-25T04:47:00.000Z",
        "last_edited_time": "2025-03-03T01:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081375/uxcomic-imgs/1675d164-78d8-80a1-a036-fb154bf02240.webp",
            "expiry_time": "2026-10-04T09:11:33.120Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1675d164-78d8-80a1-a036-fb154bf02240"
      },
      {
        "object": "block",
        "id": "1475d164-78d8-801e-93c6-c093304c98ea",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-11-23T08:52:00.000Z",
        "last_edited_time": "2024-12-25T04:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: có khi nhiều việc trong cuộc sống ta dường như không aware đến việc cần quyết định, rất có thể là do các việc đó đã được ai đó quyết định thay cho mình rồi, điều bạn cho là lẽ dĩ nhiên. Ví dụ: scope công việc của nghề do công ty, thị trường định hình lương của bạn, việc đi làm 8h,… “bèo dạt mây trôi” như thế không hẳn là xấu nhưng phải chấp nhận có khả năng sẽ mất thời gian, nhầm đường, đi vòng vòng như trong một khu rừng mà không có cái la bàn nào.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: có khi nhiều việc trong cuộc sống ta dường như không aware đến việc cần quyết định, rất có thể là do các việc đó đã được ai đó quyết định thay cho mình rồi, điều bạn cho là lẽ dĩ nhiên. Ví dụ: scope công việc của nghề do công ty, thị trường định hình lương của bạn, việc đi làm 8h,… “bèo dạt mây trôi” như thế không hẳn là xấu nhưng phải chấp nhận có khả năng sẽ mất thời gian, nhầm đường, đi vòng vòng như trong một khu rừng mà không có cái la bàn nào.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80e5-80b1-fe92366ef5bd",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-11-23T09:02:00.000Z",
        "last_edited_time": "2024-11-23T09:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80d5-bdda-d4224edc154e",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-11-23T14:29:00.000Z",
        "last_edited_time": "2025-08-08T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách chúng ta ra quyết định",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách chúng ta ra quyết định",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80b6-a8b7-f6b45a359a86",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-11-23T14:30:00.000Z",
        "last_edited_time": "2024-11-25T05:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "3 dạng quyết định:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3 dạng quyết định:",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-804b-8511-c0d02db716dc",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-11-23T14:32:00.000Z",
        "last_edited_time": "2024-11-25T10:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quyết định dựa trên lý trí:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quyết định dựa trên lý trí:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là những quyết định được đưa ra dựa trên phân tích logic, thông tin rõ ràng và kết quả có thể đoán trước. Thường cần thời gian để suy nghĩ. Vd: lựa chọn offer giữa các công ty.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là những quyết định được đưa ra dựa trên phân tích logic, thông tin rõ ràng và kết quả có thể đoán trước. Thường cần thời gian để suy nghĩ. Vd: lựa chọn offer giữa các công ty.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-805a-8578-cdbccbad4e6c",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-11-23T14:32:00.000Z",
        "last_edited_time": "2024-11-25T10:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quyết định dựa trên cảm xúc",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quyết định dựa trên cảm xúc",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": là những quyết định bị ảnh hưởng mạnh mẽ bởi cảm xúc, tâm trạng, hoặc các yếu tố tâm lý. Thường diễn ra nhanh. Vd: gu âm nhạc theo mood.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": là những quyết định bị ảnh hưởng mạnh mẽ bởi cảm xúc, tâm trạng, hoặc các yếu tố tâm lý. Thường diễn ra nhanh. Vd: gu âm nhạc theo mood.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-800d-ab7a-f91ac211c4d9",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-11-23T14:39:00.000Z",
        "last_edited_time": "2024-11-25T10:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quyết định dựa trên trực giác",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quyết định dựa trên trực giác",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": là những quyết định dựa trên kinh nghiệm & tiềm thức, bản năng của cá nhân. Thường diễn ra nhanh. Vd: khi gặp hoản hoạn, xu hướng của mình chắc chắn sẽ là quyết định “chạy ngay đi”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": là những quyết định dựa trên kinh nghiệm & tiềm thức, bản năng của cá nhân. Thường diễn ra nhanh. Vd: khi gặp hoản hoạn, xu hướng của mình chắc chắn sẽ là quyết định “chạy ngay đi”.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1485d164-78d8-80e3-ab12-c9e6e42c3e4b",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-11-24T07:37:00.000Z",
        "last_edited_time": "2024-11-25T04:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có thể thấy ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có thể thấy ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "thời gian",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "thời gian",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là yếu tố tác động quan trọng trong việc make decision, nếu chịu áp lực thời gian, khả năng ta sẽ ra quyết định thiếu đi sự suy nghĩ (lí trí).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là yếu tố tác động quan trọng trong việc make decision, nếu chịu áp lực thời gian, khả năng ta sẽ ra quyết định thiếu đi sự suy nghĩ (lí trí).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1495d164-78d8-8079-97f0-c5fcc1bb2cc3",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-11-25T05:26:00.000Z",
        "last_edited_time": "2024-11-25T05:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1495d164-78d8-804b-bda6-e5a3ff90cf3f",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-11-25T05:26:00.000Z",
        "last_edited_time": "2025-08-08T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "3 tác động đến việc mình quyết định",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3 tác động đến việc mình quyết định",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1495d164-78d8-80d1-8314-ff656df16195",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-11-25T05:28:00.000Z",
        "last_edited_time": "2024-11-25T05:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Này chỉ nói riêng cho các quyết định dựa trên lí trí nhé, vì 2 cái kia không có thời gian nghĩ kĩ mấy cái dưới đây đâu =)).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Này chỉ nói riêng cho các quyết định dựa trên lí trí nhé, vì 2 cái kia không có thời gian nghĩ kĩ mấy cái dưới đây đâu =)).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1495d164-78d8-8064-b13d-d8d97063a39b",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-11-25T05:28:00.000Z",
        "last_edited_time": "2024-11-25T05:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mục tiêu:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mục tiêu:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " một quyết định phải bắt nguồn từ mục tiêu rõ ràng. Đây là \"đích đến\" hoặc \"lý do\" khiến bạn phải đưa ra quyết định.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " một quyết định phải bắt nguồn từ mục tiêu rõ ràng. Đây là \"đích đến\" hoặc \"lý do\" khiến bạn phải đưa ra quyết định.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1495d164-78d8-8061-a6aa-da9f2548ec63",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-11-25T05:29:00.000Z",
        "last_edited_time": "2024-11-25T10:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dữ liệu và Thông tin (Data/Information): ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dữ liệu và Thông tin (Data/Information): ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "nếu bạn có tìm hiểu qua bài ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "nếu bạn có tìm hiểu qua bài ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "sense making",
                "link": {
                  "url": "/1195d16478d880cda21ff9d0e90ae7b8"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "sense making",
              "href": "/1195d16478d880cda21ff9d0e90ae7b8"
            },
            {
              "type": "text",
              "text": {
                "content": ", thì data & information sẽ tác động đến cách chúng ta hiểu, cái hiểu này dẫn đến thái độ & hành vi, và nó sẽ tác động lên cách ta quyết định. Yếu tố này rất quan trọng nên hãy cân nhắc trả lời các câu hỏi sau: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", thì data & information sẽ tác động đến cách chúng ta hiểu, cái hiểu này dẫn đến thái độ & hành vi, và nó sẽ tác động lên cách ta quyết định. Yếu tố này rất quan trọng nên hãy cân nhắc trả lời các câu hỏi sau: ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1,
        "children": [
          {
            "object": "block",
            "id": "1495d164-78d8-80dc-affb-d39e0cc24f68",
            "parent": {
              "type": "block_id",
              "block_id": "1495d164-78d8-8061-a6aa-da9f2548ec63"
            },
            "created_time": "2024-11-25T05:35:00.000Z",
            "last_edited_time": "2024-11-25T05:35:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Tôi đã thu thập đủ dữ liệu để đưa ra quyết định chưa?",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Tôi đã thu thập đủ dữ liệu để đưa ra quyết định chưa?",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1495d164-78d8-80fd-889f-c5616995bcac",
            "parent": {
              "type": "block_id",
              "block_id": "1495d164-78d8-8061-a6aa-da9f2548ec63"
            },
            "created_time": "2024-11-25T05:35:00.000Z",
            "last_edited_time": "2024-11-25T05:35:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Dữ liệu này có đáng tin cậy và có liên quan không?",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Dữ liệu này có đáng tin cậy và có liên quan không?",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1495d164-78d8-80ff-bdfd-f2165d7daa0d",
            "parent": {
              "type": "block_id",
              "block_id": "1495d164-78d8-8061-a6aa-da9f2548ec63"
            },
            "created_time": "2024-11-25T05:35:00.000Z",
            "last_edited_time": "2024-11-25T05:35:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Có những giả định nào trong dữ liệu cần kiểm chứng?",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Có những giả định nào trong dữ liệu cần kiểm chứng?",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1495d164-78d8-80f8-b1ca-e7710200c0af",
            "parent": {
              "type": "block_id",
              "block_id": "1495d164-78d8-8061-a6aa-da9f2548ec63"
            },
            "created_time": "2024-11-25T10:07:00.000Z",
            "last_edited_time": "2024-11-25T10:12:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Trong sense making cũng tồn tại một yếu tố tác động nữa đó là perception (thế giới quan), ta luôn chịu ảnh hưởng của thiên kiến, định kiến trong việc hiểu, nên để thực sự khách quan ta mới cần đến khái niệm “data-driven” là vậy.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Trong sense making cũng tồn tại một yếu tố tác động nữa đó là perception (thế giới quan), ta luôn chịu ảnh hưởng của thiên kiến, định kiến trong việc hiểu, nên để thực sự khách quan ta mới cần đến khái niệm “data-driven” là vậy.",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "1495d164-78d8-8027-a2c8-c2efada45d2a",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-11-25T05:34:00.000Z",
        "last_edited_time": "2024-12-10T01:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hậu quả và Tác động (Consequences/Impact): ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hậu quả và Tác động (Consequences/Impact): ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "mọi hành động ở hiện tại sẽ tác động đến tương lai (ngắn hạn hoặc dài hạn), dù vô thức hay cố ý ta luôn phán đoán trước độ hiệu quả cũng như các rủi ro trước khi ra quyết định làm gì đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "mọi hành động ở hiện tại sẽ tác động đến tương lai (ngắn hạn hoặc dài hạn), dù vô thức hay cố ý ta luôn phán đoán trước độ hiệu quả cũng như các rủi ro trước khi ra quyết định làm gì đó.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "1495d164-78d8-80fa-bcb7-e30fa654c01a",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-11-25T05:04:00.000Z",
        "last_edited_time": "2024-11-25T05:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kết quả của sự quyết định",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kết quả của sự quyết định",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " tồn tại dưới các hình thức sau: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " tồn tại dưới các hình thức sau: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "chọn /không chọn, giảm bớt/ tăng thêm, loại bỏ/ tạo mới",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "chọn /không chọn, giảm bớt/ tăng thêm, loại bỏ/ tạo mới",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ". Việc ta không làm gì cũng là một quyết định “án binh bất động” =)).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". Việc ta không làm gì cũng là một quyết định “án binh bất động” =)).",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-804d-a5ca-f533192543c1",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-12-23T09:44:00.000Z",
        "last_edited_time": "2024-12-23T09:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: theo mình quan sát thì thấy chúng ta thường không có thói quen bỏ, và trong product cũng vậy (ít nhất là trong các môi trường mình đã & đang làm việc), ta hãy sinh thêm feature này feature kia, hãy tìm cơ hội để improve nhưng rất ít khi mình thấy có một project nào để nhìn nhận lại cái nào chúng ta nên cắt bỏ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: theo mình quan sát thì thấy chúng ta thường không có thói quen bỏ, và trong product cũng vậy (ít nhất là trong các môi trường mình đã & đang làm việc), ta hãy sinh thêm feature này feature kia, hãy tìm cơ hội để improve nhưng rất ít khi mình thấy có một project nào để nhìn nhận lại cái nào chúng ta nên cắt bỏ.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-808c-9e1f-ec218f3b1868",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2025-05-13T01:56:00.000Z",
        "last_edited_time": "2025-05-13T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-80ff-8e97-cb53f8b43671",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2025-05-13T01:56:00.000Z",
        "last_edited_time": "2025-05-13T01:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu bạn có hứng thú thêm về cách chúng ta nên quyết định sao cho khôn ngoan hơn, thì hãy ghé xem phần 2 nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu bạn có hứng thú thêm về cách chúng ta nên quyết định sao cho khôn ngoan hơn, thì hãy ghé xem phần 2 nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ab5d164-78d8-8073-a20f-eaca94156a2a",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2025-03-03T01:40:00.000Z",
        "last_edited_time": "2025-03-03T01:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-81bb-a9ba-ca2b767259b2",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-10-26T04:12:00.000Z",
        "last_edited_time": "2024-10-26T04:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-8105-bc08-dbba88b55563",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-10-26T04:12:00.000Z",
        "last_edited_time": "2024-11-25T04:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://vietcetera.com/onboardy/3-ly-do-ban-thuong-xuyen-mat-nao-khi-can-dua-ra-quyet-dinh",
                "link": {
                  "url": "https://vietcetera.com/onboardy/3-ly-do-ban-thuong-xuyen-mat-nao-khi-can-dua-ra-quyet-dinh"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://vietcetera.com/onboardy/3-ly-do-ban-thuong-xuyen-mat-nao-khi-can-dua-ra-quyet-dinh",
              "href": "https://vietcetera.com/onboardy/3-ly-do-ban-thuong-xuyen-mat-nao-khi-can-dua-ra-quyet-dinh"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-8110-8315-f882a15fffdc",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-10-26T04:12:00.000Z",
        "last_edited_time": "2024-10-26T04:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-813d-a14a-dc03a0b7e638",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-10-26T04:12:00.000Z",
        "last_edited_time": "2024-10-26T04:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-80ac-93ce-ce8503266be2",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2025-05-13T01:38:00.000Z",
        "last_edited_time": "2025-05-13T01:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1f15d164-78d8-807b-a23b-c00515a22f7c"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Decision making (P2)",
              "href": "https://app.notion.com/p/1f15d16478d8807ba23bc00515a22f7c"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-81ae-a663-c1811392f1a8",
        "parent": {
          "type": "page_id",
          "page_id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
        },
        "created_time": "2024-10-26T04:12:00.000Z",
        "last_edited_time": "2024-11-25T05:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Smarter question for decision making",
              "href": "https://app.notion.com/p/1495d16478d880128e3cc8b2e4d92bda"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "14477ad8-7b47-470c-9af5-9bab88236d43",
    "created_time": "2024-09-15T07:32:00.000Z",
    "last_edited_time": "2026-07-26T02:17:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-09-15T07:32:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "3-Workflow",
          "color": "default"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 2
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2026-07-26T02:17:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "prxX",
          "name": "⚔️:2",
          "color": "yellow"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Take design feedback (P2)",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Take design feedback (P2)",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Take-design-feedback-P2-14477ad87b47470c9af59bab88236d43",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
      "name": "Workflow",
      "slug": "workflow",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "11e5d164-78d8-819b-a519-d4184f434224",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-13T04:03:00.000Z",
        "last_edited_time": "2024-10-26T13:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754878032/uxcomic-imgs/11e5d164-78d8-819b-a519-d4184f434224.png",
            "expiry_time": "2026-10-04T09:11:34.245Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/11e5d164-78d8-819b-a519-d4184f434224"
      },
      {
        "object": "block",
        "id": "2025d164-78d8-80ae-9057-d56b863b5c20",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2025-05-29T04:34:00.000Z",
        "last_edited_time": "2026-07-26T01:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình từng nghe qua một câu điểm giá trị nhất trong design là consult (tư vấn chuyên môn), để tư vấn là biết nên & không nên làm gì, việc này cũng rất đúng trong quá trình tackle feedback, không phải luôn gật đầu đồng ý với luận điểm đối phương, cũng không phải luôn defend cho idea của mình, mà là biết lúc nào nên & không nên nhận feedback ấy. Bài này mình sẽ cũng đi qua vài loại feedback trong design.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình từng nghe qua một câu điểm giá trị nhất trong design là consult (tư vấn chuyên môn), để tư vấn là biết nên & không nên làm gì, việc này cũng rất đúng trong quá trình tackle feedback, không phải luôn gật đầu đồng ý với luận điểm đối phương, cũng không phải luôn defend cho idea của mình, mà là biết lúc nào nên & không nên nhận feedback ấy. Bài này mình sẽ cũng đi qua vài loại feedback trong design.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2025d164-78d8-807d-b799-dcd5915d1af8",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2025-05-29T04:34:00.000Z",
        "last_edited_time": "2025-07-16T05:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-80f1-8d46-ee05927373e5",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T04:20:00.000Z",
        "last_edited_time": "2024-10-26T05:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thấy nó sao sao (Vague Feedback)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thấy nó sao sao (Vague Feedback)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-80ee-8d91-dc4bb507c041",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-27T04:37:00.000Z",
        "last_edited_time": "2024-11-16T03:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-80ab-8fad-df01c3c3d19c",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T04:22:00.000Z",
        "last_edited_time": "2024-10-26T04:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Anh A: khi dùng hoặc nhìn qua bản thiết kế, anh cho hay: “a thấy này sao sao”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Anh A: khi dùng hoặc nhìn qua bản thiết kế, anh cho hay: “a thấy này sao sao”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-80c9-a154-c6ed153e90fb",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T04:23:00.000Z",
        "last_edited_time": "2024-10-26T04:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Designer: dạ anh có thể làm rõ hơn không?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Designer: dạ anh có thể làm rõ hơn không?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-80fd-a23a-dc7b1ec523c8",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T04:24:00.000Z",
        "last_edited_time": "2024-10-26T04:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Anh A: anh thấy cái card này lạ lạ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Anh A: anh thấy cái card này lạ lạ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-80f8-9e5d-e1d23b5c3d22",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T04:25:00.000Z",
        "last_edited_time": "2024-10-26T04:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Designer: anh thấy nó lạ như thế nào?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Designer: anh thấy nó lạ như thế nào?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-800e-a55c-e7961e773879",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T04:25:00.000Z",
        "last_edited_time": "2024-10-27T04:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Anh A: anh thấy nó như một cái hình hay banner, không biết là nó có thể click được",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Anh A: anh thấy nó như một cái hình hay banner, không biết là nó có thể click được",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-8072-ba6a-db92a806d91b",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T04:28:00.000Z",
        "last_edited_time": "2026-07-26T01:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Designer: anh có nguồn nào cho em tham khảo không? Hay mình sẽ tự kiếm các ref để clarify ý đó của ảnh. (“Show don’t tell” là một cách trực quan hơn, để tránh hiểu nhầm ý của nhau).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Designer: anh có nguồn nào cho em tham khảo không? Hay mình sẽ tự kiếm các ref để clarify ý đó của ảnh. (“Show don’t tell” là một cách trực quan hơn, để tránh hiểu nhầm ý của nhau).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1d45d164-78d8-80d7-9b65-fe3b9d791886",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2025-04-13T04:10:00.000Z",
        "last_edited_time": "2025-04-13T04:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13f5d164-78d8-8022-be66-e10007c13f06",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-11-15T01:55:00.000Z",
        "last_edited_time": "2025-04-13T04:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhiệm vụ của mình trong tình huống này là cố gắng tìm hiểu xem họ thấy nó sao sao là ở khía cạnh nào, cụ thể là gì, điều gì khiến họ cảm thấy thế, lí do đằng sau của sự cảm nhận ấy là gì.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhiệm vụ của mình trong tình huống này là cố gắng tìm hiểu xem họ thấy nó sao sao là ở khía cạnh nào, cụ thể là gì, điều gì khiến họ cảm thấy thế, lí do đằng sau của sự cảm nhận ấy là gì.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "1405d164-78d8-800d-b3b9-d230ae11aa46",
            "parent": {
              "type": "block_id",
              "block_id": "13f5d164-78d8-8022-be66-e10007c13f06"
            },
            "created_time": "2024-11-16T03:47:00.000Z",
            "last_edited_time": "2026-07-26T01:33:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Tip: thông thường các feedback có “tính từ” là khả năng cao cần phải được làm rõ thêm, vd: cần tốt hơn, cần joyful hơn,…nhưng trong hình dung của họ thì như thế nào là “tốt hơn”, như thế nào là “joyful hơn”.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Tip: thông thường các feedback có “tính từ” là khả năng cao cần phải được làm rõ thêm, vd: cần tốt hơn, cần joyful hơn,…nhưng trong hình dung của họ thì như thế nào là “tốt hơn”, như thế nào là “joyful hơn”.",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "1d45d164-78d8-8031-be47-ebfb2b804f28",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2025-04-13T04:10:00.000Z",
        "last_edited_time": "2025-04-13T04:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-8082-8b8e-d3224b62e637",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T04:27:00.000Z",
        "last_edited_time": "2024-11-16T03:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> Designer: lúc này bạn có thêm thông tin đủ rõ để xem xét lại bản design & cân nhắc xem có cần thiết để cải thiện không, vd trong trường hợp trên mình sẽ có 2 problem: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> Designer: lúc này bạn có thêm thông tin đủ rõ để xem xét lại bản design & cân nhắc xem có cần thiết để cải thiện không, vd trong trường hợp trên mình sẽ có 2 problem: ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80aa-9201-c6101fdb1d1c",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-11-16T03:45:00.000Z",
        "last_edited_time": "2024-11-16T03:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "nhìn không giống card",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "nhìn không giống card",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1405d164-78d8-80b0-89c9-ddfe77ff56e7",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-11-16T03:46:00.000Z",
        "last_edited_time": "2024-11-16T03:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "không biết click được",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "không biết click được",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8070-b7c7-d972745bd8d0",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-11-16T03:46:00.000Z",
        "last_edited_time": "2024-11-16T03:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "vậy bạn nên làm rõ nó như một cái card hay chỉ cần thêm indicator để tăng tính affordance.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "vậy bạn nên làm rõ nó như một cái card hay chỉ cần thêm indicator để tăng tính affordance.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-8093-b81f-c5020e2a52ca",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T05:26:00.000Z",
        "last_edited_time": "2024-10-26T05:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-8054-9a27-f57a23e521bc",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T04:31:00.000Z",
        "last_edited_time": "2024-10-26T05:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nên theo hướng A (Solution-Oriented Feedback)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nên theo hướng A (Solution-Oriented Feedback)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-80a7-9923-d3c5eac783a6",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T04:43:00.000Z",
        "last_edited_time": "2024-10-26T04:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong buổi họp nếu ai đó propose cho bạn một solution A, ví dụ như:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong buổi họp nếu ai đó propose cho bạn một solution A, ví dụ như:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-80a9-ac34-c12057da0061",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T04:44:00.000Z",
        "last_edited_time": "2024-10-26T05:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Hãy đổi màu nút này thành đỏ cho nổi bật.”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Hãy đổi màu nút này thành đỏ cho nổi bật.”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-80ad-89c1-c5c2b8c7e17a",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T04:44:00.000Z",
        "last_edited_time": "2024-10-26T04:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Màn hình trông trống trải quá, có thể thêm thông tin không?”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Màn hình trông trống trải quá, có thể thêm thông tin không?”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-8025-8aa2-fec2c4c9fb2b",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T04:44:00.000Z",
        "last_edited_time": "2024-11-15T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Có cách nào làm cho thiết kế giống như [tên ứng dụng trên thị trường] không?”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Có cách nào làm cho thiết kế giống như [tên ứng dụng trên thị trường] không?”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-8071-be99-d49abbad46b3",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2025-01-14T11:03:00.000Z",
        "last_edited_time": "2025-01-14T11:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-8057-b255-d5ab5b5373cb",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T04:50:00.000Z",
        "last_edited_time": "2024-10-26T04:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Việc trước tiên là khoan hãy phán xét ngay độ hiệu quả của feedback hoặc ngược lại là đồng ý ngay với solution mà họ đưa ra, bạn cần thời gian để cân nhắc thêm, có thể là ngay trong hoặc sau cuộc họp đó. Điều mình có thể làm ở đây trước là ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Việc trước tiên là khoan hãy phán xét ngay độ hiệu quả của feedback hoặc ngược lại là đồng ý ngay với solution mà họ đưa ra, bạn cần thời gian để cân nhắc thêm, có thể là ngay trong hoặc sau cuộc họp đó. Điều mình có thể làm ở đây trước là ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "đào sâu hơn cách mà họ form lên solution",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "đào sâu hơn cách mà họ form lên solution",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " ấy.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ấy.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-802a-994f-f9f0109569f7",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2025-01-14T11:12:00.000Z",
        "last_edited_time": "2025-01-14T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-80e4-a794-cc6b3ee45aad",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T04:50:00.000Z",
        "last_edited_time": "2026-07-26T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để đào sâu, mình phải hỏi. Mình hỏi để làm rõ lại tính intention của họ là gì, họ lựa chọn giải pháp này dựa trên tiêu chí gì, cách họ nghĩ về solution đang serve objective chung hay không.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để đào sâu, mình phải hỏi. Mình hỏi để làm rõ lại tính intention của họ là gì, họ lựa chọn giải pháp này dựa trên tiêu chí gì, cách họ nghĩ về solution đang serve objective chung hay không.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2455d164-78d8-807a-969d-c724b119c9b3",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2025-08-04T04:23:00.000Z",
        "last_edited_time": "2025-08-04T04:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“So what? & why that?”",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“So what? & why that?”",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là câu hỏi tốt nhất cho trường hợp này.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là câu hỏi tốt nhất cho trường hợp này.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-8008-87dc-e835d0520d85",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-27T04:41:00.000Z",
        "last_edited_time": "2026-07-26T01:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi có thêm những thông tin trên bạn sẽ đủ dữ kiện hơn để đánh giá solution ấy, đánh giá xem liệu solution họ đưa ra có mapping tốt với problem hay không, liệu có điểm mạnh nào trong đề xuất ấy mà ta có thể cân nhắc hay không. Còn nếu feedback ấy không trên tiêu chí gì cụ thể, không solve problem, hay serve objective gì cả thì đừng ngần ngại phản biện.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi có thêm những thông tin trên bạn sẽ đủ dữ kiện hơn để đánh giá solution ấy, đánh giá xem liệu solution họ đưa ra có mapping tốt với problem hay không, liệu có điểm mạnh nào trong đề xuất ấy mà ta có thể cân nhắc hay không. Còn nếu feedback ấy không trên tiêu chí gì cụ thể, không solve problem, hay serve objective gì cả thì đừng ngần ngại phản biện.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-8091-81a2-f06461c45ce4",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T05:26:00.000Z",
        "last_edited_time": "2024-10-26T05:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-8045-aa5b-e29148623e9f",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T04:39:00.000Z",
        "last_edited_time": "2024-10-26T05:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nghi ngờ, không đồng ý với hướng propose của bạn (Doubtful feedback)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nghi ngờ, không đồng ý với hướng propose của bạn (Doubtful feedback)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11e5d164-78d8-815a-a598-c383b96fe563",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-13T04:03:00.000Z",
        "last_edited_time": "2024-10-27T04:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sẽ có tình huống, các stakeholder cảm thấy solution bạn đưa ra chưa hiệu quả, thiếu niềm tin vào nó. Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sẽ có tình huống, các stakeholder cảm thấy solution bạn đưa ra chưa hiệu quả, thiếu niềm tin vào nó. Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-8047-b532-e2562535d573",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T05:19:00.000Z",
        "last_edited_time": "2024-10-26T05:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Bạn có chắc người dùng sẽ hiểu tính năng này không?”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Bạn có chắc người dùng sẽ hiểu tính năng này không?”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-8087-8248-f44d1cc2b753",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T05:19:00.000Z",
        "last_edited_time": "2024-10-26T05:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Tôi không nghĩ cách này sẽ phù hợp với người dùng của chúng ta.”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Tôi không nghĩ cách này sẽ phù hợp với người dùng của chúng ta.”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3a95d164-78d8-8067-adfc-edc8ba4c1853",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2026-07-26T01:43:00.000Z",
        "last_edited_time": "2026-07-26T01:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Việc đổi lại ưu tiên nút này sẽ để lại trade-off gì?”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Việc đổi lại ưu tiên nút này sẽ để lại trade-off gì?”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-80b6-a4bb-c2f7734ded9e",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2025-01-14T11:12:00.000Z",
        "last_edited_time": "2025-01-14T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-80ec-b7a0-c2b0915b2dde",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T05:26:00.000Z",
        "last_edited_time": "2024-10-26T05:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lúc này, điều cần làm trước tiên là xem liệu mình đã có đủ ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lúc này, điều cần làm trước tiên là xem liệu mình đã có đủ ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "rationale, reference, research, best practice, case study, principle…",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "rationale, reference, research, best practice, case study, principle…",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " để back up cho design solution mình chưa (nếu chưa thì đó là do mình đang yếu rationale). Còn nếu mình thấy đã có đủ, thì liệu nó có liên quan đến ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " để back up cho design solution mình chưa (nếu chưa thì đó là do mình đang yếu rationale). Còn nếu mình thấy đã có đủ, thì liệu nó có liên quan đến ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cách truyền đạt ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cách truyền đạt ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "không, đã rõ ý, đã đủ thuyết phục, đã make sense hay chưa. Nhiệm vụ ở trường hợp này là cung cấp thêm thông tin để giúp nó trở nên ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "không, đã rõ ý, đã đủ thuyết phục, đã make sense hay chưa. Nhiệm vụ ở trường hợp này là cung cấp thêm thông tin để giúp nó trở nên ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "thuyết phục",
                "link": {
                  "url": "/1215d16478d8809d89b0e84bbf170b05"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "thuyết phục",
              "href": "/1215d16478d8809d89b0e84bbf170b05"
            },
            {
              "type": "text",
              "text": {
                "content": " hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " hơn.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-80fb-979c-c68c8c8e3a99",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2025-01-14T11:12:00.000Z",
        "last_edited_time": "2025-01-14T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-80d4-8ed7-f8d6a76b4510",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T05:25:00.000Z",
        "last_edited_time": "2026-07-26T01:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thử tưởng tượng cách bạn ra solution như một phép tính: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thử tưởng tượng cách bạn ra solution như một phép tính: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "(A+B)/C-D=Solution",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "(A+B)/C-D=Solution",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", thì mình phải dẫn họ đi qua từng cái A,B,C,D có những gì và mối liên hệ giữa chúng (các phép tinh +,-,x,/) ở đây là gì. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", thì mình phải dẫn họ đi qua từng cái A,B,C,D có những gì và mối liên hệ giữa chúng (các phép tinh +,-,x,/) ở đây là gì. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-803c-b141-ebb1eade1171",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2025-01-14T11:04:00.000Z",
        "last_edited_time": "2026-07-26T01:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Show ra cách bạn đặt vấn đề (problem statement), cách mapping solution với problem đó, cách mà mình transform solution ấy thành artifact (IA/UI/Flow/Interaction patten) như thế nào.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Show ra cách bạn đặt vấn đề (problem statement), cách mapping solution với problem đó, cách mà mình transform solution ấy thành artifact (IA/UI/Flow/Interaction patten) như thế nào.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-8046-987f-cf6059c491fa",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T05:26:00.000Z",
        "last_edited_time": "2024-10-26T05:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-8081-ade6-d0636efdd2df",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T05:14:00.000Z",
        "last_edited_time": "2024-10-26T05:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cảm nhận chủ quan (Personal Preference Feedback)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cảm nhận chủ quan (Personal Preference Feedback)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-807d-8ca7-d8b815264947",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T05:15:00.000Z",
        "last_edited_time": "2024-10-26T05:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đôi khi mình cũng sẽ gặp phải những feedback rất mang tính chất cá nhân, đây là cái mình ghét nhất 😡. Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đôi khi mình cũng sẽ gặp phải những feedback rất mang tính chất cá nhân, đây là cái mình ghét nhất 😡. Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-8014-8e41-cc54ede025e6",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T05:27:00.000Z",
        "last_edited_time": "2024-10-26T05:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Tôi thích giao diện này sáng hơn”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Tôi thích giao diện này sáng hơn”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-803c-a69e-dcb0cd80f8bf",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T05:27:00.000Z",
        "last_edited_time": "2026-07-26T01:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Tôi nghĩ hình ảnh nên to hơn”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Tôi nghĩ hình ảnh nên to hơn”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3a95d164-78d8-809c-8aa6-ec4d44aa09a9",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2026-07-26T01:51:00.000Z",
        "last_edited_time": "2026-07-26T01:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Tôi thấy nó không sang gì cả”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Tôi thấy nó không sang gì cả”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-80e1-ab98-ed9cb8d13f5b",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2025-01-14T11:04:00.000Z",
        "last_edited_time": "2025-01-14T11:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-80ca-9072-cd5ec4eb4106",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-26T05:34:00.000Z",
        "last_edited_time": "2025-01-14T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vì feedback này rất chủ quan, hay bị bias, cần đánh giá feedback đó đưa ra có đang dựa trên mục tiêu chung hay không, có dưới góc nhìn khách quan (không có data/research gì cả).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vì feedback này rất chủ quan, hay bị bias, cần đánh giá feedback đó đưa ra có đang dựa trên mục tiêu chung hay không, có dưới góc nhìn khách quan (không có data/research gì cả).",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1d45d164-78d8-8045-a45d-f12e1eb944cf",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2025-04-13T04:09:00.000Z",
        "last_edited_time": "2025-04-13T04:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-802c-94e7-e9c494fb9209",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2025-01-14T11:11:00.000Z",
        "last_edited_time": "2026-07-26T01:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nên điều mình cần làm ở đây là phải đặt ra những câu hỏi để kéo họ ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nên điều mình cần làm ở đây là phải đặt ra những câu hỏi để kéo họ ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "quay về align với objective, với problem, target user là ai, context of use như thế nào,",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "quay về align với objective, với problem, target user là ai, context of use như thế nào,",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " yêu cầu họ cung cấp những rationale, lí luận rõ ràng cho feedback ấy. Mình cần tránh là phản biện lại bằng những ý cũng mang tính cá nhân (vd: “tôi không thấy nó không sang, nó sang mà”, điều này chỉ khiến 2 bên conflict thêm, hãy cố gắng dùng",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " yêu cầu họ cung cấp những rationale, lí luận rõ ràng cho feedback ấy. Mình cần tránh là phản biện lại bằng những ý cũng mang tính cá nhân (vd: “tôi không thấy nó không sang, nó sang mà”, điều này chỉ khiến 2 bên conflict thêm, hãy cố gắng dùng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " các lí lẽ khách quan ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " các lí lẽ khách quan ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "hơn để bàn luận.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "hơn để bàn luận.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3a95d164-78d8-80c5-a735-c1cb1647cf36",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2026-07-26T01:53:00.000Z",
        "last_edited_time": "2026-07-26T02:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vì feedback khá là chủ quan, nên nó có thể đến only từ đối phương, đôi khi ta cần kiểm chứng thêm liệu những người khác có same cảm nhận hay không (lưu ý: hãy lấy feedback ẩn danh / một không gian riêng, mình sẽ muốn né trường hợp các người BCD bị bias nghe theo ý kiến của người A).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vì feedback khá là chủ quan, nên nó có thể đến only từ đối phương, đôi khi ta cần kiểm chứng thêm liệu những người khác có same cảm nhận hay không (lưu ý: hãy lấy feedback ẩn danh / một không gian riêng, mình sẽ muốn né trường hợp các người BCD bị bias nghe theo ý kiến của người A).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3a95d164-78d8-8088-a79b-d31cc5ca1ef6",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2026-07-26T02:06:00.000Z",
        "last_edited_time": "2026-07-26T02:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "3a95d164-78d8-8052-9d9d-dbe6d883f0bd",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2026-07-26T02:06:00.000Z",
        "last_edited_time": "2026-07-26T02:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Final thought",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Final thought",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3a95d164-78d8-806c-bbe8-ddef20274072",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2026-07-26T02:06:00.000Z",
        "last_edited_time": "2026-07-26T02:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Take design feedback cũng quan trọng không kém gì như lúc ta cần xác định rõ vấn đề trước khi bắt tay vào design. Vì nếu ta dễ dàng commit quá thì công sức vắt óc suy nghĩ về solution trước đó trở nên công cốc.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Take design feedback cũng quan trọng không kém gì như lúc ta cần xác định rõ vấn đề trước khi bắt tay vào design. Vì nếu ta dễ dàng commit quá thì công sức vắt óc suy nghĩ về solution trước đó trở nên công cốc.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3a95d164-78d8-80b7-98c0-edf809f66e7f",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2026-07-26T02:08:00.000Z",
        "last_edited_time": "2026-07-26T02:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Càng lên level cao, việc master skill này lại càng quan trọng, vì ta sẽ là người cần đứng ra defend design, đảm bảo cho design value,… Việc này nên được đầu tư nghiêm túc như lúc mình ngồi phân tích problem, mò mẫm solution, như mình nói ở đầu bài, phần value nhất của design không nằm ở output, nó nằm ở tư vấn, hiện tại 50% công sức mình dùng để generate ra design solution, 50% công sức còn lại để mình tự challenge lại design solution đó & chuẩn bị các kịch bản đối ứng feedback.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Càng lên level cao, việc master skill này lại càng quan trọng, vì ta sẽ là người cần đứng ra defend design, đảm bảo cho design value,… Việc này nên được đầu tư nghiêm túc như lúc mình ngồi phân tích problem, mò mẫm solution, như mình nói ở đầu bài, phần value nhất của design không nằm ở output, nó nằm ở tư vấn, hiện tại 50% công sức mình dùng để generate ra design solution, 50% công sức còn lại để mình tự challenge lại design solution đó & chuẩn bị các kịch bản đối ứng feedback.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3a95d164-78d8-8063-a768-eb0cb6a16f95",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2026-07-26T02:15:00.000Z",
        "last_edited_time": "2026-07-26T02:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quyển sách “Articulate design solution” sẽ rất helpful đấy, các bạn có thể tìm đọc nhé. Hoặc có thể xem clip này.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quyển sách “Articulate design solution” sẽ rất helpful đấy, các bạn có thể tìm đọc nhé. Hoặc có thể xem clip này.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3a95d164-78d8-8060-8df6-c34b7065599e",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2026-07-26T02:16:00.000Z",
        "last_edited_time": "2026-07-26T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "video",
        "video": {
          "caption": [],
          "type": "external",
          "external": {
            "url": "https://youtu.be/99e6d2purlo?si=687eZ6yTLoE_6Mum"
          }
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11e5d164-78d8-8125-906f-d6db5964ea4d",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-13T04:03:00.000Z",
        "last_edited_time": "2024-10-13T04:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "11e5d164-78d8-81e3-98c0-c1f0905a2fd7",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-13T04:03:00.000Z",
        "last_edited_time": "2024-10-13T04:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11e5d164-78d8-8180-bde1-e4f2dcbb3f19",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-13T04:03:00.000Z",
        "last_edited_time": "2024-10-27T04:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://designlab.com/blog/design-critique-checklist-for-ux-designers",
                "link": {
                  "url": "https://designlab.com/blog/design-critique-checklist-for-ux-designers"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://designlab.com/blog/design-critique-checklist-for-ux-designers",
              "href": "https://designlab.com/blog/design-critique-checklist-for-ux-designers"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11e5d164-78d8-8169-ac0f-fcadc11af90a",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-13T04:03:00.000Z",
        "last_edited_time": "2024-10-27T04:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.interaction-design.org/literature/article/how-to-get-meaningful-design-feedback-from-your-clients",
                "link": {
                  "url": "https://www.interaction-design.org/literature/article/how-to-get-meaningful-design-feedback-from-your-clients"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.interaction-design.org/literature/article/how-to-get-meaningful-design-feedback-from-your-clients",
              "href": "https://www.interaction-design.org/literature/article/how-to-get-meaningful-design-feedback-from-your-clients"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1d45d164-78d8-8008-acd2-e57c54c0b6b2",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2025-04-13T04:09:00.000Z",
        "last_edited_time": "2025-04-13T04:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://mmaxence.me/blog/posts/design_criticism/",
                "link": {
                  "url": "https://mmaxence.me/blog/posts/design_criticism/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://mmaxence.me/blog/posts/design_criticism/",
              "href": "https://mmaxence.me/blog/posts/design_criticism/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22c5d164-78d8-8087-ab0f-eb1aaddd1765",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2025-07-10T06:41:00.000Z",
        "last_edited_time": "2025-07-10T06:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.linkedin.com/posts/mattprzegietka_deal-with-feedback-like-a-pro-ugcPost-7302713514236743680-RN1U?",
                "link": {
                  "url": "https://www.linkedin.com/posts/mattprzegietka_deal-with-feedback-like-a-pro-ugcPost-7302713514236743680-RN1U?utm_source=share&utm_medium=member_desktop&rcm=ACoAACTxzsYBO4mptTzgsbAc8dNNiYnc142O2IA"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.linkedin.com/posts/mattprzegietka_deal-with-feedback-like-a-pro-ugcPost-7302713514236743680-RN1U?",
              "href": "https://www.linkedin.com/posts/mattprzegietka_deal-with-feedback-like-a-pro-ugcPost-7302713514236743680-RN1U?utm_source=share&utm_medium=member_desktop&rcm=ACoAACTxzsYBO4mptTzgsbAc8dNNiYnc142O2IA"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23a5d164-78d8-80ce-81fa-f268b926f898",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2025-07-24T04:08:00.000Z",
        "last_edited_time": "2025-07-24T04:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://substack.com/home/post/p-167068597",
                "link": {
                  "url": "https://substack.com/home/post/p-167068597"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://substack.com/home/post/p-167068597",
              "href": "https://substack.com/home/post/p-167068597"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3845d164-78d8-8037-b31e-c151d7597116",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2026-06-19T10:28:00.000Z",
        "last_edited_time": "2026-06-19T10:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.uxtigers.com/post/design-crit",
                "link": {
                  "url": "https://www.uxtigers.com/post/design-crit"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.uxtigers.com/post/design-crit",
              "href": "https://www.uxtigers.com/post/design-crit"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11e5d164-78d8-81b6-8b80-dee779bbe52d",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-13T04:03:00.000Z",
        "last_edited_time": "2024-10-13T04:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "11e5d164-78d8-81eb-98ae-e3669fa07b93",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-10-13T04:03:00.000Z",
        "last_edited_time": "2024-12-30T16:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2305d164-78d8-8082-8497-c2cbee05080a",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2025-07-14T02:26:00.000Z",
        "last_edited_time": "2025-07-14T02:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "22c5d164-78d8-8090-8563-e4ee428f9a9a"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Take design feedback (P1)",
              "href": "https://app.notion.com/p/22c5d16478d880908563e4ee428f9a9a"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80d5-b52f-fa0842aed993",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-11-17T03:29:00.000Z",
        "last_edited_time": "2024-11-17T03:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1405d164-78d8-801f-aad4-f558038c6ba3"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Principle of Communication",
              "href": "https://app.notion.com/p/1405d16478d8801faad4f558038c6ba3"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8053-b717-fb81edee8360",
        "parent": {
          "type": "page_id",
          "page_id": "14477ad8-7b47-470c-9af5-9bab88236d43"
        },
        "created_time": "2024-11-17T03:29:00.000Z",
        "last_edited_time": "2024-11-17T03:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "95727332-bdb3-4f63-a0cd-f9023732995d",
    "created_time": "2024-09-15T07:32:00.000Z",
    "last_edited_time": "2025-05-21T06:01:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-8063-8779-e6407a7b6f8d"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Publish": {
        "id": "%3D%60aq",
        "type": "checkbox",
        "checkbox": true
      },
      "Created time": {
        "id": "%3Dey%3C",
        "type": "created_time",
        "created_time": "2024-09-15T07:32:00.000Z"
      },
      "View": {
        "id": "RR%5BL",
        "type": "number",
        "number": null
      },
      "Like": {
        "id": "Xs%3DD",
        "type": "number",
        "number": null
      },
      "Tag": {
        "id": "%5DcPA",
        "type": "select",
        "select": {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "1-Understanding",
          "color": "orange"
        }
      },
      "ID": {
        "id": "b%3CwT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "CL",
          "number": 3
        }
      },
      "Last edited": {
        "id": "hTE%5E",
        "type": "last_edited_time",
        "last_edited_time": "2025-05-21T06:01:00.000Z"
      },
      "Type": {
        "id": "haHm",
        "type": "select",
        "select": {
          "id": "bx`f",
          "name": "⚓:3",
          "color": "purple"
        }
      },
      "Share": {
        "id": "oZ~u",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "vz%7D%3F",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Questioning (P1)",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Questioning (P1)",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Questioning-P1-95727332bdb34f63a0cdf9023732995d",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "1045d164-78d8-8055-80fc-eb5e062c0cda",
      "name": "Collaboration",
      "slug": "collaboration",
      "icon": "🤝",
      "order": 4,
      "created_time": "2024-09-17T02:13:00.000Z",
      "tags": [
        {
          "id": "715a3f1f-8d2e-426b-a2d8-86f0e34dfc02",
          "name": "Communication",
          "slug": "communication",
          "order": 2
        },
        {
          "id": "93eb03d2-df0b-4702-b9b7-62b519119ed1",
          "name": "Workflow",
          "slug": "workflow",
          "order": 3
        },
        {
          "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
          "name": "Understanding",
          "slug": "understanding",
          "order": 1
        }
      ]
    },
    "tag": {
      "id": "33f5d15b-12d5-421b-b756-116b5b0cbce8",
      "name": "Understanding",
      "slug": "understanding",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "1405d164-78d8-8191-a0c4-d6829c00c961",
        "parent": {
          "type": "page_id",
          "page_id": "95727332-bdb3-4f63-a0cd-f9023732995d"
        },
        "created_time": "2024-11-16T08:08:00.000Z",
        "last_edited_time": "2024-11-16T08:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081378/uxcomic-imgs/1405d164-78d8-8191-a0c4-d6829c00c961.png",
            "expiry_time": "2026-10-04T09:11:34.962Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1405d164-78d8-8191-a0c4-d6829c00c961"
      },
      {
        "object": "block",
        "id": "1405d164-78d8-8141-96ce-e25d5496d805",
        "parent": {
          "type": "page_id",
          "page_id": "95727332-bdb3-4f63-a0cd-f9023732995d"
        },
        "created_time": "2024-11-16T08:08:00.000Z",
        "last_edited_time": "2024-12-30T12:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tại sao chúng ta hỏi?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tại sao chúng ta hỏi?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-80d8-a957-fc64d5233f3a",
        "parent": {
          "type": "page_id",
          "page_id": "95727332-bdb3-4f63-a0cd-f9023732995d"
        },
        "created_time": "2024-11-18T15:55:00.000Z",
        "last_edited_time": "2024-11-24T01:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ta hỏi vì ta muốn biết, muốn hiểu gì đó. Vậy sự hiểu biết được hình thành như thế nào?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ta hỏi vì ta muốn biết, muốn hiểu gì đó. Vậy sự hiểu biết được hình thành như thế nào?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8033-8ae3-d0f7a2eb62c4",
        "parent": {
          "type": "page_id",
          "page_id": "95727332-bdb3-4f63-a0cd-f9023732995d"
        },
        "created_time": "2025-05-21T06:00:00.000Z",
        "last_edited_time": "2025-05-21T06:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1435d164-78d8-8060-beef-ead79fb33b14",
        "parent": {
          "type": "page_id",
          "page_id": "95727332-bdb3-4f63-a0cd-f9023732995d"
        },
        "created_time": "2024-11-19T11:16:00.000Z",
        "last_edited_time": "2025-05-21T06:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081380/uxcomic-imgs/1435d164-78d8-8060-beef-ead79fb33b14.webp",
            "expiry_time": "2026-10-04T09:11:34.962Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1435d164-78d8-8060-beef-ead79fb33b14"
      },
      {
        "object": "block",
        "id": "1425d164-78d8-803d-aa95-d43e9a038d2d",
        "parent": {
          "type": "page_id",
          "page_id": "95727332-bdb3-4f63-a0cd-f9023732995d"
        },
        "created_time": "2024-11-18T16:42:00.000Z",
        "last_edited_time": "2025-05-21T05:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dựa theo mô hình",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dựa theo mô hình",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Data to Wisdom",
                "link": {
                  "url": "/1195d16478d880cda21ff9d0e90ae7b8"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Data to Wisdom",
              "href": "/1195d16478d880cda21ff9d0e90ae7b8"
            },
            {
              "type": "text",
              "text": {
                "content": " thì các thành tố để hình thành nên hiểu biết là data & information & cách chúng ta make sense chúng. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " thì các thành tố để hình thành nên hiểu biết là data & information & cách chúng ta make sense chúng. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8007-9b1f-d7d6721d7684",
        "parent": {
          "type": "page_id",
          "page_id": "95727332-bdb3-4f63-a0cd-f9023732995d"
        },
        "created_time": "2025-05-21T05:57:00.000Z",
        "last_edited_time": "2025-05-21T06:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước mắt để có được 2 thứ data & information , mình có 2 cách thôi: 1 là thụ động, 2 là chủ động. Và ta sẽ bàn đến cách thứ 2 - chủ động, nó là việc mình để tâm quan sát, lắng nghe, cảm nhận và quan trọng nhất là đặt câu hỏi.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước mắt để có được 2 thứ data & information , mình có 2 cách thôi: 1 là thụ động, 2 là chủ động. Và ta sẽ bàn đến cách thứ 2 - chủ động, nó là việc mình để tâm quan sát, lắng nghe, cảm nhận và quan trọng nhất là đặt câu hỏi.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-80fe-b85b-dca6a2bcc3a8",
        "parent": {
          "type": "page_id",
          "page_id": "95727332-bdb3-4f63-a0cd-f9023732995d"
        },
        "created_time": "2025-05-21T05:58:00.000Z",
        "last_edited_time": "2025-05-21T06:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau đó là câu chuyện luận các data point đã có - cách ta nối mối liên hệ của chúng, thì câu hỏi cũng là khởi đầu cho việc này (vd: làm sao để biết nó là tốt nhất, cách nó tác động qua lại ra sao, cái gì là yếu tố cần, cái gì là yếu tố đủ).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau đó là câu chuyện luận các data point đã có - cách ta nối mối liên hệ của chúng, thì câu hỏi cũng là khởi đầu cho việc này (vd: làm sao để biết nó là tốt nhất, cách nó tác động qua lại ra sao, cái gì là yếu tố cần, cái gì là yếu tố đủ).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8079-a36a-f02f8884742d",
        "parent": {
          "type": "page_id",
          "page_id": "95727332-bdb3-4f63-a0cd-f9023732995d"
        },
        "created_time": "2024-11-18T16:50:00.000Z",
        "last_edited_time": "2025-05-21T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nên nếu nghĩ đơn giản câu hỏi có 3 nhiệm vụ chính là:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nên nếu nghĩ đơn giản câu hỏi có 3 nhiệm vụ chính là:",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8019-8992-c369f57b9675",
        "parent": {
          "type": "page_id",
          "page_id": "95727332-bdb3-4f63-a0cd-f9023732995d"
        },
        "created_time": "2024-11-18T16:55:00.000Z",
        "last_edited_time": "2025-05-21T05:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Biết",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Biết",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": giúp tìm kiếm thêm & làm rõ thêm thông tin (who, what, where, when,…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": giúp tìm kiếm thêm & làm rõ thêm thông tin (who, what, where, when,…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8043-ad27-cbec4e7b344d",
        "parent": {
          "type": "page_id",
          "page_id": "95727332-bdb3-4f63-a0cd-f9023732995d"
        },
        "created_time": "2024-11-18T16:55:00.000Z",
        "last_edited_time": "2025-05-21T05:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hiểu",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hiểu",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": giúp hình thành được mối liên hệ giữa các thông tin (why, how, so what,…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": giúp hình thành được mối liên hệ giữa các thông tin (why, how, so what,…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fa5d164-78d8-8022-8bc0-ffc9ad3779aa",
        "parent": {
          "type": "page_id",
          "page_id": "95727332-bdb3-4f63-a0cd-f9023732995d"
        },
        "created_time": "2025-05-21T05:52:00.000Z",
        "last_edited_time": "2025-05-21T05:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khơi mở tư duy",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khơi mở tư duy",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": có những câu hỏi mang tính hướng đường chỉ lối hơn, vì sao? Vì nó giúp ta tập trung tư duy theo một chiều hướng khác (what if,…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": có những câu hỏi mang tính hướng đường chỉ lối hơn, vì sao? Vì nó giúp ta tập trung tư duy theo một chiều hướng khác (what if,…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1435d164-78d8-80e1-a036-cf8b564f429d",
        "parent": {
          "type": "page_id",
          "page_id": "95727332-bdb3-4f63-a0cd-f9023732995d"
        },
        "created_time": "2024-11-19T02:07:00.000Z",
        "last_edited_time": "2024-11-19T02:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1435d164-78d8-8082-aeec-fc2164153d14",
        "parent": {
          "type": "page_id",
          "page_id": "95727332-bdb3-4f63-a0cd-f9023732995d"
        },
        "created_time": "2024-11-19T01:22:00.000Z",
        "last_edited_time": "2024-11-20T05:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một điểm rất thú vị nữa là câu hỏi mang một phép thần thông có khả năng tác động đến thời gian, nó giúp chúng ta ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một điểm rất thú vị nữa là câu hỏi mang một phép thần thông có khả năng tác động đến thời gian, nó giúp chúng ta ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "chậm lại.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "chậm lại.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1435d164-78d8-802b-ada5-e6cf740be4d4",
        "parent": {
          "type": "page_id",
          "page_id": "95727332-bdb3-4f63-a0cd-f9023732995d"
        },
        "created_time": "2024-11-19T01:32:00.000Z",
        "last_edited_time": "2025-05-21T05:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi bạn đang suy nghĩ về một câu hỏi, nó sẽ tạm đóng băng các luồng suy nghĩ khác để nhường lại sự tập trung tìm cho việc tìm câu trả lời.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi bạn đang suy nghĩ về một câu hỏi, nó sẽ tạm đóng băng các luồng suy nghĩ khác để nhường lại sự tập trung tìm cho việc tìm câu trả lời.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1435d164-78d8-8072-9e9f-e462bfaad68e",
        "parent": {
          "type": "page_id",
          "page_id": "95727332-bdb3-4f63-a0cd-f9023732995d"
        },
        "created_time": "2024-11-19T01:24:00.000Z",
        "last_edited_time": "2025-05-21T05:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đó là vì câu hỏi kích thích việc tư duy, nó tạm dừng quá trình chế độ lái tự động của não bộ (auto pilot - chế độ này hiểu ngắn gọn là vì não ta có xu hướng lười làm việc, ta thường không cần mấy suy nghĩ hay sự tập trung, chúng ta hành động theo thói quen, bản năng >> để não tiết kiệm năng lượng).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đó là vì câu hỏi kích thích việc tư duy, nó tạm dừng quá trình chế độ lái tự động của não bộ (auto pilot - chế độ này hiểu ngắn gọn là vì não ta có xu hướng lười làm việc, ta thường không cần mấy suy nghĩ hay sự tập trung, chúng ta hành động theo thói quen, bản năng >> để não tiết kiệm năng lượng).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1435d164-78d8-8016-b4ed-d409dea4975e",
        "parent": {
          "type": "page_id",
          "page_id": "95727332-bdb3-4f63-a0cd-f9023732995d"
        },
        "created_time": "2024-11-19T01:48:00.000Z",
        "last_edited_time": "2024-11-19T01:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-80a7-a45f-d146f5bd0820",
        "parent": {
          "type": "page_id",
          "page_id": "95727332-bdb3-4f63-a0cd-f9023732995d"
        },
        "created_time": "2024-11-18T09:11:00.000Z",
        "last_edited_time": "2024-11-18T09:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1435d164-78d8-805c-ae0b-c0d38e672a84",
        "parent": {
          "type": "page_id",
          "page_id": "95727332-bdb3-4f63-a0cd-f9023732995d"
        },
        "created_time": "2024-11-19T01:49:00.000Z",
        "last_edited_time": "2024-11-19T01:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1435d164-78d8-8004-930c-e9f3fede9fe4"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Questioning (P2)",
              "href": "https://app.notion.com/p/1435d16478d88004930ce9f3fede9fe4"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8012-8c5e-cc9a18be3631",
        "parent": {
          "type": "page_id",
          "page_id": "95727332-bdb3-4f63-a0cd-f9023732995d"
        },
        "created_time": "2024-11-18T10:39:00.000Z",
        "last_edited_time": "2024-11-19T01:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1425d164-78d8-80f2-9f44-e27115c54d8b"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Questioning (P3)",
              "href": "https://app.notion.com/p/1425d16478d880f29f44e27115c54d8b"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1435d164-78d8-80eb-ba20-eb9860f1172e",
        "parent": {
          "type": "page_id",
          "page_id": "95727332-bdb3-4f63-a0cd-f9023732995d"
        },
        "created_time": "2024-11-19T01:49:00.000Z",
        "last_edited_time": "2024-12-30T12:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sense making",
              "href": "https://app.notion.com/p/1195d16478d880cda21ff9d0e90ae7b8"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "10f5d164-78d8-804f-b8ea-e2a265424273",
    "created_time": "2024-09-28T03:59:00.000Z",
    "last_edited_time": "2025-08-15T10:43:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "page_id",
      "page_id": "a58596ad-902a-49e3-9a81-fdb9b84b92d9"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "title": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "UX comic - Introduction",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "UX comic - Introduction",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/UX-comic-Introduction-10f5d16478d8804fb8eae2a265424273",
    "public_url": null,
    "archived": false,
    "request_id": "ae3f31e6-d1e4-4136-89b7-f9e941f0a9bf",
    "content": [
      {
        "object": "block",
        "id": "1145d164-78d8-8054-b6ed-ee06674bf4ed",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-03T14:54:00.000Z",
        "last_edited_time": "2024-10-03T14:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081079/uxcomic-imgs/1145d164-78d8-8054-b6ed-ee06674bf4ed.png",
            "expiry_time": "2026-10-04T09:11:35.618Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1145d164-78d8-8054-b6ed-ee06674bf4ed"
      },
      {
        "object": "block",
        "id": "1175d164-78d8-8062-b2b6-e5d5c1f1d3b4",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-06T13:42:00.000Z",
        "last_edited_time": "2024-10-06T13:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tụi mình ở đây để chia sẻ các kiến thức, góc nhìn cá nhân về hành trình làm nghề UX/UI.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tụi mình ở đây để chia sẻ các kiến thức, góc nhìn cá nhân về hành trình làm nghề UX/UI.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "👋"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-80f5-ba2a-dc7da74d909e",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-09-28T04:03:00.000Z",
        "last_edited_time": "2025-01-14T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình xin giới thiệu chút, mình có background công việc trong graphic design, illustrator, sau đó mình chuyển sang lĩnh vực UX/UI, và chắc cũng như đa phần mọi người đó là học vài khoá, tự mày mò đọc blog để học hỏi thêm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình xin giới thiệu chút, mình có background công việc trong graphic design, illustrator, sau đó mình chuyển sang lĩnh vực UX/UI, và chắc cũng như đa phần mọi người đó là học vài khoá, tự mày mò đọc blog để học hỏi thêm.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-8022-90a4-e47dd0056496",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-14T02:05:00.000Z",
        "last_edited_time": "2025-01-14T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80b8-ba44-f0b7bbe1c82c",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-22T16:01:00.000Z",
        "last_edited_time": "2024-12-25T02:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuy nhiên trong quá trình tự học, mình hay gặp phải các vấn đề sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuy nhiên trong quá trình tự học, mình hay gặp phải các vấn đề sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-80c7-9e98-d40601cb5d76",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-09-28T04:11:00.000Z",
        "last_edited_time": "2024-12-25T02:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "😵 Theo thời gian, kiến thức gia tăng, mọi thứ dần trở nên rối ren, chi chít như màn nhện,  nó như cái cảnh mình vào khu rừng mà không có map, cứ xoay vòng vòng, vòng vòng, vòng vòng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "😵 Theo thời gian, kiến thức gia tăng, mọi thứ dần trở nên rối ren, chi chít như màn nhện,  nó như cái cảnh mình vào khu rừng mà không có map, cứ xoay vòng vòng, vòng vòng, vòng vòng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-8055-ba1e-cdeabdc6e536",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-09-28T04:11:00.000Z",
        "last_edited_time": "2024-12-25T02:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "🫣 Mặc dù đã cất công collect, tự học các thứ nhưng đến lúc làm thực tế thì lại quên bén đi, xong tự chửi bản thân: “học chi cho lắm không áp dụng được gì”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "🫣 Mặc dù đã cất công collect, tự học các thứ nhưng đến lúc làm thực tế thì lại quên bén đi, xong tự chửi bản thân: “học chi cho lắm không áp dụng được gì”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80e9-a617-fed34699865b",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T02:40:00.000Z",
        "last_edited_time": "2024-12-25T02:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "😫 Đến lúc nhớ để áp dụng rồi thì lại có khi không phù hợp, kết quả không như  khuôn mẫu sách vở.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "😫 Đến lúc nhớ để áp dụng rồi thì lại có khi không phù hợp, kết quả không như  khuôn mẫu sách vở.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80bd-821c-d1385c95355a",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-22T14:48:00.000Z",
        "last_edited_time": "2024-12-23T03:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081080/uxcomic-imgs/1645d164-78d8-80bd-821c-d1385c95355a.jpg",
            "expiry_time": "2026-10-04T09:11:35.618Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1645d164-78d8-80bd-821c-d1385c95355a"
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-80c2-a417-ca89e359e251",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-27T04:48:00.000Z",
        "last_edited_time": "2024-12-22T16:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1175d164-78d8-802e-b0b2-e9f603db4448",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-06T07:32:00.000Z",
        "last_edited_time": "2025-01-14T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Rồi tình cờ, mình có nghe đến kĩ thuật Feyman trong việc học - đại ý là học làm sao để bạn có thể dạy lại được cho người khác. Sau đó mình bắt đầu áp dụng, tập thói quen nghiền ngẫm, tập hệ thống hoá, để “ôn bài”, để biết thêm những thứ mà mình tưởng là mình đã biết >> 💡 project được sinh ra",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Rồi tình cờ, mình có nghe đến kĩ thuật Feyman trong việc học - đại ý là học làm sao để bạn có thể dạy lại được cho người khác. Sau đó mình bắt đầu áp dụng, tập thói quen nghiền ngẫm, tập hệ thống hoá, để “ôn bài”, để biết thêm những thứ mà mình tưởng là mình đã biết >> 💡 project được sinh ra",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-801d-bbfe-cbe5f489c720",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-10T02:05:00.000Z",
        "last_edited_time": "2025-01-12T14:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Share your knowledge and teach others — it benefits both of you!",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Share your knowledge and teach others — it benefits both of you!",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13f5d164-78d8-801a-871e-c9d89a1c3ec0",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-11-15T02:12:00.000Z",
        "last_edited_time": "2024-11-15T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-80ac-ba44-fb1e73088960",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-14T02:37:00.000Z",
        "last_edited_time": "2025-08-14T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "✏️ Other tiny things",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "✏️ Other tiny things",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-8041-b4ef-f5c09e17be85",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T02:57:00.000Z",
        "last_edited_time": "2025-01-14T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lê thê vậy đủ rồi. Nếu bạn có thêm chút thời gian, hãy xem thêm các chú thích ở dưới nhé, vì nó liên quan đến giá trị “hệ thống hoá” mà mình đang muốn offer khi làm blog này.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lê thê vậy đủ rồi. Nếu bạn có thêm chút thời gian, hãy xem thêm các chú thích ở dưới nhé, vì nó liên quan đến giá trị “hệ thống hoá” mà mình đang muốn offer khi làm blog này.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8033-b108-debe1f729659",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:55:00.000Z",
        "last_edited_time": "2025-08-14T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755136730/uxcomic-imgs/24f5d164-78d8-8033-b108-debe1f729659.png",
            "expiry_time": "2026-10-04T09:11:35.619Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/24f5d164-78d8-8033-b108-debe1f729659"
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80cf-9e31-eba6bd4663a0",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:02:00.000Z",
        "last_edited_time": "2025-08-14T01:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1175d164-78d8-807a-bc07-ce1b50fe378a",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-06T13:38:00.000Z",
        "last_edited_time": "2025-08-14T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "📢 ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "📢 ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Disclaimer",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Disclaimer",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8071-af14-c321c266389f",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:47:00.000Z",
        "last_edited_time": "2025-08-15T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "các bài viết này là tổng hợp của những kiến thức lượm lặt trên mạng + chatGPT + góc độ, quan sát cá nhân >> mình vẫn có thể sai >> nên đừng vội chấp nhận hoặc tin hết những gì mình viết (mặc dù mình đều cố gắng tìm hiểu các nguồn đáng tin cậy và kèm link reference cho từng bài viết nếu có).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "các bài viết này là tổng hợp của những kiến thức lượm lặt trên mạng + chatGPT + góc độ, quan sát cá nhân >> mình vẫn có thể sai >> nên đừng vội chấp nhận hoặc tin hết những gì mình viết (mặc dù mình đều cố gắng tìm hiểu các nguồn đáng tin cậy và kèm link reference cho từng bài viết nếu có).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8070-a7db-d7a5898e615d",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:47:00.000Z",
        "last_edited_time": "2025-08-15T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hãy xem mình như một người bạn, một đồng nghiệp như đang trò chuyện với bạn trong một buổi ăn trưa, một buổi hẹn cafe, chúng mình ở đây để chia sẻ và học hỏi nhau trên con đường mày mò & cải thiện quá trình làm nghề UX/UI.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hãy xem mình như một người bạn, một đồng nghiệp như đang trò chuyện với bạn trong một buổi ăn trưa, một buổi hẹn cafe, chúng mình ở đây để chia sẻ và học hỏi nhau trên con đường mày mò & cải thiện quá trình làm nghề UX/UI.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80be-bd5b-fde96187a589",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:48:00.000Z",
        "last_edited_time": "2025-08-15T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Again luôn recheck các thông tin, luận điểm của mình nhé. Cảm ơn mọi người nhiều 😜.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Again luôn recheck các thông tin, luận điểm của mình nhé. Cảm ơn mọi người nhiều 😜.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80b0-a0cf-c3d3ac509af9",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:03:00.000Z",
        "last_edited_time": "2025-01-14T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1815d164-78d8-8043-8c86-f3f060cfaa2c",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-20T03:25:00.000Z",
        "last_edited_time": "2025-01-20T03:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Contact",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Contact",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80e8-8428-f6dcc343a5ec",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T02:45:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình rất vui lòng nếu nhận được những góc nhìn khác từ các bạn, nếu bạn muốn liên hệ hay chia sẻ gì với mình thêm, hay muốn mình share topic gì khác, hãy để lại lời nhắn qua:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình rất vui lòng nếu nhận được những góc nhìn khác từ các bạn, nếu bạn muốn liên hệ hay chia sẻ gì với mình thêm, hay muốn mình share topic gì khác, hãy để lại lời nhắn qua:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1c15d164-78d8-80dc-bc47-ff02b571cf37",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-03-25T05:59:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1815d164-78d8-8006-8bb0-f9639445d848",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-20T03:23:00.000Z",
        "last_edited_time": "2025-01-20T03:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thread",
                "link": {
                  "url": "https://www.threads.net/@ux_share_choi?hl=vi"
                }
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thread",
              "href": "https://www.threads.net/@ux_share_choi?hl=vi"
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "💬"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1815d164-78d8-801b-b02c-f6a970beae36",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-20T03:23:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Linkedin",
                "link": {
                  "url": "https://www.linkedin.com/in/minhhuynh95/"
                }
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Linkedin",
              "href": "https://www.linkedin.com/in/minhhuynh95/"
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "💼"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1c15d164-78d8-80aa-b4ae-d81e4bdbad4e",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-03-25T05:59:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-8081-8eb4-f9373214ab36",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:10:00.000Z",
        "last_edited_time": "2024-12-25T03:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081083/uxcomic-imgs/1675d164-78d8-8081-8eb4-f9373214ab36.png",
            "expiry_time": "2026-10-04T09:11:35.658Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1675d164-78d8-8081-8eb4-f9373214ab36"
      },
      {
        "object": "block",
        "id": "1675d164-78d8-802d-a902-c546642f72dc",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:03:00.000Z",
        "last_edited_time": "2024-12-28T03:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mong các bài viết này có chút hữu ích cho bạn 🥰. Dự án được built with ❤️‍🔥 bởi ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mong các bài viết này có chút hữu ích cho bạn 🥰. Dự án được built with ❤️‍🔥 bởi ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Minh",
                "link": {
                  "url": "https://www.linkedin.com/in/minhhuynh95/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Minh",
              "href": "https://www.linkedin.com/in/minhhuynh95/"
            },
            {
              "type": "text",
              "text": {
                "content": " & ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " & ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Hùng",
                "link": {
                  "url": "https://www.linkedin.com/in/vhung71/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hùng",
              "href": "https://www.linkedin.com/in/vhung71/"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "26aaa722-7e34-4293-bf96-4eaa09a6a24d",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-11-23T07:53:00.000Z",
        "last_edited_time": "2024-11-23T07:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-80ef-a681-d83a4e28308a",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-27T04:50:00.000Z",
        "last_edited_time": "2024-10-27T04:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "2615d164-78d8-800e-b3f7-d657130a78a7",
    "created_time": "2025-09-01T02:30:00.000Z",
    "last_edited_time": "2025-09-01T03:24:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "fd3cd36d-73dd-4dee-8bd5-d159d6600124"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "View": {
        "id": "ATSa",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "A%5Bqc",
        "type": "select",
        "select": {
          "id": "ZxZE",
          "name": "♟️:1",
          "color": "red"
        }
      },
      "Last edited time": {
        "id": "DMgm",
        "type": "last_edited_time",
        "last_edited_time": "2025-09-01T03:24:00.000Z"
      },
      "Publish": {
        "id": "FSnx",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "_tsp",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "g%7BBg",
        "type": "created_time",
        "created_time": "2025-09-01T02:30:00.000Z"
      },
      "Share": {
        "id": "hp~_",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "m%7C%40x",
        "type": "number",
        "number": null
      },
      "Formula": {
        "id": "re%3BE",
        "type": "formula",
        "formula": {
          "type": "number",
          "number": 1
        }
      },
      "Tag": {
        "id": "%7CAvQ",
        "type": "select",
        "select": {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "4-Random",
          "color": "gray"
        }
      },
      "ID": {
        "id": "~RYT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FD",
          "number": 57
        }
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Chơi cờ dạy gì mình?",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Chơi cờ dạy gì mình?",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Ch-i-c-d-y-g-m-nh-2615d16478d8800eb3f7d657130a78a7",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "5cacdbff-b9e2-4973-b565-ec1ae4327ec9",
      "name": "Fundamental",
      "slug": "fundamental",
      "icon": "🌞",
      "order": 2,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "Product",
          "slug": "product",
          "order": 1
        },
        {
          "id": "156ef770-14db-4170-b1d7-95a2fbdf62ba",
          "name": "User",
          "slug": "user",
          "order": 2
        },
        {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "Design",
          "slug": "design",
          "order": 3
        },
        {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "Random",
          "slug": "random",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "9290a1c0-fd10-40c6-a821-56f188976357",
      "name": "Random",
      "slug": "random",
      "order": 4
    },
    "content": [
      {
        "object": "block",
        "id": "2615d164-78d8-801a-9235-d170e0389ed2",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T03:24:00.000Z",
        "last_edited_time": "2025-09-01T03:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756697272/uxcomic-imgs/2615d164-78d8-801a-9235-d170e0389ed2.png",
            "expiry_time": "2026-10-04T09:11:37.007Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2615d164-78d8-801a-9235-d170e0389ed2"
      },
      {
        "object": "block",
        "id": "2615d164-78d8-8090-96f9-de0b540bc4eb",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T02:30:00.000Z",
        "last_edited_time": "2025-09-01T02:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một hôm, nghĩ vẩn vơ về việc sắp tới nên làm gì tiếp cho con đường sự nghiệp, thì tình cờ pop up lên trong đầu việc ta make decision như chơi một ván cờ. Hm thấy cũng thú vị, nên bài này khám phá thêm xem có gì thú vị với phép ẩn dụ đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một hôm, nghĩ vẩn vơ về việc sắp tới nên làm gì tiếp cho con đường sự nghiệp, thì tình cờ pop up lên trong đầu việc ta make decision như chơi một ván cờ. Hm thấy cũng thú vị, nên bài này khám phá thêm xem có gì thú vị với phép ẩn dụ đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-80c2-98a4-d54ba612822e",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T02:33:00.000Z",
        "last_edited_time": "2025-09-01T02:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-8066-91fc-efb27bc06458",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T02:30:00.000Z",
        "last_edited_time": "2025-09-01T02:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các con cờ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các con cờ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-80b3-8de2-ddb28ac275cf",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T02:30:00.000Z",
        "last_edited_time": "2025-09-01T02:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trên bộ cờ, ta có nhiều con cờ, mỗi con cờ có function và cách hoạt động riêng, có những giới hạn riêng, tác động của nó cũng tùy theo tình thế ván cờ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trên bộ cờ, ta có nhiều con cờ, mỗi con cờ có function và cách hoạt động riêng, có những giới hạn riêng, tác động của nó cũng tùy theo tình thế ván cờ.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-8015-8765-f37c3c836e0a",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T02:35:00.000Z",
        "last_edited_time": "2025-09-01T02:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giống như ngoài đời, ta có nhiều cách, nhưng khó cái là ta có nhận diện được nó hay không, tương tự từng “cách” cũng là từng con cờ. Giá trị của “cách” đó tuỳ theo tình thế ván cờ & những dự định của chúng ta.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giống như ngoài đời, ta có nhiều cách, nhưng khó cái là ta có nhận diện được nó hay không, tương tự từng “cách” cũng là từng con cờ. Giá trị của “cách” đó tuỳ theo tình thế ván cờ & những dự định của chúng ta.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-804a-a947-eeef0fd5e5af",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T02:30:00.000Z",
        "last_edited_time": "2025-09-01T02:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một nước đi…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một nước đi…",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-8022-8054-d79bb1580a23",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T02:30:00.000Z",
        "last_edited_time": "2025-09-01T02:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trên bàn cờ, việc ta chọn đi một bước với con cờ này = với việc mình chọn không đi những con cờ khác.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trên bàn cờ, việc ta chọn đi một bước với con cờ này = với việc mình chọn không đi những con cờ khác.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-80de-9cd9-eff3d7dc2275",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T02:38:00.000Z",
        "last_edited_time": "2025-09-01T02:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong cuộc sống cũng vậy, việc ta chọn hướng đi này đồng nghĩa với việc bỏ chọn những hướng đi khác, tuy nhiên liệu mình có nhận ra hay không. Cái này người ta hay gọi là opportunity cost.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong cuộc sống cũng vậy, việc ta chọn hướng đi này đồng nghĩa với việc bỏ chọn những hướng đi khác, tuy nhiên liệu mình có nhận ra hay không. Cái này người ta hay gọi là opportunity cost.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-8002-a3f9-e4c7fbdc8f2f",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T02:39:00.000Z",
        "last_edited_time": "2025-09-01T02:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Và nước đi đó khôn ngoan hay khờ dại tuỳ thuộc vào việc phán đoán, tiên liệu của chúng ta đồng thời còn phụ thuộc vào nước đi của đối phương có mở ra cơ hội hay thử thách mới cho ta hay không.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Và nước đi đó khôn ngoan hay khờ dại tuỳ thuộc vào việc phán đoán, tiên liệu của chúng ta đồng thời còn phụ thuộc vào nước đi của đối phương có mở ra cơ hội hay thử thách mới cho ta hay không.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-8011-beee-f77dec29c5e3",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T02:41:00.000Z",
        "last_edited_time": "2025-09-01T02:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Việc mọi người hay nói người chơi cờ hay là tạo thế, là biết tính trước n bước, thì ngoài đời cũng thế, liệu ta có nhận diện được tình thế, liệu có biết cái nào là short term vs long term affect.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Việc mọi người hay nói người chơi cờ hay là tạo thế, là biết tính trước n bước, thì ngoài đời cũng thế, liệu ta có nhận diện được tình thế, liệu có biết cái nào là short term vs long term affect.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-804e-8ac3-cd23707960cb",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T02:42:00.000Z",
        "last_edited_time": "2025-09-01T02:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đừng xem thường con tốt",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đừng xem thường con tốt",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-8077-a237-f3c318d99473",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T02:43:00.000Z",
        "last_edited_time": "2025-09-01T02:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong ván cờ chắc không khó để bạn gặp phải những tình huống con tốt trở nên khó chịu hay có sức nguy hiểm cỡ nào khi vào đúng tình thế.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong ván cờ chắc không khó để bạn gặp phải những tình huống con tốt trở nên khó chịu hay có sức nguy hiểm cỡ nào khi vào đúng tình thế.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-8051-99e4-c3b9798cd5b7",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T02:45:00.000Z",
        "last_edited_time": "2025-09-01T02:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong cuộc sống cũng vậy, đôi khi các hành vi nhỏ, các minor things có thể tác động khá lớn mà đôi khi bạn cũng bất ngờ đấy.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong cuộc sống cũng vậy, đôi khi các hành vi nhỏ, các minor things có thể tác động khá lớn mà đôi khi bạn cũng bất ngờ đấy.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-80d8-81cf-da7ce9ace028",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T02:46:00.000Z",
        "last_edited_time": "2025-09-01T02:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lấy ví dụ: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lấy ví dụ: ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-80c8-957f-fbd78c88cff8",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T02:53:00.000Z",
        "last_edited_time": "2025-09-01T03:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Case của bên Booking (app đặt phòng trực tuyến), họ thay đổi microcopy của nút từ “Book” sang “Check availability” đã khiến user đỡ thấy áp lực hơn khi click, vì nó giảm việc “lo rằng sẽ phải thanh toán ngay”. Kết quả sau khi A/B testing cho thấy tỉ lệ conversion tăng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Case của bên Booking (app đặt phòng trực tuyến), họ thay đổi microcopy của nút từ “Book” sang “Check availability” đã khiến user đỡ thấy áp lực hơn khi click, vì nó giảm việc “lo rằng sẽ phải thanh toán ngay”. Kết quả sau khi A/B testing cho thấy tỉ lệ conversion tăng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-801f-a389-f349a6158e6f",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T02:48:00.000Z",
        "last_edited_time": "2025-09-01T03:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tình thế & sự thích ứng",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tình thế & sự thích ứng",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-8072-a1f5-d53c8c5bb7d4",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T02:48:00.000Z",
        "last_edited_time": "2025-09-01T02:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nãy giờ viết trên kia có mention đến chữ “tình thế“ rất nhiều, ai chơi cờ cũng sẽ nắm rất rõ từ đó tác động thế nào đến mọi quyết định của từng nước đi.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nãy giờ viết trên kia có mention đến chữ “tình thế“ rất nhiều, ai chơi cờ cũng sẽ nắm rất rõ từ đó tác động thế nào đến mọi quyết định của từng nước đi.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-80e9-b61f-ce26a6208f6d",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T02:49:00.000Z",
        "last_edited_time": "2025-09-01T02:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong cuộc sống cũng thế, mặc dù có rất nhiều ví dụ, bài học thành công, nhiều framework, nhiều tactics. Nhưng nothing one size fit all, cụm từ “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong cuộc sống cũng thế, mặc dù có rất nhiều ví dụ, bài học thành công, nhiều framework, nhiều tactics. Nhưng nothing one size fit all, cụm từ “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "it’s depends",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "it’s depends",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "” mô tả việc ta phải hiểu rõ tình huống, context khi ấy để có những kế sách đối ứng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” mô tả việc ta phải hiểu rõ tình huống, context khi ấy để có những kế sách đối ứng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-8089-8f51-d2d7802d4ff1",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T02:52:00.000Z",
        "last_edited_time": "2025-09-01T02:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mà để nhận diện được tình thế có dễ không? Không. Một người chơi cờ phải kinh qua nhiều ván mới biết tình thế đó là gì, hoặc họ phải tính trước được n thứ mới nhận ra nó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mà để nhận diện được tình thế có dễ không? Không. Một người chơi cờ phải kinh qua nhiều ván mới biết tình thế đó là gì, hoặc họ phải tính trước được n thứ mới nhận ra nó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-80ac-aac9-ff4c79a52bbd",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T03:01:00.000Z",
        "last_edited_time": "2025-09-01T03:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thế cờ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thế cờ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-80dc-b7a5-c4ab14319509",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T03:01:00.000Z",
        "last_edited_time": "2025-09-01T03:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thế cờ không được tạo ra chỉ bởi một con cờ, nó là tổ hợp của cả những con cờ của mình & đối thủ trên bàn cờ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thế cờ không được tạo ra chỉ bởi một con cờ, nó là tổ hợp của cả những con cờ của mình & đối thủ trên bàn cờ.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-80ac-8cc7-cbbb34e921c1",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T03:02:00.000Z",
        "last_edited_time": "2025-09-01T03:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tương tự trong cuộc sống cũng vậy. Thử nghĩ xem một lần bạn đang trong một tình thế nào ấy, nó là tổ hợp của bạn, của đối phương, của môi trường, của thời điểm tình huống khi ấy.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tương tự trong cuộc sống cũng vậy. Thử nghĩ xem một lần bạn đang trong một tình thế nào ấy, nó là tổ hợp của bạn, của đối phương, của môi trường, của thời điểm tình huống khi ấy.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-8067-bc97-f8478b16cc0f",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T03:03:00.000Z",
        "last_edited_time": "2025-09-01T03:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đâu đó làm mình liên tưởng đến Ikigai, nếu mình được nằm trong 4 vòng tròn đó, thì “thế” của mình đang rất mạnh, ta trở nên “dễ sống” hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đâu đó làm mình liên tưởng đến Ikigai, nếu mình được nằm trong 4 vòng tròn đó, thì “thế” của mình đang rất mạnh, ta trở nên “dễ sống” hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-8008-b357-eb5c3984d30d",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T02:30:00.000Z",
        "last_edited_time": "2025-09-01T02:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-8029-864c-fef08a7a8522",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T02:30:00.000Z",
        "last_edited_time": "2025-09-01T02:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-805d-b6b8-c0d83f474481",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T02:30:00.000Z",
        "last_edited_time": "2025-09-01T02:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Decision making (P1)",
              "href": "https://app.notion.com/p/b2deb93698dc4fafaadc9cfcb4a6c302"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2615d164-78d8-801b-80b6-c0401caa87ac",
        "parent": {
          "type": "page_id",
          "page_id": "2615d164-78d8-800e-b3f7-d657130a78a7"
        },
        "created_time": "2025-09-01T02:30:00.000Z",
        "last_edited_time": "2025-09-01T02:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1495d164-78d8-8012-8e3c-c8b2e4d92bda"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Smarter question for decision making",
              "href": "https://app.notion.com/p/1495d16478d880128e3cc8b2e4d92bda"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "2095d164-78d8-8053-8f74-c9eb6baeca79",
    "created_time": "2025-06-05T12:26:00.000Z",
    "last_edited_time": "2025-08-17T01:28:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "fd3cd36d-73dd-4dee-8bd5-d159d6600124"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "View": {
        "id": "ATSa",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "A%5Bqc",
        "type": "select",
        "select": {
          "id": "VaqQ",
          "name": "⚔️:3",
          "color": "blue"
        }
      },
      "Last edited time": {
        "id": "DMgm",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-17T01:28:00.000Z"
      },
      "Publish": {
        "id": "FSnx",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "_tsp",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "g%7BBg",
        "type": "created_time",
        "created_time": "2025-06-05T12:26:00.000Z"
      },
      "Share": {
        "id": "hp~_",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "m%7C%40x",
        "type": "number",
        "number": null
      },
      "Formula": {
        "id": "re%3BE",
        "type": "formula",
        "formula": {
          "type": "number",
          "number": 1
        }
      },
      "Tag": {
        "id": "%7CAvQ",
        "type": "select",
        "select": {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "4-Random",
          "color": "gray"
        }
      },
      "ID": {
        "id": "~RYT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FD",
          "number": 50
        }
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Lập luận vs Tranh luận",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Lập luận vs Tranh luận",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/L-p-lu-n-vs-Tranh-lu-n-2095d16478d880538f74c9eb6baeca79",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "5cacdbff-b9e2-4973-b565-ec1ae4327ec9",
      "name": "Fundamental",
      "slug": "fundamental",
      "icon": "🌞",
      "order": 2,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "Product",
          "slug": "product",
          "order": 1
        },
        {
          "id": "156ef770-14db-4170-b1d7-95a2fbdf62ba",
          "name": "User",
          "slug": "user",
          "order": 2
        },
        {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "Design",
          "slug": "design",
          "order": 3
        },
        {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "Random",
          "slug": "random",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "9290a1c0-fd10-40c6-a821-56f188976357",
      "name": "Random",
      "slug": "random",
      "order": 4
    },
    "content": [
      {
        "object": "block",
        "id": "5392ea4c-a511-4a2c-a7a6-39af62c658e6",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T09:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754722405/uxcomic-imgs/5392ea4c-a511-4a2c-a7a6-39af62c658e6.png",
            "expiry_time": "2026-10-04T09:11:37.418Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/5392ea4c-a511-4a2c-a7a6-39af62c658e6"
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8024-a068-e0a86c862594",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T06:43:00.000Z",
        "last_edited_time": "2025-08-10T00:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là một designer, ta làm việc với ý tưởng và việc phải thuyết phục, tranh luận, defend idea diễn ra hàng ngày.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là một designer, ta làm việc với ý tưởng và việc phải thuyết phục, tranh luận, defend idea diễn ra hàng ngày.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24b5d164-78d8-80fa-b998-f4f89f3ebc77",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-10T00:29:00.000Z",
        "last_edited_time": "2025-08-10T00:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong những lúc ấy, nếu bạn đã từng cảm thấy bức bối không tìm được cách diễn đạt, thấy tự ti trong lúc mở miệng tranh luận, thấy chính mình còn đang không rõ ràng…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong những lúc ấy, nếu bạn đã từng cảm thấy bức bối không tìm được cách diễn đạt, thấy tự ti trong lúc mở miệng tranh luận, thấy chính mình còn đang không rõ ràng…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24b5d164-78d8-8044-a44a-faed8e521bf6",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-10T00:34:00.000Z",
        "last_edited_time": "2025-08-10T00:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình cũng đã & đang bị như thế, chỉ là tần suất bớt đi thôi. Và việc mình tìm hiểu và áp dụng thử các nội dung trong chủ đề này thực sự đã giúp mình nhiều, nên share out cho mọi người, let’s back to môn Văn 🤣 (cái môn mình từng chán ngáy).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình cũng đã & đang bị như thế, chỉ là tần suất bớt đi thôi. Và việc mình tìm hiểu và áp dụng thử các nội dung trong chủ đề này thực sự đã giúp mình nhiều, nên share out cho mọi người, let’s back to môn Văn 🤣 (cái môn mình từng chán ngáy).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80ac-982a-ffc317ed8544",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T06:44:00.000Z",
        "last_edited_time": "2025-08-09T06:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "c7213768-49c8-491e-9334-c1a5b9f2b232",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T06:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lập luận sắc bén là như thế nào?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lập luận sắc bén là như thế nào?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8094-99ed-c61eb4c585fc",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T04:14:00.000Z",
        "last_edited_time": "2025-08-10T00:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nói đơn giản là khả năng khiến người nghe thấy cực kì make sense và mình có khả năng bảo vệ quan điểm trước mọi pov khác. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nói đơn giản là khả năng khiến người nghe thấy cực kì make sense và mình có khả năng bảo vệ quan điểm trước mọi pov khác. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24b5d164-78d8-8077-9a33-dc86b64096ef",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-10T00:26:00.000Z",
        "last_edited_time": "2025-08-10T00:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để được như thế, lập luận cần có những đặc tính sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để được như thế, lập luận cần có những đặc tính sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "38b61de4-6683-4ac8-966d-4a0866eb5525",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T06:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Rõ ràng và chính xác",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Rõ ràng và chính xác",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " – Không vòng vo, không mơ hồ, diễn đạt ý tưởng một cách súc tích và dễ hiểu.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " – Không vòng vo, không mơ hồ, diễn đạt ý tưởng một cách súc tích và dễ hiểu.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "99b927e0-349b-40df-bd0d-551d45ffad54",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T06:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có cơ sở vững chắc",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có cơ sở vững chắc",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " – Dựa trên dữ liệu, bằng chứng hoặc nguyên tắc logic chặt chẽ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " – Dựa trên dữ liệu, bằng chứng hoặc nguyên tắc logic chặt chẽ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "c56f0c3c-e4e2-4f17-9a0d-45111b36d2cd",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T06:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tính liên kết cao",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tính liên kết cao",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " – Các luận điểm kết nối logic với nhau, không có chỗ hở dễ bị phản bác.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " – Các luận điểm kết nối logic với nhau, không có chỗ hở dễ bị phản bác.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "f1c2cb08-62b0-41fb-acde-1ad6fec71778",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T06:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dự đoán trước phản biện",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dự đoán trước phản biện",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " – Lường trước được những phản biện từ đối phương và đưa ra cách phản hồi thuyết phục.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " – Lường trước được những phản biện từ đối phương và đưa ra cách phản hồi thuyết phục.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 3
      },
      {
        "object": "block",
        "id": "60155d9e-0cbd-4f0a-8ae7-3f70a2d3a85a",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T06:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tác động mạnh",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tác động mạnh",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " – Khiến người nghe khó phủ nhận, dễ bị thuyết phục hoặc phải cân nhắc lại quan điểm của mình.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " – Khiến người nghe khó phủ nhận, dễ bị thuyết phục hoặc phải cân nhắc lại quan điểm của mình.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 4
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-8024-8f7d-d62e72ef0da7",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-06T02:00:00.000Z",
        "last_edited_time": "2025-06-06T02:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8003-a538-c8c68bc43035",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T06:41:00.000Z",
        "last_edited_time": "2025-08-09T06:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tranh luận",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tranh luận",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8067-8328-d7400a126c00",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T06:38:00.000Z",
        "last_edited_time": "2025-08-10T00:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tranh luận (debate) là một quá trình thảo luận có tổ chức, trong đó các bên tham gia đưa ra các lập luận trái chiều về một chủ đề cụ thể ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tranh luận (debate) là một quá trình thảo luận có tổ chức, trong đó các bên tham gia đưa ra các lập luận trái chiều về một chủ đề cụ thể ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "để tìm ra sự thật, giải pháp tốt nhất,",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "để tìm ra sự thật, giải pháp tốt nhất,",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " hoặc thuyết phục người nghe.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " hoặc thuyết phục người nghe.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24b5d164-78d8-8093-a26d-efaea655206a",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-10T00:27:00.000Z",
        "last_edited_time": "2025-08-10T00:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nó khác với tranh cãi ở chỗ tranh luận tập trung vào việc sử dụng lý lẽ và lập luận để bảo vệ quan điểm, trong khi tranh cãi thường mang tính cá nhân và cảm xúc hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nó khác với tranh cãi ở chỗ tranh luận tập trung vào việc sử dụng lý lẽ và lập luận để bảo vệ quan điểm, trong khi tranh cãi thường mang tính cá nhân và cảm xúc hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24b5d164-78d8-80d1-a6e4-d84a0ad81ef6",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-10T00:39:00.000Z",
        "last_edited_time": "2025-08-17T01:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "(đây vẫn là một pain point đối với mình hiện tại nè, đặc biệt là khi tranh luận ta hay bắt gặp các bias - kể cả họ & mình; vậy làm sao để né nó…có các khái niệm bias như anchoring bias, confirmation bias,… chắc mình nghe ngâm cứu topic này sau).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "(đây vẫn là một pain point đối với mình hiện tại nè, đặc biệt là khi tranh luận ta hay bắt gặp các bias - kể cả họ & mình; vậy làm sao để né nó…có các khái niệm bias như anchoring bias, confirmation bias,… chắc mình nghe ngâm cứu topic này sau).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8098-92b6-dd9f5a6feb23",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T06:43:00.000Z",
        "last_edited_time": "2025-08-09T06:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "c51a6f2b-10e5-4be6-894a-82a0ac1af6aa",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vài tactics trong tranh luận",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vài tactics trong tranh luận",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-804a-af49-c467887c652c",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T10:43:00.000Z",
        "last_edited_time": "2025-08-10T00:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cấu trúc rõ ràng (PEEL, ARE)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cấu trúc rõ ràng (PEEL, ARE)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80fd-a763-c0011b5f29ac",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T10:43:00.000Z",
        "last_edited_time": "2025-08-09T10:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dự đoán phản biện trước (Prebuttal)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dự đoán phản biện trước (Prebuttal)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8004-ab1a-fa586969e45e",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T10:43:00.000Z",
        "last_edited_time": "2025-08-09T10:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cân đo lợi ích - hại (Weighing)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cân đo lợi ích - hại (Weighing)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8079-b245-ee9027d420ee",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T10:43:00.000Z",
        "last_edited_time": "2025-08-09T10:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Định hình cuộc tranh biện (Framing)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Định hình cuộc tranh biện (Framing)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-804b-b1aa-dbb0dae5b3cd",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T10:43:00.000Z",
        "last_edited_time": "2025-08-09T10:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kiểm soát câu hỏi phản biện (POI Control)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kiểm soát câu hỏi phản biện (POI Control)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-808d-838f-fef9442e8791",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T10:44:00.000Z",
        "last_edited_time": "2025-08-09T10:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phản biện theo chủ đề (Thematic Rebuttal)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phản biện theo chủ đề (Thematic Rebuttal)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "9e7c190a-e2ae-416a-aa98-00ae58b023cf",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T06:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1901a032-6e4f-4694-8156-a16ad4027fd9",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T10:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cấu trúc lập luận chặt chẽ (PEEL, ARE, etc.)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cấu trúc lập luận chặt chẽ (PEEL, ARE, etc.)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "05b57ae1-fbc7-43f5-a2c1-f29f0ab82cbf",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-10T00:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một lập luận sắc bén không chỉ dựa vào ý tưởng mạnh mà còn phải có cấu trúc rõ ràng. Một số công thức phổ biến:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một lập luận sắc bén không chỉ dựa vào ý tưởng mạnh mà còn phải có cấu trúc rõ ràng. Một số công thức phổ biến:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8078-b494-ca0e73846348",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T06:36:00.000Z",
        "last_edited_time": "2025-08-09T06:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "PEEL",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "PEEL",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Point (Luận điểm) – Evidence (Bằng chứng) – Explain (Giải thích) – Link (Kết nối với đề tài)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Point (Luận điểm) – Evidence (Bằng chứng) – Explain (Giải thích) – Link (Kết nối với đề tài)",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "🌳"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8031-ac12-c2f56ded40ed",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T06:36:00.000Z",
        "last_edited_time": "2025-08-09T06:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "ARE",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "ARE",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Assertion (Khẳng định) – Reasoning (Lý do) – Evidence (Bằng chứng)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Assertion (Khẳng định) – Reasoning (Lý do) – Evidence (Bằng chứng)",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "🌳"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80c8-b384-c8611933ce43",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T10:40:00.000Z",
        "last_edited_time": "2025-08-09T10:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "0f8c0bb0-3023-44cf-8174-6f0d04e6b10b",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tình huống ví dụ: Thuyết phục PO chọn phương án A thay vì phương án B trong thiết kế onboarding.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tình huống ví dụ: Thuyết phục PO chọn phương án A thay vì phương án B trong thiết kế onboarding.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-8002-8411-edde3c758e28",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-06T02:14:00.000Z",
        "last_edited_time": "2025-06-06T02:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "P (Point):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "P (Point):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Tôi đề xuất chọn phương án A cho flow onboarding.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Tôi đề xuất chọn phương án A cho flow onboarding.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-804c-834d-c5e7222aa1eb",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-06T02:14:00.000Z",
        "last_edited_time": "2025-06-06T02:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "E (Evidence):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "E (Evidence):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Trong nghiên cứu usability gần nhất, 68% người dùng hoàn thành flow A mà không cần trợ giúp, trong khi với flow B con số này chỉ là 41%.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Trong nghiên cứu usability gần nhất, 68% người dùng hoàn thành flow A mà không cần trợ giúp, trong khi với flow B con số này chỉ là 41%.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-80c3-a3e1-c244233f476c",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-06T02:14:00.000Z",
        "last_edited_time": "2025-06-06T02:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "E (Explanation):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "E (Explanation):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Điều này cho thấy phương án A phù hợp với hành vi tự khám phá và tạo cảm giác tự tin hơn cho người dùng mới.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Điều này cho thấy phương án A phù hợp với hành vi tự khám phá và tạo cảm giác tự tin hơn cho người dùng mới.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-8042-bf59-c3ee3b5ec6e7",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-06T02:14:00.000Z",
        "last_edited_time": "2025-06-06T02:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "L (Link):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "L (Link):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Vì vậy, phương án A sẽ giúp giảm churn ở tuần đầu – một chỉ số quan trọng mà team đang theo đuổi trong quý này.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Vì vậy, phương án A sẽ giúp giảm churn ở tuần đầu – một chỉ số quan trọng mà team đang theo đuổi trong quý này.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24b5d164-78d8-80af-991c-f7f878b70bf0",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-10T00:42:00.000Z",
        "last_edited_time": "2025-08-10T00:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "ddf88ceb-4f7b-4981-b683-d02f4e2065d9",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-06-05T12:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "97d283f6-58d4-4aa6-b3d4-9f196541e543",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T10:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kỹ thuật “Prebuttal” (Dự đoán phản biện trước)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kỹ thuật “Prebuttal” (Dự đoán phản biện trước)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "ff3c1d52-4d2e-4d7f-ae4e-8268c0d3956b",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T04:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình không chỉ bảo vệ luận điểm của mình mà còn chủ động dự đoán và vô hiệu hóa phản biện của đối phương trước khi bị công kích.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình không chỉ bảo vệ luận điểm của mình mà còn chủ động dự đoán và vô hiệu hóa phản biện của đối phương trước khi bị công kích.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3b997f8b-db47-4e48-b179-8f0f100d740e",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tình huống ví dụ: Trình bày với Dev team về một redesign flow có nhiều animation.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tình huống ví dụ: Trình bày với Dev team về một redesign flow có nhiều animation.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-8037-90fb-f22908e08df2",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-06T02:15:00.000Z",
        "last_edited_time": "2025-06-06T02:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Tôi biết một số bạn có thể lo ngại phần animation sẽ ảnh hưởng đến hiệu suất load. Nhưng chúng tôi đã thử nghiệm bản prototype trên thiết bị tầm trung, và kết quả cho thấy animation vẫn duy trì FPS ổn định. Hơn nữa, animation được thiết kế để có thể gracefully degrade nếu băng thông yếu – điều này đã được validate.”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Tôi biết một số bạn có thể lo ngại phần animation sẽ ảnh hưởng đến hiệu suất load. Nhưng chúng tôi đã thử nghiệm bản prototype trên thiết bị tầm trung, và kết quả cho thấy animation vẫn duy trì FPS ổn định. Hơn nữa, animation được thiết kế để có thể gracefully degrade nếu băng thông yếu – điều này đã được validate.”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8017-9095-e75294cc67ea",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T10:44:00.000Z",
        "last_edited_time": "2025-08-09T10:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10a964c6-4cf5-4f58-86f8-a2c5d0a0c306",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-06-05T12:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "ce6d779c-9c60-4962-962b-0b0329a534dd",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T10:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kỹ thuật “Weighing” (Cân đo, đong đếm)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kỹ thuật “Weighing” (Cân đo, đong đếm)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "519ab316-35e0-454f-ae76-866cae0d06ab",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T04:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong tranh biện, không có lập luận nào tuyệt đối đúng hoặc sai. Vì thế, người chiến thắng là người chứng minh rằng chúng ta có những tiêu chí đánh giá chuẩn đáng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong tranh biện, không có lập luận nào tuyệt đối đúng hoặc sai. Vì thế, người chiến thắng là người chứng minh rằng chúng ta có những tiêu chí đánh giá chuẩn đáng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2ec21b6b-d217-4ee8-926e-c36795151a6d",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tình huống ví dụ: Đưa ra quyết định giữa thiết kế A (đơn giản) và thiết kế B (cá nhân hóa cao) cho homepage.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tình huống ví dụ: Đưa ra quyết định giữa thiết kế A (đơn giản) và thiết kế B (cá nhân hóa cao) cho homepage.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-80c0-8717-c2d19280ee5a",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-06T02:16:00.000Z",
        "last_edited_time": "2025-06-06T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Phương án A có điểm mạnh là đơn giản, dễ phát triển, và thân thiện với người dùng mới. Tuy nhiên, nó thiếu tính cá nhân hóa.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Phương án A có điểm mạnh là đơn giản, dễ phát triển, và thân thiện với người dùng mới. Tuy nhiên, nó thiếu tính cá nhân hóa.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-80a9-876a-ee33d842198f",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-06T02:16:00.000Z",
        "last_edited_time": "2025-06-06T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong khi đó, phương án B tạo ra trải nghiệm riêng cho từng nhóm user, nhưng lại đòi hỏi nhiều effort từ dev và có nguy cơ delay release.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong khi đó, phương án B tạo ra trải nghiệm riêng cho từng nhóm user, nhưng lại đòi hỏi nhiều effort từ dev và có nguy cơ delay release.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-8032-b39c-cf0f5b8c20cc",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-06T02:16:00.000Z",
        "last_edited_time": "2025-06-06T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu mục tiêu chính trong quý này là tăng conversion từ traffic mới, phương án A mang lại lợi thế thực thi nhanh, đo lường rõ ràng. Vậy nên tôi đề xuất A là lựa chọn hợp lý hơn ở thời điểm hiện tại.”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu mục tiêu chính trong quý này là tăng conversion từ traffic mới, phương án A mang lại lợi thế thực thi nhanh, đo lường rõ ràng. Vậy nên tôi đề xuất A là lựa chọn hợp lý hơn ở thời điểm hiện tại.”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80a2-9467-d7717ae17dfb",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T10:42:00.000Z",
        "last_edited_time": "2025-08-09T10:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "d8c29165-dd22-4eb6-8b8e-d257881d30ec",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-06-05T12:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "d15d4371-7af9-4c44-abd5-e5bff463fd8b",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T10:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kỹ thuật “Framing”",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kỹ thuật “Framing”",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "0ff349c5-7c95-4817-9ba5-c0d03e6b02dd",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T04:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Không để đối phương kiểm soát cách nhìn nhận vấn đề mà định hướng cuộc tranh biện theo cách của họ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Không để đối phương kiểm soát cách nhìn nhận vấn đề mà định hướng cuộc tranh biện theo cách của họ.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "ff7a616a-b512-492f-bf53-7c56c0eb8ba4",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tình huống ví dụ : Stakeholder nói không cần thiết kế dashboard mới vì “báo cáo Excel cũng đủ”.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tình huống ví dụ : Stakeholder nói không cần thiết kế dashboard mới vì “báo cáo Excel cũng đủ”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-800e-bec7-c6f74f000c44",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-06T02:18:00.000Z",
        "last_edited_time": "2025-06-06T02:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Framing - từ nhu cầu sang cơ hội:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Framing - từ nhu cầu sang cơ hội:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-809c-9bdc-ceeef35d0ce7",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-06T02:18:00.000Z",
        "last_edited_time": "2025-06-06T02:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Cách mình đang nhìn vấn đề không phải là ‘người ta có thể làm việc được hay không’, mà là ‘liệu họ có thể đưa ra quyết định đúng nhanh hơn hay không’. Dashboard không chỉ là báo cáo – nó là công cụ ra quyết định, và hiện tại Excel đang làm chậm điều đó.”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Cách mình đang nhìn vấn đề không phải là ‘người ta có thể làm việc được hay không’, mà là ‘liệu họ có thể đưa ra quyết định đúng nhanh hơn hay không’. Dashboard không chỉ là báo cáo – nó là công cụ ra quyết định, và hiện tại Excel đang làm chậm điều đó.”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8086-85d9-e6465a11d16b",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T10:42:00.000Z",
        "last_edited_time": "2025-08-09T10:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "dc7b058a-e0a4-4cb9-b8c3-cabdfa0b114e",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-06-05T12:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "592bb98d-6c63-4e6f-b2a8-1380d8249520",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T10:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kỹ thuật “POI Control”",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kỹ thuật “POI Control”",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "87565552-9f3e-4ffe-81e3-cac34de85725",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T04:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "POI (Point of Information) là khi đối phương yêu cầu ngắt lời trong tranh biện để đặt câu hỏi hoặc phản biện. Những người giỏi sẽ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "POI (Point of Information) là khi đối phương yêu cầu ngắt lời trong tranh biện để đặt câu hỏi hoặc phản biện. Những người giỏi sẽ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "6286b1b1-0288-43d5-8c55-a47b523e1953",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-06-05T12:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đưa ra POI đúng thời điểm để làm đối thủ lúng túng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đưa ra POI đúng thời điểm để làm đối thủ lúng túng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "202cbc5d-ea1a-469e-ad3f-996056977362",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-06-06T02:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trả lời POI nhanh chóng và sắc bén để không bị mất kiểm soát.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trả lời POI nhanh chóng và sắc bén để không bị mất kiểm soát.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "9da7598f-3c2b-4f69-88ac-625ba7a34a20",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-06-05T12:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Từ chối POI một cách chiến thuật khi cần tập trung vào lập luận chính.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Từ chối POI một cách chiến thuật khi cần tập trung vào lập luận chính.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-80ec-aed3-d16655b1d6c5",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-06T02:18:00.000Z",
        "last_edited_time": "2025-08-09T10:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tình huống ví dụ: Trong buổi họp sprint planning, PO nói rằng không cần làm user testing cho phiên bản này vì đã có số liệu từ A/B test trước.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tình huống ví dụ: Trong buổi họp sprint planning, PO nói rằng không cần làm user testing cho phiên bản này vì đã có số liệu từ A/B test trước.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-80f3-b3f6-d7cc7eda4b93",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-06T02:18:00.000Z",
        "last_edited_time": "2025-06-06T02:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "POI - bổ sung thông tin:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "POI - bổ sung thông tin:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-8054-a577-c16e43801d5c",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-06T02:18:00.000Z",
        "last_edited_time": "2025-06-06T02:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Xin phép ngắt nhẹ, A/B test trước chủ yếu đo hành vi trên user cũ. Với flow mới lần này, chúng ta có nhiều first-time user hơn, nên cần thêm insight từ usability test để tránh hiểu sai kết quả.”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Xin phép ngắt nhẹ, A/B test trước chủ yếu đo hành vi trên user cũ. Với flow mới lần này, chúng ta có nhiều first-time user hơn, nên cần thêm insight từ usability test để tránh hiểu sai kết quả.”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-800b-8bd1-d328224f8518",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T10:42:00.000Z",
        "last_edited_time": "2025-08-09T10:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "dbd98be3-2ca7-4ca5-87eb-c94176a391ac",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-06-05T12:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "7cbb55fe-5059-4481-aeb8-217a58481fb9",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T10:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kỹ thuật “Thematic Rebuttal”",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kỹ thuật “Thematic Rebuttal”",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "bb09e9a8-a8be-4c40-802a-0eb31df23aae",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T04:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thay vì phản biện từng luận điểm lẻ tẻ, mình có thể gom nhóm các phản biện theo chủ đề lớn để dễ kiểm soát cuộc tranh biện.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thay vì phản biện từng luận điểm lẻ tẻ, mình có thể gom nhóm các phản biện theo chủ đề lớn để dễ kiểm soát cuộc tranh biện.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "bb1963fd-64d8-4e3a-9080-7e6f820ee3cd",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-08-09T10:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tình huống PO nói: “Tính năng này có thể khiến hệ thống phức tạp thêm, tốt nhất nên cắt.”",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tình huống PO nói: “Tính năng này có thể khiến hệ thống phức tạp thêm, tốt nhất nên cắt.”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-800e-b306-d0bf62af7972",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-06T02:24:00.000Z",
        "last_edited_time": "2025-06-06T02:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Nếu mục tiêu của chúng ta chỉ là đơn giản hệ thống, thì đúng là nên cắt. Nhưng theme của sản phẩm trong năm nay là tăng tính tự chủ cho người dùng cuối. Việc thêm tính năng này tuy làm phức tạp hệ thống, nhưng lại trao quyền cho người dùng quyết định – đúng với định hướng chiến lược.”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Nếu mục tiêu của chúng ta chỉ là đơn giản hệ thống, thì đúng là nên cắt. Nhưng theme của sản phẩm trong năm nay là tăng tính tự chủ cho người dùng cuối. Việc thêm tính năng này tuy làm phức tạp hệ thống, nhưng lại trao quyền cho người dùng quyết định – đúng với định hướng chiến lược.”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-80fd-bb35-cbc2b0055dd9",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-06T02:04:00.000Z",
        "last_edited_time": "2025-06-06T02:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-8003-9de0-ced10b027619",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-06T02:04:00.000Z",
        "last_edited_time": "2025-08-09T01:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kết",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kết",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-80e0-982f-d29fbde7eaf3",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-06T02:04:00.000Z",
        "last_edited_time": "2025-08-09T10:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình biết các tips này nghe khá học thuật và rất khó nhớ, nên cách duy nhất chỉ là tập dần dần, để nó thành thói quen phản xạ, lúc đó ta có thể tranh biện một cách linh hoạt & hiệu quả nhất. Quên thì mình lục lại bài này xem cũng  được :)).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình biết các tips này nghe khá học thuật và rất khó nhớ, nên cách duy nhất chỉ là tập dần dần, để nó thành thói quen phản xạ, lúc đó ta có thể tranh biện một cách linh hoạt & hiệu quả nhất. Quên thì mình lục lại bài này xem cũng  được :)).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80af-b58e-e4417e0b350a",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T06:13:00.000Z",
        "last_edited_time": "2025-08-09T06:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-80ad-ba28-c908c08cc0a0",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-06T02:07:00.000Z",
        "last_edited_time": "2025-08-09T06:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu có 3 ý cần phải nhớ, thì mình sẽ cố nhớ về các thành tố cần có trong mọi lập luận và tập nghi hoặc mọi thứ (không những là khi xem xét các ý của người khác mà còn ngay trong chính suy nghĩ hiện thời của mình), các câu hỏi như sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu có 3 ý cần phải nhớ, thì mình sẽ cố nhớ về các thành tố cần có trong mọi lập luận và tập nghi hoặc mọi thứ (không những là khi xem xét các ý của người khác mà còn ngay trong chính suy nghĩ hiện thời của mình), các câu hỏi như sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80cd-aa1c-f5949de44d97",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T06:31:00.000Z",
        "last_edited_time": "2025-08-09T06:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "list",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "list",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "24a5d164-78d8-80a2-84ec-cf0ab811766e",
            "parent": {
              "type": "block_id",
              "block_id": "24a5d164-78d8-80cd-aa1c-f5949de44d97"
            },
            "created_time": "2025-08-09T06:31:00.000Z",
            "last_edited_time": "2025-08-09T15:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754722409/uxcomic-imgs/24a5d164-78d8-80a2-84ec-cf0ab811766e.png",
                "expiry_time": "2026-10-04T09:11:38.007Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/24a5d164-78d8-80a2-84ec-cf0ab811766e"
          },
          {
            "object": "block",
            "id": "24a5d164-78d8-8003-8190-fd7cf1ef86a9",
            "parent": {
              "type": "block_id",
              "block_id": "24a5d164-78d8-80cd-aa1c-f5949de44d97"
            },
            "created_time": "2025-08-09T06:31:00.000Z",
            "last_edited_time": "2025-08-09T15:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754722410/uxcomic-imgs/24a5d164-78d8-8003-8190-fd7cf1ef86a9.png",
                "expiry_time": "2026-10-04T09:11:38.007Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/24a5d164-78d8-8003-8190-fd7cf1ef86a9"
          },
          {
            "object": "block",
            "id": "24a5d164-78d8-8070-afce-da7f7c858f7a",
            "parent": {
              "type": "block_id",
              "block_id": "24a5d164-78d8-80cd-aa1c-f5949de44d97"
            },
            "created_time": "2025-08-09T06:31:00.000Z",
            "last_edited_time": "2025-08-09T15:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754722412/uxcomic-imgs/24a5d164-78d8-8070-afce-da7f7c858f7a.png",
                "expiry_time": "2026-10-04T09:11:38.007Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/24a5d164-78d8-8070-afce-da7f7c858f7a"
          }
        ]
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8040-9f1b-cb8a2098cde6",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T06:27:00.000Z",
        "last_edited_time": "2025-08-09T06:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80a4-ae80-f315fe5377d2",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T06:27:00.000Z",
        "last_edited_time": "2025-08-09T06:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-803a-8e91-f37a4e236781",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T06:35:00.000Z",
        "last_edited_time": "2025-08-09T06:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://psyche.co/guides/how-to-have-arguments-that-change-minds-including-your-own",
                "link": {
                  "url": "https://psyche.co/guides/how-to-have-arguments-that-change-minds-including-your-own"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://psyche.co/guides/how-to-have-arguments-that-change-minds-including-your-own",
              "href": "https://psyche.co/guides/how-to-have-arguments-that-change-minds-including-your-own"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8041-95e8-c874233a59a1",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T06:27:00.000Z",
        "last_edited_time": "2025-08-09T06:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://ayp.vn/kha-nang-lap-luan-yeu-to-trong-tu-duy-va-thanh-cong/",
                "link": {
                  "url": "https://ayp.vn/kha-nang-lap-luan-yeu-to-trong-tu-duy-va-thanh-cong/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://ayp.vn/kha-nang-lap-luan-yeu-to-trong-tu-duy-va-thanh-cong/",
              "href": "https://ayp.vn/kha-nang-lap-luan-yeu-to-trong-tu-duy-va-thanh-cong/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8046-8eda-fcfff769b25a",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-08-09T06:27:00.000Z",
        "last_edited_time": "2025-08-09T06:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.xomtranhbien.com/post/ky-nang-tranh-bien-lap-luan-trung-cap-phan-1",
                "link": {
                  "url": "https://www.xomtranhbien.com/post/ky-nang-tranh-bien-lap-luan-trung-cap-phan-1"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.xomtranhbien.com/post/ky-nang-tranh-bien-lap-luan-trung-cap-phan-1",
              "href": "https://www.xomtranhbien.com/post/ky-nang-tranh-bien-lap-luan-trung-cap-phan-1"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "b78c1cff-ffd3-4584-9959-bc0cbb21f674",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-06-05T12:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "40fcffbd-0a4f-4c7f-bb2f-70bd61edd3a2",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-06-05T12:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "e7d9fc05-44bd-41c1-bf85-3827cccbf2c3",
        "parent": {
          "type": "page_id",
          "page_id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
        },
        "created_time": "2025-06-05T12:26:00.000Z",
        "last_edited_time": "2025-06-06T02:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Suy luận vs Lập luận",
              "href": "https://app.notion.com/p/1c95d16478d880bbae7bd759fd89c261"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1c95d164-78d8-80bb-ae7b-d759fd89c261",
    "created_time": "2025-04-02T12:05:00.000Z",
    "last_edited_time": "2025-08-09T10:58:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "fd3cd36d-73dd-4dee-8bd5-d159d6600124"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "View": {
        "id": "ATSa",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "A%5Bqc",
        "type": "select",
        "select": {
          "id": "HnGT",
          "name": "♟️:3",
          "color": "gray"
        }
      },
      "Last edited time": {
        "id": "DMgm",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-09T10:58:00.000Z"
      },
      "Publish": {
        "id": "FSnx",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "_tsp",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "g%7BBg",
        "type": "created_time",
        "created_time": "2025-04-02T12:05:00.000Z"
      },
      "Share": {
        "id": "hp~_",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "m%7C%40x",
        "type": "number",
        "number": null
      },
      "Formula": {
        "id": "re%3BE",
        "type": "formula",
        "formula": {
          "type": "number",
          "number": 1
        }
      },
      "Tag": {
        "id": "%7CAvQ",
        "type": "select",
        "select": {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "4-Random",
          "color": "gray"
        }
      },
      "ID": {
        "id": "~RYT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FD",
          "number": 39
        }
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Suy luận vs Lập luận",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Suy luận vs Lập luận",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Suy-lu-n-vs-L-p-lu-n-1c95d16478d880bbae7bd759fd89c261",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "5cacdbff-b9e2-4973-b565-ec1ae4327ec9",
      "name": "Fundamental",
      "slug": "fundamental",
      "icon": "🌞",
      "order": 2,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "Product",
          "slug": "product",
          "order": 1
        },
        {
          "id": "156ef770-14db-4170-b1d7-95a2fbdf62ba",
          "name": "User",
          "slug": "user",
          "order": 2
        },
        {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "Design",
          "slug": "design",
          "order": 3
        },
        {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "Random",
          "slug": "random",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "9290a1c0-fd10-40c6-a821-56f188976357",
      "name": "Random",
      "slug": "random",
      "order": 4
    },
    "content": [
      {
        "object": "block",
        "id": "1c95d164-78d8-8146-a7bf-d69c5a95f061",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-04-02T12:05:00.000Z",
        "last_edited_time": "2025-08-09T09:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754722418/uxcomic-imgs/1c95d164-78d8-8146-a7bf-d69c5a95f061.png",
            "expiry_time": "2026-10-04T09:11:38.742Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1c95d164-78d8-8146-a7bf-d69c5a95f061"
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-805f-8653-f9bab03e00a5",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T10:06:00.000Z",
        "last_edited_time": "2025-08-09T10:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bạn có bao giờ thua trong một cuộc tranh luận dù… lý lẽ của mình không sai?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bạn có bao giờ thua trong một cuộc tranh luận dù… lý lẽ của mình không sai?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80c5-86f6-d320f2cf3641",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T10:06:00.000Z",
        "last_edited_time": "2025-08-09T10:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Rất có thể là bạn đã suy luận đúng, nhưng lập luận chưa đủ mạnh.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Rất có thể là bạn đã suy luận đúng, nhưng lập luận chưa đủ mạnh.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-800b-8b71-c959e953ea3f",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T10:17:00.000Z",
        "last_edited_time": "2025-08-09T10:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy suy luận vs lập luận khác ra sao, và tại sao Designer cần biết về nó?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy suy luận vs lập luận khác ra sao, và tại sao Designer cần biết về nó?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8039-840f-c6e1797ec620",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T03:46:00.000Z",
        "last_edited_time": "2025-08-09T03:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8021-aa2f-d6fa016ee8af",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T03:41:00.000Z",
        "last_edited_time": "2025-08-09T03:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Suy luận là gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Suy luận là gì?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80f5-9c84-fcf4c462df7d",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T03:41:00.000Z",
        "last_edited_time": "2025-08-09T03:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Suy” là đẩy ra / mở rộng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Suy” là đẩy ra / mở rộng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80ec-a768-cafcdaf0b3a5",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T03:43:00.000Z",
        "last_edited_time": "2025-08-09T03:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Luận” là bàn bạc, phân tích, xem xét vấn đề.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Luận” là bàn bạc, phân tích, xem xét vấn đề.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80b8-87ff-ed46e114ed3a",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T03:43:00.000Z",
        "last_edited_time": "2025-08-09T03:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Suy luận” là dùng lý lẽ để mở rộng từ điều đã biết nhằm rút ra điều chưa biết.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Suy luận” là dùng lý lẽ để mở rộng từ điều đã biết nhằm rút ra điều chưa biết.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-805e-8011-f6d82273081e",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T10:07:00.000Z",
        "last_edited_time": "2025-08-09T10:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: nhìn vào dữ liệu heatmap → phát hiện người dùng hay bỏ giữa chừng ở bước thanh toán → đoán rằng form quá dài.\n\n",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: nhìn vào dữ liệu heatmap → phát hiện người dùng hay bỏ giữa chừng ở bước thanh toán → đoán rằng form quá dài.\n\n",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1c95d164-78d8-8191-a92e-e57f6b726fdb",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-04-02T12:05:00.000Z",
        "last_edited_time": "2025-08-09T01:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lập luận là gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lập luận là gì?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-808c-bff0-e40b3e1c689f",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T01:54:00.000Z",
        "last_edited_time": "2025-08-09T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Lập” là dựng lên.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Lập” là dựng lên.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80ef-b7b7-f19e288391c6",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T01:55:00.000Z",
        "last_edited_time": "2025-08-09T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Luận” là bàn bạc, phân tích, xem xét vấn đề.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Luận” là bàn bạc, phân tích, xem xét vấn đề.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1c95d164-78d8-80b9-9821-dd1e2a51c331",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-04-02T12:07:00.000Z",
        "last_edited_time": "2025-08-09T10:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Lập luận” là xây dựng và trình bày lý lẽ nhằm chứng minh, bảo vệ hoặc thuyết phục về một quan điểm, ý kiến.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Lập luận” là xây dựng và trình bày lý lẽ nhằm chứng minh, bảo vệ hoặc thuyết phục về một quan điểm, ý kiến.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8098-86dc-c0d2d85c8f3f",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T10:07:00.000Z",
        "last_edited_time": "2025-08-09T10:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: “chúng ta nên rút gọn form thanh toán từ 6 bước xuống 3 bước, vì drop rate & user feedback đều chỉ ra người dùng cảm thấy phiền phức.”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: “chúng ta nên rút gọn form thanh toán từ 6 bước xuống 3 bước, vì drop rate & user feedback đều chỉ ra người dùng cảm thấy phiền phức.”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-806b-9463-eca606255a7e",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T01:03:00.000Z",
        "last_edited_time": "2025-08-09T01:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1ca5d164-78d8-80e4-a64f-ecc267f4f90c",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-04-03T05:28:00.000Z",
        "last_edited_time": "2025-08-09T03:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Suy luận vs Lập luận",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Suy luận vs Lập luận",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80c5-9700-cec437d84145",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T10:12:00.000Z",
        "last_edited_time": "2025-08-09T10:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một UX designer giỏi vừa phải suy luận tốt để khám phá ra problem, ra insight, vừa phải lập luận sắc bén để biến insight thành hành động.\n",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một UX designer giỏi vừa phải suy luận tốt để khám phá ra problem, ra insight, vừa phải lập luận sắc bén để biến insight thành hành động.\n",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ca5d164-78d8-80e2-9448-cb52f309c5ee",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-04-03T05:27:00.000Z",
        "last_edited_time": "2025-08-09T03:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Suy luận (đối nội)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Suy luận (đối nội)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-808d-bc50-f97346a51e41",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T03:36:00.000Z",
        "last_edited_time": "2025-08-09T10:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nói đơn giản nó là cách ta nghĩ, quá trình này giúp:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nói đơn giản nó là cách ta nghĩ, quá trình này giúp:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1c95d164-78d8-812d-a3af-d5baca03d40f",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-04-02T12:05:00.000Z",
        "last_edited_time": "2025-04-03T06:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cô đặc & chặt chẽ hoá những thông tin đã có >> tác động lên cách hiểu & ra quyết định.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cô đặc & chặt chẽ hoá những thông tin đã có >> tác động lên cách hiểu & ra quyết định.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1ca5d164-78d8-8055-8ff8-ff61a9238ae1",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-04-03T02:11:00.000Z",
        "last_edited_time": "2025-08-09T03:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong quá trình suy luận sẽ sản sinh ra câu hỏi, từ đó có thêm nhiều thông tin, nhiều góc nhìn hơn >> tăng khả năng phán đoán.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong quá trình suy luận sẽ sản sinh ra câu hỏi, từ đó có thêm nhiều thông tin, nhiều góc nhìn hơn >> tăng khả năng phán đoán.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1ca5d164-78d8-802d-940b-fd0fa1400608",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-04-03T02:13:00.000Z",
        "last_edited_time": "2025-08-09T10:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhận ra lỗ hỏng, điểm yếu trong suy luận của bản thân, để biết điều chỉnh, khiến cho mình “có lý” hơn. Mặt khác, suy luận mà chặt chẽ thì chính kiến & niềm tin sẽ cao hơn, có được 2 thứ này, nó giống như “kháng sinh” để mình bản lĩnh & vững vàng hơn trước các luồng ý kiến khác.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhận ra lỗ hỏng, điểm yếu trong suy luận của bản thân, để biết điều chỉnh, khiến cho mình “có lý” hơn. Mặt khác, suy luận mà chặt chẽ thì chính kiến & niềm tin sẽ cao hơn, có được 2 thứ này, nó giống như “kháng sinh” để mình bản lĩnh & vững vàng hơn trước các luồng ý kiến khác.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80fa-8900-e3834762fc04",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T03:57:00.000Z",
        "last_edited_time": "2025-08-09T03:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các loại suy luận:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các loại suy luận:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-801c-bb48-fa1967eec77e",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T05:30:00.000Z",
        "last_edited_time": "2025-08-09T06:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "list",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "list",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "24a5d164-78d8-80ba-b625-effd2da88c67",
            "parent": {
              "type": "block_id",
              "block_id": "24a5d164-78d8-801c-bb48-fa1967eec77e"
            },
            "created_time": "2025-08-09T06:07:00.000Z",
            "last_edited_time": "2025-08-09T10:10:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754722425/uxcomic-imgs/24a5d164-78d8-80ba-b625-effd2da88c67.png",
                "expiry_time": "2026-10-04T09:11:39.364Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/24a5d164-78d8-80ba-b625-effd2da88c67"
          },
          {
            "object": "block",
            "id": "24a5d164-78d8-8060-b03e-fb384f3d307a",
            "parent": {
              "type": "block_id",
              "block_id": "24a5d164-78d8-801c-bb48-fa1967eec77e"
            },
            "created_time": "2025-08-09T06:07:00.000Z",
            "last_edited_time": "2025-08-09T10:10:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754722426/uxcomic-imgs/24a5d164-78d8-8060-b03e-fb384f3d307a.png",
                "expiry_time": "2026-10-04T09:11:39.364Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/24a5d164-78d8-8060-b03e-fb384f3d307a"
          },
          {
            "object": "block",
            "id": "24a5d164-78d8-80e6-8835-fa9c8d801c4c",
            "parent": {
              "type": "block_id",
              "block_id": "24a5d164-78d8-801c-bb48-fa1967eec77e"
            },
            "created_time": "2025-08-09T06:07:00.000Z",
            "last_edited_time": "2025-08-09T10:10:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754722427/uxcomic-imgs/24a5d164-78d8-80e6-8835-fa9c8d801c4c.png",
                "expiry_time": "2026-10-04T09:11:39.364Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/24a5d164-78d8-80e6-8835-fa9c8d801c4c"
          },
          {
            "object": "block",
            "id": "24a5d164-78d8-808a-b23a-cd235e344a05",
            "parent": {
              "type": "block_id",
              "block_id": "24a5d164-78d8-801c-bb48-fa1967eec77e"
            },
            "created_time": "2025-08-09T06:07:00.000Z",
            "last_edited_time": "2025-08-09T10:10:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754722428/uxcomic-imgs/24a5d164-78d8-808a-b23a-cd235e344a05.png",
                "expiry_time": "2026-10-04T09:11:39.365Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/24a5d164-78d8-808a-b23a-cd235e344a05"
          },
          {
            "object": "block",
            "id": "24a5d164-78d8-80fc-9c2c-f190fdb4e6a8",
            "parent": {
              "type": "block_id",
              "block_id": "24a5d164-78d8-801c-bb48-fa1967eec77e"
            },
            "created_time": "2025-08-09T06:07:00.000Z",
            "last_edited_time": "2025-08-09T10:10:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754722429/uxcomic-imgs/24a5d164-78d8-80fc-9c2c-f190fdb4e6a8.png",
                "expiry_time": "2026-10-04T09:11:39.365Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/24a5d164-78d8-80fc-9c2c-f190fdb4e6a8"
          }
        ]
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80fc-8944-d3ec36d1af7d",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T06:07:00.000Z",
        "last_edited_time": "2025-08-09T06:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80de-b35e-d211415adfeb",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T06:07:00.000Z",
        "last_edited_time": "2025-08-09T06:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ca5d164-78d8-80a8-948e-d339f118be0f",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-04-03T05:27:00.000Z",
        "last_edited_time": "2025-08-09T03:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lập luận (đối ngoại)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lập luận (đối ngoại)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80f3-83ef-c2fa474cada7",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T03:37:00.000Z",
        "last_edited_time": "2025-08-09T03:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nói đơn giản thì nó là cách ta diễn đạt.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nói đơn giản thì nó là cách ta diễn đạt.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ca5d164-78d8-8042-b037-d00573d5ce8d",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-04-03T02:06:00.000Z",
        "last_edited_time": "2025-08-09T10:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lập luận tốt sẽ giúp mình hình thành được mạch nội dung để khiến người nghe dễ follow theo, nó khiến người hiểu từ điểm a, b, c rồi liên hệ ra sao để ra được một kết luận >> người nghe nắm được ý của bạn tốt hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lập luận tốt sẽ giúp mình hình thành được mạch nội dung để khiến người nghe dễ follow theo, nó khiến người hiểu từ điểm a, b, c rồi liên hệ ra sao để ra được một kết luận >> người nghe nắm được ý của bạn tốt hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80ea-95d4-f46ee8650de6",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T04:02:00.000Z",
        "last_edited_time": "2025-08-09T10:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Về các dạng lập luận mình nghĩ có xem thêm một cuốn sách khá hay là ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Về các dạng lập luận mình nghĩ có xem thêm một cuốn sách khá hay là ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "“Show and Tell” của Dan Roam ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Show and Tell” của Dan Roam ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "(note: mặc dù sách không nói gì liên quan trực tiếp đến lập luận, nhưng nó mention đến cách diễn đạt, nó nói về 4 loại presentation ta rất hay bắt gặp trong công việc, và con người chúng ta có 3 loại sự thật...)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "(note: mặc dù sách không nói gì liên quan trực tiếp đến lập luận, nhưng nó mention đến cách diễn đạt, nó nói về 4 loại presentation ta rất hay bắt gặp trong công việc, và con người chúng ta có 3 loại sự thật...)",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ca5d164-78d8-8063-ba47-d8cc0c9f7a5d",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-04-03T02:16:00.000Z",
        "last_edited_time": "2025-04-03T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2215d164-78d8-80e9-84ec-f3f93fdd2bd1",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-06-29T03:52:00.000Z",
        "last_edited_time": "2025-08-09T04:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cấu thành của lập luận",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cấu thành của lập luận",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8022-8c76-dff263a0896d",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T10:55:00.000Z",
        "last_edited_time": "2025-08-09T10:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "—Trích từ sách “Nhân sinh quan” của Hoàng Mạnh Hải",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "—Trích từ sách “Nhân sinh quan” của Hoàng Mạnh Hải",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80b0-8f78-ec075f47a075",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T10:57:00.000Z",
        "last_edited_time": "2025-08-09T10:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Luận điểm (point):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Luận điểm (point):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Là một ý kiến, một câu nói được người đưa ra cho là đúng. Luận điểm có thể là những điều mà nhiều người đã biết, cũng có thể là chưa ai biết.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Là một ý kiến, một câu nói được người đưa ra cho là đúng. Luận điểm có thể là những điều mà nhiều người đã biết, cũng có thể là chưa ai biết.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8076-b47b-d0c7e6e5a5cd",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T10:57:00.000Z",
        "last_edited_time": "2025-08-09T10:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Luận cứ (basis):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Luận cứ (basis):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Là một điều đã được tin là đúng mà người đưa ra muốn dùng nó để chứng minh cho luận điểm của mình.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Là một điều đã được tin là đúng mà người đưa ra muốn dùng nó để chứng minh cho luận điểm của mình.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8057-a807-e3ef453d495f",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T10:57:00.000Z",
        "last_edited_time": "2025-08-09T10:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lập luận (reasoning):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lập luận (reasoning):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Là cách suy diễn, dẫn dắt từ ý này sang ý khác để cuối cùng đi đến kết luận. Lập luận đúng ta gọi là lập luận logic. Lập luận sai được gọi là lập luận không logic hay ngụy biện. Ngụy biện là “dùng cách lập luận không logic để chứng minh một điều đúng thành sai hay ngược lại, chứng minh một điều sai thành đúng”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Là cách suy diễn, dẫn dắt từ ý này sang ý khác để cuối cùng đi đến kết luận. Lập luận đúng ta gọi là lập luận logic. Lập luận sai được gọi là lập luận không logic hay ngụy biện. Ngụy biện là “dùng cách lập luận không logic để chứng minh một điều đúng thành sai hay ngược lại, chứng minh một điều sai thành đúng”.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8053-8768-d1c8013f4512",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T10:57:00.000Z",
        "last_edited_time": "2025-08-09T10:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-801d-ac58-db34b8d58990",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T03:51:00.000Z",
        "last_edited_time": "2025-08-09T06:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> Từ khái niệm này, ví dụ tình huống mình thấy hữu ích để vận dụng là khi đánh giá các luận điểm của đối phương khi trao đổi, mình có thể tự hỏi: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> Từ khái niệm này, ví dụ tình huống mình thấy hữu ích để vận dụng là khi đánh giá các luận điểm của đối phương khi trao đổi, mình có thể tự hỏi: ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80ff-b948-fed35f459a3f",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T06:10:00.000Z",
        "last_edited_time": "2025-08-09T06:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Liệu các ý họ nói có make sense? ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Liệu các ý họ nói có make sense? ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8096-88d1-db2f315aa715",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T06:10:00.000Z",
        "last_edited_time": "2025-08-09T10:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Liệu luận điểm đó có đang base trên luận cứ nào không, luận cứ đó có valid không, tại sao ta tin nó valid?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Liệu luận điểm đó có đang base trên luận cứ nào không, luận cứ đó có valid không, tại sao ta tin nó valid?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8023-8348-d8d67bb559bf",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T06:10:00.000Z",
        "last_edited_time": "2025-08-09T06:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Liệu mình có cần thêm những luận điểm (POV) khác?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Liệu mình có cần thêm những luận điểm (POV) khác?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-802b-aaa1-ef2969f35ba1",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T10:55:00.000Z",
        "last_edited_time": "2025-08-09T10:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1ca5d164-78d8-806b-b00c-fc9c035a6acb",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-04-03T06:19:00.000Z",
        "last_edited_time": "2025-08-09T06:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quá trình suy luận/ lập luận",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quá trình suy luận/ lập luận",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ca5d164-78d8-8049-8bbe-e34b5b07f0e9",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-04-03T06:21:00.000Z",
        "last_edited_time": "2025-08-09T03:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tiền đề (Premises)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tiền đề (Premises)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Các lý do hoặc bằng chứng hỗ trợ kết luận.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Các lý do hoặc bằng chứng hỗ trợ kết luận.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1ca5d164-78d8-8022-a39b-e2ad3d440497",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-04-03T06:21:00.000Z",
        "last_edited_time": "2025-04-04T02:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quá trình suy luận (Reasoning)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quá trình suy luận (Reasoning)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Cách liên kết tiền đề với kết luận.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Cách liên kết tiền đề với kết luận.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1ca5d164-78d8-8081-8240-d1c324e3dcce",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-04-03T06:21:00.000Z",
        "last_edited_time": "2025-04-04T02:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kết luận (Conclusion)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kết luận (Conclusion)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Quan điểm cuối cùng rút ra từ tiền đề.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Quan điểm cuối cùng rút ra từ tiền đề.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-808b-b63d-c57fb7e8797e",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T10:15:00.000Z",
        "last_edited_time": "2025-08-09T10:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: khi tiền đề sai hoặc cách suy luận sai → kết luận sẽ sai",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: khi tiền đề sai hoặc cách suy luận sai → kết luận sẽ sai",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8075-94b8-c16ad16169f5",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T10:38:00.000Z",
        "last_edited_time": "2025-08-09T10:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754736633/uxcomic-imgs/24a5d164-78d8-8075-94b8-c16ad16169f5.png",
            "expiry_time": "2026-10-04T09:11:38.789Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/24a5d164-78d8-8075-94b8-c16ad16169f5"
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-808c-8ddb-d1f9342b388f",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T10:14:00.000Z",
        "last_edited_time": "2025-08-09T10:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lấy ẩn dụ: một món ăn không ngon có thể vì nguyên liệu (tiền đề - data, insight, problem framing…) không ngon hoặc do chế biến chưa tốt (suy luận- solution design, solution implement…).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lấy ẩn dụ: một món ăn không ngon có thể vì nguyên liệu (tiền đề - data, insight, problem framing…) không ngon hoặc do chế biến chưa tốt (suy luận- solution design, solution implement…).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8013-921d-ce15a91304f6",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T04:08:00.000Z",
        "last_edited_time": "2025-08-09T04:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80e8-a4ce-fe14af8f68df",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T04:09:00.000Z",
        "last_edited_time": "2025-08-09T04:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kết",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kết",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80ec-9093-deff0b550ac9",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T04:09:00.000Z",
        "last_edited_time": "2025-08-09T10:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bài viết hơi dài, mình rất mừng nếu bạn đọc đến đây, mong là nó khơi thêm chút hứng thú gì đó để tìm hiểu thêm về nó, mình nghĩ đây sẽ là một “meta skill” mang tính leverage mọi thứ trong công việc & cuộc sống hiện tại đấy.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bài viết hơi dài, mình rất mừng nếu bạn đọc đến đây, mong là nó khơi thêm chút hứng thú gì đó để tìm hiểu thêm về nó, mình nghĩ đây sẽ là một “meta skill” mang tính leverage mọi thứ trong công việc & cuộc sống hiện tại đấy.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-807d-ac36-f1609b9e9a91",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T04:12:00.000Z",
        "last_edited_time": "2025-08-09T04:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Riêng cho bối cảnh công việc, bạn dùng nó trong gần như mọi khâu, từ problem discovery → Framing → Explore solution → Evaluate solution → Design push back / propose.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Riêng cho bối cảnh công việc, bạn dùng nó trong gần như mọi khâu, từ problem discovery → Framing → Explore solution → Evaluate solution → Design push back / propose.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1c95d164-78d8-8192-ab08-f034ef57af05",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-04-02T12:05:00.000Z",
        "last_edited_time": "2025-04-02T12:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1c95d164-78d8-8154-a329-c7dc1e983928",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-04-02T12:05:00.000Z",
        "last_edited_time": "2025-08-09T05:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-807c-93e7-f7a0e6560ad2",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T05:55:00.000Z",
        "last_edited_time": "2025-08-09T05:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://en.wikipedia.org/wiki/Causal_reasoning",
                "link": {
                  "url": "https://en.wikipedia.org/wiki/Causal_reasoning"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://en.wikipedia.org/wiki/Causal_reasoning",
              "href": "https://en.wikipedia.org/wiki/Causal_reasoning"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8048-a4ec-eaf79cb8ba4b",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T05:56:00.000Z",
        "last_edited_time": "2025-08-09T05:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "http://triethoc.edu.vn/vi/chuyen-de-triet-hoc/logic-hoc-tu-duy-phan-bien/khai-quat-ve-suy-luan_427.html",
                "link": {
                  "url": "http://triethoc.edu.vn/vi/chuyen-de-triet-hoc/logic-hoc-tu-duy-phan-bien/khai-quat-ve-suy-luan_427.html"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "http://triethoc.edu.vn/vi/chuyen-de-triet-hoc/logic-hoc-tu-duy-phan-bien/khai-quat-ve-suy-luan_427.html",
              "href": "http://triethoc.edu.vn/vi/chuyen-de-triet-hoc/logic-hoc-tu-duy-phan-bien/khai-quat-ve-suy-luan_427.html"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80bd-b70c-dadeb8e69ae5",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T05:55:00.000Z",
        "last_edited_time": "2025-08-09T05:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80f7-b034-f626d5028d4b",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-08-09T05:55:00.000Z",
        "last_edited_time": "2025-08-09T05:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2095d164-78d8-8091-8a66-f778f673986f",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-06-05T14:06:00.000Z",
        "last_edited_time": "2025-06-05T14:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "2095d164-78d8-8053-8f74-c9eb6baeca79"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lập luận vs Tranh luận",
              "href": "https://app.notion.com/p/2095d16478d880538f74c9eb6baeca79"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2095d164-78d8-800a-ad7d-ca7007ab2c01",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-06-05T14:06:00.000Z",
        "last_edited_time": "2025-06-06T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sense making",
              "href": "https://app.notion.com/p/1195d16478d880cda21ff9d0e90ae7b8"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20a5d164-78d8-80de-896a-ee2ccc5a817b",
        "parent": {
          "type": "page_id",
          "page_id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
        },
        "created_time": "2025-06-06T01:56:00.000Z",
        "last_edited_time": "2025-06-06T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relation (systematic thinking)",
              "href": "https://app.notion.com/p/1225d16478d880db8d9be6cc64d11314"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1605d164-78d8-80ad-9130-fe44c6663146",
    "created_time": "2024-12-18T01:59:00.000Z",
    "last_edited_time": "2025-03-20T04:53:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "fd3cd36d-73dd-4dee-8bd5-d159d6600124"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "View": {
        "id": "ATSa",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "A%5Bqc",
        "type": "select",
        "select": {
          "id": "\\i@K",
          "name": "⚓:1",
          "color": "pink"
        }
      },
      "Last edited time": {
        "id": "DMgm",
        "type": "last_edited_time",
        "last_edited_time": "2025-03-20T04:53:00.000Z"
      },
      "Publish": {
        "id": "FSnx",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "_tsp",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "g%7BBg",
        "type": "created_time",
        "created_time": "2024-12-18T01:59:00.000Z"
      },
      "Share": {
        "id": "hp~_",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "m%7C%40x",
        "type": "number",
        "number": null
      },
      "Formula": {
        "id": "re%3BE",
        "type": "formula",
        "formula": {
          "type": "number",
          "number": 1
        }
      },
      "Tag": {
        "id": "%7CAvQ",
        "type": "select",
        "select": {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "1-Product",
          "color": "default"
        }
      },
      "ID": {
        "id": "~RYT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FD",
          "number": 34
        }
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Value vs Benefit",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Value vs Benefit",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Value-vs-Benefit-1605d16478d880ad9130fe44c6663146",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "5cacdbff-b9e2-4973-b565-ec1ae4327ec9",
      "name": "Fundamental",
      "slug": "fundamental",
      "icon": "🌞",
      "order": 2,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "Product",
          "slug": "product",
          "order": 1
        },
        {
          "id": "156ef770-14db-4170-b1d7-95a2fbdf62ba",
          "name": "User",
          "slug": "user",
          "order": 2
        },
        {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "Design",
          "slug": "design",
          "order": 3
        },
        {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "Random",
          "slug": "random",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
      "name": "Product",
      "slug": "product",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "1605d164-78d8-81b0-b340-c87ae981b150",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T01:59:00.000Z",
        "last_edited_time": "2024-12-20T14:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081388/uxcomic-imgs/1605d164-78d8-81b0-b340-c87ae981b150.png",
            "expiry_time": "2026-10-04T09:11:40.992Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1605d164-78d8-81b0-b340-c87ae981b150"
      },
      {
        "object": "block",
        "id": "1635d164-78d8-8059-a112-f0c4e8bcc757",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-21T08:53:00.000Z",
        "last_edited_time": "2024-12-24T12:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tình cờ một ngày, trong lúc thảo luận về a,b,c cho project, thì bạn UX writing có mention đến khái niệm “value khác benefit” và họ thường viết content làm sao để chuyển tải thông điệp benefit (dưới góc nhìn của user) thay vì mô tả tính năng làm được gì... ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tình cờ một ngày, trong lúc thảo luận về a,b,c cho project, thì bạn UX writing có mention đến khái niệm “value khác benefit” và họ thường viết content làm sao để chuyển tải thông điệp benefit (dưới góc nhìn của user) thay vì mô tả tính năng làm được gì... ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8013-a3cf-da3780d43ae1",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-24T12:57:00.000Z",
        "last_edited_time": "2024-12-24T12:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Wow! Và thế rồi, đến cuối ngày mình ngồi ngẫm nghĩ lại, đúng là ta làm product cũng ngày đêm nghe đến chữ “feature”, lúc thảo luận brief, solution thì nghe “value này value kia”, “benefit này benefit kia”,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Wow! Và thế rồi, đến cuối ngày mình ngồi ngẫm nghĩ lại, đúng là ta làm product cũng ngày đêm nghe đến chữ “feature”, lúc thảo luận brief, solution thì nghe “value này value kia”, “benefit này benefit kia”,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80a8-916e-fa5f857f73fd",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T05:06:00.000Z",
        "last_edited_time": "2024-12-21T08:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy mối liên hệ giữa feature, benefit, value là gì?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy mối liên hệ giữa feature, benefit, value là gì?",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8025-bf3f-e79d661aee0f",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T05:29:00.000Z",
        "last_edited_time": "2024-12-18T05:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-81ed-8ff0-c8a8e785a560",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T01:59:00.000Z",
        "last_edited_time": "2024-12-18T05:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Định nghĩa",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Định nghĩa",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-81c7-89ed-d8c05274ca49",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T01:59:00.000Z",
        "last_edited_time": "2025-01-11T13:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Feature (capacity):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Feature (capacity):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là những gì mà sản phẩm có và làm được, thường mô tả dưới góc độ kĩ thuật. (hoặc nói khái quát hơn có thể là artifact: những gì bạn làm).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là những gì mà sản phẩm có và làm được, thường mô tả dưới góc độ kĩ thuật. (hoặc nói khái quát hơn có thể là artifact: những gì bạn làm).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8063-b85b-c01f499bbeb1",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T05:27:00.000Z",
        "last_edited_time": "2024-12-18T07:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Benefit:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Benefit:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là kết quả mà user trong quá trình sử dụng đạt được (tồn tại dưới 2 dạng functional & emotional benefit)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là kết quả mà user trong quá trình sử dụng đạt được (tồn tại dưới 2 dạng functional & emotional benefit)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80bf-bc5b-e8a5ec87c4f3",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T05:27:00.000Z",
        "last_edited_time": "2024-12-18T05:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Value:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Value:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là quá trình reflect, đánh giá của user về benefit đó có tác động như thế nào đến cuộc sống của họ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là quá trình reflect, đánh giá của user về benefit đó có tác động như thế nào đến cuộc sống của họ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80bd-8ce2-f1c429d8345d",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T05:50:00.000Z",
        "last_edited_time": "2024-12-18T05:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80a9-88ff-c8795ccaa1d7",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T05:28:00.000Z",
        "last_edited_time": "2024-12-20T14:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lấy ví dụ buổi Steve Job present về chiếc iPod năm 2001. Đây là script Steve present:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lấy ví dụ buổi Steve Job present về chiếc iPod năm 2001. Đây là script Steve present:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8008-b26c-f48f5635299f",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T05:49:00.000Z",
        "last_edited_time": "2024-12-18T05:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "\"What is iPod? iPod is an MP3 music player that has CD-quality music and it plays all of the popular open formats of digital music: MP3, MP3 VBR, WAV, and AIFF. But that’s not the big deal. The big deal about iPod is it holds 1,000 songs. This is a quantum leap because for most people, it’s their entire music library. This is huge!\"",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "\"What is iPod? iPod is an MP3 music player that has CD-quality music and it plays all of the popular open formats of digital music: MP3, MP3 VBR, WAV, and AIFF. But that’s not the big deal. The big deal about iPod is it holds 1,000 songs. This is a quantum leap because for most people, it’s their entire music library. This is huge!\"",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80b2-8d31-c50c6e755770",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T05:49:00.000Z",
        "last_edited_time": "2024-12-18T05:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "\"iPod is the size of a deck of cards. It weighs only 6.5 ounces, and it fits in your pocket. iPod isn’t just a new way to listen to music. It’s a whole new way of experiencing music.\"",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "\"iPod is the size of a deck of cards. It weighs only 6.5 ounces, and it fits in your pocket. iPod isn’t just a new way to listen to music. It’s a whole new way of experiencing music.\"",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80ae-bf8d-ed5c6aae16b1",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T05:50:00.000Z",
        "last_edited_time": "2024-12-18T05:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-807d-bd1a-dd1da0127ba7",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T05:49:00.000Z",
        "last_edited_time": "2024-12-24T12:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thử phân tích xem nhé:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thử phân tích xem nhé:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-806e-bc27-f2238a37983c",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T06:10:00.000Z",
        "last_edited_time": "2024-12-18T06:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Feature: 5GB; Size of a deck of cards; Weighs only 6.5 ounces; Open formats of digital music: MP3, MP3 VBR, WAV, and AIFF.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Feature: 5GB; Size of a deck of cards; Weighs only 6.5 ounces; Open formats of digital music: MP3, MP3 VBR, WAV, and AIFF.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80e7-a8e1-fcd9aa860202",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T05:49:00.000Z",
        "last_edited_time": "2024-12-18T06:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Benefit: “1000 songs in your pocket”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Benefit: “1000 songs in your pocket”.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8001-9190-ce5091b4fbca",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T06:10:00.000Z",
        "last_edited_time": "2024-12-18T06:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Value: “Freedom to enjoy music anytime, anywhere, without limits”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Value: “Freedom to enjoy music anytime, anywhere, without limits”.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8063-8bb7-ca0f5dbf5ad4",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T05:42:00.000Z",
        "last_edited_time": "2024-12-18T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081389/uxcomic-imgs/1605d164-78d8-8063-8bb7-ca0f5dbf5ad4.png",
            "expiry_time": "2026-10-04T09:11:40.993Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1605d164-78d8-8063-8bb7-ca0f5dbf5ad4"
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8041-8cc0-ca248ae1c601",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T06:21:00.000Z",
        "last_edited_time": "2024-12-18T06:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-819d-8553-e147275da864",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T01:59:00.000Z",
        "last_edited_time": "2024-12-24T13:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách hiểu của user",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách hiểu của user",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-818d-b8dc-f382c40c5478",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T01:59:00.000Z",
        "last_edited_time": "2024-12-21T09:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các khái niệm ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các khái niệm ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "feature",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "feature",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " nói dưới ngôn ngữ của nhà sản xuất (5GB, 12 inch, lưu trữ trên cloud,…), và thường bạn phải là một người rất chuyên môn mới hiểu được giá trị của các thông số đó, còn không thì bạn sẽ tưởng mình đang ở một hành tinh khác, nghe chẳng hiểu gì 🤨.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " nói dưới ngôn ngữ của nhà sản xuất (5GB, 12 inch, lưu trữ trên cloud,…), và thường bạn phải là một người rất chuyên môn mới hiểu được giá trị của các thông số đó, còn không thì bạn sẽ tưởng mình đang ở một hành tinh khác, nghe chẳng hiểu gì 🤨.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1625d164-78d8-800d-b1a9-eb5717c1a9d6",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-20T14:38:00.000Z",
        "last_edited_time": "2024-12-20T14:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80a3-8e15-c799061f4fcc",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T07:11:00.000Z",
        "last_edited_time": "2024-12-21T09:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Benefit",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Benefit",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " thì ngược lại, nó được mô tả kết quả của feature đó dưới ngôn ngữ thường ngày (đẹp hơn, tiết kiệm hơn, hiệu quả hơn,…), vì thế nó dễ hiểu hơn & dễ thấy sự liên quan hơn. Như ví dụ ở trên: khi nói chiếc iPod có 5GB, họ không biết hoặc phải cố hình dung xem 5GB thì được bao nhiêu bài hát, nên Steve Job đã chọn nhấn mạnh luôn thông điệp “1000 songs in your pocket” - hiểu ngay mức độ benefit bạn có (“1000 songs”) & dễ mang theo bên mình (”in your pocket”).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " thì ngược lại, nó được mô tả kết quả của feature đó dưới ngôn ngữ thường ngày (đẹp hơn, tiết kiệm hơn, hiệu quả hơn,…), vì thế nó dễ hiểu hơn & dễ thấy sự liên quan hơn. Như ví dụ ở trên: khi nói chiếc iPod có 5GB, họ không biết hoặc phải cố hình dung xem 5GB thì được bao nhiêu bài hát, nên Steve Job đã chọn nhấn mạnh luôn thông điệp “1000 songs in your pocket” - hiểu ngay mức độ benefit bạn có (“1000 songs”) & dễ mang theo bên mình (”in your pocket”).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-800c-9cff-c58932310b89",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T05:55:00.000Z",
        "last_edited_time": "2024-12-21T09:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lí do khách hàng mua gì đó không nằm ở việc nó có feature gì, mà là nó phục vụ, ảnh hưởng đến cuộc sống của họ như thế nào. Đó là bản năng, khi nghe thấy có gì đó liên quan đến lợi ích của ta, nó sẽ trở nên thuyết phục hơn & lọt lỗ tai hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lí do khách hàng mua gì đó không nằm ở việc nó có feature gì, mà là nó phục vụ, ảnh hưởng đến cuộc sống của họ như thế nào. Đó là bản năng, khi nghe thấy có gì đó liên quan đến lợi ích của ta, nó sẽ trở nên thuyết phục hơn & lọt lỗ tai hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-807d-87f5-e92f411b5a00",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T05:57:00.000Z",
        "last_edited_time": "2024-12-18T07:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Người dùng không mua tính năng, họ mua giải pháp và cảm xúc.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Người dùng không mua tính năng, họ mua giải pháp và cảm xúc.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1625d164-78d8-804f-913f-e8461b3bb65d",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-20T14:22:00.000Z",
        "last_edited_time": "2024-12-21T09:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tip: nếu benefit được quy ra ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tip: nếu benefit được quy ra ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "số",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "số",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " sẽ tăng tính thuyết phục hơn, vì show rõ được ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " sẽ tăng tính thuyết phục hơn, vì show rõ được ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "mức độ ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "mức độ ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "benefit. Ví dụ: 1000 bài hát, tiết kiệm 20% thời gian, giảm 50% sai sót…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "benefit. Ví dụ: 1000 bài hát, tiết kiệm 20% thời gian, giảm 50% sai sót…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80f2-bce2-e84775b6cb1e",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T07:13:00.000Z",
        "last_edited_time": "2024-12-18T07:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-805a-853f-cb26d290b713",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T06:05:00.000Z",
        "last_edited_time": "2025-01-11T13:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Value",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Value",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " thì ở một góc độ rộng hơn, nó chịu sự tác động nhiều hơn từ các yếu tố ngoại cảnh, nó mang tính cá nhân, nó tuỳ vào cách mỗi chúng ta trả lời cho câu hỏi ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " thì ở một góc độ rộng hơn, nó chịu sự tác động nhiều hơn từ các yếu tố ngoại cảnh, nó mang tính cá nhân, nó tuỳ vào cách mỗi chúng ta trả lời cho câu hỏi ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "“So what?”, “Nó tác động gì đến cuộc sống của tôi?”.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“So what?”, “Nó tác động gì đến cuộc sống của tôi?”.",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Value tuỳ vào user perception.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Value tuỳ vào user perception.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8030-8a05-dfd289e0950a",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T06:14:00.000Z",
        "last_edited_time": "2024-12-24T13:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Xin mượn ví dụ hay ho từ ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Xin mượn ví dụ hay ho từ ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "bài viết của bên UX foundation vn",
                "link": {
                  "url": "https://uxfoundation.vn/bai-viet/san-pham-goi-nen-cam-xuc"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "bài viết của bên UX foundation vn",
              "href": "https://uxfoundation.vn/bai-viet/san-pham-goi-nen-cam-xuc"
            },
            {
              "type": "text",
              "text": {
                "content": ": một người con thấy chiếc ghế gỗ đã lâu năm, mỗi tết đều phải lau dọn nó, bạn thấy nó ngồi ê cả mông, lau chùi thì khó khăn, nên muốn bỏ nó đi. Nhưng người bố nhất quyết không đồng ý vì đó là chiếc ghế mà ông đã cất công dành dụm để mua được. Đối với ông đó là minh chứng cho một thành tựu, và mỗi khi ông nhìn vào nó, nó gợi lên những hình ảnh gia đình quay quần, lúc chính người con ấy ngồi đó chơi đùa,… >> cái ghế giờ còn không chỉ là cái ghế nữa, nó hàm chứa nhiều ý nghĩa & cảm xúc. Đây chính là value trong mắt người dùng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": một người con thấy chiếc ghế gỗ đã lâu năm, mỗi tết đều phải lau dọn nó, bạn thấy nó ngồi ê cả mông, lau chùi thì khó khăn, nên muốn bỏ nó đi. Nhưng người bố nhất quyết không đồng ý vì đó là chiếc ghế mà ông đã cất công dành dụm để mua được. Đối với ông đó là minh chứng cho một thành tựu, và mỗi khi ông nhìn vào nó, nó gợi lên những hình ảnh gia đình quay quần, lúc chính người con ấy ngồi đó chơi đùa,… >> cái ghế giờ còn không chỉ là cái ghế nữa, nó hàm chứa nhiều ý nghĩa & cảm xúc. Đây chính là value trong mắt người dùng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80d4-9e44-d664d6bf45fd",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T06:21:00.000Z",
        "last_edited_time": "2024-12-18T06:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8007-aebb-e98557ca955c",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T05:31:00.000Z",
        "last_edited_time": "2024-12-24T12:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tóm lại",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tóm lại",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8054-b8a6-f0c99f1876f3",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-24T12:30:00.000Z",
        "last_edited_time": "2025-01-03T13:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Xét cho cùng kinh doanh hoạt động là sự trao đổi giá trị (value), bạn được thuê để đóng góp cho value mà công ty đang cố tạo ra cho khách hàng, và ngược lại để làm sao công ty get value từ user.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Xét cho cùng kinh doanh hoạt động là sự trao đổi giá trị (value), bạn được thuê để đóng góp cho value mà công ty đang cố tạo ra cho khách hàng, và ngược lại để làm sao công ty get value từ user.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80d8-95e4-d3801dde16fd",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T06:13:00.000Z",
        "last_edited_time": "2025-01-03T13:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "1605d164-78d8-8039-a062-cbeccd597774",
            "parent": {
              "type": "block_id",
              "block_id": "1605d164-78d8-80d8-95e4-d3801dde16fd"
            },
            "created_time": "2024-12-18T06:12:00.000Z",
            "last_edited_time": "2025-01-03T13:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Business create Value",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Business create Value",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 0
          },
          {
            "object": "block",
            "id": "1705d164-78d8-805c-bbcf-ca0369ec83e1",
            "parent": {
              "type": "block_id",
              "block_id": "1605d164-78d8-80d8-95e4-d3801dde16fd"
            },
            "created_time": "2025-01-03T13:24:00.000Z",
            "last_edited_time": "2025-01-10T10:48:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Value shape Benefit.",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Value shape Benefit.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 1
          },
          {
            "object": "block",
            "id": "1705d164-78d8-80a4-934c-e37b0fcc608d",
            "parent": {
              "type": "block_id",
              "block_id": "1605d164-78d8-80d8-95e4-d3801dde16fd"
            },
            "created_time": "2025-01-03T13:24:00.000Z",
            "last_edited_time": "2025-01-03T13:25:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Benefit shape Feature.",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Benefit shape Feature.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 2
          }
        ]
      },
      {
        "object": "block",
        "id": "1635d164-78d8-80b7-b666-dd1d6a09bf2b",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-21T09:16:00.000Z",
        "last_edited_time": "2024-12-21T09:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nên tốt hơn hết chúng ta cần nhớ: value sẽ dẫn dắt benefit, và benefit sẽ định hình cách feature nên hoạt động ra sao chứ không phải theo chiều hướng ngược lại (ta có feature rồi cố gắng nghĩ rằng nó có benefit này, benefit kia và cho rằng user sẽ thấy nó có value).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nên tốt hơn hết chúng ta cần nhớ: value sẽ dẫn dắt benefit, và benefit sẽ định hình cách feature nên hoạt động ra sao chứ không phải theo chiều hướng ngược lại (ta có feature rồi cố gắng nghĩ rằng nó có benefit này, benefit kia và cho rằng user sẽ thấy nó có value).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8047-aa9d-f808e56f9b8b",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T07:06:00.000Z",
        "last_edited_time": "2024-12-24T13:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081391/uxcomic-imgs/1605d164-78d8-8047-aa9d-f808e56f9b8b.png",
            "expiry_time": "2026-10-04T09:11:41.071Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1605d164-78d8-8047-aa9d-f808e56f9b8b"
      },
      {
        "object": "block",
        "id": "1705d164-78d8-807f-a234-c9f1fd431d94",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2025-01-03T13:26:00.000Z",
        "last_edited_time": "2025-01-03T13:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1635d164-78d8-80af-b600-f908a1b44e53",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-21T09:54:00.000Z",
        "last_edited_time": "2024-12-24T12:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hm, vậy cụ thể hơn, với nghĩa vụ của một UX/UI designer thì mình làm được gì? ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hm, vậy cụ thể hơn, với nghĩa vụ của một UX/UI designer thì mình làm được gì? ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1635d164-78d8-80e7-a97d-d1f2f1f0e53d",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-21T09:59:00.000Z",
        "last_edited_time": "2025-01-11T14:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình cần hiểu hoặc làm rõ value, benefit của từng feature, suy nghĩ xem làm sao thông qua design có cách để giúp",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình cần hiểu hoặc làm rõ value, benefit của từng feature, suy nghĩ xem làm sao thông qua design có cách để giúp",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " bôi trơn (tối ưu)",
                "link": {
                  "url": "/f27ddffd7a1646eb9e41c71d27945645"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " bôi trơn (tối ưu)",
              "href": "/f27ddffd7a1646eb9e41c71d27945645"
            },
            {
              "type": "text",
              "text": {
                "content": " việc trao đổi giá trị giữa product và user.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " việc trao đổi giá trị giữa product và user.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8049-9033-d2c997eecd1f",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-24T12:48:00.000Z",
        "last_edited_time": "2025-01-03T13:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Identify what is the value here?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Identify what is the value here?",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-80f4-b1ca-e1fb64d7ce31",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-24T12:41:00.000Z",
        "last_edited_time": "2024-12-24T12:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: bạn thiết kế cho app banking, mà bank thì yếu tố an toàn, đáng tin cậy luôn là value bắt buộc, vậy HMW chúng ta cân nhắc thể hiện đặc điểm này một cách khéo léo xuyên suốt user journey, nó có thể là một tính năng gì đó về authentication (bảo mật 2FA, Face ID,…), có thể là cách lựa chọn phong cách UI nghiêm túc, hay thậm chí là những thứ minor như content câu chữ, icon nhắc đến ngữ nghĩa “bảo mật”,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: bạn thiết kế cho app banking, mà bank thì yếu tố an toàn, đáng tin cậy luôn là value bắt buộc, vậy HMW chúng ta cân nhắc thể hiện đặc điểm này một cách khéo léo xuyên suốt user journey, nó có thể là một tính năng gì đó về authentication (bảo mật 2FA, Face ID,…), có thể là cách lựa chọn phong cách UI nghiêm túc, hay thậm chí là những thứ minor như content câu chữ, icon nhắc đến ngữ nghĩa “bảo mật”,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8171-b2df-d397f5d6d836",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T01:59:00.000Z",
        "last_edited_time": "2024-12-18T01:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8108-a93d-d45f4581e620",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T01:59:00.000Z",
        "last_edited_time": "2024-12-18T01:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8164-878a-fc1fd80d37df",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T01:59:00.000Z",
        "last_edited_time": "2024-12-18T05:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.inc.com/carmine-gallo/3-brilliant-presentation-hacks-steve-jobs-used-to-launch-ipod.html",
                "link": {
                  "url": "https://www.inc.com/carmine-gallo/3-brilliant-presentation-hacks-steve-jobs-used-to-launch-ipod.html"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.inc.com/carmine-gallo/3-brilliant-presentation-hacks-steve-jobs-used-to-launch-ipod.html",
              "href": "https://www.inc.com/carmine-gallo/3-brilliant-presentation-hacks-steve-jobs-used-to-launch-ipod.html"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8090-88e8-f94db8d1adac",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T07:06:00.000Z",
        "last_edited_time": "2024-12-18T07:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://getrafiki.ai/calls/feature-benefit-selling-definition-best-practices-and-more/",
                "link": {
                  "url": "https://getrafiki.ai/calls/feature-benefit-selling-definition-best-practices-and-more/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://getrafiki.ai/calls/feature-benefit-selling-definition-best-practices-and-more/",
              "href": "https://getrafiki.ai/calls/feature-benefit-selling-definition-best-practices-and-more/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-80b1-98ff-c33cf36b4c72",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T07:08:00.000Z",
        "last_edited_time": "2024-12-18T07:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.linkedin.com/pulse/real-difference-between-features-benefits-value-brian-felker/",
                "link": {
                  "url": "https://www.linkedin.com/pulse/real-difference-between-features-benefits-value-brian-felker/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.linkedin.com/pulse/real-difference-between-features-benefits-value-brian-felker/",
              "href": "https://www.linkedin.com/pulse/real-difference-between-features-benefits-value-brian-felker/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8059-9fcf-cc34c38bccad",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T07:09:00.000Z",
        "last_edited_time": "2024-12-18T07:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.butlerbranding.com/branding/write-good-copy-features-benefits-values/",
                "link": {
                  "url": "https://www.butlerbranding.com/branding/write-good-copy-features-benefits-values/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.butlerbranding.com/branding/write-good-copy-features-benefits-values/",
              "href": "https://www.butlerbranding.com/branding/write-good-copy-features-benefits-values/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1bc5d164-78d8-8072-8eac-e280dfee5c25",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2025-03-20T04:52:00.000Z",
        "last_edited_time": "2025-03-20T04:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://thisisthetree.com/blog/understanding-the-consumer-benefit-ladder/#:~:text=The benefit ladder is a,varies from company to company",
                "link": {
                  "url": "https://thisisthetree.com/blog/understanding-the-consumer-benefit-ladder/#:~:text=The%20benefit%20ladder%20is%20a,varies%20from%20company%20to%20company"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://thisisthetree.com/blog/understanding-the-consumer-benefit-ladder/#:~:text=The benefit ladder is a,varies from company to company",
              "href": "https://thisisthetree.com/blog/understanding-the-consumer-benefit-ladder/#:~:text=The%20benefit%20ladder%20is%20a,varies%20from%20company%20to%20company"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-816e-9846-d302a3163057",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T01:59:00.000Z",
        "last_edited_time": "2024-12-18T01:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8145-9fd6-fb704f4f8ee4",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T01:59:00.000Z",
        "last_edited_time": "2024-12-18T01:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1635d164-78d8-8009-86d7-dbd7304d7284",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-21T01:57:00.000Z",
        "last_edited_time": "2024-12-21T01:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product là gì?",
              "href": "https://app.notion.com/p/22f4879b78c641f4ac922219ca7879f2"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8029-a004-cdfbeaf4a680",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T06:01:00.000Z",
        "last_edited_time": "2024-12-18T06:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mental model?",
              "href": "https://app.notion.com/p/73bdf5d9ca494b2789a22dde16b2af7d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8145-8730-ddbc61c8497c",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T01:59:00.000Z",
        "last_edited_time": "2024-12-18T05:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1215d164-78d8-809d-89b0-e84bbf170b05"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Persuade",
              "href": "https://app.notion.com/p/1215d16478d8809d89b0e84bbf170b05"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1605d164-78d8-8037-bf8b-fc1146c63d7a",
        "parent": {
          "type": "page_id",
          "page_id": "1605d164-78d8-80ad-9130-fe44c6663146"
        },
        "created_time": "2024-12-18T06:05:00.000Z",
        "last_edited_time": "2024-12-18T06:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1445d164-78d8-805b-b388-e24b5f13cccb",
    "created_time": "2024-11-20T16:12:00.000Z",
    "last_edited_time": "2026-05-18T05:13:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "fd3cd36d-73dd-4dee-8bd5-d159d6600124"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "View": {
        "id": "ATSa",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "A%5Bqc",
        "type": "select",
        "select": {
          "id": "Blq|",
          "name": "⚓:2",
          "color": "green"
        }
      },
      "Last edited time": {
        "id": "DMgm",
        "type": "last_edited_time",
        "last_edited_time": "2026-05-18T05:13:00.000Z"
      },
      "Publish": {
        "id": "FSnx",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "_tsp",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "g%7BBg",
        "type": "created_time",
        "created_time": "2024-11-20T16:12:00.000Z"
      },
      "Share": {
        "id": "hp~_",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "m%7C%40x",
        "type": "number",
        "number": null
      },
      "Formula": {
        "id": "re%3BE",
        "type": "formula",
        "formula": {
          "type": "number",
          "number": 1
        }
      },
      "Tag": {
        "id": "%7CAvQ",
        "type": "select",
        "select": {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "1-Product",
          "color": "default"
        }
      },
      "ID": {
        "id": "~RYT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FD",
          "number": 30
        }
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Product development process (overall)",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Product development process (overall)",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Product-development-process-overall-1445d16478d8805bb388e24b5f13cccb",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "5cacdbff-b9e2-4973-b565-ec1ae4327ec9",
      "name": "Fundamental",
      "slug": "fundamental",
      "icon": "🌞",
      "order": 2,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "Product",
          "slug": "product",
          "order": 1
        },
        {
          "id": "156ef770-14db-4170-b1d7-95a2fbdf62ba",
          "name": "User",
          "slug": "user",
          "order": 2
        },
        {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "Design",
          "slug": "design",
          "order": 3
        },
        {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "Random",
          "slug": "random",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
      "name": "Product",
      "slug": "product",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "1475d164-78d8-805e-b782-f7390adcbab1",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T05:57:00.000Z",
        "last_edited_time": "2024-11-23T05:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081395/uxcomic-imgs/1475d164-78d8-805e-b782-f7390adcbab1.png",
            "expiry_time": "2026-10-04T09:11:42.157Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1475d164-78d8-805e-b782-f7390adcbab1"
      },
      {
        "object": "block",
        "id": "1445d164-78d8-81bb-b81a-f1ae6db8c76b",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-20T16:12:00.000Z",
        "last_edited_time": "2025-01-12T02:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình hay thắc mắc sao đọc nhiều process, case study… nó nói về câu chuyện đi qua nghiên cứu người dùng, nghiên cứu đối thủ, xây persona, phân tích problem, form giải pháp, lên design, test…,gần như là end-to-end process, mọi thứ đều dường như nằm trong tầm kiểm soát của designer. Nhưng trải qua thực tế thì lại khác, designer không phải là người cần hay được làm hết tất cả những thứ ấy, đặc biệt trong môi trường big corp. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình hay thắc mắc sao đọc nhiều process, case study… nó nói về câu chuyện đi qua nghiên cứu người dùng, nghiên cứu đối thủ, xây persona, phân tích problem, form giải pháp, lên design, test…,gần như là end-to-end process, mọi thứ đều dường như nằm trong tầm kiểm soát của designer. Nhưng trải qua thực tế thì lại khác, designer không phải là người cần hay được làm hết tất cả những thứ ấy, đặc biệt trong môi trường big corp. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-8059-b127-efdb495a1526",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-01-12T02:53:00.000Z",
        "last_edited_time": "2025-01-12T02:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy đâu mới là process mình cần nắm để có nhìn đúng đắn nhất cho công việc của một ux/ui designer?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy đâu mới là process mình cần nắm để có nhìn đúng đắn nhất cho công việc của một ux/ui designer?",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "🤨"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-8091-bb35-da3c29ec4376",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T03:09:00.000Z",
        "last_edited_time": "2024-12-25T02:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một hôm mình tìm được bài viết nói về khái niệm ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một hôm mình tìm được bài viết nói về khái niệm ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "3 diamond product process",
                "link": {
                  "url": "https://nealcabage.com/framework/product-management-process/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3 diamond product process",
              "href": "https://nealcabage.com/framework/product-management-process/"
            },
            {
              "type": "text",
              "text": {
                "content": ", mình thấy nó cung cấp cái hiểu rõ ràng, tổng quát hơn cho việc hiểu quy trình phát triển sản phẩm cho một công ty, từ đó hiểu công việc ux/ui thường ngày đang thực sự đang nằm ở đâu trong đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", mình thấy nó cung cấp cái hiểu rõ ràng, tổng quát hơn cho việc hiểu quy trình phát triển sản phẩm cho một công ty, từ đó hiểu công việc ux/ui thường ngày đang thực sự đang nằm ở đâu trong đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-8052-b1ef-f1e8d61b753d",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T03:11:00.000Z",
        "last_edited_time": "2024-11-23T03:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1445d164-78d8-8003-94e9-df924100896b",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-20T16:15:00.000Z",
        "last_edited_time": "2024-11-23T03:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081396/uxcomic-imgs/1445d164-78d8-8003-94e9-df924100896b.png",
            "expiry_time": "2026-10-04T09:11:42.157Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1445d164-78d8-8003-94e9-df924100896b"
      },
      {
        "object": "block",
        "id": "1445d164-78d8-805b-adfc-c32c0e533b61",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-20T16:15:00.000Z",
        "last_edited_time": "2024-11-23T03:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081398/uxcomic-imgs/1445d164-78d8-805b-adfc-c32c0e533b61.png",
            "expiry_time": "2026-10-04T09:11:42.157Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1445d164-78d8-805b-adfc-c32c0e533b61"
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80ca-b552-d2763210f244",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T06:45:00.000Z",
        "last_edited_time": "2024-11-23T06:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-805e-872b-c48dd28fbfdd",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T06:45:00.000Z",
        "last_edited_time": "2024-11-23T06:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hãy tưởng tượng nhiệm vụ công việc của UX/UI sẽ là một cái hộp nhỏ nằm trong vài cái hộp lớn sau.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hãy tưởng tượng nhiệm vụ công việc của UX/UI sẽ là một cái hộp nhỏ nằm trong vài cái hộp lớn sau.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1495d164-78d8-8039-8703-c8345d4435a8",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-25T02:30:00.000Z",
        "last_edited_time": "2024-11-25T02:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081400/uxcomic-imgs/1495d164-78d8-8039-8703-c8345d4435a8.jpg",
            "expiry_time": "2026-10-04T09:11:42.157Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1495d164-78d8-8039-8703-c8345d4435a8"
      },
      {
        "object": "block",
        "id": "1475d164-78d8-803c-b397-d4f0b2109851",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T03:14:00.000Z",
        "last_edited_time": "2024-11-23T03:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hộp thứ 1: business",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hộp thứ 1: business",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80af-83fe-da683244ac13",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T06:31:00.000Z",
        "last_edited_time": "2024-11-23T06:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có đúng mục tiêu hay không?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có đúng mục tiêu hay không?",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80ac-b1b2-fe3dd15465ff",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T03:11:00.000Z",
        "last_edited_time": "2025-01-12T02:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước khi bàn đến process product development, ta cần hiểu sơ sơ về business, vì business có thể xem như là một cái hộp đóng khung các vấn đề mà product cần phải giải quyết, nó được đóng gói dựa trên việc ta nhắm đến thị trường nào, đang phục vụ cho tệp khách hàng nào, advantage của chúng ta là gì, value proposition, business model... ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước khi bàn đến process product development, ta cần hiểu sơ sơ về business, vì business có thể xem như là một cái hộp đóng khung các vấn đề mà product cần phải giải quyết, nó được đóng gói dựa trên việc ta nhắm đến thị trường nào, đang phục vụ cho tệp khách hàng nào, advantage của chúng ta là gì, value proposition, business model... ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-809f-a3f9-f0cdfbff40c3",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-01-14T11:15:00.000Z",
        "last_edited_time": "2025-01-14T11:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-8072-bd0d-de765a593a30",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-01-12T02:57:00.000Z",
        "last_edited_time": "2025-01-12T02:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Điều này đồng nghĩa với việc không phải problem nào ta cũng giải quyết, mà phải qua một lớp filter của phía business.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Điều này đồng nghĩa với việc không phải problem nào ta cũng giải quyết, mà phải qua một lớp filter của phía business.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80de-9ff6-f3f9d8e4386d",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T03:13:00.000Z",
        "last_edited_time": "2024-11-23T06:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các khía cạnh tác động đến việc ta lựa chọn problem có thể kể đến như:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các khía cạnh tác động đến việc ta lựa chọn problem có thể kể đến như:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-8083-9a4d-c540e82591e4",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T03:13:00.000Z",
        "last_edited_time": "2024-12-13T02:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ta định vị mình ở đâu trên Industry (competitive arena) & đánh vào đâu trong value chain?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ta định vị mình ở đâu trên Industry (competitive arena) & đánh vào đâu trong value chain?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-8006-b788-e3f699c59fdf",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T03:13:00.000Z",
        "last_edited_time": "2024-12-25T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Problem có mapping đúng khi align lại với business model,  với value propositions đã đề ra không?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Problem có mapping đúng khi align lại với business model,  với value propositions đã đề ra không?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-803b-85a0-d206b73d496d",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T06:22:00.000Z",
        "last_edited_time": "2025-01-12T02:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giải quyết chúng đem lại giá trị gì cho user & doanh nghiệp?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giải quyết chúng đem lại giá trị gì cho user & doanh nghiệp?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80cb-8dfe-dd9e55a14ce4",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T06:43:00.000Z",
        "last_edited_time": "2024-12-25T02:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giải quyết chúng có khiến ta nổi bật & cạnh tranh hơn so với đối thủ không?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giải quyết chúng có khiến ta nổi bật & cạnh tranh hơn so với đối thủ không?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-800f-a9b4-ef87b18f78a2",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-01-14T11:15:00.000Z",
        "last_edited_time": "2025-01-14T11:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-80fc-8a52-f1de762ee27d",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-01-12T02:58:00.000Z",
        "last_edited_time": "2025-01-12T03:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "P/s: nhưng làm sao để tìm kiếm các cơ hội này, đó là công việc của các cấp trên, của bộ phận R&D, công ty mình có hẳn 1 team quan sát từng thay đổi ngoài thị trường, theo sát từng động tĩnh của đối thủ, đã hen 😀.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "P/s: nhưng làm sao để tìm kiếm các cơ hội này, đó là công việc của các cấp trên, của bộ phận R&D, công ty mình có hẳn 1 team quan sát từng thay đổi ngoài thị trường, theo sát từng động tĩnh của đối thủ, đã hen 😀.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-8002-8ffb-dc5e77336717",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-01-12T02:58:00.000Z",
        "last_edited_time": "2025-01-12T02:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80a4-98c4-e20ebd4dfc7f",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T03:22:00.000Z",
        "last_edited_time": "2024-11-23T03:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hộp thứ 2: strategy",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hộp thứ 2: strategy",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80da-aaf4-c744d6f63c6b",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T06:31:00.000Z",
        "last_edited_time": "2024-11-23T06:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có đáng hay không?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có đáng hay không?",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1495d164-78d8-80e9-8f40-c3dbbb5ac915",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-25T15:10:00.000Z",
        "last_edited_time": "2024-12-06T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081401/uxcomic-imgs/1495d164-78d8-80e9-8f40-c3dbbb5ac915.png",
            "expiry_time": "2026-10-04T09:11:42.270Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1495d164-78d8-80e9-8f40-c3dbbb5ac915"
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80e4-a345-d84f8f8bc3c3",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T03:23:00.000Z",
        "last_edited_time": "2024-12-25T02:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi đã nghiên cứu đủ nhiều bể problem ta sẽ phát hiện ra các cơ hội (giá trị của việc giải quyết problem ấy), nhưng dựa trên resource, tình hình kinh doanh, giai đoạn sản phẩm, chiến lược cạnh tranh hiện tại, các problem sẽ được filter lại, để quyết định xem đâu là cái ta phải làm, đâu là cái ta nên & không nên làm, đâu là cái đáng để đầu tư nhiều, đâu là cái “vừa đủ xài” là được…(kiếm vấn đề để giải quyết không khó, nhưng chọn cái nào để giải quyết mới khó 🤣).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi đã nghiên cứu đủ nhiều bể problem ta sẽ phát hiện ra các cơ hội (giá trị của việc giải quyết problem ấy), nhưng dựa trên resource, tình hình kinh doanh, giai đoạn sản phẩm, chiến lược cạnh tranh hiện tại, các problem sẽ được filter lại, để quyết định xem đâu là cái ta phải làm, đâu là cái ta nên & không nên làm, đâu là cái đáng để đầu tư nhiều, đâu là cái “vừa đủ xài” là được…(kiếm vấn đề để giải quyết không khó, nhưng chọn cái nào để giải quyết mới khó 🤣).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-8041-ae67-e95334f253e4",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-12-25T02:10:00.000Z",
        "last_edited_time": "2025-01-14T00:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ngoài kia có nhiều framework để hỗ trợ giúp mình ra quyết định cho việc này, ví dụ như: Opportunity Scoring, Opportunity Cost, ICE Scoring, Jobs To Be Done (JTBD), Kano model,…(",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ngoài kia có nhiều framework để hỗ trợ giúp mình ra quyết định cho việc này, ví dụ như: Opportunity Scoring, Opportunity Cost, ICE Scoring, Jobs To Be Done (JTBD), Kano model,…(",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "xem thêm bài này",
                "link": {
                  "url": "https://roadmunk.com/guides/product-prioritization-techniques-product-managers/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "xem thêm bài này",
              "href": "https://roadmunk.com/guides/product-prioritization-techniques-product-managers/"
            },
            {
              "type": "text",
              "text": {
                "content": ")",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ")",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-8049-8900-fbfb497e1953",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-01-12T03:00:00.000Z",
        "last_edited_time": "2025-01-12T03:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80c0-ad47-fb79b4c27a11",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T08:13:00.000Z",
        "last_edited_time": "2025-01-14T00:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tất cả những gì liên quan đến ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tất cả những gì liên quan đến ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "strategy là sự lựa chọn",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "strategy là sự lựa chọn",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", mà mọi sự lựa chọn đều có trade-off nhất định. Mà lựa chọn không hề dễ nhe, mỗi bước đi đều là một ván cược (",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", mà mọi sự lựa chọn đều có trade-off nhất định. Mà lựa chọn không hề dễ nhe, mỗi bước đi đều là một ván cược (",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "tham khảo thêm ở bài này",
                "link": {
                  "url": "https://roadmunk.com/guides/idea-management-process-tips/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "tham khảo thêm ở bài này",
              "href": "https://roadmunk.com/guides/idea-management-process-tips/"
            },
            {
              "type": "text",
              "text": {
                "content": " về câu chuyện nhức nhối nên chọn idea nào).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " về câu chuyện nhức nhối nên chọn idea nào).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-80d2-a1e5-cd60b7d55876",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-01-14T00:56:00.000Z",
        "last_edited_time": "2025-01-14T00:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dựa theo ERRC grid, thành quả của sự cân nhắc này là trả lời được các câu hỏi sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dựa theo ERRC grid, thành quả của sự cân nhắc này là trả lời được các câu hỏi sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80f5-8a09-e11aa6862e6b",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T08:05:00.000Z",
        "last_edited_time": "2024-12-25T02:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Eliminate: những yếu tố nào không còn quan trọng nữa & có thể cắt bỏ?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Eliminate: những yếu tố nào không còn quan trọng nữa & có thể cắt bỏ?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80a0-aa5f-e61aab229dcf",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T08:06:00.000Z",
        "last_edited_time": "2024-12-25T02:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reduce: những yếu tố nào có thể cân nhắc giảm mức độ đầu tư?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reduce: những yếu tố nào có thể cân nhắc giảm mức độ đầu tư?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80c3-9c0e-ef9c7c75b14a",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T08:06:00.000Z",
        "last_edited_time": "2024-12-25T02:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Raise: những yếu tố nào cần được nâng cao hơn?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Raise: những yếu tố nào cần được nâng cao hơn?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80ad-8c0f-f8eceb078a9a",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T08:06:00.000Z",
        "last_edited_time": "2024-12-25T02:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Create: những yếu tố nào có thể được tạo ra? Những tính năng/đầu tư mới nào có thể đem lại value?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Create: những yếu tố nào có thể được tạo ra? Những tính năng/đầu tư mới nào có thể đem lại value?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80a0-9883-d4914b48202a",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T08:41:00.000Z",
        "last_edited_time": "2024-11-23T09:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081402/uxcomic-imgs/1475d164-78d8-80a0-9883-d4914b48202a.png",
            "expiry_time": "2026-10-04T09:11:42.270Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1475d164-78d8-80a0-9883-d4914b48202a"
      },
      {
        "object": "block",
        "id": "1795d164-78d8-800a-a557-e5566a39e5fe",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-01-12T03:00:00.000Z",
        "last_edited_time": "2025-01-12T03:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80af-8b28-d8931e2e3739",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T03:36:00.000Z",
        "last_edited_time": "2024-11-23T09:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hộp thứ 3: solution forming",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hộp thứ 3: solution forming",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-804f-abb8-f056567c9bde",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T06:31:00.000Z",
        "last_edited_time": "2024-11-23T06:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có tối ưu hay không?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có tối ưu hay không?",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-805d-9fab-dc604569053e",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T03:30:00.000Z",
        "last_edited_time": "2025-01-14T11:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau khi đã có một danh sách ưu tiên các vấn đề cần giải quyết, việc tiếp theo là lên một danh sách các solution idea để giải quyết chúng (method: Opportunity Solution Tree), solution có thể là feature hoặc có thể không, miễn chúng giải quyết được problem (ví dụ: có thể solution nằm ở các department khác như customer support, marketing, operation, hoặc có thể là sự hợp tác, hoặc tận dụng một giải pháp nào đó có sẵn ngoài kia…). Và bộ phận product development sẽ tập trung giải pháp nào build được trên product.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau khi đã có một danh sách ưu tiên các vấn đề cần giải quyết, việc tiếp theo là lên một danh sách các solution idea để giải quyết chúng (method: Opportunity Solution Tree), solution có thể là feature hoặc có thể không, miễn chúng giải quyết được problem (ví dụ: có thể solution nằm ở các department khác như customer support, marketing, operation, hoặc có thể là sự hợp tác, hoặc tận dụng một giải pháp nào đó có sẵn ngoài kia…). Và bộ phận product development sẽ tập trung giải pháp nào build được trên product.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-80d5-989d-c7769558501b",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-01-14T11:15:00.000Z",
        "last_edited_time": "2025-01-14T11:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-80a0-9e24-f98accce25d8",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-01-12T03:01:00.000Z",
        "last_edited_time": "2025-01-12T03:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tương tự solution cũng cần đến sự lựa chọn & ưu tiên, đánh giá xem đâu là giải pháp tối ưu nhất cho thời điểm hiện tại, các framework hỗ trợ ví dụ như: SWOT, Impact/Effort matrix, RICE, Pugh Matrix, Weighted Scoring Model, Cost-Benefit Analysis,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tương tự solution cũng cần đến sự lựa chọn & ưu tiên, đánh giá xem đâu là giải pháp tối ưu nhất cho thời điểm hiện tại, các framework hỗ trợ ví dụ như: SWOT, Impact/Effort matrix, RICE, Pugh Matrix, Weighted Scoring Model, Cost-Benefit Analysis,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-80a1-9d9f-f4d61693197c",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-01-12T03:02:00.000Z",
        "last_edited_time": "2025-01-12T03:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cùng tuỳ theo mức độ tự tin về problem statement, về solution, mà ta linh hoạt xem có nên test, research thêm hay không.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cùng tuỳ theo mức độ tự tin về problem statement, về solution, mà ta linh hoạt xem có nên test, research thêm hay không.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-8094-b50b-ecf3e3646576",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T04:51:00.000Z",
        "last_edited_time": "2024-11-23T04:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80c7-8a2b-df336d814d96",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T06:47:00.000Z",
        "last_edited_time": "2024-11-25T02:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hộp thứ 4 - build solution",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hộp thứ 4 - build solution",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1495d164-78d8-805f-88eb-d19f1e631685",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-25T02:15:00.000Z",
        "last_edited_time": "2024-11-25T02:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đây là cái hộp có chứa công việc của UX/UI.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đây là cái hộp có chứa công việc của UX/UI.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80a7-a03a-d4fee215ce55",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T03:31:00.000Z",
        "last_edited_time": "2025-01-12T03:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Với kinh nghiệm hiện tại của mình, thì mình thấy gần như tất cả công việc nằm ở stage Feature development, điều này có nghĩa là mình không phải người được đi lựa chọn problem nào để giải quyết, mình không phải là người được contribute vào khâu form solution, tất cả những gì mình làm là transform solution ấy (nghe hơi buồn 😢 mà với mình thực tế đang là vậy).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Với kinh nghiệm hiện tại của mình, thì mình thấy gần như tất cả công việc nằm ở stage Feature development, điều này có nghĩa là mình không phải người được đi lựa chọn problem nào để giải quyết, mình không phải là người được contribute vào khâu form solution, tất cả những gì mình làm là transform solution ấy (nghe hơi buồn 😢 mà với mình thực tế đang là vậy).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-802a-aa55-ed604f4566c3",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-01-14T11:15:00.000Z",
        "last_edited_time": "2025-01-14T11:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-80e9-bf05-fa2516a0e2e7",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-01-12T03:03:00.000Z",
        "last_edited_time": "2025-01-12T03:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu nhìn theo hình tháp ở dưới, mình sẽ nằm đâu đó từ feature project đổ xuống. Nên nếu gói gọn công việc ở box này, những gì liên can đến problem hay solution, điều ta có thể làm là hiểu rõ nó để thiết kế sao cho đúng yêu cầu, hoặc cao hơn chút là đóng góp ý kiến cho solution concept, chứ mình không phải decision maker cho việc ấy (mình hay nhầm điều này mà qua khoá học, học đọc case study, tưởng rằng mình được đóng góp cho việc đó… hay level hiện tại mình chưa được 🫢).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu nhìn theo hình tháp ở dưới, mình sẽ nằm đâu đó từ feature project đổ xuống. Nên nếu gói gọn công việc ở box này, những gì liên can đến problem hay solution, điều ta có thể làm là hiểu rõ nó để thiết kế sao cho đúng yêu cầu, hoặc cao hơn chút là đóng góp ý kiến cho solution concept, chứ mình không phải decision maker cho việc ấy (mình hay nhầm điều này mà qua khoá học, học đọc case study, tưởng rằng mình được đóng góp cho việc đó… hay level hiện tại mình chưa được 🫢).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1445d164-78d8-80e0-95e3-e481a38509e7",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-20T16:17:00.000Z",
        "last_edited_time": "2024-11-23T03:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081404/uxcomic-imgs/1445d164-78d8-80e0-95e3-e481a38509e7.png",
            "expiry_time": "2026-10-04T09:11:42.271Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1445d164-78d8-80e0-95e3-e481a38509e7"
      },
      {
        "object": "block",
        "id": "1475d164-78d8-8010-bcfd-ff91c5b76f8c",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T03:31:00.000Z",
        "last_edited_time": "2024-11-23T03:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1445d164-78d8-8198-84b2-d837764536a1",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-20T16:12:00.000Z",
        "last_edited_time": "2024-11-23T03:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "So what",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "So what",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2775d164-78d8-8045-b81b-c09b825e3235",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-09-23T09:13:00.000Z",
        "last_edited_time": "2025-09-23T09:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1759892380/uxcomic-imgs/2775d164-78d8-8045-b81b-c09b825e3235.png",
            "expiry_time": "2026-10-04T09:11:42.366Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2775d164-78d8-8045-b81b-c09b825e3235"
      },
      {
        "object": "block",
        "id": "1475d164-78d8-8041-9718-cd825688c2fa",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T07:17:00.000Z",
        "last_edited_time": "2025-01-12T03:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bài biết này chỉ mang tính chất cho vài cái nhìn cơ bản, tổng quan, tất nhiên mình cũng không có kinh nghiệm gì để có thể nói sâu tất cả các thứ trên (vì mình chưa được tiếp cận hay trải nghiệm qua các nấc thang đó mà, chắc khi mình là founder hay PM thì mới có cơ hội làm hết các việc đó). Nhưng tìm hiểu nó giúp mình nhận ra vài ý sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bài biết này chỉ mang tính chất cho vài cái nhìn cơ bản, tổng quan, tất nhiên mình cũng không có kinh nghiệm gì để có thể nói sâu tất cả các thứ trên (vì mình chưa được tiếp cận hay trải nghiệm qua các nấc thang đó mà, chắc khi mình là founder hay PM thì mới có cơ hội làm hết các việc đó). Nhưng tìm hiểu nó giúp mình nhận ra vài ý sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-8019-b5b8-eb6b88ec5c11",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T03:39:00.000Z",
        "last_edited_time": "2025-01-12T03:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuỳ theo tổ chức & đặc thù sản phẩm mà mình nên set đúng expectations về công việc hiện tại. Ví dụ: ở start-up bạn có thể được tham gia thêm các khâu về định hình problem & solution, tuy nhiên big corp thì cần mình chuyên sâu, các phần việc kia đã có bộ phận khác handle, cụ thể là PM/PO.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuỳ theo tổ chức & đặc thù sản phẩm mà mình nên set đúng expectations về công việc hiện tại. Ví dụ: ở start-up bạn có thể được tham gia thêm các khâu về định hình problem & solution, tuy nhiên big corp thì cần mình chuyên sâu, các phần việc kia đã có bộ phận khác handle, cụ thể là PM/PO.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-8009-ab62-f3f9e594ff7f",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T06:53:00.000Z",
        "last_edited_time": "2024-11-23T06:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu mình mong muốn được tạo ra nhiều impact hơn, thì mình nghĩ có 2 hướng",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu mình mong muốn được tạo ra nhiều impact hơn, thì mình nghĩ có 2 hướng",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "1475d164-78d8-808e-bbe7-ee4e29a4c036",
            "parent": {
              "type": "block_id",
              "block_id": "1475d164-78d8-8009-ab62-f3f9e594ff7f"
            },
            "created_time": "2024-11-23T06:54:00.000Z",
            "last_edited_time": "2024-11-23T06:59:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Khả năng involve vào nhiều phase hơn, tham gia vào phase form solution hoặc biểu quyết giải quyết problem nào. Chứng minh được sự tác động của ux metrics lên business metrics.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Khả năng involve vào nhiều phase hơn, tham gia vào phase form solution hoặc biểu quyết giải quyết problem nào. Chứng minh được sự tác động của ux metrics lên business metrics.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 0
          },
          {
            "object": "block",
            "id": "1475d164-78d8-80aa-b65e-c6096003ea1d",
            "parent": {
              "type": "block_id",
              "block_id": "1475d164-78d8-8009-ab62-f3f9e594ff7f"
            },
            "created_time": "2024-11-23T06:55:00.000Z",
            "last_edited_time": "2024-11-25T02:21:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Khả năng scale giá trị của design. Ví dụ: leader có khả năng build team, quản lý và cải thiện năng suất, chất lượng của design; hay build design system để cải thiện design mang tính hệ thống & cục diện cho product;…",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Khả năng scale giá trị của design. Ví dụ: leader có khả năng build team, quản lý và cải thiện năng suất, chất lượng của design; hay build design system để cải thiện design mang tính hệ thống & cục diện cho product;…",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 1
          }
        ]
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80a3-b11a-c2b939a0a602",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T04:53:00.000Z",
        "last_edited_time": "2024-12-25T02:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Từ việc hiểu này biết đâu đó cho thêm một góc nhìn bao quát hơn, sẽ giúp bạn giao tiếp hiệu quả hơn, biết đâu đó bạn sẽ có khả năng đóng góp ý kiến nhiều hơn vì thay vì chỉ nói thuần về design.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Từ việc hiểu này biết đâu đó cho thêm một góc nhìn bao quát hơn, sẽ giúp bạn giao tiếp hiệu quả hơn, biết đâu đó bạn sẽ có khả năng đóng góp ý kiến nhiều hơn vì thay vì chỉ nói thuần về design.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-8082-9df3-ebda97656137",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T03:41:00.000Z",
        "last_edited_time": "2024-11-23T07:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nó kích thích mình tò mò quan sát & tìm hiểu thêm công việc của các stakeholder, đặc biệt là PM/ PO, để hiểu về lí do gì họ chọn giải quyết problem này, lí do gì ta lại tiếp cận bằng solution này chứ không phải solution kia,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nó kích thích mình tò mò quan sát & tìm hiểu thêm công việc của các stakeholder, đặc biệt là PM/ PO, để hiểu về lí do gì họ chọn giải quyết problem này, lí do gì ta lại tiếp cận bằng solution này chứ không phải solution kia,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8050-9cb9-e5f80ae7c90c",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-12-23T13:30:00.000Z",
        "last_edited_time": "2024-12-23T13:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80ba-8db7-cacc45b7d111",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-12-23T13:30:00.000Z",
        "last_edited_time": "2024-12-23T13:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bonus",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bonus",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": video này nói về một sản phẩm MVP thực tế, qua đó mình nghĩ sẽ giúp hiểu rõ hơn về việc build product là như thế nào.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": video này nói về một sản phẩm MVP thực tế, qua đó mình nghĩ sẽ giúp hiểu rõ hơn về việc build product là như thế nào.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80ae-b360-fadb2f4b9c5b",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-12-23T13:27:00.000Z",
        "last_edited_time": "2024-12-23T13:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "video",
        "video": {
          "caption": [],
          "type": "external",
          "external": {
            "url": "https://youtu.be/hGRBiox-Gbo?si=KpemKXRCqOykn2ao"
          }
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1445d164-78d8-81dc-a86b-d7003a1b470b",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-20T16:12:00.000Z",
        "last_edited_time": "2024-11-20T16:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1445d164-78d8-814c-b0e7-d651b54e780d",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-20T16:12:00.000Z",
        "last_edited_time": "2024-11-20T16:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1c15d164-78d8-800c-a469-d2b3a809699f",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-03-25T05:56:00.000Z",
        "last_edited_time": "2025-04-15T02:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081406/uxcomic-imgs/1c15d164-78d8-800c-a469-d2b3a809699f.jpg",
            "expiry_time": "2026-10-04T09:11:42.366Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1c15d164-78d8-800c-a469-d2b3a809699f"
      },
      {
        "object": "block",
        "id": "1c15d164-78d8-80c7-adae-e4e23bb8abd7",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-03-25T05:55:00.000Z",
        "last_edited_time": "2025-03-25T05:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1445d164-78d8-812f-afc7-f16e89b0f0f4",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-20T16:12:00.000Z",
        "last_edited_time": "2024-11-20T16:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://nealcabage.com/framework/product-management-process/",
                "link": {
                  "url": "https://nealcabage.com/framework/product-management-process/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://nealcabage.com/framework/product-management-process/",
              "href": "https://nealcabage.com/framework/product-management-process/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2265d164-78d8-8044-b926-c686dd36b6bd",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-07-04T03:54:00.000Z",
        "last_edited_time": "2025-07-04T03:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://aakashgupta.medium.com/the-prd-that-actually-works-15-years-of-product-lessons-in-5-minutes-c3d3523efe42",
                "link": {
                  "url": "https://aakashgupta.medium.com/the-prd-that-actually-works-15-years-of-product-lessons-in-5-minutes-c3d3523efe42"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://aakashgupta.medium.com/the-prd-that-actually-works-15-years-of-product-lessons-in-5-minutes-c3d3523efe42",
              "href": "https://aakashgupta.medium.com/the-prd-that-actually-works-15-years-of-product-lessons-in-5-minutes-c3d3523efe42"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-80c7-9096-c244ff10cfe2",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T06:24:00.000Z",
        "last_edited_time": "2024-11-23T08:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://businessmodelnavigator.com/",
                "link": {
                  "url": "https://businessmodelnavigator.com/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://businessmodelnavigator.com/",
              "href": "https://businessmodelnavigator.com/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-8006-b7d7-c2cadf72c29b",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T06:24:00.000Z",
        "last_edited_time": "2024-11-23T06:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://d.mba/guides/7-things-designer-should-know-about-business",
                "link": {
                  "url": "https://d.mba/guides/7-things-designer-should-know-about-business"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://d.mba/guides/7-things-designer-should-know-about-business",
              "href": "https://d.mba/guides/7-things-designer-should-know-about-business"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1475d164-78d8-807f-9920-d9e3d1de176c",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-23T08:03:00.000Z",
        "last_edited_time": "2024-11-23T08:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://d.mba/guides/strategy-design-sprint#backhere",
                "link": {
                  "url": "https://d.mba/guides/strategy-design-sprint#backhere"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://d.mba/guides/strategy-design-sprint#backhere",
              "href": "https://d.mba/guides/strategy-design-sprint#backhere"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23f5d164-78d8-8054-b853-d47b91d41473",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-07-29T03:25:00.000Z",
        "last_edited_time": "2025-07-29T03:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://productmates.substack.com/p/phan-tang-ux-e-lam-ux-tot-hon?",
                "link": {
                  "url": "https://productmates.substack.com/p/phan-tang-ux-e-lam-ux-tot-hon?r=1ir4ee&utm_campaign=post&utm_medium=web&triedRedirect=true"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://productmates.substack.com/p/phan-tang-ux-e-lam-ux-tot-hon?",
              "href": "https://productmates.substack.com/p/phan-tang-ux-e-lam-ux-tot-hon?r=1ir4ee&utm_campaign=post&utm_medium=web&triedRedirect=true"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23f5d164-78d8-80f1-9e35-cc4ee20540cd",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-07-29T03:53:00.000Z",
        "last_edited_time": "2025-07-29T03:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.tandfonline.com/doi/full/10.1080/08956308.2023.2297337#abstract",
                "link": {
                  "url": "https://www.tandfonline.com/doi/full/10.1080/08956308.2023.2297337#abstract"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.tandfonline.com/doi/full/10.1080/08956308.2023.2297337#abstract",
              "href": "https://www.tandfonline.com/doi/full/10.1080/08956308.2023.2297337#abstract"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "26b5d164-78d8-801e-88f8-cc86990eadf2",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-09-11T06:06:00.000Z",
        "last_edited_time": "2025-09-11T06:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://steveblank.com/tag/customer-development/",
                "link": {
                  "url": "https://steveblank.com/tag/customer-development/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://steveblank.com/tag/customer-development/",
              "href": "https://steveblank.com/tag/customer-development/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "26b5d164-78d8-802e-aa6f-eaeb1538913d",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-09-11T06:06:00.000Z",
        "last_edited_time": "2025-09-11T06:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://steveblank.com/2009/08/27/the-leading-cause-of-startup-death-the-product-development-diagram/",
                "link": {
                  "url": "https://steveblank.com/2009/08/27/the-leading-cause-of-startup-death-the-product-development-diagram/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://steveblank.com/2009/08/27/the-leading-cause-of-startup-death-the-product-development-diagram/",
              "href": "https://steveblank.com/2009/08/27/the-leading-cause-of-startup-death-the-product-development-diagram/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2775d164-78d8-8007-a56f-dad62aa9b99e",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-09-23T09:20:00.000Z",
        "last_edited_time": "2025-09-23T09:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://david-theil.medium.com/rethinking-the-product-backlog-from-ticket-storage-to-agile-strategy-bea3fbffec4a",
                "link": {
                  "url": "https://david-theil.medium.com/rethinking-the-product-backlog-from-ticket-storage-to-agile-strategy-bea3fbffec4a"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://david-theil.medium.com/rethinking-the-product-backlog-from-ticket-storage-to-agile-strategy-bea3fbffec4a",
              "href": "https://david-theil.medium.com/rethinking-the-product-backlog-from-ticket-storage-to-agile-strategy-bea3fbffec4a"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "29e5d164-78d8-807d-a90d-ebecb0de9050",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-11-01T08:02:00.000Z",
        "last_edited_time": "2025-11-01T08:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.threads.com/@ntsoraa/post/DQgXfZtk6WC?xmt=AQF06DCmJNrr8MEX2eK6grbs5r1aKqGY9rpts1RFCjAFsA&slof=1",
                "link": {
                  "url": "https://www.threads.com/@ntsoraa/post/DQgXfZtk6WC?xmt=AQF06DCmJNrr8MEX2eK6grbs5r1aKqGY9rpts1RFCjAFsA&slof=1"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.threads.com/@ntsoraa/post/DQgXfZtk6WC?xmt=AQF06DCmJNrr8MEX2eK6grbs5r1aKqGY9rpts1RFCjAFsA&slof=1",
              "href": "https://www.threads.com/@ntsoraa/post/DQgXfZtk6WC?xmt=AQF06DCmJNrr8MEX2eK6grbs5r1aKqGY9rpts1RFCjAFsA&slof=1"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3645d164-78d8-806c-b6ae-d36d78b785e8",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2026-05-18T05:13:00.000Z",
        "last_edited_time": "2026-05-18T05:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://userpilot.com/blog/product-pilot/",
                "link": {
                  "url": "https://userpilot.com/blog/product-pilot/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://userpilot.com/blog/product-pilot/",
              "href": "https://userpilot.com/blog/product-pilot/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1445d164-78d8-8197-8c02-d330c10177c4",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-20T16:12:00.000Z",
        "last_edited_time": "2024-11-20T16:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1445d164-78d8-81b7-8b49-fb7d0ebc2a00",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-20T16:12:00.000Z",
        "last_edited_time": "2024-11-20T16:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1445d164-78d8-81e4-99d0-d09dbf0e5999",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-20T16:12:00.000Z",
        "last_edited_time": "2024-11-23T04:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1025d164-78d8-80c5-891f-debd0fc09547"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product development process (detail)",
              "href": "https://app.notion.com/p/1025d16478d880c5891fdebd0fc09547"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1445d164-78d8-8121-a977-d047d82f6837",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2024-11-20T16:12:00.000Z",
        "last_edited_time": "2024-11-23T04:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product là gì?",
              "href": "https://app.notion.com/p/22f4879b78c641f4ac922219ca7879f2"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2265d164-78d8-8005-aab9-ebe1114ac09d",
        "parent": {
          "type": "page_id",
          "page_id": "1445d164-78d8-805b-b388-e24b5f13cccb"
        },
        "created_time": "2025-07-04T03:54:00.000Z",
        "last_edited_time": "2025-07-04T03:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10",
    "created_time": "2024-10-24T11:38:00.000Z",
    "last_edited_time": "2025-08-08T10:54:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "fd3cd36d-73dd-4dee-8bd5-d159d6600124"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "View": {
        "id": "ATSa",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "A%5Bqc",
        "type": "select",
        "select": {
          "id": "Blq|",
          "name": "⚓:2",
          "color": "green"
        }
      },
      "Last edited time": {
        "id": "DMgm",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-08T10:54:00.000Z"
      },
      "Publish": {
        "id": "FSnx",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "_tsp",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "g%7BBg",
        "type": "created_time",
        "created_time": "2024-10-24T11:38:00.000Z"
      },
      "Share": {
        "id": "hp~_",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "m%7C%40x",
        "type": "number",
        "number": null
      },
      "Formula": {
        "id": "re%3BE",
        "type": "formula",
        "formula": {
          "type": "number",
          "number": 1
        }
      },
      "Tag": {
        "id": "%7CAvQ",
        "type": "select",
        "select": {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "3-Design",
          "color": "default"
        }
      },
      "ID": {
        "id": "~RYT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FD",
          "number": 27
        }
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "“Rõ dần”",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "“Rõ dần”",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/R-d-n-5b45ba369dad4a92bccb7e54a1db1c10",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "5cacdbff-b9e2-4973-b565-ec1ae4327ec9",
      "name": "Fundamental",
      "slug": "fundamental",
      "icon": "🌞",
      "order": 2,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "Product",
          "slug": "product",
          "order": 1
        },
        {
          "id": "156ef770-14db-4170-b1d7-95a2fbdf62ba",
          "name": "User",
          "slug": "user",
          "order": 2
        },
        {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "Design",
          "slug": "design",
          "order": 3
        },
        {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "Random",
          "slug": "random",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
      "name": "Design",
      "slug": "design",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "1295d164-78d8-815d-bf71-f3367b114dc3",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-10-24T11:39:00.000Z",
        "last_edited_time": "2024-10-27T04:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081409/uxcomic-imgs/1295d164-78d8-815d-bf71-f3367b114dc3.png",
            "expiry_time": "2026-10-04T09:11:44.869Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1295d164-78d8-815d-bf71-f3367b114dc3"
      },
      {
        "object": "block",
        "id": "1295d164-78d8-819a-9039-ec81e41c723a",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-10-24T11:39:00.000Z",
        "last_edited_time": "2024-10-27T04:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hôm nay khi mình nghe một video trên Youtube có mention đến chuyến tàu lửa, toa theo toa. Làm mình liên tưởng đến chữ “process”. Mình cũng hay hình dung process là step by step, phải xong việc này mới đến việc kia, như nấu ăn sẽ qua sơ chế nguyên liệu, ướp, xào, trộn thì mới ra được dĩa đồ ăn. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hôm nay khi mình nghe một video trên Youtube có mention đến chuyến tàu lửa, toa theo toa. Làm mình liên tưởng đến chữ “process”. Mình cũng hay hình dung process là step by step, phải xong việc này mới đến việc kia, như nấu ăn sẽ qua sơ chế nguyên liệu, ướp, xào, trộn thì mới ra được dĩa đồ ăn. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-80b0-9adb-f70474b81f74",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2025-01-21T02:35:00.000Z",
        "last_edited_time": "2025-01-21T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-8075-b665-f318a66e03ca",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-10-27T04:54:00.000Z",
        "last_edited_time": "2025-01-21T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhưng càng nhìn lại trong công việc hiện tại UX/UI, đúng là vẫn có step by step và giá trị của nó là không phải bàn cãi, nhưng mình cũng rất hay gặp phải trường hợp làm bước 2 phải quay lại bước 1 clarify thêm, làm đến bước 3 thì thấy bước 2 chưa cân nhắc kĩ. >> Nên mình thấy “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhưng càng nhìn lại trong công việc hiện tại UX/UI, đúng là vẫn có step by step và giá trị của nó là không phải bàn cãi, nhưng mình cũng rất hay gặp phải trường hợp làm bước 2 phải quay lại bước 1 clarify thêm, làm đến bước 3 thì thấy bước 2 chưa cân nhắc kĩ. >> Nên mình thấy “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "rõ dần",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "rõ dần",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "” là một trạng thái luôn có trong process, nó giống như tình trạng bạn đeo kính, có lớp sương che mờ đi & từ từ nó rõ lên.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” là một trạng thái luôn có trong process, nó giống như tình trạng bạn đeo kính, có lớp sương che mờ đi & từ từ nó rõ lên.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80b7-91b2-dcb0eca6ce39",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2025-01-04T12:17:00.000Z",
        "last_edited_time": "2025-01-21T02:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081410/uxcomic-imgs/1715d164-78d8-80b7-91b2-dcb0eca6ce39.webp",
            "expiry_time": "2026-10-04T09:11:44.869Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1715d164-78d8-80b7-91b2-dcb0eca6ce39"
      },
      {
        "object": "block",
        "id": "1325d164-78d8-8034-9e19-d2c045dea8b5",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-11-02T06:10:00.000Z",
        "last_edited_time": "2024-11-02T06:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-8192-bc76-fc18efadd05e",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-10-24T11:39:00.000Z",
        "last_edited_time": "2024-10-24T15:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy cái gì trở nên “rõ hơn”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy cái gì trở nên “rõ hơn”",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-81ce-83e6-f10fc499f62e",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-10-24T11:39:00.000Z",
        "last_edited_time": "2024-12-25T01:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong công việc UX/UI thì rõ ràng nhất đó chính là một bản mockup, prototype. Nhưng nó chỉ là phần nổi của tảng băng chìm. Vậy tảng băng chìm đó là gì? Là những thứ không lồ lộ ra UI, ra interaction, nó là IA, là flow của các functionality, system, là những user need & objectives đã được define từ trước đó…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong công việc UX/UI thì rõ ràng nhất đó chính là một bản mockup, prototype. Nhưng nó chỉ là phần nổi của tảng băng chìm. Vậy tảng băng chìm đó là gì? Là những thứ không lồ lộ ra UI, ra interaction, nó là IA, là flow của các functionality, system, là những user need & objectives đã được define từ trước đó…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1765d164-78d8-8072-acd8-c3719df84d38",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2025-01-09T16:21:00.000Z",
        "last_edited_time": "2025-01-09T16:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081414/uxcomic-imgs/1765d164-78d8-8072-acd8-c3719df84d38.png",
            "expiry_time": "2026-10-04T09:11:44.869Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1765d164-78d8-8072-acd8-c3719df84d38"
      },
      {
        "object": "block",
        "id": "1295d164-78d8-80bd-8d99-fc6a372f09b0",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-10-24T15:12:00.000Z",
        "last_edited_time": "2024-10-27T04:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [
            {
              "type": "text",
              "text": {
                "content": "UX layer",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX layer",
              "href": null
            }
          ],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081416/uxcomic-imgs/1295d164-78d8-80bd-8d99-fc6a372f09b0.png",
            "expiry_time": "2026-10-04T09:11:44.869Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1295d164-78d8-80bd-8d99-fc6a372f09b0"
      },
      {
        "object": "block",
        "id": "1825d164-78d8-8088-9458-da179416e9ec",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2025-01-21T02:35:00.000Z",
        "last_edited_time": "2025-01-21T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-807b-bed3-f3a95d4b67e1",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-10-24T15:12:00.000Z",
        "last_edited_time": "2024-10-28T02:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi càng làm việc thực tế trong product development, mình càng hiểu rõ hơn sự quan trọng của việc các layer này, bạn có thể search thêm với keyword “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi càng làm việc thực tế trong product development, mình càng hiểu rõ hơn sự quan trọng của việc các layer này, bạn có thể search thêm với keyword “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "UX layer",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX layer",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "” để hiểu thêm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” để hiểu thêm.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8065-869f-f40265bc4e39",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-12-24T06:15:00.000Z",
        "last_edited_time": "2024-12-24T06:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mọi thứ đều có lí do của nó.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mọi thứ đều có lí do của nó.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-8044-b40f-f0bbb4d44675",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2025-01-21T02:35:00.000Z",
        "last_edited_time": "2025-01-21T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-80c8-9603-c358594bc395",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-10-24T15:14:00.000Z",
        "last_edited_time": "2025-01-21T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhờ việc tách lớp những layer này, nó giúp giúp mình design có nhiều sự cân nhắc hơn, có ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhờ việc tách lớp những layer này, nó giúp giúp mình design có nhiều sự cân nhắc hơn, có ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "tính concept",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "tính concept",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " hơn & giúp audit UX ngay trong quá trình làm. Thay vì chỉ tập trung thiết kế cho UI, interaction thì phải quan tâm nhiều hơn những lớp mờ mờ, ẩn ẩn bên dưới, mà tính ra thì nên ngược lại, as a builder chính những thứ đó là thứ mình cần làm rõ nhất, phải có lí do rõ ràng cho mọi design. Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " hơn & giúp audit UX ngay trong quá trình làm. Thay vì chỉ tập trung thiết kế cho UI, interaction thì phải quan tâm nhiều hơn những lớp mờ mờ, ẩn ẩn bên dưới, mà tính ra thì nên ngược lại, as a builder chính những thứ đó là thứ mình cần làm rõ nhất, phải có lí do rõ ràng cho mọi design. Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-8037-b47d-e4fd84344620",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-10-24T15:29:00.000Z",
        "last_edited_time": "2024-12-25T01:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "User need layer - mình cần quan tâm hơn motivation của họ là gì, value họ get được là gì, ngữ cảnh sử dụng ra sao, họ cần cảm thấy như thế nào trong quá trình dùng nó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User need layer - mình cần quan tâm hơn motivation của họ là gì, value họ get được là gì, ngữ cảnh sử dụng ra sao, họ cần cảm thấy như thế nào trong quá trình dùng nó.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-8023-b37c-c23c7f4b4263",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-10-24T15:30:00.000Z",
        "last_edited_time": "2024-12-25T01:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Site objective layer - project này cần đạt KPI gì, để cải thiện metrics gì trong business, nó giúp ích cho engagement hay để tăng lead, để giải quyết một issue gì đó cho operation team hay…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Site objective layer - project này cần đạt KPI gì, để cải thiện metrics gì trong business, nó giúp ích cho engagement hay để tăng lead, để giải quyết một issue gì đó cho operation team hay…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-80c3-8313-de66abbb8ea3",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-10-24T15:55:00.000Z",
        "last_edited_time": "2024-12-25T01:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chưa kể dưới lớp user need, site objective đó còn những layer khác mà bạn không biết, ví dụ: business strategy, strategy activities, blue ocean, trend, R&D,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chưa kể dưới lớp user need, site objective đó còn những layer khác mà bạn không biết, ví dụ: business strategy, strategy activities, blue ocean, trend, R&D,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-8086-92ae-e5a71de9d05e",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2025-01-21T02:36:00.000Z",
        "last_edited_time": "2025-01-21T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-8082-9749-c35d7aa325a4",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-10-24T15:33:00.000Z",
        "last_edited_time": "2024-12-25T01:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có thể mọi thứ không rõ ràng từ đầu, giữa các layer luôn có những điểm mù mà ban đầu ta-designer và stakeholder sẽ không thể cover hết, nên việc luân chuyển làm rõ lại từng layer đó cần được diễn ra thường xuyên, như kiểu bạn vừa tra map vừa chạy xe vậy, điểm xuất phát & điểm đến có thể cố định, nhưng trong lúc đi cần sự tra cứu & ứng phó liên tục.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có thể mọi thứ không rõ ràng từ đầu, giữa các layer luôn có những điểm mù mà ban đầu ta-designer và stakeholder sẽ không thể cover hết, nên việc luân chuyển làm rõ lại từng layer đó cần được diễn ra thường xuyên, như kiểu bạn vừa tra map vừa chạy xe vậy, điểm xuất phát & điểm đến có thể cố định, nhưng trong lúc đi cần sự tra cứu & ứng phó liên tục.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-80d5-a760-c3e0d2e6984f",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-12-24T15:16:00.000Z",
        "last_edited_time": "2024-12-24T15:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> Nó đòi hỏi phải liên tục lấy feedback & reflect, y như cách chúng ta iterate sản phẩm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> Nó đòi hỏi phải liên tục lấy feedback & reflect, y như cách chúng ta iterate sản phẩm.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-8019-8e50-cfab35795e45",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2025-01-21T02:36:00.000Z",
        "last_edited_time": "2025-01-21T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "bbee80f5-70ab-4ce6-9d53-79ac53b1344a",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-11-06T01:57:00.000Z",
        "last_edited_time": "2024-12-25T01:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quá trình rõ ra này làm mình liên tưởng đến lúc học vẽ tượng, mình phải đi từ tổng thể đến chi tiết. Việc xác định problem, goal giống như việc phát thảo khung sườn cho việc form lên solution vậy, quá trình refine solution như cách ta đánh khối & fine tune design là lúc vẽ chi tiết mắt mũi miệng,..",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quá trình rõ ra này làm mình liên tưởng đến lúc học vẽ tượng, mình phải đi từ tổng thể đến chi tiết. Việc xác định problem, goal giống như việc phát thảo khung sườn cho việc form lên solution vậy, quá trình refine solution như cách ta đánh khối & fine tune design là lúc vẽ chi tiết mắt mũi miệng,..",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80ed-a452-d635deb6a763",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-12-25T01:27:00.000Z",
        "last_edited_time": "2024-12-25T01:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081417/uxcomic-imgs/1675d164-78d8-80ed-a452-d635deb6a763.jpg",
            "expiry_time": "2026-10-04T09:11:44.870Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1675d164-78d8-80ed-a452-d635deb6a763"
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-8048-8450-eb36833825b1",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-10-27T05:00:00.000Z",
        "last_edited_time": "2024-10-27T05:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-8029-8497-ddc2d16be15c",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-10-24T15:38:00.000Z",
        "last_edited_time": "2024-12-25T01:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "So what?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "So what?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-80f9-a160-d28f0db3c6f2",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-12-24T15:23:00.000Z",
        "last_edited_time": "2024-12-24T15:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [
            {
              "type": "text",
              "text": {
                "content": "UX layer",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX layer",
              "href": null
            }
          ],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081419/uxcomic-imgs/1665d164-78d8-80f9-a160-d28f0db3c6f2.png",
            "expiry_time": "2026-10-04T09:11:44.929Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1665d164-78d8-80f9-a160-d28f0db3c6f2"
      },
      {
        "object": "block",
        "id": "1295d164-78d8-80ef-84b6-d6a7218732ad",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-10-24T15:40:00.000Z",
        "last_edited_time": "2024-12-25T01:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bất cứ khi nào mình nhận một project gì đó dù là làm feature mới hay cần chỉnh sửa, improve feature cũ thì luôn phải nhìn nhận vấn đề từ dưới lên (tham khảo lại hình ở trên), tầng lớp một cần có những concept & idea khác nhau để lựa chọn phương án tối ưu.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bất cứ khi nào mình nhận một project gì đó dù là làm feature mới hay cần chỉnh sửa, improve feature cũ thì luôn phải nhìn nhận vấn đề từ dưới lên (tham khảo lại hình ở trên), tầng lớp một cần có những concept & idea khác nhau để lựa chọn phương án tối ưu.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1295d164-78d8-8017-ab86-cc6c45bc1adc",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-10-24T15:41:00.000Z",
        "last_edited_time": "2024-12-25T01:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ở chiều ngược lại, khi mình audit một sản phẩm, tính năng, thay vì sa đà việc nhận xét những thứ dễ thấy như UI, interaction, content,… phải để tâm đến các thứ khó đoán hơn nằm ở layer dưới, chính những phán đoán, nghiền ngẫm về nó mới giúp bạn hiểu được nhiều thứ hơn, hiểu tại sao feature đó lại được sinh ra, tại sao lại có những thông tin đó,  tại sao lại thiết kế theo hướng đó…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ở chiều ngược lại, khi mình audit một sản phẩm, tính năng, thay vì sa đà việc nhận xét những thứ dễ thấy như UI, interaction, content,… phải để tâm đến các thứ khó đoán hơn nằm ở layer dưới, chính những phán đoán, nghiền ngẫm về nó mới giúp bạn hiểu được nhiều thứ hơn, hiểu tại sao feature đó lại được sinh ra, tại sao lại có những thông tin đó,  tại sao lại thiết kế theo hướng đó…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1295d164-78d8-8066-9958-fea0f14dba75",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-10-24T15:46:00.000Z",
        "last_edited_time": "2024-12-24T15:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Good artists copy great artists steal - Pablo Picasso",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Good artists copy great artists steal - Pablo Picasso",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-809f-a71f-c2387a946d0d",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-10-24T15:46:00.000Z",
        "last_edited_time": "2024-12-25T01:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sẽ luôn xảy ra tình trạng back & forth trong quá trình thiết kế & it’s ok, cách duy nhất để hạn chế là làm rõ, suy nghĩ thấu đáo hơn từ đầu, và thường xuyên tìm cách figure out các ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sẽ luôn xảy ra tình trạng back & forth trong quá trình thiết kế & it’s ok, cách duy nhất để hạn chế là làm rõ, suy nghĩ thấu đáo hơn từ đầu, và thường xuyên tìm cách figure out các ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "điểm mù, các assumption ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "điểm mù, các assumption ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "bằng việc",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "bằng việc",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "đem các thứ mình làm ra catch up liên tục với các stakeholder, hoặc thậm chí nếu được là test với user càng sớm càng tốt, kiểm chứng các hypothesis. (thích lắm, khi cầm ra test bạn sẽ thấy được hoá ra user có những cảm nhận, những hành vi dùng khác).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "đem các thứ mình làm ra catch up liên tục với các stakeholder, hoặc thậm chí nếu được là test với user càng sớm càng tốt, kiểm chứng các hypothesis. (thích lắm, khi cầm ra test bạn sẽ thấy được hoá ra user có những cảm nhận, những hành vi dùng khác).",
              "href": null
            }
          ],
          "color": "default",
          "list_start_index": 3
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "2495d164-78d8-8081-8aeb-e273d43aca22",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2025-08-08T10:52:00.000Z",
        "last_edited_time": "2025-08-08T10:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "We may not be right, but we should not be confused (Mình nghe được qua đâu đó).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "We may not be right, but we should not be confused (Mình nghe được qua đâu đó).",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-81a1-9476-c1fba32edc73",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-10-24T11:39:00.000Z",
        "last_edited_time": "2024-10-24T11:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-80ea-b070-dce149ef3fa5",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-11-28T11:12:00.000Z",
        "last_edited_time": "2024-11-28T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-800e-8c5c-cf410f1f0ed1",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-11-28T11:12:00.000Z",
        "last_edited_time": "2024-11-28T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.tannerchristensen.com/notes/when-every-product-of-design-is-one-of-opinion",
                "link": {
                  "url": "https://www.tannerchristensen.com/notes/when-every-product-of-design-is-one-of-opinion"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.tannerchristensen.com/notes/when-every-product-of-design-is-one-of-opinion",
              "href": "https://www.tannerchristensen.com/notes/when-every-product-of-design-is-one-of-opinion"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1765d164-78d8-8038-b1a9-ced7c078cb41",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2025-01-09T16:19:00.000Z",
        "last_edited_time": "2025-01-09T16:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://eleganthack.com/how-to-make-a-concept-model/",
                "link": {
                  "url": "https://eleganthack.com/how-to-make-a-concept-model/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://eleganthack.com/how-to-make-a-concept-model/",
              "href": "https://eleganthack.com/how-to-make-a-concept-model/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-80c0-bf4f-e4bf02cfd2d8",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-11-28T11:12:00.000Z",
        "last_edited_time": "2024-11-28T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-818a-903a-f53c6c694d29",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-10-24T11:39:00.000Z",
        "last_edited_time": "2024-10-24T11:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1735d164-78d8-8048-a2e3-d35cc23e41b1",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2025-01-06T02:25:00.000Z",
        "last_edited_time": "2025-01-06T02:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX as a Cupid",
              "href": "https://app.notion.com/p/10f5d16478d8808484a5d6eff66f3eec"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-8158-aa5d-ceb378eb57d5",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-10-24T11:39:00.000Z",
        "last_edited_time": "2024-10-24T15:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UI vs IxD vs UX vs Product design",
              "href": "https://app.notion.com/p/f33a58a305604b8cb509976f80f8c973"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8051-b24a-d3563ecd2ffd",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-12-24T06:14:00.000Z",
        "last_edited_time": "2024-12-24T06:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User Journey map, User scenario, Task flow, User flow",
              "href": "https://app.notion.com/p/1155d16478d880a883a6ec9db47fe4dc"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8095-93fd-e5fd06bb1fe1",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-12-24T06:16:00.000Z",
        "last_edited_time": "2025-01-06T02:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1605d164-78d8-80ad-9130-fe44c6663146"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Value vs Benefit",
              "href": "https://app.notion.com/p/1605d16478d880ad9130fe44c6663146"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-8082-b8cc-e1debc76059e",
        "parent": {
          "type": "page_id",
          "page_id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
        },
        "created_time": "2024-10-24T15:49:00.000Z",
        "last_edited_time": "2024-10-24T15:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Work Journal",
              "href": "https://app.notion.com/p/11b5d16478d8801e8d22d0e5bdfd337c"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1225d164-78d8-80db-8d9b-e6cc64d11314",
    "created_time": "2024-10-17T11:07:00.000Z",
    "last_edited_time": "2025-08-09T06:50:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "fd3cd36d-73dd-4dee-8bd5-d159d6600124"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "View": {
        "id": "ATSa",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "A%5Bqc",
        "type": "select",
        "select": {
          "id": "Blq|",
          "name": "⚓:2",
          "color": "green"
        }
      },
      "Last edited time": {
        "id": "DMgm",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-09T06:50:00.000Z"
      },
      "Publish": {
        "id": "FSnx",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "_tsp",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "g%7BBg",
        "type": "created_time",
        "created_time": "2024-10-17T11:07:00.000Z"
      },
      "Share": {
        "id": "hp~_",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "m%7C%40x",
        "type": "number",
        "number": null
      },
      "Formula": {
        "id": "re%3BE",
        "type": "formula",
        "formula": {
          "type": "number",
          "number": 1
        }
      },
      "Tag": {
        "id": "%7CAvQ",
        "type": "select",
        "select": {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "4-Random",
          "color": "gray"
        }
      },
      "ID": {
        "id": "~RYT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FD",
          "number": 24
        }
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Relation (systematic thinking)",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Relation (systematic thinking)",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Relation-systematic-thinking-1225d16478d880db8d9be6cc64d11314",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "5cacdbff-b9e2-4973-b565-ec1ae4327ec9",
      "name": "Fundamental",
      "slug": "fundamental",
      "icon": "🌞",
      "order": 2,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "Product",
          "slug": "product",
          "order": 1
        },
        {
          "id": "156ef770-14db-4170-b1d7-95a2fbdf62ba",
          "name": "User",
          "slug": "user",
          "order": 2
        },
        {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "Design",
          "slug": "design",
          "order": 3
        },
        {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "Random",
          "slug": "random",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "9290a1c0-fd10-40c6-a821-56f188976357",
      "name": "Random",
      "slug": "random",
      "order": 4
    },
    "content": [
      {
        "object": "block",
        "id": "1225d164-78d8-8151-8884-fe5f3b23d479",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-10-17T11:07:00.000Z",
        "last_edited_time": "2024-10-18T15:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081422/uxcomic-imgs/1225d164-78d8-8151-8884-fe5f3b23d479.png",
            "expiry_time": "2026-10-04T09:11:46.536Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1225d164-78d8-8151-8884-fe5f3b23d479"
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80b1-b7fc-ec0566cff803",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-23T05:35:00.000Z",
        "last_edited_time": "2025-08-09T06:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thông qua bài ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thông qua bài ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "sense making",
                "link": {
                  "url": "https://uxcomic.github.io/post/sense-making"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "sense making",
              "href": "https://uxcomic.github.io/post/sense-making"
            },
            {
              "type": "text",
              "text": {
                "content": ", ta biết được chính hành động vẽ được các mối liên hệ mới cho ta cái hiểu, đó mới thực sự là cách học.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", ta biết được chính hành động vẽ được các mối liên hệ mới cho ta cái hiểu, đó mới thực sự là cách học.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1225d164-78d8-81c9-bc86-e7f59588bccb",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-10-17T11:07:00.000Z",
        "last_edited_time": "2024-12-23T06:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nó tập cho mình hạn chế nhìn nhận mọi thứ theo từng thực thể riêng biệt mà phải hiểu về sự liên hệ giữa chúng. Thay vì câu nói “mọi thứ đều có lí do của nó” thì giờ có thể nói ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nó tập cho mình hạn chế nhìn nhận mọi thứ theo từng thực thể riêng biệt mà phải hiểu về sự liên hệ giữa chúng. Thay vì câu nói “mọi thứ đều có lí do của nó” thì giờ có thể nói ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "“mọi thứ đều có mối liên hệ với nhau”.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“mọi thứ đều có mối liên hệ với nhau”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1225d164-78d8-8059-87b4-e5f41473f300",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-10-17T11:14:00.000Z",
        "last_edited_time": "2025-05-25T11:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fe5d164-78d8-8094-bf12-e02b9f01f337",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-05-25T11:04:00.000Z",
        "last_edited_time": "2025-05-25T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thông qua công việc product designer, mình thấy khi nghĩ về system sẽ có ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thông qua công việc product designer, mình thấy khi nghĩ về system sẽ có ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "2 câu hỏi",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2 câu hỏi",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " chính cần làm rõ thôi:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " chính cần làm rõ thôi:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fe5d164-78d8-8074-ab36-f50be8b4ac08",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-05-25T11:04:00.000Z",
        "last_edited_time": "2025-05-25T11:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cái nào cha, cái nào con, giữa chúng nó được phân cấp như thế nào?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cái nào cha, cái nào con, giữa chúng nó được phân cấp như thế nào?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1fe5d164-78d8-80b8-bb27-e2a631878fdb",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-05-25T11:05:00.000Z",
        "last_edited_time": "2025-05-25T11:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sự tương tác giữa chúng nó là gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sự tương tác giữa chúng nó là gì?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1fe5d164-78d8-8071-8486-feafc6740bf5",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-05-25T11:10:00.000Z",
        "last_edited_time": "2025-05-25T11:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1fe5d164-78d8-8083-93b8-e428505d8e43",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-05-25T11:06:00.000Z",
        "last_edited_time": "2025-08-09T01:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_1",
        "heading_1": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tính phân cấp 🗺️",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tính phân cấp 🗺️",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-809f-82e1-dbb3c51e30fe",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-23T05:50:00.000Z",
        "last_edited_time": "2025-08-09T01:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quan hệ phân cấp",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quan hệ phân cấp",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80cf-997e-f6d1a65c4a83",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-23T05:51:00.000Z",
        "last_edited_time": "2025-08-09T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tổng thể & thành phần",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tổng thể & thành phần",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8041-b59f-daeb5f6709f6",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-08-09T01:23:00.000Z",
        "last_edited_time": "2025-08-09T01:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: mind map, affinity diagram.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: mind map, affinity diagram.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-802c-8ddc-fc19b34976d4",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-23T07:40:00.000Z",
        "last_edited_time": "2025-05-25T11:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081423/uxcomic-imgs/1655d164-78d8-802c-8ddc-fc19b34976d4.png",
            "expiry_time": "2026-10-04T09:11:46.537Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1655d164-78d8-802c-8ddc-fc19b34976d4"
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-807d-beb4-c5bd0557f671",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-08-09T01:23:00.000Z",
        "last_edited_time": "2025-08-09T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-804c-8fb0-e56480b7aba8",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-23T05:51:00.000Z",
        "last_edited_time": "2025-08-09T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mức độ & sự ưu tiên",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mức độ & sự ưu tiên",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80d2-ad2f-c1782d4c0bcd",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-08-09T01:23:00.000Z",
        "last_edited_time": "2025-08-09T01:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: weight score, impact-value matrix…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: weight score, impact-value matrix…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80f8-b9e2-f20c8ea8667b",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-30T10:28:00.000Z",
        "last_edited_time": "2025-05-25T11:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081425/uxcomic-imgs/16c5d164-78d8-80f8-b9e2-f20c8ea8667b.jpg",
            "expiry_time": "2026-10-04T09:11:46.537Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/16c5d164-78d8-80f8-b9e2-f20c8ea8667b"
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-803d-81a8-c96c3732a456",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-08-09T01:19:00.000Z",
        "last_edited_time": "2025-08-09T01:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8026-a8aa-e5e22fc80bdf",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-23T05:53:00.000Z",
        "last_edited_time": "2025-08-09T01:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quan hệ đồng nhất hoặc đối lặp",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quan hệ đồng nhất hoặc đối lặp",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80aa-8eb9-d5a6c38bcffd",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-23T05:53:00.000Z",
        "last_edited_time": "2025-08-09T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tương đồng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tương đồng",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80e4-9560-c4418f9e201d",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-08-09T01:23:00.000Z",
        "last_edited_time": "2025-08-09T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có điểm chung hoặc bổ trợ nhau. Ví dụ: có sự overlap công việc giữa PM & PD.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có điểm chung hoặc bổ trợ nhau. Ví dụ: có sự overlap công việc giữa PM & PD.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1695d164-78d8-80d5-bcff-f17bfe045ead",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-27T05:13:00.000Z",
        "last_edited_time": "2025-05-25T11:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081426/uxcomic-imgs/1695d164-78d8-80d5-bcff-f17bfe045ead.png",
            "expiry_time": "2026-10-04T09:11:46.537Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1695d164-78d8-80d5-bcff-f17bfe045ead"
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8059-9ba4-e8399829070a",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-08-09T01:22:00.000Z",
        "last_edited_time": "2025-08-09T01:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8011-a2bb-e2879fc2b19c",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-23T05:57:00.000Z",
        "last_edited_time": "2025-08-09T01:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đối lập, mẫu thuẫn",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đối lập, mẫu thuẫn",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-801f-8087-c9dca2618ef6",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-08-09T01:22:00.000Z",
        "last_edited_time": "2025-08-09T01:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: muốn nhanh & scope nhiều việc thì phải cần nhiều nhân sự (cost nhiều).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: muốn nhanh & scope nhiều việc thì phải cần nhiều nhân sự (cost nhiều).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80d3-82a0-f5dbf932df99",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-23T07:41:00.000Z",
        "last_edited_time": "2025-05-25T11:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081427/uxcomic-imgs/1655d164-78d8-80d3-82a0-f5dbf932df99.png",
            "expiry_time": "2026-10-04T09:11:46.712Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1655d164-78d8-80d3-82a0-f5dbf932df99"
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-808c-aefa-df666274bec0",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-08-09T01:19:00.000Z",
        "last_edited_time": "2025-08-09T01:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1fe5d164-78d8-8012-9df5-e9f063bf7ad0",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-05-25T11:09:00.000Z",
        "last_edited_time": "2025-08-09T01:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_1",
        "heading_1": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tính tác động 🥊",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tính tác động 🥊",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80e8-9f38-cd315754d81e",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-23T05:40:00.000Z",
        "last_edited_time": "2024-12-23T05:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Liên hệ nhân quả (causal relation)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Liên hệ nhân quả (causal relation)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-804a-9eae-fcbb7bf5daf3",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-23T05:40:00.000Z",
        "last_edited_time": "2025-04-16T11:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nguyên nhân & kết quả. Giống như một chuỗi domino A làm đổ B, B làm đổ C (hiệu ứng cánh bướm) ta nhìn được tính tác động của 1 hành động.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nguyên nhân & kết quả. Giống như một chuỗi domino A làm đổ B, B làm đổ C (hiệu ứng cánh bướm) ta nhìn được tính tác động của 1 hành động.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8086-abd9-c3f163db4d80",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-23T07:04:00.000Z",
        "last_edited_time": "2025-01-11T11:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tips: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tips: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "hỏi 5whys & Fishbone",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "hỏi 5whys & Fishbone",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8049-8973-fb976e1cb156",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-23T07:34:00.000Z",
        "last_edited_time": "2024-12-23T07:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081429/uxcomic-imgs/1655d164-78d8-8049-8973-fb976e1cb156.png",
            "expiry_time": "2026-10-04T09:11:46.713Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1655d164-78d8-8049-8973-fb976e1cb156"
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8055-a3d1-f358627b3cf2",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-23T07:04:00.000Z",
        "last_edited_time": "2025-01-11T11:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một framework khác hữu ích: Second-order thinking - để nghĩ về long-term effect, nhiều lúc khi nghĩ ra được một solution idea gì đó, ta chỉ thấy cái lợi trước mắt, nhưng xét long-term thì nó ra sao?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một framework khác hữu ích: Second-order thinking - để nghĩ về long-term effect, nhiều lúc khi nghĩ ra được một solution idea gì đó, ta chỉ thấy cái lợi trước mắt, nhưng xét long-term thì nó ra sao?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1785d164-78d8-807a-af16-c9012af10e72",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-01-11T11:22:00.000Z",
        "last_edited_time": "2025-01-11T11:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081431/uxcomic-imgs/1785d164-78d8-807a-af16-c9012af10e72.png",
            "expiry_time": "2026-10-04T09:11:46.713Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1785d164-78d8-807a-af16-c9012af10e72"
      },
      {
        "object": "block",
        "id": "1fe5d164-78d8-80d6-8619-fa72c06d05d5",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-05-25T11:10:00.000Z",
        "last_edited_time": "2025-05-25T11:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8045-a34a-dece8243e1a3",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-23T05:45:00.000Z",
        "last_edited_time": "2025-08-09T01:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Liên hệ tương tác “mạng  lưới”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Liên hệ tương tác “mạng  lưới”",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80a0-b25a-d4f56598841b",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-23T06:04:00.000Z",
        "last_edited_time": "2024-12-23T07:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là mối quan hệ mà các yếu tố trong hệ thống tác động qua lại lẫn nhau. Điểm đặc trưng là tác động hai chiều hoặc đa chiều (các yếu tố không chỉ ảnh hưởng đến nhau mà còn phản hồi liên tục). Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là mối quan hệ mà các yếu tố trong hệ thống tác động qua lại lẫn nhau. Điểm đặc trưng là tác động hai chiều hoặc đa chiều (các yếu tố không chỉ ảnh hưởng đến nhau mà còn phản hồi liên tục). Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80e8-ad02-e23509663fe8",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-23T07:31:00.000Z",
        "last_edited_time": "2024-12-23T07:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081432/uxcomic-imgs/1655d164-78d8-80e8-ad02-e23509663fe8.png",
            "expiry_time": "2026-10-04T09:11:46.714Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1655d164-78d8-80e8-ad02-e23509663fe8"
      },
      {
        "object": "block",
        "id": "1695d164-78d8-80f6-9f65-d903da1bd487",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-27T05:12:00.000Z",
        "last_edited_time": "2024-12-27T05:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80e5-b18e-c087add15072",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-23T06:44:00.000Z",
        "last_edited_time": "2025-08-09T01:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_1",
        "heading_1": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các tips để nhìn ra mối liên hệ 🕸️",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các tips để nhìn ra mối liên hệ 🕸️",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-801c-a092-f6c60387b4a3",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-01-10T02:06:00.000Z",
        "last_edited_time": "2025-01-10T02:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dùng diagram",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dùng diagram",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-80a7-8552-c0ba9222c403",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-01-10T02:32:00.000Z",
        "last_edited_time": "2025-01-10T02:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081434/uxcomic-imgs/1775d164-78d8-80a7-8552-c0ba9222c403.jpg",
            "expiry_time": "2026-10-04T09:11:46.714Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1775d164-78d8-80a7-8552-c0ba9222c403"
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80ce-82b7-fb1f773921c7",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-23T06:14:00.000Z",
        "last_edited_time": "2025-05-25T11:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách để minh hoạ mối liên hệ này không gì tốt hơn bằng",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách để minh hoạ mối liên hệ này không gì tốt hơn bằng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Diagram",
                "link": {
                  "url": "/1235d16478d8809490a1e82eea06a15b"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Diagram",
              "href": "/1235d16478d8809490a1e82eea06a15b"
            },
            {
              "type": "text",
              "text": {
                "content": ", rất tốt trong việc bạn truyền đạt cái hiểu này cho bản thân & mọi người. (có hẳn cuốn sách nói về Diagram, “Stuck? Diagrams help” - Abby Covert)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", rất tốt trong việc bạn truyền đạt cái hiểu này cho bản thân & mọi người. (có hẳn cuốn sách nói về Diagram, “Stuck? Diagrams help” - Abby Covert)",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fe5d164-78d8-807e-8296-f949f31c8132",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-05-25T11:10:00.000Z",
        "last_edited_time": "2025-05-25T11:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1d75d164-78d8-8085-8baa-d51887af063d",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-04-16T11:24:00.000Z",
        "last_edited_time": "2025-04-16T11:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Động từ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Động từ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1d75d164-78d8-80bb-9533-ebf0ea5e6976",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-04-16T11:24:00.000Z",
        "last_edited_time": "2025-08-09T01:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "For, to, make, strengthen, weaken, contain… hãy chọn ra {1 động từ} móc nối được giữa 2 thông tin / objects.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "For, to, make, strengthen, weaken, contain… hãy chọn ra {1 động từ} móc nối được giữa 2 thông tin / objects.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1d75d164-78d8-80f4-abf6-f6f39ed7f408",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-04-16T11:24:00.000Z",
        "last_edited_time": "2025-04-16T11:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-804e-8c25-cadd9e8a736f",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-01-10T02:06:00.000Z",
        "last_edited_time": "2025-01-10T02:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dùng công thức toán",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dùng công thức toán",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-80b3-8d46-e3bda745945f",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-01-10T02:06:00.000Z",
        "last_edited_time": "2025-01-10T03:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vâng, bạn nghe không sai đâu, nếu bạn thử lí giải một vấn đề gì đó bằng toán, mọi thứ sẽ khá là clear mà có khi bạn cũng bất ngờ đấy. Ví dụ tham khảo:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vâng, bạn nghe không sai đâu, nếu bạn thử lí giải một vấn đề gì đó bằng toán, mọi thứ sẽ khá là clear mà có khi bạn cũng bất ngờ đấy. Ví dụ tham khảo:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-80b2-bcb2-d3636286185c",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-01-10T02:07:00.000Z",
        "last_edited_time": "2025-01-10T02:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Experience = Perception x Interaction",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Experience = Perception x Interaction",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-80b6-81c7-fd8b0b057361",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-01-10T02:56:00.000Z",
        "last_edited_time": "2025-01-21T02:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Interaction = (Input + Output) x Time",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Interaction = (Input + Output) x Time",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-80d2-95dc-eaa8d2b7a29c",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-01-10T02:08:00.000Z",
        "last_edited_time": "2025-01-10T03:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Perception = Intention x (Bias + Background)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Perception = Intention x (Bias + Background)",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-809d-b497-cb36a677037e",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-01-10T03:03:00.000Z",
        "last_edited_time": "2025-05-25T11:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Intention = (Context x Motivation x Emotion)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Intention = (Context x Motivation x Emotion)",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-801e-b7aa-eb69892b3359",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-01-10T02:11:00.000Z",
        "last_edited_time": "2025-01-10T02:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thu nhập = Năng suất x Thời gian",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thu nhập = Năng suất x Thời gian",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-80de-825e-c34bf87fe195",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-01-10T02:12:00.000Z",
        "last_edited_time": "2025-01-10T02:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Năng suất = (Hard skill + Soft skill) x Attitude",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Năng suất = (Hard skill + Soft skill) x Attitude",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-8059-97f0-f6679b3bb6b5",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-08-09T01:27:00.000Z",
        "last_edited_time": "2025-08-09T01:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-806a-839d-e43d2cf1acd6",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-01-10T02:21:00.000Z",
        "last_edited_time": "2025-08-09T01:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Practice ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Practice ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-8056-9a69-e66e50754a5e",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-01-10T02:21:00.000Z",
        "last_edited_time": "2025-08-09T01:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đừng quên diagram hay toán thì cũng là một artifact, và nhiệm vụ chính của chúng là để hình dung được mối liên hệ giữa mọi thứ >> hãy thử nghiệm ứng dụng nó trong nhiều tính huống, nhằm kiểm chứng mức độ hiệu quả của nó >> tìm ra lỗ hỏng & cải thiện. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đừng quên diagram hay toán thì cũng là một artifact, và nhiệm vụ chính của chúng là để hình dung được mối liên hệ giữa mọi thứ >> hãy thử nghiệm ứng dụng nó trong nhiều tính huống, nhằm kiểm chứng mức độ hiệu quả của nó >> tìm ra lỗ hỏng & cải thiện. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80c9-af39-d5c7193432b6",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-08-09T01:21:00.000Z",
        "last_edited_time": "2025-08-09T01:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chỉ khi nó apply được đúng cho nhiều ngữ cảnh, nó mới trở nên có giá trị cho bản thân. Vì sao? Vì mình đang cầm trong tay một mental model, nó giúp tăng hiệu quả xử lý thông tin, nó như cuốn “bí kíp” của riêng bạn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chỉ khi nó apply được đúng cho nhiều ngữ cảnh, nó mới trở nên có giá trị cho bản thân. Vì sao? Vì mình đang cầm trong tay một mental model, nó giúp tăng hiệu quả xử lý thông tin, nó như cuốn “bí kíp” của riêng bạn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-80ca-817e-e79a5e73c8ef",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-08-09T01:29:00.000Z",
        "last_edited_time": "2025-08-09T01:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình cũng tập tành vẽ một cái cho riêng mình nè, nếu bạn tò mò có thể xem thêm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình cũng tập tành vẽ một cái cho riêng mình nè, nếu bạn tò mò có thể xem thêm.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-803d-bc52-d0891c0e78c5",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-10-18T04:32:00.000Z",
        "last_edited_time": "2024-10-18T04:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1225d164-78d8-81e5-becf-ee5af687ea8c",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-10-17T11:07:00.000Z",
        "last_edited_time": "2025-08-09T01:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8032-8340-f96c84ab1ab2",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-23T04:06:00.000Z",
        "last_edited_time": "2024-12-23T06:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "video",
        "video": {
          "caption": [],
          "type": "external",
          "external": {
            "url": "https://youtu.be/Yg_qsDPOIqo?si=_oiDFitGfN0M_K5R&t=276"
          }
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fe5d164-78d8-806e-abb6-c80b9a5805ae",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-05-25T11:10:00.000Z",
        "last_edited_time": "2025-05-25T11:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Untool.co",
                "link": {
                  "url": "http://untool.co/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Untool.co",
              "href": "http://untool.co/"
            },
            {
              "type": "text",
              "text": {
                "content": " - Một trang tổng hợp các framework, rất hữu ích để mình tập luyện clear suy nghĩ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " - Một trang tổng hợp các framework, rất hữu ích để mình tập luyện clear suy nghĩ.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1d55d164-78d8-8071-98b8-df51c22351b5",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2025-04-14T06:45:00.000Z",
        "last_edited_time": "2025-04-14T06:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://medium.com/readymag/design-ethics-and-relationships-centred-practice-fea3e57670ef",
                "link": {
                  "url": "https://medium.com/readymag/design-ethics-and-relationships-centred-practice-fea3e57670ef"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://medium.com/readymag/design-ethics-and-relationships-centred-practice-fea3e57670ef",
              "href": "https://medium.com/readymag/design-ethics-and-relationships-centred-practice-fea3e57670ef"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8089-8cc4-f823b848d92d",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-23T03:41:00.000Z",
        "last_edited_time": "2024-12-23T03:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.youtube.com/watch?v=q9xIeCxYm5Q&t=1940s",
                "link": {
                  "url": "https://www.youtube.com/watch?v=q9xIeCxYm5Q&t=1940s"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.youtube.com/watch?v=q9xIeCxYm5Q&t=1940s",
              "href": "https://www.youtube.com/watch?v=q9xIeCxYm5Q&t=1940s"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1225d164-78d8-8116-9d0a-f5415485a351",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-10-17T11:07:00.000Z",
        "last_edited_time": "2024-10-17T11:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://uxdesign.cc/information-architecture-how-to-make-it-worth-your-time-money-6ae71c0f8674",
                "link": {
                  "url": "https://uxdesign.cc/information-architecture-how-to-make-it-worth-your-time-money-6ae71c0f8674"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://uxdesign.cc/information-architecture-how-to-make-it-worth-your-time-money-6ae71c0f8674",
              "href": "https://uxdesign.cc/information-architecture-how-to-make-it-worth-your-time-money-6ae71c0f8674"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1225d164-78d8-8156-a987-d52b59f73761",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-10-17T11:07:00.000Z",
        "last_edited_time": "2024-10-18T04:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.nngroup.com/videos/flat-vs-deep-hierarchies/",
                "link": {
                  "url": "https://www.nngroup.com/videos/flat-vs-deep-hierarchies/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.nngroup.com/videos/flat-vs-deep-hierarchies/",
              "href": "https://www.nngroup.com/videos/flat-vs-deep-hierarchies/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1225d164-78d8-815b-85e6-d91ec8fbeaaa",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-10-17T11:07:00.000Z",
        "last_edited_time": "2024-10-17T11:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1225d164-78d8-819a-8d28-e0be4c1ab856",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-10-17T11:07:00.000Z",
        "last_edited_time": "2024-10-17T11:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8088-837e-ca34e5ce9ba1",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-10-18T04:55:00.000Z",
        "last_edited_time": "2024-12-23T07:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1235d164-78d8-8094-90a1-e82eea06a15b"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Diagram & Canvas",
              "href": "https://app.notion.com/p/1235d16478d8809490a1e82eea06a15b"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1225d164-78d8-81a2-9dab-cfa6aea83641",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-10-17T11:07:00.000Z",
        "last_edited_time": "2024-10-18T04:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sense making",
              "href": "https://app.notion.com/p/1195d16478d880cda21ff9d0e90ae7b8"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1225d164-78d8-81ed-b95c-ecdd4b17501f",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-10-17T11:07:00.000Z",
        "last_edited_time": "2024-10-18T04:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1165d164-78d8-80cb-9163-f985f8d8a788"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "IA? OOUX? Conceptual model?",
              "href": "https://app.notion.com/p/1165d16478d880cb9163f985f8d8a788"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-805c-8f7a-d9a79235d80a",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-10-18T04:19:00.000Z",
        "last_edited_time": "2024-10-18T04:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-801c-ab1b-f455e35da013",
        "parent": {
          "type": "page_id",
          "page_id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
        },
        "created_time": "2024-12-23T06:13:00.000Z",
        "last_edited_time": "2024-12-23T06:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c",
    "created_time": "2024-10-10T06:14:00.000Z",
    "last_edited_time": "2025-10-22T03:28:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "fd3cd36d-73dd-4dee-8bd5-d159d6600124"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "View": {
        "id": "ATSa",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "A%5Bqc",
        "type": "select",
        "select": {
          "id": "VaqQ",
          "name": "⚔️:3",
          "color": "blue"
        }
      },
      "Last edited time": {
        "id": "DMgm",
        "type": "last_edited_time",
        "last_edited_time": "2025-10-22T03:28:00.000Z"
      },
      "Publish": {
        "id": "FSnx",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "_tsp",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "g%7BBg",
        "type": "created_time",
        "created_time": "2024-10-10T06:14:00.000Z"
      },
      "Share": {
        "id": "hp~_",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "m%7C%40x",
        "type": "number",
        "number": null
      },
      "Formula": {
        "id": "re%3BE",
        "type": "formula",
        "formula": {
          "type": "number",
          "number": 1
        }
      },
      "Tag": {
        "id": "%7CAvQ",
        "type": "select",
        "select": {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "4-Random",
          "color": "gray"
        }
      },
      "ID": {
        "id": "~RYT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FD",
          "number": 22
        }
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Work Journal",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Work Journal",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Work-Journal-11b5d16478d8801e8d22d0e5bdfd337c",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "5cacdbff-b9e2-4973-b565-ec1ae4327ec9",
      "name": "Fundamental",
      "slug": "fundamental",
      "icon": "🌞",
      "order": 2,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "Product",
          "slug": "product",
          "order": 1
        },
        {
          "id": "156ef770-14db-4170-b1d7-95a2fbdf62ba",
          "name": "User",
          "slug": "user",
          "order": 2
        },
        {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "Design",
          "slug": "design",
          "order": 3
        },
        {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "Random",
          "slug": "random",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "9290a1c0-fd10-40c6-a821-56f188976357",
      "name": "Random",
      "slug": "random",
      "order": 4
    },
    "content": [
      {
        "object": "block",
        "id": "25f5d164-78d8-804d-a2d5-c7c27b9f2724",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-30T04:17:00.000Z",
        "last_edited_time": "2025-08-30T16:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756527702/uxcomic-imgs/25f5d164-78d8-804d-a2d5-c7c27b9f2724.png",
            "expiry_time": "2026-10-04T09:11:49.597Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/25f5d164-78d8-804d-a2d5-c7c27b9f2724"
      },
      {
        "object": "block",
        "id": "11b5d164-78d8-813f-ac56-e2d7894deb6c",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-10-10T06:14:00.000Z",
        "last_edited_time": "2025-08-30T16:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong công việc, mình rất hay gặp phải các tình huống sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong công việc, mình rất hay gặp phải các tình huống sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8074-8a75-ea4974f6f566",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-10-18T15:01:00.000Z",
        "last_edited_time": "2025-08-30T16:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi có ai đó trong team hỏi: “tại sao lúc đó mày design theo hướng này vậy?”, câu trả lời có khi là “Tao không nhớ nữa =))”, đặc biệt là đối với những project đã done được một thời gian khá lâu.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi có ai đó trong team hỏi: “tại sao lúc đó mày design theo hướng này vậy?”, câu trả lời có khi là “Tao không nhớ nữa =))”, đặc biệt là đối với những project đã done được một thời gian khá lâu.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-80d0-97e8-d18cabade37b",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-10-27T04:03:00.000Z",
        "last_edited_time": "2025-08-30T01:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tại sao qua các project mình đều thường gặp phải các khó khăn tương tự, chẳng hạn như phình scope. Mình than phiền và không có hướng giải quyết.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tại sao qua các project mình đều thường gặp phải các khó khăn tương tự, chẳng hạn như phình scope. Mình than phiền và không có hướng giải quyết.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80f6-9331-da21966a2584",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-10-18T15:01:00.000Z",
        "last_edited_time": "2024-11-17T08:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình dần dần thấy mất động lực làm việc vì thấy không học được gì qua mỗi project, không cảm giác mình đang grow.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình dần dần thấy mất động lực làm việc vì thấy không học được gì qua mỗi project, không cảm giác mình đang grow.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8036-b505-c54433b5ca81",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-10-18T15:01:00.000Z",
        "last_edited_time": "2025-08-30T01:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đến lúc soạn portfolio, khi cần ngồi viết lại case study và thấy mình quên đi nhiều thứ, lúc này phải ngồi mày mò lại những tờ note, xem lại các design option & và tự hỏi sao lúc đó mình quyết định vậy thế nhỉ, bài toán lúc đó giải quyết là gì, phải recall lại khá lâu.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đến lúc soạn portfolio, khi cần ngồi viết lại case study và thấy mình quên đi nhiều thứ, lúc này phải ngồi mày mò lại những tờ note, xem lại các design option & và tự hỏi sao lúc đó mình quyết định vậy thế nhỉ, bài toán lúc đó giải quyết là gì, phải recall lại khá lâu.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80a7-9d0e-cc3b5063eca4",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-10-18T15:01:00.000Z",
        "last_edited_time": "2025-08-30T17:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu bạn cũng bị tương tự, thì ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu bạn cũng bị tương tự, thì ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "work journal",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "work journal",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là thói quen mình cần luyện tập, nó sẽ giúp mình ghi lại các tình huống khi đó, những gì bạn nghĩ, bạn cảm, progress & activities - bạn tackle nó ra sao, các design decision được make như thế nào, tranh cãi gì xảy ra..., bài học rút ra là gì, sự phát triển của bản thân qua project này là gì. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là thói quen mình cần luyện tập, nó sẽ giúp mình ghi lại các tình huống khi đó, những gì bạn nghĩ, bạn cảm, progress & activities - bạn tackle nó ra sao, các design decision được make như thế nào, tranh cãi gì xảy ra..., bài học rút ra là gì, sự phát triển của bản thân qua project này là gì. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25f5d164-78d8-8091-9b3d-c257746b553c",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-30T17:03:00.000Z",
        "last_edited_time": "2025-08-30T17:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau này giá trị xem lại journal này rất cao, nó như lúc xem lại các ảnh cũ hay cuốn ghi hình cũ vậy, ngoài việc là những gì diễn ra khi đó, mình còn hồi ức lại được lối suy nghĩ & cảm xúc khi đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau này giá trị xem lại journal này rất cao, nó như lúc xem lại các ảnh cũ hay cuốn ghi hình cũ vậy, ngoài việc là những gì diễn ra khi đó, mình còn hồi ức lại được lối suy nghĩ & cảm xúc khi đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-809e-94c9-cd0b86f30eae",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-10-18T15:04:00.000Z",
        "last_edited_time": "2024-12-28T03:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Không gì grow nhanh hơn bằng việc thực chiến, nhưng cứ thực chiến mà không có quá trình reflect thì chưa chắc là đã học được gì.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Không gì grow nhanh hơn bằng việc thực chiến, nhưng cứ thực chiến mà không có quá trình reflect thì chưa chắc là đã học được gì.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-804f-9819-e6bd687676f7",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-10-27T04:08:00.000Z",
        "last_edited_time": "2024-10-27T04:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-801a-bab2-dd639560f655",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-10-27T04:15:00.000Z",
        "last_edited_time": "2024-10-27T04:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "How",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "How",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-8084-9d2e-eef5f019a226",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-10-27T04:11:00.000Z",
        "last_edited_time": "2025-08-30T16:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Journal này nên mang tính cá nhân của bạn, bạn không cần theo format nào cụ thể cả, những gì mình cần là ghi nhận hết những cảm nhận, quá trình, bài học rút ra được khi bắt tay làm một project nào đó. Nó nên là những thứ thuộc về ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Journal này nên mang tính cá nhân của bạn, bạn không cần theo format nào cụ thể cả, những gì mình cần là ghi nhận hết những cảm nhận, quá trình, bài học rút ra được khi bắt tay làm một project nào đó. Nó nên là những thứ thuộc về ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "“behind the scene”",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“behind the scene”",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", là những cuộc họp, buổi sync up, có thể là những lúc đi research hoặc test và có được cảm giác “aha, thì ra…”, hoặc có thể là những lúc bất đồng quan điểm & những cách xử lý tình huống khi ấy, v.v..",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", là những cuộc họp, buổi sync up, có thể là những lúc đi research hoặc test và có được cảm giác “aha, thì ra…”, hoặc có thể là những lúc bất đồng quan điểm & những cách xử lý tình huống khi ấy, v.v..",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25f5d164-78d8-80dc-a445-fb043a05745b",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-30T01:54:00.000Z",
        "last_edited_time": "2025-08-30T01:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-80b7-a9ac-c979f679ac0f",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-10-27T04:15:00.000Z",
        "last_edited_time": "2025-10-22T03:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau đây là những câu hỏi gợi ý trích từ ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau đây là những câu hỏi gợi ý trích từ ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Tanner Christensen",
                "link": {
                  "url": "https://www.tannerchristensen.com/"
                }
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tanner Christensen",
              "href": "https://www.tannerchristensen.com/"
            },
            {
              "type": "text",
              "text": {
                "content": " khi viết work journal.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " khi viết work journal.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25f5d164-78d8-804f-952c-c061ca6847c7",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-30T02:15:00.000Z",
        "last_edited_time": "2025-08-30T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "list",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "list",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "25f5d164-78d8-80ef-8e80-e5c2e035c195",
            "parent": {
              "type": "block_id",
              "block_id": "25f5d164-78d8-804f-952c-c061ca6847c7"
            },
            "created_time": "2025-08-30T02:16:00.000Z",
            "last_edited_time": "2025-08-30T16:28:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756526630/uxcomic-imgs/25f5d164-78d8-80ef-8e80-e5c2e035c195.png",
                "expiry_time": "2026-10-04T09:11:50.681Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25f5d164-78d8-80ef-8e80-e5c2e035c195"
          },
          {
            "object": "block",
            "id": "25f5d164-78d8-809d-89aa-d6bc42ff315c",
            "parent": {
              "type": "block_id",
              "block_id": "25f5d164-78d8-804f-952c-c061ca6847c7"
            },
            "created_time": "2025-08-30T02:16:00.000Z",
            "last_edited_time": "2025-08-30T16:28:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756526631/uxcomic-imgs/25f5d164-78d8-809d-89aa-d6bc42ff315c.png",
                "expiry_time": "2026-10-04T09:11:50.682Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25f5d164-78d8-809d-89aa-d6bc42ff315c"
          },
          {
            "object": "block",
            "id": "25f5d164-78d8-803f-af28-c8a305e61c43",
            "parent": {
              "type": "block_id",
              "block_id": "25f5d164-78d8-804f-952c-c061ca6847c7"
            },
            "created_time": "2025-08-30T02:16:00.000Z",
            "last_edited_time": "2025-08-30T16:28:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756526633/uxcomic-imgs/25f5d164-78d8-803f-af28-c8a305e61c43.png",
                "expiry_time": "2026-10-04T09:11:50.682Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25f5d164-78d8-803f-af28-c8a305e61c43"
          },
          {
            "object": "block",
            "id": "25f5d164-78d8-80ba-a951-c130805f7a28",
            "parent": {
              "type": "block_id",
              "block_id": "25f5d164-78d8-804f-952c-c061ca6847c7"
            },
            "created_time": "2025-08-30T02:16:00.000Z",
            "last_edited_time": "2025-08-30T16:28:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756526634/uxcomic-imgs/25f5d164-78d8-80ba-a951-c130805f7a28.png",
                "expiry_time": "2026-10-04T09:11:50.682Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25f5d164-78d8-80ba-a951-c130805f7a28"
          },
          {
            "object": "block",
            "id": "25f5d164-78d8-800e-b843-cf344390ca60",
            "parent": {
              "type": "block_id",
              "block_id": "25f5d164-78d8-804f-952c-c061ca6847c7"
            },
            "created_time": "2025-08-30T02:16:00.000Z",
            "last_edited_time": "2025-08-30T16:28:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756526635/uxcomic-imgs/25f5d164-78d8-800e-b843-cf344390ca60.png",
                "expiry_time": "2026-10-04T09:11:50.682Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25f5d164-78d8-800e-b843-cf344390ca60"
          },
          {
            "object": "block",
            "id": "25f5d164-78d8-8072-966a-cf5c938ef7dc",
            "parent": {
              "type": "block_id",
              "block_id": "25f5d164-78d8-804f-952c-c061ca6847c7"
            },
            "created_time": "2025-08-30T02:16:00.000Z",
            "last_edited_time": "2025-08-30T16:28:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756526636/uxcomic-imgs/25f5d164-78d8-8072-966a-cf5c938ef7dc.png",
                "expiry_time": "2026-10-04T09:11:50.682Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25f5d164-78d8-8072-966a-cf5c938ef7dc"
          },
          {
            "object": "block",
            "id": "25f5d164-78d8-8087-acd5-cd9bf482cdff",
            "parent": {
              "type": "block_id",
              "block_id": "25f5d164-78d8-804f-952c-c061ca6847c7"
            },
            "created_time": "2025-08-30T02:16:00.000Z",
            "last_edited_time": "2025-08-30T16:28:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756526637/uxcomic-imgs/25f5d164-78d8-8087-acd5-cd9bf482cdff.png",
                "expiry_time": "2026-10-04T09:11:50.682Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25f5d164-78d8-8087-acd5-cd9bf482cdff"
          }
        ]
      },
      {
        "object": "block",
        "id": "25f5d164-78d8-802b-a0a1-c305efaa74d7",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-30T02:15:00.000Z",
        "last_edited_time": "2025-08-30T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-80d2-a601-d26c3f31b5e3",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-10-27T04:19:00.000Z",
        "last_edited_time": "2024-10-27T04:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-8076-8b86-d2ea8b261631",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-10-27T04:26:00.000Z",
        "last_edited_time": "2025-08-30T01:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "So what",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "So what",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16a5d164-78d8-80ac-8deb-e67184fb77b7",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-12-28T03:54:00.000Z",
        "last_edited_time": "2025-08-30T16:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một quán ăn tồn tại 20 năm chưa hẳn sẽ ngon, làm trong nghề 5 năm chưa chắc sẽ lên được level senior, thời gian chỉ chứng minh thời gian mà ta gắn bó với nghề, thiếu đi feedback từ thực tế, thiếu đi sự tự đánh giá & ngẫm nghĩ về cách cải thiện thì đơn giản mình chỉ làm những công việc lặp đi lặp lại, như thế không có gì sai chỉ là chỉ khi bạn không đòi hỏi mình phải grow.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một quán ăn tồn tại 20 năm chưa hẳn sẽ ngon, làm trong nghề 5 năm chưa chắc sẽ lên được level senior, thời gian chỉ chứng minh thời gian mà ta gắn bó với nghề, thiếu đi feedback từ thực tế, thiếu đi sự tự đánh giá & ngẫm nghĩ về cách cải thiện thì đơn giản mình chỉ làm những công việc lặp đi lặp lại, như thế không có gì sai chỉ là chỉ khi bạn không đòi hỏi mình phải grow.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25f5d164-78d8-80f9-9751-e3455e806c76",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-30T01:53:00.000Z",
        "last_edited_time": "2025-08-30T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25f5d164-78d8-80d0-a144-cd1d6ed9a875",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-30T01:40:00.000Z",
        "last_edited_time": "2025-08-30T16:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chưa kể chính từ những work journal này, aware được những vấn đề hay gặp, có khi liên quan đến tổ chức, workflow, quá trình collaboration, process… cũng chính là bước đầu trong việc nghĩ ra hướng cải thiện năng suất không chỉ cho riêng mình mà còn cho phòng ban (tất nhiên cái này thì level Senior+ mới cần lưu ý nhiều, nhưng những phát hiện này có thể ngay cả một intern hay junior cũng có thể phát hiện được, vì nó ở ngay trước mắt, vì mình trải qua chúng trong chính project hàng ngày, ví dụ: khi trong giai đoạn probation/ onboarding, bạn thấy phòng ban thiếu document → dẫn đến bạn gặp khó trong việc gain domain knowledge hay hiểu về process / workflow thì chính bạn có thể nhận ra vấn đề và có thể đề xuất tổng hợp những finding của bạn lại thành document để làm tài sản cho internal team nhầm phòng khi có một new member join team, họ có sẵn những thông tin ấy, hoặc nếu bạn thấy thường xuyên nhận request không rõ ràng thì có thể tự soạn sẵn một checklist các thông tin cần có để sau này gặp project nào cũng có thể lôi ra xài, nếu được thì share cho team review & refine để xài chung…)… không thiếu những vùng xám công việc ngoài chuyên môn của mình để có thể đóng góp cho team hay org.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chưa kể chính từ những work journal này, aware được những vấn đề hay gặp, có khi liên quan đến tổ chức, workflow, quá trình collaboration, process… cũng chính là bước đầu trong việc nghĩ ra hướng cải thiện năng suất không chỉ cho riêng mình mà còn cho phòng ban (tất nhiên cái này thì level Senior+ mới cần lưu ý nhiều, nhưng những phát hiện này có thể ngay cả một intern hay junior cũng có thể phát hiện được, vì nó ở ngay trước mắt, vì mình trải qua chúng trong chính project hàng ngày, ví dụ: khi trong giai đoạn probation/ onboarding, bạn thấy phòng ban thiếu document → dẫn đến bạn gặp khó trong việc gain domain knowledge hay hiểu về process / workflow thì chính bạn có thể nhận ra vấn đề và có thể đề xuất tổng hợp những finding của bạn lại thành document để làm tài sản cho internal team nhầm phòng khi có một new member join team, họ có sẵn những thông tin ấy, hoặc nếu bạn thấy thường xuyên nhận request không rõ ràng thì có thể tự soạn sẵn một checklist các thông tin cần có để sau này gặp project nào cũng có thể lôi ra xài, nếu được thì share cho team review & refine để xài chung…)… không thiếu những vùng xám công việc ngoài chuyên môn của mình để có thể đóng góp cho team hay org.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25f5d164-78d8-802c-a5f5-d07fe571ffe2",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-30T01:34:00.000Z",
        "last_edited_time": "2025-08-30T01:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Keeping awareness & reflecting really matters.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Keeping awareness & reflecting really matters.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25f5d164-78d8-805b-b1e2-de3699b77db2",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-30T01:53:00.000Z",
        "last_edited_time": "2025-08-30T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-8053-a2c9-c98bdd7b5d55",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-10-27T04:19:00.000Z",
        "last_edited_time": "2025-08-31T04:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thay vì đọc 5 case study khác nhau trên mạng, việc mình bắt đầu ngồi reflect & viết work journal cho từng project mình đã hoặc đang handle sẽ có giá trị hơn, rút ra được các bài học sâu sắc từ chính trải nghiệm của bản thân quan trọng hơn rất nhiều. Vì kiến thức gì sát với bối cảnh nhất mới thực sự dễ ứng dụng nhất, lý thuyết để mình có thể tìm hiểu đến là vô vàn, chắc chắn là không thể nhớ hết được.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thay vì đọc 5 case study khác nhau trên mạng, việc mình bắt đầu ngồi reflect & viết work journal cho từng project mình đã hoặc đang handle sẽ có giá trị hơn, rút ra được các bài học sâu sắc từ chính trải nghiệm của bản thân quan trọng hơn rất nhiều. Vì kiến thức gì sát với bối cảnh nhất mới thực sự dễ ứng dụng nhất, lý thuyết để mình có thể tìm hiểu đến là vô vàn, chắc chắn là không thể nhớ hết được.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2605d164-78d8-800a-b88f-e65b2accb7d0",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-31T04:29:00.000Z",
        "last_edited_time": "2025-08-31T04:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nó làm mình nhớ đến câu chuyện funnel của marketing vậy:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nó làm mình nhớ đến câu chuyện funnel của marketing vậy:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2605d164-78d8-80a6-b8a5-f52860b0c7ef",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-31T04:31:00.000Z",
        "last_edited_time": "2025-08-31T04:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Việc bạn đọc case study, đọc sách, học khoá học sẽ có giá trị mặt thu gom thêm các thông tin = Tạo lead",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Việc bạn đọc case study, đọc sách, học khoá học sẽ có giá trị mặt thu gom thêm các thông tin = Tạo lead",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2605d164-78d8-802d-9d60-d20173f91047",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-31T04:31:00.000Z",
        "last_edited_time": "2025-08-31T04:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Engagement & Conversion = quá trình bạn áp dụng kiến thức + reflect để biến chúng thành kiến thức kinh nghiệm của riêng mình",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Engagement & Conversion = quá trình bạn áp dụng kiến thức + reflect để biến chúng thành kiến thức kinh nghiệm của riêng mình",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2605d164-78d8-807c-b129-f379206706ff",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-31T04:33:00.000Z",
        "last_edited_time": "2025-08-31T04:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Advocate / Refferal = Tận dụng lại các kinh nghiệm đó. Việc keep reflecting này giống như mình đang tự bỏ vô túi mình vài đồng xu vậy, không làm nó chỉ thiệt cho bản thân.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Advocate / Refferal = Tận dụng lại các kinh nghiệm đó. Việc keep reflecting này giống như mình đang tự bỏ vô túi mình vài đồng xu vậy, không làm nó chỉ thiệt cho bản thân.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25f5d164-78d8-80b2-b794-df30ca6baf23",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-30T01:53:00.000Z",
        "last_edited_time": "2025-08-30T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-8047-b911-fbc958356f44",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-10-27T04:23:00.000Z",
        "last_edited_time": "2025-08-31T04:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Work journal giúp mình biết mình hay gặp vấn đề gì trong quá trình làm việc, những thách thức nào hay phát sinh và cách mình phản ứng với chúng ra sao... Tất cả những thứ này mới là thứ bạn muốn nhìn lại, đồng thời nó cũng là thứ mà các Hiring Manager muốn tìm hiểu về bạn, chứ không phải các case study na ná nhau. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Work journal giúp mình biết mình hay gặp vấn đề gì trong quá trình làm việc, những thách thức nào hay phát sinh và cách mình phản ứng với chúng ra sao... Tất cả những thứ này mới là thứ bạn muốn nhìn lại, đồng thời nó cũng là thứ mà các Hiring Manager muốn tìm hiểu về bạn, chứ không phải các case study na ná nhau. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2605d164-78d8-8066-955e-d7bb5a1843ab",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-31T04:34:00.000Z",
        "last_edited_time": "2025-08-31T10:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu mình đã từng nghe qua tip STAR (situation - task - action - result) - mọi người hay recommend dùng nó trong tình huống trong buổi phỏng vấn, thì để có nguyên liệu trình bày theo framework đó chính xác là những gì bạn viết trong journal này, nó là những gì mình đã phải trải qua, là những phần mình reflect được, những câu chuyện “behind the scene”. Khi đọc được những ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu mình đã từng nghe qua tip STAR (situation - task - action - result) - mọi người hay recommend dùng nó trong tình huống trong buổi phỏng vấn, thì để có nguyên liệu trình bày theo framework đó chính xác là những gì bạn viết trong journal này, nó là những gì mình đã phải trải qua, là những phần mình reflect được, những câu chuyện “behind the scene”. Khi đọc được những ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "case study",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "case study",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " thế này, nó là một câu chuyện, nó cuốn hút hơn vì nó có tính ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " thế này, nó là một câu chuyện, nó cuốn hút hơn vì nó có tính ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "authentic ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "authentic ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cao hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cao hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25f5d164-78d8-8087-8b72-d88c31e02422",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-30T16:57:00.000Z",
        "last_edited_time": "2025-08-31T04:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "25f5d164-78d8-800b-87eb-fdf96fdcc781",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-30T01:54:00.000Z",
        "last_edited_time": "2025-08-30T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một người bạn của mình đã khuyên hãy viết, viết thực sự giúp mình học được rất nhiều, mãi 2 năm trở lại đây mình mới thực hiện và thực sự thấy được giá trị của nó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một người bạn của mình đã khuyên hãy viết, viết thực sự giúp mình học được rất nhiều, mãi 2 năm trở lại đây mình mới thực hiện và thực sự thấy được giá trị của nó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25f5d164-78d8-8091-8556-c30691a41179",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-30T01:56:00.000Z",
        "last_edited_time": "2025-08-30T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "I believe the most important activity for growth is writing / journaling.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "I believe the most important activity for growth is writing / journaling.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25f5d164-78d8-80dc-bfc1-fc854d1160f7",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-30T16:38:00.000Z",
        "last_edited_time": "2025-08-30T16:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "25f5d164-78d8-80af-a483-ed0c8448df3c",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-30T01:36:00.000Z",
        "last_edited_time": "2025-08-30T16:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bonus",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bonus",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25f5d164-78d8-8039-903f-e23be1475c0a",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-30T01:36:00.000Z",
        "last_edited_time": "2025-08-30T03:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình có làm một Figma template để tiện thực hành work journal trong khi design. Các bạn thấy có thể xem chơi ở",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình có làm một Figma template để tiện thực hành work journal trong khi design. Các bạn thấy có thể xem chơi ở",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " link này",
                "link": {
                  "url": "https://www.figma.com/community/file/1543461762863307361/work-journal-doc"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " link này",
              "href": "https://www.figma.com/community/file/1543461762863307361/work-journal-doc"
            },
            {
              "type": "text",
              "text": {
                "content": " nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25f5d164-78d8-8037-bc44-ce2adebfb841",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-30T03:58:00.000Z",
        "last_edited_time": "2025-08-31T04:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756526628/uxcomic-imgs/25f5d164-78d8-8037-bc44-ce2adebfb841.png",
            "expiry_time": "2026-10-04T09:11:49.876Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/25f5d164-78d8-8037-bc44-ce2adebfb841"
      },
      {
        "object": "block",
        "id": "2605d164-78d8-8045-8406-fe3266d3b56d",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-31T04:38:00.000Z",
        "last_edited_time": "2025-08-31T06:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ, mình có thể journal ngay trong quá trình design, làm đến đâu viết đến đó =))",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ, mình có thể journal ngay trong quá trình design, làm đến đâu viết đến đó =))",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2605d164-78d8-8032-8af6-c5d28928a8a8",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-31T06:23:00.000Z",
        "last_edited_time": "2025-08-31T06:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756623118/uxcomic-imgs/2605d164-78d8-8032-8af6-c5d28928a8a8.png",
            "expiry_time": "2026-10-04T09:11:49.876Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2605d164-78d8-8032-8af6-c5d28928a8a8"
      },
      {
        "object": "block",
        "id": "11b5d164-78d8-8103-ac15-e406d394557e",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-10-10T06:14:00.000Z",
        "last_edited_time": "2024-10-10T06:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "11b5d164-78d8-8167-96a0-c2d030cf4e29",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-10-10T06:14:00.000Z",
        "last_edited_time": "2024-10-10T06:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11b5d164-78d8-817b-a32b-ea873dea4875",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-10-10T06:14:00.000Z",
        "last_edited_time": "2024-10-10T11:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.tannerchristensen.com/notes/using-a-work-journal-to-create-design-case-studies",
                "link": {
                  "url": "https://www.tannerchristensen.com/notes/using-a-work-journal-to-create-design-case-studies"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.tannerchristensen.com/notes/using-a-work-journal-to-create-design-case-studies",
              "href": "https://www.tannerchristensen.com/notes/using-a-work-journal-to-create-design-case-studies"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25b5d164-78d8-8088-8ce4-ef32c0ef9a67",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-26T10:07:00.000Z",
        "last_edited_time": "2025-08-26T10:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://medium.com/@paul_vd_merwe/why-documentation-matters-more-than-you-think-9d6eeba7987a",
                "link": {
                  "url": "https://medium.com/@paul_vd_merwe/why-documentation-matters-more-than-you-think-9d6eeba7987a"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://medium.com/@paul_vd_merwe/why-documentation-matters-more-than-you-think-9d6eeba7987a",
              "href": "https://medium.com/@paul_vd_merwe/why-documentation-matters-more-than-you-think-9d6eeba7987a"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16a5d164-78d8-8008-a9ea-dcbc3f961eb4",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-12-28T04:02:00.000Z",
        "last_edited_time": "2024-12-28T04:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "16a5d164-78d8-8082-b754-c6523b19a7c4",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-12-28T04:02:00.000Z",
        "last_edited_time": "2024-12-28T04:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25f5d164-78d8-8042-9cdd-c466cc632563",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2025-08-30T04:26:00.000Z",
        "last_edited_time": "2025-08-30T04:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX as a Cupid",
              "href": "https://app.notion.com/p/10f5d16478d8808484a5d6eff66f3eec"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16a5d164-78d8-80eb-bdcd-c35c0b5d62fc",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-12-28T04:02:00.000Z",
        "last_edited_time": "2024-12-28T04:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sense making",
              "href": "https://app.notion.com/p/1195d16478d880cda21ff9d0e90ae7b8"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16a5d164-78d8-80fc-a8eb-c1e75acf55c5",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-12-28T04:02:00.000Z",
        "last_edited_time": "2024-12-28T04:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1445d164-78d8-805b-b388-e24b5f13cccb"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product development process (overall)",
              "href": "https://app.notion.com/p/1445d16478d8805bb388e24b5f13cccb"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16a5d164-78d8-8041-a1c5-c234c24c709a",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-12-28T04:03:00.000Z",
        "last_edited_time": "2024-12-28T04:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1025d164-78d8-80c5-891f-debd0fc09547"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product development process (detail)",
              "href": "https://app.notion.com/p/1025d16478d880c5891fdebd0fc09547"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2173c194-12a2-4e26-b581-341e7657edd7",
        "parent": {
          "type": "page_id",
          "page_id": "11b5d164-78d8-801e-8d22-d0e5bdfd337c"
        },
        "created_time": "2024-10-10T11:58:00.000Z",
        "last_edited_time": "2024-10-10T11:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8",
    "created_time": "2024-10-08T05:49:00.000Z",
    "last_edited_time": "2025-01-01T14:34:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "fd3cd36d-73dd-4dee-8bd5-d159d6600124"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "View": {
        "id": "ATSa",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "A%5Bqc",
        "type": "select",
        "select": {
          "id": "QNIE",
          "name": "⚓:3",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "DMgm",
        "type": "last_edited_time",
        "last_edited_time": "2025-01-01T14:34:00.000Z"
      },
      "Publish": {
        "id": "FSnx",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "_tsp",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "g%7BBg",
        "type": "created_time",
        "created_time": "2024-10-08T05:49:00.000Z"
      },
      "Share": {
        "id": "hp~_",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "m%7C%40x",
        "type": "number",
        "number": null
      },
      "Formula": {
        "id": "re%3BE",
        "type": "formula",
        "formula": {
          "type": "number",
          "number": 1
        }
      },
      "Tag": {
        "id": "%7CAvQ",
        "type": "select",
        "select": {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "4-Random",
          "color": "gray"
        }
      },
      "ID": {
        "id": "~RYT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FD",
          "number": 18
        }
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Sense making",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Sense making",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Sense-making-1195d16478d880cda21ff9d0e90ae7b8",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "5cacdbff-b9e2-4973-b565-ec1ae4327ec9",
      "name": "Fundamental",
      "slug": "fundamental",
      "icon": "🌞",
      "order": 2,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "Product",
          "slug": "product",
          "order": 1
        },
        {
          "id": "156ef770-14db-4170-b1d7-95a2fbdf62ba",
          "name": "User",
          "slug": "user",
          "order": 2
        },
        {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "Design",
          "slug": "design",
          "order": 3
        },
        {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "Random",
          "slug": "random",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "9290a1c0-fd10-40c6-a821-56f188976357",
      "name": "Random",
      "slug": "random",
      "order": 4
    },
    "content": [
      {
        "object": "block",
        "id": "1195d164-78d8-8158-835e-de309eafe4fb",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-10-08T05:49:00.000Z",
        "last_edited_time": "2024-10-12T02:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081443/uxcomic-imgs/1195d164-78d8-8158-835e-de309eafe4fb.png",
            "expiry_time": "2026-10-04T09:11:52.791Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1195d164-78d8-8158-835e-de309eafe4fb"
      },
      {
        "object": "block",
        "id": "1195d164-78d8-8107-b4de-fbeae2d1b72e",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-10-08T05:49:00.000Z",
        "last_edited_time": "2024-12-24T11:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi tình cờ nghiên cứu về IA qua cuốn sách “how to make sense of any mess”, mình biết đến cụm từ sense making & wow, một topic cực kì tuyệt vời.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi tình cờ nghiên cứu về IA qua cuốn sách “how to make sense of any mess”, mình biết đến cụm từ sense making & wow, một topic cực kì tuyệt vời.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-806e-9406-ef238fe02021",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-12-23T05:00:00.000Z",
        "last_edited_time": "2024-12-23T05:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Topic này giúp bạn hiểu cái hiểu >> tác động lên mọi thứ trong cuộc sống. Cùng tìm hiểu chung với mình nhé!",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Topic này giúp bạn hiểu cái hiểu >> tác động lên mọi thứ trong cuộc sống. Cùng tìm hiểu chung với mình nhé!",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-807f-b31a-d77ab8af4a36",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-12-23T05:00:00.000Z",
        "last_edited_time": "2024-12-23T05:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-806a-99c1-ced7afbd3514",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-12-23T05:01:00.000Z",
        "last_edited_time": "2024-12-23T05:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Định nghĩa",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Định nghĩa",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-801f-991c-da823668841e",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T03:35:00.000Z",
        "last_edited_time": "2024-11-17T06:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sense-making",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sense-making",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là quá trình hiểu và diễn giải thông tin để đưa ra những quyết định hoặc hành động ý nghĩa. Nó liên quan đến việc biến dữ liệu thô thành hiểu biết sâu sắc và cuối cùng là trí tuệ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là quá trình hiểu và diễn giải thông tin để đưa ra những quyết định hoặc hành động ý nghĩa. Nó liên quan đến việc biến dữ liệu thô thành hiểu biết sâu sắc và cuối cùng là trí tuệ.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-81a0-b6b5-e94b5768ab09",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-10-08T05:49:00.000Z",
        "last_edited_time": "2024-10-08T05:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nghiên cứu sense making giúp mình hiểu mình, hiểu người. Hơn hết nó giúp mình hiểu “cái hiểu” được hình thành như thế nào. Điều này tác động lên mọi khía cạnh trong cuộc sống.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nghiên cứu sense making giúp mình hiểu mình, hiểu người. Hơn hết nó giúp mình hiểu “cái hiểu” được hình thành như thế nào. Điều này tác động lên mọi khía cạnh trong cuộc sống.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "7c1ce0e4-b732-4a26-89d0-abb7486fd23a",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-13T01:06:00.000Z",
        "last_edited_time": "2024-11-18T13:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình sẽ dựa trên concept ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình sẽ dựa trên concept ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "data to wisdom ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "data to wisdom ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "để tìm hiểu về chủ đề này.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "để tìm hiểu về chủ đề này.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "cf384449-30db-4e5c-aa44-c7e59a57409a",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-13T01:07:00.000Z",
        "last_edited_time": "2024-11-17T03:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "9eb59622-2692-47d3-b3ff-e97991eb8f54",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-10-08T05:50:00.000Z",
        "last_edited_time": "2024-11-18T13:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Data to Wisdom",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Data to Wisdom",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-80cc-9a49-f66a95f84ab3",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-18T13:24:00.000Z",
        "last_edited_time": "2024-11-19T11:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081445/uxcomic-imgs/1425d164-78d8-80cc-9a49-f66a95f84ab3.png",
            "expiry_time": "2026-10-04T09:11:52.791Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1425d164-78d8-80cc-9a49-f66a95f84ab3"
      },
      {
        "object": "block",
        "id": "1195d164-78d8-8159-b47d-e7704b96d129",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-10-08T05:49:00.000Z",
        "last_edited_time": "2024-12-23T05:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Data (cái thấy):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Data (cái thấy):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là sự quan sát khách quan, thuần khiết, ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là sự quan sát khách quan, thuần khiết, ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "chưa có ý nghĩa",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "chưa có ý nghĩa",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ". Đây là nguyên liệu thô mà mình sẽ thu thập được qua các 5 giác quan. Ví dụ: bạn nhìn thấy một con chó màu nâu đang chạy rất nhanh, thời tiết hôm nay 25 độ C, vị này chua, chạm vào thấy mềm…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". Đây là nguyên liệu thô mà mình sẽ thu thập được qua các 5 giác quan. Ví dụ: bạn nhìn thấy một con chó màu nâu đang chạy rất nhanh, thời tiết hôm nay 25 độ C, vị này chua, chạm vào thấy mềm…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8082-91b9-f8ee80652efe",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T05:34:00.000Z",
        "last_edited_time": "2024-11-22T02:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bắt đầu từ ba quá trình ở dưới, mọi thứ đều bắt đầu có tính chủ quan, nó chịu sự ảnh hưởng của perception (POV).",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bắt đầu từ ba quá trình ở dưới, mọi thứ đều bắt đầu có tính chủ quan, nó chịu sự ảnh hưởng của perception (POV).",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8042-ac4c-e15677a75e8e",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T03:39:00.000Z",
        "last_edited_time": "2024-12-28T08:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Information (cái biết):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Information (cái biết):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " nó giống như một quá trình “dịch” data vậy, là khi trong một ngữ cảnh bạn gán một ngữ nghĩa gì đó cho data mà bạn thu thập được (thường trả lời được cho các câu hỏi: who, when, where, what, how often…). Ví dụ: ngôn ngữ là thứ mạnh mẽ để biết nó thành information, thử hình dung, một đứa bé cảm thấy khó chịu, lúc đó nó chưa nói được, ta chỉ nhận biết được tâm trạng của nó qua tiếng khóc, tiếng cười & những ngôn ngữ cơ thể. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " nó giống như một quá trình “dịch” data vậy, là khi trong một ngữ cảnh bạn gán một ngữ nghĩa gì đó cho data mà bạn thu thập được (thường trả lời được cho các câu hỏi: who, when, where, what, how often…). Ví dụ: ngôn ngữ là thứ mạnh mẽ để biết nó thành information, thử hình dung, một đứa bé cảm thấy khó chịu, lúc đó nó chưa nói được, ta chỉ nhận biết được tâm trạng của nó qua tiếng khóc, tiếng cười & những ngôn ngữ cơ thể. ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Represent & organizations: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Represent & organizations: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "và khi đã có ngôn ngữ, ngay từ cách chúng ta trình diễn data như thế nào đã vô tình hay cố ý hình thành nên xu hướng cho một ngữ nghĩa gì đó rồi. Ví dụ: trong danh sách, nếu bạn để thông tin gì đó trên đầu khả năng vô tình khiến nó được chú ý nhiều và có vẻ quan trọng hơn. Một ví dụ khác: nếu riêng việc mình biết hôm nay bán được 10 ly cà phê sẽ không cho mình biết chuyện gì cụ thể, còn khi đặt kế số lượng bán ra với những ngày khác trong tuần, bạn sẽ thấy có sự so sánh rằng trong 1 tuần qua, bán được 10 ly đang là thấp nhất, sự so sánh này cho bạn một thông tin có ý nghĩa. (có thể tìm hiểu thêm về cognitive bias).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "và khi đã có ngôn ngữ, ngay từ cách chúng ta trình diễn data như thế nào đã vô tình hay cố ý hình thành nên xu hướng cho một ngữ nghĩa gì đó rồi. Ví dụ: trong danh sách, nếu bạn để thông tin gì đó trên đầu khả năng vô tình khiến nó được chú ý nhiều và có vẻ quan trọng hơn. Một ví dụ khác: nếu riêng việc mình biết hôm nay bán được 10 ly cà phê sẽ không cho mình biết chuyện gì cụ thể, còn khi đặt kế số lượng bán ra với những ngày khác trong tuần, bạn sẽ thấy có sự so sánh rằng trong 1 tuần qua, bán được 10 ly đang là thấp nhất, sự so sánh này cho bạn một thông tin có ý nghĩa. (có thể tìm hiểu thêm về cognitive bias).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80e7-880b-c77d16c926bb",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T03:42:00.000Z",
        "last_edited_time": "2025-01-01T14:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Knowledge (cái hiểu):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Knowledge (cái hiểu):",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " dựa trên những cái thấy, cái biết, bạn diễn giải và phân tích ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " dựa trên những cái thấy, cái biết, bạn diễn giải và phân tích ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "mối quan hệ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "mối quan hệ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " giữa chúng (interpretation, thường trả lời cho câu hỏi how & why), từ đó rút ra ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " giữa chúng (interpretation, thường trả lời cho câu hỏi how & why), từ đó rút ra ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "những kết luận",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "những kết luận",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ". Đây là thứ value nhất trong sense making, đó là nhìn nhận bằng “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". Đây là thứ value nhất trong sense making, đó là nhìn nhận bằng “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "mối quan hệ",
                "link": {
                  "url": "/1225d16478d880db8d9be6cc64d11314"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "mối quan hệ",
              "href": "/1225d16478d880db8d9be6cc64d11314"
            },
            {
              "type": "text",
              "text": {
                "content": "”, vì với mỗi cách ta vẽ mối liên hệ giữa các information sẽ cho ra những cái hiểu khác nhau. Vd: task này đang gấp và quan trọng >> cần được ưu tiên cao hơn; task gấp & ít quan trọng >> làm nhanh, hạn chế công sức. Tips: apply framework thinking.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "”, vì với mỗi cách ta vẽ mối liên hệ giữa các information sẽ cho ra những cái hiểu khác nhau. Vd: task này đang gấp và quan trọng >> cần được ưu tiên cao hơn; task gấp & ít quan trọng >> làm nhanh, hạn chế công sức. Tips: apply framework thinking.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80ea-9c90-f3506790cdaa",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T03:43:00.000Z",
        "last_edited_time": "2024-12-24T11:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Wisdom (khôn ngoan): ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Wisdom (khôn ngoan): ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "là những bài học kinh nghiệm sâu sắc được rút ra sau một quá trình quá trình thử nghiệm, phản chiếu và suy luận sâu sắc. Cái chính của level này nằm ở khả năng linh hoạt, ứng biến và có chiến lược, là khả năng ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "là những bài học kinh nghiệm sâu sắc được rút ra sau một quá trình quá trình thử nghiệm, phản chiếu và suy luận sâu sắc. Cái chính của level này nằm ở khả năng linh hoạt, ứng biến và có chiến lược, là khả năng ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "biết khi nào thì nên áp dụng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "biết khi nào thì nên áp dụng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "knowledge",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "knowledge",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "nào",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "nào",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " vào thực tế, việc chuyển từ hiểu biết sang hành động có giá trị, đưa ra được những quyết định đúng đắn, sáng suốt. Trí tuệ trả lời được cho câu hỏi: liệu có phù hợp? liệu có quan trọng? liệu có đúng thời điểm? liệu đã tối ưu?… Wisdom sẽ khuếch đại tính ứng dụng các thông tin, kiến thức của bạn, để giúp đưa ra các quyết định sáng suốt. Ví dụ: “Đi một ngày đàng học một sàng khôn”; “Không có lửa sao có khói”; “Thà hỏi để thấy mình ngu lúc đó còn hơn ngu suốt đời”…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " vào thực tế, việc chuyển từ hiểu biết sang hành động có giá trị, đưa ra được những quyết định đúng đắn, sáng suốt. Trí tuệ trả lời được cho câu hỏi: liệu có phù hợp? liệu có quan trọng? liệu có đúng thời điểm? liệu đã tối ưu?… Wisdom sẽ khuếch đại tính ứng dụng các thông tin, kiến thức của bạn, để giúp đưa ra các quyết định sáng suốt. Ví dụ: “Đi một ngày đàng học một sàng khôn”; “Không có lửa sao có khói”; “Thà hỏi để thấy mình ngu lúc đó còn hơn ngu suốt đời”…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1465d164-78d8-80ed-9d32-f5afec04a0e0",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-22T02:47:00.000Z",
        "last_edited_time": "2024-11-22T02:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-8164-aa33-df659d32a4ac",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-10-08T05:49:00.000Z",
        "last_edited_time": "2024-11-18T13:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8070-a2b6-f9a34d29c58e",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T03:33:00.000Z",
        "last_edited_time": "2024-11-18T13:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081446/uxcomic-imgs/1415d164-78d8-8070-a2b6-f9a34d29c58e.png",
            "expiry_time": "2026-10-04T09:11:52.791Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1415d164-78d8-8070-a2b6-f9a34d29c58e"
      },
      {
        "object": "block",
        "id": "1195d164-78d8-81a7-8df6-d088847c7275",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-10-08T05:49:00.000Z",
        "last_edited_time": "2024-11-17T06:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dựa trên Data to Wisdom ở trên mình sẽ lấy một ví dụ thực tế.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dựa trên Data to Wisdom ở trên mình sẽ lấy một ví dụ thực tế.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80da-92f5-f43e5773ae86",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T06:06:00.000Z",
        "last_edited_time": "2024-11-17T06:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80ce-8445-f83d017e221c",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T03:53:00.000Z",
        "last_edited_time": "2024-11-17T03:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ 1: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ 1: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Một hôm, cậu bé 3 tuổi nghe thấy một tiếng kêu é é từ một cái ấm nước sôi bằng inox. Câu bé tò mò nên lại sờ vào ấm nước ấy, vì nó đang rất nóng nên làm bỏng tay cậu bé, khiến cho nó la lên và khóc. Từ đó về sau nó không dám sờ vào ấm nước nữa, thậm chí ấm nước có sôi hay không.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một hôm, cậu bé 3 tuổi nghe thấy một tiếng kêu é é từ một cái ấm nước sôi bằng inox. Câu bé tò mò nên lại sờ vào ấm nước ấy, vì nó đang rất nóng nên làm bỏng tay cậu bé, khiến cho nó la lên và khóc. Từ đó về sau nó không dám sờ vào ấm nước nữa, thậm chí ấm nước có sôi hay không.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8059-b505-cbd0298f74c8",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T03:56:00.000Z",
        "last_edited_time": "2024-11-17T03:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy hãy thử mapping lên các component trên nhé:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy hãy thử mapping lên các component trên nhé:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-802d-8151-c558a6d4d1d7",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T03:57:00.000Z",
        "last_edited_time": "2024-11-17T03:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Data: tiếng é é, ấm nước bằng inox là những gì cậu bé thuần quan sát và nghe được.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Data: tiếng é é, ấm nước bằng inox là những gì cậu bé thuần quan sát và nghe được.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8040-8c32-ed78845a7945",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T03:57:00.000Z",
        "last_edited_time": "2024-12-23T05:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Information: câu bé không biết nó đang sôi, tuy nhiên sau khi sờ vào cậu bé thấy nóng và đau, bản năng cho cậu bé biết nó đang có hại cho bản thân. Từ đó cậu hiểu: (Tiếng é é + hơi nước + ấm nước inox) = nước đang sôi và rất nóng. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Information: câu bé không biết nó đang sôi, tuy nhiên sau khi sờ vào cậu bé thấy nóng và đau, bản năng cho cậu bé biết nó đang có hại cho bản thân. Từ đó cậu hiểu: (Tiếng é é + hơi nước + ấm nước inox) = nước đang sôi và rất nóng. ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8012-82c7-c1824f2a9fd9",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T03:57:00.000Z",
        "last_edited_time": "2024-12-23T05:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Knowledge: khi nước đang sôi mình chạm vào sẽ rất nóng & đau.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Knowledge: khi nước đang sôi mình chạm vào sẽ rất nóng & đau.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8091-a3fc-d8fd727bc2a0",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T03:58:00.000Z",
        "last_edited_time": "2024-11-17T04:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Wisdom: cậu bé rút kinh nghiệm, lần sau không dám sờ vào nó khi đang sôi nữa.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Wisdom: cậu bé rút kinh nghiệm, lần sau không dám sờ vào nó khi đang sôi nữa.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8050-a300-d07d0ba54d94",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T06:06:00.000Z",
        "last_edited_time": "2024-11-17T06:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Qua ví dụ này có thể thấy đây là cách chúng ta học và rút kinh nghiệm cho việc gì đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Qua ví dụ này có thể thấy đây là cách chúng ta học và rút kinh nghiệm cho việc gì đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80bd-a145-d3392afca875",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T06:06:00.000Z",
        "last_edited_time": "2024-11-17T06:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-802b-ab41-e26d5c037747",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T03:59:00.000Z",
        "last_edited_time": "2024-11-17T04:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ 2:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ 2:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Một hôm bạn vào một quán ăn và xem menu để order món ăn. Đây là tấm menu bạn cầm trên tay.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Một hôm bạn vào một quán ăn và xem menu để order món ăn. Đây là tấm menu bạn cầm trên tay.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-803b-9d42-d99829908b88",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T04:42:00.000Z",
        "last_edited_time": "2024-11-17T04:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081447/uxcomic-imgs/1415d164-78d8-803b-9d42-d99829908b88.png",
            "expiry_time": "2026-10-04T09:11:52.876Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1415d164-78d8-803b-9d42-d99829908b88"
      },
      {
        "object": "block",
        "id": "1415d164-78d8-807e-8466-c19e541182b7",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T04:44:00.000Z",
        "last_edited_time": "2024-11-17T04:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Data: chữ tiếng anh, giá, biểu tượng, hình ảnh, kích thước, badge…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Data: chữ tiếng anh, giá, biểu tượng, hình ảnh, kích thước, badge…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80f2-b591-d01d46175ce2",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T04:45:00.000Z",
        "last_edited_time": "2024-11-22T01:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Information: hiểu nghĩa của tiếng anh, các thành phần, giá cao giá thấp, hình to hình nhỏ…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Information: hiểu nghĩa của tiếng anh, các thành phần, giá cao giá thấp, hình to hình nhỏ…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80ac-87e1-d425e24e3cdf",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T04:46:00.000Z",
        "last_edited_time": "2024-12-23T05:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Knowledge: việc hình đầu tiên to hơn hẳn, có badge “Recommended” giúp bạn hiểu món này là món signature, sẽ đặc biệt hơn & có vẻ ngon hơn các món khác.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Knowledge: việc hình đầu tiên to hơn hẳn, có badge “Recommended” giúp bạn hiểu món này là món signature, sẽ đặc biệt hơn & có vẻ ngon hơn các món khác.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8048-91ea-ea6ac9d64e2f",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T04:47:00.000Z",
        "last_edited_time": "2024-11-17T04:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Wisdom: theo kinh nghiệm của bạn thì đa phần mấy món mà quán đề xuất thường khác lạ và đáng để thử nên bạn quyết định order món này.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Wisdom: theo kinh nghiệm của bạn thì đa phần mấy món mà quán đề xuất thường khác lạ và đáng để thử nên bạn quyết định order món này.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8089-a3d1-ce620e4f189d",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T04:51:00.000Z",
        "last_edited_time": "2024-11-17T04:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Qua ví dụ này bạn thấy việc trình diễn các information giúp hình thành cái hiểu cho user và tác động đến quyết định của họ như thế nào.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Qua ví dụ này bạn thấy việc trình diễn các information giúp hình thành cái hiểu cho user và tác động đến quyết định của họ như thế nào.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8062-80b1-fca5efbe6767",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T06:15:00.000Z",
        "last_edited_time": "2024-11-17T06:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80bd-bf95-fe78c38830b3",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-12-23T05:16:00.000Z",
        "last_edited_time": "2024-12-23T05:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tóm gọn",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tóm gọn",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80da-a1a8-ca3b1b1ffaf0",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-12-23T05:16:00.000Z",
        "last_edited_time": "2024-12-23T05:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thử hình dung nếu sense making là một phương trình toán học thì nó trông ra sao nhé:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thử hình dung nếu sense making là một phương trình toán học thì nó trông ra sao nhé:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8044-9607-e24306175d17",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-12-23T05:16:00.000Z",
        "last_edited_time": "2024-12-23T05:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Information = Data + Context",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Information = Data + Context",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "fa557b26-1aee-4ee1-9ae3-141bd887f039",
            "parent": {
              "type": "block_id",
              "block_id": "1655d164-78d8-8044-9607-e24306175d17"
            },
            "created_time": "2024-12-23T05:16:00.000Z",
            "last_edited_time": "2024-12-23T05:16:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Knowledge = Information * (Perception + Experience) ",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Knowledge = Information * (Perception + Experience) ",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "4d2f1cba-2f93-4137-a875-c770cbe712d7",
            "parent": {
              "type": "block_id",
              "block_id": "1655d164-78d8-8044-9607-e24306175d17"
            },
            "created_time": "2024-12-23T05:16:00.000Z",
            "last_edited_time": "2024-12-23T05:16:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Wisdom = Knowledge + Judgment",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Wisdom = Knowledge + Judgment",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "97044ce8-eb2b-4619-a6d7-b5f99943b6a5",
            "parent": {
              "type": "block_id",
              "block_id": "1655d164-78d8-8044-9607-e24306175d17"
            },
            "created_time": "2024-12-23T05:16:00.000Z",
            "last_edited_time": "2024-12-23T05:16:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "divider",
            "divider": {},
            "archived": false
          },
          {
            "object": "block",
            "id": "2bb3a2d4-0155-4a08-9ea9-2202facd2744",
            "parent": {
              "type": "block_id",
              "block_id": "1655d164-78d8-8044-9607-e24306175d17"
            },
            "created_time": "2024-12-23T05:16:00.000Z",
            "last_edited_time": "2025-01-01T14:33:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Perception = Emotion + Bias + Belief",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Perception = Emotion + Bias + Belief",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "78fb2d4f-e727-4a40-8de6-86a61cdc3e0f",
            "parent": {
              "type": "block_id",
              "block_id": "1655d164-78d8-8044-9607-e24306175d17"
            },
            "created_time": "2024-12-23T05:16:00.000Z",
            "last_edited_time": "2024-12-23T05:16:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Decision = Wisdom * Knowledge",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Decision = Wisdom * Knowledge",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80c8-add7-c109c7ad209b",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-12-23T05:16:00.000Z",
        "last_edited_time": "2024-12-23T05:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80b9-8a7f-d2705120327f",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-12-23T05:16:00.000Z",
        "last_edited_time": "2024-12-23T05:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Như có nói ở trên, từ information đến wisdom đến chịu tác động chủ quan hay cụ thể hơn thì nó là perception. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Như có nói ở trên, từ information đến wisdom đến chịu tác động chủ quan hay cụ thể hơn thì nó là perception. ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Perception (nhận thức): ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Perception (nhận thức): ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "giúp con người ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "giúp con người ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "chọn lọc và gán ý nghĩa",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "chọn lọc và gán ý nghĩa",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " cho dữ liệu thô. Nên không phải tất cả dữ liệu đều được tiếp nhận và hiểu giống nhau, nó đóng vai trò như cái phễu & lăng kính; perception phụ thuộc vào bối cảnh, kỳ vọng, niềm tin, kinh nghiệm, định kiến & cảm xúc thời điểm đó. Ví dụ cho sự tác động này “Người buồn cảnh có vui đâu bao giờ”, “Người này gọi đó là thất bại, nhưng tôi lại thấy nó là những bài học đáng giá”…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " cho dữ liệu thô. Nên không phải tất cả dữ liệu đều được tiếp nhận và hiểu giống nhau, nó đóng vai trò như cái phễu & lăng kính; perception phụ thuộc vào bối cảnh, kỳ vọng, niềm tin, kinh nghiệm, định kiến & cảm xúc thời điểm đó. Ví dụ cho sự tác động này “Người buồn cảnh có vui đâu bao giờ”, “Người này gọi đó là thất bại, nhưng tôi lại thấy nó là những bài học đáng giá”…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-809b-9254-c513f3bffa5e",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-12-26T05:06:00.000Z",
        "last_edited_time": "2024-12-26T05:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Liên hệ một chút đến tam quan:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Liên hệ một chút đến tam quan:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-8050-93fa-d8bbd5ad840e",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-12-26T05:06:00.000Z",
        "last_edited_time": "2024-12-26T05:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thế giới quan = data",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thế giới quan = data",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-8096-b3cf-c8f35b861fce",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-12-26T05:06:00.000Z",
        "last_edited_time": "2024-12-26T05:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giá trị quan = Information + Knowledge",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giá trị quan = Information + Knowledge",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-8002-aced-c1466ef62d59",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-12-26T05:06:00.000Z",
        "last_edited_time": "2024-12-26T05:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhân sinh quan = Wisdom",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhân sinh quan = Wisdom",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-80bb-9114-d8f4405b6f1d",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-12-26T05:07:00.000Z",
        "last_edited_time": "2024-12-26T05:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu bạn muốn tìm hiểu thêm về tam quan, mình có mention đến trong ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu bạn muốn tìm hiểu thêm về tam quan, mình có mention đến trong ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "bài này",
                "link": {
                  "url": "/32cbe568c34b4255a408f2a2e6227bb2"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "bài này",
              "href": "/32cbe568c34b4255a408f2a2e6227bb2"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80c1-b70e-d392cc182e4b",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-12-23T05:16:00.000Z",
        "last_edited_time": "2024-12-23T05:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-8150-a845-f8d693153614",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-10-08T05:49:00.000Z",
        "last_edited_time": "2024-11-18T12:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "OK biết vậy để làm gì",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "OK biết vậy để làm gì",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-80e6-b2aa-ce300cb4817e",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-18T12:53:00.000Z",
        "last_edited_time": "2024-12-23T05:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thật sự topic này đối với mình nó rất trừu tượng, mình thấy việc biết, hiểu nó có thể áp dụng để lên rất nhiều thứ & nhiều tình huống trong cuộc sống. Ví dụ sau đây là vài cái mình thấy được sự tác động của nó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thật sự topic này đối với mình nó rất trừu tượng, mình thấy việc biết, hiểu nó có thể áp dụng để lên rất nhiều thứ & nhiều tình huống trong cuộc sống. Ví dụ sau đây là vài cái mình thấy được sự tác động của nó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-8077-9956-d653e21d17fb",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T04:56:00.000Z",
        "last_edited_time": "2024-11-17T07:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Việc học",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Việc học",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-809d-830c-f86b7d4791b1",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T04:56:00.000Z",
        "last_edited_time": "2024-11-18T13:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhận thức việc hình thành cái biết hiện tại đều dựa trên dữ liệu quá khứ. Khi cái hiểu hình thành, nó sẽ thay đổi cách chúng ta nhìn thế giới. Tuy nhiên, mỗi ngày mỗi giờ ta đang trải qua, data ngoài thế giới biến chuyển liên tục >> kiến thức, kinh nghiệm mình hình thành ở quá khứ có thể không còn đúng cho hiện tại. >> ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhận thức việc hình thành cái biết hiện tại đều dựa trên dữ liệu quá khứ. Khi cái hiểu hình thành, nó sẽ thay đổi cách chúng ta nhìn thế giới. Tuy nhiên, mỗi ngày mỗi giờ ta đang trải qua, data ngoài thế giới biến chuyển liên tục >> kiến thức, kinh nghiệm mình hình thành ở quá khứ có thể không còn đúng cho hiện tại. >> ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Tránh bias.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tránh bias.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-806c-af44-c7bdc5ee42d4",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T07:18:00.000Z",
        "last_edited_time": "2024-12-23T05:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhận thức cái biết tương lai dựa trên việc hôm nay bạn có thêm dữ liệu nào >>",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhận thức cái biết tương lai dựa trên việc hôm nay bạn có thêm dữ liệu nào >>",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Tò mò là đức tính khởi nguồn của sự học",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Tò mò là đức tính khởi nguồn của sự học",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", vì nhờ nó mà ta để ý, quan tâm và đặt câu hỏi nhiều hơn, từ đó chủ động thu thập được nhiều thông tin hơn, tác động đến cái hiểu.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", vì nhờ nó mà ta để ý, quan tâm và đặt câu hỏi nhiều hơn, từ đó chủ động thu thập được nhiều thông tin hơn, tác động đến cái hiểu.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80fd-8ab1-d5ec95e36564",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T09:55:00.000Z",
        "last_edited_time": "2024-12-23T05:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có khi cái bạn biết chưa phải cái bạn hiểu. Vì để hiểu, mình cần thời gian bình tâm ngồi xuống suy nghĩ sâu sắc về chúng, là lúc mình có khả năng vẽ được các mối liên hệ giữa các thông tin, các thứ mình biết. Một cách test nhanh, dựa theo kĩ thuật của ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có khi cái bạn biết chưa phải cái bạn hiểu. Vì để hiểu, mình cần thời gian bình tâm ngồi xuống suy nghĩ sâu sắc về chúng, là lúc mình có khả năng vẽ được các mối liên hệ giữa các thông tin, các thứ mình biết. Một cách test nhanh, dựa theo kĩ thuật của ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Feyman",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Feyman",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", đó là hãy thử truyền đạt lại một chủ đề gì đó cho người khác, xem đối phương có nắm được cái ý bạn nói không, có thấy dễ hiểu không, có khi trong lúc mình đang lên kịch bản những thứ cần nói cũng đang thấy rối rối, đó là vì mình chưa hình dung rõ được ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", đó là hãy thử truyền đạt lại một chủ đề gì đó cho người khác, xem đối phương có nắm được cái ý bạn nói không, có thấy dễ hiểu không, có khi trong lúc mình đang lên kịch bản những thứ cần nói cũng đang thấy rối rối, đó là vì mình chưa hình dung rõ được ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "mối liên hệ",
                "link": {
                  "url": "/1225d16478d880db8d9be6cc64d11314"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "mối liên hệ",
              "href": "/1225d16478d880db8d9be6cc64d11314"
            },
            {
              "type": "text",
              "text": {
                "content": " giữa chúng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " giữa chúng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8007-878a-e057b7f9d052",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-18T12:55:00.000Z",
        "last_edited_time": "2024-11-22T02:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tận dung các dữ liệu quá khứ ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tận dung các dữ liệu quá khứ ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "để hình dung cái hiểu mới tốt hơn, điều này giúp cái mình hiểu được chặt chẽ hơn, hãy thử cố gắng minh hoạ hoá hoặc ẩn dụ chủ đề mới theo những gì bạn đã quen thuộc với đời sống của mình. Ví dụ mình thấy từ data, information, knowledge, wisdom không giúp mình hình dung được mối liên hệ giữa chúng, nên mình chuyển nó sang từ tiếng Việt cho dễ hình dung hơn: data-cái thấy, information-cái biết, knowledge-cái hiểu, wisdom-khôn ngoan.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "để hình dung cái hiểu mới tốt hơn, điều này giúp cái mình hiểu được chặt chẽ hơn, hãy thử cố gắng minh hoạ hoá hoặc ẩn dụ chủ đề mới theo những gì bạn đã quen thuộc với đời sống của mình. Ví dụ mình thấy từ data, information, knowledge, wisdom không giúp mình hình dung được mối liên hệ giữa chúng, nên mình chuyển nó sang từ tiếng Việt cho dễ hình dung hơn: data-cái thấy, information-cái biết, knowledge-cái hiểu, wisdom-khôn ngoan.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8030-9096-d31a8dc6eccc",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-12-24T00:48:00.000Z",
        "last_edited_time": "2024-12-24T00:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giờ bộ não không đơn giản chỉ là cái kho chứa đựng các kiến thức, nó là một mạng lưới chằn chịt như neuron z đó (nghĩ thấy thú vị thiệt, hình thái nó rất giống với cách chính đó hoạt động), mọi thứ bạn học, bạn biết đều có tính liên kết với nhau, học một cái gì đó đồng nghĩa việc thêm & enhance tất cả những gì đã biết",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giờ bộ não không đơn giản chỉ là cái kho chứa đựng các kiến thức, nó là một mạng lưới chằn chịt như neuron z đó (nghĩ thấy thú vị thiệt, hình thái nó rất giống với cách chính đó hoạt động), mọi thứ bạn học, bạn biết đều có tính liên kết với nhau, học một cái gì đó đồng nghĩa việc thêm & enhance tất cả những gì đã biết",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8052-9182-ef62a23e185f",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-12-24T00:53:00.000Z",
        "last_edited_time": "2024-12-24T11:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081449/uxcomic-imgs/1665d164-78d8-8052-9182-ef62a23e185f.webp",
            "expiry_time": "2026-10-04T09:11:52.950Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1665d164-78d8-8052-9182-ef62a23e185f"
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80f6-9b05-eca9dfa3c043",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T04:55:00.000Z",
        "last_edited_time": "2024-11-18T12:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhận thức được sự tác động của data, information lên cách chúng ta hiểu",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhận thức được sự tác động của data, information lên cách chúng ta hiểu",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1415d164-78d8-80e8-bc90-da154f24174e",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T04:56:00.000Z",
        "last_edited_time": "2024-11-22T02:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thông tin sai lệch",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thông tin sai lệch",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " sẽ hình thành một cái hiểu sai lệch. “Garbage in, garbage out”. Vậy nên hãy luôn đặt câu hỏi, nghi vấn những gì mình thấy, mình biết. >> lí do tư duy phản biện quan trọng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " sẽ hình thành một cái hiểu sai lệch. “Garbage in, garbage out”. Vậy nên hãy luôn đặt câu hỏi, nghi vấn những gì mình thấy, mình biết. >> lí do tư duy phản biện quan trọng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-801d-979b-cdff2b2336c2",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-18T13:01:00.000Z",
        "last_edited_time": "2024-12-23T05:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi thiếu thông tin,",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi thiếu thông tin,",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " sẽ dẫn đến việc ta không hình thành được cái hiểu không hoàn chỉnh, hoặc hiểu theo chiều hướng khác. Ví dụ: khi bạn xem các phim cảnh sát điều tra vụ án, họ phải đi collect từng dữ kiện để giúp họ giải án.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " sẽ dẫn đến việc ta không hình thành được cái hiểu không hoàn chỉnh, hoặc hiểu theo chiều hướng khác. Ví dụ: khi bạn xem các phim cảnh sát điều tra vụ án, họ phải đi collect từng dữ kiện để giúp họ giải án.",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " “Một nửa sự thật không còn là sự thật.”",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " “Một nửa sự thật không còn là sự thật.”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1545d164-78d8-80a4-8cf4-f44a65e1e60c",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-12-06T12:34:00.000Z",
        "last_edited_time": "2024-12-17T04:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [
            {
              "type": "text",
              "text": {
                "content": "Trích từ bài post facebook của Nguyễn Vương Chung",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trích từ bài post facebook của Nguyễn Vương Chung",
              "href": null
            }
          ],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081451/uxcomic-imgs/1545d164-78d8-80a4-8cf4-f44a65e1e60c.jpg",
            "expiry_time": "2026-10-04T09:11:52.951Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1545d164-78d8-80a4-8cf4-f44a65e1e60c"
      },
      {
        "object": "block",
        "id": "1415d164-78d8-808a-9c9b-e8564663c822",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-17T06:52:00.000Z",
        "last_edited_time": "2024-11-18T13:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi quá nhiều thông tin",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi quá nhiều thông tin",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", đồng nghĩa với việc phải xử lý chúng nhiều hơn, điều này dẫn đến sự khó hiểu, hỗn loạn (mess) >> khi bạn thấy mess, thì thử tách nhỏ thông tin ra, phân nhóm chúng, từ từ hình dung mối liên hệ của chúng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", đồng nghĩa với việc phải xử lý chúng nhiều hơn, điều này dẫn đến sự khó hiểu, hỗn loạn (mess) >> khi bạn thấy mess, thì thử tách nhỏ thông tin ra, phân nhóm chúng, từ từ hình dung mối liên hệ của chúng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-80fe-aaa1-fe3e53fffa3a",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-18T12:16:00.000Z",
        "last_edited_time": "2024-11-18T12:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cùng một lượng thông tin, nhưng cách ta diễn giải (”nối”) chúng như thế nào sẽ hình thành nên những cách hiểu khác nhau.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cùng một lượng thông tin, nhưng cách ta diễn giải (”nối”) chúng như thế nào sẽ hình thành nên những cách hiểu khác nhau.",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-806c-aa8d-d26785de907b",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-18T12:47:00.000Z",
        "last_edited_time": "2024-12-23T05:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lấy ví dụ “nửa cốc nước”, chỉ cần một nhân tố là niềm tin khác nhau đã có 2 thái độ khác nhau.  Người sẽ thấy may quá còn một nửa ly nước, người sẽ thấy tiếc vì chỉ còn một nửa ly nước. >> ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lấy ví dụ “nửa cốc nước”, chỉ cần một nhân tố là niềm tin khác nhau đã có 2 thái độ khác nhau.  Người sẽ thấy may quá còn một nửa ly nước, người sẽ thấy tiếc vì chỉ còn một nửa ly nước. >> ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "why perception matter.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "why perception matter.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8014-8bbd-ff6f0298d33e",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-18T12:53:00.000Z",
        "last_edited_time": "2024-12-23T05:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Tư duy lối mòn”, “Tư duy đa chiều”, “Tư duy sáng tạo”, “Tư duy ngược“, “Six hat thinking”… các loại tư duy này đều minh hoạ cho việc ta ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Tư duy lối mòn”, “Tư duy đa chiều”, “Tư duy sáng tạo”, “Tư duy ngược“, “Six hat thinking”… các loại tư duy này đều minh hoạ cho việc ta ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "“nối” ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“nối” ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "các thông tin sẵn có như thế nào.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "các thông tin sẵn có như thế nào.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-80d7-a099-c119ec01bb49",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-18T13:49:00.000Z",
        "last_edited_time": "2024-12-23T05:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Việc mình giao tiếp, trình bày cho người khác, họ không hiểu hay hiểu sai là chuyện bình thường và rất hay xảy ra. Để diễn đạt cho dễ hiểu, đồng nghĩa với việc bạn trình bày mớ thông tin ấy ra và trình diễn cách bạn “nối” chúng như thế nào, nó đang dựa trên perception ra sao, aware perception của mình & họ có gì khác nhau.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Việc mình giao tiếp, trình bày cho người khác, họ không hiểu hay hiểu sai là chuyện bình thường và rất hay xảy ra. Để diễn đạt cho dễ hiểu, đồng nghĩa với việc bạn trình bày mớ thông tin ấy ra và trình diễn cách bạn “nối” chúng như thế nào, nó đang dựa trên perception ra sao, aware perception của mình & họ có gì khác nhau.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1515d164-78d8-8009-9938-c63543b0eec7",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-12-03T05:55:00.000Z",
        "last_edited_time": "2024-12-03T06:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: bạn hiểu thế nào về câu nói “người nói đạo lý thường sống như l*@/₫:!”",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: bạn hiểu thế nào về câu nói “người nói đạo lý thường sống như l*@/₫:!”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1515d164-78d8-80eb-b467-e48763bae1c7",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-12-03T05:56:00.000Z",
        "last_edited_time": "2024-12-03T06:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nghe qua là thấy câu này tiêu cực rồi. Mà mình thắc mắc sao thấy người biết đạo lý rõ ràng là tích cực như vế sau thì lại là một chiều hướng không tốt. Hãy thử nhìn nhận với vài góc nhìn sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nghe qua là thấy câu này tiêu cực rồi. Mà mình thắc mắc sao thấy người biết đạo lý rõ ràng là tích cực như vế sau thì lại là một chiều hướng không tốt. Hãy thử nhìn nhận với vài góc nhìn sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1515d164-78d8-8034-8659-d3e5bc0c987f",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-12-03T06:00:00.000Z",
        "last_edited_time": "2024-12-23T05:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lời nói không đi kèm hành động. Đó là do khi người khác nói đạo lý, mình cảm thấy đây là một lời hứa của họ, mình sẽ đặt kì vọng và quan sát họ nhiều hơn, nếu họ không thực hiện được thì xem như đã thất hứa, đã mất uy tín, nghĩ rằng người này chỉ giỏi nói chứ không làm. Nhưng sự thật là nói thì dễ nhưng làm thì khó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lời nói không đi kèm hành động. Đó là do khi người khác nói đạo lý, mình cảm thấy đây là một lời hứa của họ, mình sẽ đặt kì vọng và quan sát họ nhiều hơn, nếu họ không thực hiện được thì xem như đã thất hứa, đã mất uy tín, nghĩ rằng người này chỉ giỏi nói chứ không làm. Nhưng sự thật là nói thì dễ nhưng làm thì khó.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1515d164-78d8-80b8-bf42-cb6c600e01d0",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-12-03T06:02:00.000Z",
        "last_edited_time": "2024-12-23T05:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cũng do những lời nói đạo lý đó, đôi khi ta kì vọng nhiều hơn ở phía đối phương, có khi họ nói 3 đạo lý, nhưng ta kì vọng họ phải đạt thêm 7 đạo lý khác. >> vô tình việc họ nói nhiều khiến người khác kì vọng bạn cao hơn luôn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cũng do những lời nói đạo lý đó, đôi khi ta kì vọng nhiều hơn ở phía đối phương, có khi họ nói 3 đạo lý, nhưng ta kì vọng họ phải đạt thêm 7 đạo lý khác. >> vô tình việc họ nói nhiều khiến người khác kì vọng bạn cao hơn luôn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1515d164-78d8-80c7-82e2-efb81ece2756",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-12-03T06:09:00.000Z",
        "last_edited_time": "2024-12-23T05:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đâu đó nó làm mình liên tưởng đến câu nói “học đi đôi với hành”. Bất kể bạn biết nhiều đến mức nào đi nữa, nếu không hành, có khi nó còn phản tác dụng, kiểu “thùng rỗng kêu to”, “chỉ biết vẽ”, “phông bạt”, vì biết là một chuyện, khả năng mình vận dụng được nó vào trong công việc thực tế mà tạo ra được kết quả là khác.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đâu đó nó làm mình liên tưởng đến câu nói “học đi đôi với hành”. Bất kể bạn biết nhiều đến mức nào đi nữa, nếu không hành, có khi nó còn phản tác dụng, kiểu “thùng rỗng kêu to”, “chỉ biết vẽ”, “phông bạt”, vì biết là một chuyện, khả năng mình vận dụng được nó vào trong công việc thực tế mà tạo ra được kết quả là khác.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "1455d164-78d8-8001-b10b-ffda0721a3ed",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-21T02:37:00.000Z",
        "last_edited_time": "2024-11-21T02:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8070-96fb-d009f39d6a2e",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-18T13:53:00.000Z",
        "last_edited_time": "2024-11-18T13:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80b1-aa03-c9565aa279aa",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-12-23T05:32:00.000Z",
        "last_edited_time": "2024-12-26T05:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relation (systematic thinking)",
              "href": "https://app.notion.com/p/1225d16478d880db8d9be6cc64d11314"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8062-853d-d39f13da768a",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-18T13:53:00.000Z",
        "last_edited_time": "2024-12-26T05:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Understand, Empathize user?",
              "href": "https://app.notion.com/p/32cbe568c34b4255a408f2a2e6227bb2"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-803d-a8a7-ec628ac233e2",
        "parent": {
          "type": "page_id",
          "page_id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
        },
        "created_time": "2024-11-18T13:54:00.000Z",
        "last_edited_time": "2024-12-23T05:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "95727332-bdb3-4f63-a0cd-f9023732995d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Questioning (P1)",
              "href": "https://app.notion.com/p/95727332bdb34f63a0cdf9023732995d"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "22f4879b-78c6-41f4-ac92-2219ca7879f2",
    "created_time": "2024-10-07T10:25:00.000Z",
    "last_edited_time": "2025-09-11T06:06:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "fd3cd36d-73dd-4dee-8bd5-d159d6600124"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "View": {
        "id": "ATSa",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "A%5Bqc",
        "type": "select",
        "select": {
          "id": "\\i@K",
          "name": "⚓:1",
          "color": "pink"
        }
      },
      "Last edited time": {
        "id": "DMgm",
        "type": "last_edited_time",
        "last_edited_time": "2025-09-11T06:06:00.000Z"
      },
      "Publish": {
        "id": "FSnx",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "_tsp",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "g%7BBg",
        "type": "created_time",
        "created_time": "2024-10-07T10:25:00.000Z"
      },
      "Share": {
        "id": "hp~_",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "m%7C%40x",
        "type": "number",
        "number": null
      },
      "Formula": {
        "id": "re%3BE",
        "type": "formula",
        "formula": {
          "type": "number",
          "number": 1
        }
      },
      "Tag": {
        "id": "%7CAvQ",
        "type": "select",
        "select": {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "1-Product",
          "color": "default"
        }
      },
      "ID": {
        "id": "~RYT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FD",
          "number": 16
        }
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Product là gì?",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Product là gì?",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Product-l-g-22f4879b78c641f4ac922219ca7879f2",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "5cacdbff-b9e2-4973-b565-ec1ae4327ec9",
      "name": "Fundamental",
      "slug": "fundamental",
      "icon": "🌞",
      "order": 2,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "Product",
          "slug": "product",
          "order": 1
        },
        {
          "id": "156ef770-14db-4170-b1d7-95a2fbdf62ba",
          "name": "User",
          "slug": "user",
          "order": 2
        },
        {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "Design",
          "slug": "design",
          "order": 3
        },
        {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "Random",
          "slug": "random",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
      "name": "Product",
      "slug": "product",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "1185d164-78d8-81d4-811f-f2d308a16fa3",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-07T10:26:00.000Z",
        "last_edited_time": "2024-10-08T13:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081455/uxcomic-imgs/1185d164-78d8-81d4-811f-f2d308a16fa3.png",
            "expiry_time": "2026-10-04T09:11:54.846Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1185d164-78d8-81d4-811f-f2d308a16fa3"
      },
      {
        "object": "block",
        "id": "1635d164-78d8-800c-a752-f520992e4944",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-12-21T08:48:00.000Z",
        "last_edited_time": "2025-01-01T00:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình đến với nghề này cũng rất chi tình cờ, thông qua một người bạn rủ rê học thử 1 khoá ngắn hạn (tầm 2-3 tháng thì phải), mình bắt đầu biết rất cơ bản & sau đó thì apply làm fresher cho một công ty outsource, và rồi cứ thế vừa tự học, vừa làm,… nhưng nghĩ lại thì chẳng bao giờ mình thật sự tìm hiểu hẳn hoi cho thứ mình thiết kế cho là product, nó là gì, điều gì tạo nên product mà một UX/UI designer có thể quan tâm đến?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình đến với nghề này cũng rất chi tình cờ, thông qua một người bạn rủ rê học thử 1 khoá ngắn hạn (tầm 2-3 tháng thì phải), mình bắt đầu biết rất cơ bản & sau đó thì apply làm fresher cho một công ty outsource, và rồi cứ thế vừa tự học, vừa làm,… nhưng nghĩ lại thì chẳng bao giờ mình thật sự tìm hiểu hẳn hoi cho thứ mình thiết kế cho là product, nó là gì, điều gì tạo nên product mà một UX/UI designer có thể quan tâm đến?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1635d164-78d8-800c-b151-d61971a95d20",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-12-21T08:52:00.000Z",
        "last_edited_time": "2024-12-21T08:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-806b-92e4-fc54396826e2",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T04:37:00.000Z",
        "last_edited_time": "2024-10-19T06:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Product là gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product là gì?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8015-86a1-d7a8405f6cab",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T04:37:00.000Z",
        "last_edited_time": "2024-10-21T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Product là bất kỳ hàng hóa hoặc dịch vụ nào được cung cấp cho thị trường để đáp ứng nhu cầu hoặc mong muốn của khách hàng.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product là bất kỳ hàng hóa hoặc dịch vụ nào được cung cấp cho thị trường để đáp ứng nhu cầu hoặc mong muốn của khách hàng.",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Để form lên được một product đó là câu chuyện của việc “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Để form lên được một product đó là câu chuyện của việc “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "tạo được một thứ gì đó",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "tạo được một thứ gì đó",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "” dùng để trao đổi “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” dùng để trao đổi “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "giá trị",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "giá trị",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "” với “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” với “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "khách hàng.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "khách hàng.",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "” ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "5506511b-1860-4254-8834-80cf734f742f",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-21T02:16:00.000Z",
        "last_edited_time": "2024-10-21T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một thứ gì đó có thể là:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một thứ gì đó có thể là:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1245d164-78d8-8022-9af9-d31b57fc99c5",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-19T06:31:00.000Z",
        "last_edited_time": "2024-10-19T06:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hữu hình (physical product): sản phẩm vật lý như quần áo, điện thoại, thực phẩm, xe cộ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hữu hình (physical product): sản phẩm vật lý như quần áo, điện thoại, thực phẩm, xe cộ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1245d164-78d8-80c8-81bc-c7a7c7c95b21",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-19T06:31:00.000Z",
        "last_edited_time": "2024-12-21T10:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vô hình: dịch vụ hoặc trải nghiệm, chẳng hạn như phần mềm, gói bảo hiểm, dịch vụ tư vấn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vô hình: dịch vụ hoặc trải nghiệm, chẳng hạn như phần mềm, gói bảo hiểm, dịch vụ tư vấn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "5c4d857a-1245-4cb8-8ba7-5214e3aba0a2",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-12-21T10:26:00.000Z",
        "last_edited_time": "2024-12-21T10:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "P/s: có thể tìm hiểu thêm sự khác biệt giữa ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "P/s: có thể tìm hiểu thêm sự khác biệt giữa ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "digital vs physical product.",
                "link": {
                  "url": "/c066dc23043d44af925d1f71f899090a"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "digital vs physical product.",
              "href": "/c066dc23043d44af925d1f71f899090a"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-800f-a35a-f7effa5bfd73",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2025-01-14T11:15:00.000Z",
        "last_edited_time": "2025-01-14T11:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1245d164-78d8-807c-a32a-e861e3ccda91",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-19T06:38:00.000Z",
        "last_edited_time": "2025-01-01T00:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Và giá trị có thể là:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Và giá trị có thể là:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1245d164-78d8-80c4-a0e6-c8262867ce4a",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-19T06:41:00.000Z",
        "last_edited_time": "2024-10-19T06:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giúp việc gì đó trở nên khả thi (máy chụp ảnh giúp bạn lưu giữ được kỉ niệm)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giúp việc gì đó trở nên khả thi (máy chụp ảnh giúp bạn lưu giữ được kỉ niệm)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1245d164-78d8-80d7-bd70-f8ee226f74de",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-19T06:42:00.000Z",
        "last_edited_time": "2024-10-19T06:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giúp việc gì đó trở nên dễ hơn (grab giúp bạn không cần đi đâu để mua đồ ăn)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giúp việc gì đó trở nên dễ hơn (grab giúp bạn không cần đi đâu để mua đồ ăn)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1245d164-78d8-80e5-bafb-d9d34e594206",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-19T06:41:00.000Z",
        "last_edited_time": "2025-01-01T00:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giải quyết một nỗi đau hay mong muốn gì đó (ghế văn phòng để ngồi đỡ đau lưng, facebook giúp bạn kết nối & thể hiện bản thân)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giải quyết một nỗi đau hay mong muốn gì đó (ghế văn phòng để ngồi đỡ đau lưng, facebook giúp bạn kết nối & thể hiện bản thân)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-8055-a317-ea0b660626dc",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2025-01-14T11:15:00.000Z",
        "last_edited_time": "2025-01-14T11:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1635d164-78d8-80fa-a3e0-e43e38ba1d35",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-12-21T02:04:00.000Z",
        "last_edited_time": "2025-01-01T00:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Product thực chất được dùng để trao đổi giá trị, nó nên trả lời cụ thể được câu hỏi: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product thực chất được dùng để trao đổi giá trị, nó nên trả lời cụ thể được câu hỏi: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cho ai & được gì?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cho ai & được gì?",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", kèm theo đó product cần tồn tại trên thị trường nên cần phải nhắc đến ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", kèm theo đó product cần tồn tại trên thị trường nên cần phải nhắc đến ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "yếu tố cạnh tranh",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "yếu tố cạnh tranh",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " nên cần xác định được advantage, value proposition, product market fit.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " nên cần xác định được advantage, value proposition, product market fit.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "59db13e2-a05c-4b84-8d2b-e47b2143d023",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-11-02T13:34:00.000Z",
        "last_edited_time": "2024-12-21T02:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081456/uxcomic-imgs/59db13e2-a05c-4b84-8d2b-e47b2143d023.jpg",
            "expiry_time": "2026-10-04T09:11:54.847Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/59db13e2-a05c-4b84-8d2b-e47b2143d023"
      },
      {
        "object": "block",
        "id": "f57482d3-16b3-4a5a-a044-700c2cb66187",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-19T06:08:00.000Z",
        "last_edited_time": "2024-11-12T02:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "cb060d25-2650-420e-b172-884937b0d3b8",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-19T06:08:00.000Z",
        "last_edited_time": "2024-11-12T02:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Use case",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Use case",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1635d164-78d8-807a-9f32-de7fa8f47f7c",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-12-21T09:30:00.000Z",
        "last_edited_time": "2025-01-02T11:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ok ta hiểu được sơ sơ product đại diện cho giá trị ta trao cho khách hàng, giá trị đó xảy ra khi product được user sử dụng trong các tình huống thực tế.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ok ta hiểu được sơ sơ product đại diện cho giá trị ta trao cho khách hàng, giá trị đó xảy ra khi product được user sử dụng trong các tình huống thực tế.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-80d5-a7f7-e9d5861384a2",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T04:44:00.000Z",
        "last_edited_time": "2025-01-02T11:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lấy ví dụ, mình dùng grab food để đặt đồ ăn, những sẽ có vài tình huống sử dụng khác nhau như:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lấy ví dụ, mình dùng grab food để đặt đồ ăn, những sẽ có vài tình huống sử dụng khác nhau như:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16f5d164-78d8-80b1-8308-f450916ac4c3",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2025-01-02T11:51:00.000Z",
        "last_edited_time": "2025-01-02T11:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình ở nhà & lười nấu cơm nên đặt đồ ăn ship đến.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình ở nhà & lười nấu cơm nên đặt đồ ăn ship đến.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16f5d164-78d8-80f9-8aa1-fca292f3fe1d",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2025-01-02T11:51:00.000Z",
        "last_edited_time": "2025-01-02T11:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình ở văn phòng & muốn đặt đồ ăn trưa cùng team.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình ở văn phòng & muốn đặt đồ ăn trưa cùng team.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16f5d164-78d8-80f0-9e3d-c8249faed045",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2025-01-02T11:51:00.000Z",
        "last_edited_time": "2025-01-02T11:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình muốn đặt đồ ăn giao cho người yêu.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình muốn đặt đồ ăn giao cho người yêu.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8049-b5f5-d19f79ece4ab",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T04:57:00.000Z",
        "last_edited_time": "2025-01-02T11:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "3 tình huống này đều là nhu cầu sử dụng của user nhưng ở các ngữ cảnh khác nhau, khiến Grab phải cân nhắc xem đâu là cơ hội tốt khi thông qua bài toán phục vụ cho user, biến nó thành cơ hội để mang lại benefit cho công ty.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3 tình huống này đều là nhu cầu sử dụng của user nhưng ở các ngữ cảnh khác nhau, khiến Grab phải cân nhắc xem đâu là cơ hội tốt khi thông qua bài toán phục vụ cho user, biến nó thành cơ hội để mang lại benefit cho công ty.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "872e0425-838f-4e7f-858b-dd6c24ec155f",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-19T06:08:00.000Z",
        "last_edited_time": "2025-01-01T12:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khái niệm này ta sẽ gọi nó là use case - use case mô tả cách một sản phẩm, dịch vụ hoặc giải pháp có thể ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khái niệm này ta sẽ gọi nó là use case - use case mô tả cách một sản phẩm, dịch vụ hoặc giải pháp có thể ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "được áp dụng vào các tình huống thực tế ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "được áp dụng vào các tình huống thực tế ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "để giải quyết vấn đề hoặc mang lại giá trị cho khách hàng & doanh nghiệp.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "để giải quyết vấn đề hoặc mang lại giá trị cho khách hàng & doanh nghiệp.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-802e-b67e-c770ddcfad8a",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T05:11:00.000Z",
        "last_edited_time": "2024-11-12T02:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "dc55c499-71f8-41ff-a78d-7a0fc504c4e6",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T05:11:00.000Z",
        "last_edited_time": "2024-11-12T02:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Feature",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Feature",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8085-9604-d6ad5c52273d",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T05:06:00.000Z",
        "last_edited_time": "2025-01-01T00:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đi sau use case đó sẽ là feature. Feature là một ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đi sau use case đó sẽ là feature. Feature là một ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "khả năng cụ thể",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "khả năng cụ thể",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " của sản phẩm hoặc dịch vụ, feature có thể được thiết kế để phục vụ cho một hoặc nhiều use case.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " của sản phẩm hoặc dịch vụ, feature có thể được thiết kế để phục vụ cho một hoặc nhiều use case.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-80b2-a699-cf1f921e51b7",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T05:10:00.000Z",
        "last_edited_time": "2025-01-01T12:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: cho tình huống đặt đồ ăn cho team, nhầm tạo giải pháp thuận tiện hơn, grab đã sinh ra feature “đặt đơn nhóm” - cho phép user tạo một đường link và chia sẻ đến mọi người, để họ có thể vào app Grab và đặt trên điện thoại của họ, thay vì trước đó cần có một “chủ xị” phải đi đến từng người để hỏi & thao tác đặt hàng dùm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: cho tình huống đặt đồ ăn cho team, nhầm tạo giải pháp thuận tiện hơn, grab đã sinh ra feature “đặt đơn nhóm” - cho phép user tạo một đường link và chia sẻ đến mọi người, để họ có thể vào app Grab và đặt trên điện thoại của họ, thay vì trước đó cần có một “chủ xị” phải đi đến từng người để hỏi & thao tác đặt hàng dùm.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-805f-8629-f41f4cc372f6",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T09:11:00.000Z",
        "last_edited_time": "2024-10-20T14:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "video",
        "video": {
          "caption": [],
          "type": "external",
          "external": {
            "url": "https://www.youtube.com/watch?v=HtU0BkQIp9U&list=PLnlsoKq9KL0G65ncpXcwIWwRHzm6yL57n&index=1"
          }
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1635d164-78d8-80e9-a124-e6f99e4330ff",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-12-21T09:51:00.000Z",
        "last_edited_time": "2024-12-21T09:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-809a-bff2-f1a476073604",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T05:13:00.000Z",
        "last_edited_time": "2024-10-12T05:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hm vậy function khác gì với feature?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hm vậy function khác gì với feature?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8041-9b2c-e23d144d1330",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T04:57:00.000Z",
        "last_edited_time": "2025-01-01T12:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu bạn muốn feature “đặt đơn nhóm” hoạt động được thì phía hệ thống cần làm gì để hiện thực hoá nó?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu bạn muốn feature “đặt đơn nhóm” hoạt động được thì phía hệ thống cần làm gì để hiện thực hoá nó?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-802a-9d6e-d69853985b47",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2025-01-01T12:45:00.000Z",
        "last_edited_time": "2025-01-01T12:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đó là lúc function vào cuộc, nó tập trung nhiều hơn vào ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đó là lúc function vào cuộc, nó tập trung nhiều hơn vào ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cách hệ thống xử lý ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cách hệ thống xử lý ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "để tạo ra kết quả mà feature mong muốn. Ví dụ minh hoạ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "để tạo ra kết quả mà feature mong muốn. Ví dụ minh hoạ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8047-af78-d7ae08e21c36",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T05:17:00.000Z",
        "last_edited_time": "2024-10-12T08:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Feature",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Feature",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Tính năng “đặt đơn nhóm”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Tính năng “đặt đơn nhóm”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8017-8b48-e5215ce00438",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T05:17:00.000Z",
        "last_edited_time": "2024-10-12T08:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các functions liên quan",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các functions liên quan",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ":",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ":",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8071-97f0-d64c3a7ee73e",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T05:18:00.000Z",
        "last_edited_time": "2024-10-12T08:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tạo và chia sẻ đơn đặt hàng nhóm",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tạo và chia sẻ đơn đặt hàng nhóm",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8022-b796-f36b88fb2c06",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T05:18:00.000Z",
        "last_edited_time": "2024-10-12T08:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quản lý quyền truy cập và đóng góp của các thành viên",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quản lý quyền truy cập và đóng góp của các thành viên",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1635d164-78d8-8056-8083-d95f318fd70b",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-12-21T00:20:00.000Z",
        "last_edited_time": "2024-12-21T00:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tính toán tự động",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tính toán tự động",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1635d164-78d8-8092-a50c-e658014bea5f",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-12-21T00:20:00.000Z",
        "last_edited_time": "2024-12-21T00:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thanh toán chung hoặc riêng ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thanh toán chung hoặc riêng ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-808f-a5db-c03a3ecc21fd",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T05:18:00.000Z",
        "last_edited_time": "2024-12-21T00:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Theo dõi trạng thái đơn hàng",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Theo dõi trạng thái đơn hàng",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-80a6-8336-ee036a5d06d1",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T05:18:00.000Z",
        "last_edited_time": "2024-10-19T06:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chia bill,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chia bill,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1635d164-78d8-8055-b2b4-cf47300fa4b9",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-12-21T09:51:00.000Z",
        "last_edited_time": "2024-12-21T09:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-80a8-aa96-daf2dabbe794",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T06:56:00.000Z",
        "last_edited_time": "2025-01-01T00:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Công nghệ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Công nghệ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1635d164-78d8-80d8-a0ee-e5af18077c50",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-12-21T09:51:00.000Z",
        "last_edited_time": "2025-01-01T00:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình đang làm cho công ty công nghệ mà, nó là gì? ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình đang làm cho công ty công nghệ mà, nó là gì? ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-809a-8206-e915a251579e",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2025-01-01T00:37:00.000Z",
        "last_edited_time": "2025-01-01T12:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có thể hiểu đơn giản công nghệ là “nguyên vật liệu” để xây nên function.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có thể hiểu đơn giản công nghệ là “nguyên vật liệu” để xây nên function.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-80b7-9e1a-d49956b39fb7",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T06:56:00.000Z",
        "last_edited_time": "2025-01-01T12:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình cũng không rành lắm đâu :D, nhưng đại khái có thể hình dung: để có thể sản xuất được chiếc xe thì cần phải có kim loại, máy móc, công nghệ đúc ép khuôn, các định luật vật lý, hoá học, công thái học.. thì bên digital product sẽ cần: Software Infrastructure, Data Infrastructure, Cloud, Sever, Security, API,… đây chính là công nghệ - là những nguyên vật liệu để build nên function cho một product.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình cũng không rành lắm đâu :D, nhưng đại khái có thể hình dung: để có thể sản xuất được chiếc xe thì cần phải có kim loại, máy móc, công nghệ đúc ép khuôn, các định luật vật lý, hoá học, công thái học.. thì bên digital product sẽ cần: Software Infrastructure, Data Infrastructure, Cloud, Sever, Security, API,… đây chính là công nghệ - là những nguyên vật liệu để build nên function cho một product.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8018-9f67-dedc0acffd78",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T08:29:00.000Z",
        "last_edited_time": "2024-10-12T09:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-80a5-8a31-edae319c87d5",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T08:29:00.000Z",
        "last_edited_time": "2024-12-21T00:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Wrap up",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Wrap up",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-802f-9c0e-e3964f2a97ed",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T08:29:00.000Z",
        "last_edited_time": "2025-01-01T00:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tóm lại product sẽ đưa những khả năng của technology để áp dụng vào thực tế cuộc sống, giúp giải quyết vấn đề hoặc nhu cầu gì đó của con người thông qua các feature, và các feature hoạt động được dựa trên những function nhất định, function hoạt động dựa trên công nghệ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tóm lại product sẽ đưa những khả năng của technology để áp dụng vào thực tế cuộc sống, giúp giải quyết vấn đề hoặc nhu cầu gì đó của con người thông qua các feature, và các feature hoạt động được dựa trên những function nhất định, function hoạt động dựa trên công nghệ.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1635d164-78d8-8095-82db-cad33cb0a7e3",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-12-21T00:56:00.000Z",
        "last_edited_time": "2025-01-06T02:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "1625d164-78d8-8043-ae57-de87c70d5f6f",
            "parent": {
              "type": "block_id",
              "block_id": "1635d164-78d8-8095-82db-cad33cb0a7e3"
            },
            "created_time": "2024-12-20T15:03:00.000Z",
            "last_edited_time": "2024-12-21T00:56:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Value dẫn dắt Benefit.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Value dẫn dắt Benefit.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 0
          },
          {
            "object": "block",
            "id": "1635d164-78d8-803a-8923-c5b99cd32485",
            "parent": {
              "type": "block_id",
              "block_id": "1635d164-78d8-8095-82db-cad33cb0a7e3"
            },
            "created_time": "2024-12-21T00:56:00.000Z",
            "last_edited_time": "2024-12-21T00:56:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Benefit lựa chọn Use case nào để giải quyết.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Benefit lựa chọn Use case nào để giải quyết.",
                  "href": null
                }
              ],
              "color": "default",
              "list_start_index": 2
            },
            "archived": false,
            "index": 1
          },
          {
            "object": "block",
            "id": "1635d164-78d8-806a-866c-c3d5f92da6a2",
            "parent": {
              "type": "block_id",
              "block_id": "1635d164-78d8-8095-82db-cad33cb0a7e3"
            },
            "created_time": "2024-12-21T00:56:00.000Z",
            "last_edited_time": "2024-12-21T10:37:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Use case định hình feature.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Use case định hình feature.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 2
          },
          {
            "object": "block",
            "id": "df043a7e-6310-4b5e-ab94-8c486d6679a2",
            "parent": {
              "type": "block_id",
              "block_id": "1635d164-78d8-8095-82db-cad33cb0a7e3"
            },
            "created_time": "2024-12-21T10:37:00.000Z",
            "last_edited_time": "2024-12-21T10:37:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Feature gồm có những function khác nhau.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Feature gồm có những function khác nhau.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 3
          },
          {
            "object": "block",
            "id": "1735d164-78d8-8081-9980-efbe5bda8f9d",
            "parent": {
              "type": "block_id",
              "block_id": "1635d164-78d8-8095-82db-cad33cb0a7e3"
            },
            "created_time": "2025-01-06T02:29:00.000Z",
            "last_edited_time": "2025-01-06T02:30:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Function dựa trên nền tảng công nghệ",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Function dựa trên nền tảng công nghệ",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 4
          }
        ]
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8008-bb34-cabad8fe60d2",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T08:33:00.000Z",
        "last_edited_time": "2024-12-21T02:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hiểu được tổng quan “Product là gì?” giúp mình có góc nhìn rộng hơn trong product development, để hiểu ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hiểu được tổng quan “Product là gì?” giúp mình có góc nhìn rộng hơn trong product development, để hiểu ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "why we do what we do",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "why we do what we do",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ",",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ",",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "nên ngoài việc mình chỉ quan tâm đến thiết kế tương tác sao cho dễ dùng, UX tốt, giờ mình có thể quan tâm thêm các khía cạnh khác như:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "nên ngoài việc mình chỉ quan tâm đến thiết kế tương tác sao cho dễ dùng, UX tốt, giờ mình có thể quan tâm thêm các khía cạnh khác như:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-80f0-9e2b-da9009a0952a",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T08:57:00.000Z",
        "last_edited_time": "2024-11-02T07:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Feature đó được phục vụ cho use case nào, use case đó đóng góp gì vào product value, vào câu chuyện giữa biz & customer/user?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Feature đó được phục vụ cho use case nào, use case đó đóng góp gì vào product value, vào câu chuyện giữa biz & customer/user?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-809e-9699-f8963bf9f2e5",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T08:57:00.000Z",
        "last_edited_time": "2024-10-20T14:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi design, mình đã biết feature này sẽ gồm các function nào chưa?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi design, mình đã biết feature này sẽ gồm các function nào chưa?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-80ef-bffa-f51e61b50897",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T08:57:00.000Z",
        "last_edited_time": "2024-11-02T07:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các xu hướng công nghệ gần đây có tác động thế nào đến sản phẩm & nhu cầu con người như thế nào?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các xu hướng công nghệ gần đây có tác động thế nào đến sản phẩm & nhu cầu con người như thế nào?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-802d-b473-f40c10d6a11e",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-12-23T17:13:00.000Z",
        "last_edited_time": "2024-12-23T17:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-803b-991e-eae86754e81f",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-12-23T17:14:00.000Z",
        "last_edited_time": "2024-12-23T17:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bonus",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bonus",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8000-a233-cb702ca5029c",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-12-23T17:14:00.000Z",
        "last_edited_time": "2024-12-23T17:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các thứ ở trên là góc nhìn của mình as a UX/UI designer. Vậy góc nhìn của PM thì ra sao?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các thứ ở trên là góc nhìn của mình as a UX/UI designer. Vậy góc nhìn của PM thì ra sao?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-801e-aebe-f2e0479143b7",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-12-23T17:14:00.000Z",
        "last_edited_time": "2024-12-23T17:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "video",
        "video": {
          "caption": [],
          "type": "external",
          "external": {
            "url": "https://www.youtube.com/watch?v=PLbruw0Sovw&list=WL&index=51"
          }
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-800b-9676-c8c1abc94882",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T09:33:00.000Z",
        "last_edited_time": "2024-10-12T09:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "12d5d164-78d8-8091-8c0c-dd2b9c761dd5",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-28T06:20:00.000Z",
        "last_edited_time": "2024-12-21T00:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1635d164-78d8-807e-a757-fa3d816e1c99",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-12-21T09:41:00.000Z",
        "last_edited_time": "2024-12-21T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.forbes.com/councils/theyec/2023/06/02/define-your-product-use-case-in-five-steps/",
                "link": {
                  "url": "https://www.forbes.com/councils/theyec/2023/06/02/define-your-product-use-case-in-five-steps/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.forbes.com/councils/theyec/2023/06/02/define-your-product-use-case-in-five-steps/",
              "href": "https://www.forbes.com/councils/theyec/2023/06/02/define-your-product-use-case-in-five-steps/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12d5d164-78d8-8009-9d4b-eefa96ab2621",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-28T06:20:00.000Z",
        "last_edited_time": "2024-10-28T06:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.tannerchristensen.com/notes/design-requires-a-product-narrative",
                "link": {
                  "url": "https://www.tannerchristensen.com/notes/design-requires-a-product-narrative"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.tannerchristensen.com/notes/design-requires-a-product-narrative",
              "href": "https://www.tannerchristensen.com/notes/design-requires-a-product-narrative"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1325d164-78d8-8059-9f0d-f645aa725540",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-11-02T04:46:00.000Z",
        "last_edited_time": "2024-11-02T04:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.youtube.com/watch?v=kMLgug3GrkU&t=449s",
                "link": {
                  "url": "https://www.youtube.com/watch?v=kMLgug3GrkU&t=449s"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.youtube.com/watch?v=kMLgug3GrkU&t=449s",
              "href": "https://www.youtube.com/watch?v=kMLgug3GrkU&t=449s"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "26b5d164-78d8-8091-9491-f224b3c39668",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2025-09-11T06:06:00.000Z",
        "last_edited_time": "2025-09-11T06:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://steveblank.com/2009/08/27/the-leading-cause-of-startup-death-the-product-development-diagram/",
                "link": {
                  "url": "https://steveblank.com/2009/08/27/the-leading-cause-of-startup-death-the-product-development-diagram/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://steveblank.com/2009/08/27/the-leading-cause-of-startup-death-the-product-development-diagram/",
              "href": "https://steveblank.com/2009/08/27/the-leading-cause-of-startup-death-the-product-development-diagram/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12d5d164-78d8-8068-806a-f1bb40df506f",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-28T06:20:00.000Z",
        "last_edited_time": "2024-10-28T06:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8082-bed7-f2f04940a82f",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T09:21:00.000Z",
        "last_edited_time": "2024-12-21T00:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1625d164-78d8-80b9-80b6-cd2ac2d6a730",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-12-20T14:53:00.000Z",
        "last_edited_time": "2024-12-20T14:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1605d164-78d8-80ad-9130-fe44c6663146"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Value vs Benefit",
              "href": "https://app.notion.com/p/1605d16478d880ad9130fe44c6663146"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1635d164-78d8-80ef-9b94-ff2fd6a16e7b",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-12-21T02:20:00.000Z",
        "last_edited_time": "2024-12-21T02:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1445d164-78d8-805b-b388-e24b5f13cccb"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product development process (overall)",
              "href": "https://app.notion.com/p/1445d16478d8805bb388e24b5f13cccb"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8090-849e-d0bb0c80be78",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T09:21:00.000Z",
        "last_edited_time": "2024-10-12T09:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cái ghế & Product",
              "href": "https://app.notion.com/p/10f5d16478d8809abbf5ec2e471cf60e"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-80dd-95a5-d59240b8c60a",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T09:21:00.000Z",
        "last_edited_time": "2024-10-12T09:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "c066dc23-043d-44af-925d-1f71f899090a"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Digital vs Physical product",
              "href": "https://app.notion.com/p/c066dc23043d44af925d1f71f899090a"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-80ea-9443-dd7bd58499c2",
        "parent": {
          "type": "page_id",
          "page_id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
        },
        "created_time": "2024-10-12T09:33:00.000Z",
        "last_edited_time": "2024-10-12T09:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "f27ddffd-7a16-46eb-9e41-c71d27945645",
    "created_time": "2024-10-07T05:13:00.000Z",
    "last_edited_time": "2025-01-16T12:30:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "fd3cd36d-73dd-4dee-8bd5-d159d6600124"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "View": {
        "id": "ATSa",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "A%5Bqc",
        "type": "select",
        "select": {
          "id": "QNIE",
          "name": "⚓:3",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "DMgm",
        "type": "last_edited_time",
        "last_edited_time": "2025-01-16T12:30:00.000Z"
      },
      "Publish": {
        "id": "FSnx",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "_tsp",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "g%7BBg",
        "type": "created_time",
        "created_time": "2024-10-07T05:13:00.000Z"
      },
      "Share": {
        "id": "hp~_",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "m%7C%40x",
        "type": "number",
        "number": null
      },
      "Formula": {
        "id": "re%3BE",
        "type": "formula",
        "formula": {
          "type": "number",
          "number": 1
        }
      },
      "Tag": {
        "id": "%7CAvQ",
        "type": "select",
        "select": {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "3-Design",
          "color": "default"
        }
      },
      "ID": {
        "id": "~RYT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FD",
          "number": 15
        }
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Why people said “Good design is invisible”?",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Why people said “Good design is invisible”?",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Why-people-said-Good-design-is-invisible-f27ddffd7a1646eb9e41c71d27945645",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "5cacdbff-b9e2-4973-b565-ec1ae4327ec9",
      "name": "Fundamental",
      "slug": "fundamental",
      "icon": "🌞",
      "order": 2,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "Product",
          "slug": "product",
          "order": 1
        },
        {
          "id": "156ef770-14db-4170-b1d7-95a2fbdf62ba",
          "name": "User",
          "slug": "user",
          "order": 2
        },
        {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "Design",
          "slug": "design",
          "order": 3
        },
        {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "Random",
          "slug": "random",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
      "name": "Design",
      "slug": "design",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "1185d164-78d8-8142-9112-e7cfeefe6de7",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2024-10-07T05:13:00.000Z",
        "last_edited_time": "2025-01-06T16:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081461/uxcomic-imgs/1185d164-78d8-8142-9112-e7cfeefe6de7.png",
            "expiry_time": "2026-10-04T09:11:55.840Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1185d164-78d8-8142-9112-e7cfeefe6de7"
      },
      {
        "object": "block",
        "id": "1185d164-78d8-818d-a98b-f070d123e901",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2024-10-07T05:13:00.000Z",
        "last_edited_time": "2025-01-05T11:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có ai đã nghe qua câu: “nếu một thiết kế tốt, thì nó gần như trở nên vô hình” chưa nhỉ?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có ai đã nghe qua câu: “nếu một thiết kế tốt, thì nó gần như trở nên vô hình” chưa nhỉ?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1725d164-78d8-80dc-9328-fc973e024c40",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-05T11:22:00.000Z",
        "last_edited_time": "2025-01-05T11:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình đã nghe được câu này vài năm trước, nó khơi lên một mình sự tò mò thú vị về một góc nhìn mới trong thiết kế, vì mình thấy nó mâu thuẫn, design không phải lên làm nó lung linh, lộng lẫy, thu hút người xem hay sao mà lại nói tốt có nghĩa là vô hình.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình đã nghe được câu này vài năm trước, nó khơi lên một mình sự tò mò thú vị về một góc nhìn mới trong thiết kế, vì mình thấy nó mâu thuẫn, design không phải lên làm nó lung linh, lộng lẫy, thu hút người xem hay sao mà lại nói tốt có nghĩa là vô hình.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1725d164-78d8-80cf-a008-d0c02ab63909",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-05T11:23:00.000Z",
        "last_edited_time": "2025-01-07T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhưng qua vài năm làm UX, thực hiện vài buổi testing, hiểu về mental model, interaction cost, mình mới bắt đầu rơi vào Aha moment, hòm hòm thấm được ý nghĩa của câu đó nói về việc gì.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhưng qua vài năm làm UX, thực hiện vài buổi testing, hiểu về mental model, interaction cost, mình mới bắt đầu rơi vào Aha moment, hòm hòm thấm được ý nghĩa của câu đó nói về việc gì.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1725d164-78d8-80ff-aad9-e585f0284ebb",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-05T11:25:00.000Z",
        "last_edited_time": "2025-01-05T11:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nên hôm nay cùng mình đào sâu thêm nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nên hôm nay cùng mình đào sâu thêm nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-81f4-b364-e07b7313c785",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2024-10-07T05:13:00.000Z",
        "last_edited_time": "2024-10-07T05:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Good design = Invisible? Why? Does it make sense?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Good design = Invisible? Why? Does it make sense?",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1725d164-78d8-8053-b6d6-c73d880ec22c",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-05T11:25:00.000Z",
        "last_edited_time": "2025-01-05T11:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-81ef-936a-c6389cab2836",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2024-10-07T05:13:00.000Z",
        "last_edited_time": "2025-01-11T11:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vô hình?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vô hình?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-80ee-b32b-f703357ca6a8",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T04:18:00.000Z",
        "last_edited_time": "2025-01-12T04:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "User sử dụng product để get được một benefit gì đó, từ đó họ thấy nó đóng góp vào một giá trị gì đó vào cuộc sống của họ. Ví dụ: mình dùng messenger để chat, chat là để kết nối, để có cảm giác thuộc về một cộng đồng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User sử dụng product để get được một benefit gì đó, từ đó họ thấy nó đóng góp vào một giá trị gì đó vào cuộc sống của họ. Ví dụ: mình dùng messenger để chat, chat là để kết nối, để có cảm giác thuộc về một cộng đồng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-8024-b0dc-d9614c59f675",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T04:53:00.000Z",
        "last_edited_time": "2025-01-13T10:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhưng trước khi họ get được benefit, user cần còn dùng product, cần dùng các feature (feature là các khả năng mà product offer để giúp user đạt được nhu cầu gì đó), “dùng” - hay nói cách khác là tương tác, mà tương tác thì dù ít hay nhiều họ cũng phải học, phải tốn sức (interaction cost). Và nhiệm vụ của design là hạn chế đi các công sức này.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhưng trước khi họ get được benefit, user cần còn dùng product, cần dùng các feature (feature là các khả năng mà product offer để giúp user đạt được nhu cầu gì đó), “dùng” - hay nói cách khác là tương tác, mà tương tác thì dù ít hay nhiều họ cũng phải học, phải tốn sức (interaction cost). Và nhiệm vụ của design là hạn chế đi các công sức này.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-8039-8daf-dfa6d604f2da",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T05:34:00.000Z",
        "last_edited_time": "2025-01-12T05:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> ý nghĩa của từ “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> ý nghĩa của từ “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "vô hình",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "vô hình",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "” trong câu nói ấy có nghĩa là thiết kế nên “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” trong câu nói ấy có nghĩa là thiết kế nên “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "trực quan",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "trực quan",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-80f1-8b4f-ff7a3a49ce52",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T05:39:00.000Z",
        "last_edited_time": "2025-01-12T05:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> hạn chế ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> hạn chế ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "interaction cost",
                "link": {
                  "url": "/1195d16478d881308d61fe6e1619967b"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "interaction cost",
              "href": "/1195d16478d881308d61fe6e1619967b"
            },
            {
              "type": "text",
              "text": {
                "content": " (physical,  cognitive, emotional, temporal cost)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (physical,  cognitive, emotional, temporal cost)",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-8083-aa51-c6bd226cfe0e",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T05:39:00.000Z",
        "last_edited_time": "2025-01-12T05:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> user có thể dùng nó một cách dễ dàng, êm ái nhẹ nhàng như một hơi thở ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> user có thể dùng nó một cách dễ dàng, êm ái nhẹ nhàng như một hơi thở ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-80e9-a9db-f07957d515cd",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T05:39:00.000Z",
        "last_edited_time": "2025-01-12T05:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> khiến rào cản giữa user & benefit trở nên vô hình.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> khiến rào cản giữa user & benefit trở nên vô hình.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-81ba-a7d1-c7782d49c448",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2024-10-07T05:13:00.000Z",
        "last_edited_time": "2025-01-12T05:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Keep in mind. User dùng product chúng ta ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Keep in mind. User dùng product chúng ta ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "để phục vụ cho một nhu cầu, để get value",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "để phục vụ cho một nhu cầu, để get value",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " chứ không phải để dùng feature, feature chỉ là trung gian tạm thời thôi.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " chứ không phải để dùng feature, feature chỉ là trung gian tạm thời thôi.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1725d164-78d8-8022-ac80-f4490903fe3d",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-05T12:26:00.000Z",
        "last_edited_time": "2025-01-12T05:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“People don’t want to buy a quarter-inch drill. They want a quarter-inch hole!”",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“People don’t want to buy a quarter-inch drill. They want a quarter-inch hole!”",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " — Theodore Levitt",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " — Theodore Levitt",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1725d164-78d8-800f-ab6b-ccd7bd15922c",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-05T11:38:00.000Z",
        "last_edited_time": "2025-01-05T11:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-8136-8c19-f125da9962d6",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2024-10-07T05:13:00.000Z",
        "last_edited_time": "2025-01-11T11:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1725d164-78d8-801e-8de5-df77ca2186d6",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-05T11:43:00.000Z",
        "last_edited_time": "2025-01-11T14:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để tạo ra một banner đẹp để thu hút người xem quan tâm đến một event, ta có thể học photoshop để design banner đó, nhưng học & dùng được photoshop không hề dễ, một là mình sẽ bỏ time & effort để học cách dùng nó, 2 là bỏ tiền để thuê một bạn graphic designer giúp mình design 🤔.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để tạo ra một banner đẹp để thu hút người xem quan tâm đến một event, ta có thể học photoshop để design banner đó, nhưng học & dùng được photoshop không hề dễ, một là mình sẽ bỏ time & effort để học cách dùng nó, 2 là bỏ tiền để thuê một bạn graphic designer giúp mình design 🤔.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-80e0-be83-e3afdb11c23b",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T08:59:00.000Z",
        "last_edited_time": "2025-01-12T08:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1725d164-78d8-8014-a2d6-dee3a52b767e",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-05T11:43:00.000Z",
        "last_edited_time": "2025-01-13T10:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhưng giờ đây, đã có công cụ Canva giúp việc design một banner trở nên đơn giản hơn nhiều, với thiết kế trực quan & template đa dạng khiến một người không biết về design cũng có thể có trong tay một banner đẹp đẽ mà ít tốn công sức hơn rất nhiều. (😘 Ít công sức, lại không phải mất nhiều tiền).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhưng giờ đây, đã có công cụ Canva giúp việc design một banner trở nên đơn giản hơn nhiều, với thiết kế trực quan & template đa dạng khiến một người không biết về design cũng có thể có trong tay một banner đẹp đẽ mà ít tốn công sức hơn rất nhiều. (😘 Ít công sức, lại không phải mất nhiều tiền).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-80a9-9aed-f54921e04a46",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T08:59:00.000Z",
        "last_edited_time": "2025-01-12T08:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1725d164-78d8-8016-8efd-eb1f71b284d4",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-05T11:44:00.000Z",
        "last_edited_time": "2025-01-11T14:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tiếp đến, thời đại của AI, mình chỉ cần gõ, miêu tả mong muốn banner ra sao thì AI có thể giúp bạn có nó ngay chỉ trong vài phút. Việc lúc này chỉ cần làm rõ ý muốn trong đầu và học cách gõ prompt (thậm chí vài các nền tảng cung cấp luôn template > không cần học prompt > 🤪 chia 4, chia 5 công sức luôn, sướng).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tiếp đến, thời đại của AI, mình chỉ cần gõ, miêu tả mong muốn banner ra sao thì AI có thể giúp bạn có nó ngay chỉ trong vài phút. Việc lúc này chỉ cần làm rõ ý muốn trong đầu và học cách gõ prompt (thậm chí vài các nền tảng cung cấp luôn template > không cần học prompt > 🤪 chia 4, chia 5 công sức luôn, sướng).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1745d164-78d8-806d-929a-f5a5f89cca56",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-07T02:09:00.000Z",
        "last_edited_time": "2025-01-07T02:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081463/uxcomic-imgs/1745d164-78d8-806d-929a-f5a5f89cca56.png",
            "expiry_time": "2026-10-04T09:11:55.840Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1745d164-78d8-806d-929a-f5a5f89cca56"
      },
      {
        "object": "block",
        "id": "1795d164-78d8-8076-9144-e99ebe302441",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T09:00:00.000Z",
        "last_edited_time": "2025-01-12T09:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1785d164-78d8-802a-aef4-c0757eadeb55",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-11T11:38:00.000Z",
        "last_edited_time": "2025-01-13T10:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Product nào miễn chúng giúp user nhanh có được thứ mình muốn mà ít tốn resource / effort hơn thì họ sẽ ưa chuộng, bởi vì đối với họ feature, cách dùng feature… chỉ là những thứ họ phải làm để đến được đích.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product nào miễn chúng giúp user nhanh có được thứ mình muốn mà ít tốn resource / effort hơn thì họ sẽ ưa chuộng, bởi vì đối với họ feature, cách dùng feature… chỉ là những thứ họ phải làm để đến được đích.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1785d164-78d8-8069-88ea-c85f2cff96b9",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-11T11:39:00.000Z",
        "last_edited_time": "2025-01-11T11:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1785d164-78d8-80b0-a0a1-e28b762ef145",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-11T12:10:00.000Z",
        "last_edited_time": "2025-01-11T12:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "What if?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "What if?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1785d164-78d8-8077-9549-eb3540eae5f9",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-11T12:10:00.000Z",
        "last_edited_time": "2025-01-12T09:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một hôm có app tự giúp bạn đặt cuốc xe với giá rẻ nhất, mà không cần bạn áp mã giảm & so sánh giữa Grab, Xanh, Be…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một hôm có app tự giúp bạn đặt cuốc xe với giá rẻ nhất, mà không cần bạn áp mã giảm & so sánh giữa Grab, Xanh, Be…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1785d164-78d8-801e-b514-db662bbc51d8",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-11T12:12:00.000Z",
        "last_edited_time": "2025-01-11T12:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một ngày nào đó bạn design web chỉ cần 1 version laptop, AI tự giúp bạn responsive design sang tablet & mobile (Wix có rồi nè).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một ngày nào đó bạn design web chỉ cần 1 version laptop, AI tự giúp bạn responsive design sang tablet & mobile (Wix có rồi nè).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1785d164-78d8-8004-a879-e69ce1cd3e1d",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-11T12:11:00.000Z",
        "last_edited_time": "2025-01-13T10:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ngày nào đó bạn chỉ cần lia camera vào thứ gì đó & hỏi, điện thoại sẽ cho bạn biết nó là gì, hệt như cái cách bạn sẽ hỏi một người bạn (",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ngày nào đó bạn chỉ cần lia camera vào thứ gì đó & hỏi, điện thoại sẽ cho bạn biết nó là gì, hệt như cái cách bạn sẽ hỏi một người bạn (",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Google AI demo",
                "link": {
                  "url": "https://youtu.be/nXVvvRhiGjI?si=JqMEX8V-PXolerLW"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Google AI demo",
              "href": "https://youtu.be/nXVvvRhiGjI?si=JqMEX8V-PXolerLW"
            },
            {
              "type": "text",
              "text": {
                "content": ").",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ").",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-8061-9db2-f3d1518b7a99",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T05:59:00.000Z",
        "last_edited_time": "2025-01-12T09:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bạn có dùng? Tại sao?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bạn có dùng? Tại sao?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1785d164-78d8-80fb-8032-cc272a5bb231",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-11T14:24:00.000Z",
        "last_edited_time": "2025-01-11T14:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1725d164-78d8-80cc-9703-e1788141216b",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-05T11:51:00.000Z",
        "last_edited_time": "2025-01-11T14:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "So what?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "So what?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-806f-882b-f92ef91fae96",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T09:04:00.000Z",
        "last_edited_time": "2025-01-13T10:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy rốt cuộc thì tôi - UX/UI designer thì biết cái “vô hình” này để làm gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy rốt cuộc thì tôi - UX/UI designer thì biết cái “vô hình” này để làm gì?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-8063-a6eb-fab1937238ed",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-16T12:28:00.000Z",
        "last_edited_time": "2025-01-16T12:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1785d164-78d8-80af-a937-c740b2b22973",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-11T14:27:00.000Z",
        "last_edited_time": "2025-01-16T12:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Việc hiểu thêm về sự “vô hình” này để nhắc nhở bản thân trước khi nhảy ngay vào design, trước khi dành hết suy nghĩ về usability, về IxD, về IA, Flow, về UI, motion các thứ…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Việc hiểu thêm về sự “vô hình” này để nhắc nhở bản thân trước khi nhảy ngay vào design, trước khi dành hết suy nghĩ về usability, về IxD, về IA, Flow, về UI, motion các thứ…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-80db-953f-f5c116d9bbcf",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-16T12:28:00.000Z",
        "last_edited_time": "2025-01-16T12:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1785d164-78d8-80ff-8a1c-fd7852941eb5",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-11T14:04:00.000Z",
        "last_edited_time": "2025-01-12T05:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hãy dừng lại một chút xem…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hãy dừng lại một chút xem…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1785d164-78d8-809f-b2b0-c6660d1bd2aa",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-11T14:04:00.000Z",
        "last_edited_time": "2025-01-13T10:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình đã nắm rõ & đúng ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình đã nắm rõ & đúng ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "value, benefit của user (aka biz) ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "value, benefit của user (aka biz) ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "ở đây là gì chưa?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "ở đây là gì chưa?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1795d164-78d8-80bf-a3c7-e93427723808",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T06:01:00.000Z",
        "last_edited_time": "2025-01-13T10:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình đã để tâm đến user ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình đã để tâm đến user ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "mental model",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "mental model",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1785d164-78d8-80c7-a121-fa1d84db0e46",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-11T14:04:00.000Z",
        "last_edited_time": "2025-01-13T10:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đã đánh giá xem bập bênh giữa ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đã đánh giá xem bập bênh giữa ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "motivation & interaction cost",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "motivation & interaction cost",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", bên nào đang nặng hơn?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", bên nào đang nặng hơn?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "1785d164-78d8-8046-8988-fae57fe888cf",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-11T14:33:00.000Z",
        "last_edited_time": "2025-01-11T14:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081465/uxcomic-imgs/1785d164-78d8-8046-8988-fae57fe888cf.png",
            "expiry_time": "2026-10-04T09:11:55.963Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1785d164-78d8-8046-8988-fae57fe888cf"
      },
      {
        "object": "block",
        "id": "1785d164-78d8-80ce-92f0-d01255a51f2c",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-11T14:28:00.000Z",
        "last_edited_time": "2025-01-11T14:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1745d164-78d8-80f4-81cf-dc122ecb4afc",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-07T01:51:00.000Z",
        "last_edited_time": "2025-01-13T10:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là UX/UI designer, IxD (thiết kế tương tác) sẽ chiếm một phần lớn công việc >> nhiệm vụ của mình là thiết kế làm sao hạn chế tốn “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là UX/UI designer, IxD (thiết kế tương tác) sẽ chiếm một phần lớn công việc >> nhiệm vụ của mình là thiết kế làm sao hạn chế tốn “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "interaction cost",
                "link": {
                  "url": "/1195d16478d881308d61fe6e1619967b"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "interaction cost",
              "href": "/1195d16478d881308d61fe6e1619967b"
            },
            {
              "type": "text",
              "text": {
                "content": "” của user, chẳng hạn như: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” của user, chẳng hạn như: ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1745d164-78d8-80a3-8212-e54660e26644",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-07T01:53:00.000Z",
        "last_edited_time": "2025-01-13T10:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "User không cần phải cố hiểu chuyện gì đang xảy ra.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User không cần phải cố hiểu chuyện gì đang xảy ra.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1745d164-78d8-80a4-b6e8-f9f33d2bf9f1",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-07T01:53:00.000Z",
        "last_edited_time": "2025-01-13T10:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "User không cần phải tìm hiểu xem nên click nút nào.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User không cần phải tìm hiểu xem nên click nút nào.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1785d164-78d8-801d-b10f-ec568334bc49",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-11T13:12:00.000Z",
        "last_edited_time": "2025-01-13T10:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "User không cần phải rướn ngón tay để chạm vào nút.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User không cần phải rướn ngón tay để chạm vào nút.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1745d164-78d8-8003-9f81-fc72d9552855",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-07T01:53:00.000Z",
        "last_edited_time": "2025-01-12T09:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "User không cần phải mày mò xem đã làm đúng hay chưa,… ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User không cần phải mày mò xem đã làm đúng hay chưa,… ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-80bc-9ae9-c9e44681116f",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T09:39:00.000Z",
        "last_edited_time": "2025-01-13T10:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "User lỡ điền form & out ra, khi quay về thì form nên vẫn có sẵn những thông tin đã điền.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User lỡ điền form & out ra, khi quay về thì form nên vẫn có sẵn những thông tin đã điền.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-8085-bc37-d9af3d79767c",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T09:40:00.000Z",
        "last_edited_time": "2025-01-13T10:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bạn đang xem Youtube, bấm dừng, một chút quay lại xem tiếp thì nó tự động quay lại trước đó vài giây để bạn nắm lại câu chuyện đang đến đâu.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bạn đang xem Youtube, bấm dừng, một chút quay lại xem tiếp thì nó tự động quay lại trước đó vài giây để bạn nắm lại câu chuyện đang đến đâu.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-804d-acdd-d14992d76a8e",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T09:08:00.000Z",
        "last_edited_time": "2025-01-13T10:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "4479 thứ khác…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "4479 thứ khác…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-8096-9453-ef0b4e0de31f",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T09:09:00.000Z",
        "last_edited_time": "2025-01-12T09:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1745d164-78d8-8045-8e8a-d417651b748c",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-07T01:54:00.000Z",
        "last_edited_time": "2025-01-13T10:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tất cả tương tác này nên tự nhiên (",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tất cả tương tác này nên tự nhiên (",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "seamless, intuitive",
                "link": {
                  "url": "/1195d16478d8800e93ccd89ca8ed01bc"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "seamless, intuitive",
              "href": "/1195d16478d8800e93ccd89ca8ed01bc"
            },
            {
              "type": "text",
              "text": {
                "content": ") - đồng nghĩa với việc design của bạn đã trở nên “vô hình” - vì họ dùng để làm thứ họ thật sự muốn mà không có chút trở ngại nào, không cần mất nhiều sự tập trung, không tốn thần kinh nơron, mọi thứ tự nhiên như hít một hơi thở, dễ như ăn bánh vậy.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ") - đồng nghĩa với việc design của bạn đã trở nên “vô hình” - vì họ dùng để làm thứ họ thật sự muốn mà không có chút trở ngại nào, không cần mất nhiều sự tập trung, không tốn thần kinh nơron, mọi thứ tự nhiên như hít một hơi thở, dễ như ăn bánh vậy.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1735d164-78d8-8001-87a4-e6248cab3a78",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-06T17:10:00.000Z",
        "last_edited_time": "2025-01-07T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081466/uxcomic-imgs/1735d164-78d8-8001-87a4-e6248cab3a78.jpg",
            "expiry_time": "2026-10-04T09:11:56.090Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1735d164-78d8-8001-87a4-e6248cab3a78"
      },
      {
        "object": "block",
        "id": "1795d164-78d8-8033-ae55-d5f3331a666f",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T05:55:00.000Z",
        "last_edited_time": "2025-01-12T05:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "It’s not just about “usability”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "It’s not just about “usability”",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1725d164-78d8-80fb-a2de-ebe4d6dc5ef9",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-05T12:06:00.000Z",
        "last_edited_time": "2025-01-12T09:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhưng đôi khi nó không dừng lại ở usability, trong interaction cost còn mention đến một khía cạnh khá quan trọng mà có khi mình ít để tâm đến, đó là ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhưng đôi khi nó không dừng lại ở usability, trong interaction cost còn mention đến một khía cạnh khá quan trọng mà có khi mình ít để tâm đến, đó là ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cảm xúc của người dùng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cảm xúc của người dùng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", UX design còn là câu chuyện về product nên thuyết phục & tâm lý ra sao với người dùng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", UX design còn là câu chuyện về product nên thuyết phục & tâm lý ra sao với người dùng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-8064-a296-ca0695651827",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T08:55:00.000Z",
        "last_edited_time": "2025-01-16T12:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "A feature is something users use.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "A feature is something users use.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "6fe9fb7a-9729-42b3-abea-f8c1b7f67800",
            "parent": {
              "type": "block_id",
              "block_id": "1795d164-78d8-8064-a296-ca0695651827"
            },
            "created_time": "2025-01-12T08:55:00.000Z",
            "last_edited_time": "2025-01-12T08:56:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "An experience is something users seamlessly engage with as they accomplish their goals.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "An experience is something users seamlessly engage with as they accomplish their goals.",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "1795d164-78d8-80b1-9e26-f18a12aa9b4e",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T09:11:00.000Z",
        "last_edited_time": "2025-01-12T09:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1735d164-78d8-807c-b4de-cfaf18650e93",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-06T16:53:00.000Z",
        "last_edited_time": "2025-01-12T09:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lấy ví dụ: một landing page đang cố gắng thuyết phục user đăng ký dùng dịch vụ của họ, một landing page tốt sẽ tựa như một cuộn phim - đạo diễn, kịch bản phải có khả năng đi guốc trong bụng user, họ nắm được motivation của họ, hiểu được họ xem trọng value/benefit gì, hiểu rất rõ những pain point user đang gặp phải, hiểu những đắn đo mà họ phải cân nhắc trước khi ra quyết định,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lấy ví dụ: một landing page đang cố gắng thuyết phục user đăng ký dùng dịch vụ của họ, một landing page tốt sẽ tựa như một cuộn phim - đạo diễn, kịch bản phải có khả năng đi guốc trong bụng user, họ nắm được motivation của họ, hiểu được họ xem trọng value/benefit gì, hiểu rất rõ những pain point user đang gặp phải, hiểu những đắn đo mà họ phải cân nhắc trước khi ra quyết định,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1785d164-78d8-800c-82b5-dda4aeb99d3d",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-11T13:15:00.000Z",
        "last_edited_time": "2025-01-13T16:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081467/uxcomic-imgs/1785d164-78d8-800c-82b5-dda4aeb99d3d.png",
            "expiry_time": "2026-10-04T09:11:56.090Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1785d164-78d8-800c-82b5-dda4aeb99d3d"
      },
      {
        "object": "block",
        "id": "1745d164-78d8-806c-9099-c63a579e0165",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-07T01:57:00.000Z",
        "last_edited_time": "2025-01-12T09:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">>> Nếu landing page được thiết kế cover tốt các điểm trên, nó sẽ có khả năng khiến họ hào hứng cũng như xoa dịu nỗi lo của user >> tác động đến quá trình ra quyết định của họ (bạn có thể tham khảo thêm về intention of use, journey map, fogg behavior model).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">>> Nếu landing page được thiết kế cover tốt các điểm trên, nó sẽ có khả năng khiến họ hào hứng cũng như xoa dịu nỗi lo của user >> tác động đến quá trình ra quyết định của họ (bạn có thể tham khảo thêm về intention of use, journey map, fogg behavior model).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-8076-b898-e752e5cbfa49",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-10T11:05:00.000Z",
        "last_edited_time": "2025-01-12T05:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1735d164-78d8-8068-9667-cca6bc3649d9",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-06T16:53:00.000Z",
        "last_edited_time": "2025-01-16T12:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Vô hình” ở đây không phải chỉ về usability, mà còn về việc ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Vô hình” ở đây không phải chỉ về usability, mà còn về việc ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "xoá mờ các rào cản tâm lý, thúc đẩy hoặc hâm nóng những mong muốn, động lực trong họ. ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "xoá mờ các rào cản tâm lý, thúc đẩy hoặc hâm nóng những mong muốn, động lực trong họ. ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Như cái cách mình xem phim & vô tư vui buồn cùng nó, rồi bình luận “phim nay ít sạn”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Như cái cách mình xem phim & vô tư vui buồn cùng nó, rồi bình luận “phim nay ít sạn”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1735d164-78d8-808c-a3fa-fe7e061bd316",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-06T16:58:00.000Z",
        "last_edited_time": "2025-01-12T05:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081469/uxcomic-imgs/1735d164-78d8-808c-a3fa-fe7e061bd316.png",
            "expiry_time": "2026-10-04T09:11:56.090Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1735d164-78d8-808c-a3fa-fe7e061bd316"
      },
      {
        "object": "block",
        "id": "1795d164-78d8-8046-9c73-f463c1f03ffe",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T05:46:00.000Z",
        "last_edited_time": "2025-01-12T05:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1725d164-78d8-803d-861c-c96767aa5cb7",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-05T12:02:00.000Z",
        "last_edited_time": "2025-01-12T05:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy bằng cách nào?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy bằng cách nào?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-80d9-8690-f1146da91af8",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T09:41:00.000Z",
        "last_edited_time": "2025-01-13T11:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Keep in mind, vẻ đẹp của một feature không chỉ dừng lại ở functionality, ở capacity, nó còn về experience. Hãy hình dung feature đó ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Keep in mind, vẻ đẹp của một feature không chỉ dừng lại ở functionality, ở capacity, nó còn về experience. Hãy hình dung feature đó ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "sống như thế nào ",
                "link": {
                  "url": "/1155d16478d880a883a6ec9db47fe4dc"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "sống như thế nào ",
              "href": "/1155d16478d880a883a6ec9db47fe4dc"
            },
            {
              "type": "text",
              "text": {
                "content": "trong cuộc sống hàng ngày của user.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "trong cuộc sống hàng ngày của user.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-8090-af44-fe50e35a9636",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T05:49:00.000Z",
        "last_edited_time": "2025-01-13T11:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Xác định “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Xác định “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "value & benefit",
                "link": {
                  "url": "/1605d16478d880ad9130fe44c6663146"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "value & benefit",
              "href": "/1605d16478d880ad9130fe44c6663146"
            },
            {
              "type": "text",
              "text": {
                "content": "”, hiểu động lực của họ, intention of use, Job to be done…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "”, hiểu động lực của họ, intention of use, Job to be done…",
              "href": null
            }
          ],
          "color": "default",
          "list_start_index": 0
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1745d164-78d8-807c-9009-c1215f6299bd",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-07T02:00:00.000Z",
        "last_edited_time": "2025-01-13T11:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081471/uxcomic-imgs/1745d164-78d8-807c-9009-c1215f6299bd.png",
            "expiry_time": "2026-10-04T09:11:56.090Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1745d164-78d8-807c-9009-c1215f6299bd"
      },
      {
        "object": "block",
        "id": "1785d164-78d8-803a-9f92-c2d2267208b5",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-11T11:42:00.000Z",
        "last_edited_time": "2025-01-13T11:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Design hợp với “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Design hợp với “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "mental model",
                "link": {
                  "url": "/73bdf5d9ca494b2789a22dde16b2af7d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "mental model",
              "href": "/73bdf5d9ca494b2789a22dde16b2af7d"
            },
            {
              "type": "text",
              "text": {
                "content": "” của họ, hợp với lối suy nghĩ & thói quen dùng của họ. (lấy ví dụ như: khi bạn mượn một chiếc xe máy khác của bạn bè, bạn có thể chạy nó mà không cần suy nghĩ nên đề ga ở đâu, đá chống thế nào - đó là vì nó đã được thiết kế như chiếc xe bạn đang chạy hoặc đại đa số các xe máy đều vậy >> hợp mental model). Ví dụ vài method: user interviews, persona, contextual inquiry, think aloud protocol, competitive analysis, UX laws, consistency… ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” của họ, hợp với lối suy nghĩ & thói quen dùng của họ. (lấy ví dụ như: khi bạn mượn một chiếc xe máy khác của bạn bè, bạn có thể chạy nó mà không cần suy nghĩ nên đề ga ở đâu, đá chống thế nào - đó là vì nó đã được thiết kế như chiếc xe bạn đang chạy hoặc đại đa số các xe máy đều vậy >> hợp mental model). Ví dụ vài method: user interviews, persona, contextual inquiry, think aloud protocol, competitive analysis, UX laws, consistency… ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1795d164-78d8-80a9-9352-f2134cd3968b",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T09:27:00.000Z",
        "last_edited_time": "2025-01-13T11:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Care về user scenario, job story, context of use, storyboard, journey map… & aware việc một feature sẽ phục vụ cho ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Care về user scenario, job story, context of use, storyboard, journey map… & aware việc một feature sẽ phục vụ cho ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "nhiều dạng user",
                "link": {
                  "url": "/22a3b4bb88d34f84a70f83e7c12ac91d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "nhiều dạng user",
              "href": "/22a3b4bb88d34f84a70f83e7c12ac91d"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1785d164-78d8-801d-b797-ec4af97fe8d5",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-11T11:42:00.000Z",
        "last_edited_time": "2025-01-13T11:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhận diện & giảm tải hết mức có thể các ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhận diện & giảm tải hết mức có thể các ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "interaction cost",
                "link": {
                  "url": "/1195d16478d881308d61fe6e1619967b"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "interaction cost",
              "href": "/1195d16478d881308d61fe6e1619967b"
            },
            {
              "type": "text",
              "text": {
                "content": ". Ví dụ như: cắt step, giảm time on task, hạn chế error case… bằng các tactics: default setting, automation, short-cut, real-time result/ validation, loading feedback, usability heuristic, tooltip…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". Ví dụ như: cắt step, giảm time on task, hạn chế error case… bằng các tactics: default setting, automation, short-cut, real-time result/ validation, loading feedback, usability heuristic, tooltip…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "1795d164-78d8-8014-9cc8-ef79d009c71f",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T05:43:00.000Z",
        "last_edited_time": "2025-01-13T11:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Áp dụng emotion design, psychology, visual design, content, world mapping… để thiết kế của bạn trở nên có hồn, có cảm xúc hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Áp dụng emotion design, psychology, visual design, content, world mapping… để thiết kế của bạn trở nên có hồn, có cảm xúc hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 3
      },
      {
        "object": "block",
        "id": "1795d164-78d8-803a-b6cd-e3bf26bf88f3",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T05:50:00.000Z",
        "last_edited_time": "2025-01-12T09:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Leverage technologies - this’s a huge thing (ví dụ: Face ID, SSO, magic link,…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Leverage technologies - this’s a huge thing (ví dụ: Face ID, SSO, magic link,…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 4
      },
      {
        "object": "block",
        "id": "1795d164-78d8-80d4-9862-dd66c81a9f66",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T09:49:00.000Z",
        "last_edited_time": "2025-01-13T11:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình có nghe qua câu nói ẩn dụ rất hay về UX: “UX giống như kể một câu chuyện cười, nếu bạn phải giải thích thì câu chuyện đã hết buồn cười. Nó trở thành nỗi buồn của người kể chuyện”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình có nghe qua câu nói ẩn dụ rất hay về UX: “UX giống như kể một câu chuyện cười, nếu bạn phải giải thích thì câu chuyện đã hết buồn cười. Nó trở thành nỗi buồn của người kể chuyện”.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "😅"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-801e-a4b9-ece9e69622e6",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T09:28:00.000Z",
        "last_edited_time": "2025-01-12T09:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-808d-aed9-e88418e991da",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T05:51:00.000Z",
        "last_edited_time": "2025-01-12T09:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tóm lại",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tóm lại",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-8045-a324-d4dfc4162b61",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T05:51:00.000Z",
        "last_edited_time": "2025-01-12T09:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một design trở nên “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một design trở nên “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "vô hình",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "vô hình",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "” là một cách nói ẩn dụ, nó là ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” là một cách nói ẩn dụ, nó là ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "đỉnh cao của sự thấu hiểu",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "đỉnh cao của sự thấu hiểu",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " người dùng, khả năng biết tất tần tật về mong muốn, nỗi lo của họ, nắm rõ hành vi & thói quen sử dụng, am hiểu từng cảm xúc, tâm lý của họ…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " người dùng, khả năng biết tất tần tật về mong muốn, nỗi lo của họ, nắm rõ hành vi & thói quen sử dụng, am hiểu từng cảm xúc, tâm lý của họ…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17a5d164-78d8-80f4-b365-ebad1ba4871e",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-13T11:09:00.000Z",
        "last_edited_time": "2025-01-13T11:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-801c-a47a-d4cb629a1392",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T09:24:00.000Z",
        "last_edited_time": "2025-01-13T11:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để vô hình, nó còn về khả năng ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để vô hình, nó còn về khả năng ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "quy hoạch",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "quy hoạch",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", nhìn trải nghiệm dưới một góc độ bao quát, toàn app, cả những trải nghiệm ngoài app có thể là gì,… còn không ta sẽ rất dễ rơi vào tình trạng ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", nhìn trải nghiệm dưới một góc độ bao quát, toàn app, cả những trải nghiệm ngoài app có thể là gì,… còn không ta sẽ rất dễ rơi vào tình trạng ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "feature factory",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "feature factory",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " - ta chỉ thuần add thêm feature, thêm function, còn user thì phải khùng điên học về cách dùng nó hoặc làm mọi thứ trở nên rối răm, trở thành nổi lẩu thập cẩm lúc nào mà không hay.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " - ta chỉ thuần add thêm feature, thêm function, còn user thì phải khùng điên học về cách dùng nó hoặc làm mọi thứ trở nên rối răm, trở thành nổi lẩu thập cẩm lúc nào mà không hay.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-806f-9272-e3e28570d67e",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T09:51:00.000Z",
        "last_edited_time": "2025-01-12T09:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-80fe-9682-d3f03381be53",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T09:16:00.000Z",
        "last_edited_time": "2025-01-12T09:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cảm ơn bạn đã đọc đến đây, mong bạn góp nhặt được gì đó cho công việc của mình 😚.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cảm ơn bạn đã đọc đến đây, mong bạn góp nhặt được gì đó cho công việc của mình 😚.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-8040-8bed-de6927f50513",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T09:17:00.000Z",
        "last_edited_time": "2025-01-14T03:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các reference ở dưới cũng hay lắm, mọi người có time check xem nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các reference ở dưới cũng hay lắm, mọi người có time check xem nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-81aa-b793-c24806728b85",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2024-10-07T05:13:00.000Z",
        "last_edited_time": "2024-10-07T05:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-81fe-b150-e113e49c48ac",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2024-10-07T05:13:00.000Z",
        "last_edited_time": "2024-10-07T05:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17a5d164-78d8-8057-b29b-fd680f7b44f3",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-13T13:01:00.000Z",
        "last_edited_time": "2025-01-13T13:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "video",
        "video": {
          "caption": [],
          "type": "external",
          "external": {
            "url": "https://youtu.be/bTrxDPG6WP4?si=_YlA8tE3yj_uipmF"
          }
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-8159-b575-f4ade3547de4",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2024-10-07T05:13:00.000Z",
        "last_edited_time": "2025-01-05T11:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://uxdesign.cc/features-shouldnt-feel-like-features-fba44644f961",
                "link": {
                  "url": "https://uxdesign.cc/features-shouldnt-feel-like-features-fba44644f961"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://uxdesign.cc/features-shouldnt-feel-like-features-fba44644f961",
              "href": "https://uxdesign.cc/features-shouldnt-feel-like-features-fba44644f961"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-81b6-aa5f-d8af38621179",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2024-10-07T05:13:00.000Z",
        "last_edited_time": "2025-01-05T11:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.theicod.org/professional-design/polemics-archive/good-design-rare",
                "link": {
                  "url": "https://www.theicod.org/professional-design/polemics-archive/good-design-rare"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.theicod.org/professional-design/polemics-archive/good-design-rare",
              "href": "https://www.theicod.org/professional-design/polemics-archive/good-design-rare"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-8077-a2dd-e44ae8ab71ac",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-14T03:57:00.000Z",
        "last_edited_time": "2025-01-14T03:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.joemoe.win/article/synesthesia",
                "link": {
                  "url": "https://www.joemoe.win/article/synesthesia"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.joemoe.win/article/synesthesia",
              "href": "https://www.joemoe.win/article/synesthesia"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-815f-b5d3-e67f3e725c05",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2024-10-07T05:13:00.000Z",
        "last_edited_time": "2025-01-05T11:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-81e2-b8b9-fddc08bb98c9",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2024-10-07T05:13:00.000Z",
        "last_edited_time": "2025-01-05T11:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-8128-8257-e09d00527dbd",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2024-10-07T05:13:00.000Z",
        "last_edited_time": "2025-01-05T12:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1195d164-78d8-8130-8d61-fe6e1619967b"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "IxD checklist",
              "href": "https://app.notion.com/p/1195d16478d881308d61fe6e1619967b"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-80b8-a291-cbec3ea71ea5",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-12T09:37:00.000Z",
        "last_edited_time": "2025-01-12T09:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1195d164-78d8-800e-93cc-d89ca8ed01bc"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX checklist",
              "href": "https://app.notion.com/p/1195d16478d8800e93ccd89ca8ed01bc"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-81b1-9bbf-e2c8c45a61a2",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2024-10-07T05:13:00.000Z",
        "last_edited_time": "2025-01-05T12:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Understand, Empathize user?",
              "href": "https://app.notion.com/p/32cbe568c34b4255a408f2a2e6227bb2"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1725d164-78d8-804a-a126-df79704dd194",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-05T12:15:00.000Z",
        "last_edited_time": "2025-01-05T12:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mental model?",
              "href": "https://app.notion.com/p/73bdf5d9ca494b2789a22dde16b2af7d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1725d164-78d8-80fc-be0e-c7e8f23d828d",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-05T12:15:00.000Z",
        "last_edited_time": "2025-01-05T12:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User Journey map, User scenario, Task flow, User flow",
              "href": "https://app.notion.com/p/1155d16478d880a883a6ec9db47fe4dc"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1725d164-78d8-80fc-bba9-e096845a8436",
        "parent": {
          "type": "page_id",
          "page_id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
        },
        "created_time": "2025-01-05T12:15:00.000Z",
        "last_edited_time": "2025-01-05T12:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User Multiverse",
              "href": "https://app.notion.com/p/22a3b4bb88d34f84a70f83e7c12ac91d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "f33a58a3-0560-4b8c-b509-976f80f8c973",
    "created_time": "2024-10-04T01:56:00.000Z",
    "last_edited_time": "2025-07-13T04:13:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "fd3cd36d-73dd-4dee-8bd5-d159d6600124"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "View": {
        "id": "ATSa",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "A%5Bqc",
        "type": "select",
        "select": {
          "id": "\\i@K",
          "name": "⚓:1",
          "color": "pink"
        }
      },
      "Last edited time": {
        "id": "DMgm",
        "type": "last_edited_time",
        "last_edited_time": "2025-07-13T04:13:00.000Z"
      },
      "Publish": {
        "id": "FSnx",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "_tsp",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "g%7BBg",
        "type": "created_time",
        "created_time": "2024-10-04T01:56:00.000Z"
      },
      "Share": {
        "id": "hp~_",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "m%7C%40x",
        "type": "number",
        "number": null
      },
      "Formula": {
        "id": "re%3BE",
        "type": "formula",
        "formula": {
          "type": "number",
          "number": 1
        }
      },
      "Tag": {
        "id": "%7CAvQ",
        "type": "select",
        "select": {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "3-Design",
          "color": "default"
        }
      },
      "ID": {
        "id": "~RYT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FD",
          "number": 10
        }
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "UI vs IxD vs UX vs Product design",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "UI vs IxD vs UX vs Product design",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/UI-vs-IxD-vs-UX-vs-Product-design-f33a58a305604b8cb509976f80f8c973",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "5cacdbff-b9e2-4973-b565-ec1ae4327ec9",
      "name": "Fundamental",
      "slug": "fundamental",
      "icon": "🌞",
      "order": 2,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "Product",
          "slug": "product",
          "order": 1
        },
        {
          "id": "156ef770-14db-4170-b1d7-95a2fbdf62ba",
          "name": "User",
          "slug": "user",
          "order": 2
        },
        {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "Design",
          "slug": "design",
          "order": 3
        },
        {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "Random",
          "slug": "random",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
      "name": "Design",
      "slug": "design",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "1155d164-78d8-8191-97fd-d40b83e2a4de",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-04T01:56:00.000Z",
        "last_edited_time": "2024-12-06T01:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081474/uxcomic-imgs/1155d164-78d8-8191-97fd-d40b83e2a4de.png",
            "expiry_time": "2026-10-04T09:11:57.943Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1155d164-78d8-8191-97fd-d40b83e2a4de"
      },
      {
        "object": "block",
        "id": "1155d164-78d8-81d6-87c6-c8d56bcc9890",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-04T01:56:00.000Z",
        "last_edited_time": "2024-12-31T00:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thời gian đầu vào nghề, mình bị loạn xà ngầu với mấy term này: UX, UI, IxD, Product design. Vậy giữa chúng có thật sự khác biệt gì và mối liên hệ giữa chúng như thế nào?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thời gian đầu vào nghề, mình bị loạn xà ngầu với mấy term này: UX, UI, IxD, Product design. Vậy giữa chúng có thật sự khác biệt gì và mối liên hệ giữa chúng như thế nào?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16d5d164-78d8-804d-8818-c36452f46aa1",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-12-31T00:54:00.000Z",
        "last_edited_time": "2024-12-31T00:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1155d164-78d8-8105-bc48-e22ec2c6c8de",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-04T01:56:00.000Z",
        "last_edited_time": "2025-07-13T04:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "UI design",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UI design",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1155d164-78d8-8117-a0a5-c8208e47f0b7",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-04T01:56:00.000Z",
        "last_edited_time": "2025-07-13T04:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nó là giao diện, là những phần bạn nhìn thấy khi dùng một app hay web gì đó, là layout, color, graphic, icon, theme, typography, motion,… ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nó là giao diện, là những phần bạn nhìn thấy khi dùng một app hay web gì đó, là layout, color, graphic, icon, theme, typography, motion,… ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80ce-a1ca-f4f3f5e748ef",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2025-01-01T15:00:00.000Z",
        "last_edited_time": "2025-07-13T04:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Công việc của UI xoay quanh việc tìm cách trình diễn sao cho cân bằng thị giác, ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Công việc của UI xoay quanh việc tìm cách trình diễn sao cho cân bằng thị giác, ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "truyền tải rõ thông điệp/thông tin",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "truyền tải rõ thông điệp/thông tin",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", tạo sự thu hút… ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", tạo sự thu hút… ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1205d164-78d8-80e2-8305-db33174be771",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-15T11:44:00.000Z",
        "last_edited_time": "2025-01-01T15:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu bạn đi lên từ Graphic design, công việc sẽ có tính liên quan, nó đều tập trung mạnh vào phần visual. Tuy nhiên Interface này cần dựa trên cơ sở trước của IxD, vậy IxD là gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu bạn đi lên từ Graphic design, công việc sẽ có tính liên quan, nó đều tập trung mạnh vào phần visual. Tuy nhiên Interface này cần dựa trên cơ sở trước của IxD, vậy IxD là gì?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16d5d164-78d8-80a5-a14b-cccde40fd966",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-12-31T00:54:00.000Z",
        "last_edited_time": "2024-12-31T00:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1155d164-78d8-81e3-8ead-f059cbd65ba8",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-04T01:56:00.000Z",
        "last_edited_time": "2024-10-15T11:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "IxD",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "IxD",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-800d-a07c-c8f984ba5d06",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2025-01-01T15:04:00.000Z",
        "last_edited_time": "2025-07-13T04:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tương tác định nghĩa là một sự trao đổi liên tục 2 chiều hoặc đa chiều.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tương tác định nghĩa là một sự trao đổi liên tục 2 chiều hoặc đa chiều.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1155d164-78d8-8166-97d5-ee40760c5e9b",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-04T01:56:00.000Z",
        "last_edited_time": "2025-07-13T04:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Công việc của thiết kế tương tác tập trung vào việc cân bằng giữa việc cách hệ thống hoạt động ra sao & user nên tương tác như thế nào nên 2 bên có một mối quan hệ tốt đẹp (cả về mặt functional & emotional).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Công việc của thiết kế tương tác tập trung vào việc cân bằng giữa việc cách hệ thống hoạt động ra sao & user nên tương tác như thế nào nên 2 bên có một mối quan hệ tốt đẹp (cả về mặt functional & emotional).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-80a3-b5f7-dac454fe55ed",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2025-07-13T04:05:00.000Z",
        "last_edited_time": "2025-07-13T04:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nó bao gồm việc cân nhắc: cách điều hướng, các step phải trải qua, nên dùng interaction pattern nào, user take action gì & nhận feedback ra sao… Ở state này output cần đến có thể chỉ cần dừng ở flowchart, wireframe, chọn các interaction pattern phù hợp.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nó bao gồm việc cân nhắc: cách điều hướng, các step phải trải qua, nên dùng interaction pattern nào, user take action gì & nhận feedback ra sao… Ở state này output cần đến có thể chỉ cần dừng ở flowchart, wireframe, chọn các interaction pattern phù hợp.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1205d164-78d8-809a-90a7-d04477704559",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-15T11:49:00.000Z",
        "last_edited_time": "2025-07-13T04:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: khi user click nút “thêm vào giỏ hàng” thì hệ thống có animation thêm đúng item đó vào trong giỏ và tăng số items trong giỏ hàng, user có thể thấy lại các item và tùy chỉnh nó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: khi user click nút “thêm vào giỏ hàng” thì hệ thống có animation thêm đúng item đó vào trong giỏ và tăng số items trong giỏ hàng, user có thể thấy lại các item và tùy chỉnh nó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-805a-9a5e-fc485d222b2c",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2025-07-13T04:09:00.000Z",
        "last_edited_time": "2025-07-13T04:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081476/uxcomic-imgs/22f5d164-78d8-805a-9a5e-fc485d222b2c.png",
            "expiry_time": "2026-10-04T09:11:57.944Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/22f5d164-78d8-805a-9a5e-fc485d222b2c"
      },
      {
        "object": "block",
        "id": "1295d164-78d8-801d-929b-c3b04f113b66",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-24T15:22:00.000Z",
        "last_edited_time": "2024-10-24T15:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hãy hình dung xem product của bạn đang ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hãy hình dung xem product của bạn đang ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "trò chuyện với user",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "trò chuyện với user",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " như thế nào? >> IxD",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " như thế nào? >> IxD",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1205d164-78d8-80e9-b0ce-c8acf1e08067",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-15T11:53:00.000Z",
        "last_edited_time": "2024-10-24T15:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "P/s: Trong cuốn sách “About Face” có nhắc đến 1 khái niệm rất hay, đó là công việc của mình as a UX/UI designer chính là ở “Represented Models” - trình diễn cách system hoạt động sao cho phù hợp với cách user nghĩ nó sẽ hoạt động, càng trình diễn tốt thì đó chính là một UX tốt.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "P/s: Trong cuốn sách “About Face” có nhắc đến 1 khái niệm rất hay, đó là công việc của mình as a UX/UI designer chính là ở “Represented Models” - trình diễn cách system hoạt động sao cho phù hợp với cách user nghĩ nó sẽ hoạt động, càng trình diễn tốt thì đó chính là một UX tốt.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-80f8-94bc-d8687a56770a",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-24T15:23:00.000Z",
        "last_edited_time": "2024-12-06T01:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081478/uxcomic-imgs/1295d164-78d8-80f8-94bc-d8687a56770a.png",
            "expiry_time": "2026-10-04T09:11:57.944Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1295d164-78d8-80f8-94bc-d8687a56770a"
      },
      {
        "object": "block",
        "id": "16d5d164-78d8-80c7-8b71-d13dac0f1993",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-12-31T00:54:00.000Z",
        "last_edited_time": "2024-12-31T00:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1205d164-78d8-804f-9138-f3938e90b830",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-15T11:59:00.000Z",
        "last_edited_time": "2025-07-13T04:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "UX",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1205d164-78d8-807b-aada-fe6b4b74cc78",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-15T11:59:00.000Z",
        "last_edited_time": "2025-01-01T15:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhắc đến là trải nghiệm là việc bạn muốn user “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhắc đến là trải nghiệm là việc bạn muốn user “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "CẢM",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "CẢM",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "” ra sao khi họ tương tác với product/ feature. Và khi nói đến “cảm” nó rất có tính personal và cần sự “phù hợp” nhất định, để mang đến được 1 trải nghiệm tích cực, mình phải hiểu rõ họ là ai, background, họ mong muốn & sợ gì, ngữ cảnh họ dùng thế nào,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” ra sao khi họ tương tác với product/ feature. Và khi nói đến “cảm” nó rất có tính personal và cần sự “phù hợp” nhất định, để mang đến được 1 trải nghiệm tích cực, mình phải hiểu rõ họ là ai, background, họ mong muốn & sợ gì, ngữ cảnh họ dùng thế nào,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16d5d164-78d8-8042-a8ee-cc76c35a745d",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-12-31T00:50:00.000Z",
        "last_edited_time": "2025-01-01T15:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có một câu mình thấy rất phù hợp đến nói về trải nghiệm đó là: “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có một câu mình thấy rất phù hợp đến nói về trải nghiệm đó là: “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Mọi người sẽ quên những gì bạn nói, quên những gì bạn đã làm, nhưng họ sẽ không bao giờ quên cảm xúc mà bạn mang lại cho họ”. ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mọi người sẽ quên những gì bạn nói, quên những gì bạn đã làm, nhưng họ sẽ không bao giờ quên cảm xúc mà bạn mang lại cho họ”. ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Nên không quan trọng bạn làm bao nhiêu màn hình, bao nhiêu flow, bao nhiêu micro interaction,… tổng thể trải nghiệm mới là thứ user nhớ đến.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nên không quan trọng bạn làm bao nhiêu màn hình, bao nhiêu flow, bao nhiêu micro interaction,… tổng thể trải nghiệm mới là thứ user nhớ đến.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1205d164-78d8-80cd-9be3-c3dfafa6eb07",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-15T12:03:00.000Z",
        "last_edited_time": "2024-12-31T00:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: nếu user thường sử dụng product trong ngữ cảnh rất gấp thì các thao tác nên diễn ra nhanh chóng, ít sai là họ rất mừng rồi, còn nếu họ sẽ dùng product trong ngữ cảnh đang khám phá, tò mò thì thao tác nhiều hay không không quan trọng bằng việc phải khiến họ thấy thích thú, khiến sự tò mò được thoả mãn,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: nếu user thường sử dụng product trong ngữ cảnh rất gấp thì các thao tác nên diễn ra nhanh chóng, ít sai là họ rất mừng rồi, còn nếu họ sẽ dùng product trong ngữ cảnh đang khám phá, tò mò thì thao tác nhiều hay không không quan trọng bằng việc phải khiến họ thấy thích thú, khiến sự tò mò được thoả mãn,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-80db-918b-ea507a91ff07",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-24T15:17:00.000Z",
        "last_edited_time": "2025-01-01T15:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có một tactic mình rất hay dùng khi design UX cho một feature, mình sẽ cố gắng suy nghĩ xem có những ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có một tactic mình rất hay dùng khi design UX cho một feature, mình sẽ cố gắng suy nghĩ xem có những ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "“TÍNH TỪ” ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“TÍNH TỪ” ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "gì mà mình muốn user cảm thấy khi dùng (vd: vui hào hứng, an tâm, nhanh gọn), và đồng thời để ý khả năng user cảm thấy tiêu cực gì không (vd: sợ lộ thông tin, sợ bị đánh giá, không tin tưởng…).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "gì mà mình muốn user cảm thấy khi dùng (vd: vui hào hứng, an tâm, nhanh gọn), và đồng thời để ý khả năng user cảm thấy tiêu cực gì không (vd: sợ lộ thông tin, sợ bị đánh giá, không tin tưởng…).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8069-b983-d43d98f7ede9",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-12-24T02:03:00.000Z",
        "last_edited_time": "2025-01-10T11:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hãy liên tưởng đến một service 5⭐️, nó sẽ trông như thế nào.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hãy liên tưởng đến một service 5⭐️, nó sẽ trông như thế nào.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "7b1f6d7c-c3f1-4059-98f6-85697f0bd75b",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-25T08:22:00.000Z",
        "last_edited_time": "2024-10-25T08:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách này giúp mình tạm tránh tập trung vào việc design dựa theo business objective, functionality, usability ,…mà còn phải nghĩ đến những yếu tố cảm xúc mà user cần có.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách này giúp mình tạm tránh tập trung vào việc design dựa theo business objective, functionality, usability ,…mà còn phải nghĩ đến những yếu tố cảm xúc mà user cần có.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16d5d164-78d8-80f4-b894-d3dcf4d2499e",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-12-31T00:54:00.000Z",
        "last_edited_time": "2024-12-31T00:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1205d164-78d8-8014-bdab-eaae45a38684",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-15T12:05:00.000Z",
        "last_edited_time": "2025-07-13T04:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Product design",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product design",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1205d164-78d8-800b-abb9-d255dfa18edf",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-15T12:05:00.000Z",
        "last_edited_time": "2025-01-01T15:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy product design là gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy product design là gì?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8041-a21d-cc257c54c03c",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2025-01-01T15:07:00.000Z",
        "last_edited_time": "2025-01-01T15:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ngay tại cái tên, bạn đã thấy nó đang mất đi chữ “user” ở đầu, vì lúc này công việc cần quan tâm nhiều hơn là về ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ngay tại cái tên, bạn đã thấy nó đang mất đi chữ “user” ở đầu, vì lúc này công việc cần quan tâm nhiều hơn là về ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "product",
                "link": {
                  "url": "/22f4879b78c641f4ac922219ca7879f2"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "product",
              "href": "/22f4879b78c641f4ac922219ca7879f2"
            },
            {
              "type": "text",
              "text": {
                "content": ", mà product là một thực thể trao đổi ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", mà product là một thực thể trao đổi ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "giá trị",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "giá trị",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " giữa user & biz",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " giữa user & biz",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-80f6-88a3-c05d8221e23b",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2025-01-01T15:08:00.000Z",
        "last_edited_time": "2025-01-01T15:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> product designer sẽ quan tâm nhiều hơn đến các ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> product designer sẽ quan tâm nhiều hơn đến các ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "metrics & outcome",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "metrics & outcome",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " từ design, đồng thời xem xét cân nhắc các mặt technical, resource của team ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " từ design, đồng thời xem xét cân nhắc các mặt technical, resource của team ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8086-8871-dab05a88f191",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2025-01-01T15:08:00.000Z",
        "last_edited_time": "2025-01-01T15:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> product design sẽ có cái nhìn tổng quan hơn để làm sao để cho ra một thiết kế vừa đáp ứng được user need, biz value và feasibility.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> product design sẽ có cái nhìn tổng quan hơn để làm sao để cho ra một thiết kế vừa đáp ứng được user need, biz value và feasibility.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8084-94f4-d03f1eab1c3d",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-12-24T02:04:00.000Z",
        "last_edited_time": "2024-12-24T02:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tưởng tượng mình là co-founder, giữ nhiệm vụ design, own chính sản phẩm của mình, thì bạn phải quan tâm đến điều gì? >> product design",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tưởng tượng mình là co-founder, giữ nhiệm vụ design, own chính sản phẩm của mình, thì bạn phải quan tâm đến điều gì? >> product design",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1205d164-78d8-8005-a803-d7bb6cc39948",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-15T12:08:00.000Z",
        "last_edited_time": "2025-01-10T11:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: khi bạn muốn cho vào một nút “liên hệ với support” để user được hỗ trợ giải đáp các thắc mắc cho user, tuy nhiên khi cân nhắc đến resources, team customer support hiện đang bị overload, khiến việc hỗ trợ giải đáp ngay cho user là bất khả thi, nên khả năng cao user sẽ phải đợi để được hỗ trợ, như vậy thì trải nghiệm sẽ không tốt. Vậy mình cần tìm ra phương án khác ví dụ như là dẫn user đến trang FAQ để được giải đáp những thắc mắc phổ biến, nếu user không tìm được câu trả lời thì mới offer họ việc “liên hệ với support”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: khi bạn muốn cho vào một nút “liên hệ với support” để user được hỗ trợ giải đáp các thắc mắc cho user, tuy nhiên khi cân nhắc đến resources, team customer support hiện đang bị overload, khiến việc hỗ trợ giải đáp ngay cho user là bất khả thi, nên khả năng cao user sẽ phải đợi để được hỗ trợ, như vậy thì trải nghiệm sẽ không tốt. Vậy mình cần tìm ra phương án khác ví dụ như là dẫn user đến trang FAQ để được giải đáp những thắc mắc phổ biến, nếu user không tìm được câu trả lời thì mới offer họ việc “liên hệ với support”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1205d164-78d8-80f5-ac97-c2c42edb13b8",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-15T12:13:00.000Z",
        "last_edited_time": "2025-01-01T15:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Qua ví dụ trên bạn thấy product design cân nhắc đến solution không còn gói gọn trong việc thiết kế cách user tương tác, nhìn giao diện như thế nào, hay chỉ trong phạm vi feature, góc nhìn đã được mở rộng ra, việc hình thành 1 giải pháp phải cần có tính chiến lược và sự cân nhắc ở nhiều khía cạnh hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Qua ví dụ trên bạn thấy product design cân nhắc đến solution không còn gói gọn trong việc thiết kế cách user tương tác, nhìn giao diện như thế nào, hay chỉ trong phạm vi feature, góc nhìn đã được mở rộng ra, việc hình thành 1 giải pháp phải cần có tính chiến lược và sự cân nhắc ở nhiều khía cạnh hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1205d164-78d8-803b-a86a-c59f8e9dd0c0",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-15T12:15:00.000Z",
        "last_edited_time": "2024-10-15T12:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1205d164-78d8-80db-9ed8-f8765f8511c1",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-15T12:15:00.000Z",
        "last_edited_time": "2025-01-01T14:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tóm lại",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tóm lại",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1205d164-78d8-8092-bb74-f7cfcab3ee03",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-15T12:15:00.000Z",
        "last_edited_time": "2025-01-10T11:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Việc tìm hiểu và phân biệt rõ hơn các term này đã giúp mình hiểu rõ các scope công việc và nhiệm vụ của từng title.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Việc tìm hiểu và phân biệt rõ hơn các term này đã giúp mình hiểu rõ các scope công việc và nhiệm vụ của từng title.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8094-8bf3-c8840b44a240",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2025-01-01T15:09:00.000Z",
        "last_edited_time": "2025-01-01T15:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu công việc của mình sẽ bao gồm hết các scope ấy, thì việc chia rõ scope theo từng term cũng sẽ giúp mình chậm lại 1 nhịp và xem xét lại tại thời điểm đó, project đó, nên được focus execute ở tầng nào hoặc liệu mình còn bỏ sót khía cạnh nào không.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu công việc của mình sẽ bao gồm hết các scope ấy, thì việc chia rõ scope theo từng term cũng sẽ giúp mình chậm lại 1 nhịp và xem xét lại tại thời điểm đó, project đó, nên được focus execute ở tầng nào hoặc liệu mình còn bỏ sót khía cạnh nào không.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8039-b146-dc05a013d156",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2025-01-01T15:11:00.000Z",
        "last_edited_time": "2025-01-01T15:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tóm tắt thì có thể hiểu như sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tóm tắt thì có thể hiểu như sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8040-add3-ed560bb57732",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2025-01-01T14:59:00.000Z",
        "last_edited_time": "2025-01-01T14:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "16e5d164-78d8-8078-86c9-fef5bc66dd27",
            "parent": {
              "type": "block_id",
              "block_id": "16e5d164-78d8-8040-add3-ed560bb57732"
            },
            "created_time": "2025-01-01T14:56:00.000Z",
            "last_edited_time": "2025-07-13T04:11:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "UI: cách bạn ăn mặc, ngôn từ, câu chữ, thể hiện thông điệp",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "UI: cách bạn ăn mặc, ngôn từ, câu chữ, thể hiện thông điệp",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "16e5d164-78d8-8082-aec3-dcc878d6ed30",
            "parent": {
              "type": "block_id",
              "block_id": "16e5d164-78d8-8040-add3-ed560bb57732"
            },
            "created_time": "2025-01-01T14:56:00.000Z",
            "last_edited_time": "2025-07-13T04:11:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "IxD: cách bạn nói chuyện, tương tác với user",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "IxD: cách bạn nói chuyện, tương tác với user",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "16e5d164-78d8-8063-b35c-efaa2543cc4e",
            "parent": {
              "type": "block_id",
              "block_id": "16e5d164-78d8-8040-add3-ed560bb57732"
            },
            "created_time": "2025-01-01T14:56:00.000Z",
            "last_edited_time": "2025-01-01T14:59:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "UX: user cảm nhận ra sao",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "UX: user cảm nhận ra sao",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "16e5d164-78d8-8008-a0a5-f4ba4f276f5c",
            "parent": {
              "type": "block_id",
              "block_id": "16e5d164-78d8-8040-add3-ed560bb57732"
            },
            "created_time": "2025-01-01T14:57:00.000Z",
            "last_edited_time": "2025-01-01T14:59:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Product design: tập trung nhiều hơn về value, strategy & constraints của product.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Product design: tập trung nhiều hơn về value, strategy & constraints của product.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "47bedc37-0458-497b-9de0-8a0011f1fca2",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-16T02:03:00.000Z",
        "last_edited_time": "2024-10-16T02:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081479/uxcomic-imgs/47bedc37-0458-497b-9de0-8a0011f1fca2.png",
            "expiry_time": "2026-10-04T09:11:58.031Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/47bedc37-0458-497b-9de0-8a0011f1fca2"
      },
      {
        "object": "block",
        "id": "1155d164-78d8-811a-9aa8-d2e367ba71ad",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-04T01:56:00.000Z",
        "last_edited_time": "2024-10-04T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "bcaf5bef-c6b1-46b2-ac6c-2255dbdc4869",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-16T02:09:00.000Z",
        "last_edited_time": "2024-10-16T02:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "87d0b77c-12fd-4791-ba2d-b615a0b6f18e",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-10-16T02:09:00.000Z",
        "last_edited_time": "2024-12-24T02:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User Journey map, User scenario, Task flow, User flow",
              "href": "https://app.notion.com/p/1155d16478d880a883a6ec9db47fe4dc"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8092-bcfd-ea6f325df7f5",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-12-24T02:10:00.000Z",
        "last_edited_time": "2024-12-24T02:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1445d164-78d8-805b-b388-e24b5f13cccb"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product development process (overall)",
              "href": "https://app.notion.com/p/1445d16478d8805bb388e24b5f13cccb"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8068-b80d-f3b35db66fff",
        "parent": {
          "type": "page_id",
          "page_id": "f33a58a3-0560-4b8c-b509-976f80f8c973"
        },
        "created_time": "2024-12-24T02:10:00.000Z",
        "last_edited_time": "2024-12-24T02:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1605d164-78d8-80ad-9130-fe44c6663146"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Value vs Benefit",
              "href": "https://app.notion.com/p/1605d16478d880ad9130fe44c6663146"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "10f5d164-78d8-8050-9b0c-e73068127ed4",
    "created_time": "2024-09-28T08:05:00.000Z",
    "last_edited_time": "2025-08-21T05:59:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "fd3cd36d-73dd-4dee-8bd5-d159d6600124"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "View": {
        "id": "ATSa",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "A%5Bqc",
        "type": "select",
        "select": {
          "id": "\\i@K",
          "name": "⚓:1",
          "color": "pink"
        }
      },
      "Last edited time": {
        "id": "DMgm",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-21T05:59:00.000Z"
      },
      "Publish": {
        "id": "FSnx",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "_tsp",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "g%7BBg",
        "type": "created_time",
        "created_time": "2024-09-28T08:05:00.000Z"
      },
      "Share": {
        "id": "hp~_",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "m%7C%40x",
        "type": "number",
        "number": null
      },
      "Formula": {
        "id": "re%3BE",
        "type": "formula",
        "formula": {
          "type": "number",
          "number": 1
        }
      },
      "Tag": {
        "id": "%7CAvQ",
        "type": "select",
        "select": {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "3-Design",
          "color": "default"
        }
      },
      "ID": {
        "id": "~RYT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FD",
          "number": 9
        }
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Interaction",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Interaction",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Interaction-10f5d16478d880509b0ce73068127ed4",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "5cacdbff-b9e2-4973-b565-ec1ae4327ec9",
      "name": "Fundamental",
      "slug": "fundamental",
      "icon": "🌞",
      "order": 2,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "Product",
          "slug": "product",
          "order": 1
        },
        {
          "id": "156ef770-14db-4170-b1d7-95a2fbdf62ba",
          "name": "User",
          "slug": "user",
          "order": 2
        },
        {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "Design",
          "slug": "design",
          "order": 3
        },
        {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "Random",
          "slug": "random",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
      "name": "Design",
      "slug": "design",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "10f5d164-78d8-81bb-b1d7-c7218694bc34",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2024-09-28T08:05:00.000Z",
        "last_edited_time": "2025-08-14T06:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754878066/uxcomic-imgs/10f5d164-78d8-81bb-b1d7-c7218694bc34.png",
            "expiry_time": "2026-10-04T09:12:02.126Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/10f5d164-78d8-81bb-b1d7-c7218694bc34"
      },
      {
        "object": "block",
        "id": "2375d164-78d8-8035-92b8-e5b645550551",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-07-21T02:41:00.000Z",
        "last_edited_time": "2025-08-11T01:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có thể nói phần lớn công việc UX/UI design hiện tại, phần việc IxD chiếm chắc đến 70%. Ta là người thiết kế nên “cách thức trò chuyện” giữa người và máy. Cụ thể ra sao mời bạn đón xem thêm nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có thể nói phần lớn công việc UX/UI design hiện tại, phần việc IxD chiếm chắc đến 70%. Ta là người thiết kế nên “cách thức trò chuyện” giữa người và máy. Cụ thể ra sao mời bạn đón xem thêm nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24c5d164-78d8-8085-ae03-fbfa374949c5",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-11T01:58:00.000Z",
        "last_edited_time": "2025-08-11T01:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8086-9940-e3b9d263362f",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-07-12T04:13:00.000Z",
        "last_edited_time": "2025-07-13T04:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Definition",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Definition",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24c5d164-78d8-80c4-9a5f-f9a1ff2b04eb",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-11T01:54:00.000Z",
        "last_edited_time": "2025-08-12T10:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Interaction trong IxD là toàn bộ quá trình và hành vi giao tiếp hai chiều giữa người dùng và sản phẩm kỹ thuật số, tập trung vào việc thiết kế các hành động người dùng và phản hồi của hệ thống để tối ưu trải nghiệm người dùng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Interaction trong IxD là toàn bộ quá trình và hành vi giao tiếp hai chiều giữa người dùng và sản phẩm kỹ thuật số, tập trung vào việc thiết kế các hành động người dùng và phản hồi của hệ thống để tối ưu trải nghiệm người dùng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24d5d164-78d8-80cc-9c4a-dbd081173eca",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-12T10:33:00.000Z",
        "last_edited_time": "2025-08-15T01:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754995033/uxcomic-imgs/24d5d164-78d8-80cc-9c4a-dbd081173eca.png",
            "expiry_time": "2026-10-04T09:12:02.126Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/24d5d164-78d8-80cc-9c4a-dbd081173eca"
      },
      {
        "object": "block",
        "id": "24d5d164-78d8-801c-afcb-dddb48b0a6db",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-12T10:31:00.000Z",
        "last_edited_time": "2025-08-15T01:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ngắn gọn thì:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ngắn gọn thì:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2505d164-78d8-8022-b064-c85e9fc55d52",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-15T01:20:00.000Z",
        "last_edited_time": "2025-08-15T01:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nó là vòng lặp của: “Thấy” gì → Nghĩ gì → Làm gì → “Thấy” gì…",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nó là vòng lặp của: “Thấy” gì → Nghĩ gì → Làm gì → “Thấy” gì…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24d5d164-78d8-807f-bdb5-dad05732d7be",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-12T10:31:00.000Z",
        "last_edited_time": "2025-08-15T10:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nghĩ đến 2 chữ “phát tác”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nghĩ đến 2 chữ “phát tác”",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "2505d164-78d8-80fe-bf90-e7f77cdcfdc2",
            "parent": {
              "type": "block_id",
              "block_id": "24d5d164-78d8-807f-bdb5-dad05732d7be"
            },
            "created_time": "2025-08-15T01:17:00.000Z",
            "last_edited_time": "2025-08-15T01:19:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Phát ra tín hiệu hoặc thông tin gì?",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Phát ra tín hiệu hoặc thông tin gì?",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "2505d164-78d8-8072-ae0e-fa3d8d143006",
            "parent": {
              "type": "block_id",
              "block_id": "24d5d164-78d8-807f-bdb5-dad05732d7be"
            },
            "created_time": "2025-08-15T01:18:00.000Z",
            "last_edited_time": "2025-08-15T01:19:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Tác động ra sao? - Vật lý (giác quan) & Cách hiểu & Cảm xúc",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Tác động ra sao? - Vật lý (giác quan) & Cách hiểu & Cảm xúc",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "2505d164-78d8-800f-bc92-ca241a0e058f",
            "parent": {
              "type": "block_id",
              "block_id": "24d5d164-78d8-807f-bdb5-dad05732d7be"
            },
            "created_time": "2025-08-15T10:07:00.000Z",
            "last_edited_time": "2025-08-15T10:47:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Cách user control & sự tác động tương ứng ra sao…",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Cách user control & sự tác động tương ứng ra sao…",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "24c5d164-78d8-800e-871c-c08892a42d90",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-11T01:53:00.000Z",
        "last_edited_time": "2025-08-11T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "24c5d164-78d8-8082-b797-f8a51f91c286",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-11T01:29:00.000Z",
        "last_edited_time": "2025-08-15T10:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thử điểm qua cách Interaction, control trong các platform/ device",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thử điểm qua cách Interaction, control trong các platform/ device",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24c5d164-78d8-8069-a202-cb045b7f190b",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-11T01:30:00.000Z",
        "last_edited_time": "2025-08-11T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước khi GUI ra đời (graphic user interface) thì con người tương tác với máy tính vẫn bằng câu lệnh (command line interface).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước khi GUI ra đời (graphic user interface) thì con người tương tác với máy tính vẫn bằng câu lệnh (command line interface).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24c5d164-78d8-803f-b578-d8916b572557",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-11T01:45:00.000Z",
        "last_edited_time": "2025-08-11T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754878068/uxcomic-imgs/24c5d164-78d8-803f-b578-d8916b572557.png",
            "expiry_time": "2026-10-04T09:12:02.126Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/24c5d164-78d8-803f-b578-d8916b572557"
      },
      {
        "object": "block",
        "id": "24c5d164-78d8-80ea-84c0-ef23d82677d4",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-11T01:34:00.000Z",
        "last_edited_time": "2025-08-11T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24c5d164-78d8-8058-a0ab-e02c83928e0f",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-11T01:31:00.000Z",
        "last_edited_time": "2025-08-11T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi có con chuột và trình diễn đồ hoạ, con người tương tác với máy tính trực quan hơn, ta trỏ đến, ta click, double click, ta scroll, ta quét chọn, ta drag…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi có con chuột và trình diễn đồ hoạ, con người tương tác với máy tính trực quan hơn, ta trỏ đến, ta click, double click, ta scroll, ta quét chọn, ta drag…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24c5d164-78d8-8075-9ea9-cadc1772ecf6",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-11T01:45:00.000Z",
        "last_edited_time": "2025-08-11T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754878068/uxcomic-imgs/24c5d164-78d8-8075-9ea9-cadc1772ecf6.gif",
            "expiry_time": "2026-10-04T09:12:02.126Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/24c5d164-78d8-8075-9ea9-cadc1772ecf6"
      },
      {
        "object": "block",
        "id": "24c5d164-78d8-8027-9b91-f75d59d6c227",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-11T01:34:00.000Z",
        "last_edited_time": "2025-08-11T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24c5d164-78d8-80de-8ec5-c2ef5f6fbe89",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-11T01:33:00.000Z",
        "last_edited_time": "2025-08-11T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Qua đến thời kì điện thoại Nokia thì ta điều hướng bằng bàn phím bằng keyboard, các nút mũi tên lên xuống, trái phải… và nút “ok”, “back”…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Qua đến thời kì điện thoại Nokia thì ta điều hướng bằng bàn phím bằng keyboard, các nút mũi tên lên xuống, trái phải… và nút “ok”, “back”…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24c5d164-78d8-80fb-84ca-c51a10ee6ae8",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-11T01:45:00.000Z",
        "last_edited_time": "2025-08-11T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754878070/uxcomic-imgs/24c5d164-78d8-80fb-84ca-c51a10ee6ae8.jpg",
            "expiry_time": "2026-10-04T09:12:02.126Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/24c5d164-78d8-80fb-84ca-c51a10ee6ae8"
      },
      {
        "object": "block",
        "id": "24c5d164-78d8-80e5-af81-e6e3a18011e1",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-11T01:37:00.000Z",
        "last_edited_time": "2025-08-11T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24c5d164-78d8-8013-81e2-fcbaec30b38b",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-11T01:37:00.000Z",
        "last_edited_time": "2025-08-15T10:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Qua đến thời kì màn hình cảm ứng, ta có tap, swipe, long press, drag,….",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Qua đến thời kì màn hình cảm ứng, ta có tap, swipe, long press, drag,….",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24c5d164-78d8-8086-9295-c088b0e7d5a7",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-11T01:44:00.000Z",
        "last_edited_time": "2025-08-11T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754878071/uxcomic-imgs/24c5d164-78d8-8086-9295-c088b0e7d5a7.jpg",
            "expiry_time": "2026-10-04T09:12:02.127Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/24c5d164-78d8-8086-9295-c088b0e7d5a7"
      },
      {
        "object": "block",
        "id": "24c5d164-78d8-8050-9fff-c872834e24af",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-11T01:38:00.000Z",
        "last_edited_time": "2025-08-11T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2505d164-78d8-8081-9864-d733b4211197",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-15T10:45:00.000Z",
        "last_edited_time": "2025-08-15T10:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ngoài ra còn có cái dạng công nghệ hay hay như eye detecting, VUI, haptic feedback,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ngoài ra còn có cái dạng công nghệ hay hay như eye detecting, VUI, haptic feedback,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24c5d164-78d8-80f4-b9c0-dd513327d2e1",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-11T01:38:00.000Z",
        "last_edited_time": "2025-08-11T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Rồi đến các công cụ như kính VR, smart swatch, smart speaker,… cũng có những cách tương tác đặc trưng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Rồi đến các công cụ như kính VR, smart swatch, smart speaker,… cũng có những cách tương tác đặc trưng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24c5d164-78d8-8039-9c74-e5862c3abaec",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-11T01:47:00.000Z",
        "last_edited_time": "2025-08-11T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754878073/uxcomic-imgs/24c5d164-78d8-8039-9c74-e5862c3abaec.gif",
            "expiry_time": "2026-10-04T09:12:02.276Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/24c5d164-78d8-8039-9c74-e5862c3abaec"
      },
      {
        "object": "block",
        "id": "24c5d164-78d8-803c-a3bf-d0b1d6a1d499",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-11T01:41:00.000Z",
        "last_edited_time": "2025-08-11T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24c5d164-78d8-8055-900e-c3621c8e78a4",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-11T01:41:00.000Z",
        "last_edited_time": "2025-08-11T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tất cả những cách tác vụ hay những “cách giao tiếp” này ta gọi là tương tác (interaction). Nó tuỳ vào device, tuỳ vào platform, tuỳ vào cách các app define & design. Inteaction design giống như thiết kế cho một “hình thức giao tiếp” giữa người & máy.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tất cả những cách tác vụ hay những “cách giao tiếp” này ta gọi là tương tác (interaction). Nó tuỳ vào device, tuỳ vào platform, tuỳ vào cách các app define & design. Inteaction design giống như thiết kế cho một “hình thức giao tiếp” giữa người & máy.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2565d164-78d8-804c-8b83-c77bb095df50",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-21T05:58:00.000Z",
        "last_edited_time": "2025-08-21T05:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhìn chung thì có 4 thành phần sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhìn chung thì có 4 thành phần sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2565d164-78d8-8054-9509-cd0f1646d23c",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-21T05:58:00.000Z",
        "last_edited_time": "2025-08-21T05:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Flow & Navigation",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Flow & Navigation",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2565d164-78d8-8036-b294-c9be3fed0ce8",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-21T05:58:00.000Z",
        "last_edited_time": "2025-08-21T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Affordance, state & feedback",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Affordance, state & feedback",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2565d164-78d8-80a8-8873-f1cb6243afd5",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-21T05:59:00.000Z",
        "last_edited_time": "2025-08-21T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Animation & Timing",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Animation & Timing",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2565d164-78d8-804f-a095-d5b8bc689a26",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-21T05:59:00.000Z",
        "last_edited_time": "2025-08-21T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Microinteraction (touch area, trigger, response…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Microinteraction (touch area, trigger, response…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24c5d164-78d8-80be-a864-c130f65bcf4e",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-11T01:56:00.000Z",
        "last_edited_time": "2025-08-11T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "24c5d164-78d8-8049-a01b-fc470c8d3b6d",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-11T01:55:00.000Z",
        "last_edited_time": "2025-08-11T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phisolophy",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phisolophy",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-80af-a431-c68e1e0bb01d",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-07-13T04:03:00.000Z",
        "last_edited_time": "2025-08-11T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "— From Perplexity",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "— From Perplexity",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22c5d164-78d8-80c7-9555-e4f0341cc74d",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-07-10T09:00:00.000Z",
        "last_edited_time": "2025-08-11T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "The ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "The ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "philosophy of interaction design",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "philosophy of interaction design",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " explores the foundational ideas and principles guiding how interactive products and services are created to support human activities and cognition. It emphasizes that interaction design is not just about creating frictionless interfaces but about shaping users' thought processes and experiences through the design elements themselves.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " explores the foundational ideas and principles guiding how interactive products and services are created to support human activities and cognition. It emphasizes that interaction design is not just about creating frictionless interfaces but about shaping users' thought processes and experiences through the design elements themselves.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22c5d164-78d8-80c7-ad0b-c7e0cad3bd35",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-07-10T09:00:00.000Z",
        "last_edited_time": "2025-08-11T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Key points in the philosophy of interaction design include:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Key points in the philosophy of interaction design include:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22c5d164-78d8-8086-a25a-c88a09cfdf4e",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-07-10T09:00:00.000Z",
        "last_edited_time": "2025-08-11T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Interaction as part of cognition:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Interaction as part of cognition:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Designers build components that become part of the user's thinking process during interaction. For example, a spinning wheel interface element can make users actively consider their choices, integrating the interface into their decision-making rather than merely facilitating a pre-formed plan",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Designers build components that become part of the user's thinking process during interaction. For example, a spinning wheel interface element can make users actively consider their choices, integrating the interface into their decision-making rather than merely facilitating a pre-formed plan",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "1",
                "link": {
                  "url": "https://www.linkedin.com/pulse/philosophy-mind-interaction-design-reflections-ucd15-nigel-shardlow"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "1",
              "href": "https://www.linkedin.com/pulse/philosophy-mind-interaction-design-reflections-ucd15-nigel-shardlow"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22c5d164-78d8-8091-a4ba-c9a322d1e8a1",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-07-10T09:00:00.000Z",
        "last_edited_time": "2025-08-11T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "User-centered and context-aware design:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User-centered and context-aware design:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Good interaction design requires understanding users in their real environments, considering their behaviors, tools, and cognitive processes in context rather than isolated actions or survey responses. This approach aligns with ethnographic methods and supports designing interfaces that help users form plans and achieve goals",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Good interaction design requires understanding users in their real environments, considering their behaviors, tools, and cognitive processes in context rather than isolated actions or survey responses. This approach aligns with ethnographic methods and supports designing interfaces that help users form plans and achieve goals",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "1",
                "link": {
                  "url": "https://www.linkedin.com/pulse/philosophy-mind-interaction-design-reflections-ucd15-nigel-shardlow"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "1",
              "href": "https://www.linkedin.com/pulse/philosophy-mind-interaction-design-reflections-ucd15-nigel-shardlow"
            },
            {
              "type": "text",
              "text": {
                "content": "6",
                "link": {
                  "url": "http://www.wiley.com/legacy/wileychi/interactiondesign/pdf/ID_ch6.pdf"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "6",
              "href": "http://www.wiley.com/legacy/wileychi/interactiondesign/pdf/ID_ch6.pdf"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22c5d164-78d8-80ad-9b19-ceafd5eb2e23",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-07-10T09:00:00.000Z",
        "last_edited_time": "2025-08-11T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Design as creating relations and experiences:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Design as creating relations and experiences:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Interaction design is about more than functionality; it creates relationships that evoke emotions and meaningful experiences. This view suggests moving beyond traditional desktop metaphors to make technology \"invisible\" by embedding it naturally into everyday life, focusing on the purpose rather than the technology itself",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Interaction design is about more than functionality; it creates relationships that evoke emotions and meaningful experiences. This view suggests moving beyond traditional desktop metaphors to make technology \"invisible\" by embedding it naturally into everyday life, focusing on the purpose rather than the technology itself",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "3",
                "link": {
                  "url": "https://www.academia.edu/4164386/Towards_a_Philosophy_of_Interaction_Design"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3",
              "href": "https://www.academia.edu/4164386/Towards_a_Philosophy_of_Interaction_Design"
            },
            {
              "type": "text",
              "text": {
                "content": "5",
                "link": {
                  "url": "https://www.academia.edu/37739137/Philosophy_of_Interaction"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "5",
              "href": "https://www.academia.edu/37739137/Philosophy_of_Interaction"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22c5d164-78d8-80df-9bca-f2cc65cc9283",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-07-10T09:00:00.000Z",
        "last_edited_time": "2025-08-11T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Multi-disciplinary perspectives:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Multi-disciplinary perspectives:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " The philosophy of interaction design draws on formal logic, cognitive science, phenomenology, media studies, and more to understand interactivity's complexity and how users experience interactive products",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " The philosophy of interaction design draws on formal logic, cognitive science, phenomenology, media studies, and more to understand interactivity's complexity and how users experience interactive products",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "4",
                "link": {
                  "url": "https://www.interaction-design.org/literature/book/the-encyclopedia-of-human-computer-interaction-2nd-ed/philosophy-of-interaction"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "4",
              "href": "https://www.interaction-design.org/literature/book/the-encyclopedia-of-human-computer-interaction-2nd-ed/philosophy-of-interaction"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22c5d164-78d8-8090-a35a-d032ee1b7301",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-07-10T09:00:00.000Z",
        "last_edited_time": "2025-08-11T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "A guiding design philosophy:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "A guiding design philosophy:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Interaction designers develop a personal or team philosophy that guides design decisions, balancing the interests of all stakeholders and focusing on improving users' lives. This philosophy involves asking critical questions about purpose, target users, value, and problem-solving effectiveness, aligning and optimizing design elements like personas, goals, and behaviors",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Interaction designers develop a personal or team philosophy that guides design decisions, balancing the interests of all stakeholders and focusing on improving users' lives. This philosophy involves asking critical questions about purpose, target users, value, and problem-solving effectiveness, aligning and optimizing design elements like personas, goals, and behaviors",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "2",
                "link": {
                  "url": "https://www.uxmatters.com/mt/archives/2022/04/how-to-develop-your-ux-design-philosophy.php"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2",
              "href": "https://www.uxmatters.com/mt/archives/2022/04/how-to-develop-your-ux-design-philosophy.php"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22c5d164-78d8-801f-914a-c640640ebe45",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-07-10T09:00:00.000Z",
        "last_edited_time": "2025-08-11T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "In essence, the philosophy of interaction design frames the discipline as a human-centered, contextually aware, and experience-driven practice that integrates technology seamlessly into users' lives to support meaningful interaction and thought.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "In essence, the philosophy of interaction design frames the discipline as a human-centered, contextually aware, and experience-driven practice that integrates technology seamlessly into users' lives to support meaningful interaction and thought.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8096-95c2-c94ce1a1dad2",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-07-12T04:25:00.000Z",
        "last_edited_time": "2025-07-12T04:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-8172-b11f-dcdb23dbb13c",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2024-09-28T08:05:00.000Z",
        "last_edited_time": "2025-07-12T04:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thân - Tâm - Trí trong interaction",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thân - Tâm - Trí trong interaction",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22c5d164-78d8-8078-8bce-c7ba16746f3b",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-07-10T08:46:00.000Z",
        "last_edited_time": "2025-07-13T04:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754878075/uxcomic-imgs/22c5d164-78d8-8078-8bce-c7ba16746f3b.png",
            "expiry_time": "2026-10-04T09:12:02.276Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/22c5d164-78d8-8078-8bce-c7ba16746f3b"
      },
      {
        "object": "block",
        "id": "22c5d164-78d8-80f3-a4de-f9cdaa5bdf90",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-07-10T08:45:00.000Z",
        "last_edited_time": "2025-08-12T10:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754878076/uxcomic-imgs/22c5d164-78d8-80f3-a4de-f9cdaa5bdf90.png",
            "expiry_time": "2026-10-04T09:12:02.276Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/22c5d164-78d8-80f3-a4de-f9cdaa5bdf90"
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-81b0-af6b-cd578610981c",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2024-09-28T08:05:00.000Z",
        "last_edited_time": "2025-07-14T01:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tương tác tạo ra sự tác động qua lại giữa 2 bên, thì ta có thể nhóm chúng vào góc nhìn thân - tâm - trí.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tương tác tạo ra sự tác động qua lại giữa 2 bên, thì ta có thể nhóm chúng vào góc nhìn thân - tâm - trí.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8063-9f4e-f48fdcc6bb95",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-07-12T04:21:00.000Z",
        "last_edited_time": "2025-08-11T01:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thân",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thân",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " - tác động lên giác quan của user thế nào (họ cần take action gì: click, swipe, scroll, view,… và hệ thống feedback lại gì: visibility, haptic feedback, transition… chúng giúp user hiểu chuyện gì vừa xảy ra, kết quả của thao tác vừa rồi, mối liên hệ giữa các object…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " - tác động lên giác quan của user thế nào (họ cần take action gì: click, swipe, scroll, view,… và hệ thống feedback lại gì: visibility, haptic feedback, transition… chúng giúp user hiểu chuyện gì vừa xảy ra, kết quả của thao tác vừa rồi, mối liên hệ giữa các object…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-80fd-adb8-fabf6ec426f1",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-07-12T04:22:00.000Z",
        "last_edited_time": "2025-07-14T01:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trí",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trí",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " - nó tác động đến việc hiểu như thế nào, nó cost mental effort hay cognitive load, memory load ra sao (information hierarchy, content flow, words & meaning, recently items, psychology into content - frame effect, visual effects and their meaning…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " - nó tác động đến việc hiểu như thế nào, nó cost mental effort hay cognitive load, memory load ra sao (information hierarchy, content flow, words & meaning, recently items, psychology into content - frame effect, visual effects and their meaning…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8092-bbce-c7358fc83c93",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-07-12T04:23:00.000Z",
        "last_edited_time": "2025-08-11T02:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tâm",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tâm",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " - nó tác động đến cảm nhận user ra sao, họ thấy delightful hay depress, enjoyable hay frustrated, excited hay boring,… (chúng được hình thành thông qua việc hiểu context of use, mental model, user perception và tìm cách áp dụng các psychology, UX laws, UX ladder sao cho phù hợp…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " - nó tác động đến cảm nhận user ra sao, họ thấy delightful hay depress, enjoyable hay frustrated, excited hay boring,… (chúng được hình thành thông qua việc hiểu context of use, mental model, user perception và tìm cách áp dụng các psychology, UX laws, UX ladder sao cho phù hợp…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80d3-86f5-c80fa1de514f",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-14T06:00:00.000Z",
        "last_edited_time": "2025-08-14T06:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-800e-92de-da07a6a5eecf",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-14T06:00:00.000Z",
        "last_edited_time": "2025-08-14T06:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vài terms quan trọng liên quan đến interaction",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vài terms quan trọng liên quan đến interaction",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8005-aef7-df5652104ce5",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-14T06:03:00.000Z",
        "last_edited_time": "2025-08-14T06:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Từng term này hàm chứa rất nhiều kiến thức khác nên mình chỉ list ra tạm, có time sẽ ngâm cứu kĩ thêm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Từng term này hàm chứa rất nhiều kiến thức khác nên mình chỉ list ra tạm, có time sẽ ngâm cứu kĩ thêm.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80ab-8f89-fdcbbdfc7e1e",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-14T06:00:00.000Z",
        "last_edited_time": "2025-08-14T06:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Affordance",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Affordance",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-806b-aced-eb03c382560a",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-14T06:01:00.000Z",
        "last_edited_time": "2025-08-14T06:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "State",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "State",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-807c-bd57-cc98806cc4c0",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-14T06:02:00.000Z",
        "last_edited_time": "2025-08-14T06:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Command",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Command",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-801f-8d1a-c3bdd64b7105",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-14T06:01:00.000Z",
        "last_edited_time": "2025-08-14T06:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Feedback",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Feedback",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8057-8a0b-ee4da3b4383b",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-14T06:02:00.000Z",
        "last_edited_time": "2025-08-14T06:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Transition",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Transition",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8085-9be2-dcd481939b81",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-14T06:01:00.000Z",
        "last_edited_time": "2025-08-14T06:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Interactable area",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Interactable area",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80ae-8d3f-f61ddea557a1",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-14T06:01:00.000Z",
        "last_edited_time": "2025-08-14T06:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Touch zone",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Touch zone",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-806f-bed9-d36e8abb21ec",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-14T06:03:00.000Z",
        "last_edited_time": "2025-08-14T06:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Control, Gesture",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Control, Gesture",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80ea-8825-d60eb5b8d658",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-14T06:01:00.000Z",
        "last_edited_time": "2025-08-14T06:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trigger, detect & Dismiss",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trigger, detect & Dismiss",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80da-a4fe-c00ae25e0bbb",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-14T06:00:00.000Z",
        "last_edited_time": "2025-08-14T06:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "etc.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "etc.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2505d164-78d8-8065-aeb4-c48d29574877",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-15T10:04:00.000Z",
        "last_edited_time": "2025-08-15T10:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2505d164-78d8-8029-9fec-df0c0a3dcaf3",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-15T10:04:00.000Z",
        "last_edited_time": "2025-08-15T10:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ 1 case cần phải define interaction control",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ 1 case cần phải define interaction control",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2505d164-78d8-8068-b616-d668b43cd58f",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-15T10:04:00.000Z",
        "last_edited_time": "2025-08-15T10:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình hỏi GPT: “tôi đang thiết kế một interaction pattern liên quan đến việc dùng drag handle để đóng panel, làm thế nào để tôi define được khi nào thì đóng 50% panel, khi nào thì đóng 100% panel dựa theo độ mạnh nhẹ của thao tác drag của bàn tay?”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình hỏi GPT: “tôi đang thiết kế một interaction pattern liên quan đến việc dùng drag handle để đóng panel, làm thế nào để tôi define được khi nào thì đóng 50% panel, khi nào thì đóng 100% panel dựa theo độ mạnh nhẹ của thao tác drag của bàn tay?”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2505d164-78d8-801d-a4e1-f0f7d1039ac6",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-08-15T10:04:00.000Z",
        "last_edited_time": "2025-08-15T10:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [
            {
              "type": "text",
              "text": {
                "content": "chatGPT trả lời",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "chatGPT trả lời",
              "href": null
            }
          ],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755252543/uxcomic-imgs/2505d164-78d8-801d-a4e1-f0f7d1039ac6.png",
            "expiry_time": "2026-10-04T09:12:02.384Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2505d164-78d8-801d-a4e1-f0f7d1039ac6"
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-8178-a875-d7c5fd8a89ea",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2024-09-28T08:05:00.000Z",
        "last_edited_time": "2024-09-28T08:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-81e7-b728-de69ef3a46ed",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2024-09-28T08:05:00.000Z",
        "last_edited_time": "2024-09-28T08:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23c5d164-78d8-805a-8c91-f7479f406391",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2025-07-26T10:26:00.000Z",
        "last_edited_time": "2025-08-12T10:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.figma.com/resource-library/interaction-design/#interaction-design-definition",
                "link": {
                  "url": "https://www.figma.com/resource-library/interaction-design/#interaction-design-definition"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.figma.com/resource-library/interaction-design/#interaction-design-definition",
              "href": "https://www.figma.com/resource-library/interaction-design/#interaction-design-definition"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-81a3-9358-c04e3aaa9eda",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2024-09-28T08:05:00.000Z",
        "last_edited_time": "2024-09-28T08:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://uxdesign.cc/beyond-the-concept-of-form-follows-function-7bf7d2154a29",
                "link": {
                  "url": "https://uxdesign.cc/beyond-the-concept-of-form-follows-function-7bf7d2154a29"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://uxdesign.cc/beyond-the-concept-of-form-follows-function-7bf7d2154a29",
              "href": "https://uxdesign.cc/beyond-the-concept-of-form-follows-function-7bf7d2154a29"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-8103-8514-e2a9e943dfaf",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2024-09-28T08:05:00.000Z",
        "last_edited_time": "2025-07-10T08:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.interaction-design.org/literature/book/the-encyclopedia-of-human-computer-interaction-2nd-ed/philosophy-of-interaction",
                "link": {
                  "url": "https://www.interaction-design.org/literature/book/the-encyclopedia-of-human-computer-interaction-2nd-ed/philosophy-of-interaction"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.interaction-design.org/literature/book/the-encyclopedia-of-human-computer-interaction-2nd-ed/philosophy-of-interaction",
              "href": "https://www.interaction-design.org/literature/book/the-encyclopedia-of-human-computer-interaction-2nd-ed/philosophy-of-interaction"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-81e9-9da0-f89ff91d6ab7",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2024-09-28T08:05:00.000Z",
        "last_edited_time": "2024-09-28T08:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-8190-8cf6-c405fd1b5a0e",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2024-09-28T08:05:00.000Z",
        "last_edited_time": "2024-09-28T08:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-81c2-a841-d55869f92a4f",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2024-09-28T08:05:00.000Z",
        "last_edited_time": "2025-07-12T04:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Interaction Pattern",
              "href": "https://app.notion.com/p/56798be37f484cfea30e49cc2dedd33d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-816f-8320-e1beb0bdc159",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
        },
        "created_time": "2024-09-28T08:05:00.000Z",
        "last_edited_time": "2025-07-12T04:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User Journey map, User scenario, Task flow, User flow",
              "href": "https://app.notion.com/p/1155d16478d880a883a6ec9db47fe4dc"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e",
    "created_time": "2024-09-28T07:46:00.000Z",
    "last_edited_time": "2024-12-31T02:06:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "fd3cd36d-73dd-4dee-8bd5-d159d6600124"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "View": {
        "id": "ATSa",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "A%5Bqc",
        "type": "select",
        "select": {
          "id": "\\i@K",
          "name": "⚓:1",
          "color": "pink"
        }
      },
      "Last edited time": {
        "id": "DMgm",
        "type": "last_edited_time",
        "last_edited_time": "2024-12-31T02:06:00.000Z"
      },
      "Publish": {
        "id": "FSnx",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "_tsp",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "g%7BBg",
        "type": "created_time",
        "created_time": "2024-09-28T07:46:00.000Z"
      },
      "Share": {
        "id": "hp~_",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "m%7C%40x",
        "type": "number",
        "number": null
      },
      "Formula": {
        "id": "re%3BE",
        "type": "formula",
        "formula": {
          "type": "number",
          "number": 1
        }
      },
      "Tag": {
        "id": "%7CAvQ",
        "type": "select",
        "select": {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "1-Product",
          "color": "default"
        }
      },
      "ID": {
        "id": "~RYT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FD",
          "number": 7
        }
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Cái ghế & Product",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Cái ghế & Product",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/C-i-gh-Product-10f5d16478d8809abbf5ec2e471cf60e",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "5cacdbff-b9e2-4973-b565-ec1ae4327ec9",
      "name": "Fundamental",
      "slug": "fundamental",
      "icon": "🌞",
      "order": 2,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "Product",
          "slug": "product",
          "order": 1
        },
        {
          "id": "156ef770-14db-4170-b1d7-95a2fbdf62ba",
          "name": "User",
          "slug": "user",
          "order": 2
        },
        {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "Design",
          "slug": "design",
          "order": 3
        },
        {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "Random",
          "slug": "random",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
      "name": "Product",
      "slug": "product",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "1105d164-78d8-80a5-9fcf-d7ec8f453ce8",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-09-29T14:58:00.000Z",
        "last_edited_time": "2024-10-20T14:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081490/uxcomic-imgs/1105d164-78d8-80a5-9fcf-d7ec8f453ce8.png",
            "expiry_time": "2026-10-04T09:12:05.090Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1105d164-78d8-80a5-9fcf-d7ec8f453ce8"
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8060-af32-ebd243c271db",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-10-18T03:11:00.000Z",
        "last_edited_time": "2024-10-18T03:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một hôm tình cờ mình nghĩ về câu hỏi này đã giúp mình hiểu thêm chút về khái niệm product.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một hôm tình cờ mình nghĩ về câu hỏi này đã giúp mình hiểu thêm chút về khái niệm product.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-8125-a556-de23b8f05fd0",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-09-28T07:46:00.000Z",
        "last_edited_time": "2024-09-29T14:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tại sao lại có nhiều loại ghế trên thế giới vậy nhể? Cũng là để ngồi thôi mà.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tại sao lại có nhiều loại ghế trên thế giới vậy nhể? Cũng là để ngồi thôi mà.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "🤔"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80b3-a117-ff5e361e1971",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-12-30T16:04:00.000Z",
        "last_edited_time": "2024-12-30T16:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "c0550daa-11a9-4a18-9ae7-0fd0c4964d65",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-09-30T02:09:00.000Z",
        "last_edited_time": "2024-10-18T03:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cái ghế",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cái ghế",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d38090e-931d-4c34-bd75-18d238960056",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-09-28T07:46:00.000Z",
        "last_edited_time": "2024-09-30T02:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chúng ta cần một cái ghế để ngồi, nhưng thử đếm xem nào, một ngày của bạn đã ngồi được bao nhiêu loại ghế?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chúng ta cần một cái ghế để ngồi, nhưng thử đếm xem nào, một ngày của bạn đã ngồi được bao nhiêu loại ghế?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-81b1-a229-c88bb4743b85",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-09-28T07:46:00.000Z",
        "last_edited_time": "2024-10-06T07:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sáng sớm mình hay làm ly cafe +1 ghế, sau đó lên văn phòng +1 ghế, trưa mình nằm ghế lười để ngủ miếng +1 ghế, tối về ăn cơm +1 ghế. Và cùng là ngồi nhưng mình đã có 4 loại ghế thường dùng đến.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sáng sớm mình hay làm ly cafe +1 ghế, sau đó lên văn phòng +1 ghế, trưa mình nằm ghế lười để ngủ miếng +1 ghế, tối về ăn cơm +1 ghế. Và cùng là ngồi nhưng mình đã có 4 loại ghế thường dùng đến.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80c3-b9ac-ef262f7e9639",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-12-30T16:01:00.000Z",
        "last_edited_time": "2024-12-31T02:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081493/uxcomic-imgs/16c5d164-78d8-80c3-b9ac-ef262f7e9639.png",
            "expiry_time": "2026-10-04T09:12:05.090Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/16c5d164-78d8-80c3-b9ac-ef262f7e9639"
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80f2-98b8-e5ce694ae0d5",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-10-18T03:12:00.000Z",
        "last_edited_time": "2024-12-21T10:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ghế ngồi cafe: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ghế ngồi cafe: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "mình hay ngồi mấy quán cốc và thích ngồi ngoài đường, mình nhận ra nhu cầu cũng không cần cao, chỉ cần ngồi êm êm, mát mẻ là được.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "mình hay ngồi mấy quán cốc và thích ngồi ngoài đường, mình nhận ra nhu cầu cũng không cần cao, chỉ cần ngồi êm êm, mát mẻ là được.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8094-8fdd-ed4398864a36",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-10-18T03:35:00.000Z",
        "last_edited_time": "2024-12-21T10:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ghế văn phòng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ghế văn phòng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": mình cần chiếc ghế có thể ngồi hàng tiếng đồng hồ, bảo vệ được cột sống của mình.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": mình cần chiếc ghế có thể ngồi hàng tiếng đồng hồ, bảo vệ được cột sống của mình.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80df-bae9-ee6bccdd4c59",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-10-18T03:36:00.000Z",
        "last_edited_time": "2024-12-21T10:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ghế lười:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ghế lười:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " thật ra mình cần nằm thoải mái cho giấc ngủ trưa, ghế lười form nó rất flexible nên giúp mình nằm được, và do khu vực để ghế lười ở công ty mình có cái hiên phía trên cho ánh sáng lọt vào, nên mình cũng có nhu cầu chuyển vị trí của nó để tránh sáng cho đỡ chói mắt & ghế này cũng nhẹ, dễ di chuyển.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " thật ra mình cần nằm thoải mái cho giấc ngủ trưa, ghế lười form nó rất flexible nên giúp mình nằm được, và do khu vực để ghế lười ở công ty mình có cái hiên phía trên cho ánh sáng lọt vào, nên mình cũng có nhu cầu chuyển vị trí của nó để tránh sáng cho đỡ chói mắt & ghế này cũng nhẹ, dễ di chuyển.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-807b-a8da-db43216b1d69",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-10-18T03:39:00.000Z",
        "last_edited_time": "2024-12-21T10:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ghế dùng ở bếp:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ghế dùng ở bếp:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " mình đang dùng ghế nhựa, thứ mình consider chính là nó dễ lau chùi, vì rất dễ rớt đồ ăn, các sốt lên đó, mình không muốn nó dễ bị bám màu, khó vệ sinh.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " mình đang dùng ghế nhựa, thứ mình consider chính là nó dễ lau chùi, vì rất dễ rớt đồ ăn, các sốt lên đó, mình không muốn nó dễ bị bám màu, khó vệ sinh.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "a727d5ce-c3a7-412c-ab1d-c5d4c36a43aa",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-09-30T01:44:00.000Z",
        "last_edited_time": "2024-10-21T02:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Như vậy có thể thấy 4 loại ghế phục vụ cho mục đích, ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Như vậy có thể thấy 4 loại ghế phục vụ cho mục đích, ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "context sử dụng khác nhau. ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "context sử dụng khác nhau. ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Cũng là để ngồi thôi, mà lại có rất nhiều cách ngồi và ngữ cảnh sử dụng chúng khác nhau, những yếu tố môi trường cũng tác động lên việc hình thành nhu cầu khác ngoài ngồi.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cũng là để ngồi thôi, mà lại có rất nhiều cách ngồi và ngữ cảnh sử dụng chúng khác nhau, những yếu tố môi trường cũng tác động lên việc hình thành nhu cầu khác ngoài ngồi.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-804c-bb6e-c0e9a3e80679",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-10-18T03:41:00.000Z",
        "last_edited_time": "2024-10-18T03:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khía cạnh khác",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khía cạnh khác",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "361957e3-3e8e-496f-b89e-8de7047c6749",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-09-30T01:47:00.000Z",
        "last_edited_time": "2024-10-18T03:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Và đôi khi ngoài mục đích sử dụng của người dùng, phía chủ cửa tiệm như quán cafe có thêm nhu cầu khác, ví dụ chiếc ghế để ngồi ngoài trời, họ cần thu dọn nó mỗi ngày khi đóng tiệm, một chiếc ghế nhẹ, gắp được tất nhiên sẽ tốt hơn một chiếc ghế nặng và phải khiên từng cái một >> ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Và đôi khi ngoài mục đích sử dụng của người dùng, phía chủ cửa tiệm như quán cafe có thêm nhu cầu khác, ví dụ chiếc ghế để ngồi ngoài trời, họ cần thu dọn nó mỗi ngày khi đóng tiệm, một chiếc ghế nhẹ, gắp được tất nhiên sẽ tốt hơn một chiếc ghế nặng và phải khiên từng cái một >> ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "nhu cầu của người mua ghế sẽ khác",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "nhu cầu của người mua ghế sẽ khác",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "ab100228-6266-4ae2-be69-ad4cbd41e4af",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-09-30T01:49:00.000Z",
        "last_edited_time": "2024-10-21T02:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chưa kể đến phía công ty sản xuất ghế họ còn phải cân nhắc việc tối ưu chi phí, các công nghệ hiện có để có thể sản xuất, khi vận chuyển làm sao để hiệu quả… >> ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chưa kể đến phía công ty sản xuất ghế họ còn phải cân nhắc việc tối ưu chi phí, các công nghệ hiện có để có thể sản xuất, khi vận chuyển làm sao để hiệu quả… >> ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "yêu cầu của phía sản xuất lại khác",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "yêu cầu của phía sản xuất lại khác",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-803d-aba6-d2f1ff7c4555",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-10-18T03:50:00.000Z",
        "last_edited_time": "2024-10-21T02:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "af9bb377-9150-4e52-85e2-e8c2ca38ab5c",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-10-18T03:51:00.000Z",
        "last_edited_time": "2024-12-17T04:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tóm lại",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tóm lại",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8076-973e-c12345c07cb9",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-10-18T03:51:00.000Z",
        "last_edited_time": "2024-11-22T10:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sự quan sát này cho thấy một chiếc ghế được hình thành tuỳ thuộc vào rất nhiều khía cạnh. Đúng là chỉ để ngồi, mà cách chúng ta ngồi khác nhau, và nhu cầu không chỉ là ngồi, còn lại các thứ xoay quanh như dễ lau chùi, dễ di chuyển, dễ sản xuất…Đó là sự biến đổi A+B = ghế 1, B+C = ghế 2… sự thú vị product là nằm ở ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sự quan sát này cho thấy một chiếc ghế được hình thành tuỳ thuộc vào rất nhiều khía cạnh. Đúng là chỉ để ngồi, mà cách chúng ta ngồi khác nhau, và nhu cầu không chỉ là ngồi, còn lại các thứ xoay quanh như dễ lau chùi, dễ di chuyển, dễ sản xuất…Đó là sự biến đổi A+B = ghế 1, B+C = ghế 2… sự thú vị product là nằm ở ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "it’s depends, ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "it’s depends, ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "rõ ràng về các nhu cầu, khả năng, hiểu về ngữ cảnh tình huống sử dụng sẽ giúp thiết kế được chiếc ghế phù hợp hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "rõ ràng về các nhu cầu, khả năng, hiểu về ngữ cảnh tình huống sử dụng sẽ giúp thiết kế được chiếc ghế phù hợp hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8063-82cf-fb7e9551bce7",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-10-18T03:57:00.000Z",
        "last_edited_time": "2024-10-18T03:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081495/uxcomic-imgs/1235d164-78d8-8063-82cf-fb7e9551bce7.png",
            "expiry_time": "2026-10-04T09:12:05.091Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1235d164-78d8-8063-82cf-fb7e9551bce7"
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-8181-9fe5-f4c3638503b4",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-09-28T07:46:00.000Z",
        "last_edited_time": "2024-09-28T07:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-81a8-a358-d7c407d910eb",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-09-28T07:46:00.000Z",
        "last_edited_time": "2024-09-28T07:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-814f-bd9e-f38b66511a2b",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-09-28T07:46:00.000Z",
        "last_edited_time": "2024-09-30T02:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://hoang.moe/product-o-geek-up/",
                "link": {
                  "url": "https://hoang.moe/product-o-geek-up/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://hoang.moe/product-o-geek-up/",
              "href": "https://hoang.moe/product-o-geek-up/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-819e-8fc7-f24797b073dd",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-09-28T07:46:00.000Z",
        "last_edited_time": "2024-09-28T07:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-8123-9bbf-f69e8b043c86",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-09-28T07:46:00.000Z",
        "last_edited_time": "2024-09-28T07:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1b4d0029-3ab1-41f9-90c9-4971a66717dc",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-12-21T10:25:00.000Z",
        "last_edited_time": "2024-12-21T10:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product là gì?",
              "href": "https://app.notion.com/p/22f4879b78c641f4ac922219ca7879f2"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "a6fde4fa-b8a1-444a-b71c-6afe4fb44ea9",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-12-21T10:25:00.000Z",
        "last_edited_time": "2024-12-21T10:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1605d164-78d8-80ad-9130-fe44c6663146"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Value vs Benefit",
              "href": "https://app.notion.com/p/1605d16478d880ad9130fe44c6663146"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-81dd-9cfb-f99f78e6a234",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
        },
        "created_time": "2024-09-28T07:46:00.000Z",
        "last_edited_time": "2024-10-12T09:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "c066dc23-043d-44af-925d-1f71f899090a"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Digital vs Physical product",
              "href": "https://app.notion.com/p/c066dc23043d44af925d1f71f899090a"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1025d164-78d8-80c5-891f-debd0fc09547",
    "created_time": "2024-09-15T05:42:00.000Z",
    "last_edited_time": "2025-02-25T02:08:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "fd3cd36d-73dd-4dee-8bd5-d159d6600124"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "View": {
        "id": "ATSa",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "A%5Bqc",
        "type": "select",
        "select": {
          "id": "Blq|",
          "name": "⚓:2",
          "color": "green"
        }
      },
      "Last edited time": {
        "id": "DMgm",
        "type": "last_edited_time",
        "last_edited_time": "2025-02-25T02:08:00.000Z"
      },
      "Publish": {
        "id": "FSnx",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "_tsp",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "g%7BBg",
        "type": "created_time",
        "created_time": "2024-09-15T05:42:00.000Z"
      },
      "Share": {
        "id": "hp~_",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "m%7C%40x",
        "type": "number",
        "number": null
      },
      "Formula": {
        "id": "re%3BE",
        "type": "formula",
        "formula": {
          "type": "number",
          "number": 1
        }
      },
      "Tag": {
        "id": "%7CAvQ",
        "type": "select",
        "select": {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "1-Product",
          "color": "default"
        }
      },
      "ID": {
        "id": "~RYT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FD",
          "number": 6
        }
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Product development process (detail)",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Product development process (detail)",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Product-development-process-detail-1025d16478d880c5891fdebd0fc09547",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "5cacdbff-b9e2-4973-b565-ec1ae4327ec9",
      "name": "Fundamental",
      "slug": "fundamental",
      "icon": "🌞",
      "order": 2,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "Product",
          "slug": "product",
          "order": 1
        },
        {
          "id": "156ef770-14db-4170-b1d7-95a2fbdf62ba",
          "name": "User",
          "slug": "user",
          "order": 2
        },
        {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "Design",
          "slug": "design",
          "order": 3
        },
        {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "Random",
          "slug": "random",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
      "name": "Product",
      "slug": "product",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "1305d164-78d8-802b-96f1-e456014c8592",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T11:43:00.000Z",
        "last_edited_time": "2024-11-20T15:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081499/uxcomic-imgs/1305d164-78d8-802b-96f1-e456014c8592.png",
            "expiry_time": "2026-10-04T09:12:05.887Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1305d164-78d8-802b-96f1-e456014c8592"
      },
      {
        "object": "block",
        "id": "1025d164-78d8-80f4-94af-c4d58382c047",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-09-15T05:43:00.000Z",
        "last_edited_time": "2025-01-12T03:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Disclaimer:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Disclaimer:",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "1345d164-78d8-80b3-88dd-de2bba81b3a7",
            "parent": {
              "type": "block_id",
              "block_id": "1025d164-78d8-80f4-94af-c4d58382c047"
            },
            "created_time": "2024-11-04T11:02:00.000Z",
            "last_edited_time": "2024-11-23T05:55:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "The process is not a fixed recipe; it always adapts to the specific objectives and situations at hand.",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "The process is not a fixed recipe; it always adapts to the specific objectives and situations at hand.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1345d164-78d8-8045-876c-c727d1b211b6",
            "parent": {
              "type": "block_id",
              "block_id": "1025d164-78d8-80f4-94af-c4d58382c047"
            },
            "created_time": "2024-11-04T11:02:00.000Z",
            "last_edited_time": "2024-11-23T05:56:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Processes are designed to minimize errors and optimize effort, but they can sometimes hinder creativity.",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Processes are designed to minimize errors and optimize effort, but they can sometimes hinder creativity.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "12f5d164-78d8-80fe-869d-de27bcd0abb5",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-30T02:37:00.000Z",
        "last_edited_time": "2024-11-02T05:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081500/uxcomic-imgs/12f5d164-78d8-80fe-869d-de27bcd0abb5.png",
            "expiry_time": "2026-10-04T09:12:05.887Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/12f5d164-78d8-80fe-869d-de27bcd0abb5"
      },
      {
        "object": "block",
        "id": "1325d164-78d8-8021-8faa-e4b2abc58293",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-11-02T05:56:00.000Z",
        "last_edited_time": "2024-11-02T05:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-809a-913b-de1c5c8315f5",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T03:21:00.000Z",
        "last_edited_time": "2025-01-12T03:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "0. Problem gathering",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "0. Problem gathering",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12f5d164-78d8-8008-ab4e-e3b166437099",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-30T01:44:00.000Z",
        "last_edited_time": "2024-11-25T02:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chúng ta đã nghe rất nhiều về việc design là problem solving, nhưng problem ở đâu mà ra?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chúng ta đã nghe rất nhiều về việc design là problem solving, nhưng problem ở đâu mà ra?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12f5d164-78d8-8033-84cd-c37d682cdaf8",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-30T01:44:00.000Z",
        "last_edited_time": "2024-11-04T11:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Theo mình thấy thì problem xuất phát từ 2 nguồn:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Theo mình thấy thì problem xuất phát từ 2 nguồn:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-808d-8c80-d969cb476462",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T03:34:00.000Z",
        "last_edited_time": "2025-01-10T03:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12f5d164-78d8-8044-b4c8-e3fc3ee1087f",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-30T01:50:00.000Z",
        "last_edited_time": "2025-01-10T03:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Từ những gì sản phẩm chưa có (đàng ngoài):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Từ những gì sản phẩm chưa có (đàng ngoài):",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "1775d164-78d8-80a5-9eaa-fe1ff807b732",
            "parent": {
              "type": "block_id",
              "block_id": "12f5d164-78d8-8044-b4c8-e3fc3ee1087f"
            },
            "created_time": "2025-01-10T03:14:00.000Z",
            "last_edited_time": "2025-01-12T03:18:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Quan sát user + những sáng kiến mới… Nếu công ty nhìn thấy giá trị của việc giải quyết problem đó >> nó sẽ biến thành ",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Quan sát user + những sáng kiến mới… Nếu công ty nhìn thấy giá trị của việc giải quyết problem đó >> nó sẽ biến thành ",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": "cơ hội",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "cơ hội",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": " kinh doanh.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": " kinh doanh.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 0
          },
          {
            "object": "block",
            "id": "1775d164-78d8-80e3-a9dc-e7f4c1c8c001",
            "parent": {
              "type": "block_id",
              "block_id": "12f5d164-78d8-8044-b4c8-e3fc3ee1087f"
            },
            "created_time": "2025-01-10T03:14:00.000Z",
            "last_edited_time": "2025-01-12T03:19:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Quan sát đối thủ & thấy cần bắt kịp thị trường >> đảm bảo tính cạnh tranh. Note: một sai lầm hay thấy là mình quan sát đối thủ có gì & muốn làm theo nhưng lại không phân tích sâu, đừng quên mọi problem ta lựa chọn để giải quyết đều cần align với strategy, với value proposition (",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Quan sát đối thủ & thấy cần bắt kịp thị trường >> đảm bảo tính cạnh tranh. Note: một sai lầm hay thấy là mình quan sát đối thủ có gì & muốn làm theo nhưng lại không phân tích sâu, đừng quên mọi problem ta lựa chọn để giải quyết đều cần align với strategy, với value proposition (",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": "xem thêm ở bài này)",
                    "link": {
                      "url": "/1445d16478d8805bb388e24b5f13cccb"
                    }
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "xem thêm ở bài này)",
                  "href": "/1445d16478d8805bb388e24b5f13cccb"
                },
                {
                  "type": "text",
                  "text": {
                    "content": ".",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": ".",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 1
          }
        ]
      },
      {
        "object": "block",
        "id": "1775d164-78d8-8060-938a-ef60e12df9a0",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T03:34:00.000Z",
        "last_edited_time": "2025-01-10T03:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12f5d164-78d8-80ac-97c3-c6860314cced",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-30T01:54:00.000Z",
        "last_edited_time": "2025-01-10T03:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Từ những gì sản phẩm đang có (đàng trong):",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Từ những gì sản phẩm đang có (đàng trong):",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "1775d164-78d8-8044-b92d-d883835cd8a7",
            "parent": {
              "type": "block_id",
              "block_id": "12f5d164-78d8-80ac-97c3-c6860314cced"
            },
            "created_time": "2025-01-10T03:16:00.000Z",
            "last_edited_time": "2025-01-10T03:19:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Qua quá trình tracking và quan sát, nhận phản hồi từ user >> ta sẽ phát hiện thêm được những problem mới, nó có thể liên quan đến việc improve hay enhance một khía cạnh nào đó. ",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Qua quá trình tracking và quan sát, nhận phản hồi từ user >> ta sẽ phát hiện thêm được những problem mới, nó có thể liên quan đến việc improve hay enhance một khía cạnh nào đó. ",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 0
          },
          {
            "object": "block",
            "id": "1775d164-78d8-80c4-a958-c26619ba35e6",
            "parent": {
              "type": "block_id",
              "block_id": "12f5d164-78d8-80ac-97c3-c6860314cced"
            },
            "created_time": "2025-01-10T03:16:00.000Z",
            "last_edited_time": "2025-01-12T03:19:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Hoặc đôi khi chỉ nhầm phục vụ cho nội bộ doanh nghiệp như để đảm bảo về mặt security, privacy, legal… hoặc giảm tải sever, thay đổi resource, thay đổi strategy…",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Hoặc đôi khi chỉ nhầm phục vụ cho nội bộ doanh nghiệp như để đảm bảo về mặt security, privacy, legal… hoặc giảm tải sever, thay đổi resource, thay đổi strategy…",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 1
          }
        ]
      },
      {
        "object": "block",
        "id": "1305d164-78d8-8095-ac9f-ceafe8b705b9",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T04:02:00.000Z",
        "last_edited_time": "2024-10-31T04:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081502/uxcomic-imgs/1305d164-78d8-8095-ac9f-ceafe8b705b9.png",
            "expiry_time": "2026-10-04T09:12:05.887Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1305d164-78d8-8095-ac9f-ceafe8b705b9"
      },
      {
        "object": "block",
        "id": "1775d164-78d8-8073-8aef-dc239d3cf860",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T03:38:00.000Z",
        "last_edited_time": "2025-01-12T03:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: khi gather một đóng các problem, ta sẽ cần một bước filter - đánh giá xem đâu là cái mình sẽ lựa chọn để giải quyết, ta gọi việc này là strategy - lựa chọn (",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: khi gather một đóng các problem, ta sẽ cần một bước filter - đánh giá xem đâu là cái mình sẽ lựa chọn để giải quyết, ta gọi việc này là strategy - lựa chọn (",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "xem thêm bài này",
                "link": {
                  "url": "/1445d16478d8805bb388e24b5f13cccb"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "xem thêm bài này",
              "href": "/1445d16478d8805bb388e24b5f13cccb"
            },
            {
              "type": "text",
              "text": {
                "content": ").",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ").",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-8061-aafd-d3fe714ac90e",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T03:20:00.000Z",
        "last_edited_time": "2025-01-10T03:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "12f5d164-78d8-80f5-a670-daab2ae7017c",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-30T01:49:00.000Z",
        "last_edited_time": "2025-01-12T03:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "1. Problem investigate",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "1. Problem investigate",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-8080-9073-df6a46c4b9cd",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T03:40:00.000Z",
        "last_edited_time": "2025-01-10T04:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau khi đã chọn được vấn đề để giải quyết. Ở phase này, ta sẽ đi đào sâu thêm, collect thêm thông tin xoay quanh vấn đề đó ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau khi đã chọn được vấn đề để giải quyết. Ở phase này, ta sẽ đi đào sâu thêm, collect thêm thông tin xoay quanh vấn đề đó ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "càng nhiều càng tốt, ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "càng nhiều càng tốt, ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "các thông tin này nên được quan sát dưới góc độ rất raw (fact), là những gì mình thuần tuý quan sát được, chưa cần phải phân tích quá sâu.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "các thông tin này nên được quan sát dưới góc độ rất raw (fact), là những gì mình thuần tuý quan sát được, chưa cần phải phân tích quá sâu.",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-8027-ae8f-e190e17709f4",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T04:10:00.000Z",
        "last_edited_time": "2025-01-10T04:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thông tin này giúp xác định rõ vấn đề để giải quyết ở bước 2.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thông tin này giúp xác định rõ vấn đề để giải quyết ở bước 2.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1765d164-78d8-8029-a9d8-d8d8e2a4ff5f",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-09T16:50:00.000Z",
        "last_edited_time": "2025-01-10T04:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách để investigate thêm thì sẽ có 2 nguồn: quantitative & qualitative data.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách để investigate thêm thì sẽ có 2 nguồn: quantitative & qualitative data.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-800e-b981-c2f8820f69a7",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T04:13:00.000Z",
        "last_edited_time": "2025-01-10T04:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081504/uxcomic-imgs/1775d164-78d8-800e-b981-c2f8820f69a7.png",
            "expiry_time": "2026-10-04T09:12:05.888Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1775d164-78d8-800e-b981-c2f8820f69a7"
      },
      {
        "object": "block",
        "id": "12f5d164-78d8-80c5-9e13-fabf585871bb",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-30T02:01:00.000Z",
        "last_edited_time": "2024-10-30T02:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "12f5d164-78d8-8088-894b-c0aded92f40a",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-30T02:01:00.000Z",
        "last_edited_time": "2025-01-12T03:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "2. Problem definition (framing)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2. Problem definition (framing)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1485d164-78d8-8081-8230-c892de839e39",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-11-24T06:45:00.000Z",
        "last_edited_time": "2025-01-10T04:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là quá trình xác định và làm rõ bản chất của một vấn đề cụ thể nhằm hiểu sâu và toàn diện về nó. Sự xác định này nên cover được các khía cạnh sau: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là quá trình xác định và làm rõ bản chất của một vấn đề cụ thể nhằm hiểu sâu và toàn diện về nó. Sự xác định này nên cover được các khía cạnh sau: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "bối cảnh, vấn đề, ảnh hưởng đến ai, ảnh hưởng ra sao & mục tiêu sau khi giải quyết vấn đề này là gì.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "bối cảnh, vấn đề, ảnh hưởng đến ai, ảnh hưởng ra sao & mục tiêu sau khi giải quyết vấn đề này là gì.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-80e5-b3f7-e55c3cb0c3af",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T04:18:00.000Z",
        "last_edited_time": "2025-01-10T04:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lưu ý: khi định nghĩa vấn đề tránh đề cập đến giải pháp, định nghĩa ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lưu ý: khi định nghĩa vấn đề tránh đề cập đến giải pháp, định nghĩa ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "càng cụ thể càng tốt",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "càng cụ thể càng tốt",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", nếu được thì nên đi kèm dữ liệu hoặc minh chứng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", nếu được thì nên đi kèm dữ liệu hoặc minh chứng.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "🤨"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-804c-8847-d3c8481861f5",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T04:24:00.000Z",
        "last_edited_time": "2025-01-10T04:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1485d164-78d8-8063-a29e-c1aadeb010ee",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-11-24T06:56:00.000Z",
        "last_edited_time": "2024-11-24T06:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1485d164-78d8-809f-9419-e7277fc1c918",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-11-24T06:58:00.000Z",
        "last_edited_time": "2025-01-10T04:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "❌ Sai: \"Chúng ta cần xây dựng một chatbot để cải thiện dịch vụ khách hàng.\"",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "❌ Sai: \"Chúng ta cần xây dựng một chatbot để cải thiện dịch vụ khách hàng.\"",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1485d164-78d8-805a-8bf1-f56d59326a74",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-11-24T06:58:00.000Z",
        "last_edited_time": "2025-01-10T04:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "✅ Đúng: \"Thời gian phản hồi của đội ngũ hỗ trợ khách hàng hiện tại quá chậm (trung bình 48 giờ), dẫn đến giảm mức độ hài lòng của khách hàng xuống dưới 70%.\"",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "✅ Đúng: \"Thời gian phản hồi của đội ngũ hỗ trợ khách hàng hiện tại quá chậm (trung bình 48 giờ), dẫn đến giảm mức độ hài lòng của khách hàng xuống dưới 70%.\"",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-80de-8c25-d2082e4bef2b",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T04:23:00.000Z",
        "last_edited_time": "2025-01-10T04:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1485d164-78d8-8026-b58b-eadfcc0ae37d",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-11-24T06:58:00.000Z",
        "last_edited_time": "2025-01-10T04:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "❌ Sai: \"Hệ thống của chúng ta không hoạt động tốt.\"",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "❌ Sai: \"Hệ thống của chúng ta không hoạt động tốt.\"",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1485d164-78d8-8035-837e-ee992a87d5e0",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-11-24T06:58:00.000Z",
        "last_edited_time": "2025-01-10T04:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "✅ Đúng: \"Hệ thống hiện gặp lỗi ở bước thanh toán, khiến 20% giao dịch bị hủy bỏ trong tháng qua.\"",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "✅ Đúng: \"Hệ thống hiện gặp lỗi ở bước thanh toán, khiến 20% giao dịch bị hủy bỏ trong tháng qua.\"",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-808b-ae3a-fdfd60835c0d",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T04:23:00.000Z",
        "last_edited_time": "2025-01-10T04:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1485d164-78d8-8039-987b-de7b460b1fd4",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-11-24T06:58:00.000Z",
        "last_edited_time": "2025-01-10T04:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "❌ Sai: \"Người dùng không thích ứng dụng của chúng ta.\"",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "❌ Sai: \"Người dùng không thích ứng dụng của chúng ta.\"",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1485d164-78d8-8073-80f4-c38ae3401e4f",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-11-24T06:58:00.000Z",
        "last_edited_time": "2025-01-10T04:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "✅ Đúng: \"Tỷ lệ gỡ cài đặt ứng dụng tăng 30% trong vòng 1 tháng sau khi phát hành phiên bản mới.\"",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "✅ Đúng: \"Tỷ lệ gỡ cài đặt ứng dụng tăng 30% trong vòng 1 tháng sau khi phát hành phiên bản mới.\"",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15b5d164-78d8-8047-ba85-ee84e3936643",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-12-13T02:19:00.000Z",
        "last_edited_time": "2024-12-13T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12f5d164-78d8-80ea-9616-cc3fec7b8928",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-30T01:56:00.000Z",
        "last_edited_time": "2025-01-10T04:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tactics để đào & phân tích vấn đề:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tactics để đào & phân tích vấn đề:",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15b5d164-78d8-80bf-8691-e5edb96a7e0a",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-12-13T05:15:00.000Z",
        "last_edited_time": "2024-12-13T05:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "5whys:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "5whys:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " để bạn hiểu sâu, tìm gốc rễ vấn đề.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " để bạn hiểu sâu, tìm gốc rễ vấn đề.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15b5d164-78d8-8081-999a-eaea36b176fa",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-12-13T05:15:00.000Z",
        "last_edited_time": "2024-12-13T05:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Fishbone: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Fishbone: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "để bạn hiểu các yếu tố xung quanh tác động đến vấn đề.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "để bạn hiểu các yếu tố xung quanh tác động đến vấn đề.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15b5d164-78d8-807a-8a2e-d8a175ee5892",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-12-13T05:15:00.000Z",
        "last_edited_time": "2024-12-13T05:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Problem statement canvas: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Problem statement canvas: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "để",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "để",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "có cái nhìn hệ thống xoay quanh vấn đề.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "có cái nhìn hệ thống xoay quanh vấn đề.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1325d164-78d8-80e3-a7ed-f06336c1436f",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-11-02T06:18:00.000Z",
        "last_edited_time": "2024-12-13T05:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhiệm vụ quan trọng là phân biệt “triệu chứng & căn bệnh”. ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhiệm vụ quan trọng là phân biệt “triệu chứng & căn bệnh”. ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Vì có khi vấn đề đang gặp chỉ là do tác động hoặc là hệ quả của một vấn đề khác.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vì có khi vấn đề đang gặp chỉ là do tác động hoặc là hệ quả của một vấn đề khác.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-80fc-b0f4-cc215b9f3c7a",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T04:20:00.000Z",
        "last_edited_time": "2025-01-10T04:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081508/uxcomic-imgs/1775d164-78d8-80fc-b0f4-cc215b9f3c7a.png",
            "expiry_time": "2026-10-04T09:12:05.956Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1775d164-78d8-80fc-b0f4-cc215b9f3c7a"
      },
      {
        "object": "block",
        "id": "1775d164-78d8-809b-933c-f41a17652263",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T04:20:00.000Z",
        "last_edited_time": "2025-01-10T04:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1325d164-78d8-8036-87f3-e5d8080540cc",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-11-02T04:12:00.000Z",
        "last_edited_time": "2025-01-12T03:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "🤡 ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "🤡 ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Độ rõ ràng vs assumption",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Độ rõ ràng vs assumption",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-80ca-8351-ed480ef2bf51",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T04:20:00.000Z",
        "last_edited_time": "2025-01-10T04:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuy nhiên trong quá trình define problem, sẽ có những lúc thông tin xoay quanh problem không rõ ràng, thiếu dẫn chứng, tồn tại nhiều ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuy nhiên trong quá trình define problem, sẽ có những lúc thông tin xoay quanh problem không rõ ràng, thiếu dẫn chứng, tồn tại nhiều ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "assumption",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "assumption",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ". Vậy mình research thêm như thế nào & bao nhiêu là đủ? Bạn có thể tham khảo matrix này của bên Dovetail.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". Vậy mình research thêm như thế nào & bao nhiêu là đủ? Bạn có thể tham khảo matrix này của bên Dovetail.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1305d164-78d8-803b-8e63-d6d5aed3e686",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T13:16:00.000Z",
        "last_edited_time": "2024-11-02T04:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [
            {
              "type": "text",
              "text": {
                "content": "https://dovetail.com/outlier/roadmap-to-insights/",
                "link": {
                  "url": "https://dovetail.com/outlier/roadmap-to-insights/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://dovetail.com/outlier/roadmap-to-insights/",
              "href": "https://dovetail.com/outlier/roadmap-to-insights/"
            }
          ],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081510/uxcomic-imgs/1305d164-78d8-803b-8e63-d6d5aed3e686.png",
            "expiry_time": "2026-10-04T09:12:05.957Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1305d164-78d8-803b-8e63-d6d5aed3e686"
      },
      {
        "object": "block",
        "id": "4ebcc0a3-5be3-434f-bfa0-f831345000ad",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-30T02:22:00.000Z",
        "last_edited_time": "2024-10-30T02:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "b5dd202d-4baf-4d1a-a98b-eeddd7599828",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-30T02:22:00.000Z",
        "last_edited_time": "2024-11-01T00:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "3. Solution discovery & concept validation",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3. Solution discovery & concept validation",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "44574c32-5f4d-4149-9fbf-2ac19bcdc4cb",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-30T02:23:00.000Z",
        "last_edited_time": "2025-01-12T03:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau khi đã xác định được vấn đề, đây là lúc bạn sẽ phải làm buổi project kick-off để các bên cùng ngồi xuống thảo luận về problem, tìm ra các hướng solution mapping cho vấn đề đó, align với nhau về objective, expectation của project này là gì. (điều này cùng tuỳ tổ chức, có khi mọi solution đã được định hình thì mới có buổi kick-off).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau khi đã xác định được vấn đề, đây là lúc bạn sẽ phải làm buổi project kick-off để các bên cùng ngồi xuống thảo luận về problem, tìm ra các hướng solution mapping cho vấn đề đó, align với nhau về objective, expectation của project này là gì. (điều này cùng tuỳ tổ chức, có khi mọi solution đã được định hình thì mới có buổi kick-off).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-80a2-94bf-e38ad8925456",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-12T03:24:00.000Z",
        "last_edited_time": "2025-01-12T03:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-80a9-a43b-d39d73816b88",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T04:26:00.000Z",
        "last_edited_time": "2025-01-10T05:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Value first, solution later",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Value first, solution later",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-80d8-9a20-c2bbb54a8662",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T05:40:00.000Z",
        "last_edited_time": "2025-01-12T03:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Keep in mind, bản chất product là trao giá trị (",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Keep in mind, bản chất product là trao giá trị (",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "value & benefit",
                "link": {
                  "url": "/1605d16478d880ad9130fe44c6663146"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "value & benefit",
              "href": "/1605d16478d880ad9130fe44c6663146"
            },
            {
              "type": "text",
              "text": {
                "content": ") cho người dùng, nên mọi sự suy nghĩ nên bắt đầu từ nó, đừng để mình bị rơi vô cái trap là chưa gì đã nhảy ngay đến solution.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ") cho người dùng, nên mọi sự suy nghĩ nên bắt đầu từ nó, đừng để mình bị rơi vô cái trap là chưa gì đã nhảy ngay đến solution.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1305d164-78d8-806f-87a9-dbb6943df5f8",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T03:56:00.000Z",
        "last_edited_time": "2025-01-10T04:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tip: khi nghĩ về solution ta nên hình dung nó ở dạng “verb” trước, sau đó mới nghĩ đến “noun”.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tip: khi nghĩ về solution ta nên hình dung nó ở dạng “verb” trước, sau đó mới nghĩ đến “noun”.",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "1345d164-78d8-80ec-9dd6-d938d29e2ecc",
            "parent": {
              "type": "block_id",
              "block_id": "1305d164-78d8-806f-87a9-dbb6943df5f8"
            },
            "created_time": "2024-11-04T11:12:00.000Z",
            "last_edited_time": "2024-11-04T11:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Ví dụ: “User cần nội dung ngắn hơn” vs “User cần đọc sách một cách nhanh hơn”.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Ví dụ: “User cần nội dung ngắn hơn” vs “User cần đọc sách một cách nhanh hơn”.",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1305d164-78d8-801d-8b2e-cdd9177a97ea",
            "parent": {
              "type": "block_id",
              "block_id": "1305d164-78d8-806f-87a9-dbb6943df5f8"
            },
            "created_time": "2024-10-31T03:57:00.000Z",
            "last_edited_time": "2025-01-10T04:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Thử nhìn xem 2 câu đó, một câu mô tả solution dưới dạng “noun” - “User cần nội dung ngắn hơn”, vô tình khiến cho idea bị giới hạn và đóng gói solution xoay quanh chữ “nội dung ngắn”. Còn câu dưới dạng “verb” - “user đọc một cách nhanh hơn” giúp ta focus hơn vào user need, vào JTBD của user, nên solution có thể là [nội dung ngắn bằng việc có summary] hoặc [dùng voice đọc dùm >> kèm tuỳ chỉnh speed],… ",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Thử nhìn xem 2 câu đó, một câu mô tả solution dưới dạng “noun” - “User cần nội dung ngắn hơn”, vô tình khiến cho idea bị giới hạn và đóng gói solution xoay quanh chữ “nội dung ngắn”. Còn câu dưới dạng “verb” - “user đọc một cách nhanh hơn” giúp ta focus hơn vào user need, vào JTBD của user, nên solution có thể là [nội dung ngắn bằng việc có summary] hoặc [dùng voice đọc dùm >> kèm tuỳ chỉnh speed],… ",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1775d164-78d8-8076-8cb3-d316f7dda196",
            "parent": {
              "type": "block_id",
              "block_id": "1305d164-78d8-806f-87a9-dbb6943df5f8"
            },
            "created_time": "2025-01-10T04:26:00.000Z",
            "last_edited_time": "2025-01-10T04:26:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": ">> Dùng verb mở ra nhiều hướng tiếp cận hơn vì lúc đó chúng ta đang tập trung vào value.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": ">> Dùng verb mở ra nhiều hướng tiếp cận hơn vì lúc đó chúng ta đang tập trung vào value.",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "1795d164-78d8-807f-9aa8-f5aed48c06b3",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-12T03:25:00.000Z",
        "last_edited_time": "2025-01-12T03:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-80a7-b516-c626dd07b4b6",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T05:39:00.000Z",
        "last_edited_time": "2025-01-10T05:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ideate",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ideate",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-8086-b2f7-e2bdc34fa16e",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T05:38:00.000Z",
        "last_edited_time": "2025-01-12T03:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi đã có đủ thông tin về problem, hiểu mình đang cố trao đi value gì >> lúc này mới đẻ solution idea, mapping problems & solution. (cách gì? >> ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi đã có đủ thông tin về problem, hiểu mình đang cố trao đi value gì >> lúc này mới đẻ solution idea, mapping problems & solution. (cách gì? >> ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "xem thêm bài này về brainstorm",
                "link": {
                  "url": "/1585d16478d880c3b602e97f38fd7948"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "xem thêm bài này về brainstorm",
              "href": "/1585d16478d880c3b602e97f38fd7948"
            },
            {
              "type": "text",
              "text": {
                "content": ").",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ").",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-80e9-b82e-c59c788b337f",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T05:45:00.000Z",
        "last_edited_time": "2025-01-10T05:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-80de-bbff-c875604b3e9a",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T04:26:00.000Z",
        "last_edited_time": "2025-01-10T05:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Risk evaluation ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Risk evaluation ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1305d164-78d8-80c8-a8c9-c9ca5c09f69c",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T11:05:00.000Z",
        "last_edited_time": "2025-01-12T03:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi đã brainstorm được một vài idea, ta rất hay tích cực hoá nó lên - thấy một bầu trời sáng lạn,  nhưng đừng quên mình sẽ cần cân nhắc thêm các ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi đã brainstorm được một vài idea, ta rất hay tích cực hoá nó lên - thấy một bầu trời sáng lạn,  nhưng đừng quên mình sẽ cần cân nhắc thêm các ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "risk",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "risk",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " có thể xảy ra (trong sách “Inspire” của Marty Cagan có nhắc đến 4 loại risk sau):",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " có thể xảy ra (trong sách “Inspire” của Marty Cagan có nhắc đến 4 loại risk sau):",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1305d164-78d8-8056-b6fc-c3afe54a5b08",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T11:06:00.000Z",
        "last_edited_time": "2024-11-01T00:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Value risk",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Value risk",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (whether customers will buy it or users will choose to use it) - Product Manager chịu trách nhiệm chính",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (whether customers will buy it or users will choose to use it) - Product Manager chịu trách nhiệm chính",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1305d164-78d8-80a0-95d0-f2955e2b6958",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T11:07:00.000Z",
        "last_edited_time": "2024-11-01T00:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Business viability risk",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Business viability risk",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (whether this solution also works for the various aspects of our business) - Product Manager chịu trách nhiệm chính",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (whether this solution also works for the various aspects of our business) - Product Manager chịu trách nhiệm chính",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1305d164-78d8-8062-9406-d42cb7d1bc7a",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T11:06:00.000Z",
        "last_edited_time": "2024-11-01T00:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Usability risk",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Usability risk",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (whether users can figure out how to use it) - Product Designer chịu trách nhiệm chính",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (whether users can figure out how to use it) - Product Designer chịu trách nhiệm chính",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "1305d164-78d8-80ce-914b-c1c031f52a33",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T11:06:00.000Z",
        "last_edited_time": "2024-11-01T00:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Feasibility risk ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Feasibility risk ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "(whether our engineers can build what we need with the time, skills and technology we have) - Product Lead Engineer chịu trách nhiệm chính",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "(whether our engineers can build what we need with the time, skills and technology we have) - Product Lead Engineer chịu trách nhiệm chính",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 3
      },
      {
        "object": "block",
        "id": "1795d164-78d8-8050-b192-c843cabfc35c",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-12T03:28:00.000Z",
        "last_edited_time": "2025-01-12T03:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có thể tham khảo thêm ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có thể tham khảo thêm ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "bài này",
                "link": {
                  "url": "https://d.mba/guides/derisking-innovation-a-guide-for-designers"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "bài này",
              "href": "https://d.mba/guides/derisking-innovation-a-guide-for-designers"
            },
            {
              "type": "text",
              "text": {
                "content": " để hình dung thêm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " để hình dung thêm.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-8009-84d2-c49a7dd428ab",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T05:30:00.000Z",
        "last_edited_time": "2025-01-10T05:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-802f-966c-c5bc34394a38",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T05:30:00.000Z",
        "last_edited_time": "2025-01-10T05:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hypothesis",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hypothesis",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-8078-80e0-cce2dbbf3e2c",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T05:30:00.000Z",
        "last_edited_time": "2025-01-12T03:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một solution idea được form lên căn bản cũng ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một solution idea được form lên căn bản cũng ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "chỉ là những ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "chỉ là những ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "phỏng đoán",
                "link": {
                  "url": "/fba9a75a71ae4302ac761431b742e33d"
                }
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "phỏng đoán",
              "href": "/fba9a75a71ae4302ac761431b742e33d"
            },
            {
              "type": "text",
              "text": {
                "content": ", dù có apply bao nhiêu principle, research hay rationale rõ ràng thế nào đi nữa,… kết quả thực sự chỉ bắt đầu khi mình quăng nó ra thị trường, xem user thực tế trải nghiệm nó & tiếp nhận nó ra sao. Đây là một mindset cực kì quan trọng, ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", dù có apply bao nhiêu principle, research hay rationale rõ ràng thế nào đi nữa,… kết quả thực sự chỉ bắt đầu khi mình quăng nó ra thị trường, xem user thực tế trải nghiệm nó & tiếp nhận nó ra sao. Đây là một mindset cực kì quan trọng, ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "design is just an experiment",
                "link": {
                  "url": "/fba9a75a71ae4302ac761431b742e33d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "design is just an experiment",
              "href": "/fba9a75a71ae4302ac761431b742e33d"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-801d-8361-d7d69f27f6b8",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T05:33:00.000Z",
        "last_edited_time": "2025-01-12T03:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để có thể đánh giá được độ hiệu quả của solution đó, ta cũng cần phải rõ ràng ý định / chủ đích solution mình đưa ra là gì >> có nghĩa là hiểu mình đang cố kiểm chứng điều gì, càng cụ thể càng tốt, ví dụ solution giúp giảm số lỗi xảy ra đi 10%, time on task giảm 20%, độ happiness tăng 15%…Đây là quá trình mình cần form lên hypothesis, thông qua những tín hiệu của user > ta biết được outcome của project này có đạt hay chưa.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để có thể đánh giá được độ hiệu quả của solution đó, ta cũng cần phải rõ ràng ý định / chủ đích solution mình đưa ra là gì >> có nghĩa là hiểu mình đang cố kiểm chứng điều gì, càng cụ thể càng tốt, ví dụ solution giúp giảm số lỗi xảy ra đi 10%, time on task giảm 20%, độ happiness tăng 15%…Đây là quá trình mình cần form lên hypothesis, thông qua những tín hiệu của user > ta biết được outcome của project này có đạt hay chưa.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-8082-ab0a-dcd7090abdac",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-10T05:35:00.000Z",
        "last_edited_time": "2025-01-10T05:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuy nhiên phải biết các tiêu chí này có thể conflict với nhau, ví dụ: bạn muốn time on task nhanh hơn thì có khi việc để user tuỳ chỉnh nhiều sẽ không được đáp ứng >> hình dung được các trade off để lựa chọn solution.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuy nhiên phải biết các tiêu chí này có thể conflict với nhau, ví dụ: bạn muốn time on task nhanh hơn thì có khi việc để user tuỳ chỉnh nhiều sẽ không được đáp ứng >> hình dung được các trade off để lựa chọn solution.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20436681-02ff-4c14-bf9c-94b00b4cd63e",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T01:54:00.000Z",
        "last_edited_time": "2024-10-31T01:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "9d8915c1-d419-48bd-9062-3643164e2e21",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T01:54:00.000Z",
        "last_edited_time": "2024-10-31T13:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "4. Development",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "4. Development",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "ad927fcf-0fb4-4439-aad6-661151f59842",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T01:54:00.000Z",
        "last_edited_time": "2025-01-12T03:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau khi đã form được solution, tiếp đến là quá trình design & build solution ấy, đây là lúc bắt đầu cần đến công việc của UX/UI… ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau khi đã form được solution, tiếp đến là quá trình design & build solution ấy, đây là lúc bắt đầu cần đến công việc của UX/UI… ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-8074-bee4-c3cb6c38b944",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-12T03:33:00.000Z",
        "last_edited_time": "2025-01-12T03:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thường khi đã hòm hòm có được design concept nên involve thêm Dev/Engineer vào để check về độ khả thi, có technical constraints, có edge case hay dependencies nào cần aware trước không. (",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thường khi đã hòm hòm có được design concept nên involve thêm Dev/Engineer vào để check về độ khả thi, có technical constraints, có edge case hay dependencies nào cần aware trước không. (",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "xem thêm bài này",
                "link": {
                  "url": "/10f5d16478d8808484a5d6eff66f3eec"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "xem thêm bài này",
              "href": "/10f5d16478d8808484a5d6eff66f3eec"
            },
            {
              "type": "text",
              "text": {
                "content": " để nắm được chiếc hộp của một designer là gì)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " để nắm được chiếc hộp của một designer là gì)",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15b5d164-78d8-80f2-83de-c0428d3fb5ef",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-12-13T05:16:00.000Z",
        "last_edited_time": "2024-12-13T05:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi đã xong design & hand-off, nhiệm vụ của designer là tiếp tục follow up để support các bên ấy, đôi khi trong xuyên suốt quá trình build & UAT sẽ phát sinh thêm các edge case hoặc vướng thêm vài technical constraint, lúc này designer cần cân nhắc & adapt theo (các constraint nên minor, không ảnh hưởng đến solution concept hay main flow).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi đã xong design & hand-off, nhiệm vụ của designer là tiếp tục follow up để support các bên ấy, đôi khi trong xuyên suốt quá trình build & UAT sẽ phát sinh thêm các edge case hoặc vướng thêm vài technical constraint, lúc này designer cần cân nhắc & adapt theo (các constraint nên minor, không ảnh hưởng đến solution concept hay main flow).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "75b126a8-59de-4450-bf19-b797292fd69c",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T04:55:00.000Z",
        "last_edited_time": "2024-10-31T04:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "9fd2bd60-0128-4a57-a242-9d824b98373a",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T04:55:00.000Z",
        "last_edited_time": "2024-11-05T06:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "5. Validation & Roll out program",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "5. Validation & Roll out program",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "6835c207-64ee-4b7a-bd26-6c3060ebabc8",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T04:55:00.000Z",
        "last_edited_time": "2024-11-23T05:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi bản build đã ready, đây là lúc mình sẽ release cho internal hoặc test xem có đúng với expectation chưa, liệu có phát sinh thêm vấn đề gì như: usability, độ tương thích, độ tải sever,... (để hiểu thêm, mình có thể tìm hiểu các term: alpha, closed beta, open beta).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi bản build đã ready, đây là lúc mình sẽ release cho internal hoặc test xem có đúng với expectation chưa, liệu có phát sinh thêm vấn đề gì như: usability, độ tương thích, độ tải sever,... (để hiểu thêm, mình có thể tìm hiểu các term: alpha, closed beta, open beta).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1305d164-78d8-80cd-8410-e8d028037bc4",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T11:18:00.000Z",
        "last_edited_time": "2025-01-12T03:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi đã tự tin về chất lượng sau khi thử nghiệm thực tế, lúc này ta sẽ phải lên roll-out plan tiếp cận đến với user như thế nào, ví dụ ta có thể release cho 10% user (early access program) hoặc cho 1 user segment cụ thể trước, khi đạt được các tín hiệu mong muốn mới release rộng ra thêm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi đã tự tin về chất lượng sau khi thử nghiệm thực tế, lúc này ta sẽ phải lên roll-out plan tiếp cận đến với user như thế nào, ví dụ ta có thể release cho 10% user (early access program) hoặc cho 1 user segment cụ thể trước, khi đạt được các tín hiệu mong muốn mới release rộng ra thêm.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-805b-9f46-d1a9a9b0bb6b",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-12T03:35:00.000Z",
        "last_edited_time": "2025-01-12T03:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: luôn cần chuẩn bị trước các kịch bản khi release để ứng phó kịp thời, ví dụ: lỡ traffic tăng đột biến thì sao, lỡ có lỗi xảy ra thì sao, lỡ có một tính hiệu xấu ảnh hưởng đến branding thì sao,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: luôn cần chuẩn bị trước các kịch bản khi release để ứng phó kịp thời, ví dụ: lỡ traffic tăng đột biến thì sao, lỡ có lỗi xảy ra thì sao, lỡ có một tính hiệu xấu ảnh hưởng đến branding thì sao,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1315d164-78d8-806b-842d-c0d2194ac493",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-11-01T03:31:00.000Z",
        "last_edited_time": "2024-11-25T02:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong quá trình này mình cũng cần định hình những data cần tracking để có thêm thông tin, dữ kiện phục vụ cho việc measure tính năng, trả lời các hypothesis trước đó, hoặc làm cơ sở cho đợt improve ở các phase sau.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong quá trình này mình cũng cần định hình những data cần tracking để có thêm thông tin, dữ kiện phục vụ cho việc measure tính năng, trả lời các hypothesis trước đó, hoặc làm cơ sở cho đợt improve ở các phase sau.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1305d164-78d8-8031-937b-d3182e601644",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T11:21:00.000Z",
        "last_edited_time": "2024-10-31T11:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1305d164-78d8-800e-8cf7-cee2c66d0160",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T11:21:00.000Z",
        "last_edited_time": "2024-10-31T13:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "6. Retro",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "6. Retro",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1305d164-78d8-80c1-be04-f2cd16457411",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T11:22:00.000Z",
        "last_edited_time": "2024-10-31T11:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đây là phase mình hào hứng nhất.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đây là phase mình hào hứng nhất.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1305d164-78d8-80a5-80ac-da65512b4d93",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T11:21:00.000Z",
        "last_edited_time": "2025-01-12T03:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau khi feature đã ra mắt được 1 thời gian, dựa theo những feedback & data log, mình sẽ đánh giá được outcome của dự án, từ đó cả team xem learn được các bài học gì, liệu nó có đúng như những expectation mình đã đề ra, liệu có những issue/incident nào mình cần aware thêm, liệu có một insight gì đó thú vị…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau khi feature đã ra mắt được 1 thời gian, dựa theo những feedback & data log, mình sẽ đánh giá được outcome của dự án, từ đó cả team xem learn được các bài học gì, liệu nó có đúng như những expectation mình đã đề ra, liệu có những issue/incident nào mình cần aware thêm, liệu có một insight gì đó thú vị…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15b5d164-78d8-80ec-ba71-c1a1c0f4b139",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-12-13T05:18:00.000Z",
        "last_edited_time": "2024-12-13T05:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Những thông tin này không những giúp ích cho việc cải thiện feature này mà còn là các insight/bài học phục vụ cho các feature khác ở tương lai.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Những thông tin này không những giúp ích cho việc cải thiện feature này mà còn là các insight/bài học phục vụ cho các feature khác ở tương lai.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1305d164-78d8-8069-aea5-e9e6688c874f",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T11:34:00.000Z",
        "last_edited_time": "2024-10-31T11:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1305d164-78d8-8008-86e4-c3c8b8d712ec",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T11:34:00.000Z",
        "last_edited_time": "2024-11-23T04:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "So what",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "So what",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-8094-aa8b-fe5a0c68ecb6",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-01-12T03:37:00.000Z",
        "last_edited_time": "2025-01-12T03:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình biết bài này khá là dàiiiiiii. Đọc đến đây rồi mong bạn rút ra được gì đó, còn riêng mình thì rút ra được vài điểm sau quá trình tìm hiểu về process này.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình biết bài này khá là dàiiiiiii. Đọc đến đây rồi mong bạn rút ra được gì đó, còn riêng mình thì rút ra được vài điểm sau quá trình tìm hiểu về process này.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1325d164-78d8-80ce-924f-e070f70b11cf",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-11-02T05:55:00.000Z",
        "last_edited_time": "2025-01-12T03:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mặc dù đây là tổng quan process chung và gần như hoàn chỉnh của product development, nhưng mình có thể linh hoạt cắt bớt giai đoạn tuỳ thuộc vào bối cảnh thời điểm đó. Ví dụ: có khi ta không cần phải đánh giá nghiên cứu problem quá sâu, nếu đối thủ ngoài kia đã có một solution chứng minh được giá trị của nó, ta có thể tham khảo & điều chỉnh cho phù hợp với product của mình (nói nôm na là clone giải pháp đó); hoặc đôi khi ta chỉ cần làm ra một solution ít tốn effort (no code, low code, hoặc prototype, fake door…) để test xem hiệu ứng thị trường thế nào, từ đó bổ sung nhanh cho việc đánh giá vấn đề.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mặc dù đây là tổng quan process chung và gần như hoàn chỉnh của product development, nhưng mình có thể linh hoạt cắt bớt giai đoạn tuỳ thuộc vào bối cảnh thời điểm đó. Ví dụ: có khi ta không cần phải đánh giá nghiên cứu problem quá sâu, nếu đối thủ ngoài kia đã có một solution chứng minh được giá trị của nó, ta có thể tham khảo & điều chỉnh cho phù hợp với product của mình (nói nôm na là clone giải pháp đó); hoặc đôi khi ta chỉ cần làm ra một solution ít tốn effort (no code, low code, hoặc prototype, fake door…) để test xem hiệu ứng thị trường thế nào, từ đó bổ sung nhanh cho việc đánh giá vấn đề.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1305d164-78d8-80e9-9149-d7d26e3934c1",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T11:36:00.000Z",
        "last_edited_time": "2025-01-12T03:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Việc hiểu được bức tranh lớn cũng giúp ta có sự đánh giá khách quan hơn, để khi có bắt gặp issue gì đó bạn có thể phân tích xem vấn đề nó nằm ở đâu, ví dụ: nó có thể nằm ở mặt development (UX, usability không tốt) hay nằm ở mặt solution (no value), hay nằm ở mặt tiếp cận thị trường chưa phù hợp (roll-out program). Biết ở đây không phải để quy trách nhiệm cho nhau, mà để biết đường đào ra đúng vấn đề và tìm giải pháp ứng phó phù hợp.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Việc hiểu được bức tranh lớn cũng giúp ta có sự đánh giá khách quan hơn, để khi có bắt gặp issue gì đó bạn có thể phân tích xem vấn đề nó nằm ở đâu, ví dụ: nó có thể nằm ở mặt development (UX, usability không tốt) hay nằm ở mặt solution (no value), hay nằm ở mặt tiếp cận thị trường chưa phù hợp (roll-out program). Biết ở đây không phải để quy trách nhiệm cho nhau, mà để biết đường đào ra đúng vấn đề và tìm giải pháp ứng phó phù hợp.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1265d164-78d8-805f-b579-d1542a91590e",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-21T03:40:00.000Z",
        "last_edited_time": "2024-10-21T03:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1265d164-78d8-80dc-aaf2-c8dbc7d2be5f",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-21T03:40:00.000Z",
        "last_edited_time": "2024-10-21T03:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12f5d164-78d8-8072-af73-eb037525a3a8",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-30T02:37:00.000Z",
        "last_edited_time": "2024-10-30T02:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.tedgoas.com/blog/product-design-process/",
                "link": {
                  "url": "https://www.tedgoas.com/blog/product-design-process/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.tedgoas.com/blog/product-design-process/",
              "href": "https://www.tedgoas.com/blog/product-design-process/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1315d164-78d8-804a-9449-cce3074939a1",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-11-01T03:05:00.000Z",
        "last_edited_time": "2024-11-01T03:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://medium.com/zendesk-creative-blog/the-zendesk-triple-diamond-process-fd857a11c179",
                "link": {
                  "url": "https://medium.com/zendesk-creative-blog/the-zendesk-triple-diamond-process-fd857a11c179"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://medium.com/zendesk-creative-blog/the-zendesk-triple-diamond-process-fd857a11c179",
              "href": "https://medium.com/zendesk-creative-blog/the-zendesk-triple-diamond-process-fd857a11c179"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1315d164-78d8-80d2-af4d-f2a387daa0c3",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-11-01T03:28:00.000Z",
        "last_edited_time": "2024-11-01T03:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://docs.google.com/document/d/1U9ESAnv9wkpTCIs0OEuYYrYhzhD6Zu9ezeg06bBJyI4/edit?tab=t.0",
                "link": {
                  "url": "https://docs.google.com/document/d/1U9ESAnv9wkpTCIs0OEuYYrYhzhD6Zu9ezeg06bBJyI4/edit?tab=t.0"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://docs.google.com/document/d/1U9ESAnv9wkpTCIs0OEuYYrYhzhD6Zu9ezeg06bBJyI4/edit?tab=t.0",
              "href": "https://docs.google.com/document/d/1U9ESAnv9wkpTCIs0OEuYYrYhzhD6Zu9ezeg06bBJyI4/edit?tab=t.0"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12f5d164-78d8-80b6-bae8-f740b66368fc",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-30T02:47:00.000Z",
        "last_edited_time": "2024-10-30T02:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://blog.prototypr.io/origami-way-of-work-in-product-design-b63fdc9ba52f",
                "link": {
                  "url": "https://blog.prototypr.io/origami-way-of-work-in-product-design-b63fdc9ba52f"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://blog.prototypr.io/origami-way-of-work-in-product-design-b63fdc9ba52f",
              "href": "https://blog.prototypr.io/origami-way-of-work-in-product-design-b63fdc9ba52f"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1305d164-78d8-8071-adba-cd7d6bbc789f",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-31T13:16:00.000Z",
        "last_edited_time": "2024-10-31T13:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://dovetail.com/outlier/roadmap-to-insights/",
                "link": {
                  "url": "https://dovetail.com/outlier/roadmap-to-insights/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://dovetail.com/outlier/roadmap-to-insights/",
              "href": "https://dovetail.com/outlier/roadmap-to-insights/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1a55d164-78d8-80f0-bb2a-d191a3cd89e2",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-02-25T02:08:00.000Z",
        "last_edited_time": "2025-02-25T02:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://designsprintkit.withgoogle.com/methodology/overview",
                "link": {
                  "url": "https://designsprintkit.withgoogle.com/methodology/overview"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://designsprintkit.withgoogle.com/methodology/overview",
              "href": "https://designsprintkit.withgoogle.com/methodology/overview"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1335d164-78d8-80c2-8759-f07668259614",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-11-03T07:58:00.000Z",
        "last_edited_time": "2024-11-03T07:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://notion.notion.site/Loom-s-product-requirements-document-c23bddb0325c40edae071e29dfb7b357",
                "link": {
                  "url": "https://notion.notion.site/Loom-s-product-requirements-document-c23bddb0325c40edae071e29dfb7b357"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://notion.notion.site/Loom-s-product-requirements-document-c23bddb0325c40edae071e29dfb7b357",
              "href": "https://notion.notion.site/Loom-s-product-requirements-document-c23bddb0325c40edae071e29dfb7b357"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1a55d164-78d8-8002-a3fc-eb635fb66bd6",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2025-02-25T02:08:00.000Z",
        "last_edited_time": "2025-02-25T02:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12e5d164-78d8-80ca-b096-dbd98f575409",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-29T12:12:00.000Z",
        "last_edited_time": "2024-10-29T12:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "12e5d164-78d8-8099-9dd1-e8887e6646b8",
        "parent": {
          "type": "page_id",
          "page_id": "1025d164-78d8-80c5-891f-debd0fc09547"
        },
        "created_time": "2024-10-29T12:12:00.000Z",
        "last_edited_time": "2024-10-29T12:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Related Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Related Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d",
    "created_time": "2024-09-15T05:41:00.000Z",
    "last_edited_time": "2025-01-03T12:51:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "fd3cd36d-73dd-4dee-8bd5-d159d6600124"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "View": {
        "id": "ATSa",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "A%5Bqc",
        "type": "select",
        "select": {
          "id": "QNIE",
          "name": "⚓:3",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "DMgm",
        "type": "last_edited_time",
        "last_edited_time": "2025-01-03T12:51:00.000Z"
      },
      "Publish": {
        "id": "FSnx",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "_tsp",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "g%7BBg",
        "type": "created_time",
        "created_time": "2024-09-15T05:41:00.000Z"
      },
      "Share": {
        "id": "hp~_",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "m%7C%40x",
        "type": "number",
        "number": null
      },
      "Formula": {
        "id": "re%3BE",
        "type": "formula",
        "formula": {
          "type": "number",
          "number": 1
        }
      },
      "Tag": {
        "id": "%7CAvQ",
        "type": "select",
        "select": {
          "id": "156ef770-14db-4170-b1d7-95a2fbdf62ba",
          "name": "2-User",
          "color": "default"
        }
      },
      "ID": {
        "id": "~RYT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FD",
          "number": 5
        }
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "User Multiverse",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "User Multiverse",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/User-Multiverse-22a3b4bb88d34f84a70f83e7c12ac91d",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "5cacdbff-b9e2-4973-b565-ec1ae4327ec9",
      "name": "Fundamental",
      "slug": "fundamental",
      "icon": "🌞",
      "order": 2,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "Product",
          "slug": "product",
          "order": 1
        },
        {
          "id": "156ef770-14db-4170-b1d7-95a2fbdf62ba",
          "name": "User",
          "slug": "user",
          "order": 2
        },
        {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "Design",
          "slug": "design",
          "order": 3
        },
        {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "Random",
          "slug": "random",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "156ef770-14db-4170-b1d7-95a2fbdf62ba",
      "name": "User",
      "slug": "user",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "1185d164-78d8-80ce-82da-c2978ff5b99c",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T13:48:00.000Z",
        "last_edited_time": "2024-11-23T04:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081517/uxcomic-imgs/1185d164-78d8-80ce-82da-c2978ff5b99c.png",
            "expiry_time": "2026-10-04T09:12:08.369Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1185d164-78d8-80ce-82da-c2978ff5b99c"
      },
      {
        "object": "block",
        "id": "1185d164-78d8-8096-9707-c3f53ccfe861",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T13:32:00.000Z",
        "last_edited_time": "2024-10-08T04:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong nghề chắc mình nghe “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong nghề chắc mình nghe “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "design for user",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "design for user",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "” như cơm bữa rồi. Nhưng càng nghiên cứu mới biết chữ “user” tồn tại ở khá nhiều dạng khác nhau, mình ví von vui nó là “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” như cơm bữa rồi. Nhưng càng nghiên cứu mới biết chữ “user” tồn tại ở khá nhiều dạng khác nhau, mình ví von vui nó là “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "đa vũ trụ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "đa vũ trụ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "” nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-800a-b0b5-ee53602c3527",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2025-01-03T12:47:00.000Z",
        "last_edited_time": "2025-01-03T12:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081518/uxcomic-imgs/1705d164-78d8-800a-b0b5-ee53602c3527.jpg",
            "expiry_time": "2026-10-04T09:12:08.369Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1705d164-78d8-800a-b0b5-ee53602c3527"
      },
      {
        "object": "block",
        "id": "1185d164-78d8-8037-ad33-d44669b0feed",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T14:11:00.000Z",
        "last_edited_time": "2024-11-23T04:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-801b-9cdd-cc489c2f2d81",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T14:11:00.000Z",
        "last_edited_time": "2025-01-03T12:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vũ trụ Persona (user segment)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vũ trụ Persona (user segment)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-802c-9ee4-c159f77829ce",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T14:12:00.000Z",
        "last_edited_time": "2025-01-03T12:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là một nhóm user có sự tương đồng về behavior, nhu cầu, động lực, thái độ khi tìm đến sản phẩm. Ví dụ: sản phẩm Zalo có nhóm dùng để trò chuyện với gia đình, nhóm dùng để làm việc, kết nối với khách hàng…hay có người thích lướt hàng trên Shopee hàng giờ nhưng có người lại chỉ ghé khi biết mình cần mua gì và chốt đơn rất nhanh…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là một nhóm user có sự tương đồng về behavior, nhu cầu, động lực, thái độ khi tìm đến sản phẩm. Ví dụ: sản phẩm Zalo có nhóm dùng để trò chuyện với gia đình, nhóm dùng để làm việc, kết nối với khách hàng…hay có người thích lướt hàng trên Shopee hàng giờ nhưng có người lại chỉ ghé khi biết mình cần mua gì và chốt đơn rất nhanh…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1545d164-78d8-8056-acae-d3b86f20ef0d",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-12-06T06:03:00.000Z",
        "last_edited_time": "2025-01-03T12:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: có khái niệm về anti-persona nữa, này để chỉ về một nhóm user mà product cần né họ ra, ví dụ nếu ai làm các chương trình tặng thưởng thì cần phải để ý cách để phòng chống nhóm user MMO (nhóm này chuyên tìm cách tham gia các chương trình để nhận thưởng).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: có khái niệm về anti-persona nữa, này để chỉ về một nhóm user mà product cần né họ ra, ví dụ nếu ai làm các chương trình tặng thưởng thì cần phải để ý cách để phòng chống nhóm user MMO (nhóm này chuyên tìm cách tham gia các chương trình để nhận thưởng).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-804f-9b44-f2dc71a12f69",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T14:21:00.000Z",
        "last_edited_time": "2024-11-23T04:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-809c-bc88-dba160824a46",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T14:21:00.000Z",
        "last_edited_time": "2024-10-07T15:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vũ trụ Demographic",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vũ trụ Demographic",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-8020-96eb-d6de75fb1931",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T14:21:00.000Z",
        "last_edited_time": "2025-01-03T12:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là một nhóm user có sự tương đồng về độ tuổi, giới tính, thu nhập, background, văn hoá… định nghĩa này giúp nắm được những đặc tính chung chung. Ví dụ: người trẻ xu hướng thích các thứ trending, người già thì gặp trở ngại thị giác, hay content tiêu thụ giữa nam & nữ khác nhau…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là một nhóm user có sự tương đồng về độ tuổi, giới tính, thu nhập, background, văn hoá… định nghĩa này giúp nắm được những đặc tính chung chung. Ví dụ: người trẻ xu hướng thích các thứ trending, người già thì gặp trở ngại thị giác, hay content tiêu thụ giữa nam & nữ khác nhau…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-8031-a073-c163454e90e1",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-08T04:51:00.000Z",
        "last_edited_time": "2024-11-23T04:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-804b-ba58-fffdb7899ccf",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T14:24:00.000Z",
        "last_edited_time": "2024-10-07T15:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vũ trụ Engagement",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vũ trụ Engagement",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-8035-a7b7-f07a0b850e4a",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T14:33:00.000Z",
        "last_edited_time": "2025-01-03T12:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dựa theo vòng đời user gắn kết với sản phẩm (product life cycle), cũng có thể chia làm rất nhiều dạng user, ví dụ: new/ recurring user, churn, free/ trial/ paid user, active user, happy/ frustrated user, early adopter/ power user… ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dựa theo vòng đời user gắn kết với sản phẩm (product life cycle), cũng có thể chia làm rất nhiều dạng user, ví dụ: new/ recurring user, churn, free/ trial/ paid user, active user, happy/ frustrated user, early adopter/ power user… ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-80ce-b6de-e70a2ff33935",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2025-01-03T12:41:00.000Z",
        "last_edited_time": "2025-01-03T12:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách định nghĩa này giúp thiết kế cân nhắc đa dạng các cách tiếp cận đến user. Vd: new user cần onboarding để hiểu hơn về sản phẩm có thể đem lại lợi ích gì hay cách dùng thế nào; power user thì sẽ cần những tính năng advance hơn,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách định nghĩa này giúp thiết kế cân nhắc đa dạng các cách tiếp cận đến user. Vd: new user cần onboarding để hiểu hơn về sản phẩm có thể đem lại lợi ích gì hay cách dùng thế nào; power user thì sẽ cần những tính năng advance hơn,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-808a-9832-e552b15ef405",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T14:36:00.000Z",
        "last_edited_time": "2024-11-23T04:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-8012-8845-c9ebc32b5280",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T14:36:00.000Z",
        "last_edited_time": "2024-10-07T15:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vũ trụ Role play",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vũ trụ Role play",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-8016-9c63-d833f60d6ebe",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T14:36:00.000Z",
        "last_edited_time": "2025-01-03T12:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Định nghĩa này dành cho cách chúng ta phân nhóm user bằng những nghĩa vụ hay quyền hạn của user với sản phẩm. Vd: khi bạn post bài trên Facebook thì bạn có quyền chỉnh sửa nội dung hay set quyền riêng tư (giới hạn người xem), nhưng với các người thấy post của bạn thì chỉ có thể tương tác: xem, like, share…; hay trong Figma có role admin, editor, viewer,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Định nghĩa này dành cho cách chúng ta phân nhóm user bằng những nghĩa vụ hay quyền hạn của user với sản phẩm. Vd: khi bạn post bài trên Facebook thì bạn có quyền chỉnh sửa nội dung hay set quyền riêng tư (giới hạn người xem), nhưng với các người thấy post của bạn thì chỉ có thể tương tác: xem, like, share…; hay trong Figma có role admin, editor, viewer,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-8072-aa9f-e05c7462474b",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T15:02:00.000Z",
        "last_edited_time": "2025-01-03T12:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-8041-84c9-c40b44dc262d",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T15:03:00.000Z",
        "last_edited_time": "2024-10-07T15:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Biết nhiều loại vũ trụ vậy để làm gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Biết nhiều loại vũ trụ vậy để làm gì?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-8018-9b6d-d6214e5f7031",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T15:10:00.000Z",
        "last_edited_time": "2024-10-07T15:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để có những kế sách phù hợp phục vụ cho từng nhóm user. Vì từng nhóm có những đặc tính rất khác, nhu cầu user sử dụng sẽ khác, motivation khác, context sử dụng khác,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để có những kế sách phù hợp phục vụ cho từng nhóm user. Vì từng nhóm có những đặc tính rất khác, nhu cầu user sử dụng sẽ khác, motivation khác, context sử dụng khác,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-80e4-bee5-e0b643c22ab7",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T15:05:00.000Z",
        "last_edited_time": "2024-10-07T15:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để khi ra design solution phải cân nhắc đến việc không chỉ phục vụ tốt cho nhóm này mà còn phải cân nhắc xem có ảnh hưởng đến nhóm khác hay không.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để khi ra design solution phải cân nhắc đến việc không chỉ phục vụ tốt cho nhóm này mà còn phải cân nhắc xem có ảnh hưởng đến nhóm khác hay không.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-8061-b98b-fde9767432b1",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2025-01-03T12:50:00.000Z",
        "last_edited_time": "2025-01-03T12:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081520/uxcomic-imgs/1705d164-78d8-8061-b98b-fde9767432b1.jpg",
            "expiry_time": "2026-10-04T09:12:08.370Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1705d164-78d8-8061-b98b-fde9767432b1"
      },
      {
        "object": "block",
        "id": "1705d164-78d8-80c6-872b-f7fa441d1331",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2025-01-03T12:45:00.000Z",
        "last_edited_time": "2025-01-03T12:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "💬 Chắc hẳn còn vài vụ trụ nữa, bạn nào biết share với mình thêm nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "💬 Chắc hẳn còn vài vụ trụ nữa, bạn nào biết share với mình thêm nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-80a8-83ad-c1658a5082a9",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T15:01:00.000Z",
        "last_edited_time": "2024-10-07T15:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-800e-9c4a-c2721354f6dc",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T15:01:00.000Z",
        "last_edited_time": "2024-10-07T15:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-8008-b1de-d544092b6f6f",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T15:01:00.000Z",
        "last_edited_time": "2024-10-07T15:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://spotify.design/article/the-story-of-spotify-personas",
                "link": {
                  "url": "https://spotify.design/article/the-story-of-spotify-personas"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://spotify.design/article/the-story-of-spotify-personas",
              "href": "https://spotify.design/article/the-story-of-spotify-personas"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-800c-8321-f9a43a57a9e7",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T15:02:00.000Z",
        "last_edited_time": "2024-10-07T15:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-8049-b964-d05ef7afa75c",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T15:02:00.000Z",
        "last_edited_time": "2024-10-07T15:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "You may like",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "You may like",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-805c-9d81-e199b7576d53",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T15:20:00.000Z",
        "last_edited_time": "2024-10-07T15:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Understand, Empathize user?",
              "href": "https://app.notion.com/p/32cbe568c34b4255a408f2a2e6227bb2"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-80a6-ae50-f03a49d57d9f",
        "parent": {
          "type": "page_id",
          "page_id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
        },
        "created_time": "2024-10-07T15:20:00.000Z",
        "last_edited_time": "2024-10-07T15:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "c066dc23-043d-44af-925d-1f71f899090a",
    "created_time": "2024-09-15T05:36:00.000Z",
    "last_edited_time": "2025-08-23T02:26:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "fd3cd36d-73dd-4dee-8bd5-d159d6600124"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "View": {
        "id": "ATSa",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "A%5Bqc",
        "type": "select",
        "select": {
          "id": "\\i@K",
          "name": "⚓:1",
          "color": "pink"
        }
      },
      "Last edited time": {
        "id": "DMgm",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-23T02:26:00.000Z"
      },
      "Publish": {
        "id": "FSnx",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "_tsp",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "g%7BBg",
        "type": "created_time",
        "created_time": "2024-09-15T05:36:00.000Z"
      },
      "Share": {
        "id": "hp~_",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "m%7C%40x",
        "type": "number",
        "number": null
      },
      "Formula": {
        "id": "re%3BE",
        "type": "formula",
        "formula": {
          "type": "number",
          "number": 1
        }
      },
      "Tag": {
        "id": "%7CAvQ",
        "type": "select",
        "select": {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "1-Product",
          "color": "default"
        }
      },
      "ID": {
        "id": "~RYT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FD",
          "number": 3
        }
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Digital vs Physical product",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Digital vs Physical product",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Digital-vs-Physical-product-c066dc23043d44af925d1f71f899090a",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "5cacdbff-b9e2-4973-b565-ec1ae4327ec9",
      "name": "Fundamental",
      "slug": "fundamental",
      "icon": "🌞",
      "order": 2,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "Product",
          "slug": "product",
          "order": 1
        },
        {
          "id": "156ef770-14db-4170-b1d7-95a2fbdf62ba",
          "name": "User",
          "slug": "user",
          "order": 2
        },
        {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "Design",
          "slug": "design",
          "order": 3
        },
        {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "Random",
          "slug": "random",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
      "name": "Product",
      "slug": "product",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "1115d164-78d8-8119-876f-ebec94484caf",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-09-30T15:14:00.000Z",
        "last_edited_time": "2024-09-30T15:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081523/uxcomic-imgs/1115d164-78d8-8119-876f-ebec94484caf.png",
            "expiry_time": "2026-10-04T09:12:09.328Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1115d164-78d8-8119-876f-ebec94484caf"
      },
      {
        "object": "block",
        "id": "1115d164-78d8-81b1-9aae-f1e0ac54084a",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-09-30T15:14:00.000Z",
        "last_edited_time": "2024-11-22T11:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi tiếp xúc với những kiến thức lĩnh vực UX/UI, mình rất hay gặp phải những term xa lạ, khó hình dung và hiểu rõ nó. Vd: như thế nào được gọi là thiết kế trực quan, tại sao feedback trên app nên <400ms, cognitive load là gì mà được nhắc nhiều trong các bài blog vậy?? ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi tiếp xúc với những kiến thức lĩnh vực UX/UI, mình rất hay gặp phải những term xa lạ, khó hình dung và hiểu rõ nó. Vd: như thế nào được gọi là thiết kế trực quan, tại sao feedback trên app nên <400ms, cognitive load là gì mà được nhắc nhiều trong các bài blog vậy?? ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1255d164-78d8-809d-bb03-fc4e301953ce",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-10-20T14:51:00.000Z",
        "last_edited_time": "2025-08-23T02:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy nên mình hay có thói quen hình dung “nếu liên tưởng những kiến thức UX/UI áp dụng cho digital product sang physical product thì sẽ như thế nào?”. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy nên mình hay có thói quen hình dung “nếu liên tưởng những kiến thức UX/UI áp dụng cho digital product sang physical product thì sẽ như thế nào?”. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "de2f5290-49d2-44ca-9267-84276531e300",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-12-21T10:42:00.000Z",
        "last_edited_time": "2025-08-23T02:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Liệu physical & digital product có điểm gì giống và khác nhau?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Liệu physical & digital product có điểm gì giống và khác nhau?",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1255d164-78d8-8060-a1d8-ec149c14f231",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-10-20T14:53:00.000Z",
        "last_edited_time": "2024-10-20T14:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1115d164-78d8-8193-aa6e-db0b7e00f3d8",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-09-30T15:14:00.000Z",
        "last_edited_time": "2024-09-30T16:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Điểm chung",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Điểm chung",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1115d164-78d8-81d9-a529-f010750b6d19",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-09-30T15:14:00.000Z",
        "last_edited_time": "2024-12-21T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cả digital và physical product đều là product và nó được sinh ra để phục vụ cho con người, nó giải quyết một nhu cầu gì đó cụ thể. Vd: cái búa để chặt cây, cái điện thoại để nghe gọi điện, app để đặt đồ ăn,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cả digital và physical product đều là product và nó được sinh ra để phục vụ cho con người, nó giải quyết một nhu cầu gì đó cụ thể. Vd: cái búa để chặt cây, cái điện thoại để nghe gọi điện, app để đặt đồ ăn,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1115d164-78d8-80fd-85ad-ff2bf70b4dd6",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-09-30T15:51:00.000Z",
        "last_edited_time": "2024-10-06T13:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đều có 3 khía cạnh tác động lên việc hình thành ra một sản phẩm đó là user need, business goal, technology.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đều có 3 khía cạnh tác động lên việc hình thành ra một sản phẩm đó là user need, business goal, technology.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1115d164-78d8-804e-bb36-d2d78c193aae",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-09-30T15:52:00.000Z",
        "last_edited_time": "2024-12-21T10:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các activities để develop nó cũng có điểm tương đồng, đều cần research để hiểu về user, về thị trường, về trend, ứng dụng các công nghệ mới … và đều cần làm ra các bản demo, mock-up, đều sẽ phải test và iteration để tiếp tục cải thiện.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các activities để develop nó cũng có điểm tương đồng, đều cần research để hiểu về user, về thị trường, về trend, ứng dụng các công nghệ mới … và đều cần làm ra các bản demo, mock-up, đều sẽ phải test và iteration để tiếp tục cải thiện.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1255d164-78d8-80cd-8a1e-ee400d42afd6",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-10-20T14:53:00.000Z",
        "last_edited_time": "2024-10-20T14:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1115d164-78d8-81fe-ae54-d4b6244ce900",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-09-30T15:14:00.000Z",
        "last_edited_time": "2024-09-30T16:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Điểm riêng biệt",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Điểm riêng biệt",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-8036-8f2f-e529090c7a00",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-10-07T06:35:00.000Z",
        "last_edited_time": "2024-10-07T06:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Về giá trị sử dụng",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Về giá trị sử dụng",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1d8fff2e-cab6-4ba3-bcc1-cf25f137bc72",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-10-07T10:26:00.000Z",
        "last_edited_time": "2024-10-07T10:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước mắt mình điểm qua use case là gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước mắt mình điểm qua use case là gì?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1894699a-6c7f-42ce-a759-186bea62f567",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-10-07T10:27:00.000Z",
        "last_edited_time": "2024-10-20T14:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Use case",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Use case",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " mô tả cách một sản phẩm, dịch vụ hoặc giải pháp có thể được áp dụng vào các tình huống thực tế để giải quyết vấn đề hoặc mang lại giá trị cho khách hàng & doanh nghiệp.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " mô tả cách một sản phẩm, dịch vụ hoặc giải pháp có thể được áp dụng vào các tình huống thực tế để giải quyết vấn đề hoặc mang lại giá trị cho khách hàng & doanh nghiệp.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "38e50b60-fee8-4fb9-9fca-b6ad5740fc78",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-10-07T10:26:00.000Z",
        "last_edited_time": "2024-10-07T10:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Physical product:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Physical product:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " các use case thường rất tập trung và giới hạn. Vd: tủ lạnh để làm mát, bảo quản; ghế để ngồi; xe để di chuyển…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " các use case thường rất tập trung và giới hạn. Vd: tủ lạnh để làm mát, bảo quản; ghế để ngồi; xe để di chuyển…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "82ac5f35-9406-4dcb-9759-80f5e4b375ad",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-10-07T10:28:00.000Z",
        "last_edited_time": "2024-12-21T10:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Digital product:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Digital product:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " cũng có các main use case, nhưng khả năng scale linh hoạt hơn. Vd: grab thoạt đầu là đặt xe, nhưng sau này có grab food, grab groceries,… cũng là ship nhưng mặt hàng đa dạng (ship người, ship vật); facebook thoạt đầu là mạng xã hội cho trường học nhưng giờ bạn có thể run business trên ấy, tạo event hay build cộng đồng,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " cũng có các main use case, nhưng khả năng scale linh hoạt hơn. Vd: grab thoạt đầu là đặt xe, nhưng sau này có grab food, grab groceries,… cũng là ship nhưng mặt hàng đa dạng (ship người, ship vật); facebook thoạt đầu là mạng xã hội cho trường học nhưng giờ bạn có thể run business trên ấy, tạo event hay build cộng đồng,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1735d164-78d8-80a2-9ab2-ff8782e0f501",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2025-01-06T05:02:00.000Z",
        "last_edited_time": "2025-01-06T05:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081525/uxcomic-imgs/1735d164-78d8-80a2-9ab2-ff8782e0f501.webp",
            "expiry_time": "2026-10-04T09:12:09.329Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1735d164-78d8-80a2-9ab2-ff8782e0f501"
      },
      {
        "object": "block",
        "id": "1115d164-78d8-8179-bcb5-dae6b49c45aa",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-09-30T15:14:00.000Z",
        "last_edited_time": "2024-10-06T14:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Về cách thức tương tác",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Về cách thức tương tác",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1115d164-78d8-8002-85ef-e80d6c22e22a",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-09-30T16:01:00.000Z",
        "last_edited_time": "2024-10-20T14:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Physical product (hữu hình): ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Physical product (hữu hình): ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "bạn có thể chạm, cầm nắm nó. Khi bạn dùng nó, tính phản hồi thường diễn ra ngay tức khắc và rất trực quan. Vd: bạn ngồi lên một cái ghế thì sẽ biết nó êm hay không êm, bạn sờ chiếc áo sẽ thấy mịn hay không. Vì thế “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "bạn có thể chạm, cầm nắm nó. Khi bạn dùng nó, tính phản hồi thường diễn ra ngay tức khắc và rất trực quan. Vd: bạn ngồi lên một cái ghế thì sẽ biết nó êm hay không êm, bạn sờ chiếc áo sẽ thấy mịn hay không. Vì thế “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "ergonomics",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "ergonomics",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "” là cụm từ sẽ thường được nghe nhiều khi thiết kế physical product.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” là cụm từ sẽ thường được nghe nhiều khi thiết kế physical product.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1115d164-78d8-8033-862c-e0510d936a59",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-09-30T16:03:00.000Z",
        "last_edited_time": "2024-11-22T11:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Digital product (vô hình): ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Digital product (vô hình): ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "bạn không thể chạm nó, nó phi vật thể, bản chất sản phẩm này giúp con người tiếp cận, xử lý & truyền thông tin cho nhau. Những gì tương tác ở đây là thông tin trên màn hình và luồng thông tin ấy thay đổi thế nào khi user tương tác với máy. Thông tin này tồn tại dưới hình thức visual hoặc âm thanh. Vì thế cụm từ “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "bạn không thể chạm nó, nó phi vật thể, bản chất sản phẩm này giúp con người tiếp cận, xử lý & truyền thông tin cho nhau. Những gì tương tác ở đây là thông tin trên màn hình và luồng thông tin ấy thay đổi thế nào khi user tương tác với máy. Thông tin này tồn tại dưới hình thức visual hoặc âm thanh. Vì thế cụm từ “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cognitive load",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cognitive load",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "” rất quan trọng khi thiết kế digital product. Và vì không bị giới hạn bởi vật lý, địa lý, con người, user có thể truy cập nó ở bất kì đâu, bất kì thời điểm nào nên tính linh hoạt sẽ cao hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” rất quan trọng khi thiết kế digital product. Và vì không bị giới hạn bởi vật lý, địa lý, con người, user có thể truy cập nó ở bất kì đâu, bất kì thời điểm nào nên tính linh hoạt sẽ cao hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1115d164-78d8-8095-b1be-fced7642dd4c",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-09-30T16:08:00.000Z",
        "last_edited_time": "2024-10-06T14:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Về mặt sản xuất",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Về mặt sản xuất",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1115d164-78d8-80fe-9ebb-c83048474e42",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-09-30T16:10:00.000Z",
        "last_edited_time": "2025-08-23T02:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Physical product:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Physical product:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " những thứ cần phải take care như là nguyên vật liệu, máy móc, kho bãi, bảo quản, vận chuyển, kênh phân phối… Theo thời gian sản phẩm sẽ bị hư hại và mất dần giá trị. Và việc cho ra một bản version mới sẽ cost hơn nhiều so với digital product.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " những thứ cần phải take care như là nguyên vật liệu, máy móc, kho bãi, bảo quản, vận chuyển, kênh phân phối… Theo thời gian sản phẩm sẽ bị hư hại và mất dần giá trị. Và việc cho ra một bản version mới sẽ cost hơn nhiều so với digital product.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1115d164-78d8-800b-853b-c9aad3523d2f",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-09-30T16:16:00.000Z",
        "last_edited_time": "2024-12-21T10:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Digital product:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Digital product:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " những nguyên vật liệu ở đây là công nghệ thông tin như thuật toán, data, sever, cloud, API, platform… Một điểm rất quý giá nhất trên digital đó là khả năng tracking, đo lường hành vi sử dụng của user dễ dàng hơn rất nhiều so với physical product >> nó giúp sản phẩm có thêm nhiều thông tin để tiếp tục hoàn thiện cũng như phán đoán được hướng đi tốt hơn. Và vì trên môi trường số, việc ship sản phẩm đến với khách hàng dễ dàng hơn >> việc cải tiến cũng diễn ra nhanh chóng, điều này khiến digital product phải thay đổi cải tiến liên tục.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " những nguyên vật liệu ở đây là công nghệ thông tin như thuật toán, data, sever, cloud, API, platform… Một điểm rất quý giá nhất trên digital đó là khả năng tracking, đo lường hành vi sử dụng của user dễ dàng hơn rất nhiều so với physical product >> nó giúp sản phẩm có thêm nhiều thông tin để tiếp tục hoàn thiện cũng như phán đoán được hướng đi tốt hơn. Và vì trên môi trường số, việc ship sản phẩm đến với khách hàng dễ dàng hơn >> việc cải tiến cũng diễn ra nhanh chóng, điều này khiến digital product phải thay đổi cải tiến liên tục.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1255d164-78d8-80a6-8e19-da123d6f377d",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-10-20T14:54:00.000Z",
        "last_edited_time": "2024-10-20T14:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1115d164-78d8-800c-b69d-c46e1745a5c9",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-09-30T16:32:00.000Z",
        "last_edited_time": "2024-09-30T16:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy thì so what",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy thì so what",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1465d164-78d8-8010-868c-fc95ddfe70ce",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-11-22T11:51:00.000Z",
        "last_edited_time": "2024-11-22T11:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau đây là vài điểm mình thấy hữu ích sau khi so sánh thử physical & digital product:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau đây là vài điểm mình thấy hữu ích sau khi so sánh thử physical & digital product:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1115d164-78d8-8016-9d68-f0c0e6b768e5",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-09-30T16:32:00.000Z",
        "last_edited_time": "2025-08-23T02:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "World matching",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "World matching",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": như bạn biết đó, con người mình dùng physical product từ xaaaaa xưa, từ thời hái lượm, thời đồ đá… nên việc design cho digital nếu được nên mô phỏng tốt như ngoài thực tế thì sẽ giúp trải nghiệm user được trực quan hơn. Ví dụ: thời gian feedback ngoài đời rất nhanh, bạn đụng vô gì đó là sẽ biết ngay nó nóng hay lạnh, sần sùi hay mịn màng nên nếu feedback trên app mà chậm 400ms thì user sẽ bắt đầu thấy chậm hay lag, hay không hiểu chuyện gì đang xảy ra.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": như bạn biết đó, con người mình dùng physical product từ xaaaaa xưa, từ thời hái lượm, thời đồ đá… nên việc design cho digital nếu được nên mô phỏng tốt như ngoài thực tế thì sẽ giúp trải nghiệm user được trực quan hơn. Ví dụ: thời gian feedback ngoài đời rất nhanh, bạn đụng vô gì đó là sẽ biết ngay nó nóng hay lạnh, sần sùi hay mịn màng nên nếu feedback trên app mà chậm 400ms thì user sẽ bắt đầu thấy chậm hay lag, hay không hiểu chuyện gì đang xảy ra.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1115d164-78d8-8050-a53a-cd572296eb85",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-09-30T16:41:00.000Z",
        "last_edited_time": "2024-10-06T14:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Data ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Data ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "là một tiền tệ quý mà chỉ có digital product mới có, vậy hãy nghĩ cách tận dụng nó nhiều nhất có thể. Dùng nó để hiểu về hành vi user, để phán đoán xu hướng nhu cầu, để tạo trải nghiệm cá nhân hoá,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "là một tiền tệ quý mà chỉ có digital product mới có, vậy hãy nghĩ cách tận dụng nó nhiều nhất có thể. Dùng nó để hiểu về hành vi user, để phán đoán xu hướng nhu cầu, để tạo trải nghiệm cá nhân hoá,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "1115d164-78d8-807c-a3c7-ce4ec216de40",
            "parent": {
              "type": "block_id",
              "block_id": "1115d164-78d8-8050-a53a-cd572296eb85"
            },
            "created_time": "2024-09-30T17:02:00.000Z",
            "last_edited_time": "2024-10-06T14:18:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [
                {
                  "type": "text",
                  "text": {
                    "content": "Tạo bằng Copilot AI",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Tạo bằng Copilot AI",
                  "href": null
                }
              ],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081527/uxcomic-imgs/1115d164-78d8-807c-a3c7-ce4ec216de40.jpg",
                "expiry_time": "2026-10-04T09:12:10.257Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/1115d164-78d8-807c-a3c7-ce4ec216de40"
          }
        ]
      },
      {
        "object": "block",
        "id": "1115d164-78d8-8042-8b34-e851441708dd",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-09-30T16:43:00.000Z",
        "last_edited_time": "2025-08-23T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Information, ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Information, ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "bản chất digital product là cầu nối con người với thông tin (mình cũng hay nghe qua từ “công nghệ thông tin” đúng không nào, nhìn chung các sản phẩm digital hầu hết là giúp mình tiếp nhận, tạo, xử lý & truyền các thông tin). Vậy nên để có hướng design tốt hơn thì mình sẽ nghiên cứu nhiều hơn về “cognitive load”, nghiên cứu cách con người xử lý thông tin, cách tổ chức thông tin như information architect, information hirearchy, signifier & signified…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "bản chất digital product là cầu nối con người với thông tin (mình cũng hay nghe qua từ “công nghệ thông tin” đúng không nào, nhìn chung các sản phẩm digital hầu hết là giúp mình tiếp nhận, tạo, xử lý & truyền các thông tin). Vậy nên để có hướng design tốt hơn thì mình sẽ nghiên cứu nhiều hơn về “cognitive load”, nghiên cứu cách con người xử lý thông tin, cách tổ chức thông tin như information architect, information hirearchy, signifier & signified…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1115d164-78d8-811c-ac6b-d003c727fa9f",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-09-30T15:14:00.000Z",
        "last_edited_time": "2024-09-30T15:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1115d164-78d8-8117-89fb-dc6f16129e47",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-09-30T15:14:00.000Z",
        "last_edited_time": "2024-09-30T15:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1115d164-78d8-81a4-b357-fcbf6dddcc3f",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-09-30T15:14:00.000Z",
        "last_edited_time": "2024-10-12T09:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "22f4879b-78c6-41f4-ac92-2219ca7879f2"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product là gì?",
              "href": "https://app.notion.com/p/22f4879b78c641f4ac922219ca7879f2"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1115d164-78d8-8189-932b-c2b485701845",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-09-30T15:14:00.000Z",
        "last_edited_time": "2024-10-20T14:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1165d164-78d8-80cb-9163-f985f8d8a788"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "IA? OOUX? Conceptual model?",
              "href": "https://app.notion.com/p/1165d16478d880cb9163f985f8d8a788"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1255d164-78d8-8015-a0f6-ccb6632770fa",
        "parent": {
          "type": "page_id",
          "page_id": "c066dc23-043d-44af-925d-1f71f899090a"
        },
        "created_time": "2024-10-20T14:49:00.000Z",
        "last_edited_time": "2024-10-20T14:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d",
    "created_time": "2024-09-15T05:36:00.000Z",
    "last_edited_time": "2025-09-03T11:04:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "fd3cd36d-73dd-4dee-8bd5-d159d6600124"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "View": {
        "id": "ATSa",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "A%5Bqc",
        "type": "select",
        "select": {
          "id": "\\i@K",
          "name": "⚓:1",
          "color": "pink"
        }
      },
      "Last edited time": {
        "id": "DMgm",
        "type": "last_edited_time",
        "last_edited_time": "2025-09-03T11:04:00.000Z"
      },
      "Publish": {
        "id": "FSnx",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "_tsp",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "g%7BBg",
        "type": "created_time",
        "created_time": "2024-09-15T05:36:00.000Z"
      },
      "Share": {
        "id": "hp~_",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "m%7C%40x",
        "type": "number",
        "number": null
      },
      "Formula": {
        "id": "re%3BE",
        "type": "formula",
        "formula": {
          "type": "number",
          "number": 1
        }
      },
      "Tag": {
        "id": "%7CAvQ",
        "type": "select",
        "select": {
          "id": "156ef770-14db-4170-b1d7-95a2fbdf62ba",
          "name": "2-User",
          "color": "default"
        }
      },
      "ID": {
        "id": "~RYT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FD",
          "number": 1
        }
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Mental model?",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Mental model?",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Mental-model-73bdf5d9ca494b2789a22dde16b2af7d",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "5cacdbff-b9e2-4973-b565-ec1ae4327ec9",
      "name": "Fundamental",
      "slug": "fundamental",
      "icon": "🌞",
      "order": 2,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "Product",
          "slug": "product",
          "order": 1
        },
        {
          "id": "156ef770-14db-4170-b1d7-95a2fbdf62ba",
          "name": "User",
          "slug": "user",
          "order": 2
        },
        {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "Design",
          "slug": "design",
          "order": 3
        },
        {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "Random",
          "slug": "random",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "156ef770-14db-4170-b1d7-95a2fbdf62ba",
      "name": "User",
      "slug": "user",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "1025d164-78d8-801a-b506-fb79dcd77518",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2024-09-15T05:39:00.000Z",
        "last_edited_time": "2024-09-15T05:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081530/uxcomic-imgs/1025d164-78d8-801a-b506-fb79dcd77518.png",
            "expiry_time": "2026-10-04T09:12:10.833Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1025d164-78d8-801a-b506-fb79dcd77518"
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-801f-a244-ededce24bd14",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2024-11-26T01:52:00.000Z",
        "last_edited_time": "2024-11-26T01:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong công việc của UX design, mình đoán ít nhất một lần bạn đã nghe qua thiết kế phù hợp với mental model của user, vậy mental model là gì vậy? Nó có quyền năng gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong công việc của UX design, mình đoán ít nhất một lần bạn đã nghe qua thiết kế phù hợp với mental model của user, vậy mental model là gì vậy? Nó có quyền năng gì?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-80c9-b8dc-c1fcdbaf8862",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2024-11-26T01:54:00.000Z",
        "last_edited_time": "2024-11-26T01:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-8037-8b38-f0de3c4831e2",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2024-11-26T01:52:00.000Z",
        "last_edited_time": "2024-11-26T01:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mental model",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mental model",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1025d164-78d8-80b0-8e6d-c58fb13e22c5",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2024-09-15T05:38:00.000Z",
        "last_edited_time": "2025-09-03T11:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mental model là cách chúng ta hình dung, giải thích và và hiểu về thế giới, về cách một sự việc hoặc hệ thống sẽ hoạt động. Khả năng này được hình thành thông qua trải nghiệm, những kiến thức đã có, bản năng và kỳ vọng. Nói một cách đơn giản hơn, thì nó là thấu kính của mỗi một người khi nhìn vào một sự vật hiện tượng để giải nghĩa, suy diễn và cho ra một cái hiểu, 1 thái độ gì đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mental model là cách chúng ta hình dung, giải thích và và hiểu về thế giới, về cách một sự việc hoặc hệ thống sẽ hoạt động. Khả năng này được hình thành thông qua trải nghiệm, những kiến thức đã có, bản năng và kỳ vọng. Nói một cách đơn giản hơn, thì nó là thấu kính của mỗi một người khi nhìn vào một sự vật hiện tượng để giải nghĩa, suy diễn và cho ra một cái hiểu, 1 thái độ gì đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-80df-9da1-ff32ceabbe92",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-01-14T11:17:00.000Z",
        "last_edited_time": "2025-09-03T11:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "VD: ai quen dùng các web đặt máy bay thì sẽ kì vọng thanh search ngày đi ngày về, điểm đến nằm ngay trên đầu trang. Hay ví dụ ai đã bị chó cắn thì sẽ không có ấn tượng tốt với chó, vì khi thấy chó họ sẽ thấy sự nguy hiểm trong đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "VD: ai quen dùng các web đặt máy bay thì sẽ kì vọng thanh search ngày đi ngày về, điểm đến nằm ngay trên đầu trang. Hay ví dụ ai đã bị chó cắn thì sẽ không có ấn tượng tốt với chó, vì khi thấy chó họ sẽ thấy sự nguy hiểm trong đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-8078-97f6-feaa24b0a137",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-01-14T11:16:00.000Z",
        "last_edited_time": "2025-01-14T11:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1025d164-78d8-8093-bbec-c48d0c68230d",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2024-09-15T05:38:00.000Z",
        "last_edited_time": "2025-09-03T11:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Và mental model có thể thay đổi theo thời gian (bởi vậy trong ngành ta mới có từ “educate user”). Ví dụ: icon “sparkle” gần đây được dùng cho các tính năng AI, khi market & trong app sử dụng thường xuyên, user sau này nhìn thấy sẽ hiểu được feature đó có apply công nghệ AI.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Và mental model có thể thay đổi theo thời gian (bởi vậy trong ngành ta mới có từ “educate user”). Ví dụ: icon “sparkle” gần đây được dùng cho các tính năng AI, khi market & trong app sử dụng thường xuyên, user sau này nhìn thấy sẽ hiểu được feature đó có apply công nghệ AI.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-8091-a3cb-d92f04afb9df",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-09-03T11:02:00.000Z",
        "last_edited_time": "2025-09-03T11:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-805e-af27-f0179d0879f2",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2024-12-10T02:14:00.000Z",
        "last_edited_time": "2025-08-09T04:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tip: khi bạn test với user, thấy user “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tip: khi bạn test với user, thấy user “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "ủa, tôi tưởng là…",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "ủa, tôi tưởng là…",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "” ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” ",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "24a5d164-78d8-8095-8c40-f8d89a87c56f",
            "parent": {
              "type": "block_id",
              "block_id": "1585d164-78d8-805e-af27-f0179d0879f2"
            },
            "created_time": "2025-08-09T04:49:00.000Z",
            "last_edited_time": "2025-08-09T04:49:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": ">> đây chính là mental model. Vì để họ “tưởng là…” có nghĩa họ đang dựa trên những kinh nghiệm quá khứ, thói quen hay một cách suy đoán nào đó có sẵn từ trước.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": ">> đây chính là mental model. Vì để họ “tưởng là…” có nghĩa họ đang dựa trên những kinh nghiệm quá khứ, thói quen hay một cách suy đoán nào đó có sẵn từ trước.",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-8060-acbf-c30522e87f78",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2024-11-26T02:27:00.000Z",
        "last_edited_time": "2024-11-26T02:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80e0-a758-f16d8812ed5d",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:28:00.000Z",
        "last_edited_time": "2025-07-28T05:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Type of mental model",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Type of mental model",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-808b-bff6-de22edf9a9b9",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:31:00.000Z",
        "last_edited_time": "2025-07-29T04:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mental model là những kiến thức, khung hiểu biết đã có.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mental model là những kiến thức, khung hiểu biết đã có.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-807a-968b-ec9aa165c8cd",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:16:00.000Z",
        "last_edited_time": "2025-07-28T05:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Existing mental model",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Existing mental model",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Tận dụng lại cách hiểu trước đó (ví dụ khi lướt web, nếu ta click vào logo trên top  navigation thì nó sẽ quay về homepage).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Tận dụng lại cách hiểu trước đó (ví dụ khi lướt web, nếu ta click vào logo trên top  navigation thì nó sẽ quay về homepage).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80f6-8209-c1ad22136975",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:16:00.000Z",
        "last_edited_time": "2025-09-03T10:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Universal mental model",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Universal mental model",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Cách con người suy đoán, diễn giải chung chung mà đa phần con người đều vậy (ví dụ: gestalt - nghiên cứu được nếu ta đặt các cụm thông tin gần nhau thì con người sẽ nghĩ khối thông tin ấy có tính liên quan, hoặc nếu dùng chung 1 style thì thông tin ấy có tính tương đồng).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Cách con người suy đoán, diễn giải chung chung mà đa phần con người đều vậy (ví dụ: gestalt - nghiên cứu được nếu ta đặt các cụm thông tin gần nhau thì con người sẽ nghĩ khối thông tin ấy có tính liên quan, hoặc nếu dùng chung 1 style thì thông tin ấy có tính tương đồng).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-808e-af05-e785112789c8",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:17:00.000Z",
        "last_edited_time": "2025-09-03T10:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Conceptual mental model",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Conceptual mental model",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Là khi product đã educate user gì đó, và qua một thời gian, nó trở thành thói quen, kinh nghiệm của user khi dùng chính product đó (ví dụ: nhấn giữ vào một item để hiển thị thêm các sub action).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Là khi product đã educate user gì đó, và qua một thời gian, nó trở thành thói quen, kinh nghiệm của user khi dùng chính product đó (ví dụ: nhấn giữ vào một item để hiển thị thêm các sub action).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-8026-a8e9-e467d53d89d5",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2024-11-26T02:50:00.000Z",
        "last_edited_time": "2024-11-26T02:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80ef-b53a-c4d2820f612b",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:32:00.000Z",
        "last_edited_time": "2025-07-28T05:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khái niệm top-down processing & bottom-up processing",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khái niệm top-down processing & bottom-up processing",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-8002-8614-fe38c8f028d9",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:32:00.000Z",
        "last_edited_time": "2025-07-28T05:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "2 khái niệm nói để 2 cách não bộ chúng ta xử lý và diễn giải thông tin.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2 khái niệm nói để 2 cách não bộ chúng ta xử lý và diễn giải thông tin.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-8072-a79d-e80eeabde759",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:32:00.000Z",
        "last_edited_time": "2025-07-28T05:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753685303/uxcomic-imgs/23e5d164-78d8-8072-a79d-e80eeabde759.jpg",
            "expiry_time": "2026-10-04T09:12:10.834Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/23e5d164-78d8-8072-a79d-e80eeabde759"
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80c6-8d0e-dbe6e83711a0",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:32:00.000Z",
        "last_edited_time": "2025-07-28T05:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-8063-ad9f-c860c84f7eb2",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:32:00.000Z",
        "last_edited_time": "2025-07-28T05:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bottom-up processing",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bottom-up processing",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-808e-b691-f2224ed7af41",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:32:00.000Z",
        "last_edited_time": "2025-07-28T05:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là quá trình khi bạn tiếp xúc với một khái niệm ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là quá trình khi bạn tiếp xúc với một khái niệm ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "mới lạ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "mới lạ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", bạn xử lý thông tin trên dữ liệu thô thu thập được từ các giác quan để hình thành nên một ý nghĩa cụ thể nào đó. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", bạn xử lý thông tin trên dữ liệu thô thu thập được từ các giác quan để hình thành nên một ý nghĩa cụ thể nào đó. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-8038-8667-edc0b6217ef4",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:32:00.000Z",
        "last_edited_time": "2025-07-28T05:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ lần đầu bạn sử dụng photoshop phải làm quen với từng tool, từng function một. Quá trình này bắt đầu từ qua việc như nhìn & đoán xem icon đó nghĩa là gì, đọc term đó nghĩa là gì, click thử này kia để xem nó hoạt động ra sao và có ý nghĩa như thế nào.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ lần đầu bạn sử dụng photoshop phải làm quen với từng tool, từng function một. Quá trình này bắt đầu từ qua việc như nhìn & đoán xem icon đó nghĩa là gì, đọc term đó nghĩa là gì, click thử này kia để xem nó hoạt động ra sao và có ý nghĩa như thế nào.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-804a-a800-ce14d8042165",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:52:00.000Z",
        "last_edited_time": "2025-07-28T05:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lúc này não bộ nó sẽ phải  phân tích nhiều  & xử lý chậm hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lúc này não bộ nó sẽ phải  phân tích nhiều  & xử lý chậm hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80b6-b76d-fdeb05853055",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:32:00.000Z",
        "last_edited_time": "2025-07-28T05:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753685304/uxcomic-imgs/23e5d164-78d8-80b6-b76d-fdeb05853055.jpg",
            "expiry_time": "2026-10-04T09:12:10.930Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/23e5d164-78d8-80b6-b76d-fdeb05853055"
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-8063-b423-e0e40d34e354",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:32:00.000Z",
        "last_edited_time": "2025-07-28T05:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80db-8377-fe2032fffaf9",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:32:00.000Z",
        "last_edited_time": "2025-07-28T05:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Top-down processing",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Top-down processing",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-804e-8174-e5095bf751b2",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:32:00.000Z",
        "last_edited_time": "2025-07-28T05:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là quá trình bạn xử lý, giải nghĩa thông tin dựa trên kiến thức, kinh nghiệm và kỳ vọng ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là quá trình bạn xử lý, giải nghĩa thông tin dựa trên kiến thức, kinh nghiệm và kỳ vọng ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "sẵn có ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "sẵn có ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "để có thể hiểu. Não bộ xử lý nhanh hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "để có thể hiểu. Não bộ xử lý nhanh hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-8098-bdca-d62982af2005",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:32:00.000Z",
        "last_edited_time": "2025-07-28T05:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một ví dụ thực tế mình thấy rất hay để nói về “top dowm processing” này là metaphor (ẩn dụ), ta dùng những minh hoạ ta đã biết để hiểu một thứ mới tốt hơn, ta dùng những ví dụ để nói về cái mới, điều này giúp ta nắm bắt được vấn đề tốt hơn. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một ví dụ thực tế mình thấy rất hay để nói về “top dowm processing” này là metaphor (ẩn dụ), ta dùng những minh hoạ ta đã biết để hiểu một thứ mới tốt hơn, ta dùng những ví dụ để nói về cái mới, điều này giúp ta nắm bắt được vấn đề tốt hơn. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80b4-a1c5-f5fbfe42b25a",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:32:00.000Z",
        "last_edited_time": "2025-07-28T05:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: “trái tim sắt đá” ý nói con người thô kệch, vô cảm, vì sao ta nghĩ được thế, vì sắt đá mang trong nó tính chất ấy, nó vô hồn, nó cứng cỏi. Ngược lại “uyển chuyển như nước” cho thấy khả năng linh hoạt qua vượt mọi địa hình >> khả năng khéo léo xử lý tình huống.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: “trái tim sắt đá” ý nói con người thô kệch, vô cảm, vì sao ta nghĩ được thế, vì sắt đá mang trong nó tính chất ấy, nó vô hồn, nó cứng cỏi. Ngược lại “uyển chuyển như nước” cho thấy khả năng linh hoạt qua vượt mọi địa hình >> khả năng khéo léo xử lý tình huống.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-8088-9ef7-da7b59c3dbd0",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:32:00.000Z",
        "last_edited_time": "2025-07-28T05:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bởi vậy mới nói =))",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bởi vậy mới nói =))",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "23e5d164-78d8-804f-af72-c80f24a9165d",
            "parent": {
              "type": "block_id",
              "block_id": "23e5d164-78d8-8088-9ef7-da7b59c3dbd0"
            },
            "created_time": "2025-07-28T05:32:00.000Z",
            "last_edited_time": "2025-07-28T05:32:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "“Giang sơn dễ đổi, bản tính khó dời” - Top down processing",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "“Giang sơn dễ đổi, bản tính khó dời” - Top down processing",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "23e5d164-78d8-801e-ba02-d205ea33d66b",
            "parent": {
              "type": "block_id",
              "block_id": "23e5d164-78d8-8088-9ef7-da7b59c3dbd0"
            },
            "created_time": "2025-07-28T05:32:00.000Z",
            "last_edited_time": "2025-07-28T05:32:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "“Vạn sự khởi đầu nan” - Bottom up processing",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "“Vạn sự khởi đầu nan” - Bottom up processing",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-8083-b72c-ded091107845",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:32:00.000Z",
        "last_edited_time": "2025-07-28T05:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-803e-90fd-dfa6f8cb5e73",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2024-11-26T02:27:00.000Z",
        "last_edited_time": "2024-11-26T02:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ứng dụng thế nào?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ứng dụng thế nào?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-809d-ae96-cc7b384c872b",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2024-11-26T02:27:00.000Z",
        "last_edited_time": "2025-08-09T04:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Như mình thấy top-down process sẽ giúp mình giải nghĩa nhanh hơn vì dựa trên những kiến thức sẵn có, còn bottom-up thì sẽ take mental effort hơn vì cần phải học.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Như mình thấy top-down process sẽ giúp mình giải nghĩa nhanh hơn vì dựa trên những kiến thức sẵn có, còn bottom-up thì sẽ take mental effort hơn vì cần phải học.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-80da-96da-e07b8f4e742b",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2024-11-26T02:30:00.000Z",
        "last_edited_time": "2024-12-28T04:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: khi bạn chạy xe trên một con đường lạ, bạn sẽ phải chú ý đến các biển báo và chỉ dẫn nhiều, còn khi đã lái trên con đường quen thuộc thì bạn ít để ý hơn vì đã dựa trên trí nhớ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: khi bạn chạy xe trên một con đường lạ, bạn sẽ phải chú ý đến các biển báo và chỉ dẫn nhiều, còn khi đã lái trên con đường quen thuộc thì bạn ít để ý hơn vì đã dựa trên trí nhớ.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80de-8298-d603d67b6acf",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:24:00.000Z",
        "last_edited_time": "2025-07-28T05:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753685305/uxcomic-imgs/23e5d164-78d8-80de-8298-d603d67b6acf.jpg",
            "expiry_time": "2026-10-04T09:12:10.930Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/23e5d164-78d8-80de-8298-d603d67b6acf"
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80e2-b49b-c5d936db4221",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:36:00.000Z",
        "last_edited_time": "2025-07-28T05:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80da-86eb-fd5729560023",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:35:00.000Z",
        "last_edited_time": "2025-08-09T04:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tận dụng mental model (khung hiểu biết đã có) để tối ưu cho não bộ xử lý theo hướng top-down processing >> nó giúp user dễ học, dễ dùng hơn (mental model có thể hiểu đơn giản là một dạng “short-cut” trong tư duy, họ adapt những gì đã biết trước đó để hiểu, để dùng một thứ mới).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tận dụng mental model (khung hiểu biết đã có) để tối ưu cho não bộ xử lý theo hướng top-down processing >> nó giúp user dễ học, dễ dùng hơn (mental model có thể hiểu đơn giản là một dạng “short-cut” trong tư duy, họ adapt những gì đã biết trước đó để hiểu, để dùng một thứ mới).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-809e-9281-de255474a53d",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-01-14T11:17:00.000Z",
        "last_edited_time": "2025-01-14T11:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-8086-b1c0-ea6bda9ba786",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2024-11-26T02:32:00.000Z",
        "last_edited_time": "2025-08-09T04:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Điều này lý giải sự cần thiết của tính đồng bộ trong thiết kế",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Điều này lý giải sự cần thiết của tính đồng bộ trong thiết kế",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", tại sao nên tối đa tận dụng các element, pattern quen thuộc để user không phải learn nữa, mà họ có thể dùng nó mượt mà ngay (vì user đã có kinh nghiệm sử dụng thông qua product của mình hoặc các product khác trên thị trường). Ví dụ: product nào cũng sẽ dùng “kính lúp” để indicate cho tính năng search, app banking nào cũng để số dư ngay trên cùng của trang home, các main CTA trên app đều dùng màu primary…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", tại sao nên tối đa tận dụng các element, pattern quen thuộc để user không phải learn nữa, mà họ có thể dùng nó mượt mà ngay (vì user đã có kinh nghiệm sử dụng thông qua product của mình hoặc các product khác trên thị trường). Ví dụ: product nào cũng sẽ dùng “kính lúp” để indicate cho tính năng search, app banking nào cũng để số dư ngay trên cùng của trang home, các main CTA trên app đều dùng màu primary…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-8047-8850-dcb08e194cc7",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:44:00.000Z",
        "last_edited_time": "2025-08-09T04:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Why mental model matter",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Why mental model matter",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-8008-b2d7-ef388f54fa4e",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:43:00.000Z",
        "last_edited_time": "2025-09-03T10:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giảm mental effort - User không phải học lại một patten mới.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giảm mental effort - User không phải học lại một patten mới.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-8045-9719-f08ed95fd506",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:43:00.000Z",
        "last_edited_time": "2025-07-28T05:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tăng usability - user hoàn thành task một cách nhanh & hiệu quả hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tăng usability - user hoàn thành task một cách nhanh & hiệu quả hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80eb-8891-f88401398e45",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:43:00.000Z",
        "last_edited_time": "2025-07-29T04:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tăng trust - user thấy system hoạt động đúng logic, ổn định sẽ giúp họ thấy an toàn, dễ đoán, dễ control hơn. Ngược lại nếu sai với mental model của họ thì sẽ dẫn đến các sai lầm khi sử dụng >> giảm niềm tin (thậm chí cảm thấy bị lừa).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tăng trust - user thấy system hoạt động đúng logic, ổn định sẽ giúp họ thấy an toàn, dễ đoán, dễ control hơn. Ngược lại nếu sai với mental model của họ thì sẽ dẫn đến các sai lầm khi sử dụng >> giảm niềm tin (thậm chí cảm thấy bị lừa).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80e5-a62d-edfba4c41b68",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:49:00.000Z",
        "last_edited_time": "2025-07-28T05:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80db-80ba-d308e23a4cb8",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:44:00.000Z",
        "last_edited_time": "2025-07-28T05:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reminder",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reminder",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-8082-babc-e78c00fbbc26",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:44:00.000Z",
        "last_edited_time": "2025-07-28T05:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước khi làm sản phẩm, ux designer/ux researcher nên nghiên cứu các sản phẩm tương tự hoặc cách target user suy nghĩ hành động hoặc rà lại các pattern sử dụng quen thuộc hiện có trên app mình.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước khi làm sản phẩm, ux designer/ux researcher nên nghiên cứu các sản phẩm tương tự hoặc cách target user suy nghĩ hành động hoặc rà lại các pattern sử dụng quen thuộc hiện có trên app mình.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80e4-a557-e1e5239f306c",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:50:00.000Z",
        "last_edited_time": "2025-07-28T05:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Từ đó nắm bắt đc hành vi, thói quen sử dụng của user để tạo ra design phù hợp mà không phải tạo mới quá nhiều (vì tạo mới ở đây chưa chắc đã tốt bằng việc mapping đúng mental model của user). ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Từ đó nắm bắt đc hành vi, thói quen sử dụng của user để tạo ra design phù hợp mà không phải tạo mới quá nhiều (vì tạo mới ở đây chưa chắc đã tốt bằng việc mapping đúng mental model của user). ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-8002-8125-f629cf12937d",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:51:00.000Z",
        "last_edited_time": "2025-07-28T05:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "VD: Messenger bắt chước Story của Snapchat, khi bật công tắc ngoài đời ta thấy nó sáng lên cũng giống như trạng thái click chọn checkbox, radio hay toggle trên UI ta cũng dùng màu để biểu trưng cho sự “sáng lên” này…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "VD: Messenger bắt chước Story của Snapchat, khi bật công tắc ngoài đời ta thấy nó sáng lên cũng giống như trạng thái click chọn checkbox, radio hay toggle trên UI ta cũng dùng màu để biểu trưng cho sự “sáng lên” này…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-809b-9da3-f92b03a2f630",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:44:00.000Z",
        "last_edited_time": "2025-07-28T05:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để dễ hình dung thì thiết kế phù hợp với mental model giống như bạn cần nói “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để dễ hình dung thì thiết kế phù hợp với mental model giống như bạn cần nói “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "ngôn ngữ quen thuộc” ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "ngôn ngữ quen thuộc” ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "với user, ở địa phương đó hay dùng từ gì thì bạn cũng nên dùng từ ấy.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "với user, ở địa phương đó hay dùng từ gì thì bạn cũng nên dùng từ ấy.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-801b-a98d-d1ea95c90a7b",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:44:00.000Z",
        "last_edited_time": "2025-07-28T05:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có một cách ẩn dụ khá hay về mental model, thiết UX giống như kể một câu chuyện đùa, nếu bạn phải giải thích nó thì câu chuyện đã bớt buồn cười rồi. Nghe nói quê :)))))",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có một cách ẩn dụ khá hay về mental model, thiết UX giống như kể một câu chuyện đùa, nếu bạn phải giải thích nó thì câu chuyện đã bớt buồn cười rồi. Nghe nói quê :)))))",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-8009-ba1a-ff9ae56b296d",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-01-14T11:18:00.000Z",
        "last_edited_time": "2025-01-14T11:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-806b-b814-ff7b5ec5702f",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2024-11-26T02:36:00.000Z",
        "last_edited_time": "2025-08-09T04:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Còn trường hợp nếu cần thiết kế một gì đó khác lạ, tức có nghĩa bạn đang cần user xây một mental model mới, điều designer cần làm là phải cung cấp các gợi ý, hướng dẫn, onboarding hoặc cố gắng áp dụng world mapping để quá trình học của user được dễ dàng. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Còn trường hợp nếu cần thiết kế một gì đó khác lạ, tức có nghĩa bạn đang cần user xây một mental model mới, điều designer cần làm là phải cung cấp các gợi ý, hướng dẫn, onboarding hoặc cố gắng áp dụng world mapping để quá trình học của user được dễ dàng. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24a5d164-78d8-803a-8d1a-df7deaefad50",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-08-09T04:46:00.000Z",
        "last_edited_time": "2025-08-09T04:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: product tour, tooltip, các tính năng liên quan đến AI trên thị trường đều có biểu tượng sparkle thì nếu product mình có tính năng AI thì cũng nên có biểu tượng sparkle ấy),…hoặc ta tận dụng các icon mang tính universal (ai cũng biết) như nút “back = ←”; nút “đóng = X” ; nút “thêm = +”…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: product tour, tooltip, các tính năng liên quan đến AI trên thị trường đều có biểu tượng sparkle thì nếu product mình có tính năng AI thì cũng nên có biểu tượng sparkle ấy),…hoặc ta tận dụng các icon mang tính universal (ai cũng biết) như nút “back = ←”; nút “đóng = X” ; nút “thêm = +”…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-809e-b27e-f5caeb7f08c9",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-01-14T11:18:00.000Z",
        "last_edited_time": "2025-01-14T11:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-8045-9362-e92122b5e4c4",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2024-11-26T02:51:00.000Z",
        "last_edited_time": "2025-08-09T04:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Harsh truth",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Harsh truth",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-804c-9284-da91f010ee6e",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2024-11-26T02:51:00.000Z",
        "last_edited_time": "2025-01-06T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đó là khi ta hoặc team ta là những người định hình nên product hay feature đó hoạt động ra sao >> ta dễ dàng thấy nó dễ dùng và nghĩ rằng user cũng thấy tương tự, nhưng có khi thực tế mental model của user rất khác, họ sẽ gặp trở ngại hoặc sử dụng nó theo chiều hướng khác hoàn toàn. Vậy nên hãy thường xuyên test với user để điều chỉnh phù hợp, nhận diện được khoảng gap này càng sớm càng tốt.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đó là khi ta hoặc team ta là những người định hình nên product hay feature đó hoạt động ra sao >> ta dễ dàng thấy nó dễ dùng và nghĩ rằng user cũng thấy tương tự, nhưng có khi thực tế mental model của user rất khác, họ sẽ gặp trở ngại hoặc sử dụng nó theo chiều hướng khác hoàn toàn. Vậy nên hãy thường xuyên test với user để điều chỉnh phù hợp, nhận diện được khoảng gap này càng sớm càng tốt.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-8024-9ec2-cea743957dfd",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2024-11-26T02:57:00.000Z",
        "last_edited_time": "2024-11-26T02:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081540/uxcomic-imgs/14a5d164-78d8-8024-9ec2-cea743957dfd.png",
            "expiry_time": "2026-10-04T09:12:11.006Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/14a5d164-78d8-8024-9ec2-cea743957dfd"
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-8077-9c46-c94ba347a97e",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2024-11-26T01:51:00.000Z",
        "last_edited_time": "2024-11-26T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-800e-9dfd-eb59886fa531",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2024-11-26T01:56:00.000Z",
        "last_edited_time": "2024-11-26T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2635d164-78d8-8066-a6b8-d33992fa6dff",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-09-03T10:52:00.000Z",
        "last_edited_time": "2025-09-03T10:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://thedecisionlab.com/reference-guide/design/mental-models",
                "link": {
                  "url": "https://thedecisionlab.com/reference-guide/design/mental-models?utm_source=chatgpt.com"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://thedecisionlab.com/reference-guide/design/mental-models",
              "href": "https://thedecisionlab.com/reference-guide/design/mental-models?utm_source=chatgpt.com"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80bc-817c-fbbb6ed062fd",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T05:25:00.000Z",
        "last_edited_time": "2025-07-28T05:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.nngroup.com/articles/mental-models/",
                "link": {
                  "url": "https://www.nngroup.com/articles/mental-models/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.nngroup.com/articles/mental-models/",
              "href": "https://www.nngroup.com/articles/mental-models/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-8021-aadc-d4fe93631d1c",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2024-11-26T01:56:00.000Z",
        "last_edited_time": "2024-11-26T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.linkedin.com/pulse/mental-model-là-gì-được-ứng-dụng-vào-ux-như-thế-nào-staylab?",
                "link": {
                  "url": "https://www.linkedin.com/pulse/mental-model-l%C3%A0-g%C3%AC-%C4%91%C6%B0%E1%BB%A3c-%E1%BB%A9ng-d%E1%BB%A5ng-v%C3%A0o-ux-nh%C6%B0-th%E1%BA%BF-n%C3%A0o-staylab?utm_source=share&utm_medium=member_ios&utm_campaign=share_via"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.linkedin.com/pulse/mental-model-là-gì-được-ứng-dụng-vào-ux-như-thế-nào-staylab?",
              "href": "https://www.linkedin.com/pulse/mental-model-l%C3%A0-g%C3%AC-%C4%91%C6%B0%E1%BB%A3c-%E1%BB%A9ng-d%E1%BB%A5ng-v%C3%A0o-ux-nh%C6%B0-th%E1%BA%BF-n%C3%A0o-staylab?utm_source=share&utm_medium=member_ios&utm_campaign=share_via"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17a5d164-78d8-80f5-94ae-f8ef860c895e",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-01-13T02:59:00.000Z",
        "last_edited_time": "2025-01-13T02:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://uxmyths.com/",
                "link": {
                  "url": "https://uxmyths.com/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://uxmyths.com/",
              "href": "https://uxmyths.com/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23f5d164-78d8-80a2-9c27-f426d427d351",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-29T04:00:00.000Z",
        "last_edited_time": "2025-07-29T04:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.thealien.design/insights/mental-model-in-ux-design",
                "link": {
                  "url": "https://www.thealien.design/insights/mental-model-in-ux-design"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.thealien.design/insights/mental-model-in-ux-design",
              "href": "https://www.thealien.design/insights/mental-model-in-ux-design"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23f5d164-78d8-806d-9514-c6804fa628c1",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-29T04:02:00.000Z",
        "last_edited_time": "2025-07-29T04:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://thailam.substack.com/p/tam-quan-trong-cua-user-mental-model",
                "link": {
                  "url": "https://thailam.substack.com/p/tam-quan-trong-cua-user-mental-model"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://thailam.substack.com/p/tam-quan-trong-cua-user-mental-model",
              "href": "https://thailam.substack.com/p/tam-quan-trong-cua-user-mental-model"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-80be-8078-ef88a9832d4a",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2024-11-26T01:56:00.000Z",
        "last_edited_time": "2024-11-26T02:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-80e2-a774-f14a0172f077",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2024-11-26T02:54:00.000Z",
        "last_edited_time": "2024-11-26T02:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80ef-9495-d027a2f24d03",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-07-28T06:43:00.000Z",
        "last_edited_time": "2025-07-28T06:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Understand, Empathize user?",
              "href": "https://app.notion.com/p/32cbe568c34b4255a408f2a2e6227bb2"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1735d164-78d8-8021-a5ba-faf3809a5116",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2025-01-06T02:06:00.000Z",
        "last_edited_time": "2025-01-06T02:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "f27ddffd-7a16-46eb-9e41-c71d27945645"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Why people said “Good design is invisible”?",
              "href": "https://app.notion.com/p/f27ddffd7a1646eb9e41c71d27945645"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-800f-aaa7-e77c06178dc2",
        "parent": {
          "type": "page_id",
          "page_id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
        },
        "created_time": "2024-11-26T02:54:00.000Z",
        "last_edited_time": "2024-11-26T02:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX as a Cupid",
              "href": "https://app.notion.com/p/10f5d16478d8808484a5d6eff66f3eec"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "ed40fd40-a318-4fd6-a63f-0067b4e54861",
    "created_time": "2024-09-15T05:36:00.000Z",
    "last_edited_time": "2025-10-21T04:48:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "fd3cd36d-73dd-4dee-8bd5-d159d6600124"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "View": {
        "id": "ATSa",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "A%5Bqc",
        "type": "select",
        "select": {
          "id": "Blq|",
          "name": "⚓:2",
          "color": "green"
        }
      },
      "Last edited time": {
        "id": "DMgm",
        "type": "last_edited_time",
        "last_edited_time": "2025-10-21T04:48:00.000Z"
      },
      "Publish": {
        "id": "FSnx",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "_tsp",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "g%7BBg",
        "type": "created_time",
        "created_time": "2024-09-15T05:36:00.000Z"
      },
      "Share": {
        "id": "hp~_",
        "type": "number",
        "number": null
      },
      "Dislike": {
        "id": "m%7C%40x",
        "type": "number",
        "number": null
      },
      "Formula": {
        "id": "re%3BE",
        "type": "formula",
        "formula": {
          "type": "number",
          "number": 1
        }
      },
      "Tag": {
        "id": "%7CAvQ",
        "type": "select",
        "select": {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "3-Design",
          "color": "default"
        }
      },
      "ID": {
        "id": "~RYT",
        "type": "unique_id",
        "unique_id": {
          "prefix": "FD",
          "number": 2
        }
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Design value",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Design value",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Design-value-ed40fd40a3184fd6a63f0067b4e54861",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "5cacdbff-b9e2-4973-b565-ec1ae4327ec9",
      "name": "Fundamental",
      "slug": "fundamental",
      "icon": "🌞",
      "order": 2,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "843ac5bc-2826-43e2-a5ea-ff89ae43d888",
          "name": "Product",
          "slug": "product",
          "order": 1
        },
        {
          "id": "156ef770-14db-4170-b1d7-95a2fbdf62ba",
          "name": "User",
          "slug": "user",
          "order": 2
        },
        {
          "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
          "name": "Design",
          "slug": "design",
          "order": 3
        },
        {
          "id": "9290a1c0-fd10-40c6-a821-56f188976357",
          "name": "Random",
          "slug": "random",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "4d57276c-5c0e-47d6-93b9-378a6f6d4367",
      "name": "Design",
      "slug": "design",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "1125d164-78d8-815e-bef6-c3aa0f79fdd4",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-01T02:01:00.000Z",
        "last_edited_time": "2024-10-06T13:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081544/uxcomic-imgs/1125d164-78d8-815e-bef6-c3aa0f79fdd4.png",
            "expiry_time": "2026-10-04T09:12:13.069Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1125d164-78d8-815e-bef6-c3aa0f79fdd4"
      },
      {
        "object": "block",
        "id": "1125d164-78d8-81e4-a19a-d3e104498b7e",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-01T02:01:00.000Z",
        "last_edited_time": "2024-12-28T04:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đã bao giờ bạn thắc mắc về giá trị công việc của design là gì chưa? Tại sao ngành này được sinh ra? Trong tổ chức công ty thì mọi người kì vọng gì ở designer? Bạn bè bạn nghĩ gì khi biết mình làm công việc thiết kế, họ hiểu nó ra sao & có những kì vọng gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đã bao giờ bạn thắc mắc về giá trị công việc của design là gì chưa? Tại sao ngành này được sinh ra? Trong tổ chức công ty thì mọi người kì vọng gì ở designer? Bạn bè bạn nghĩ gì khi biết mình làm công việc thiết kế, họ hiểu nó ra sao & có những kì vọng gì?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16a5d164-78d8-8004-b4a7-e9cd4cb121c3",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-12-28T04:17:00.000Z",
        "last_edited_time": "2024-12-28T04:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "OK, cùng với mình thử hình dung về design value nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "OK, cùng với mình thử hình dung về design value nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80df-92cc-d1b623ca66a8",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-18T15:08:00.000Z",
        "last_edited_time": "2024-10-18T15:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1485d164-78d8-8096-9872-cb17e6e246d6",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-11-24T03:29:00.000Z",
        "last_edited_time": "2024-11-24T03:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước hết hãy điểm qua các đặc tính của “thiết kế”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước hết hãy điểm qua các đặc tính của “thiết kế”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1125d164-78d8-81ef-a611-d22ff1a91640",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-01T02:01:00.000Z",
        "last_edited_time": "2024-11-02T06:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "1. Tính thẩm mỹ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "1. Tính thẩm mỹ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1125d164-78d8-8169-9664-e10719b1ff16",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-01T02:01:00.000Z",
        "last_edited_time": "2024-12-28T04:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vâng, nó luôn là expectation đầu tiên của mọi người, thử xem nếu bạn cho ai đó biết bạn làm design, thường họ sẽ có xu hướng expect bạn có gu và làm được những thứ đẹp đẽ. Mình thấy chắc 10/10 người đều nghĩ vậy.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vâng, nó luôn là expectation đầu tiên của mọi người, thử xem nếu bạn cho ai đó biết bạn làm design, thường họ sẽ có xu hướng expect bạn có gu và làm được những thứ đẹp đẽ. Mình thấy chắc 10/10 người đều nghĩ vậy.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-808a-af0a-ff763b52aa00",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-11-18T09:49:00.000Z",
        "last_edited_time": "2025-01-06T12:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thẩm mỹ có giá trị trong việc tạo cảm tình & dễ tiếp cận user hơn, nó giúp user enjoy hơn khi sử dụng,…Thời đại bây giờ có khi không còn là “tốt gỗ hơn tốt nước sơn”, ngoài thị trường có quá nhiều lựa chọn, nếu nước sơn của bạn mà không tốt, có khi cơ hội để user thử chạm đến product của bạn, để biết nó có “tốt gỗ” hay không cũng khó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thẩm mỹ có giá trị trong việc tạo cảm tình & dễ tiếp cận user hơn, nó giúp user enjoy hơn khi sử dụng,…Thời đại bây giờ có khi không còn là “tốt gỗ hơn tốt nước sơn”, ngoài thị trường có quá nhiều lựa chọn, nếu nước sơn của bạn mà không tốt, có khi cơ hội để user thử chạm đến product của bạn, để biết nó có “tốt gỗ” hay không cũng khó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8094-ad0d-c14a996d3cb6",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-11-18T09:50:00.000Z",
        "last_edited_time": "2024-12-28T04:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: câu chuyện thẩm mỹ có tính chủ quan rất cao, có người thấy đẹp, người thấy xấu, nó còn có tính thời đại nữa (từ ta hay dùng là trending đó), ví dụ: có thời người ta thấy phụ nữ có lông mày mỏng là đẹp, nhưng thời hiện tại lại thấy dày là đẹp.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: câu chuyện thẩm mỹ có tính chủ quan rất cao, có người thấy đẹp, người thấy xấu, nó còn có tính thời đại nữa (từ ta hay dùng là trending đó), ví dụ: có thời người ta thấy phụ nữ có lông mày mỏng là đẹp, nhưng thời hiện tại lại thấy dày là đẹp.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8030-b670-ea8ed0a1a762",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-18T15:12:00.000Z",
        "last_edited_time": "2024-12-28T04:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "2. Tính sáng tạo",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2. Tính sáng tạo",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8061-8e46-e56ba5e831e1",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-18T15:12:00.000Z",
        "last_edited_time": "2024-12-28T04:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Design cũng không thể tách biệt khỏi chữ “sáng tạo “. Nó là khả năng mình có thể tận dụng các thứ sẵn có để biến tấu & kết quả là tạo ra một sự khác biệt thú vị. Và sự ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Design cũng không thể tách biệt khỏi chữ “sáng tạo “. Nó là khả năng mình có thể tận dụng các thứ sẵn có để biến tấu & kết quả là tạo ra một sự khác biệt thú vị. Và sự ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "khác biệt ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "khác biệt ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "sẽ giúp mình nổi bật trong đám đông ngoài kia, nếu khác biệt đó mang lại hiệu ứng tốt sẽ tạo được lợi thế cạnh tranh.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "sẽ giúp mình nổi bật trong đám đông ngoài kia, nếu khác biệt đó mang lại hiệu ứng tốt sẽ tạo được lợi thế cạnh tranh.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16a5d164-78d8-8067-82ad-c6fd8117960a",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-12-28T04:28:00.000Z",
        "last_edited_time": "2024-12-28T04:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "P/s: thú vị là mình có 4 dạng sáng tạo đó mọi người, bạn có thể tìm hiểu thêm qua ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "P/s: thú vị là mình có 4 dạng sáng tạo đó mọi người, bạn có thể tìm hiểu thêm qua ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "bài viết này",
                "link": {
                  "url": "/15e5d16478d880c8ac9eff1a29784a09"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "bài viết này",
              "href": "/15e5d16478d880c8ac9eff1a29784a09"
            },
            {
              "type": "text",
              "text": {
                "content": " nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "ea7124d5-ca1a-4b5e-b5f6-a23c60782a9f",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-01T02:15:00.000Z",
        "last_edited_time": "2024-12-28T04:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "3. Tính chủ đích",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3. Tính chủ đích",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "853d73b9-e912-422d-86ac-da6dfe71d69c",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-01T02:23:00.000Z",
        "last_edited_time": "2024-12-28T04:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khác với art, vẻ đẹp của thiết kế nằm ở việc nó ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khác với art, vẻ đẹp của thiết kế nằm ở việc nó ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "luôn có mục đích",
                "link": {
                  "url": "/1195d16478d88052be12d1b7400ce556"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "luôn có mục đích",
              "href": "/1195d16478d88052be12d1b7400ce556"
            },
            {
              "type": "text",
              "text": {
                "content": ". Design là một nghệ thuật sắp đặt có tính chủ đích rõ ràng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". Design là một nghệ thuật sắp đặt có tính chủ đích rõ ràng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1325d164-78d8-8006-965a-d5e26d7bc4b3",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-11-02T07:11:00.000Z",
        "last_edited_time": "2025-01-09T02:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hai thành tố quan trọng nhất của chủ đích là: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hai thành tố quan trọng nhất của chủ đích là: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cho ai & được gì.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cho ai & được gì.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "54cedba3-83f8-4a9c-8e40-69ac4d9915f4",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-30T08:16:00.000Z",
        "last_edited_time": "2025-01-09T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "\"Design is not just what it looks like and feels like. Design is how it works.\" – Steve Jobs",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "\"Design is not just what it looks like and feels like. Design is how it works.\" – Steve Jobs",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "1425d164-78d8-802d-bf0e-e78667693c5a",
            "parent": {
              "type": "block_id",
              "block_id": "54cedba3-83f8-4a9c-8e40-69ac4d9915f4"
            },
            "created_time": "2024-11-18T10:06:00.000Z",
            "last_edited_time": "2024-12-28T04:24:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "paragraph",
            "paragraph": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "But ",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "But ",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": "what",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "what",
                  "href": null
                },
                {
                  "type": "text",
                  "text": {
                    "content": " works?",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": " works?",
                  "href": null
                }
              ],
              "icon": null,
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1425d164-78d8-8086-b54a-c052d4c7c8b5",
            "parent": {
              "type": "block_id",
              "block_id": "54cedba3-83f8-4a9c-8e40-69ac4d9915f4"
            },
            "created_time": "2024-11-18T10:06:00.000Z",
            "last_edited_time": "2024-11-18T10:06:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Functionality & system work.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Functionality & system work.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 0
          },
          {
            "object": "block",
            "id": "1425d164-78d8-8027-8283-f57be1685f08",
            "parent": {
              "type": "block_id",
              "block_id": "54cedba3-83f8-4a9c-8e40-69ac4d9915f4"
            },
            "created_time": "2024-11-18T10:06:00.000Z",
            "last_edited_time": "2024-12-28T04:24:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Work for business, for strategy.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Work for business, for strategy.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 1
          },
          {
            "object": "block",
            "id": "16a5d164-78d8-8058-840c-f706360b7dd2",
            "parent": {
              "type": "block_id",
              "block_id": "54cedba3-83f8-4a9c-8e40-69ac4d9915f4"
            },
            "created_time": "2024-12-28T04:24:00.000Z",
            "last_edited_time": "2024-12-28T04:24:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Work for user; for stakeholders.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Work for user; for stakeholders.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 2
          }
        ]
      },
      {
        "object": "block",
        "id": "1325d164-78d8-804c-820f-d2c5bdbbd134",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-11-02T07:11:00.000Z",
        "last_edited_time": "2024-12-28T04:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lấy ví dụ: khi thiết kế xem nên chọn layout thế nào thông tin cùa một màn hình, nếu đó là dạng thông tin theo hướng discover, explore thì scroll sẽ phù hợp vì user có thể scan nhanh và thao tác dùng rất đơn giản chỉ cần scroll cho đến khi thấy gì đó hứng thú & stop để xem; còn nếu thông tin theo hướng cần phải dễ so sánh thì có thể phải dùng dạng table để có thể scan nhanh sự khác nhau của 2 object trên những tiêu chí cụ thể. Ví dụ này chính là việc bạn nghĩ về chủ đích sử dụng của user để lựa chọn hướng design sao cho phù hợp.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lấy ví dụ: khi thiết kế xem nên chọn layout thế nào thông tin cùa một màn hình, nếu đó là dạng thông tin theo hướng discover, explore thì scroll sẽ phù hợp vì user có thể scan nhanh và thao tác dùng rất đơn giản chỉ cần scroll cho đến khi thấy gì đó hứng thú & stop để xem; còn nếu thông tin theo hướng cần phải dễ so sánh thì có thể phải dùng dạng table để có thể scan nhanh sự khác nhau của 2 object trên những tiêu chí cụ thể. Ví dụ này chính là việc bạn nghĩ về chủ đích sử dụng của user để lựa chọn hướng design sao cho phù hợp.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1125d164-78d8-81fa-8fb6-c4fc5c8550f3",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-01T02:01:00.000Z",
        "last_edited_time": "2024-11-02T06:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "4. Tính tối ưu",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "4. Tính tối ưu",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1125d164-78d8-81ad-a5d5-d8a29e4821ae",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-01T02:01:00.000Z",
        "last_edited_time": "2025-01-10T05:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đây là đặc tính mình thấy thích nhất, vì nó cần đến tính innovation cao, nghĩ về nó giúp chúng ta sáng tạo nhưng mà chân vẫn chạm đất, không quá bay & phi thực tế. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đây là đặc tính mình thấy thích nhất, vì nó cần đến tính innovation cao, nghĩ về nó giúp chúng ta sáng tạo nhưng mà chân vẫn chạm đất, không quá bay & phi thực tế. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-80b5-967d-f8b4741c661a",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2025-01-10T05:14:00.000Z",
        "last_edited_time": "2025-01-10T05:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tối ưu là khả năng đạt được kết quả tốt nhất trong khi sử dụng tối thiểu các nguồn lực như thời gian, công sức, hoặc tài nguyên. Ví dụ: với số vốn ít ỏi thay vì bạn phải suggest công ty build hẳn một website từ đầu, thì xem liệu mình có thể tận dụng các web builder như WordPress, Framer hay Webflow không.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tối ưu là khả năng đạt được kết quả tốt nhất trong khi sử dụng tối thiểu các nguồn lực như thời gian, công sức, hoặc tài nguyên. Ví dụ: với số vốn ít ỏi thay vì bạn phải suggest công ty build hẳn một website từ đầu, thì xem liệu mình có thể tận dụng các web builder như WordPress, Framer hay Webflow không.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-80df-bfb1-ce08ae18f8d4",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2025-01-10T05:14:00.000Z",
        "last_edited_time": "2025-01-10T05:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tối ưu là hiểu các ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tối ưu là hiểu các ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "trade off",
                "link": {
                  "url": "/b2deb93698dc4fafaadc9cfcb4a6c302"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "trade off",
              "href": "/b2deb93698dc4fafaadc9cfcb4a6c302"
            },
            {
              "type": "text",
              "text": {
                "content": " giữa các idea để lựa chọn phù hợp, không có idea nào one size fit all, tuỳ xem mình đang ưu tiên tiêu chí nào. Lấy ví dụ muốn mọi thứ đơn giản thì phải giấu bớt tính năng, nhưng trade off là các tính năng đó sẽ bị ẩn, khó tìm, khó biết.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " giữa các idea để lựa chọn phù hợp, không có idea nào one size fit all, tuỳ xem mình đang ưu tiên tiêu chí nào. Lấy ví dụ muốn mọi thứ đơn giản thì phải giấu bớt tính năng, nhưng trade off là các tính năng đó sẽ bị ẩn, khó tìm, khó biết.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-801d-9eb1-fcb38c237088",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-18T15:10:00.000Z",
        "last_edited_time": "2025-01-10T05:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một ví dụ khác: dưới góc độ mình là một user thì “Face ID” là giải pháp bảo mật tối ưu hơn. Mình không cần phải bấm mật khẩu để mở khoá hay phải thực hiện thêm nhiều tác vụ như nhập, click,… mình cũng chẳng cần phải nhớ pass hay reset định kỳ, cũng không sợ bị lộ passcode vì chỉ có mình mới có gượng mặt này. Trải nghiệm đơn giản hơn mà độ bảo mật lại cao hơn, đây chính là tính tối ưu, tính innovation mà một product cần có. Tuy nhiên sự đánh đổi (trade off) ở đây là phía technical phải xử lý nhiều việc hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một ví dụ khác: dưới góc độ mình là một user thì “Face ID” là giải pháp bảo mật tối ưu hơn. Mình không cần phải bấm mật khẩu để mở khoá hay phải thực hiện thêm nhiều tác vụ như nhập, click,… mình cũng chẳng cần phải nhớ pass hay reset định kỳ, cũng không sợ bị lộ passcode vì chỉ có mình mới có gượng mặt này. Trải nghiệm đơn giản hơn mà độ bảo mật lại cao hơn, đây chính là tính tối ưu, tính innovation mà một product cần có. Tuy nhiên sự đánh đổi (trade off) ở đây là phía technical phải xử lý nhiều việc hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "439be2cc-db3b-463c-807e-4d9efc788dac",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-01T02:27:00.000Z",
        "last_edited_time": "2024-10-18T15:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "4ae0ef4c-0ec0-464e-bb36-522913746326",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-01T02:29:00.000Z",
        "last_edited_time": "2024-12-28T04:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy dưới góc nhìn tổ chức, giá trị của design là gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy dưới góc nhìn tổ chức, giá trị của design là gì?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16a5d164-78d8-8042-bdba-c7b42cfce5d3",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-12-28T04:37:00.000Z",
        "last_edited_time": "2024-12-31T01:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước khi đọc tiếp, mong bạn thử dành vài giây nghĩ về nó trước…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước khi đọc tiếp, mong bạn thử dành vài giây nghĩ về nó trước…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16d5d164-78d8-80ee-93b8-ef8e2277a4a0",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-12-31T01:44:00.000Z",
        "last_edited_time": "2024-12-31T01:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "OK, chắc bạn đã có vài ý trong đầu, nếu được thì share cho mình biết thêm qua comment nhé. Còn đây là vài ý mình nhận ra:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "OK, chắc bạn đã có vài ý trong đầu, nếu được thì share cho mình biết thêm qua comment nhé. Còn đây là vài ý mình nhận ra:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-807c-870c-c980f256eaae",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-18T15:26:00.000Z",
        "last_edited_time": "2025-01-07T10:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Design giúp ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Design giúp ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "visualize ý tưởng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "visualize ý tưởng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " để các stakeholder dễ dàng hình dung, để tiện trao đổi và đưa ra quyết định 🫂. Tưởng tượng nếu business ngồi với dev thảo luận mà trong đầu mỗi người đều không hình dung được UI, flow như thế nào thì sẽ khó mà trực quan.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " để các stakeholder dễ dàng hình dung, để tiện trao đổi và đưa ra quyết định 🫂. Tưởng tượng nếu business ngồi với dev thảo luận mà trong đầu mỗi người đều không hình dung được UI, flow như thế nào thì sẽ khó mà trực quan.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80a2-a7a9-c044a6d970e2",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-18T15:26:00.000Z",
        "last_edited_time": "2025-01-07T10:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Design là một phần ”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Design là một phần ”",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "bản vẽ kiến trúc",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "bản vẽ kiến trúc",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "” (PRD/FRD) để giúp cho đội ngũ engineer định hình công việc & build sao cho hợp “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” (PRD/FRD) để giúp cho đội ngũ engineer định hình công việc & build sao cho hợp “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "phong thủy",
                "link": {
                  "url": "/73bdf5d9ca494b2789a22dde16b2af7d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "phong thủy",
              "href": "/73bdf5d9ca494b2789a22dde16b2af7d"
            },
            {
              "type": "text",
              "text": {
                "content": "” 🥰. Nói cách khác thì design giúp product được user friendly, từ đó “bôi trơn” quá trình trao đổi giá trị giữa product và user.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” 🥰. Nói cách khác thì design giúp product được user friendly, từ đó “bôi trơn” quá trình trao đổi giá trị giữa product và user.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8068-a637-d863c47b02b4",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-18T15:26:00.000Z",
        "last_edited_time": "2025-07-26T02:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Thuận business xuôi dev",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thuận business xuôi dev",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "” 🤣. Một design tốt phải đảm bảo được business objectives cũng như là thực tế phải build được, không khiến hệ thống phức tạp hoá một cách không cần thiết, có giá trị sử dụng lại (pattern)... Tuy nhiên đôi khi trách nhiệm của mình là phải come up 1 version có UX tuyệt vời sẽ trông ra sao, và phía tech sẽ chịu trách nhiệm tìm cách hiện thực hoá nó sau (tuỳ trường hợp nhé, nếu feature đó cần chú trọng UX thì nên vậy).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” 🤣. Một design tốt phải đảm bảo được business objectives cũng như là thực tế phải build được, không khiến hệ thống phức tạp hoá một cách không cần thiết, có giá trị sử dụng lại (pattern)... Tuy nhiên đôi khi trách nhiệm của mình là phải come up 1 version có UX tuyệt vời sẽ trông ra sao, và phía tech sẽ chịu trách nhiệm tìm cách hiện thực hoá nó sau (tuỳ trường hợp nhé, nếu feature đó cần chú trọng UX thì nên vậy).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1745d164-78d8-80af-9e6a-f693c121125b",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2025-01-07T10:00:00.000Z",
        "last_edited_time": "2025-01-07T10:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "UX là một diễn viên",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX là một diễn viên",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", chúng ta đóng khá nhiều vai, lúc thì đóng vai là một shipper giao value từ biz đến user, lúc vào vai thần cupid để giúp user & system kết nối được với nhau, lúc là một nhân viên sale nhằm thuyết phục user dùng & mua hàng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", chúng ta đóng khá nhiều vai, lúc thì đóng vai là một shipper giao value từ biz đến user, lúc vào vai thần cupid để giúp user & system kết nối được với nhau, lúc là một nhân viên sale nhằm thuyết phục user dùng & mua hàng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16d5d164-78d8-8056-8c74-c3e9b211db04",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-12-31T07:14:00.000Z",
        "last_edited_time": "2025-04-11T04:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081546/uxcomic-imgs/16d5d164-78d8-8056-8c74-c3e9b211db04.png",
            "expiry_time": "2026-10-04T09:12:13.121Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/16d5d164-78d8-8056-8c74-c3e9b211db04"
      },
      {
        "object": "block",
        "id": "36216c2d-7b1f-4be9-bf85-7e32664a63bf",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-08T02:03:00.000Z",
        "last_edited_time": "2024-10-08T02:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "8f698fb9-2885-4afb-9d9e-bfa4704578b3",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-08T02:04:00.000Z",
        "last_edited_time": "2024-11-23T04:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "So what",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "So what",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16a5d164-78d8-8063-92f7-f7942bc21bb9",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-12-28T04:40:00.000Z",
        "last_edited_time": "2024-12-28T04:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hm, mình biết nghe cũng đao to búa lớn đó, nhưng biết mấy thứ này để làm gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hm, mình biết nghe cũng đao to búa lớn đó, nhưng biết mấy thứ này để làm gì?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "6a8150f2-b255-4446-9f3e-11a25d5d74eb",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-08T02:04:00.000Z",
        "last_edited_time": "2024-12-31T01:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Việc nhìn nhận được giá trị của design giúp chúng ta làm rõ trách nhiệm & bổ phận của nó, hiểu rằng mình là một mắt xích trong tổ chức, để có thể vừa khiêm tốn, vừa tự tin về công việc của design.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Việc nhìn nhận được giá trị của design giúp chúng ta làm rõ trách nhiệm & bổ phận của nó, hiểu rằng mình là một mắt xích trong tổ chức, để có thể vừa khiêm tốn, vừa tự tin về công việc của design.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "b76fe524-2d70-4c3c-aa61-814979ca51ce",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-08T02:08:00.000Z",
        "last_edited_time": "2025-08-08T10:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để không bị chỉ sa đà vào một giá trị duy nhất, để có chiến lược tối ưu hoá các giá trị khác. Ví dụ: đôi lúc thiết kế thẩm mỹ thôi là chưa đủ, sáng tạo mà không có chủ đích thì cũng vô dụng, hoặc đôi khi mình có thể tự hỏi xem nếu có một sự đột phá trong bản thiết kế này thì nó sẽ trông ra sao chứ không chỉ dừng lại ở việc đảm bảo usability…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để không bị chỉ sa đà vào một giá trị duy nhất, để có chiến lược tối ưu hoá các giá trị khác. Ví dụ: đôi lúc thiết kế thẩm mỹ thôi là chưa đủ, sáng tạo mà không có chủ đích thì cũng vô dụng, hoặc đôi khi mình có thể tự hỏi xem nếu có một sự đột phá trong bản thiết kế này thì nó sẽ trông ra sao chứ không chỉ dừng lại ở việc đảm bảo usability…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1125d164-78d8-81b6-9329-e48e87a81775",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-01T02:01:00.000Z",
        "last_edited_time": "2024-10-01T02:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1125d164-78d8-810a-8ee1-e7a4104419b6",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-01T02:01:00.000Z",
        "last_edited_time": "2024-10-01T02:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2935d164-78d8-8069-b1ee-e90b0e7e0cf2",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2025-10-21T04:48:00.000Z",
        "last_edited_time": "2025-10-21T04:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.linkedin.com/pulse/diagram-shows-value-great-ux-jared-spool-2rxae/",
                "link": {
                  "url": "https://www.linkedin.com/pulse/diagram-shows-value-great-ux-jared-spool-2rxae/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.linkedin.com/pulse/diagram-shows-value-great-ux-jared-spool-2rxae/",
              "href": "https://www.linkedin.com/pulse/diagram-shows-value-great-ux-jared-spool-2rxae/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1d25d164-78d8-8037-8c97-e622d79cbed0",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2025-04-11T04:51:00.000Z",
        "last_edited_time": "2025-04-11T04:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.jameswondrack.com/how-and-why-to-avoid-the-design-cycle-of-doom/",
                "link": {
                  "url": "https://www.jameswondrack.com/how-and-why-to-avoid-the-design-cycle-of-doom/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.jameswondrack.com/how-and-why-to-avoid-the-design-cycle-of-doom/",
              "href": "https://www.jameswondrack.com/how-and-why-to-avoid-the-design-cycle-of-doom/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1125d164-78d8-81e4-97fc-f748ba46f29a",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-01T02:01:00.000Z",
        "last_edited_time": "2024-10-08T04:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.eleken.co/blog-posts/designers-role-in-product-development-things-you-must-know",
                "link": {
                  "url": "https://www.eleken.co/blog-posts/designers-role-in-product-development-things-you-must-know"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.eleken.co/blog-posts/designers-role-in-product-development-things-you-must-know",
              "href": "https://www.eleken.co/blog-posts/designers-role-in-product-development-things-you-must-know"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1125d164-78d8-81b6-b024-d73f1d577df6",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-01T02:01:00.000Z",
        "last_edited_time": "2024-10-08T04:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://medium.com/@alina.magowska/the-role-of-design-in-product-development-173bdbc15ddb",
                "link": {
                  "url": "https://medium.com/@alina.magowska/the-role-of-design-in-product-development-173bdbc15ddb"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://medium.com/@alina.magowska/the-role-of-design-in-product-development-173bdbc15ddb",
              "href": "https://medium.com/@alina.magowska/the-role-of-design-in-product-development-173bdbc15ddb"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-8088-b42a-d550bc9cf225",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-08T05:33:00.000Z",
        "last_edited_time": "2024-10-08T05:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://medium.com/@alina.magowska/the-role-of-design-in-product-development-173bdbc15ddb",
                "link": {
                  "url": "https://medium.com/@alina.magowska/the-role-of-design-in-product-development-173bdbc15ddb"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://medium.com/@alina.magowska/the-role-of-design-in-product-development-173bdbc15ddb",
              "href": "https://medium.com/@alina.magowska/the-role-of-design-in-product-development-173bdbc15ddb"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8026-954c-c059e0458e3d",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-12-24T02:02:00.000Z",
        "last_edited_time": "2024-12-24T02:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.linkedin.com/posts/mattprzegietka_a-must-have-for-each-design-case-study-activity-7251634114083131392-cId3?",
                "link": {
                  "url": "https://www.linkedin.com/posts/mattprzegietka_a-must-have-for-each-design-case-study-activity-7251634114083131392-cId3?utm_source=share&utm_medium=member_ios"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.linkedin.com/posts/mattprzegietka_a-must-have-for-each-design-case-study-activity-7251634114083131392-cId3?",
              "href": "https://www.linkedin.com/posts/mattprzegietka_a-must-have-for-each-design-case-study-activity-7251634114083131392-cId3?utm_source=share&utm_medium=member_ios"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1125d164-78d8-81ab-9b57-c3f1ba18eb0d",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-01T02:01:00.000Z",
        "last_edited_time": "2024-10-01T02:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1125d164-78d8-8171-a1a9-e76a48482ad2",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-10-01T02:01:00.000Z",
        "last_edited_time": "2024-10-08T02:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8007-8458-c83995be7ae3",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2025-08-14T05:53:00.000Z",
        "last_edited_time": "2025-08-14T05:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "10f5d164-78d8-809a-bbf5-ec2e471cf60e"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cái ghế & Product",
              "href": "https://app.notion.com/p/10f5d16478d8809abbf5ec2e471cf60e"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8065-a880-d6273b1c399c",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2025-08-14T05:54:00.000Z",
        "last_edited_time": "2025-08-14T05:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1605d164-78d8-80ad-9130-fe44c6663146"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Value vs Benefit",
              "href": "https://app.notion.com/p/1605d16478d880ad9130fe44c6663146"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16a5d164-78d8-808f-bf5b-fdf6f73011e7",
        "parent": {
          "type": "page_id",
          "page_id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
        },
        "created_time": "2024-12-28T04:46:00.000Z",
        "last_edited_time": "2025-08-14T05:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1445d164-78d8-805b-b388-e24b5f13cccb"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product development process (overall)",
              "href": "https://app.notion.com/p/1445d16478d8805bb388e24b5f13cccb"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "10f5d164-78d8-804f-b8ea-e2a265424273",
    "created_time": "2024-09-28T03:59:00.000Z",
    "last_edited_time": "2025-08-15T10:43:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "page_id",
      "page_id": "a58596ad-902a-49e3-9a81-fdb9b84b92d9"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "title": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "UX comic - Introduction",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "UX comic - Introduction",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/UX-comic-Introduction-10f5d16478d8804fb8eae2a265424273",
    "public_url": null,
    "archived": false,
    "request_id": "fcff3e2b-a2ed-4bd2-b0db-51d16b992270",
    "content": [
      {
        "object": "block",
        "id": "1145d164-78d8-8054-b6ed-ee06674bf4ed",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-03T14:54:00.000Z",
        "last_edited_time": "2024-10-03T14:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081079/uxcomic-imgs/1145d164-78d8-8054-b6ed-ee06674bf4ed.png",
            "expiry_time": "2026-10-04T09:12:13.919Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1145d164-78d8-8054-b6ed-ee06674bf4ed"
      },
      {
        "object": "block",
        "id": "1175d164-78d8-8062-b2b6-e5d5c1f1d3b4",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-06T13:42:00.000Z",
        "last_edited_time": "2024-10-06T13:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tụi mình ở đây để chia sẻ các kiến thức, góc nhìn cá nhân về hành trình làm nghề UX/UI.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tụi mình ở đây để chia sẻ các kiến thức, góc nhìn cá nhân về hành trình làm nghề UX/UI.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "👋"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-80f5-ba2a-dc7da74d909e",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-09-28T04:03:00.000Z",
        "last_edited_time": "2025-01-14T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình xin giới thiệu chút, mình có background công việc trong graphic design, illustrator, sau đó mình chuyển sang lĩnh vực UX/UI, và chắc cũng như đa phần mọi người đó là học vài khoá, tự mày mò đọc blog để học hỏi thêm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình xin giới thiệu chút, mình có background công việc trong graphic design, illustrator, sau đó mình chuyển sang lĩnh vực UX/UI, và chắc cũng như đa phần mọi người đó là học vài khoá, tự mày mò đọc blog để học hỏi thêm.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-8022-90a4-e47dd0056496",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-14T02:05:00.000Z",
        "last_edited_time": "2025-01-14T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80b8-ba44-f0b7bbe1c82c",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-22T16:01:00.000Z",
        "last_edited_time": "2024-12-25T02:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuy nhiên trong quá trình tự học, mình hay gặp phải các vấn đề sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuy nhiên trong quá trình tự học, mình hay gặp phải các vấn đề sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-80c7-9e98-d40601cb5d76",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-09-28T04:11:00.000Z",
        "last_edited_time": "2024-12-25T02:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "😵 Theo thời gian, kiến thức gia tăng, mọi thứ dần trở nên rối ren, chi chít như màn nhện,  nó như cái cảnh mình vào khu rừng mà không có map, cứ xoay vòng vòng, vòng vòng, vòng vòng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "😵 Theo thời gian, kiến thức gia tăng, mọi thứ dần trở nên rối ren, chi chít như màn nhện,  nó như cái cảnh mình vào khu rừng mà không có map, cứ xoay vòng vòng, vòng vòng, vòng vòng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-8055-ba1e-cdeabdc6e536",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-09-28T04:11:00.000Z",
        "last_edited_time": "2024-12-25T02:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "🫣 Mặc dù đã cất công collect, tự học các thứ nhưng đến lúc làm thực tế thì lại quên bén đi, xong tự chửi bản thân: “học chi cho lắm không áp dụng được gì”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "🫣 Mặc dù đã cất công collect, tự học các thứ nhưng đến lúc làm thực tế thì lại quên bén đi, xong tự chửi bản thân: “học chi cho lắm không áp dụng được gì”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80e9-a617-fed34699865b",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T02:40:00.000Z",
        "last_edited_time": "2024-12-25T02:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "😫 Đến lúc nhớ để áp dụng rồi thì lại có khi không phù hợp, kết quả không như  khuôn mẫu sách vở.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "😫 Đến lúc nhớ để áp dụng rồi thì lại có khi không phù hợp, kết quả không như  khuôn mẫu sách vở.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80bd-821c-d1385c95355a",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-22T14:48:00.000Z",
        "last_edited_time": "2024-12-23T03:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081080/uxcomic-imgs/1645d164-78d8-80bd-821c-d1385c95355a.jpg",
            "expiry_time": "2026-10-04T09:12:13.919Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1645d164-78d8-80bd-821c-d1385c95355a"
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-80c2-a417-ca89e359e251",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-27T04:48:00.000Z",
        "last_edited_time": "2024-12-22T16:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1175d164-78d8-802e-b0b2-e9f603db4448",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-06T07:32:00.000Z",
        "last_edited_time": "2025-01-14T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Rồi tình cờ, mình có nghe đến kĩ thuật Feyman trong việc học - đại ý là học làm sao để bạn có thể dạy lại được cho người khác. Sau đó mình bắt đầu áp dụng, tập thói quen nghiền ngẫm, tập hệ thống hoá, để “ôn bài”, để biết thêm những thứ mà mình tưởng là mình đã biết >> 💡 project được sinh ra",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Rồi tình cờ, mình có nghe đến kĩ thuật Feyman trong việc học - đại ý là học làm sao để bạn có thể dạy lại được cho người khác. Sau đó mình bắt đầu áp dụng, tập thói quen nghiền ngẫm, tập hệ thống hoá, để “ôn bài”, để biết thêm những thứ mà mình tưởng là mình đã biết >> 💡 project được sinh ra",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-801d-bbfe-cbe5f489c720",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-10T02:05:00.000Z",
        "last_edited_time": "2025-01-12T14:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Share your knowledge and teach others — it benefits both of you!",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Share your knowledge and teach others — it benefits both of you!",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13f5d164-78d8-801a-871e-c9d89a1c3ec0",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-11-15T02:12:00.000Z",
        "last_edited_time": "2024-11-15T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-80ac-ba44-fb1e73088960",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-14T02:37:00.000Z",
        "last_edited_time": "2025-08-14T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "✏️ Other tiny things",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "✏️ Other tiny things",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-8041-b4ef-f5c09e17be85",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T02:57:00.000Z",
        "last_edited_time": "2025-01-14T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lê thê vậy đủ rồi. Nếu bạn có thêm chút thời gian, hãy xem thêm các chú thích ở dưới nhé, vì nó liên quan đến giá trị “hệ thống hoá” mà mình đang muốn offer khi làm blog này.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lê thê vậy đủ rồi. Nếu bạn có thêm chút thời gian, hãy xem thêm các chú thích ở dưới nhé, vì nó liên quan đến giá trị “hệ thống hoá” mà mình đang muốn offer khi làm blog này.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8033-b108-debe1f729659",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:55:00.000Z",
        "last_edited_time": "2025-08-14T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755136730/uxcomic-imgs/24f5d164-78d8-8033-b108-debe1f729659.png",
            "expiry_time": "2026-10-04T09:12:13.919Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/24f5d164-78d8-8033-b108-debe1f729659"
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80cf-9e31-eba6bd4663a0",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:02:00.000Z",
        "last_edited_time": "2025-08-14T01:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1175d164-78d8-807a-bc07-ce1b50fe378a",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-06T13:38:00.000Z",
        "last_edited_time": "2025-08-14T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "📢 ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "📢 ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Disclaimer",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Disclaimer",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8071-af14-c321c266389f",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:47:00.000Z",
        "last_edited_time": "2025-08-15T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "các bài viết này là tổng hợp của những kiến thức lượm lặt trên mạng + chatGPT + góc độ, quan sát cá nhân >> mình vẫn có thể sai >> nên đừng vội chấp nhận hoặc tin hết những gì mình viết (mặc dù mình đều cố gắng tìm hiểu các nguồn đáng tin cậy và kèm link reference cho từng bài viết nếu có).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "các bài viết này là tổng hợp của những kiến thức lượm lặt trên mạng + chatGPT + góc độ, quan sát cá nhân >> mình vẫn có thể sai >> nên đừng vội chấp nhận hoặc tin hết những gì mình viết (mặc dù mình đều cố gắng tìm hiểu các nguồn đáng tin cậy và kèm link reference cho từng bài viết nếu có).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8070-a7db-d7a5898e615d",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:47:00.000Z",
        "last_edited_time": "2025-08-15T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hãy xem mình như một người bạn, một đồng nghiệp như đang trò chuyện với bạn trong một buổi ăn trưa, một buổi hẹn cafe, chúng mình ở đây để chia sẻ và học hỏi nhau trên con đường mày mò & cải thiện quá trình làm nghề UX/UI.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hãy xem mình như một người bạn, một đồng nghiệp như đang trò chuyện với bạn trong một buổi ăn trưa, một buổi hẹn cafe, chúng mình ở đây để chia sẻ và học hỏi nhau trên con đường mày mò & cải thiện quá trình làm nghề UX/UI.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80be-bd5b-fde96187a589",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:48:00.000Z",
        "last_edited_time": "2025-08-15T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Again luôn recheck các thông tin, luận điểm của mình nhé. Cảm ơn mọi người nhiều 😜.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Again luôn recheck các thông tin, luận điểm của mình nhé. Cảm ơn mọi người nhiều 😜.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80b0-a0cf-c3d3ac509af9",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:03:00.000Z",
        "last_edited_time": "2025-01-14T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1815d164-78d8-8043-8c86-f3f060cfaa2c",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-20T03:25:00.000Z",
        "last_edited_time": "2025-01-20T03:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Contact",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Contact",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80e8-8428-f6dcc343a5ec",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T02:45:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình rất vui lòng nếu nhận được những góc nhìn khác từ các bạn, nếu bạn muốn liên hệ hay chia sẻ gì với mình thêm, hay muốn mình share topic gì khác, hãy để lại lời nhắn qua:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình rất vui lòng nếu nhận được những góc nhìn khác từ các bạn, nếu bạn muốn liên hệ hay chia sẻ gì với mình thêm, hay muốn mình share topic gì khác, hãy để lại lời nhắn qua:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1c15d164-78d8-80dc-bc47-ff02b571cf37",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-03-25T05:59:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1815d164-78d8-8006-8bb0-f9639445d848",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-20T03:23:00.000Z",
        "last_edited_time": "2025-01-20T03:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thread",
                "link": {
                  "url": "https://www.threads.net/@ux_share_choi?hl=vi"
                }
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thread",
              "href": "https://www.threads.net/@ux_share_choi?hl=vi"
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "💬"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1815d164-78d8-801b-b02c-f6a970beae36",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-20T03:23:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Linkedin",
                "link": {
                  "url": "https://www.linkedin.com/in/minhhuynh95/"
                }
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Linkedin",
              "href": "https://www.linkedin.com/in/minhhuynh95/"
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "💼"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1c15d164-78d8-80aa-b4ae-d81e4bdbad4e",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-03-25T05:59:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-8081-8eb4-f9373214ab36",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:10:00.000Z",
        "last_edited_time": "2024-12-25T03:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081083/uxcomic-imgs/1675d164-78d8-8081-8eb4-f9373214ab36.png",
            "expiry_time": "2026-10-04T09:12:13.999Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1675d164-78d8-8081-8eb4-f9373214ab36"
      },
      {
        "object": "block",
        "id": "1675d164-78d8-802d-a902-c546642f72dc",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:03:00.000Z",
        "last_edited_time": "2024-12-28T03:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mong các bài viết này có chút hữu ích cho bạn 🥰. Dự án được built with ❤️‍🔥 bởi ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mong các bài viết này có chút hữu ích cho bạn 🥰. Dự án được built with ❤️‍🔥 bởi ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Minh",
                "link": {
                  "url": "https://www.linkedin.com/in/minhhuynh95/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Minh",
              "href": "https://www.linkedin.com/in/minhhuynh95/"
            },
            {
              "type": "text",
              "text": {
                "content": " & ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " & ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Hùng",
                "link": {
                  "url": "https://www.linkedin.com/in/vhung71/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hùng",
              "href": "https://www.linkedin.com/in/vhung71/"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "26aaa722-7e34-4293-bf96-4eaa09a6a24d",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-11-23T07:53:00.000Z",
        "last_edited_time": "2024-11-23T07:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-80ef-a681-d83a4e28308a",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-27T04:50:00.000Z",
        "last_edited_time": "2024-10-27T04:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "3d95d164-78d8-80de-910a-c8ddf1430321",
    "created_time": "2026-09-12T07:40:00.000Z",
    "last_edited_time": "2026-09-12T08:37:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "2-Think",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2026-09-12T08:37:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": "HnPZ",
          "name": "⚔️:3",
          "color": "default"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 64
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2026-09-12T07:40:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Design Approach",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Design Approach",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Design-Approach-3d95d16478d880de910ac8ddf1430321",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
      "name": "Think",
      "slug": "think",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "3d95d164-78d8-8002-97a0-c8dfb87ffec6",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T07:40:00.000Z",
        "last_edited_time": "2026-09-12T08:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1789202580/uxcomic-imgs/3d95d164-78d8-8002-97a0-c8dfb87ffec6.png",
            "expiry_time": "2026-10-04T09:12:15.465Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/3d95d164-78d8-8002-97a0-c8dfb87ffec6"
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-80e5-b50b-c543048dfe71",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T07:40:00.000Z",
        "last_edited_time": "2026-09-12T08:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bài này tổng hợp lại các cách mà mình nhận ra thường hay tiếp cận các bài toán design.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bài này tổng hợp lại các cách mà mình nhận ra thường hay tiếp cận các bài toán design.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-802a-afc0-cd28fe6126fd",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T08:23:00.000Z",
        "last_edited_time": "2026-09-12T08:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Gần đây mình có reflect lại vài tình huống:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Gần đây mình có reflect lại vài tình huống:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-80a8-99fe-db33c4ca5ca4",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T08:25:00.000Z",
        "last_edited_time": "2026-09-12T08:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có vài project trong lúc mình propose design, thì tiếp nhận được những feedback khiến mình chợt phát giác “tại sao mình chưa nghĩ đến vấn đề này nhỉ? nó thậm chí là một ý rất quan trọng tác động đến toàn bộ định hướng design này”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có vài project trong lúc mình propose design, thì tiếp nhận được những feedback khiến mình chợt phát giác “tại sao mình chưa nghĩ đến vấn đề này nhỉ? nó thậm chí là một ý rất quan trọng tác động đến toàn bộ định hướng design này”.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-8080-b923-f6a35c864d0d",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T08:26:00.000Z",
        "last_edited_time": "2026-09-12T08:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có bạn đồng nghiệp đôi khi ngó sang bảng Figjam của mình & hỏi “đang làm gì đó”, rồi mình giải thích bla bla,… và bạn thấy mình tiếp cận mỗi project vs mỗi cách làm figjam khác nhau.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có bạn đồng nghiệp đôi khi ngó sang bảng Figjam của mình & hỏi “đang làm gì đó”, rồi mình giải thích bla bla,… và bạn thấy mình tiếp cận mỗi project vs mỗi cách làm figjam khác nhau.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-8082-8aab-cfe6bc072367",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T08:32:00.000Z",
        "last_edited_time": "2026-09-12T08:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-8073-b807-cfbb6f8c3cf0",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T07:40:00.000Z",
        "last_edited_time": "2026-09-12T08:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Start w Design tactics 🕳️",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Start w Design tactics 🕳️",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-80ac-90bb-ee2cfebc48fe",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T08:32:00.000Z",
        "last_edited_time": "2026-09-12T08:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1789202581/uxcomic-imgs/3d95d164-78d8-80ac-90bb-ee2cfebc48fe.png",
            "expiry_time": "2026-10-04T09:12:15.466Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/3d95d164-78d8-80ac-90bb-ee2cfebc48fe"
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-8065-ac1a-d8360a3f6d42",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T07:40:00.000Z",
        "last_edited_time": "2026-09-12T07:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thói quen này là thường xuyên nhất, ta bắt đầu giải quyết problem ngay từ những kĩ thuật của design như: chọn màu nào, layout nào, pattern nào,… từ đó explore được nhiều option, rồi đánh giá các option >> ra quyết định.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thói quen này là thường xuyên nhất, ta bắt đầu giải quyết problem ngay từ những kĩ thuật của design như: chọn màu nào, layout nào, pattern nào,… từ đó explore được nhiều option, rồi đánh giá các option >> ra quyết định.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-8029-8258-c009bd749d64",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T07:54:00.000Z",
        "last_edited_time": "2026-09-12T07:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Try mixmatching design toolbox (pattern, flow, IA, psychology …) >> Explore option >> Analyze option >> Pick",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Try mixmatching design toolbox (pattern, flow, IA, psychology …) >> Explore option >> Analyze option >> Pick",
              "href": null
            }
          ],
          "icon": null,
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-80f4-9614-c34b5e872960",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T07:46:00.000Z",
        "last_edited_time": "2026-09-12T08:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách này tương tự như tactic của brainstorm, giúp mình explore nhiều hướng mà bản thân có thể không ngờ đến,… tuy nhiên nếu không chú ý ở khâu đánh giá option, ta dễ quên mất bài toán problem cần giải là gì.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách này tương tự như tactic của brainstorm, giúp mình explore nhiều hướng mà bản thân có thể không ngờ đến,… tuy nhiên nếu không chú ý ở khâu đánh giá option, ta dễ quên mất bài toán problem cần giải là gì.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-80ad-b131-def234019ba4",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T08:32:00.000Z",
        "last_edited_time": "2026-09-12T08:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-80f3-b3ce-f278fbbb7f57",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T07:40:00.000Z",
        "last_edited_time": "2026-09-12T08:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Start w Outcome 🌟",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Start w Outcome 🌟",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-800f-932d-fa071f97cbc5",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T08:32:00.000Z",
        "last_edited_time": "2026-09-12T08:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1789202583/uxcomic-imgs/3d95d164-78d8-800f-932d-fa071f97cbc5.png",
            "expiry_time": "2026-10-04T09:12:15.466Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/3d95d164-78d8-800f-932d-fa071f97cbc5"
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-8074-9142-ca4fd334c2cc",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T07:40:00.000Z",
        "last_edited_time": "2026-09-12T08:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách này bắt đầu tự việc define rõ outcome (JTBD), sau đó define được các tiêu chí cần đạt, rồi từ đó explore các design option để đạt tiêu chí đã đề ra, hướng này ngược với cách ở trên.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách này bắt đầu tự việc define rõ outcome (JTBD), sau đó define được các tiêu chí cần đạt, rồi từ đó explore các design option để đạt tiêu chí đã đề ra, hướng này ngược với cách ở trên.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-80a3-ae48-c9004fb6477f",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T07:53:00.000Z",
        "last_edited_time": "2026-09-12T07:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Define clear expected outcome >> Define success criteria >> Explore option >> Pick",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Define clear expected outcome >> Define success criteria >> Explore option >> Pick",
              "href": null
            }
          ],
          "icon": null,
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-804e-957b-cff09e59ecc3",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T07:48:00.000Z",
        "last_edited_time": "2026-09-12T08:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách này thì gần vs mindset của design thinking hơn, vì làm mọi thứ đều có chủ đích rõ ràng, tuy nhiên sẽ khó khi brief không rõ ràng từ đầu >> khiến design bị stuck, đòi hỏi phía design phải có khả năng làm việc với stakeholder để làm rõ (và tất nhiên, việc này cũng phụ thuộc vào khả năng làm rõ vấn đề / mong muốn của bản thân họ).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách này thì gần vs mindset của design thinking hơn, vì làm mọi thứ đều có chủ đích rõ ràng, tuy nhiên sẽ khó khi brief không rõ ràng từ đầu >> khiến design bị stuck, đòi hỏi phía design phải có khả năng làm việc với stakeholder để làm rõ (và tất nhiên, việc này cũng phụ thuộc vào khả năng làm rõ vấn đề / mong muốn của bản thân họ).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-8023-8428-d7a3216ecf4d",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T08:14:00.000Z",
        "last_edited_time": "2026-09-12T08:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhưng bù lại nếu define được rất kĩ ngay cả khi chưa design gì cả, thì hướng này giúp chúng ta tiết kiệm được thời gian vì đã narrow down dc hướng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhưng bù lại nếu define được rất kĩ ngay cả khi chưa design gì cả, thì hướng này giúp chúng ta tiết kiệm được thời gian vì đã narrow down dc hướng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-8087-9107-ce89375b3e7c",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T08:32:00.000Z",
        "last_edited_time": "2026-09-12T08:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-80f7-afa5-efdf3f481ac5",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T08:06:00.000Z",
        "last_edited_time": "2026-09-12T08:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Start w Research",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Start w Research",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-80cf-8d2c-c2c9aa38897c",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T08:32:00.000Z",
        "last_edited_time": "2026-09-12T08:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1789202584/uxcomic-imgs/3d95d164-78d8-80cf-8d2c-c2c9aa38897c.png",
            "expiry_time": "2026-10-04T09:12:15.466Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/3d95d164-78d8-80cf-8d2c-c2c9aa38897c"
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-804a-bb48-f3bf85ca33c3",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T08:06:00.000Z",
        "last_edited_time": "2026-09-12T08:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bắt đầu dự án bằng việc research rất kĩ problem hiện tại (có evidence rõ ràng qua phân tích data / user research), và research đối thủ (phân tích context của họ & cách họ giải quyết)… Sau khi tìm ra điểm đau (Pain points), mình mới bắt đầu design để giải quyết đúng các điểm đau đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bắt đầu dự án bằng việc research rất kĩ problem hiện tại (có evidence rõ ràng qua phân tích data / user research), và research đối thủ (phân tích context của họ & cách họ giải quyết)… Sau khi tìm ra điểm đau (Pain points), mình mới bắt đầu design để giải quyết đúng các điểm đau đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-80c3-b6cd-fd2e5866876b",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T08:10:00.000Z",
        "last_edited_time": "2026-09-12T08:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Suspicious problem >> Assumption >> Investigate >> Hypothesis >> Design explore",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Suspicious problem >> Assumption >> Investigate >> Hypothesis >> Design explore",
              "href": null
            }
          ],
          "icon": null,
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-804c-aed5-f9714090be98",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T08:09:00.000Z",
        "last_edited_time": "2026-09-12T08:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách này đầu đó như cách ở trên nhưng apply khi thấy vấn đề còn mơ hồ hoặc mang tính thử nghiệm (cải thiện flow/ uplift metrics nào đó). Việc research có thể gây tốn thời gian nhưng bù lại sẽ có bằng chứng khách quan để củng cố cho các quyết định design.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách này đầu đó như cách ở trên nhưng apply khi thấy vấn đề còn mơ hồ hoặc mang tính thử nghiệm (cải thiện flow/ uplift metrics nào đó). Việc research có thể gây tốn thời gian nhưng bù lại sẽ có bằng chứng khách quan để củng cố cho các quyết định design.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-8004-a1d0-eed97f30fe7a",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T08:33:00.000Z",
        "last_edited_time": "2026-09-12T08:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-809d-ad33-fe9fe62c02da",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T07:45:00.000Z",
        "last_edited_time": "2026-09-12T08:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Start w System & Constraint-First",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Start w System & Constraint-First",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-803e-8e2b-d09e56b0a960",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T08:33:00.000Z",
        "last_edited_time": "2026-09-12T08:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1789202586/uxcomic-imgs/3d95d164-78d8-803e-8e2b-d09e56b0a960.png",
            "expiry_time": "2026-10-04T09:12:15.548Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/3d95d164-78d8-803e-8e2b-d09e56b0a960"
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-8028-b112-c275fe3d3258",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T08:02:00.000Z",
        "last_edited_time": "2026-09-12T08:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách này thường dùng khi cần design mang tính hệ thống to / sơ khai, ta cần define rất rõ có bao nhiêu rất, chúng nên được sắp xếp ra sao, cần quy chuẩn chúng như thế nào để consistent, scale được, đủ flexible để adapt cho nhiều design case,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách này thường dùng khi cần design mang tính hệ thống to / sơ khai, ta cần define rất rõ có bao nhiêu rất, chúng nên được sắp xếp ra sao, cần quy chuẩn chúng như thế nào để consistent, scale được, đủ flexible để adapt cho nhiều design case,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3d95d164-78d8-8030-bbf4-c0aaf5606c77",
        "parent": {
          "type": "page_id",
          "page_id": "3d95d164-78d8-80de-910a-c8ddf1430321"
        },
        "created_time": "2026-09-12T08:05:00.000Z",
        "last_edited_time": "2026-09-12T08:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Design case >> Design element >> Design system ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Design case >> Design element >> Design system ",
              "href": null
            }
          ],
          "icon": null,
          "color": "gray_background"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "2555d164-78d8-8086-970c-f37ef391e281",
    "created_time": "2025-08-20T01:31:00.000Z",
    "last_edited_time": "2025-08-29T02:04:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "3-Build",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-29T02:04:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": ";n|V",
          "name": "⚔️:1",
          "color": "brown"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 61
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2025-08-20T01:31:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Khác biệt “văn hoá” giữa iOS & Android",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Khác biệt “văn hoá” giữa iOS & Android",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Kh-c-bi-t-v-n-ho-gi-a-iOS-Android-2555d16478d88086970cf37ef391e281",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
      "name": "Build",
      "slug": "build",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "2555d164-78d8-801b-a598-c4eb647223d2",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:31:00.000Z",
        "last_edited_time": "2025-08-29T02:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756432159/uxcomic-imgs/2555d164-78d8-801b-a598-c4eb647223d2.png",
            "expiry_time": "2026-10-04T09:12:16.887Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2555d164-78d8-801b-a598-c4eb647223d2"
      },
      {
        "object": "block",
        "id": "2555d164-78d8-8097-aa48-c11a5f613a50",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:31:00.000Z",
        "last_edited_time": "2025-08-29T01:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Không khó để bạn bắt gặp trong JD có 1 bullet point này “Strongly understanding of platform guideline (iOS Human Interface guideline & Android Material design guideline).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Không khó để bạn bắt gặp trong JD có 1 bullet point này “Strongly understanding of platform guideline (iOS Human Interface guideline & Android Material design guideline).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-80c2-81ff-c0bf9ea0334a",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:33:00.000Z",
        "last_edited_time": "2025-08-20T01:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nó là gì và tại sao mình cần quan tâm?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nó là gì và tại sao mình cần quan tâm?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-80e2-92bc-d9c360489c7a",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:34:00.000Z",
        "last_edited_time": "2025-08-20T01:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-80e1-bbed-d5db1067f99e",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:31:00.000Z",
        "last_edited_time": "2025-08-20T01:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "OS là gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "OS là gì?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-80bd-a21a-dc4af62d12ef",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:37:00.000Z",
        "last_edited_time": "2025-08-29T01:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "OS (Operating System – Hệ điều hành) chính là “linh hồn” của thiết bị. iOS (Apple) và Android (Google) không chỉ điều khiển phần cứng, mà còn định hình luôn cách người dùng tương tác với ứng dụng với phần mềm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "OS (Operating System – Hệ điều hành) chính là “linh hồn” của thiết bị. iOS (Apple) và Android (Google) không chỉ điều khiển phần cứng, mà còn định hình luôn cách người dùng tương tác với ứng dụng với phần mềm.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-800e-bf88-edda67583d60",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:37:00.000Z",
        "last_edited_time": "2025-08-20T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-80f5-b025-e376bb08e9f5",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:37:00.000Z",
        "last_edited_time": "2025-08-20T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "iOS nổi tiếng với sự tối giản, mượt mà, gesture-driven.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "iOS nổi tiếng với sự tối giản, mượt mà, gesture-driven.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-80fe-9c3b-f5868c86b129",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:37:00.000Z",
        "last_edited_time": "2025-08-20T01:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Android lại đặc trưng bởi sự linh hoạt, đa dạng thiết bị, nhiều tuỳ chỉnh.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Android lại đặc trưng bởi sự linh hoạt, đa dạng thiết bị, nhiều tuỳ chỉnh.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-8091-8a31-f9b139fdae95",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:37:00.000Z",
        "last_edited_time": "2025-08-29T01:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi thiết kế app, chúng ta không thể “vẽ ra một thế giới riêng” tách khỏi OS, bởi người dùng sẽ luôn so sánh app với trải nghiệm họ đã quen thuộc trên chính chiếc điện thoại của mình → Nếu quá khác thì bạn đang không tận dụng tốt mental model sẵn có của user, một phần sẽ ảnh hưởng không tốt lên UX.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi thiết kế app, chúng ta không thể “vẽ ra một thế giới riêng” tách khỏi OS, bởi người dùng sẽ luôn so sánh app với trải nghiệm họ đã quen thuộc trên chính chiếc điện thoại của mình → Nếu quá khác thì bạn đang không tận dụng tốt mental model sẵn có của user, một phần sẽ ảnh hưởng không tốt lên UX.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-80c6-87a3-d6bc7dd2c7a2",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:42:00.000Z",
        "last_edited_time": "2025-08-20T01:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-8009-9e9d-dc93ec318a0e",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:31:00.000Z",
        "last_edited_time": "2025-08-20T01:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Design patten là gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Design patten là gì?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-8050-88ef-e153d97b4028",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:38:00.000Z",
        "last_edited_time": "2025-08-29T01:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Design pattern là những giải pháp lặp đi lặp lại đã được “chuẩn hoá” để giải quyết vấn đề quen thuộc, nói cách đơn giản hơn thì nó là “component” & cách interaction mà bạn hay dùng trong thiết kế ấy.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Design pattern là những giải pháp lặp đi lặp lại đã được “chuẩn hoá” để giải quyết vấn đề quen thuộc, nói cách đơn giản hơn thì nó là “component” & cách interaction mà bạn hay dùng trong thiết kế ấy.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25e5d164-78d8-807a-8dda-e1ae7342e512",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-29T01:08:00.000Z",
        "last_edited_time": "2025-08-29T01:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "→ ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "→ ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Human Interface Guideline (iOS) & Material Design Guideline (Android) là 2 nơi quy chuẩn các design pattern cho 2 native OS.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Human Interface Guideline (iOS) & Material Design Guideline (Android) là 2 nơi quy chuẩn các design pattern cho 2 native OS.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-80c0-9cad-da0b29f81de1",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:38:00.000Z",
        "last_edited_time": "2025-08-20T01:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Pattern giúp user dễ học – dễ nhớ – dễ dùng, vì họ không cần “học lại từ đầu” ở mỗi app. Nó ứng dụng nhiều cho tiêu chí “Consistency & Standard” trong Usability heuristic.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Pattern giúp user dễ học – dễ nhớ – dễ dùng, vì họ không cần “học lại từ đầu” ở mỗi app. Nó ứng dụng nhiều cho tiêu chí “Consistency & Standard” trong Usability heuristic.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-800a-a891-c0449142c35d",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:42:00.000Z",
        "last_edited_time": "2025-08-20T01:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-8068-a0d3-dd452ec54552",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:41:00.000Z",
        "last_edited_time": "2025-08-29T01:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vài “văn hoá” của 2 OS",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vài “văn hoá” của 2 OS",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-8006-b270-c5d03026b20a",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:41:00.000Z",
        "last_edited_time": "2025-08-29T01:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Back navigation",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Back navigation",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "2555d164-78d8-80f9-b382-c8f2e62492bd",
            "parent": {
              "type": "block_id",
              "block_id": "2555d164-78d8-8006-b270-c5d03026b20a"
            },
            "created_time": "2025-08-20T01:41:00.000Z",
            "last_edited_time": "2025-08-20T01:41:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "iOS: back = vuốt từ cạnh trái hoặc nút back trên top-left.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "iOS: back = vuốt từ cạnh trái hoặc nút back trên top-left.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "2555d164-78d8-803d-a2bb-f5713c964332",
            "parent": {
              "type": "block_id",
              "block_id": "2555d164-78d8-8006-b270-c5d03026b20a"
            },
            "created_time": "2025-08-20T01:41:00.000Z",
            "last_edited_time": "2025-08-20T01:45:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Android: back = gesture cạnh trái/phải hoặc nút back system.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Android: back = gesture cạnh trái/phải hoặc nút back system.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "2555d164-78d8-8048-bfa3-c42d2ace9cab",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:41:00.000Z",
        "last_edited_time": "2025-08-20T03:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Navigation model",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Navigation model",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "2555d164-78d8-800b-aabe-d5b4b8aec347",
            "parent": {
              "type": "block_id",
              "block_id": "2555d164-78d8-8048-bfa3-c42d2ace9cab"
            },
            "created_time": "2025-08-20T01:41:00.000Z",
            "last_edited_time": "2025-08-20T01:41:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "iOS: Tab bar cố định, Hierarchical navigation.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "iOS: Tab bar cố định, Hierarchical navigation.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "2555d164-78d8-80aa-bb06-e1f89b7e2cd6",
            "parent": {
              "type": "block_id",
              "block_id": "2555d164-78d8-8048-bfa3-c42d2ace9cab"
            },
            "created_time": "2025-08-20T01:41:00.000Z",
            "last_edited_time": "2025-08-29T01:10:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Android: Bottom navigation + Navigation Drawer.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Android: Bottom navigation + Navigation Drawer.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "2555d164-78d8-8073-9e4c-d06093c78c42",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:41:00.000Z",
        "last_edited_time": "2025-08-20T01:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-8023-a50f-e33fb8c7f29b",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:41:00.000Z",
        "last_edited_time": "2025-08-29T01:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Action placement",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Action placement",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "2555d164-78d8-8040-a374-c38c0dbc164c",
            "parent": {
              "type": "block_id",
              "block_id": "2555d164-78d8-8023-a50f-e33fb8c7f29b"
            },
            "created_time": "2025-08-20T01:41:00.000Z",
            "last_edited_time": "2025-08-29T01:14:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "iOS: hay dùng Action Sheet. Khi dùng OS bạn sẽ thường gặp nút CTA bên iOS được đặt phía trên.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "iOS: hay dùng Action Sheet. Khi dùng OS bạn sẽ thường gặp nút CTA bên iOS được đặt phía trên.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "2555d164-78d8-80c9-bc73-cf0deea74dd2",
            "parent": {
              "type": "block_id",
              "block_id": "2555d164-78d8-8023-a50f-e33fb8c7f29b"
            },
            "created_time": "2025-08-20T01:41:00.000Z",
            "last_edited_time": "2025-08-29T01:13:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Android: hay dùng Modal Bottom Sheet hoặc Dialog. Bên Android cũng có nét đặc trưng nút FAB (bạn sẽ thường gặp trong các app của Google như Gmail, Drive, Authenticator,…). Tuy nhiên thì mình thấy giờ tuỳ app mà iOS cũng dùng (vd: Thread, Airbnb,…), nó không còn mang nặng nét đặc trưng nữa.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Android: hay dùng Modal Bottom Sheet hoặc Dialog. Bên Android cũng có nét đặc trưng nút FAB (bạn sẽ thường gặp trong các app của Google như Gmail, Drive, Authenticator,…). Tuy nhiên thì mình thấy giờ tuỳ app mà iOS cũng dùng (vd: Thread, Airbnb,…), nó không còn mang nặng nét đặc trưng nữa.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "25e5d164-78d8-8057-b5ce-f0168c912844",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-29T01:16:00.000Z",
        "last_edited_time": "2025-08-29T01:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756432160/uxcomic-imgs/25e5d164-78d8-8057-b5ce-f0168c912844.png",
            "expiry_time": "2026-10-04T09:12:16.887Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/25e5d164-78d8-8057-b5ce-f0168c912844"
      },
      {
        "object": "block",
        "id": "25e5d164-78d8-8053-b0d1-e0d30072b3fb",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-29T01:16:00.000Z",
        "last_edited_time": "2025-08-29T01:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756432161/uxcomic-imgs/25e5d164-78d8-8053-b0d1-e0d30072b3fb.png",
            "expiry_time": "2026-10-04T09:12:16.887Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/25e5d164-78d8-8053-b0d1-e0d30072b3fb"
      },
      {
        "object": "block",
        "id": "2555d164-78d8-80a1-b6ba-ebef61e11ab5",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:41:00.000Z",
        "last_edited_time": "2025-08-29T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thói quen thao tác cho Delete item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thói quen thao tác cho Delete item",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "2555d164-78d8-805e-b506-f8d27fdc3391",
            "parent": {
              "type": "block_id",
              "block_id": "2555d164-78d8-80a1-b6ba-ebef61e11ab5"
            },
            "created_time": "2025-08-20T01:43:00.000Z",
            "last_edited_time": "2025-08-20T01:44:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "iOS: swipe left",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "iOS: swipe left",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "2555d164-78d8-80f7-b517-d6eace7ae880",
            "parent": {
              "type": "block_id",
              "block_id": "2555d164-78d8-80a1-b6ba-ebef61e11ab5"
            },
            "created_time": "2025-08-20T01:44:00.000Z",
            "last_edited_time": "2025-08-20T01:44:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Android: Overflow menu / long-press",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Android: Overflow menu / long-press",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "2555d164-78d8-806e-8362-ecf94886d618",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:41:00.000Z",
        "last_edited_time": "2025-08-29T01:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Feedback",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Feedback",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "2555d164-78d8-8041-bcc3-fd6212cc8607",
            "parent": {
              "type": "block_id",
              "block_id": "2555d164-78d8-806e-8362-ecf94886d618"
            },
            "created_time": "2025-08-20T01:41:00.000Z",
            "last_edited_time": "2025-08-20T01:41:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "iOS: Alert, Banner.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "iOS: Alert, Banner.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "2555d164-78d8-8038-acc1-e9be041c2a70",
            "parent": {
              "type": "block_id",
              "block_id": "2555d164-78d8-806e-8362-ecf94886d618"
            },
            "created_time": "2025-08-20T01:41:00.000Z",
            "last_edited_time": "2025-08-20T01:41:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Android: Snackbar, Toast.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Android: Snackbar, Toast.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "25e5d164-78d8-803c-bfad-ff2ec1356eed",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-29T01:22:00.000Z",
        "last_edited_time": "2025-08-29T01:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Safe zone khác biệt ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Safe zone khác biệt ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25e5d164-78d8-8035-94e4-d1fcb1df5afc",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-29T01:20:00.000Z",
        "last_edited_time": "2025-08-29T01:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các component đặc trưng của 2 OS: date picker, permission modal, modal, bottom sheet, picker, notification banner, UI control element… cũng có nét khá biệt.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các component đặc trưng của 2 OS: date picker, permission modal, modal, bottom sheet, picker, notification banner, UI control element… cũng có nét khá biệt.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25e5d164-78d8-80ba-b7e7-c222981a2679",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-29T01:36:00.000Z",
        "last_edited_time": "2025-08-29T01:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756432163/uxcomic-imgs/25e5d164-78d8-80ba-b7e7-c222981a2679.jpg",
            "expiry_time": "2026-10-04T09:12:16.969Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/25e5d164-78d8-80ba-b7e7-c222981a2679"
      },
      {
        "object": "block",
        "id": "2555d164-78d8-80e2-95a9-fe4b14fa4e81",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:41:00.000Z",
        "last_edited_time": "2025-08-29T01:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Design language",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Design language",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25e5d164-78d8-808b-bb61-f3293e7c6d65",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-29T01:34:00.000Z",
        "last_edited_time": "2025-08-29T01:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Style",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Style",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "25e5d164-78d8-809a-81cc-dc607a0ee1cf",
            "parent": {
              "type": "block_id",
              "block_id": "25e5d164-78d8-808b-bb61-f3293e7c6d65"
            },
            "created_time": "2025-08-29T01:34:00.000Z",
            "last_edited_time": "2025-08-29T01:34:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "iOS: prefer flat design",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "iOS: prefer flat design",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-8083-be17-e4a2ab9e3b26",
            "parent": {
              "type": "block_id",
              "block_id": "25e5d164-78d8-808b-bb61-f3293e7c6d65"
            },
            "created_time": "2025-08-29T01:34:00.000Z",
            "last_edited_time": "2025-08-29T01:34:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Android: prefer elevation (shadow)",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Android: prefer elevation (shadow)",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "2555d164-78d8-800d-a246-e0959d3dde77",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:41:00.000Z",
        "last_edited_time": "2025-08-29T01:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Typography",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Typography",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "2555d164-78d8-8098-91a6-ea68fcf6d470",
            "parent": {
              "type": "block_id",
              "block_id": "2555d164-78d8-800d-a246-e0959d3dde77"
            },
            "created_time": "2025-08-20T01:41:00.000Z",
            "last_edited_time": "2025-08-20T02:00:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "iOS: font San Francisco",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "iOS: font San Francisco",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "2555d164-78d8-8061-b5e4-c16de7ae164c",
            "parent": {
              "type": "block_id",
              "block_id": "2555d164-78d8-800d-a246-e0959d3dde77"
            },
            "created_time": "2025-08-20T01:41:00.000Z",
            "last_edited_time": "2025-08-20T02:00:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Android: font Roboto/Google Sans",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Android: font Roboto/Google Sans",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "25e5d164-78d8-8033-bd5f-de1d35604bba",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-29T01:41:00.000Z",
        "last_edited_time": "2025-08-29T01:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ngoài ra còn có cái OS UI đặc trưng mà các brand tự build riêng như: MIUI (Xiaomi); OneUI (Samsung); oxygenOS (OnePlus); Harmony OS (Huawei)…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ngoài ra còn có cái OS UI đặc trưng mà các brand tự build riêng như: MIUI (Xiaomi); OneUI (Samsung); oxygenOS (OnePlus); Harmony OS (Huawei)…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-80f2-9720-fedf9901db76",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T02:00:00.000Z",
        "last_edited_time": "2025-08-20T02:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-802c-8e6f-fd4611559c24",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:41:00.000Z",
        "last_edited_time": "2025-08-20T01:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Biết để làm gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Biết để làm gì?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-802b-bc62-c7f6619f45f6",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:47:00.000Z",
        "last_edited_time": "2025-08-20T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Biết pattern nào cần tuân thủ để user cảm thấy native, pattern nào có thể linh hoạt. Nên ưu tiên dùng các critical pattern như navigation cơ bản (back, action sheet vs bottom sheet, swipe vs long press…), các input thông dụng (date picker, toggle, picker…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Biết pattern nào cần tuân thủ để user cảm thấy native, pattern nào có thể linh hoạt. Nên ưu tiên dùng các critical pattern như navigation cơ bản (back, action sheet vs bottom sheet, swipe vs long press…), các input thông dụng (date picker, toggle, picker…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-80fb-b9c3-fb952d90ffd5",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:47:00.000Z",
        "last_edited_time": "2025-08-20T01:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Biết văn hoá trải nghiệm của từng hệ sinh thái để không tạo cảm giác “app iOS bị Android hoá” hoặc ngược lại → Nếu app ưu tiên trải nghiệm mượt mà, theo đúng thói quen người dùng, thì nên native hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Biết văn hoá trải nghiệm của từng hệ sinh thái để không tạo cảm giác “app iOS bị Android hoá” hoặc ngược lại → Nếu app ưu tiên trải nghiệm mượt mà, theo đúng thói quen người dùng, thì nên native hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-8076-9ed0-ec52df4b7b43",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:54:00.000Z",
        "last_edited_time": "2025-08-29T01:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chuẩn bị các alterative interaction cho trường hợp design cross-platform. Ví dụ: iOS có thói quen swipe để xem thêm các action items, nhưng Android lại không quen với cách interaction này, họ quen với click “overflow menu” hoặc “long-press” → mình cũng cần bổ sung thêm cách interaction này để phục vụ cho tệp Anroid user.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chuẩn bị các alterative interaction cho trường hợp design cross-platform. Ví dụ: iOS có thói quen swipe để xem thêm các action items, nhưng Android lại không quen với cách interaction này, họ quen với click “overflow menu” hoặc “long-press” → mình cũng cần bổ sung thêm cách interaction này để phục vụ cho tệp Anroid user.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25e5d164-78d8-80eb-8963-e88482962349",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-29T01:24:00.000Z",
        "last_edited_time": "2025-08-29T01:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: mặc dù có khác biệt nhưng không phải lúc nào cũng phải follow y khuôn các pattern của 2 OS, các app hiện tại dần dần cũng quy về chung 1 loại pattern dùng chung rồi, có thể ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: mặc dù có khác biệt nhưng không phải lúc nào cũng phải follow y khuôn các pattern của 2 OS, các app hiện tại dần dần cũng quy về chung 1 loại pattern dùng chung rồi, có thể ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "xem thêm ở bài này.",
                "link": {
                  "url": "https://uxplanet.org/you-dont-always-need-to-follow-native-android-or-ios-ui-patterns-when-designing-an-app-2a361a21c342"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "xem thêm ở bài này.",
              "href": "https://uxplanet.org/you-dont-always-need-to-follow-native-android-or-ios-ui-patterns-when-designing-an-app-2a361a21c342"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-8040-9681-d9dd8538f077",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:31:00.000Z",
        "last_edited_time": "2025-08-20T01:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-8031-9655-fa115d330ff4",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:31:00.000Z",
        "last_edited_time": "2025-08-20T01:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-807d-abb7-c317783c57e7",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:31:00.000Z",
        "last_edited_time": "2025-08-20T03:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://m3.material.io/blog/ten-steps-ios-android-design",
                "link": {
                  "url": "https://m3.material.io/blog/ten-steps-ios-android-design"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://m3.material.io/blog/ten-steps-ios-android-design",
              "href": "https://m3.material.io/blog/ten-steps-ios-android-design"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-802e-97d0-efc2c414a6e7",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:31:00.000Z",
        "last_edited_time": "2025-08-20T03:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.learnui.design/blog/ios-vs-android-app-ui-design-complete-guide.html",
                "link": {
                  "url": "https://www.learnui.design/blog/ios-vs-android-app-ui-design-complete-guide.html"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.learnui.design/blog/ios-vs-android-app-ui-design-complete-guide.html",
              "href": "https://www.learnui.design/blog/ios-vs-android-app-ui-design-complete-guide.html"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25e5d164-78d8-807a-af12-ffd4b12c28e3",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-29T01:24:00.000Z",
        "last_edited_time": "2025-08-29T01:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://uxplanet.org/you-dont-always-need-to-follow-native-android-or-ios-ui-patterns-when-designing-an-app-2a361a21c342",
                "link": {
                  "url": "https://uxplanet.org/you-dont-always-need-to-follow-native-android-or-ios-ui-patterns-when-designing-an-app-2a361a21c342"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://uxplanet.org/you-dont-always-need-to-follow-native-android-or-ios-ui-patterns-when-designing-an-app-2a361a21c342",
              "href": "https://uxplanet.org/you-dont-always-need-to-follow-native-android-or-ios-ui-patterns-when-designing-an-app-2a361a21c342"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-80ce-8bd6-fbb72d904a18",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:31:00.000Z",
        "last_edited_time": "2025-08-20T01:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-80c5-8ec2-c0af1a1ea91a",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:31:00.000Z",
        "last_edited_time": "2025-08-20T01:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-8091-9b91-cb09aef420a4",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:31:00.000Z",
        "last_edited_time": "2025-08-20T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Interaction Pattern",
              "href": "https://app.notion.com/p/56798be37f484cfea30e49cc2dedd33d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-80e5-8499-f20b9f56251d",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:31:00.000Z",
        "last_edited_time": "2025-08-20T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UI pattern",
              "href": "https://app.notion.com/p/22d5d16478d88069940de3185e1a8b1a"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-804d-aa4c-d77c00e8052b",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T01:56:00.000Z",
        "last_edited_time": "2025-08-20T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mental model?",
              "href": "https://app.notion.com/p/73bdf5d9ca494b2789a22dde16b2af7d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2555d164-78d8-804b-b3dc-c7d43b8b9364",
        "parent": {
          "type": "page_id",
          "page_id": "2555d164-78d8-8086-970c-f37ef391e281"
        },
        "created_time": "2025-08-20T02:00:00.000Z",
        "last_edited_time": "2025-08-20T02:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "2465d164-78d8-80b5-a79b-ed3aafd415ae",
    "created_time": "2025-08-05T02:38:00.000Z",
    "last_edited_time": "2025-08-26T06:46:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "3-Build",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-26T06:46:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": "}QTb",
          "name": "⚔️:2",
          "color": "gray"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 60
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2025-08-05T02:38:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Cognitive Load",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Cognitive Load",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Cognitive-Load-2465d16478d880b5a79bed3aafd415ae",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
      "name": "Build",
      "slug": "build",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "2465d164-78d8-806c-8dbc-d59325ebaa3e",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-05T02:38:00.000Z",
        "last_edited_time": "2025-08-07T01:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754479111/uxcomic-imgs/2465d164-78d8-806c-8dbc-d59325ebaa3e.png",
            "expiry_time": "2026-10-04T09:12:19.083Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2465d164-78d8-806c-8dbc-d59325ebaa3e"
      },
      {
        "object": "block",
        "id": "2465d164-78d8-80dd-9262-cfa841584d58",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-05T02:38:00.000Z",
        "last_edited_time": "2025-08-06T01:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cognitive load là khái niệm nói về tổng mental effort để con người suy nghĩ (xử lý thông tin), là lượng thông tin cần phải xử lý để hiểu, để học, để nhớ, để làm gì đó tại một thời điểm. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cognitive load là khái niệm nói về tổng mental effort để con người suy nghĩ (xử lý thông tin), là lượng thông tin cần phải xử lý để hiểu, để học, để nhớ, để làm gì đó tại một thời điểm. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2475d164-78d8-8092-9157-c3bb7ae9330c",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-06T01:49:00.000Z",
        "last_edited_time": "2025-08-26T06:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Và trong công việc UX/UI, ta phục vụ trong ngành “công nghệ thông tin”, những gì user thấy trên màn hình bản chất là thông tin, nên khái niệm này rất liên quan & quan trọng. Nếu ta biết cách tăng giảm cognitive load một cách phù hợp thì sẽ giúp UX tốt hơn, vì ta đang giúp làm “nhẹ đầu” bớt cho user.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Và trong công việc UX/UI, ta phục vụ trong ngành “công nghệ thông tin”, những gì user thấy trên màn hình bản chất là thông tin, nên khái niệm này rất liên quan & quan trọng. Nếu ta biết cách tăng giảm cognitive load một cách phù hợp thì sẽ giúp UX tốt hơn, vì ta đang giúp làm “nhẹ đầu” bớt cho user.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2475d164-78d8-80c6-a718-eb7c05d7f6fc",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-06T01:53:00.000Z",
        "last_edited_time": "2025-08-06T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2475d164-78d8-8099-8c45-d1e1e38a0533",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-06T01:45:00.000Z",
        "last_edited_time": "2025-08-06T01:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các khái niệm ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các khái niệm ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2465d164-78d8-8018-a622-e05df6fdf6cb",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-05T02:38:00.000Z",
        "last_edited_time": "2025-08-06T01:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các loại cognitive load",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các loại cognitive load",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2485d164-78d8-80b4-a623-c2308cde6cda",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-07T00:42:00.000Z",
        "last_edited_time": "2025-08-26T06:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Intrinsic load",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Intrinsic load",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": là phần cần phải suy nghĩ liên quan đến bản chất phức tạp của nhiệm vụ hoặc nội dung. Ví dụ: tính toán sổ sách sẽ khó hơn là đặt một cuốc xe; nhớ OTP “29JH75” sẽ khó hơn là “8750”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": là phần cần phải suy nghĩ liên quan đến bản chất phức tạp của nhiệm vụ hoặc nội dung. Ví dụ: tính toán sổ sách sẽ khó hơn là đặt một cuốc xe; nhớ OTP “29JH75” sẽ khó hơn là “8750”.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2485d164-78d8-8063-aa70-cdd76f9b26f8",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-07T00:42:00.000Z",
        "last_edited_time": "2025-08-26T06:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Extraneous load",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Extraneous load",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": là phần suy nghĩ không cần thiết do gặp phải các yếu tố distraction, vô nghĩa, dư thừa. Ví dụ: banner quảng cáo; thông tin vô nghĩa / xa lạ; pop up quá đà. Ví dụ thay vì nói “bạn đã sử dụng 10.5/14 ngày phép” thì có thể nói “bạn còn lại 3.5 ngày phép trong tổng 14 ngày phép” → user sẽ không cần phải tính toán thêm để biết được mình còn bao nhiêu ngày phép.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": là phần suy nghĩ không cần thiết do gặp phải các yếu tố distraction, vô nghĩa, dư thừa. Ví dụ: banner quảng cáo; thông tin vô nghĩa / xa lạ; pop up quá đà. Ví dụ thay vì nói “bạn đã sử dụng 10.5/14 ngày phép” thì có thể nói “bạn còn lại 3.5 ngày phép trong tổng 14 ngày phép” → user sẽ không cần phải tính toán thêm để biết được mình còn bao nhiêu ngày phép.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2485d164-78d8-80b9-8c31-ef7f3244bef5",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-07T00:42:00.000Z",
        "last_edited_time": "2025-08-25T00:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Germane load",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Germane load",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": là phần suy nghĩ mà mình sẽ link với những kiến thức, trải nghiệm quá khứ để hiểu thêm về một vấn đề gì đó và nó sẽ được củng cố vào bộ nhớ dài hạn. Loại tải này giúp người học phát triển hiểu biết sâu sắc và kỹ năng ứng dụng kiến thức một cách hiệu quả. Ví dụ: sử dụng UI pattern (primary button) để giúp user làm quen với hệ thống và dễ dự đoán hơn; tooltips hướng dẫn; dùng các icon universal delete = thùng rác; edit = cây bút…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": là phần suy nghĩ mà mình sẽ link với những kiến thức, trải nghiệm quá khứ để hiểu thêm về một vấn đề gì đó và nó sẽ được củng cố vào bộ nhớ dài hạn. Loại tải này giúp người học phát triển hiểu biết sâu sắc và kỹ năng ứng dụng kiến thức một cách hiệu quả. Ví dụ: sử dụng UI pattern (primary button) để giúp user làm quen với hệ thống và dễ dự đoán hơn; tooltips hướng dẫn; dùng các icon universal delete = thùng rác; edit = cây bút…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2475d164-78d8-80c5-b840-cb4af32146f3",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-06T15:04:00.000Z",
        "last_edited_time": "2025-08-06T15:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2465d164-78d8-8003-9438-e9fee84770d2",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-05T02:38:00.000Z",
        "last_edited_time": "2025-08-07T00:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Working memory & External memory",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Working memory & External memory",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2475d164-78d8-8011-a13b-f55534c4aec2",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-06T15:04:00.000Z",
        "last_edited_time": "2025-08-24T04:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Working memory",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Working memory",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": là phần trí nhớ ngắn hạn, nơi não bộ giữ và xử lý thông tin tạm thời để hoàn thành các nhiệm vụ đang diễn ra.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": là phần trí nhớ ngắn hạn, nơi não bộ giữ và xử lý thông tin tạm thời để hoàn thành các nhiệm vụ đang diễn ra.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2485d164-78d8-80b3-b613-da0505905f53",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-07T00:43:00.000Z",
        "last_edited_time": "2025-08-07T00:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "External memory",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "External memory",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": là những công cụ hoặc yếu tố bên ngoài giúp lưu giữ và hỗ trợ truy xuất thông tin, thay vì người dùng phải nhớ trong đầu.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": là những công cụ hoặc yếu tố bên ngoài giúp lưu giữ và hỗ trợ truy xuất thông tin, thay vì người dùng phải nhớ trong đầu.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2475d164-78d8-8037-b3e2-d570dedc2a2f",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-06T15:04:00.000Z",
        "last_edited_time": "2025-08-06T15:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2475d164-78d8-80c6-88a0-ff2203c45f71",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-06T01:59:00.000Z",
        "last_edited_time": "2025-08-26T06:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mối liên hệ giữa chúng?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mối liên hệ giữa chúng?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2475d164-78d8-8099-a8a0-c4f4875922c1",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-06T02:00:00.000Z",
        "last_edited_time": "2025-08-25T00:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cognitive load là tổng lượng thông tin cần được xử lý, có thể hình dung là độ nặng của một chương trình đang chạy (vd: chrome tốn 30% dung lượng ram, photoshop tốn 70% ram).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cognitive load là tổng lượng thông tin cần được xử lý, có thể hình dung là độ nặng của một chương trình đang chạy (vd: chrome tốn 30% dung lượng ram, photoshop tốn 70% ram).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2475d164-78d8-8034-aaba-e995bb68d85c",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-06T02:01:00.000Z",
        "last_edited_time": "2025-08-24T04:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Working memory là vùng tạm thời để xử lý thông tin, ta có thể hình dung nó là RAM để chạy chương trình, hoặc có thể hình dung nó như 1 cái bàn làm việc, các thông tin cần xử lý là các giấy tờ, sổ sách trên bàn. Khi lượng cognitive load tại 1 thời điểm > working memory sẽ dẫn đến overload → user sẽ mệt mỏi, mất tập trung & giảm hiệu quả thực thi task.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Working memory là vùng tạm thời để xử lý thông tin, ta có thể hình dung nó là RAM để chạy chương trình, hoặc có thể hình dung nó như 1 cái bàn làm việc, các thông tin cần xử lý là các giấy tờ, sổ sách trên bàn. Khi lượng cognitive load tại 1 thời điểm > working memory sẽ dẫn đến overload → user sẽ mệt mỏi, mất tập trung & giảm hiệu quả thực thi task.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2475d164-78d8-80a0-9a9e-e59fc49adca6",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-06T02:04:00.000Z",
        "last_edited_time": "2025-08-25T00:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "External memory giống như một bộ nhớ ngoài, nó giúp giảm tải “RAM”, từ đó giảm nhẹ cognitive load. (Ví dụ: viết to-do-list sẽ khiến bạn làm việc hiệu quả hơn, do mà mình k cần nhớ “sắp tới mình sẽ cần làm gì tiếp ta”, bạn chỉ cần viết ra 1 lần, sau đó thì cứ thế follow theo).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "External memory giống như một bộ nhớ ngoài, nó giúp giảm tải “RAM”, từ đó giảm nhẹ cognitive load. (Ví dụ: viết to-do-list sẽ khiến bạn làm việc hiệu quả hơn, do mà mình k cần nhớ “sắp tới mình sẽ cần làm gì tiếp ta”, bạn chỉ cần viết ra 1 lần, sau đó thì cứ thế follow theo).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2475d164-78d8-8091-ad8f-de2c855c9184",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-06T02:00:00.000Z",
        "last_edited_time": "2025-08-06T02:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2465d164-78d8-8060-8c82-ef4d9d570f86",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-05T02:38:00.000Z",
        "last_edited_time": "2025-08-06T01:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách vận dụng trong công việc UX",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách vận dụng trong công việc UX",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2485d164-78d8-8024-b924-e7422270df3f",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-07T00:52:00.000Z",
        "last_edited_time": "2025-08-07T00:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "list",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "list",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "2485d164-78d8-8083-af9f-ebe08d3b5a2b",
            "parent": {
              "type": "block_id",
              "block_id": "2485d164-78d8-8024-b924-e7422270df3f"
            },
            "created_time": "2025-08-07T00:52:00.000Z",
            "last_edited_time": "2025-08-23T01:59:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754528531/uxcomic-imgs/2485d164-78d8-8083-af9f-ebe08d3b5a2b.png",
                "expiry_time": "2026-10-04T09:12:19.557Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2485d164-78d8-8083-af9f-ebe08d3b5a2b"
          },
          {
            "object": "block",
            "id": "2485d164-78d8-8018-bbb0-e74446a87387",
            "parent": {
              "type": "block_id",
              "block_id": "2485d164-78d8-8024-b924-e7422270df3f"
            },
            "created_time": "2025-08-07T00:52:00.000Z",
            "last_edited_time": "2025-08-23T01:59:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754528532/uxcomic-imgs/2485d164-78d8-8018-bbb0-e74446a87387.png",
                "expiry_time": "2026-10-04T09:12:19.557Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2485d164-78d8-8018-bbb0-e74446a87387"
          },
          {
            "object": "block",
            "id": "2485d164-78d8-80d0-9de7-f677ea618ecd",
            "parent": {
              "type": "block_id",
              "block_id": "2485d164-78d8-8024-b924-e7422270df3f"
            },
            "created_time": "2025-08-07T00:52:00.000Z",
            "last_edited_time": "2025-08-23T01:59:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754528533/uxcomic-imgs/2485d164-78d8-80d0-9de7-f677ea618ecd.png",
                "expiry_time": "2026-10-04T09:12:19.557Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2485d164-78d8-80d0-9de7-f677ea618ecd"
          },
          {
            "object": "block",
            "id": "2485d164-78d8-80c0-805e-c07bdc7474f7",
            "parent": {
              "type": "block_id",
              "block_id": "2485d164-78d8-8024-b924-e7422270df3f"
            },
            "created_time": "2025-08-07T00:52:00.000Z",
            "last_edited_time": "2025-08-23T01:59:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1754528534/uxcomic-imgs/2485d164-78d8-80c0-805e-c07bdc7474f7.png",
                "expiry_time": "2026-10-04T09:12:19.557Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2485d164-78d8-80c0-805e-c07bdc7474f7"
          }
        ]
      },
      {
        "object": "block",
        "id": "2585d164-78d8-80a1-b1de-d585c9da428b",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-23T02:00:00.000Z",
        "last_edited_time": "2025-08-23T02:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2585d164-78d8-80de-9947-d44c0e331c2a",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-23T02:00:00.000Z",
        "last_edited_time": "2025-08-23T02:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2465d164-78d8-80bb-b5c9-e9cf6c9f7fb8",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-05T02:38:00.000Z",
        "last_edited_time": "2025-08-05T02:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2465d164-78d8-804c-94fc-eb5a168e179a",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-05T02:38:00.000Z",
        "last_edited_time": "2025-08-05T02:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2595d164-78d8-80bd-91b2-eee7749f39ce",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-24T04:19:00.000Z",
        "last_edited_time": "2025-08-24T04:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "video",
        "video": {
          "caption": [],
          "type": "external",
          "external": {
            "url": "https://www.youtube.com/watch?v=IkH0EGYqWO0"
          }
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2465d164-78d8-8048-8cd8-e97048adde43",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-05T02:38:00.000Z",
        "last_edited_time": "2025-08-06T01:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://lawsofux.com/cognitive-load/",
                "link": {
                  "url": "https://lawsofux.com/cognitive-load/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://lawsofux.com/cognitive-load/",
              "href": "https://lawsofux.com/cognitive-load/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2465d164-78d8-806a-a670-df639f7bdc33",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-05T02:38:00.000Z",
        "last_edited_time": "2025-08-06T01:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.nngroup.com/videos/cognitive-load/",
                "link": {
                  "url": "https://www.nngroup.com/videos/cognitive-load/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.nngroup.com/videos/cognitive-load/",
              "href": "https://www.nngroup.com/videos/cognitive-load/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2475d164-78d8-80c0-b7bc-e31dcb6335ae",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-06T01:42:00.000Z",
        "last_edited_time": "2025-08-06T01:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.nngroup.com/articles/working-memory-external-memory/",
                "link": {
                  "url": "https://www.nngroup.com/articles/working-memory-external-memory/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.nngroup.com/articles/working-memory-external-memory/",
              "href": "https://www.nngroup.com/articles/working-memory-external-memory/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2585d164-78d8-80a3-9cc6-f565a1955a0c",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-23T16:39:00.000Z",
        "last_edited_time": "2025-08-23T16:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.interaction-design.org/literature/topics/cognitive-task-analysis",
                "link": {
                  "url": "https://www.interaction-design.org/literature/topics/cognitive-task-analysis"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.interaction-design.org/literature/topics/cognitive-task-analysis",
              "href": "https://www.interaction-design.org/literature/topics/cognitive-task-analysis"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2465d164-78d8-8075-90b3-e8f790fce34d",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-05T02:38:00.000Z",
        "last_edited_time": "2025-08-05T02:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2465d164-78d8-8080-9e04-dc60297e3292",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-05T02:38:00.000Z",
        "last_edited_time": "2025-08-05T02:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2465d164-78d8-8057-b77e-da785f117bc2",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-05T02:38:00.000Z",
        "last_edited_time": "2025-08-06T02:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "2345d164-78d8-8068-929a-ed7272e1260b"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Interaction cost",
              "href": "https://app.notion.com/p/2345d16478d88068929aed7272e1260b"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2465d164-78d8-804d-8638-d0b2232ff620",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-05T02:38:00.000Z",
        "last_edited_time": "2025-08-06T02:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "73bdf5d9-ca49-4b27-89a2-2dde16b2af7d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mental model?",
              "href": "https://app.notion.com/p/73bdf5d9ca494b2789a22dde16b2af7d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2475d164-78d8-805b-b01c-d217835d2ed7",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-06T02:15:00.000Z",
        "last_edited_time": "2025-08-06T02:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "2475d164-78d8-8075-8c4d-f915f369beb7"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cognitive load checklist",
              "href": "https://app.notion.com/p/2475d16478d880758c4df915f369beb7"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2475d164-78d8-8090-abe5-fe76255c0e5e",
        "parent": {
          "type": "page_id",
          "page_id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
        },
        "created_time": "2025-08-06T15:04:00.000Z",
        "last_edited_time": "2025-08-06T15:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "2345d164-78d8-8068-929a-ed7272e1260b",
    "created_time": "2025-07-18T23:22:00.000Z",
    "last_edited_time": "2025-08-06T02:10:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "3-Build",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-06T02:10:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": "}QTb",
          "name": "⚔️:2",
          "color": "gray"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 54
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2025-07-18T23:22:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Interaction cost",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Interaction cost",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Interaction-cost-2345d16478d88068929aed7272e1260b",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
      "name": "Build",
      "slug": "build",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "2345d164-78d8-8093-b29a-c66e58657ef7",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:22:00.000Z",
        "last_edited_time": "2025-07-27T13:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753685315/uxcomic-imgs/2345d164-78d8-8093-b29a-c66e58657ef7.png",
            "expiry_time": "2026-10-04T09:12:20.648Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2345d164-78d8-8093-b29a-c66e58657ef7"
      },
      {
        "object": "block",
        "id": "2345d164-78d8-809b-b4ed-dbc168adabf3",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:24:00.000Z",
        "last_edited_time": "2025-07-18T23:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Interaction cost",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Interaction cost",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-8061-a4cd-cd0f8211efab",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:22:00.000Z",
        "last_edited_time": "2025-07-18T23:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có một khái niệm về interaction cost, nó nói về việc user phải tốn một effort nhất định khi tương tác với máy để hoàn thành một mục tiêu nào đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có một khái niệm về interaction cost, nó nói về việc user phải tốn một effort nhất định khi tương tác với máy để hoàn thành một mục tiêu nào đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-8039-92d9-cff8dd75e433",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:26:00.000Z",
        "last_edited_time": "2025-07-31T01:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ta gọi nó là cost bởi vì thật sự họ không muốn tương tác, cái họ muốn là “mục đích cuối của việc dùng” product của bạn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ta gọi nó là cost bởi vì thật sự họ không muốn tương tác, cái họ muốn là “mục đích cuối của việc dùng” product của bạn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2415d164-78d8-8012-ad51-e361e738472c",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-31T01:49:00.000Z",
        "last_edited_time": "2025-07-31T01:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: bạn muốn mua một quyển sách trên e-commerce, bạn phải lên app, gõ tên sách, tìm xem bên nào bán giá tốt, lựa chọn khuyến mãi, check out,… nhưng cái họ muốn là có cuốn sách có trên bàn của họ một cách “nhanh nhất” hoặc “rẻ nhất” hoặc “có review cao nhất”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: bạn muốn mua một quyển sách trên e-commerce, bạn phải lên app, gõ tên sách, tìm xem bên nào bán giá tốt, lựa chọn khuyến mãi, check out,… nhưng cái họ muốn là có cuốn sách có trên bàn của họ một cách “nhanh nhất” hoặc “rẻ nhất” hoặc “có review cao nhất”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2415d164-78d8-80f3-9e93-c7f825da4071",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-31T01:48:00.000Z",
        "last_edited_time": "2025-07-31T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-8008-8b17-f1aa70908d00",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:29:00.000Z",
        "last_edited_time": "2025-07-31T01:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bản chất con người thích lười, nên việc gì khiến họ nhanh đến mục tiêu hơn mà ít tốn công sức hơn, chắc chắn sẽ làm họ thích.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bản chất con người thích lười, nên việc gì khiến họ nhanh đến mục tiêu hơn mà ít tốn công sức hơn, chắc chắn sẽ làm họ thích.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2415d164-78d8-80d9-9586-ee056ee5cae8",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-31T01:50:00.000Z",
        "last_edited_time": "2025-07-31T01:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: giờ bạn chỉ cần gõ miêu tả bức tranh, AI có thể vẽ ngay cho bạn, bạn không còn phải học tool để tự vẽ >> xem bao nhiêu người điên cuồng vì nó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: giờ bạn chỉ cần gõ miêu tả bức tranh, AI có thể vẽ ngay cho bạn, bạn không còn phải học tool để tự vẽ >> xem bao nhiêu người điên cuồng vì nó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2415d164-78d8-8066-8a87-f96be35f73a7",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-31T01:50:00.000Z",
        "last_edited_time": "2025-07-31T01:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2415d164-78d8-80ea-b8f0-c20e2f9ae540",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-31T01:50:00.000Z",
        "last_edited_time": "2025-07-31T01:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Cost” thì ai cũng không muốn, nên giảm được thì càng tốt. Vậy ta có mấy loại interaction cost:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Cost” thì ai cũng không muốn, nên giảm được thì càng tốt. Vậy ta có mấy loại interaction cost:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-803c-a04d-f02ac529cc3c",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:22:00.000Z",
        "last_edited_time": "2025-07-18T23:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cognitive cost",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cognitive cost",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": là effort bạn cần dùng đến não để nghĩ, giải nghĩa & ghi nhớ thông tin.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": là effort bạn cần dùng đến não để nghĩ, giải nghĩa & ghi nhớ thông tin.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-8027-9fca-dc08302cb34d",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:22:00.000Z",
        "last_edited_time": "2025-07-18T23:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Physical cost",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Physical cost",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": là effort vật lý khi bạn tương tác như scroll, click, di chuyển ngón tay, gõ,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": là effort vật lý khi bạn tương tác như scroll, click, di chuyển ngón tay, gõ,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-8052-9876-cb3097ed0b7a",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:22:00.000Z",
        "last_edited_time": "2025-07-18T23:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Emotional cost",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Emotional cost",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": là những cảm giác khó chịu, lo sợ, stress khi đang tương tác",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": là những cảm giác khó chịu, lo sợ, stress khi đang tương tác",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-80d0-bbc6-f346276c387a",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:22:00.000Z",
        "last_edited_time": "2025-07-18T23:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Temporal cost",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Temporal cost",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": là thời gian bạn phải đợi trong khi tương tác, ví dụ: loading, transition,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": là thời gian bạn phải đợi trong khi tương tác, ví dụ: loading, transition,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-8064-9679-f1da488a12b0",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:22:00.000Z",
        "last_edited_time": "2025-07-18T23:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-80cb-a4c3-e650808d0912",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:22:00.000Z",
        "last_edited_time": "2025-07-18T23:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi nhắc đến design ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi nhắc đến design ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "effortless, seamless",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "effortless, seamless",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " đồng nghĩa với việc mình giảm tải những cost này cho user.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " đồng nghĩa với việc mình giảm tải những cost này cho user.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-804d-bf21-e62a35c7cdf0",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:22:00.000Z",
        "last_edited_time": "2025-07-18T23:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có rất nhiều cách để giảm effort này, có thể từ việc bạn thiết kế ux tốt hơn (rõ ràng, dễ hiểu, ít step, default setting, personalization…), có thể về mặt technical (load nhanh hơn, system tự tính toán để đưa ra lựa chọn phù hợp, Face ID…), có thể liên quan đến operation (ví dụ: user chỉ cần gọi đến customer support, mọi việc còn lại như điền thông tin, tìm kiếm, lựa chọn… đã có người làm thay cho user). ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có rất nhiều cách để giảm effort này, có thể từ việc bạn thiết kế ux tốt hơn (rõ ràng, dễ hiểu, ít step, default setting, personalization…), có thể về mặt technical (load nhanh hơn, system tự tính toán để đưa ra lựa chọn phù hợp, Face ID…), có thể liên quan đến operation (ví dụ: user chỉ cần gọi đến customer support, mọi việc còn lại như điền thông tin, tìm kiếm, lựa chọn… đã có người làm thay cho user). ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2415d164-78d8-801d-8826-ee188ee72807",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-31T01:39:00.000Z",
        "last_edited_time": "2025-07-31T01:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Interaction cost",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Interaction cost",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "2415d164-78d8-804c-b96c-e3afe36f5cd5",
            "parent": {
              "type": "block_id",
              "block_id": "2415d164-78d8-801d-8826-ee188ee72807"
            },
            "created_time": "2025-07-31T01:39:00.000Z",
            "last_edited_time": "2025-07-31T01:39:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753928834/uxcomic-imgs/2415d164-78d8-804c-b96c-e3afe36f5cd5.png",
                "expiry_time": "2026-10-04T09:12:21.398Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2415d164-78d8-804c-b96c-e3afe36f5cd5"
          },
          {
            "object": "block",
            "id": "2415d164-78d8-80e8-ae3a-ec2100d28303",
            "parent": {
              "type": "block_id",
              "block_id": "2415d164-78d8-801d-8826-ee188ee72807"
            },
            "created_time": "2025-07-31T01:39:00.000Z",
            "last_edited_time": "2025-07-31T01:39:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753928835/uxcomic-imgs/2415d164-78d8-80e8-ae3a-ec2100d28303.png",
                "expiry_time": "2026-10-04T09:12:21.398Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2415d164-78d8-80e8-ae3a-ec2100d28303"
          },
          {
            "object": "block",
            "id": "2415d164-78d8-8051-b4e1-f65b3ea0072f",
            "parent": {
              "type": "block_id",
              "block_id": "2415d164-78d8-801d-8826-ee188ee72807"
            },
            "created_time": "2025-07-31T01:39:00.000Z",
            "last_edited_time": "2025-07-31T01:39:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753928836/uxcomic-imgs/2415d164-78d8-8051-b4e1-f65b3ea0072f.png",
                "expiry_time": "2026-10-04T09:12:21.398Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2415d164-78d8-8051-b4e1-f65b3ea0072f"
          },
          {
            "object": "block",
            "id": "2415d164-78d8-806b-957b-e3e403f323df",
            "parent": {
              "type": "block_id",
              "block_id": "2415d164-78d8-801d-8826-ee188ee72807"
            },
            "created_time": "2025-07-31T01:39:00.000Z",
            "last_edited_time": "2025-07-31T01:39:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753928837/uxcomic-imgs/2415d164-78d8-806b-957b-e3e403f323df.png",
                "expiry_time": "2026-10-04T09:12:21.399Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/2415d164-78d8-806b-957b-e3e403f323df"
          }
        ]
      },
      {
        "object": "block",
        "id": "2345d164-78d8-8031-99a2-d0e4d952ebf6",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:22:00.000Z",
        "last_edited_time": "2025-07-18T23:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-800c-adc3-dc873d946004",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:22:00.000Z",
        "last_edited_time": "2025-07-18T23:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "It’s depends ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "It’s depends ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-8006-996e-f9530667471f",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:22:00.000Z",
        "last_edited_time": "2025-07-18T23:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuỳ vào flow mà user sẽ có effort capital khác nhau, ví dụ khi flow mang tính chất làm task như điền form thì nó rất chán nên mình phải quan tâm hơn về việc giảm physical cost. Nhưng khi ở flow onboarding có thể user cần sự hứng thú nên mình phải quan tâm hơn về emotion & cognitive cost. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuỳ vào flow mà user sẽ có effort capital khác nhau, ví dụ khi flow mang tính chất làm task như điền form thì nó rất chán nên mình phải quan tâm hơn về việc giảm physical cost. Nhưng khi ở flow onboarding có thể user cần sự hứng thú nên mình phải quan tâm hơn về emotion & cognitive cost. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-80bb-8003-ed5f530625aa",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:22:00.000Z",
        "last_edited_time": "2025-07-31T01:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có khi nó còn tuỳ ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có khi nó còn tuỳ ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "user type",
                "link": {
                  "url": "/22a3b4bb88d34f84a70f83e7c12ac91d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "user type",
              "href": "/22a3b4bb88d34f84a70f83e7c12ac91d"
            },
            {
              "type": "text",
              "text": {
                "content": " mà họ sẽ có những cost hoàn toàn khác nhau, ví dụ new user thì cần làm quen với cách dùng mới nên ta sẽ muốn hạn chế cognitive cost nhiều hơn, nhưng nếu tần suất họ đã dùng thường xuyên & muốn mọi thứ nhanh hơn, thì ta phải để ý giảm interaction cost (vd: short cut, global search, cách facebook tự động suggest các nội dung liên quan…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " mà họ sẽ có những cost hoàn toàn khác nhau, ví dụ new user thì cần làm quen với cách dùng mới nên ta sẽ muốn hạn chế cognitive cost nhiều hơn, nhưng nếu tần suất họ đã dùng thường xuyên & muốn mọi thứ nhanh hơn, thì ta phải để ý giảm interaction cost (vd: short cut, global search, cách facebook tự động suggest các nội dung liên quan…)",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-803f-8920-de826ec5c092",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:32:00.000Z",
        "last_edited_time": "2025-07-18T23:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-800e-b388-cfb1c96a15ee",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:22:00.000Z",
        "last_edited_time": "2025-07-31T01:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hãy thử hình dung, khi user tương tác, họ đều có một effort, emotion capital nhất định. Ví dụ: nếu user chỉ có effort capital ~5 tương tác mà flow bạn đòi hỏi 10 tương tác >> drop; nếu user có emotion capital ~3, khi vào landing page, emotion đó không được đẩy >3 mà còn khó hiểu, không hấp dẫn, không thuyết phục thì emotion bị giảm xuống còn 1 >>>  drop vì mất hứng thú.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hãy thử hình dung, khi user tương tác, họ đều có một effort, emotion capital nhất định. Ví dụ: nếu user chỉ có effort capital ~5 tương tác mà flow bạn đòi hỏi 10 tương tác >> drop; nếu user có emotion capital ~3, khi vào landing page, emotion đó không được đẩy >3 mà còn khó hiểu, không hấp dẫn, không thuyết phục thì emotion bị giảm xuống còn 1 >>>  drop vì mất hứng thú.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2415d164-78d8-80d8-ad1b-dfc082f0d506",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-31T01:52:00.000Z",
        "last_edited_time": "2025-07-31T01:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-80f7-8d34-cb29b327edb6",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:22:00.000Z",
        "last_edited_time": "2025-07-31T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy nên mình phải hiểu user, xem motivation của họ là gì, mức độ intention of use của họ ra sao, mental model của họ ra sao, rồi đánh giá thử mức độ effort user phải bỏ ra như thế nào là hợp lý để có hướng giải pháp phù hợp nhất (có thể tìm hiểu thêm về Fogg behavioral model).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy nên mình phải hiểu user, xem motivation của họ là gì, mức độ intention of use của họ ra sao, mental model của họ ra sao, rồi đánh giá thử mức độ effort user phải bỏ ra như thế nào là hợp lý để có hướng giải pháp phù hợp nhất (có thể tìm hiểu thêm về Fogg behavioral model).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-8000-952e-c1fc0aac9778",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:22:00.000Z",
        "last_edited_time": "2025-07-31T01:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nó tựa như cái bập bênh, motivation luôn nên cao hơn coót thì vậy user mới thấy “lời” & họ sẽ thích thú hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nó tựa như cái bập bênh, motivation luôn nên cao hơn coót thì vậy user mới thấy “lời” & họ sẽ thích thú hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-803d-bf30-f6dbad3dc302",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:22:00.000Z",
        "last_edited_time": "2025-07-18T23:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753685317/uxcomic-imgs/2345d164-78d8-803d-bf30-f6dbad3dc302.gif",
            "expiry_time": "2026-10-04T09:12:20.706Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2345d164-78d8-803d-bf30-f6dbad3dc302"
      },
      {
        "object": "block",
        "id": "2345d164-78d8-805c-8101-f1d3ec8a8e87",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:22:00.000Z",
        "last_edited_time": "2025-07-18T23:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-8050-b409-de70d6d5ee72",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:22:00.000Z",
        "last_edited_time": "2025-07-18T23:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-8061-9ee2-f381f374c23c",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:22:00.000Z",
        "last_edited_time": "2025-07-18T23:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.nngroup.com/articles/interaction-cost-definition/",
                "link": {
                  "url": "https://www.nngroup.com/articles/interaction-cost-definition/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.nngroup.com/articles/interaction-cost-definition/",
              "href": "https://www.nngroup.com/articles/interaction-cost-definition/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23c5d164-78d8-80bc-bb32-d49d139b410a",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-26T06:58:00.000Z",
        "last_edited_time": "2025-07-26T06:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.freecodecamp.org/news/interaction-design-evaluate-interaction-costs-improve-ux/",
                "link": {
                  "url": "https://www.freecodecamp.org/news/interaction-design-evaluate-interaction-costs-improve-ux/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.freecodecamp.org/news/interaction-design-evaluate-interaction-costs-improve-ux/",
              "href": "https://www.freecodecamp.org/news/interaction-design-evaluate-interaction-costs-improve-ux/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-8024-aff8-d69f26fc3c80",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:22:00.000Z",
        "last_edited_time": "2025-07-18T23:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-802b-a02a-e5823745eb66",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:22:00.000Z",
        "last_edited_time": "2025-07-18T23:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23c5d164-78d8-801e-83af-d69b0a3d8ba9",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-26T06:58:00.000Z",
        "last_edited_time": "2025-07-26T06:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Interaction",
              "href": "https://app.notion.com/p/10f5d16478d880509b0ce73068127ed4"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-8021-9529-c164f8fe2568",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:22:00.000Z",
        "last_edited_time": "2025-07-18T23:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Interaction Pattern",
              "href": "https://app.notion.com/p/56798be37f484cfea30e49cc2dedd33d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2345d164-78d8-802c-b9d6-c9c1477dfe23",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-07-18T23:23:00.000Z",
        "last_edited_time": "2025-07-18T23:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1195d164-78d8-8130-8d61-fe6e1619967b"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "IxD checklist",
              "href": "https://app.notion.com/p/1195d16478d881308d61fe6e1619967b"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2475d164-78d8-80bd-83a9-d0aa6ed45d20",
        "parent": {
          "type": "page_id",
          "page_id": "2345d164-78d8-8068-929a-ed7272e1260b"
        },
        "created_time": "2025-08-06T02:10:00.000Z",
        "last_edited_time": "2025-08-06T02:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "2465d164-78d8-80b5-a79b-ed3aafd415ae"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cognitive Load",
              "href": "https://app.notion.com/p/2465d16478d880b5a79bed3aafd415ae"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "22d5d164-78d8-8069-940d-e3185e1a8b1a",
    "created_time": "2025-07-11T10:58:00.000Z",
    "last_edited_time": "2025-08-15T06:10:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "3-Build",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-15T06:10:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": ";n|V",
          "name": "⚔️:1",
          "color": "brown"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 51
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2025-07-11T10:58:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "UI pattern",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "UI pattern",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/UI-pattern-22d5d16478d88069940de3185e1a8b1a",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
      "name": "Build",
      "slug": "build",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "22d5d164-78d8-8024-a5c2-fbe964588c83",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
        },
        "created_time": "2025-07-11T10:58:00.000Z",
        "last_edited_time": "2025-08-15T06:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081554/uxcomic-imgs/22d5d164-78d8-8024-a5c2-fbe964588c83.png",
            "expiry_time": "2026-10-04T09:12:22.714Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/22d5d164-78d8-8024-a5c2-fbe964588c83"
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-8031-aee9-e690192b9a2e",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
        },
        "created_time": "2025-07-11T10:58:00.000Z",
        "last_edited_time": "2025-07-13T03:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Definition",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Definition",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-808f-b3a3-f47c876a02c3",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
        },
        "created_time": "2025-07-11T11:02:00.000Z",
        "last_edited_time": "2025-07-13T03:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "UI Pattern mang nghĩa cần",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UI Pattern mang nghĩa cần",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " chuẩn hoá cách trình bày thông tin và thành phần giao diện (bố cục, phân cấp và hiển thị)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " chuẩn hoá cách trình bày thông tin và thành phần giao diện (bố cục, phân cấp và hiển thị)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " — giúp người dùng dễ nhìn – hiểu – thao tác một cách nhất quán và quen thuộc. Nó giống như “Từ điển thiết kế” chung cho các bên giao tiếp hiệu quả giữa các thành viên trong team design và dev.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " — giúp người dùng dễ nhìn – hiểu – thao tác một cách nhất quán và quen thuộc. Nó giống như “Từ điển thiết kế” chung cho các bên giao tiếp hiệu quả giữa các thành viên trong team design và dev.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8033-a79e-ea5327123724",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
        },
        "created_time": "2025-07-12T04:35:00.000Z",
        "last_edited_time": "2025-07-12T04:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lấy ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lấy ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-80f1-93e9-e454559fe386",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
        },
        "created_time": "2025-07-12T04:35:00.000Z",
        "last_edited_time": "2025-07-13T03:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi cần trình bày một nội dung, dựa trên lượng thông tin và ngữ cảnh flow ta có thể quyết định nên layout nó trên modal (bottom sheet-nhanh & gọn) hay trang riêng (page-nhiều & tập trung).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi cần trình bày một nội dung, dựa trên lượng thông tin và ngữ cảnh flow ta có thể quyết định nên layout nó trên modal (bottom sheet-nhanh & gọn) hay trang riêng (page-nhiều & tập trung).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8063-8720-ed462f9ed586",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
        },
        "created_time": "2025-07-12T04:36:00.000Z",
        "last_edited_time": "2025-07-13T03:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Infinity scroll (phù hợp user cần xem thông tin mang tính khám phá) vs Pagination (phù hợp hơn khi user tìm thông tin).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Infinity scroll (phù hợp user cần xem thông tin mang tính khám phá) vs Pagination (phù hợp hơn khi user tìm thông tin).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-8003-a7e0-c70f50164bdd",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
        },
        "created_time": "2025-07-11T10:58:00.000Z",
        "last_edited_time": "2025-07-13T03:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vài loại UI patterns:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vài loại UI patterns:",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-8031-9760-c24dab1875bf",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
        },
        "created_time": "2025-07-13T03:44:00.000Z",
        "last_edited_time": "2025-07-13T03:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách phân bổ thông tin như: page, tabs, segment control, infinite scroll vs pagination",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách phân bổ thông tin như: page, tabs, segment control, infinite scroll vs pagination",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-80a2-b4b5-d711ea2f86bc",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
        },
        "created_time": "2025-07-13T03:53:00.000Z",
        "last_edited_time": "2025-07-13T03:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các cách layout như: list, grid, bento, vertical vs horizontal direction,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các cách layout như: list, grid, bento, vertical vs horizontal direction,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-80b4-a107-c088762a100b",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
        },
        "created_time": "2025-07-13T03:44:00.000Z",
        "last_edited_time": "2025-07-13T03:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách hiển thị thông tin như: section, card, accordion, modal, tooltips, slider / carousel, table,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách hiển thị thông tin như: section, card, accordion, modal, tooltips, slider / carousel, table,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-8074-bac0-f1803f8c8463",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
        },
        "created_time": "2025-07-13T03:49:00.000Z",
        "last_edited_time": "2025-07-13T03:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách định hình vị trí hiển thị như: sticky, stop at top, floating, appear / disappear in view,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách định hình vị trí hiển thị như: sticky, stop at top, floating, appear / disappear in view,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-80df-9658-efcea6f148dc",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
        },
        "created_time": "2025-07-13T03:58:00.000Z",
        "last_edited_time": "2025-07-13T03:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách điều hướng nhìn: F pattern, Z pattern, visual weights, direction,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách điều hướng nhìn: F pattern, Z pattern, visual weights, direction,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-8033-bf9e-fb216f3e7dd8",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
        },
        "created_time": "2025-07-13T03:46:00.000Z",
        "last_edited_time": "2025-07-13T03:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các navigation pattern như: breadcrumb, header, sidebar / drawer, footer, link,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các navigation pattern như: breadcrumb, header, sidebar / drawer, footer, link,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-80c2-bd72-c9d865cca97e",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
        },
        "created_time": "2025-07-13T03:47:00.000Z",
        "last_edited_time": "2025-07-13T03:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các signal & information như: red dot, transition, animation, status, color, icon,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các signal & information như: red dot, transition, animation, status, color, icon,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-80c6-9776-d8121b2b26c8",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
        },
        "created_time": "2025-07-11T10:58:00.000Z",
        "last_edited_time": "2025-07-11T10:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-80e8-8195-f65cac8ade4f",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
        },
        "created_time": "2025-07-11T10:58:00.000Z",
        "last_edited_time": "2025-07-11T10:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-802e-bbe7-ef10887e5932",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
        },
        "created_time": "2025-07-11T10:58:00.000Z",
        "last_edited_time": "2025-07-12T04:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.interaction-design.org/literature/topics/ui-design-patterns",
                "link": {
                  "url": "https://www.interaction-design.org/literature/topics/ui-design-patterns"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.interaction-design.org/literature/topics/ui-design-patterns",
              "href": "https://www.interaction-design.org/literature/topics/ui-design-patterns"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8066-ab4e-e3d1c7bc3e1c",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
        },
        "created_time": "2025-08-14T02:39:00.000Z",
        "last_edited_time": "2025-08-14T02:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.nngroup.com/articles/design-pattern-guidelines/",
                "link": {
                  "url": "https://www.nngroup.com/articles/design-pattern-guidelines/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.nngroup.com/articles/design-pattern-guidelines/",
              "href": "https://www.nngroup.com/articles/design-pattern-guidelines/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2505d164-78d8-808e-9317-d0bbac83836c",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
        },
        "created_time": "2025-08-15T06:10:00.000Z",
        "last_edited_time": "2025-08-15T06:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://component.gallery",
                "link": {
                  "url": "https://component.gallery/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://component.gallery",
              "href": "https://component.gallery/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-8020-b84e-d8be8f1813e3",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
        },
        "created_time": "2025-07-11T10:58:00.000Z",
        "last_edited_time": "2025-07-11T10:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-80d4-b249-c1ea619362b2",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
        },
        "created_time": "2025-07-11T10:58:00.000Z",
        "last_edited_time": "2025-07-11T10:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-80b8-82fa-f22febfc4f74",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
        },
        "created_time": "2025-07-11T10:58:00.000Z",
        "last_edited_time": "2025-07-12T04:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Interaction Pattern",
              "href": "https://app.notion.com/p/56798be37f484cfea30e49cc2dedd33d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-8004-ad91-c4079b196289",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
        },
        "created_time": "2025-07-11T10:58:00.000Z",
        "last_edited_time": "2025-07-12T04:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "22d5d164-78d8-805e-91ed-ebff577e5186"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX pattern",
              "href": "https://app.notion.com/p/22d5d16478d8805e91edebff577e5186"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "22d5d164-78d8-805e-91ed-ebff577e5186",
    "created_time": "2025-07-11T10:55:00.000Z",
    "last_edited_time": "2025-07-22T03:55:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "3-Build",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2025-07-22T03:55:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": "}QTb",
          "name": "⚔️:2",
          "color": "gray"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 50
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2025-07-11T10:55:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "UX pattern",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "UX pattern",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/UX-pattern-22d5d16478d8805e91edebff577e5186",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
      "name": "Build",
      "slug": "build",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "22d5d164-78d8-80cc-8f47-d38ef03e72a1",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-11T10:56:00.000Z",
        "last_edited_time": "2025-07-13T03:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081557/uxcomic-imgs/22d5d164-78d8-80cc-8f47-d38ef03e72a1.png",
            "expiry_time": "2026-10-04T09:12:23.129Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/22d5d164-78d8-80cc-8f47-d38ef03e72a1"
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-805c-b850-d9ecc4503392",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-11T10:56:00.000Z",
        "last_edited_time": "2025-07-13T03:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Definition",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Definition",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-80dc-8ab8-e307793ae3bb",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-13T03:35:00.000Z",
        "last_edited_time": "2025-07-13T03:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "UX pattern",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX pattern",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "là các giải pháp lặp lại, đã được kiểm chứng, dùng để giải quyết những vấn đề phổ biến về trải nghiệm người dùng. UX Pattern tập trung vào ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "là các giải pháp lặp lại, đã được kiểm chứng, dùng để giải quyết những vấn đề phổ biến về trải nghiệm người dùng. UX Pattern tập trung vào ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "giải quyết các tình huống, nhu cầu, hoặc vấn đề lặp lại trong trải nghiệm người dùng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "giải quyết các tình huống, nhu cầu, hoặc vấn đề lặp lại trong trải nghiệm người dùng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " — vượt ra ngoài giao diện (UI pattern) hoặc tương tác (Interaction pattern) đơn lẻ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " — vượt ra ngoài giao diện (UI pattern) hoặc tương tác (Interaction pattern) đơn lẻ.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8040-a745-fbbdf31f7fa4",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-12T04:28:00.000Z",
        "last_edited_time": "2025-07-12T04:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một công thức có thể minh họa tốt hơn cho term này là:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một công thức có thể minh họa tốt hơn cho term này là:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-80f5-9c5d-edd1a8d236f5",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-12T04:30:00.000Z",
        "last_edited_time": "2025-07-12T04:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi user gặp {tình huống a}, thì họ {mong muốn hoặc cần gì}, vậy hệ thống mình cần {làm gì} để họ có trải nghiệm tốt hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi user gặp {tình huống a}, thì họ {mong muốn hoặc cần gì}, vậy hệ thống mình cần {làm gì} để họ có trải nghiệm tốt hơn.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8052-947f-fbd5f61b7764",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-12T04:30:00.000Z",
        "last_edited_time": "2025-07-12T04:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lấy ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lấy ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-80c6-a570-f96ebd629592",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-12T04:30:00.000Z",
        "last_edited_time": "2025-07-12T04:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi user {gặp phải lỗi a}, thì họ {cần biết lỗi này là gì, tại sao lại bị, có cách khắc phục không}, vậy hệ thống mình cần {báo chính xác lỗi cho user biết và đề xuất hướng giải quyết nếu có thể} hoặc hệ thống cần {làm sao để phòng lỗi này trước khi nó xảy ra}.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi user {gặp phải lỗi a}, thì họ {cần biết lỗi này là gì, tại sao lại bị, có cách khắc phục không}, vậy hệ thống mình cần {báo chính xác lỗi cho user biết và đề xuất hướng giải quyết nếu có thể} hoặc hệ thống cần {làm sao để phòng lỗi này trước khi nó xảy ra}.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-8068-9c42-f8a1a2f67cfc",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-11T10:56:00.000Z",
        "last_edited_time": "2025-07-13T03:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-8044-961b-f58d731cf04f",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-13T03:24:00.000Z",
        "last_edited_time": "2025-07-13T03:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các luồng / trải nghiệm phổ biến:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các luồng / trải nghiệm phổ biến:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-80da-a4e6-eb9b92782f5e",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-13T03:25:00.000Z",
        "last_edited_time": "2025-07-13T03:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Onboarding",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Onboarding",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-80a1-a5f6-fba8af04a587",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-13T03:25:00.000Z",
        "last_edited_time": "2025-07-13T03:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Empty state, Error state, Success state…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Empty state, Error state, Success state…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-800c-9734-c87591291834",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-13T03:39:00.000Z",
        "last_edited_time": "2025-07-13T03:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Error prevention & handling",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Error prevention & handling",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-80fc-becd-f87f29e3d1f3",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-13T03:26:00.000Z",
        "last_edited_time": "2025-07-13T03:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "CRUD (create, read, update, delete - 4 loại action phổ biến trong dữ liệu, thông tin)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "CRUD (create, read, update, delete - 4 loại action phổ biến trong dữ liệu, thông tin)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-8061-bdef-edc479b011e5",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-13T03:25:00.000Z",
        "last_edited_time": "2025-07-13T03:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Interact & Feedback & Progress Indicator",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Interact & Feedback & Progress Indicator",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-80a5-bbbc-e647adf3bc31",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-13T03:40:00.000Z",
        "last_edited_time": "2025-07-13T03:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Effortless (auto complete, suggestion, smart default,…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Effortless (auto complete, suggestion, smart default,…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-8001-92a7-df605668ebcb",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-13T03:37:00.000Z",
        "last_edited_time": "2025-07-13T03:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Progress Disclosure",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Progress Disclosure",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-8044-b3c7-f68a26d0fb25",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-13T03:25:00.000Z",
        "last_edited_time": "2025-07-13T03:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Personalization",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Personalization",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-803a-bcb9-d6d48c30b31e",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-13T03:43:00.000Z",
        "last_edited_time": "2025-07-13T03:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trust & Privacy",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trust & Privacy",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-8073-ac05-cb352561ff32",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-13T03:38:00.000Z",
        "last_edited_time": "2025-07-13T03:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Persuasive pattern (Loss Aversion, Scarcity,…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Persuasive pattern (Loss Aversion, Scarcity,…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-80eb-8436-c0695a49c4e1",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-13T03:38:00.000Z",
        "last_edited_time": "2025-07-13T03:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hook model (build habits)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hook model (build habits)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-80ac-86e6-f2a5c780a555",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-13T03:25:00.000Z",
        "last_edited_time": "2025-07-13T03:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Gamification",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Gamification",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-807e-a02e-c0a1abba6eb4",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-13T03:38:00.000Z",
        "last_edited_time": "2025-07-13T03:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "v.v",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "v.v",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-8067-a45a-e7ccf74de085",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-11T10:56:00.000Z",
        "last_edited_time": "2025-07-11T10:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-804f-8243-dae725263418",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-11T10:56:00.000Z",
        "last_edited_time": "2025-07-11T10:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-807e-8ac2-cf5f8ad056de",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-11T10:56:00.000Z",
        "last_edited_time": "2025-07-12T04:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.shapeof.ai/",
                "link": {
                  "url": "https://www.shapeof.ai/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.shapeof.ai/",
              "href": "https://www.shapeof.ai/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22f5d164-78d8-8053-8234-fc1cb456c602",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-13T03:41:00.000Z",
        "last_edited_time": "2025-07-13T03:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://ui-patterns.com/",
                "link": {
                  "url": "https://ui-patterns.com/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://ui-patterns.com/",
              "href": "https://ui-patterns.com/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-8047-9b69-c15164d23640",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-11T10:56:00.000Z",
        "last_edited_time": "2025-07-22T03:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://uxdesign.cc/gray-patterns-in-ux-where-do-we-draw-the-line-between-helpful-vs-harmful-design-ced7fbaa8ad5",
                "link": {
                  "url": "https://uxdesign.cc/gray-patterns-in-ux-where-do-we-draw-the-line-between-helpful-vs-harmful-design-ced7fbaa8ad5"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://uxdesign.cc/gray-patterns-in-ux-where-do-we-draw-the-line-between-helpful-vs-harmful-design-ced7fbaa8ad5",
              "href": "https://uxdesign.cc/gray-patterns-in-ux-where-do-we-draw-the-line-between-helpful-vs-harmful-design-ced7fbaa8ad5"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2385d164-78d8-8060-bf8e-f82b00736b86",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-22T03:55:00.000Z",
        "last_edited_time": "2025-07-22T03:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://designsystem.line.me/LDSM/ux/navigation-ex-en/",
                "link": {
                  "url": "https://designsystem.line.me/LDSM/ux/navigation-ex-en/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://designsystem.line.me/LDSM/ux/navigation-ex-en/",
              "href": "https://designsystem.line.me/LDSM/ux/navigation-ex-en/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-80d4-b24a-d1f571bc51ef",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-11T10:56:00.000Z",
        "last_edited_time": "2025-07-11T10:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-800a-bffa-cc99432dde06",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-11T10:56:00.000Z",
        "last_edited_time": "2025-07-11T10:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-8022-92de-f13b22692f82",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-11T10:56:00.000Z",
        "last_edited_time": "2025-07-12T04:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Interaction Pattern",
              "href": "https://app.notion.com/p/56798be37f484cfea30e49cc2dedd33d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8029-b3da-e305bdc5ce15",
        "parent": {
          "type": "page_id",
          "page_id": "22d5d164-78d8-805e-91ed-ebff577e5186"
        },
        "created_time": "2025-07-12T04:03:00.000Z",
        "last_edited_time": "2025-07-12T04:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UI pattern",
              "href": "https://app.notion.com/p/22d5d16478d88069940de3185e1a8b1a"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc",
    "created_time": "2025-04-03T11:21:00.000Z",
    "last_edited_time": "2026-02-24T08:19:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "~cV[",
          "name": "4-Measure",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2026-02-24T08:19:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": "}QTb",
          "name": "⚔️:2",
          "color": "gray"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 62
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2025-04-03T11:21:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Data-Metrics in UX",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Data-Metrics in UX",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Data-Metrics-in-UX-1ca5d16478d8802ebb3bfaa465a1d6dc",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "~cV[",
      "name": "Measure",
      "slug": "measure",
      "order": 4
    },
    "content": [
      {
        "object": "block",
        "id": "9456c557-3837-464e-828e-9611603fb6e7",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-04-03T11:21:00.000Z",
        "last_edited_time": "2025-08-25T06:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756098387/uxcomic-imgs/9456c557-3837-464e-828e-9611603fb6e7.png",
            "expiry_time": "2026-10-04T09:12:23.791Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/9456c557-3837-464e-828e-9611603fb6e7"
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-80dd-8ff4-e6c3a7631e29",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T01:18:00.000Z",
        "last_edited_time": "2025-08-25T10:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ship được một flow, một feature chỉ mới hoàn thành 1 nửa chặng đường, có thể nói là ta mới dừng lại ở việc deliver ra output, artifact gì đó và cho nó ra thế giới.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ship được một flow, một feature chỉ mới hoàn thành 1 nửa chặng đường, có thể nói là ta mới dừng lại ở việc deliver ra output, artifact gì đó và cho nó ra thế giới.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-800d-a1ed-ce3269554323",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T06:07:00.000Z",
        "last_edited_time": "2025-08-25T06:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thử hình dung artifact đó là một hợp chất A, ta release để nó tiếp xúc với world - hợp chất B, và ta cần xem chúng nó phản ứng ra sao, liệu sự phản ứng đó có phải thứ mà ta đang kì vọng. Sự phản ứng này chính là outcome của project/product, nếu mình không đo đạc chúng thì sẽ thiếu dữ kiện, thiếu định hướng, chơi bài may rủi, và tệ hơn là không learn được gì cả.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thử hình dung artifact đó là một hợp chất A, ta release để nó tiếp xúc với world - hợp chất B, và ta cần xem chúng nó phản ứng ra sao, liệu sự phản ứng đó có phải thứ mà ta đang kì vọng. Sự phản ứng này chính là outcome của project/product, nếu mình không đo đạc chúng thì sẽ thiếu dữ kiện, thiếu định hướng, chơi bài may rủi, và tệ hơn là không learn được gì cả.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8091-8a35-cde43fc1450e",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T04:54:00.000Z",
        "last_edited_time": "2025-08-25T06:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đây là mindset nhìn nhận mình như là một nhà hoá học, mang tâm thế của một người thử nghiệm, các bạn có thể xem thêm bài này về ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đây là mindset nhìn nhận mình như là một nhà hoá học, mang tâm thế của một người thử nghiệm, các bạn có thể xem thêm bài này về ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "experimental mindset",
                "link": {
                  "url": "/fba9a75a71ae4302ac761431b742e33d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "experimental mindset",
              "href": "/fba9a75a71ae4302ac761431b742e33d"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-803a-922c-c458f4f1caff",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T01:21:00.000Z",
        "last_edited_time": "2025-08-25T03:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy câu hỏi: “ta nên đo lường ra sao?”",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy câu hỏi: “ta nên đo lường ra sao?”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-80f1-8911-cfb70a448bf5",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T01:22:00.000Z",
        "last_edited_time": "2025-08-25T01:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8009-a07a-e035a027b47a",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T01:22:00.000Z",
        "last_edited_time": "2025-08-25T01:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phạm vi đo lường",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phạm vi đo lường",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8041-9cea-cbd00404b2ea",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T01:32:00.000Z",
        "last_edited_time": "2025-08-25T03:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ta nói ta cần đo lường, không đo thì giống như chạy xe trong bóng đêm mà không có đèn. Tuy nhiên có bao nhiêu thứ cần đo? trước khi vô detail các loại metrics thì có thể bắt đầu từ phạm vi trước, vì mỗi phạm vi cho chúng ta biết những thứ khác nhau.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ta nói ta cần đo lường, không đo thì giống như chạy xe trong bóng đêm mà không có đèn. Tuy nhiên có bao nhiêu thứ cần đo? trước khi vô detail các loại metrics thì có thể bắt đầu từ phạm vi trước, vì mỗi phạm vi cho chúng ta biết những thứ khác nhau.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-80d3-8859-f9d5bdaf10a0",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T04:49:00.000Z",
        "last_edited_time": "2025-08-29T10:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "list2",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "list2",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "25e5d164-78d8-80d1-9b42-e62d347a8d1b",
            "parent": {
              "type": "block_id",
              "block_id": "25a5d164-78d8-80d3-8859-f9d5bdaf10a0"
            },
            "created_time": "2025-08-29T10:06:00.000Z",
            "last_edited_time": "2026-01-04T01:31:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756462397/uxcomic-imgs/25e5d164-78d8-80d1-9b42-e62d347a8d1b.png",
                "expiry_time": "2026-10-04T09:12:24.671Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-80d1-9b42-e62d347a8d1b"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-8053-a168-d989cab6aa4d",
            "parent": {
              "type": "block_id",
              "block_id": "25a5d164-78d8-80d3-8859-f9d5bdaf10a0"
            },
            "created_time": "2025-08-29T10:06:00.000Z",
            "last_edited_time": "2026-01-04T01:31:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756462399/uxcomic-imgs/25e5d164-78d8-8053-a168-d989cab6aa4d.png",
                "expiry_time": "2026-10-04T09:12:24.671Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-8053-a168-d989cab6aa4d"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-80da-9a82-df9bae4cf0a0",
            "parent": {
              "type": "block_id",
              "block_id": "25a5d164-78d8-80d3-8859-f9d5bdaf10a0"
            },
            "created_time": "2025-08-29T10:06:00.000Z",
            "last_edited_time": "2026-01-04T01:31:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756462402/uxcomic-imgs/25e5d164-78d8-80da-9a82-df9bae4cf0a0.png",
                "expiry_time": "2026-10-04T09:12:24.671Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-80da-9a82-df9bae4cf0a0"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-8091-a3a0-c9de19324264",
            "parent": {
              "type": "block_id",
              "block_id": "25a5d164-78d8-80d3-8859-f9d5bdaf10a0"
            },
            "created_time": "2025-08-29T10:06:00.000Z",
            "last_edited_time": "2026-01-04T01:31:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756462403/uxcomic-imgs/25e5d164-78d8-8091-a3a0-c9de19324264.png",
                "expiry_time": "2026-10-04T09:12:24.671Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-8091-a3a0-c9de19324264"
          }
        ]
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8090-8eee-fbce462abd7a",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T04:50:00.000Z",
        "last_edited_time": "2025-08-25T04:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8072-a79a-eca5bcb7013f",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T01:52:00.000Z",
        "last_edited_time": "2025-08-25T10:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: mình hơi confuse nghĩ xem liệu có thêm feature hay module level không, vì anyway trong các daily task của designer vẫn dính nhiều đến feature hoặc một module nào đó, mà mình thấy nó có khi là combine của task & journey level, có khi lại nằm ở task level thôi,… nên thôi anyway thấy các level trên cũng đã đủ cover.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: mình hơi confuse nghĩ xem liệu có thêm feature hay module level không, vì anyway trong các daily task của designer vẫn dính nhiều đến feature hoặc một module nào đó, mà mình thấy nó có khi là combine của task & journey level, có khi lại nằm ở task level thôi,… nên thôi anyway thấy các level trên cũng đã đủ cover.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-80ba-9b31-c90b3addf728",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T01:58:00.000Z",
        "last_edited_time": "2025-08-25T01:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8089-96b1-fcd64fa26a17",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T01:58:00.000Z",
        "last_edited_time": "2025-08-25T01:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các loại metrics",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các loại metrics",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2895d164-78d8-8038-b71a-fe8f4a539d80",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-10-11T03:18:00.000Z",
        "last_edited_time": "2025-10-11T03:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1760352849/uxcomic-imgs/2895d164-78d8-8038-b71a-fe8f4a539d80.jpg",
            "expiry_time": "2026-10-04T09:12:23.792Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2895d164-78d8-8038-b71a-fe8f4a539d80"
      },
      {
        "object": "block",
        "id": "3115d164-78d8-8079-97f0-f93951c7c93a",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2026-02-24T08:19:00.000Z",
        "last_edited_time": "2026-02-24T08:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1771921592/uxcomic-imgs/3115d164-78d8-8079-97f0-f93951c7c93a.png",
            "expiry_time": "2026-10-04T09:12:23.792Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/3115d164-78d8-8079-97f0-f93951c7c93a"
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-809e-ac62-d0bd49a993d4",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T01:59:00.000Z",
        "last_edited_time": "2025-08-25T01:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhìn một cách tổng quan nhất thì mình thấy có vài cái đo để giúp mình biết:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhìn một cách tổng quan nhất thì mình thấy có vài cái đo để giúp mình biết:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-801f-bd19-dfc3034bc9f6",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T02:45:00.000Z",
        "last_edited_time": "2025-08-25T03:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quantitative:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quantitative:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " cho mình biết “what & how many, when, where…”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " cho mình biết “what & how many, when, where…”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-80f6-a7de-f47c81f4d07b",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T02:45:00.000Z",
        "last_edited_time": "2025-08-25T03:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Qualitative:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Qualitative:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " cho mình biết “why”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " cho mình biết “why”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-80ca-91cf-e4bd7562d5e6",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T01:59:00.000Z",
        "last_edited_time": "2025-08-25T03:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tích cực: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tích cực: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "đo xem thông qua design đó nó cải thiện được những gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "đo xem thông qua design đó nó cải thiện được những gì?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-806e-9614-e2ef90aaa99d",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T02:00:00.000Z",
        "last_edited_time": "2025-08-25T03:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tiêu cực: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tiêu cực: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "các metrics để ta hình dung được liệu user có gặp khó khăn, phiền hà ở đâu không? ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "các metrics để ta hình dung được liệu user có gặp khó khăn, phiền hà ở đâu không? ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8092-9431-f0ad29d4471b",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T02:00:00.000Z",
        "last_edited_time": "2025-08-25T03:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Behavior: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Behavior: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "nhận diện hành vi, thói quen dùng của user.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "nhận diện hành vi, thói quen dùng của user.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8097-a32e-c53ede8a2a7a",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T02:00:00.000Z",
        "last_edited_time": "2025-08-25T03:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Attitude: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Attitude: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "nhận diện thái độ của user, xem họ hiểu nó ra sao, có perception như thế nào? xem liệu họ có cần / có thích không?, có cảm giác gì khi dùng feature / product?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "nhận diện thái độ của user, xem họ hiểu nó ra sao, có perception như thế nào? xem liệu họ có cần / có thích không?, có cảm giác gì khi dùng feature / product?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-80e1-8bfe-d2e33ac07f50",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T02:04:00.000Z",
        "last_edited_time": "2025-08-25T04:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhiều lắm, nên mình nghĩ rảnh thì có thể tìm hiểu dần dần nhe. Mình tổng hợp sơ qua như sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhiều lắm, nên mình nghĩ rảnh thì có thể tìm hiểu dần dần nhe. Mình tổng hợp sơ qua như sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8011-b6db-ce37d40a9193",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T03:23:00.000Z",
        "last_edited_time": "2025-08-29T10:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "list",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "list",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "25e5d164-78d8-809d-8c9c-c1394d043ac5",
            "parent": {
              "type": "block_id",
              "block_id": "25a5d164-78d8-8011-b6db-ce37d40a9193"
            },
            "created_time": "2025-08-29T10:07:00.000Z",
            "last_edited_time": "2025-10-11T03:18:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756462407/uxcomic-imgs/25e5d164-78d8-809d-8c9c-c1394d043ac5.png",
                "expiry_time": "2026-10-04T09:12:26.016Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-809d-8c9c-c1394d043ac5"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-801c-b632-f491e7b768f2",
            "parent": {
              "type": "block_id",
              "block_id": "25a5d164-78d8-8011-b6db-ce37d40a9193"
            },
            "created_time": "2025-08-29T10:07:00.000Z",
            "last_edited_time": "2025-10-11T03:18:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756462408/uxcomic-imgs/25e5d164-78d8-801c-b632-f491e7b768f2.png",
                "expiry_time": "2026-10-04T09:12:26.017Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-801c-b632-f491e7b768f2"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-8066-b4c1-f0be7a12e16c",
            "parent": {
              "type": "block_id",
              "block_id": "25a5d164-78d8-8011-b6db-ce37d40a9193"
            },
            "created_time": "2025-08-29T10:07:00.000Z",
            "last_edited_time": "2025-10-11T03:18:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756462409/uxcomic-imgs/25e5d164-78d8-8066-b4c1-f0be7a12e16c.png",
                "expiry_time": "2026-10-04T09:12:26.017Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-8066-b4c1-f0be7a12e16c"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-80c0-baf8-cee5008bbdc7",
            "parent": {
              "type": "block_id",
              "block_id": "25a5d164-78d8-8011-b6db-ce37d40a9193"
            },
            "created_time": "2025-08-29T10:07:00.000Z",
            "last_edited_time": "2025-10-11T03:18:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756462410/uxcomic-imgs/25e5d164-78d8-80c0-baf8-cee5008bbdc7.png",
                "expiry_time": "2026-10-04T09:12:26.017Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-80c0-baf8-cee5008bbdc7"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-800b-b2da-dcd364ebadf8",
            "parent": {
              "type": "block_id",
              "block_id": "25a5d164-78d8-8011-b6db-ce37d40a9193"
            },
            "created_time": "2025-08-29T10:07:00.000Z",
            "last_edited_time": "2025-10-11T03:18:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756462411/uxcomic-imgs/25e5d164-78d8-800b-b2da-dcd364ebadf8.png",
                "expiry_time": "2026-10-04T09:12:26.017Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-800b-b2da-dcd364ebadf8"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-8076-81b7-c0cf0df0fb5b",
            "parent": {
              "type": "block_id",
              "block_id": "25a5d164-78d8-8011-b6db-ce37d40a9193"
            },
            "created_time": "2025-08-29T10:07:00.000Z",
            "last_edited_time": "2025-10-11T03:18:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756462412/uxcomic-imgs/25e5d164-78d8-8076-81b7-c0cf0df0fb5b.png",
                "expiry_time": "2026-10-04T09:12:26.017Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-8076-81b7-c0cf0df0fb5b"
          },
          {
            "object": "block",
            "id": "25e5d164-78d8-807b-be53-e5996ad34f9b",
            "parent": {
              "type": "block_id",
              "block_id": "25a5d164-78d8-8011-b6db-ce37d40a9193"
            },
            "created_time": "2025-08-29T10:07:00.000Z",
            "last_edited_time": "2025-10-11T03:18:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1756462413/uxcomic-imgs/25e5d164-78d8-807b-be53-e5996ad34f9b.png",
                "expiry_time": "2026-10-04T09:12:26.017Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/25e5d164-78d8-807b-be53-e5996ad34f9b"
          }
        ]
      },
      {
        "object": "block",
        "id": "25e5d164-78d8-8034-b9b3-c925af0e9211",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-29T10:07:00.000Z",
        "last_edited_time": "2025-08-29T10:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-80e0-aa44-c626e813675a",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T03:47:00.000Z",
        "last_edited_time": "2025-08-29T10:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Link này giúp tìm hiểu về các tactic trong research / testing.",
                "link": {
                  "url": "https://theuxcookbook.com/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Link này giúp tìm hiểu về các tactic trong research / testing.",
              "href": "https://theuxcookbook.com/"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-80da-a64a-f818cf16dfff",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T02:05:00.000Z",
        "last_edited_time": "2025-08-25T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8040-ba67-d07978be90f1",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T02:05:00.000Z",
        "last_edited_time": "2025-08-25T04:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vài mindset nên có khi measure",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vài mindset nên có khi measure",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-80e8-8499-e06c58175704",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T02:47:00.000Z",
        "last_edited_time": "2025-08-25T04:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Balance giữa định tính & định lượng, vì định tính cho ta thông tin, raw data nhưng định lượng giúp ta hiểu thêm “tại sao nó lại như thế”. Đằng sau những con số đó, có những câu chuyện, và mình cần “get out of the building” để tìm hiểu chúng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Balance giữa định tính & định lượng, vì định tính cho ta thông tin, raw data nhưng định lượng giúp ta hiểu thêm “tại sao nó lại như thế”. Đằng sau những con số đó, có những câu chuyện, và mình cần “get out of the building” để tìm hiểu chúng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-80a5-baa1-c5ad143c9e55",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T04:35:00.000Z",
        "last_edited_time": "2025-08-25T10:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Outcome > Output. Hãy đo xem người dùng đạt được mục tiêu chưa, có thành công & hài lòng không thay vì những con số sáo rỗng. (ví dụ: mình làm blog khi ban đầu khá vui nếu đạt được 200 lượt view nhưng buồn khi thấy chẳng mấy ai đọc hết bài viết - thời gian scan 1 bài chỉ tầm 30s).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Outcome > Output. Hãy đo xem người dùng đạt được mục tiêu chưa, có thành công & hài lòng không thay vì những con số sáo rỗng. (ví dụ: mình làm blog khi ban đầu khá vui nếu đạt được 200 lượt view nhưng buồn khi thấy chẳng mấy ai đọc hết bài viết - thời gian scan 1 bài chỉ tầm 30s).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-804b-ad12-dcaca1383e9d",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T04:39:00.000Z",
        "last_edited_time": "2025-08-25T10:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giá trị của số liệu đến từ sự so sánh, nên nếu ta có 1 cái benchmark thì sẽ tốt hơn. Và metrics có giá trị nhất thì nó giúp ta take được action gì đó, chứ không phải chỉ để báo cáo. Think Diagnostic, not Vanity.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giá trị của số liệu đến từ sự so sánh, nên nếu ta có 1 cái benchmark thì sẽ tốt hơn. Và metrics có giá trị nhất thì nó giúp ta take được action gì đó, chứ không phải chỉ để báo cáo. Think Diagnostic, not Vanity.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8050-8271-eeea2619d04b",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T02:47:00.000Z",
        "last_edited_time": "2025-08-25T06:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đo UX thì nên chú ý đo cả 1 hành trình, 1 trải nghiệm tổng thể, measure learnability, ease of use, funnel, measure error, measure happniess / delight…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đo UX thì nên chú ý đo cả 1 hành trình, 1 trải nghiệm tổng thể, measure learnability, ease of use, funnel, measure error, measure happniess / delight…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-804f-bbc1-e779ae9cdba1",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T02:47:00.000Z",
        "last_edited_time": "2025-08-25T03:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8088-bc47-f4759caf7a83",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T02:47:00.000Z",
        "last_edited_time": "2025-08-25T04:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vài điểm lưu ý",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vài điểm lưu ý",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8046-8735-dfec7316ba2b",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T02:47:00.000Z",
        "last_edited_time": "2025-08-25T02:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nên tinh gọn các metrics cần log, vì có đợt làm việc chung với PO để define các metrics cần log thì mình có gặp phải comment “log nhiều làm tăng tải, chi phí storage, query chậm → ảnh hưởng performance”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nên tinh gọn các metrics cần log, vì có đợt làm việc chung với PO để define các metrics cần log thì mình có gặp phải comment “log nhiều làm tăng tải, chi phí storage, query chậm → ảnh hưởng performance”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-80f9-9a4c-cb6f852a2406",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T02:49:00.000Z",
        "last_edited_time": "2025-08-25T10:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Xem có thể define main metrics nào mà thông qua nó trả lời được nhiều câu hỏi hay không, liệu thứ mình cần log quan trọng đến đâu, có giúp mình take được action gì sau khi biết hay không → Vậy bằng cách nào để ta lựa metrics cho phù hợp?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Xem có thể define main metrics nào mà thông qua nó trả lời được nhiều câu hỏi hay không, liệu thứ mình cần log quan trọng đến đâu, có giúp mình take được action gì sau khi biết hay không → Vậy bằng cách nào để ta lựa metrics cho phù hợp?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-80ee-8f28-db354b0725d5",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T02:51:00.000Z",
        "last_edited_time": "2025-08-25T02:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Why we log this metrics? What we want to know? Actionability test (nếu số này tăng/giảm, mình có hành động gì?)?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Why we log this metrics? What we want to know? Actionability test (nếu số này tăng/giảm, mình có hành động gì?)?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-807f-a13b-c113c5e8d738",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T02:50:00.000Z",
        "last_edited_time": "2025-08-25T02:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Goal-driven (GSM – Goal → Signal → Metrics)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Goal-driven (GSM – Goal → Signal → Metrics)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8098-849b-e64cda2c0b63",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T02:52:00.000Z",
        "last_edited_time": "2025-08-25T02:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Diagnostic > Vanity",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Diagnostic > Vanity",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-80aa-a290-ca908efc8500",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T02:53:00.000Z",
        "last_edited_time": "2025-08-25T04:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Maybe ta có thể ưu tiên metrics tùy theo vòng đời sản phẩm. Ví dụ: Phase khám phá → log để hiểu hành vi user; Phase tối ưu → log sâu chỗ bottleneck. Phase mature → giảm log noise, giữ lại metrics chiến lược.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Maybe ta có thể ưu tiên metrics tùy theo vòng đời sản phẩm. Ví dụ: Phase khám phá → log để hiểu hành vi user; Phase tối ưu → log sâu chỗ bottleneck. Phase mature → giảm log noise, giữ lại metrics chiến lược.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-80cf-8221-f45637def7b6",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T02:56:00.000Z",
        "last_edited_time": "2025-08-25T02:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-800b-9b6e-f1fe06c2dd12",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T02:56:00.000Z",
        "last_edited_time": "2025-08-25T02:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2645d164-78d8-8028-b24a-fa26e9c31b76",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-09-04T06:46:00.000Z",
        "last_edited_time": "2025-09-04T06:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://hellopm.co/product-analytics-the-ultimate-guide-for-product-managers/",
                "link": {
                  "url": "https://hellopm.co/product-analytics-the-ultimate-guide-for-product-managers/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://hellopm.co/product-analytics-the-ultimate-guide-for-product-managers/",
              "href": "https://hellopm.co/product-analytics-the-ultimate-guide-for-product-managers/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-802a-9426-fc1b4bf441a0",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T02:56:00.000Z",
        "last_edited_time": "2025-08-25T02:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://maze.co/collections/ux-management/kpis/",
                "link": {
                  "url": "https://maze.co/collections/ux-management/kpis/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://maze.co/collections/ux-management/kpis/",
              "href": "https://maze.co/collections/ux-management/kpis/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8090-ad20-cb0d4b50a6ca",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T03:11:00.000Z",
        "last_edited_time": "2025-08-25T03:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.nngroup.com/articles/usability-metrics/",
                "link": {
                  "url": "https://www.nngroup.com/articles/usability-metrics/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.nngroup.com/articles/usability-metrics/",
              "href": "https://www.nngroup.com/articles/usability-metrics/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8080-a17d-de5e4e1b3421",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T02:58:00.000Z",
        "last_edited_time": "2025-08-25T02:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.interaction-design.org/literature/topics/kpi?srsltid=AfmBOorULHGv76qJbXmFDRIAj--sCbGIrKyp7Wm-M21h3zYZEqRbbmkn",
                "link": {
                  "url": "https://www.interaction-design.org/literature/topics/kpi?srsltid=AfmBOorULHGv76qJbXmFDRIAj--sCbGIrKyp7Wm-M21h3zYZEqRbbmkn"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.interaction-design.org/literature/topics/kpi?srsltid=AfmBOorULHGv76qJbXmFDRIAj--sCbGIrKyp7Wm-M21h3zYZEqRbbmkn",
              "href": "https://www.interaction-design.org/literature/topics/kpi?srsltid=AfmBOorULHGv76qJbXmFDRIAj--sCbGIrKyp7Wm-M21h3zYZEqRbbmkn"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-806d-9584-f973afa8ce47",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T03:01:00.000Z",
        "last_edited_time": "2025-08-25T03:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.baked.design/article/list-of-ux-metrics",
                "link": {
                  "url": "https://www.baked.design/article/list-of-ux-metrics"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.baked.design/article/list-of-ux-metrics",
              "href": "https://www.baked.design/article/list-of-ux-metrics"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-806f-bdd3-ccfef40a04c4",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T03:08:00.000Z",
        "last_edited_time": "2025-08-25T03:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://clay.global/blog/ux-guide/measure-ux",
                "link": {
                  "url": "https://clay.global/blog/ux-guide/measure-ux"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://clay.global/blog/ux-guide/measure-ux",
              "href": "https://clay.global/blog/ux-guide/measure-ux"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2de5d164-78d8-8014-ab6d-d5cbc50ee494",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2026-01-04T01:32:00.000Z",
        "last_edited_time": "2026-01-04T01:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.linkedin.com/posts/bryanzmijewski_how-much-better-when-i-began-my-career-activity-7411479533574516736-diPD?",
                "link": {
                  "url": "https://www.linkedin.com/posts/bryanzmijewski_how-much-better-when-i-began-my-career-activity-7411479533574516736-diPD?utm_medium=ios_app&rcm=ACoAACTxzsYBO4mptTzgsbAc8dNNiYnc142O2IA&utm_source=social_share_send&utm_campaign=copy_link"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.linkedin.com/posts/bryanzmijewski_how-much-better-when-i-began-my-career-activity-7411479533574516736-diPD?",
              "href": "https://www.linkedin.com/posts/bryanzmijewski_how-much-better-when-i-began-my-career-activity-7411479533574516736-diPD?utm_medium=ios_app&rcm=ACoAACTxzsYBO4mptTzgsbAc8dNNiYnc142O2IA&utm_source=social_share_send&utm_campaign=copy_link"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2de5d164-78d8-806e-acac-f39703a4d297",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2026-01-04T01:32:00.000Z",
        "last_edited_time": "2026-01-04T01:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.figma.com/board/fBUZyy84WBRbrQx9qXf1gx/ZURB-Glare-Diagrams?node-id=1-187&t=7e77hhSxHyhlyaRb-1",
                "link": {
                  "url": "https://www.figma.com/board/fBUZyy84WBRbrQx9qXf1gx/ZURB-Glare-Diagrams?node-id=1-187&t=7e77hhSxHyhlyaRb-1"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.figma.com/board/fBUZyy84WBRbrQx9qXf1gx/ZURB-Glare-Diagrams?node-id=1-187&t=7e77hhSxHyhlyaRb-1",
              "href": "https://www.figma.com/board/fBUZyy84WBRbrQx9qXf1gx/ZURB-Glare-Diagrams?node-id=1-187&t=7e77hhSxHyhlyaRb-1"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-80ae-b53a-cccfa5fcdb01",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T03:01:00.000Z",
        "last_edited_time": "2025-08-25T03:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8006-98dc-cc7eb0a56289",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T03:01:00.000Z",
        "last_edited_time": "2025-08-25T03:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Items",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Items",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-8068-a3ef-cce43ca32b50",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T03:01:00.000Z",
        "last_edited_time": "2025-08-25T03:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Just an experiment",
              "href": "https://app.notion.com/p/fba9a75a71ae4302ac761431b742e33d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25a5d164-78d8-80ee-8cc3-f2583555da3c",
        "parent": {
          "type": "page_id",
          "page_id": "1ca5d164-78d8-802e-bb3b-faa465a1d6dc"
        },
        "created_time": "2025-08-25T03:01:00.000Z",
        "last_edited_time": "2025-08-25T04:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Design value",
              "href": "https://app.notion.com/p/ed40fd40a3184fd6a63f0067b4e54861"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1705d164-78d8-8075-923f-fbb228f43ae9",
    "created_time": "2025-01-03T14:28:00.000Z",
    "last_edited_time": "2025-08-16T06:25:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "~cV[",
          "name": "4-Measure",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-16T06:25:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": "}QTb",
          "name": "⚔️:2",
          "color": "gray"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 36
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2025-01-03T14:28:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Design Ops",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Design Ops",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Design-Ops-1705d16478d88075923ffbb228f43ae9",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "~cV[",
      "name": "Measure",
      "slug": "measure",
      "order": 4
    },
    "content": [
      {
        "object": "block",
        "id": "1705d164-78d8-81ed-b168-e7cd4724acb5",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-03T14:28:00.000Z",
        "last_edited_time": "2025-01-04T11:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081560/uxcomic-imgs/1705d164-78d8-81ed-b168-e7cd4724acb5.png",
            "expiry_time": "2026-10-04T09:12:28.346Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1705d164-78d8-81ed-b168-e7cd4724acb5"
      },
      {
        "object": "block",
        "id": "1705d164-78d8-8134-b5ec-f53f9912c62f",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-03T14:28:00.000Z",
        "last_edited_time": "2025-01-05T03:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước đó mình thường làm trong môi trường start-up, nên toàn là designer một mình nên, việc tự quản lý đầu việc, file, document các thứ cũng không gặp trục trặc gì nhiều, vì cơ bản có mình xài là chủ yếu mà 🤣.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước đó mình thường làm trong môi trường start-up, nên toàn là designer một mình nên, việc tự quản lý đầu việc, file, document các thứ cũng không gặp trục trặc gì nhiều, vì cơ bản có mình xài là chủ yếu mà 🤣.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-808c-ac81-fb8a5980e66b",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T06:26:00.000Z",
        "last_edited_time": "2025-01-05T03:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhưng khi mình được vào môi trường có team, có nhiều thành viên hơn, nhiều stakeholder hơn, mình mới thấy việc align với nhau từ quy trình, quản lý file, task management… cần tốn effort hơn để set up, maintain & improve >>> đây là những công việc liên quan đến DesignOps (design operation - mục tiêu của nó nhằm tăng hiệu suất công việc, cải thiện sự hợp tác, đồng bộ hoá quy trình & quản lý resources).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhưng khi mình được vào môi trường có team, có nhiều thành viên hơn, nhiều stakeholder hơn, mình mới thấy việc align với nhau từ quy trình, quản lý file, task management… cần tốn effort hơn để set up, maintain & improve >>> đây là những công việc liên quan đến DesignOps (design operation - mục tiêu của nó nhằm tăng hiệu suất công việc, cải thiện sự hợp tác, đồng bộ hoá quy trình & quản lý resources).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80d6-a9ec-f267e0fe8438",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T06:39:00.000Z",
        "last_edited_time": "2025-01-04T06:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thậm chí các công ty siêu lớn như Shoptify, Airbnb có hẳn team chuyên làm về Design Ops.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thậm chí các công ty siêu lớn như Shoptify, Airbnb có hẳn team chuyên làm về Design Ops.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80b2-a1dc-c81ce515e530",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T06:42:00.000Z",
        "last_edited_time": "2025-01-05T03:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nói về Operation, ta sẽ quan tâm đến 3 khía cạnh chính: người, việc & công cụ. Người & việc thì sẽ thiên nhiều hơn về quản lý (leader / manager), nhưng trong topic này mình chỉ mention đến những thứ mình quan sát & đóng góp được thôi, đó là “công cụ”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nói về Operation, ta sẽ quan tâm đến 3 khía cạnh chính: người, việc & công cụ. Người & việc thì sẽ thiên nhiều hơn về quản lý (leader / manager), nhưng trong topic này mình chỉ mention đến những thứ mình quan sát & đóng góp được thôi, đó là “công cụ”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1765d164-78d8-80e4-a573-d26fb64a91bc",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-09T14:34:00.000Z",
        "last_edited_time": "2025-08-16T06:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081561/uxcomic-imgs/1765d164-78d8-80e4-a573-d26fb64a91bc.jpg",
            "expiry_time": "2026-10-04T09:12:28.346Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1765d164-78d8-80e4-a573-d26fb64a91bc"
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8090-b804-fa9b8df23b70",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T07:51:00.000Z",
        "last_edited_time": "2025-01-04T07:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-814a-ad57-dd468fc0761c",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-03T14:28:00.000Z",
        "last_edited_time": "2025-01-04T07:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Design file organization",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Design file organization",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80d1-b8fc-eab81c68def3",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T08:25:00.000Z",
        "last_edited_time": "2025-01-04T08:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081563/uxcomic-imgs/1715d164-78d8-80d1-b8fc-eab81c68def3.png",
            "expiry_time": "2026-10-04T09:12:28.347Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1715d164-78d8-80d1-b8fc-eab81c68def3"
      },
      {
        "object": "block",
        "id": "1705d164-78d8-81ef-9ce8-cab22f53add0",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-03T14:28:00.000Z",
        "last_edited_time": "2025-01-05T03:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có 3 thứ liên quan đến quản lý file.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có 3 thứ liên quan đến quản lý file.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-800d-8086-e7edcbb734de",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T07:34:00.000Z",
        "last_edited_time": "2025-01-04T08:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Naming",
                "link": {
                  "url": "https://medium.com/design-bootcamp/figma-component-naming-conventions-ce53e53c7d39"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Naming",
              "href": "https://medium.com/design-bootcamp/figma-component-naming-conventions-ce53e53c7d39"
            },
            {
              "type": "text",
              "text": {
                "content": ": đặt tên làm sao team thấy được tính hệ thống, đồng bộ, dễ nhận diện các thông tin quan trọng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": đặt tên làm sao team thấy được tính hệ thống, đồng bộ, dễ nhận diện các thông tin quan trọng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0,
        "children": [
          {
            "object": "block",
            "id": "1715d164-78d8-80d8-b80c-cf4d2ce44bfb",
            "parent": {
              "type": "block_id",
              "block_id": "1715d164-78d8-800d-8086-e7edcbb734de"
            },
            "created_time": "2025-01-04T07:38:00.000Z",
            "last_edited_time": "2025-01-04T07:38:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Tên cần có thông tin gì",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Tên cần có thông tin gì",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 0
          },
          {
            "object": "block",
            "id": "1715d164-78d8-80d0-a94b-e608cd0780f5",
            "parent": {
              "type": "block_id",
              "block_id": "1715d164-78d8-800d-8086-e7edcbb734de"
            },
            "created_time": "2025-01-04T07:38:00.000Z",
            "last_edited_time": "2025-01-04T08:03:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Cấu trúc tên & ý nghĩa của nó",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Cấu trúc tên & ý nghĩa của nó",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 1
          }
        ]
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8080-a38d-dd6f2b998235",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T07:35:00.000Z",
        "last_edited_time": "2025-01-04T08:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "File locate:",
                "link": {
                  "url": "https://leemunroe.medium.com/how-we-organize-figma-projects-and-files-on-our-design-team-adc4a6109dce"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "File locate:",
              "href": "https://leemunroe.medium.com/how-we-organize-figma-projects-and-files-on-our-design-team-adc4a6109dce"
            },
            {
              "type": "text",
              "text": {
                "content": " khi cần tìm đến file, ta biết nó nằm ở đâu. Ví dụ: cần tìm lại version cũ của feature X thuộc product B; Dev cần xem file hand-off chỉnh chu các final spec, nhưng có khi designer lại muốn xem lại các option cũ…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " khi cần tìm đến file, ta biết nó nằm ở đâu. Ví dụ: cần tìm lại version cũ của feature X thuộc product B; Dev cần xem file hand-off chỉnh chu các final spec, nhưng có khi designer lại muốn xem lại các option cũ…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8011-b399-d822e3e6e108",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T08:24:00.000Z",
        "last_edited_time": "2025-01-05T03:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Figma page & object organization",
                "link": {
                  "url": "https://uxdesign.cc/how-to-build-trust-with-others-by-cleaning-your-figma-files-f283e72cb057"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Figma page & object organization",
              "href": "https://uxdesign.cc/how-to-build-trust-with-others-by-cleaning-your-figma-files-f283e72cb057"
            },
            {
              "type": "text",
              "text": {
                "content": ": quy ước cách sử dụng từng thành phần riêng trên file Figma, nên sắp xếp các screen ra sao, grouping thế nào, chia page với ngữ nghĩa nào…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": quy ước cách sử dụng từng thành phần riêng trên file Figma, nên sắp xếp các screen ra sao, grouping thế nào, chia page với ngữ nghĩa nào…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8010-a735-fba8b4b920cb",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T07:52:00.000Z",
        "last_edited_time": "2025-01-04T07:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-80f0-aa35-f5c2669cf742",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-03T14:29:00.000Z",
        "last_edited_time": "2025-01-04T06:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Library & Design system",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Library & Design system",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8075-8078-f8fe347ad107",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T08:20:00.000Z",
        "last_edited_time": "2025-01-05T03:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081565/uxcomic-imgs/1715d164-78d8-8075-8078-f8fe347ad107.webp",
            "expiry_time": "2026-10-04T09:12:28.347Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1715d164-78d8-8075-8078-f8fe347ad107"
      },
      {
        "object": "block",
        "id": "1705d164-78d8-80a4-afa2-c6fb9aeac33b",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-03T14:29:00.000Z",
        "last_edited_time": "2025-08-16T06:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Súng đạn của team design theo mình có thể tách làm vài dạng:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Súng đạn của team design theo mình có thể tách làm vài dạng:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80f6-9e3b-c31430a99bf5",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T07:29:00.000Z",
        "last_edited_time": "2025-08-16T06:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "[Design system] - Đạn - Các component cơ bản như là: design token, variables, button, text field, checkbox, snack bar…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "[Design system] - Đạn - Các component cơ bản như là: design token, variables, button, text field, checkbox, snack bar…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80f1-a8b4-ef44ed00a0ab",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T07:30:00.000Z",
        "last_edited_time": "2025-01-04T08:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "[Library] - Súng - Các component dưới dạng UI kit, ở level là object hoặc screen, ví dụ: header, product card, welcome screen, empty state,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "[Library] - Súng - Các component dưới dạng UI kit, ở level là object hoặc screen, ví dụ: header, product card, welcome screen, empty state,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "2515d164-78d8-80b2-b0da-c2cca2eadf2d",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-08-16T06:19:00.000Z",
        "last_edited_time": "2025-08-16T06:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "[Guideline library] - Kĩ thuật - Các nguyên lý, hướng dẫn sử dụng Interaction pattern, UI pattern, UX pattern,… chân kinh này giúp team luyện võ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "[Guideline library] - Kĩ thuật - Các nguyên lý, hướng dẫn sử dụng Interaction pattern, UI pattern, UX pattern,… chân kinh này giúp team luyện võ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "2515d164-78d8-80d2-95b2-dacc6c779bba",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-08-16T06:23:00.000Z",
        "last_edited_time": "2025-08-16T06:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "[Research or Report library] - Đối tượng - Có thể là các nghiên cứu đối tượng người dùng, đối thủ cạnh tranh, bức tranh thị trường, report các outcome dự án quá khứ, decision log… ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "[Research or Report library] - Đối tượng - Có thể là các nghiên cứu đối tượng người dùng, đối thủ cạnh tranh, bức tranh thị trường, report các outcome dự án quá khứ, decision log… ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 3
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8071-978f-fdc518796d40",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T07:52:00.000Z",
        "last_edited_time": "2025-01-04T07:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-809f-8fa5-c5099f2c01e4",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T06:41:00.000Z",
        "last_edited_time": "2025-01-04T06:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Document",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Document",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8035-a12c-d31d34369c5b",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T08:15:00.000Z",
        "last_edited_time": "2025-01-04T08:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081567/uxcomic-imgs/1715d164-78d8-8035-a12c-d31d34369c5b.png",
            "expiry_time": "2026-10-04T09:12:28.347Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1715d164-78d8-8035-a12c-d31d34369c5b"
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80e4-a3c2-f9acbfe6e5c8",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T07:39:00.000Z",
        "last_edited_time": "2025-01-05T03:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong công việc, chắc chắn sẽ còn nhiều asset cần quản lý ngoài design asset, có thể là knowledge, sharing, guideline, planning, research & finding, tool subscription fee, UX debt…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong công việc, chắc chắn sẽ còn nhiều asset cần quản lý ngoài design asset, có thể là knowledge, sharing, guideline, planning, research & finding, tool subscription fee, UX debt…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8064-a573-d78f48cccbed",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T07:53:00.000Z",
        "last_edited_time": "2025-01-04T08:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ngoài ra note trong file Figma cũng nên trở thành 1 thói quen, các note có thể về những phân tích trong quá trình problem solving, các design decision qua từng vòng review, các cơ chế hoạt động của feature, version control, change log,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ngoài ra note trong file Figma cũng nên trở thành 1 thói quen, các note có thể về những phân tích trong quá trình problem solving, các design decision qua từng vòng review, các cơ chế hoạt động của feature, version control, change log,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80c0-9c28-f9a9d59b8662",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T07:52:00.000Z",
        "last_edited_time": "2025-01-04T07:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80f8-a6a4-d1bee3af1ce9",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T07:39:00.000Z",
        "last_edited_time": "2025-01-04T07:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Task management tool",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Task management tool",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80e8-b5cd-c3b358ac93c0",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T08:21:00.000Z",
        "last_edited_time": "2025-01-05T03:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081569/uxcomic-imgs/1715d164-78d8-80e8-b5cd-c3b358ac93c0.webp",
            "expiry_time": "2026-10-04T09:12:28.417Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1715d164-78d8-80e8-b5cd-c3b358ac93c0"
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8095-a968-d4722c5331f8",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T07:40:00.000Z",
        "last_edited_time": "2025-08-16T06:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phần này thiên về quản lý task, phương pháp thì nhiều tuỳ mọi người lựa chọn, có thể đơn giản là kanban board, hoặc advance hơn dùng notion hoặc jira, airtable… Này sẽ tuỳ thuộc vào công ty & team, cần định hình xem ai cần involve vào, mục đích & thói quen sử dụng >> quyết định xem tool cái nào thì phù hợp.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phần này thiên về quản lý task, phương pháp thì nhiều tuỳ mọi người lựa chọn, có thể đơn giản là kanban board, hoặc advance hơn dùng notion hoặc jira, airtable… Này sẽ tuỳ thuộc vào công ty & team, cần định hình xem ai cần involve vào, mục đích & thói quen sử dụng >> quyết định xem tool cái nào thì phù hợp.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80ba-9a0d-d1c31828b283",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T07:46:00.000Z",
        "last_edited_time": "2025-08-16T06:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuy nhiên mình thấy nó cần đảm bảo 3 khía cạnh:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuy nhiên mình thấy nó cần đảm bảo 3 khía cạnh:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8088-9c19-ebf45e7ced79",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T07:46:00.000Z",
        "last_edited_time": "2025-01-05T03:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tracking được tiến độ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tracking được tiến độ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-802a-8d1d-f0a5eeadb366",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T07:47:00.000Z",
        "last_edited_time": "2025-01-04T07:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khả năng liên kết link giữa các task (vì trong một product có nhiều project, project có thể gồm nhiều task, sub-task,…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khả năng liên kết link giữa các task (vì trong một product có nhiều project, project có thể gồm nhiều task, sub-task,…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-800f-aef7-e4c9284492a4",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-04T07:48:00.000Z",
        "last_edited_time": "2025-01-05T03:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thống kê, ví dụ như: số lượng task theo quý, thời gian thực thi trung bình, khối lượng workload hiện tại,… Có được các thông tin này sẽ giúp mình có cơ sở đánh giá & cải thiện quy trình một cách khách quan hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thống kê, ví dụ như: số lượng task theo quý, thời gian thực thi trung bình, khối lượng workload hiện tại,… Có được các thông tin này sẽ giúp mình có cơ sở đánh giá & cải thiện quy trình một cách khách quan hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-81e0-8dde-e2e906bf569c",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-03T14:28:00.000Z",
        "last_edited_time": "2025-01-03T14:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-8162-bdb0-d5148e8eda49",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-03T14:28:00.000Z",
        "last_edited_time": "2025-01-03T14:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-815d-8fc8-da7dabaaa921",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8075-923f-fbb228f43ae9"
        },
        "created_time": "2025-01-03T14:28:00.000Z",
        "last_edited_time": "2025-01-04T06:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "12c5d164-78d8-80b5-82fb-dc48f1f4d4f8"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Non-design work",
              "href": "https://app.notion.com/p/12c5d16478d880b582fbdc48f1f4d4f8"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1705d164-78d8-8087-8fcc-e832cb1f677b",
    "created_time": "2025-01-03T14:20:00.000Z",
    "last_edited_time": "2025-01-05T17:41:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "3-Build",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2025-01-05T17:41:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": "}QTb",
          "name": "⚔️:2",
          "color": "gray"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 35
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2025-01-03T14:20:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Engineer friendly",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Engineer friendly",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Engineer-friendly-1705d16478d880878fcce832cb1f677b",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
      "name": "Build",
      "slug": "build",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "1705d164-78d8-81b6-ba40-d17d8d90bed4",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-03T14:20:00.000Z",
        "last_edited_time": "2025-01-04T05:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081573/uxcomic-imgs/1705d164-78d8-81b6-ba40-d17d8d90bed4.png",
            "expiry_time": "2026-10-04T09:12:29.882Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1705d164-78d8-81b6-ba40-d17d8d90bed4"
      },
      {
        "object": "block",
        "id": "1705d164-78d8-8110-911c-edc831d66466",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-03T14:20:00.000Z",
        "last_edited_time": "2025-01-04T02:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Làm trong nghề UX/UI ta nói rất nhiều đến user-friendly, nhưng mình có lãng quên very first user xem design của bạn là các stakeholder không, nếu bạn làm việc với business sẽ là cách bạn trình bày problem solving, design proposal, còn phía dev sẽ là file hand-off & design spec.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Làm trong nghề UX/UI ta nói rất nhiều đến user-friendly, nhưng mình có lãng quên very first user xem design của bạn là các stakeholder không, nếu bạn làm việc với business sẽ là cách bạn trình bày problem solving, design proposal, còn phía dev sẽ là file hand-off & design spec.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8021-843a-ec77fc8216c8",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T03:51:00.000Z",
        "last_edited_time": "2025-01-04T03:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "\"Engineer-friendly\" trong design là một khái niệm đề cập đến việc thiết kế giao diện và sản phẩm theo cách giúp đội ngũ kỹ sư (developers) dễ dàng hiểu, triển khai, và phát triển sản phẩm. Một thiết kế được coi là engineer-friendly khi nó giảm thiểu sự mơ hồ, tối ưu quy trình làm việc giữa designer và developer, và đảm bảo rằng các giải pháp thiết kế có thể được thực thi hiệu quả về mặt kỹ thuật.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "\"Engineer-friendly\" trong design là một khái niệm đề cập đến việc thiết kế giao diện và sản phẩm theo cách giúp đội ngũ kỹ sư (developers) dễ dàng hiểu, triển khai, và phát triển sản phẩm. Một thiết kế được coi là engineer-friendly khi nó giảm thiểu sự mơ hồ, tối ưu quy trình làm việc giữa designer và developer, và đảm bảo rằng các giải pháp thiết kế có thể được thực thi hiệu quả về mặt kỹ thuật.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80cc-812c-c4891e89dad4",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T12:11:00.000Z",
        "last_edited_time": "2025-01-04T12:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081574/uxcomic-imgs/1715d164-78d8-80cc-812c-c4891e89dad4.png",
            "expiry_time": "2026-10-04T09:12:29.882Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1715d164-78d8-80cc-812c-c4891e89dad4"
      },
      {
        "object": "block",
        "id": "1715d164-78d8-801d-9dc3-df70d0cb51b2",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T10:36:00.000Z",
        "last_edited_time": "2025-01-04T10:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy cụ thể design để engineer friendly là gì?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy cụ thể design để engineer friendly là gì?",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "🤨"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8063-8f31-f8caf64734a5",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T02:55:00.000Z",
        "last_edited_time": "2025-01-04T02:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-81ef-b809-d93633601ceb",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-03T14:20:00.000Z",
        "last_edited_time": "2025-01-03T14:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "UI vs Box model",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UI vs Box model",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-8114-8bee-f204d82b1a03",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-03T14:20:00.000Z",
        "last_edited_time": "2025-01-04T03:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi thiết kế UI chia các thành phần theo từng block một, sử dụng auto layout như cách thức box model đã khiến dev đỡ mệt mỏi phần nào rồi đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi thiết kế UI chia các thành phần theo từng block một, sử dụng auto layout như cách thức box model đã khiến dev đỡ mệt mỏi phần nào rồi đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80cf-bf81-e7deb612c409",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T03:56:00.000Z",
        "last_edited_time": "2025-01-04T03:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081576/uxcomic-imgs/1715d164-78d8-80cf-bf81-e7deb612c409.png",
            "expiry_time": "2026-10-04T09:12:29.882Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1715d164-78d8-80cf-bf81-e7deb612c409"
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80f2-8dc3-def0c91c4393",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T04:05:00.000Z",
        "last_edited_time": "2025-01-04T04:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-80c0-9c39-e17773fc69b2",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-03T14:37:00.000Z",
        "last_edited_time": "2025-01-03T14:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Document Flows & Logic",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Document Flows & Logic",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8029-ad1f-e33fef36e92d",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T03:57:00.000Z",
        "last_edited_time": "2025-01-04T04:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chắc bạn sẽ quen thuộc với user flow, screen flow khi design UX/UI, nó là một phần trong việc bạn transfer lại logic sử dụng cho dev hình dung, ngoài ra nếu tìm hiểu sâu hơn, mình sẽ có use case để mô tả kĩ hơn như Preconditions, Postconditions, Workflow… (còn muốn nhức nhói hơn nữa, mò thử ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chắc bạn sẽ quen thuộc với user flow, screen flow khi design UX/UI, nó là một phần trong việc bạn transfer lại logic sử dụng cho dev hình dung, ngoài ra nếu tìm hiểu sâu hơn, mình sẽ có use case để mô tả kĩ hơn như Preconditions, Postconditions, Workflow… (còn muốn nhức nhói hơn nữa, mò thử ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "UML qua bài này ",
                "link": {
                  "url": "https://200lab.io/blog/uml-la-gi-gioi-thieu-cac-loai-uml-hay-dung/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UML qua bài này ",
              "href": "https://200lab.io/blog/uml-la-gi-gioi-thieu-cac-loai-uml-hay-dung/"
            },
            {
              "type": "text",
              "text": {
                "content": "nhé)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "nhé)",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8092-b1df-f5ce89a20f60",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T04:04:00.000Z",
        "last_edited_time": "2025-01-04T04:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: có khi các edge case mình sẽ không thể cover hết, nếu ngay khi có wireframe bạn có thể gửi ngay cho dev để họ hình dung & giúp bạn aware sớm các edge case cũng như các constraints có thể xảy ra.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: có khi các edge case mình sẽ không thể cover hết, nếu ngay khi có wireframe bạn có thể gửi ngay cho dev để họ hình dung & giúp bạn aware sớm các edge case cũng như các constraints có thể xảy ra.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80e6-9f1a-fd5535adefa4",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T03:57:00.000Z",
        "last_edited_time": "2025-01-04T05:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081577/uxcomic-imgs/1715d164-78d8-80e6-9f1a-fd5535adefa4.png",
            "expiry_time": "2026-10-04T09:12:29.882Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1715d164-78d8-80e6-9f1a-fd5535adefa4"
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8011-a8ac-e6b6d79c01fe",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T04:02:00.000Z",
        "last_edited_time": "2025-01-04T04:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ngoài ra mình còn cần lưu ý note thêm các rule hiển thị / interaction như min-max width, motion, min-max characters / lines, auto dismiss, time out,… Càng rõ ràng càng tốt, không thì phía dev phải đoán già đoán non & dẫn đến bản build khác xa với design expectation.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ngoài ra mình còn cần lưu ý note thêm các rule hiển thị / interaction như min-max width, motion, min-max characters / lines, auto dismiss, time out,… Càng rõ ràng càng tốt, không thì phía dev phải đoán già đoán non & dẫn đến bản build khác xa với design expectation.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8080-b802-c2c0ca949b06",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T04:05:00.000Z",
        "last_edited_time": "2025-01-04T04:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-8011-a083-d86171c399ad",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-03T14:38:00.000Z",
        "last_edited_time": "2025-01-03T14:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Design with Real data",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Design with Real data",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8025-aa77-ee8b8eab84d4",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T04:06:00.000Z",
        "last_edited_time": "2025-01-04T04:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình đã từng gặp qua vài trường hợp, nghĩ là nên có thông tin này, thông tin kia nhưng khi bàn giao cho dev, thì gặp phải tình huống phía database đang không hề có dữ liệu đó hoặc để có dữ liệu đó cần phải tốn effort chạy thêm sẽ ảnh hưởng đến app performance… Nên keep in mind, từng dòng chữ, từng hình, từng status, nếu mình không sure đều nên check với dev sớm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình đã từng gặp qua vài trường hợp, nghĩ là nên có thông tin này, thông tin kia nhưng khi bàn giao cho dev, thì gặp phải tình huống phía database đang không hề có dữ liệu đó hoặc để có dữ liệu đó cần phải tốn effort chạy thêm sẽ ảnh hưởng đến app performance… Nên keep in mind, từng dòng chữ, từng hình, từng status, nếu mình không sure đều nên check với dev sớm.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-807d-8359-d3d20b10b48f",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T04:31:00.000Z",
        "last_edited_time": "2025-01-04T04:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081579/uxcomic-imgs/1715d164-78d8-807d-8359-d3d20b10b48f.png",
            "expiry_time": "2026-10-04T09:12:29.883Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1715d164-78d8-807d-8359-d3d20b10b48f"
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8092-9a7c-cbcc6726a13a",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T04:11:00.000Z",
        "last_edited_time": "2025-01-04T10:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mặt khác phải luôn hình dung trong đầu các tình huống thực tế liên quan đến data, ví dụ: nếu không có dữ liệu thì sẽ hiển thị ra sao, nếu không lấy được data từ sever thì sao, nếu text quá dài hay hình không phù hợp thì xử lý hiển thị ra sao,…?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mặt khác phải luôn hình dung trong đầu các tình huống thực tế liên quan đến data, ví dụ: nếu không có dữ liệu thì sẽ hiển thị ra sao, nếu không lấy được data từ sever thì sao, nếu text quá dài hay hình không phù hợp thì xử lý hiển thị ra sao,…?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8091-bc88-dd4015e90744",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T04:17:00.000Z",
        "last_edited_time": "2025-01-04T04:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tips: learn python, SQL, Notion database 😃",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tips: learn python, SQL, Notion database 😃",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-803b-88d0-f617b9967e06",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-03T14:38:00.000Z",
        "last_edited_time": "2025-01-04T04:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-817f-b3ac-f0f58ee966b4",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-03T14:20:00.000Z",
        "last_edited_time": "2025-01-03T14:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Naming convention",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Naming convention",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-812f-9bf0-cde16a848ebb",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-03T14:20:00.000Z",
        "last_edited_time": "2025-01-04T04:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chắc ai cũng như mình, khá là ngán ngẫm phải đi đặt tên cho từng layer 😐. Nhưng nếu bạn đã trải qua cảm giác đi xem một file design cũ của ai đó hand over lại, bạn sẽ hiểu được tầm quan trọng của việc đặt tên HOẶC khi bạn build design system thì mới thấy tính cần thiết của nó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chắc ai cũng như mình, khá là ngán ngẫm phải đi đặt tên cho từng layer 😐. Nhưng nếu bạn đã trải qua cảm giác đi xem một file design cũ của ai đó hand over lại, bạn sẽ hiểu được tầm quan trọng của việc đặt tên HOẶC khi bạn build design system thì mới thấy tính cần thiết của nó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8076-b738-d7b0ad975d14",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T10:19:00.000Z",
        "last_edited_time": "2025-01-04T10:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [
            {
              "type": "text",
              "text": {
                "content": "https://medium.com/design-bootcamp/flexing-figma-component-structure-properties-like-a-pro-4ded91b03a7e",
                "link": {
                  "url": "https://medium.com/design-bootcamp/flexing-figma-component-structure-properties-like-a-pro-4ded91b03a7e"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://medium.com/design-bootcamp/flexing-figma-component-structure-properties-like-a-pro-4ded91b03a7e",
              "href": "https://medium.com/design-bootcamp/flexing-figma-component-structure-properties-like-a-pro-4ded91b03a7e"
            }
          ],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081580/uxcomic-imgs/1715d164-78d8-8076-b738-d7b0ad975d14.png",
            "expiry_time": "2026-10-04T09:12:29.883Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1715d164-78d8-8076-b738-d7b0ad975d14"
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80cc-9cd4-efead91e41f4",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T04:48:00.000Z",
        "last_edited_time": "2025-01-04T04:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nói riêng việc naming này chắc dong dài lắm, nên mình share vài hint để bạn explore thêm nếu thấy cần nhé:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nói riêng việc naming này chắc dong dài lắm, nên mình share vài hint để bạn explore thêm nếu thấy cần nhé:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-806e-8175-ec0425ceab63",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T04:54:00.000Z",
        "last_edited_time": "2025-01-04T04:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "File organization",
                "link": {
                  "url": "https://leemunroe.medium.com/how-we-organize-figma-projects-and-files-on-our-design-team-adc4a6109dce"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "File organization",
              "href": "https://leemunroe.medium.com/how-we-organize-figma-projects-and-files-on-our-design-team-adc4a6109dce"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8011-9796-e5f6e9d78bc0",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T05:00:00.000Z",
        "last_edited_time": "2025-01-04T05:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Component naming",
                "link": {
                  "url": "https://medium.com/design-bootcamp/figma-component-naming-conventions-ce53e53c7d39"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Component naming",
              "href": "https://medium.com/design-bootcamp/figma-component-naming-conventions-ce53e53c7d39"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80be-a902-e1ed57a41dc7",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T04:50:00.000Z",
        "last_edited_time": "2025-01-04T04:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Design token naming",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Design token naming",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80bf-a12a-dff2f3d55c2e",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T04:48:00.000Z",
        "last_edited_time": "2025-01-04T04:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Base trên ngôn ngữ HTML, đặt tên theo function của item đó (header, sidebar, container, section,…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Base trên ngôn ngữ HTML, đặt tên theo function của item đó (header, sidebar, container, section,…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-801a-a2b4-f043c6bcd708",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T04:51:00.000Z",
        "last_edited_time": "2025-01-04T04:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Base trên loại content, ví dụ: profile-photo, background-image, headline, title,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Base trên loại content, ví dụ: profile-photo, background-image, headline, title,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80ea-9c10-cd1fb15705e3",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T05:34:00.000Z",
        "last_edited_time": "2025-01-04T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-8001-a9be-d452b79310ee",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-03T14:35:00.000Z",
        "last_edited_time": "2025-01-03T14:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Consistent vs Component",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Consistent vs Component",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-80dd-aeae-c6507cd76530",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-03T14:35:00.000Z",
        "last_edited_time": "2025-01-04T05:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phía dev luôn muốn tối ưu tái sử dụng nhiều nhất có thể, và phía design mình cũng có concept giống vậy, đó là design system.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phía dev luôn muốn tối ưu tái sử dụng nhiều nhất có thể, và phía design mình cũng có concept giống vậy, đó là design system.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8009-acf7-edc656322389",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T05:35:00.000Z",
        "last_edited_time": "2025-01-04T05:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Design system không những giúp tiết kiệm thời gian để build mà còn giúp thiết kế có tính consistent, một tính chất rất quan trọng trong UX. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Design system không những giúp tiết kiệm thời gian để build mà còn giúp thiết kế có tính consistent, một tính chất rất quan trọng trong UX. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8082-b996-c78763d3de3b",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T05:36:00.000Z",
        "last_edited_time": "2025-01-04T05:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "So cố gắng suy nghĩ UI của bạn as a system, tái sử dụng nhiều nhất có thể.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "So cố gắng suy nghĩ UI của bạn as a system, tái sử dụng nhiều nhất có thể.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8076-8529-cb2f2a321942",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T05:37:00.000Z",
        "last_edited_time": "2025-01-04T05:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-80e0-bc43-c33863f4316d",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-03T14:36:00.000Z",
        "last_edited_time": "2025-01-04T02:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Framework, OS friendly",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Framework, OS friendly",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80fa-949d-e04832c6ea44",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T05:37:00.000Z",
        "last_edited_time": "2025-01-04T05:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhiều khi mình tham khảo các reference hoặc các app khác, mình sẽ tìm được đâu đó các idea để muốn apply vào design của mình, có thể là animation, là một interaction hoặc một function nào đó, nhưng khi đem ra hỏi dev thì bảo frameworks mình không support, cần time để mò thêm…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhiều khi mình tham khảo các reference hoặc các app khác, mình sẽ tìm được đâu đó các idea để muốn apply vào design của mình, có thể là animation, là một interaction hoặc một function nào đó, nhưng khi đem ra hỏi dev thì bảo frameworks mình không support, cần time để mò thêm…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80ae-a22a-f05222f9a8c0",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T05:40:00.000Z",
        "last_edited_time": "2025-01-04T05:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nên để tiết kiệm thời gian cho đôi bên, mình cần trước tiên hiểu họ đang build trên framework nào & tìm reference cho phù hợp.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nên để tiết kiệm thời gian cho đôi bên, mình cần trước tiên hiểu họ đang build trên framework nào & tìm reference cho phù hợp.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8045-9e24-eadffbbb94f9",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T05:42:00.000Z",
        "last_edited_time": "2025-01-04T05:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: Tailwind CSS, Bootstrap, React, Next JS, Swift,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: Tailwind CSS, Bootstrap, React, Next JS, Swift,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-8068-a356-f5f17289d4e9",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-03T14:38:00.000Z",
        "last_edited_time": "2025-01-04T05:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-80d5-ab15-e18003620928",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-03T14:36:00.000Z",
        "last_edited_time": "2025-01-03T14:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Deliver asset",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Deliver asset",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-804f-ae79-ea36e25f59a0",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T05:54:00.000Z",
        "last_edited_time": "2025-01-04T05:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Về asset, bạn có thể hỏi dev cung cấp cho bạn để xuất cho phù hợp, hoặc khoẻ hơn thì hướng dẫn họ cách export trên Figma.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Về asset, bạn có thể hỏi dev cung cấp cho bạn để xuất cho phù hợp, hoặc khoẻ hơn thì hướng dẫn họ cách export trên Figma.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-809e-a99c-ca0fa0156fd9",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T05:54:00.000Z",
        "last_edited_time": "2025-01-04T05:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình có thể lưu ý cài điểm sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình có thể lưu ý cài điểm sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-809c-924b-d73dc4a3c8cc",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-03T14:35:00.000Z",
        "last_edited_time": "2025-01-05T17:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Again, naming, hệ thống cách đặt tên sao cho rõ ràng, đồng bộ, dễ tìm lại.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Again, naming, hệ thống cách đặt tên sao cho rõ ràng, đồng bộ, dễ tìm lại.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8020-8c05-ce5883db5517",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T05:48:00.000Z",
        "last_edited_time": "2025-01-05T17:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "File format",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "File format",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "1715d164-78d8-8092-b1a8-dce15a856113",
            "parent": {
              "type": "block_id",
              "block_id": "1715d164-78d8-8020-8c05-ce5883db5517"
            },
            "created_time": "2025-01-04T05:53:00.000Z",
            "last_edited_time": "2025-01-05T17:41:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "SVG: Đối với icon hoặc hình ảnh vector.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "SVG: Đối với icon hoặc hình ảnh vector.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1715d164-78d8-8053-8cc6-ff2c5a748c45",
            "parent": {
              "type": "block_id",
              "block_id": "1715d164-78d8-8020-8c05-ce5883db5517"
            },
            "created_time": "2025-01-04T05:53:00.000Z",
            "last_edited_time": "2025-01-05T17:41:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "PNG/WebP: Đối với hình ảnh bitmap (kích thước nhỏ gọn hơn JPG).",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "PNG/WebP: Đối với hình ảnh bitmap (kích thước nhỏ gọn hơn JPG).",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "1715d164-78d8-8052-b1c4-c35c17c49006",
            "parent": {
              "type": "block_id",
              "block_id": "1715d164-78d8-8020-8c05-ce5883db5517"
            },
            "created_time": "2025-01-04T05:53:00.000Z",
            "last_edited_time": "2025-01-05T17:41:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "PDF: Cho các tài liệu in ấn hoặc vector phức tạp.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "PDF: Cho các tài liệu in ấn hoặc vector phức tạp.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8066-8203-cff3fe876893",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T05:53:00.000Z",
        "last_edited_time": "2025-01-05T17:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Export với độ phân giải phù hợp: Nếu thiết kế cho nhiều màn hình (retina, desktop, mobile), export asset ở các tỷ lệ khác nhau: 1x, 2x, 3x.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Export với độ phân giải phù hợp: Nếu thiết kế cho nhiều màn hình (retina, desktop, mobile), export asset ở các tỷ lệ khác nhau: 1x, 2x, 3x.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8071-a9b5-ced6f5926bac",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T05:55:00.000Z",
        "last_edited_time": "2025-01-05T17:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cắt đúng kích thước: Đảm bảo hình ảnh và icon không có padding thừa hoặc bị crop sai.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cắt đúng kích thước: Đảm bảo hình ảnh và icon không có padding thừa hoặc bị crop sai.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80d1-812e-d4aaaecf11fb",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T10:16:00.000Z",
        "last_edited_time": "2025-01-04T10:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-808f-bdbe-e9a9c287c348",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T10:16:00.000Z",
        "last_edited_time": "2025-01-04T10:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80ba-83d3-eb5c82c42272",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T10:16:00.000Z",
        "last_edited_time": "2025-01-04T10:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1705d164-78d8-8075-923f-fbb228f43ae9"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Design Ops",
              "href": "https://app.notion.com/p/1705d16478d88075923ffbb228f43ae9"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8060-8890-cb2773f258e2",
        "parent": {
          "type": "page_id",
          "page_id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
        },
        "created_time": "2025-01-04T05:48:00.000Z",
        "last_edited_time": "2025-01-04T05:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "bb2954d0-2081-4702-a748-8c22aee6689b",
    "created_time": "2024-12-28T07:21:00.000Z",
    "last_edited_time": "2025-08-31T05:16:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "3-Build",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-31T05:16:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": "cgmn",
          "name": "⚓:1",
          "color": "orange"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 34
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2024-12-28T07:21:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Graphic Fundamental",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Graphic Fundamental",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Graphic-Fundamental-bb2954d020814702a7488c22aee6689b",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
      "name": "Build",
      "slug": "build",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "37518491-5860-4a83-89e5-90a964289baf",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2024-12-28T07:21:00.000Z",
        "last_edited_time": "2025-01-04T05:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081584/uxcomic-imgs/37518491-5860-4a83-89e5-90a964289baf.png",
            "expiry_time": "2026-10-04T09:12:34.129Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/37518491-5860-4a83-89e5-90a964289baf"
      },
      {
        "object": "block",
        "id": "98da3f72-3722-47da-a9f5-b3b260fc61e8",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2024-12-28T07:21:00.000Z",
        "last_edited_time": "2025-01-05T03:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước đó UI từng được gọi với cái tên GUI (graphic user interface). UI là giao diện để giao tiếp với user & khi dính đến phần nhìn thì sẽ cần nói đến graphic & visual, nên thấy có chữ graphic trong đó cũng khá đúng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước đó UI từng được gọi với cái tên GUI (graphic user interface). UI là giao diện để giao tiếp với user & khi dính đến phần nhìn thì sẽ cần nói đến graphic & visual, nên thấy có chữ graphic trong đó cũng khá đúng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8048-a054-d4ef59c7c7bf",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T01:28:00.000Z",
        "last_edited_time": "2025-01-05T03:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kiến thức graphic thì rất rộng (nó cũng là một nghề hẳn hoi mà), nên mình chỉ giới thiệu sơ các khái niệm mình nghĩ là quan trọng nhất cho công việc UI, mọi người có thể tham khảo để tìm hiểu thêm trên mạng nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kiến thức graphic thì rất rộng (nó cũng là một nghề hẳn hoi mà), nên mình chỉ giới thiệu sơ các khái niệm mình nghĩ là quan trọng nhất cho công việc UI, mọi người có thể tham khảo để tìm hiểu thêm trên mạng nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "f771d47f-3407-4eda-b2cf-081da9bc4ec0",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2024-12-28T07:21:00.000Z",
        "last_edited_time": "2024-12-28T07:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Design là nghệ thuật đặt để có chủ đích.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Design là nghệ thuật đặt để có chủ đích.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8028-be13-e6dbd842a89c",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:23:00.000Z",
        "last_edited_time": "2025-01-04T02:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "e2099c2e-79b5-45e9-bc07-f058fcdd246b",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2024-12-28T07:21:00.000Z",
        "last_edited_time": "2025-01-05T03:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Gestalt",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Gestalt",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "df801193-35bc-4e76-9c85-f5db0e4751dc",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2024-12-28T07:21:00.000Z",
        "last_edited_time": "2025-01-05T04:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Gestalt là một lý thuyết tâm lý học nhấn mạnh rằng con người ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Gestalt là một lý thuyết tâm lý học nhấn mạnh rằng con người ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "nhận thức",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "nhận thức",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " tổng thể trước khi nhận thức các phần riêng lẻ. Trong thiết kế, Gestalt được dùng để giải thích cách người dùng nhóm các yếu tố thị giác và tạo ra ý nghĩa từ chúng. Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " tổng thể trước khi nhận thức các phần riêng lẻ. Trong thiết kế, Gestalt được dùng để giải thích cách người dùng nhóm các yếu tố thị giác và tạo ra ý nghĩa từ chúng. Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-808f-9bc1-c32dc21fe01a",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:15:00.000Z",
        "last_edited_time": "2025-01-04T02:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Gần gũi",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Gần gũi",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (Proximity): Các yếu tố gần nhau thường được xem như một nhóm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (Proximity): Các yếu tố gần nhau thường được xem như một nhóm.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8032-8186-d29319419c0e",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:15:00.000Z",
        "last_edited_time": "2025-01-04T02:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tương đồng ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tương đồng ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "(Similarity): Các yếu tố giống nhau về hình dạng, màu sắc sẽ được liên kết với nhau.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "(Similarity): Các yếu tố giống nhau về hình dạng, màu sắc sẽ được liên kết với nhau.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-809d-97df-e5957a742dd6",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:15:00.000Z",
        "last_edited_time": "2025-01-04T02:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Liên tục",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Liên tục",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (Continuity): Mắt sẽ đi theo đường liên tục hoặc đường cong hơn là các đoạn rời rạc.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (Continuity): Mắt sẽ đi theo đường liên tục hoặc đường cong hơn là các đoạn rời rạc.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80fb-9eca-eba4b5e39373",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:15:00.000Z",
        "last_edited_time": "2025-01-04T02:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đóng kín",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đóng kín",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (Closure): Não tự điền vào các khoảng trống để nhận diện một hình dạng hoàn chỉnh. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (Closure): Não tự điền vào các khoảng trống để nhận diện một hình dạng hoàn chỉnh. ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80aa-9c69-ec15954075a4",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:15:00.000Z",
        "last_edited_time": "2025-01-04T02:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hình và nền",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hình và nền",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (Figure/Ground): Phân biệt yếu tố chính (figure) với nền (background).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (Figure/Ground): Phân biệt yếu tố chính (figure) với nền (background).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8086-8a1e-f43fb9ce8da8",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:51:00.000Z",
        "last_edited_time": "2025-01-04T02:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "7ff543b7-d96a-4397-875c-0a86b401dcad",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2024-12-28T07:21:00.000Z",
        "last_edited_time": "2025-01-03T14:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Visual weight",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Visual weight",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80cd-a630-d1e9ebc4344e",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:17:00.000Z",
        "last_edited_time": "2025-01-05T04:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Visual weight là mức độ mà một yếu tố trên giao diện hoặc thiết kế",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Visual weight là mức độ mà một yếu tố trên giao diện hoặc thiết kế",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " thu hút sự chú ý",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " thu hút sự chú ý",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " của người nhìn. Một thiết kế có Visual weight tốt sẽ giúp điều hướng ánh nhìn người dùng qua nội dung một cách mượt mà và theo ý đồ của thiết kế. Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " của người nhìn. Một thiết kế có Visual weight tốt sẽ giúp điều hướng ánh nhìn người dùng qua nội dung một cách mượt mà và theo ý đồ của thiết kế. Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8005-a9c5-c9eae8190af5",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:17:00.000Z",
        "last_edited_time": "2025-01-04T02:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kích thước",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kích thước",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (Size): Yếu tố lớn hơn thường có trọng lượng thị giác cao hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (Size): Yếu tố lớn hơn thường có trọng lượng thị giác cao hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8005-88f2-dbc4da5f60fb",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:17:00.000Z",
        "last_edited_time": "2025-01-04T02:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Màu sắc",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Màu sắc",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (Color): Màu sắc đậm, sáng, hoặc tương phản mạnh thu hút mắt hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (Color): Màu sắc đậm, sáng, hoặc tương phản mạnh thu hút mắt hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80bc-a21c-e5f2bee7c4ed",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:18:00.000Z",
        "last_edited_time": "2025-01-04T02:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Độ đậm nhạt",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Độ đậm nhạt",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (Contrast): Yếu tố tương phản với nền hoặc các yếu tố xung quanh sẽ nổi bật hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (Contrast): Yếu tố tương phản với nền hoặc các yếu tố xung quanh sẽ nổi bật hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-809b-9308-c82d3d67f708",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:18:00.000Z",
        "last_edited_time": "2025-01-04T02:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hình dạng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hình dạng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (Shape): Các hình dạng bất thường hoặc khác biệt có trọng lượng thị giác cao hơn so với các hình cơ bản.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (Shape): Các hình dạng bất thường hoặc khác biệt có trọng lượng thị giác cao hơn so với các hình cơ bản.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-809a-a785-f3d496afa19d",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:18:00.000Z",
        "last_edited_time": "2025-01-04T02:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vị trí",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vị trí",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (Position): Yếu tố nằm ở trung tâm hoặc khu vực “nóng” của thiết kế (như góc nhìn đầu tiên) sẽ có nhiều trọng lượng thị giác hơn. Hoặc độ xa gần, rõ mờ cũng được xem như vị trí trong không gian 3 chiều (z-index), nó cũng giúp quy hoạch sự chú ý của người xem.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (Position): Yếu tố nằm ở trung tâm hoặc khu vực “nóng” của thiết kế (như góc nhìn đầu tiên) sẽ có nhiều trọng lượng thị giác hơn. Hoặc độ xa gần, rõ mờ cũng được xem như vị trí trong không gian 3 chiều (z-index), nó cũng giúp quy hoạch sự chú ý của người xem.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8095-a759-dea0534eb43d",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:18:00.000Z",
        "last_edited_time": "2025-01-04T02:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chi tiết",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chi tiết",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (Detail): Yếu tố nhiều chi tiết phức tạp thường thu hút sự chú ý hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (Detail): Yếu tố nhiều chi tiết phức tạp thường thu hút sự chú ý hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80ea-b413-f2b3b37fa8a8",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:17:00.000Z",
        "last_edited_time": "2025-01-04T02:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-80a2-a5b1-c18f6ca7d524",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-03T14:15:00.000Z",
        "last_edited_time": "2025-01-05T04:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Balance & contrast",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Balance & contrast",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1725d164-78d8-80a9-8922-dbf21797e599",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-05T04:07:00.000Z",
        "last_edited_time": "2025-01-05T04:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hài hoà & tương phản là kim chỉ nam cho mọi thiết kế, nó như một bản nhạc với đầy đủ các nốt thăng trầm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hài hoà & tương phản là kim chỉ nam cho mọi thiết kế, nó như một bản nhạc với đầy đủ các nốt thăng trầm.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80e6-a7c3-d5e52d637119",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:22:00.000Z",
        "last_edited_time": "2025-01-04T02:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Balance là sự phân bổ đồng đều của các yếu tố thị giác trong một thiết kế để tạo cảm giác ổn định và hài hòa, dễ chịu cho người xem.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Balance là sự phân bổ đồng đều của các yếu tố thị giác trong một thiết kế để tạo cảm giác ổn định và hài hòa, dễ chịu cho người xem.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8036-b4ec-c9cd9aa46743",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:25:00.000Z",
        "last_edited_time": "2025-01-04T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Contrast là sự khác biệt rõ rệt giữa các yếu tố để làm nổi bật hoặc phân biệt chúng. Contrast làm nổi bật thông tin quan trọng, tạo cấu trúc thị giác, và hướng ánh nhìn của người dùng. Để nghiên cứu thêm bạn có thể search thêm về quy tắc 60-30-10.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Contrast là sự khác biệt rõ rệt giữa các yếu tố để làm nổi bật hoặc phân biệt chúng. Contrast làm nổi bật thông tin quan trọng, tạo cấu trúc thị giác, và hướng ánh nhìn của người dùng. Để nghiên cứu thêm bạn có thể search thêm về quy tắc 60-30-10.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8020-9ef8-c81ed56aabd7",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:34:00.000Z",
        "last_edited_time": "2025-01-04T02:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8014-9910-fad2b70e1879",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:34:00.000Z",
        "last_edited_time": "2025-01-04T02:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Rhythm ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Rhythm ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-806c-a25e-f7582e3df0df",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:35:00.000Z",
        "last_edited_time": "2025-01-04T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Rhythm trong thiết kế là sự lặp lại hoặc sắp xếp có tổ chức của các yếu tố thị giác để tạo ra sự chuyển động hoặc dòng chảy tự nhiên, hướng dẫn mắt người xem qua bố cục. Nó giúp thiết kế trở nên mạch lạc và thu hút hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Rhythm trong thiết kế là sự lặp lại hoặc sắp xếp có tổ chức của các yếu tố thị giác để tạo ra sự chuyển động hoặc dòng chảy tự nhiên, hướng dẫn mắt người xem qua bố cục. Nó giúp thiết kế trở nên mạch lạc và thu hút hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-801b-af3c-f4cbb8ea4be7",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:36:00.000Z",
        "last_edited_time": "2025-01-04T02:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Rhythm có thể đâu đó liên quan đến tính consistent, một đặc điểm rất quan trọng trong UI, consistency này tồn tại ở nhiều hình thức khác nhau: style guide, spacing, grid, size, radius,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Rhythm có thể đâu đó liên quan đến tính consistent, một đặc điểm rất quan trọng trong UI, consistency này tồn tại ở nhiều hình thức khác nhau: style guide, spacing, grid, size, radius,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-8058-9490-c4fd71641e1f",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-03T14:15:00.000Z",
        "last_edited_time": "2025-01-04T02:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1705d164-78d8-806e-840f-df58ced3cc65",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-03T14:16:00.000Z",
        "last_edited_time": "2025-01-03T14:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Color psychology",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Color psychology",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-800c-8a5b-efc41479b4df",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:28:00.000Z",
        "last_edited_time": "2025-01-04T02:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Color psychology là nghiên cứu về cách màu sắc ảnh hưởng đến cảm xúc, hành vi và nhận thức của con người. Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Color psychology là nghiên cứu về cách màu sắc ảnh hưởng đến cảm xúc, hành vi và nhận thức của con người. Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-801a-b59d-f0b38ce419f5",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:29:00.000Z",
        "last_edited_time": "2025-01-04T02:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hue",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hue",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (sắc độ): mỗi màu mang lại một cảm xúc & ý nghĩa riêng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (sắc độ): mỗi màu mang lại một cảm xúc & ý nghĩa riêng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8002-90fa-d4b9c3f6af11",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:41:00.000Z",
        "last_edited_time": "2025-01-04T02:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Saturation",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Saturation",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (độ bão hoà): độ tinh khiết của màu, từ xám xịt đến rực rỡ cũng mang lại năng lượng khác.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (độ bão hoà): độ tinh khiết của màu, từ xám xịt đến rực rỡ cũng mang lại năng lượng khác.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8084-afd1-ec9a6e925e58",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:42:00.000Z",
        "last_edited_time": "2025-01-04T02:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lightness",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lightness",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (độ sáng): tương tự sắc độ từ tối sang sáng cũng có trường năng lượng riêng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (độ sáng): tương tự sắc độ từ tối sang sáng cũng có trường năng lượng riêng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80b2-89c9-dac4aab5eeed",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:45:00.000Z",
        "last_edited_time": "2025-01-04T02:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ngoài ra mình có thể tìm hiểu thêm về các cách phối màu như: phối màu đơn sắc, tương tự, bổ sung, tam giác, tứ giác và trung tính. Mỗi cách phối mang lại cảm giác khác nhau: từ hài hòa, cân bằng (như phối màu tương tự) đến tương phản mạnh mẽ, nổi bật (như phối màu bổ sung).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ngoài ra mình có thể tìm hiểu thêm về các cách phối màu như: phối màu đơn sắc, tương tự, bổ sung, tam giác, tứ giác và trung tính. Mỗi cách phối mang lại cảm giác khác nhau: từ hài hòa, cân bằng (như phối màu tương tự) đến tương phản mạnh mẽ, nổi bật (như phối màu bổ sung).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80b3-9f0c-fd006ec7100d",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:38:00.000Z",
        "last_edited_time": "2025-01-04T02:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8076-ad1e-ea589739c04f",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:38:00.000Z",
        "last_edited_time": "2025-01-04T02:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Typography",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Typography",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80b3-b29e-c20adb1cc3d0",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:39:00.000Z",
        "last_edited_time": "2025-01-04T02:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Typography",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Typography",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " trong thiết kế là nghệ thuật và kỹ thuật sắp xếp chữ viết để truyền tải thông điệp một cách hiệu quả, thẩm mỹ và dễ đọc. Gồm các thành phần chính:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " trong thiết kế là nghệ thuật và kỹ thuật sắp xếp chữ viết để truyền tải thông điệp một cách hiệu quả, thẩm mỹ và dễ đọc. Gồm các thành phần chính:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80c0-abf6-c07bc6997a2c",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:39:00.000Z",
        "last_edited_time": "2025-01-04T02:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Font/Typeface:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Font/Typeface:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Kiểu chữ (Serif, Sans-serif, Script, Display).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Kiểu chữ (Serif, Sans-serif, Script, Display).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80d9-9ff0-c2d90e4ff648",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:39:00.000Z",
        "last_edited_time": "2025-01-04T02:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Size:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Size:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Kích thước chữ để tạo hierarchy.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Kích thước chữ để tạo hierarchy.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8097-b70c-eace64d03958",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:39:00.000Z",
        "last_edited_time": "2025-01-04T02:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Weight:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Weight:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Độ đậm nhạt (Regular, Bold, Light).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Độ đậm nhạt (Regular, Bold, Light).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80bf-b51e-e922540ea892",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:39:00.000Z",
        "last_edited_time": "2025-01-04T02:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Spacing:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Spacing:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Khoảng cách giữa chữ (Kerning), dòng (Leading), và từ (Tracking).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Khoảng cách giữa chữ (Kerning), dòng (Leading), và từ (Tracking).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-80fb-8637-db4ae3396186",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:47:00.000Z",
        "last_edited_time": "2025-01-04T02:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ngoài ra mình cũng có thể tìm hiểu về cụm từ font pairing để biết các cách phối chữ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ngoài ra mình cũng có thể tìm hiểu về cụm từ font pairing để biết các cách phối chữ.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "75667c90-a967-44b0-b9a9-02f3281cc786",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2024-12-28T07:21:00.000Z",
        "last_edited_time": "2024-12-28T07:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "70bfb9a4-8d7c-4eb4-be05-24cc53e714a7",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2024-12-28T07:21:00.000Z",
        "last_edited_time": "2024-12-28T07:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2605d164-78d8-80ef-9abb-ca31060668d0",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-08-31T05:16:00.000Z",
        "last_edited_time": "2025-08-31T05:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "2605d164-78d8-800a-87d2-ca72aa76dbb9"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UI checklist ",
              "href": "https://app.notion.com/p/2605d16478d8800a87d2ca72aa76dbb9"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8028-b867-deb8f226a3c6",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:51:00.000Z",
        "last_edited_time": "2025-01-04T02:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1705d164-78d8-8087-8fcc-e832cb1f677b"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Engineer friendly",
              "href": "https://app.notion.com/p/1705d16478d880878fcce832cb1f677b"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1715d164-78d8-8084-a86a-f2e3c3653702",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2025-01-04T02:51:00.000Z",
        "last_edited_time": "2025-01-04T02:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Interaction Pattern",
              "href": "https://app.notion.com/p/56798be37f484cfea30e49cc2dedd33d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "c0417066-24be-4b5d-86fb-aa599017c901",
        "parent": {
          "type": "page_id",
          "page_id": "bb2954d0-2081-4702-a748-8c22aee6689b"
        },
        "created_time": "2024-12-28T07:21:00.000Z",
        "last_edited_time": "2025-01-04T02:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "140a6f9c-8b40-41a9-bbaf-28c279a87dff"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Essential Design Principles ",
              "href": "https://app.notion.com/p/140a6f9c8b4041a9bbaf28c279a87dff"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09",
    "created_time": "2024-12-16T05:34:00.000Z",
    "last_edited_time": "2025-01-21T02:34:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "2-Think",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2025-01-21T02:34:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": "ByM|",
          "name": "♟️:2",
          "color": "pink"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 33
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2024-12-16T05:34:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Ideate (P2)",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Ideate (P2)",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Ideate-P2-15e5d16478d880c8ac9eff1a29784a09",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
      "name": "Think",
      "slug": "think",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "25c39924-73f3-42bb-aec5-10fabe77bcbe",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-16T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081586/uxcomic-imgs/25c39924-73f3-42bb-aec5-10fabe77bcbe.png",
            "expiry_time": "2026-10-04T09:12:34.966Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/25c39924-73f3-42bb-aec5-10fabe77bcbe"
      },
      {
        "object": "block",
        "id": "989251ff-5bef-455b-9ca7-40ec090c63e1",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-16T05:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Qua ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Qua ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "phần một",
                "link": {
                  "url": "/1585d16478d880c3b602e97f38fd7948"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "phần một",
              "href": "/1585d16478d880c3b602e97f38fd7948"
            },
            {
              "type": "text",
              "text": {
                "content": " chúng ta đã biết cách để cho ra nhiều idea nhất có thể, vậy bước tiếp theo là làm sao để chọn ra idea để triển khai. Và làm thế nào để rèn luyện tính sáng tạo.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " chúng ta đã biết cách để cho ra nhiều idea nhất có thể, vậy bước tiếp theo là làm sao để chọn ra idea để triển khai. Và làm thế nào để rèn luyện tính sáng tạo.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "9c714d91-fafe-4fe8-8fc8-0b033905a9f3",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-16T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "02bbee49-c35b-47a2-8e74-85bee21ff2b8",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-16T05:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lựa chọn",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lựa chọn",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "f97b6a0b-811d-4cb1-8fcd-5b9dc1988919",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-23T02:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau khi có một bể idea rồi, sẽ thành công cốc nếu sau cùng bạn/ nhóm chọn một idea tệ. Tất nhiên là việc chọn không phải lúc nào cũng đúng nhưng hãy có theo cách lí trí nhất có thể, vì khi rõ ràng bạn mới có cơ sở kiểm chứng & học hỏi từ nó tốt hơn - why it works, why it don't work.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau khi có một bể idea rồi, sẽ thành công cốc nếu sau cùng bạn/ nhóm chọn một idea tệ. Tất nhiên là việc chọn không phải lúc nào cũng đúng nhưng hãy có theo cách lí trí nhất có thể, vì khi rõ ràng bạn mới có cơ sở kiểm chứng & học hỏi từ nó tốt hơn - why it works, why it don't work.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-8019-bb3e-e4e973452a27",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2025-01-21T02:34:00.000Z",
        "last_edited_time": "2025-01-21T02:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-8076-ac4a-f85b9b9ca8f1",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2025-01-21T02:34:00.000Z",
        "last_edited_time": "2025-01-21T02:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081588/uxcomic-imgs/1825d164-78d8-8076-ac4a-f85b9b9ca8f1.jpg",
            "expiry_time": "2026-10-04T09:12:34.966Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1825d164-78d8-8076-ac4a-f85b9b9ca8f1"
      },
      {
        "object": "block",
        "id": "ca3c7f35-49a2-4950-9f4b-e5f272e2a705",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2025-01-21T02:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "2 công cụ ta cần có khi đánh giá idea đó là ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2 công cụ ta cần có khi đánh giá idea đó là ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "benchmark & criteria",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "benchmark & criteria",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", thiếu đi cây thước đo này, mọi người sẽ đánh giá idea theo mỗi người một kiểu >> dễ dẫn đến conflict & khó đồng thuận. Nếu tò mò về cách chúng ta ra quyết định, bạn có xem qua bài viết ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", thiếu đi cây thước đo này, mọi người sẽ đánh giá idea theo mỗi người một kiểu >> dễ dẫn đến conflict & khó đồng thuận. Nếu tò mò về cách chúng ta ra quyết định, bạn có xem qua bài viết ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "decision making.",
                "link": {
                  "url": "/b2deb93698dc4fafaadc9cfcb4a6c302"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "decision making.",
              "href": "/b2deb93698dc4fafaadc9cfcb4a6c302"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10fecac9-8790-42e3-a6ad-543d915d1183",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-30T15:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "6d62e8ff-f353-4c83-9a1e-0f8a7fc958bf",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-23T02:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuy nhiên ta luôn có những điểm mù, ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuy nhiên ta luôn có những điểm mù, ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "sai lầm",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "sai lầm",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " khi lựa chọn idea, ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " khi lựa chọn idea, ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "791fb14a-5cb2-49b7-afa5-f578ae2d9e39",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-18T01:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thường ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thường ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "idea đầu tiên",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "idea đầu tiên",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " của bạn không tốt, vì idea đầu thường là những idea được bạn lưu sẵn trong tiềm thức, bạn đã thấy nó ở đâu đó nên tính innovation không cao.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " của bạn không tốt, vì idea đầu thường là những idea được bạn lưu sẵn trong tiềm thức, bạn đã thấy nó ở đâu đó nên tính innovation không cao.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "264cbd2e-09d2-459e-a62a-319f98d4ba57",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-30T15:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thường idea nào minh biết chính xác được cách implement nó không có gì sáng tạo, nó thường là các idea đã có trên thị trường hoặc những idea bạn đã thường làm qua.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thường idea nào minh biết chính xác được cách implement nó không có gì sáng tạo, nó thường là các idea đã có trên thị trường hoặc những idea bạn đã thường làm qua.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "b63a1fee-6a4f-457c-a42b-b987668e12a9",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-30T15:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Idea mà đa số mọi người đồng ý cũng chưa hẳn đã tốt,",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Idea mà đa số mọi người đồng ý cũng chưa hẳn đã tốt,",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " vì đó sẽ là idea khả năng đa số thị trường ngoài kia đều thấy, nên tính cạnh tranh nó không cao.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " vì đó sẽ là idea khả năng đa số thị trường ngoài kia đều thấy, nên tính cạnh tranh nó không cao.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "b90e3f4b-31fd-49f9-874e-9f5b8d430eed",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-18T01:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chọn idea thú vị, độc đáo nhưng bỏ quên ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chọn idea thú vị, độc đáo nhưng bỏ quên ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "tính khả thi & effor",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "tính khả thi & effor",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "t phải bỏ ra. Có khi rất dễ để mình biết idea nào là tốt nhất, mang lại nhiều value nhất nhưng đến khi thực thi thì có rào cản, hoặc effort phải bỏ ra quá nhiều, điều này do ta chưa đánh giá kĩ về các trade off, các risk có thể xảy ra.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "t phải bỏ ra. Có khi rất dễ để mình biết idea nào là tốt nhất, mang lại nhiều value nhất nhưng đến khi thực thi thì có rào cản, hoặc effort phải bỏ ra quá nhiều, điều này do ta chưa đánh giá kĩ về các trade off, các risk có thể xảy ra.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2d6131f5-89f4-4da2-82e9-98b454e77e45",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-18T01:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chọn idea phù hợp cho ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chọn idea phù hợp cho ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "short term",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "short term",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " nhưng bỏ quên ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " nhưng bỏ quên ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "long term",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "long term",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", ví dụ: sẽ như thế nào nếu nó ảnh hưởng đến một khía cạnh gì đó, sẽ như thế nào nếu sau này có nhu cầu scale thêm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", ví dụ: sẽ như thế nào nếu nó ảnh hưởng đến một khía cạnh gì đó, sẽ như thế nào nếu sau này có nhu cầu scale thêm.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "e246caac-ee26-4559-86b5-4f089e5685b3",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-30T15:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chọn idea dựa trên",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chọn idea dựa trên",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " đánh giá cảm quan/ assumption,",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " đánh giá cảm quan/ assumption,",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " thiếu tính thực tế, thiếu số liệu. Ví dụ: trong cuộc họp chúng ta đều đồng ý với idea này dựa trên vài cuộc thảo luận nội bộ, nhưng idea đó đều dựa trên voice của các thành viên, chúng ta bỏ quên voice của user >> đến lúc test thì mới phát hiện ra idea đó chưa đủ tốt. >> Evaluate idea càng sớm càng tốt ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " thiếu tính thực tế, thiếu số liệu. Ví dụ: trong cuộc họp chúng ta đều đồng ý với idea này dựa trên vài cuộc thảo luận nội bộ, nhưng idea đó đều dựa trên voice của các thành viên, chúng ta bỏ quên voice của user >> đến lúc test thì mới phát hiện ra idea đó chưa đủ tốt. >> Evaluate idea càng sớm càng tốt ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "(lean discovery).",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "(lean discovery).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8039-b6c1-c550028b6eff",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-30T15:12:00.000Z",
        "last_edited_time": "2024-12-30T15:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "c1373bf4-4030-4d72-abcc-d24bcbf43655",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-18T01:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy lựa chọn 1 idea cần mình đánh giá qua các khía cạnh sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy lựa chọn 1 idea cần mình đánh giá qua các khía cạnh sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80b7-8fce-e45de477dc3e",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-30T15:10:00.000Z",
        "last_edited_time": "2024-12-30T15:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "88c5d03a-8354-44e2-bf97-4d70d99af57e",
            "parent": {
              "type": "block_id",
              "block_id": "16c5d164-78d8-80b7-8fce-e45de477dc3e"
            },
            "created_time": "2024-12-16T05:34:00.000Z",
            "last_edited_time": "2024-12-30T15:11:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Value & Impact",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Value & Impact",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "6305608f-0154-4e2f-9ab1-013012237c7c",
            "parent": {
              "type": "block_id",
              "block_id": "16c5d164-78d8-80b7-8fce-e45de477dc3e"
            },
            "created_time": "2024-12-16T05:34:00.000Z",
            "last_edited_time": "2024-12-30T15:11:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Feasibility & Constraints awareness",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Feasibility & Constraints awareness",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "a34a40a6-1d56-40d9-96c3-3b2cb8f20b4e",
            "parent": {
              "type": "block_id",
              "block_id": "16c5d164-78d8-80b7-8fce-e45de477dc3e"
            },
            "created_time": "2024-12-16T05:34:00.000Z",
            "last_edited_time": "2024-12-30T15:11:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Idea/ Risk evaluation",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Idea/ Risk evaluation",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "af5ddc3b-a2a8-48f7-80d1-b9295f347fdb",
            "parent": {
              "type": "block_id",
              "block_id": "16c5d164-78d8-80b7-8fce-e45de477dc3e"
            },
            "created_time": "2024-12-16T05:34:00.000Z",
            "last_edited_time": "2024-12-30T15:11:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Competitive & Innovative",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Competitive & Innovative",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "d6a75408-61d0-4147-8ec4-6259447e82cf",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-16T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "673ecd20-6005-463b-b6fc-dfe53caf5c50",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-16T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bonus: các dạng creativity",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bonus: các dạng creativity",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "05aec668-ff95-4342-a4cd-6b429297a17f",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-16T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081590/uxcomic-imgs/05aec668-ff95-4342-a4cd-6b429297a17f.webp",
            "expiry_time": "2026-10-04T09:12:34.967Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/05aec668-ff95-4342-a4cd-6b429297a17f"
      },
      {
        "object": "block",
        "id": "40d0e79c-b863-4011-94e0-dbe91cf3e574",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-16T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Deliberate:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Deliberate:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Có chủ đích, dựa trên nỗ lực.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Có chủ đích, dựa trên nỗ lực.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "6a2d8c80-5350-4c93-a5bc-54043da9e8be",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-16T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Spontaneous:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Spontaneous:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Ngẫu hứng, bất ngờ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Ngẫu hứng, bất ngờ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "099968f3-b3ed-418e-b5c4-c81a16a5d483",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-16T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cognitive:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cognitive:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Dựa trên lý trí và kiến thức.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Dựa trên lý trí và kiến thức.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "bb1bfed2-000c-4c4f-8db5-c01119a0f94c",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-16T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Emotional:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Emotional:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Dựa trên cảm xúc và cảm hứng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Dựa trên cảm xúc và cảm hứng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-80f9-a692-de2c51b0af1c",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2025-01-21T02:24:00.000Z",
        "last_edited_time": "2025-01-21T02:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "6aad5a0a-0855-42c6-bdcf-96209e4cb6e1",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-16T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Kết hợp chúng lại ta có:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kết hợp chúng lại ta có:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "fa7cb7bb-3b81-447a-9ca2-3e9dfba8a379",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-16T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Deliberate and Cognitive Creativity",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Deliberate and Cognitive Creativity",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": sáng tạo này dựa trên kế hoạch và tư duy logic, sử dụng kiến thức và phân tích để giải quyết vấn đề một cách có chủ đích. Nó thường được áp dụng trong khoa học, kỹ thuật, và kinh doanh, ví dụ như việc Edison đã phát minh ra bóng đèn điện thông qua việc tiến hành hàng ngàn thử nghiệm có hệ thống với các vật liệu khác nhau để tìm ra dây tóc bóng đèn phù hợp.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": sáng tạo này dựa trên kế hoạch và tư duy logic, sử dụng kiến thức và phân tích để giải quyết vấn đề một cách có chủ đích. Nó thường được áp dụng trong khoa học, kỹ thuật, và kinh doanh, ví dụ như việc Edison đã phát minh ra bóng đèn điện thông qua việc tiến hành hàng ngàn thử nghiệm có hệ thống với các vật liệu khác nhau để tìm ra dây tóc bóng đèn phù hợp.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "db66c8c3-6dbf-486e-bb37-f6a9d7949857",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-23T07:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Deliberate and Emotional Creativity",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Deliberate and Emotional Creativity",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": dựa trên cảm xúc kết hợp với mục tiêu rõ ràng, loại sáng tạo này tập trung vào động lực cá nhân để tạo ra những thứ mang ý nghĩa sâu sắc. Ví dụ: một người tham gia trị liệu tâm lý muốn vượt qua nỗi sợ bị từ chối. Qua nhiều buổi trò chuyện có kế hoạch với nhà trị liệu, họ được hướng dẫn khai thác cảm xúc sâu kín và nhận thức rõ ràng về những trải nghiệm trong quá khứ. Điều này thúc đẩy họ sáng tạo ra những cách mới để đối diện với nỗi sợ, như viết nhật ký tự yêu thương hoặc tham gia các hoạt động xây dựng lòng tự tin.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": dựa trên cảm xúc kết hợp với mục tiêu rõ ràng, loại sáng tạo này tập trung vào động lực cá nhân để tạo ra những thứ mang ý nghĩa sâu sắc. Ví dụ: một người tham gia trị liệu tâm lý muốn vượt qua nỗi sợ bị từ chối. Qua nhiều buổi trò chuyện có kế hoạch với nhà trị liệu, họ được hướng dẫn khai thác cảm xúc sâu kín và nhận thức rõ ràng về những trải nghiệm trong quá khứ. Điều này thúc đẩy họ sáng tạo ra những cách mới để đối diện với nỗi sợ, như viết nhật ký tự yêu thương hoặc tham gia các hoạt động xây dựng lòng tự tin.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "47f9a1d6-a795-4ced-8dc9-85b12755f86c",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-16T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Spontaneous and Cognitive Creativity",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Spontaneous and Cognitive Creativity",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": xuất hiện một cách bất ngờ từ những kiến thức đã tích lũy, thường xảy ra khi bạn không cố ý suy nghĩ về vấn đề. Ví dụ, Newton nghĩ ra Định luật vạn vật hấp dẫn sau khi nhìn quả táo rơi.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": xuất hiện một cách bất ngờ từ những kiến thức đã tích lũy, thường xảy ra khi bạn không cố ý suy nghĩ về vấn đề. Ví dụ, Newton nghĩ ra Định luật vạn vật hấp dẫn sau khi nhìn quả táo rơi.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3e1fb8ec-2a3d-4de9-bf6c-9cadcdcd2baa",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-16T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Spontaneous and Emotional Creativity",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Spontaneous and Emotional Creativity",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": được khơi nguồn bởi cảm xúc mãnh liệt và xảy ra tức thì, loại sáng tạo này mang tính trực giác, thường thấy trong nghệ thuật và âm nhạc. Một ví dụ là nhạc sĩ ngẫu hứng sáng tác một bản nhạc từ cảm hứng mạnh mẽ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": được khơi nguồn bởi cảm xúc mãnh liệt và xảy ra tức thì, loại sáng tạo này mang tính trực giác, thường thấy trong nghệ thuật và âm nhạc. Một ví dụ là nhạc sĩ ngẫu hứng sáng tác một bản nhạc từ cảm hứng mạnh mẽ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-806b-b2a7-d66df1dffad3",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2025-01-21T02:24:00.000Z",
        "last_edited_time": "2025-01-21T02:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3245a445-f13e-4077-8cf2-04b7d40bd867",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-23T07:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: công việc của một product design có thể thấy thiên hướng về ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: công việc của một product design có thể thấy thiên hướng về ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Deliberate and Cognitive Creativity, Deliberate and Emotional Creativity, ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Deliberate and Cognitive Creativity, Deliberate and Emotional Creativity, ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "idea thường cần có tính chủ đích rõ ràng & suy nghĩ sâu sắc về vấn đề, cảm thông sâu sắc về người dùng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "idea thường cần có tính chủ đích rõ ràng & suy nghĩ sâu sắc về vấn đề, cảm thông sâu sắc về người dùng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15e5d164-78d8-803e-9783-e9ada43beecd",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T09:42:00.000Z",
        "last_edited_time": "2024-12-16T09:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "9126768e-2b2b-4ffe-9e75-2c92030fa05e",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-23T02:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "OK, vậy làm sao để chúng ta trở nên sáng tạo hơn?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "OK, vậy làm sao để chúng ta trở nên sáng tạo hơn?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "4ef94a93-1652-4e1d-91a7-bd6963114ba4",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2025-01-21T02:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu phỏng theo mô hình matrix trên, ta cần ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu phỏng theo mô hình matrix trên, ta cần ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "giàu trải nghiệm hơn, cần có thói quen quan sát, nghiền ngẫm nhiều hơn",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "giàu trải nghiệm hơn, cần có thói quen quan sát, nghiền ngẫm nhiều hơn",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ". Đặc biệt nếu luyện cho mình quan sát để tìm ra nguyên lý, bản chất đằng sau của các hiện tượng, sự vật thì lúc kết hợp idea sẽ rất thú vị hơn hẳn. Ví dụ: từ thời hái lượm, bản năng chúng ta đã để ý những thứ chuyển động vì nó báo hiệu cho ta khả năng có con thú săn mồi nào đó >> chuyển động tác động đến sự chú ý >> áp dụng nguyên lý này, khi bạn muốn thu hút sự chú ý user vào một thành tố nào đó, hãy thử làm nó động xem sao.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". Đặc biệt nếu luyện cho mình quan sát để tìm ra nguyên lý, bản chất đằng sau của các hiện tượng, sự vật thì lúc kết hợp idea sẽ rất thú vị hơn hẳn. Ví dụ: từ thời hái lượm, bản năng chúng ta đã để ý những thứ chuyển động vì nó báo hiệu cho ta khả năng có con thú săn mồi nào đó >> chuyển động tác động đến sự chú ý >> áp dụng nguyên lý này, khi bạn muốn thu hút sự chú ý user vào một thành tố nào đó, hãy thử làm nó động xem sao.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15e5d164-78d8-8067-aa61-e65ed9504dca",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:47:00.000Z",
        "last_edited_time": "2024-12-23T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Challenge bản thân",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Challenge bản thân",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", tự phá bỏ những cách nhìn, cách hiểu quen thuộc, tập hỏi “what if” để khơi gợi một góc nhìn khác, tập nhìn ra những cơ hội, tiềm năng trong các idea trước khi phán xét chúng. Ví dụ: thông thường ta nghĩ đến kem có vị ngọt, sẽ như thế nào nếu kem có vị mặn >> kem muối hạt.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", tự phá bỏ những cách nhìn, cách hiểu quen thuộc, tập hỏi “what if” để khơi gợi một góc nhìn khác, tập nhìn ra những cơ hội, tiềm năng trong các idea trước khi phán xét chúng. Ví dụ: thông thường ta nghĩ đến kem có vị ngọt, sẽ như thế nào nếu kem có vị mặn >> kem muối hạt.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "d7c2f1a3-03c4-4458-be14-58c0a6414973",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2025-01-21T02:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bạn có để ý đôi khi bạn đang tắm, đang cà phê, hoặc lúc sắp ngủ thì lại có idea pop up trong đầu không? Mình nghĩ hiện tượng này giống như cảnh tượng: khi mình cố gắng phân tích, nghĩ quá nhiều tại thời điểm đó, nó như có một mớ đất cát & lá cây đang chôn vùi lên chồi non, khiến nó không được nhìn thấy, hoặc không được xem xét kĩ, và khi bạn ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bạn có để ý đôi khi bạn đang tắm, đang cà phê, hoặc lúc sắp ngủ thì lại có idea pop up trong đầu không? Mình nghĩ hiện tượng này giống như cảnh tượng: khi mình cố gắng phân tích, nghĩ quá nhiều tại thời điểm đó, nó như có một mớ đất cát & lá cây đang chôn vùi lên chồi non, khiến nó không được nhìn thấy, hoặc không được xem xét kĩ, và khi bạn ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "ngưng nghĩ ngợi nó ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "ngưng nghĩ ngợi nó ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cũng giống như cho có một cơn gió thổi đi đống cát lá đó, chồi non mới xuất hiện.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cũng giống như cho có một cơn gió thổi đi đống cát lá đó, chồi non mới xuất hiện.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-804f-83d3-e86f285c8a22",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2025-01-21T02:28:00.000Z",
        "last_edited_time": "2025-01-21T02:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081591/uxcomic-imgs/1825d164-78d8-804f-83d3-e86f285c8a22.jpg",
            "expiry_time": "2026-10-04T09:12:35.095Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1825d164-78d8-804f-83d3-e86f285c8a22"
      },
      {
        "object": "block",
        "id": "7b9cc61a-1262-417c-8731-66144a827c16",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-16T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "7522ca44-b3f6-4d4a-80e1-78ea5775b778",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-16T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "26ad4e2e-6116-4042-ad98-ea18b7f9f54b",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-16T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.campariacademy.com/inspiration/trends/the-4-types-of-creativity-explained/",
                "link": {
                  "url": "https://www.campariacademy.com/inspiration/trends/the-4-types-of-creativity-explained/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.campariacademy.com/inspiration/trends/the-4-types-of-creativity-explained/",
              "href": "https://www.campariacademy.com/inspiration/trends/the-4-types-of-creativity-explained/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "c41fab2c-696c-4f7c-96c0-cf49c144efaa",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-16T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://professional.dce.harvard.edu/blog/4-ways-creative-thinking-drives-professional-success/",
                "link": {
                  "url": "https://professional.dce.harvard.edu/blog/4-ways-creative-thinking-drives-professional-success/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://professional.dce.harvard.edu/blog/4-ways-creative-thinking-drives-professional-success/",
              "href": "https://professional.dce.harvard.edu/blog/4-ways-creative-thinking-drives-professional-success/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "b209a579-4fed-41a7-a1ed-9da35d849aa3",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-16T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "26d4a7b9-297b-43ae-8c68-cc8dfe54cf6f",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-16T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15e5d164-78d8-80d4-a63e-c97ab46e6b31",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:45:00.000Z",
        "last_edited_time": "2024-12-16T05:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1585d164-78d8-80c3-b602-e97f38fd7948"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ideate (P1)",
              "href": "https://app.notion.com/p/1585d16478d880c3b602e97f38fd7948"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "04fe556c-e5f5-4f82-8e6b-a210efba06cb",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-16T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1505d164-78d8-80f8-9aad-e59e03c067dc"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Brainstorm toolkit",
              "href": "https://app.notion.com/p/1505d16478d880f89aade59e03c067dc"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22db1edc-6d88-4dac-94b8-ba1b5d67cc14",
        "parent": {
          "type": "page_id",
          "page_id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
        },
        "created_time": "2024-12-16T05:34:00.000Z",
        "last_edited_time": "2024-12-16T05:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Decision making (P1)",
              "href": "https://app.notion.com/p/b2deb93698dc4fafaadc9cfcb4a6c302"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1585d164-78d8-80c3-b602-e97f38fd7948",
    "created_time": "2024-12-10T12:16:00.000Z",
    "last_edited_time": "2025-07-17T07:48:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "2-Think",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2025-07-17T07:48:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": "ByM|",
          "name": "♟️:2",
          "color": "pink"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 31
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2024-12-10T12:16:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Ideate (P1)",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Ideate (P1)",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Ideate-P1-1585d16478d880c3b602e97f38fd7948",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
      "name": "Think",
      "slug": "think",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "1585d164-78d8-8138-9b22-daeb33a5c6ae",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-10T12:16:00.000Z",
        "last_edited_time": "2024-12-16T00:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081595/uxcomic-imgs/1585d164-78d8-8138-9b22-daeb33a5c6ae.png",
            "expiry_time": "2026-10-04T09:12:36.245Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1585d164-78d8-8138-9b22-daeb33a5c6ae"
      },
      {
        "object": "block",
        "id": "1585d164-78d8-8169-ab6b-ef1e3d36b1a6",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-10T12:16:00.000Z",
        "last_edited_time": "2024-12-30T14:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Designer được sinh ra để chỉ ra tại sao ta nên tiếp cận nó theo hướng này chứ không phải hướng khác, nghĩa vụ chúng ta là tìm một phương án tối ưu, tạo được cái gì đó khác biệt & thú vị hơn. >> Ý tưởng là bạn đồng hành của designer.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Designer được sinh ra để chỉ ra tại sao ta nên tiếp cận nó theo hướng này chứ không phải hướng khác, nghĩa vụ chúng ta là tìm một phương án tối ưu, tạo được cái gì đó khác biệt & thú vị hơn. >> Ý tưởng là bạn đồng hành của designer.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8098-ab67-c6af57a7868c",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-30T14:44:00.000Z",
        "last_edited_time": "2024-12-30T14:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhưng gần đây ngồi nhìn lại thì mình nhận ra chưa dành thời gian nghiên cứu hẳn hoi cho topic này, các câu hỏi: sáng tạo là gì, idea là gì, liệu có cách nào để ta tìm idea thay vì chỉ dựa vào bản năng hay cảm hứng, tại sao lại có những ý tưởng đột phá…?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhưng gần đây ngồi nhìn lại thì mình nhận ra chưa dành thời gian nghiên cứu hẳn hoi cho topic này, các câu hỏi: sáng tạo là gì, idea là gì, liệu có cách nào để ta tìm idea thay vì chỉ dựa vào bản năng hay cảm hứng, tại sao lại có những ý tưởng đột phá…?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-80d7-9965-e296031ccf83",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-15T15:15:00.000Z",
        "last_edited_time": "2024-12-15T15:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-81b4-89b5-f4be3f7f1dc8",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-10T12:16:00.000Z",
        "last_edited_time": "2024-12-10T12:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Direction vs Option",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Direction vs Option",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-8048-bd28-c0e0da37e864",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-23T01:47:00.000Z",
        "last_edited_time": "2024-12-30T14:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước hết, theo mình là quan trọng nhất, phải hiểu về sự phân cấp direction & option trong idea.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước hết, theo mình là quan trọng nhất, phải hiểu về sự phân cấp direction & option trong idea.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-819e-9160-d80affd9c299",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-10T12:16:00.000Z",
        "last_edited_time": "2024-12-23T01:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Direction ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Direction ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "là hướng tiếp cận, là định hướng chung hoặc khuôn khổ để phát triển ý tưởng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "là hướng tiếp cận, là định hướng chung hoặc khuôn khổ để phát triển ý tưởng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-8069-afa3-cf9ffbb35ae5",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-15T14:21:00.000Z",
        "last_edited_time": "2024-12-15T14:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Option",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Option",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là các giải pháp cụ thể, đa dạng, được phát triển dựa trên direction.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là các giải pháp cụ thể, đa dạng, được phát triển dựa trên direction.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-805c-bfe1-ec63411e9af2",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-30T14:58:00.000Z",
        "last_edited_time": "2025-01-10T05:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081597/uxcomic-imgs/16c5d164-78d8-805c-bfe1-ec63411e9af2.png",
            "expiry_time": "2026-10-04T09:12:36.246Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/16c5d164-78d8-805c-bfe1-ec63411e9af2"
      },
      {
        "object": "block",
        "id": "1825d164-78d8-8083-bc53-ef39bdff6824",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2025-01-21T02:22:00.000Z",
        "last_edited_time": "2025-01-21T02:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-80a3-a40e-d5d13e762709",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-15T14:23:00.000Z",
        "last_edited_time": "2025-01-21T02:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: với thử thách “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: với thử thách “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cách nào để cải thiện trải nghiệm đăng ký tài khoản?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cách nào để cải thiện trải nghiệm đăng ký tài khoản?",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-8068-a8db-e6545e5a0762",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2025-01-21T02:22:00.000Z",
        "last_edited_time": "2025-01-21T02:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-8032-aadb-c3a220a97e9d",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-15T14:31:00.000Z",
        "last_edited_time": "2024-12-15T14:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các direction có thể là:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các direction có thể là:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-8049-9ccc-d55e2d0725cd",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-15T14:29:00.000Z",
        "last_edited_time": "2024-12-22T13:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giảm thiểu số bước trong quy trình đăng ký.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giảm thiểu số bước trong quy trình đăng ký.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-8053-ae64-e72d9958ce3d",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-15T14:29:00.000Z",
        "last_edited_time": "2024-12-22T13:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Làm cho giao diện đăng ký trở nên thân thiện và hấp dẫn hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Làm cho giao diện đăng ký trở nên thân thiện và hấp dẫn hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-801d-883a-c3301f495490",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-15T14:29:00.000Z",
        "last_edited_time": "2024-12-22T13:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tăng cường tính bảo mật trong quá trình xác thực.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tăng cường tính bảo mật trong quá trình xác thực.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-80d5-b3c1-fc790d3ffb41",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2025-01-21T02:22:00.000Z",
        "last_edited_time": "2025-01-21T02:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-806f-b66b-d71149e006e8",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-15T14:32:00.000Z",
        "last_edited_time": "2024-12-15T14:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các option cho “giảm thiệu số bước trong quy trình đăng ký” có thể là:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các option cho “giảm thiệu số bước trong quy trình đăng ký” có thể là:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-802d-86ee-d4fb6a2d02ee",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-15T14:32:00.000Z",
        "last_edited_time": "2024-12-22T13:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tích hợp đăng ký một lần bằng tài khoản Google/Facebook.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tích hợp đăng ký một lần bằng tài khoản Google/Facebook.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-805e-aa8b-e8d852374e19",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-15T14:32:00.000Z",
        "last_edited_time": "2024-12-22T13:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sử dụng OTP để bỏ qua việc tạo mật khẩu.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sử dụng OTP để bỏ qua việc tạo mật khẩu.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-80e4-bccf-eefefd3dd1ca",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-15T14:32:00.000Z",
        "last_edited_time": "2024-12-22T13:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Gộp thông tin vào một màn hình duy nhất thay vì nhiều bước.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Gộp thông tin vào một màn hình duy nhất thay vì nhiều bước.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-808d-89b5-da3e79ed1085",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-15T14:34:00.000Z",
        "last_edited_time": "2024-12-15T15:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-8175-bcaa-c35d57e8df94",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-10T12:16:00.000Z",
        "last_edited_time": "2024-12-10T12:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Variations",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Variations",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-8048-94c2-cb3c5ca33455",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-25T04:59:00.000Z",
        "last_edited_time": "2025-01-10T05:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081599/uxcomic-imgs/1675d164-78d8-8048-94c2-cb3c5ca33455.webp",
            "expiry_time": "2026-10-04T09:12:36.246Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1675d164-78d8-8048-94c2-cb3c5ca33455"
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-80bd-8786-f29384fcb8bb",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-15T15:49:00.000Z",
        "last_edited_time": "2024-12-30T14:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Idea nên là bất tận, không quy luật, là trí tưởng tượng bay xa =)). Mình hay hình dung cách để mình tìm idea như việc cầm 1 khối rubik, ta xoay, ta kết hợp, ta lật các mặt,…đó là sự xoay chuyển liên tục các góc nhìn, các hướng tiếp cận. Cụ thể hơn thì ta có các level sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Idea nên là bất tận, không quy luật, là trí tưởng tượng bay xa =)). Mình hay hình dung cách để mình tìm idea như việc cầm 1 khối rubik, ta xoay, ta kết hợp, ta lật các mặt,…đó là sự xoay chuyển liên tục các góc nhìn, các hướng tiếp cận. Cụ thể hơn thì ta có các level sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-807e-81d7-d3547f4c0c56",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2025-01-21T02:20:00.000Z",
        "last_edited_time": "2025-01-21T02:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8013-8c6a-e39230b37a82",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:42:00.000Z",
        "last_edited_time": "2024-12-22T13:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "1/ Imitative Creativity (Sáng tạo bắt chước)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "1/ Imitative Creativity (Sáng tạo bắt chước)",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-806d-b755-c280751eab1c",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:42:00.000Z",
        "last_edited_time": "2024-12-22T13:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sử dụng hoặc cải tiến các ý tưởng đã có sẵn, tạo ra các giải pháp dựa trên mô hình hiện tại. Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sử dụng hoặc cải tiến các ý tưởng đã có sẵn, tạo ra các giải pháp dựa trên mô hình hiện tại. Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8004-a9f6-eb1dd7c2c802",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:43:00.000Z",
        "last_edited_time": "2024-12-22T13:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thay đổi màu sắc hoặc hình dáng của một sản phẩm đã tồn tại.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thay đổi màu sắc hoặc hình dáng của một sản phẩm đã tồn tại.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80ec-99b0-f34053ba0257",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:43:00.000Z",
        "last_edited_time": "2024-12-22T13:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phát triển một ứng dụng tương tự như Uber nhưng dành riêng cho thú cưng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phát triển một ứng dụng tương tự như Uber nhưng dành riêng cho thú cưng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-8032-90cf-d36bc0558fa3",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2025-01-21T02:20:00.000Z",
        "last_edited_time": "2025-01-21T02:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80b8-a2d1-efc320266a03",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:42:00.000Z",
        "last_edited_time": "2024-12-22T13:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "2/ Adaptive Creativity (Sáng tạo thích nghi)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2/ Adaptive Creativity (Sáng tạo thích nghi)",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-807e-a159-fbcbf4d83ecf",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:43:00.000Z",
        "last_edited_time": "2024-12-22T13:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Điều chỉnh hoặc tái định hình ý tưởng, sản phẩm, hoặc giải pháp để phù hợp với bối cảnh mới. Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Điều chỉnh hoặc tái định hình ý tưởng, sản phẩm, hoặc giải pháp để phù hợp với bối cảnh mới. Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-809e-bef3-c1537f947c4c",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:43:00.000Z",
        "last_edited_time": "2024-12-22T13:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thiết kế xe đạp gấp để phù hợp với không gian sống nhỏ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thiết kế xe đạp gấp để phù hợp với không gian sống nhỏ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-806a-9f10-c0b29113c9ba",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:44:00.000Z",
        "last_edited_time": "2024-12-22T13:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Áp dụng mô hình học trực tuyến để dạy kỹ năng mềm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Áp dụng mô hình học trực tuyến để dạy kỹ năng mềm.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-8043-8193-dfbcdc9848d5",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2025-01-21T02:20:00.000Z",
        "last_edited_time": "2025-01-21T02:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80f3-b3fd-ea9eaa5d838e",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:42:00.000Z",
        "last_edited_time": "2024-12-22T13:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "3/ Innovative Creativity (Sáng tạo đổi mới)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3/ Innovative Creativity (Sáng tạo đổi mới)",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8029-8ef4-f988c8424b09",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:44:00.000Z",
        "last_edited_time": "2024-12-22T13:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tạo ra các ý tưởng hoặc giải pháp mới lạ, nhưng vẫn dựa trên các nguyên tắc, tài nguyên hoặc công nghệ đã tồn tại. Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tạo ra các ý tưởng hoặc giải pháp mới lạ, nhưng vẫn dựa trên các nguyên tắc, tài nguyên hoặc công nghệ đã tồn tại. Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80ad-ab86-cd32b448ab9f",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:44:00.000Z",
        "last_edited_time": "2024-12-22T13:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phát triển hệ thống giao hàng bằng drone.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phát triển hệ thống giao hàng bằng drone.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8069-8002-d319bfeed7d4",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:44:00.000Z",
        "last_edited_time": "2024-12-30T14:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tạo ra điện thoại gập với màn hình linh hoạt.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tạo ra điện thoại gập với màn hình linh hoạt.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-804b-b3c2-fcada50bfd91",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2025-01-21T02:20:00.000Z",
        "last_edited_time": "2025-01-21T02:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-808c-b262-fbd7263bd438",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:42:00.000Z",
        "last_edited_time": "2024-12-22T13:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "4/ Inventive Creativity (Sáng tạo phát minh)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "4/ Inventive Creativity (Sáng tạo phát minh)",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8067-a71a-f2e36fc0fabe",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:42:00.000Z",
        "last_edited_time": "2024-12-22T13:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tạo ra các sản phẩm hoặc ý tưởng chưa từng tồn tại, mang tính đột phá và thay đổi cuộc chơi. Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tạo ra các sản phẩm hoặc ý tưởng chưa từng tồn tại, mang tính đột phá và thay đổi cuộc chơi. Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8011-980c-ecec176bb4d7",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:44:00.000Z",
        "last_edited_time": "2024-12-22T13:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phát minh ra Internet.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phát minh ra Internet.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80f9-990a-ca2725bead75",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:44:00.000Z",
        "last_edited_time": "2024-12-22T13:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tạo ra xe điện tự lái như Tesla.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tạo ra xe điện tự lái như Tesla.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-801c-840a-cf7615e1dbde",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2025-01-21T02:20:00.000Z",
        "last_edited_time": "2025-01-21T02:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8004-810a-ca1b6d356072",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:42:00.000Z",
        "last_edited_time": "2024-12-22T13:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "5/ Boundary-Breaking Creativity (Sáng tạo phá vỡ giới hạn)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "5/ Boundary-Breaking Creativity (Sáng tạo phá vỡ giới hạn)",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80d3-8cc2-c41d938cb65a",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:42:00.000Z",
        "last_edited_time": "2024-12-22T13:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phá bỏ các quy chuẩn hoặc cách suy nghĩ truyền thống, tạo ra những giải pháp vượt ra ngoài mong đợi. Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phá bỏ các quy chuẩn hoặc cách suy nghĩ truyền thống, tạo ra những giải pháp vượt ra ngoài mong đợi. Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8005-bc98-ef4d1b57ec70",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:45:00.000Z",
        "last_edited_time": "2024-12-22T13:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tư duy về không gian như Elon Musk với SpaceX và giấc mơ định cư trên sao Hỏa.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tư duy về không gian như Elon Musk với SpaceX và giấc mơ định cư trên sao Hỏa.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80da-8adf-ef9e1fd2a156",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:45:00.000Z",
        "last_edited_time": "2024-12-22T13:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Blockchain tái định nghĩa cách chúng ta lưu trữ và giao dịch dữ liệu.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Blockchain tái định nghĩa cách chúng ta lưu trữ và giao dịch dữ liệu.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-809d-ab0b-e5f3178ed012",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2025-01-21T02:20:00.000Z",
        "last_edited_time": "2025-01-21T02:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80df-9d7b-c35759f5a598",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:42:00.000Z",
        "last_edited_time": "2024-12-22T13:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "6/ Meta Creativity (Sáng tạo định hình sáng tạo)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "6/ Meta Creativity (Sáng tạo định hình sáng tạo)",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-804c-abb0-dde6ef8e0282",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:45:00.000Z",
        "last_edited_time": "2024-12-22T13:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mô tả: Sáng tạo trong cách sáng tạo, phát minh ra phương pháp hoặc công cụ để nâng cao khả năng sáng tạo của người khác. Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mô tả: Sáng tạo trong cách sáng tạo, phát minh ra phương pháp hoặc công cụ để nâng cao khả năng sáng tạo của người khác. Ví dụ:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8067-90ac-e3d2a16032af",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:45:00.000Z",
        "last_edited_time": "2024-12-22T13:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phát triển các phương pháp tư duy sáng tạo như Design Thinking hoặc SCAMPER.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phát triển các phương pháp tư duy sáng tạo như Design Thinking hoặc SCAMPER.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80f1-951c-ded4ef4f10ae",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:45:00.000Z",
        "last_edited_time": "2024-12-22T13:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tạo ra công cụ AI hỗ trợ sáng tạo nội dung như ChatGPT.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tạo ra công cụ AI hỗ trợ sáng tạo nội dung như ChatGPT.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8080-8f06-c99005295385",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-30T14:29:00.000Z",
        "last_edited_time": "2024-12-30T14:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tip: nếu như có một solution 10x better, nó sẽ là gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tip: nếu như có một solution 10x better, nó sẽ là gì?",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8069-8380-f137c81038c2",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-30T15:00:00.000Z",
        "last_edited_time": "2024-12-30T15:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-80b8-a902-fc97a50127fd",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-15T14:40:00.000Z",
        "last_edited_time": "2025-07-17T07:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Direction",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Direction",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-8022-b593-ca7b4a6f3620",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-15T14:40:00.000Z",
        "last_edited_time": "2024-12-23T01:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cách để ta có nhiều direction thường cần đến sự phân tích nhiều hơn, ta cần tìm ra các solution, các hướng tiếp cận nhờ việc hiểu rất rõ về vấn đề đang có, càng bóc tách, mổ xẻ nó, thì hướng đi càng nhiều.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cách để ta có nhiều direction thường cần đến sự phân tích nhiều hơn, ta cần tìm ra các solution, các hướng tiếp cận nhờ việc hiểu rất rõ về vấn đề đang có, càng bóc tách, mổ xẻ nó, thì hướng đi càng nhiều.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-8161-ac1e-ccf3ea3cd2be",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-10T12:16:00.000Z",
        "last_edited_time": "2024-12-16T10:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một tactics khá hữu ích sẽ là ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một tactics khá hữu ích sẽ là ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "HMW (How Might We)",
                "link": {
                  "url": "/1505d16478d880f89aade59e03c067dc"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "HMW (How Might We)",
              "href": "/1505d16478d880f89aade59e03c067dc"
            },
            {
              "type": "text",
              "text": {
                "content": ", đây là cách ta tìm ra direction thông qua các câu hỏi định hướng, nhìn nhận vấn đề dưới các góc độ khác nhau.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", đây là cách ta tìm ra direction thông qua các câu hỏi định hướng, nhìn nhận vấn đề dưới các góc độ khác nhau.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-808d-b0f8-c1069d1d5f03",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2025-01-21T02:21:00.000Z",
        "last_edited_time": "2025-01-21T02:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15e5d164-78d8-80fc-9b49-cf1268a4f329",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-16T09:50:00.000Z",
        "last_edited_time": "2025-01-21T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quan trọng nhất trong việc set direction là nó nên mở, không tập trung vào một giải pháp gì đó quá cụ thể (cụ thể nên dành cho bước nghĩ option). ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quan trọng nhất trong việc set direction là nó nên mở, không tập trung vào một giải pháp gì đó quá cụ thể (cụ thể nên dành cho bước nghĩ option). ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-80ef-b3dc-feee0c67d549",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2025-01-21T02:19:00.000Z",
        "last_edited_time": "2025-07-17T07:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tip",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tip",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2335d164-78d8-80a6-9583-fec2fe2f623c",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2025-07-17T07:46:00.000Z",
        "last_edited_time": "2025-07-17T07:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tránh dùng noun, gợi mở idea bằng verb & adjective trong câu hỏi. Ví dụ: thay vì nghĩ tạo ra một app giúp việc đọc sách trở nên lôi cuốn hơn >> chuyển sang làm sao để việc đọc sách trở nên lôi cuốn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tránh dùng noun, gợi mở idea bằng verb & adjective trong câu hỏi. Ví dụ: thay vì nghĩ tạo ra một app giúp việc đọc sách trở nên lôi cuốn hơn >> chuyển sang làm sao để việc đọc sách trở nên lôi cuốn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2335d164-78d8-8008-a6df-f66781199fab",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2025-07-17T07:46:00.000Z",
        "last_edited_time": "2025-07-17T07:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hãy gắn chữ “…-oriented” đằng sau cho idea đó, nếu chia ra được rõ ràng thì nó sẽ là 1 direction, ví dụ: task-oriented, outcome-oriented, service-oriented,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hãy gắn chữ “…-oriented” đằng sau cho idea đó, nếu chia ra được rõ ràng thì nó sẽ là 1 direction, ví dụ: task-oriented, outcome-oriented, service-oriented,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-8083-bd97-fae6cbd1d06f",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2025-01-21T02:19:00.000Z",
        "last_edited_time": "2025-01-21T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-8012-8efd-ef238a155760",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-15T14:44:00.000Z",
        "last_edited_time": "2025-07-17T07:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Option",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Option",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-80bf-9cc4-c8944cc2c00f",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-15T14:44:00.000Z",
        "last_edited_time": "2024-12-30T15:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vì bản chất option là những idea thiên về các cách thức cụ thể để phục vụ cho direction, nên theo mình thì dễ pop up hơn. Tuy nhiên hạn chế của nó là thường dựa trên những thứ mình đã biết >> để có nhiều option hơn ta cần nghiên cứu nhiều hơn, hoặc nhờ đến sự trợ giúp - thu thập idea từ lĩnh vực khác hoặc các người khác (sẽ tốt hơn nếu họ làm ở một chuyên môn khác) để figure out 1 cách làm khác sẽ như thế nào. Ah quên mất, có phương pháp ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vì bản chất option là những idea thiên về các cách thức cụ thể để phục vụ cho direction, nên theo mình thì dễ pop up hơn. Tuy nhiên hạn chế của nó là thường dựa trên những thứ mình đã biết >> để có nhiều option hơn ta cần nghiên cứu nhiều hơn, hoặc nhờ đến sự trợ giúp - thu thập idea từ lĩnh vực khác hoặc các người khác (sẽ tốt hơn nếu họ làm ở một chuyên môn khác) để figure out 1 cách làm khác sẽ như thế nào. Ah quên mất, có phương pháp ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "SCAMPER",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "SCAMPER",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " cũng khá giúp ích đấy.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " cũng khá giúp ích đấy.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80d1-9c0f-d31030f6a27c",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-30T15:01:00.000Z",
        "last_edited_time": "2024-12-30T15:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-8079-8921-ed2f3b85f699",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-15T15:07:00.000Z",
        "last_edited_time": "2025-07-17T07:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Rule",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Rule",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-80fd-b8cc-ff958ed212db",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-15T15:08:00.000Z",
        "last_edited_time": "2024-12-23T02:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi lên ý tưởng, điều quan trọng nhất ta cần là số lượng idea, ta cần có trên bàn ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi lên ý tưởng, điều quan trọng nhất ta cần là số lượng idea, ta cần có trên bàn ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "càng nhiều hướng, càng nhiều góc nhìn càng tốt,",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "càng nhiều hướng, càng nhiều góc nhìn càng tốt,",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " vậy nên lúc này hãy tạm gác lại mọi sự đánh giá, mọi sự xem xét trong đầu, mọi idea đều cần được welcome. Đặc biệt nếu bạn có thực hiện việc lên idea với các thành viên khác, thì càng phải phổ biến luật này hoặc tìm cách thức nào đó để đạt được goal trên, ví dụ các tactics: crazy 8s, silent brainstorm, round robin,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " vậy nên lúc này hãy tạm gác lại mọi sự đánh giá, mọi sự xem xét trong đầu, mọi idea đều cần được welcome. Đặc biệt nếu bạn có thực hiện việc lên idea với các thành viên khác, thì càng phải phổ biến luật này hoặc tìm cách thức nào đó để đạt được goal trên, ví dụ các tactics: crazy 8s, silent brainstorm, round robin,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15e5d164-78d8-8020-9b25-dda11194fbc3",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-16T10:29:00.000Z",
        "last_edited_time": "2024-12-23T02:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Defer judgment. Seek quantity.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Defer judgment. Seek quantity.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-8008-9835-d1685dfbfcc7",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2025-01-21T02:21:00.000Z",
        "last_edited_time": "2025-01-21T02:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8093-86a6-ca738c0722d1",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:29:00.000Z",
        "last_edited_time": "2025-01-21T02:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tip: cách nhận diện bạn đang có nhiều hơn một direction hay không?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tip: cách nhận diện bạn đang có nhiều hơn một direction hay không?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80df-a258-c92d6b26f6e6",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-30T15:03:00.000Z",
        "last_edited_time": "2024-12-30T15:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nghĩ xem với các idea hiện có, chúng có đem lại một benefit hoàn toàn khác nhau không?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nghĩ xem với các idea hiện có, chúng có đem lại một benefit hoàn toàn khác nhau không?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-80df-bbd6-e5acfd0cd68b",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-30T15:03:00.000Z",
        "last_edited_time": "2024-12-30T15:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hoặc dùng affinity mapping để nhóm các idea có tính tương đồng, nhóm đến khi không thể nhóm được nữa >> số nhóm = direction. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hoặc dùng affinity mapping để nhóm các idea có tính tương đồng, nhóm đến khi không thể nhóm được nữa >> số nhóm = direction. ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80f2-85f5-e71c94d6fafe",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-23T13:10:00.000Z",
        "last_edited_time": "2024-12-23T13:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Aware the box, then ask what else could be outside the box?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Aware the box, then ask what else could be outside the box?",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-80a5-bd08-f4a818c6a484",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2025-01-21T02:21:00.000Z",
        "last_edited_time": "2025-01-21T02:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80b8-980d-c07a66b9eb17",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:33:00.000Z",
        "last_edited_time": "2024-12-22T13:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: để cải thiện trình độ tiếng anh, ta có các idea sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: để cải thiện trình độ tiếng anh, ta có các idea sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80c9-83d0-d23cb6551d11",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:34:00.000Z",
        "last_edited_time": "2024-12-22T13:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Học sách vở",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Học sách vở",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80e9-929f-ced183588d10",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:34:00.000Z",
        "last_edited_time": "2024-12-22T13:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Học qua app",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Học qua app",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8084-820a-deb77973a515",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:34:00.000Z",
        "last_edited_time": "2024-12-22T13:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Học bằng việc xem phim với subtitle tiếng anh",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Học bằng việc xem phim với subtitle tiếng anh",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80fb-8018-fc074fb239d8",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:35:00.000Z",
        "last_edited_time": "2024-12-22T13:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Học khoá học phản xạ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Học khoá học phản xạ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8053-a99d-c8dcb5c41341",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:35:00.000Z",
        "last_edited_time": "2024-12-22T13:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đến trường luyện thi Ielts",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đến trường luyện thi Ielts",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-806d-9436-e3fde6a593c0",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:35:00.000Z",
        "last_edited_time": "2024-12-22T13:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "etc",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "etc",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8046-8c46-c32547ada034",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-22T13:35:00.000Z",
        "last_edited_time": "2024-12-30T15:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có thể thấy tất cả idea này có thể nhóm lại là mình cần phải học từ trường lớp đến tự học, từ trả phí đến không trả phí. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có thể thấy tất cả idea này có thể nhóm lại là mình cần phải học từ trường lớp đến tự học, từ trả phí đến không trả phí. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16c5d164-78d8-8099-8d13-d95698879871",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-30T15:05:00.000Z",
        "last_edited_time": "2024-12-30T15:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhưng một hôm mình tình cờ chạy trên đường thấy có dịch vụ chạy xe chở các khách du lịch nước ngoài đi vòng vòng Sài Gòn >> Ồ! Mình nhận ra đây cũng là một cách, vừa có thể kiếm thêm thu nhập lại vừa có thể luyện tiếng anh một cách rất thực tế & tự nhiên >> đây có thể xem là một direction hoàn toàn khác (vừa học vừa được trả phí).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhưng một hôm mình tình cờ chạy trên đường thấy có dịch vụ chạy xe chở các khách du lịch nước ngoài đi vòng vòng Sài Gòn >> Ồ! Mình nhận ra đây cũng là một cách, vừa có thể kiếm thêm thu nhập lại vừa có thể luyện tiếng anh một cách rất thực tế & tự nhiên >> đây có thể xem là một direction hoàn toàn khác (vừa học vừa được trả phí).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-8022-bddb-e81e03c6f6e6",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-15T15:16:00.000Z",
        "last_edited_time": "2024-12-15T15:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-8137-9f3d-ed854e003054",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-10T12:16:00.000Z",
        "last_edited_time": "2024-12-16T02:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-801d-818d-d153ce951a8f",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-23T02:05:00.000Z",
        "last_edited_time": "2024-12-23T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.ideou.com/blogs/inspiration/7-simple-rules-of-brainstorming",
                "link": {
                  "url": "https://www.ideou.com/blogs/inspiration/7-simple-rules-of-brainstorming"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.ideou.com/blogs/inspiration/7-simple-rules-of-brainstorming",
              "href": "https://www.ideou.com/blogs/inspiration/7-simple-rules-of-brainstorming"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-8174-8a0a-d296245b6656",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-10T12:16:00.000Z",
        "last_edited_time": "2024-12-15T15:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.interaction-design.org/literature/article/learn-how-to-use-the-best-ideation-methods-analogies",
                "link": {
                  "url": "https://www.interaction-design.org/literature/article/learn-how-to-use-the-best-ideation-methods-analogies"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.interaction-design.org/literature/article/learn-how-to-use-the-best-ideation-methods-analogies",
              "href": "https://www.interaction-design.org/literature/article/learn-how-to-use-the-best-ideation-methods-analogies"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-815a-a9e8-c71812756b5d",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-10T12:16:00.000Z",
        "last_edited_time": "2024-12-15T15:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://craftinnovations.global/7-best-methods-for-ideation/",
                "link": {
                  "url": "https://craftinnovations.global/7-best-methods-for-ideation/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://craftinnovations.global/7-best-methods-for-ideation/",
              "href": "https://craftinnovations.global/7-best-methods-for-ideation/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-8158-aa11-fd64cf0e60b9",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-10T12:16:00.000Z",
        "last_edited_time": "2024-12-10T12:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-8169-9b71-c2a4d4139b7a",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-10T12:16:00.000Z",
        "last_edited_time": "2024-12-10T12:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15e5d164-78d8-8027-8329-d826b20e2ea8",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-16T05:44:00.000Z",
        "last_edited_time": "2024-12-16T05:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "15e5d164-78d8-80c8-ac9e-ff1a29784a09"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ideate (P2)",
              "href": "https://app.notion.com/p/15e5d16478d880c8ac9eff1a29784a09"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-81a9-9e84-f8158635b002",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-10T12:16:00.000Z",
        "last_edited_time": "2024-12-15T15:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1505d164-78d8-80f8-9aad-e59e03c067dc"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Brainstorm toolkit",
              "href": "https://app.notion.com/p/1505d16478d880f89aade59e03c067dc"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15d5d164-78d8-8067-aaa5-dd53c17879fb",
        "parent": {
          "type": "page_id",
          "page_id": "1585d164-78d8-80c3-b602-e97f38fd7948"
        },
        "created_time": "2024-12-15T15:15:00.000Z",
        "last_edited_time": "2024-12-15T15:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Decision making (P1)",
              "href": "https://app.notion.com/p/b2deb93698dc4fafaadc9cfcb4a6c302"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e",
    "created_time": "2024-10-24T12:24:00.000Z",
    "last_edited_time": "2025-05-22T05:29:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "2-Think",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2025-05-22T05:29:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": "}`k_",
          "name": "⚓:2",
          "color": "green"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 28
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2024-10-24T12:24:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "“Figjam before Figma”",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "“Figjam before Figma”",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Figjam-before-Figma-b3551d4fd6db48b293bd21c9a7ea792e",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
      "name": "Think",
      "slug": "think",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "1295d164-78d8-81e1-b9bf-cfafa34bffd4",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2024-10-24T12:24:00.000Z",
        "last_edited_time": "2025-05-22T05:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081602/uxcomic-imgs/1295d164-78d8-81e1-b9bf-cfafa34bffd4.png",
            "expiry_time": "2026-10-04T09:12:37.537Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1295d164-78d8-81e1-b9bf-cfafa34bffd4"
      },
      {
        "object": "block",
        "id": "1295d164-78d8-8151-8693-d5738868a6e5",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2024-10-24T12:24:00.000Z",
        "last_edited_time": "2024-12-10T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu bạn đã dùng qua Figjam thì cũng biết nó là một canvas để chúng ta note và playround với đống note đó, là một kiểu “write down our thought”. “Figjam before Figma” nghĩa là hãy nghĩ trước khi design (mình nghe được từ này từ một a lead designer, xong nghe vui vui mà cũng đúng thiệt). ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu bạn đã dùng qua Figjam thì cũng biết nó là một canvas để chúng ta note và playround với đống note đó, là một kiểu “write down our thought”. “Figjam before Figma” nghĩa là hãy nghĩ trước khi design (mình nghe được từ này từ một a lead designer, xong nghe vui vui mà cũng đúng thiệt). ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-800e-84d8-d378517fb1ef",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2024-12-10T02:19:00.000Z",
        "last_edited_time": "2024-12-10T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lí do không đụng vào Figma trước là vì khi đã vào Figma, ta hay có xu hướng vẽ UI trước, lúc này mình nghĩ dưới góc độ UI-driven, rất dễ stuck với một ý tưởng hoặc 1 hướng nào đó, vì lúc đó đầu ta chỉ nhảy số với interaction, layout, icon text,… chúng ta bỏ quên cái nhìn tổng thể, bỏ quên các hướng tiếp cận riêng biệt (concept).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lí do không đụng vào Figma trước là vì khi đã vào Figma, ta hay có xu hướng vẽ UI trước, lúc này mình nghĩ dưới góc độ UI-driven, rất dễ stuck với một ý tưởng hoặc 1 hướng nào đó, vì lúc đó đầu ta chỉ nhảy số với interaction, layout, icon text,… chúng ta bỏ quên cái nhìn tổng thể, bỏ quên các hướng tiếp cận riêng biệt (concept).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1545d164-78d8-8038-be38-d9479292e9fa",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2024-12-06T01:46:00.000Z",
        "last_edited_time": "2024-12-20T02:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081604/uxcomic-imgs/1545d164-78d8-8038-be38-d9479292e9fa.jpg",
            "expiry_time": "2026-10-04T09:12:37.538Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1545d164-78d8-8038-be38-d9479292e9fa"
      },
      {
        "object": "block",
        "id": "1fb5d164-78d8-804e-bbf5-f7b276f4c740",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2025-05-22T05:29:00.000Z",
        "last_edited_time": "2025-05-22T05:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1515d164-78d8-8045-b5c2-d40804406527",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2024-12-03T12:03:00.000Z",
        "last_edited_time": "2025-05-22T05:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy cụ thể chúng ta làm gì khi ở Figjam stage? Chúng ta cần suy nghĩ về cái gì? ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy cụ thể chúng ta làm gì khi ở Figjam stage? Chúng ta cần suy nghĩ về cái gì? ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-80e9-99aa-e64806abe082",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2024-12-10T02:20:00.000Z",
        "last_edited_time": "2024-12-20T02:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Câu trả lời là tất cả những gì cần nghĩ khi design, là problem framing, là lên concept, là phân tích các case, note down các constraints, dependencies… tất cả đống note này sẽ support cho system thinking để suy xét kĩ vấn đề, giải pháp. Có thể hình dung đống note đó như những viên gạch, và cách bạn sắp xếp, make sense chúng tựa như xi măng, bạn sẽ dùng nó để phục vụ cho giai đoạn design (Figma). Căn nhà càng to (vấn đề phức tạp hoặc không rõ ràng) thì bạn càng cần nhiều gạch & xi măng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Câu trả lời là tất cả những gì cần nghĩ khi design, là problem framing, là lên concept, là phân tích các case, note down các constraints, dependencies… tất cả đống note này sẽ support cho system thinking để suy xét kĩ vấn đề, giải pháp. Có thể hình dung đống note đó như những viên gạch, và cách bạn sắp xếp, make sense chúng tựa như xi măng, bạn sẽ dùng nó để phục vụ cho giai đoạn design (Figma). Căn nhà càng to (vấn đề phức tạp hoặc không rõ ràng) thì bạn càng cần nhiều gạch & xi măng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-81a3-8418-e80c91ab5d55",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2024-10-24T12:24:00.000Z",
        "last_edited_time": "2024-12-20T02:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Xét vấn đề (Problem Framing)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Xét vấn đề (Problem Framing)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-8105-b4f9-d4d117cbc4de",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2024-10-24T12:24:00.000Z",
        "last_edited_time": "2024-12-04T02:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Làm rõ tất tần tật mọi thứ liên quan đến vấn đề bạn chuẩn bị tackle. Bạn có thể xem qua ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Làm rõ tất tần tật mọi thứ liên quan đến vấn đề bạn chuẩn bị tackle. Bạn có thể xem qua ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "bài này",
                "link": {
                  "url": "/10f5d16478d8808484a5d6eff66f3eec"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "bài này",
              "href": "/10f5d16478d8808484a5d6eff66f3eec"
            },
            {
              "type": "text",
              "text": {
                "content": " & ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " & ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "bài này",
                "link": {
                  "url": "/1265d16478d8804587d2e2532aae0b64"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "bài này",
              "href": "/1265d16478d8804587d2e2532aae0b64"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-819f-a7bb-d5f8c59bda51",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2024-10-24T12:24:00.000Z",
        "last_edited_time": "2024-12-20T02:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nghĩ giải pháp (Conceptualize the solution)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nghĩ giải pháp (Conceptualize the solution)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1525d164-78d8-80e0-8be4-d380481a75bf",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2024-12-04T02:24:00.000Z",
        "last_edited_time": "2024-12-20T02:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là lúc ta nghĩ về solution, các hướng tiếp cận ở mức độ tổng quan đến chi tiết (",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là lúc ta nghĩ về solution, các hướng tiếp cận ở mức độ tổng quan đến chi tiết (",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "direction vs option",
                "link": {
                  "url": "/1585d16478d880c3b602e97f38fd7948"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "direction vs option",
              "href": "/1585d16478d880c3b602e97f38fd7948"
            },
            {
              "type": "text",
              "text": {
                "content": "). Là việc list ra các solution, đánh giá mức độ hiệu quả & các trade off. Bạn có thể tham khảo các ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "). Là việc list ra các solution, đánh giá mức độ hiệu quả & các trade off. Bạn có thể tham khảo các ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "tip này ",
                "link": {
                  "url": "/1505d16478d880f89aade59e03c067dc"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "tip này ",
              "href": "/1505d16478d880f89aade59e03c067dc"
            },
            {
              "type": "text",
              "text": {
                "content": "cho việc lên ý tưởng. Và ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cho việc lên ý tưởng. Và ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "bài này",
                "link": {
                  "url": "/b2deb93698dc4fafaadc9cfcb4a6c302"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "bài này",
              "href": "/b2deb93698dc4fafaadc9cfcb4a6c302"
            },
            {
              "type": "text",
              "text": {
                "content": " để support cho việc ra quyết định.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " để support cho việc ra quyết định.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1535d164-78d8-807e-a280-f44542ba1e01",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2024-12-05T06:15:00.000Z",
        "last_edited_time": "2024-12-20T02:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Minh hoạ cho việc này, hãy tưởng tượng với  mỗi mẫu thông tin tựa như một nguyên tố hoá học, nhưng cách bạn gắn kết chúng sẽ tạo ra những chất khác nhau.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Minh hoạ cho việc này, hãy tưởng tượng với  mỗi mẫu thông tin tựa như một nguyên tố hoá học, nhưng cách bạn gắn kết chúng sẽ tạo ra những chất khác nhau.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1625d164-78d8-8066-96d0-f9feaaa99b6a",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2024-12-20T02:17:00.000Z",
        "last_edited_time": "2024-12-20T02:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [
            {
              "type": "text",
              "text": {
                "content": "Cùng nguyên tố carbon, tuỳ cách chúng gắn kết mà có thể cho ra than, mực đen hoặc kim cương",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cùng nguyên tố carbon, tuỳ cách chúng gắn kết mà có thể cho ra than, mực đen hoặc kim cương",
              "href": null
            }
          ],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081606/uxcomic-imgs/1625d164-78d8-8066-96d0-f9feaaa99b6a.jpg",
            "expiry_time": "2026-10-04T09:12:37.538Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1625d164-78d8-8066-96d0-f9feaaa99b6a"
      },
      {
        "object": "block",
        "id": "1fb5d164-78d8-8090-bb9c-d1d7ac90b9a7",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2025-05-22T05:26:00.000Z",
        "last_edited_time": "2025-05-22T05:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "3 câu hỏi chính giúp bạn gắn kết chúng là:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3 câu hỏi chính giúp bạn gắn kết chúng là:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fb5d164-78d8-8001-af8c-dce65959392b",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2025-05-22T05:26:00.000Z",
        "last_edited_time": "2025-05-22T05:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Why",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Why",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": xác định lý do, tính chủ đích & mục tiêu của action đó",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": xác định lý do, tính chủ đích & mục tiêu của action đó",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fb5d164-78d8-8066-976a-caca6a02eb17",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2025-05-22T05:27:00.000Z",
        "last_edited_time": "2025-05-22T05:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "What if",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "What if",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": mở rộng giải pháp để tìm ra hướng tối ưu & phù hợp nhất.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": mở rộng giải pháp để tìm ra hướng tối ưu & phù hợp nhất.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fb5d164-78d8-80b6-bb4c-d1d4c1b9250f",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2025-05-22T05:27:00.000Z",
        "last_edited_time": "2025-05-22T05:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "What does it effects",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "What does it effects",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": nhìn cách decision mình đưa ra tạo ra ảnh hưởng gì (cả tốt & xấu, trong ngắn & dài hạn)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": nhìn cách decision mình đưa ra tạo ra ảnh hưởng gì (cả tốt & xấu, trong ngắn & dài hạn)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1fb5d164-78d8-8045-9f29-fe9eae60694d",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2025-05-22T05:28:00.000Z",
        "last_edited_time": "2025-05-22T05:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1525d164-78d8-80e1-81d0-f657f4027713",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2024-12-04T02:27:00.000Z",
        "last_edited_time": "2025-05-22T05:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Collaboration ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Collaboration ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1525d164-78d8-80ca-b62a-d0af31b7a091",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2024-12-04T02:27:00.000Z",
        "last_edited_time": "2025-05-22T05:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Do ở Figjam, những output mình làm ra là những tờ note & cách sắp xếp thông tin, vậy nên trong quá trình trình bày với các stakeholder chúng ta cũng sẽ thảo luận dựa trên mớ note ấy hay có thể nói là thảo luận về cách chúng ta suy nghĩ về vấn đề & giải pháp. Việc không show UI giúp chúng ta tập trung vào vấn đề giải pháp hơn là cách design, điều này rất quan trọng, chúng ta cần align những vấn đề này trước khi bắt tay vào design. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Do ở Figjam, những output mình làm ra là những tờ note & cách sắp xếp thông tin, vậy nên trong quá trình trình bày với các stakeholder chúng ta cũng sẽ thảo luận dựa trên mớ note ấy hay có thể nói là thảo luận về cách chúng ta suy nghĩ về vấn đề & giải pháp. Việc không show UI giúp chúng ta tập trung vào vấn đề giải pháp hơn là cách design, điều này rất quan trọng, chúng ta cần align những vấn đề này trước khi bắt tay vào design. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-8114-999b-f04c481360f9",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2024-10-24T12:24:00.000Z",
        "last_edited_time": "2024-10-24T12:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-81aa-9c3f-ef1a4a00a222",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2024-10-24T12:24:00.000Z",
        "last_edited_time": "2024-10-24T12:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-814c-b3f2-fa2f4e68a24f",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2024-10-24T12:24:00.000Z",
        "last_edited_time": "2024-10-24T12:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://storytribeapp.com/blog/why-lo-fi-the-power-of-simplicity/blog/why-lo-fi-the-power-of-simplicity",
                "link": {
                  "url": "https://storytribeapp.com/blog/why-lo-fi-the-power-of-simplicity/blog/why-lo-fi-the-power-of-simplicity"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://storytribeapp.com/blog/why-lo-fi-the-power-of-simplicity/blog/why-lo-fi-the-power-of-simplicity",
              "href": "https://storytribeapp.com/blog/why-lo-fi-the-power-of-simplicity/blog/why-lo-fi-the-power-of-simplicity"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-81a5-9a80-d12c160c4dc3",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2024-10-24T12:24:00.000Z",
        "last_edited_time": "2024-10-24T12:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-81c7-9f6e-e8cff4ef071e",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2024-10-24T12:24:00.000Z",
        "last_edited_time": "2024-10-24T12:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-815b-b890-cca3025f6a5e",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2024-10-24T12:24:00.000Z",
        "last_edited_time": "2024-12-06T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1265d164-78d8-8045-87d2-e2532aae0b64"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Brief (Hiểu đề)",
              "href": "https://app.notion.com/p/1265d16478d8804587d2e2532aae0b64"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-8169-bea3-ce4e5095a821",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2024-10-24T12:24:00.000Z",
        "last_edited_time": "2024-12-06T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Rõ dần”",
              "href": "https://app.notion.com/p/5b45ba369dad4a92bccb7e54a1db1c10"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1545d164-78d8-80bf-a81a-d00ac08b8ef9",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2024-12-06T01:48:00.000Z",
        "last_edited_time": "2024-12-06T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1505d164-78d8-80f8-9aad-e59e03c067dc"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Brainstorm toolkit",
              "href": "https://app.notion.com/p/1505d16478d880f89aade59e03c067dc"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1545d164-78d8-80d7-b027-f8cea407e9f3",
        "parent": {
          "type": "page_id",
          "page_id": "b3551d4f-d6db-48b2-93bd-21c9a7ea792e"
        },
        "created_time": "2024-12-06T01:48:00.000Z",
        "last_edited_time": "2024-12-06T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "b2deb936-98dc-4faf-aadc-9cfcb4a6c302"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Decision making (P1)",
              "href": "https://app.notion.com/p/b2deb93698dc4fafaadc9cfcb4a6c302"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079",
    "created_time": "2024-10-24T12:05:00.000Z",
    "last_edited_time": "2024-12-03T11:29:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "3-Build",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2024-12-03T11:29:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": "}QTb",
          "name": "⚔️:2",
          "color": "gray"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 27
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2024-10-24T12:05:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Psychology",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Psychology",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Psychology-bcb5ee9a895149328a469ca5ffafc079",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
      "name": "Build",
      "slug": "build",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "1295d164-78d8-81b7-942a-ed0c3bc60321",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-10-24T12:05:00.000Z",
        "last_edited_time": "2024-11-15T00:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081609/uxcomic-imgs/1295d164-78d8-81b7-942a-ed0c3bc60321.png",
            "expiry_time": "2026-10-04T09:12:38.487Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1295d164-78d8-81b7-942a-ed0c3bc60321"
      },
      {
        "object": "block",
        "id": "1395d164-78d8-8069-a326-cc1b99066dc2",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-09T07:02:00.000Z",
        "last_edited_time": "2024-11-09T07:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tại sao phải biến product của bạn thành 1 chàng trai/cô nàng “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tại sao phải biến product của bạn thành 1 chàng trai/cô nàng “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "tâm lý",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "tâm lý",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "”? ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "”? ",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1395d164-78d8-8050-816e-c0df37c5f11f",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-09T07:01:00.000Z",
        "last_edited_time": "2024-11-10T01:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vì digital product cơ bản là công nghệ thông tin, mà thông tin ảnh hưởng đến cách con người suy nghĩ và hành động, yếu tố này rất liên đới đến tâm lý. Và nó còn đặc biệt hữu ích khi bạn thiết kế cho consumer product, vì product thành công ngoài việc đảm bảo về utility, functionality mà còn phải khiến user khao khát, yêu thích nó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vì digital product cơ bản là công nghệ thông tin, mà thông tin ảnh hưởng đến cách con người suy nghĩ và hành động, yếu tố này rất liên đới đến tâm lý. Và nó còn đặc biệt hữu ích khi bạn thiết kế cho consumer product, vì product thành công ngoài việc đảm bảo về utility, functionality mà còn phải khiến user khao khát, yêu thích nó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1395d164-78d8-801b-ab01-c7972b8d2a36",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-09T06:45:00.000Z",
        "last_edited_time": "2024-11-10T01:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để nắm bắt tâm lý con người là điều không dễ dàng gì, vì con người phức tạp, chúng ta có background khác nhau, có motivation & những nỗi sợ khác nhau, cá tính khác nhau…, cách hiệu quả nhất vẫn là việc mình phải gặp user trực tiếp, quan sát, lắng nghe và cùng họ trải nghiệm, cảm thông cho những nỗi đau và động lực của họ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để nắm bắt tâm lý con người là điều không dễ dàng gì, vì con người phức tạp, chúng ta có background khác nhau, có motivation & những nỗi sợ khác nhau, cá tính khác nhau…, cách hiệu quả nhất vẫn là việc mình phải gặp user trực tiếp, quan sát, lắng nghe và cùng họ trải nghiệm, cảm thông cho những nỗi đau và động lực của họ.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1395d164-78d8-8073-be4b-dab3e3862ece",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-09T06:57:00.000Z",
        "last_edited_time": "2024-11-10T01:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuy nhiên không phải lúc nào mình cũng có time/effort để làm điều này, nên việc hiểu tâm lý chung chung của con người sẽ giúp ích phần nào >> cần hiểu biết về psychology",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuy nhiên không phải lúc nào mình cũng có time/effort để làm điều này, nên việc hiểu tâm lý chung chung của con người sẽ giúp ích phần nào >> cần hiểu biết về psychology",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1395d164-78d8-80b1-8e8c-f68184a27539",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-09T06:47:00.000Z",
        "last_edited_time": "2024-11-10T01:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhưng mà mình đã tìm hiểu, mày mò, đọc các case study,… ôi giời ôi nó nhiều, nó đông như quân nguyên, có đến 100+ tâm lý khác nhau để bạn có thể ứng dụng, vậy làm sao để biết áp dụng được đây, chẳng nhẽ phải nhớ hết các tâm lý đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhưng mà mình đã tìm hiểu, mày mò, đọc các case study,… ôi giời ôi nó nhiều, nó đông như quân nguyên, có đến 100+ tâm lý khác nhau để bạn có thể ứng dụng, vậy làm sao để biết áp dụng được đây, chẳng nhẽ phải nhớ hết các tâm lý đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1395d164-78d8-8083-8bab-d9eb687c8531",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-09T07:10:00.000Z",
        "last_edited_time": "2024-11-09T07:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1395d164-78d8-805a-a001-fb405dd643ae",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-09T07:10:00.000Z",
        "last_edited_time": "2024-11-09T07:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Type",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Type",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1395d164-78d8-8032-b3df-f5ab7a19516f",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-09T07:13:00.000Z",
        "last_edited_time": "2024-11-10T01:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước khi có tactic phù hợp để áp dụng nó cho công việc design, hãy điểm sơ vài dạng psychology mình cần quan tâm đến.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước khi có tactic phù hợp để áp dụng nó cho công việc design, hãy điểm sơ vài dạng psychology mình cần quan tâm đến.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-81d5-87fa-cb4504abc774",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-10-24T12:05:00.000Z",
        "last_edited_time": "2024-11-10T04:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cognitive: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cognitive: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cách mà con người tư duy, định nghĩa, hiểu & ghi nhớ thông tin. Có thể điểm sơ qua cách con người chú ý đến thông tin nào, cách họ hiểu, các thiên kiến, định kiến ảnh hưởng đến việc họ hiểu.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cách mà con người tư duy, định nghĩa, hiểu & ghi nhớ thông tin. Có thể điểm sơ qua cách con người chú ý đến thông tin nào, cách họ hiểu, các thiên kiến, định kiến ảnh hưởng đến việc họ hiểu.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1395d164-78d8-80c4-b7d1-f6af7ac6f8b0",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-09T06:38:00.000Z",
        "last_edited_time": "2024-11-13T01:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Behavior: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Behavior: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cách mà con người lựa chọn & đưa ra quyết định, các xu hướng thói quen được hình thành như thế nào.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cách mà con người lựa chọn & đưa ra quyết định, các xu hướng thói quen được hình thành như thế nào.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "d825338a-b8fc-48e2-8962-6fdd4be9252d",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-10T01:50:00.000Z",
        "last_edited_time": "2024-11-13T01:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Emotion & Attitude: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Emotion & Attitude: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cách mà",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cách mà",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cảm xúc, động lực, thái độ của tác động đến cách họ nghĩ họ làm, tại sao “người buồn cảnh có vui đâu bao giờ”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cảm xúc, động lực, thái độ của tác động đến cách họ nghĩ họ làm, tại sao “người buồn cảnh có vui đâu bao giờ”.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1395d164-78d8-806b-8eee-f29ccbeb97ae",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-09T06:39:00.000Z",
        "last_edited_time": "2024-11-09T07:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1395d164-78d8-8071-9e54-e1ef0ea001c9",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-09T07:15:00.000Z",
        "last_edited_time": "2024-11-09T07:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "How",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "How",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1395d164-78d8-8093-ade5-eb1c31084337",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-09T06:48:00.000Z",
        "last_edited_time": "2024-11-10T02:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Như mình có đề cập ở trên, mình có đến 100+ tâm lý để áp dụng cho ux. Nhưng làm sao để mình nhớ hết được? câu trả lời là bạn không cần, đây là cách mình áp dụng:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Như mình có đề cập ở trên, mình có đến 100+ tâm lý để áp dụng cho ux. Nhưng làm sao để mình nhớ hết được? câu trả lời là bạn không cần, đây là cách mình áp dụng:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "55ffd31d-a797-422d-8d61-553c7da85c17",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-10T02:09:00.000Z",
        "last_edited_time": "2024-11-15T00:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhận diện flow bạn đang làm là gì và suy nghĩ xem main action của user ở đây là gì, họ cần cảm thấy “tính từ” nào.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhận diện flow bạn đang làm là gì và suy nghĩ xem main action của user ở đây là gì, họ cần cảm thấy “tính từ” nào.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "ab08cc41-5f2d-42cc-82e5-dbb14ba2af85",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-10T02:10:00.000Z",
        "last_edited_time": "2024-11-10T02:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bạn đem đi hỏi chatGPT (AI) xem trong flow này tôi đang muốn user cảm thấy vậy, hãy suggest cho tôi hướng tiếp cận.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bạn đem đi hỏi chatGPT (AI) xem trong flow này tôi đang muốn user cảm thấy vậy, hãy suggest cho tôi hướng tiếp cận.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "f983caa3-4d3f-41fc-89a3-53eebdc9e635",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-10T02:12:00.000Z",
        "last_edited_time": "2024-11-10T02:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau đó bạn sẽ có vài keyword mà AI tư vấn cho bạn, bạn đem nó đi search các case study để áp dụng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau đó bạn sẽ có vài keyword mà AI tư vấn cho bạn, bạn đem nó đi search các case study để áp dụng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "19ac02fe-49f2-4a1c-8bcc-6f1a8c880779",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-10T02:13:00.000Z",
        "last_edited_time": "2024-12-03T11:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tất nhiên đây chỉ là short cut, để mình có được cái sense về tâm lý nhiều hơn, thì mình vẫn nên đọc sơ qua các khái niệm, bạn có thể tham khảo thêm ở ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tất nhiên đây chỉ là short cut, để mình có được cái sense về tâm lý nhiều hơn, thì mình vẫn nên đọc sơ qua các khái niệm, bạn có thể tham khảo thêm ở ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "link này.",
                "link": {
                  "url": "https://www.nngroup.com/articles/psychology-study-guide/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "link này.",
              "href": "https://www.nngroup.com/articles/psychology-study-guide/"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "0cf57b7d-11d0-4a84-8f63-51cc9a77b630",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-15T00:26:00.000Z",
        "last_edited_time": "2024-11-15T00:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "0f7ea371-0db2-4da6-845b-8582b5cd1fca",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-15T00:27:00.000Z",
        "last_edited_time": "2024-12-03T11:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi user ở welcome screen, main task ở đây của user là cần hiểu về sản phẩm này làm về gì, mình cần nó “thu hút” & “dễ hiểu” ta có nghĩ đến hiệu ứng thẩm mỹ hay social proof.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi user ở welcome screen, main task ở đây của user là cần hiểu về sản phẩm này làm về gì, mình cần nó “thu hút” & “dễ hiểu” ta có nghĩ đến hiệu ứng thẩm mỹ hay social proof.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "323e1296-d8a3-4ee0-b685-92240e5c0c2c",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-15T00:27:00.000Z",
        "last_edited_time": "2024-11-15T00:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi user ở flow chọn gói, họ đang cần lựa chọn & ra quyết định, ta cần giúp họ dễ ra quyết định hơn bằng việc set default một lựa chọn hay áp dụng hiệu ứng mỏ neo…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi user ở flow chọn gói, họ đang cần lựa chọn & ra quyết định, ta cần giúp họ dễ ra quyết định hơn bằng việc set default một lựa chọn hay áp dụng hiệu ứng mỏ neo…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2b9623ab-6305-4b9b-9709-40b4140e8dfe",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-15T00:28:00.000Z",
        "last_edited_time": "2024-11-15T00:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-8031-aa47-f1179e355aa9",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-12-02T10:36:00.000Z",
        "last_edited_time": "2024-12-02T10:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tóm lại",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tóm lại",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "6684dc97-ae7f-4346-8428-6077c0227b54",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-10T02:15:00.000Z",
        "last_edited_time": "2024-11-10T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để gói gọn lại thì việc áp dụng các tâm lý này cho design, hãy trả lời mấy câu hỏi sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để gói gọn lại thì việc áp dụng các tâm lý này cho design, hãy trả lời mấy câu hỏi sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "309cb2f2-0c35-4c5e-a973-06a3bf422ff3",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-10T02:16:00.000Z",
        "last_edited_time": "2024-11-13T01:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "User đang làm gì với product & họ cần cảm thấy gì khi hoặc sau khi dùng product.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User đang làm gì với product & họ cần cảm thấy gì khi hoặc sau khi dùng product.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "0cabcaaf-f285-4f81-bd46-140643dd7678",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-10T02:17:00.000Z",
        "last_edited_time": "2024-11-13T01:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Product đang muốn gì ở user & tâm lý nào sẽ tác động đến cách user suy nghĩ & hành động.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product đang muốn gì ở user & tâm lý nào sẽ tác động đến cách user suy nghĩ & hành động.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "87509955-24b8-4ad1-981b-f97907cb3230",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-11-10T02:17:00.000Z",
        "last_edited_time": "2024-12-03T11:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Liệu tâm lý này có đúng với tệp user của mình, vì không phải các lý thuyết tâm lý lúc nào cũng hiệu quả, ví dụ: có thuyết càng ít lựa chọn thì con người càng dễ ra quyết định và làm giảm quá trình suy nghĩ, vậy tại sao cùng 1 loại product, phương Tây lại theo hướng tối giản mà phương Đông lại theo hướng show càng nhiều càng tốt, lí do là vì có sự tác động của văn hoá, cuộc sống phương Đông vốn nhộn nhịp xô bồ hơn, dân thì đông mà cảnh tượng “như cái chợ” thì nhiều, trái ngược với phương Tây, mọi thứ thường đã được quy hoạch, dân số thấp, đâu ra đó rõ ràng >> những yếu tố này đã tác động đến hành vi sử dụng của user, khiến “thuyết ít lựa chọn” đúng cho phương Tây nhưng lại không phù hợp cho phương Đông.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Liệu tâm lý này có đúng với tệp user của mình, vì không phải các lý thuyết tâm lý lúc nào cũng hiệu quả, ví dụ: có thuyết càng ít lựa chọn thì con người càng dễ ra quyết định và làm giảm quá trình suy nghĩ, vậy tại sao cùng 1 loại product, phương Tây lại theo hướng tối giản mà phương Đông lại theo hướng show càng nhiều càng tốt, lí do là vì có sự tác động của văn hoá, cuộc sống phương Đông vốn nhộn nhịp xô bồ hơn, dân thì đông mà cảnh tượng “như cái chợ” thì nhiều, trái ngược với phương Tây, mọi thứ thường đã được quy hoạch, dân số thấp, đâu ra đó rõ ràng >> những yếu tố này đã tác động đến hành vi sử dụng của user, khiến “thuyết ít lựa chọn” đúng cho phương Tây nhưng lại không phù hợp cho phương Đông.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-8149-863e-f74aa4e949ef",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-10-24T12:05:00.000Z",
        "last_edited_time": "2024-10-24T12:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-81c9-bed7-f55d7b9cf011",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-10-24T12:05:00.000Z",
        "last_edited_time": "2024-10-24T12:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-81ec-815c-e3cc711f79ea",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-10-24T12:05:00.000Z",
        "last_edited_time": "2024-11-10T02:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.nngroup.com/articles/psychology-study-guide/",
                "link": {
                  "url": "https://www.nngroup.com/articles/psychology-study-guide/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.nngroup.com/articles/psychology-study-guide/",
              "href": "https://www.nngroup.com/articles/psychology-study-guide/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1295d164-78d8-811e-8588-df11bf7c52a0",
        "parent": {
          "type": "page_id",
          "page_id": "bcb5ee9a-8951-4932-8a46-9ca5ffafc079"
        },
        "created_time": "2024-10-24T12:05:00.000Z",
        "last_edited_time": "2024-10-24T12:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1265d164-78d8-8045-87d2-e2532aae0b64",
    "created_time": "2024-10-21T03:38:00.000Z",
    "last_edited_time": "2026-08-18T01:25:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "1-Understand",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2026-08-18T01:25:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": "}QTb",
          "name": "⚔️:2",
          "color": "gray"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 25
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2024-10-21T03:38:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Brief (Hiểu đề)",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Brief (Hiểu đề)",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Brief-Hi-u-1265d16478d8804587d2e2532aae0b64",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
      "name": "Understand",
      "slug": "understand",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "1425d164-78d8-80df-aa02-ee3441fd5207",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-18T11:17:00.000Z",
        "last_edited_time": "2024-11-19T11:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081611/uxcomic-imgs/1425d164-78d8-80df-aa02-ee3441fd5207.png",
            "expiry_time": "2026-10-04T09:12:39.007Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1425d164-78d8-80df-aa02-ee3441fd5207"
      },
      {
        "object": "block",
        "id": "1825d164-78d8-807e-8ac0-cd40eafb3156",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-01-21T02:12:00.000Z",
        "last_edited_time": "2025-08-17T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ta cũng nghe rất nhiều câu chuyện design là problem solving, mình thì hãy convert sang “design cần có tính chủ đích”, chủ đích ở đây thường liên quan đến việc bạn định nghĩa bằng việc trả lời tường tận cho câu hỏi: “cho ai? được gì? như thế nào?”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ta cũng nghe rất nhiều câu chuyện design là problem solving, mình thì hãy convert sang “design cần có tính chủ đích”, chủ đích ở đây thường liên quan đến việc bạn định nghĩa bằng việc trả lời tường tận cho câu hỏi: “cho ai? được gì? như thế nào?”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1265d164-78d8-81a1-af0b-f43ad0be33e0",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-10-21T03:38:00.000Z",
        "last_edited_time": "2025-08-17T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tưởng tượng bạn tốn 3 tháng để build 1 solution, tốn hàng trăm triệu cho nhân lực. Rồi khi mà giải sai đề, các công sức làm ra phải đập đi xây lại, khiến vừa mất thời gian, công sức, nhân sự thì mất động lực, chưa kể đến lỡ solution không giải quyết được vấn đề mà còn làm ảnh hưởng đến các nơi khác, sinh thêm những vấn đề mới, ôi thốn!",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tưởng tượng bạn tốn 3 tháng để build 1 solution, tốn hàng trăm triệu cho nhân lực. Rồi khi mà giải sai đề, các công sức làm ra phải đập đi xây lại, khiến vừa mất thời gian, công sức, nhân sự thì mất động lực, chưa kể đến lỡ solution không giải quyết được vấn đề mà còn làm ảnh hưởng đến các nơi khác, sinh thêm những vấn đề mới, ôi thốn!",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-8096-9003-dd4afa84dac8",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-01-21T02:14:00.000Z",
        "last_edited_time": "2025-01-21T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Còn gì tệ hơn khi giải sai đề 🤯",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Còn gì tệ hơn khi giải sai đề 🤯",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1335d164-78d8-807e-b99a-e0bf3609554d",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-03T08:42:00.000Z",
        "last_edited_time": "2024-11-03T08:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-807e-a657-c4b236880bb8",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-05-13T10:04:00.000Z",
        "last_edited_time": "2025-08-17T02:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các loại đề",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các loại đề",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-80f8-9ddb-c460bdc8704f",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-08-17T02:05:00.000Z",
        "last_edited_time": "2025-08-17T02:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuỳ thuộc vào level của mình, vào công ty/project mình đang thuộc về, chúng định hình nên dạng đề công việc hàng ngày của chúng ta.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuỳ thuộc vào level của mình, vào công ty/project mình đang thuộc về, chúng định hình nên dạng đề công việc hàng ngày của chúng ta.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-8087-a547-f7f270faa68d",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-05-13T10:15:00.000Z",
        "last_edited_time": "2025-05-13T10:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081613/uxcomic-imgs/1f25d164-78d8-8087-a547-f7f270faa68d.png",
            "expiry_time": "2026-10-04T09:12:39.008Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1f25d164-78d8-8087-a547-f7f270faa68d"
      },
      {
        "object": "block",
        "id": "1f25d164-78d8-8056-ad39-d1792f3494bc",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-05-13T10:05:00.000Z",
        "last_edited_time": "2025-05-13T10:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1265d164-78d8-810e-9d71-d8a54ac2714b",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-10-21T03:38:00.000Z",
        "last_edited_time": "2025-08-17T02:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bàn về Problem (Framing)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bàn về Problem (Framing)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1445d164-78d8-80af-8fd2-f64a3b2def04",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-20T05:59:00.000Z",
        "last_edited_time": "2024-12-22T16:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình sẽ dùng một minh hoạ rất hay để gián tiếp nói về câu chuyện framing này đó là góc quay trong điện ảnh.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình sẽ dùng một minh hoạ rất hay để gián tiếp nói về câu chuyện framing này đó là góc quay trong điện ảnh.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1445d164-78d8-80b4-b53c-fbeff34f44aa",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-20T05:59:00.000Z",
        "last_edited_time": "2024-12-22T16:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Góc quay điện ảnh trong phim ảnh không chỉ ảnh hưởng đến cảm xúc mà còn định hướng cách người xem hiểu và cảm nhận câu chuyện. Ví dụ: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Góc quay điện ảnh trong phim ảnh không chỉ ảnh hưởng đến cảm xúc mà còn định hướng cách người xem hiểu và cảm nhận câu chuyện. Ví dụ: ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1445d164-78d8-80e0-b363-c28e3eeb1532",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-20T05:59:00.000Z",
        "last_edited_time": "2024-11-20T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Extreme Long Shot:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Extreme Long Shot:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " dùng để thiết lập bối cảnh hoặc cung cấp cái nhìn bao quát.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " dùng để thiết lập bối cảnh hoặc cung cấp cái nhìn bao quát.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1445d164-78d8-803a-aad3-f4c2e810b818",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-20T05:59:00.000Z",
        "last_edited_time": "2024-11-20T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Long Shot:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Long Shot:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " giúp người xem hiểu nhân vật trong bối cảnh cụ thể.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " giúp người xem hiểu nhân vật trong bối cảnh cụ thể.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1445d164-78d8-809e-b5ef-e95a5acd1bf1",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-20T05:59:00.000Z",
        "last_edited_time": "2024-11-20T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Medium Shot",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Medium Shot",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": tạo cảm giác gần gũi hơn nhưng vẫn khách quan.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": tạo cảm giác gần gũi hơn nhưng vẫn khách quan.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1445d164-78d8-8006-9482-ec92087fbd62",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-20T05:59:00.000Z",
        "last_edited_time": "2024-11-20T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Close-up:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Close-up:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " làm nổi bật cảm xúc và chi tiết, tạo sự gần gũi.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " làm nổi bật cảm xúc và chi tiết, tạo sự gần gũi.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1445d164-78d8-80e3-b51e-d44a2dbcb6f2",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-20T05:59:00.000Z",
        "last_edited_time": "2024-11-20T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Extreme Close-up:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Extreme Close-up:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " tạo sự hồi hộp, bí ẩn, hoặc nhấn mạnh yếu tố quan trọng trong câu chuyện.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " tạo sự hồi hộp, bí ẩn, hoặc nhấn mạnh yếu tố quan trọng trong câu chuyện.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1445d164-78d8-8080-aaaf-f91f08542f0e",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-20T05:59:00.000Z",
        "last_edited_time": "2024-11-20T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081614/uxcomic-imgs/1445d164-78d8-8080-aaaf-f91f08542f0e.png",
            "expiry_time": "2026-10-04T09:12:39.008Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1445d164-78d8-8080-aaaf-f91f08542f0e"
      },
      {
        "object": "block",
        "id": "1445d164-78d8-8082-a340-faad4c3b46bb",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-20T05:59:00.000Z",
        "last_edited_time": "2024-12-22T16:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tương tự, trong ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tương tự, trong ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "problem framing",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "problem framing",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", cách chúng ta định hình và trình bày vấn đề sẽ ảnh hưởng trực tiếp đến cách chúng ta hiểu và giải quyết chúng. Nên tốt nhất là ta nên đi qua được hết mấy shot này, từ tổng quan đến chi tiết rồi từ chi tiết đi ra tổng quan, liên tục ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", cách chúng ta định hình và trình bày vấn đề sẽ ảnh hưởng trực tiếp đến cách chúng ta hiểu và giải quyết chúng. Nên tốt nhất là ta nên đi qua được hết mấy shot này, từ tổng quan đến chi tiết rồi từ chi tiết đi ra tổng quan, liên tục ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "zoom in, zoom out.",
                "link": {
                  "url": "/1195d16478d880fd9af8c482d6330662"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "zoom in, zoom out.",
              "href": "/1195d16478d880fd9af8c482d6330662"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "d3f20f95-b405-4ad4-9fde-fa8d983d76e9",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-12T01:51:00.000Z",
        "last_edited_time": "2024-11-18T13:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "3 nhiệm vụ quan trọng nhất trong framing là:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3 nhiệm vụ quan trọng nhất trong framing là:",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "1425d164-78d8-8013-810d-d2f841744b01",
            "parent": {
              "type": "block_id",
              "block_id": "d3f20f95-b405-4ad4-9fde-fa8d983d76e9"
            },
            "created_time": "2024-11-18T11:11:00.000Z",
            "last_edited_time": "2024-11-18T13:42:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Nắm tổng quát & bối cảnh vấn đề",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Nắm tổng quát & bối cảnh vấn đề",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 0
          },
          {
            "object": "block",
            "id": "1425d164-78d8-8069-a2d0-eb0eb3e51bdc",
            "parent": {
              "type": "block_id",
              "block_id": "d3f20f95-b405-4ad4-9fde-fa8d983d76e9"
            },
            "created_time": "2024-11-18T11:12:00.000Z",
            "last_edited_time": "2025-02-10T02:12:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Tính xác thực của những lí luận về vấn đề",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Tính xác thực của những lí luận về vấn đề",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 1
          },
          {
            "object": "block",
            "id": "1425d164-78d8-8058-b46e-e59e779d9dfc",
            "parent": {
              "type": "block_id",
              "block_id": "d3f20f95-b405-4ad4-9fde-fa8d983d76e9"
            },
            "created_time": "2024-11-18T11:12:00.000Z",
            "last_edited_time": "2024-11-19T11:09:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Hiểu độ sâu & độ đa chiều của vấn đề",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Hiểu độ sâu & độ đa chiều của vấn đề",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 2
          }
        ]
      },
      {
        "object": "block",
        "id": "1825d164-78d8-806f-ad73-fd1a91ab15b7",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-01-21T02:16:00.000Z",
        "last_edited_time": "2025-01-21T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-804d-b037-d1f07eea88c6",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-18T11:11:00.000Z",
        "last_edited_time": "2024-11-18T11:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vài câu hỏi ví dụ cho quá trình framing:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vài câu hỏi ví dụ cho quá trình framing:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1265d164-78d8-81c1-9b8a-e7dd1cf01a51",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-10-21T03:38:00.000Z",
        "last_edited_time": "2024-11-19T11:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cho tôi biết lí do vì sao sinh ra problem này? Tình huống, câu chuyện của nó là gì? Tại sao ta xem nó là vấn đề? Mức độ của problem này thế nào (nếu được thì quy ra số), độ ảnh hưởng, tần suất xảy ra của nó…?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cho tôi biết lí do vì sao sinh ra problem này? Tình huống, câu chuyện của nó là gì? Tại sao ta xem nó là vấn đề? Mức độ của problem này thế nào (nếu được thì quy ra số), độ ảnh hưởng, tần suất xảy ra của nó…?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "7d861316-cb6c-4057-8cb8-4ca601c8abd7",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-12T01:55:00.000Z",
        "last_edited_time": "2025-08-17T02:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có data, research, chứng cứ gì cho việc bạn xác định nó là vấn đề không? Liệu có assumption nào cần được validate? ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có data, research, chứng cứ gì cho việc bạn xác định nó là vấn đề không? Liệu có assumption nào cần được validate? ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "fdc0ee36-b142-487d-8191-52bd4262f799",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-12T01:56:00.000Z",
        "last_edited_time": "2025-08-17T02:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Problem này tác động đến những ai, đến mình hay đến tệp user nào đó? (về user có thể xem thêm bài ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Problem này tác động đến những ai, đến mình hay đến tệp user nào đó? (về user có thể xem thêm bài ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "User multiverse",
                "link": {
                  "url": "/22a3b4bb88d34f84a70f83e7c12ac91d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User multiverse",
              "href": "/22a3b4bb88d34f84a70f83e7c12ac91d"
            },
            {
              "type": "text",
              "text": {
                "content": ").",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ").",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "b096b087-3c08-497d-993d-27db3a824021",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-12T01:54:00.000Z",
        "last_edited_time": "2024-12-25T02:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy giải pháp hiện tại của user là gì? Có điểm gì bất cập với giải pháp đó? Journey của họ đang như thế nào?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy giải pháp hiện tại của user là gì? Có điểm gì bất cập với giải pháp đó? Journey của họ đang như thế nào?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1435d164-78d8-8089-a2c1-ebf2aace366d",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-19T11:09:00.000Z",
        "last_edited_time": "2025-08-17T02:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Challenge của project này là gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Challenge của project này là gì?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-8088-a8d6-f1ea14431f4a",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-01-21T02:16:00.000Z",
        "last_edited_time": "2025-01-21T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "721808a9-4753-4ce2-91c0-c1c112ed2767",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-12T02:00:00.000Z",
        "last_edited_time": "2025-03-08T06:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tips",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tips",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": áp dụng các framework như Abstract Ladder, First Principles, 5 Whys, Fishbone Diagram, và Problem Statement Canvas, Job Story để phân tích và biểu diễn vấn đề một cách trực quan, tổng quát.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": áp dụng các framework như Abstract Ladder, First Principles, 5 Whys, Fishbone Diagram, và Problem Statement Canvas, Job Story để phân tích và biểu diễn vấn đề một cách trực quan, tổng quát.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "7848da97-6768-4304-b97c-22b62cf5e609",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-12T02:03:00.000Z",
        "last_edited_time": "2024-11-12T14:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081616/uxcomic-imgs/7848da97-6768-4304-b97c-22b62cf5e609.png",
            "expiry_time": "2026-10-04T09:12:39.075Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/7848da97-6768-4304-b97c-22b62cf5e609"
      },
      {
        "object": "block",
        "id": "3eba6d1f-4689-4357-a6a6-a2636b7a8e7d",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-12T02:03:00.000Z",
        "last_edited_time": "2024-11-12T14:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081617/uxcomic-imgs/3eba6d1f-4689-4357-a6a6-a2636b7a8e7d.png",
            "expiry_time": "2026-10-04T09:12:39.075Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/3eba6d1f-4689-4357-a6a6-a2636b7a8e7d"
      },
      {
        "object": "block",
        "id": "1765d164-78d8-80b9-86b0-deffac3e9c53",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-01-09T16:33:00.000Z",
        "last_edited_time": "2025-01-09T16:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081619/uxcomic-imgs/1765d164-78d8-80b9-86b0-deffac3e9c53.jpg",
            "expiry_time": "2026-10-04T09:12:39.075Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1765d164-78d8-80b9-86b0-deffac3e9c53"
      },
      {
        "object": "block",
        "id": "1335d164-78d8-808a-b926-d7dcc556b237",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-03T08:29:00.000Z",
        "last_edited_time": "2024-11-03T08:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1335d164-78d8-800a-9e76-d02a63554916",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-03T08:29:00.000Z",
        "last_edited_time": "2025-08-17T02:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bàn về Solution",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bàn về Solution",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1445d164-78d8-8064-90ed-e96e9a68b050",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-20T11:13:00.000Z",
        "last_edited_time": "2025-08-17T02:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thông thường trong công việc, ở hoàn cảnh hiện tại của mình thì mình thấy việc form lên giải pháp không nằm trong scope của UX/UI, nó thường nằm ở PM/PO, hoặc nếu bạn được tham gia vào strategy thì còn may ra được contribute vào. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thông thường trong công việc, ở hoàn cảnh hiện tại của mình thì mình thấy việc form lên giải pháp không nằm trong scope của UX/UI, nó thường nằm ở PM/PO, hoặc nếu bạn được tham gia vào strategy thì còn may ra được contribute vào. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-80f3-bd49-d5c147162b04",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-08-17T02:09:00.000Z",
        "last_edited_time": "2025-08-17T02:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nên phần lớn nhiệm vụ của chúng ta là người đi transform solution, chúng ta giúp biến solution đó thành hình, thành một bản vẽ để cho các kĩ sư (dev) xây nhà sao cho hợp phong thuỷ. Và để hợp phong thuỷ, ta cần trả lời các câu sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nên phần lớn nhiệm vụ của chúng ta là người đi transform solution, chúng ta giúp biến solution đó thành hình, thành một bản vẽ để cho các kĩ sư (dev) xây nhà sao cho hợp phong thuỷ. Và để hợp phong thuỷ, ta cần trả lời các câu sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "981c2745-4408-4550-af16-2a987c2f4635",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-15T00:37:00.000Z",
        "last_edited_time": "2024-12-25T02:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giải quyết vấn đề này để được gì? Objective của project này là gì? Expectation là gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giải quyết vấn đề này để được gì? Objective của project này là gì? Expectation là gì?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1435d164-78d8-80e9-ba09-ff88dc8436c3",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-19T11:10:00.000Z",
        "last_edited_time": "2025-08-17T02:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Project này có nằm đâu trong tổng thể solution theme, trong strategy? Tại sao ta lại lựa chọn giải quyết nó trong thời điểm hiện tại - why now?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Project này có nằm đâu trong tổng thể solution theme, trong strategy? Tại sao ta lại lựa chọn giải quyết nó trong thời điểm hiện tại - why now?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1335d164-78d8-80b2-afd0-eb5beb318e39",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-03T08:42:00.000Z",
        "last_edited_time": "2024-11-03T08:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các solution idea là gì & tại sao lựa chọn thực thi solution này? Tiêu chí gì để đánh giá các solution?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các solution idea là gì & tại sao lựa chọn thực thi solution này? Tiêu chí gì để đánh giá các solution?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "f19fe9a4-93f5-477d-9ae3-8a9ef8d09eee",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-15T00:39:00.000Z",
        "last_edited_time": "2025-08-17T02:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hypothesis ở đây là gì? Experiment ở đây là gì? ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hypothesis ở đây là gì? Experiment ở đây là gì? ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1335d164-78d8-80c5-8b36-ca78869172a9",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-03T08:58:00.000Z",
        "last_edited_time": "2024-11-03T09:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có exist knowledge, bài học nào ở quá khứ mà liên quan đến solution này không?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có exist knowledge, bài học nào ở quá khứ mà liên quan đến solution này không?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1335d164-78d8-80f0-9848-e7a210094780",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-03T09:05:00.000Z",
        "last_edited_time": "2025-01-21T02:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ngoài thị trường có solution nào same same để tham khảo được không? Họ tackle problem này như thế nào? Điểm gì ta nên giống, điểm gì ta nên khác?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ngoài thị trường có solution nào same same để tham khảo được không? Họ tackle problem này như thế nào? Điểm gì ta nên giống, điểm gì ta nên khác?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1335d164-78d8-808a-b9ba-f4366c320b1a",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-03T08:34:00.000Z",
        "last_edited_time": "2024-11-15T00:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình đã cân nhắc đến risk của solution này chưa? Liệu nó có những contraints hay restrictions nào cần làm rõ trước không? Liệu có dependencies nào cần check không, có đụng đến feature, function nào khác không, có tác động tiêu cực gì đến department nào khác không? Có thể tham khảo framework pre-mortem để đánh giá mức độ các risk.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình đã cân nhắc đến risk của solution này chưa? Liệu nó có những contraints hay restrictions nào cần làm rõ trước không? Liệu có dependencies nào cần check không, có đụng đến feature, function nào khác không, có tác động tiêu cực gì đến department nào khác không? Có thể tham khảo framework pre-mortem để đánh giá mức độ các risk.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1335d164-78d8-80f3-9ddc-f505c2707b3f",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-03T08:35:00.000Z",
        "last_edited_time": "2024-12-25T02:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Làm sao để measure success, khi nào ta biết solution work? Benchmark thế nào được xem là thành công, ta dựa trên metrics nào để đánh giá?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Làm sao để measure success, khi nào ta biết solution work? Benchmark thế nào được xem là thành công, ta dựa trên metrics nào để đánh giá?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-8014-b913-f54d3bf837c7",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-01-21T02:16:00.000Z",
        "last_edited_time": "2025-01-21T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1445d164-78d8-80a8-80bc-d6bd9db77f88",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-20T16:46:00.000Z",
        "last_edited_time": "2024-12-25T02:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: các câu hỏi này có thể liên quan đến strategy, có thể PM/PO sẽ không cần share cho bạn, vì đó là scope của họ. Tuy nhiên mình cần được inspire, nên hãy cứ hỏi nhé, hỏi sao cho khéo là được, đừng hỏi như kiểu hỏi cung hay thăm dò tội phạm 😅.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: các câu hỏi này có thể liên quan đến strategy, có thể PM/PO sẽ không cần share cho bạn, vì đó là scope của họ. Tuy nhiên mình cần được inspire, nên hãy cứ hỏi nhé, hỏi sao cho khéo là được, đừng hỏi như kiểu hỏi cung hay thăm dò tội phạm 😅.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-80fa-b801-e23248e1315f",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-08-17T02:13:00.000Z",
        "last_edited_time": "2025-08-17T02:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-8042-980b-c368e70b4386",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-08-17T02:13:00.000Z",
        "last_edited_time": "2025-08-17T02:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tip: nếu solution mang trong nó những “tính từ”, ví dụ “nhanh hơn”, “phong phú hơn”, “dễ tiếp cận hơn”… thì nên ngồi xuống align thêm việc ta định nghĩa chúng như thế nào, biết “tính từ” thành “noun hoặc verb”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tip: nếu solution mang trong nó những “tính từ”, ví dụ “nhanh hơn”, “phong phú hơn”, “dễ tiếp cận hơn”… thì nên ngồi xuống align thêm việc ta định nghĩa chúng như thế nào, biết “tính từ” thành “noun hoặc verb”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1335d164-78d8-80c6-bfa5-dc550a4899b3",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-03T09:03:00.000Z",
        "last_edited_time": "2024-11-03T09:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1335d164-78d8-8053-9911-eb64f373bea2",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-03T08:43:00.000Z",
        "last_edited_time": "2025-08-17T02:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bàn về Scope",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bàn về Scope",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1445d164-78d8-8079-969f-db30835ecb83",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-20T16:49:00.000Z",
        "last_edited_time": "2024-12-22T14:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cả 2 phần trên đều là việc set up cho cái hiểu, giờ là lúc bàn đến cái làm. Chủ yếu bước này là làm rõ ra các đầu việc cần làm, để hình dung mức độ phức tạp của dự án như thế nào, từ đó có thể estimate được các deliverable item & timeline.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cả 2 phần trên đều là việc set up cho cái hiểu, giờ là lúc bàn đến cái làm. Chủ yếu bước này là làm rõ ra các đầu việc cần làm, để hình dung mức độ phức tạp của dự án như thế nào, từ đó có thể estimate được các deliverable item & timeline.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1335d164-78d8-8064-a90c-d0b14ca66789",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-03T08:29:00.000Z",
        "last_edited_time": "2024-11-19T11:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình nên tiếp cận project này như thế nào? Nó là một feature mang tính dài hạn, hay là một MVP mang tính chất thử nghiệm, hay mang tính chất fix, improve,… (note: nếu về long-term, ta cần hình dung solution ở bức tranh lớn hơn, về mối liên hệ giữa các solution khác, về khả năng scale, khả năng adapt…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình nên tiếp cận project này như thế nào? Nó là một feature mang tính dài hạn, hay là một MVP mang tính chất thử nghiệm, hay mang tính chất fix, improve,… (note: nếu về long-term, ta cần hình dung solution ở bức tranh lớn hơn, về mối liên hệ giữa các solution khác, về khả năng scale, khả năng adapt…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1335d164-78d8-80d9-b90e-e986476279a5",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-03T08:47:00.000Z",
        "last_edited_time": "2024-11-20T16:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "To do list - những gì mình cần làm? Có bao nhiêu use case? Những functionality cần có là gì? Liệu đã biết rõ những gì cần làm hay chưa? Nếu chưa thì xin cái hẹn check lại & báo lại estimation. Mình hay dùng ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "To do list - những gì mình cần làm? Có bao nhiêu use case? Những functionality cần có là gì? Liệu đã biết rõ những gì cần làm hay chưa? Nếu chưa thì xin cái hẹn check lại & báo lại estimation. Mình hay dùng ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "canvas này",
                "link": {
                  "url": "/10f5d16478d8808484a5d6eff66f3eec"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "canvas này",
              "href": "/10f5d16478d8808484a5d6eff66f3eec"
            },
            {
              "type": "text",
              "text": {
                "content": " để có thể hình dung rõ về những thứ cần cân nhắc trước khi thiết kế.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " để có thể hình dung rõ về những thứ cần cân nhắc trước khi thiết kế.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1335d164-78d8-802d-9111-c00c5a068468",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-03T08:49:00.000Z",
        "last_edited_time": "2024-11-20T16:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Plan release (roll-out) như thế nào? Cách chúng ta communicate / promote feature này đến vs user ra sao? Các kịch bản cần chuẩn bị khi roll-out là gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Plan release (roll-out) như thế nào? Cách chúng ta communicate / promote feature này đến vs user ra sao? Các kịch bản cần chuẩn bị khi roll-out là gì?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1335d164-78d8-8008-844d-d606eaf145da",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-03T09:00:00.000Z",
        "last_edited_time": "2024-11-15T00:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Timeline như thế nào? Có cần chia làm nhiều phase để xử lý không? Làm theo kiểu waterfall hay cuốn chiếu?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Timeline như thế nào? Có cần chia làm nhiều phase để xử lý không? Làm theo kiểu waterfall hay cuốn chiếu?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1335d164-78d8-80f8-80ea-c9d3de10faae",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-03T08:49:00.000Z",
        "last_edited_time": "2024-11-15T00:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Stakeholder - những ai cần tham gia để transform solution này là ai? Người quyết định cuối là ai? Ai chịu trách nhiệm cho việc gì? ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Stakeholder - những ai cần tham gia để transform solution này là ai? Người quyết định cuối là ai? Ai chịu trách nhiệm cho việc gì? ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "RACI ",
                "link": {
                  "url": "/1185d16478d88014bdf1e631b28f601e"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "RACI ",
              "href": "/1185d16478d88014bdf1e631b28f601e"
            },
            {
              "type": "text",
              "text": {
                "content": "trông như thế nào?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "trông như thế nào?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-80e3-88a1-d0c94a4c4429",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-01-21T02:17:00.000Z",
        "last_edited_time": "2025-01-21T02:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1445d164-78d8-808d-80ad-f8e61c28550e",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-20T16:51:00.000Z",
        "last_edited_time": "2024-11-20T16:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: trong quá trình làm, scope của bạn có thể sẽ phình ra hoặc timeline bị kéo dài do sự phản hồi lâu hay phải ưu tiên cho task khác,… muôn vàn lí do nhưng cái chính muốn nói ở đây là phải update cho nhau biết nếu thấy không thể bám sát theo plan ban đầu.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: trong quá trình làm, scope của bạn có thể sẽ phình ra hoặc timeline bị kéo dài do sự phản hồi lâu hay phải ưu tiên cho task khác,… muôn vàn lí do nhưng cái chính muốn nói ở đây là phải update cho nhau biết nếu thấy không thể bám sát theo plan ban đầu.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80db-ad41-da35989f6b7f",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-12-22T14:06:00.000Z",
        "last_edited_time": "2025-08-17T02:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tam giác trong project management: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tam giác trong project management: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "time, scope & cost.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "time, scope & cost.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-8089-be01-eec5623099cb",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-08-17T02:13:00.000Z",
        "last_edited_time": "2025-08-17T02:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-80d4-9aa5-f9b57efadaa6",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-08-17T02:13:00.000Z",
        "last_edited_time": "2025-08-17T02:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bonus",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bonus",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-80a3-ac48-fc2c6be24281",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-08-17T02:26:00.000Z",
        "last_edited_time": "2025-08-17T02:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "— Trích từ tài liệu ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "— Trích từ tài liệu ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "“Design Project Scoping Guide”",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Design Project Scoping Guide”",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " của Hasso Platner Insitute of Design Standford (😍 hay lắm đấy đó, các bạn có thể tìm đọc thử).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " của Hasso Platner Insitute of Design Standford (😍 hay lắm đấy đó, các bạn có thể tìm đọc thử).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-80b7-b788-efb4be651e74",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-08-17T02:49:00.000Z",
        "last_edited_time": "2025-08-17T02:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-801b-912f-f707a2d81bd2",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-08-17T02:26:00.000Z",
        "last_edited_time": "2025-08-17T02:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755488667/uxcomic-imgs/2525d164-78d8-801b-912f-f707a2d81bd2.jpg",
            "expiry_time": "2026-10-04T09:12:39.146Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2525d164-78d8-801b-912f-f707a2d81bd2"
      },
      {
        "object": "block",
        "id": "2525d164-78d8-807a-ad90-cfac14f124c0",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-08-17T02:32:00.000Z",
        "last_edited_time": "2025-08-17T02:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Each element is a lever",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Each element is a lever",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-80f2-bdab-c25c213d3c05",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-08-17T02:31:00.000Z",
        "last_edited_time": "2025-08-17T02:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Notice that each of the five elements is a lever that can drastically change the challenge scope (both the topic and how broad or narrow). You goals is to bound the playing field in a specific way but leave room for discovery.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Notice that each of the five elements is a lever that can drastically change the challenge scope (both the topic and how broad or narrow). You goals is to bound the playing field in a specific way but leave room for discovery.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-80c8-9919-de8a87ced035",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-08-17T02:31:00.000Z",
        "last_edited_time": "2025-08-17T02:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "This is the art of scoping here. You need to create an actionable direction but also leave room for discovery and exploration. In the most open innovation work, you don’t know what solution or even what type of solution (event, campaign, service, product, digital platform . . .) will be most effective. The goal is not to eliminate ambiguity. Ambiguity is necessary to allow for new discovery.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "This is the art of scoping here. You need to create an actionable direction but also leave room for discovery and exploration. In the most open innovation work, you don’t know what solution or even what type of solution (event, campaign, service, product, digital platform . . .) will be most effective. The goal is not to eliminate ambiguity. Ambiguity is necessary to allow for new discovery.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-806a-9656-cca9760afc42",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-08-17T02:31:00.000Z",
        "last_edited_time": "2025-08-17T02:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "However, how you frame a challenge will affect how much ambiguity exists, and how much exploration will happen. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "However, how you frame a challenge will affect how much ambiguity exists, and how much exploration will happen. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-80b2-8893-e359fd522c2c",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-08-17T02:32:00.000Z",
        "last_edited_time": "2025-08-17T02:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Another way to think about: Scoping will happen. It will happen either prior to the project or during the project. It may be more efficient to narrow the scope prior (save time by preventing wide investigation); but it may be more effective to narrow the scope during the project (allow a human-centered process to lead you to the most meaningful and fruitful opportunity).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Another way to think about: Scoping will happen. It will happen either prior to the project or during the project. It may be more efficient to narrow the scope prior (save time by preventing wide investigation); but it may be more effective to narrow the scope during the project (allow a human-centered process to lead you to the most meaningful and fruitful opportunity).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-8056-a047-f683e6d7e411",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-08-17T02:49:00.000Z",
        "last_edited_time": "2025-08-17T02:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755488670/uxcomic-imgs/2525d164-78d8-8056-a047-f683e6d7e411.jpg",
            "expiry_time": "2026-10-04T09:12:39.146Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/2525d164-78d8-8056-a047-f683e6d7e411"
      },
      {
        "object": "block",
        "id": "1265d164-78d8-81c8-a53a-ecb5ccd1e68c",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-10-21T03:38:00.000Z",
        "last_edited_time": "2024-10-21T03:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "b57ae68f-d516-466e-97ad-77e2ce81d597",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-12T02:02:00.000Z",
        "last_edited_time": "2024-11-12T02:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "a15fb880-1833-445a-82c2-719ed243e635",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-12T02:02:00.000Z",
        "last_edited_time": "2024-11-12T02:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.d-eship.com/articles/the-problem-statement-canvas-a-deep-dive-in-problem-definition-for-startups-and-innovation-teams/",
                "link": {
                  "url": "https://www.d-eship.com/articles/the-problem-statement-canvas-a-deep-dive-in-problem-definition-for-startups-and-innovation-teams/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.d-eship.com/articles/the-problem-statement-canvas-a-deep-dive-in-problem-definition-for-startups-and-innovation-teams/",
              "href": "https://www.d-eship.com/articles/the-problem-statement-canvas-a-deep-dive-in-problem-definition-for-startups-and-innovation-teams/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15a5d164-78d8-804a-8f48-f15afc85d93f",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-12-12T02:36:00.000Z",
        "last_edited_time": "2024-12-12T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://plan.io/blog/kickoff-meeting/",
                "link": {
                  "url": "https://plan.io/blog/kickoff-meeting/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://plan.io/blog/kickoff-meeting/",
              "href": "https://plan.io/blog/kickoff-meeting/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1a45d164-78d8-80fe-a925-d47adc319fcb",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-02-24T07:26:00.000Z",
        "last_edited_time": "2025-02-24T07:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://designsprintkit.withgoogle.com/methodology/phase1-understand/iceberg-canvas",
                "link": {
                  "url": "https://designsprintkit.withgoogle.com/methodology/phase1-understand/iceberg-canvas"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://designsprintkit.withgoogle.com/methodology/phase1-understand/iceberg-canvas",
              "href": "https://designsprintkit.withgoogle.com/methodology/phase1-understand/iceberg-canvas"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1a45d164-78d8-80f5-80a9-efddc2c8c263",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-02-24T07:28:00.000Z",
        "last_edited_time": "2025-02-24T07:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://designsprintkit.withgoogle.com/methodology/overview",
                "link": {
                  "url": "https://designsprintkit.withgoogle.com/methodology/overview"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://designsprintkit.withgoogle.com/methodology/overview",
              "href": "https://designsprintkit.withgoogle.com/methodology/overview"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1b05d164-78d8-8032-ab57-ce172138f1c6",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2025-03-08T06:28:00.000Z",
        "last_edited_time": "2025-03-08T06:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://untools.co/problem-solving/#tools",
                "link": {
                  "url": "https://untools.co/problem-solving/#tools"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://untools.co/problem-solving/#tools",
              "href": "https://untools.co/problem-solving/#tools"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "840ed052-3717-40c8-bd6c-3030e6519f46",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-12T02:02:00.000Z",
        "last_edited_time": "2024-11-12T02:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "80fc20b5-dd21-4d32-b8e1-147223667175",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-12T02:02:00.000Z",
        "last_edited_time": "2024-11-12T02:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "180eafa5-9ac5-4bbb-bec2-56746c6c0e0f",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-12T02:03:00.000Z",
        "last_edited_time": "2024-11-15T00:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX as a Cupid",
              "href": "https://app.notion.com/p/10f5d16478d8808484a5d6eff66f3eec"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1455d164-78d8-8015-a76f-c6f036dc6afc",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-21T02:26:00.000Z",
        "last_edited_time": "2024-11-21T02:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1445d164-78d8-805b-b388-e24b5f13cccb"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product development process (overall)",
              "href": "https://app.notion.com/p/1445d16478d8805bb388e24b5f13cccb"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13f5d164-78d8-804d-aff1-f04ca8eafd81",
        "parent": {
          "type": "page_id",
          "page_id": "1265d164-78d8-8045-87d2-e2532aae0b64"
        },
        "created_time": "2024-11-15T00:45:00.000Z",
        "last_edited_time": "2024-11-15T00:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1185d164-78d8-8014-bdf1-e631b28f601e"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "RACI (Role & Responsibility)",
              "href": "https://app.notion.com/p/1185d16478d88014bdf1e631b28f601e"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1235d164-78d8-8094-90a1-e82eea06a15b",
    "created_time": "2024-10-18T04:55:00.000Z",
    "last_edited_time": "2025-08-17T02:39:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "1-Understand",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-17T02:39:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": "ByM|",
          "name": "♟️:2",
          "color": "pink"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 22
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2024-10-18T04:55:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Diagram & Canvas",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Diagram & Canvas",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Diagram-Canvas-1235d16478d8809490a1e82eea06a15b",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
      "name": "Understand",
      "slug": "understand",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "1235d164-78d8-8159-b0f3-c0c65b64d4c8",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T09:14:00.000Z",
        "last_edited_time": "2024-11-21T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081623/uxcomic-imgs/1235d164-78d8-8159-b0f3-c0c65b64d4c8.png",
            "expiry_time": "2026-10-04T09:12:41.283Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1235d164-78d8-8159-b0f3-c0c65b64d4c8"
      },
      {
        "object": "block",
        "id": "1235d164-78d8-81d0-a3d5-e8f678d8e482",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T09:14:00.000Z",
        "last_edited_time": "2024-10-27T04:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thử điểm xem vài tình huống sau, xem mình có hay gặp phải trong công việc không nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thử điểm xem vài tình huống sau, xem mình có hay gặp phải trong công việc không nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-80a1-8f89-d2f896453be3",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-27T04:33:00.000Z",
        "last_edited_time": "2025-01-10T04:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bạn có cả nùi suy nghĩ trong đầu khi phân tích problem hoặc nghĩ về solution, dần dần nó loạn xạ và bạn không biết mình đang làm gì nữa.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bạn có cả nùi suy nghĩ trong đầu khi phân tích problem hoặc nghĩ về solution, dần dần nó loạn xạ và bạn không biết mình đang làm gì nữa.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8095-ae3e-dc54c7dba37c",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T09:26:00.000Z",
        "last_edited_time": "2024-10-27T05:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bạn nói hoài không ai hiểu gì hết. Tức thiệt chứ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bạn nói hoài không ai hiểu gì hết. Tức thiệt chứ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80a0-a5ab-fb070c649a10",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T09:26:00.000Z",
        "last_edited_time": "2024-11-21T11:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Ông nói gà, bà nói vịt” - Mỗi người nói mỗi ý, các cuộc tranh cãi không dựa trên cùng tiêu chí gì cả. 2 người đã khó align, bạn mình dung càng nhiều người nữa thì nó có như cái chợ không.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Ông nói gà, bà nói vịt” - Mỗi người nói mỗi ý, các cuộc tranh cãi không dựa trên cùng tiêu chí gì cả. 2 người đã khó align, bạn mình dung càng nhiều người nữa thì nó có như cái chợ không.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-80ff-83ec-d786c86332c7",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-27T04:31:00.000Z",
        "last_edited_time": "2024-11-21T11:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu bạn có gặp các tình huống này thì mình nghĩ Diagram sẽ giúp ích đấy. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu bạn có gặp các tình huống này thì mình nghĩ Diagram sẽ giúp ích đấy. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8074-a8ef-f20f6d4b7b5e",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T14:14:00.000Z",
        "last_edited_time": "2024-10-18T14:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8083-8351-c962aeb6d3a7",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T09:20:00.000Z",
        "last_edited_time": "2024-10-18T09:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Diagram là gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Diagram là gì?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80bc-a1b0-d996512d6aa3",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T09:28:00.000Z",
        "last_edited_time": "2025-08-09T06:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nó là những hình vẽ để minh hoạ ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nó là những hình vẽ để minh hoạ ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "mối quan hệ",
                "link": {
                  "url": "https://uxcomic.github.io/post/relation-systematic-thinking"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "mối quan hệ",
              "href": "https://uxcomic.github.io/post/relation-systematic-thinking"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "của các thông tin với nhau, khiến các thông tin dễ hiểu và trực quan hơn >> diagram cực kì hữu ích đặc biệt là trong tình huống phải trình bày ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "của các thông tin với nhau, khiến các thông tin dễ hiểu và trực quan hơn >> diagram cực kì hữu ích đặc biệt là trong tình huống phải trình bày ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "dữ liệu phức tạp",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "dữ liệu phức tạp",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " hoặc ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " hoặc ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "thông tin có nhiều mối liên hệ.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "thông tin có nhiều mối liên hệ.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-801b-9f70-e12a30554dee",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-01-10T01:40:00.000Z",
        "last_edited_time": "2025-01-10T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một term cũng khá tương đồng là concept model. “A concept model is a visual representation of a set of ideas that clarifies the concept for both the thinker and the audience. It is a useful and powerful tool for user experience designers but also for business, engineering, and marketing… basically anyone who needs to communicate complexity. Which is most of us, these days.” — Jamie Mill",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một term cũng khá tương đồng là concept model. “A concept model is a visual representation of a set of ideas that clarifies the concept for both the thinker and the audience. It is a useful and powerful tool for user experience designers but also for business, engineering, and marketing… basically anyone who needs to communicate complexity. Which is most of us, these days.” — Jamie Mill",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-8089-ac79-c55cb2e6e6bf",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-01-10T01:42:00.000Z",
        "last_edited_time": "2025-01-10T01:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80e7-9b1d-ee6440208f18",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T09:55:00.000Z",
        "last_edited_time": "2024-12-23T07:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhưng tại sao Diagram có thể thể hiện được điều này mà ngôn từ thì lại không bằng?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhưng tại sao Diagram có thể thể hiện được điều này mà ngôn từ thì lại không bằng?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80ef-9eed-e496e6662a30",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T09:42:00.000Z",
        "last_edited_time": "2024-10-18T10:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Não người ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Não người ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "xử lý và ghi nhớ hình ảnh tốt hơn",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "xử lý và ghi nhớ hình ảnh tốt hơn",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (90% xử lý nhanh hơn, nhớ hình gấp 6 lần so với chữ)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (90% xử lý nhanh hơn, nhớ hình gấp 6 lần so với chữ)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8056-9a5d-f6d41a15fa05",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T09:43:00.000Z",
        "last_edited_time": "2024-12-23T07:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "2 better than 1.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2 better than 1.",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Khi vừa có ngôn từ, vừa có hình ảnh minh hoạ >> não chúng ta xử lý tốt hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Khi vừa có ngôn từ, vừa có hình ảnh minh hoạ >> não chúng ta xử lý tốt hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80ae-8990-e145953d3394",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T09:46:00.000Z",
        "last_edited_time": "2025-01-14T02:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Diễn đạt mối liên hệ phức tạp tốt hơn",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Diễn đạt mối liên hệ phức tạp tốt hơn",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ". Thử nghĩ xem, khi nói/ đọc/nghe mình sẽ qua từng từ từng câu một, và nó có tính tuyến tính (linear thinking vẫn cần thiết vì nó giúp mình hiểu từng chút - chunking) a => b, b => c, trong khi nhìn hình ảnh, nó không theo kiểu tuyến tính đó, nó theo kiểu mapping, system thinking, mọi thông tin đến theo cụm, quan trọng nhất là nhìn được ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". Thử nghĩ xem, khi nói/ đọc/nghe mình sẽ qua từng từ từng câu một, và nó có tính tuyến tính (linear thinking vẫn cần thiết vì nó giúp mình hiểu từng chút - chunking) a => b, b => c, trong khi nhìn hình ảnh, nó không theo kiểu tuyến tính đó, nó theo kiểu mapping, system thinking, mọi thông tin đến theo cụm, quan trọng nhất là nhìn được ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "mối liên hệ giữa chúng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "mối liên hệ giữa chúng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", bạn sẽ gắn kết các “thành phần hình ảnh” ngay tức khắc và hình dung ra một thông điệp gì đó qua vài giây nhìn. Ví dụ: thay vì bạn gửi hình dưới cho người nghe, hãy thử hình dung xem nếu bạn phải diễn tả nó chỉ bằng lời nói, xem có dong dài & đối phương dễ nắm bắt  vấn đề không.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", bạn sẽ gắn kết các “thành phần hình ảnh” ngay tức khắc và hình dung ra một thông điệp gì đó qua vài giây nhìn. Ví dụ: thay vì bạn gửi hình dưới cho người nghe, hãy thử hình dung xem nếu bạn phải diễn tả nó chỉ bằng lời nói, xem có dong dài & đối phương dễ nắm bắt  vấn đề không.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1455d164-78d8-808c-80bc-c5bd306631e8",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-11-21T11:35:00.000Z",
        "last_edited_time": "2024-12-02T10:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081624/uxcomic-imgs/1455d164-78d8-808c-80bc-c5bd306631e8.png",
            "expiry_time": "2026-10-04T09:12:41.284Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1455d164-78d8-808c-80bc-c5bd306631e8"
      },
      {
        "object": "block",
        "id": "1775d164-78d8-805a-8c3d-e97d6bcb14b8",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-01-10T04:52:00.000Z",
        "last_edited_time": "2025-01-10T04:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "A picture is worth thousand words.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "A picture is worth thousand words.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "50c69bec-3e68-4887-90a6-0137f2b52408",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-19T00:32:00.000Z",
        "last_edited_time": "2024-10-19T00:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "6392d222-bed7-47a3-9467-4ed0423841c6",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-19T00:32:00.000Z",
        "last_edited_time": "2024-10-19T00:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "So what",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "So what",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1695d164-78d8-8060-8ce4-f6a9ee62cba9",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-12-27T01:28:00.000Z",
        "last_edited_time": "2025-01-10T01:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Diagram như cách chúng ta quy hoạch đường phố vậy, phân khu nhà phố giống đại diện  các cụm thông tin, đường xá giống đại diện cách thể hiện cho sự liên hệ giữa các cụm thông tin. (mối liên hệ thực tế sẽ là verb, ví dụ a chứa b, a tác động b, a truyền cho b… để hình dung được ta sẽ đặt câu hỏi How).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Diagram như cách chúng ta quy hoạch đường phố vậy, phân khu nhà phố giống đại diện  các cụm thông tin, đường xá giống đại diện cách thể hiện cho sự liên hệ giữa các cụm thông tin. (mối liên hệ thực tế sẽ là verb, ví dụ a chứa b, a tác động b, a truyền cho b… để hình dung được ta sẽ đặt câu hỏi How).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1695d164-78d8-80a1-89d5-d281df5d25b2",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-12-27T01:31:00.000Z",
        "last_edited_time": "2024-12-27T01:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081626/uxcomic-imgs/1695d164-78d8-80a1-89d5-d281df5d25b2.jpg",
            "expiry_time": "2026-10-04T09:12:41.284Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1695d164-78d8-80a1-89d5-d281df5d25b2"
      },
      {
        "object": "block",
        "id": "1775d164-78d8-80aa-9620-db1ded48c005",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-01-10T01:58:00.000Z",
        "last_edited_time": "2025-01-10T02:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có được diagram như có trong tay một tấm bản đồ, nó giúp ta định vị & hình dung các luồng thông tin di chuyển như thế nào. Không những giúp mình hiểu mà còn đặc biệt trong các cuộc trao đổi với nhiều người, vấn đề càng phức tạp thì ngôn từ càng bất lực.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có được diagram như có trong tay một tấm bản đồ, nó giúp ta định vị & hình dung các luồng thông tin di chuyển như thế nào. Không những giúp mình hiểu mà còn đặc biệt trong các cuộc trao đổi với nhiều người, vấn đề càng phức tạp thì ngôn từ càng bất lực.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16e5d164-78d8-8005-bd24-cf97baa6291f",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-01-01T12:30:00.000Z",
        "last_edited_time": "2025-01-01T12:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "8ad1aea6-37a4-49b7-b553-5a9570fdcdcb",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T09:53:00.000Z",
        "last_edited_time": "2024-10-19T00:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy trong công việc của UX/UI design thì nó sẽ giúp được gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy trong công việc của UX/UI design thì nó sẽ giúp được gì?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8010-9caf-cf628817f5d6",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T09:56:00.000Z",
        "last_edited_time": "2024-10-19T00:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Alignment & share understanding",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Alignment & share understanding",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "- để trong các cuộc họp hay discuss bạn muốn tất cả đều hiểu cùng một ngữ nghĩa",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "- để trong các cuộc họp hay discuss bạn muốn tất cả đều hiểu cùng một ngữ nghĩa",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8031-a46d-d4a194af1868",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T09:57:00.000Z",
        "last_edited_time": "2024-10-19T00:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Analysis",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Analysis",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " - dùng để phân tích thông tin, giúp bạn hình dung rõ hơn về những concept, những ý nghĩa đang có trong đầu.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " - dùng để phân tích thông tin, giúp bạn hình dung rõ hơn về những concept, những ý nghĩa đang có trong đầu.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1695d164-78d8-80a5-b2fe-e7e7473f7a41",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-12-27T01:32:00.000Z",
        "last_edited_time": "2025-01-01T12:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Conceptual design",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Conceptual design",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " - dùng để lên ý tưởng, định hình hướng tiếp cận tổng quan. Ví dụ Notion tiếp cận các thông tin theo từng block riêng lẻ, khác hẳn cách tiếp cận của Word.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " - dùng để lên ý tưởng, định hình hướng tiếp cận tổng quan. Ví dụ Notion tiếp cận các thông tin theo từng block riêng lẻ, khác hẳn cách tiếp cận của Word.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1455d164-78d8-8030-ae70-e3b24a1b6e49",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-11-21T02:24:00.000Z",
        "last_edited_time": "2024-11-21T02:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1695d164-78d8-804b-ae78-e12c8ca8f86f",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-12-27T01:38:00.000Z",
        "last_edited_time": "2025-01-10T01:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hãy đi qua vài cách trình diễn mối liên hệ bằng diagram (phần này mình trích dẫn các hình từ trong sách “How to make sense of any mess”).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hãy đi qua vài cách trình diễn mối liên hệ bằng diagram (phần này mình trích dẫn các hình từ trong sách “How to make sense of any mess”).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1455d164-78d8-8011-a21b-c1ab8139af8a",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-11-21T11:36:00.000Z",
        "last_edited_time": "2024-11-21T11:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các loại diagram & sự trình diễn mối liên hệ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các loại diagram & sự trình diễn mối liên hệ",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-8094-8b5b-cefe5af2ba4b",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-08-17T02:36:00.000Z",
        "last_edited_time": "2025-08-17T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8024-9cf0-dda43cbf2391",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T10:06:00.000Z",
        "last_edited_time": "2024-10-18T11:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Block diagram",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Block diagram",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-814d-9959-c25827e354d5",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T09:14:00.000Z",
        "last_edited_time": "2024-10-24T16:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thể hiện phần các thành phần trong một khái niệm gì đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thể hiện phần các thành phần trong một khái niệm gì đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-809f-a814-ea2c2a6a85bb",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T11:50:00.000Z",
        "last_edited_time": "2024-11-21T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081628/uxcomic-imgs/1235d164-78d8-809f-a814-ea2c2a6a85bb.png",
            "expiry_time": "2026-10-04T09:12:41.360Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1235d164-78d8-809f-a814-ea2c2a6a85bb"
      },
      {
        "object": "block",
        "id": "2525d164-78d8-80d8-99b1-e19080d130d0",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-08-17T02:36:00.000Z",
        "last_edited_time": "2025-08-17T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-80c7-b755-db2ea567bee3",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-08-17T02:36:00.000Z",
        "last_edited_time": "2025-08-17T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-80c4-abf7-fe3b6c40dad7",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-11-18T07:47:00.000Z",
        "last_edited_time": "2024-11-18T07:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Pyramid diagram",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Pyramid diagram",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8091-a9c1-db3a89e0e2ab",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-11-18T07:50:00.000Z",
        "last_edited_time": "2024-12-27T01:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để minh hoạ sự ưu tiên, tính cần thiết hoặc nền tảng giữa các thành phần.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để minh hoạ sự ưu tiên, tính cần thiết hoặc nền tảng giữa các thành phần.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-80c1-8728-e66247379be3",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-11-18T07:50:00.000Z",
        "last_edited_time": "2024-11-18T07:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081629/uxcomic-imgs/1425d164-78d8-80c1-8728-e66247379be3.png",
            "expiry_time": "2026-10-04T09:12:41.360Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1425d164-78d8-80c1-8728-e66247379be3"
      },
      {
        "object": "block",
        "id": "2525d164-78d8-8019-a9af-cdbac35b204d",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-08-17T02:36:00.000Z",
        "last_edited_time": "2025-08-17T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-800c-b862-febd1c32ade8",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-08-17T02:36:00.000Z",
        "last_edited_time": "2025-08-17T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80d1-b87a-f4e3fa6a2233",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T13:53:00.000Z",
        "last_edited_time": "2024-12-27T01:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Flowchart / Workflow",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Flowchart / Workflow",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8197-bde1-c3721cb6dd29",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T09:14:00.000Z",
        "last_edited_time": "2024-10-18T14:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để mô tả các bước trong một quy trình, bao gồm các điều kiện của user hoặc system, mối liên kết giữa các task. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để mô tả các bước trong một quy trình, bao gồm các điều kiện của user hoặc system, mối liên kết giữa các task. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80a3-8bee-c4fcccecad38",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T13:53:00.000Z",
        "last_edited_time": "2024-11-21T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081631/uxcomic-imgs/1235d164-78d8-80a3-8bee-c4fcccecad38.png",
            "expiry_time": "2026-10-04T09:12:41.361Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1235d164-78d8-80a3-8bee-c4fcccecad38"
      },
      {
        "object": "block",
        "id": "2525d164-78d8-8035-9b96-c42eac16107e",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-08-17T02:36:00.000Z",
        "last_edited_time": "2025-08-17T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-808d-8071-c021d7e78a67",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-08-17T02:36:00.000Z",
        "last_edited_time": "2025-08-17T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80d2-9c04-dbeefeed6a24",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T13:54:00.000Z",
        "last_edited_time": "2024-10-18T14:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Gantt Chart",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Gantt Chart",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80c1-8643-ee722188eafd",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T13:55:00.000Z",
        "last_edited_time": "2024-10-18T14:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để mô tả các tiến độ công việc trên một timeframe nhất định, giúp mình hình dung được mối liên hệ của task, con người & thời gian.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để mô tả các tiến độ công việc trên một timeframe nhất định, giúp mình hình dung được mối liên hệ của task, con người & thời gian.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8081-a7a4-fc403bed6042",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T13:56:00.000Z",
        "last_edited_time": "2024-11-21T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081632/uxcomic-imgs/1235d164-78d8-8081-a7a4-fc403bed6042.png",
            "expiry_time": "2026-10-04T09:12:41.361Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1235d164-78d8-8081-a7a4-fc403bed6042"
      },
      {
        "object": "block",
        "id": "2525d164-78d8-809b-a9b8-e3c776a2f478",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-08-17T02:36:00.000Z",
        "last_edited_time": "2025-08-17T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-808e-8f8b-ef11e4d80547",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-08-17T02:36:00.000Z",
        "last_edited_time": "2025-08-17T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8043-b4ee-d22fa3c09fe2",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T13:57:00.000Z",
        "last_edited_time": "2024-10-18T14:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Matrix Diagram",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Matrix Diagram",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80c5-b435-f8df31937a35",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T13:58:00.000Z",
        "last_edited_time": "2024-10-18T14:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Được dùng để minh hoạ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Được dùng để minh hoạ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " việc so sánh ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " việc so sánh ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "các item trên một hệ quy chiếu nhất định.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "các item trên một hệ quy chiếu nhất định.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8005-80fc-ee96513fc80f",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T13:58:00.000Z",
        "last_edited_time": "2024-11-21T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081634/uxcomic-imgs/1235d164-78d8-8005-80fc-ee96513fc80f.png",
            "expiry_time": "2026-10-04T09:12:41.455Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1235d164-78d8-8005-80fc-ee96513fc80f"
      },
      {
        "object": "block",
        "id": "2525d164-78d8-806f-a441-dad515c12bc6",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-08-17T02:36:00.000Z",
        "last_edited_time": "2025-08-17T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-80bb-985c-e33b9ce6d7dd",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-08-17T02:36:00.000Z",
        "last_edited_time": "2025-08-17T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80e3-9635-c1fe2230fa69",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T13:59:00.000Z",
        "last_edited_time": "2024-10-18T13:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Venn Diagram",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Venn Diagram",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8084-b520-ced920579ece",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T13:59:00.000Z",
        "last_edited_time": "2024-10-18T14:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dùng để thể hiện sự overlap, tính liên quan của các item.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dùng để thể hiện sự overlap, tính liên quan của các item.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-800c-b1a1-f24b20ae6cde",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T14:00:00.000Z",
        "last_edited_time": "2024-11-21T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081635/uxcomic-imgs/1235d164-78d8-800c-b1a1-f24b20ae6cde.png",
            "expiry_time": "2026-10-04T09:12:41.455Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1235d164-78d8-800c-b1a1-f24b20ae6cde"
      },
      {
        "object": "block",
        "id": "2525d164-78d8-80f7-b094-f08ad374b3ad",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-08-17T02:36:00.000Z",
        "last_edited_time": "2025-08-17T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-8062-b4fd-ff50d27f8094",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-08-17T02:36:00.000Z",
        "last_edited_time": "2025-08-17T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80b6-b112-d775035a8988",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T14:00:00.000Z",
        "last_edited_time": "2024-10-18T14:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Swim Lane Diagram",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Swim Lane Diagram",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-805f-a67e-ed5ad6fbd1be",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T14:00:00.000Z",
        "last_edited_time": "2024-10-18T14:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Được dùng để minh hoạ cho một quy trình phức tạp hơn mà gồm nhiều bên tham gia vào. Này chắc các BA nghiên cứu về nghiệp vụ sẽ tiếp xúc hàng ngày luôn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Được dùng để minh hoạ cho một quy trình phức tạp hơn mà gồm nhiều bên tham gia vào. Này chắc các BA nghiên cứu về nghiệp vụ sẽ tiếp xúc hàng ngày luôn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8033-b4c4-cc1bf9cee9b1",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T14:01:00.000Z",
        "last_edited_time": "2024-11-21T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081637/uxcomic-imgs/1235d164-78d8-8033-b4c4-cc1bf9cee9b1.png",
            "expiry_time": "2026-10-04T09:12:41.455Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1235d164-78d8-8033-b4c4-cc1bf9cee9b1"
      },
      {
        "object": "block",
        "id": "2525d164-78d8-80a9-8261-f0b75675480f",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-08-17T02:36:00.000Z",
        "last_edited_time": "2025-08-17T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-808a-b1ed-cfbbaa4bd1fd",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-08-17T02:36:00.000Z",
        "last_edited_time": "2025-08-17T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8014-bd0c-f7fd27570f09",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T14:02:00.000Z",
        "last_edited_time": "2025-08-17T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tree Diagram (Hierarchy) / Mind map",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tree Diagram (Hierarchy) / Mind map",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80c2-880a-d99c3a8f2c75",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T14:02:00.000Z",
        "last_edited_time": "2024-10-24T16:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để mô tả cấp bậc các thông tin. Site map theo dạng này nè.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để mô tả cấp bậc các thông tin. Site map theo dạng này nè.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80b1-8c97-f95fb25f60d7",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T14:02:00.000Z",
        "last_edited_time": "2024-11-21T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081638/uxcomic-imgs/1235d164-78d8-80b1-8c97-f95fb25f60d7.png",
            "expiry_time": "2026-10-04T09:12:41.455Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1235d164-78d8-80b1-8c97-f95fb25f60d7"
      },
      {
        "object": "block",
        "id": "2525d164-78d8-80cd-b85b-e0962b6be633",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-08-17T02:36:00.000Z",
        "last_edited_time": "2025-08-17T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-8001-ac7f-ce30252a42cd",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-08-17T02:36:00.000Z",
        "last_edited_time": "2025-08-17T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8023-9bba-fdcab9a4c784",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T14:03:00.000Z",
        "last_edited_time": "2024-10-18T14:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Schematic",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Schematic",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80e3-a464-cf648b282fa9",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T14:03:00.000Z",
        "last_edited_time": "2024-10-18T14:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Biểu diễn các thành phần và cấu trúc của một hệ thống bằng các ký hiệu đơn giản. Nhìn quen hén, này giống như wireframe, lofi hay UI spec nè.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Biểu diễn các thành phần và cấu trúc của một hệ thống bằng các ký hiệu đơn giản. Nhìn quen hén, này giống như wireframe, lofi hay UI spec nè.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8016-ad14-c2ed36360038",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T14:06:00.000Z",
        "last_edited_time": "2024-11-21T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081639/uxcomic-imgs/1235d164-78d8-8016-ad14-c2ed36360038.png",
            "expiry_time": "2026-10-04T09:12:41.456Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1235d164-78d8-8016-ad14-c2ed36360038"
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80da-8b81-cec33ffad027",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T14:06:00.000Z",
        "last_edited_time": "2024-11-21T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081641/uxcomic-imgs/1235d164-78d8-80da-8b81-cec33ffad027.png",
            "expiry_time": "2026-10-04T09:12:41.456Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1235d164-78d8-80da-8b81-cec33ffad027"
      },
      {
        "object": "block",
        "id": "2525d164-78d8-8033-8afa-e93f1353f1cf",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-08-17T02:37:00.000Z",
        "last_edited_time": "2025-08-17T02:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-8083-b16b-dc066ecfa6d6",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-08-17T02:37:00.000Z",
        "last_edited_time": "2025-08-17T02:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8065-be71-d3a4380851e9",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T14:10:00.000Z",
        "last_edited_time": "2024-10-18T14:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Journey Map",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Journey Map",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80ea-a386-c90cbd8181b4",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T14:10:00.000Z",
        "last_edited_time": "2024-10-18T14:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dùng để mô tả tất cả các task step & touch point của một user trong xuyên suốt một hoạt động gì đó. Từ đó bạn hiểu tổng quan hơn những gì user sẽ trải qua, và touch point nào cần được cải thiện.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dùng để mô tả tất cả các task step & touch point của một user trong xuyên suốt một hoạt động gì đó. Từ đó bạn hiểu tổng quan hơn những gì user sẽ trải qua, và touch point nào cần được cải thiện.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-803b-8649-fa65a2afbd15",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T14:10:00.000Z",
        "last_edited_time": "2024-11-21T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081643/uxcomic-imgs/1235d164-78d8-803b-8649-fa65a2afbd15.png",
            "expiry_time": "2026-10-04T09:12:41.558Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1235d164-78d8-803b-8649-fa65a2afbd15"
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8016-be77-fe40ad636a1e",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T14:26:00.000Z",
        "last_edited_time": "2024-12-27T01:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Và còn rất nhiều dạng khác nữa, nếu bạn nghiên cứu data visualization sẽ thấy nào còn Bar chart, Pie chart, Scatter Plot,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Và còn rất nhiều dạng khác nữa, nếu bạn nghiên cứu data visualization sẽ thấy nào còn Bar chart, Pie chart, Scatter Plot,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-80e7-8233-c8fbf2c93ce8",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-08-17T02:37:00.000Z",
        "last_edited_time": "2025-08-17T02:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-80c3-9b7b-e13f26d8ea7c",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-08-17T02:37:00.000Z",
        "last_edited_time": "2025-08-17T02:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-806a-9099-f68b62e2eecb",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-01-10T01:53:00.000Z",
        "last_edited_time": "2025-01-10T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Diamond",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Diamond",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-8050-a4d2-cd470d731939",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-01-10T01:54:00.000Z",
        "last_edited_time": "2025-01-10T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mô tả cách thức ta tư duy ở từng giai đoạn, đâu là lúc nên mở vấn đề, tìm kiếm thông tin, đâu là lúc kết nối các thông tin & đóng vấn đề.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mô tả cách thức ta tư duy ở từng giai đoạn, đâu là lúc nên mở vấn đề, tìm kiếm thông tin, đâu là lúc kết nối các thông tin & đóng vấn đề.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-80bd-9f07-c6d3035624a7",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-01-10T01:53:00.000Z",
        "last_edited_time": "2025-01-10T06:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081644/uxcomic-imgs/1775d164-78d8-80bd-9f07-c6d3035624a7.jpg",
            "expiry_time": "2026-10-04T09:12:41.558Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1775d164-78d8-80bd-9f07-c6d3035624a7"
      },
      {
        "object": "block",
        "id": "1685d164-78d8-805e-a740-ddf0dfc669e8",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-12-26T11:13:00.000Z",
        "last_edited_time": "2024-12-26T11:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-8003-be0a-d9f15d10457b",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-12-26T11:13:00.000Z",
        "last_edited_time": "2024-12-26T11:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tóm lại",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tóm lại",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-8068-b3e8-e24c69286878",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-12-26T11:13:00.000Z",
        "last_edited_time": "2024-12-27T01:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Như tên tựa của một cuốn sách: “Stuck? Diagram help”. Bất cứ khi nào thấy rối rối, hãy vẽ diagram, vừa giúp mình có cái nhìn chặt chẽ vừa giúp truyền đạt hiệu quả hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Như tên tựa của một cuốn sách: “Stuck? Diagram help”. Bất cứ khi nào thấy rối rối, hãy vẽ diagram, vừa giúp mình có cái nhìn chặt chẽ vừa giúp truyền đạt hiệu quả hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-804e-89f3-ed6e50ddcbf4",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-08-17T02:37:00.000Z",
        "last_edited_time": "2025-08-17T02:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vì sao? Vì khi bạn vẽ ra diagram nó giúp mình mốc nối mối liên hệ giữa các thông tin, việc mốc nối này là “suy luận”, nó thúc đẩy cái hiểu.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vì sao? Vì khi bạn vẽ ra diagram nó giúp mình mốc nối mối liên hệ giữa các thông tin, việc mốc nối này là “suy luận”, nó thúc đẩy cái hiểu.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-80dd-ae5e-f8a2751a016a",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-01-10T01:48:00.000Z",
        "last_edited_time": "2025-01-10T01:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“The more we draw, the more our ideas become visible, and as they become visible they become clear, and as they become clear they become easier to discuss—which in the virtuous cycle of visual thinking prompts us to discuss even more.” — Jamie Mill",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“The more we draw, the more our ideas become visible, and as they become visible they become clear, and as they become clear they become easier to discuss—which in the virtuous cycle of visual thinking prompts us to discuss even more.” — Jamie Mill",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8194-9411-f04bff1c9083",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T09:14:00.000Z",
        "last_edited_time": "2024-10-18T09:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-810a-95ee-c677c5b5ed7e",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T09:14:00.000Z",
        "last_edited_time": "2024-10-18T09:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-814a-83d4-d61573766930",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T09:14:00.000Z",
        "last_edited_time": "2024-10-18T14:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "www.howtomakesenseofanymess.com",
                "link": {
                  "url": "http://www.howtomakesenseofanymess.com/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "www.howtomakesenseofanymess.com",
              "href": "http://www.howtomakesenseofanymess.com/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-807a-9084-ebc4b7cfa3fb",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-01-10T06:44:00.000Z",
        "last_edited_time": "2025-01-10T06:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.drawio.com/example-diagrams",
                "link": {
                  "url": "https://www.drawio.com/example-diagrams"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.drawio.com/example-diagrams",
              "href": "https://www.drawio.com/example-diagrams"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8150-b6af-e201e0b8ae44",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T09:14:00.000Z",
        "last_edited_time": "2024-10-18T09:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-81a0-b244-edca2c85bbe7",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T09:14:00.000Z",
        "last_edited_time": "2024-10-18T14:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8147-8b71-eaf90953ee7e",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-10-18T09:14:00.000Z",
        "last_edited_time": "2024-10-18T14:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relation (systematic thinking)",
              "href": "https://app.notion.com/p/1225d16478d880db8d9be6cc64d11314"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1455d164-78d8-8057-a352-c7465d89a04a",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2024-11-21T02:19:00.000Z",
        "last_edited_time": "2024-11-21T02:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1195d164-78d8-80cd-a21f-f9d0e90ae7b8"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sense making",
              "href": "https://app.notion.com/p/1195d16478d880cda21ff9d0e90ae7b8"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-8033-8c5f-d42a4e9eb405",
        "parent": {
          "type": "page_id",
          "page_id": "1235d164-78d8-8094-90a1-e82eea06a15b"
        },
        "created_time": "2025-08-17T02:38:00.000Z",
        "last_edited_time": "2025-08-17T02:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1c95d164-78d8-80bb-ae7b-d759fd89c261"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Suy luận vs Lập luận",
              "href": "https://app.notion.com/p/1c95d16478d880bbae7bd759fd89c261"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "11d5d164-78d8-80f1-a613-c5735f42db88",
    "created_time": "2024-10-12T09:38:00.000Z",
    "last_edited_time": "2025-08-17T02:46:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "3-Build",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-17T02:46:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": "}QTb",
          "name": "⚔️:2",
          "color": "gray"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 21
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2024-10-12T09:38:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Use case",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Use case",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Use-case-11d5d16478d880f1a613c5735f42db88",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
      "name": "Build",
      "slug": "build",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "11d5d164-78d8-81fe-ac9c-d0e6a07c94cb",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:38:00.000Z",
        "last_edited_time": "2025-01-05T17:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755488695/uxcomic-imgs/11d5d164-78d8-81fe-ac9c-d0e6a07c94cb.png",
            "expiry_time": "2026-10-04T09:12:44.937Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/11d5d164-78d8-81fe-ac9c-d0e6a07c94cb"
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8126-95ef-cb6b5fdc4bfd",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:38:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "What",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "What",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-806c-9b6d-c0673047cf65",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Use case",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Use case",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là một tài liệu mô tả cách mà người dùng (hoặc hệ thống khác) tương tác với một hệ thống để đạt được một mục tiêu cụ thể. Nó giải thích rõ ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là một tài liệu mô tả cách mà người dùng (hoặc hệ thống khác) tương tác với một hệ thống để đạt được một mục tiêu cụ thể. Nó giải thích rõ ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "quá trình tương tác",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "quá trình tương tác",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " giữa các bên liên quan (actors) và hệ thống, trong đó bao gồm các bước mà người dùng thực hiện và phản hồi của hệ thống ở mỗi bước.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " giữa các bên liên quan (actors) và hệ thống, trong đó bao gồm các bước mà người dùng thực hiện và phản hồi của hệ thống ở mỗi bước.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-80bd-b7a5-f5e63274b0a4",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Use case thường được sử dụng trong quá trình phát triển phần mềm hoặc sản phẩm để giúp các nhóm phát triển hiểu rõ ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Use case thường được sử dụng trong quá trình phát triển phần mềm hoặc sản phẩm để giúp các nhóm phát triển hiểu rõ ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "những chức năng cần xây dựng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "những chức năng cần xây dựng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " từ góc nhìn của người dùng, cũng như các ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " từ góc nhìn của người dùng, cũng như các ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "yêu cầu hệ thống",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "yêu cầu hệ thống",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " liên quan. Nó giúp đảm bảo rằng sản phẩm sẽ đáp ứng đúng nhu cầu của người dùng và hoạt động như mong đợi trong các tình huống khác nhau.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " liên quan. Nó giúp đảm bảo rằng sản phẩm sẽ đáp ứng đúng nhu cầu của người dùng và hoạt động như mong đợi trong các tình huống khác nhau.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-8077-bbce-f0758ca0fbb6",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2025-08-17T02:43:00.000Z",
        "last_edited_time": "2025-08-17T02:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8024-a3d8-d0c3b72e8a54",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2025-08-17T02:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cấu trúc của Use Case:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cấu trúc của Use Case:",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-80f3-83e3-c166d2bc1bd1",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tên use case",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tên use case",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Tên của tình huống sử dụng được mô tả.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Tên của tình huống sử dụng được mô tả.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-806c-94e8-f5568475dc89",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mục tiêu (Goal)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mục tiêu (Goal)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Mục tiêu mà người dùng muốn đạt được khi tương tác với hệ thống.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Mục tiêu mà người dùng muốn đạt được khi tương tác với hệ thống.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-804d-9ac6-eae1800edcb1",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2025-08-17T02:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đối tượng tham gia (Actors)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đối tượng tham gia (Actors)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Ai là người tham gia vào use case, bao gồm người dùng và các hệ thống liên quan.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Ai là người tham gia vào use case, bao gồm người dùng và các hệ thống liên quan.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-802d-8fac-f2c02e181d25",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các bên liên quan (Stakeholders)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các bên liên quan (Stakeholders)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Các bên bị ảnh hưởng hoặc có quan tâm đến use case (ví dụ: khách hàng, quản trị viên).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Các bên bị ảnh hưởng hoặc có quan tâm đến use case (ví dụ: khách hàng, quản trị viên).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 3
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-80aa-ba22-ec6fee4bd624",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Điều kiện trước (Preconditions)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Điều kiện trước (Preconditions)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Điều kiện nào cần có trước khi bắt đầu use case.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Điều kiện nào cần có trước khi bắt đầu use case.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 4
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8099-9b47-f18b62353932",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dòng sự kiện chính (Main Success Scenario)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dòng sự kiện chính (Main Success Scenario)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Các bước chính mà người dùng thực hiện và cách hệ thống phản hồi, để đạt được mục tiêu thành công.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Các bước chính mà người dùng thực hiện và cách hệ thống phản hồi, để đạt được mục tiêu thành công.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 5
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-80e1-8983-ee8b2a1a1b03",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dòng sự kiện mở rộng (Alternate Scenarios)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dòng sự kiện mở rộng (Alternate Scenarios)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Các tình huống phụ hoặc kịch bản khác có thể xảy ra (ví dụ: khi lỗi xảy ra, hệ thống xử lý thế nào).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Các tình huống phụ hoặc kịch bản khác có thể xảy ra (ví dụ: khi lỗi xảy ra, hệ thống xử lý thế nào).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 6
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8091-baa1-eaa7be37a75c",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Điều kiện sau (Postconditions)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Điều kiện sau (Postconditions)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Trạng thái của hệ thống sau khi use case hoàn tất.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Trạng thái của hệ thống sau khi use case hoàn tất.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 7
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8061-8c47-e4a6458197f7",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tiêu chí chấp nhận (Acceptance Criteria)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tiêu chí chấp nhận (Acceptance Criteria)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Các tiêu chí để đánh giá xem use case đã thành công hay chưa.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Các tiêu chí để đánh giá xem use case đã thành công hay chưa.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 8
      },
      {
        "object": "block",
        "id": "1225d164-78d8-8059-9b14-cdac2d5cdae8",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-17T10:47:00.000Z",
        "last_edited_time": "2025-01-05T17:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755488696/uxcomic-imgs/1225d164-78d8-8059-9b14-cdac2d5cdae8.png",
            "expiry_time": "2026-10-04T09:12:44.938Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1225d164-78d8-8059-9b14-cdac2d5cdae8"
      },
      {
        "object": "block",
        "id": "2525d164-78d8-80cf-9519-d16427538be4",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2025-08-17T02:39:00.000Z",
        "last_edited_time": "2025-08-17T02:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-80be-94ee-fcd058a1e44a",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2025-08-17T02:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ về Use Case:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ về Use Case:",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-802d-89c5-f2ef714a2bc6",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tình huống: Đặt vé máy bay trực tuyến",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tình huống: Đặt vé máy bay trực tuyến",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-805a-85b8-c52ecde94eb7",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tên Use Case",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tên Use Case",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Đặt vé máy bay trực tuyến",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Đặt vé máy bay trực tuyến",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-80ed-bbb6-d3478b60ab17",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mục tiêu",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mục tiêu",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Người dùng muốn đặt vé máy bay thông qua một hệ thống trực tuyến.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Người dùng muốn đặt vé máy bay thông qua một hệ thống trực tuyến.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-809e-9f67-fc08ef06f667",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2025-08-17T02:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Actor:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Actor:",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "11d5d164-78d8-806b-94f8-cafc2da2605f",
            "parent": {
              "type": "block_id",
              "block_id": "11d5d164-78d8-809e-9f67-fc08ef06f667"
            },
            "created_time": "2024-10-12T09:41:00.000Z",
            "last_edited_time": "2024-10-12T09:41:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Người dùng (Customer): Muốn đặt vé máy bay.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Người dùng (Customer): Muốn đặt vé máy bay.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "11d5d164-78d8-80d3-aece-f02abfb8664b",
            "parent": {
              "type": "block_id",
              "block_id": "11d5d164-78d8-809e-9f67-fc08ef06f667"
            },
            "created_time": "2024-10-12T09:41:00.000Z",
            "last_edited_time": "2024-10-12T09:41:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Hệ thống thanh toán: Xử lý thanh toán cho giao dịch.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Hệ thống thanh toán: Xử lý thanh toán cho giao dịch.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-800c-8918-e7b152ea4ad7",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Điều kiện trước",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Điều kiện trước",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ":",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ":",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "11d5d164-78d8-804c-ac35-efed7b720a57",
            "parent": {
              "type": "block_id",
              "block_id": "11d5d164-78d8-800c-8918-e7b152ea4ad7"
            },
            "created_time": "2024-10-12T09:41:00.000Z",
            "last_edited_time": "2024-10-12T09:41:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Người dùng đã đăng nhập vào hệ thống và có tài khoản hợp lệ.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Người dùng đã đăng nhập vào hệ thống và có tài khoản hợp lệ.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "11d5d164-78d8-800c-bc91-f770d21aae5e",
            "parent": {
              "type": "block_id",
              "block_id": "11d5d164-78d8-800c-8918-e7b152ea4ad7"
            },
            "created_time": "2024-10-12T09:41:00.000Z",
            "last_edited_time": "2024-10-12T09:41:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Hệ thống có kết nối với các hãng hàng không để lấy thông tin chuyến bay.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Hệ thống có kết nối với các hãng hàng không để lấy thông tin chuyến bay.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-80e8-aa36-f4b2344d0427",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dòng sự kiện chính",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dòng sự kiện chính",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ":",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ":",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "11d5d164-78d8-8063-b8f9-d759ae1699a8",
            "parent": {
              "type": "block_id",
              "block_id": "11d5d164-78d8-80e8-aa36-f4b2344d0427"
            },
            "created_time": "2024-10-12T09:41:00.000Z",
            "last_edited_time": "2024-10-12T09:41:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Người dùng chọn điểm đi và điểm đến.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Người dùng chọn điểm đi và điểm đến.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 0
          },
          {
            "object": "block",
            "id": "11d5d164-78d8-80de-a667-c90109597ba4",
            "parent": {
              "type": "block_id",
              "block_id": "11d5d164-78d8-80e8-aa36-f4b2344d0427"
            },
            "created_time": "2024-10-12T09:41:00.000Z",
            "last_edited_time": "2024-10-12T09:41:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Người dùng chọn ngày và giờ bay.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Người dùng chọn ngày và giờ bay.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 1
          },
          {
            "object": "block",
            "id": "11d5d164-78d8-80c8-bf1b-e6fe74b801ef",
            "parent": {
              "type": "block_id",
              "block_id": "11d5d164-78d8-80e8-aa36-f4b2344d0427"
            },
            "created_time": "2024-10-12T09:41:00.000Z",
            "last_edited_time": "2024-10-12T09:41:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Hệ thống hiển thị các chuyến bay tương ứng.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Hệ thống hiển thị các chuyến bay tương ứng.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 2
          },
          {
            "object": "block",
            "id": "11d5d164-78d8-802f-8d1d-e74ce1550f29",
            "parent": {
              "type": "block_id",
              "block_id": "11d5d164-78d8-80e8-aa36-f4b2344d0427"
            },
            "created_time": "2024-10-12T09:41:00.000Z",
            "last_edited_time": "2024-10-12T09:41:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Người dùng chọn chuyến bay và nhập thông tin hành khách.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Người dùng chọn chuyến bay và nhập thông tin hành khách.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 3
          },
          {
            "object": "block",
            "id": "11d5d164-78d8-8071-a2ee-d8d43979343f",
            "parent": {
              "type": "block_id",
              "block_id": "11d5d164-78d8-80e8-aa36-f4b2344d0427"
            },
            "created_time": "2024-10-12T09:41:00.000Z",
            "last_edited_time": "2024-10-12T09:41:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Hệ thống hiển thị tổng giá và yêu cầu thanh toán.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Hệ thống hiển thị tổng giá và yêu cầu thanh toán.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 4
          },
          {
            "object": "block",
            "id": "11d5d164-78d8-801f-892d-c3df3b108b08",
            "parent": {
              "type": "block_id",
              "block_id": "11d5d164-78d8-80e8-aa36-f4b2344d0427"
            },
            "created_time": "2024-10-12T09:41:00.000Z",
            "last_edited_time": "2024-10-12T09:41:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Người dùng chọn phương thức thanh toán và hoàn tất thanh toán.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Người dùng chọn phương thức thanh toán và hoàn tất thanh toán.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 5
          },
          {
            "object": "block",
            "id": "11d5d164-78d8-804f-8f01-cf2545ce60df",
            "parent": {
              "type": "block_id",
              "block_id": "11d5d164-78d8-80e8-aa36-f4b2344d0427"
            },
            "created_time": "2024-10-12T09:41:00.000Z",
            "last_edited_time": "2024-10-12T09:41:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Hệ thống xác nhận thanh toán và gửi vé máy bay điện tử tới email của người dùng.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Hệ thống xác nhận thanh toán và gửi vé máy bay điện tử tới email của người dùng.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 6
          }
        ]
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8089-9aba-c0a9ec06cfdc",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Dòng sự kiện mở rộng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Dòng sự kiện mở rộng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ":",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ":",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "11d5d164-78d8-8010-8222-f80d2aed4a90",
            "parent": {
              "type": "block_id",
              "block_id": "11d5d164-78d8-8089-9aba-c0a9ec06cfdc"
            },
            "created_time": "2024-10-12T09:41:00.000Z",
            "last_edited_time": "2024-10-12T09:41:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Nếu thông tin thanh toán không hợp lệ, hệ thống hiển thị thông báo lỗi và yêu cầu người dùng nhập lại.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Nếu thông tin thanh toán không hợp lệ, hệ thống hiển thị thông báo lỗi và yêu cầu người dùng nhập lại.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-80b8-8394-df809711c49d",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-17T10:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Điều kiện sau",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Điều kiện sau",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ":",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ":",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "11d5d164-78d8-805b-b02e-f173e4208106",
            "parent": {
              "type": "block_id",
              "block_id": "11d5d164-78d8-80b8-8394-df809711c49d"
            },
            "created_time": "2024-10-12T09:41:00.000Z",
            "last_edited_time": "2024-10-17T10:48:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Vé máy bay đã được đặt thành công và gửi cho người dùng.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Vé máy bay đã được đặt thành công và gửi cho người dùng.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "1225d164-78d8-80c6-9215-e0183129e8ff",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-17T10:48:00.000Z",
        "last_edited_time": "2024-10-17T10:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755488697/uxcomic-imgs/1225d164-78d8-80c6-9215-e0183129e8ff.png",
            "expiry_time": "2026-10-04T09:12:45.007Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1225d164-78d8-80c6-9215-e0183129e8ff"
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-80f1-849b-d02906913e53",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8091-a0a5-fae8760c2f55",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tại sao Use Case quan trọng?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tại sao Use Case quan trọng?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8036-8bf6-ec2431c3939e",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tập trung vào người dùng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tập trung vào người dùng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Use case giúp các nhóm phát triển tập trung vào nhu cầu của người dùng và cách họ sẽ tương tác với hệ thống, giúp xây dựng các tính năng thực sự hữu ích.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Use case giúp các nhóm phát triển tập trung vào nhu cầu của người dùng và cách họ sẽ tương tác với hệ thống, giúp xây dựng các tính năng thực sự hữu ích.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8059-b179-dc3f5fa6e5b2",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Rõ ràng và dễ hiểu",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Rõ ràng và dễ hiểu",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Use case mô tả một cách đơn giản và rõ ràng các bước cần thiết để đạt được một mục tiêu cụ thể, giúp cả đội phát triển, quản lý và các bên liên quan dễ dàng hiểu quy trình.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Use case mô tả một cách đơn giản và rõ ràng các bước cần thiết để đạt được một mục tiêu cụ thể, giúp cả đội phát triển, quản lý và các bên liên quan dễ dàng hiểu quy trình.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-80f5-a5a2-e6bee6485743",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giúp phát triển và kiểm thử",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giúp phát triển và kiểm thử",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Use case cung cấp một cơ sở tốt để viết mã và tạo ra các kịch bản kiểm thử nhằm đảm bảo rằng hệ thống hoạt động như mong đợi.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Use case cung cấp một cơ sở tốt để viết mã và tạo ra các kịch bản kiểm thử nhằm đảm bảo rằng hệ thống hoạt động như mong đợi.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8075-87c3-f0b5bcd26c1d",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Quản lý các tình huống ngoại lệ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Quản lý các tình huống ngoại lệ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Use case không chỉ mô tả các tình huống thành công mà còn giúp xác định và xử lý các trường hợp lỗi hoặc ngoại lệ, giúp hệ thống hoạt động ổn định hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Use case không chỉ mô tả các tình huống thành công mà còn giúp xác định và xử lý các trường hợp lỗi hoặc ngoại lệ, giúp hệ thống hoạt động ổn định hơn.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 3
      },
      {
        "object": "block",
        "id": "2525d164-78d8-8061-82ab-c48a1576a658",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2025-08-17T02:39:00.000Z",
        "last_edited_time": "2025-08-17T02:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-80f5-84da-d50c3429b5cd",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2025-08-17T02:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tóm lại",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tóm lại",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8089-8f6e-db7abdec7f8c",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:41:00.000Z",
        "last_edited_time": "2024-10-12T09:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Use case là công cụ mạnh mẽ để phân tích và mô tả cách hệ thống sẽ hoạt động trong các tình huống thực tế, đảm bảo rằng các tính năng được phát triển phù hợp với nhu cầu của người dùng và hoạt động theo cách mong đợi.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Use case là công cụ mạnh mẽ để phân tích và mô tả cách hệ thống sẽ hoạt động trong các tình huống thực tế, đảm bảo rằng các tính năng được phát triển phù hợp với nhu cầu của người dùng và hoạt động theo cách mong đợi.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8147-afc3-f9b144ee468f",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:38:00.000Z",
        "last_edited_time": "2024-10-12T09:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-8168-bee0-ec7a92051946",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:38:00.000Z",
        "last_edited_time": "2024-10-12T09:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-808e-9938-dd785d9e1c54",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:33:00.000Z",
        "last_edited_time": "2024-10-12T09:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.figma.com/resource-library/what-is-a-use-case/",
                "link": {
                  "url": "https://www.figma.com/resource-library/what-is-a-use-case/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.figma.com/resource-library/what-is-a-use-case/",
              "href": "https://www.figma.com/resource-library/what-is-a-use-case/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1225d164-78d8-80c0-ba7f-f376183661a5",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-17T10:49:00.000Z",
        "last_edited_time": "2024-10-17T10:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://venngage.com/blog/use-case-diagram-example/",
                "link": {
                  "url": "https://venngage.com/blog/use-case-diagram-example/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://venngage.com/blog/use-case-diagram-example/",
              "href": "https://venngage.com/blog/use-case-diagram-example/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-81ff-a0cc-ee4489ad9d73",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:38:00.000Z",
        "last_edited_time": "2024-10-12T09:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-810d-b87d-dd04a101cc21",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:38:00.000Z",
        "last_edited_time": "2024-10-12T09:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-810a-a117-d0981d53abeb",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:38:00.000Z",
        "last_edited_time": "2025-08-17T02:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1265d164-78d8-8045-87d2-e2532aae0b64"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Brief (Hiểu đề)",
              "href": "https://app.notion.com/p/1265d16478d8804587d2e2532aae0b64"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-81c6-978d-c3acaf2098b9",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2024-10-12T09:38:00.000Z",
        "last_edited_time": "2025-08-17T02:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1445d164-78d8-805b-b388-e24b5f13cccb"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product development process (overall)",
              "href": "https://app.notion.com/p/1445d16478d8805bb388e24b5f13cccb"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-803f-ab2c-dbce9588c15f",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2025-08-17T02:40:00.000Z",
        "last_edited_time": "2025-08-17T02:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1025d164-78d8-80c5-891f-debd0fc09547"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product development process (detail)",
              "href": "https://app.notion.com/p/1025d16478d880c5891fdebd0fc09547"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2525d164-78d8-80b2-8c4e-eab7ed00f173",
        "parent": {
          "type": "page_id",
          "page_id": "11d5d164-78d8-80f1-a613-c5735f42db88"
        },
        "created_time": "2025-08-17T02:40:00.000Z",
        "last_edited_time": "2025-08-17T02:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User Multiverse",
              "href": "https://app.notion.com/p/22a3b4bb88d34f84a70f83e7c12ac91d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "fba9a75a-71ae-4302-ac76-1431b742e33d",
    "created_time": "2024-10-10T06:06:00.000Z",
    "last_edited_time": "2026-02-02T04:30:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "~cV[",
          "name": "4-Measure",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2026-02-02T04:30:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": "cgmn",
          "name": "⚓:1",
          "color": "orange"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 20
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2024-10-10T06:06:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Just an experiment",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Just an experiment",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Just-an-experiment-fba9a75a71ae4302ac761431b742e33d",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "~cV[",
      "name": "Measure",
      "slug": "measure",
      "order": 4
    },
    "content": [
      {
        "object": "block",
        "id": "11b5d164-78d8-8111-a827-c82e1f1d6ac8",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-10-10T06:06:00.000Z",
        "last_edited_time": "2024-12-29T03:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081648/uxcomic-imgs/11b5d164-78d8-8111-a827-c82e1f1d6ac8.png",
            "expiry_time": "2026-10-04T09:12:48.873Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/11b5d164-78d8-8111-a827-c82e1f1d6ac8"
      },
      {
        "object": "block",
        "id": "11b5d164-78d8-8172-b116-eb4c08220724",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-10-10T06:06:00.000Z",
        "last_edited_time": "2024-12-29T02:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "UX Law, design principle, JTBD framework, competitive analysis, design research, IA, user flow, journey map, gestalts, interaction pattern…4479 việc khác để cho thấy mình & team đã bỏ rất nhiều công sức form lên một solution tuyệt hảo…Thoáng qua cả team hoặc bản thân mình sẽ cảm thấy tự tin rằng nó sẽ work, user sẽ thích lắm cho xem, chỉ số business metrics sẽ được cải thiện, nó sẽ viral, bla bla",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX Law, design principle, JTBD framework, competitive analysis, design research, IA, user flow, journey map, gestalts, interaction pattern…4479 việc khác để cho thấy mình & team đã bỏ rất nhiều công sức form lên một solution tuyệt hảo…Thoáng qua cả team hoặc bản thân mình sẽ cảm thấy tự tin rằng nó sẽ work, user sẽ thích lắm cho xem, chỉ số business metrics sẽ được cải thiện, nó sẽ viral, bla bla",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16a5d164-78d8-8005-ade6-c0aa7bb33a64",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-28T08:13:00.000Z",
        "last_edited_time": "2024-12-28T08:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhưng không, tất cả đều có thể SAI.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhưng không, tất cả đều có thể SAI.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-807b-872a-e1ca8de869b2",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T02:43:00.000Z",
        "last_edited_time": "2024-12-29T02:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081649/uxcomic-imgs/16b5d164-78d8-807b-872a-e1ca8de869b2.webp",
            "expiry_time": "2026-10-04T09:12:48.873Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/16b5d164-78d8-807b-872a-e1ca8de869b2"
      },
      {
        "object": "block",
        "id": "16a5d164-78d8-8040-8037-d94dc970759a",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-28T08:07:00.000Z",
        "last_edited_time": "2025-08-07T12:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "SAI là thứ chúng ta sẽ không hề mong muốn, mà ảo tưởng rằng mình đúng thì còn tệ hơn, biết rằng mình sai hoặc mình sẽ sai rất quan trọng trong ngành làm product này, nó giúp ta quay lại nhìn nhận thực tế user sử dụng nó ra sao, có rất nhiều thứ ta không lường trước hoặc assume sai lầm hoàn toàn về user >> biết mình sai thì sẽ đi tìm cách cải thiện product tốt hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "SAI là thứ chúng ta sẽ không hề mong muốn, mà ảo tưởng rằng mình đúng thì còn tệ hơn, biết rằng mình sai hoặc mình sẽ sai rất quan trọng trong ngành làm product này, nó giúp ta quay lại nhìn nhận thực tế user sử dụng nó ra sao, có rất nhiều thứ ta không lường trước hoặc assume sai lầm hoàn toàn về user >> biết mình sai thì sẽ đi tìm cách cải thiện product tốt hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-8010-99f5-fe06a92cd240",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T01:38:00.000Z",
        "last_edited_time": "2024-12-29T03:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mặc dù sai là thứ ta không thể control được nhưng ta kiểm soát được khi nào thì nên kiểm chứng giả thuyết của chúng ta, nói vui vui là lên ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mặc dù sai là thứ ta không thể control được nhưng ta kiểm soát được khi nào thì nên kiểm chứng giả thuyết của chúng ta, nói vui vui là lên ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "chiến lược để biết mình sai. ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "chiến lược để biết mình sai. ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Nhận ra mình sai đúng lúc là thứ bạn cần để tránh hao tổn công sức, tiền bạc.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhận ra mình sai đúng lúc là thứ bạn cần để tránh hao tổn công sức, tiền bạc.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-8012-8317-fb90116df289",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T01:41:00.000Z",
        "last_edited_time": "2024-12-29T01:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> Đây là Experimental Mindset (tư duy thử nghiệm)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> Đây là Experimental Mindset (tư duy thử nghiệm)",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-800e-a3df-d7daf5fdd6e0",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T01:41:00.000Z",
        "last_edited_time": "2024-12-29T01:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "11b5d164-78d8-810b-8f13-fcc0647e4cb0",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-10-10T06:06:00.000Z",
        "last_edited_time": "2024-12-29T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Experimental Mindset?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Experimental Mindset?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-8050-927d-dfd2962291e7",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T01:43:00.000Z",
        "last_edited_time": "2024-12-29T02:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“72% of new products and services fail.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“72% of new products and services fail.",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Kucher 2014",
                "link": {
                  "url": "https://www.simon-kucher.com/sites/default/files/simon-kucher_global_pricing_study_2014.pdf"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Kucher 2014",
              "href": "https://www.simon-kucher.com/sites/default/files/simon-kucher_global_pricing_study_2014.pdf"
            },
            {
              "type": "text",
              "text": {
                "content": ") For startups, that number can go as high as 90%. (",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ") For startups, that number can go as high as 90%. (",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Startup Genome 2011",
                "link": {
                  "url": "https://innovationfootprints.com/wp-content/uploads/2015/07/startup-genome-report-extra-on-premature-scaling.pdf"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Startup Genome 2011",
              "href": "https://innovationfootprints.com/wp-content/uploads/2015/07/startup-genome-report-extra-on-premature-scaling.pdf"
            },
            {
              "type": "text",
              "text": {
                "content": ")” >> với % fail cao như thế, bạn có nghĩ mình tự tin được với solution trong tay hay không?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ")” >> với % fail cao như thế, bạn có nghĩ mình tự tin được với solution trong tay hay không?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-800c-aabd-d26a3357d295",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2025-01-10T05:48:00.000Z",
        "last_edited_time": "2025-01-10T05:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11b5d164-78d8-810b-a4a2-d8935c35fa9f",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-10-10T06:06:00.000Z",
        "last_edited_time": "2024-12-29T02:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chúng ta là một designer nên hiểu mindset này ngay từ sớm. Sẽ thật buồn cười nếu nói design cho user mà chưa một lần nào gặp họ, chưa một lần ngồi quan sát xem cách họ dùng thế nào, nó giống như một đầu bếp chẳng bao giờ hỏi han thực khách xem món ăn có hợp khẩu vị hay không, chỉ làm ra & để đó, quán đông hay ế cũng không biết vì sao.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chúng ta là một designer nên hiểu mindset này ngay từ sớm. Sẽ thật buồn cười nếu nói design cho user mà chưa một lần nào gặp họ, chưa một lần ngồi quan sát xem cách họ dùng thế nào, nó giống như một đầu bếp chẳng bao giờ hỏi han thực khách xem món ăn có hợp khẩu vị hay không, chỉ làm ra & để đó, quán đông hay ế cũng không biết vì sao.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-804b-a066-d11bf8bdab73",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2025-01-10T05:48:00.000Z",
        "last_edited_time": "2025-01-10T05:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-8063-a1b2-c21ceda13954",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T01:47:00.000Z",
        "last_edited_time": "2024-12-29T02:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Có thể hình dung chúng ta (một designer) hay product team (đội build nên sản phẩm) phải xem mình như một nhà khoa học, chúng ta không nên tự hào khi release được một feature hay product nào đó, mà nên tự hào khi thực sự thấy được outcome của nó (cách user tiếp nhận & dùng nó). Bạn giống như một nhà hoá học tạo ra được một hợp chất mới (the solution) & cần thử nghiệm nó, kết hợp chúng với các chất khác (the realities of messy humans in a chaotic world) để xem phản ứng hoá học của nó ra sao.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Có thể hình dung chúng ta (một designer) hay product team (đội build nên sản phẩm) phải xem mình như một nhà khoa học, chúng ta không nên tự hào khi release được một feature hay product nào đó, mà nên tự hào khi thực sự thấy được outcome của nó (cách user tiếp nhận & dùng nó). Bạn giống như một nhà hoá học tạo ra được một hợp chất mới (the solution) & cần thử nghiệm nó, kết hợp chúng với các chất khác (the realities of messy humans in a chaotic world) để xem phản ứng hoá học của nó ra sao.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-80fa-95ad-c697d3d8203f",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T01:44:00.000Z",
        "last_edited_time": "2024-12-29T02:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Experimental Mindset",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Experimental Mindset",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là một cách tư duy khuyến khích thử nghiệm, học hỏi và cải tiến liên tục thông qua việc thiết kế các giả thuyết, thực hiện các thí nghiệm, và phân tích kết quả để đưa ra quyết định dựa trên dữ liệu thay vì cảm giác hoặc giả định. Đây là một phương pháp tư duy linh hoạt, tập trung vào ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là một cách tư duy khuyến khích thử nghiệm, học hỏi và cải tiến liên tục thông qua việc thiết kế các giả thuyết, thực hiện các thí nghiệm, và phân tích kết quả để đưa ra quyết định dựa trên dữ liệu thay vì cảm giác hoặc giả định. Đây là một phương pháp tư duy linh hoạt, tập trung vào ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "khám phá",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "khám phá",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " và ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " và ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "kiểm chứng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "kiểm chứng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " thay vì chỉ dựa vào những ý tưởng ban đầu.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " thay vì chỉ dựa vào những ý tưởng ban đầu.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-8064-86d2-de219e1d03b8",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T02:08:00.000Z",
        "last_edited_time": "2024-12-29T02:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "11b5d164-78d8-8173-bc22-cd848680ba04",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-10-10T06:06:00.000Z",
        "last_edited_time": "2024-12-29T01:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "How",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "How",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-80cc-b9ba-fd1a5fa3b082",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T02:05:00.000Z",
        "last_edited_time": "2025-08-07T12:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phông bạt vậy thôi, chứ mình cũng đang học về cái này nhiều vì thực tế công việc hiện tại của mình cũng không nhiều cơ hội để test user, thông thường, để kiểm chứng assumption, hypothesis đều đang dựa trên phản hồi từ data là chính. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phông bạt vậy thôi, chứ mình cũng đang học về cái này nhiều vì thực tế công việc hiện tại của mình cũng không nhiều cơ hội để test user, thông thường, để kiểm chứng assumption, hypothesis đều đang dựa trên phản hồi từ data là chính. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2485d164-78d8-8083-a8de-d7c6a7edbadb",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2025-08-07T12:04:00.000Z",
        "last_edited_time": "2025-08-07T12:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhưng đã qua vài lần làm user testing, mình thật sự thấy được tính cần thiết của nó. Đâu đó mình còn nghĩ thay vì là một bậc thầy design, ta nên là một bậc thầy về việc test, thực tế / fact nên là anh cả của mọi principle.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhưng đã qua vài lần làm user testing, mình thật sự thấy được tính cần thiết của nó. Đâu đó mình còn nghĩ thay vì là một bậc thầy design, ta nên là một bậc thầy về việc test, thực tế / fact nên là anh cả của mọi principle.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-8048-83dc-e598804e1a17",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T02:24:00.000Z",
        "last_edited_time": "2024-12-29T02:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Your assumptions are your windows on the world. Scrub them off every once in a while, or the light won't come in.” ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Your assumptions are your windows on the world. Scrub them off every once in a while, or the light won't come in.” ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "― Alan Alda",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "― Alan Alda",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-8016-acf3-c418326fdeee",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T02:53:00.000Z",
        "last_edited_time": "2024-12-29T02:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-80d5-b20e-c4259edd204d",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T01:55:00.000Z",
        "last_edited_time": "2024-12-29T02:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chúng ta có 7 principles để tập quen experimental mindset như sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chúng ta có 7 principles để tập quen experimental mindset như sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-80bf-b390-d0c89bf1a8bc",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T02:24:00.000Z",
        "last_edited_time": "2024-12-29T02:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "16b5d164-78d8-80b2-8c5a-f7cce72490c0",
            "parent": {
              "type": "block_id",
              "block_id": "16b5d164-78d8-80bf-b390-d0c89bf1a8bc"
            },
            "created_time": "2024-12-29T01:54:00.000Z",
            "last_edited_time": "2024-12-29T02:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Test assumptions. Don’t test ideas.",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Test assumptions. Don’t test ideas.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 0
          },
          {
            "object": "block",
            "id": "16b5d164-78d8-80ce-9d1b-c540b5f74bd2",
            "parent": {
              "type": "block_id",
              "block_id": "16b5d164-78d8-80bf-b390-d0c89bf1a8bc"
            },
            "created_time": "2024-12-29T01:54:00.000Z",
            "last_edited_time": "2024-12-29T02:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Every prototype should be a test.",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Every prototype should be a test.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 1
          },
          {
            "object": "block",
            "id": "16b5d164-78d8-80ac-81d3-f43d98a9650b",
            "parent": {
              "type": "block_id",
              "block_id": "16b5d164-78d8-80bf-b390-d0c89bf1a8bc"
            },
            "created_time": "2024-12-29T01:54:00.000Z",
            "last_edited_time": "2024-12-29T02:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Test Desirability, not just Usability.",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Test Desirability, not just Usability.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 2
          },
          {
            "object": "block",
            "id": "16b5d164-78d8-8033-8880-d410f8447d3c",
            "parent": {
              "type": "block_id",
              "block_id": "16b5d164-78d8-80bf-b390-d0c89bf1a8bc"
            },
            "created_time": "2024-12-29T01:54:00.000Z",
            "last_edited_time": "2024-12-29T02:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Convince with data, not opinions.",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Convince with data, not opinions.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 3
          },
          {
            "object": "block",
            "id": "16b5d164-78d8-80a2-a55a-f1196d601260",
            "parent": {
              "type": "block_id",
              "block_id": "16b5d164-78d8-80bf-b390-d0c89bf1a8bc"
            },
            "created_time": "2024-12-29T01:54:00.000Z",
            "last_edited_time": "2024-12-29T02:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Design quick and dirty, not pixel-perfect.",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Design quick and dirty, not pixel-perfect.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 4
          },
          {
            "object": "block",
            "id": "16b5d164-78d8-80d4-b36c-c3dfe1e127a0",
            "parent": {
              "type": "block_id",
              "block_id": "16b5d164-78d8-80bf-b390-d0c89bf1a8bc"
            },
            "created_time": "2024-12-29T01:54:00.000Z",
            "last_edited_time": "2024-12-29T02:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Design experiments bold enough to “fail.”",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Design experiments bold enough to “fail.”",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 5
          },
          {
            "object": "block",
            "id": "16b5d164-78d8-8026-a71a-fde10137a233",
            "parent": {
              "type": "block_id",
              "block_id": "16b5d164-78d8-80bf-b390-d0c89bf1a8bc"
            },
            "created_time": "2024-12-29T01:54:00.000Z",
            "last_edited_time": "2024-12-29T02:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Generate evidence critically.",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Generate evidence critically.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 6
          }
        ]
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-80db-9a9c-d28ff07ef4cb",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T02:16:00.000Z",
        "last_edited_time": "2024-12-29T03:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chi tiết hơn từng mục, bạn xem thêm 👉 ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chi tiết hơn từng mục, bạn xem thêm 👉 ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "bài viết này",
                "link": {
                  "url": "https://www.thefountaininstitute.com/blog/getting-started-in-testing-and-experimentation-a-designers-guide"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "bài viết này",
              "href": "https://www.thefountaininstitute.com/blog/getting-started-in-testing-and-experimentation-a-designers-guide"
            },
            {
              "type": "text",
              "text": {
                "content": " 👈 nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " 👈 nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-8091-8f4a-e53f8c928a90",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T02:18:00.000Z",
        "last_edited_time": "2024-12-29T02:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-8093-91c1-fb81f88f4500",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T02:18:00.000Z",
        "last_edited_time": "2024-12-29T02:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tóm lại",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tóm lại",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-80c1-9b87-c5fecd5c0da6",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T02:39:00.000Z",
        "last_edited_time": "2024-12-29T02:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“We don't need rockstars and experts when judging ideas based on experiment outcomes. We need critically-thinking teams. We don’t need to design stuff to appease an ego or an instinct. We need to see our ideas based on the only person who can determine our ideas' validity: the customer.”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“We don't need rockstars and experts when judging ideas based on experiment outcomes. We need critically-thinking teams. We don’t need to design stuff to appease an ego or an instinct. We need to see our ideas based on the only person who can determine our ideas' validity: the customer.”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-803b-9167-d3732e48c52a",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T02:54:00.000Z",
        "last_edited_time": "2024-12-29T02:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Như cách một cảnh sát trưởng hay hỏi trước khi bắt tội phạm: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Như cách một cảnh sát trưởng hay hỏi trước khi bắt tội phạm: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "“Bằng chứng đâu?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Bằng chứng đâu?",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "”.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1775d164-78d8-80c1-a039-cece45e95bab",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2025-01-10T05:49:00.000Z",
        "last_edited_time": "2025-01-10T05:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-80b5-963b-e3403bb6e58a",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T02:18:00.000Z",
        "last_edited_time": "2024-12-29T02:18:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bạn cần trả lời các câu hỏi sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bạn cần trả lời các câu hỏi sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-803a-80f2-f7ddeca8679b",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T02:18:00.000Z",
        "last_edited_time": "2024-12-29T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "1/ Xác định mục tiêu việc test là gì? ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "1/ Xác định mục tiêu việc test là gì? ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "- Đánh giá xem ta đang có loại risk nào trong solution đó - theo 4 big risks of product (viability, desirability, feasibility, and usability).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "- Đánh giá xem ta đang có loại risk nào trong solution đó - theo 4 big risks of product (viability, desirability, feasibility, and usability).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-8066-a26d-c39ee2c69a11",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T02:22:00.000Z",
        "last_edited_time": "2024-12-29T02:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081651/uxcomic-imgs/16b5d164-78d8-8066-a26d-c39ee2c69a11.png",
            "expiry_time": "2026-10-04T09:12:49.016Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/16b5d164-78d8-8066-a26d-c39ee2c69a11"
      },
      {
        "object": "block",
        "id": "1775d164-78d8-80f9-8ef2-fb84d8046535",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2025-01-10T05:49:00.000Z",
        "last_edited_time": "2025-01-10T05:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-8054-b18c-cd7f441578dc",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T02:18:00.000Z",
        "last_edited_time": "2024-12-29T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "2/ Liệu assumption có critical để cần test hay không?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2/ Liệu assumption có critical để cần test hay không?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-806b-9ac9-f204ab6c0fbe",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T02:22:00.000Z",
        "last_edited_time": "2024-12-29T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081652/uxcomic-imgs/16b5d164-78d8-806b-9ac9-f204ab6c0fbe.png",
            "expiry_time": "2026-10-04T09:12:49.017Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/16b5d164-78d8-806b-9ac9-f204ab6c0fbe"
      },
      {
        "object": "block",
        "id": "1775d164-78d8-8069-9421-fdc487274d92",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2025-01-10T05:49:00.000Z",
        "last_edited_time": "2025-01-10T05:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-8052-adb9-dd27225c1023",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T02:20:00.000Z",
        "last_edited_time": "2024-12-29T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "3/ Ta nên test nó như thế nào",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3/ Ta nên test nó như thế nào",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " để tiết kiệm công sức nhất & cần aware về mức độ chắc chắn, uy tín của phương pháp test đó ra sao?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " để tiết kiệm công sức nhất & cần aware về mức độ chắc chắn, uy tín của phương pháp test đó ra sao?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-80a4-9a41-f6165ad81c5e",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T02:22:00.000Z",
        "last_edited_time": "2024-12-29T02:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081653/uxcomic-imgs/16b5d164-78d8-80a4-9a41-f6165ad81c5e.png",
            "expiry_time": "2026-10-04T09:12:49.017Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/16b5d164-78d8-80a4-9a41-f6165ad81c5e"
      },
      {
        "object": "block",
        "id": "11b5d164-78d8-8117-9e37-efef24978194",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-10-10T06:06:00.000Z",
        "last_edited_time": "2024-10-10T06:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-80cd-87e3-c029d64202b8",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T03:05:00.000Z",
        "last_edited_time": "2024-12-29T03:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Template",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Template",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-8072-831e-cabd96306523",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T02:11:00.000Z",
        "last_edited_time": "2024-12-29T03:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình lấy từ the Fountain Institute",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình lấy từ the Fountain Institute",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2575d164-78d8-80f3-9127-ee2876afa6d3",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2025-08-22T01:39:00.000Z",
        "last_edited_time": "2025-08-22T01:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "toggle",
        "toggle": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "list",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "list",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "16b5d164-78d8-807c-a9ea-d63f04f70ac6",
            "parent": {
              "type": "block_id",
              "block_id": "2575d164-78d8-80f3-9127-ee2876afa6d3"
            },
            "created_time": "2024-12-29T02:12:00.000Z",
            "last_edited_time": "2025-08-22T01:39:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081655/uxcomic-imgs/16b5d164-78d8-807c-a9ea-d63f04f70ac6.png",
                "expiry_time": "2026-10-04T09:12:50.692Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/16b5d164-78d8-807c-a9ea-d63f04f70ac6"
          },
          {
            "object": "block",
            "id": "16b5d164-78d8-80ee-9861-dd0136832fa4",
            "parent": {
              "type": "block_id",
              "block_id": "2575d164-78d8-80f3-9127-ee2876afa6d3"
            },
            "created_time": "2024-12-29T02:12:00.000Z",
            "last_edited_time": "2025-08-22T01:40:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081656/uxcomic-imgs/16b5d164-78d8-80ee-9861-dd0136832fa4.png",
                "expiry_time": "2026-10-04T09:12:50.693Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/16b5d164-78d8-80ee-9861-dd0136832fa4"
          },
          {
            "object": "block",
            "id": "16b5d164-78d8-80d8-84ca-f6884ecc44b4",
            "parent": {
              "type": "block_id",
              "block_id": "2575d164-78d8-80f3-9127-ee2876afa6d3"
            },
            "created_time": "2024-12-29T02:14:00.000Z",
            "last_edited_time": "2025-08-22T01:40:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081658/uxcomic-imgs/16b5d164-78d8-80d8-84ca-f6884ecc44b4.jpg",
                "expiry_time": "2026-10-04T09:12:50.693Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/16b5d164-78d8-80d8-84ca-f6884ecc44b4"
          },
          {
            "object": "block",
            "id": "16b5d164-78d8-80ce-82c6-cdff8048c6ec",
            "parent": {
              "type": "block_id",
              "block_id": "2575d164-78d8-80f3-9127-ee2876afa6d3"
            },
            "created_time": "2024-12-29T02:14:00.000Z",
            "last_edited_time": "2025-08-22T01:40:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "image",
            "image": {
              "caption": [],
              "type": "file",
              "file": {
                "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081659/uxcomic-imgs/16b5d164-78d8-80ce-82c6-cdff8048c6ec.png",
                "expiry_time": "2026-10-04T09:12:50.693Z"
              }
            },
            "archived": false,
            "public_id": "uxcomic-imgs/16b5d164-78d8-80ce-82c6-cdff8048c6ec"
          }
        ]
      },
      {
        "object": "block",
        "id": "2fb5d164-78d8-80ad-b97e-ee8d7e7daacb",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2026-02-02T04:27:00.000Z",
        "last_edited_time": "2026-02-02T04:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Measure Judgement Test",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Measure Judgement Test",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2fb5d164-78d8-8024-9cd7-ddc9326a1575",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2026-02-02T04:27:00.000Z",
        "last_edited_time": "2026-02-02T04:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tool này mình tìm được trên mạng, nó dùng để đo đếm xem nhưng lần mình “đoán” trong product bao nhiêu % là đúng và sai, nhờ có một tool để log như thế, mình mới reflect được những initiative, những decision mà mình đưa ra, sau một thời gian nhìn lại, nó có quá tự tin hay thực tế,… Nói chung khá hay ho 😀",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tool này mình tìm được trên mạng, nó dùng để đo đếm xem nhưng lần mình “đoán” trong product bao nhiêu % là đúng và sai, nhờ có một tool để log như thế, mình mới reflect được những initiative, những decision mà mình đưa ra, sau một thời gian nhìn lại, nó có quá tự tin hay thực tế,… Nói chung khá hay ho 😀",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2fb5d164-78d8-8019-b850-d24bf87b47f7",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2026-02-02T04:27:00.000Z",
        "last_edited_time": "2026-02-02T04:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.notion.so/The-Product-Judgment-Test-2e92182754b68081a535fd7f507f7b91",
                "link": {
                  "url": "https://www.notion.so/The-Product-Judgment-Test-2e92182754b68081a535fd7f507f7b91"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.notion.so/The-Product-Judgment-Test-2e92182754b68081a535fd7f507f7b91",
              "href": "https://www.notion.so/The-Product-Judgment-Test-2e92182754b68081a535fd7f507f7b91"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-80fe-a03a-e9017a73b820",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T03:06:00.000Z",
        "last_edited_time": "2024-12-29T03:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "11b5d164-78d8-813a-8a0e-f0e2ff350737",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-10-10T06:06:00.000Z",
        "last_edited_time": "2024-10-10T06:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23b5d164-78d8-8040-9f3b-f722469bb5eb",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2025-07-25T03:00:00.000Z",
        "last_edited_time": "2025-10-17T02:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://thailam.substack.com/p/ab-test-danh-cho-product-designer",
                "link": {
                  "url": "https://thailam.substack.com/p/ab-test-danh-cho-product-designer"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://thailam.substack.com/p/ab-test-danh-cho-product-designer",
              "href": "https://thailam.substack.com/p/ab-test-danh-cho-product-designer"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11b5d164-78d8-81cd-93d7-cab205c4b64d",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-10-10T06:06:00.000Z",
        "last_edited_time": "2024-11-26T07:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://d.mba/guides/derisking-innovation-a-guide-for-designers",
                "link": {
                  "url": "https://d.mba/guides/derisking-innovation-a-guide-for-designers"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://d.mba/guides/derisking-innovation-a-guide-for-designers",
              "href": "https://d.mba/guides/derisking-innovation-a-guide-for-designers"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11b5d164-78d8-811e-a52c-d530b901b2ba",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-10-10T06:06:00.000Z",
        "last_edited_time": "2024-12-29T01:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.thefountaininstitute.com/blog/getting-started-in-testing-and-experimentation-a-designers-guide",
                "link": {
                  "url": "https://www.thefountaininstitute.com/blog/getting-started-in-testing-and-experimentation-a-designers-guide"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.thefountaininstitute.com/blog/getting-started-in-testing-and-experimentation-a-designers-guide",
              "href": "https://www.thefountaininstitute.com/blog/getting-started-in-testing-and-experimentation-a-designers-guide"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17a5d164-78d8-8065-9647-dc4f717dc732",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2025-01-13T03:00:00.000Z",
        "last_edited_time": "2025-01-13T03:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://uxmyths.com/",
                "link": {
                  "url": "https://uxmyths.com/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://uxmyths.com/",
              "href": "https://uxmyths.com/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28f5d164-78d8-80df-a031-df2a45318523",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2025-10-17T02:41:00.000Z",
        "last_edited_time": "2025-10-17T02:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://measuringu.com/he-cw/",
                "link": {
                  "url": "https://measuringu.com/he-cw/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://measuringu.com/he-cw/",
              "href": "https://measuringu.com/he-cw/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2955d164-78d8-807a-b0ef-c7357901185b",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2025-10-23T07:54:00.000Z",
        "last_edited_time": "2025-10-23T07:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://mercury.com/blog/measuring-product-market-fit",
                "link": {
                  "url": "https://mercury.com/blog/measuring-product-market-fit"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://mercury.com/blog/measuring-product-market-fit",
              "href": "https://mercury.com/blog/measuring-product-market-fit"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11b5d164-78d8-8125-b9b4-c25ae0c96f7d",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-10-10T06:06:00.000Z",
        "last_edited_time": "2024-12-29T02:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Book “The mom test” - Rob Fitzpatrick",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Book “The mom test” - Rob Fitzpatrick",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11b5d164-78d8-812f-85c4-e3cb5d571aee",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-10-10T06:06:00.000Z",
        "last_edited_time": "2024-10-10T06:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "11b5d164-78d8-817c-8ad7-ebd44af9f5c9",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-10-10T06:06:00.000Z",
        "last_edited_time": "2024-10-10T06:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "25c5d164-78d8-8005-bc20-fb66a192b7c9",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2025-08-27T10:58:00.000Z",
        "last_edited_time": "2025-08-27T10:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "25a5d164-78d8-8022-885c-cf74b030e53d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Measuring checklist",
              "href": "https://app.notion.com/p/25a5d16478d88022885ccf74b030e53d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11b5d164-78d8-814a-a8f3-f2e08ab913b2",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-10-10T06:06:00.000Z",
        "last_edited_time": "2024-12-29T02:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Understand, Empathize user?",
              "href": "https://app.notion.com/p/32cbe568c34b4255a408f2a2e6227bb2"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11b5d164-78d8-818d-9bbd-e9a61c911293",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-10-10T06:06:00.000Z",
        "last_edited_time": "2024-12-29T02:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User Multiverse",
              "href": "https://app.notion.com/p/22a3b4bb88d34f84a70f83e7c12ac91d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-80c1-9024-d9c70726cd73",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2024-12-29T02:28:00.000Z",
        "last_edited_time": "2024-12-29T02:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1605d164-78d8-80c3-b322-f577530e7916"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Questionnaire toolkit",
              "href": "https://app.notion.com/p/1605d16478d880c3b322f577530e7916"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23b5d164-78d8-8053-a1d5-f1c418f0d117",
        "parent": {
          "type": "page_id",
          "page_id": "fba9a75a-71ae-4302-ac76-1431b742e33d"
        },
        "created_time": "2025-07-25T03:00:00.000Z",
        "last_edited_time": "2025-07-25T03:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "140a6f9c-8b40-41a9-bbaf-28c279a87dff",
    "created_time": "2024-10-07T10:44:00.000Z",
    "last_edited_time": "2024-12-31T00:47:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "3-Build",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2024-12-31T00:47:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": "HnPZ",
          "name": "⚔️:3",
          "color": "default"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 19
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2024-10-07T10:44:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Essential Design Principles ",
              "link": null
            },
            "annotations": {
              "bold": true,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Essential Design Principles ",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Essential-Design-Principles-140a6f9c8b4041a9bbaf28c279a87dff",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
      "name": "Build",
      "slug": "build",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "1185d164-78d8-81f6-a064-eac763f1bce6",
        "parent": {
          "type": "page_id",
          "page_id": "140a6f9c-8b40-41a9-bbaf-28c279a87dff"
        },
        "created_time": "2024-10-07T10:44:00.000Z",
        "last_edited_time": "2024-10-08T06:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081662/uxcomic-imgs/1185d164-78d8-81f6-a064-eac763f1bce6.png",
            "expiry_time": "2026-10-04T09:12:51.882Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1185d164-78d8-81f6-a064-eac763f1bce6"
      },
      {
        "object": "block",
        "id": "1185d164-78d8-815d-a65d-e084da8443f0",
        "parent": {
          "type": "page_id",
          "page_id": "140a6f9c-8b40-41a9-bbaf-28c279a87dff"
        },
        "created_time": "2024-10-07T10:44:00.000Z",
        "last_edited_time": "2024-10-08T06:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình tình cờ xem được clip này của Apple nói về các design principle. Thật sự rất hữu ích, đó là tất cả những consideration cần thì come up một design. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình tình cờ xem được clip này của Apple nói về các design principle. Thật sự rất hữu ích, đó là tất cả những consideration cần thì come up một design. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-8080-b2fa-e145b52c8f50",
        "parent": {
          "type": "page_id",
          "page_id": "140a6f9c-8b40-41a9-bbaf-28c279a87dff"
        },
        "created_time": "2024-10-08T06:29:00.000Z",
        "last_edited_time": "2024-10-08T06:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu tự hỏi tại sao các thiết kế design từ Apple lại tuyệt vời đến thế.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu tự hỏi tại sao các thiết kế design từ Apple lại tuyệt vời đến thế.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-802f-bc7b-d9110d7e2f09",
        "parent": {
          "type": "page_id",
          "page_id": "140a6f9c-8b40-41a9-bbaf-28c279a87dff"
        },
        "created_time": "2024-10-08T07:10:00.000Z",
        "last_edited_time": "2024-10-08T09:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu bạn thắc mắc tại sao Apple gọi “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu bạn thắc mắc tại sao Apple gọi “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "human interface",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "human interface",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "” not “user interface”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” not “user interface”",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-8093-ad0f-e35a2e445a11",
        "parent": {
          "type": "page_id",
          "page_id": "140a6f9c-8b40-41a9-bbaf-28c279a87dff"
        },
        "created_time": "2024-10-08T06:29:00.000Z",
        "last_edited_time": "2024-10-08T07:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu bạn tự hỏi làm sao để biết design, UX, UI mình đã đủ tốt chưa? Làm thế nào để audit các UX của sản phẩm khác.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu bạn tự hỏi làm sao để biết design, UX, UI mình đã đủ tốt chưa? Làm thế nào để audit các UX của sản phẩm khác.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-8007-894d-fbc45c787b14",
        "parent": {
          "type": "page_id",
          "page_id": "140a6f9c-8b40-41a9-bbaf-28c279a87dff"
        },
        "created_time": "2024-10-08T06:30:00.000Z",
        "last_edited_time": "2024-12-30T15:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đâu là những thứ mình cần ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đâu là những thứ mình cần ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "nằm lòng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "nằm lòng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " khi bắt tay vào thiết kế UX/UI, cái gì làm nên một thiết kế tốt,",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " khi bắt tay vào thiết kế UX/UI, cái gì làm nên một thiết kế tốt,",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " trực quan",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " trực quan",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-8048-8f55-c90b14338eaa",
        "parent": {
          "type": "page_id",
          "page_id": "140a6f9c-8b40-41a9-bbaf-28c279a87dff"
        },
        "created_time": "2024-10-08T06:05:00.000Z",
        "last_edited_time": "2024-12-31T00:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "video",
        "video": {
          "caption": [],
          "type": "external",
          "external": {
            "url": "https://www.youtube.com/watch?v=Sv3G3z6WzxU"
          }
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-80c2-96e5-d514b8d9363a",
        "parent": {
          "type": "page_id",
          "page_id": "140a6f9c-8b40-41a9-bbaf-28c279a87dff"
        },
        "created_time": "2024-10-08T06:31:00.000Z",
        "last_edited_time": "2024-10-08T06:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081664/uxcomic-imgs/1195d164-78d8-80c2-96e5-d514b8d9363a.png",
            "expiry_time": "2026-10-04T09:12:51.882Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1195d164-78d8-80c2-96e5-d514b8d9363a"
      },
      {
        "object": "block",
        "id": "1195d164-78d8-800f-b762-f059a2c9802a",
        "parent": {
          "type": "page_id",
          "page_id": "140a6f9c-8b40-41a9-bbaf-28c279a87dff"
        },
        "created_time": "2024-10-08T07:27:00.000Z",
        "last_edited_time": "2024-10-08T07:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Design principles are the key to understanding how design serves human needs for safety, meaning, achievement and beauty. Learn what these principles are and how they can help you design more welcoming, understandable, empowering and gratifying user experiences.” - Apple Developer",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Design principles are the key to understanding how design serves human needs for safety, meaning, achievement and beauty. Learn what these principles are and how they can help you design more welcoming, understandable, empowering and gratifying user experiences.” - Apple Developer",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-8185-ba03-e1620ec7ba2f",
        "parent": {
          "type": "page_id",
          "page_id": "140a6f9c-8b40-41a9-bbaf-28c279a87dff"
        },
        "created_time": "2024-10-07T10:44:00.000Z",
        "last_edited_time": "2024-10-07T10:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-81a0-887c-da859eaf3018",
        "parent": {
          "type": "page_id",
          "page_id": "140a6f9c-8b40-41a9-bbaf-28c279a87dff"
        },
        "created_time": "2024-10-07T10:44:00.000Z",
        "last_edited_time": "2024-10-07T10:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1185d164-78d8-8198-b978-eaf49ba491a6",
        "parent": {
          "type": "page_id",
          "page_id": "140a6f9c-8b40-41a9-bbaf-28c279a87dff"
        },
        "created_time": "2024-10-07T10:44:00.000Z",
        "last_edited_time": "2024-10-09T08:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://uxdesign.cc/design-what-makes-us-human-a1b9013f1db6",
                "link": {
                  "url": "https://uxdesign.cc/design-what-makes-us-human-a1b9013f1db6"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://uxdesign.cc/design-what-makes-us-human-a1b9013f1db6",
              "href": "https://uxdesign.cc/design-what-makes-us-human-a1b9013f1db6"
            }
          ],
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1165d164-78d8-80cb-9163-f985f8d8a788",
    "created_time": "2024-10-05T09:32:00.000Z",
    "last_edited_time": "2026-05-27T08:49:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "3-Build",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2026-05-27T08:49:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": "}QTb",
          "name": "⚔️:2",
          "color": "gray"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 18
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2024-10-05T09:32:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "IA? OOUX? Conceptual model?",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "IA? OOUX? Conceptual model?",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/IA-OOUX-Conceptual-model-1165d16478d880cb9163f985f8d8a788",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
      "name": "Build",
      "slug": "build",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "1225d164-78d8-816b-984f-db4efc94ddc2",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T02:00:00.000Z",
        "last_edited_time": "2024-11-15T01:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081667/uxcomic-imgs/1225d164-78d8-816b-984f-db4efc94ddc2.png",
            "expiry_time": "2026-10-04T09:12:52.421Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1225d164-78d8-816b-984f-db4efc94ddc2"
      },
      {
        "object": "block",
        "id": "1225d164-78d8-81e0-b601-f8eb6b4e4f9b",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T02:00:00.000Z",
        "last_edited_time": "2024-10-18T08:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Về căn bản các digital product thuộc công nghệ thông tin, thứ “hàng hoá” được trao đổi là thông tin. Thử quan sát xem nhé,",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Về căn bản các digital product thuộc công nghệ thông tin, thứ “hàng hoá” được trao đổi là thông tin. Thử quan sát xem nhé,",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-808f-955d-e22c7432d2df",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-18T08:55:00.000Z",
        "last_edited_time": "2024-10-18T08:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tạo ra content (vd: tạo post Facebook, quay edit video qua capcut,…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tạo ra content (vd: tạo post Facebook, quay edit video qua capcut,…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80dc-b901-ca65a8fb71a8",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-18T08:56:00.000Z",
        "last_edited_time": "2024-10-18T08:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giao tiếp / truyền thông tin (vd: chat, đặt xe, gửi email,…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giao tiếp / truyền thông tin (vd: chat, đặt xe, gửi email,…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-8046-a47d-f27210c9252a",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-18T08:56:00.000Z",
        "last_edited_time": "2024-10-18T08:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tiêu thụ thông tin (vd: lướt feed, lướt reel, xem chart chứng khoán,…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tiêu thụ thông tin (vd: lướt feed, lướt reel, xem chart chứng khoán,…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-808a-b235-d4913153da34",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-18T08:56:00.000Z",
        "last_edited_time": "2024-11-15T01:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tìm kiếm hoặc Xử lý thông tin (vd: xem map để biết các nhà hàng gần đây, dashboard,…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tìm kiếm hoặc Xử lý thông tin (vd: xem map để biết các nhà hàng gần đây, dashboard,…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80f6-b194-f20a08379b1d",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-18T08:56:00.000Z",
        "last_edited_time": "2024-11-15T01:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nên khi design cho digital product, “thông tin” là thứ cần quan tâm đến, do đó term",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nên khi design cho digital product, “thông tin” là thứ cần quan tâm đến, do đó term",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Information architecture (IA)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Information architecture (IA)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là sẽ là từ bắt gặp rất nhiều trong công việc UX/UI, sơ lược thì nó để giải quyết việc quyết định xem các thông tin cần có là gì, gọi tên & ngữ nghĩa nó thế nào, sắp xếp chúng ra sao, thông tin đó tác động gì đến user,… ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là sẽ là từ bắt gặp rất nhiều trong công việc UX/UI, sơ lược thì nó để giải quyết việc quyết định xem các thông tin cần có là gì, gọi tên & ngữ nghĩa nó thế nào, sắp xếp chúng ra sao, thông tin đó tác động gì đến user,… ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1325d164-78d8-80ce-bb02-e4e0d0c354f3",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-11-02T05:10:00.000Z",
        "last_edited_time": "2024-11-02T05:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1225d164-78d8-8113-890c-eaaabdad8f4f",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T02:00:00.000Z",
        "last_edited_time": "2024-10-17T02:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "IA là gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "IA là gì?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "769d08ed-c960-420f-9241-23be341a9aef",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T02:14:00.000Z",
        "last_edited_time": "2024-10-17T02:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Information (Thông tin)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Information (Thông tin)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "b34857d0-7cbe-42c2-b769-ae35d07bb828",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T02:14:00.000Z",
        "last_edited_time": "2024-10-17T02:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "\"Information\" trong IA là bất kỳ dữ liệu, nội dung hoặc tài liệu nào mà người dùng cần tìm và sử dụng trên một website hoặc ứng dụng. Điều này bao gồm văn bản, hình ảnh, video, tài liệu, liên kết, và nhiều loại thông tin khác.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "\"Information\" trong IA là bất kỳ dữ liệu, nội dung hoặc tài liệu nào mà người dùng cần tìm và sử dụng trên một website hoặc ứng dụng. Điều này bao gồm văn bản, hình ảnh, video, tài liệu, liên kết, và nhiều loại thông tin khác.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "79bae34f-563e-40de-b85c-80748589964d",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T02:14:00.000Z",
        "last_edited_time": "2024-10-17T02:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Architecture (Kiến trúc)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Architecture (Kiến trúc)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1f73ff2e-55e0-4351-a90d-d04ffee31748",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T02:14:00.000Z",
        "last_edited_time": "2024-11-27T02:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "\"Architecture\" là cách ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "\"Architecture\" là cách ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "tổ chức",
                "link": {
                  "url": "/1225d16478d880db8d9be6cc64d11314"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "tổ chức",
              "href": "/1225d16478d880db8d9be6cc64d11314"
            },
            {
              "type": "text",
              "text": {
                "content": " và sắp xếp thông tin một cách có hệ thống và logic, tương tự như cách một kiến trúc sư xây dựng cấu trúc cho một ngôi nhà vậy. Đó là việc phân chia phòng ốc, thiết kế lối đi, hành lang, và thang máy để mọi người có thể di chuyển dễ dàng trong tòa nhà, cách đặt để các vật dụng trong phòng ra sao cho tiện nghi, quyết định xem nên dùng loại cửa nào, chất liệu ra sao cho phù hợp…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " và sắp xếp thông tin một cách có hệ thống và logic, tương tự như cách một kiến trúc sư xây dựng cấu trúc cho một ngôi nhà vậy. Đó là việc phân chia phòng ốc, thiết kế lối đi, hành lang, và thang máy để mọi người có thể di chuyển dễ dàng trong tòa nhà, cách đặt để các vật dụng trong phòng ra sao cho tiện nghi, quyết định xem nên dùng loại cửa nào, chất liệu ra sao cho phù hợp…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1225d164-78d8-810b-a6d0-c9c4b3db95d5",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T02:00:00.000Z",
        "last_edited_time": "2024-10-17T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "bbfca228-2454-4b01-93d1-c6120e9d75f2",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T02:00:00.000Z",
        "last_edited_time": "2024-10-17T02:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy làm IA là làm gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy làm IA là làm gì?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-8042-a4fb-cb64f12b495c",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-11-26T05:53:00.000Z",
        "last_edited_time": "2024-11-26T05:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [
            {
              "type": "text",
              "text": {
                "content": "https://dribbble.com/shots/2234810-Defining-Design-Animations",
                "link": {
                  "url": "https://dribbble.com/shots/2234810-Defining-Design-Animations"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://dribbble.com/shots/2234810-Defining-Design-Animations",
              "href": "https://dribbble.com/shots/2234810-Defining-Design-Animations"
            }
          ],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081668/uxcomic-imgs/14a5d164-78d8-8042-a4fb-cb64f12b495c.gif",
            "expiry_time": "2026-10-04T09:12:52.422Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/14a5d164-78d8-8042-a4fb-cb64f12b495c"
      },
      {
        "object": "block",
        "id": "00ceaa8c-ceea-4c1e-bd6e-8829c799b64e",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T02:18:00.000Z",
        "last_edited_time": "2024-10-17T02:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đặt tên & gán nhãn (labeling)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đặt tên & gán nhãn (labeling)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2d09048c-9dd3-4391-b59d-77e1d2b11b79",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T02:19:00.000Z",
        "last_edited_time": "2024-11-27T02:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Define tên gọi & ngữ nghĩa có tính thống nhất xuyên suốt trên app/web, mình muốn make sure tên gọi (name) và ngữ nghĩa (meaning) luôn được đồng bộ với nhau & nên dễ hiểu cho user, mình gọi đây là công việc naming conventions.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Define tên gọi & ngữ nghĩa có tính thống nhất xuyên suốt trên app/web, mình muốn make sure tên gọi (name) và ngữ nghĩa (meaning) luôn được đồng bộ với nhau & nên dễ hiểu cho user, mình gọi đây là công việc naming conventions.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1225d164-78d8-8042-a0ef-c6be14b84b59",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T10:53:00.000Z",
        "last_edited_time": "2024-11-27T02:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: trong app tại flow “huỷ gói đăng ký” bạn có action để user huỷ đăng ký, mặc dù từ ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: trong app tại flow “huỷ gói đăng ký” bạn có action để user huỷ đăng ký, mặc dù từ ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "“huỷ”",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“huỷ”",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " riêng trong ngữ cảnh này có thể hiểu là huỷ gói đăng ký nhưng từ “huỷ” này cũng đang được dùng ở nhiều màn hình khác với nghĩa là bỏ qua/ đóng >> giờ bạn phải thay đổi thành từ ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " riêng trong ngữ cảnh này có thể hiểu là huỷ gói đăng ký nhưng từ “huỷ” này cũng đang được dùng ở nhiều màn hình khác với nghĩa là bỏ qua/ đóng >> giờ bạn phải thay đổi thành từ ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "“huỷ đăng ký”",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“huỷ đăng ký”",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " để tránh trùng lắp ngữ nghĩa.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " để tránh trùng lắp ngữ nghĩa.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1225d164-78d8-8076-9c70-d00a79c93d30",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T10:55:00.000Z",
        "last_edited_time": "2024-10-17T10:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081670/uxcomic-imgs/1225d164-78d8-8076-9c70-d00a79c93d30.png",
            "expiry_time": "2026-10-04T09:12:52.422Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1225d164-78d8-8076-9c70-d00a79c93d30"
      },
      {
        "object": "block",
        "id": "12a0ce9e-2860-40f0-918f-12b61083f370",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T02:17:00.000Z",
        "last_edited_time": "2024-10-17T02:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sắp xếp phân loại (content structure)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sắp xếp phân loại (content structure)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1225d164-78d8-81da-b6bc-c6862b3a6b05",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T02:00:00.000Z",
        "last_edited_time": "2024-11-26T05:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phân loại thông tin và sắp xếp chúng thành các nhóm chủ đề hợp lý. Ví dụ: trong danh mục “Điện thoại - máy tính bảng” có các mục con: điện thoại smartphone, máy tính bảng, máy đọc sách,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phân loại thông tin và sắp xếp chúng thành các nhóm chủ đề hợp lý. Ví dụ: trong danh mục “Điện thoại - máy tính bảng” có các mục con: điện thoại smartphone, máy tính bảng, máy đọc sách,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-800a-8624-f65aa057dd5d",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-11-26T05:47:00.000Z",
        "last_edited_time": "2024-11-27T02:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Yếu tố chính của Content Structure",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Yếu tố chính của Content Structure",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-8099-8f19-c3edcab7a339",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-11-26T05:47:00.000Z",
        "last_edited_time": "2024-11-26T05:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phân cấp thông tin (Hierarchy)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phân cấp thông tin (Hierarchy)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-8034-b140-ff752756a688",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-11-26T05:48:00.000Z",
        "last_edited_time": "2024-11-26T05:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhóm nội dung (Grouping)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhóm nội dung (Grouping)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-800f-ac42-d54fba20154f",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-11-26T05:47:00.000Z",
        "last_edited_time": "2024-11-26T05:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Metadata và Tags",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Metadata và Tags",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-805c-80df-fdc813675e69",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-11-26T05:47:00.000Z",
        "last_edited_time": "2024-11-26T05:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Consistency",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Consistency",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1225d164-78d8-8065-af7f-cedca28ab4c8",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T10:57:00.000Z",
        "last_edited_time": "2026-05-22T07:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081672/uxcomic-imgs/1225d164-78d8-8065-af7f-cedca28ab4c8.png",
            "expiry_time": "2026-10-04T09:12:52.523Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1225d164-78d8-8065-af7f-cedca28ab4c8"
      },
      {
        "object": "block",
        "id": "c6a744ec-75fb-4ceb-b591-e65dcd004e35",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T02:23:00.000Z",
        "last_edited_time": "2024-11-27T02:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thiết kế luồng thông tin & điều hướng (Information Flow & navigation)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thiết kế luồng thông tin & điều hướng (Information Flow & navigation)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "60157d80-2127-4ca4-b06a-54c43555d7ac",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T02:30:00.000Z",
        "last_edited_time": "2024-12-03T11:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Định nghĩa cách thông tin di chuyển trong hệ thống và cách người dùng tương tác với thông tin qua các bước hoặc kịch bản. Đảm bảo luồng thông tin mạch lạc, hỗ trợ người dùng đạt được mục tiêu nhanh chóng. Output: site map, navigation flow, progressive disclosure, state, flowchart…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Định nghĩa cách thông tin di chuyển trong hệ thống và cách người dùng tương tác với thông tin qua các bước hoặc kịch bản. Đảm bảo luồng thông tin mạch lạc, hỗ trợ người dùng đạt được mục tiêu nhanh chóng. Output: site map, navigation flow, progressive disclosure, state, flowchart…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1225d164-78d8-8046-abd3-d7e8a272cd87",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T10:58:00.000Z",
        "last_edited_time": "2024-10-17T10:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081673/uxcomic-imgs/1225d164-78d8-8046-abd3-d7e8a272cd87.png",
            "expiry_time": "2026-10-04T09:12:52.524Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1225d164-78d8-8046-abd3-d7e8a272cd87"
      },
      {
        "object": "block",
        "id": "1235d164-78d8-80f3-b0c9-e88913e41807",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-18T09:11:00.000Z",
        "last_edited_time": "2024-10-18T09:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "3b0a66dc-7615-408c-8098-6fc7bfc161d0",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T02:22:00.000Z",
        "last_edited_time": "2024-10-18T09:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Evaluate the IA",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Evaluate the IA",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "c559fcd6-0b07-4ac4-be82-cef170648540",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T02:22:00.000Z",
        "last_edited_time": "2024-10-18T09:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tất cả các output của IA như labeling, structure, navigation… đều phải hợp lý với user, phù hợp với mental model của họ. Mình sẽ không muốn việc nói A nhưng user hiểu B, hoặc các bước sử dụng, tìm kiếm thông tin của user trên app lại khác hoàn toàn với cách họ hình dung, kì vọng. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tất cả các output của IA như labeling, structure, navigation… đều phải hợp lý với user, phù hợp với mental model của họ. Mình sẽ không muốn việc nói A nhưng user hiểu B, hoặc các bước sử dụng, tìm kiếm thông tin của user trên app lại khác hoàn toàn với cách họ hình dung, kì vọng. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1235d164-78d8-803f-b2e8-ea4da8d7c2d6",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-18T09:13:00.000Z",
        "last_edited_time": "2024-11-27T02:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để có thể đánh giá IA tốt sẽ có các cách tactics như: card sorting (cách user phân nhóm thông tin), tree testing (cách user điều hướng tìm kiếm thông tin nào đó), usability testing (chung chung về việc user có hiểu label & tìm kiếm thông tin không, cách sắp xếp có phù hợp với mental model của họ không)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để có thể đánh giá IA tốt sẽ có các cách tactics như: card sorting (cách user phân nhóm thông tin), tree testing (cách user điều hướng tìm kiếm thông tin nào đó), usability testing (chung chung về việc user có hiểu label & tìm kiếm thông tin không, cách sắp xếp có phù hợp với mental model của họ không)",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12d5d164-78d8-80a7-b192-eca83fb43a80",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-28T07:42:00.000Z",
        "last_edited_time": "2024-10-28T07:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "12d5d164-78d8-8036-9ed1-d83e2485205f",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-28T07:42:00.000Z",
        "last_edited_time": "2025-09-09T09:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Another concept - OOUX & Conceptual model",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Another concept - OOUX & Conceptual model",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2695d164-78d8-80e9-8f4f-dc902d05cc03",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2025-09-09T09:41:00.000Z",
        "last_edited_time": "2025-09-09T09:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "2 khái niệm này chưa tìm hiểu đủ sâu, nhưng có đọc & áp dụng sơ sơ thì thấy cũng Oh quao đấy! 😛",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2 khái niệm này chưa tìm hiểu đủ sâu, nhưng có đọc & áp dụng sơ sơ thì thấy cũng Oh quao đấy! 😛",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ca5d164-78d8-80d4-bb7e-e8c0e3a1a6a7",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2025-04-03T07:32:00.000Z",
        "last_edited_time": "2025-04-03T07:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081675/uxcomic-imgs/1ca5d164-78d8-80d4-bb7e-e8c0e3a1a6a7.png",
            "expiry_time": "2026-10-04T09:12:52.524Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1ca5d164-78d8-80d4-bb7e-e8c0e3a1a6a7"
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-80de-87ce-fbe0713f2be9",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-11-26T05:51:00.000Z",
        "last_edited_time": "2025-01-10T05:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "OOUX (Object-Oriented UX)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "OOUX (Object-Oriented UX)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là một phương pháp thiết kế tập trung vào việc xác định và tổ chức các đối tượng cốt lõi trong hệ thống trước khi phát triển giao diện người dùng. Chúng đưa cái hình dung một digital object gần hơn với physical object, ở đó bạn nắm các về điều gì cấu thành nên chúng, mối quan hệ giữa các object, user có thể tương tác với chúng như thế nào (phần nào đó khái niệm này sẽ bổ sung cái hiểu cho ERD - dùng để thiết kế dữ liệu database).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là một phương pháp thiết kế tập trung vào việc xác định và tổ chức các đối tượng cốt lõi trong hệ thống trước khi phát triển giao diện người dùng. Chúng đưa cái hình dung một digital object gần hơn với physical object, ở đó bạn nắm các về điều gì cấu thành nên chúng, mối quan hệ giữa các object, user có thể tương tác với chúng như thế nào (phần nào đó khái niệm này sẽ bổ sung cái hiểu cho ERD - dùng để thiết kế dữ liệu database).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-80a9-b01e-e7a0883f9f9e",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-11-26T05:51:00.000Z",
        "last_edited_time": "2024-11-26T05:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thay vì bắt đầu từ luồng hoặc giao diện, OOUX tập trung vào:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thay vì bắt đầu từ luồng hoặc giao diện, OOUX tập trung vào:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-8072-b29c-d23e08524e01",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-11-26T05:51:00.000Z",
        "last_edited_time": "2025-01-10T05:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Object - Các đối tượng chính",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Object - Các đối tượng chính",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (ví dụ: sản phẩm, người dùng, sự kiện).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (ví dụ: sản phẩm, người dùng, sự kiện).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-805d-ad7b-e7933791ddbb",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-11-26T05:51:00.000Z",
        "last_edited_time": "2025-01-10T05:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relationship- Mối quan hệ giữa các đối tượng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relationship- Mối quan hệ giữa các đối tượng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " (như liên kết hoặc thứ bậc).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (như liên kết hoặc thứ bậc).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-8048-9800-d459046b7ab2",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-11-26T06:00:00.000Z",
        "last_edited_time": "2024-11-26T06:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "CTA của đối tượng ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "CTA của đối tượng ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "(có thể tuỳ theo user role có CTA khác nhau)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "(có thể tuỳ theo user role có CTA khác nhau)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-808f-b538-e1d6099236ec",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-11-26T05:51:00.000Z",
        "last_edited_time": "2025-01-10T05:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Attribute - Thuộc tính và thông tin cần thiết",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Attribute - Thuộc tính và thông tin cần thiết",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " của mỗi đối tượng. (ID, size, số lượng,…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " của mỗi đối tượng. (ID, size, số lượng,…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 3
      },
      {
        "object": "block",
        "id": "1ca5d164-78d8-80ce-9d14-e66a329bdf20",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2025-04-03T07:33:00.000Z",
        "last_edited_time": "2025-09-09T09:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cực kì hữu ích khi phải làm việc với hệ thống lớn hoặc design system. Tham khảo thêm qua các bài viết sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cực kì hữu ích khi phải làm việc với hệ thống lớn hoặc design system. Tham khảo thêm qua các bài viết sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2255d164-78d8-80ce-a181-df88d70f32dc",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2025-07-03T06:41:00.000Z",
        "last_edited_time": "2025-09-09T09:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://alistapart.com/article/ooux-a-foundation-for-interaction-design/",
                "link": {
                  "url": "https://alistapart.com/article/ooux-a-foundation-for-interaction-design/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://alistapart.com/article/ooux-a-foundation-for-interaction-design/",
              "href": "https://alistapart.com/article/ooux-a-foundation-for-interaction-design/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2695d164-78d8-80d0-b82b-c5a05564ded0",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2025-09-09T07:46:00.000Z",
        "last_edited_time": "2025-09-09T07:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2695d164-78d8-80f8-b28c-c445a6cab1a1",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2025-09-09T07:45:00.000Z",
        "last_edited_time": "2025-09-09T09:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khái niệm OOUX này lại rất liên quan đến term: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khái niệm OOUX này lại rất liên quan đến term: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Conceptual models. ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Conceptual models. ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Tham khảo thêm qua các bài viết sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tham khảo thêm qua các bài viết sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "36d5d164-78d8-80ee-9842-d790694812fa",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2026-05-27T08:49:00.000Z",
        "last_edited_time": "2026-05-27T08:49:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.linkedin.com/pulse/mental-models-vs-conceptual-ux-design-guide-2026-glow-team-wrzee/",
                "link": {
                  "url": "https://www.linkedin.com/pulse/mental-models-vs-conceptual-ux-design-guide-2026-glow-team-wrzee/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.linkedin.com/pulse/mental-models-vs-conceptual-ux-design-guide-2026-glow-team-wrzee/",
              "href": "https://www.linkedin.com/pulse/mental-models-vs-conceptual-ux-design-guide-2026-glow-team-wrzee/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2695d164-78d8-80cb-aa10-f8a6f5452e20",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2025-09-09T08:16:00.000Z",
        "last_edited_time": "2025-09-09T08:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://presentations.dubberly.com/conceptual_models.pdf",
                "link": {
                  "url": "https://presentations.dubberly.com/conceptual_models.pdf"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://presentations.dubberly.com/conceptual_models.pdf",
              "href": "https://presentations.dubberly.com/conceptual_models.pdf"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2695d164-78d8-80c3-bb94-d86429ee9d40",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2025-09-09T09:45:00.000Z",
        "last_edited_time": "2025-09-09T09:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.interaction-design.org/literature/topics/conceptual-models?srsltid=AfmBOooSjxnWyGzDNqRlVUdSOxE18QpFYZD9cGv50dvBM0QhpRsjefRP",
                "link": {
                  "url": "https://www.interaction-design.org/literature/topics/conceptual-models?srsltid=AfmBOooSjxnWyGzDNqRlVUdSOxE18QpFYZD9cGv50dvBM0QhpRsjefRP"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.interaction-design.org/literature/topics/conceptual-models?srsltid=AfmBOooSjxnWyGzDNqRlVUdSOxE18QpFYZD9cGv50dvBM0QhpRsjefRP",
              "href": "https://www.interaction-design.org/literature/topics/conceptual-models?srsltid=AfmBOooSjxnWyGzDNqRlVUdSOxE18QpFYZD9cGv50dvBM0QhpRsjefRP"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2695d164-78d8-80d2-aaa4-f367ccd3204b",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2025-09-09T09:47:00.000Z",
        "last_edited_time": "2025-09-09T09:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.interaction-design.org/literature/article/we-think-therefore-it-is-conceptual-modelling-for-mobile-applications",
                "link": {
                  "url": "https://www.interaction-design.org/literature/article/we-think-therefore-it-is-conceptual-modelling-for-mobile-applications"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.interaction-design.org/literature/article/we-think-therefore-it-is-conceptual-modelling-for-mobile-applications",
              "href": "https://www.interaction-design.org/literature/article/we-think-therefore-it-is-conceptual-modelling-for-mobile-applications"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1225d164-78d8-8119-8197-e787b8e39b3e",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T02:00:00.000Z",
        "last_edited_time": "2024-10-17T02:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1225d164-78d8-8141-a8bc-c1ecdcf4eb63",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T02:00:00.000Z",
        "last_edited_time": "2024-10-17T02:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2295d164-78d8-80eb-a652-c604216fe56e",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2025-07-07T08:29:00.000Z",
        "last_edited_time": "2025-07-07T08:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cuốn sách của anh này nói rất thú vị về chủ đề IA, ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cuốn sách của anh này nói rất thú vị về chủ đề IA, ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "mọi người có thể tham khảo thêm",
                "link": {
                  "url": "https://abbycovert.com/speaking/understanding-ia/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "mọi người có thể tham khảo thêm",
              "href": "https://abbycovert.com/speaking/understanding-ia/"
            },
            {
              "type": "text",
              "text": {
                "content": " (How to make sense of any mess của Abby Convert).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " (How to make sense of any mess của Abby Convert).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14a5d164-78d8-8046-836a-c2ae76fe5a4a",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-11-26T05:57:00.000Z",
        "last_edited_time": "2024-11-26T05:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.interaction-design.org/literature/topics/information-architecture",
                "link": {
                  "url": "https://www.interaction-design.org/literature/topics/information-architecture"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.interaction-design.org/literature/topics/information-architecture",
              "href": "https://www.interaction-design.org/literature/topics/information-architecture"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1225d164-78d8-806e-ab63-cdd05ef19c46",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T11:01:00.000Z",
        "last_edited_time": "2024-10-17T11:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://uxdesign.cc/information-architecture-how-to-make-it-worth-your-time-money-6ae71c0f8674",
                "link": {
                  "url": "https://uxdesign.cc/information-architecture-how-to-make-it-worth-your-time-money-6ae71c0f8674"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://uxdesign.cc/information-architecture-how-to-make-it-worth-your-time-money-6ae71c0f8674",
              "href": "https://uxdesign.cc/information-architecture-how-to-make-it-worth-your-time-money-6ae71c0f8674"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-8080-811f-fe1f15e0dc85",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2025-01-21T06:01:00.000Z",
        "last_edited_time": "2025-01-21T06:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://michaelgearon.medium.com/information-architecture-ia-in-ux-91dae4e3124d",
                "link": {
                  "url": "https://michaelgearon.medium.com/information-architecture-ia-in-ux-91dae4e3124d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://michaelgearon.medium.com/information-architecture-ia-in-ux-91dae4e3124d",
              "href": "https://michaelgearon.medium.com/information-architecture-ia-in-ux-91dae4e3124d"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "3685d164-78d8-8074-b599-c9f82371d775",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2026-05-22T07:52:00.000Z",
        "last_edited_time": "2026-05-27T03:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.upsilonit.com/blog/information-architecture-design-a-product-discovery-step",
                "link": {
                  "url": "https://www.upsilonit.com/blog/information-architecture-design-a-product-discovery-step"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.upsilonit.com/blog/information-architecture-design-a-product-discovery-step",
              "href": "https://www.upsilonit.com/blog/information-architecture-design-a-product-discovery-step"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1225d164-78d8-81d3-b6e2-c1c15efd9b12",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T02:00:00.000Z",
        "last_edited_time": "2024-10-17T02:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1225d164-78d8-8154-8568-db5f23af66e4",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T02:00:00.000Z",
        "last_edited_time": "2024-10-17T02:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1225d164-78d8-8136-bb17-ea2abc4cb68a",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-10-17T02:00:00.000Z",
        "last_edited_time": "2024-10-17T11:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relation (systematic thinking)",
              "href": "https://app.notion.com/p/1225d16478d880db8d9be6cc64d11314"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1455d164-78d8-80d8-83ec-d95db9e963a9",
        "parent": {
          "type": "page_id",
          "page_id": "1165d164-78d8-80cb-9163-f985f8d8a788"
        },
        "created_time": "2024-11-21T02:28:00.000Z",
        "last_edited_time": "2024-11-21T02:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1235d164-78d8-8094-90a1-e82eea06a15b"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Diagram & Canvas",
              "href": "https://app.notion.com/p/1235d16478d8809490a1e82eea06a15b"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc",
    "created_time": "2024-10-04T02:49:00.000Z",
    "last_edited_time": "2025-08-24T01:26:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "3-Build",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-24T01:26:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": ";n|V",
          "name": "⚔️:1",
          "color": "brown"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 15
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2024-10-04T02:49:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "User Journey map, User scenario, Task flow, User flow",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "User Journey map, User scenario, Task flow, User flow",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/User-Journey-map-User-scenario-Task-flow-User-flow-1155d16478d880a883a6ec9db47fe4dc",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
      "name": "Build",
      "slug": "build",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "11f5d164-78d8-81a9-b1a6-da0fae3e075a",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-10-14T02:58:00.000Z",
        "last_edited_time": "2024-11-14T15:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081679/uxcomic-imgs/11f5d164-78d8-81a9-b1a6-da0fae3e075a.png",
            "expiry_time": "2026-10-04T09:12:54.091Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/11f5d164-78d8-81a9-b1a6-da0fae3e075a"
      },
      {
        "object": "block",
        "id": "dd974242-af1a-4c17-841e-afdfc2bcba2a",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-11-13T14:26:00.000Z",
        "last_edited_time": "2024-12-25T01:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thử hình dung nếu trải nghiệm là một phương trình toán học, mình nghĩ nó sẽ trong như sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thử hình dung nếu trải nghiệm là một phương trình toán học, mình nghĩ nó sẽ trong như sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13d5d164-78d8-803a-9755-f02a65a6d29b",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-11-13T15:01:00.000Z",
        "last_edited_time": "2024-11-14T15:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "52aaa675-9c6c-473d-bee1-c24aaf4f4865",
            "parent": {
              "type": "block_id",
              "block_id": "13d5d164-78d8-803a-9755-f02a65a6d29b"
            },
            "created_time": "2024-11-13T14:33:00.000Z",
            "last_edited_time": "2024-11-14T15:13:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Trải nghiệm = Tương tác * Cảm nhận",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Trải nghiệm = Tương tác * Cảm nhận",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "13e5d164-78d8-80d5-88e1-f9aa93ec7820",
            "parent": {
              "type": "block_id",
              "block_id": "13d5d164-78d8-803a-9755-f02a65a6d29b"
            },
            "created_time": "2024-11-14T15:13:00.000Z",
            "last_edited_time": "2024-11-14T15:13:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Cảm nhận = Cảm xúc * Nhận thức * Ngữ cảnh * Kỳ vọng ",
                    "link": null
                  },
                  "annotations": {
                    "bold": true,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Cảm nhận = Cảm xúc * Nhận thức * Ngữ cảnh * Kỳ vọng ",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "1495d164-78d8-8050-821b-fd482b70ac56",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-11-25T03:50:00.000Z",
        "last_edited_time": "2025-08-05T01:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy để hình dung rõ hơn về sự liên hệ này, mình cần tìm hiểu qua các khái niệm “user mental model” & “represented model”, từ cách user giải quyết vấn đề hiện tại trong cuộc sống  > khi họ giải quyết vấn đề thông qua product của bạn, trong nó 2 term đó bao gồm các term sau: user journey map, user scenario, use case, user flow.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy để hình dung rõ hơn về sự liên hệ này, mình cần tìm hiểu qua các khái niệm “user mental model” & “represented model”, từ cách user giải quyết vấn đề hiện tại trong cuộc sống  > khi họ giải quyết vấn đề thông qua product của bạn, trong nó 2 term đó bao gồm các term sau: user journey map, user scenario, use case, user flow.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-808b-a9a6-c05fb286b2b6",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-12-23T17:29:00.000Z",
        "last_edited_time": "2024-12-24T03:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081680/uxcomic-imgs/1655d164-78d8-808b-a9a6-c05fb286b2b6.png",
            "expiry_time": "2026-10-04T09:12:54.091Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1655d164-78d8-808b-a9a6-c05fb286b2b6"
      },
      {
        "object": "block",
        "id": "1665d164-78d8-80df-ae7f-dbef6543296e",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-12-24T03:57:00.000Z",
        "last_edited_time": "2024-12-24T15:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081682/uxcomic-imgs/1665d164-78d8-80df-ae7f-dbef6543296e.png",
            "expiry_time": "2026-10-04T09:12:54.091Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1665d164-78d8-80df-ae7f-dbef6543296e"
      },
      {
        "object": "block",
        "id": "11f5d164-78d8-8036-a909-fb829cf94c50",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-10-14T15:31:00.000Z",
        "last_edited_time": "2024-11-12T02:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "11f5d164-78d8-804e-87ed-f208298d821a",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-10-14T14:57:00.000Z",
        "last_edited_time": "2024-12-24T01:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "User/customer journey map",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User/customer journey map",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "e2e988fe-e08d-4461-b5c2-748a437d0310",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-11-13T14:37:00.000Z",
        "last_edited_time": "2024-12-25T01:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đây là bản đồ mô tả toàn bộ hành trình của người dùng từ khi họ có nhu cầu đến khi họ đạt được mục tiêu. User journey giúp nhóm thiết kế ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đây là bản đồ mô tả toàn bộ hành trình của người dùng từ khi họ có nhu cầu đến khi họ đạt được mục tiêu. User journey giúp nhóm thiết kế ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "thấy rõ các giai đoạn, điểm chạm (touch points) và cảm xúc của người dùng, cho bạn một cái nhìn bao quát",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "thấy rõ các giai đoạn, điểm chạm (touch points) và cảm xúc của người dùng, cho bạn một cái nhìn bao quát",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ". Nó giúp bạn phán đoán hoặc nhận diện được đâu là khoảnh khắc user mong chờ sự vui vẻ, tích cực, đâu là lúc họ thấy chán chường hay tiêu cực >> từ đó xác định được những điểm cần cải thiện trong hành trình tổng thể.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". Nó giúp bạn phán đoán hoặc nhận diện được đâu là khoảnh khắc user mong chờ sự vui vẻ, tích cực, đâu là lúc họ thấy chán chường hay tiêu cực >> từ đó xác định được những điểm cần cải thiện trong hành trình tổng thể.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13d5d164-78d8-80bb-b1f7-e202fa8a8cc5",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-11-13T14:45:00.000Z",
        "last_edited_time": "2024-11-13T14:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081683/uxcomic-imgs/13d5d164-78d8-80bb-b1f7-e202fa8a8cc5.png",
            "expiry_time": "2026-10-04T09:12:54.091Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/13d5d164-78d8-80bb-b1f7-e202fa8a8cc5"
      },
      {
        "object": "block",
        "id": "8278de1a-e07a-46eb-83fb-33bf67a298d5",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-11-13T14:36:00.000Z",
        "last_edited_time": "2024-12-24T02:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thử hình dung luồng trải nghiệm như 1 bản nhạc có thăng có trầm, lúc du dương, lúc đùng đùng, thì trải nghiệm trong product của bạn cũng có nhịp độ lên xuống như thế. Ví dụ: có nơi bạn cần user cảm thấy được welcome, có khi sẽ chậm rãi để onboard, có khi sẽ bùng ben để vui mừng 1 kết quả gì đó, có nơi bạn để họ chậm rãi tò mò khám phá và kinh ngạc… ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thử hình dung luồng trải nghiệm như 1 bản nhạc có thăng có trầm, lúc du dương, lúc đùng đùng, thì trải nghiệm trong product của bạn cũng có nhịp độ lên xuống như thế. Ví dụ: có nơi bạn cần user cảm thấy được welcome, có khi sẽ chậm rãi để onboard, có khi sẽ bùng ben để vui mừng 1 kết quả gì đó, có nơi bạn để họ chậm rãi tò mò khám phá và kinh ngạc… ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1695d164-78d8-803e-9505-dcd731c0760b",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-12-27T04:37:00.000Z",
        "last_edited_time": "2024-12-27T04:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Don’t forget to figure out how your product make user FEEL.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Don’t forget to figure out how your product make user FEEL.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-802e-be7a-d195170867b3",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-12-23T17:22:00.000Z",
        "last_edited_time": "2024-12-25T01:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ah chắc cái này dễ hình dung hơn nè, hãy nghĩ đến một trải nghiệm dịch vụ gần đây mà bạn cảm thấy tuyệt vời, có thể là khách sạn 5 sao, một buổi ăn ở 4p, hay thậm chí là 1 cuốc xe grab gần đây,…nhớ lại xem, lí do gì khiến bạn cảm thấy hài lòng hoặc bực bội. >> đây chính là cách chúng ta practice UX sense, để ý từng product/service bạn tương tác hàng ngày, nếu tốt thì lí giải xem tại sao, nếu tệ thì do vụ việc gì, nghĩ xem liệu có cách nào cải thiện.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ah chắc cái này dễ hình dung hơn nè, hãy nghĩ đến một trải nghiệm dịch vụ gần đây mà bạn cảm thấy tuyệt vời, có thể là khách sạn 5 sao, một buổi ăn ở 4p, hay thậm chí là 1 cuốc xe grab gần đây,…nhớ lại xem, lí do gì khiến bạn cảm thấy hài lòng hoặc bực bội. >> đây chính là cách chúng ta practice UX sense, để ý từng product/service bạn tương tác hàng ngày, nếu tốt thì lí giải xem tại sao, nếu tệ thì do vụ việc gì, nghĩ xem liệu có cách nào cải thiện.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11f5d164-78d8-807e-9704-dd8132978d93",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-10-14T15:05:00.000Z",
        "last_edited_time": "2024-12-25T01:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: khi bạn đến một quán cà phê, thấy ngoại thất decor đẹp đẽ sáng sủa, bác bảo vệ chào hỏi và dắt xe cho bạn, có bạn mở cửa tiếp đón khi bạn bước vào quán, bạn vừa tìm được chỗ ngồi thì đã có bạn đến cho bạn ly trà đá mát lạnh giữa cái nóng sài gòn, bạn xem menu và không biết chọn món nào thì nhân viên tư vấn nhiệt tình, bạn thấy oh quao quán này cũng được được nhỉ, nhưng rồi bạn phải đợi 30 phút thì nước mới được mang ra >> dẫn đến tất cả trải nghiệm tốt đẹp trước đó thành công cốc, giờ bạn chỉ cảm thấy bực dọc & không muốn ghé quán này lần nào nữa. (này gọi là Peak End effect)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: khi bạn đến một quán cà phê, thấy ngoại thất decor đẹp đẽ sáng sủa, bác bảo vệ chào hỏi và dắt xe cho bạn, có bạn mở cửa tiếp đón khi bạn bước vào quán, bạn vừa tìm được chỗ ngồi thì đã có bạn đến cho bạn ly trà đá mát lạnh giữa cái nóng sài gòn, bạn xem menu và không biết chọn món nào thì nhân viên tư vấn nhiệt tình, bạn thấy oh quao quán này cũng được được nhỉ, nhưng rồi bạn phải đợi 30 phút thì nước mới được mang ra >> dẫn đến tất cả trải nghiệm tốt đẹp trước đó thành công cốc, giờ bạn chỉ cảm thấy bực dọc & không muốn ghé quán này lần nào nữa. (này gọi là Peak End effect)",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1495d164-78d8-80b2-a82e-ec956baf0572",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-11-25T03:26:00.000Z",
        "last_edited_time": "2024-12-24T02:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1495d164-78d8-8064-a5ad-fc74d03e29e7",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-11-25T03:27:00.000Z",
        "last_edited_time": "2024-11-25T03:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sẵn nói sơ qua về ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sẵn nói sơ qua về ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "emotion design",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "emotion design",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", theo Donald Norman, chúng ta có 3 level như sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", theo Donald Norman, chúng ta có 3 level như sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1495d164-78d8-80ba-bae4-cee1f63e36da",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-11-25T03:27:00.000Z",
        "last_edited_time": "2024-11-25T03:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cấp độ bản năng (Visceral level)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cấp độ bản năng (Visceral level)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Đây là cảm xúc ngay lập tức và bản năng mà người dùng cảm nhận được khi nhìn vào sản phẩm. Ngắn gọn thì có thể gọi đây là ấn tượng đầu. Vd: bạn gặp một người ăn mặc lịch thiệp thì có thể ấn tượng là người này ngăn nắp, chỉnh chu nhưng một người khác lại có thể thấy là làm lố.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Đây là cảm xúc ngay lập tức và bản năng mà người dùng cảm nhận được khi nhìn vào sản phẩm. Ngắn gọn thì có thể gọi đây là ấn tượng đầu. Vd: bạn gặp một người ăn mặc lịch thiệp thì có thể ấn tượng là người này ngăn nắp, chỉnh chu nhưng một người khác lại có thể thấy là làm lố.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "1495d164-78d8-8067-a886-fa9e0821d2a5",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-11-25T03:27:00.000Z",
        "last_edited_time": "2024-12-25T01:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cấp độ hành vi (Behavioral level)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cấp độ hành vi (Behavioral level)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Ở cấp độ này, cảm xúc của người dùng phụ thuộc vào cách sản phẩm hoạt động, tính dễ dùng, và cảm giác kiểm soát trong quá trình tương tác. Nó có dễ dùng không, trong quá trình dùng có thoải mái không, có cảm thấy bị xúc phạm không,… Cũng giống như bạn đi chơi với ai đó, các tương tác qua lại có khiến bạn dễ chịu hay thấy gượng gạo.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Ở cấp độ này, cảm xúc của người dùng phụ thuộc vào cách sản phẩm hoạt động, tính dễ dùng, và cảm giác kiểm soát trong quá trình tương tác. Nó có dễ dùng không, trong quá trình dùng có thoải mái không, có cảm thấy bị xúc phạm không,… Cũng giống như bạn đi chơi với ai đó, các tương tác qua lại có khiến bạn dễ chịu hay thấy gượng gạo.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1495d164-78d8-808c-8660-ff3018be56bf",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-11-25T03:27:00.000Z",
        "last_edited_time": "2024-12-25T01:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cấp độ phản tư (Reflective level)",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cấp độ phản tư (Reflective level)",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Đây là cấp độ sâu hơn, khi người dùng suy ngẫm và gắn bó với sản phẩm ở mức độ cá nhân. Các yếu tố như giá trị, ý nghĩa và tính độc đáo của sản phẩm sẽ được người dùng đánh giá ở cấp độ này. Cũng giống như qua một quá trình bạn đi chơi với người ấy, ngồi ngẫm lại quá trình, nhìn nhận cảm xúc xem có phù hợp với người đó hay không.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Đây là cấp độ sâu hơn, khi người dùng suy ngẫm và gắn bó với sản phẩm ở mức độ cá nhân. Các yếu tố như giá trị, ý nghĩa và tính độc đáo của sản phẩm sẽ được người dùng đánh giá ở cấp độ này. Cũng giống như qua một quá trình bạn đi chơi với người ấy, ngồi ngẫm lại quá trình, nhìn nhận cảm xúc xem có phù hợp với người đó hay không.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2
      },
      {
        "object": "block",
        "id": "15f5d164-78d8-80dc-8e6e-f53063910f71",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-12-17T09:43:00.000Z",
        "last_edited_time": "2024-12-24T02:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Bài này bên UX foundation ",
                "link": {
                  "url": "https://uxfoundation.vn/bai-viet/san-pham-goi-nen-cam-xuc"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Bài này bên UX foundation ",
              "href": "https://uxfoundation.vn/bai-viet/san-pham-goi-nen-cam-xuc"
            },
            {
              "type": "text",
              "text": {
                "content": "viết rõ hơn về yếu tố cảm xúc trong sản phẩm nè.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "viết rõ hơn về yếu tố cảm xúc trong sản phẩm nè.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "dcd573c4-27f6-46a7-9ac8-7cfb0c8b57bb",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-10-14T15:10:00.000Z",
        "last_edited_time": "2024-11-12T02:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "51dacfcf-5dd9-40b0-860c-cb95f2205df0",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-10-14T15:10:00.000Z",
        "last_edited_time": "2025-01-12T09:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "User scenario / Job story",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User scenario / Job story",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1795d164-78d8-80f2-9f16-fadc933b7324",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2025-01-12T09:45:00.000Z",
        "last_edited_time": "2025-01-12T09:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081685/uxcomic-imgs/1795d164-78d8-80f2-9f16-fadc933b7324.png",
            "expiry_time": "2026-10-04T09:12:54.091Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1795d164-78d8-80f2-9f16-fadc933b7324"
      },
      {
        "object": "block",
        "id": "11f5d164-78d8-807b-bdeb-dc1dc614f691",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-10-14T15:09:00.000Z",
        "last_edited_time": "2024-12-25T01:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thông thường các brief/requirement mình nhận được khá khô khan hoặc sẽ rất chung chung, brief mention nhiều đến goal/objective hay solution concept, nó thiếu cái gì đó nghe inspire và gần gũi. Và khi mình mường tượng feature dưới một câu chuyện thực tế, có ngữ cảnh, có con người, có diễn biến kết quả >> khiến feature có tính human-centric hơn & khiến mình dễ hình dung hơn về why, cũng cần phải cân nhắc nhiều hơn về ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thông thường các brief/requirement mình nhận được khá khô khan hoặc sẽ rất chung chung, brief mention nhiều đến goal/objective hay solution concept, nó thiếu cái gì đó nghe inspire và gần gũi. Và khi mình mường tượng feature dưới một câu chuyện thực tế, có ngữ cảnh, có con người, có diễn biến kết quả >> khiến feature có tính human-centric hơn & khiến mình dễ hình dung hơn về why, cũng cần phải cân nhắc nhiều hơn về ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "context of use",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "context of use",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", điều này giúp mình hiểu hơn về features/ product sẽ can thiệp như thế nào đến cuộc sống hàng ngày của user.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", điều này giúp mình hiểu hơn về features/ product sẽ can thiệp như thế nào đến cuộc sống hàng ngày của user.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11f5d164-78d8-80d3-a11d-e3e791c39d47",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-10-14T15:20:00.000Z",
        "last_edited_time": "2024-11-25T03:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ví dụ: anh An thấy cái điện thoại trong túi nó cứ rung rung, khi anh đang dừng đèn đỏ, a lấy cái điện thoại ra check xem thì vướng cái lock của Face ID, a không mở được vì đang đeo khẩu trang, mà đồng hồ đèn giao thông còn có 10s nữa thôi nên a vội vàng cất lại phone vào túi mà vẫn chưa check được là tin nhắn gì, phải một hồi sau a mới tấp xe vào lề, kéo khẩu trang xuống để unlock Face ID và check tin nhắn. >> Nếu anh An biết set up Face ID khẩu trang thì đã khoẻ biết bao.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ví dụ: anh An thấy cái điện thoại trong túi nó cứ rung rung, khi anh đang dừng đèn đỏ, a lấy cái điện thoại ra check xem thì vướng cái lock của Face ID, a không mở được vì đang đeo khẩu trang, mà đồng hồ đèn giao thông còn có 10s nữa thôi nên a vội vàng cất lại phone vào túi mà vẫn chưa check được là tin nhắn gì, phải một hồi sau a mới tấp xe vào lề, kéo khẩu trang xuống để unlock Face ID và check tin nhắn. >> Nếu anh An biết set up Face ID khẩu trang thì đã khoẻ biết bao.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-800d-b11c-ea35c6d0a0cb",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-12-23T17:26:00.000Z",
        "last_edited_time": "2024-12-24T15:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081686/uxcomic-imgs/1655d164-78d8-800d-b11c-ea35c6d0a0cb.jpg",
            "expiry_time": "2026-10-04T09:12:54.187Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1655d164-78d8-800d-b11c-ea35c6d0a0cb"
      },
      {
        "object": "block",
        "id": "1665d164-78d8-8059-8cb2-f7ee545a83af",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-12-24T15:37:00.000Z",
        "last_edited_time": "2024-12-24T15:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một ví dụ khác: khi bạn xem youtube thì đột nhiên shipper gọi bạn xuống lấy hàng, bạn pause video lại, xong xí bạn quay lại bật nó xem tiếp, nó sẽ phát lại trước thời điểm bạn pause khoảng 10s >> giúp bạn hình dung & bắt kịp lại câu chuyện tốt hơn. Wow phải không, việc để ý đến user scenario giúp bạn có những thiết kế trải nghiệm tốt hơn nè.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một ví dụ khác: khi bạn xem youtube thì đột nhiên shipper gọi bạn xuống lấy hàng, bạn pause video lại, xong xí bạn quay lại bật nó xem tiếp, nó sẽ phát lại trước thời điểm bạn pause khoảng 10s >> giúp bạn hình dung & bắt kịp lại câu chuyện tốt hơn. Wow phải không, việc để ý đến user scenario giúp bạn có những thiết kế trải nghiệm tốt hơn nè.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11f5d164-78d8-80bc-b8d9-f7c1e8bcd938",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-10-14T15:30:00.000Z",
        "last_edited_time": "2024-11-12T02:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "68254290-1cb7-4396-a770-ed684d46ed65",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-10-14T15:30:00.000Z",
        "last_edited_time": "2024-12-24T03:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Task flow",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Task flow",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14b5d164-78d8-80c7-9f78-fee8d289c964",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-11-27T10:48:00.000Z",
        "last_edited_time": "2025-05-21T10:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước khi vẽ user flow, mình cần phân tích xem có bao nhiêu task user cần phải thực hiện liên quan đến flow này ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước khi vẽ user flow, mình cần phân tích xem có bao nhiêu task user cần phải thực hiện liên quan đến flow này ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "(task analysis), ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "(task analysis), ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "điều này rất quan trọng vì khi đã bắt đầu vẽ flow, bạn đang đi vào solution rồi, còn liệt kê task thì bạn vẫn còn đang tập trung vào problem, vào cách user giải quyết vấn đề ở thực tại hoặc họ cần làm để giải quyết vấn đề đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "điều này rất quan trọng vì khi đã bắt đầu vẽ flow, bạn đang đi vào solution rồi, còn liệt kê task thì bạn vẫn còn đang tập trung vào problem, vào cách user giải quyết vấn đề ở thực tại hoặc họ cần làm để giải quyết vấn đề đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-80ff-bd3d-f3bd00a7efe1",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-12-24T01:46:00.000Z",
        "last_edited_time": "2024-12-25T01:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi liệt kê task hãy lưu ý phải hình dung nó trong các tình huống sử dụng khác nhau (happy path, edge case, error case), liệu có yếu tố môi trường nào tác động đến quá trình dùng không. Thói quen của designer hay chỉ tập trung vào happy path, trong điều kiện lí tưởng, nên đôi khi nếu user gặp phải những tình huống khác thì UX lại tệ (tất nhiên ta không thể cover hết các tình huống nhưng thà có sự cân nhắc còn hơn không).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi liệt kê task hãy lưu ý phải hình dung nó trong các tình huống sử dụng khác nhau (happy path, edge case, error case), liệu có yếu tố môi trường nào tác động đến quá trình dùng không. Thói quen của designer hay chỉ tập trung vào happy path, trong điều kiện lí tưởng, nên đôi khi nếu user gặp phải những tình huống khác thì UX lại tệ (tất nhiên ta không thể cover hết các tình huống nhưng thà có sự cân nhắc còn hơn không).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-80aa-a4d4-d9a26a1da4d2",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-12-24T01:45:00.000Z",
        "last_edited_time": "2025-08-24T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081687/uxcomic-imgs/1665d164-78d8-80aa-a4d4-d9a26a1da4d2.png",
            "expiry_time": "2026-10-04T09:12:54.187Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1665d164-78d8-80aa-a4d4-d9a26a1da4d2"
      },
      {
        "object": "block",
        "id": "2595d164-78d8-8079-9703-caab73fc9539",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2025-08-24T01:22:00.000Z",
        "last_edited_time": "2025-08-24T01:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "— Trích từ ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "— Trích từ ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "IDF",
                "link": {
                  "url": "https://www.interaction-design.org/literature/article/task-analysis-a-ux-designer-s-best-friend"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "IDF",
              "href": "https://www.interaction-design.org/literature/article/task-analysis-a-ux-designer-s-best-friend"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2595d164-78d8-804e-9df8-df99cf474239",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2025-08-24T01:22:00.000Z",
        "last_edited_time": "2025-08-24T01:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau đây là 5 loại thông tin mình cần hiểu user:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau đây là 5 loại thông tin mình cần hiểu user:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2595d164-78d8-80aa-bbe0-d08891c1d106",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2025-08-24T01:22:00.000Z",
        "last_edited_time": "2025-08-24T01:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trigger:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trigger:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " What initiates the task for the user?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " What initiates the task for the user?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2595d164-78d8-801f-ba87-c3b478e8fa7c",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2025-08-24T01:22:00.000Z",
        "last_edited_time": "2025-08-24T01:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Desired Outcome:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Desired Outcome:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " How will users know they have successfully completed the task?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " How will users know they have successfully completed the task?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2595d164-78d8-80a4-83d1-eb7658595a31",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2025-08-24T01:22:00.000Z",
        "last_edited_time": "2025-08-24T01:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Base Knowledge:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Base Knowledge:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " What will the users be expected to know when starting the task?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " What will the users be expected to know when starting the task?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2595d164-78d8-80d4-b1fe-e5fbd4e7df36",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2025-08-24T01:22:00.000Z",
        "last_edited_time": "2025-08-24T01:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Required Knowledge:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Required Knowledge:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " What do users already know before starting the task?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " What do users already know before starting the task?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2595d164-78d8-80bd-a00d-e4bf2dc3305a",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2025-08-24T01:22:00.000Z",
        "last_edited_time": "2025-08-24T01:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Artifacts",
                "link": {
                  "url": "https://www.interaction-design.org/literature/topics/artifact"
                }
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Artifacts",
              "href": "https://www.interaction-design.org/literature/topics/artifact"
            },
            {
              "type": "text",
              "text": {
                "content": ":",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ":",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " What resources or tools will users require during the task?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " What resources or tools will users require during the task?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2595d164-78d8-8097-9e52-d506dbba4a27",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2025-08-24T01:24:00.000Z",
        "last_edited_time": "2025-08-24T01:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: ngoài những task mình quan sát được user thực hiện, mình còn phải nắm thêm ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: ngoài những task mình quan sát được user thực hiện, mình còn phải nắm thêm ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "cognitive task",
                "link": {
                  "url": "https://www.interaction-design.org/literature/topics/cognitive-task-analysis"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "cognitive task",
              "href": "https://www.interaction-design.org/literature/topics/cognitive-task-analysis"
            },
            {
              "type": "text",
              "text": {
                "content": " - nó nói về việc user cần phải biết gì, consider gì, judge ra sao để make decision…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " - nó nói về việc user cần phải biết gì, consider gì, judge ra sao để make decision…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "d085f480-2886-473d-beb7-380a224573a4",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-10-15T02:26:00.000Z",
        "last_edited_time": "2024-11-12T02:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "3cb1f069-93d0-4a21-aeee-583aedaac1f3",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-10-15T02:26:00.000Z",
        "last_edited_time": "2024-12-24T03:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "User flow - Screen flow",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User flow - Screen flow",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "7e7f011d-2c83-4f08-928a-29157c808e81",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-10-15T02:26:00.000Z",
        "last_edited_time": "2025-08-05T01:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "OK, tiếp theo là user flow. Term này chắc là quen thuộc nhất trong UX/UI design, nó mô tả ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "OK, tiếp theo là user flow. Term này chắc là quen thuộc nhất trong UX/UI design, nó mô tả ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "chi tiết hơn cách user sẽ tương tác như thế nào với tính năng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "chi tiết hơn cách user sẽ tương tác như thế nào với tính năng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", để hình dung rõ hơn về cách họ ra quyết định và các tình huống có thể gặp phải trong quá trình sử dụng. ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", để hình dung rõ hơn về cách họ ra quyết định và các tình huống có thể gặp phải trong quá trình sử dụng. ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "0f7beb8d-ca96-474f-8cc1-a5347e327110",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-10-15T02:31:00.000Z",
        "last_edited_time": "2024-12-24T01:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081689/uxcomic-imgs/0f7beb8d-ca96-474f-8cc1-a5347e327110.jpg",
            "expiry_time": "2026-10-04T09:12:54.188Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/0f7beb8d-ca96-474f-8cc1-a5347e327110"
      },
      {
        "object": "block",
        "id": "1665d164-78d8-80f8-8c89-e75a93ede2a6",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-12-24T01:40:00.000Z",
        "last_edited_time": "2025-08-24T01:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "User flow là cầu nối giữa task flow & screen flow. Screen flow mô tả chính xác, cụ thể cách user tương tác với UI như thế nào, điều hướng ra sao, xem cái gì, click cái gì, control & feedback ra sao. Đây là version sát nhất với thực tế sử dụng (tất nhiên sau bản build demo :)), có khi dev lên rồi mới thấy có chỗ này chỗ kia không như expectation, hoặc cảm giác transition chậm, hoặc chưa tính tương thích với user device,…mà thôi bỏ qua cái đó nhé).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User flow là cầu nối giữa task flow & screen flow. Screen flow mô tả chính xác, cụ thể cách user tương tác với UI như thế nào, điều hướng ra sao, xem cái gì, click cái gì, control & feedback ra sao. Đây là version sát nhất với thực tế sử dụng (tất nhiên sau bản build demo :)), có khi dev lên rồi mới thấy có chỗ này chỗ kia không như expectation, hoặc cảm giác transition chậm, hoặc chưa tính tương thích với user device,…mà thôi bỏ qua cái đó nhé).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-809d-8457-d648cc4ec7bd",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-12-24T01:48:00.000Z",
        "last_edited_time": "2024-12-24T03:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081691/uxcomic-imgs/1665d164-78d8-809d-8457-d648cc4ec7bd.webp",
            "expiry_time": "2026-10-04T09:12:54.188Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1665d164-78d8-809d-8457-d648cc4ec7bd"
      },
      {
        "object": "block",
        "id": "12f5d164-78d8-803b-a8ee-e11b83caeb92",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-10-30T10:10:00.000Z",
        "last_edited_time": "2024-10-30T10:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1205d164-78d8-80d1-834e-dcc89c0c4d10",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-10-15T02:47:00.000Z",
        "last_edited_time": "2024-12-24T05:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Wrap up",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Wrap up",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1205d164-78d8-807c-aa8f-d85eac602e8f",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-10-15T02:47:00.000Z",
        "last_edited_time": "2025-08-05T01:46:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Như vậy, mình có thể thấy mỗi loại sẽ tập trung vào một vài khía cạnh nhất định, khi làm UX ta phải liên tục hình dung xem mối liên hệ giữa product & user ra sao, 2 nhân vật này tương tác lẫn nhau như thế nào, vì at the end nghĩa vụ của UX design là bôi trơn quá trình tương tác này để kiến tạo nó thành một trải nghiệm tốt, để product vs user trao đổi giá trị suôn sẻ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Như vậy, mình có thể thấy mỗi loại sẽ tập trung vào một vài khía cạnh nhất định, khi làm UX ta phải liên tục hình dung xem mối liên hệ giữa product & user ra sao, 2 nhân vật này tương tác lẫn nhau như thế nào, vì at the end nghĩa vụ của UX design là bôi trơn quá trình tương tác này để kiến tạo nó thành một trải nghiệm tốt, để product vs user trao đổi giá trị suôn sẻ.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-807f-9355-d84d2e9922ae",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-12-24T03:57:00.000Z",
        "last_edited_time": "2024-12-24T06:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081692/uxcomic-imgs/1665d164-78d8-807f-9355-d84d2e9922ae.png",
            "expiry_time": "2026-10-04T09:12:54.188Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1665d164-78d8-807f-9355-d84d2e9922ae"
      },
      {
        "object": "block",
        "id": "1205d164-78d8-8052-8814-d4f8c9ac561b",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-10-15T11:19:00.000Z",
        "last_edited_time": "2024-12-25T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "User journey map",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User journey map",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " sẽ phù hợp với tổng quan & tập trung đến từng điểm chạm, cảm xúc người dùng. Don’t forget figure out ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " sẽ phù hợp với tổng quan & tập trung đến từng điểm chạm, cảm xúc người dùng. Don’t forget figure out ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "HOW SHOULD THEY FEEL",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "HOW SHOULD THEY FEEL",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " while using your product.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " while using your product.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1205d164-78d8-8078-b254-fdd82dc61b5e",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-10-15T11:19:00.000Z",
        "last_edited_time": "2024-12-25T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "User scenario",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User scenario",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " tập trung nhiều về ngữ cảnh, product của bạn thực sự hiện diện như thế nào trong đời sống của user.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " tập trung nhiều về ngữ cảnh, product của bạn thực sự hiện diện như thế nào trong đời sống của user.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-80c4-b1a7-f8189e7b910a",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-12-24T01:48:00.000Z",
        "last_edited_time": "2025-04-10T07:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Task flow",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Task flow",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " minh hoạ kĩ hơn từng bước mà user đang thực hiện ở thực tại ra sao để hoàn thành một nhiệm vụ nào đó. (là những step để đến dc JTBD)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " minh hoạ kĩ hơn từng bước mà user đang thực hiện ở thực tại ra sao để hoàn thành một nhiệm vụ nào đó. (là những step để đến dc JTBD)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1205d164-78d8-8015-ac82-c4c00047b126",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-10-15T11:19:00.000Z",
        "last_edited_time": "2024-12-25T01:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "User flow, screen flow",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User flow, screen flow",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " thiên nhiều về cách hoạt động của function, sự giao tiếp giữa user & hệ thống.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " thiên nhiều về cách hoạt động của function, sự giao tiếp giữa user & hệ thống.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1495d164-78d8-8062-a6dd-d5ff9bc88ec5",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-11-25T03:48:00.000Z",
        "last_edited_time": "2024-12-23T17:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80db-aefc-d5e7d26f6ebf",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-12-23T17:30:00.000Z",
        "last_edited_time": "2024-12-23T17:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-803f-94d6-ff251c4c7b92",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-12-23T17:30:00.000Z",
        "last_edited_time": "2024-12-23T17:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.uxpassion.com/blog/implementation-mental-representation-models-ux-user-experience/",
                "link": {
                  "url": "https://www.uxpassion.com/blog/implementation-mental-representation-models-ux-user-experience/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.uxpassion.com/blog/implementation-mental-representation-models-ux-user-experience/",
              "href": "https://www.uxpassion.com/blog/implementation-mental-representation-models-ux-user-experience/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1d15d164-78d8-804e-bdc4-caf914be744b",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2025-04-10T07:21:00.000Z",
        "last_edited_time": "2025-04-10T07:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.linkedin.com/pulse/task-flow-vs-user-same-different-henrik-giaretta/",
                "link": {
                  "url": "https://www.linkedin.com/pulse/task-flow-vs-user-same-different-henrik-giaretta/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.linkedin.com/pulse/task-flow-vs-user-same-different-henrik-giaretta/",
              "href": "https://www.linkedin.com/pulse/task-flow-vs-user-same-different-henrik-giaretta/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2595d164-78d8-802b-9871-c120d7930f17",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2025-08-24T01:26:00.000Z",
        "last_edited_time": "2025-08-24T01:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.interaction-design.org/literature/topics/cognitive-task-analysis",
                "link": {
                  "url": "https://www.interaction-design.org/literature/topics/cognitive-task-analysis"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.interaction-design.org/literature/topics/cognitive-task-analysis",
              "href": "https://www.interaction-design.org/literature/topics/cognitive-task-analysis"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "2595d164-78d8-804e-982e-c198b9215342",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2025-08-24T01:26:00.000Z",
        "last_edited_time": "2025-08-24T01:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.interaction-design.org/literature/article/task-analysis-a-ux-designer-s-best-friend",
                "link": {
                  "url": "https://www.interaction-design.org/literature/article/task-analysis-a-ux-designer-s-best-friend"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.interaction-design.org/literature/article/task-analysis-a-ux-designer-s-best-friend",
              "href": "https://www.interaction-design.org/literature/article/task-analysis-a-ux-designer-s-best-friend"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80b5-b440-c1429889a3d2",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-12-23T17:30:00.000Z",
        "last_edited_time": "2024-12-23T17:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80d8-8397-ef4bcfdbd567",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-12-23T17:30:00.000Z",
        "last_edited_time": "2024-12-23T17:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-80cd-aff8-e32dd23dd606",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-12-24T02:11:00.000Z",
        "last_edited_time": "2024-12-24T02:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1605d164-78d8-80ad-9130-fe44c6663146"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Value vs Benefit",
              "href": "https://app.notion.com/p/1605d16478d880ad9130fe44c6663146"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-80ad-94ac-cd1a3c78a223",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-12-24T06:14:00.000Z",
        "last_edited_time": "2024-12-24T06:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "5b45ba36-9dad-4a92-bccb-7e54a1db1c10"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Rõ dần”",
              "href": "https://app.notion.com/p/5b45ba369dad4a92bccb7e54a1db1c10"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1655d164-78d8-80b4-8d0d-e7e6e95f1865",
        "parent": {
          "type": "page_id",
          "page_id": "1155d164-78d8-80a8-83a6-ec9db47fe4dc"
        },
        "created_time": "2024-12-23T17:30:00.000Z",
        "last_edited_time": "2024-12-23T17:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Interaction Pattern",
              "href": "https://app.notion.com/p/56798be37f484cfea30e49cc2dedd33d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae",
    "created_time": "2024-10-04T02:04:00.000Z",
    "last_edited_time": "2025-10-17T02:42:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "~cV[",
          "name": "4-Measure",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2025-10-17T02:42:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": "ByM|",
          "name": "♟️:2",
          "color": "pink"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 12
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2024-10-04T02:04:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "UX audit",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "UX audit",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/UX-audit-f795c7b7fe0a48759c8296002d8bbdae",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "~cV[",
      "name": "Measure",
      "slug": "measure",
      "order": 4
    },
    "content": [
      {
        "object": "block",
        "id": "14c5d164-78d8-81ce-9126-ee7960da6bb9",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-28T05:43:00.000Z",
        "last_edited_time": "2024-12-05T02:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081696/uxcomic-imgs/14c5d164-78d8-81ce-9126-ee7960da6bb9.png",
            "expiry_time": "2026-10-04T09:12:56.612Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/14c5d164-78d8-81ce-9126-ee7960da6bb9"
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80db-9446-db44c64447dd",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-12-22T06:13:00.000Z",
        "last_edited_time": "2024-12-22T06:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cũng hơi xấu hổ khi phải thú thật là mình chưa nghe đến khái niệm này cho đến những năm gần đây, lần đầu tiên mình nghe là trong một cuộc phỏng vấn, tất nhiên khi bạn không biết về nó thì cách bạn làm cũng sẽ rất loay hoay & kết quả dĩ nhiên là tệ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cũng hơi xấu hổ khi phải thú thật là mình chưa nghe đến khái niệm này cho đến những năm gần đây, lần đầu tiên mình nghe là trong một cuộc phỏng vấn, tất nhiên khi bạn không biết về nó thì cách bạn làm cũng sẽ rất loay hoay & kết quả dĩ nhiên là tệ.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8068-90b1-ece293a3afb6",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-12-22T06:15:00.000Z",
        "last_edited_time": "2024-12-22T06:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ôm tủi nhục này về sau buổi phỏng vấn, giờ mình mới có thể hỏi để thật sự tìm hiểu về nó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ôm tủi nhục này về sau buổi phỏng vấn, giờ mình mới có thể hỏi để thật sự tìm hiểu về nó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80cb-a58f-f55b5d6509f1",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-12-22T06:13:00.000Z",
        "last_edited_time": "2024-12-22T06:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80db-814e-e2df49000d79",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-12-22T06:16:00.000Z",
        "last_edited_time": "2024-12-22T06:16:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "UX audit là gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX audit là gì?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8073-9152-ed2aa35d51b4",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-12-22T06:17:00.000Z",
        "last_edited_time": "2024-12-29T02:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Ngắn gọn thì là đánh giá UX cho một product hoặc flow, tìm ra cái gì tốt, cái gì không tốt & nếu được thì đề xuất luôn hướng cải thiện.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Ngắn gọn thì là đánh giá UX cho một product hoặc flow, tìm ra cái gì tốt, cái gì không tốt & nếu được thì đề xuất luôn hướng cải thiện.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80b0-8cc9-e256e65c0605",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-12-22T06:19:00.000Z",
        "last_edited_time": "2024-12-29T02:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tại sao UX audit trở thành một bài test trong buổi phỏng vấn? Vì thông qua cách bạn đánh giá một design, nó cho thấy xu hướng thiết kế của mình ra sao. Nếu thực tế lúc bạn bắt tay vào thiết kế, bạn trải qua process thế nào, đâu là những thứ bạn cân nhắc, tư duy về mục tiêu, vấn đề & giải pháp ra sao thì đến lúc audit bạn cũng sẽ có xu hướng y chang vậy.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tại sao UX audit trở thành một bài test trong buổi phỏng vấn? Vì thông qua cách bạn đánh giá một design, nó cho thấy xu hướng thiết kế của mình ra sao. Nếu thực tế lúc bạn bắt tay vào thiết kế, bạn trải qua process thế nào, đâu là những thứ bạn cân nhắc, tư duy về mục tiêu, vấn đề & giải pháp ra sao thì đến lúc audit bạn cũng sẽ có xu hướng y chang vậy.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-80d0-846f-f7fcac5e4ab1",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2025-01-16T14:07:00.000Z",
        "last_edited_time": "2025-01-16T14:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-8093-94a5-ec5d0de3074f",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-12-22T06:25:00.000Z",
        "last_edited_time": "2024-12-22T06:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy thì chúng ta nên audit như thế nào?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy thì chúng ta nên audit như thế nào?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-818b-bbd6-d07bf8fc42c1",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-28T05:43:00.000Z",
        "last_edited_time": "2024-12-22T06:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Để đánh giá được một thiết kế tốt hay không, mình phải hiểu những thứ behind the interface, behind the interaction, cũng giống như khi tackle product design challenge mình đi qua ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Để đánh giá được một thiết kế tốt hay không, mình phải hiểu những thứ behind the interface, behind the interaction, cũng giống như khi tackle product design challenge mình đi qua ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "layer",
                "link": {
                  "url": "/5b45ba369dad4a92bccb7e54a1db1c10"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "layer",
              "href": "/5b45ba369dad4a92bccb7e54a1db1c10"
            },
            {
              "type": "text",
              "text": {
                "content": " trên, thì khi audit cũng vậy.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " trên, thì khi audit cũng vậy.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1625d164-78d8-8070-9bb8-e3635122ed7f",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-12-20T05:45:00.000Z",
        "last_edited_time": "2024-12-29T02:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081698/uxcomic-imgs/1625d164-78d8-8070-9bb8-e3635122ed7f.png",
            "expiry_time": "2026-10-04T09:12:56.612Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1625d164-78d8-8070-9bb8-e3635122ed7f"
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-81d3-b72f-ea08d2819f93",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-28T05:43:00.000Z",
        "last_edited_time": "2024-11-28T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "We rarely see the constraints, pushback, perspectives, and objectives others are working with. We can hardly know whether the work was even meant for someone like us, or if the audience is an entirely different group of people with different beliefs, ways of seeing things, or needs.",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "We rarely see the constraints, pushback, perspectives, and objectives others are working with. We can hardly know whether the work was even meant for someone like us, or if the audience is an entirely different group of people with different beliefs, ways of seeing things, or needs.",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " Readily jumping to any conclusions without first considering these aspects means we're shutting off and rejecting work that may otherwise actually be \"good” or even remarkable.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " Readily jumping to any conclusions without first considering these aspects means we're shutting off and rejecting work that may otherwise actually be \"good” or even remarkable.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14d5d164-78d8-804d-bbb0-cf8043e96b97",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-29T04:58:00.000Z",
        "last_edited_time": "2024-11-29T04:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy khi nào thì ta nên audit?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy khi nào thì ta nên audit?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14d5d164-78d8-8018-a398-da57e1359dd7",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-29T04:59:00.000Z",
        "last_edited_time": "2024-11-29T04:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi cần redesign",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi cần redesign",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14d5d164-78d8-80d4-99a8-e1418ddd0147",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-29T05:00:00.000Z",
        "last_edited_time": "2024-11-29T05:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi cần feedback cho đồng nghiệp",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi cần feedback cho đồng nghiệp",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14d5d164-78d8-80da-b90b-c9b4ca525bca",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-29T04:59:00.000Z",
        "last_edited_time": "2024-11-29T04:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi tham khảo design của đối thủ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi tham khảo design của đối thủ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14d5d164-78d8-8072-b6ca-c69d6d2336e4",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-29T04:59:00.000Z",
        "last_edited_time": "2024-11-29T05:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi cần tìm cách cải thiện UX của sản phẩm hiện tại",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi cần tìm cách cải thiện UX của sản phẩm hiện tại",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ca5d164-78d8-8085-a126-d1ac51f0fdb1",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2025-04-03T04:11:00.000Z",
        "last_edited_time": "2025-04-03T04:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081699/uxcomic-imgs/1ca5d164-78d8-8085-a126-d1ac51f0fdb1.png",
            "expiry_time": "2026-10-04T09:12:56.612Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1ca5d164-78d8-8085-a126-d1ac51f0fdb1"
      },
      {
        "object": "block",
        "id": "14d5d164-78d8-80e4-b6ee-f25b3b28d61e",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-29T04:58:00.000Z",
        "last_edited_time": "2024-11-29T04:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-81dc-9b0f-d8c8ebfb2411",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-28T05:43:00.000Z",
        "last_edited_time": "2024-11-29T04:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "1. Hiểu",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "1. Hiểu",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14d5d164-78d8-80e9-9d27-c87c54e8e8f0",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-29T04:39:00.000Z",
        "last_edited_time": "2024-11-29T04:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cho ai? Được gì?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cho ai? Được gì?",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-81bd-abfe-c396f1f6ed9c",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-28T05:43:00.000Z",
        "last_edited_time": "2024-12-23T07:22:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước hết phải start với objective, context, problem background. Ta cần hiểu design trước mắt đang có nghĩa vụ gì, nó được sinh ra vì lí do gì, ta phục vụ cho ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước hết phải start với objective, context, problem background. Ta cần hiểu design trước mắt đang có nghĩa vụ gì, nó được sinh ra vì lí do gì, ta phục vụ cho ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "đối tượng user",
                "link": {
                  "url": "/22a3b4bb88d34f84a70f83e7c12ac91d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "đối tượng user",
              "href": "/22a3b4bb88d34f84a70f83e7c12ac91d"
            },
            {
              "type": "text",
              "text": {
                "content": " nào? Liệu có research, data hay insight gì bổ trợ cho vấn đề này?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " nào? Liệu có research, data hay insight gì bổ trợ cho vấn đề này?",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-8034-8d3e-d86a0e3a82f1",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-28T11:22:00.000Z",
        "last_edited_time": "2024-12-20T05:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau phải hiểu thêm các constraints gặp phải ở đây là gì, có phải do technical constraints, dependencies, business, legal constraints,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau phải hiểu thêm các constraints gặp phải ở đây là gì, có phải do technical constraints, dependencies, business, legal constraints,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-804c-852f-c3678f10adbb",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-28T11:26:00.000Z",
        "last_edited_time": "2024-11-28T11:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Timeline, mức độ effort đầu tư cho feature này như thế nào? Nó là trọng điểm, là core feature hay chỉ mang tính chất MVP, thử nghiệm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Timeline, mức độ effort đầu tư cho feature này như thế nào? Nó là trọng điểm, là core feature hay chỉ mang tính chất MVP, thử nghiệm.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1595d164-78d8-8085-833a-d10bbfd0d30a",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-12-11T11:04:00.000Z",
        "last_edited_time": "2024-12-11T11:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Note: khi mình audit product ngoài market khả năng cao mình sẽ không có những thông tin này, nhưng thông quá UI, IA, flow của họ đâu đó ta sẽ phán đoán được objective của họ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Note: khi mình audit product ngoài market khả năng cao mình sẽ không có những thông tin này, nhưng thông quá UI, IA, flow của họ đâu đó ta sẽ phán đoán được objective của họ.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-8069-b73e-e634f11ee1a6",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-12-29T03:05:00.000Z",
        "last_edited_time": "2024-12-29T03:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-8169-bbd5-fa007a0b8dff",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-28T05:43:00.000Z",
        "last_edited_time": "2024-11-29T04:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "2. Đánh giá",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2. Đánh giá",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14d5d164-78d8-8071-9c26-f08feabb7d9a",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-29T04:34:00.000Z",
        "last_edited_time": "2024-11-29T04:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đúng - Đủ - Đẹp?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đúng - Đủ - Đẹp?",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-8195-beb5-d157fa748ae7",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-28T05:43:00.000Z",
        "last_edited_time": "2024-12-29T03:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đúng",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đúng",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": sau khi đã có đủ context, mình mới đánh giá xem design hiện tại có serve đúng cho problem, cho objective, cho user need không.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": sau khi đã có đủ context, mình mới đánh giá xem design hiện tại có serve đúng cho problem, cho objective, cho user need không.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1625d164-78d8-8057-b448-d63101856f99",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-12-20T05:32:00.000Z",
        "last_edited_time": "2025-01-16T14:15:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đủ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đủ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": liệu interaction pattern hiện tại có phù hợp với context of user, với tệp user không? Flow này có cover được cho hết user scenario, edge case chưa? Các trade off có thể thấy ở đây là gì, cách design này đang ưu tiên tối ưu giải quyết vấn đề gì hay cho trải nghiệm nào?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": liệu interaction pattern hiện tại có phù hợp với context of user, với tệp user không? Flow này có cover được cho hết user scenario, edge case chưa? Các trade off có thể thấy ở đây là gì, cách design này đang ưu tiên tối ưu giải quyết vấn đề gì hay cho trải nghiệm nào?",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-80c5-b26d-c2569ec99ade",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-28T11:26:00.000Z",
        "last_edited_time": "2024-12-29T03:01:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đẹp",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đẹp",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": đẹp ở đây đánh giá cả trên thẩm mĩ và vẻ đẹp của cảm xúc khi họ dùng. Ta đánh giá xem emotion design ở đây có được serve tốt không, liệu có psychology có thể apply cho flow này không? User có cần cảm thấy hứng thú hơn hay tiện lợi hơn? Liệu UI, visual / information hierarchy đã bổ trợ tốt cho Interaction?…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": đẹp ở đây đánh giá cả trên thẩm mĩ và vẻ đẹp của cảm xúc khi họ dùng. Ta đánh giá xem emotion design ở đây có được serve tốt không, liệu có psychology có thể apply cho flow này không? User có cần cảm thấy hứng thú hơn hay tiện lợi hơn? Liệu UI, visual / information hierarchy đã bổ trợ tốt cho Interaction?…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-8029-b01b-cb2b129b7519",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-28T11:28:00.000Z",
        "last_edited_time": "2024-12-20T05:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đó là góc nhìn đánh giá của chuyên môn (expert review), còn thực tế có data/ research nào giúp ích cho việc đánh giá này không? Có thể nói ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đó là góc nhìn đánh giá của chuyên môn (expert review), còn thực tế có data/ research nào giúp ích cho việc đánh giá này không? Có thể nói ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "fact - thực tế người dùng trải nghiệm ra sao ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "fact - thực tế người dùng trải nghiệm ra sao ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "luôn nên được xem là quan trọng nhất.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "luôn nên được xem là quan trọng nhất.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-80b2-84fd-dfef5aa32290",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2025-01-16T14:17:00.000Z",
        "last_edited_time": "2025-01-16T14:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-8046-8b15-ea4c4dea1cc4",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2025-01-16T14:11:00.000Z",
        "last_edited_time": "2025-01-16T14:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Các framework (tuỳ theo loại hình product, stage of development & cái điều mình muốn biết mà lựa chọn framework cho phù hợp)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Các framework (tuỳ theo loại hình product, stage of development & cái điều mình muốn biết mà lựa chọn framework cho phù hợp)",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-8016-9e3e-ecbf559d9915",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2025-01-16T14:11:00.000Z",
        "last_edited_time": "2025-01-16T14:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "SUS:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "SUS:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " system usability scale (best for comparing usability across multiple systems or iterations).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " system usability scale (best for comparing usability across multiple systems or iterations).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-8003-a782-d684bb448bb8",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2025-01-16T14:11:00.000Z",
        "last_edited_time": "2025-01-16T14:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "SUPR-Q:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "SUPR-Q:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " standardized user experience percentile rank questionnarie (best for E-commerce websites, SaaS platforms, and apps where trust and loyalty are critical).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " standardized user experience percentile rank questionnarie (best for E-commerce websites, SaaS platforms, and apps where trust and loyalty are critical).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-8099-898f-e39c35031470",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2025-01-16T14:12:00.000Z",
        "last_edited_time": "2025-01-16T14:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "UX Honeycomb",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX Honeycomb",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": Useful; Usable; Desirable; Findable; Accessible; Credible; Valuable (best for  Early-stage evaluations or holistic UX reviews).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": Useful; Usable; Desirable; Findable; Accessible; Credible; Valuable (best for  Early-stage evaluations or holistic UX reviews).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-80e1-9dea-db618b4cb3d9",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2025-01-16T14:13:00.000Z",
        "last_edited_time": "2025-01-16T14:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Usability heuristic",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Usability heuristic",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": (best for spot-checking usability issues during design or development).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": (best for spot-checking usability issues during design or development).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17d5d164-78d8-80e8-acd9-f5e592f399ca",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2025-01-16T14:17:00.000Z",
        "last_edited_time": "2025-01-16T14:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "search trên chatGPT để biết thêm",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "search trên chatGPT để biết thêm",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-80fa-a29e-c3163a9a2b6d",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-12-29T03:04:00.000Z",
        "last_edited_time": "2024-12-29T03:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1625d164-78d8-80ab-a351-ec6759c08d79",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-12-20T05:47:00.000Z",
        "last_edited_time": "2024-12-20T05:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sai lầm phổ biến",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sai lầm phổ biến",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-8067-887f-ee18caa55ad4",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-12-29T03:02:00.000Z",
        "last_edited_time": "2024-12-29T03:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước đó nếu kêu mình đánh giá landing page này như thế nào, mình sẽ quên hỏi về mục tiêu của landing page này là gì, đối tượng là ai, quên xem cấu trúc thông tin nó như thế nào, mà lại nhảy thẳng vào đánh giá UI, Interaction của nó, vì tầng UI, interaction là thứ lộ rõ ra trước mắt, nên khi audit chúng ta rất dễ lậm vào nó >> đây là một thiếu sót trong cách ta ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước đó nếu kêu mình đánh giá landing page này như thế nào, mình sẽ quên hỏi về mục tiêu của landing page này là gì, đối tượng là ai, quên xem cấu trúc thông tin nó như thế nào, mà lại nhảy thẳng vào đánh giá UI, Interaction của nó, vì tầng UI, interaction là thứ lộ rõ ra trước mắt, nên khi audit chúng ta rất dễ lậm vào nó >> đây là một thiếu sót trong cách ta ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "hiểu về design",
                "link": {
                  "url": "/ed40fd40a3184fd6a63f0067b4e54861"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "hiểu về design",
              "href": "/ed40fd40a3184fd6a63f0067b4e54861"
            },
            {
              "type": "text",
              "text": {
                "content": " và sự tồn tại của design trong bức tranh lớn ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " và sự tồn tại của design trong bức tranh lớn ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "product development process.",
                "link": {
                  "url": "/1445d16478d8805bb388e24b5f13cccb"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "product development process.",
              "href": "/1445d16478d8805bb388e24b5f13cccb"
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-801b-959b-c1df933421c4",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-12-29T03:03:00.000Z",
        "last_edited_time": "2024-12-29T03:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-8039-818e-c44fc8106b9d",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-12-29T03:02:00.000Z",
        "last_edited_time": "2024-12-29T03:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tip để tránh tình trạng này là hãy bám theo câu hỏi sau khi audit:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tip để tránh tình trạng này là hãy bám theo câu hỏi sau khi audit:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1625d164-78d8-80ad-a686-f4b3598b3ef4",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-12-20T05:49:00.000Z",
        "last_edited_time": "2025-03-19T06:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "1625d164-78d8-8038-805b-cdd8e9c7d42e",
            "parent": {
              "type": "block_id",
              "block_id": "1625d164-78d8-80ad-a686-f4b3598b3ef4"
            },
            "created_time": "2024-12-20T05:51:00.000Z",
            "last_edited_time": "2025-03-19T06:27:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Phỏng đoán xem liệu những gì tôi đang thấy & tương tác, nó nhầm phục vụ cho nhu cầu gì (user need & business objectives)? Main action & sub-action nên có là gì?",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Phỏng đoán xem liệu những gì tôi đang thấy & tương tác, nó nhầm phục vụ cho nhu cầu gì (user need & business objectives)? Main action & sub-action nên có là gì?",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 0
          },
          {
            "object": "block",
            "id": "f4c9c0a4-6afa-45a3-8076-5c92fc6e1121",
            "parent": {
              "type": "block_id",
              "block_id": "1625d164-78d8-80ad-a686-f4b3598b3ef4"
            },
            "created_time": "2024-12-20T05:49:00.000Z",
            "last_edited_time": "2024-12-29T03:04:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Tôi đang thấy gì & tương tác nó ra sao? Liệu context tôi đang tương tác có giống như một user thực tế đang sử dụng?",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Tôi đang thấy gì & tương tác nó ra sao? Liệu context tôi đang tương tác có giống như một user thực tế đang sử dụng?",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 1
          },
          {
            "object": "block",
            "id": "1625d164-78d8-8018-97d5-e31316bfc118",
            "parent": {
              "type": "block_id",
              "block_id": "1625d164-78d8-80ad-a686-f4b3598b3ef4"
            },
            "created_time": "2024-12-20T05:52:00.000Z",
            "last_edited_time": "2024-12-20T05:53:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "numbered_list_item",
            "numbered_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Vậy đánh giá xem hướng xử lý này có pros & cons ra sao?",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Vậy đánh giá xem hướng xử lý này có pros & cons ra sao?",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false,
            "index": 2
          }
        ]
      },
      {
        "object": "block",
        "id": "16b5d164-78d8-80da-a7b8-fb705770a395",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-12-29T03:04:00.000Z",
        "last_edited_time": "2024-12-29T03:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14d5d164-78d8-8033-a479-de9f8ce33d18",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-29T04:51:00.000Z",
        "last_edited_time": "2024-11-29T04:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "3. Đề xuất",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3. Đề xuất",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14d5d164-78d8-8012-8c81-c85bcf0c508c",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-29T04:55:00.000Z",
        "last_edited_time": "2024-11-29T04:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tăng hoặc Giảm; Tạo hoặc Bỏ?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tăng hoặc Giảm; Tạo hoặc Bỏ?",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14d5d164-78d8-80e7-8d95-c22074737098",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-29T04:52:00.000Z",
        "last_edited_time": "2024-12-20T05:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau khi đã đánh giá, phê bình được điểm tốt, điểm tệ, hiểu các trade off. Giờ mình sẽ thử hình dung xem có giải pháp cải thiện nào không. Có khi không cần chi tiết mà chỉ cần list out ra những challenge mà design cần phải cân nhắc để giải quyết thêm. Ví dụ: làm sao để không click nhầm, làm sao để tiện lợi hơn, làm sao để user tự tin take action hơn,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau khi đã đánh giá, phê bình được điểm tốt, điểm tệ, hiểu các trade off. Giờ mình sẽ thử hình dung xem có giải pháp cải thiện nào không. Có khi không cần chi tiết mà chỉ cần list out ra những challenge mà design cần phải cân nhắc để giải quyết thêm. Ví dụ: làm sao để không click nhầm, làm sao để tiện lợi hơn, làm sao để user tự tin take action hơn,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-81bb-8735-d3705a0e3278",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-28T05:43:00.000Z",
        "last_edited_time": "2024-11-28T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-811a-9c1a-d3ed12859da1",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-28T05:43:00.000Z",
        "last_edited_time": "2024-11-28T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1ca5d164-78d8-809d-a17f-fd48d58ee176",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2025-04-03T03:31:00.000Z",
        "last_edited_time": "2025-04-03T03:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://givegoodux.com/ux-audit-workbook/",
                "link": {
                  "url": "https://givegoodux.com/ux-audit-workbook/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://givegoodux.com/ux-audit-workbook/",
              "href": "https://givegoodux.com/ux-audit-workbook/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "28f5d164-78d8-8058-a637-c49f4e11352d",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2025-10-17T02:42:00.000Z",
        "last_edited_time": "2025-10-17T02:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://measuringu.com/he-cw/",
                "link": {
                  "url": "https://measuringu.com/he-cw/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://measuringu.com/he-cw/",
              "href": "https://measuringu.com/he-cw/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-810a-8eef-c2c7d27b1b57",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-28T05:43:00.000Z",
        "last_edited_time": "2024-11-28T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.tannerchristensen.com/notes/making-more-informed-design-judgements",
                "link": {
                  "url": "https://www.tannerchristensen.com/notes/making-more-informed-design-judgements"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.tannerchristensen.com/notes/making-more-informed-design-judgements",
              "href": "https://www.tannerchristensen.com/notes/making-more-informed-design-judgements"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-8113-8b1b-c77ce1d5fec3",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-28T05:43:00.000Z",
        "last_edited_time": "2024-11-28T11:14:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.tannerchristensen.com/notes/four-things-working-at-facebook-has-taught-me-about-design-critique",
                "link": {
                  "url": "https://www.tannerchristensen.com/notes/four-things-working-at-facebook-has-taught-me-about-design-critique"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.tannerchristensen.com/notes/four-things-working-at-facebook-has-taught-me-about-design-critique",
              "href": "https://www.tannerchristensen.com/notes/four-things-working-at-facebook-has-taught-me-about-design-critique"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1a15d164-78d8-807a-b3d3-f552005dfe9c",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2025-02-21T12:02:00.000Z",
        "last_edited_time": "2025-02-21T12:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://uxdesign.cc/how-i-review-design-work-6323a06a4932",
                "link": {
                  "url": "https://uxdesign.cc/how-i-review-design-work-6323a06a4932"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://uxdesign.cc/how-i-review-design-work-6323a06a4932",
              "href": "https://uxdesign.cc/how-i-review-design-work-6323a06a4932"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1c85d164-78d8-80a0-9055-eece5c40e606",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2025-04-01T01:46:00.000Z",
        "last_edited_time": "2025-04-01T01:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.linkedin.com/posts/vitalyfriedman_ux-design-activity-7312475730515234817-w4Te?",
                "link": {
                  "url": "https://www.linkedin.com/posts/vitalyfriedman_ux-design-activity-7312475730515234817-w4Te?utm_source=share&utm_medium=member_ios&rcm=ACoAACTxzsYBO4mptTzgsbAc8dNNiYnc142O2IA"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.linkedin.com/posts/vitalyfriedman_ux-design-activity-7312475730515234817-w4Te?",
              "href": "https://www.linkedin.com/posts/vitalyfriedman_ux-design-activity-7312475730515234817-w4Te?utm_source=share&utm_medium=member_ios&rcm=ACoAACTxzsYBO4mptTzgsbAc8dNNiYnc142O2IA"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-8131-bbc4-f753d45601c2",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-28T05:43:00.000Z",
        "last_edited_time": "2024-11-28T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-8173-acb3-e11daaae5a84",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-28T05:43:00.000Z",
        "last_edited_time": "2024-11-28T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-816a-b741-ea76d27ee0f1",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-28T05:43:00.000Z",
        "last_edited_time": "2024-12-02T10:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1195d164-78d8-81ac-9a30-d03724b3531b"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Usability Heuristics",
              "href": "https://app.notion.com/p/1195d16478d881ac9a30d03724b3531b"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "14c5d164-78d8-8182-a224-cecb1d0e549a",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-11-28T05:43:00.000Z",
        "last_edited_time": "2024-12-02T10:28:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1195d164-78d8-8130-8d61-fe6e1619967b"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "IxD checklist",
              "href": "https://app.notion.com/p/1195d16478d881308d61fe6e1619967b"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-8029-b668-effdd6739fbb",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-12-02T10:29:00.000Z",
        "last_edited_time": "2024-12-02T10:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1195d164-78d8-800e-93cc-d89ca8ed01bc"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX checklist",
              "href": "https://app.notion.com/p/1195d16478d8800e93ccd89ca8ed01bc"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-80d2-8f74-e0c93052bcdb",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-12-02T10:29:00.000Z",
        "last_edited_time": "2024-12-02T10:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1195d164-78d8-80db-a620-d79bfde9595c"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Information, Message, Content",
              "href": "https://app.notion.com/p/1195d16478d880dba620d79bfde9595c"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1505d164-78d8-80f5-806f-cee2878f078b",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2024-12-02T10:29:00.000Z",
        "last_edited_time": "2025-02-22T03:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1a25d164-78d8-8014-9c62-f19436d6ecf5",
        "parent": {
          "type": "page_id",
          "page_id": "f795c7b7-fe0a-4875-9c82-96002d8bbdae"
        },
        "created_time": "2025-02-22T03:43:00.000Z",
        "last_edited_time": "2025-02-22T03:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "32cbe568-c34b-4255-a408-f2a2e6227bb2",
    "created_time": "2024-10-04T01:59:00.000Z",
    "last_edited_time": "2025-07-21T05:40:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "1-Understand",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2025-07-21T05:40:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": "cgmn",
          "name": "⚓:1",
          "color": "orange"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 55
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2024-10-04T01:59:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Understand, Empathize user?",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Understand, Empathize user?",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Understand-Empathize-user-32cbe568c34b4255a408f2a2e6227bb2",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
      "name": "Understand",
      "slug": "understand",
      "order": 1
    },
    "content": [
      {
        "object": "block",
        "id": "1155d164-78d8-81bb-94f5-cdccf5856221",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-04T01:59:00.000Z",
        "last_edited_time": "2024-10-08T04:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081705/uxcomic-imgs/1155d164-78d8-81bb-94f5-cdccf5856221.png",
            "expiry_time": "2026-10-04T09:12:57.723Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1155d164-78d8-81bb-94f5-cdccf5856221"
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-80e4-99fb-e71f05e487b2",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-12T03:40:00.000Z",
        "last_edited_time": "2024-10-12T03:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hiểu về user được xem là một kĩ năng critical trong ux/ui design và trong phát triển sản phẩm nói chung, sẽ thật vô lý khi bạn thiết kế sản phẩm cho người dùng mà chưa từng nói chuyện với họ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hiểu về user được xem là một kĩ năng critical trong ux/ui design và trong phát triển sản phẩm nói chung, sẽ thật vô lý khi bạn thiết kế sản phẩm cho người dùng mà chưa từng nói chuyện với họ.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1155d164-78d8-81a6-9fe4-c5c017986fb0",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-04T01:59:00.000Z",
        "last_edited_time": "2024-10-08T04:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1155d164-78d8-8116-bc5a-cf4564466f5a",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-04T01:59:00.000Z",
        "last_edited_time": "2024-10-08T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước hết, tại sao phải hiểu user?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước hết, tại sao phải hiểu user?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1155d164-78d8-81cc-bbc4-c1795865744b",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-04T01:59:00.000Z",
        "last_edited_time": "2024-10-08T02:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sản phẩm được sinh ra để phục vụ user, từ việc giải quyết vấn đề của họ, business sẽ nhận lại những giá trị từ phía user. Và chắc hẳn chúng ta không muốn làm ra một sản phẩm mà không ai dùng vì không có nhu cầu, vậy nên mình phải hiểu họ, hiểu nhu cầu, động lực, những khó khăn họ đang gặp phải.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sản phẩm được sinh ra để phục vụ user, từ việc giải quyết vấn đề của họ, business sẽ nhận lại những giá trị từ phía user. Và chắc hẳn chúng ta không muốn làm ra một sản phẩm mà không ai dùng vì không có nhu cầu, vậy nên mình phải hiểu họ, hiểu nhu cầu, động lực, những khó khăn họ đang gặp phải.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "6d8a7bb6-6e7a-4a03-904f-65482920e070",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-08T02:21:00.000Z",
        "last_edited_time": "2025-01-21T02:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Phải hiểu các phần mềm mang trong nó rất nhiều khả năng mà con người không tài nào làm được (lấy ví dụ bạn sẽ không thể tính toán nhanh bằng máy vi tính), bằng việc giúp con người tiếp cận với những công nghệ đó, nó giúp boost những khả năng mới của con người. Nhưng khi product không được thiết kế user friendly, thì sẽ trở thành rào cản giữa công nghệ và người dùng, khiến giá trị trao đổi này bị stuck. Vậy nên trước khi có term UX, đã tồn tại term nghe dễ trực quan hơn là human computer interaction (HCI) -thiết kế để con người & máy tính có thể tương tác với nhau. Tuy nhiên đó là thời điểm trước, khi công nghệ là thứ gì đó mới mẻ, và nó thường được ứng dụng cho công việc, user buộc phải học cách để dùng nó (lấy ví dụ bạn phải học Word, Excel). Nhưng bây giờ công nghệ đã trở thành những thứ rất quen thuộc & tồn tại nhiều hơn trong cuộc sống hàng ngày (bạn lướt feed trên Facebook mỗi ngày, xem youtube, đặt đồ ăn…) >> công nghệ phải trở nên friendly hơn, phải adapt theo hành vi của user chứ không còn theo chiều ngược lại, có như thế product mới chiếm lấy được con tim của user. >> để friendly thì ta cần hiểu họ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Phải hiểu các phần mềm mang trong nó rất nhiều khả năng mà con người không tài nào làm được (lấy ví dụ bạn sẽ không thể tính toán nhanh bằng máy vi tính), bằng việc giúp con người tiếp cận với những công nghệ đó, nó giúp boost những khả năng mới của con người. Nhưng khi product không được thiết kế user friendly, thì sẽ trở thành rào cản giữa công nghệ và người dùng, khiến giá trị trao đổi này bị stuck. Vậy nên trước khi có term UX, đã tồn tại term nghe dễ trực quan hơn là human computer interaction (HCI) -thiết kế để con người & máy tính có thể tương tác với nhau. Tuy nhiên đó là thời điểm trước, khi công nghệ là thứ gì đó mới mẻ, và nó thường được ứng dụng cho công việc, user buộc phải học cách để dùng nó (lấy ví dụ bạn phải học Word, Excel). Nhưng bây giờ công nghệ đã trở thành những thứ rất quen thuộc & tồn tại nhiều hơn trong cuộc sống hàng ngày (bạn lướt feed trên Facebook mỗi ngày, xem youtube, đặt đồ ăn…) >> công nghệ phải trở nên friendly hơn, phải adapt theo hành vi của user chứ không còn theo chiều ngược lại, có như thế product mới chiếm lấy được con tim của user. >> để friendly thì ta cần hiểu họ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1155d164-78d8-81af-9f68-f07720d7b10e",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-04T01:59:00.000Z",
        "last_edited_time": "2024-10-08T02:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "5231b4b6-79a0-41fa-8c78-3fd7ea30ecb9",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-04T01:59:00.000Z",
        "last_edited_time": "2024-10-08T02:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy thì mình cần hiểu gì?",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy thì mình cần hiểu gì?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-8016-b4e5-f43528560807",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-25T14:01:00.000Z",
        "last_edited_time": "2024-12-26T05:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khả năng nói qua hết mấy thứ này thì dài dòng lắm, mà chính mình cũng chưa đủ kinh nghiệm về user research, chắc mình cũng như bạn, đều đang cố gắng quan sát & áp dụng nó từ từ. >> Nên mình chỉ liệt kê các thứ cần nắm khi muốn hiểu một ai đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khả năng nói qua hết mấy thứ này thì dài dòng lắm, mà chính mình cũng chưa đủ kinh nghiệm về user research, chắc mình cũng như bạn, đều đang cố gắng quan sát & áp dụng nó từ từ. >> Nên mình chỉ liệt kê các thứ cần nắm khi muốn hiểu một ai đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-803e-a8ab-d647e812bf55",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-25T14:03:00.000Z",
        "last_edited_time": "2024-12-25T14:03:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-8028-bf1d-de449404f0b6",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-08T04:44:00.000Z",
        "last_edited_time": "2024-12-25T13:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khía cạnh",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khía cạnh",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-8018-b718-cedae8b113db",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-08T04:43:00.000Z",
        "last_edited_time": "2024-12-26T10:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false,
        "children": [
          {
            "object": "block",
            "id": "d500a517-5f38-4a26-851b-dffc3a27e8b8",
            "parent": {
              "type": "block_id",
              "block_id": "1195d164-78d8-8018-b718-cedae8b113db"
            },
            "created_time": "2024-10-08T02:39:00.000Z",
            "last_edited_time": "2024-12-26T10:29:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Behavior, Habit & Intention ",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Behavior, Habit & Intention ",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "c6c52620-0b34-447f-a349-e1213dafb0a7",
            "parent": {
              "type": "block_id",
              "block_id": "1195d164-78d8-8018-b718-cedae8b113db"
            },
            "created_time": "2024-10-08T02:39:00.000Z",
            "last_edited_time": "2024-12-26T10:31:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Context & Scenario",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Context & Scenario",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "e567f653-2d46-4e5f-87e7-4a361b572e20",
            "parent": {
              "type": "block_id",
              "block_id": "1195d164-78d8-8018-b718-cedae8b113db"
            },
            "created_time": "2024-10-08T02:37:00.000Z",
            "last_edited_time": "2024-10-08T04:45:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Motivation & Attitude ",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Motivation & Attitude ",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "3d93a0e0-8717-4625-be9b-836c9d04a500",
            "parent": {
              "type": "block_id",
              "block_id": "1195d164-78d8-8018-b718-cedae8b113db"
            },
            "created_time": "2024-10-08T02:38:00.000Z",
            "last_edited_time": "2024-12-26T10:30:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Background & Aptitude",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Background & Aptitude",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "1195d164-78d8-80fd-8149-cabb949cda26",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-08T04:45:00.000Z",
        "last_edited_time": "2024-10-08T04:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "5459e1cf-9d9f-49a4-9f17-1ebfba7ed269",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-08T02:39:00.000Z",
        "last_edited_time": "2024-12-25T13:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mức độ hiểu",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mức độ hiểu",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-802a-bdb5-cee57b64e584",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-08T04:30:00.000Z",
        "last_edited_time": "2024-10-08T04:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081706/uxcomic-imgs/1195d164-78d8-802a-bdb5-cee57b64e584.png",
            "expiry_time": "2026-10-04T09:12:57.723Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1195d164-78d8-802a-bdb5-cee57b64e584"
      },
      {
        "object": "block",
        "id": "1675d164-78d8-8043-8c9c-f9db07ec8b15",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-25T13:52:00.000Z",
        "last_edited_time": "2024-12-25T13:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11d5d164-78d8-801a-beb8-ccffccd50e3d",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-12T03:40:00.000Z",
        "last_edited_time": "2024-12-25T13:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tam quan",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tam quan",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-806e-b752-e421acc6e99a",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-26T10:21:00.000Z",
        "last_edited_time": "2024-12-27T02:07:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081708/uxcomic-imgs/1685d164-78d8-806e-b752-e421acc6e99a.png",
            "expiry_time": "2026-10-04T09:12:57.723Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1685d164-78d8-806e-b752-e421acc6e99a"
      },
      {
        "object": "block",
        "id": "1685d164-78d8-8005-bd76-cc891c5c616a",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-26T02:40:00.000Z",
        "last_edited_time": "2024-12-26T02:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Chữ “quan” trong tiếng Hán Việt nghĩa là ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Chữ “quan” trong tiếng Hán Việt nghĩa là ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-805c-bf92-c1283ec39f2d",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-26T02:48:00.000Z",
        "last_edited_time": "2024-12-26T02:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“Quan” (觀) trong tiếng Hán Việt nghĩa là: cách nhìn, quan điểm, quan niệm. Nó giống như chữ “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“Quan” (觀) trong tiếng Hán Việt nghĩa là: cách nhìn, quan điểm, quan niệm. Nó giống như chữ “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "framing",
                "link": {
                  "url": "https://en.wikipedia.org/wiki/Framing_(social_sciences)"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "framing",
              "href": "https://en.wikipedia.org/wiki/Framing_(social_sciences)"
            },
            {
              "type": "text",
              "text": {
                "content": "” mà ta thường nghe trong quá trình problem solving. “In social theory, framing is a schema of interpretation, a collection of anecdotes and stereotypes, that individuals rely on to understand and respond to events. In other words, people build a series of mental \"filters\" through biological and cultural influences. They then use these filters to make sense of the world. “ (From Wikipedia).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” mà ta thường nghe trong quá trình problem solving. “In social theory, framing is a schema of interpretation, a collection of anecdotes and stereotypes, that individuals rely on to understand and respond to events. In other words, people build a series of mental \"filters\" through biological and cultural influences. They then use these filters to make sense of the world. “ (From Wikipedia).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-801b-b9f0-cfa3f40411db",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-25T13:52:00.000Z",
        "last_edited_time": "2024-12-25T14:06:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thế giới quan",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thế giới quan",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": là những gì bạn biết, bạn thấy trong cuộc sống này.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": là những gì bạn biết, bạn thấy trong cuộc sống này.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-8008-81ea-d3405a5f2260",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-25T14:01:00.000Z",
        "last_edited_time": "2024-12-26T02:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giá trị quan",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giá trị quan",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": là những đánh giá, góc nhìn của bản thân về một sự vật, sự việc.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": là những đánh giá, góc nhìn của bản thân về một sự vật, sự việc.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-807a-a2f4-f6586727afa5",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-25T14:01:00.000Z",
        "last_edited_time": "2024-12-25T14:09:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhân sinh quan",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhân sinh quan",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ": là những niềm tin cốt lõi, chúng sẽ định hình thái độ của chúng ta với cuộc sống này.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ": là những niềm tin cốt lõi, chúng sẽ định hình thái độ của chúng ta với cuộc sống này.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16a5d164-78d8-805c-8eb5-f0761c902b9a",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-28T03:37:00.000Z",
        "last_edited_time": "2024-12-28T03:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16a5d164-78d8-8036-b73b-f22c6c419652",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-28T03:37:00.000Z",
        "last_edited_time": "2024-12-28T03:37:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lấy một ví dụ minh họa nhé:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lấy một ví dụ minh họa nhé:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16a5d164-78d8-806c-8d0b-ff48f646d3dc",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-28T03:37:00.000Z",
        "last_edited_time": "2024-12-28T03:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trên đời có rất nhiều nhiều món ăn, thức uống. Theo thời gian bạn sẽ thử được món này món kia, quán này quán kia (thế giới quan), bạn sẽ đánh giá được món nào ngon món nào không (giá trị quan), tuy nhiên sau khi thử rất nhiều món bạn nhận ra mình vẫn thích món quê nhà hơn (nhân sinh quan). Nhân sinh quan có thể sẽ tác động lên xu hướng ăn uống của bạn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trên đời có rất nhiều nhiều món ăn, thức uống. Theo thời gian bạn sẽ thử được món này món kia, quán này quán kia (thế giới quan), bạn sẽ đánh giá được món nào ngon món nào không (giá trị quan), tuy nhiên sau khi thử rất nhiều món bạn nhận ra mình vẫn thích món quê nhà hơn (nhân sinh quan). Nhân sinh quan có thể sẽ tác động lên xu hướng ăn uống của bạn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "16a5d164-78d8-80f7-8f21-d93a008be2fb",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-28T03:41:00.000Z",
        "last_edited_time": "2024-12-28T03:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-8083-978f-d8aab3b0febc",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-26T02:21:00.000Z",
        "last_edited_time": "2024-12-28T03:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tam quan lý giải cho việc hình thành nên mindset, thái độ & hành vi. Khi nhắc đến hiểu user, theo như hình màu hồng ở trên, cái quan trọng nhất là hiểu “Why they do it?” >> có nghĩa là ta phải tìm hiểu tam quan của họ, biết được background của họ, môi trường sống của họ ra sao, bản chất con người họ (họ đang đề cao giá trị gì, họ có niềm tin gì, họ có xu hướng hành vi ra sao), figure out cái gì tác động lên cách định hình suy nghĩ đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tam quan lý giải cho việc hình thành nên mindset, thái độ & hành vi. Khi nhắc đến hiểu user, theo như hình màu hồng ở trên, cái quan trọng nhất là hiểu “Why they do it?” >> có nghĩa là ta phải tìm hiểu tam quan của họ, biết được background của họ, môi trường sống của họ ra sao, bản chất con người họ (họ đang đề cao giá trị gì, họ có niềm tin gì, họ có xu hướng hành vi ra sao), figure out cái gì tác động lên cách định hình suy nghĩ đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-806b-bc7b-fa387b166557",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-26T05:19:00.000Z",
        "last_edited_time": "2024-12-28T03:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Đây mới chính là lúc thấu cảm (empathy) bắt đầu diễn ra, còn việc nghiên cứu hành vi, thái độ mới chỉ đang nằm ở mức quan sát.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Đây mới chính là lúc thấu cảm (empathy) bắt đầu diễn ra, còn việc nghiên cứu hành vi, thái độ mới chỉ đang nằm ở mức quan sát.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-8046-b0cb-d6634670d9c9",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-25T13:50:00.000Z",
        "last_edited_time": "2024-12-26T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "49ba3a44-778b-40f1-bdeb-bd4cea26a4ad",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-08T02:52:00.000Z",
        "last_edited_time": "2024-12-17T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "How",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "How",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15f5d164-78d8-80b0-b69a-f9b028f87fef",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-17T01:59:00.000Z",
        "last_edited_time": "2024-12-17T01:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nếu chia theo hành động nghiên cứu, theo mình có thể chia như sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nếu chia theo hành động nghiên cứu, theo mình có thể chia như sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15f5d164-78d8-80e2-9206-f0d44cface54",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-17T01:59:00.000Z",
        "last_edited_time": "2024-12-26T02:20:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lv1",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lv1",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ". ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Observation: ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Observation: ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "quan sát hiện tượng, bề mặt, những gì họ nói, họ làm. Stage này bạn thuần là một người ngoài cuộc, như một cái camera chỉ thuần quan sát, ghi chép họ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "quan sát hiện tượng, bề mặt, những gì họ nói, họ làm. Stage này bạn thuần là một người ngoài cuộc, như một cái camera chỉ thuần quan sát, ghi chép họ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15f5d164-78d8-807e-9b1d-ec788334db55",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-17T01:59:00.000Z",
        "last_edited_time": "2024-12-26T05:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lv2",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lv2",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ". ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Hiểu cảm xúc & động lực:",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hiểu cảm xúc & động lực:",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " này thiên về việc mình cố gắng ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " này thiên về việc mình cố gắng ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "lắng nghe & hiểu",
                "link": {
                  "url": "/1405d16478d8801ab019e709965fbf48"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "lắng nghe & hiểu",
              "href": "/1405d16478d8801ab019e709965fbf48"
            },
            {
              "type": "text",
              "text": {
                "content": ", để phân tích & lí giải why they do what they do. Này làm mình liên tưởng đến cảnh mà các cảnh sát đang cố gắng tra hỏi, suy nghĩ dưới tâm lý tội phạm. Có thể nói stage này là bắt đầu hoà nhập, tuy nhiên vẫn có một khoảng gap giữa mình & họ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", để phân tích & lí giải why they do what they do. Này làm mình liên tưởng đến cảnh mà các cảnh sát đang cố gắng tra hỏi, suy nghĩ dưới tâm lý tội phạm. Có thể nói stage này là bắt đầu hoà nhập, tuy nhiên vẫn có một khoảng gap giữa mình & họ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15f5d164-78d8-8052-8b64-c2257da8c34d",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-17T02:00:00.000Z",
        "last_edited_time": "2024-12-26T05:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lv3",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lv3",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ". ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ". ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Be them (role-playing",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Be them (role-playing",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "): bạn trở thành họ, bạn đặt mình vào môi trường sống của họ, hiểu những gì họ trải qua, hiểu về bản chất con người & gốc rễ sản sinh nên những ý nghĩ, niềm tin đó. Bạn thấy họ ở góc độ là một cá thể phức tạp được hình nên bởi môi trường, những sự việc đã trải qua, những tổn thương & hy vọng riêng biệt. Có thể nói đây là giai đoạn bạn hoà tan. Cái này làm mình nhớ đến mấy phim có một cảnh sát chìm trà trộn vào băng xã hội đen, khi họ thực sự sống trong môi trường đó có thể khiến họ dần dần quên mất chính mình là một cảnh sát.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "): bạn trở thành họ, bạn đặt mình vào môi trường sống của họ, hiểu những gì họ trải qua, hiểu về bản chất con người & gốc rễ sản sinh nên những ý nghĩ, niềm tin đó. Bạn thấy họ ở góc độ là một cá thể phức tạp được hình nên bởi môi trường, những sự việc đã trải qua, những tổn thương & hy vọng riêng biệt. Có thể nói đây là giai đoạn bạn hoà tan. Cái này làm mình nhớ đến mấy phim có một cảnh sát chìm trà trộn vào băng xã hội đen, khi họ thực sự sống trong môi trường đó có thể khiến họ dần dần quên mất chính mình là một cảnh sát.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1825d164-78d8-8011-bc5d-e9aaa3388b1b",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2025-01-21T02:38:00.000Z",
        "last_edited_time": "2025-01-21T02:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15f5d164-78d8-804a-8a7f-da8334cbd2d3",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-17T01:58:00.000Z",
        "last_edited_time": "2024-12-26T05:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Về cơ bản ta có định tính (qualitative - sâu) & định lượng (quantitative- rộng). Còn các cách cụ thể để hiểu thì có rất nhiều framework ngoài kia, bạn có thể tìm hiểu thêm qua các hình này.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Về cơ bản ta có định tính (qualitative - sâu) & định lượng (quantitative- rộng). Còn các cách cụ thể để hiểu thì có rất nhiều framework ngoài kia, bạn có thể tìm hiểu thêm qua các hình này.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-8041-9f9e-ee8db97f120e",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-08T04:24:00.000Z",
        "last_edited_time": "2024-10-08T04:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081710/uxcomic-imgs/1195d164-78d8-8041-9f9e-ee8db97f120e.png",
            "expiry_time": "2026-10-04T09:12:57.811Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1195d164-78d8-8041-9f9e-ee8db97f120e"
      },
      {
        "object": "block",
        "id": "1155d164-78d8-81a0-b766-c9701fa91f98",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-04T01:59:00.000Z",
        "last_edited_time": "2024-10-04T01:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-8099-8bcd-d4d5bab8b6df",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-26T05:43:00.000Z",
        "last_edited_time": "2024-12-26T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Product/Feature development process & việc nghiên cứu user",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product/Feature development process & việc nghiên cứu user",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-802f-bfba-f77c08b7a172",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-26T05:43:00.000Z",
        "last_edited_time": "2024-12-26T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Việc liên tục tìm hiểu user diễn ra xuyên suốt trong quá trình phát triển sản phẩm. Vd: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Việc liên tục tìm hiểu user diễn ra xuyên suốt trong quá trình phát triển sản phẩm. Vd: ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-80c3-9d18-c66259f28a67",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-26T05:43:00.000Z",
        "last_edited_time": "2024-12-26T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Giai đoạn đầu bạn muốn hiểu rõ về nhu cầu, pain & các ngữ cảnh… của họ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Giai đoạn đầu bạn muốn hiểu rõ về nhu cầu, pain & các ngữ cảnh… của họ",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-80c2-95fb-ce2eab441267",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-26T05:43:00.000Z",
        "last_edited_time": "2024-12-26T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trong khi design bạn muốn áp dụng các UX law & psychology (base trên những nghiên cứu đã có trước đó về việc hiểu về hành vi con người).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trong khi design bạn muốn áp dụng các UX law & psychology (base trên những nghiên cứu đã có trước đó về việc hiểu về hành vi con người).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-8049-894c-d10bf576b9ce",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-26T05:43:00.000Z",
        "last_edited_time": "2024-12-26T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau khi release sản phẩm bà muốn đo lường lại để hiểu sản phẩm có thật sự phù hợp với user hay không…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau khi release sản phẩm bà muốn đo lường lại để hiểu sản phẩm có thật sự phù hợp với user hay không…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-809e-880c-d1de53750ed7",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-26T05:43:00.000Z",
        "last_edited_time": "2024-12-26T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Clip này của anh Thi sẽ làm rõ hơn về ý này:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Clip này của anh Thi sẽ làm rõ hơn về ý này:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-803b-aac7-d8e053ada693",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-08T04:22:00.000Z",
        "last_edited_time": "2024-12-26T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "video",
        "video": {
          "caption": [],
          "type": "external",
          "external": {
            "url": "https://www.youtube.com/watch?v=MGkHHvo0Yg4&t=4s"
          }
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-80fe-a677-fd0815be96aa",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-26T05:43:00.000Z",
        "last_edited_time": "2024-12-26T05:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-80b4-a022-dfdeab16dbd8",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-26T05:27:00.000Z",
        "last_edited_time": "2024-12-26T05:27:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tóm lại",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tóm lại",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-8037-9efd-f67595250df8",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-26T05:28:00.000Z",
        "last_edited_time": "2024-12-26T05:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hiểu được user cũng là một cách để hiểu được mình, ta phải dig deep hơn vào khái niệm tam quan thay vì chỉ quan sát hành vi & thái độ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hiểu được user cũng là một cách để hiểu được mình, ta phải dig deep hơn vào khái niệm tam quan thay vì chỉ quan sát hành vi & thái độ.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-80f9-8379-f6f95dfaa998",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-26T05:29:00.000Z",
        "last_edited_time": "2025-01-21T02:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tất nhiên lí thuyết là vậy, nhưng làm được không hề dễ, nội những người xung quanh mình như gia đình, bạn bè, đồng nghiệp, mình sống sát với họ hàng ngày như thế mà còn chưa hiểu hết nữa mà. Tuy nhiên giờ đã có cách (các to do list ở trên) để bổ trợ phần nào, nên không cần áp dụng gì xa xôi đâu, bắt đầu tập luyện ngay với những người xung quanh bạn trước nhé.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tất nhiên lí thuyết là vậy, nhưng làm được không hề dễ, nội những người xung quanh mình như gia đình, bạn bè, đồng nghiệp, mình sống sát với họ hàng ngày như thế mà còn chưa hiểu hết nữa mà. Tuy nhiên giờ đã có cách (các to do list ở trên) để bổ trợ phần nào, nên không cần áp dụng gì xa xôi đâu, bắt đầu tập luyện ngay với những người xung quanh bạn trước nhé.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1685d164-78d8-80f6-bf33-c053c0c832c8",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-26T05:29:00.000Z",
        "last_edited_time": "2024-12-26T05:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1155d164-78d8-8136-ad92-f5669f601b32",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-04T01:59:00.000Z",
        "last_edited_time": "2024-10-04T01:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1155d164-78d8-81bb-875f-c9ecf2bc1a2f",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-04T01:59:00.000Z",
        "last_edited_time": "2024-10-08T02:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.smashingmagazine.com/2018/06/how-to-get-to-know-your-users/",
                "link": {
                  "url": "https://www.smashingmagazine.com/2018/06/how-to-get-to-know-your-users/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.smashingmagazine.com/2018/06/how-to-get-to-know-your-users/",
              "href": "https://www.smashingmagazine.com/2018/06/how-to-get-to-know-your-users/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1155d164-78d8-81eb-a325-f68854a25061",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-04T01:59:00.000Z",
        "last_edited_time": "2024-10-08T04:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.linkedin.com/posts/helio_uxresearch-productdiscovery-marketresearch-activity-7209967520114491392-GCPV/",
                "link": {
                  "url": "https://www.linkedin.com/posts/helio_uxresearch-productdiscovery-marketresearch-activity-7209967520114491392-GCPV/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.linkedin.com/posts/helio_uxresearch-productdiscovery-marketresearch-activity-7209967520114491392-GCPV/",
              "href": "https://www.linkedin.com/posts/helio_uxresearch-productdiscovery-marketresearch-activity-7209967520114491392-GCPV/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-80a4-b662-db04a72e3eb3",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-08T04:23:00.000Z",
        "last_edited_time": "2024-10-08T04:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.nngroup.com/articles/which-ux-research-methods/",
                "link": {
                  "url": "https://www.nngroup.com/articles/which-ux-research-methods/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.nngroup.com/articles/which-ux-research-methods/",
              "href": "https://www.nngroup.com/articles/which-ux-research-methods/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "64929c98-0e29-41db-bff8-2e9b56387135",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-16T06:26:00.000Z",
        "last_edited_time": "2024-12-26T05:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.linkedin.com/posts/nbabich_ux-userresearch-uxdesign-activity-7251617288586432512-kMqu?",
                "link": {
                  "url": "https://www.linkedin.com/posts/nbabich_ux-userresearch-uxdesign-activity-7251617288586432512-kMqu?utm_source=share&utm_medium=member_ios"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.linkedin.com/posts/nbabich_ux-userresearch-uxdesign-activity-7251617288586432512-kMqu?",
              "href": "https://www.linkedin.com/posts/nbabich_ux-userresearch-uxdesign-activity-7251617288586432512-kMqu?utm_source=share&utm_medium=member_ios"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1155d164-78d8-8115-b066-fb0f7671fa62",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-04T01:59:00.000Z",
        "last_edited_time": "2024-10-04T01:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1155d164-78d8-8172-83b4-e12c58ff711b",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-04T01:59:00.000Z",
        "last_edited_time": "2024-10-04T01:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "15f5d164-78d8-80b4-9fed-f8a91e09ea9a",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-17T02:35:00.000Z",
        "last_edited_time": "2024-12-26T05:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1405d164-78d8-801a-b019-e709965fbf48"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Listening",
              "href": "https://app.notion.com/p/1405d16478d8801ab019e709965fbf48"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1155d164-78d8-81bc-ac8c-dc3c20455448",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-10-04T01:59:00.000Z",
        "last_edited_time": "2024-10-08T04:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "22a3b4bb-88d3-4f84-a70f-83e7c12ac91d"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "User Multiverse",
              "href": "https://app.notion.com/p/22a3b4bb88d34f84a70f83e7c12ac91d"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80df-8c34-ebd06c8a1147",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-25T14:09:00.000Z",
        "last_edited_time": "2024-12-26T05:48:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "a8c82bf1-5c5b-4f4d-b945-cbdb31c819b7"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mindset vs Tâm thế",
              "href": "https://app.notion.com/p/a8c82bf15c5b4f4db945cbdb31c819b7"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1695d164-78d8-80ca-a292-d44f1f0d8862",
        "parent": {
          "type": "page_id",
          "page_id": "32cbe568-c34b-4255-a408-f2a2e6227bb2"
        },
        "created_time": "2024-12-27T09:57:00.000Z",
        "last_edited_time": "2024-12-27T09:57:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d",
    "created_time": "2024-10-04T01:55:00.000Z",
    "last_edited_time": "2025-08-11T01:53:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "3-Build",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2025-08-11T01:53:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": "}QTb",
          "name": "⚔️:2",
          "color": "gray"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 8
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2024-10-04T01:55:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "Interaction Pattern",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "Interaction Pattern",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/Interaction-Pattern-56798be37f484cfea30e49cc2dedd33d",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
      "name": "Build",
      "slug": "build",
      "order": 3
    },
    "content": [
      {
        "object": "block",
        "id": "1195d164-78d8-8059-bb08-d7bb216a81a8",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-08T13:12:00.000Z",
        "last_edited_time": "2025-07-13T03:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081715/uxcomic-imgs/1195d164-78d8-8059-bb08-d7bb216a81a8.png",
            "expiry_time": "2026-10-04T09:12:59.114Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1195d164-78d8-8059-bb08-d7bb216a81a8"
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-8062-b5a5-ca972ab3318c",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-11T10:41:00.000Z",
        "last_edited_time": "2025-07-13T03:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Definition",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Definition",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-80f9-b543-c48b6d28ef3c",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-11T10:41:00.000Z",
        "last_edited_time": "2025-07-28T06:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước mắt hãy hiểu về term “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước mắt hãy hiểu về term “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "interaction",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "interaction",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "”",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "”",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80dc-b613-c35d7b5e467d",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-28T06:26:00.000Z",
        "last_edited_time": "2025-07-28T06:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nó là quá trình tương tác diễn ra khi con người {hành động-trigger} gì đó trên một {objects} thì system sẽ {phản hồi - feedback} gì đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nó là quá trình tương tác diễn ra khi con người {hành động-trigger} gì đó trên một {objects} thì system sẽ {phản hồi - feedback} gì đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80ab-b47c-d7172e8037ac",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-28T06:18:00.000Z",
        "last_edited_time": "2025-07-28T06:26:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "— và ngược lại —",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "— và ngược lại —",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80dd-8974-fe19b6c85dab",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-28T06:17:00.000Z",
        "last_edited_time": "2025-07-28T06:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "có khi object sẽ {hành động-trigger} gì đó lên con người thông qua các {giác quan} để con người nhận được {tín hiệu - thông điệp} gì đó.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "có khi object sẽ {hành động-trigger} gì đó lên con người thông qua các {giác quan} để con người nhận được {tín hiệu - thông điệp} gì đó.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80f5-8310-f181d49250e4",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-28T06:17:00.000Z",
        "last_edited_time": "2025-07-28T06:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": ">> Quá trình này ta gọi là tương tác. Nó gồm 3 thành tố chính:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ">> Quá trình này ta gọi là tương tác. Nó gồm 3 thành tố chính:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-8003-83f7-fe4ab39e4f41",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-28T06:30:00.000Z",
        "last_edited_time": "2025-07-28T06:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trigger (command, input, auto detect…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trigger (command, input, auto detect…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80e7-b7df-f3b18e128a46",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-28T06:30:00.000Z",
        "last_edited_time": "2025-07-28T06:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Object (button, page scrolling, checkbox…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Object (button, page scrolling, checkbox…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80a1-a14a-e717565ac122",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-28T06:30:00.000Z",
        "last_edited_time": "2025-07-28T06:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Feedback (toast, change, status…)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Feedback (toast, change, status…)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-80c0-8182-ef8c5397684f",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-28T06:17:00.000Z",
        "last_edited_time": "2025-07-28T06:17:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-8055-89aa-e33436271f50",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-11T10:43:00.000Z",
        "last_edited_time": "2025-07-28T06:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lấy một ví dụ: ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lấy một ví dụ: ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-8018-a6a4-e903b55cc9b9",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-28T06:19:00.000Z",
        "last_edited_time": "2025-07-28T06:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi bạn {chạm} vào một cái {nồi nước đang sôi} thì bạn thấy nó {nóng & đau - feedback} >> đây là một tương tác.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi bạn {chạm} vào một cái {nồi nước đang sôi} thì bạn thấy nó {nóng & đau - feedback} >> đây là một tương tác.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-8059-97c9-fb8e3e8bb350",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-28T06:19:00.000Z",
        "last_edited_time": "2025-07-28T06:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Khi máy điện thoại cần thông báo có {tin nhắn mới} cho bạn, chúng sẽ báo hiệu qua {run nhẹ kèm âm thanh} để bạn nhận biết có thông báo gì đó mới.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Khi máy điện thoại cần thông báo có {tin nhắn mới} cho bạn, chúng sẽ báo hiệu qua {run nhẹ kèm âm thanh} để bạn nhận biết có thông báo gì đó mới.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-8029-ab7c-f045b762037d",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-28T06:13:00.000Z",
        "last_edited_time": "2025-07-28T06:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-80ae-a7a6-d8abd26125f8",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-11T10:45:00.000Z",
        "last_edited_time": "2025-07-28T06:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "“",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "“",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Pattern",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Pattern",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "” là một cái gì đó diễn ra lặp đi lặp lại. Trong bối cảnh nói trong chuyên môn thì nó có thêm nghĩa như sau: Pattern = Một cách làm sẵn + Dùng đi dùng lại + Hiệu quả đã được chứng minh.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” là một cái gì đó diễn ra lặp đi lặp lại. Trong bối cảnh nói trong chuyên môn thì nó có thêm nghĩa như sau: Pattern = Một cách làm sẵn + Dùng đi dùng lại + Hiệu quả đã được chứng minh.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23e5d164-78d8-808f-ad91-ef6e468b0278",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-28T06:24:00.000Z",
        "last_edited_time": "2025-07-28T06:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-8000-9aa8-f93e6b49e4f5",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-11T10:47:00.000Z",
        "last_edited_time": "2025-07-28T06:24:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy gộp lại “",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy gộp lại “",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "interaction pattern",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "interaction pattern",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "” là một giải pháp thiết kế lặp lại để xử lý một tình huống tương tác phổ biến giữa người dùng và hệ thống. Nó giống như một công thức được ghi nhận, chuẩn hóa, và áp dụng nhiều lần để mang lại trải nghiệm nhất quán, hiệu quả, và quen thuộc cho người dùng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "” là một giải pháp thiết kế lặp lại để xử lý một tình huống tương tác phổ biến giữa người dùng và hệ thống. Nó giống như một công thức được ghi nhận, chuẩn hóa, và áp dụng nhiều lần để mang lại trải nghiệm nhất quán, hiệu quả, và quen thuộc cho người dùng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-8069-aede-d226bdea4573",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-11T10:41:00.000Z",
        "last_edited_time": "2025-07-11T10:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-80ac-8f97-ef25a5dbff73",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-11T10:49:00.000Z",
        "last_edited_time": "2025-07-28T06:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Type of interaction patterns (high level)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Type of interaction patterns (high level)",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-8015-9f0c-e76d5b344e66",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-08T13:12:00.000Z",
        "last_edited_time": "2025-07-11T10:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "1. Navigational Patterns",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "1. Navigational Patterns",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23c5d164-78d8-807e-ad18-f8ea355254da",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-26T10:55:00.000Z",
        "last_edited_time": "2025-07-26T10:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Actions that help users ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Actions that help users ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "move through",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "move through",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " an interface, system, or information space.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " an interface, system, or information space.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-8062-8446-fa54ab8fed00",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-08T13:12:00.000Z",
        "last_edited_time": "2024-10-08T13:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Clear Entry Points (Điểm vào rõ ràng): Xác định các điểm truy cập chính để người dùng có thể dễ dàng bắt đầu sử dụng hệ thống.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Clear Entry Points (Điểm vào rõ ràng): Xác định các điểm truy cập chính để người dùng có thể dễ dàng bắt đầu sử dụng hệ thống.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-8006-b548-df3c00f3bab0",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-08T13:12:00.000Z",
        "last_edited_time": "2025-06-11T02:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hub and Spoke (Mô hình Hub và Spoke): Trung tâm là trang chính, và người dùng điều hướng đến các trang phụ (spokes) từ trang này và trở về trung tâm sau khi hoàn thành nhiệm vụ. Ví dụ: bottom sheet, modal,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hub and Spoke (Mô hình Hub và Spoke): Trung tâm là trang chính, và người dùng điều hướng đến các trang phụ (spokes) từ trang này và trở về trung tâm sau khi hoàn thành nhiệm vụ. Ví dụ: bottom sheet, modal,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-806c-a0f9-fcdf0db0fc94",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-08T13:12:00.000Z",
        "last_edited_time": "2025-06-11T02:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Pyramid Structure (Cấu trúc hình tháp): Người dùng bắt đầu từ một điểm chính và điều hướng theo các nhánh để hoàn thành nhiệm vụ. Ví dụ: sub page,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Pyramid Structure (Cấu trúc hình tháp): Người dùng bắt đầu từ một điểm chính và điều hướng theo các nhánh để hoàn thành nhiệm vụ. Ví dụ: sub page,…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-80be-9bac-fd17007191c7",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-08T13:12:00.000Z",
        "last_edited_time": "2024-10-08T13:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "2. Command Patterns",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "2. Command Patterns",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23c5d164-78d8-8025-ad4d-d6a773c6c77d",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-26T10:55:00.000Z",
        "last_edited_time": "2025-07-26T10:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Actions where the user ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Actions where the user ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "tells the system to do something",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "tells the system to do something",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " — usually triggers an operation.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " — usually triggers an operation.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-80f5-b811-e4684ee2d260",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-08T13:12:00.000Z",
        "last_edited_time": "2025-06-11T02:45:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Explicit Actions (Hành động rõ ràng): Người dùng thực hiện các hành động rõ ràng, trực tiếp thông qua các nút lệnh hoặc biểu tượng. Ví dụ: trên google map sau khi ta click chọn “nhà hàng” thì ngay lập tức trên map chỉ hiển thị các nhà hàng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Explicit Actions (Hành động rõ ràng): Người dùng thực hiện các hành động rõ ràng, trực tiếp thông qua các nút lệnh hoặc biểu tượng. Ví dụ: trên google map sau khi ta click chọn “nhà hàng” thì ngay lập tức trên map chỉ hiển thị các nhà hàng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-807f-b129-eb17f2490577",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-08T13:12:00.000Z",
        "last_edited_time": "2025-06-11T02:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Implicit Actions (Hành động ngầm): Hệ thống tự động thực hiện các hành động dựa trên ngữ cảnh hoặc thói quen của người dùng mà không cần lệnh trực tiếp. Ví dụ: cơ chế phân phối feed trên facebook…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Implicit Actions (Hành động ngầm): Hệ thống tự động thực hiện các hành động dựa trên ngữ cảnh hoặc thói quen của người dùng mà không cần lệnh trực tiếp. Ví dụ: cơ chế phân phối feed trên facebook…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-805d-800f-f0dacd23c7dd",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-08T13:12:00.000Z",
        "last_edited_time": "2025-06-11T02:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Batch Actions (Hành động hàng loạt): Người dùng có thể thực hiện một loạt hành động cùng lúc thông qua các công cụ như chọn hàng loạt, sao chép, hoặc xóa. Ví dụ: tạo một feed mới trên facebook cần phải viết caption, thêm hình, chỉnh sửa trang trí… rồi mới đăng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Batch Actions (Hành động hàng loạt): Người dùng có thể thực hiện một loạt hành động cùng lúc thông qua các công cụ như chọn hàng loạt, sao chép, hoặc xóa. Ví dụ: tạo một feed mới trên facebook cần phải viết caption, thêm hình, chỉnh sửa trang trí… rồi mới đăng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-8024-b5a4-c0e148bf5ff8",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-08T13:12:00.000Z",
        "last_edited_time": "2024-10-08T13:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "3. Input Patterns",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "3. Input Patterns",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23c5d164-78d8-80c7-b208-e8c9e1aa4e11",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-26T10:55:00.000Z",
        "last_edited_time": "2025-07-26T10:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Actions where the user ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Actions where the user ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "provides data",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "provides data",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " for the system to process or store.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " for the system to process or store.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-809f-b525-c225ada4808e",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-08T13:12:00.000Z",
        "last_edited_time": "2024-10-08T13:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Form Entry (Nhập liệu qua biểu mẫu): Người dùng điền thông tin vào các biểu mẫu truyền thống với các trường văn bản, dropdown, checkbox, v.v.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Form Entry (Nhập liệu qua biểu mẫu): Người dùng điền thông tin vào các biểu mẫu truyền thống với các trường văn bản, dropdown, checkbox, v.v.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-800b-ae3f-cfda8c1b8c13",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-08T13:12:00.000Z",
        "last_edited_time": "2024-10-08T13:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Direct Manipulation (Tương tác trực tiếp): Người dùng thao tác trực tiếp với các đối tượng giao diện để chỉnh sửa hoặc di chuyển chúng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Direct Manipulation (Tương tác trực tiếp): Người dùng thao tác trực tiếp với các đối tượng giao diện để chỉnh sửa hoặc di chuyển chúng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-806d-87c5-e1ba56dc33fd",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-08T13:12:00.000Z",
        "last_edited_time": "2024-10-08T13:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Inline Editing (Chỉnh sửa trực tiếp): Cho phép người dùng chỉnh sửa nội dung ngay tại vị trí hiển thị mà không cần chuyển qua chế độ chỉnh sửa riêng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Inline Editing (Chỉnh sửa trực tiếp): Cho phép người dùng chỉnh sửa nội dung ngay tại vị trí hiển thị mà không cần chuyển qua chế độ chỉnh sửa riêng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-8054-b957-ffc95412752c",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-08T13:12:00.000Z",
        "last_edited_time": "2024-10-08T13:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "4. Selection Patterns",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "4. Selection Patterns",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23c5d164-78d8-80a7-a49a-ecdb766d0239",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-26T10:56:00.000Z",
        "last_edited_time": "2025-07-26T10:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Actions where the user ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Actions where the user ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "chooses from available options",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "chooses from available options",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-802c-b67e-c5b899f3c7d0",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-08T13:12:00.000Z",
        "last_edited_time": "2025-06-11T02:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Single-Select (Chọn một đối tượng): Người dùng chọn một đối tượng duy nhất từ danh sách hoặc nhóm. Ví dụ: radio button, checkmark…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Single-Select (Chọn một đối tượng): Người dùng chọn một đối tượng duy nhất từ danh sách hoặc nhóm. Ví dụ: radio button, checkmark…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-8024-adf4-d21d706b4e82",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-08T13:12:00.000Z",
        "last_edited_time": "2025-06-11T02:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Multi-Select (Chọn nhiều đối tượng): Người dùng chọn nhiều đối tượng từ danh sách hoặc nhóm để thực hiện các hành động hàng loạt. Ví dụ: checkbox, checked items, chip selection…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Multi-Select (Chọn nhiều đối tượng): Người dùng chọn nhiều đối tượng từ danh sách hoặc nhóm để thực hiện các hành động hàng loạt. Ví dụ: checkbox, checked items, chip selection…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-80aa-a8ce-fdb8d0c012c6",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-08T13:12:00.000Z",
        "last_edited_time": "2024-10-08T13:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Filtered Search (Tìm kiếm có lọc): Người dùng áp dụng bộ lọc để thu hẹp phạm vi tìm kiếm và chọn kết quả phù hợp.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Filtered Search (Tìm kiếm có lọc): Người dùng áp dụng bộ lọc để thu hẹp phạm vi tìm kiếm và chọn kết quả phù hợp.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-80fd-b071-f6626d87063e",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-08T13:12:00.000Z",
        "last_edited_time": "2024-10-08T13:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_3",
        "heading_3": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "5. Temporal Patterns",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "5. Temporal Patterns",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "23c5d164-78d8-803c-a6fa-d8d85371776e",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-26T10:56:00.000Z",
        "last_edited_time": "2025-07-26T10:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "This one’s a bit broader. It refers to ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "This one’s a bit broader. It refers to ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "interactions related to time",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "interactions related to time",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": ", sequences, or timing.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ", sequences, or timing.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-8081-aff1-d5f8d7d95cda",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-08T13:12:00.000Z",
        "last_edited_time": "2025-06-11T02:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Feedback Loops (Vòng lặp phản hồi): Hệ thống cung cấp phản hồi ngay lập tức hoặc theo thời gian để thông báo cho người dùng về trạng thái của hành động. Ví dụ: toast message, snack bar, progress bar, inline error message…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Feedback Loops (Vòng lặp phản hồi): Hệ thống cung cấp phản hồi ngay lập tức hoặc theo thời gian để thông báo cho người dùng về trạng thái của hành động. Ví dụ: toast message, snack bar, progress bar, inline error message…",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-80cf-af2a-d4951003fb69",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-08T13:12:00.000Z",
        "last_edited_time": "2024-10-08T13:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Undo/Redo (Hoàn tác/Làm lại): Người dùng có thể quay lại hoặc làm lại các hành động trước đó để dễ dàng kiểm soát kết quả.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Undo/Redo (Hoàn tác/Làm lại): Người dùng có thể quay lại hoặc làm lại các hành động trước đó để dễ dàng kiểm soát kết quả.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1195d164-78d8-8033-9e55-e2c90afac3b7",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-08T13:12:00.000Z",
        "last_edited_time": "2024-10-08T13:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Progressive Disclosure (Tiết lộ dần dần): Thông tin hoặc tùy chọn được tiết lộ dần dần dựa trên hành vi của người dùng hoặc mức độ hiểu biết của họ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Progressive Disclosure (Tiết lộ dần dần): Thông tin hoặc tùy chọn được tiết lộ dần dần dựa trên hành vi của người dùng hoặc mức độ hiểu biết của họ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-803a-b7c5-c58eb0249369",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-11T10:50:00.000Z",
        "last_edited_time": "2025-07-11T10:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-801d-a546-e4cb61b69a3c",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-11T10:50:00.000Z",
        "last_edited_time": "2025-07-13T03:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vài ví dụ cụ thể mà bạn có thể quen thuộc hơn",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vài ví dụ cụ thể mà bạn có thể quen thuộc hơn",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-80c5-bed5-c3b7cd2500fa",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-11T10:50:00.000Z",
        "last_edited_time": "2025-07-11T10:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Back - chuyển trang trên mobile thì có animation slide in từ phải sang trái, và affordance là nút “back”, hành động user có thể click vào button đó hoặc gesture drag ngay mép bên trái qua phải (iOS), samsung thì ngược lại từ mép phải qua trái",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Back - chuyển trang trên mobile thì có animation slide in từ phải sang trái, và affordance là nút “back”, hành động user có thể click vào button đó hoặc gesture drag ngay mép bên trái qua phải (iOS), samsung thì ngược lại từ mép phải qua trái",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-803f-bd62-c9460066664c",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-11T10:50:00.000Z",
        "last_edited_time": "2025-07-28T06:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Form auto validate pattern: Khi người dùng nhập sai, hiển thị lỗi ngay bên dưới trường nhập, đổi màu viền sang đỏ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Form auto validate pattern: Khi người dùng nhập sai, hiển thị lỗi ngay bên dưới trường nhập, đổi màu viền sang đỏ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-80e8-a742-ed978c912749",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-11T10:50:00.000Z",
        "last_edited_time": "2025-07-11T10:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Infinite scroll: Tải thêm nội dung khi người dùng kéo xuống cuối trang.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Infinite scroll: Tải thêm nội dung khi người dùng kéo xuống cuối trang.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22d5d164-78d8-8058-a789-e51c6246e307",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-11T10:50:00.000Z",
        "last_edited_time": "2025-07-11T10:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Confirmation dialog: Yêu cầu xác nhận trước khi thực hiện hành động không thể hoàn tác (như xóa dữ liệu)",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Confirmation dialog: Yêu cầu xác nhận trước khi thực hiện hành động không thể hoàn tác (như xóa dữ liệu)",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11a5d164-78d8-809a-bb30-f3d04373c9c7",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-09T02:38:00.000Z",
        "last_edited_time": "2024-10-09T02:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "11a5d164-78d8-80fb-b966-d4cc5105092a",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-09T02:39:00.000Z",
        "last_edited_time": "2025-07-13T03:33:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "11a5d164-78d8-80c2-8824-c9c620a94ce7",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2024-10-09T02:39:00.000Z",
        "last_edited_time": "2025-06-11T02:29:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://m3.material.io/foundations/interaction/inputs",
                "link": {
                  "url": "https://m3.material.io/foundations/interaction/inputs"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://m3.material.io/foundations/interaction/inputs",
              "href": "https://m3.material.io/foundations/interaction/inputs"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20f5d164-78d8-80d2-a929-c0da4ae75aea",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-06-11T02:29:00.000Z",
        "last_edited_time": "2025-06-11T02:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://developer.apple.com/design/human-interface-guidelines/patterns",
                "link": {
                  "url": "https://developer.apple.com/design/human-interface-guidelines/patterns"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://developer.apple.com/design/human-interface-guidelines/patterns",
              "href": "https://developer.apple.com/design/human-interface-guidelines/patterns"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20f5d164-78d8-8055-8d7d-d0a1e0442461",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-06-11T02:31:00.000Z",
        "last_edited_time": "2025-06-11T02:31:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.nngroup.com/articles/design-pattern-guidelines/",
                "link": {
                  "url": "https://www.nngroup.com/articles/design-pattern-guidelines/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.nngroup.com/articles/design-pattern-guidelines/",
              "href": "https://www.nngroup.com/articles/design-pattern-guidelines/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20f5d164-78d8-80a0-aa35-ce0541945e24",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-06-11T02:32:00.000Z",
        "last_edited_time": "2025-06-11T02:32:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://ui-patterns.com/patterns",
                "link": {
                  "url": "https://ui-patterns.com/patterns"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://ui-patterns.com/patterns",
              "href": "https://ui-patterns.com/patterns"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "20f5d164-78d8-80e9-b4be-e584e7e221d2",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-06-11T02:32:00.000Z",
        "last_edited_time": "2025-07-12T00:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://www.interaction-design.org/literature/book/the-glossary-of-human-computer-interaction/interaction-design-patterns",
                "link": {
                  "url": "https://www.interaction-design.org/literature/book/the-glossary-of-human-computer-interaction/interaction-design-patterns"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://www.interaction-design.org/literature/book/the-glossary-of-human-computer-interaction/interaction-design-patterns",
              "href": "https://www.interaction-design.org/literature/book/the-glossary-of-human-computer-interaction/interaction-design-patterns"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-8087-8f6e-e2ab36c8fd8b",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-12T00:55:00.000Z",
        "last_edited_time": "2025-07-12T00:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "https://qubstudio.com/blog/interaction-design-patterns/",
                "link": {
                  "url": "https://qubstudio.com/blog/interaction-design-patterns/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "https://qubstudio.com/blog/interaction-design-patterns/",
              "href": "https://qubstudio.com/blog/interaction-design-patterns/"
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-80cd-9290-feb3e603156d",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-12T04:08:00.000Z",
        "last_edited_time": "2025-07-12T04:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-802b-8488-f85c9fe3cfb8",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-12T04:08:00.000Z",
        "last_edited_time": "2025-07-12T04:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Items",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Items",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-801a-9128-d840cfc03a7c",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-12T04:13:00.000Z",
        "last_edited_time": "2025-07-12T04:13:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "10f5d164-78d8-8050-9b0c-e73068127ed4"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Interaction",
              "href": "https://app.notion.com/p/10f5d16478d880509b0ce73068127ed4"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-809a-8520-deb57f968cd3",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-12T04:08:00.000Z",
        "last_edited_time": "2025-07-12T04:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "22d5d164-78d8-805e-91ed-ebff577e5186"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UX pattern",
              "href": "https://app.notion.com/p/22d5d16478d8805e91edebff577e5186"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "22e5d164-78d8-80ac-b91c-f93ff6f0d7bd",
        "parent": {
          "type": "page_id",
          "page_id": "56798be3-7f48-4cfe-a30e-49cc2dedd33d"
        },
        "created_time": "2025-07-12T04:08:00.000Z",
        "last_edited_time": "2025-07-12T04:08:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "22d5d164-78d8-8069-940d-e3185e1a8b1a"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "UI pattern",
              "href": "https://app.notion.com/p/22d5d16478d88069940de3185e1a8b1a"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "10f5d164-78d8-8084-84a5-d6eff66f3eec",
    "created_time": "2024-09-28T09:17:00.000Z",
    "last_edited_time": "2025-03-27T08:40:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "database_id",
      "database_id": "1025d164-78d8-801f-847d-ca47af91f746"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "Tag": {
        "id": "%3CT%3AQ",
        "type": "select",
        "select": {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "2-Think",
          "color": "default"
        }
      },
      "Last edited time": {
        "id": "A%40_d",
        "type": "last_edited_time",
        "last_edited_time": "2025-03-27T08:40:00.000Z"
      },
      "Dislike": {
        "id": "Bg%3Ae",
        "type": "number",
        "number": null
      },
      "Type": {
        "id": "IbTi",
        "type": "select",
        "select": {
          "id": "ByM|",
          "name": "♟️:2",
          "color": "pink"
        }
      },
      "Publish": {
        "id": "RHgQ",
        "type": "checkbox",
        "checkbox": true
      },
      "Like": {
        "id": "aY%7CK",
        "type": "number",
        "number": null
      },
      "ID": {
        "id": "hYqe",
        "type": "unique_id",
        "unique_id": {
          "prefix": "DS",
          "number": 5
        }
      },
      "View": {
        "id": "h%5BxP",
        "type": "number",
        "number": null
      },
      "Created time": {
        "id": "pX%5B_",
        "type": "created_time",
        "created_time": "2024-09-28T09:17:00.000Z"
      },
      "Share": {
        "id": "q%3BQn",
        "type": "number",
        "number": null
      },
      "Name": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "UX as a Cupid",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "UX as a Cupid",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/UX-as-a-Cupid-10f5d16478d8808484a5d6eff66f3eec",
    "public_url": null,
    "archived": false,
    "category": {
      "id": "bdbc06ee-d7c2-4b3c-813d-674e7a4975c6",
      "name": "Design",
      "slug": "design",
      "icon": "🌗",
      "order": 3,
      "created_time": "2024-09-17T02:10:00.000Z",
      "tags": [
        {
          "id": "1d9985ef-31a1-4ad8-a081-3ccb155ec30d",
          "name": "Understand",
          "slug": "understand",
          "order": 1
        },
        {
          "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
          "name": "Think",
          "slug": "think",
          "order": 2
        },
        {
          "id": "d307b34b-7c4b-4801-93c4-724215d4f425",
          "name": "Build",
          "slug": "build",
          "order": 3
        },
        {
          "id": "~cV[",
          "name": "Measure",
          "slug": "measure",
          "order": 4
        }
      ]
    },
    "tag": {
      "id": "4ec0342e-83f3-47a0-986c-f4331a8c4390",
      "name": "Think",
      "slug": "think",
      "order": 2
    },
    "content": [
      {
        "object": "block",
        "id": "12b5d164-78d8-813e-a93f-f0bf88ca1dca",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-10-26T04:12:00.000Z",
        "last_edited_time": "2024-11-15T00:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081717/uxcomic-imgs/12b5d164-78d8-813e-a93f-f0bf88ca1dca.png",
            "expiry_time": "2026-10-04T09:12:59.587Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/12b5d164-78d8-813e-a93f-f0bf88ca1dca"
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-81e7-ae83-c242a71a8ac5",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-10-26T04:12:00.000Z",
        "last_edited_time": "2024-11-09T03:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sau vài năm làm với công việc UX/UI design, mình đang cố gắng “template hoá” process làm việc để nhầm đẩy cao hiệu suất, tiết kiệm thời gian cũng như tránh sai sót.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sau vài năm làm với công việc UX/UI design, mình đang cố gắng “template hoá” process làm việc để nhầm đẩy cao hiệu suất, tiết kiệm thời gian cũng như tránh sai sót.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1395d164-78d8-8069-ac3a-f7ca452eb86f",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-11-09T03:13:00.000Z",
        "last_edited_time": "2024-11-09T03:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Cụ thể hơn là sau phase đã define được solution mong muốn, bước tiếp theo trong product development thường là design UX/UI. Vậy đâu là những thông tin mình cần có để có thể come up được bản design. Đây chính là cái template mình muốn build để phục vụ cho công việc hiện tại. Tuy nhiên mãi vẫn chưa có cái template nào phù hợp cho đến khi…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Cụ thể hơn là sau phase đã define được solution mong muốn, bước tiếp theo trong product development thường là design UX/UI. Vậy đâu là những thông tin mình cần có để có thể come up được bản design. Đây chính là cái template mình muốn build để phục vụ cho công việc hiện tại. Tuy nhiên mãi vẫn chưa có cái template nào phù hợp cho đến khi…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1395d164-78d8-80f5-bf0b-dd7d7cd8bd03",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-11-09T00:52:00.000Z",
        "last_edited_time": "2024-11-09T03:21:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một ngày mình tình cờ đọc qua sách “About Face” của Alan Cooper có nhắc đến khái niệm representation model, nó khiến mình cảm thấy rất thích thú và có cái hình dung rất tốt về nhiệm vụ công việc UX/UI.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một ngày mình tình cờ đọc qua sách “About Face” của Alan Cooper có nhắc đến khái niệm representation model, nó khiến mình cảm thấy rất thích thú và có cái hình dung rất tốt về nhiệm vụ công việc UX/UI.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1395d164-78d8-80e8-8bf7-fc923ec68501",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-11-09T02:58:00.000Z",
        "last_edited_time": "2024-11-09T02:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-811f-9cf5-fc732dd45110",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-10-26T04:12:00.000Z",
        "last_edited_time": "2024-11-09T02:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Definition",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Definition",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-8126-9d2b-ff1d9939c238",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-10-26T04:12:00.000Z",
        "last_edited_time": "2024-11-14T15:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Trước hết hãy hiểu về khái niệm của bức hình sau.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Trước hết hãy hiểu về khái niệm của bức hình sau.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1395d164-78d8-8086-be2f-d1cf39a25d86",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-11-09T00:52:00.000Z",
        "last_edited_time": "2024-11-15T00:30:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081718/uxcomic-imgs/1395d164-78d8-8086-be2f-d1cf39a25d86.png",
            "expiry_time": "2026-10-04T09:12:59.588Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1395d164-78d8-8086-be2f-d1cf39a25d86"
      },
      {
        "object": "block",
        "id": "1395d164-78d8-80a5-af2c-f0efe43a9eb1",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-11-09T02:55:00.000Z",
        "last_edited_time": "2024-11-09T02:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Implementation Model",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Implementation Model",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là góc nhìn từ người phát triển, tập trung vào cách hệ thống hoạt động.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là góc nhìn từ người phát triển, tập trung vào cách hệ thống hoạt động.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1395d164-78d8-8032-a99a-f3f3c20ab763",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-11-09T02:55:00.000Z",
        "last_edited_time": "2024-12-24T17:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mental Model ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mental Model ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "là cách người dùng mong đợi hệ thống sẽ hoạt động, kì vọng & thói quen sử dụng của họ.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "là cách người dùng mong đợi hệ thống sẽ hoạt động, kì vọng & thói quen sử dụng của họ.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1395d164-78d8-802e-9ddf-fba8196d7074",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-11-09T02:55:00.000Z",
        "last_edited_time": "2024-12-24T17:00:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Represented Model",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Represented Model",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": " là “cầu nối” chuyển đổi implementation model thành giao diện cho người dùng sử dụng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " là “cầu nối” chuyển đổi implementation model thành giao diện cho người dùng sử dụng.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1395d164-78d8-8014-92a8-d7cd24870612",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-11-09T02:56:00.000Z",
        "last_edited_time": "2024-12-24T17:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nhiệm vụ của UX/UI design chính là ở “Represented model”, chúng ta thiết kế, trình diễn cách hệ thống hoạt động làm sao cho user tận dụng được công nghệ để phục vụ cho nhu cầu của họ. Mình hình dung vui vui thì UX designer như là thần cupid giúp implementation model & mental model yêu nhau. Chúng ta có nhiệm vụ bôi trơn, đẩy thuyền quá trình này 😜.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nhiệm vụ của UX/UI design chính là ở “Represented model”, chúng ta thiết kế, trình diễn cách hệ thống hoạt động làm sao cho user tận dụng được công nghệ để phục vụ cho nhu cầu của họ. Mình hình dung vui vui thì UX designer như là thần cupid giúp implementation model & mental model yêu nhau. Chúng ta có nhiệm vụ bôi trơn, đẩy thuyền quá trình này 😜.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1395d164-78d8-80b1-a344-f84292a30a03",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-11-09T02:59:00.000Z",
        "last_edited_time": "2024-11-14T15:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuy nhiên hình ở trên bị miss một cái liên quan đến khía cạnh business, business là thứ đóng khung việc ta sẽ phục vụ cho user nào và ứng dụng công nghệ nào vào sản phẩm. Nên mình có thêm yếu tố này trong canvas thêm dưới.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuy nhiên hình ở trên bị miss một cái liên quan đến khía cạnh business, business là thứ đóng khung việc ta sẽ phục vụ cho user nào và ứng dụng công nghệ nào vào sản phẩm. Nên mình có thêm yếu tố này trong canvas thêm dưới.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1395d164-78d8-80e9-a361-e09478cb2397",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-11-09T02:58:00.000Z",
        "last_edited_time": "2024-11-14T15:44:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "3c1513ed-c131-41b3-a1b1-ac72b75cfc0c",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-11-14T12:04:00.000Z",
        "last_edited_time": "2024-11-14T15:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "The box of material",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "The box of material",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-81f5-9946-f753f7bef0b8",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-10-26T04:12:00.000Z",
        "last_edited_time": "2025-03-27T08:38:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình tạm đặt tên cho canvas này là “hộp nguyên liệu” vì nó là cách để mình đi thu thập các thông tin cần thiết trước khi bắt tay vào thiết kế.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình tạm đặt tên cho canvas này là “hộp nguyên liệu” vì nó là cách để mình đi thu thập các thông tin cần thiết trước khi bắt tay vào thiết kế.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1e1aa3dc-9ab6-41bf-b461-0bbd04aba6d7",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-10-26T04:11:00.000Z",
        "last_edited_time": "2025-03-27T08:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Nó cũng giống như việc trước khi đóng cái ghế, mình cần thu thập các nguyên vật liệu cần thiết trước, và nguyên vật liệu này tuỳ thuộc vào chiếc ghế bạn muốn đóng nó ra sao. Ví dụ cái ghế cần êm thì cần nệm, cần thu gấp được hay không, cần có gu tạo hình ra sao, chi phí hay độ bền như thế nào để quyết định vật tư,…",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Nó cũng giống như việc trước khi đóng cái ghế, mình cần thu thập các nguyên vật liệu cần thiết trước, và nguyên vật liệu này tuỳ thuộc vào chiếc ghế bạn muốn đóng nó ra sao. Ví dụ cái ghế cần êm thì cần nệm, cần thu gấp được hay không, cần có gu tạo hình ra sao, chi phí hay độ bền như thế nào để quyết định vật tư,…",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1425d164-78d8-8072-846e-e3ff2f74bf51",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-11-18T11:34:00.000Z",
        "last_edited_time": "2024-11-18T11:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081719/uxcomic-imgs/1425d164-78d8-8072-846e-e3ff2f74bf51.png",
            "expiry_time": "2026-10-04T09:12:59.588Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1425d164-78d8-8072-846e-e3ff2f74bf51"
      },
      {
        "object": "block",
        "id": "1695d164-78d8-80f6-8302-cdaa6daf8786",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-12-27T05:02:00.000Z",
        "last_edited_time": "2024-12-27T05:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "As a whole, seeing interrelationships.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "As a whole, seeing interrelationships.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1395d164-78d8-80c4-b580-d9d88d4797df",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-11-09T04:49:00.000Z",
        "last_edited_time": "2025-03-27T08:40:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Một phần nữa, canvas sẽ giúp thúc đẩy tư duy hệ thống, giúp mình nhìn thấy sự liên hệ, khả năng tác động giữa các yếu tố qua lại với nhau như thế nào… >>  phát hiện các blocker, dependencies, trade off hoặc rủi ro có thể xảy ra... Nói một cách khác, đây chính là những thứ giúp chân bạn chạm ở mặt đất - có nghĩa là design solution bạn đưa ra sát với thực tế hơn.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Một phần nữa, canvas sẽ giúp thúc đẩy tư duy hệ thống, giúp mình nhìn thấy sự liên hệ, khả năng tác động giữa các yếu tố qua lại với nhau như thế nào… >>  phát hiện các blocker, dependencies, trade off hoặc rủi ro có thể xảy ra... Nói một cách khác, đây chính là những thứ giúp chân bạn chạm ở mặt đất - có nghĩa là design solution bạn đưa ra sát với thực tế hơn.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1665d164-78d8-80b8-959c-e995ae62e72b",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-12-24T17:09:00.000Z",
        "last_edited_time": "2024-12-27T05:02:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081721/uxcomic-imgs/1665d164-78d8-80b8-959c-e995ae62e72b.png",
            "expiry_time": "2026-10-04T09:12:59.588Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1665d164-78d8-80b8-959c-e995ae62e72b"
      },
      {
        "object": "block",
        "id": "1395d164-78d8-80de-88da-df949a581fae",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-11-09T02:58:00.000Z",
        "last_edited_time": "2024-11-09T02:58:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1395d164-78d8-80c9-be40-c448ae50e299",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-11-09T04:17:00.000Z",
        "last_edited_time": "2024-11-14T15:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Vậy mình dùng canvas này thế nào?",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Vậy mình dùng canvas này thế nào?",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1395d164-78d8-8070-a746-d1c349d3ec38",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-11-09T04:44:00.000Z",
        "last_edited_time": "2024-11-14T15:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là một danh sách nguyên vật liệu mình cần chuẩn bị hay đi mua trước khi đóng cái ghế (thu thập các thông tin để chuẩn bị cho việc thiết kế).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là một danh sách nguyên vật liệu mình cần chuẩn bị hay đi mua trước khi đóng cái ghế (thu thập các thông tin để chuẩn bị cho việc thiết kế).",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 0
      },
      {
        "object": "block",
        "id": "13d5d164-78d8-803c-b15b-e13ef139b0ce",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-11-13T08:10:00.000Z",
        "last_edited_time": "2024-12-27T05:10:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là một công cụ để giúp mình đánh giá mức độ phức tạp của project, thông qua đó improve khả năng scope, estimate effort & thời gian. Đồng thời thông qua nó, liên tục zoom in, zoom out để nhận biết một thành tố đều sẽ tác động đến bức tranh chung & bức tranh chung định hướng các thành tố còn lại ra sao.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là một công cụ để giúp mình đánh giá mức độ phức tạp của project, thông qua đó improve khả năng scope, estimate effort & thời gian. Đồng thời thông qua nó, liên tục zoom in, zoom out để nhận biết một thành tố đều sẽ tác động đến bức tranh chung & bức tranh chung định hướng các thành tố còn lại ra sao.",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 1
      },
      {
        "object": "block",
        "id": "1395d164-78d8-805b-8b61-e3eb96edc5cd",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-11-09T04:45:00.000Z",
        "last_edited_time": "2024-12-24T17:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": true,
        "in_trash": false,
        "type": "numbered_list_item",
        "numbered_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Là một road map để mình biết mình biết đang tập trung trau dồi kiến thức nào. Dựa theo hình vẽ ở trên, công việc của UX/UI thường focus nhiều hơn nằm ở user model, tuy nhiên để design của bạn có tính khả thi hơn & tận dụng được tốt hơn các khả năng của công nghệ có thể mang lại thì cần quan tâm thêm về implementation model, hoặc nếu bạn muốn tạo ra được nhiều impact/value thì phải hình dung & cân nhắc hơn cho các khía cạnh của business. Ví dụ:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Là một road map để mình biết mình biết đang tập trung trau dồi kiến thức nào. Dựa theo hình vẽ ở trên, công việc của UX/UI thường focus nhiều hơn nằm ở user model, tuy nhiên để design của bạn có tính khả thi hơn & tận dụng được tốt hơn các khả năng của công nghệ có thể mang lại thì cần quan tâm thêm về implementation model, hoặc nếu bạn muốn tạo ra được nhiều impact/value thì phải hình dung & cân nhắc hơn cho các khía cạnh của business. Ví dụ:",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false,
        "index": 2,
        "children": [
          {
            "object": "block",
            "id": "b65379f1-d688-4338-98c4-03727adda1d9",
            "parent": {
              "type": "block_id",
              "block_id": "1395d164-78d8-805b-8b61-e3eb96edc5cd"
            },
            "created_time": "2024-11-12T01:35:00.000Z",
            "last_edited_time": "2024-11-13T08:11:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Khi công việc mình đang thiên hướng về implementation model nhiều hơn ta có các công việc UX Engineer, Design Ops.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Khi công việc mình đang thiên hướng về implementation model nhiều hơn ta có các công việc UX Engineer, Design Ops.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "6d74c121-6cce-4e15-82cb-761223a44bf6",
            "parent": {
              "type": "block_id",
              "block_id": "1395d164-78d8-805b-8b61-e3eb96edc5cd"
            },
            "created_time": "2024-11-12T01:35:00.000Z",
            "last_edited_time": "2024-11-13T08:11:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Khi công việc càng hướng về nghiên cứu user model, ta có các công việc của User research.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Khi công việc càng hướng về nghiên cứu user model, ta có các công việc của User research.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "3148ee80-9183-42b1-8571-50b76284909d",
            "parent": {
              "type": "block_id",
              "block_id": "1395d164-78d8-805b-8b61-e3eb96edc5cd"
            },
            "created_time": "2024-11-12T01:35:00.000Z",
            "last_edited_time": "2024-12-24T17:11:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Khi công việc chỉ chuyên sâu phần represented model ta có công việc của IxD, UI design, Principle design.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Khi công việc chỉ chuyên sâu phần represented model ta có công việc của IxD, UI design, Principle design.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          },
          {
            "object": "block",
            "id": "054cba34-eae4-4eed-bd22-593d12c82281",
            "parent": {
              "type": "block_id",
              "block_id": "1395d164-78d8-805b-8b61-e3eb96edc5cd"
            },
            "created_time": "2024-11-12T01:35:00.000Z",
            "last_edited_time": "2024-11-14T12:21:00.000Z",
            "created_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "last_edited_by": {
              "object": "user",
              "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
            },
            "has_children": false,
            "in_trash": false,
            "type": "bulleted_list_item",
            "bulleted_list_item": {
              "rich_text": [
                {
                  "type": "text",
                  "text": {
                    "content": "Khi công việc cần quán xuyến tổng thể nhiều hơn, ta có công việc của Product design, PM, PO.",
                    "link": null
                  },
                  "annotations": {
                    "bold": false,
                    "italic": false,
                    "strikethrough": false,
                    "underline": false,
                    "code": false,
                    "color": "default"
                  },
                  "plain_text": "Khi công việc cần quán xuyến tổng thể nhiều hơn, ta có công việc của Product design, PM, PO.",
                  "href": null
                }
              ],
              "color": "default"
            },
            "archived": false
          }
        ]
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-817e-9280-f3fc0801f83d",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-10-26T04:12:00.000Z",
        "last_edited_time": "2024-10-26T04:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-81fb-a819-fb99107bd7fc",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-10-26T04:12:00.000Z",
        "last_edited_time": "2024-10-26T04:12:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Reference",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Reference",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-8170-8f8c-ed12366c7452",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-10-26T04:12:00.000Z",
        "last_edited_time": "2024-11-09T04:51:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "bulleted_list_item",
        "bulleted_list_item": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Sách ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Sách ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "About face ",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "About face ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "của Alan Cooper",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "của Alan Cooper",
              "href": null
            }
          ],
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-817d-a164-da756ad39957",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-10-26T04:12:00.000Z",
        "last_edited_time": "2024-11-09T04:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-8168-8197-da5ed2bf6c20",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-10-26T04:12:00.000Z",
        "last_edited_time": "2024-11-09T04:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Relevant Item",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relevant Item",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1695d164-78d8-800c-96b3-ffcafd34aa78",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-12-27T05:11:00.000Z",
        "last_edited_time": "2024-12-27T05:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1225d164-78d8-80db-8d9b-e6cc64d11314"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Relation (systematic thinking)",
              "href": "https://app.notion.com/p/1225d16478d880db8d9be6cc64d11314"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1695d164-78d8-8090-adc6-d54203ec5633",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-12-27T05:11:00.000Z",
        "last_edited_time": "2024-12-27T05:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1445d164-78d8-805b-b388-e24b5f13cccb"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product development process (overall)",
              "href": "https://app.notion.com/p/1445d16478d8805bb388e24b5f13cccb"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-816c-8afd-f7b0791b9215",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-10-26T04:12:00.000Z",
        "last_edited_time": "2024-11-09T04:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "1025d164-78d8-80c5-891f-debd0fc09547"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Product development process (detail)",
              "href": "https://app.notion.com/p/1025d16478d880c5891fdebd0fc09547"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12b5d164-78d8-8178-a57e-c659e2dea532",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-8084-84a5-d6eff66f3eec"
        },
        "created_time": "2024-10-26T04:12:00.000Z",
        "last_edited_time": "2024-11-09T04:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "mention",
              "mention": {
                "type": "page",
                "page": {
                  "id": "ed40fd40-a318-4fd6-a63f-0067b4e54861"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Design value",
              "href": "https://app.notion.com/p/ed40fd40a3184fd6a63f0067b4e54861"
            },
            {
              "type": "text",
              "text": {
                "content": " ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " ",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  },
  {
    "object": "page",
    "id": "10f5d164-78d8-804f-b8ea-e2a265424273",
    "created_time": "2024-09-28T03:59:00.000Z",
    "last_edited_time": "2025-08-15T10:43:00.000Z",
    "created_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "last_edited_by": {
      "object": "user",
      "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
    },
    "cover": null,
    "icon": null,
    "parent": {
      "type": "page_id",
      "page_id": "a58596ad-902a-49e3-9a81-fdb9b84b92d9"
    },
    "in_trash": false,
    "is_archived": false,
    "is_locked": false,
    "properties": {
      "title": {
        "id": "title",
        "type": "title",
        "title": [
          {
            "type": "text",
            "text": {
              "content": "UX comic - Introduction",
              "link": null
            },
            "annotations": {
              "bold": false,
              "italic": false,
              "strikethrough": false,
              "underline": false,
              "code": false,
              "color": "default"
            },
            "plain_text": "UX comic - Introduction",
            "href": null
          }
        ]
      }
    },
    "url": "https://app.notion.com/p/UX-comic-Introduction-10f5d16478d8804fb8eae2a265424273",
    "public_url": null,
    "archived": false,
    "request_id": "c600e8d2-4f27-4460-9b5d-e6b1c1f6a08e",
    "content": [
      {
        "object": "block",
        "id": "1145d164-78d8-8054-b6ed-ee06674bf4ed",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-03T14:54:00.000Z",
        "last_edited_time": "2024-10-03T14:54:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081079/uxcomic-imgs/1145d164-78d8-8054-b6ed-ee06674bf4ed.png",
            "expiry_time": "2026-10-04T09:13:00.751Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1145d164-78d8-8054-b6ed-ee06674bf4ed"
      },
      {
        "object": "block",
        "id": "1175d164-78d8-8062-b2b6-e5d5c1f1d3b4",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-06T13:42:00.000Z",
        "last_edited_time": "2024-10-06T13:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tụi mình ở đây để chia sẻ các kiến thức, góc nhìn cá nhân về hành trình làm nghề UX/UI.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tụi mình ở đây để chia sẻ các kiến thức, góc nhìn cá nhân về hành trình làm nghề UX/UI.",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "👋"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-80f5-ba2a-dc7da74d909e",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-09-28T04:03:00.000Z",
        "last_edited_time": "2025-01-14T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình xin giới thiệu chút, mình có background công việc trong graphic design, illustrator, sau đó mình chuyển sang lĩnh vực UX/UI, và chắc cũng như đa phần mọi người đó là học vài khoá, tự mày mò đọc blog để học hỏi thêm.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình xin giới thiệu chút, mình có background công việc trong graphic design, illustrator, sau đó mình chuyển sang lĩnh vực UX/UI, và chắc cũng như đa phần mọi người đó là học vài khoá, tự mày mò đọc blog để học hỏi thêm.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-8022-90a4-e47dd0056496",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-14T02:05:00.000Z",
        "last_edited_time": "2025-01-14T02:05:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80b8-ba44-f0b7bbe1c82c",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-22T16:01:00.000Z",
        "last_edited_time": "2024-12-25T02:39:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Tuy nhiên trong quá trình tự học, mình hay gặp phải các vấn đề sau:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Tuy nhiên trong quá trình tự học, mình hay gặp phải các vấn đề sau:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-80c7-9e98-d40601cb5d76",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-09-28T04:11:00.000Z",
        "last_edited_time": "2024-12-25T02:42:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "😵 Theo thời gian, kiến thức gia tăng, mọi thứ dần trở nên rối ren, chi chít như màn nhện,  nó như cái cảnh mình vào khu rừng mà không có map, cứ xoay vòng vòng, vòng vòng, vòng vòng.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "😵 Theo thời gian, kiến thức gia tăng, mọi thứ dần trở nên rối ren, chi chít như màn nhện,  nó như cái cảnh mình vào khu rừng mà không có map, cứ xoay vòng vòng, vòng vòng, vòng vòng.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "10f5d164-78d8-8055-ba1e-cdeabdc6e536",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-09-28T04:11:00.000Z",
        "last_edited_time": "2024-12-25T02:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "🫣 Mặc dù đã cất công collect, tự học các thứ nhưng đến lúc làm thực tế thì lại quên bén đi, xong tự chửi bản thân: “học chi cho lắm không áp dụng được gì”.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "🫣 Mặc dù đã cất công collect, tự học các thứ nhưng đến lúc làm thực tế thì lại quên bén đi, xong tự chửi bản thân: “học chi cho lắm không áp dụng được gì”.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80e9-a617-fed34699865b",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T02:40:00.000Z",
        "last_edited_time": "2024-12-25T02:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "😫 Đến lúc nhớ để áp dụng rồi thì lại có khi không phù hợp, kết quả không như  khuôn mẫu sách vở.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "😫 Đến lúc nhớ để áp dụng rồi thì lại có khi không phù hợp, kết quả không như  khuôn mẫu sách vở.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1645d164-78d8-80bd-821c-d1385c95355a",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-22T14:48:00.000Z",
        "last_edited_time": "2024-12-23T03:41:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081080/uxcomic-imgs/1645d164-78d8-80bd-821c-d1385c95355a.jpg",
            "expiry_time": "2026-10-04T09:13:00.752Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1645d164-78d8-80bd-821c-d1385c95355a"
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-80c2-a417-ca89e359e251",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-27T04:48:00.000Z",
        "last_edited_time": "2024-12-22T16:04:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1175d164-78d8-802e-b0b2-e9f603db4448",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-06T07:32:00.000Z",
        "last_edited_time": "2025-01-14T02:36:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Rồi tình cờ, mình có nghe đến kĩ thuật Feyman trong việc học - đại ý là học làm sao để bạn có thể dạy lại được cho người khác. Sau đó mình bắt đầu áp dụng, tập thói quen nghiền ngẫm, tập hệ thống hoá, để “ôn bài”, để biết thêm những thứ mà mình tưởng là mình đã biết >> 💡 project được sinh ra",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Rồi tình cờ, mình có nghe đến kĩ thuật Feyman trong việc học - đại ý là học làm sao để bạn có thể dạy lại được cho người khác. Sau đó mình bắt đầu áp dụng, tập thói quen nghiền ngẫm, tập hệ thống hoá, để “ôn bài”, để biết thêm những thứ mà mình tưởng là mình đã biết >> 💡 project được sinh ra",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1585d164-78d8-801d-bbfe-cbe5f489c720",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-10T02:05:00.000Z",
        "last_edited_time": "2025-01-12T14:34:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Share your knowledge and teach others — it benefits both of you!",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Share your knowledge and teach others — it benefits both of you!",
              "href": null
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "📌"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "13f5d164-78d8-801a-871e-c9d89a1c3ec0",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-11-15T02:12:00.000Z",
        "last_edited_time": "2024-11-15T02:19:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "17b5d164-78d8-80ac-ba44-fb1e73088960",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-14T02:37:00.000Z",
        "last_edited_time": "2025-08-14T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "✏️ Other tiny things",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "✏️ Other tiny things",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-8041-b4ef-f5c09e17be85",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T02:57:00.000Z",
        "last_edited_time": "2025-01-14T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Lê thê vậy đủ rồi. Nếu bạn có thêm chút thời gian, hãy xem thêm các chú thích ở dưới nhé, vì nó liên quan đến giá trị “hệ thống hoá” mà mình đang muốn offer khi làm blog này.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Lê thê vậy đủ rồi. Nếu bạn có thêm chút thời gian, hãy xem thêm các chú thích ở dưới nhé, vì nó liên quan đến giá trị “hệ thống hoá” mà mình đang muốn offer khi làm blog này.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8033-b108-debe1f729659",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:55:00.000Z",
        "last_edited_time": "2025-08-14T01:55:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1755136730/uxcomic-imgs/24f5d164-78d8-8033-b108-debe1f729659.png",
            "expiry_time": "2026-10-04T09:13:00.752Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/24f5d164-78d8-8033-b108-debe1f729659"
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80cf-9e31-eba6bd4663a0",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:02:00.000Z",
        "last_edited_time": "2025-08-14T01:47:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1175d164-78d8-807a-bc07-ce1b50fe378a",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-06T13:38:00.000Z",
        "last_edited_time": "2025-08-14T01:56:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "📢 ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "📢 ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Disclaimer",
                "link": null
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Disclaimer",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8071-af14-c321c266389f",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:47:00.000Z",
        "last_edited_time": "2025-08-15T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "các bài viết này là tổng hợp của những kiến thức lượm lặt trên mạng + chatGPT + góc độ, quan sát cá nhân >> mình vẫn có thể sai >> nên đừng vội chấp nhận hoặc tin hết những gì mình viết (mặc dù mình đều cố gắng tìm hiểu các nguồn đáng tin cậy và kèm link reference cho từng bài viết nếu có).",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "các bài viết này là tổng hợp của những kiến thức lượm lặt trên mạng + chatGPT + góc độ, quan sát cá nhân >> mình vẫn có thể sai >> nên đừng vội chấp nhận hoặc tin hết những gì mình viết (mặc dù mình đều cố gắng tìm hiểu các nguồn đáng tin cậy và kèm link reference cho từng bài viết nếu có).",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-8070-a7db-d7a5898e615d",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:47:00.000Z",
        "last_edited_time": "2025-08-15T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Hãy xem mình như một người bạn, một đồng nghiệp như đang trò chuyện với bạn trong một buổi ăn trưa, một buổi hẹn cafe, chúng mình ở đây để chia sẻ và học hỏi nhau trên con đường mày mò & cải thiện quá trình làm nghề UX/UI.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hãy xem mình như một người bạn, một đồng nghiệp như đang trò chuyện với bạn trong một buổi ăn trưa, một buổi hẹn cafe, chúng mình ở đây để chia sẻ và học hỏi nhau trên con đường mày mò & cải thiện quá trình làm nghề UX/UI.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "24f5d164-78d8-80be-bd5b-fde96187a589",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-08-14T01:48:00.000Z",
        "last_edited_time": "2025-08-15T10:43:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Again luôn recheck các thông tin, luận điểm của mình nhé. Cảm ơn mọi người nhiều 😜.",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Again luôn recheck các thông tin, luận điểm của mình nhé. Cảm ơn mọi người nhiều 😜.",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80b0-a0cf-c3d3ac509af9",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:03:00.000Z",
        "last_edited_time": "2025-01-14T02:35:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "divider",
        "divider": {},
        "archived": false
      },
      {
        "object": "block",
        "id": "1815d164-78d8-8043-8c86-f3f060cfaa2c",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-20T03:25:00.000Z",
        "last_edited_time": "2025-01-20T03:25:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "heading_2",
        "heading_2": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Contact",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Contact",
              "href": null
            }
          ],
          "is_toggleable": false,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-80e8-8428-f6dcc343a5ec",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T02:45:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mình rất vui lòng nếu nhận được những góc nhìn khác từ các bạn, nếu bạn muốn liên hệ hay chia sẻ gì với mình thêm, hay muốn mình share topic gì khác, hãy để lại lời nhắn qua:",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mình rất vui lòng nếu nhận được những góc nhìn khác từ các bạn, nếu bạn muốn liên hệ hay chia sẻ gì với mình thêm, hay muốn mình share topic gì khác, hãy để lại lời nhắn qua:",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1c15d164-78d8-80dc-bc47-ff02b571cf37",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-03-25T05:59:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1815d164-78d8-8006-8bb0-f9639445d848",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-20T03:23:00.000Z",
        "last_edited_time": "2025-01-20T03:23:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Thread",
                "link": {
                  "url": "https://www.threads.net/@ux_share_choi?hl=vi"
                }
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Thread",
              "href": "https://www.threads.net/@ux_share_choi?hl=vi"
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "💬"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1815d164-78d8-801b-b02c-f6a970beae36",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-01-20T03:23:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "callout",
        "callout": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Linkedin",
                "link": {
                  "url": "https://www.linkedin.com/in/minhhuynh95/"
                }
              },
              "annotations": {
                "bold": true,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Linkedin",
              "href": "https://www.linkedin.com/in/minhhuynh95/"
            }
          ],
          "icon": {
            "type": "emoji",
            "emoji": "💼"
          },
          "color": "gray_background"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1c15d164-78d8-80aa-b4ae-d81e4bdbad4e",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2025-03-25T05:59:00.000Z",
        "last_edited_time": "2025-03-25T05:59:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "1675d164-78d8-8081-8eb4-f9373214ab36",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:10:00.000Z",
        "last_edited_time": "2024-12-25T03:11:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "image",
        "image": {
          "caption": [],
          "type": "file",
          "file": {
            "url": "https://res.cloudinary.com/dpzknshvi/image/upload/v1753081083/uxcomic-imgs/1675d164-78d8-8081-8eb4-f9373214ab36.png",
            "expiry_time": "2026-10-04T09:13:01.803Z"
          }
        },
        "archived": false,
        "public_id": "uxcomic-imgs/1675d164-78d8-8081-8eb4-f9373214ab36"
      },
      {
        "object": "block",
        "id": "1675d164-78d8-802d-a902-c546642f72dc",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-12-25T03:03:00.000Z",
        "last_edited_time": "2024-12-28T03:52:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [
            {
              "type": "text",
              "text": {
                "content": "Mong các bài viết này có chút hữu ích cho bạn 🥰. Dự án được built with ❤️‍🔥 bởi ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Mong các bài viết này có chút hữu ích cho bạn 🥰. Dự án được built with ❤️‍🔥 bởi ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Minh",
                "link": {
                  "url": "https://www.linkedin.com/in/minhhuynh95/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Minh",
              "href": "https://www.linkedin.com/in/minhhuynh95/"
            },
            {
              "type": "text",
              "text": {
                "content": " & ",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": " & ",
              "href": null
            },
            {
              "type": "text",
              "text": {
                "content": "Hùng",
                "link": {
                  "url": "https://www.linkedin.com/in/vhung71/"
                }
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": "Hùng",
              "href": "https://www.linkedin.com/in/vhung71/"
            },
            {
              "type": "text",
              "text": {
                "content": ".",
                "link": null
              },
              "annotations": {
                "bold": false,
                "italic": false,
                "strikethrough": false,
                "underline": false,
                "code": false,
                "color": "default"
              },
              "plain_text": ".",
              "href": null
            }
          ],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "26aaa722-7e34-4293-bf96-4eaa09a6a24d",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-11-23T07:53:00.000Z",
        "last_edited_time": "2024-11-23T07:53:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      },
      {
        "object": "block",
        "id": "12c5d164-78d8-80ef-a681-d83a4e28308a",
        "parent": {
          "type": "page_id",
          "page_id": "10f5d164-78d8-804f-b8ea-e2a265424273"
        },
        "created_time": "2024-10-27T04:50:00.000Z",
        "last_edited_time": "2024-10-27T04:50:00.000Z",
        "created_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "last_edited_by": {
          "object": "user",
          "id": "ab24e3a0-5d07-4c0e-8ddf-b9d9eda19bf9"
        },
        "has_children": false,
        "in_trash": false,
        "type": "paragraph",
        "paragraph": {
          "rich_text": [],
          "icon": null,
          "color": "default"
        },
        "archived": false
      }
    ]
  }
]